export const festivalYinList = [
    { date: "01-01", name: "Tahun Baru", name1: '元旦' },
    { date: "01-27", name: "Isra Mikraj Nabi Muhammad", name1: '登宵节' },
    { date: "01-28", name: "Cuti Bersama  ", name1: '共同假期' },
    { date: "01-29", name: "Tahun Baru Imlek ", name1: '衣历新年/春节' },
    { date: "03-28", name: "Cuti Bersama   ", name1: '共同假期' },
    { date: "03-29", name: "Hari Raya Nyepi  ", name1: '兴都教静居日' },
    { date: "03-31", name: "Hari Raya Idul Fitri  ", name1: '开斋节' },
    { date: "04-02", name: "Cuti Bersama ", name1: '共同假期' },
    { date: "04-18", name: "Jumat Agung   ", name1: '耶稣受难日' },
    { date: "04-20", name: "Paskah   ", name1: '复活节' },
    { date: "05-01", name: "Hari Buruh   ", name1: '劳动节' },
    { date: "05-12", name: "Hari Raya Waisak      ", name1: '卫塞节' },
    { date: "05-13", name: "Cuti Bersama   ", name1: '共同假期' },
    { date: "05-29", name: "Kenaikan Yesus Kristus ", name1: '耶稣基督升天日' },
    { date: "05-30", name: "Cuti Bersama  ", name1: '共同假期' },
    { date: "06-01", name: "Hari Lahir Pancasila   ", name1: '建国五基诞生日' },
    { date: "06-06", name: "Hari Raya Idul Adha  ", name1: '宰牲节' },
    { date: "06-09", name: "Cuti Bersama   ", name1: '共同假期' },
    { date: "06-27", name: "Tahun Baru Islam   ", name1: '伊斯兰新年' },
    { date: "08-17", name: "Hari Kemerdekaan  ", name1: '国庆日' },
    { date: "09-05", name: "Maulid Nabi Muhammad   ", name1: '先知穆罕默德诞辰' },
    { date: "12-25", name: "Hari Natal ", name1: '圣诞节' },
    { date: "12-26", name: "Cuti Bersama", name1: '共同假期' }
]
export const festivalYinListCurrent = [
    { date: "01-01", name: "Tahun Baru", name1: '元旦' },
    { date: "01-27", name: "Isra Mikraj Nabi Muhammad", name1: '登宵节' },
    { date: "01-28", name: "Cuti Bersama  ", name1: '共同假期' },
    { date: "01-29", name: "Tahun Baru Imlek ", name1: '衣历新年/春节' },
    { date: "03-28", name: "Cuti Bersama   ", name1: '共同假期' },
    { date: "03-29", name: "Hari Raya Nyepi  ", name1: '兴都教静居日' },
    { date: "03-31", name: "Hari Raya Idul Fitri  ", name1: '开斋节' },
    { date: "04-01", name: "Hari Raya Idul Fitri  ", name1: '开斋节' },
    { date: "04-02", name: "Cuti Bersama ", name1: '共同假期' },
    { date: "04-03", name: "Cuti Bersama  ", name1: '共同假期' },
    { date: "04-04", name: "Cuti Bersama ", name1: '共同假期' },
    { date: "04-07", name: "Cuti Bersama  ", name1: '共同假期' },
    { date: "04-18", name: "Jumat Agung   ", name1: '耶稣受难日' },
    { date: "04-20", name: "Paskah   ", name1: '复活节' },
    { date: "05-01", name: "Hari Buruh   ", name1: '劳动节' },
    { date: "05-12", name: "Hari Raya Waisak      ", name1: '卫塞节' },
    { date: "05-13", name: "Cuti Bersama   ", name1: '共同假期' },
    { date: "05-29", name: "Kenaikan Yesus Kristus ", name1: '耶稣基督升天日' },
    { date: "05-30", name: "Cuti Bersama  ", name1: '共同假期' },
    { date: "06-01", name: "Hari Lahir Pancasila   ", name1: '建国五基诞生日' },
    { date: "06-06", name: "Hari Raya Idul Adha  ", name1: '宰牲节' },
    { date: "06-09", name: "Cuti Bersama   ", name1: '共同假期' },
    { date: "06-27", name: "Tahun Baru Islam   ", name1: '伊斯兰新年' },
    { date: "08-17", name: "Hari Kemerdekaan  ", name1: '国庆日' },
    { date: "09-05", name: "Maulid Nabi Muhammad   ", name1: '先知穆罕默德诞辰' },
    { date: "12-25", name: "Hari Natal ", name1: '圣诞节' },
    { date: "12-26", name: "Cuti Bersama", name1: '共同假期' }
]
export const festivalXiList = [
    { date: "01-01", name: "Año Nuevo", name1: '元旦' },
    { date: "01-06", name: "Epifanía", name1: '主显节' },
    { date: "04-18", name: "Viernes Santo", name1: '耶稣受难日' },
    { date: "05-01", name: "Día del Trabajo", name1: '劳动节' },
    { date: "08-15", name: "Asunción de María", name1: '圣母升天节' },
    { date: "10-12", name: "Día de la Hispanidad", name1: '国庆节' },
    { date: "11-01", name: "Día de Todos los Santos", name1: '诸圣日' },
    { date: "12-06", name: "Día de la Constitución", name1: '宪法日' },
    { date: "12-08", name: "Inmaculada Concepción", name1: '圣母无染原罪节' },
    { date: "12-25", name: "Día de Navidad", name1: '圣诞节' }
]
export const festivalEnList = [
    { date: "01-01", name: "New Year's Day", name1: '元旦' },
    { date: "05-01", name: "International Workers' Day", name1: '国际劳动节' },
    { date: "12-25", name: "Christmas Day", name1: '圣诞节' }
];
export const festivalRussianList = [
    { date: "01-01", name: "Новый год", name1: '元旦' },
    { date: "01-02", name: "Новогодние каникулы", name1: '新年假期周' },
    { date: "01-03", name: "Новогодние каникулы", name1: '新年假期周' },
    { date: "01-04", name: "Новогодние каникулы", name1: '新年假期周' },
    { date: "01-05", name: "Новогодние каникулы", name1: '新年假期周' },
    { date: "01-06", name: "Новогодние каникулы", name1: '新年假期周' },
    { date: "01-07", name: "Православное Рождество", name1: '东正教圣诞节' },
    { date: "01-08", name: "Новогодние каникулы", name1: '新年假期周' },
    { date: "01-13", name: "Канун Старого Нового года", name1: '旧除夕' },
    { date: "02-14", name: "День Святого Валентина", name1: '情人节' },
    { date: "02-23", name: "День защитника Отечества", name1: '祖国保卫者日' },
    { date: "02-24", name: "День защитника Отечества", name1: '纪念祖国保卫者日' },
    { date: "03-08", name: "Международный женский день", name1: '国际妇女节' },
    { date: "03-10", name: "Международный женский день", name1: '国际妇女节 - 桥梁 公共假期' },
    { date: "04-01", name: "Первое апреля", name1: '愚人节' },
    { date: "04-20", name: "Православная Пасха", name1: '东正教复活节' },
    { date: "05-01", name: "Праздник весны и труда", name1: '国际劳动节' },
    { date: "05-09", name: "День Победы", name1: '胜利日' },
    { date: "06-12", name: "День России", name1: '俄罗斯日' },
    { date: "08-22", name: "День Государственного флага", name1: '国旗日' },
    { date: "09-01", name: "День знаний", name1: '知识日' },
    { date: "10-05", name: "День учителя", name1: '教师节' },
    { date: "11-04", name: "День народного единства", name1: '团结日' },
    { date: "12-31", name: "Канун Нового года", name1: '除夕' }
]
export const festivalFrenchList = [
    { date: "01-01", name: "Jour de l'An", name1: '元旦' },
    { date: "02-14", name: "Saint-Valentin", name1: '情人节' },
    { date: "04-18", name: "Vendredi saint", name1: '耶稣受难日' },
    { date: "04-20", name: "Dimanche de Pâques", name1: '复活节' },
    { date: "04-21", name: "Lundi de Pâques", name1: '复活节星期一' },
    { date: "05-01", name: "Fête du Travail", name1: '国际劳动节' },
    { date: "05-08", name: "La fin de la Seconde Guerre mondiale en Europe", name1: '欧洲胜利日' },
    { date: "05-25", name: "Fête des Mères", name1: '母亲节' },
    { date: "05-29", name: "Ascension", name1: '耶稣升天日' },
    { date: "06-08", name: "Pentecôte", name1: '五旬节' },
    { date: "06-09", name: "Lundi de Pentecôte", name1: '圣灵降临节' },
    { date: "06-15", name: "Fête des Pères", name1: '父亲节' },
    { date: "07-14", name: "Fête nationale française", name1: '巴士底日' },
    { date: "08-15", name: "Assomption de Marie", name1: '圣母升天节' },
    { date: "11-01", name: "Toussaint", name1: '万圣节' },
    { date: "11-11", name: "Armistice", name1: '休战纪念日' },
    { date: "12-24", name: "Veille de Noël", name1: '圣诞节前夕' },
    { date: "12-25", name: "Noël", name1: '圣诞节' },
    { date: "12-26", name: "Saint-Étienne", name1: '圣斯蒂芬节' },
    { date: "12-31", name: "Veille du Nouvel An", name1: '除夕' }
]
export const festivalItalyList = [
    { date: "01-01", name: "Capodanno", name1: '元旦' },
    { date: "01-06", name: "Epifania", name1: '主显节' },
    { date: "02-14", name: "San Valentino", name1: '情人节' },
    { date: "03-19", name: "Festa del papà", name1: '父亲节' },
    { date: "04-18", name: "Venerdì Santo", name1: '耶稣受难日' },
    { date: "04-20", name: "Domenica di Pasqua", name1: '复活节' },
    { date: "04-21", name: "Lunedì di Pasqua", name1: '复活节星期一' },
    { date: "04-25", name: "Festa della Liberazione", name1: '解放日' },
    { date: "05-01", name: "Festa internazionale dei lavoratori", name1: '国际劳动节' },
    { date: "05-11", name: "Festa della mamma", name1: '母亲节' },
    { date: "06-02", name: "Festa della Repubblica", name1: '共和日' },
    { date: "08-15", name: "Assunzione di Maria", name1: '圣母升天节' },
    { date: "11-01", name: "Ognissanti", name1: '万圣节' },
    { date: "12-08", name: "Festa dell'Immacolata Concezione", name1: '圣母无玷始胎节' },
    { date: "12-25", name: "Natale", name1: '圣诞节' },
    { date: "12-26", name: "Santo Stefano", name1: '圣斯蒂芬节' },
    { date: "12-31", name: "Capodanno", name1: '除夕' }
]
export const festivalPortugalList = [
    { date: "01-01", name: "Dia de Ano Novo", name1: '元旦' },
    { date: "02-28", name: "Início do Carnaval", name1: '狂欢节开始' },
    { date: "03-01", name: "Sábado de Carnaval", name1: '狂欢周六' },
    { date: "03-02", name: "Domingo de Carnaval", name1: '狂欢节星期天' },
    { date: "03-03", name: "Segunda-feira de Carnaval", name1: '狂欢星期一' },
    { date: "03-04", name: "Terça-feira de Carnaval", name1: '狂欢星期二' },
    { date: "03-05", name: "Quarta-feira de cinzas", name1: '狂欢结束' },
    { date: "04-18", name: "Sexta-feira Santa", name1: '耶稣受难日' },
    { date: "04-20", name: "Domingo de Páscoa", name1: '复活节' },
    { date: "04-21", name: "Dia de Tiradentes", name1: '蒂拉登特斯日' },
    { date: "05-01", name: "Dia Internacional dos Trabalhadores", name1: '国际劳动节' },
    { date: "05-11", name: "Dia das Mães", name1: '母亲节' },
    { date: "06-12", name: "Dia dos Namorados", name1: '情人节' },
    { date: "06-19", name: "Corpus Christi", name1: '科珀斯克里斯蒂' },
    { date: "08-10", name: "Dia dos Pais", name1: '父亲节' },
    { date: "09-07", name: "Dia da Independência", name1: '独立日' },
    { date: "10-12", name: "Nossa Senhora Aparecida", name1: '阿帕雷西达圣母' },
    { date: "10-15", name: "Dia dos Professores", name1: '教师节' },
    { date: "11-02", name: "Dia de Finados", name1: '万灵节' },
    { date: "11-15", name: "Dia da Proclamação da República", name1: '共和国宣告日' },
    { date: "11-20", name: "Dia da Consciência Negra", name1: '黑人意识日' },
    { date: "12-24", name: "Véspera de Natal", name1: '圣诞节前夕' },
    { date: "12-25", name: "Dia de Natal", name1: '圣诞节' },
    { date: "12-31", name: "Véspera de Ano Novo", name1: '除夕' }
]
export const festivalTurkishList = [
    { date: "01-01", name: "Yılbaşı", name1: '元旦' },
    { date: "03-31", name: "Ramazan Bayramı", name1: '开斋节' },
    { date: "04-01", name: "Ramazan Bayramı 2. Gün", name1: '开斋节' },
    { date: "04-02", name: "Ramazan Bayramı 3. Gün", name1: '开斋节' },
    { date: "04-23", name: "Ulusal Egemenlik ve Çocuk Bayramı", name1: '国家主权与儿童节' },
    { date: "05-01", name: "1 Mayıs İşçi ve Emekçi Bayramı", name1: '国际劳动节' },
    { date: "05-19", name: "19 Mayıs Atatürk'ü Anma, Gençlik ve Spor Bayramı ", name1: '纪念阿塔图尔克日、青年日和体育日' },
    { date: "06-07", name: "Kurban Bayramı 2. Gün", name1: '宰牲节' },
    { date: "06-08", name: "Kurban Bayramı 3. Gün", name1: '宰牲节' },
    { date: "06-09", name: "Kurban Bayramı 4. Gün", name1: '宰牲节' },
    { date: "06-10", name: "Kurban Bayramı", name1: '宰牲节' },
    { date: "07-15", name: "Demokrasi ve Milli Birlik Günü", name1: '民主与民族团结日' },
    { date: "08-30", name: "Zafer Bayramı", name1: '胜利日' },
    { date: "10-29", name: "Cumhuriyet Bayramı", name1: '共和日' },
    { date: "11-10", name: "Atatürk'ü Anma Günü", name1: '阿塔图尔克纪念日' },
    { date: "12-31", name: "Yılbaşı Gecesi", name1: '除夕' }
]
export const festivalGermanList = [
    { date: "01-01", name: "Neujahr", name1: '元旦' },
    { date: "01-06", name: "Dreikönigstag", name1: '主显节' },
    { date: "02-14", name: "Valentinstag", name1: '情人节' },
    { date: "04-18", name: "Karfreitag", name1: '耶稣受难日' },
    { date: "04-20", name: "Ostersonntag", name1: '复活节' },
    { date: "04-21", name: "Ostermontag", name1: '复活节星期一' },
    { date: "04-23", name: "Tag des Deutschen Bieres", name1: '德国啤酒日' },
    { date: "04-30", name: "Walpurgisnacht", name1: '沃尔帕吉斯之夜' },
    { date: "05-01", name: "Tag der Arbeit", name1: '国际劳动节' },
    { date: "05-11", name: "Muttertag", name1: '母亲节' },
    { date: "05-29", name: "Christi Himmelfahrt&Vatertag", name1: '父亲节' },
    { date: "05-29", name: "Christi Himmelfahrt", name1: '耶稣升天日' },
    { date: "06-09", name: "Pfingstmontag", name1: '圣灵降临节' },
    { date: "08-15", name: "Mariä Himmelfahrt", name1: '圣母升天节' },
    { date: "10-03", name: "Tag der Deutschen Einheit", name1: '德国统一日' },
    { date: "10-31", name: "Halloween", name1: '万圣节' },
    { date: "11-09", name: "Fall der Berliner Mauer", name1: '柏林墙倒塌' },
    { date: "12-24", name: "Heiligabend", name1: '圣诞节前夕' },
    { date: "12-25", name: "Erster Weihnachtsfeiertag", name1: '圣诞节' },
    { date: "12-26", name: "Zweiter Weihnachtsfeiertag", name1: '节礼日' },
    { date: "12-31", name: "Silvester", name1: '除夕' }
];

export const starList1 = {
    "白羊座": { start: "03-21", end: "04-19" },
    "金牛座": { start: "04-20", end: "05-20" },
    "双子座": { start: "05-21", end: "06-21" },
    "巨蟹座": { start: "06-22", end: "07-22" },
    "狮子座": { start: "07-23", end: "08-22" },
    "处女座": { start: "08-23", end: "09-22" },
    "天秤座": { start: "09-23", end: "10-23" },
    "天蝎座": { start: "10-24", end: "11-22" },
    "射手座": { start: "11-23", end: "12-21" },
    "摩羯座1": { start: "12-22", end: "12-31" },
    "摩羯座2": { start: "01-01", end: "01-19" },
    "水瓶座": { start: "01-20", end: "02-18" },
    "双鱼座": { start: "02-19", end: "03-20" }
};
export const starList = [
    { start: "03-21", end: "04-19", nameid: "Aries", namees_us: 'Aries', namees: "Aries", nameen: "Aries", nameen_gb: "Aries", nameru: "Овен", namefr: "Bélier", nameit: "Ariete", namebr: 'Áries', nametr: "Koç", namede: "Widder", img: "Aries.png" },
    { start: "04-20", end: "05-20", nameid: "Taurus", namees_us: 'Tauro', namees: "Tauro", nameen: "Taurus", nameen_gb: "Taurus", nameru: "Телец", namefr: "Taureau", nameit: "Toro", namebr: 'Touro', nametr: "Boğa", namede: "Stier", img: "Taurus.png" },
    { start: "05-21", end: "06-21", nameid: "Gemini", namees_us: 'Géminis', namees: "Géminis", nameen: "Gemini", nameen_gb: "Gemini", nameru: "Близнецы", namefr: "Gémeaux", nameit: "Gemelli", namebr: 'Gêmeos', nametr: "İkizler", namede: "Zwillinge", img: "Gemini.png" },
    { start: "06-22", end: "07-22", nameid: "Cancer", namees_us: 'Cáncer', namees: "Cáncer", nameen: "Cancer", nameen_gb: "Cancer", nameru: "Рак", namefr: "Cancer", nameit: "Cancro", namebr: 'Câncer', nametr: "Yengeç", namede: "Krebs", img: "Kanker.png" },
    { start: "07-23", end: "08-22", nameid: "Leo", namees_us: 'Leo', namees: "Leo", nameen: "Leo", nameen_gb: "Leo", nameru: "Лев", namefr: "Lion", nameit: "Leone", namebr: 'Leão', nametr: "Aslan", namede: "Löwe", img: "Leo.png" },
    { start: "08-23", end: "09-22", nameid: "Virgo", namees_us: 'Virgo', namees: "Virgo", nameen: "Virgo", nameen_gb: "Virgo", nameru: "Дева", namefr: "Vierge", nameit: "Vergine", namebr: 'Virgem', nametr: "Başak", namede: "Jungfrau", img: "Virgo.png" },
    { start: "09-23", end: "10-23", nameid: "Libra", namees_us: 'Libra', namees: "Libra", nameen: "Libra", nameen_gb: "Libra", nameru: "Весы", namefr: "Balance", nameit: "Bilancia", namebr: 'Libra', nametr: "Terazi", namede: "Waage", img: "Libra.png" },
    { start: "10-24", end: "11-22", nameid: "Scorpio", namees_us: 'Escorpio', namees: "Escorpio", nameen: "Scorpio", nameen_gb: "Scorpio", nameru: "Скорпион", namefr: "Scorpion", nameit: "Scorpione", namebr: 'Escorpião', nametr: "Akrep", namede: "Skorpion", img: "Scorpio.png" },
    { start: "11-23", end: "12-21", nameid: "Sagitarius", namees_us: 'Sagitario', namees: "Sagitario", nameen: "Sagittarius", nameen_gb: "Sagittarius", nameru: "Стрелец", namefr: "Sagittaire", nameit: "Sagittario", namebr: 'Sagitário', nametr: "Yay", namede: "Schütze", img: "Sagittarius.png" },
    { start: "12-22", end: "12-31", nameid: "Capricorn1", namees_us: 'Capricornio1', namees: "Capricornio1", nameen: "Capricorn1", nameen_gb: "Capricorn1", nameru: "Козерог1", namefr: "Capricorne1", nameit: "Capricorno1", namebr: 'Capricórnio1', nametr: "Oğlak1", namede: "Steinbock1", img: "Capricorn.png" },
    { start: "01-01", end: "01-19", nameid: "Capricorn2", namees_us: 'Capricornio2', namees: "Capricornio2", nameen: "Capricorn2", nameen_gb: "Capricorn2", nameru: "Козерог2", namefr: "Capricorne2", nameit: "Capricorno2", namebr: 'Capricórnio2', nametr: "Oğlak2", namede: "Steinbock2", img: "Capricorn.png" },
    { start: "01-20", end: "02-18", nameid: "Aquarius", namees_us: 'Acuario', namees: "Acuario", nameen: "Aquarius", nameen_gb: "Aquarius", nameru: "Водолей", namefr: "Verseau", nameit: "Acquario", namebr: 'Aquário', nametr: "Kova", namede: "Wassermann", img: "Aquarius.png" },
    { start: "02-19", end: "03-20", nameid: "Pisces", namees_us: 'Piscis', namees: "Piscis", nameen: "Pisces", nameen_gb: "Pisces", nameru: "Рыбы", namefr: "Poissons", nameit: "Pesci", namebr: 'Peixes', nametr: "Balık", namede: "Fische", img: "Pisces.png" },
]
export const dateXiList = {
    "2023-01-01": {
        "content": "Suspiró y después sonrió con la misma sonrisa que, sin importar cuántas veces la viese, siempre le robaba el corazón. Cada vez que sonreía volvía a ser la primera vez. –Neil Gaiman\t"
    },
    "2023-01-02": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2023-01-03": {
        "content": " El secreto para disfrutar el trabajo esta contenido en una palabra –excelencia. Saber cómo hacer algo bien es disfrutarlo. –Pearl S. Buck.\t"
    },
    "2023-01-04": {
        "content": "El hombre está condenado a ser libre –Jean  Paul Sartre.\t"
    },
    "2023-01-05": {
        "content": " Alguien que elige sonreír antes que enfadarse, es una persona realmente fuerte –David Schary\t"
    },
    "2023-01-06": {
        "content": "La mayoría de las grandes hazañas logradas por el hombre fueron consideradas imposibles antes de que alguien las llevara a cabo”. –Louis D. Brandeis.\t"
    },
    "2023-01-07": {
        "content": " El cambio está en el aire. Nos recuerda que fuimos esculpidos por el mismo poder que orquesta el cambio de las estaciones. Que esta sea la estación en la que aceptes el cambio y te alinees con él. –Steve Maraboli\t"
    },
    "2023-01-08": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2023-01-09": {
        "content": "Si un hombre sonríe todo el tiempo, probablemente vende algo que no funciona. –George Carlin\t"
    },
    "2023-01-10": {
        "content": " El futuro pertenece a los que creen en la belleza de sus sueños. –Eleanor Roosevelt\t"
    },
    "2023-01-11": {
        "content": "Nunca te rindas. Establece una meta y no te rindas hasta que la consigas. Cuando la consigas, establece otro objetivo y no te rindas hasta que lo alcances. Nunca te rindas. –Bear Bryant\t"
    },
    "2023-01-12": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2023-01-13": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2023-01-14": {
        "content": "No puedo darte una fórmula segura para el éxito, pero puedo darte una para el fracaso: intenta complacer a todo el mundo todo el tiempo. –Herbert Bayard Swope\t"
    },
    "2023-01-15": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2023-01-16": {
        "content": "El corazón alegre hermosea el rostro. –Rey Salomón\t"
    },
    "2023-01-17": {
        "content": "Deja de mentirte. Cuando negamos nuestra verdad, negamos nuestro verdadero potencial. –Steve Maraboli\t"
    },
    "2023-01-18": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2023-01-19": {
        "content": "No quiero dejar de sonreír, bajo ninguna circunstancia, ni perder la libertad para pensar, y quiero enfrentarme a cualquier dificultad con valentía. –Banana Yashimoto\t"
    },
    "2023-01-20": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2023-01-21": {
        "content": " El éxito es un mal maestro. –Robert T. Kiyosaki\t"
    },
    "2023-01-22": {
        "content": " No hay razón para tener un plan B, porque te distrae del plan A. –Will Smith\t"
    },
    "2023-01-23": {
        "content": "Eres mi sol nocturno, mi luna de día, mi mejor sonrisa. –Federico Moccia\t"
    },
    "2023-01-24": {
        "content": "La muerte nos sonríe a todos, devolvámosle la sonrisa. –Gladiator\t"
    },
    "2023-01-25": {
        "content": "Me sonrió como no podría hacerlo un hombre, como si las mujeres lo supieran todo unas de las otras desde la eternidad. –Marcela serrano\t"
    },
    "2023-01-26": {
        "content": "La lógica te llevará de la A a la Z, pero la imaginación te llevará a cualquier lugar”. –Albert Einstein\t"
    },
    "2023-01-27": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2023-01-28": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes . –Víctor Ruiz Iriarte\t"
    },
    "2023-01-29": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2023-01-30": {
        "content": " No importa lo bueno que seas, siempre puedes ser mejor, esa es la parte emocionante. –Tiger Woods\t"
    },
    "2023-01-31": {
        "content": " El secreto del éxito es mantener una imagen de un resultado exitoso en la mente. –Henry David Thoreau\t"
    },
    "2023-02-01": {
        "content": "No dejes de sonreír… Porque es muy poco el tiempo que te dan para la alegría –Zenaida Bacardí de Argamasilla\t"
    },
    "2023-02-02": {
        "content": "Estaba sonriendo ayer, estoy sonriendo hoy y sonreiré mañana. Simplemente porque la vida es muy corta para llorar por cualquier cosa. –Santosh Kalwar\t"
    },
    "2023-02-03": {
        "content": " Son necesarios cuarenta músculos para arrugar una frente, pero sólo quince para sonreír –Swami Sivananda\t"
    },
    "2023-02-04": {
        "content": "Sonreír es definitivamente una de los mejores y más bellos remedios. Si tienes un buen sentido de humor y un buen enfoque hacia la vida, eso es hermoso –Rashida Jones\t"
    },
    "2023-02-05": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2023-02-06": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2023-02-07": {
        "content": "Y luego me da una sonrisa que parece tan genuinamente dulce con el toque justo de timidez que el calor inesperado corre a través de mí. –Suzanne Collins\t"
    },
    "2023-02-08": {
        "content": "Tenía los labios inmóviles, pero cuando lo miré parecieron sonreír sin hacer el más mínimo movimiento. –Anne Rice\t"
    },
    "2023-02-09": {
        "content": "El secreto de la existencia humana no solo está en vivir, sino también en saber para qué se vive –Fiódor Dostoievski\t"
    },
    "2023-02-10": {
        "content": "Pienso, luego existo –René Descartes.\t"
    },
    "2023-02-11": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2023-02-12": {
        "content": "Si dicen mal de ti con fundamento, corrígete; de lo contrario, échate a reír. –Epicteto de Frigia\t"
    },
    "2023-02-13": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2023-02-14": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2023-02-15": {
        "content": " Nunca dejes de sonreír, ni siquiera cuando estés triste, porque nunca sabes quien se puede enamorar de tu sonrisa –Gabriel García Márquez\t"
    },
    "2023-02-16": {
        "content": "Las limitaciones solo habitan en nuestra mente. Pero si usamos nuestra imaginación, nuestras posibilidades son ilimitadas –Jamie Paolinetti.\t"
    },
    "2023-02-17": {
        "content": " Nunca te sorprendas por tu éxito. –Steve Maraboli\t"
    },
    "2023-02-18": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2023-02-19": {
        "content": "Si estás leyendo esto… Felicitaciones, estás vivo. Si eso no es algo para sonreír, entonces no sé qué es. –Chad Sugg\t"
    },
    "2023-02-20": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2023-02-21": {
        "content": "La sonrisa es la llave que abre el corazón de todo el mundo. –Anthony J. D’Angelo\t"
    },
    "2023-02-22": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2023-02-23": {
        "content": "De humanos es errar y de necios permanecer en el error –Marco Tulio Cicerón\t"
    },
    "2023-02-24": {
        "content": "Hay un solo rincón del universo que puedes estar seguro de poder mejorar, y eres tú mismo –Aldous Huxley.\t"
    },
    "2023-02-25": {
        "content": " No dejes que los bloqueos mentales te controlen. Libérate. Enfrenta tus miedos y transforma los bloqueos mentales en bloques de construcción. –Roopleen\t"
    },
    "2023-02-26": {
        "content": "No se trata de si te derriban, se trata de si te levantas –Vince Lombardi.\t"
    },
    "2023-02-27": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2023-02-28": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2023-03-01": {
        "content": "El único hombre que nunca comete un error es el hombre que nunca hace nada. –Theodore Roosevelt\t"
    },
    "2023-03-02": {
        "content": "El éxito y la felicidad dependen de ti. –Helen Keller\t"
    },
    "2023-03-03": {
        "content": "A veces, cuando innovas, cometes errores. Lo mejor es admitirlos rápidamente y seguir mejorando otras innovaciones. –Steve Jobs\t"
    },
    "2023-03-04": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2023-03-05": {
        "content": " Es mejor olvidarse y sonreír que recordar y entristecerse –Cristina Rossetti\t"
    },
    "2023-03-06": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2023-03-07": {
        "content": " Prende tu sonrisa, ríe sin razón. Tú controlas el interruptor de la felicidad, eres tú quien cambia el mundo –Roel van Sleeuwen\t"
    },
    "2023-03-08": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2023-03-09": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2023-03-10": {
        "content": "El no querer es la causa, el no poder el pretexto –Seneca.\t"
    },
    "2023-03-11": {
        "content": "«No importa cuántas veces te caigas, sino cuántas veces te levantes». –Vince Lombardi\t"
    },
    "2023-03-12": {
        "content": "Por una mirada, un mundo –por una sonrisa, un cielo –por un beso… yo no sé –qué te diera por un beso. –Gustavo Adolfo Bécquer\t"
    },
    "2023-03-13": {
        "content": "Tu trabajo va a llenar una gran parte de tu vida; la única manera de estar verdaderamente satisfecho es hacer lo que crees que es un gran trabajo y la única manera de hacer un gran trabajo es amar lo que haces. Si todavía no lo has encontrado, sigue buscando. No te conformes. Como con todos los asuntos del corazón, sabrás cuando lo encuentres. –Steve Jobs\t"
    },
    "2023-03-14": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2023-03-15": {
        "content": "Quienes no saben llorar con todo el corazón, tampoco saben sonreír. –Golda Meir\t"
    },
    "2023-03-16": {
        "content": " La única batalla real en la vida es la que se da entre elegir aferrarse o dejar que se vaya. –Shannon L. Alder\t"
    },
    "2023-03-17": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2023-03-18": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2023-03-19": {
        "content": "Su sonrisa podía parar el corazón de un hombre. –El nombre del viento\t"
    },
    "2023-03-20": {
        "content": "No importa si te derriban, lo importante es si te levantas cuando sucede”. –Vince Lombardi\t"
    },
    "2023-03-21": {
        "content": " Sin importar lo fácil o difícil que sea la vida, siempre encontraré la manera de disfrutar. Incluso cuando las circunstancias sean adversas. –Termitope Owosela\t"
    },
    "2023-03-22": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2023-03-23": {
        "content": " La risa cura, es la obra social más barata y efectiva del mundo –Roberto Pettinato\t"
    },
    "2023-03-24": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2023-03-25": {
        "content": " Empieza cada día con una sonrisa y mantenla todo el día –W. C. Fields\t"
    },
    "2023-03-26": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2023-03-27": {
        "content": "La curva mas hermosa de una mujer es su sonrisa. –Bob Marley\t"
    },
    "2023-03-28": {
        "content": "La mejor parte de la belleza es aquella que ninguna imagen puede expresar –Francis Bacon.\t"
    },
    "2023-03-29": {
        "content": "Una gran sonrisa es un bello rostro de gigante –Charles Baudelaire\t"
    },
    "2023-03-30": {
        "content": "Una sonrisa es la felicidad que encontrarás justo debajo te tu nariz. –Tom Wilson\t"
    },
    "2023-03-31": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2023-04-01": {
        "content": "Creo que podría hacerme sonreír aunque estuviera colgada de una horca. –Jandy Nelson\t"
    },
    "2023-04-02": {
        "content": "La vida se encoge o se expande en proporción al coraje de uno –Anais Nin.\t"
    },
    "2023-04-03": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2023-04-04": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2023-04-05": {
        "content": "No llores porque ya se terminó, sonríe porque sucedió. –Gabriel García Marquez\t"
    },
    "2023-04-06": {
        "content": "La voluntad de ganar, el deseo de triunfar, el ímpetu de alcanzar tu pleno potencial…estas son las llaves que abrirán la puerta a la excelencia personal. –Confucio\t"
    },
    "2023-04-07": {
        "content": "Estar preparado es importante, saber esperarlo es aún más, pero aprovechar el momento adecuado es la clave de la vida –Arthur Schnitzler.\t"
    },
    "2023-04-08": {
        "content": "Esa sonrisa me ha salvado de llantos y dolores. –Salvatore Quasimodo\t"
    },
    "2023-04-09": {
        "content": "No puedo mantenerme enojado cuando me sonríes. –M.F. Moonzajer\t"
    },
    "2023-04-10": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2023-04-11": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2023-04-12": {
        "content": "Rodéate de personas que crean en tus sueños, alienten tus ideas, apoyen tus ambiciones y saquen lo mejor de ti”. –Roy T. Bennett\t"
    },
    "2023-04-13": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2023-04-14": {
        "content": "Los seres humanos no nacen para siempre el día en que sus madres los alumbran, sino que la vida los obliga a parirse a sí mismos una y otra vez –Gabriel García Márquez.\t"
    },
    "2023-04-15": {
        "content": "Sabes lo que es realmente contagioso? Una gran sonrisa. –Scrubs\t"
    },
    "2023-04-16": {
        "content": "Comienza y termina el día con una sonrisa. –W.C. Fields\t"
    },
    "2023-04-17": {
        "content": "«El éxito es la capacidad de ir de fracaso en fracaso sin perder el entusiasmo.» –Winston Churchill.\t"
    },
    "2023-04-18": {
        "content": "No cuentes los días, haz que los días cuenten –Muhammad Ali.\t"
    },
    "2023-04-19": {
        "content": "La sonrisa es el trapo que limpia las telarañas del corazón. –Mort Walker\t"
    },
    "2023-04-20": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2023-04-21": {
        "content": "Permanece firme a tus principios, pero siempre abierto a aprender. Trabaja duro, nunca renuncies a tus sueños, incluso cuando nadie crea que puedan hacerse realidad excepto tu. Estos no son clichés, sino que son herramientas auténticas que necesitas para estar concentrado en tu trayectoria, no importa a lo que te dediques en tu vida. –Phillip Sweet\t"
    },
    "2023-04-22": {
        "content": "Sin sonrisa de mujer no hay gloria completa de hombre. –José Marti\t"
    },
    "2023-04-23": {
        "content": "Las guerras seguirán mientras el color de la piel siga siendo más importante que el de los ojos –Bob Marley.\t"
    },
    "2023-04-24": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2023-04-25": {
        "content": "El primer paso es el más importante. Es el más crucial y más efectivo, ya que iniciará la dirección que has elegido. –Steve Backley\t"
    },
    "2023-04-26": {
        "content": "Son tus ojos los que busco, son tus labios los que quiero ver sonreír. –Violeta Parra\t"
    },
    "2023-04-27": {
        "content": "La forma de empezar es dejar de hablar y empezar a actuar   –Walt Disney\t"
    },
    "2023-04-28": {
        "content": "«El único modo de hacer un gran trabajo es amar lo que haces». –Steve Jobs\t"
    },
    "2023-04-29": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2023-04-30": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2023-05-01": {
        "content": "El hombre que nos hace reír tiene mas votos para su propósito que el hombre que nos exige pensar. –Malcom de Chazall\t"
    },
    "2023-05-02": {
        "content": "Si la vida no te diera al menos una persona que no quiera que lo logres, entonces la mitad de nosotros perdería la motivación de escalar el acantilado sólo para probar que se equivocan. –Shannon L. Alder\t"
    },
    "2023-05-03": {
        "content": " No le temas al fracaso. Es el camino al éxito. –LeBron James\t"
    },
    "2023-05-04": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2023-05-05": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2023-05-06": {
        "content": "Es maravilloso que nadie tenga que esperar ni un segundo para comenzar a hacer del mundo un lugar mejor”. –Ana Frank\t"
    },
    "2023-05-07": {
        "content": " El día peor empleado es aquél en que no se ha reído –Nicolás  Sebastien Roch Chamfort\t"
    },
    "2023-05-08": {
        "content": " Lo que hoy ves como fracaso puede ser un paso crucial hacia el éxito que estás buscando. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2023-05-09": {
        "content": "Hacer sonreír a una persona significa para mi más que cualquier cosa. –Michael Jackson\t"
    },
    "2023-05-10": {
        "content": "¿Cuándo regresará esa sonrisa que me desnuda en cuerpo y alma? –Jenniley Bonilla\t"
    },
    "2023-05-11": {
        "content": "«La vida no se trata de esperar a que pase la tormenta, se trata de aprender a bailar bajo la lluvia». –Vivian Greene\t"
    },
    "2023-05-12": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2023-05-13": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2023-05-14": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2023-05-15": {
        "content": "Nunca permitiré que me vuelva tan importante, sabio, reservado y poderoso, que no pueda sonreír a los demás y reírme de mí mismo. –Og Mandino\t"
    },
    "2023-05-16": {
        "content": "«El éxito no es para los que tienen fuerzas, sino para aquellos que no se rinden.» –Alexandre Dumas.\t"
    },
    "2023-05-17": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2023-05-18": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2023-05-19": {
        "content": "La raza humana tiene un arma verdaderamente eficaz: la risa. –Mark Twain\t"
    },
    "2023-05-20": {
        "content": "Sé amable, ya que cada persona que conoces está enfrentando una batalla interna”. –Platón\t"
    },
    "2023-05-21": {
        "content": "Los colores son la sonrisa de la naturaleza. –Leigh Hunt\t"
    },
    "2023-05-22": {
        "content": " Cada sonrisa te hace un día más joven  –Proverbio chino\t"
    },
    "2023-05-23": {
        "content": "El momento en el que consideras rendirte es justo el momento en el que debes seguir adelante”. –Anónimo\t"
    },
    "2023-05-24": {
        "content": "Para tener éxito hoy, tienes que fijar prioridades, decidir lo que representas. –Lee Laccoca\t"
    },
    "2023-05-25": {
        "content": "«El fracaso no es caer, sino negarse a levantarse». –Anónimo\t"
    },
    "2023-05-26": {
        "content": "Opino que lo que se llama belleza, reside únicamente en la sonrisa. –León Tolstoi\t"
    },
    "2023-05-27": {
        "content": "Tomar responsabilidad personal es algo hermoso porque nos da un control completo sobre nuestro destino. –Heather Schuck\t"
    },
    "2023-05-28": {
        "content": "La definición del propósito es el punto de comienzo de todo logro –Clement Stone.\t"
    },
    "2023-05-29": {
        "content": "Si no usas tu sonrisa, eres como un hombre con un millón de dolares en el banco y sin poder sacarlos. –Les Giblin\t"
    },
    "2023-05-30": {
        "content": "Hay tres tipos de personas en este mundo. Primero, están las que hacen que ocurran las cosas. Luego están las que ven cómo ocurren las cosas. Por último, están las que preguntan, ¿qué ha ocurrido? ¿Cuál quieres ser tú? –Steve Backley\t"
    },
    "2023-05-31": {
        "content": "Para ser exitoso hay que seguir el camino de los gigantes. –Lillian Cauldwell\t"
    },
    "2023-06-01": {
        "content": "Quítame el pan, si quieres, quítame el aire, pero no me quites tu risa. –Pablo Neruda\t"
    },
    "2023-06-02": {
        "content": " Si sonríes cuando no hay nadie a tu alrededor, lo haces en serio –Andy Rooney\t"
    },
    "2023-06-03": {
        "content": "La risa es el lenguaje del alma. –Pablo Neruda\t"
    },
    "2023-06-04": {
        "content": "Haz que se pregunten por qué sigues sonriendo. –Elizabethtown\t"
    },
    "2023-06-05": {
        "content": "Ve definitivamente en dirección de tus sueños. Vive la vida que imaginaste tener –Henry David Thoreau.\t"
    },
    "2023-06-06": {
        "content": "Elimina de tu vida todo aquello que te cause estrés y te quite la sonrisa. –Paulo Coelho\t"
    },
    "2023-06-07": {
        "content": "Una sonrisa puede iluminar los lugares más oscuros. –Steve Maraboli\t"
    },
    "2023-06-08": {
        "content": " El éxito es hacer lo que sea que quieras hacer, cuando quieras, donde quieras, con quien quieras y por el tiempo que quieras. –Anthony Robbins\t"
    },
    "2023-06-09": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2023-06-10": {
        "content": " Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs\t"
    },
    "2023-06-11": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2023-06-12": {
        "content": "Aunque sentí que estaba a punto de llorar, opté por sonreír. –Kristen Ashley\t"
    },
    "2023-06-13": {
        "content": "Hazles comprender que no tienen en el mundo otro deber que la alegría. –Paul Claudel\t"
    },
    "2023-06-14": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2023-06-15": {
        "content": " Hoy es el único día sobre el que tenemos poder. –Steve Maraboli\t"
    },
    "2023-06-16": {
        "content": "Cambia tus pensamientos y cambiarás tu mundo –Norman Vincent Peale.\t"
    },
    "2023-06-17": {
        "content": "Mi padre siempre me decía: encuentra un trabajo que te guste y no tendrás que trabajar un solo día de tu vida. –Jim Fox.\t"
    },
    "2023-06-18": {
        "content": "Eres asombroso porque estás aquí vivo, luchas cada día para mantenerte de pie. ¿Por qué sufres si tienes la solución en tus manos? ¿Por qué lloras si puedes cambiarlo todo? La vida es hermosa porque existes tú”. –Frases sobre la vida\t"
    },
    "2023-06-19": {
        "content": "No importa lo lento que vayas mientras que no pares –Confucio.\t"
    },
    "2023-06-20": {
        "content": "Espero tu sonrisa y espero tu fragancia por encima de todo, del tiempo y la distancia. –José Angel Buesa\t"
    },
    "2023-06-21": {
        "content": "La forma de arruinar la vida de alguien es darle todo lo que quiere. –Patrick Swayze\t"
    },
    "2023-06-22": {
        "content": "Nunca eres demasiado mayor para establecer nuevas metas o tener nuevos sueños”. –C.S. Lewis\t"
    },
    "2023-06-23": {
        "content": " El éxito no es comparar lo que hemos hecho con lo que los demás han hecho. –Myles Munroe\t"
    },
    "2023-06-24": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2023-06-25": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2023-06-26": {
        "content": "Mantente alejado de la gente que intenta menospreciar tus ambiciones. La gente pequeña siempre hace eso, pero la gente realmente grande te hace sentir que tu también puedes ser grande –Mark Twain.\t"
    },
    "2023-06-27": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2023-06-28": {
        "content": "«La vida nos somete a pruebas para mostrarnos que somos más fuertes de lo que imaginamos en nuestros peores momentos». –Las mejores frases de la vida es dura\t"
    },
    "2023-06-29": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2023-06-30": {
        "content": "Todos deberíamos saber todo el bien que una simple sonrisa puede hacer. –Madre Teresa de Calcuta\t"
    },
    "2023-07-01": {
        "content": " Ríe y el mundo reirá contigo; llora y llorarás sólo –Eli Wilcox\t"
    },
    "2023-07-02": {
        "content": "El niño reconoce a la madre por la sonrisa. –Leon Tolstoi\t"
    },
    "2023-07-03": {
        "content": "Si un líder no transmite pasión e intensidad, entonces no habrá pasión e intensidad dentro de la organización y empezarán a caer y deprimirse. –Colin Powell\t"
    },
    "2023-07-04": {
        "content": "Puede que seas la única persona que crea en ti, pero eso es suficiente. Sólo se necesita una estrella para perforar la oscuridad del universo. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2023-07-05": {
        "content": " Confía en la fuerza de tu cuerpo y corazón. Elige por estrella la autosuficiencia, la fe, la honestidad y la industria. No tomes demasiados consejos, mantén el timón y dirige tu propio barco, y recuerda que el gran arte de mandar es tomar una participación equitativa del trabajo. Pon fuego sobre la marca que quieres golpear. La energía y la determinación con el motivo correctos son las palancas que mueven al mundo. –Noah Porter.\t"
    },
    "2023-07-06": {
        "content": "La sonrisa es el idioma general de los hombres inteligentes. Sólo son tristes los tontos y los delincuentes. –Víctor Ruiz Iriarte\t"
    },
    "2023-07-07": {
        "content": " La sonrisa enriquece a los que la reciben, sin empobrecer a los que la dan –Frank Irving\t"
    },
    "2023-07-08": {
        "content": "Sólo hay un éxito: ser capaz de pasar tu vida a tu manera. –Christopher Morley\t"
    },
    "2023-07-09": {
        "content": "Consulta no tus miedos sino tus esperanzas y tus sueños. No pienses en tus frustraciones, sino en tu potencial incumplido. Preocúpate no en lo que has intentado y fracasado, sino en lo que todavía es posible hacer y lograr. –Juan XXIII\t"
    },
    "2023-07-10": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2023-07-11": {
        "content": "Comienza donde estás, usa lo que tienes, haz lo que puedes –Arthur Ashe.\t"
    },
    "2023-07-12": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2023-07-13": {
        "content": "Si te pones a ti mismo en una posición en la que tienes que salir de tu zona de confort, estas forzando la expansión de tu consciencia. –Les Brown\t"
    },
    "2023-07-14": {
        "content": "Si es bueno vivir, todavía es mejor soñar, y lo mejor de todo, despertar –Antonio Machado.\t"
    },
    "2023-07-15": {
        "content": "«En medio de la dificultad yace la oportunidad». –Albert Einstein\t"
    },
    "2023-07-16": {
        "content": "Hoy llevo puesta la sonrisa que me regalaste. –Edith Castro\t"
    },
    "2023-07-17": {
        "content": "Sonreír en la presencia del peligro no significa que niegas el miedo, simplemente te ayudará a superarlo. –Richelle E. Goodrich\t"
    },
    "2023-07-18": {
        "content": "Eres lo que eres hoy por las acciones que has hecho o las acciones que no has hecho. –Steve Maraboli\t"
    },
    "2023-07-19": {
        "content": "El éxito no es final, el fracaso no es fatal. Es el coraje para continuar lo que cuenta. –Winston S. Churchill\t"
    },
    "2023-07-20": {
        "content": " Quien no sabe sonreír, no debe hablar de los beneficios de la sonrisa   –Eusebio Gómez Navarro\t"
    },
    "2023-07-21": {
        "content": "Muy frecuentemente las lágrimas son la última sonrisa del amor. –Stendhal\t"
    },
    "2023-07-22": {
        "content": "¿Quieres saber quién eres? No preguntes. ¡Actúa! La acción delineará y definirá quién eres –Thomas Jefferson.\t"
    },
    "2023-07-23": {
        "content": " Estoy convencido de que aproximadamente la mitad de lo que separa a los emprendedores de éxito de los de no  éxito es la perseverancia. –Steve Jobs\t"
    },
    "2023-07-24": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2023-07-25": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2023-07-26": {
        "content": "Tu mejor maestro es tu último error. –Ralph Nader\t"
    },
    "2023-07-27": {
        "content": "El éxito es un camino, no un destino. –Ben Sweetland\t"
    },
    "2023-07-28": {
        "content": "«El éxito no es para los que sueñan despiertos, sino para aquellos que sueñan y hacen que sus sueños se hagan realidad.» –Jack Canfield.\t"
    },
    "2023-07-29": {
        "content": " El éxito es hacer, no obtener. Es intentar, no triunfar. El éxito es un estándar personal, es alcanzar lo más alto que hay en nosotros, convertirnos en todo lo que podemos ser. Si damos nuestro mejor esfuerzo, somos exitosos. –Zig Ziglar\t"
    },
    "2023-07-30": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2023-07-31": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2023-08-01": {
        "content": "Todavía su conocimiento no ha aprendido a sonreír. –Friedrich Nietzsche\t"
    },
    "2023-08-02": {
        "content": "Conviene reír sin esperar a ser dichoso, no sea que nos sorprenda la muerte sin haber reído. –Jean de la Bruyere\t"
    },
    "2023-08-03": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2023-08-04": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2023-08-05": {
        "content": "Quiero borrar las lágrimas de todos los que confiaron en la esperanza y se las quitaron. Quiero que se queden con una sonrisa en sus rostros. –Cuarteto Magica\t"
    },
    "2023-08-06": {
        "content": "La educación es el arma más poderosa para cambiar el mundo –Nelson Mandela.\t"
    },
    "2023-08-07": {
        "content": "«La vida nos prueba con obstáculos, pero nuestras respuestas a esas pruebas definen nuestra fuerza y determinación». ­–Frases de la vida es dura para reflexionar\t"
    },
    "2023-08-08": {
        "content": "Mira hacia atrás y sonríe ante los peligros del pasado. –Walter Scott\t"
    },
    "2023-08-09": {
        "content": "La mala noticia es que el tiempo vuela, la buena noticia es que tú eres el piloto. –Michael Althsuler\t"
    },
    "2023-08-10": {
        "content": "Una sonrisa es una línea curva que lo endereza todo –Phyllis Diller\t"
    },
    "2023-08-11": {
        "content": " Cuando deseamos convertirnos en personas de éxito, lo primero que tenemos que hacer es actuar como si ya lo fuésemos. –Gaby Vargas\t"
    },
    "2023-08-12": {
        "content": "¿Sabias que. . . Cuando pasas caminando por una flor, sea en algún jardín o en un alguna ladera, la flor siempre te sonríe? la forma más cortés de responder, me han dicho, es devolver la sonrisa alegremente. –Ron Atchison\t"
    },
    "2023-08-13": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2023-08-14": {
        "content": "La sonrisa es una verdadera fuerza vital, la única capaz de mover lo inconmovible –Orison Swett Marden\t"
    },
    "2023-08-15": {
        "content": "Lo que nos parecen pruebas amargas son bendiciones disfrazadas. –Oscar Wilde\t"
    },
    "2023-08-16": {
        "content": "Sonríe, es una terapia gratis. –Douglas Horton\t"
    },
    "2023-08-17": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2023-08-18": {
        "content": "La mayor declaración de amor es la que no se hace; el hombre que siente mucho, habla poco –Platón.\t"
    },
    "2023-08-19": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2023-08-20": {
        "content": "La vida es un 10% lo que me ocurre y 90% cómo reacciono a ello –John Maxwell.\t"
    },
    "2023-08-21": {
        "content": "Sonríe, a pesar de todo. –Steinberg\t"
    },
    "2023-08-22": {
        "content": "Podemos experimentar muchas derrotas, pero no debemos permitir que nos derroten”. –Maya Angelou\t"
    },
    "2023-08-23": {
        "content": "Si mi estupidez te hace sonreír, prefiero entonces actuar siempre como un estúpido. –M.F. Moonzajer\t"
    },
    "2023-08-24": {
        "content": "Cuando tienes la habilidad de hacer lo que amas y amar lo que haces, tienes la habilidad de impactar a las personas. Eso es lo que es tener una vida exitosa. Eso es lo que es tener una vida con sentido. –Tim Tebow\t"
    },
    "2023-08-25": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2023-08-26": {
        "content": "Después de cada tormenta sonríe el sol; para cada problema hay una solución y el deber irrenunciable del alma es estar de buen ánimo. –William R. Alger\t"
    },
    "2023-08-27": {
        "content": "Una sonrisa es la única aflicción infecciosa que animo a todos a que propaguen. –Omar Kiam\t"
    },
    "2023-08-28": {
        "content": "Ve tan lejos como puedas ver y verás más lejos. –Zig Ziglar\t"
    },
    "2023-08-29": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2023-08-30": {
        "content": "Las sonrisas generan amor y paz, el amor y la paz enciende las sonrisas en las personas. –Mehmet Murat ildan\t"
    },
    "2023-08-31": {
        "content": " Si sonríes cuando no hay nadie a tu alrededor, lo haces en serio –Andy Rooney\t"
    },
    "2023-09-01": {
        "content": " Si quieres probarle algo al mundo, entonces necesitas que el mundo te preste atención para poder probarlo. –Toba Beta\t"
    },
    "2023-09-02": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2023-09-03": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2023-09-04": {
        "content": "Una sonrisa es una curva que pone todo recto. –Phyllis Diller\t"
    },
    "2023-09-05": {
        "content": "El éxito no es mágico ni misterioso. El éxito es la consecuencia natural de aplicar los fundamentos básicos. –Jim Rohn\t"
    },
    "2023-09-06": {
        "content": "No importa lo que la gente diga, las palabras y las ideas tienen el poder de cambiar el mundo”. –Robin Williams\t"
    },
    "2023-09-07": {
        "content": "La lógica te llevará desde A hasta B. La imaginación te llevará a cualquier parte –Albert Einstein.\t"
    },
    "2023-09-08": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2023-09-09": {
        "content": "Aferrarse a la ira es como beber veneno y esperar que la otra persona muera –Buda.\t"
    },
    "2023-09-10": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2023-09-11": {
        "content": "No llores porque terminó. Sonríe porque ocurrió. –Dr. Seuss.\t"
    },
    "2023-09-12": {
        "content": "Si he visto más lejos que otros, es por estar de pie sobre los hombros de gigantes –Isaac Newton.\t"
    },
    "2023-09-13": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2023-09-14": {
        "content": "Una sonrisa es la forma más barata de cambiar nuestro aspecto. –Charles Gordu\t"
    },
    "2023-09-15": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2023-09-16": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2023-09-17": {
        "content": "El hombre verdadero sonríe ante los problemas, toma fuerza de la angustia y crece valiente ante la decepción. –Thomas Paine\t"
    },
    "2023-09-18": {
        "content": "Si solo tienes una sonrisa, dásela a la gente que amas. –Maya Angelou\t"
    },
    "2023-09-19": {
        "content": "Ella sonrió y su rostro se iluminó. O tal vez fue el mío. Todo lo que sé con certeza es que su sonrisa iluminó hasta mis días más oscuros. –J. Sterling\t"
    },
    "2023-09-20": {
        "content": "Sonreímos, pero quiero más, quiero que me abraces. –M.J. Hayland\t"
    },
    "2023-09-21": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2023-09-22": {
        "content": "La sonrisa se ha puesto de pie como una hazaña. –Manuel Del Cabral\t"
    },
    "2023-09-23": {
        "content": "Haz de tu sonrisa un paraguas y deja que llueva. –Twin Peaks\t"
    },
    "2023-09-24": {
        "content": " La mayor arma que uno puede portar frente a sus enemigos es una simple…sonrisa –Lionel Suggs\t"
    },
    "2023-09-25": {
        "content": "Encontrarás la clave del éxito debajo de la alarma del reloj. –Benjamin Franklin\t"
    },
    "2023-09-26": {
        "content": " Aunque sonreír es un trabajo de un simple instante, sus efectos duran por mucho tiempo –Bucky Buckbinder\t"
    },
    "2023-09-27": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2023-09-28": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2023-09-29": {
        "content": " Crecerás el día en que verdaderamente te rías por primera vez de ti mismo –Ethel Barrymore\t"
    },
    "2023-09-30": {
        "content": "No malgastes tu tiempo odiando un fracaso. El fracaso es mejor maestro que el éxito. Escucha, aprende, sigue adelante. –Clarissa Pinkola Estés\t"
    },
    "2023-10-01": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2023-10-02": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2023-10-03": {
        "content": " El poder de una sonrisa es tal que, incluso si dibujas una carita feliz, bastará para hacer que tus labios se muevan de la misma forma –Richelle E. Goodrich\t"
    },
    "2023-10-04": {
        "content": " La diferencia entre la codicia y la ambición es que la persona codiciosa desea cosas para las que no está preparada. –Habeeb Akande\t"
    },
    "2023-10-05": {
        "content": "Huye de los rostros graves y solemnes que jamás se distienden en una sonrisa. Huye de los espíritus susceptibles, que por todo se ofenden. –Ricardo León\t"
    },
    "2023-10-06": {
        "content": " Vamos a conseguir muchas más cosas si pensamos que nada es imposible. –Vince Lombardi\t"
    },
    "2023-10-07": {
        "content": "Y que placer, cuando no hay nada, que pueda ver, y solo invento tu sonrisa, y apago así, toda agonía. –Luis Alberto Spinetta\t"
    },
    "2023-10-08": {
        "content": "Si vas en busca del amor nunca lo encontrarás porque el amor nunca se perdió; sólo nosotros nos perdemos. –Shannon L. Alder\t"
    },
    "2023-10-09": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2023-10-10": {
        "content": "Nadie puede hacerte sentir inferior sin tu consentimiento”. –Eleanor Roosevelt\t"
    },
    "2023-10-11": {
        "content": "«El éxito no es la clave de la felicidad. La felicidad es la clave del éxito. Si amas lo que haces, tendrás éxito.» –Albert Schweitzer.\t"
    },
    "2023-10-12": {
        "content": " No hay ninguna cosa seria que no pueda decirse con una sonrisa –Alejandro Casona\t"
    },
    "2023-10-13": {
        "content": "«El éxito no es la clave de la felicidad. La felicidad es la clave del éxito. Si amas lo que haces, serás exitoso». –Albert Schweitzer\t"
    },
    "2023-10-14": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2023-10-15": {
        "content": "No puedo esperar a hacerlo, quiero hacerlo ahora, quiero que ocurra si va a ocurrir –Georgia O’Keeffe.\t"
    },
    "2023-10-16": {
        "content": "Ni siquiera trató de sonreír. Entonces supe que lo había perdido para siempre. –Marian Keyes\t"
    },
    "2023-10-17": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2023-10-18": {
        "content": " Es más fácil obtener lo que se desea con una sonrisa que con la punta de la espada –William Shakespeare\t"
    },
    "2023-10-19": {
        "content": " Nunca te olvides de sonreír porque el día que no sonrías será un día perdido –Charles Chaplin\t"
    },
    "2023-10-20": {
        "content": " ¿Cómo serías si fueses la única persona del mundo? Si quieres ser realmente feliz, debes ser esa persona. –Quetin Crisp\t"
    },
    "2023-10-21": {
        "content": " Lleva una sonrisa y ten amigos; lleva el ceño fruncido y ten arrugas –George Eliot\t"
    },
    "2023-10-22": {
        "content": " La felicidad no puede ser la única medida del éxito. –John C. Maxwell\t"
    },
    "2023-10-23": {
        "content": "El pesimista ve dificultades en cada oportunidad. El optimista ve oportunidades en cada dificultad”. –Winston Churchill\t"
    },
    "2023-10-24": {
        "content": "No puedo dejar de justificar el que se anime a los niños a sonreír antes que a llorar. No deseo pagar por ver otras lágrimas que las del teatro. –Robert Louis Stevenson\t"
    },
    "2023-10-25": {
        "content": "El éxito consiste en ir de fracaso en fracaso sin pérdida de entusiasmo. –Winston Churchill\t"
    },
    "2023-10-26": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2023-10-27": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2023-10-28": {
        "content": " Lo que mueve al mundo no son los potentes brazos de los héroes, sino la suma de los pequeños empujones de cada trabajador honrado. –Hellen Keller.\t"
    },
    "2023-10-29": {
        "content": "Cuando la necesidad de éxito es tanta como la necesidad de respirar, entonces serás exitoso –Eric Thomas.\t"
    },
    "2023-10-30": {
        "content": "Quien nos hace reír es un cómico. Quien nos hace pensar y luego reír es un humorista. –George Burns\t"
    },
    "2023-10-31": {
        "content": " A menudo las personas quedan atrapadas en un estado de sobre  pensamiento, y el resultado es que nunca toman una decisión. –Steve Backley\t"
    },
    "2023-11-01": {
        "content": " A veces, no obtener lo que quieres es un golpe de suerte brillante. –Lorii Myers\t"
    },
    "2023-11-02": {
        "content": "Cuando ella sonreía, él se olvidaba de todo. –Palmeras en la nieve\t"
    },
    "2023-11-03": {
        "content": "Comienza por hacer lo necesario; luego haz lo que es posible; y, de repente, estarás haciendo lo imposible –Francisco de Asís.\t"
    },
    "2023-11-04": {
        "content": "Supe que eras la indicada cuando tu sonrisa se convirtió en mi cielo, tu risa en mi canción favorita y tus brazos en mi hogar. –Steve Maraboli\t"
    },
    "2023-11-05": {
        "content": "El cielo no es un límite para mí, porque no tengo límites en mi vida. Porque la vida es un mundo lleno de riesgos y posibilidades. –Termitope Owosela\t"
    },
    "2023-11-06": {
        "content": "El hombre incapaz de reír no solamente es apto para las traiciones, las estratagemas y los fraudes, sino que su vida entera ya es una traición y una estratagema. –Thomas Carlyle\t"
    },
    "2023-11-07": {
        "content": " El trabajo más productivo es el que sale de las manos de un hombre contento. –Victor Pauchet.\t"
    },
    "2023-11-08": {
        "content": "No tienes que ser grande para empezar. Pero tienes que empezar para poder ser grande”. –Zig Ziglar\t"
    },
    "2023-11-09": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2023-11-10": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2023-11-11": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes. –Víctor Ruiz Iriarte\t"
    },
    "2023-11-12": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2023-11-13": {
        "content": "La creatividad es la inteligencia divirtiéndose”. –Albert Einstein\t"
    },
    "2023-11-14": {
        "content": "Si de verdad quieres comer, sigue escalando. Las frutas están en la cima del árbol. Estira tus brazos y sigue estirándolos. El éxito está en la cima, sigue adelante. –Isralemore Ayivor\t"
    },
    "2023-11-15": {
        "content": "El comportamiento humano fluye de tres fuentes: emoción, deseo y conocimiento –Platón.\t"
    },
    "2023-11-16": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2023-11-17": {
        "content": "Cuando un niño comienza a sonreír, con una pequeña bifurcación de amargor y dulzura, las orillas de su sonrisa desembocan sin burlas en la anarquía del océano. –Osip Mandelshtam\t"
    },
    "2023-11-18": {
        "content": "Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs.\t"
    },
    "2023-11-19": {
        "content": "Cuando uno nace sólo sabe llorar. Sólo gradualmente se aprende a sonreír. –Halldór Laxness\t"
    },
    "2023-11-20": {
        "content": "No hay caminos para la paz; la paz es el camino –Mahatma Gandhi.\t"
    },
    "2023-11-21": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2023-11-22": {
        "content": " El día en que te halles a ti mismo sonriendo sin razón, ese día puedes decir que has encontrado la felicidad –Rebecca Stead\t"
    },
    "2023-11-23": {
        "content": "«El futuro pertenece a aquellos que creen en la belleza de sus sueños». –Eleanor Roosevelt\t"
    },
    "2023-11-24": {
        "content": " La vida es corta. Vive apasionadamente. –Marc A. Pitma\t"
    },
    "2023-11-25": {
        "content": "Si haces cada tarea como la vas a hacer por el resto de tu vida, es entonces cuando vas a destacar. –Mary Barra\t"
    },
    "2023-11-26": {
        "content": "En cierto momento logré sonreír de nuevo y sentirme mejor. No solo en el corazón, sino en todo mi cuerpo. Caí en la cuenta de que me hacía bien, que tenía que seguir sonriendo. –Yoko Ono\t"
    },
    "2023-11-27": {
        "content": "No esperes. Nunca habrá un momento perfecto”. –Napoleon Hill,\t"
    },
    "2023-11-28": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2023-11-29": {
        "content": "Cada día sabemos más y entendemos menos –Albert Einstein.\t"
    },
    "2023-11-30": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2023-12-01": {
        "content": "Quiero borrar las lágrimas de todos los que confiaron en la esperanza y se las quitaron. Quiero que se queden con una sonrisa en sus rostros. –Cuarteto Magica\t"
    },
    "2023-12-02": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2023-12-03": {
        "content": "«La vida es como montar una bicicleta, para mantener el equilibrio debes seguir adelante». –Albert Einstein, frases de la vida es dura\t"
    },
    "2023-12-04": {
        "content": "Frecuentemente me pregunto si esas personas, las que más sonríen, serán en verdad las más tristes en el mundo. –Anthony Liccione\t"
    },
    "2023-12-05": {
        "content": "La paz comienza con una sonrisa. –Madre Teresa\t"
    },
    "2023-12-06": {
        "content": "Las más grandes decepciones que sufre el hombre, vienen de sus propias opiniones. –Leonardo DaVinci\t"
    },
    "2023-12-07": {
        "content": "La perseverancia y la energía conquistan todo”. –Benjamin Franklin\t"
    },
    "2023-12-08": {
        "content": "Hay sonrisas que no son de felicidad, sino de un modo de llorar con bondad. –Gabriela Mistral\t"
    },
    "2023-12-09": {
        "content": " No te sientas avergonzado de intentarlo y fallar, puesto que la persona que nunca ha fallado es alguien que nunca lo ha intentado. –Og Mandino\t"
    },
    "2023-12-10": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2023-12-11": {
        "content": " La risa es la distancia más corta entre dos personas –Víctor Borge\t"
    },
    "2023-12-12": {
        "content": "Los ganadores se toman su tiempo para realizar su trabajo, sabiendo que escalar la montaña es lo que hace la vista tan estimulante. –Denis Waitley.\t"
    },
    "2023-12-13": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2023-12-14": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2023-12-15": {
        "content": " Nunca conseguirás el éxito al menos que te guste lo que estas haciendo. –Dale Carnegie\t"
    },
    "2023-12-16": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2023-12-17": {
        "content": "«El éxito es cuestión de actitud, no de aptitud.» –Ralph Waldo Emerson.\t"
    },
    "2023-12-18": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2023-12-19": {
        "content": "Las sonrisas más auténticas son aquellas que se esparcen en nuestras caras cuando nadie nos está mirando. –Minhal Mehdi\t"
    },
    "2023-12-20": {
        "content": " La buena gestión consiste en mostrar a la gente común cómo hacer el trabajo de las personas superiores. –John D. Rockefeller\t"
    },
    "2023-12-21": {
        "content": "Cuando tengas fallas, no temas abandonarlas. –Confucio\t"
    },
    "2023-12-22": {
        "content": "Teresa de la dulce sonrisa; porque mientras las demás se esforzaban una y otra vez en superarla, ella simplemente las derrotaba con una sonrisa en su rostro. –Claymore\t"
    },
    "2023-12-23": {
        "content": " No tengas miedo de dejar algo bueno para ir a por algo mejor. –John D. Rockefeller\t"
    },
    "2023-12-24": {
        "content": "Dios creó el desierto para que el hombre pudiera sonreír al ver las palmeras. –Paulo Coelho\t"
    },
    "2023-12-25": {
        "content": "Deja que mi alma sonría a través de mi corazón y que mi corazón sonría a través de mis ojos, para que pueda esparcir ricas sonrisas en corazones tristes. –Paramahansa Yogananda\t"
    },
    "2023-12-26": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2023-12-27": {
        "content": " A veces tu alegría es la fuente de tu sonrisa, pero a veces tu sonrisa puede ser la fuente de tu alegría –Thích Nhất Hạnh\t"
    },
    "2023-12-28": {
        "content": " Comparte tus aspiraciones con aquellos que te vayan a apoyar, no con aquellos que respondan con duda o falta de interés. –Steve Backley\t"
    },
    "2023-12-29": {
        "content": " En cualquier momento, la decisión de ser feliz está presente. Sólo tenemos que escoger ser feliz. –Steve Maraboli\t"
    },
    "2023-12-30": {
        "content": "La mejor preparación para mañana es hacer lo mejor que puedas hoy –H. Jackson Brown, Jr.\t"
    },
    "2023-12-31": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2024-01-01": {
        "content": "El no querer es la causa, el no poder el pretexto –Seneca.\t"
    },
    "2024-01-02": {
        "content": " La única batalla real en la vida es la que se da entre elegir aferrarse o dejar que se vaya. –Shannon L. Alder\t"
    },
    "2024-01-03": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2024-01-04": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2024-01-05": {
        "content": " La diferencia entre la codicia y la ambición es que la persona codiciosa desea cosas para las que no está preparada. –Habeeb Akande\t"
    },
    "2024-01-06": {
        "content": "Sonreímos, pero quiero más, quiero que me abraces. –M.J. Hayland\t"
    },
    "2024-01-07": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2024-01-08": {
        "content": "La mayor declaración de amor es la que no se hace; el hombre que siente mucho, habla poco –Platón.\t"
    },
    "2024-01-09": {
        "content": "«La vida nos somete a pruebas para mostrarnos que somos más fuertes de lo que imaginamos en nuestros peores momentos». –Las mejores frases de la vida es dura\t"
    },
    "2024-01-10": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2024-01-11": {
        "content": "Aceptamos la salida del sol y de la luna, sabemos de su poder, de su influencia, incluso les rendimos tributo, pero no alcanzamos a comprender lo que nos puede beneficiar el nacimiento de una sonrisa en nuestro corazón. –Laura Esqivel\t"
    },
    "2024-01-12": {
        "content": "Hoy llevo puesta la sonrisa que me regalaste. –Edith Castro\t"
    },
    "2024-01-13": {
        "content": " La felicidad no puede ser la única medida del éxito. –John C. Maxwell\t"
    },
    "2024-01-14": {
        "content": " El futuro pertenece a los que creen en la belleza de sus sueños. –Eleanor Roosevelt\t"
    },
    "2024-01-15": {
        "content": "Todos deberíamos saber todo el bien que una simple sonrisa puede hacer. –Madre Teresa de Calcuta\t"
    },
    "2024-01-16": {
        "content": " Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs\t"
    },
    "2024-01-17": {
        "content": "El hombre incapaz de reír no solamente es apto para las traiciones, las estratagemas y los fraudes, sino que su vida entera ya es una traición y una estratagema. –Thomas Carlyle\t"
    },
    "2024-01-18": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2024-01-19": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2024-01-20": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2024-01-21": {
        "content": "A veces, cuando innovas, cometes errores. Lo mejor es admitirlos rápidamente y seguir mejorando otras innovaciones. –Steve Jobs\t"
    },
    "2024-01-22": {
        "content": "Sé amable, ya que cada persona que conoces está enfrentando una batalla interna”. –Platón\t"
    },
    "2024-01-23": {
        "content": "Todavía su conocimiento no ha aprendido a sonreír. –Friedrich Nietzsche\t"
    },
    "2024-01-24": {
        "content": "Si mi estupidez te hace sonreír, prefiero entonces actuar siempre como un estúpido. –M.F. Moonzajer\t"
    },
    "2024-01-25": {
        "content": "Si un líder no transmite pasión e intensidad, entonces no habrá pasión e intensidad dentro de la organización y empezarán a caer y deprimirse. –Colin Powell\t"
    },
    "2024-01-26": {
        "content": "Cada día sabemos más y entendemos menos –Albert Einstein.\t"
    },
    "2024-01-27": {
        "content": "Sólo hay un éxito: ser capaz de pasar tu vida a tu manera. –Christopher Morley\t"
    },
    "2024-01-28": {
        "content": "Aunque sentí que estaba a punto de llorar, opté por sonreír. –Kristen Ashley\t"
    },
    "2024-01-29": {
        "content": "Permanece firme a tus principios, pero siempre abierto a aprender. Trabaja duro, nunca renuncies a tus sueños, incluso cuando nadie crea que puedan hacerse realidad excepto tu. Estos no son clichés, sino que son herramientas auténticas que necesitas para estar concentrado en tu trayectoria, no importa a lo que te dediques en tu vida. –Phillip Sweet\t"
    },
    "2024-01-30": {
        "content": "El éxito y la felicidad dependen de ti. –Helen Keller\t"
    },
    "2024-01-31": {
        "content": "El niño reconoce a la madre por la sonrisa. –Leon Tolstoi\t"
    },
    "2024-02-01": {
        "content": "Deja de mentirte. Cuando negamos nuestra verdad, negamos nuestro verdadero potencial. –Steve Maraboli\t"
    },
    "2024-02-02": {
        "content": "«El éxito es la capacidad de ir de fracaso en fracaso sin perder el entusiasmo.» –Winston Churchill.\t"
    },
    "2024-02-03": {
        "content": " A menudo las personas quedan atrapadas en un estado de sobre  pensamiento, y el resultado es que nunca toman una decisión. –Steve Backley\t"
    },
    "2024-02-04": {
        "content": "El secreto de la existencia humana no solo está en vivir, sino también en saber para qué se vive –Fiódor Dostoievski\t"
    },
    "2024-02-05": {
        "content": " Es más fácil obtener lo que se desea con una sonrisa que con la punta de la espada –William Shakespeare\t"
    },
    "2024-02-06": {
        "content": " No hay razón para tener un plan B, porque te distrae del plan A. –Will Smith\t"
    },
    "2024-02-07": {
        "content": " Vamos a conseguir muchas más cosas si pensamos que nada es imposible. –Vince Lombardi\t"
    },
    "2024-02-08": {
        "content": "Puede que seas la única persona que crea en ti, pero eso es suficiente. Sólo se necesita una estrella para perforar la oscuridad del universo. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2024-02-09": {
        "content": "Por una mirada, un mundo –por una sonrisa, un cielo –por un beso… yo no sé –qué te diera por un beso. –Gustavo Adolfo Bécquer\t"
    },
    "2024-02-10": {
        "content": " Empieza cada día con una sonrisa y mantenla todo el día –W. C. Fields\t"
    },
    "2024-02-11": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2024-02-12": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2024-02-13": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2024-02-14": {
        "content": " Quien no sabe sonreír, no debe hablar de los beneficios de la sonrisa   –Eusebio Gómez Navarro\t"
    },
    "2024-02-15": {
        "content": "Su sonrisa podía parar el corazón de un hombre. –El nombre del viento\t"
    },
    "2024-02-16": {
        "content": "Si dicen mal de ti con fundamento, corrígete; de lo contrario, échate a reír. –Epicteto de Frigia\t"
    },
    "2024-02-17": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2024-02-18": {
        "content": " Aunque sonreír es un trabajo de un simple instante, sus efectos duran por mucho tiempo –Bucky Buckbinder\t"
    },
    "2024-02-19": {
        "content": "Eres asombroso porque estás aquí vivo, luchas cada día para mantenerte de pie. ¿Por qué sufres si tienes la solución en tus manos? ¿Por qué lloras si puedes cambiarlo todo? La vida es hermosa porque existes tú”. –Frases sobre la vida\t"
    },
    "2024-02-20": {
        "content": "El hombre que nos hace reír tiene mas votos para su propósito que el hombre que nos exige pensar. –Malcom de Chazall\t"
    },
    "2024-02-21": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2024-02-22": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2024-02-23": {
        "content": " Estoy convencido de que aproximadamente la mitad de lo que separa a los emprendedores de éxito de los de no  éxito es la perseverancia. –Steve Jobs\t"
    },
    "2024-02-24": {
        "content": "«La vida es como montar una bicicleta, para mantener el equilibrio debes seguir adelante». –Albert Einstein, frases de la vida es dura\t"
    },
    "2024-02-25": {
        "content": "Me sonrió como no podría hacerlo un hombre, como si las mujeres lo supieran todo unas de las otras desde la eternidad. –Marcela serrano\t"
    },
    "2024-02-26": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2024-02-27": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2024-02-28": {
        "content": " El éxito es hacer lo que sea que quieras hacer, cuando quieras, donde quieras, con quien quieras y por el tiempo que quieras. –Anthony Robbins\t"
    },
    "2024-02-29": {
        "content": "Si algo me gusta, es vivir. Ver mi cuerpo en la calle, hablar contigo como un camarada, mirar escaparates y, sobre todo, sonreír de lejos a los árboles. –Blas de Otero\t"
    },
    "2024-03-01": {
        "content": "Ni siquiera trató de sonreír. Entonces supe que lo había perdido para siempre. –Marian Keyes\t"
    },
    "2024-03-02": {
        "content": " Cada sonrisa te hace un día más joven  –Proverbio chino\t"
    },
    "2024-03-03": {
        "content": " Crecerás el día en que verdaderamente te rías por primera vez de ti mismo –Ethel Barrymore\t"
    },
    "2024-03-04": {
        "content": "El éxito consiste en ir de fracaso en fracaso sin pérdida de entusiasmo. –Winston Churchill\t"
    },
    "2024-03-05": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2024-03-06": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2024-03-07": {
        "content": "«La vida no se trata de esperar a que pase la tormenta, se trata de aprender a bailar bajo la lluvia». –Vivian Greene\t"
    },
    "2024-03-08": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2024-03-09": {
        "content": "La sonrisa es el trapo que limpia las telarañas del corazón. –Mort Walker\t"
    },
    "2024-03-10": {
        "content": "La educación es el arma más poderosa para cambiar el mundo –Nelson Mandela.\t"
    },
    "2024-03-11": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2024-03-12": {
        "content": "Frecuentemente me pregunto si esas personas, las que más sonríen, serán en verdad las más tristes en el mundo. –Anthony Liccione\t"
    },
    "2024-03-13": {
        "content": "Si he visto más lejos que otros, es por estar de pie sobre los hombros de gigantes –Isaac Newton.\t"
    },
    "2024-03-14": {
        "content": "Comienza por hacer lo necesario; luego haz lo que es posible; y, de repente, estarás haciendo lo imposible –Francisco de Asís.\t"
    },
    "2024-03-15": {
        "content": "Si la vida no te diera al menos una persona que no quiera que lo logres, entonces la mitad de nosotros perdería la motivación de escalar el acantilado sólo para probar que se equivocan. –Shannon L. Alder\t"
    },
    "2024-03-16": {
        "content": "Quítame el pan, si quieres, quítame el aire, pero no me quites tu risa. –Pablo Neruda\t"
    },
    "2024-03-17": {
        "content": " Nunca conseguirás el éxito al menos que te guste lo que estas haciendo. –Dale Carnegie\t"
    },
    "2024-03-18": {
        "content": "La sonrisa se ha puesto de pie como una hazaña. –Manuel Del Cabral\t"
    },
    "2024-03-19": {
        "content": "Ve definitivamente en dirección de tus sueños. Vive la vida que imaginaste tener –Henry David Thoreau.\t"
    },
    "2024-03-20": {
        "content": "Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs.\t"
    },
    "2024-03-21": {
        "content": "Las guerras seguirán mientras el color de la piel siga siendo más importante que el de los ojos –Bob Marley.\t"
    },
    "2024-03-22": {
        "content": "«No importa cuántas veces te caigas, sino cuántas veces te levantes». –Vince Lombardi\t"
    },
    "2024-03-23": {
        "content": "La sonrisa es una verdadera fuerza vital, la única capaz de mover lo inconmovible –Orison Swett Marden\t"
    },
    "2024-03-24": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2024-03-25": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2024-03-26": {
        "content": " El éxito es un mal maestro. –Robert T. Kiyosaki\t"
    },
    "2024-03-27": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2024-03-28": {
        "content": " El éxito es hacer, no obtener. Es intentar, no triunfar. El éxito es un estándar personal, es alcanzar lo más alto que hay en nosotros, convertirnos en todo lo que podemos ser. Si damos nuestro mejor esfuerzo, somos exitosos. –Zig Ziglar\t"
    },
    "2024-03-29": {
        "content": "Creo que podría hacerme sonreír aunque estuviera colgada de una horca. –Jandy Nelson\t"
    },
    "2024-03-30": {
        "content": "La sonrisa es la llave que abre el corazón de todo el mundo. –Anthony J. D’Angelo\t"
    },
    "2024-03-31": {
        "content": "Haz que se pregunten por qué sigues sonriendo. –Elizabethtown\t"
    },
    "2024-04-01": {
        "content": " La buena gestión consiste en mostrar a la gente común cómo hacer el trabajo de las personas superiores. –John D. Rockefeller\t"
    },
    "2024-04-02": {
        "content": "Hay un solo rincón del universo que puedes estar seguro de poder mejorar, y eres tú mismo –Aldous Huxley.\t"
    },
    "2024-04-03": {
        "content": "Hay sonrisas que no son de felicidad, sino de un modo de llorar con bondad. –Gabriela Mistral\t"
    },
    "2024-04-04": {
        "content": " La vida es corta. Vive apasionadamente. –Marc A. Pitma\t"
    },
    "2024-04-05": {
        "content": "Elimina de tu vida todo aquello que te cause estrés y te quite la sonrisa. –Paulo Coelho\t"
    },
    "2024-04-06": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2024-04-07": {
        "content": "«El éxito no es para los que tienen fuerzas, sino para aquellos que no se rinden.» –Alexandre Dumas.\t"
    },
    "2024-04-08": {
        "content": "«La vida nos prueba con obstáculos, pero nuestras respuestas a esas pruebas definen nuestra fuerza y determinación». ­–Frases de la vida es dura para reflexionar\t"
    },
    "2024-04-09": {
        "content": "«El futuro pertenece a aquellos que creen en la belleza de sus sueños». –Eleanor Roosevelt\t"
    },
    "2024-04-10": {
        "content": " A veces tu alegría es la fuente de tu sonrisa, pero a veces tu sonrisa puede ser la fuente de tu alegría –Thích Nhất Hạnh\t"
    },
    "2024-04-11": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2024-04-12": {
        "content": "De humanos es errar y de necios permanecer en el error –Marco Tulio Cicerón\t"
    },
    "2024-04-13": {
        "content": "Hacer sonreír a una persona significa para mi más que cualquier cosa. –Michael Jackson\t"
    },
    "2024-04-14": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2024-04-15": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2024-04-16": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2024-04-17": {
        "content": "La mejor preparación para mañana es hacer lo mejor que puedas hoy –H. Jackson Brown, Jr.\t"
    },
    "2024-04-18": {
        "content": "Tu mejor maestro es tu último error. –Ralph Nader\t"
    },
    "2024-04-19": {
        "content": "Las sonrisas más auténticas son aquellas que se esparcen en nuestras caras cuando nadie nos está mirando. –Minhal Mehdi\t"
    },
    "2024-04-20": {
        "content": " El secreto para disfrutar el trabajo esta contenido en una palabra –excelencia. Saber cómo hacer algo bien es disfrutarlo. –Pearl S. Buck.\t"
    },
    "2024-04-21": {
        "content": " No hay ninguna cosa seria que no pueda decirse con una sonrisa –Alejandro Casona\t"
    },
    "2024-04-22": {
        "content": "Suspiró y después sonrió con la misma sonrisa que, sin importar cuántas veces la viese, siempre le robaba el corazón. Cada vez que sonreía volvía a ser la primera vez. –Neil Gaiman\t"
    },
    "2024-04-23": {
        "content": " Nunca te sorprendas por tu éxito. –Steve Maraboli\t"
    },
    "2024-04-24": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2024-04-25": {
        "content": "Y que placer, cuando no hay nada, que pueda ver, y solo invento tu sonrisa, y apago así, toda agonía. –Luis Alberto Spinetta\t"
    },
    "2024-04-26": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2024-04-27": {
        "content": " El cambio está en el aire. Nos recuerda que fuimos esculpidos por el mismo poder que orquesta el cambio de las estaciones. Que esta sea la estación en la que aceptes el cambio y te alinees con él. –Steve Maraboli\t"
    },
    "2024-04-28": {
        "content": " Sin importar lo fácil o difícil que sea la vida, siempre encontraré la manera de disfrutar. Incluso cuando las circunstancias sean adversas. –Termitope Owosela\t"
    },
    "2024-04-29": {
        "content": "No se trata de si te derriban, se trata de si te levantas –Vince Lombardi.\t"
    },
    "2024-04-30": {
        "content": "No malgastes tu tiempo odiando un fracaso. El fracaso es mejor maestro que el éxito. Escucha, aprende, sigue adelante. –Clarissa Pinkola Estés\t"
    },
    "2024-05-01": {
        "content": " Cuando deseamos convertirnos en personas de éxito, lo primero que tenemos que hacer es actuar como si ya lo fuésemos. –Gaby Vargas\t"
    },
    "2024-05-02": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2024-05-03": {
        "content": "Encontrarás la clave del éxito debajo de la alarma del reloj. –Benjamin Franklin\t"
    },
    "2024-05-04": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2024-05-05": {
        "content": "Quien nos hace reír es un cómico. Quien nos hace pensar y luego reír es un humorista. –George Burns\t"
    },
    "2024-05-06": {
        "content": " Alguien que elige sonreír antes que enfadarse, es una persona realmente fuerte –David Schary\t"
    },
    "2024-05-07": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2024-05-08": {
        "content": "Nunca te rindas. Establece una meta y no te rindas hasta que la consigas. Cuando la consigas, establece otro objetivo y no te rindas hasta que lo alcances. Nunca te rindas. –Bear Bryant\t"
    },
    "2024-05-09": {
        "content": "Sin sonrisa de mujer no hay gloria completa de hombre. –José Marti\t"
    },
    "2024-05-10": {
        "content": "El momento en el que consideras rendirte es justo el momento en el que debes seguir adelante”. –Anónimo\t"
    },
    "2024-05-11": {
        "content": "Una gran sonrisa es un bello rostro de gigante –Charles Baudelaire\t"
    },
    "2024-05-12": {
        "content": "Sonríe, a pesar de todo. –Steinberg\t"
    },
    "2024-05-13": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes . –Víctor Ruiz Iriarte\t"
    },
    "2024-05-14": {
        "content": "Eres mi sol nocturno, mi luna de día, mi mejor sonrisa. –Federico Moccia\t"
    },
    "2024-05-15": {
        "content": "Sabes lo que es realmente contagioso? Una gran sonrisa. –Scrubs\t"
    },
    "2024-05-16": {
        "content": "Deja que mi alma sonría a través de mi corazón y que mi corazón sonría a través de mis ojos, para que pueda esparcir ricas sonrisas en corazones tristes. –Paramahansa Yogananda\t"
    },
    "2024-05-17": {
        "content": "El cielo no es un límite para mí, porque no tengo límites en mi vida. Porque la vida es un mundo lleno de riesgos y posibilidades. –Termitope Owosela\t"
    },
    "2024-05-18": {
        "content": "No puedo darte una fórmula segura para el éxito, pero puedo darte una para el fracaso: intenta complacer a todo el mundo todo el tiempo. –Herbert Bayard Swope\t"
    },
    "2024-05-19": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2024-05-20": {
        "content": "La perseverancia y la energía conquistan todo”. –Benjamin Franklin\t"
    },
    "2024-05-21": {
        "content": "«El fracaso no es caer, sino negarse a levantarse». –Anónimo\t"
    },
    "2024-05-22": {
        "content": "«El éxito es cuestión de actitud, no de aptitud.» –Ralph Waldo Emerson.\t"
    },
    "2024-05-23": {
        "content": "Supe que eras la indicada cuando tu sonrisa se convirtió en mi cielo, tu risa en mi canción favorita y tus brazos en mi hogar. –Steve Maraboli\t"
    },
    "2024-05-24": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2024-05-25": {
        "content": "Esa sonrisa me ha salvado de llantos y dolores. –Salvatore Quasimodo\t"
    },
    "2024-05-26": {
        "content": "La mejor parte de la belleza es aquella que ninguna imagen puede expresar –Francis Bacon.\t"
    },
    "2024-05-27": {
        "content": "La curva mas hermosa de una mujer es su sonrisa. –Bob Marley\t"
    },
    "2024-05-28": {
        "content": "Era una sonrisa que podría hacer que un hombre creyera que la vida era buena. –John Verdon\t"
    },
    "2024-05-29": {
        "content": " El poder de una sonrisa es tal que, incluso si dibujas una carita feliz, bastará para hacer que tus labios se muevan de la misma forma –Richelle E. Goodrich\t"
    },
    "2024-05-30": {
        "content": "¿Cuándo regresará esa sonrisa que me desnuda en cuerpo y alma? –Jenniley Bonilla\t"
    },
    "2024-05-31": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2024-06-01": {
        "content": "Estaba sonriendo ayer, estoy sonriendo hoy y sonreiré mañana. Simplemente porque la vida es muy corta para llorar por cualquier cosa. –Santosh Kalwar\t"
    },
    "2024-06-02": {
        "content": " Si sonríes cuando no hay nadie a tu alrededor, lo haces en serio –Andy Rooney\t"
    },
    "2024-06-03": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2024-06-04": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2024-06-05": {
        "content": "La sonrisa es la llave que abre el corazón de todo el mundo. –Anthony J. D’Angelo\t"
    },
    "2024-06-06": {
        "content": " La risa cura, es la obra social más barata y efectiva del mundo –Roberto Pettinato\t"
    },
    "2024-06-07": {
        "content": "Si vas en busca del amor nunca lo encontrarás porque el amor nunca se perdió; sólo nosotros nos perdemos. –Shannon L. Alder\t"
    },
    "2024-06-08": {
        "content": "La forma de arruinar la vida de alguien es darle todo lo que quiere. –Patrick Swayze\t"
    },
    "2024-06-09": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes . –Víctor Ruiz Iriarte\t"
    },
    "2024-06-10": {
        "content": "Si un hombre sonríe todo el tiempo, probablemente vende algo que no funciona. –George Carlin\t"
    },
    "2024-06-11": {
        "content": "La voluntad de ganar, el deseo de triunfar, el ímpetu de alcanzar tu pleno potencial…estas son las llaves que abrirán la puerta a la excelencia personal. –Confucio\t"
    },
    "2024-06-12": {
        "content": "Cuando uno nace sólo sabe llorar. Sólo gradualmente se aprende a sonreír. –Halldór Laxness\t"
    },
    "2024-06-13": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2024-06-14": {
        "content": "Hazles comprender que no tienen en el mundo otro deber que la alegría. –Paul Claudel\t"
    },
    "2024-06-15": {
        "content": "La vida se encoge o se expande en proporción al coraje de uno –Anais Nin.\t"
    },
    "2024-06-16": {
        "content": "Para ser exitoso hay que seguir el camino de los gigantes. –Lillian Cauldwell\t"
    },
    "2024-06-17": {
        "content": "No hay caminos para la paz; la paz es el camino –Mahatma Gandhi.\t"
    },
    "2024-06-18": {
        "content": "El éxito es un camino, no un destino. –Ben Sweetland\t"
    },
    "2024-06-19": {
        "content": "Nadie puede hacerte sentir inferior sin tu consentimiento”. –Eleanor Roosevelt\t"
    },
    "2024-06-20": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2024-06-21": {
        "content": " Son necesarios cuarenta músculos para arrugar una frente, pero sólo quince para sonreír –Swami Sivananda\t"
    },
    "2024-06-22": {
        "content": " Nunca dejes de sonreír, ni siquiera cuando estés triste, porque nunca sabes quien se puede enamorar de tu sonrisa –Gabriel García Márquez\t"
    },
    "2024-06-23": {
        "content": "Podemos experimentar muchas derrotas, pero no debemos permitir que nos derroten”. –Maya Angelou\t"
    },
    "2024-06-24": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2024-06-25": {
        "content": "Muy frecuentemente las lágrimas son la última sonrisa del amor. –Stendhal\t"
    },
    "2024-06-26": {
        "content": "No esperes. Nunca habrá un momento perfecto”. –Napoleon Hill,\t"
    },
    "2024-06-27": {
        "content": "Huye de los rostros graves y solemnes que jamás se distienden en una sonrisa. Huye de los espíritus susceptibles, que por todo se ofenden. –Ricardo León\t"
    },
    "2024-06-28": {
        "content": "Pienso, luego existo –René Descartes.\t"
    },
    "2024-06-29": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2024-06-30": {
        "content": "Lo que nos parecen pruebas amargas son bendiciones disfrazadas. –Oscar Wilde\t"
    },
    "2024-07-01": {
        "content": "La creatividad es la inteligencia divirtiéndose”. –Albert Einstein\t"
    },
    "2024-07-02": {
        "content": "En cierto momento logré sonreír de nuevo y sentirme mejor. No solo en el corazón, sino en todo mi cuerpo. Caí en la cuenta de que me hacía bien, que tenía que seguir sonriendo. –Yoko Ono\t"
    },
    "2024-07-03": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2024-07-04": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2024-07-05": {
        "content": " El secreto del éxito es mantener una imagen de un resultado exitoso en la mente. –Henry David Thoreau\t"
    },
    "2024-07-06": {
        "content": "Y luego me da una sonrisa que parece tan genuinamente dulce con el toque justo de timidez que el calor inesperado corre a través de mí. –Suzanne Collins\t"
    },
    "2024-07-07": {
        "content": "Son tus ojos los que busco, son tus labios los que quiero ver sonreír. –Violeta Parra\t"
    },
    "2024-07-08": {
        "content": "Después de cada tormenta sonríe el sol; para cada problema hay una solución y el deber irrenunciable del alma es estar de buen ánimo. –William R. Alger\t"
    },
    "2024-07-09": {
        "content": " La mayor arma que uno puede portar frente a sus enemigos es una simple…sonrisa –Lionel Suggs\t"
    },
    "2024-07-10": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2024-07-11": {
        "content": "No importa lo lento que vayas mientras que no pares –Confucio.\t"
    },
    "2024-07-12": {
        "content": "La raza humana tiene un arma verdaderamente eficaz: la risa. –Mark Twain\t"
    },
    "2024-07-13": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2024-07-14": {
        "content": "Si estás leyendo esto… Felicitaciones, estás vivo. Si eso no es algo para sonreír, entonces no sé qué es. –Chad Sugg\t"
    },
    "2024-07-15": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2024-07-16": {
        "content": "Una sonrisa es la felicidad que encontrarás justo debajo te tu nariz. –Tom Wilson\t"
    },
    "2024-07-17": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2024-07-18": {
        "content": " No te sientas avergonzado de intentarlo y fallar, puesto que la persona que nunca ha fallado es alguien que nunca lo ha intentado. –Og Mandino\t"
    },
    "2024-07-19": {
        "content": "Los ganadores se toman su tiempo para realizar su trabajo, sabiendo que escalar la montaña es lo que hace la vista tan estimulante. –Denis Waitley.\t"
    },
    "2024-07-20": {
        "content": "Si de verdad quieres comer, sigue escalando. Las frutas están en la cima del árbol. Estira tus brazos y sigue estirándolos. El éxito está en la cima, sigue adelante. –Isralemore Ayivor\t"
    },
    "2024-07-21": {
        "content": " Confía en la fuerza de tu cuerpo y corazón. Elige por estrella la autosuficiencia, la fe, la honestidad y la industria. No tomes demasiados consejos, mantén el timón y dirige tu propio barco, y recuerda que el gran arte de mandar es tomar una participación equitativa del trabajo. Pon fuego sobre la marca que quieres golpear. La energía y la determinación con el motivo correctos son las palancas que mueven al mundo. –Noah Porter.\t"
    },
    "2024-07-22": {
        "content": "Eres lo que eres hoy por las acciones que has hecho o las acciones que no has hecho. –Steve Maraboli\t"
    },
    "2024-07-23": {
        "content": "Ve tan lejos como puedas ver y verás más lejos. –Zig Ziglar\t"
    },
    "2024-07-24": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2024-07-25": {
        "content": " Si sonríes cuando no hay nadie a tu alrededor, lo haces en serio –Andy Rooney\t"
    },
    "2024-07-26": {
        "content": "No quiero dejar de sonreír, bajo ninguna circunstancia, ni perder la libertad para pensar, y quiero enfrentarme a cualquier dificultad con valentía. –Banana Yashimoto\t"
    },
    "2024-07-27": {
        "content": "Conviene reír sin esperar a ser dichoso, no sea que nos sorprenda la muerte sin haber reído. –Jean de la Bruyere\t"
    },
    "2024-07-28": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2024-07-29": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2024-07-30": {
        "content": "El primer paso es el más importante. Es el más crucial y más efectivo, ya que iniciará la dirección que has elegido. –Steve Backley\t"
    },
    "2024-07-31": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2024-08-01": {
        "content": "Una sonrisa es una curva que pone todo recto. –Phyllis Diller\t"
    },
    "2024-08-02": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2024-08-03": {
        "content": "Las más grandes decepciones que sufre el hombre, vienen de sus propias opiniones. –Leonardo DaVinci\t"
    },
    "2024-08-04": {
        "content": "Espero tu sonrisa y espero tu fragancia por encima de todo, del tiempo y la distancia. –José Angel Buesa\t"
    },
    "2024-08-05": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2024-08-06": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2024-08-07": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2024-08-08": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2024-08-09": {
        "content": "El único hombre que nunca comete un error es el hombre que nunca hace nada. –Theodore Roosevelt\t"
    },
    "2024-08-10": {
        "content": "Sonreír en la presencia del peligro no significa que niegas el miedo, simplemente te ayudará a superarlo. –Richelle E. Goodrich\t"
    },
    "2024-08-11": {
        "content": "Opino que lo que se llama belleza, reside únicamente en la sonrisa. –León Tolstoi\t"
    },
    "2024-08-12": {
        "content": " Es mejor olvidarse y sonreír que recordar y entristecerse –Cristina Rossetti\t"
    },
    "2024-08-13": {
        "content": " Hoy es el único día sobre el que tenemos poder. –Steve Maraboli\t"
    },
    "2024-08-14": {
        "content": " No tengas miedo de dejar algo bueno para ir a por algo mejor. –John D. Rockefeller\t"
    },
    "2024-08-15": {
        "content": "Si estás comprometido con algo que realmente te importa, no necesitarás que nadie te empuje: tu visión te impulsará”. –Steve Jobs\t"
    },
    "2024-08-16": {
        "content": "Si no usas tu sonrisa, eres como un hombre con un millón de dolares en el banco y sin poder sacarlos. –Les Giblin\t"
    },
    "2024-08-17": {
        "content": "Si solo tienes una sonrisa, dásela a la gente que amas. –Maya Angelou\t"
    },
    "2024-08-18": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2024-08-19": {
        "content": "Nunca eres demasiado mayor para establecer nuevas metas o tener nuevos sueños”. –C.S. Lewis\t"
    },
    "2024-08-20": {
        "content": "Una sonrisa es la forma más barata de cambiar nuestro aspecto. –Charles Gordu\t"
    },
    "2024-08-21": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2024-08-22": {
        "content": "Tenía los labios inmóviles, pero cuando lo miré parecieron sonreír sin hacer el más mínimo movimiento. –Anne Rice\t"
    },
    "2024-08-23": {
        "content": "Comienza y termina el día con una sonrisa. –W.C. Fields\t"
    },
    "2024-08-24": {
        "content": "Muy frecuentemente las lágrimas son la última sonrisa del amor. –Stendhal\t"
    },
    "2024-08-25": {
        "content": "Son tus ojos los que busco, son tus labios los que quiero ver sonreír. –Violeta Parra\t"
    },
    "2024-08-26": {
        "content": "Mira hacia atrás y sonríe ante los peligros del pasado. –Walter Scott\t"
    },
    "2024-08-27": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2024-08-28": {
        "content": " El día peor empleado es aquél en que no se ha reído –Nicolás  Sebastien Roch Chamfort\t"
    },
    "2024-08-29": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2024-08-30": {
        "content": "Rodéate de personas que crean en tus sueños, alienten tus ideas, apoyen tus ambiciones y saquen lo mejor de ti”. –Roy T. Bennett\t"
    },
    "2024-08-31": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2024-09-01": {
        "content": "No puedo dejar de justificar el que se anime a los niños a sonreír antes que a llorar. No deseo pagar por ver otras lágrimas que las del teatro. –Robert Louis Stevenson\t"
    },
    "2024-09-02": {
        "content": "«El éxito no es la clave de la felicidad. La felicidad es la clave del éxito. Si amas lo que haces, serás exitoso». –Albert Schweitzer\t"
    },
    "2024-09-03": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2024-09-04": {
        "content": "La mayoría de las grandes hazañas logradas por el hombre fueron consideradas imposibles antes de que alguien las llevara a cabo”. –Louis D. Brandeis.\t"
    },
    "2024-09-05": {
        "content": "La forma de empezar es dejar de hablar y empezar a actuar   –Walt Disney\t"
    },
    "2024-09-06": {
        "content": "No importa lo que la gente diga, las palabras y las ideas tienen el poder de cambiar el mundo”. –Robin Williams\t"
    },
    "2024-09-07": {
        "content": "Cuando ella sonreía, él se olvidaba de todo. –Palmeras en la nieve\t"
    },
    "2024-09-08": {
        "content": " A veces, no obtener lo que quieres es un golpe de suerte brillante. –Lorii Myers\t"
    },
    "2024-09-09": {
        "content": "Las sonrisas generan amor y paz, el amor y la paz enciende las sonrisas en las personas. –Mehmet Murat ildan\t"
    },
    "2024-09-10": {
        "content": "La paz comienza con una sonrisa. –Madre Teresa\t"
    },
    "2024-09-11": {
        "content": "Si te pones a ti mismo en una posición en la que tienes que salir de tu zona de confort, estas forzando la expansión de tu consciencia. –Les Brown\t"
    },
    "2024-09-12": {
        "content": "No puedo mantenerme enojado cuando me sonríes. –M.F. Moonzajer\t"
    },
    "2024-09-13": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2024-09-14": {
        "content": "El comportamiento humano fluye de tres fuentes: emoción, deseo y conocimiento –Platón.\t"
    },
    "2024-09-15": {
        "content": " La risa es la distancia más corta entre dos personas –Víctor Borge\t"
    },
    "2024-09-16": {
        "content": "No tienes que ser grande para empezar. Pero tienes que empezar para poder ser grande”. –Zig Ziglar\t"
    },
    "2024-09-17": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2024-09-18": {
        "content": " Ríe y el mundo reirá contigo; llora y llorarás sólo –Eli Wilcox\t"
    },
    "2024-09-19": {
        "content": "Mantente alejado de la gente que intenta menospreciar tus ambiciones. La gente pequeña siempre hace eso, pero la gente realmente grande te hace sentir que tu también puedes ser grande –Mark Twain.\t"
    },
    "2024-09-20": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2024-09-21": {
        "content": "Haz de tu sonrisa un paraguas y deja que llueva. –Twin Peaks\t"
    },
    "2024-09-22": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2024-09-23": {
        "content": "¿Quieres saber quién eres? No preguntes. ¡Actúa! La acción delineará y definirá quién eres –Thomas Jefferson.\t"
    },
    "2024-09-24": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2024-09-25": {
        "content": "Una sonrisa es una línea curva que lo endereza todo –Phyllis Diller\t"
    },
    "2024-09-26": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2024-09-27": {
        "content": "Aferrarse a la ira es como beber veneno y esperar que la otra persona muera –Buda.\t"
    },
    "2024-09-28": {
        "content": "Quiero borrar las lágrimas de todos los que confiaron en la esperanza y se las quitaron. Quiero que se queden con una sonrisa en sus rostros. –Cuarteto Magica\t"
    },
    "2024-09-29": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2024-09-30": {
        "content": "El éxito no es final, el fracaso no es fatal. Es el coraje para continuar lo que cuenta. –Winston S. Churchill\t"
    },
    "2024-10-01": {
        "content": "El pesimista ve dificultades en cada oportunidad. El optimista ve oportunidades en cada dificultad”. –Winston Churchill\t"
    },
    "2024-10-02": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2024-10-03": {
        "content": "Los seres humanos no nacen para siempre el día en que sus madres los alumbran, sino que la vida los obliga a parirse a sí mismos una y otra vez –Gabriel García Márquez.\t"
    },
    "2024-10-04": {
        "content": "No llores porque ya se terminó, sonríe porque sucedió. –Gabriel García Marquez\t"
    },
    "2024-10-05": {
        "content": "Quienes no saben llorar con todo el corazón, tampoco saben sonreír. –Golda Meir\t"
    },
    "2024-10-06": {
        "content": "Una sonrisa es la única aflicción infecciosa que animo a todos a que propaguen. –Omar Kiam\t"
    },
    "2024-10-07": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2024-10-08": {
        "content": "Cuando la necesidad de éxito es tanta como la necesidad de respirar, entonces serás exitoso –Eric Thomas.\t"
    },
    "2024-10-09": {
        "content": " Participa en tus propios sueños. No digas solamente lo que quieres o te quejes de lo que no tienes. –Steve Maraboli\t"
    },
    "2024-10-10": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2024-10-11": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2024-10-12": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2024-10-13": {
        "content": "No tienes que ser grande para empezar. Pero tienes que empezar para poder ser grande”. –Zig Ziglar\t"
    },
    "2024-10-14": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2024-10-15": {
        "content": "El hombre verdadero sonríe ante los problemas, toma fuerza de la angustia y crece valiente ante la decepción. –Thomas Paine\t"
    },
    "2024-10-16": {
        "content": "Tomar responsabilidad personal es algo hermoso porque nos da un control completo sobre nuestro destino. –Heather Schuck\t"
    },
    "2024-10-17": {
        "content": "Porque yo, sólo yo, veo su sonrisa una milésima antes de que le llegue a la cara. –David Mitchell\t"
    },
    "2024-10-18": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2024-10-19": {
        "content": "Ella sonrió y su rostro se iluminó. O tal vez fue el mío. Todo lo que sé con certeza es que su sonrisa iluminó hasta mis días más oscuros. –J. Sterling\t"
    },
    "2024-10-20": {
        "content": "La definición del propósito es el punto de comienzo de todo logro –Clement Stone.\t"
    },
    "2024-10-21": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2024-10-22": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2024-10-23": {
        "content": " No importa lo bueno que seas, siempre puedes ser mejor, esa es la parte emocionante. –Tiger Woods\t"
    },
    "2024-10-24": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2024-10-25": {
        "content": "Tu trabajo va a llenar una gran parte de tu vida; la única manera de estar verdaderamente satisfecho es hacer lo que crees que es un gran trabajo y la única manera de hacer un gran trabajo es amar lo que haces. Si todavía no lo has encontrado, sigue buscando. No te conformes. Como con todos los asuntos del corazón, sabrás cuando lo encuentres. –Steve Jobs\t"
    },
    "2024-10-26": {
        "content": "Mi padre siempre me decía: encuentra un trabajo que te guste y no tendrás que trabajar un solo día de tu vida. –Jim Fox.\t"
    },
    "2024-10-27": {
        "content": " Nunca te olvides de sonreír porque el día que no sonrías será un día perdido –Charles Chaplin\t"
    },
    "2024-10-28": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2024-10-29": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2024-10-30": {
        "content": "Las arrugas solo deberían indicar donde las sonrisas han estado. –Mark Twain\t"
    },
    "2024-10-31": {
        "content": "«El éxito no es para los que sueñan despiertos, sino para aquellos que sueñan y hacen que sus sueños se hagan realidad.» –Jack Canfield.\t"
    },
    "2024-11-01": {
        "content": "Una sonrisa puede iluminar los lugares más oscuros. –Steve Maraboli\t"
    },
    "2024-11-02": {
        "content": "La mala noticia es que el tiempo vuela, la buena noticia es que tú eres el piloto. –Michael Althsuler\t"
    },
    "2024-11-03": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2024-11-04": {
        "content": " La sonrisa enriquece a los que la reciben, sin empobrecer a los que la dan –Frank Irving\t"
    },
    "2024-11-05": {
        "content": " Si quieres probarle algo al mundo, entonces necesitas que el mundo te preste atención para poder probarlo. –Toba Beta\t"
    },
    "2024-11-06": {
        "content": " Lo que mueve al mundo no son los potentes brazos de los héroes, sino la suma de los pequeños empujones de cada trabajador honrado. –Hellen Keller.\t"
    },
    "2024-11-07": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2024-11-08": {
        "content": "La lógica te llevará de la A a la Z, pero la imaginación te llevará a cualquier lugar”. –Albert Einstein\t"
    },
    "2024-11-09": {
        "content": " En cualquier momento, la decisión de ser feliz está presente. Sólo tenemos que escoger ser feliz. –Steve Maraboli\t"
    },
    "2024-11-10": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2024-11-11": {
        "content": "Si es bueno vivir, todavía es mejor soñar, y lo mejor de todo, despertar –Antonio Machado.\t"
    },
    "2024-11-12": {
        "content": " El trabajo más productivo es el que sale de las manos de un hombre contento. –Victor Pauchet.\t"
    },
    "2024-11-13": {
        "content": "El corazón alegre hermosea el rostro. –Rey Salomón\t"
    },
    "2024-11-14": {
        "content": "¿Sabias que. . . Cuando pasas caminando por una flor, sea en algún jardín o en un alguna ladera, la flor siempre te sonríe? la forma más cortés de responder, me han dicho, es devolver la sonrisa alegremente. –Ron Atchison\t"
    },
    "2024-11-15": {
        "content": " Prende tu sonrisa, ríe sin razón. Tú controlas el interruptor de la felicidad, eres tú quien cambia el mundo –Roel van Sleeuwen\t"
    },
    "2024-11-16": {
        "content": "No llores porque terminó. Sonríe porque ocurrió. –Dr. Seuss.\t"
    },
    "2024-11-17": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2024-11-18": {
        "content": " Comparte tus aspiraciones con aquellos que te vayan a apoyar, no con aquellos que respondan con duda o falta de interés. –Steve Backley\t"
    },
    "2024-11-19": {
        "content": "Teresa de la dulce sonrisa; porque mientras las demás se esforzaban una y otra vez en superarla, ella simplemente las derrotaba con una sonrisa en su rostro. –Claymore\t"
    },
    "2024-11-20": {
        "content": "El éxito no es mágico ni misterioso. El éxito es la consecuencia natural de aplicar los fundamentos básicos. –Jim Rohn\t"
    },
    "2024-11-21": {
        "content": "Los colores son la sonrisa de la naturaleza. –Leigh Hunt\t"
    },
    "2024-11-22": {
        "content": "Quiero borrar las lágrimas de todos los que confiaron en la esperanza y se las quitaron. Quiero que se queden con una sonrisa en sus rostros. –Cuarteto Magica\t"
    },
    "2024-11-23": {
        "content": "La sonrisa es el idioma general de los hombres inteligentes. Sólo son tristes los tontos y los delincuentes. –Víctor Ruiz Iriarte\t"
    },
    "2024-11-24": {
        "content": "Cambia tus pensamientos y cambiarás tu mundo –Norman Vincent Peale.\t"
    },
    "2024-11-25": {
        "content": "Si es posible, se debe hacer reír hasta a los muertos. –Leonardo Da Vinci\t"
    },
    "2024-11-26": {
        "content": "No importa si te derriban, lo importante es si te levantas cuando sucede”. –Vince Lombardi\t"
    },
    "2024-11-27": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2024-11-28": {
        "content": "No cuentes los días, haz que los días cuenten –Muhammad Ali.\t"
    },
    "2024-11-29": {
        "content": "Consulta no tus miedos sino tus esperanzas y tus sueños. No pienses en tus frustraciones, sino en tu potencial incumplido. Preocúpate no en lo que has intentado y fracasado, sino en lo que todavía es posible hacer y lograr. –Juan XXIII\t"
    },
    "2024-11-30": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2024-12-01": {
        "content": "No dejes de sonreír… Porque es muy poco el tiempo que te dan para la alegría –Zenaida Bacardí de Argamasilla\t"
    },
    "2024-12-02": {
        "content": "«El único modo de hacer un gran trabajo es amar lo que haces». –Steve Jobs\t"
    },
    "2024-12-03": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2024-12-04": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2024-12-05": {
        "content": "Para tener éxito hoy, tienes que fijar prioridades, decidir lo que representas. –Lee Laccoca\t"
    },
    "2024-12-06": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2024-12-07": {
        "content": "Si haces cada tarea como la vas a hacer por el resto de tu vida, es entonces cuando vas a destacar. –Mary Barra\t"
    },
    "2024-12-08": {
        "content": " El día en que te halles a ti mismo sonriendo sin razón, ese día puedes decir que has encontrado la felicidad –Rebecca Stead\t"
    },
    "2024-12-09": {
        "content": " Lo que hoy ves como fracaso puede ser un paso crucial hacia el éxito que estás buscando. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2024-12-10": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2024-12-11": {
        "content": "La vida es un 10% lo que me ocurre y 90% cómo reacciono a ello –John Maxwell.\t"
    },
    "2024-12-12": {
        "content": "La risa es el lenguaje del alma. –Pablo Neruda\t"
    },
    "2024-12-13": {
        "content": "Las limitaciones solo habitan en nuestra mente. Pero si usamos nuestra imaginación, nuestras posibilidades son ilimitadas –Jamie Paolinetti.\t"
    },
    "2024-12-14": {
        "content": "Cuando un niño comienza a sonreír, con una pequeña bifurcación de amargor y dulzura, las orillas de su sonrisa desembocan sin burlas en la anarquía del océano. –Osip Mandelshtam\t"
    },
    "2024-12-15": {
        "content": "Comienza donde estás, usa lo que tienes, haz lo que puedes –Arthur Ashe.\t"
    },
    "2024-12-16": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2024-12-17": {
        "content": "La lógica te llevará desde A hasta B. La imaginación te llevará a cualquier parte –Albert Einstein.\t"
    },
    "2024-12-18": {
        "content": "No puedo esperar a hacerlo, quiero hacerlo ahora, quiero que ocurra si va a ocurrir –Georgia O’Keeffe.\t"
    },
    "2024-12-19": {
        "content": " ¿Cómo serías si fueses la única persona del mundo? Si quieres ser realmente feliz, debes ser esa persona. –Quetin Crisp\t"
    },
    "2024-12-20": {
        "content": "Nunca permitiré que me vuelva tan importante, sabio, reservado y poderoso, que no pueda sonreír a los demás y reírme de mí mismo. –Og Mandino\t"
    },
    "2024-12-21": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2024-12-22": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2024-12-23": {
        "content": " El éxito no es comparar lo que hemos hecho con lo que los demás han hecho. –Myles Munroe\t"
    },
    "2024-12-24": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2024-12-25": {
        "content": "Cuando tengas fallas, no temas abandonarlas. –Confucio\t"
    },
    "2024-12-26": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2024-12-27": {
        "content": "La muerte nos sonríe a todos, devolvámosle la sonrisa. –Gladiator\t"
    },
    "2024-12-28": {
        "content": "Es maravilloso que nadie tenga que esperar ni un segundo para comenzar a hacer del mundo un lugar mejor”. –Ana Frank\t"
    },
    "2024-12-29": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2024-12-30": {
        "content": " Lleva una sonrisa y ten amigos; lleva el ceño fruncido y ten arrugas –George Eliot\t"
    },
    "2024-12-31": {
        "content": "Comienza por hacer lo necesario; luego haz lo que es posible; y, de repente, estarás haciendo lo imposible –Francisco de Asís.\t"
    },
    "2025-01-01": {
        "content": "La creatividad es la inteligencia divirtiéndose”. –Albert Einstein\t"
    },
    "2025-01-02": {
        "content": "La educación es el arma más poderosa para cambiar el mundo –Nelson Mandela.\t"
    },
    "2025-01-03": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2025-01-04": {
        "content": " Lleva una sonrisa y ten amigos; lleva el ceño fruncido y ten arrugas –George Eliot\t"
    },
    "2025-01-05": {
        "content": "Todavía su conocimiento no ha aprendido a sonreír. –Friedrich Nietzsche\t"
    },
    "2025-01-06": {
        "content": "La raza humana tiene un arma verdaderamente eficaz: la risa. –Mark Twain\t"
    },
    "2025-01-07": {
        "content": " A veces tu alegría es la fuente de tu sonrisa, pero a veces tu sonrisa puede ser la fuente de tu alegría –Thích Nhất Hạnh\t"
    },
    "2025-01-08": {
        "content": "La lógica te llevará desde A hasta B. La imaginación te llevará a cualquier parte –Albert Einstein.\t"
    },
    "2025-01-09": {
        "content": "Hazles comprender que no tienen en el mundo otro deber que la alegría. –Paul Claudel\t"
    },
    "2025-01-10": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2025-01-11": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2025-01-12": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2025-01-13": {
        "content": "Eres lo que eres hoy por las acciones que has hecho o las acciones que no has hecho. –Steve Maraboli\t"
    },
    "2025-01-14": {
        "content": " Es más fácil obtener lo que se desea con una sonrisa que con la punta de la espada –William Shakespeare\t"
    },
    "2025-01-15": {
        "content": " Sin importar lo fácil o difícil que sea la vida, siempre encontraré la manera de disfrutar. Incluso cuando las circunstancias sean adversas. –Termitope Owosela\t"
    },
    "2025-01-16": {
        "content": "Si no usas tu sonrisa, eres como un hombre con un millón de dolares en el banco y sin poder sacarlos. –Les Giblin\t"
    },
    "2025-01-17": {
        "content": "Sonreír es definitivamente una de los mejores y más bellos remedios. Si tienes un buen sentido de humor y un buen enfoque hacia la vida, eso es hermoso –Rashida Jones\t"
    },
    "2025-01-18": {
        "content": " El éxito es un mal maestro. –Robert T. Kiyosaki\t"
    },
    "2025-01-19": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2025-01-20": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2025-01-21": {
        "content": "Tu mejor maestro es tu último error. –Ralph Nader\t"
    },
    "2025-01-22": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2025-01-23": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2025-01-24": {
        "content": " Participa en tus propios sueños. No digas solamente lo que quieres o te quejes de lo que no tienes. –Steve Maraboli\t"
    },
    "2025-01-25": {
        "content": "Ve definitivamente en dirección de tus sueños. Vive la vida que imaginaste tener –Henry David Thoreau.\t"
    },
    "2025-01-26": {
        "content": " Si quieres probarle algo al mundo, entonces necesitas que el mundo te preste atención para poder probarlo. –Toba Beta\t"
    },
    "2025-01-27": {
        "content": "El éxito y la felicidad dependen de ti. –Helen Keller\t"
    },
    "2025-01-28": {
        "content": "No hay caminos para la paz; la paz es el camino –Mahatma Gandhi.\t"
    },
    "2025-01-29": {
        "content": " Son necesarios cuarenta músculos para arrugar una frente, pero sólo quince para sonreír –Swami Sivananda\t"
    },
    "2025-01-30": {
        "content": "«La vida no se trata de esperar a que pase la tormenta, se trata de aprender a bailar bajo la lluvia». –Vivian Greene\t"
    },
    "2025-01-31": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2025-02-01": {
        "content": "La lógica te llevará de la A a la Z, pero la imaginación te llevará a cualquier lugar”. –Albert Einstein\t"
    },
    "2025-02-02": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2025-02-03": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2025-02-04": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2025-02-05": {
        "content": " Nunca te olvides de sonreír porque el día que no sonrías será un día perdido –Charles Chaplin\t"
    },
    "2025-02-06": {
        "content": "No quiero dejar de sonreír, bajo ninguna circunstancia, ni perder la libertad para pensar, y quiero enfrentarme a cualquier dificultad con valentía. –Banana Yashimoto\t"
    },
    "2025-02-07": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2025-02-08": {
        "content": "La mejor parte de la belleza es aquella que ninguna imagen puede expresar –Francis Bacon.\t"
    },
    "2025-02-09": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2025-02-10": {
        "content": " Ríe y el mundo reirá contigo; llora y llorarás sólo –Eli Wilcox\t"
    },
    "2025-02-11": {
        "content": "Conviene reír sin esperar a ser dichoso, no sea que nos sorprenda la muerte sin haber reído. –Jean de la Bruyere\t"
    },
    "2025-02-12": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2025-02-13": {
        "content": "El hombre que nos hace reír tiene mas votos para su propósito que el hombre que nos exige pensar. –Malcom de Chazall\t"
    },
    "2025-02-14": {
        "content": "El hombre incapaz de reír no solamente es apto para las traiciones, las estratagemas y los fraudes, sino que su vida entera ya es una traición y una estratagema. –Thomas Carlyle\t"
    },
    "2025-02-15": {
        "content": "Y luego me da una sonrisa que parece tan genuinamente dulce con el toque justo de timidez que el calor inesperado corre a través de mí. –Suzanne Collins\t"
    },
    "2025-02-16": {
        "content": "Eres mi sol nocturno, mi luna de día, mi mejor sonrisa. –Federico Moccia\t"
    },
    "2025-02-17": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2025-02-18": {
        "content": "No se trata de si te derriban, se trata de si te levantas –Vince Lombardi.\t"
    },
    "2025-02-19": {
        "content": "Cuando tienes la habilidad de hacer lo que amas y amar lo que haces, tienes la habilidad de impactar a las personas. Eso es lo que es tener una vida exitosa. Eso es lo que es tener una vida con sentido. –Tim Tebow\t"
    },
    "2025-02-20": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2025-02-21": {
        "content": " El secreto del éxito es mantener una imagen de un resultado exitoso en la mente. –Henry David Thoreau\t"
    },
    "2025-02-22": {
        "content": " Prende tu sonrisa, ríe sin razón. Tú controlas el interruptor de la felicidad, eres tú quien cambia el mundo –Roel van Sleeuwen\t"
    },
    "2025-02-23": {
        "content": "Sonreír en la presencia del peligro no significa que niegas el miedo, simplemente te ayudará a superarlo. –Richelle E. Goodrich\t"
    },
    "2025-02-24": {
        "content": "Una sonrisa es la única aflicción infecciosa que animo a todos a que propaguen. –Omar Kiam\t"
    },
    "2025-02-25": {
        "content": "«El éxito es la capacidad de ir de fracaso en fracaso sin perder el entusiasmo.» –Winston Churchill.\t"
    },
    "2025-02-26": {
        "content": "El hombre está condenado a ser libre –Jean  Paul Sartre.\t"
    },
    "2025-02-27": {
        "content": " La risa cura, es la obra social más barata y efectiva del mundo –Roberto Pettinato\t"
    },
    "2025-02-28": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2025-03-01": {
        "content": "El éxito consiste en ir de fracaso en fracaso sin pérdida de entusiasmo. –Winston Churchill\t"
    },
    "2025-03-02": {
        "content": "Nunca eres demasiado mayor para establecer nuevas metas o tener nuevos sueños”. –C.S. Lewis\t"
    },
    "2025-03-03": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2025-03-04": {
        "content": "La curva mas hermosa de una mujer es su sonrisa. –Bob Marley\t"
    },
    "2025-03-05": {
        "content": " Quien no sabe sonreír, no debe hablar de los beneficios de la sonrisa   –Eusebio Gómez Navarro\t"
    },
    "2025-03-06": {
        "content": "La perseverancia y la energía conquistan todo”. –Benjamin Franklin\t"
    },
    "2025-03-07": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2025-03-08": {
        "content": " Confía en la fuerza de tu cuerpo y corazón. Elige por estrella la autosuficiencia, la fe, la honestidad y la industria. No tomes demasiados consejos, mantén el timón y dirige tu propio barco, y recuerda que el gran arte de mandar es tomar una participación equitativa del trabajo. Pon fuego sobre la marca que quieres golpear. La energía y la determinación con el motivo correctos son las palancas que mueven al mundo. –Noah Porter.\t"
    },
    "2025-03-09": {
        "content": " Si sonríes cuando no hay nadie a tu alrededor, lo haces en serio –Andy Rooney\t"
    },
    "2025-03-10": {
        "content": "Lo que nos parecen pruebas amargas son bendiciones disfrazadas. –Oscar Wilde\t"
    },
    "2025-03-11": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2025-03-12": {
        "content": " El secreto para disfrutar el trabajo esta contenido en una palabra –excelencia. Saber cómo hacer algo bien es disfrutarlo. –Pearl S. Buck.\t"
    },
    "2025-03-13": {
        "content": "Si solo tienes una sonrisa, dásela a la gente que amas. –Maya Angelou\t"
    },
    "2025-03-14": {
        "content": "La voluntad de ganar, el deseo de triunfar, el ímpetu de alcanzar tu pleno potencial…estas son las llaves que abrirán la puerta a la excelencia personal. –Confucio\t"
    },
    "2025-03-15": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2025-03-16": {
        "content": "Encontrarás la clave del éxito debajo de la alarma del reloj. –Benjamin Franklin\t"
    },
    "2025-03-17": {
        "content": "No puedo esperar a hacerlo, quiero hacerlo ahora, quiero que ocurra si va a ocurrir –Georgia O’Keeffe.\t"
    },
    "2025-03-18": {
        "content": "Tomar responsabilidad personal es algo hermoso porque nos da un control completo sobre nuestro destino. –Heather Schuck\t"
    },
    "2025-03-19": {
        "content": "Cada día sabemos más y entendemos menos –Albert Einstein.\t"
    },
    "2025-03-20": {
        "content": " El éxito no es comparar lo que hemos hecho con lo que los demás han hecho. –Myles Munroe\t"
    },
    "2025-03-21": {
        "content": "Hacer sonreír a una persona significa para mi más que cualquier cosa. –Michael Jackson\t"
    },
    "2025-03-22": {
        "content": " No importa lo bueno que seas, siempre puedes ser mejor, esa es la parte emocionante. –Tiger Woods\t"
    },
    "2025-03-23": {
        "content": "La forma de empezar es dejar de hablar y empezar a actuar   –Walt Disney\t"
    },
    "2025-03-24": {
        "content": "Si es bueno vivir, todavía es mejor soñar, y lo mejor de todo, despertar –Antonio Machado.\t"
    },
    "2025-03-25": {
        "content": "Haz de tu sonrisa un paraguas y deja que llueva. –Twin Peaks\t"
    },
    "2025-03-26": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2025-03-27": {
        "content": " El éxito es hacer, no obtener. Es intentar, no triunfar. El éxito es un estándar personal, es alcanzar lo más alto que hay en nosotros, convertirnos en todo lo que podemos ser. Si damos nuestro mejor esfuerzo, somos exitosos. –Zig Ziglar\t"
    },
    "2025-03-28": {
        "content": "El no querer es la causa, el no poder el pretexto –Seneca.\t"
    },
    "2025-03-29": {
        "content": "Estar preparado es importante, saber esperarlo es aún más, pero aprovechar el momento adecuado es la clave de la vida –Arthur Schnitzler.\t"
    },
    "2025-03-30": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2025-03-31": {
        "content": "La sonrisa es una verdadera fuerza vital, la única capaz de mover lo inconmovible –Orison Swett Marden\t"
    },
    "2025-04-01": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2025-04-02": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2025-04-03": {
        "content": "Dios creó el desierto para que el hombre pudiera sonreír al ver las palmeras. –Paulo Coelho\t"
    },
    "2025-04-04": {
        "content": "La mayoría de las grandes hazañas logradas por el hombre fueron consideradas imposibles antes de que alguien las llevara a cabo”. –Louis D. Brandeis.\t"
    },
    "2025-04-05": {
        "content": "La sonrisa se ha puesto de pie como una hazaña. –Manuel Del Cabral\t"
    },
    "2025-04-06": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2025-04-07": {
        "content": "«El fracaso no es caer, sino negarse a levantarse». –Anónimo\t"
    },
    "2025-04-08": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2025-04-09": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2025-04-10": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2025-04-11": {
        "content": "Quien nos hace reír es un cómico. Quien nos hace pensar y luego reír es un humorista. –George Burns\t"
    },
    "2025-04-12": {
        "content": "Ni siquiera trató de sonreír. Entonces supe que lo había perdido para siempre. –Marian Keyes\t"
    },
    "2025-04-13": {
        "content": "Y que placer, cuando no hay nada, que pueda ver, y solo invento tu sonrisa, y apago así, toda agonía. –Luis Alberto Spinetta\t"
    },
    "2025-04-14": {
        "content": "No llores porque ya se terminó, sonríe porque sucedió. –Gabriel García Marquez\t"
    },
    "2025-04-15": {
        "content": "Podemos experimentar muchas derrotas, pero no debemos permitir que nos derroten”. –Maya Angelou\t"
    },
    "2025-04-16": {
        "content": "Aceptamos la salida del sol y de la luna, sabemos de su poder, de su influencia, incluso les rendimos tributo, pero no alcanzamos a comprender lo que nos puede beneficiar el nacimiento de una sonrisa en nuestro corazón. –Laura Esqivel\t"
    },
    "2025-04-17": {
        "content": "Porque yo, sólo yo, veo su sonrisa una milésima antes de que le llegue a la cara. –David Mitchell\t"
    },
    "2025-04-18": {
        "content": "Sabes lo que es realmente contagioso? Una gran sonrisa. –Scrubs\t"
    },
    "2025-04-19": {
        "content": "Sonríe, a pesar de todo. –Steinberg\t"
    },
    "2025-04-20": {
        "content": " Aunque sonreír es un trabajo de un simple instante, sus efectos duran por mucho tiempo –Bucky Buckbinder\t"
    },
    "2025-04-21": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2025-04-22": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2025-04-23": {
        "content": "Consulta no tus miedos sino tus esperanzas y tus sueños. No pienses en tus frustraciones, sino en tu potencial incumplido. Preocúpate no en lo que has intentado y fracasado, sino en lo que todavía es posible hacer y lograr. –Juan XXIII\t"
    },
    "2025-04-24": {
        "content": " La única batalla real en la vida es la que se da entre elegir aferrarse o dejar que se vaya. –Shannon L. Alder\t"
    },
    "2025-04-25": {
        "content": " Empieza cada día con una sonrisa y mantenla todo el día –W. C. Fields\t"
    },
    "2025-04-26": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2025-04-27": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2025-04-28": {
        "content": "Es maravilloso que nadie tenga que esperar ni un segundo para comenzar a hacer del mundo un lugar mejor”. –Ana Frank\t"
    },
    "2025-04-29": {
        "content": " El poder de una sonrisa es tal que, incluso si dibujas una carita feliz, bastará para hacer que tus labios se muevan de la misma forma –Richelle E. Goodrich\t"
    },
    "2025-04-30": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2025-05-01": {
        "content": "Si haces cada tarea como la vas a hacer por el resto de tu vida, es entonces cuando vas a destacar. –Mary Barra\t"
    },
    "2025-05-02": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2025-05-03": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2025-05-04": {
        "content": " Nunca conseguirás el éxito al menos que te guste lo que estas haciendo. –Dale Carnegie\t"
    },
    "2025-05-05": {
        "content": "Mantente alejado de la gente que intenta menospreciar tus ambiciones. La gente pequeña siempre hace eso, pero la gente realmente grande te hace sentir que tu también puedes ser grande –Mark Twain.\t"
    },
    "2025-05-06": {
        "content": "No importa lo lento que vayas mientras que no pares –Confucio.\t"
    },
    "2025-05-07": {
        "content": "«El éxito es cuestión de actitud, no de aptitud.» –Ralph Waldo Emerson.\t"
    },
    "2025-05-08": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2025-05-09": {
        "content": " Cada sonrisa te hace un día más joven  –Proverbio chino\t"
    },
    "2025-05-10": {
        "content": "«La vida es como montar una bicicleta, para mantener el equilibrio debes seguir adelante». –Albert Einstein, frases de la vida es dura\t"
    },
    "2025-05-11": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2025-05-12": {
        "content": "«El éxito no es para los que sueñan despiertos, sino para aquellos que sueñan y hacen que sus sueños se hagan realidad.» –Jack Canfield.\t"
    },
    "2025-05-13": {
        "content": "Nunca te rindas. Establece una meta y no te rindas hasta que la consigas. Cuando la consigas, establece otro objetivo y no te rindas hasta que lo alcances. Nunca te rindas. –Bear Bryant\t"
    },
    "2025-05-14": {
        "content": "Cambia tus pensamientos y cambiarás tu mundo –Norman Vincent Peale.\t"
    },
    "2025-05-15": {
        "content": "Si un hombre sonríe todo el tiempo, probablemente vende algo que no funciona. –George Carlin\t"
    },
    "2025-05-16": {
        "content": " No tengas miedo de dejar algo bueno para ir a por algo mejor. –John D. Rockefeller\t"
    },
    "2025-05-17": {
        "content": "Son tus ojos los que busco, son tus labios los que quiero ver sonreír. –Violeta Parra\t"
    },
    "2025-05-18": {
        "content": "«El éxito no es para los que tienen fuerzas, sino para aquellos que no se rinden.» –Alexandre Dumas.\t"
    },
    "2025-05-19": {
        "content": " No hay ninguna cosa seria que no pueda decirse con una sonrisa –Alejandro Casona\t"
    },
    "2025-05-20": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2025-05-21": {
        "content": "El primer paso es el más importante. Es el más crucial y más efectivo, ya que iniciará la dirección que has elegido. –Steve Backley\t"
    },
    "2025-05-22": {
        "content": " Crecerás el día en que verdaderamente te rías por primera vez de ti mismo –Ethel Barrymore\t"
    },
    "2025-05-23": {
        "content": " En cualquier momento, la decisión de ser feliz está presente. Sólo tenemos que escoger ser feliz. –Steve Maraboli\t"
    },
    "2025-05-24": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2025-05-25": {
        "content": " Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs\t"
    },
    "2025-05-26": {
        "content": "Huye de los rostros graves y solemnes que jamás se distienden en una sonrisa. Huye de los espíritus susceptibles, que por todo se ofenden. –Ricardo León\t"
    },
    "2025-05-27": {
        "content": "Si es posible, se debe hacer reír hasta a los muertos. –Leonardo Da Vinci\t"
    },
    "2025-05-28": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2025-05-29": {
        "content": "La risa es el lenguaje del alma. –Pablo Neruda\t"
    },
    "2025-05-30": {
        "content": "La vida es un 10% lo que me ocurre y 90% cómo reacciono a ello –John Maxwell.\t"
    },
    "2025-05-31": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2025-06-01": {
        "content": " Vamos a conseguir muchas más cosas si pensamos que nada es imposible. –Vince Lombardi\t"
    },
    "2025-06-02": {
        "content": "No puedo dejar de justificar el que se anime a los niños a sonreír antes que a llorar. No deseo pagar por ver otras lágrimas que las del teatro. –Robert Louis Stevenson\t"
    },
    "2025-06-03": {
        "content": "El momento en el que consideras rendirte es justo el momento en el que debes seguir adelante”. –Anónimo\t"
    },
    "2025-06-04": {
        "content": " La felicidad no puede ser la única medida del éxito. –John C. Maxwell\t"
    },
    "2025-06-05": {
        "content": "La sonrisa es la llave que abre el corazón de todo el mundo. –Anthony J. D’Angelo\t"
    },
    "2025-06-06": {
        "content": "Hay tres tipos de personas en este mundo. Primero, están las que hacen que ocurran las cosas. Luego están las que ven cómo ocurren las cosas. Por último, están las que preguntan, ¿qué ha ocurrido? ¿Cuál quieres ser tú? –Steve Backley\t"
    },
    "2025-06-07": {
        "content": "El éxito no es final, el fracaso no es fatal. Es el coraje para continuar lo que cuenta. –Winston S. Churchill\t"
    },
    "2025-06-08": {
        "content": " Lo que mueve al mundo no son los potentes brazos de los héroes, sino la suma de los pequeños empujones de cada trabajador honrado. –Hellen Keller.\t"
    },
    "2025-06-09": {
        "content": "«No importa cuántas veces te caigas, sino cuántas veces te levantes». –Vince Lombardi\t"
    },
    "2025-06-10": {
        "content": "Rodéate de personas que crean en tus sueños, alienten tus ideas, apoyen tus ambiciones y saquen lo mejor de ti”. –Roy T. Bennett\t"
    },
    "2025-06-11": {
        "content": "Cuando la necesidad de éxito es tanta como la necesidad de respirar, entonces serás exitoso –Eric Thomas.\t"
    },
    "2025-06-12": {
        "content": "Pienso, luego existo –René Descartes.\t"
    },
    "2025-06-13": {
        "content": "La mala noticia es que el tiempo vuela, la buena noticia es que tú eres el piloto. –Michael Althsuler\t"
    },
    "2025-06-14": {
        "content": "La definición del propósito es el punto de comienzo de todo logro –Clement Stone.\t"
    },
    "2025-06-15": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2025-06-16": {
        "content": "Sin sonrisa de mujer no hay gloria completa de hombre. –José Marti\t"
    },
    "2025-06-17": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2025-06-18": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2025-06-19": {
        "content": "En cierto momento logré sonreír de nuevo y sentirme mejor. No solo en el corazón, sino en todo mi cuerpo. Caí en la cuenta de que me hacía bien, que tenía que seguir sonriendo. –Yoko Ono\t"
    },
    "2025-06-20": {
        "content": "Espero tu sonrisa y espero tu fragancia por encima de todo, del tiempo y la distancia. –José Angel Buesa\t"
    },
    "2025-06-21": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2025-06-22": {
        "content": "La sonrisa es el trapo que limpia las telarañas del corazón. –Mort Walker\t"
    },
    "2025-06-23": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2025-06-24": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2025-06-25": {
        "content": "El cielo no es un límite para mí, porque no tengo límites en mi vida. Porque la vida es un mundo lleno de riesgos y posibilidades. –Termitope Owosela\t"
    },
    "2025-06-26": {
        "content": "Las más grandes decepciones que sufre el hombre, vienen de sus propias opiniones. –Leonardo DaVinci\t"
    },
    "2025-06-27": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2025-06-28": {
        "content": "Sólo hay un éxito: ser capaz de pasar tu vida a tu manera. –Christopher Morley\t"
    },
    "2025-06-29": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2025-06-30": {
        "content": "Comienza por hacer lo necesario; luego haz lo que es posible; y, de repente, estarás haciendo lo imposible –Francisco de Asís.\t"
    },
    "2025-07-01": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2025-07-02": {
        "content": "Una sonrisa es una curva que pone todo recto. –Phyllis Diller\t"
    },
    "2025-07-03": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2025-07-04": {
        "content": " Alguien que elige sonreír antes que enfadarse, es una persona realmente fuerte –David Schary\t"
    },
    "2025-07-05": {
        "content": "Opino que lo que se llama belleza, reside únicamente en la sonrisa. –León Tolstoi\t"
    },
    "2025-07-06": {
        "content": "No esperes. Nunca habrá un momento perfecto”. –Napoleon Hill,\t"
    },
    "2025-07-07": {
        "content": " El día en que te halles a ti mismo sonriendo sin razón, ese día puedes decir que has encontrado la felicidad –Rebecca Stead\t"
    },
    "2025-07-08": {
        "content": "Sonríe, es una terapia gratis. –Douglas Horton\t"
    },
    "2025-07-09": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2025-07-10": {
        "content": "El secreto de la existencia humana no solo está en vivir, sino también en saber para qué se vive –Fiódor Dostoievski\t"
    },
    "2025-07-11": {
        "content": "Hay sonrisas que no son de felicidad, sino de un modo de llorar con bondad. –Gabriela Mistral\t"
    },
    "2025-07-12": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2025-07-13": {
        "content": "Era una sonrisa que podría hacer que un hombre creyera que la vida era buena. –John Verdon\t"
    },
    "2025-07-14": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes . –Víctor Ruiz Iriarte\t"
    },
    "2025-07-15": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2025-07-16": {
        "content": " El trabajo más productivo es el que sale de las manos de un hombre contento. –Victor Pauchet.\t"
    },
    "2025-07-17": {
        "content": "Los colores son la sonrisa de la naturaleza. –Leigh Hunt\t"
    },
    "2025-07-18": {
        "content": "Las limitaciones solo habitan en nuestra mente. Pero si usamos nuestra imaginación, nuestras posibilidades son ilimitadas –Jamie Paolinetti.\t"
    },
    "2025-07-19": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2025-07-20": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2025-07-21": {
        "content": "Supe que eras la indicada cuando tu sonrisa se convirtió en mi cielo, tu risa en mi canción favorita y tus brazos en mi hogar. –Steve Maraboli\t"
    },
    "2025-07-22": {
        "content": "«La vida nos prueba con obstáculos, pero nuestras respuestas a esas pruebas definen nuestra fuerza y determinación». ­–Frases de la vida es dura para reflexionar\t"
    },
    "2025-07-23": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2025-07-24": {
        "content": "Quienes no saben llorar con todo el corazón, tampoco saben sonreír. –Golda Meir\t"
    },
    "2025-07-25": {
        "content": " Estoy convencido de que aproximadamente la mitad de lo que separa a los emprendedores de éxito de los de no  éxito es la perseverancia. –Steve Jobs\t"
    },
    "2025-07-26": {
        "content": "El único hombre que nunca comete un error es el hombre que nunca hace nada. –Theodore Roosevelt\t"
    },
    "2025-07-27": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2025-07-28": {
        "content": " La mayor arma que uno puede portar frente a sus enemigos es una simple…sonrisa –Lionel Suggs\t"
    },
    "2025-07-29": {
        "content": "Si dicen mal de ti con fundamento, corrígete; de lo contrario, échate a reír. –Epicteto de Frigia\t"
    },
    "2025-07-30": {
        "content": "«La vida nos somete a pruebas para mostrarnos que somos más fuertes de lo que imaginamos en nuestros peores momentos». –Las mejores frases de la vida es dura\t"
    },
    "2025-07-31": {
        "content": "Eres asombroso porque estás aquí vivo, luchas cada día para mantenerte de pie. ¿Por qué sufres si tienes la solución en tus manos? ¿Por qué lloras si puedes cambiarlo todo? La vida es hermosa porque existes tú”. –Frases sobre la vida\t"
    },
    "2025-08-01": {
        "content": " El cambio está en el aire. Nos recuerda que fuimos esculpidos por el mismo poder que orquesta el cambio de las estaciones. Que esta sea la estación en la que aceptes el cambio y te alinees con él. –Steve Maraboli\t"
    },
    "2025-08-02": {
        "content": "Comienza donde estás, usa lo que tienes, haz lo que puedes –Arthur Ashe.\t"
    },
    "2025-08-03": {
        "content": " Lo que hoy ves como fracaso puede ser un paso crucial hacia el éxito que estás buscando. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2025-08-04": {
        "content": "La sonrisa es el idioma general de los hombres inteligentes. Sólo son tristes los tontos y los delincuentes. –Víctor Ruiz Iriarte\t"
    },
    "2025-08-05": {
        "content": "Todos deberíamos saber todo el bien que una simple sonrisa puede hacer. –Madre Teresa de Calcuta\t"
    },
    "2025-08-06": {
        "content": "Ella sonrió y su rostro se iluminó. O tal vez fue el mío. Todo lo que sé con certeza es que su sonrisa iluminó hasta mis días más oscuros. –J. Sterling\t"
    },
    "2025-08-07": {
        "content": "Aferrarse a la ira es como beber veneno y esperar que la otra persona muera –Buda.\t"
    },
    "2025-08-08": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2025-08-09": {
        "content": " La risa es la distancia más corta entre dos personas –Víctor Borge\t"
    },
    "2025-08-10": {
        "content": "¿Cuándo regresará esa sonrisa que me desnuda en cuerpo y alma? –Jenniley Bonilla\t"
    },
    "2025-08-11": {
        "content": "Quiero borrar las lágrimas de todos los que confiaron en la esperanza y se las quitaron. Quiero que se queden con una sonrisa en sus rostros. –Cuarteto Magica\t"
    },
    "2025-08-12": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2025-08-13": {
        "content": "La muerte nos sonríe a todos, devolvámosle la sonrisa. –Gladiator\t"
    },
    "2025-08-14": {
        "content": "Tenía los labios inmóviles, pero cuando lo miré parecieron sonreír sin hacer el más mínimo movimiento. –Anne Rice\t"
    },
    "2025-08-15": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2025-08-16": {
        "content": "Deja de mentirte. Cuando negamos nuestra verdad, negamos nuestro verdadero potencial. –Steve Maraboli\t"
    },
    "2025-08-17": {
        "content": " Cuando deseamos convertirnos en personas de éxito, lo primero que tenemos que hacer es actuar como si ya lo fuésemos. –Gaby Vargas\t"
    },
    "2025-08-18": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2025-08-19": {
        "content": "El éxito no es mágico ni misterioso. El éxito es la consecuencia natural de aplicar los fundamentos básicos. –Jim Rohn\t"
    },
    "2025-08-20": {
        "content": "Creo que podría hacerme sonreír aunque estuviera colgada de una horca. –Jandy Nelson\t"
    },
    "2025-08-21": {
        "content": "Los seres humanos no nacen para siempre el día en que sus madres los alumbran, sino que la vida los obliga a parirse a sí mismos una y otra vez –Gabriel García Márquez.\t"
    },
    "2025-08-22": {
        "content": "Tu trabajo va a llenar una gran parte de tu vida; la única manera de estar verdaderamente satisfecho es hacer lo que crees que es un gran trabajo y la única manera de hacer un gran trabajo es amar lo que haces. Si todavía no lo has encontrado, sigue buscando. No te conformes. Como con todos los asuntos del corazón, sabrás cuando lo encuentres. –Steve Jobs\t"
    },
    "2025-08-23": {
        "content": "No cuentes los días, haz que los días cuenten –Muhammad Ali.\t"
    },
    "2025-08-24": {
        "content": "Frecuentemente me pregunto si esas personas, las que más sonríen, serán en verdad las más tristes en el mundo. –Anthony Liccione\t"
    },
    "2025-08-25": {
        "content": "Si un líder no transmite pasión e intensidad, entonces no habrá pasión e intensidad dentro de la organización y empezarán a caer y deprimirse. –Colin Powell\t"
    },
    "2025-08-26": {
        "content": "No dejes de sonreír… Porque es muy poco el tiempo que te dan para la alegría –Zenaida Bacardí de Argamasilla\t"
    },
    "2025-08-27": {
        "content": "Puede que seas la única persona que crea en ti, pero eso es suficiente. Sólo se necesita una estrella para perforar la oscuridad del universo. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2025-08-28": {
        "content": "Una sonrisa es una línea curva que lo endereza todo –Phyllis Diller\t"
    },
    "2025-08-29": {
        "content": "Por una mirada, un mundo –por una sonrisa, un cielo –por un beso… yo no sé –qué te diera por un beso. –Gustavo Adolfo Bécquer\t"
    },
    "2025-08-30": {
        "content": "No malgastes tu tiempo odiando un fracaso. El fracaso es mejor maestro que el éxito. Escucha, aprende, sigue adelante. –Clarissa Pinkola Estés\t"
    },
    "2025-08-31": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2025-09-01": {
        "content": "Cuando un niño comienza a sonreír, con una pequeña bifurcación de amargor y dulzura, las orillas de su sonrisa desembocan sin burlas en la anarquía del océano. –Osip Mandelshtam\t"
    },
    "2025-09-02": {
        "content": "«El éxito no es la clave de la felicidad. La felicidad es la clave del éxito. Si amas lo que haces, serás exitoso». –Albert Schweitzer\t"
    },
    "2025-09-03": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2025-09-04": {
        "content": "Si estás comprometido con algo que realmente te importa, no necesitarás que nadie te empuje: tu visión te impulsará”. –Steve Jobs\t"
    },
    "2025-09-05": {
        "content": "¿Quieres saber quién eres? No preguntes. ¡Actúa! La acción delineará y definirá quién eres –Thomas Jefferson.\t"
    },
    "2025-09-06": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2025-09-07": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2025-09-08": {
        "content": " No le temas al fracaso. Es el camino al éxito. –LeBron James\t"
    },
    "2025-09-09": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2025-09-10": {
        "content": " Hoy es el único día sobre el que tenemos poder. –Steve Maraboli\t"
    },
    "2025-09-11": {
        "content": "Quítame el pan, si quieres, quítame el aire, pero no me quites tu risa. –Pablo Neruda\t"
    },
    "2025-09-12": {
        "content": "Deja que mi alma sonría a través de mi corazón y que mi corazón sonría a través de mis ojos, para que pueda esparcir ricas sonrisas en corazones tristes. –Paramahansa Yogananda\t"
    },
    "2025-09-13": {
        "content": " La sonrisa enriquece a los que la reciben, sin empobrecer a los que la dan –Frank Irving\t"
    },
    "2025-09-14": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2025-09-15": {
        "content": " La vida es corta. Vive apasionadamente. –Marc A. Pitma\t"
    },
    "2025-09-16": {
        "content": "La paz comienza con una sonrisa. –Madre Teresa\t"
    },
    "2025-09-17": {
        "content": "Si mi estupidez te hace sonreír, prefiero entonces actuar siempre como un estúpido. –M.F. Moonzajer\t"
    },
    "2025-09-18": {
        "content": "No tienes que ser grande para empezar. Pero tienes que empezar para poder ser grande”. –Zig Ziglar\t"
    },
    "2025-09-19": {
        "content": "Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs.\t"
    },
    "2025-09-20": {
        "content": " Nunca dejes de sonreír, ni siquiera cuando estés triste, porque nunca sabes quien se puede enamorar de tu sonrisa –Gabriel García Márquez\t"
    },
    "2025-09-21": {
        "content": "Me sonrió como no podría hacerlo un hombre, como si las mujeres lo supieran todo unas de las otras desde la eternidad. –Marcela serrano\t"
    },
    "2025-09-22": {
        "content": " La buena gestión consiste en mostrar a la gente común cómo hacer el trabajo de las personas superiores. –John D. Rockefeller\t"
    },
    "2025-09-23": {
        "content": "La mejor parte de la belleza es aquella que ninguna imagen puede expresar –Francis Bacon.\t"
    },
    "2025-09-24": {
        "content": "Quiero borrar las lágrimas de todos los que confiaron en la esperanza y se las quitaron. Quiero que se queden con una sonrisa en sus rostros. –Cuarteto Magica\t"
    },
    "2025-09-25": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2025-09-26": {
        "content": "Aunque sentí que estaba a punto de llorar, opté por sonreír. –Kristen Ashley\t"
    },
    "2025-09-27": {
        "content": "Cuando ella sonreía, él se olvidaba de todo. –Palmeras en la nieve\t"
    },
    "2025-09-28": {
        "content": "Su sonrisa podía parar el corazón de un hombre. –El nombre del viento\t"
    },
    "2025-09-29": {
        "content": "Cuando tengas fallas, no temas abandonarlas. –Confucio\t"
    },
    "2025-09-30": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2025-10-01": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2025-10-02": {
        "content": "Después de cada tormenta sonríe el sol; para cada problema hay una solución y el deber irrenunciable del alma es estar de buen ánimo. –William R. Alger\t"
    },
    "2025-10-03": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2025-10-04": {
        "content": "Si te pones a ti mismo en una posición en la que tienes que salir de tu zona de confort, estas forzando la expansión de tu consciencia. –Les Brown\t"
    },
    "2025-10-05": {
        "content": "La vida se encoge o se expande en proporción al coraje de uno –Anais Nin.\t"
    },
    "2025-10-06": {
        "content": "«El éxito no es la clave de la felicidad. La felicidad es la clave del éxito. Si amas lo que haces, tendrás éxito.» –Albert Schweitzer.\t"
    },
    "2025-10-07": {
        "content": "Mira hacia atrás y sonríe ante los peligros del pasado. –Walter Scott\t"
    },
    "2025-10-08": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes. –Víctor Ruiz Iriarte\t"
    },
    "2025-10-09": {
        "content": "Si vas en busca del amor nunca lo encontrarás porque el amor nunca se perdió; sólo nosotros nos perdemos. –Shannon L. Alder\t"
    },
    "2025-10-10": {
        "content": "Las arrugas solo deberían indicar donde las sonrisas han estado. –Mark Twain\t"
    },
    "2025-10-11": {
        "content": "No importa lo que la gente diga, las palabras y las ideas tienen el poder de cambiar el mundo”. –Robin Williams\t"
    },
    "2025-10-12": {
        "content": "No tienes que ser grande para empezar. Pero tienes que empezar para poder ser grande”. –Zig Ziglar\t"
    },
    "2025-10-13": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2025-10-14": {
        "content": "Muy frecuentemente las lágrimas son la última sonrisa del amor. –Stendhal\t"
    },
    "2025-10-15": {
        "content": "La mejor preparación para mañana es hacer lo mejor que puedas hoy –H. Jackson Brown, Jr.\t"
    },
    "2025-10-16": {
        "content": "Si la vida no te diera al menos una persona que no quiera que lo logres, entonces la mitad de nosotros perdería la motivación de escalar el acantilado sólo para probar que se equivocan. –Shannon L. Alder\t"
    },
    "2025-10-17": {
        "content": "La forma de arruinar la vida de alguien es darle todo lo que quiere. –Patrick Swayze\t"
    },
    "2025-10-18": {
        "content": "Cuando uno nace sólo sabe llorar. Sólo gradualmente se aprende a sonreír. –Halldór Laxness\t"
    },
    "2025-10-19": {
        "content": "El niño reconoce a la madre por la sonrisa. –Leon Tolstoi\t"
    },
    "2025-10-20": {
        "content": "Haz que se pregunten por qué sigues sonriendo. –Elizabethtown\t"
    },
    "2025-10-21": {
        "content": "Suspiró y después sonrió con la misma sonrisa que, sin importar cuántas veces la viese, siempre le robaba el corazón. Cada vez que sonreía volvía a ser la primera vez. –Neil Gaiman\t"
    },
    "2025-10-22": {
        "content": "«El único modo de hacer un gran trabajo es amar lo que haces». –Steve Jobs\t"
    },
    "2025-10-23": {
        "content": " No hay razón para tener un plan B, porque te distrae del plan A. –Will Smith\t"
    },
    "2025-10-24": {
        "content": "Hoy llevo puesta la sonrisa que me regalaste. –Edith Castro\t"
    },
    "2025-10-25": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2025-10-26": {
        "content": "Nunca permitiré que me vuelva tan importante, sabio, reservado y poderoso, que no pueda sonreír a los demás y reírme de mí mismo. –Og Mandino\t"
    },
    "2025-10-27": {
        "content": "Estaba sonriendo ayer, estoy sonriendo hoy y sonreiré mañana. Simplemente porque la vida es muy corta para llorar por cualquier cosa. –Santosh Kalwar\t"
    },
    "2025-10-28": {
        "content": "Una sonrisa es la felicidad que encontrarás justo debajo te tu nariz. –Tom Wilson\t"
    },
    "2025-10-29": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2025-10-30": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2025-10-31": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2025-11-01": {
        "content": "De humanos es errar y de necios permanecer en el error –Marco Tulio Cicerón\t"
    },
    "2025-11-02": {
        "content": "El corazón alegre hermosea el rostro. –Rey Salomón\t"
    },
    "2025-11-03": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2025-11-04": {
        "content": "A veces, cuando innovas, cometes errores. Lo mejor es admitirlos rápidamente y seguir mejorando otras innovaciones. –Steve Jobs\t"
    },
    "2025-11-05": {
        "content": "Para tener éxito hoy, tienes que fijar prioridades, decidir lo que representas. –Lee Laccoca\t"
    },
    "2025-11-06": {
        "content": "No llores porque terminó. Sonríe porque ocurrió. –Dr. Seuss.\t"
    },
    "2025-11-07": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes . –Víctor Ruiz Iriarte\t"
    },
    "2025-11-08": {
        "content": "No importa si te derriban, lo importante es si te levantas cuando sucede”. –Vince Lombardi\t"
    },
    "2025-11-09": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2025-11-10": {
        "content": "Las guerras seguirán mientras el color de la piel siga siendo más importante que el de los ojos –Bob Marley.\t"
    },
    "2025-11-11": {
        "content": " ¿Cómo serías si fueses la única persona del mundo? Si quieres ser realmente feliz, debes ser esa persona. –Quetin Crisp\t"
    },
    "2025-11-12": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2025-11-13": {
        "content": "Si estás leyendo esto… Felicitaciones, estás vivo. Si eso no es algo para sonreír, entonces no sé qué es. –Chad Sugg\t"
    },
    "2025-11-14": {
        "content": " Nunca te sorprendas por tu éxito. –Steve Maraboli\t"
    },
    "2025-11-15": {
        "content": "Para ser exitoso hay que seguir el camino de los gigantes. –Lillian Cauldwell\t"
    },
    "2025-11-16": {
        "content": "El éxito es un camino, no un destino. –Ben Sweetland\t"
    },
    "2025-11-17": {
        "content": " A menudo las personas quedan atrapadas en un estado de sobre  pensamiento, y el resultado es que nunca toman una decisión. –Steve Backley\t"
    },
    "2025-11-18": {
        "content": "Sonreímos, pero quiero más, quiero que me abraces. –M.J. Hayland\t"
    },
    "2025-11-19": {
        "content": " A veces, no obtener lo que quieres es un golpe de suerte brillante. –Lorii Myers\t"
    },
    "2025-11-20": {
        "content": "Si de verdad quieres comer, sigue escalando. Las frutas están en la cima del árbol. Estira tus brazos y sigue estirándolos. El éxito está en la cima, sigue adelante. –Isralemore Ayivor\t"
    },
    "2025-11-21": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2025-11-22": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2025-11-23": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2025-11-24": {
        "content": "Nadie puede hacerte sentir inferior sin tu consentimiento”. –Eleanor Roosevelt\t"
    },
    "2025-11-25": {
        "content": "Una sonrisa es la forma más barata de cambiar nuestro aspecto. –Charles Gordu\t"
    },
    "2025-11-26": {
        "content": "Una sonrisa puede iluminar los lugares más oscuros. –Steve Maraboli\t"
    },
    "2025-11-27": {
        "content": " El día peor empleado es aquél en que no se ha reído –Nicolás  Sebastien Roch Chamfort\t"
    },
    "2025-11-28": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2025-11-29": {
        "content": "No puedo mantenerme enojado cuando me sonríes. –M.F. Moonzajer\t"
    },
    "2025-11-30": {
        "content": "Elimina de tu vida todo aquello que te cause estrés y te quite la sonrisa. –Paulo Coelho\t"
    },
    "2025-12-01": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2025-12-02": {
        "content": " No te sientas avergonzado de intentarlo y fallar, puesto que la persona que nunca ha fallado es alguien que nunca lo ha intentado. –Og Mandino\t"
    },
    "2025-12-03": {
        "content": "La mayor declaración de amor es la que no se hace; el hombre que siente mucho, habla poco –Platón.\t"
    },
    "2025-12-04": {
        "content": "El hombre verdadero sonríe ante los problemas, toma fuerza de la angustia y crece valiente ante la decepción. –Thomas Paine\t"
    },
    "2025-12-05": {
        "content": "El pesimista ve dificultades en cada oportunidad. El optimista ve oportunidades en cada dificultad”. –Winston Churchill\t"
    },
    "2025-12-06": {
        "content": "Si he visto más lejos que otros, es por estar de pie sobre los hombros de gigantes –Isaac Newton.\t"
    },
    "2025-12-07": {
        "content": "Hay un solo rincón del universo que puedes estar seguro de poder mejorar, y eres tú mismo –Aldous Huxley.\t"
    },
    "2025-12-08": {
        "content": "El comportamiento humano fluye de tres fuentes: emoción, deseo y conocimiento –Platón.\t"
    },
    "2025-12-09": {
        "content": "Las sonrisas más auténticas son aquellas que se esparcen en nuestras caras cuando nadie nos está mirando. –Minhal Mehdi\t"
    },
    "2025-12-10": {
        "content": "No puedo darte una fórmula segura para el éxito, pero puedo darte una para el fracaso: intenta complacer a todo el mundo todo el tiempo. –Herbert Bayard Swope\t"
    },
    "2025-12-11": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2025-12-12": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2025-12-13": {
        "content": " Comparte tus aspiraciones con aquellos que te vayan a apoyar, no con aquellos que respondan con duda o falta de interés. –Steve Backley\t"
    },
    "2025-12-14": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2025-12-15": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2025-12-16": {
        "content": "Ve tan lejos como puedas ver y verás más lejos. –Zig Ziglar\t"
    },
    "2025-12-17": {
        "content": " La diferencia entre la codicia y la ambición es que la persona codiciosa desea cosas para las que no está preparada. –Habeeb Akande\t"
    },
    "2025-12-18": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2025-12-19": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2025-12-20": {
        "content": "Teresa de la dulce sonrisa; porque mientras las demás se esforzaban una y otra vez en superarla, ella simplemente las derrotaba con una sonrisa en su rostro. –Claymore\t"
    },
    "2025-12-21": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2025-12-22": {
        "content": "«En medio de la dificultad yace la oportunidad». –Albert Einstein\t"
    },
    "2025-12-23": {
        "content": "Mi padre siempre me decía: encuentra un trabajo que te guste y no tendrás que trabajar un solo día de tu vida. –Jim Fox.\t"
    },
    "2025-12-24": {
        "content": " El éxito es hacer lo que sea que quieras hacer, cuando quieras, donde quieras, con quien quieras y por el tiempo que quieras. –Anthony Robbins\t"
    },
    "2025-12-25": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2025-12-26": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2025-12-27": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2025-12-28": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2025-12-29": {
        "content": "Son tus ojos los que busco, son tus labios los que quiero ver sonreír. –Violeta Parra\t"
    },
    "2025-12-30": {
        "content": " Si sonríes cuando no hay nadie a tu alrededor, lo haces en serio –Andy Rooney\t"
    },
    "2025-12-31": {
        "content": "¿Sabias que. . . Cuando pasas caminando por una flor, sea en algún jardín o en un alguna ladera, la flor siempre te sonríe? la forma más cortés de responder, me han dicho, es devolver la sonrisa alegremente. –Ron Atchison\t"
    },
    "2026-01-01": {
        "content": " Lo que hoy ves como fracaso puede ser un paso crucial hacia el éxito que estás buscando. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2026-01-02": {
        "content": " La vida es corta. Vive apasionadamente. –Marc A. Pitma\t"
    },
    "2026-01-03": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2026-01-04": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2026-01-05": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2026-01-06": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2026-01-07": {
        "content": " El trabajo más productivo es el que sale de las manos de un hombre contento. –Victor Pauchet.\t"
    },
    "2026-01-08": {
        "content": " El éxito no es comparar lo que hemos hecho con lo que los demás han hecho. –Myles Munroe\t"
    },
    "2026-01-09": {
        "content": "Si la vida no te diera al menos una persona que no quiera que lo logres, entonces la mitad de nosotros perdería la motivación de escalar el acantilado sólo para probar que se equivocan. –Shannon L. Alder\t"
    },
    "2026-01-10": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2026-01-11": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2026-01-12": {
        "content": "Permanece firme a tus principios, pero siempre abierto a aprender. Trabaja duro, nunca renuncies a tus sueños, incluso cuando nadie crea que puedan hacerse realidad excepto tu. Estos no son clichés, sino que son herramientas auténticas que necesitas para estar concentrado en tu trayectoria, no importa a lo que te dediques en tu vida. –Phillip Sweet\t"
    },
    "2026-01-13": {
        "content": "Sé amable, ya que cada persona que conoces está enfrentando una batalla interna”. –Platón\t"
    },
    "2026-01-14": {
        "content": "Suspiró y después sonrió con la misma sonrisa que, sin importar cuántas veces la viese, siempre le robaba el corazón. Cada vez que sonreía volvía a ser la primera vez. –Neil Gaiman\t"
    },
    "2026-01-15": {
        "content": "Las limitaciones solo habitan en nuestra mente. Pero si usamos nuestra imaginación, nuestras posibilidades son ilimitadas –Jamie Paolinetti.\t"
    },
    "2026-01-16": {
        "content": "Cada día sabemos más y entendemos menos –Albert Einstein.\t"
    },
    "2026-01-17": {
        "content": "Comienza donde estás, usa lo que tienes, haz lo que puedes –Arthur Ashe.\t"
    },
    "2026-01-18": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2026-01-19": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2026-01-20": {
        "content": " La única batalla real en la vida es la que se da entre elegir aferrarse o dejar que se vaya. –Shannon L. Alder\t"
    },
    "2026-01-21": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2026-01-22": {
        "content": "Me sonrió como no podría hacerlo un hombre, como si las mujeres lo supieran todo unas de las otras desde la eternidad. –Marcela serrano\t"
    },
    "2026-01-23": {
        "content": "Comienza y termina el día con una sonrisa. –W.C. Fields\t"
    },
    "2026-01-24": {
        "content": " Nunca te sorprendas por tu éxito. –Steve Maraboli\t"
    },
    "2026-01-25": {
        "content": "La lógica te llevará de la A a la Z, pero la imaginación te llevará a cualquier lugar”. –Albert Einstein\t"
    },
    "2026-01-26": {
        "content": "Sin sonrisa de mujer no hay gloria completa de hombre. –José Marti\t"
    },
    "2026-01-27": {
        "content": "Aceptamos la salida del sol y de la luna, sabemos de su poder, de su influencia, incluso les rendimos tributo, pero no alcanzamos a comprender lo que nos puede beneficiar el nacimiento de una sonrisa en nuestro corazón. –Laura Esqivel\t"
    },
    "2026-01-28": {
        "content": "Quítame el pan, si quieres, quítame el aire, pero no me quites tu risa. –Pablo Neruda\t"
    },
    "2026-01-29": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2026-01-30": {
        "content": "«En medio de la dificultad yace la oportunidad». –Albert Einstein\t"
    },
    "2026-01-31": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2026-02-01": {
        "content": "El hombre está condenado a ser libre –Jean  Paul Sartre.\t"
    },
    "2026-02-02": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2026-02-03": {
        "content": "A menudo subestimamos el poder de una caricia, una sonrisa, una palabra amable, un oído atento, un cumplido honesto o el acto más pequeño de cariño, todos los cuales tienen el potencial de cambiar una vida. –Leo Buscaglia\t"
    },
    "2026-02-04": {
        "content": " No dejes que los bloqueos mentales te controlen. Libérate. Enfrenta tus miedos y transforma los bloqueos mentales en bloques de construcción. –Roopleen\t"
    },
    "2026-02-05": {
        "content": "Las arrugas solo deberían indicar donde las sonrisas han estado. –Mark Twain\t"
    },
    "2026-02-06": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2026-02-07": {
        "content": "La mayor declaración de amor es la que no se hace; el hombre que siente mucho, habla poco –Platón.\t"
    },
    "2026-02-08": {
        "content": " El secreto del éxito es mantener una imagen de un resultado exitoso en la mente. –Henry David Thoreau\t"
    },
    "2026-02-09": {
        "content": "Los ganadores se toman su tiempo para realizar su trabajo, sabiendo que escalar la montaña es lo que hace la vista tan estimulante. –Denis Waitley.\t"
    },
    "2026-02-10": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2026-02-11": {
        "content": " El día en que te halles a ti mismo sonriendo sin razón, ese día puedes decir que has encontrado la felicidad –Rebecca Stead\t"
    },
    "2026-02-12": {
        "content": " La mayor arma que uno puede portar frente a sus enemigos es una simple…sonrisa –Lionel Suggs\t"
    },
    "2026-02-13": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2026-02-14": {
        "content": "«El único modo de hacer un gran trabajo es amar lo que haces». –Steve Jobs\t"
    },
    "2026-02-15": {
        "content": "En cierto momento logré sonreír de nuevo y sentirme mejor. No solo en el corazón, sino en todo mi cuerpo. Caí en la cuenta de que me hacía bien, que tenía que seguir sonriendo. –Yoko Ono\t"
    },
    "2026-02-16": {
        "content": "Ve definitivamente en dirección de tus sueños. Vive la vida que imaginaste tener –Henry David Thoreau.\t"
    },
    "2026-02-17": {
        "content": " El futuro pertenece a los que creen en la belleza de sus sueños. –Eleanor Roosevelt\t"
    },
    "2026-02-18": {
        "content": "La vida se encoge o se expande en proporción al coraje de uno –Anais Nin.\t"
    },
    "2026-02-19": {
        "content": "La mejor parte de la belleza es aquella que ninguna imagen puede expresar –Francis Bacon.\t"
    },
    "2026-02-20": {
        "content": "Sólo hay un éxito: ser capaz de pasar tu vida a tu manera. –Christopher Morley\t"
    },
    "2026-02-21": {
        "content": "La mejor parte de la belleza es aquella que ninguna imagen puede expresar –Francis Bacon.\t"
    },
    "2026-02-22": {
        "content": " La felicidad no puede ser la única medida del éxito. –John C. Maxwell\t"
    },
    "2026-02-23": {
        "content": "«El éxito no es la clave de la felicidad. La felicidad es la clave del éxito. Si amas lo que haces, serás exitoso». –Albert Schweitzer\t"
    },
    "2026-02-24": {
        "content": "Una sonrisa cálida es el lenguaje universal de la amabilidad. –William Arthur Ward\t"
    },
    "2026-02-25": {
        "content": " No tengas miedo de dejar algo bueno para ir a por algo mejor. –John D. Rockefeller\t"
    },
    "2026-02-26": {
        "content": "Hacer sonreír a una persona significa para mi más que cualquier cosa. –Michael Jackson\t"
    },
    "2026-02-27": {
        "content": "Si no usas tu sonrisa, eres como un hombre con un millón de dolares en el banco y sin poder sacarlos. –Les Giblin\t"
    },
    "2026-02-28": {
        "content": "Nunca te rindas. Establece una meta y no te rindas hasta que la consigas. Cuando la consigas, establece otro objetivo y no te rindas hasta que lo alcances. Nunca te rindas. –Bear Bryant\t"
    },
    "2026-03-01": {
        "content": "Quiero borrar las lágrimas de todos los que confiaron en la esperanza y se las quitaron. Quiero que se queden con una sonrisa en sus rostros. –Cuarteto Magica\t"
    },
    "2026-03-02": {
        "content": "No tienes que ser grande para empezar. Pero tienes que empezar para poder ser grande”. –Zig Ziglar\t"
    },
    "2026-03-03": {
        "content": "Las sonrisas más auténticas son aquellas que se esparcen en nuestras caras cuando nadie nos está mirando. –Minhal Mehdi\t"
    },
    "2026-03-04": {
        "content": " Nunca te olvides de sonreír porque el día que no sonrías será un día perdido –Charles Chaplin\t"
    },
    "2026-03-05": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2026-03-06": {
        "content": " El éxito es un mal maestro. –Robert T. Kiyosaki\t"
    },
    "2026-03-07": {
        "content": "La auténtica motivación proviene de trabajar en cosas que nos importan”. –Sheryl Sandberg\t"
    },
    "2026-03-08": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2026-03-09": {
        "content": "Rodéate de personas que crean en tus sueños, alienten tus ideas, apoyen tus ambiciones y saquen lo mejor de ti”. –Roy T. Bennett\t"
    },
    "2026-03-10": {
        "content": "Tu mejor maestro es tu último error. –Ralph Nader\t"
    },
    "2026-03-11": {
        "content": "Es maravilloso que nadie tenga que esperar ni un segundo para comenzar a hacer del mundo un lugar mejor”. –Ana Frank\t"
    },
    "2026-03-12": {
        "content": "Los sueños son sumamente importantes. Nada se hace sin que antes se imagine –George Lucas.\t"
    },
    "2026-03-13": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2026-03-14": {
        "content": " Prende tu sonrisa, ríe sin razón. Tú controlas el interruptor de la felicidad, eres tú quien cambia el mundo –Roel van Sleeuwen\t"
    },
    "2026-03-15": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2026-03-16": {
        "content": "Muchos desean cambiar el mundo, pero pocos piensan en cambiarse a sí mismos”. –León Tolstói\t"
    },
    "2026-03-17": {
        "content": "La paz comienza con una sonrisa. –Madre Teresa\t"
    },
    "2026-03-18": {
        "content": "¿Sabias que. . . Cuando pasas caminando por una flor, sea en algún jardín o en un alguna ladera, la flor siempre te sonríe? la forma más cortés de responder, me han dicho, es devolver la sonrisa alegremente. –Ron Atchison\t"
    },
    "2026-03-19": {
        "content": "La sonrisa es una verdadera fuerza vital, la única capaz de mover lo inconmovible –Orison Swett Marden\t"
    },
    "2026-03-20": {
        "content": "Eres asombroso porque estás aquí vivo, luchas cada día para mantenerte de pie. ¿Por qué sufres si tienes la solución en tus manos? ¿Por qué lloras si puedes cambiarlo todo? La vida es hermosa porque existes tú”. –Frases sobre la vida\t"
    },
    "2026-03-21": {
        "content": "La sonrisa es el trapo que limpia las telarañas del corazón. –Mort Walker\t"
    },
    "2026-03-22": {
        "content": "Cuando tienes la habilidad de hacer lo que amas y amar lo que haces, tienes la habilidad de impactar a las personas. Eso es lo que es tener una vida exitosa. Eso es lo que es tener una vida con sentido. –Tim Tebow\t"
    },
    "2026-03-23": {
        "content": "Si estás comprometido con algo que realmente te importa, no necesitarás que nadie te empuje: tu visión te impulsará”. –Steve Jobs\t"
    },
    "2026-03-24": {
        "content": "La sonrisa es la llave que abre el corazón de todo el mundo. –Anthony J. D’Angelo\t"
    },
    "2026-03-25": {
        "content": "El éxito y la felicidad dependen de ti. –Helen Keller\t"
    },
    "2026-03-26": {
        "content": "Puede que seas la única persona que crea en ti, pero eso es suficiente. Sólo se necesita una estrella para perforar la oscuridad del universo. Nunca te rindas. –Richelle E. Goodrich\t"
    },
    "2026-03-27": {
        "content": "Cuando tengas fallas, no temas abandonarlas. –Confucio\t"
    },
    "2026-03-28": {
        "content": "Una sonrisa puede iluminar los lugares más oscuros. –Steve Maraboli\t"
    },
    "2026-03-29": {
        "content": "El pesimista ve dificultades en cada oportunidad. El optimista ve oportunidades en cada dificultad”. –Winston Churchill\t"
    },
    "2026-03-30": {
        "content": "El hombre incapaz de reír no solamente es apto para las traiciones, las estratagemas y los fraudes, sino que su vida entera ya es una traición y una estratagema. –Thomas Carlyle\t"
    },
    "2026-03-31": {
        "content": "Una sonrisa es la forma más barata de cambiar nuestro aspecto. –Charles Gordu\t"
    },
    "2026-04-01": {
        "content": "Haz de tu sonrisa un paraguas y deja que llueva. –Twin Peaks\t"
    },
    "2026-04-02": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2026-04-03": {
        "content": "Las más grandes decepciones que sufre el hombre, vienen de sus propias opiniones. –Leonardo DaVinci\t"
    },
    "2026-04-04": {
        "content": "«El éxito es cuestión de actitud, no de aptitud.» –Ralph Waldo Emerson.\t"
    },
    "2026-04-05": {
        "content": " A menudo las personas quedan atrapadas en un estado de sobre  pensamiento, y el resultado es que nunca toman una decisión. –Steve Backley\t"
    },
    "2026-04-06": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2026-04-07": {
        "content": "«El éxito es la capacidad de ir de fracaso en fracaso sin perder el entusiasmo.» –Winston Churchill.\t"
    },
    "2026-04-08": {
        "content": "No puedo mantenerme enojado cuando me sonríes. –M.F. Moonzajer\t"
    },
    "2026-04-09": {
        "content": "No malgastes tu tiempo odiando un fracaso. El fracaso es mejor maestro que el éxito. Escucha, aprende, sigue adelante. –Clarissa Pinkola Estés\t"
    },
    "2026-04-10": {
        "content": "Elimina de tu vida todo aquello que te cause estrés y te quite la sonrisa. –Paulo Coelho\t"
    },
    "2026-04-11": {
        "content": "No puedo darte una fórmula segura para el éxito, pero puedo darte una para el fracaso: intenta complacer a todo el mundo todo el tiempo. –Herbert Bayard Swope\t"
    },
    "2026-04-12": {
        "content": "«La vida nos prueba con obstáculos, pero nuestras respuestas a esas pruebas definen nuestra fuerza y determinación». ­–Frases de la vida es dura para reflexionar\t"
    },
    "2026-04-13": {
        "content": " La diferencia entre la codicia y la ambición es que la persona codiciosa desea cosas para las que no está preparada. –Habeeb Akande\t"
    },
    "2026-04-14": {
        "content": " Participa en tus propios sueños. No digas solamente lo que quieres o te quejes de lo que no tienes. –Steve Maraboli\t"
    },
    "2026-04-15": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2026-04-16": {
        "content": "Deja de mentirte. Cuando negamos nuestra verdad, negamos nuestro verdadero potencial. –Steve Maraboli\t"
    },
    "2026-04-17": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2026-04-18": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes . –Víctor Ruiz Iriarte\t"
    },
    "2026-04-19": {
        "content": "No hay caminos para la paz; la paz es el camino –Mahatma Gandhi.\t"
    },
    "2026-04-20": {
        "content": "Los colores son la sonrisa de la naturaleza. –Leigh Hunt\t"
    },
    "2026-04-21": {
        "content": "El momento en el que consideras rendirte es justo el momento en el que debes seguir adelante”. –Anónimo\t"
    },
    "2026-04-22": {
        "content": " Sin importar lo fácil o difícil que sea la vida, siempre encontraré la manera de disfrutar. Incluso cuando las circunstancias sean adversas. –Termitope Owosela\t"
    },
    "2026-04-23": {
        "content": "El éxito no es final, el fracaso no es fatal. Es el coraje para continuar lo que cuenta. –Winston S. Churchill\t"
    },
    "2026-04-24": {
        "content": "Nunca permitiré que me vuelva tan importante, sabio, reservado y poderoso, que no pueda sonreír a los demás y reírme de mí mismo. –Og Mandino\t"
    },
    "2026-04-25": {
        "content": "Sonreír en la presencia del peligro no significa que niegas el miedo, simplemente te ayudará a superarlo. –Richelle E. Goodrich\t"
    },
    "2026-04-26": {
        "content": "Si solo tienes una sonrisa, dásela a la gente que amas. –Maya Angelou\t"
    },
    "2026-04-27": {
        "content": "Si algo me gusta, es vivir. Ver mi cuerpo en la calle, hablar contigo como un camarada, mirar escaparates y, sobre todo, sonreír de lejos a los árboles. –Blas de Otero\t"
    },
    "2026-04-28": {
        "content": "Una sonrisa es la única aflicción infecciosa que animo a todos a que propaguen. –Omar Kiam\t"
    },
    "2026-04-29": {
        "content": " La sonrisa enriquece a los que la reciben, sin empobrecer a los que la dan –Frank Irving\t"
    },
    "2026-04-30": {
        "content": "El corazón alegre hermosea el rostro. –Rey Salomón\t"
    },
    "2026-05-01": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2026-05-02": {
        "content": "«El fracaso no es caer, sino negarse a levantarse». –Anónimo\t"
    },
    "2026-05-03": {
        "content": "Muy frecuentemente las lágrimas son la última sonrisa del amor. –Stendhal\t"
    },
    "2026-05-04": {
        "content": "No puedo esperar a hacerlo, quiero hacerlo ahora, quiero que ocurra si va a ocurrir –Georgia O’Keeffe.\t"
    },
    "2026-05-05": {
        "content": "Mantente alejado de la gente que intenta menospreciar tus ambiciones. La gente pequeña siempre hace eso, pero la gente realmente grande te hace sentir que tu también puedes ser grande –Mark Twain.\t"
    },
    "2026-05-06": {
        "content": "No llores porque terminó. Sonríe porque ocurrió. –Dr. Seuss.\t"
    },
    "2026-05-07": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2026-05-08": {
        "content": "No se trata de si te derriban, se trata de si te levantas –Vince Lombardi.\t"
    },
    "2026-05-09": {
        "content": "Nunca eres demasiado mayor para establecer nuevas metas o tener nuevos sueños”. –C.S. Lewis\t"
    },
    "2026-05-10": {
        "content": "El primer paso es el más importante. Es el más crucial y más efectivo, ya que iniciará la dirección que has elegido. –Steve Backley\t"
    },
    "2026-05-11": {
        "content": "Una sonrisa es una curva que pone todo recto. –Phyllis Diller\t"
    },
    "2026-05-12": {
        "content": " La risa cura, es la obra social más barata y efectiva del mundo –Roberto Pettinato\t"
    },
    "2026-05-13": {
        "content": "La forma de empezar es dejar de hablar y empezar a actuar   –Walt Disney\t"
    },
    "2026-05-14": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2026-05-15": {
        "content": "La muerte nos sonríe a todos, devolvámosle la sonrisa. –Gladiator\t"
    },
    "2026-05-16": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2026-05-17": {
        "content": "«La vida no se trata de esperar a que pase la tormenta, se trata de aprender a bailar bajo la lluvia». –Vivian Greene\t"
    },
    "2026-05-18": {
        "content": "Frecuentemente me pregunto si esas personas, las que más sonríen, serán en verdad las más tristes en el mundo. –Anthony Liccione\t"
    },
    "2026-05-19": {
        "content": "A veces, cuando innovas, cometes errores. Lo mejor es admitirlos rápidamente y seguir mejorando otras innovaciones. –Steve Jobs\t"
    },
    "2026-05-20": {
        "content": " A veces tu alegría es la fuente de tu sonrisa, pero a veces tu sonrisa puede ser la fuente de tu alegría –Thích Nhất Hạnh\t"
    },
    "2026-05-21": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2026-05-22": {
        "content": "La perseverancia y la energía conquistan todo”. –Benjamin Franklin\t"
    },
    "2026-05-23": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2026-05-24": {
        "content": "Ve tan lejos como puedas ver y verás más lejos. –Zig Ziglar\t"
    },
    "2026-05-25": {
        "content": "El hombre que nos hace reír tiene mas votos para su propósito que el hombre que nos exige pensar. –Malcom de Chazall\t"
    },
    "2026-05-26": {
        "content": " Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs\t"
    },
    "2026-05-27": {
        "content": "Y que placer, cuando no hay nada, que pueda ver, y solo invento tu sonrisa, y apago así, toda agonía. –Luis Alberto Spinetta\t"
    },
    "2026-05-28": {
        "content": "De humanos es errar y de necios permanecer en el error –Marco Tulio Cicerón\t"
    },
    "2026-05-29": {
        "content": "Quisiera tener varias sonrisas de recambio y un vasto repertorio de modos de expresarme. –Concha Méndez\t"
    },
    "2026-05-30": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2026-05-31": {
        "content": "Cuando uno nace sólo sabe llorar. Sólo gradualmente se aprende a sonreír. –Halldór Laxness\t"
    },
    "2026-06-01": {
        "content": "La sonrisa se ha puesto de pie como una hazaña. –Manuel Del Cabral\t"
    },
    "2026-06-02": {
        "content": "El éxito consiste en ir de fracaso en fracaso sin pérdida de entusiasmo. –Winston Churchill\t"
    },
    "2026-06-03": {
        "content": " No hay razón para tener un plan B, porque te distrae del plan A. –Will Smith\t"
    },
    "2026-06-04": {
        "content": " Crecerás el día en que verdaderamente te rías por primera vez de ti mismo –Ethel Barrymore\t"
    },
    "2026-06-05": {
        "content": "Estaba sonriendo ayer, estoy sonriendo hoy y sonreiré mañana. Simplemente porque la vida es muy corta para llorar por cualquier cosa. –Santosh Kalwar\t"
    },
    "2026-06-06": {
        "content": "Aprende a vivir y sabrás morir bien –Confucio.\t"
    },
    "2026-06-07": {
        "content": "Después de cada tormenta sonríe el sol; para cada problema hay una solución y el deber irrenunciable del alma es estar de buen ánimo. –William R. Alger\t"
    },
    "2026-06-08": {
        "content": "Pienso, luego existo –René Descartes.\t"
    },
    "2026-06-09": {
        "content": "El dar de mala gana es grosería. Nada cuesta añadir una sonrisa. –Jean de La Bruyère\t"
    },
    "2026-06-10": {
        "content": "«No importa cuántas veces te caigas, sino cuántas veces te levantes». –Vince Lombardi\t"
    },
    "2026-06-11": {
        "content": "Encontrarás la clave del éxito debajo de la alarma del reloj. –Benjamin Franklin\t"
    },
    "2026-06-12": {
        "content": "La vida es un 10% lo que me ocurre y 90% cómo reacciono a ello –John Maxwell.\t"
    },
    "2026-06-13": {
        "content": "Cuando la necesidad de éxito es tanta como la necesidad de respirar, entonces serás exitoso –Eric Thomas.\t"
    },
    "2026-06-14": {
        "content": "Son tus ojos los que busco, son tus labios los que quiero ver sonreír. –Violeta Parra\t"
    },
    "2026-06-15": {
        "content": "Si es posible, se debe hacer reír hasta a los muertos. –Leonardo Da Vinci\t"
    },
    "2026-06-16": {
        "content": "La definición del propósito es el punto de comienzo de todo logro –Clement Stone.\t"
    },
    "2026-06-17": {
        "content": "Si un hombre sonríe todo el tiempo, probablemente vende algo que no funciona. –George Carlin\t"
    },
    "2026-06-18": {
        "content": "La sonrisa es el idioma general de los hombres inteligentes. Sólo son tristes los tontos y los delincuentes. –Víctor Ruiz Iriarte\t"
    },
    "2026-06-19": {
        "content": "Deja que mi alma sonría a través de mi corazón y que mi corazón sonría a través de mis ojos, para que pueda esparcir ricas sonrisas en corazones tristes. –Paramahansa Yogananda\t"
    },
    "2026-06-20": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2026-06-21": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2026-06-22": {
        "content": " ¿Cómo serías si fueses la única persona del mundo? Si quieres ser realmente feliz, debes ser esa persona. –Quetin Crisp\t"
    },
    "2026-06-23": {
        "content": "Si he visto más lejos que otros, es por estar de pie sobre los hombros de gigantes –Isaac Newton.\t"
    },
    "2026-06-24": {
        "content": " El secreto para disfrutar el trabajo esta contenido en una palabra –excelencia. Saber cómo hacer algo bien es disfrutarlo. –Pearl S. Buck.\t"
    },
    "2026-06-25": {
        "content": "Creo que podría hacerme sonreír aunque estuviera colgada de una horca. –Jandy Nelson\t"
    },
    "2026-06-26": {
        "content": "Y luego me da una sonrisa que parece tan genuinamente dulce con el toque justo de timidez que el calor inesperado corre a través de mí. –Suzanne Collins\t"
    },
    "2026-06-27": {
        "content": "Las guerras seguirán mientras el color de la piel siga siendo más importante que el de los ojos –Bob Marley.\t"
    },
    "2026-06-28": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2026-06-29": {
        "content": "La mala noticia es que el tiempo vuela, la buena noticia es que tú eres el piloto. –Michael Althsuler\t"
    },
    "2026-06-30": {
        "content": " El día peor empleado es aquél en que no se ha reído –Nicolás  Sebastien Roch Chamfort\t"
    },
    "2026-07-01": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2026-07-02": {
        "content": "Esconde tu locura detrás de una sonrisa. –Paulo Coelho\t"
    },
    "2026-07-03": {
        "content": "Era una sonrisa que podría hacer que un hombre creyera que la vida era buena. –John Verdon\t"
    },
    "2026-07-04": {
        "content": "El éxito no es mágico ni misterioso. El éxito es la consecuencia natural de aplicar los fundamentos básicos. –Jim Rohn\t"
    },
    "2026-07-05": {
        "content": "El comportamiento humano fluye de tres fuentes: emoción, deseo y conocimiento –Platón.\t"
    },
    "2026-07-06": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes . –Víctor Ruiz Iriarte\t"
    },
    "2026-07-07": {
        "content": "Opino que lo que se llama belleza, reside únicamente en la sonrisa. –León Tolstoi\t"
    },
    "2026-07-08": {
        "content": "Quienes no saben llorar con todo el corazón, tampoco saben sonreír. –Golda Meir\t"
    },
    "2026-07-09": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2026-07-10": {
        "content": "Conviene reír sin esperar a ser dichoso, no sea que nos sorprenda la muerte sin haber reído. –Jean de la Bruyere\t"
    },
    "2026-07-11": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2026-07-12": {
        "content": "El éxito es un camino, no un destino. –Ben Sweetland\t"
    },
    "2026-07-13": {
        "content": "«El éxito no es definitivo, el fracaso no es fatal: es el coraje para continuar lo que cuenta.» –Winston Churchill.\t"
    },
    "2026-07-14": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2026-07-15": {
        "content": "El niño reconoce a la madre por la sonrisa. –Leon Tolstoi\t"
    },
    "2026-07-16": {
        "content": " Si sonríes cuando no hay nadie a tu alrededor, lo haces en serio –Andy Rooney\t"
    },
    "2026-07-17": {
        "content": "Si vas en busca del amor nunca lo encontrarás porque el amor nunca se perdió; sólo nosotros nos perdemos. –Shannon L. Alder\t"
    },
    "2026-07-18": {
        "content": "Cuando un niño comienza a sonreír, con una pequeña bifurcación de amargor y dulzura, las orillas de su sonrisa desembocan sin burlas en la anarquía del océano. –Osip Mandelshtam\t"
    },
    "2026-07-19": {
        "content": "Comienza por hacer lo necesario; luego haz lo que es posible; y, de repente, estarás haciendo lo imposible –Francisco de Asís.\t"
    },
    "2026-07-20": {
        "content": "La vida es algo difícil de entender. Nos hace demasiado felices y de repente nos quita la felicidad. Pero debemos sonreír en cada fase de la vida. –Sahaj Oberoi\t"
    },
    "2026-07-21": {
        "content": "Si estás esperando a sentirte lo suficientemente talentoso para poder hacer algo, nunca lo harás. –Criss Jami\t"
    },
    "2026-07-22": {
        "content": "Nadie puede hacerte sentir inferior sin tu consentimiento”. –Eleanor Roosevelt\t"
    },
    "2026-07-23": {
        "content": "Consulta no tus miedos sino tus esperanzas y tus sueños. No pienses en tus frustraciones, sino en tu potencial incumplido. Preocúpate no en lo que has intentado y fracasado, sino en lo que todavía es posible hacer y lograr. –Juan XXIII\t"
    },
    "2026-07-24": {
        "content": "«La vida nos somete a pruebas para mostrarnos que somos más fuertes de lo que imaginamos en nuestros peores momentos». –Las mejores frases de la vida es dura\t"
    },
    "2026-07-25": {
        "content": " La risa es la distancia más corta entre dos personas –Víctor Borge\t"
    },
    "2026-07-26": {
        "content": "Antes de fruncir tu ceño, comprueba que no hay sonrisas disponibles. –Jim Beggs.\t"
    },
    "2026-07-27": {
        "content": "Si dicen mal de ti con fundamento, corrígete; de lo contrario, échate a reír. –Epicteto de Frigia\t"
    },
    "2026-07-28": {
        "content": "Para ser exitoso hay que seguir el camino de los gigantes. –Lillian Cauldwell\t"
    },
    "2026-07-29": {
        "content": "No esperes. Nunca habrá un momento perfecto”. –Napoleon Hill,\t"
    },
    "2026-07-30": {
        "content": " Vamos a conseguir muchas más cosas si pensamos que nada es imposible. –Vince Lombardi\t"
    },
    "2026-07-31": {
        "content": "Supe que eras la indicada cuando tu sonrisa se convirtió en mi cielo, tu risa en mi canción favorita y tus brazos en mi hogar. –Steve Maraboli\t"
    },
    "2026-08-01": {
        "content": "Estar preparado es importante, saber esperarlo es aún más, pero aprovechar el momento adecuado es la clave de la vida –Arthur Schnitzler.\t"
    },
    "2026-08-02": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2026-08-03": {
        "content": " Siempre que te pregunten si puedes hacer un trabajo, contesta que sí y ponte enseguida a aprender cómo se hace. –Franklin D. Roosevelt.\t"
    },
    "2026-08-04": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2026-08-05": {
        "content": "Si estás leyendo esto… Felicitaciones, estás vivo. Si eso no es algo para sonreír, entonces no sé qué es. –Chad Sugg\t"
    },
    "2026-08-06": {
        "content": "Porque yo, sólo yo, veo su sonrisa una milésima antes de que le llegue a la cara. –David Mitchell\t"
    },
    "2026-08-07": {
        "content": "El hombre verdadero sonríe ante los problemas, toma fuerza de la angustia y crece valiente ante la decepción. –Thomas Paine\t"
    },
    "2026-08-08": {
        "content": " El poder de una sonrisa es tal que, incluso si dibujas una carita feliz, bastará para hacer que tus labios se muevan de la misma forma –Richelle E. Goodrich\t"
    },
    "2026-08-09": {
        "content": "«El optimismo es la fe que conduce al logro. Nada se puede hacer sin esperanza y confianza». –Helen Keller\t"
    },
    "2026-08-10": {
        "content": "La lógica te llevará desde A hasta B. La imaginación te llevará a cualquier parte –Albert Einstein.\t"
    },
    "2026-08-11": {
        "content": "Ella sonrió y su rostro se iluminó. O tal vez fue el mío. Todo lo que sé con certeza es que su sonrisa iluminó hasta mis días más oscuros. –J. Sterling\t"
    },
    "2026-08-12": {
        "content": "Hoy llevo puesta la sonrisa que me regalaste. –Edith Castro\t"
    },
    "2026-08-13": {
        "content": "Mira hacia atrás y sonríe ante los peligros del pasado. –Walter Scott\t"
    },
    "2026-08-14": {
        "content": "Sabes lo que es realmente contagioso? Una gran sonrisa. –Scrubs\t"
    },
    "2026-08-15": {
        "content": "Si un líder no transmite pasión e intensidad, entonces no habrá pasión e intensidad dentro de la organización y empezarán a caer y deprimirse. –Colin Powell\t"
    },
    "2026-08-16": {
        "content": " El éxito es hacer lo que sea que quieras hacer, cuando quieras, donde quieras, con quien quieras y por el tiempo que quieras. –Anthony Robbins\t"
    },
    "2026-08-17": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2026-08-18": {
        "content": "Si mi estupidez te hace sonreír, prefiero entonces actuar siempre como un estúpido. –M.F. Moonzajer\t"
    },
    "2026-08-19": {
        "content": "Aferrarse a la ira es como beber veneno y esperar que la otra persona muera –Buda.\t"
    },
    "2026-08-20": {
        "content": "Todavía su conocimiento no ha aprendido a sonreír. –Friedrich Nietzsche\t"
    },
    "2026-08-21": {
        "content": "El no querer es la causa, el no poder el pretexto –Seneca.\t"
    },
    "2026-08-22": {
        "content": " Es mejor olvidarse y sonreír que recordar y entristecerse –Cristina Rossetti\t"
    },
    "2026-08-23": {
        "content": "Para tener éxito hoy, tienes que fijar prioridades, decidir lo que representas. –Lee Laccoca\t"
    },
    "2026-08-24": {
        "content": "Quien nos hace reír es un cómico. Quien nos hace pensar y luego reír es un humorista. –George Burns\t"
    },
    "2026-08-25": {
        "content": "La risa es el lenguaje del alma. –Pablo Neruda\t"
    },
    "2026-08-26": {
        "content": " Cada sonrisa te hace un día más joven  –Proverbio chino\t"
    },
    "2026-08-27": {
        "content": "Teresa de la dulce sonrisa; porque mientras las demás se esforzaban una y otra vez en superarla, ella simplemente las derrotaba con una sonrisa en su rostro. –Claymore\t"
    },
    "2026-08-28": {
        "content": "¿Quieres saber quién eres? No preguntes. ¡Actúa! La acción delineará y definirá quién eres –Thomas Jefferson.\t"
    },
    "2026-08-29": {
        "content": " No importa lo bueno que seas, siempre puedes ser mejor, esa es la parte emocionante. –Tiger Woods\t"
    },
    "2026-08-30": {
        "content": "Ríete de la noche, del día, de la luna, ríete de las calles torcidas de la isla, ríete de este torpe muchacho que te quiere. –Pablo Neruda\t"
    },
    "2026-08-31": {
        "content": "El cielo no es un límite para mí, porque no tengo límites en mi vida. Porque la vida es un mundo lleno de riesgos y posibilidades. –Termitope Owosela\t"
    },
    "2026-09-01": {
        "content": "Su sonrisa podía parar el corazón de un hombre. –El nombre del viento\t"
    },
    "2026-09-02": {
        "content": " No hay ninguna cosa seria que no pueda decirse con una sonrisa –Alejandro Casona\t"
    },
    "2026-09-03": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2026-09-04": {
        "content": "No tienes que ser grande para empezar. Pero tienes que empezar para poder ser grande”. –Zig Ziglar\t"
    },
    "2026-09-05": {
        "content": "«La vida es como montar una bicicleta, para mantener el equilibrio debes seguir adelante». –Albert Einstein, frases de la vida es dura\t"
    },
    "2026-09-06": {
        "content": "Muy frecuentemente las lágrimas son la última sonrisa del amor. –Stendhal\t"
    },
    "2026-09-07": {
        "content": "No dejes de sonreír… Porque es muy poco el tiempo que te dan para la alegría –Zenaida Bacardí de Argamasilla\t"
    },
    "2026-09-08": {
        "content": "Si te pones a ti mismo en una posición en la que tienes que salir de tu zona de confort, estas forzando la expansión de tu consciencia. –Les Brown\t"
    },
    "2026-09-09": {
        "content": " Cuando deseamos convertirnos en personas de éxito, lo primero que tenemos que hacer es actuar como si ya lo fuésemos. –Gaby Vargas\t"
    },
    "2026-09-10": {
        "content": "Aunque sentí que estaba a punto de llorar, opté por sonreír. –Kristen Ashley\t"
    },
    "2026-09-11": {
        "content": "Una gran sonrisa es un bello rostro de gigante –Charles Baudelaire\t"
    },
    "2026-09-12": {
        "content": "Si es bueno vivir, todavía es mejor soñar, y lo mejor de todo, despertar –Antonio Machado.\t"
    },
    "2026-09-13": {
        "content": "«El futuro pertenece a aquellos que creen en la belleza de sus sueños». –Eleanor Roosevelt\t"
    },
    "2026-09-14": {
        "content": "Tu trabajo va a llenar una gran parte de tu vida; la única manera de estar verdaderamente satisfecho es hacer lo que crees que es un gran trabajo y la única manera de hacer un gran trabajo es amar lo que haces. Si todavía no lo has encontrado, sigue buscando. No te conformes. Como con todos los asuntos del corazón, sabrás cuando lo encuentres. –Steve Jobs\t"
    },
    "2026-09-15": {
        "content": "La curva mas hermosa de una mujer es su sonrisa. –Bob Marley\t"
    },
    "2026-09-16": {
        "content": "La capacidad de reír juntos es el amor. –Francoise Sagan\t"
    },
    "2026-09-17": {
        "content": " Si quieres probarle algo al mundo, entonces necesitas que el mundo te preste atención para poder probarlo. –Toba Beta\t"
    },
    "2026-09-18": {
        "content": "Si de verdad quieres comer, sigue escalando. Las frutas están en la cima del árbol. Estira tus brazos y sigue estirándolos. El éxito está en la cima, sigue adelante. –Isralemore Ayivor\t"
    },
    "2026-09-19": {
        "content": "Hay tres tipos de personas en este mundo. Primero, están las que hacen que ocurran las cosas. Luego están las que ven cómo ocurren las cosas. Por último, están las que preguntan, ¿qué ha ocurrido? ¿Cuál quieres ser tú? –Steve Backley\t"
    },
    "2026-09-20": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2026-09-21": {
        "content": "El secreto de la existencia humana no solo está en vivir, sino también en saber para qué se vive –Fiódor Dostoievski\t"
    },
    "2026-09-22": {
        "content": "Nunca estas completamente vestido sin una sonrisa –Martin Charnin\t"
    },
    "2026-09-23": {
        "content": "Lo que el sol es para las flores, la sonrisa es para la humanidad. –Joseph Addison\t"
    },
    "2026-09-24": {
        "content": "Eres lo que eres hoy por las acciones que has hecho o las acciones que no has hecho. –Steve Maraboli\t"
    },
    "2026-09-25": {
        "content": " El éxito es hacer, no obtener. Es intentar, no triunfar. El éxito es un estándar personal, es alcanzar lo más alto que hay en nosotros, convertirnos en todo lo que podemos ser. Si damos nuestro mejor esfuerzo, somos exitosos. –Zig Ziglar\t"
    },
    "2026-09-26": {
        "content": " No te sientas avergonzado de intentarlo y fallar, puesto que la persona que nunca ha fallado es alguien que nunca lo ha intentado. –Og Mandino\t"
    },
    "2026-09-27": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2026-09-28": {
        "content": "No importa lo que la gente diga, las palabras y las ideas tienen el poder de cambiar el mundo”. –Robin Williams\t"
    },
    "2026-09-29": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2026-09-30": {
        "content": "Nunca me cansaré de decir esto: no te compares con los demás, sé fiel a ti mismo y sigue aprendiendo todo lo que puedas aprender. –Daisaku Ikeda\t"
    },
    "2026-10-01": {
        "content": "Comienza por hacer lo necesario; luego haz lo que es posible; y, de repente, estarás haciendo lo imposible –Francisco de Asís.\t"
    },
    "2026-10-02": {
        "content": "Puedes tenerlo todo, sólo que no al mismo tiempo. –Betty Friedan\t"
    },
    "2026-10-03": {
        "content": "«El éxito no es la clave de la felicidad. La felicidad es la clave del éxito. Si amas lo que haces, tendrás éxito.» –Albert Schweitzer.\t"
    },
    "2026-10-04": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2026-10-05": {
        "content": "No importa si te derriban, lo importante es si te levantas cuando sucede”. –Vince Lombardi\t"
    },
    "2026-10-06": {
        "content": "La mejor preparación para mañana es hacer lo mejor que puedas hoy –H. Jackson Brown, Jr.\t"
    },
    "2026-10-07": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2026-10-08": {
        "content": "¿Cuándo regresará esa sonrisa que me desnuda en cuerpo y alma? –Jenniley Bonilla\t"
    },
    "2026-10-09": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2026-10-10": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2026-10-11": {
        "content": "Toma tus victorias, sin importar cuáles sean, cuídalas, úsalas, pero no te conformes con ellas. –Mia Hamm\t"
    },
    "2026-10-12": {
        "content": "Sonríe, es una terapia gratis. –Douglas Horton\t"
    },
    "2026-10-13": {
        "content": " Es más fácil obtener lo que se desea con una sonrisa que con la punta de la espada –William Shakespeare\t"
    },
    "2026-10-14": {
        "content": " La única manera de hacer un gran trabajo es amar lo que hace. Si no ha encontrado todavía algo que ame, siga buscando. No se conforme. Al igual que los asuntos del corazón, sabrá cuando lo encuentre. –Steve Jobs.\t"
    },
    "2026-10-15": {
        "content": " Su sonrisa sigue siendo como el sol que rompe a través de las nubes. –Dale Carnegie\t"
    },
    "2026-10-16": {
        "content": "Cuando ella sonreía, él se olvidaba de todo. –Palmeras en la nieve\t"
    },
    "2026-10-17": {
        "content": " Aunque sonreír es un trabajo de un simple instante, sus efectos duran por mucho tiempo –Bucky Buckbinder\t"
    },
    "2026-10-18": {
        "content": "Una sonrisa es la felicidad que encontrarás justo debajo te tu nariz. –Tom Wilson\t"
    },
    "2026-10-19": {
        "content": "La sonrisa es el lenguaje universal de los hombres inteligentes. –Víctor Ruiz Iriarte\t"
    },
    "2026-10-20": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2026-10-21": {
        "content": "La forma de arruinar la vida de alguien es darle todo lo que quiere. –Patrick Swayze\t"
    },
    "2026-10-22": {
        "content": "No importa cuán fugaz es tu sonrisa, tu sonrisa es el principio de la luz de tu sabiduría. –Sri Chinmoy\t"
    },
    "2026-10-23": {
        "content": "«El éxito no es para los que sueñan despiertos, sino para aquellos que sueñan y hacen que sus sueños se hagan realidad.» –Jack Canfield.\t"
    },
    "2026-10-24": {
        "content": "Ni siquiera trató de sonreír. Entonces supe que lo había perdido para siempre. –Marian Keyes\t"
    },
    "2026-10-25": {
        "content": "No puedo dejar de justificar el que se anime a los niños a sonreír antes que a llorar. No deseo pagar por ver otras lágrimas que las del teatro. –Robert Louis Stevenson\t"
    },
    "2026-10-26": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2026-10-27": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2026-10-28": {
        "content": "Lo que nos parecen pruebas amargas son bendiciones disfrazadas. –Oscar Wilde\t"
    },
    "2026-10-29": {
        "content": "Si haces cada tarea como la vas a hacer por el resto de tu vida, es entonces cuando vas a destacar. –Mary Barra\t"
    },
    "2026-10-30": {
        "content": "En nuestras bocas las sonrisas fueron mensajes de esperanza. –Alfonso Orantes\t"
    },
    "2026-10-31": {
        "content": "Lo inevitable puede aceptarse también sin sonreír. –Santiago Rusiñol\t"
    },
    "2026-11-01": {
        "content": " Estoy convencido de que aproximadamente la mitad de lo que separa a los emprendedores de éxito de los de no  éxito es la perseverancia. –Steve Jobs\t"
    },
    "2026-11-02": {
        "content": "Las sonrisas generan amor y paz, el amor y la paz enciende las sonrisas en las personas. –Mehmet Murat ildan\t"
    },
    "2026-11-03": {
        "content": "Tenía los labios inmóviles, pero cuando lo miré parecieron sonreír sin hacer el más mínimo movimiento. –Anne Rice\t"
    },
    "2026-11-04": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2026-11-05": {
        "content": " Alcanza el éxito el hombre que ha vivido bien, quien ha reído con frecuencia y ha amado mucho, quien ha disfrutado de la confianza de una mujer pura, del respeto de la inteligencia de los otros y del amor de sus hijos. –Bessie Anderson Stanley\t"
    },
    "2026-11-06": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2026-11-07": {
        "content": "No quiero dejar de sonreír, bajo ninguna circunstancia, ni perder la libertad para pensar, y quiero enfrentarme a cualquier dificultad con valentía. –Banana Yashimoto\t"
    },
    "2026-11-08": {
        "content": "La voluntad de ganar, el deseo de triunfar, el ímpetu de alcanzar tu pleno potencial…estas son las llaves que abrirán la puerta a la excelencia personal. –Confucio\t"
    },
    "2026-11-09": {
        "content": "Cuando sonrió el hombre, el mundo lo amó. Cuando rió, le tuvo miedo. –Rabindranath Tagore\t"
    },
    "2026-11-10": {
        "content": "El único hombre que nunca comete un error es el hombre que nunca hace nada. –Theodore Roosevelt\t"
    },
    "2026-11-11": {
        "content": "La raza humana tiene un arma verdaderamente eficaz: la risa. –Mark Twain\t"
    },
    "2026-11-12": {
        "content": "Sólo tu sonrisa permanece como muchas estrellas sobre ti, y pronto también sobre mí. –Rainer Maria Rilke\t"
    },
    "2026-11-13": {
        "content": "«La vida es 10% lo que nos sucede y 90 % cómo reaccionamos ante ello». –Charles R. Swindoll\t"
    },
    "2026-11-14": {
        "content": "Mi padre siempre me decía: encuentra un trabajo que te guste y no tendrás que trabajar un solo día de tu vida. –Jim Fox.\t"
    },
    "2026-11-15": {
        "content": " Ríe y el mundo reirá contigo; llora y llorarás sólo –Eli Wilcox\t"
    },
    "2026-11-16": {
        "content": "Hazles comprender que no tienen en el mundo otro deber que la alegría. –Paul Claudel\t"
    },
    "2026-11-17": {
        "content": " El cambio está en el aire. Nos recuerda que fuimos esculpidos por el mismo poder que orquesta el cambio de las estaciones. Que esta sea la estación en la que aceptes el cambio y te alinees con él. –Steve Maraboli\t"
    },
    "2026-11-18": {
        "content": "Ningún hombre es lo bastante bueno para gobernar a otros sin su consentimiento –Abraham Lincoln.\t"
    },
    "2026-11-19": {
        "content": " Empieza cada día con una sonrisa y mantenla todo el día –W. C. Fields\t"
    },
    "2026-11-20": {
        "content": "Llegará el día en que miremos atrás, todas esas sonrisas que hemos compartido, y entonces sonreiremos una vez más. Son momentos como ese los que hacen que la vida valga la pena. –Nadège Richards\t"
    },
    "2026-11-21": {
        "content": "Hay un solo rincón del universo que puedes estar seguro de poder mejorar, y eres tú mismo –Aldous Huxley.\t"
    },
    "2026-11-22": {
        "content": "Los seres humanos no nacen para siempre el día en que sus madres los alumbran, sino que la vida los obliga a parirse a sí mismos una y otra vez –Gabriel García Márquez.\t"
    },
    "2026-11-23": {
        "content": " En cualquier momento, la decisión de ser feliz está presente. Sólo tenemos que escoger ser feliz. –Steve Maraboli\t"
    },
    "2026-11-24": {
        "content": "Dios creó el desierto para que el hombre pudiera sonreír al ver las palmeras. –Paulo Coelho\t"
    },
    "2026-11-25": {
        "content": "Ella era una persona cuyo rostro cambiaba totalmente cuando sonreía, como el sol cuando se pone en el horizonte. –Caroline Green\t"
    },
    "2026-11-26": {
        "content": "Las cosas más valiosas son baratas, como el pan o el agua, o son gratis; como el aire, la sonrisa y el amor. –Pacoyo\t"
    },
    "2026-11-27": {
        "content": " Alguien que elige sonreír antes que enfadarse, es una persona realmente fuerte –David Schary\t"
    },
    "2026-11-28": {
        "content": "Sonríe, a pesar de todo. –Steinberg\t"
    },
    "2026-11-29": {
        "content": " Confía en la fuerza de tu cuerpo y corazón. Elige por estrella la autosuficiencia, la fe, la honestidad y la industria. No tomes demasiados consejos, mantén el timón y dirige tu propio barco, y recuerda que el gran arte de mandar es tomar una participación equitativa del trabajo. Pon fuego sobre la marca que quieres golpear. La energía y la determinación con el motivo correctos son las palancas que mueven al mundo. –Noah Porter.\t"
    },
    "2026-11-30": {
        "content": "Eres mi sol nocturno, mi luna de día, mi mejor sonrisa. –Federico Moccia\t"
    },
    "2026-12-01": {
        "content": "Huye de los rostros graves y solemnes que jamás se distienden en una sonrisa. Huye de los espíritus susceptibles, que por todo se ofenden. –Ricardo León\t"
    },
    "2026-12-02": {
        "content": "Si en la lid el destino te derriba; si todo en tu camino es cuesta arriba, si tu sonrisa es ansia insatisfecha, si hay faena excesiva y vil cosecha, si a tu caudal se anteponen diques. . . Date una tregua ¡pero no claudiques! –Rudyard Kipling\t"
    },
    "2026-12-03": {
        "content": " Son necesarios cuarenta músculos para arrugar una frente, pero sólo quince para sonreír –Swami Sivananda\t"
    },
    "2026-12-04": {
        "content": "«El éxito es la suma de pequeños esfuerzos repetidos día tras día.» –Robert Collier.\t"
    },
    "2026-12-05": {
        "content": "Espero tu sonrisa y espero tu fragancia por encima de todo, del tiempo y la distancia. –José Angel Buesa\t"
    },
    "2026-12-06": {
        "content": "No importa lo lento que vayas mientras que no pares –Confucio.\t"
    },
    "2026-12-07": {
        "content": "Todos deberíamos saber todo el bien que una simple sonrisa puede hacer. –Madre Teresa de Calcuta\t"
    },
    "2026-12-08": {
        "content": "Despierta ríes y al reír tus labios inquietos me parecen relámpagos de grana que serpean sobre un cielo de nieve. –Gustavo Adolfo Bécquer\t"
    },
    "2026-12-09": {
        "content": "Podemos experimentar muchas derrotas, pero no debemos permitir que nos derroten”. –Maya Angelou\t"
    },
    "2026-12-10": {
        "content": "No cuentes los días, haz que los días cuenten –Muhammad Ali.\t"
    },
    "2026-12-11": {
        "content": "Hay sonrisas que no son de felicidad, sino de un modo de llorar con bondad. –Gabriela Mistral\t"
    },
    "2026-12-12": {
        "content": "Volvió a sonreír. Era una buena sonrisa, con montones de dientes. –Harlan Coben\t"
    },
    "2026-12-13": {
        "content": "Cambia tus pensamientos y cambiarás tu mundo –Norman Vincent Peale.\t"
    },
    "2026-12-14": {
        "content": " Tómate las siguientes 24 horas y relájate sabiendo que todo va bien. Deja ir el estrés y las preocupaciones por un día y observa qué ocurre. –Mike Basevic\t"
    },
    "2026-12-15": {
        "content": " A veces, no obtener lo que quieres es un golpe de suerte brillante. –Lorii Myers\t"
    },
    "2026-12-16": {
        "content": "El mundo es bello, pero tiene un defecto llamado hombre –Friedrich Nietzsche.\t"
    },
    "2026-12-17": {
        "content": "La mayoría de las grandes hazañas logradas por el hombre fueron consideradas imposibles antes de que alguien las llevara a cabo”. –Louis D. Brandeis.\t"
    },
    "2026-12-18": {
        "content": "El éxito es ir de fracaso en fracaso sin perder el entusiasmo –Winston Churchill.\t"
    },
    "2026-12-19": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2026-12-20": {
        "content": "Si quieres tener éxito es simple. Conoce lo que estás haciendo, ama lo que estás haciendo y cree en lo que estás haciendo. –Will Rogers\t"
    },
    "2026-12-21": {
        "content": "No llores porque ya se terminó, sonríe porque sucedió. –Gabriel García Marquez\t"
    },
    "2026-12-22": {
        "content": "«Los momentos más oscuros son la antesala de los amaneceres más brillantes; nunca pierdas la esperanza». –Citas y frases de la vida es dura\t"
    },
    "2026-12-23": {
        "content": "La educación es el arma más poderosa para cambiar el mundo –Nelson Mandela.\t"
    },
    "2026-12-24": {
        "content": " Lo que mueve al mundo no son los potentes brazos de los héroes, sino la suma de los pequeños empujones de cada trabajador honrado. –Hellen Keller.\t"
    },
    "2026-12-25": {
        "content": "Una sonrisa es la bienvenida universal. –Max Eastman\t"
    },
    "2026-12-26": {
        "content": "Sonreír es definitivamente una de los mejores y más bellos remedios. Si tienes un buen sentido de humor y un buen enfoque hacia la vida, eso es hermoso –Rashida Jones\t"
    },
    "2026-12-27": {
        "content": " No le temas al fracaso. Es el camino al éxito. –LeBron James\t"
    },
    "2026-12-28": {
        "content": "Tomar responsabilidad personal es algo hermoso porque nos da un control completo sobre nuestro destino. –Heather Schuck\t"
    },
    "2026-12-29": {
        "content": "Haz que se pregunten por qué sigues sonriendo. –Elizabethtown\t"
    },
    "2026-12-30": {
        "content": "«El único lugar donde los sueños son imposibles es en nuestra mente». –Emilio Lledó\t"
    },
    "2026-12-31": {
        "content": " Comparte tus aspiraciones con aquellos que te vayan a apoyar, no con aquellos que respondan con duda o falta de interés. –Steve Backley\t"
    }
}

export const dateYinList = {
    "2023-01-01": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2023-01-02": {
        "content": "Pikirkanlah sebelum berbicara, karena perkataan memiliki kekuatan yang besar. –Ali bin Abi Thalib"
    },
    "2023-01-03": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2023-01-04": {
        "content": "Ubah lukamu menjadi kebijaksanaan. –Oprah Winfrey"
    },
    "2023-01-05": {
        "content": "Kebahagiaan dari hidupmu tergantung dari kualitas pikiranmu –Marcus Aurelius."
    },
    "2023-01-06": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2023-01-07": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2023-01-08": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2023-01-09": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2023-01-10": {
        "content": "Kegigihan adalah kunci kesuksesan dalam pencapaian tujuan. –Abdul Qadir al-Jilani"
    },
    "2023-01-11": {
        "content": "Penemuan terbesar sepanjang masa adalah bahwa seseorang bisa mengubah masa depannya hanya dengan mengubah sikapnya saat ini. -Oprah Winfrey"
    },
    "2023-01-12": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2023-01-13": {
        "content": "Semua mimpi kita bisa jadi kenyataan, jika kita memiliki keberanian untuk mengejarnya –Walt Disney"
    },
    "2023-01-14": {
        "content": "Kebenaran adalah cahaya yang menghilangkan kegelapan. –al-Ghazali"
    },
    "2023-01-15": {
        "content": "Perjalanan seribu mil dimulai dengan satu langkah. –Lao Tzu"
    },
    "2023-01-16": {
        "content": "Jalan menuju sukses dan jalan menuju kegagalan hampir persis sama –Colin R. Davis"
    },
    "2023-01-17": {
        "content": "Hanya mereka yang berani mengambil risiko melangkah terlalu jauh, yang mungkin bisa mengetahui seberapa jauh seseorang bisa melangkah. –TS Eliot"
    },
    "2023-01-18": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. –Maya Angelou"
    },
    "2023-01-19": {
        "content": "Suatu pekerjaan yang paling tak kunjung bisa diselesaikan adalah pekerjaan yang tak kunjung pernah dimulai. –JRR Tolkien"
    },
    "2023-01-20": {
        "content": "Diam adalah sumber dari kekuatan yang luar biasa. -Lao Tzu"
    },
    "2023-01-21": {
        "content": "Tidak apa-apa merayakan kesuksesan, tapi lebih penting untuk memperhatikan pelajaran tentang kegagalan.  –Bill Gates"
    },
    "2023-01-22": {
        "content": "Ketika Anda jatuh cinta, kebahagiaan akan membuat Anda sulit tertidur karena kenyataan lebih baik dibandingkan mimpi Anda –Dr Seuss"
    },
    "2023-01-23": {
        "content": "Jangan habiskan waktumu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. -Coco Canel"
    },
    "2023-01-24": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2023-01-25": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2023-01-26": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2023-01-27": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2023-01-28": {
        "content": "Ingatlah selalu bahwa kamu benar-benar unik. Sama seperti orang lain. –Margaret Mead"
    },
    "2023-01-29": {
        "content": "Kamu hanya gagal saat kamu berhenti mencoba –Albert Einstein"
    },
    "2023-01-30": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2023-01-31": {
        "content": "Seseorang tak akan pernah tahu betapa dalam kadar cintanya sampai terjadi sebuah perpisahan. -Kahlil Gibran"
    },
    "2023-02-01": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2023-02-02": {
        "content": "Kita harus belajar untuk hidup bersama sebagai saudara atau kita akan binasa bersama-sama sebagai orang bodoh. –Martin Luther King"
    },
    "2023-02-03": {
        "content": "Hidup adalah perjalanan spiritual menuju kebenaran mutlak. –Rumi"
    },
    "2023-02-04": {
        "content": "Semuanya kelihatan tidak mungkin sampai segala sesuatu selesai. -Nelson Mandela"
    },
    "2023-02-05": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2023-02-06": {
        "content": "Kamu tidak bisa kembali dan mengubah awal saat kamu memulainya, tapi kamu bisa memulainya lagi dari di mana kamu berada sekarang dan ubah akhirnya. -C.S Lewis"
    },
    "2023-02-07": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2023-02-08": {
        "content": "Kita memahami dunia tidak sebagaimana ia adalah, tetapi sebagaimana kita. –Immanuel Kant"
    },
    "2023-02-09": {
        "content": "Jauhi orang-orang yang mencoba meremehkan ambisimu. Pikiran kecil akan selalu melakukan itu, tetapi pikiran besar akan memberi perasaan bahwa kamu juga bisa menjadi hebat –Mark Twain"
    },
    "2023-02-10": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2023-02-11": {
        "content": "Pada saat-saat tergelaplah kita harus fokus untuk melihat cahaya. -Aristoteles"
    },
    "2023-02-12": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2023-02-13": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2023-02-14": {
        "content": "Ketahuilah bahwa hidup ini adalah ujian yang sebenarnya. –Ibn Qayyim al-Jawziyya"
    },
    "2023-02-15": {
        "content": "Ketika dirimu tidak memperoleh solusi untuk mengatasi permasalahan, itu mungkin bukanlah masalah yang harus diatasi, melainkan kebenaran yang harus diterima –Mao Zedong."
    },
    "2023-02-16": {
        "content": "Kekuatan dan perkembangan datang hanya dari usaha dan perjuangan yang terus menerus. –Napoleon Hill"
    },
    "2023-02-17": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara. -Shah Rukh Khan"
    },
    "2023-02-18": {
        "content": "Belajarlah seolah-olah kamu akan hidup selamanya, hiduplah seolah-olah kamu akan mati besok. –Mahatma Gandhi"
    },
    "2023-02-19": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2023-02-20": {
        "content": "Jika kamu benar-benar menginginkan sesuatu, jangan menunggu untuk itu –ajari dirimu untuk tidak sabar –Gurbaksh Chahal"
    },
    "2023-02-21": {
        "content": "Beri nilai dari usahanya jangan dari hasilnya. Baru kita bisa menilai kehidupan. -Albert Einstein"
    },
    "2023-02-22": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2023-02-23": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2023-02-24": {
        "content": "Cinta tak berupa tatapan satu sama lain, tetapi memandang keluar bersama ke arah yang sama. –B.J. Habibie"
    },
    "2023-02-25": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2023-02-26": {
        "content": "Kita tidak hidup dari apa yang kita miliki, tetapi dari apa yang kita berikan. –Pablo Picasso"
    },
    "2023-02-27": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2023-02-28": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2023-03-01": {
        "content": "Cinta tidak terlihat dengan mata, tetapi dengan hati.–William Shakespeare"
    },
    "2023-03-02": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2023-03-03": {
        "content": "Hidup itu sendiri adalah dongeng yang paling indah. -Hans Christian Andersen"
    },
    "2023-03-04": {
        "content": "Tidak ada akhir untuk pendidikan. Bukan berarti Anda membaca buku, lulus ujian, dan menyelesaikan pendidikan. Seluruh kehidupan, dari saat Anda lahir hingga saat Anda mati, adalah proses pembelajaran. –Jiddu Krishnamurti"
    },
    "2023-03-05": {
        "content": "Suatu ide yang berguna lebih berharga daripada kekayaan. –Socrates"
    },
    "2023-03-06": {
        "content": "Aku tidak takut badai karena telah belajar berlayar dengan kapalku –Louisa May Alcott."
    },
    "2023-03-07": {
        "content": "Anda ingin mengetahui siapa diri Anda? Jangan bertanya. Beraksilah! -Thomas Jefferson "
    },
    "2023-03-08": {
        "content": "Kesempatan emas yang kau cari ada di dalam dirimu sendiri –Orison Sweet Marden."
    },
    "2023-03-09": {
        "content": "Kau tidak pernah dilahirkan untuk hidup kalah, tertekan, bersalah, malu, terkutuk, dan tidak layak. Kau dilahirkan untuk menjadi seorang pemenang –Mikhail Sergeyevich Gorbachev."
    },
    "2023-03-10": {
        "content": "Untuk sukses, sikap sama pentingnya dengan kemampuan. -Walter Scott"
    },
    "2023-03-11": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2023-03-12": {
        "content": "Dia yang mengetahui semua jawaban belum pernah memperoleh pertanyaan –Confucius."
    },
    "2023-03-13": {
        "content": "Jangan habiskan waktu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. –Coco Canel"
    },
    "2023-03-14": {
        "content": "Jangan pernah bermimpi untuk sukses, tapi kerjakan sesuatu untuk meraih kesuksesan –Ester Lauder"
    },
    "2023-03-15": {
        "content": "Sulit untuk mengalahkan orang yang tidak pernah menyerah –Babe Ruth"
    },
    "2023-03-16": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2023-03-17": {
        "content": "Tindakan menyalahkan hanya akan membuang waktu. Sebesar apapun kesalahan yang kamu timpakan ke orang lain, dan sebesar apapun kamu menyalahkannya, hal tersebut tidak akan mengubahmu –Wayne Dyer"
    },
    "2023-03-18": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2023-03-19": {
        "content": "Yang membuatku terus berkembang adalah tujuan-tujuan hidupku. -Muhammad Ali"
    },
    "2023-03-20": {
        "content": "Cara paling mendasar dan kuat untuk terhubung dengan orang lain adalah dengan mendengarkan. Cukup Dengarkan. Mungkin hal terpenting yang bisa kita berikan kepada orang lain adalah perhatian kita –Rachel Naomi Remen"
    },
    "2023-03-21": {
        "content": "Jangan menilai setiap hari dengan panen yang kamu tuai, tetapi dengan benih yang kamu tanam. –Robert Louis Stevenson"
    },
    "2023-03-22": {
        "content": "Satu-satunya sumber dari pengertahuan adalah pengalaman. -Albert Einstein"
    },
    "2023-03-23": {
        "content": "Keyakinan merupakan suatu pengetahuan di dalam hati, jauh tak terjangkau oleh bukti.–Kahlil Gibran, Pujangga"
    },
    "2023-03-24": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2023-03-25": {
        "content": "Bila Anda gagal hari ini, jangan pernah menyerah Ulangi terus kegagalan Anda sampai atasan/komandan Anda menyerah –Mario Teguh"
    },
    "2023-03-26": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2023-03-27": {
        "content": "Kebebasan adalah hak setiap individu. –John Locke"
    },
    "2023-03-28": {
        "content": "Kepanikan adalah separuh penyakit. Ketenangan adalah separuh obat, kesabaran adalah permulaan kesembuhan.–Ibnu Sina"
    },
    "2023-03-29": {
        "content": "Hidup merupakan suatu perjalanan yang dapat dijadikan pengalaman, bukan sekadar masalah yang harus diselesaikan –C.S. Lewis."
    },
    "2023-03-30": {
        "content": "Hidup adalah rangkaian pelajaran yang harus dijalani untuk dipahami. –Ralph Waldo Emerson"
    },
    "2023-03-31": {
        "content": "Gravitasi tidak bertanggung-jawab atas orang yang jatuh cinta –Albert Einstein"
    },
    "2023-04-01": {
        "content": "Dalam hidup ini kita tidak bisa melakukan hal-hal besar. Kita hanya bisa melakukan hal-hal kecil dengan cinta yang besar. -Bunda Teresa"
    },
    "2023-04-02": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semuanya harus dirasakan dengan hati. –Helen Keller"
    },
    "2023-04-03": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2023-04-04": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2023-04-05": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2023-04-06": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2023-04-07": {
        "content": "Anda hanya hidup sekali, tetapi jika Anda melakukannya dengan benar, sekali saja sudah cukup. -Mae West"
    },
    "2023-04-08": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2023-04-09": {
        "content": "Tetap menghadapkan wajah selalu ke arah sinar matahari, dan bayangan akan jatuh di belakangmu –Walt Whitman"
    },
    "2023-04-10": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2023-04-11": {
        "content": "Kedamaian hilang karena kita lupa jika sebenarnya memiliki satu sama lain –Bunda Maria Teresa Bojaxhiu."
    },
    "2023-04-12": {
        "content": "Aku telah belajar jika ada lebih banyak kekuatan di dalam sebuah pelukan yang kuat dibandingkan dengan seribu kata-kata –Ann Hood."
    },
    "2023-04-13": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2023-04-14": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2023-04-15": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2023-04-16": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2023-04-17": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2023-04-18": {
        "content": "Jangan khawatir jika Anda tidak diakui, tetapi berusahalah untuk menjadi layak diakui. -Abraham Lincoln"
    },
    "2023-04-19": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. -Maya Angelou"
    },
    "2023-04-20": {
        "content": "Aku hanya ingin orang lain mengambil langkah mundur, mengambil napas yang dalam, dan benar-benar mengamati sesuatu dengan cara yang berbeda. Namun, mayoritas orang tidak akan pernah melakukannya –Brian Mc.Knight."
    },
    "2023-04-21": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2023-04-22": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. –Zig Ziglar"
    },
    "2023-04-23": {
        "content": "Hubungan asmara itu seperti kaca. Terkadang lebih baik meninggalkannya dalam keadaan pecah. Daripada menyakiti dirimu dengan cara menyatukan mereka kembali. -D.Love"
    },
    "2023-04-24": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2023-04-25": {
        "content": "Jangan takut akan kesulitan, karena itu adalah kesempatan untuk tumbuh. –Albert Einstein"
    },
    "2023-04-26": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2023-04-27": {
        "content": "Kesuksesan bukanlah hal yang final; kegagalan bukanlah hal yang fatal: Yang terpenting adalah keberanian untuk terus maju. -Winston S. Churchill"
    },
    "2023-04-28": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2023-04-29": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2023-04-30": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2023-05-01": {
        "content": "Arahkan mata Anda pada bintang-bintang dengan kaki tetap berpijak pada tanah. -Theodore Roosevelt"
    },
    "2023-05-02": {
        "content": "Cinta itu seperti halnya angin. Kita tidak dapat melihatnya, tetapi dapat merasakannya –Nicholas Sparks."
    },
    "2023-05-03": {
        "content": "Kebahagiaan kita tergantung kepada diri kita sendiri –Aristoteles."
    },
    "2023-05-04": {
        "content": "Gagal itu makanan sehari-hari. Itu biasa, yang penting bagimana kamu menyikapinya. Evaluasi. Bangkit. Gagal lagi? Bangkit lagi!” –Chairul Tanjung"
    },
    "2023-05-05": {
        "content": "Jangan menilai setiap hari dengan panen yang kamu tuai, tetapi dengan benih yang kamu tanam. –Robert Louis Stevenson"
    },
    "2023-05-06": {
        "content": "Tujuan hidup adalah untuk hidup dengan bijaksana dan merenung. –Plato"
    },
    "2023-05-07": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2023-05-08": {
        "content": "Rahasia kesuksesan adalah melakukan hal yang biasa dengan sangat baik. -John D. Rockefeller Jr."
    },
    "2023-05-09": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2023-05-10": {
        "content": "Begitu kita menerima batasan kita, kita melampauinya. –Albert Einstein"
    },
    "2023-05-11": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2023-05-12": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2023-05-13": {
        "content": "Belajar tidak pernah melelahkan pikiran –Leonardo Da Vinci"
    },
    "2023-05-14": {
        "content": "Tiga hal dalam hidup –kesehatanmu, misimu dan orang yang kamu cintai. –Naval Ravikant"
    },
    "2023-05-15": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2023-05-16": {
        "content": "Apa yang kita pikirkan menentukan apa yang akan terjadi pada kita. Jadi jika kita ingin mengubah hidup, kita perlu sedikit mengubah pikiran kita. –Wayne Dyer."
    },
    "2023-05-17": {
        "content": "Rahasia dari kesuksesan kita adalah bahwa kita tidak pernah menyerah. –Ilma Mankiller"
    },
    "2023-05-18": {
        "content": "Jangan merusak sesuatu yang kau miliki dengan mengharapkan sesuatu yang tidak akan pernah kau miliki; ingatlah jika sesuatu yang kau miliki saat ini pernah menjadi salah satu hal yang kau harapkan –Epicurus."
    },
    "2023-05-19": {
        "content": "Dia, yang tidak cukup berani untuk mengambil risiko, tidak akan mencapai apa pun dalam hidup. –Muhammad Ali"
    },
    "2023-05-20": {
        "content": " Orang yang memiliki sasaran sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2023-05-21": {
        "content": "Jangan menunggu orang lain membahagiakanmu. Kebahagiaan apa pun yang Anda peroleh, harus Anda ciptakan sendiri. -Alice Walker"
    },
    "2023-05-22": {
        "content": "Cinta selalu saja misterius Jangan diburu-buru, atau kau akan merusak jalan ceritanya sendiri –Tere Liye"
    },
    "2023-05-23": {
        "content": "Hadapkan wajahmu selalu ke arah matahari, sehingga bayangan akan jatuh di belakangmu. -Walt Whitman"
    },
    "2023-05-24": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2023-05-25": {
        "content": "Hidup itu sebentar. Kamu harus bisa tersenyum saat merasakan kepedihan atau kita tak akan pernah melanjutkan hidup.–Jeff Ross"
    },
    "2023-05-26": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2023-05-27": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2023-05-28": {
        "content": "Hidup adalah yang terjadi saat kamu sibuk membuat rencana lain. –John Lennon"
    },
    "2023-05-29": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2023-05-30": {
        "content": "Satu-satunya tempat di mana kesuksesan datang sebelum bekerja adalah di kamus. -Vidal Sassoon"
    },
    "2023-05-31": {
        "content": "Kebahagiaan berada di dalam. Hal itu tidak ada hubungannya dengan seberapa banyak tepuk tangan yang kau peroleh atau seberapa banyak orang yang menyanjungmu. Kebahagiaan datang saat kau percaya telah melaksanakan sesuatu yang benar-benar berharga –Martin Yan."
    },
    "2023-06-01": {
        "content": "Cinta adalah kebenaran terbesar dan kebaikan tertinggi. –Plato"
    },
    "2023-06-02": {
        "content": "Dunia itu seluas langkah kaki. Jelajahilah dan jangan pernah takut melangkah. Hanya dengan itu kita bisa mengerti kehidupan dan menyatu dengannya.–Soe Hok Gie"
    },
    "2023-06-03": {
        "content": "Saya tidak bisa mengubah arah angin, namun saya bisa menyesuaikan pelayaran saya untuk selalu menggapai tujuan saya –Jimmy Dean"
    },
    "2023-06-04": {
        "content": "Kebanggaan kita yang terbesar adalah bukan tidak pernah gagal, tetapi bangkit kembali setiap kali kita jatuh. –Confusius"
    },
    "2023-06-05": {
        "content": "Cinta itu layaknya angin, aku tidak bisa melihatnya tetapi aku bisa merasakannya. –Nicholas Sparck"
    },
    "2023-06-06": {
        "content": "Semakin tinggi ilmu seseorang, maka semakin tinggi toleransinya. –Gus Dur"
    },
    "2023-06-07": {
        "content": "Hiduplah seolah-olah Anda akan mati besok. Belajarlah seolah Anda hidup selamanya. –Mahatma Gandhi"
    },
    "2023-06-08": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2023-06-09": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2023-06-10": {
        "content": "Tidak ada hal apapun di dunia ini yang lebih berharga dari persahabatan sejati –Thomas Aquinas"
    },
    "2023-06-11": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2023-06-12": {
        "content": "Ketika kamu mengubah pikiran, ingatlah untuk juga mengubah duniamu juga —Norman Vincent Peale"
    },
    "2023-06-13": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2023-06-14": {
        "content": "Kamu bisa menjadi segalanya. Kamu bisa menjadi orang yang tidak terbatas jumlahnya. ” –Kesha"
    },
    "2023-06-15": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2023-06-16": {
        "content": "Ingatlah bahwa kita hanya bisa hidup saat ini, dalam waktu yang sekarang. –Jean-Paul Sartre"
    },
    "2023-06-17": {
        "content": "Seseorang yang benar-benar hebat merupakan orang yang membuat tiap orang merasa hebat –G.K. Chesterton."
    },
    "2023-06-18": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2023-06-19": {
        "content": "Jangan khawatir tentang kegagalan, khawatirkan tentang peluang yang kamu lewatkan ketika kamu bahkan tidak mencoba. –Jack Canfield"
    },
    "2023-06-20": {
        "content": "Kebijaksanaan bukanlah produk dari sekolah tetapi dari usaha seumur hidup untuk mendapatkannya. –Albert Einstein"
    },
    "2023-06-21": {
        "content": "Kesuksesan biasanya datang pada mereka yang terlalu sibuk untuk mencarinya. -Henry David Thoreau"
    },
    "2023-06-22": {
        "content": "Tujuan hidup kita adalah untuk menjadi bahagia. -Dalai Lama"
    },
    "2023-06-23": {
        "content": "Bagaimana kau mengeja 'cinta'? tanya Piglet.Kau tak usah mengejanya….rasakan saja. Jawab Pooh. -A.A Milne"
    },
    "2023-06-24": {
        "content": " Hidup memiliki semua tikungan dan belokan itu. Kamu harus berpegangan erat-erat dan pergilah. –Nicole Kidman"
    },
    "2023-06-25": {
        "content": "Keindahan persahabatan adalah bahwa kamu tahu kepada siapa kamu dapat mempercayakan rahasia –Alessandro Manzoni"
    },
    "2023-06-26": {
        "content": "Kesempurnaan adalah hasil dari usaha dan keteguhan dalam mengejar kebaikan. –Ibn Taymiyyah"
    },
    "2023-06-27": {
        "content": "Cinta adalah ketika kebahagiaan orang lain lebih penting dari kebahagiaanmu. -H. Jackson Brown"
    },
    "2023-06-28": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan –Shakuntala Devi"
    },
    "2023-06-29": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2023-06-30": {
        "content": "​Sukses adalah jumlah dari usaha-usaha kecil, berulang-ulang hari demi hari –Robert Collier"
    },
    "2023-07-01": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2023-07-02": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2023-07-03": {
        "content": "Kesabaran adalah kekuatan; kebitteran adalah kelemahan. –Immanuel Kant"
    },
    "2023-07-04": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2023-07-05": {
        "content": "Sesuatu akan terlihat berkesan jika hal tersebut dapat bermakna dan penuh warna –Joshua Foer."
    },
    "2023-07-06": {
        "content": "Cinta itu bukan hanya perasaan senang ketika bersamanya Cinta juga adalah komitmen untuk tetap bersamanya, ketika perasaan senang itu hilang –Merry Riana"
    },
    "2023-07-07": {
        "content": "Sukses bukanlah akhir, kegagalan bukanlah fatal, yang terpenting adalah keberanian untuk melanjutkan –Winston S. Churchill"
    },
    "2023-07-08": {
        "content": "Jangan biarkan rasa takut kalah lebih besar daripada kegembiraan saat menang –Robert Kiyosaki"
    },
    "2023-07-09": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2023-07-10": {
        "content": "Kamu tidak selalu membutuhkan rencana. Terkadang kamu hanya perlu bernapas, percaya, melepaskan dan melihat apa yang terjadi –Mandy Hale"
    },
    "2023-07-11": {
        "content": "Berjuang untuk sukses tanpa kerja keras seperti mencoba memanen ketika kamu belum menanam –David Bly"
    },
    "2023-07-12": {
        "content": "Anda memiliki otak di kepala Anda. Anda memiliki kaki di sepatu Anda. Anda dapat mengarahkan diri Anda ke arah mana pun yang Anda pilih. -Dr. Seuss"
    },
    "2023-07-13": {
        "content": "Aku menginginkanmu seutuhnya, selamanya, kamu dan aku, setiap hari. –The Notebook, Nicholas Sparks"
    },
    "2023-07-14": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2023-07-15": {
        "content": "Harta yang paling berharga adalah hati yang bertakwa. –Umar bin Khattab"
    },
    "2023-07-16": {
        "content": "Bekerja keraslah dengan diam. Kesuksesan adalah suaramu –Frank Ocean."
    },
    "2023-07-17": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2023-07-18": {
        "content": " Hidup memiliki semua tikungan dan belokan itu. Kamu harus berpegangan erat-erat dan pergilah. –Nicole Kidman"
    },
    "2023-07-19": {
        "content": "Orang yang hebat tidak dilahirkan begitu saja, tetapi mereka tumbuh menjadi lebih hebat –Mario Puzo."
    },
    "2023-07-20": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2023-07-21": {
        "content": "Orang yang memiliki sasaran akan menjadi sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2023-07-22": {
        "content": "Aku memilih untuk membuat sisa hidupku menjadi yang terbaik dalam hidupku. -Louise Hay"
    },
    "2023-07-23": {
        "content": "Tidak ada yang tidak mungkin. Kata itu sendiri mengatakan 'Saya mungkin!'” —Audrey Hepburn"
    },
    "2023-07-24": {
        "content": "Banyak dari kegagalan hidup adalah karena mereka tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. –Thomas A. Edison"
    },
    "2023-07-25": {
        "content": "Cinta bukan mengajar kita lemah, tetapi membangkitkan kekuatan Cinta bukan mengajar kita menghinakan diri, tetapi mengembuskan kegagahan Cinta bukan melemahkan semangat, tetapi membangkitkan semangat –Buya Hamka"
    },
    "2023-07-26": {
        "content": "Cara terbaik untuk menyiapkan kehidupan adalah memulai hidup –Elbert Hubbard."
    },
    "2023-07-27": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2023-07-28": {
        "content": "Jadilah diri Anda sendiri; semua orang sudah menjadi orang lain. -Oscar Wilde"
    },
    "2023-07-29": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2023-07-30": {
        "content": "Saya suka mereka yang bisa tersenyum dalam kesulitan. –Leonardo da Vinci"
    },
    "2023-07-31": {
        "content": "Satu-satunya batasan untuk meraih mimpi kita adalah keragu-raguan kita akan hari ini. Marilah kita maju dengan keyakinan yang aktif dan kuat –Franklin Roosevelt"
    },
    "2023-08-01": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2023-08-02": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2023-08-03": {
        "content": "Orang yang hebat tidak dilahirkan begitu saja, tetapi mereka tumbuh menjadi lebih hebat –Mario Puzo."
    },
    "2023-08-04": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. –Wayne Huizenga"
    },
    "2023-08-05": {
        "content": "Hadiah terbesar dalam hidup ini adalah persahabatan, dan aku telah mendapatkannya –Hubert H Humphrey"
    },
    "2023-08-06": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan. -Shakuntala Devi"
    },
    "2023-08-07": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2023-08-08": {
        "content": "Tidak ada kata terlambat untuk menjadi dirimu yang seharusnya. –George Eliot"
    },
    "2023-08-09": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2023-08-10": {
        "content": "Lakukanlah sesuatu hari ini yang akan membuatmu berterima kasih kepada orang lain di masa depan nanti –Sean Patrick."
    },
    "2023-08-11": {
        "content": "Semakin kau tahu tentang jati diri dan sesuatu yang kau inginkan, semakin sedikit pula kau membiarkan berbagai hal yang membuatmu kesal berlalu –Stephanie Perkins."
    },
    "2023-08-12": {
        "content": "Hidup tanpa tujuan adalah seperti menelusuri lautan tanpa kompas. –Thomas Carlyle"
    },
    "2023-08-13": {
        "content": "Kabar buruknya adalah waktu berlalu begitu saja. Kabar baiknya adalah kamu adalah pilotnya. —Michael Altshuler"
    },
    "2023-08-14": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. -Zig Ziglar"
    },
    "2023-08-15": {
        "content": "Keadilan adalah tanda kekuatan dan keberanian. –Ali bin Abi Thalib"
    },
    "2023-08-16": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2023-08-17": {
        "content": "Sebab sahabat itu saling tumbuh, bukan yang hilang ketika satunya jatuh –Boy Candra"
    },
    "2023-08-18": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2023-08-19": {
        "content": "Jika kamu melihat apa yang kamu miliki dalam hidup, kamu akan selalu memiliki lebih banyak. Jika kamu melihat apa yang tidak kamu miliki dalam hidup, kamu tidak akan pernah merasa cukup. –Oprah Winfrey"
    },
    "2023-08-20": {
        "content": "Sebarkan cinta ke mana pun kamu pergi. Jangan biarkan orang lain mendatangimu tanpa mendapatkan hal yang lebih bahagia. –Bunda Teresa"
    },
    "2023-08-21": {
        "content": "Aku hanya ingin orang lain mengambil langkah mundur, mengambil napas yang dalam, dan benar-benar mengamati sesuatu dengan cara yang berbeda. Namun, mayoritas orang tidak akan pernah melakukannya –Brian Mc.Knight."
    },
    "2023-08-22": {
        "content": "Jika kamu berpikir kamu terlalu kecil untuk membuat sebuah perubahan, cobalah tidur di ruangan dengan seekor nyamuk. -Dalai Lama"
    },
    "2023-08-23": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    },
    "2023-08-24": {
        "content": "Pikiran yang baik dan hati yang baik selalu merupakan kombinasi yang hebat –Nelson Mandela"
    },
    "2023-08-25": {
        "content": "Kejujuran adalah batu penjuru dari segala kesuksesan. Pengakuan adalah motivasi terkuat. Bahkan kritik dapat membangun rasa percaya diri saat 'disisipkan' di antara pujian. –May Kay Ash"
    },
    "2023-08-26": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semuanya harus dirasakan dengan hati. –Helen Keller"
    },
    "2023-08-27": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2023-08-28": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2023-08-29": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2023-08-30": {
        "content": "Jangan katakan tidak punya cukup waktu. Anda memiliki jumlah jam yang persis sama per hari yang diberikan kepada Helen Keller, Pasteur, Michelangelo, Mother Teresa, Leonardo da Vinci, Thomas Jefferson, dan Albert Einstein. –H. Jackson Brown Jr"
    },
    "2023-08-31": {
        "content": "Kebahagiaan dirasakan oleh orang-orang yang dapat merasa puas kepada dirinya sendiri –Agatha Christie."
    },
    "2023-09-01": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2023-09-02": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2023-09-03": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2023-09-04": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2023-09-05": {
        "content": "Kamu dapat menipu beberapa orang setiap saat dan semua orang pada suatu waktu, tetapi kamu tidak dapat membodohi semua orang setiap saat. -Abraham Lincol"
    },
    "2023-09-06": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2023-09-07": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2023-09-08": {
        "content": "Kesuksesan bersumber dari perbuatan. Orang yang sukses terus melakukan usaha. Orang sukses bahkan membuat kesalahan, namun mereka tidak berhenti usaha –Cobrad Hilton"
    },
    "2023-09-09": {
        "content": "Ini adalah agamaku yang sederhana. Tak perlu ada kuil; tak perlu filosofi yang rumit. Otak kita sendiri, hati kita sendiri adalah kuil kita; filosofinya adalah kebaikan –Dalai Lama."
    },
    "2023-09-10": {
        "content": "Jika kamu ingin menjalani hidup yang bahagia, ikatlah dengan tujuan, bukan pada orang atau benda. –Albert Einstein"
    },
    "2023-09-11": {
        "content": "Saya telah gagal berkali-kali dalam hidup. Dan itulah mengapa saya berhasil. –Michael Jordan"
    },
    "2023-09-12": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2023-09-13": {
        "content": "Hidup yang baik adalah yang terinspirasi dari cinta dan dipandu oleh ilmu pengetahuan. –Bertrand Russell."
    },
    "2023-09-14": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2023-09-15": {
        "content": "Rasa bahagia dan tak bahagia bukan berasal dari apa yang kamu miliki, bukan pula berasal dari siapa diri kamu, atau apa yang kamu kerjakan. Bahagia dan tak bahagia berasal dari pikiran kamu. –Dale Carnegie"
    },
    "2023-09-16": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2023-09-17": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2023-09-18": {
        "content": "Satu-satunya batasan untuk meraih mimpi kita adalah keragu-raguan kita akan hari ini. Marilah kita maju dengan keyakinan yang aktif dan kuat –Franklin Roosevelt"
    },
    "2023-09-19": {
        "content": "Cara untuk memulai adalah dengan berhenti berbicara dan mulai melakukan. -Walt Disney"
    },
    "2023-09-20": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2023-09-21": {
        "content": "Pekerjaan-pekerjaan kecil yang selesai dilakukan, lebih baik daripada rencana-rencana besar yang hanya didiskusikan. -Peter Marshall"
    },
    "2023-09-22": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2023-09-23": {
        "content": "Orang bijak belajar ketika mereka bisa. Orang bodoh belajar ketika mereka dipaksa. -Arthur Wellesley"
    },
    "2023-09-24": {
        "content": "Jangan tinggalkan apa pun untuk hari esok yang bisa dilakukan hari ini. -Abraham Lincoln"
    },
    "2023-09-25": {
        "content": "Bukan gunung di depan untuk didaki yang membuatmu lelah, melainkan kerikil di sepatumu. –Muhammad Ali"
    },
    "2023-09-26": {
        "content": "Satu-satunya cara untuk mencapai yang tidak mungkin adalah percaya bahwa itu mungkin –Charles Kingsleigh"
    },
    "2023-09-27": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2023-09-28": {
        "content": "Yang membuatku terus berkembang adalah tujuan-tujuan hidupku. -Muhammad Ali"
    },
    "2023-09-29": {
        "content": "Menjadi diri sendiri di dunia yang terus-menerus berusaha menjadikan Anda orang lain adalah pencapaian terbesar. -Ralph Waldo Emerson"
    },
    "2023-09-30": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2023-10-01": {
        "content": "Cara untuk memulai adalah dengan berhenti berbicara dan mulai melakukan. -Walt Disney"
    },
    "2023-10-02": {
        "content": "Banyak orang gagal dalam kehidupan, bukan karena kurangnya kemampuan, pengetahuan, atau keberanian, namun hanya karena mereka tidak pernah mengatur energinya pada sasaran –Elbert Hubbard"
    },
    "2023-10-03": {
        "content": "Kebijaksanaan sejati adalah mengenal diri sendiri. –Ali bin Abi Thalib"
    },
    "2023-10-04": {
        "content": "Hidup itu sendiri adalah dongeng yang paling indah. -Hans Christian Andersen"
    },
    "2023-10-05": {
        "content": "Orang paling kesepian memiliki kepribadian yang baik hati. Orang paling sedih memiliki senyum paling cerah. Orang paling rusak memiliki kebijaksanaan yang luas. Semua itu karena mereka tidak ingin orang lain menderita seperti mereka –Zarathustra."
    },
    "2023-10-06": {
        "content": "Pekerjaan-pekerjaan kecil yang selesai dilakukan, lebih baik daripada rencana-rencana besar yang hanya didiskusikan. -Peter Marshall"
    },
    "2023-10-07": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2023-10-08": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2023-10-09": {
        "content": "Seseorang pernah bertanya kepadaku,Mengapa kau selalu bersikukuh mengambil jalan tersulit?” Aku menjawabnya,Mengapa kau menganggapku memilih dua jalan?” –John Fitzgerald Kennedy."
    },
    "2023-10-10": {
        "content": "Anda tidak dapat menjelekkan tanah di mana Anda berdiri. –Arthur Schopenhauer"
    },
    "2023-10-11": {
        "content": "Hal yang paling menyakitkan adalah kehilangan jati dirimu saat engkau terlalu mencintai seseorang. Serta lupa bahwa sebenarnya engkau juga spesial. -Ernest Hemingway"
    },
    "2023-10-12": {
        "content": "Jadilah seperti bebek. Tenang di permukaan tapi selalu mengayuh seperti ayam di bawahnya. -Michael Caine"
    },
    "2023-10-13": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2023-10-14": {
        "content": "Dalam hidup ini kita tidak bisa melakukan hal-hal besar. Kita hanya bisa melakukan hal-hal kecil dengan cinta yang besar. –Bunda Teresa"
    },
    "2023-10-15": {
        "content": "Tujuan pendidikan itu untuk mempertajam kecerdasan, memperkukuh kemauan serta memperhalus perasaan. –Tan Malaka"
    },
    "2023-10-16": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. –John F. Kennedy"
    },
    "2023-10-17": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2023-10-18": {
        "content": "Tuntutlah ilmu, tapi tidak melupakan ibadah. Kerjakanlah ibadah tapi tidak boleh lupa pada ilmu. –Hassan Al Bashri"
    },
    "2023-10-19": {
        "content": "Mimpi adalah jendela ke dalam alam bawah sadar. –Sigmund Freud"
    },
    "2023-10-20": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2023-10-21": {
        "content": "Keyakinan merupakan suatu pengetahuan di dalam hati, jauh tak terjangkau oleh bukti. –Kahlil Gibran, Pujangga"
    },
    "2023-10-22": {
        "content": "Tindakan manusia dapat dimodifikasi sampai batas tertentu, tetapi sifat manusia tidak dapat diubah. –Abraham Lincoln"
    },
    "2023-10-23": {
        "content": "Berjuang sampai napas terakhir –William Shakespeare"
    },
    "2023-10-24": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2023-10-25": {
        "content": "Anda mungkin bisa menunda, tapi waktu tidak akan menunggu. –Benjamin Franklin"
    },
    "2023-10-26": {
        "content": "Keyakinan menciptakan fakta yang sebenarnya –William James"
    },
    "2023-10-27": {
        "content": "Sahabat adalah keluarga yang Anda pilih –Jess C Scott"
    },
    "2023-10-28": {
        "content": "Percayalah, jika dia memang cinta sejati kau, mau semenyakitkan apa pun, mau seberapa sulit liku yang harus dilalui, dia tetap akan bersama kau kelak, suatu saat nanti. –Tere Liye"
    },
    "2023-10-29": {
        "content": "Anda akan menghadapi banyak kekalahan dalam hidup, tetapi jangan pernah membiarkan diri Anda dikalahkan. -Maya Angelou"
    },
    "2023-10-30": {
        "content": "Siapapun yang bahagia akan membuat orang lain juga bahagia. –Anne Frank"
    },
    "2023-10-31": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2023-11-01": {
        "content": "Kau harus membiarkan orang lain untuk pergi. Setiap orang yang ada dalam kehidupanmu ditakdirkan untuk berada dalam perjalanan, tetapi tidak semuanya dimaksudkan untuk tinggal hingga akhir –Vasco da Gama."
    },
    "2023-11-02": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2023-11-03": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2023-11-04": {
        "content": "Pengetahuan tidak memiliki nilai kecuali jika dipraktekkan. –Thomas Aquinas"
    },
    "2023-11-05": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2023-11-06": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2023-11-07": {
        "content": "Ketika kita memahami diri kita sendiri, kita mendekati pemahaman tentang Tuhan. –Ibn Sina"
    },
    "2023-11-08": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2023-11-09": {
        "content": "Ketika kita memahami diri kita sendiri, kita mendekati pemahaman tentang Tuhan. –Ibn Sina"
    },
    "2023-11-10": {
        "content": "Keselamatan adalah hasil akhir dari kesabaran. –Ibn Taymiyyah"
    },
    "2023-11-11": {
        "content": "Tidak masalah seberapa lambat kau berjalan asalkan kau tidak berhenti. -Confucius"
    },
    "2023-11-12": {
        "content": "Kegelapan tidak dapat mengusir kegelapan: hanya cahaya yang dapat melakukannya. Kebencian tidak dapat mengusir kebencian: hanya cinta yang dapat melakukannya. -Martin Luther King Jr."
    },
    "2023-11-13": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2023-11-14": {
        "content": "Tujuan hidup adalah untuk hidup dengan bijaksana dan merenung. –Plato"
    },
    "2023-11-15": {
        "content": "Kita adalah apa yang kita pikirkan. –Marcus Aurelius"
    },
    "2023-11-16": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2023-11-17": {
        "content": "Tiada awan di langit yang tetap selamanya. Tiada mungkin akan terus-menerus terang cuaca. Sehabis malam gelap gulita lahir pagi membawa keindahan. Kehidupan manusia serupa alam. –RA Kartini"
    },
    "2023-11-18": {
        "content": "Cinta yang tak dewasa: 'Aku mencintaimu karena aku membutuhkanmu' Cinta yang dewasa: 'Aku membutuhkanmu karena aku mencintaimu' –Erich Fromm"
    },
    "2023-11-19": {
        "content": "Karena cinta, duri menjadi mawar. Karena cinta, cuka menjelma anggur segar. –Jalaluddin Rumi"
    },
    "2023-11-20": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2023-11-21": {
        "content": "Banyak kegagalan dalam hidup adalah orang-orang yang tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. -Thomas A. Edison"
    },
    "2023-11-22": {
        "content": "Kemuliaan terbesar dalam hidup bukan terletak pada tidak pernah jatuh, tetapi bangkit setiap kali kita jatuh. -Nelson Mandela"
    },
    "2023-11-23": {
        "content": "Kehidupan adalah pengorbanan untuk mencapai kedamaian batin. –Ibn Hazm"
    },
    "2023-11-24": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2023-11-25": {
        "content": "Kamu menjadi apa yang kamu yakini. -Oprah Winfrey"
    },
    "2023-11-26": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2023-11-27": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2023-11-28": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2023-11-29": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2023-11-30": {
        "content": "Hal yang paling menyakitkan adalah kehilangan jati dirimu saat engkau terlalu mencintai seseorang. Serta lupa bahwa sebenarnya engkau juga spesial. -Ernest Hemingway"
    },
    "2023-12-01": {
        "content": "Orang yang meninggal memperoleh lebih banyak bunga dibandingkan orang yang masih hidup karena penyesalan lebih kuat dibandingkan rasa syukur –Anne Frank."
    },
    "2023-12-02": {
        "content": "Cintai hidup yang kau jalani. Jalani hidup yang kau cintai. –Bob Marley"
    },
    "2023-12-03": {
        "content": "Janganlah menganggap remeh hal-hal yang terdekat dengan hatimu. Rangkullah mereka seperti sama berharganya dengan hidupmu, karena tanpa mereka hidup adalah sia-sia –Peribahasa Cina"
    },
    "2023-12-04": {
        "content": "Kebijaksanaan adalah lebih berharga daripada kekayaan. –Heraclitus"
    },
    "2023-12-05": {
        "content": "Banyak dari kegagalan hidup adalah karena mereka tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. –Thomas A. Edison"
    },
    "2023-12-06": {
        "content": "Doa adalah senjata terbesar umat manusia. –Abu Hamid al-Ghazali"
    },
    "2023-12-07": {
        "content": "Saya tidak memikirkan semua penderitaan, tetapi keindahan yang masih tersisa. –Anne Frank"
    },
    "2023-12-08": {
        "content": "Dunia ini adalah sebuah cermin bagi pikiran kita sendiri. –Baruch Spinoza"
    },
    "2023-12-09": {
        "content": "Jika tindakanmu menginspirasi orang lain untuk bermimpi lebih banyak, belajar lebih banyak, berbuat lebih banyak, dan menjadi lebih sukses, kamu adalah seorang pemimpin –John Quincy Adams"
    },
    "2023-12-10": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. –Maya Angelou"
    },
    "2023-12-11": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2023-12-12": {
        "content": "Sebelum apa pun, persiapan adalah kunci menuju kesuksesan. -Alexander Graham Bell"
    },
    "2023-12-13": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2023-12-14": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2023-12-15": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2023-12-16": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2023-12-17": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2023-12-18": {
        "content": "Ketika kesulitan datang, ingatlah bahwa Allah selalu bersamamu. –Jalal ad-Din Rumi"
    },
    "2023-12-19": {
        "content": "Lebih baik mempunyai kehidupan yang bermakna dan memberikan perbedaan dibandingkan hanya mempunyai umur yang panjang –Bryant H. Mc.Gill."
    },
    "2023-12-20": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2023-12-21": {
        "content": "Memaafkan belum tentu membuat kita lebih baik atau bahkan merasa lebih baik tetapi yang jelas membuka jalan kebaikan.–Eleanor Roosevelt"
    },
    "2023-12-22": {
        "content": "Pencarian ilmu adalah ibadah yang paling utama. –Abu Yusuf al-Qadi"
    },
    "2023-12-23": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2023-12-24": {
        "content": "Jika Anda tidak mampu berpikir secara jernih, tidak Anda mempunyai hak untuk bertindak. –Martin Heidegger"
    },
    "2023-12-25": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2023-12-26": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2023-12-27": {
        "content": "Bangun dan wujudkan mimpimu atau orang lain akan memperkerjakanmu untuk membangun mimpi mereka –Farrah Gray"
    },
    "2023-12-28": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2023-12-29": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    },
    "2023-12-30": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2023-12-31": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2024-01-01": {
        "content": "Cara terbaik untuk menyiapkan kehidupan adalah memulai hidup –Elbert Hubbard."
    },
    "2024-01-02": {
        "content": "Jadilah seperti bebek. Tenang di permukaan tapi selalu mengayuh seperti ayam di bawahnya. -Michael Caine"
    },
    "2024-01-03": {
        "content": "Kita memahami dunia tidak sebagaimana ia adalah, tetapi sebagaimana kita. –Immanuel Kant"
    },
    "2024-01-04": {
        "content": "Sebab sahabat itu saling tumbuh, bukan yang hilang ketika satunya jatuh –Boy Candra"
    },
    "2024-01-05": {
        "content": "Sukses bukanlah akhir, kegagalan bukanlah fatal, yang terpenting adalah keberanian untuk melanjutkan –Winston S. Churchill"
    },
    "2024-01-06": {
        "content": "Mimpi adalah jendela ke dalam alam bawah sadar. –Sigmund Freud"
    },
    "2024-01-07": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. -Zig Ziglar"
    },
    "2024-01-08": {
        "content": "Tiga hal dalam hidup –kesehatanmu, misimu dan orang yang kamu cintai. –Naval Ravikant"
    },
    "2024-01-09": {
        "content": "Orang bijak belajar ketika mereka bisa. Orang bodoh belajar ketika mereka dipaksa. -Arthur Wellesley"
    },
    "2024-01-10": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2024-01-11": {
        "content": "Sulit untuk mengalahkan orang yang tidak pernah menyerah –Babe Ruth"
    },
    "2024-01-12": {
        "content": "Ketika kamu mengubah pikiran, ingatlah untuk juga mengubah duniamu juga —Norman Vincent Peale"
    },
    "2024-01-13": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2024-01-14": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2024-01-15": {
        "content": "Sesuatu akan terlihat berkesan jika hal tersebut dapat bermakna dan penuh warna –Joshua Foer."
    },
    "2024-01-16": {
        "content": "Diam adalah sumber dari kekuatan yang luar biasa. -Lao Tzu"
    },
    "2024-01-17": {
        "content": "Anda akan menghadapi banyak kekalahan dalam hidup, tetapi jangan pernah membiarkan diri Anda dikalahkan. -Maya Angelou"
    },
    "2024-01-18": {
        "content": "Memaafkan belum tentu membuat kita lebih baik atau bahkan merasa lebih baik tetapi yang jelas membuka jalan kebaikan.–Eleanor Roosevelt"
    },
    "2024-01-19": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2024-01-20": {
        "content": "Satu-satunya batasan untuk meraih mimpi kita adalah keragu-raguan kita akan hari ini. Marilah kita maju dengan keyakinan yang aktif dan kuat –Franklin Roosevelt"
    },
    "2024-01-21": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2024-01-22": {
        "content": "Anda mungkin bisa menunda, tapi waktu tidak akan menunggu. -Benjamin Franklin"
    },
    "2024-01-23": {
        "content": "Semakin tinggi ilmu seseorang, maka semakin tinggi toleransinya. –Gus Dur"
    },
    "2024-01-24": {
        "content": "Hidup adalah rangkaian pelajaran yang harus dijalani untuk dipahami. –Ralph Waldo Emerson"
    },
    "2024-01-25": {
        "content": "Seseorang pernah bertanya kepadaku,Mengapa kau selalu bersikukuh mengambil jalan tersulit?” Aku menjawabnya,Mengapa kau menganggapku memilih dua jalan?” –John Fitzgerald Kennedy."
    },
    "2024-01-26": {
        "content": "Keindahan persahabatan adalah bahwa kamu tahu kepada siapa kamu dapat mempercayakan rahasia –Alessandro Manzoni"
    },
    "2024-01-27": {
        "content": "Cinta adalah ketika kebahagiaan orang lain lebih penting dari kebahagiaanmu. -H. Jackson Brown"
    },
    "2024-01-28": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2024-01-29": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2024-01-30": {
        "content": "Kebahagiaan dirasakan oleh orang-orang yang dapat merasa puas kepada dirinya sendiri –Agatha Christie."
    },
    "2024-01-31": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2024-02-01": {
        "content": "Kita adalah apa yang kita pikirkan. –Marcus Aurelius"
    },
    "2024-02-02": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2024-02-03": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2024-02-04": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2024-02-05": {
        "content": " Hidup memiliki semua tikungan dan belokan itu. Kamu harus berpegangan erat-erat dan pergilah. –Nicole Kidman"
    },
    "2024-02-06": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2024-02-07": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2024-02-08": {
        "content": "Aku menginginkanmu seutuhnya, selamanya, kamu dan aku, setiap hari. –The Notebook, Nicholas Sparks"
    },
    "2024-02-09": {
        "content": "Banyak kegagalan dalam hidup adalah orang-orang yang tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. -Thomas A. Edison"
    },
    "2024-02-10": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semuanya harus dirasakan dengan hati. –Helen Keller"
    },
    "2024-02-11": {
        "content": "Tindakan manusia dapat dimodifikasi sampai batas tertentu, tetapi sifat manusia tidak dapat diubah. –Abraham Lincoln"
    },
    "2024-02-12": {
        "content": "Bila Anda gagal hari ini, jangan pernah menyerah Ulangi terus kegagalan Anda sampai atasan/komandan Anda menyerah –Mario Teguh"
    },
    "2024-02-13": {
        "content": "Keyakinan menciptakan fakta yang sebenarnya –William James"
    },
    "2024-02-14": {
        "content": "Ketika dirimu tidak memperoleh solusi untuk mengatasi permasalahan, itu mungkin bukanlah masalah yang harus diatasi, melainkan kebenaran yang harus diterima –Mao Zedong."
    },
    "2024-02-15": {
        "content": "Jika tindakanmu menginspirasi orang lain untuk bermimpi lebih banyak, belajar lebih banyak, berbuat lebih banyak, dan menjadi lebih sukses, kamu adalah seorang pemimpin –John Quincy Adams"
    },
    "2024-02-16": {
        "content": "Cinta terjadi begitu singkat, namun melupakan memakan waktu begitu lama. -Pablo Neruda"
    },
    "2024-02-17": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2024-02-18": {
        "content": "Saya suka mereka yang bisa tersenyum dalam kesulitan. –Leonardo da Vinci"
    },
    "2024-02-19": {
        "content": "Kepanikan adalah separuh penyakit. Ketenangan adalah separuh obat, kesabaran adalah permulaan kesembuhan.–Ibnu Sina"
    },
    "2024-02-20": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2024-02-21": {
        "content": "Ini adalah agamaku yang sederhana. Tak perlu ada kuil; tak perlu filosofi yang rumit. Otak kita sendiri, hati kita sendiri adalah kuil kita; filosofinya adalah kebaikan –Dalai Lama."
    },
    "2024-02-22": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2024-02-23": {
        "content": "Cinta yang tak dewasa: 'Aku mencintaimu karena aku membutuhkanmu' Cinta yang dewasa: 'Aku membutuhkanmu karena aku mencintaimu' –Erich Fromm"
    },
    "2024-02-24": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2024-02-25": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara. -Shah Rukh Khan"
    },
    "2024-02-26": {
        "content": "Jangan khawatir jika Anda tidak diakui, tetapi berusahalah untuk menjadi layak diakui. -Abraham Lincoln"
    },
    "2024-02-27": {
        "content": "Pada saat-saat tergelaplah kita harus fokus untuk melihat cahaya. -Aristoteles"
    },
    "2024-02-28": {
        "content": "Ingatlah bahwa kita hanya bisa hidup saat ini, dalam waktu yang sekarang. –Jean-Paul Sartre"
    },
    "2024-02-29": {
        "content": "Harta yang paling berharga adalah hati yang bertakwa. –Umar bin Khattab"
    },
    "2024-03-01": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2024-03-02": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. –Maya Angelou"
    },
    "2024-03-03": {
        "content": "Kejujuran adalah batu penjuru dari segala kesuksesan. Pengakuan adalah motivasi terkuat. Bahkan kritik dapat membangun rasa percaya diri saat 'disisipkan' di antara pujian. –May Kay Ash"
    },
    "2024-03-04": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. –Maya Angelou"
    },
    "2024-03-05": {
        "content": "Kebahagiaan sama dengan kenyataan dikurangi ekspektasi. -Tom Magliozzi"
    },
    "2024-03-06": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2024-03-07": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2024-03-08": {
        "content": "Tindakan menyalahkan hanya akan membuang waktu. Sebesar apapun kesalahan yang kamu timpakan ke orang lain, dan sebesar apapun kamu menyalahkannya, hal tersebut tidak akan mengubahmu –Wayne Dyer"
    },
    "2024-03-09": {
        "content": "Kamu tidak bisa kembali dan mengubah awal saat kamu memulainya, tapi kamu bisa memulainya lagi dari di mana kamu berada sekarang dan ubah akhirnya. -C.S Lewis"
    },
    "2024-03-10": {
        "content": "Untuk sukses, sikap sama pentingnya dengan kemampuan. -Walter Scott"
    },
    "2024-03-11": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2024-03-12": {
        "content": "Jangan habiskan waktu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. –Coco Canel"
    },
    "2024-03-13": {
        "content": "Keselamatan adalah hasil akhir dari kesabaran. –Ibn Taymiyyah"
    },
    "2024-03-14": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan –Shakuntala Devi"
    },
    "2024-03-15": {
        "content": "Tujuan pendidikan itu untuk mempertajam kecerdasan, memperkukuh kemauan serta memperhalus perasaan. –Tan Malaka"
    },
    "2024-03-16": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2024-03-17": {
        "content": "Janganlah menganggap remeh hal-hal yang terdekat dengan hatimu. Rangkullah mereka seperti sama berharganya dengan hidupmu, karena tanpa mereka hidup adalah sia-sia –Peribahasa Cina"
    },
    "2024-03-18": {
        "content": " Hidup memiliki semua tikungan dan belokan itu. Kamu harus berpegangan erat-erat dan pergilah. –Nicole Kidman"
    },
    "2024-03-19": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2024-03-20": {
        "content": " Orang yang memiliki sasaran sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2024-03-21": {
        "content": "Cinta bukan mengajar kita lemah, tetapi membangkitkan kekuatan Cinta bukan mengajar kita menghinakan diri, tetapi mengembuskan kegagahan Cinta bukan melemahkan semangat, tetapi membangkitkan semangat –Buya Hamka"
    },
    "2024-03-22": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2024-03-23": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2024-03-24": {
        "content": "Kebahagiaan dari hidupmu tergantung dari kualitas pikiranmu –Marcus Aurelius."
    },
    "2024-03-25": {
        "content": "Suatu pekerjaan yang paling tak kunjung bisa diselesaikan adalah pekerjaan yang tak kunjung pernah dimulai. –JRR Tolkien"
    },
    "2024-03-26": {
        "content": "Doa adalah senjata terbesar umat manusia. –Abu Hamid al-Ghazali"
    },
    "2024-03-27": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2024-03-28": {
        "content": "Jangan biarkan rasa takut kalah lebih besar daripada kegembiraan saat menang –Robert Kiyosaki"
    },
    "2024-03-29": {
        "content": "Bukan gunung di depan untuk didaki yang membuatmu lelah, melainkan kerikil di sepatumu. –Muhammad Ali"
    },
    "2024-03-30": {
        "content": "Ubah lukamu menjadi kebijaksanaan. –Oprah Winfrey"
    },
    "2024-03-31": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2024-04-01": {
        "content": "Rahasia kesuksesan adalah melakukan hal yang biasa dengan sangat baik. -John D. Rockefeller Jr."
    },
    "2024-04-02": {
        "content": "Kabar buruknya adalah waktu berlalu begitu saja. Kabar baiknya adalah kamu adalah pilotnya. —Michael Altshuler"
    },
    "2024-04-03": {
        "content": "​Sukses adalah jumlah dari usaha-usaha kecil, berulang-ulang hari demi hari –Robert Collier"
    },
    "2024-04-04": {
        "content": "Tujuan hidup kita adalah untuk menjadi bahagia. -Dalai Lama"
    },
    "2024-04-05": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2024-04-06": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2024-04-07": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2024-04-08": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2024-04-09": {
        "content": "Aku hanya ingin orang lain mengambil langkah mundur, mengambil napas yang dalam, dan benar-benar mengamati sesuatu dengan cara yang berbeda. Namun, mayoritas orang tidak akan pernah melakukannya –Brian Mc.Knight."
    },
    "2024-04-10": {
        "content": "Anda tidak dapat menjelekkan tanah di mana Anda berdiri. –Arthur Schopenhauer"
    },
    "2024-04-11": {
        "content": "Hadiah terbesar dalam hidup ini adalah persahabatan, dan aku telah mendapatkannya –Hubert H Humphrey"
    },
    "2024-04-12": {
        "content": "Jadilah diri Anda sendiri; semua orang sudah menjadi orang lain. -Oscar Wilde"
    },
    "2024-04-13": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2024-04-14": {
        "content": "Ketika kita memahami diri kita sendiri, kita mendekati pemahaman tentang Tuhan. –Ibn Sina"
    },
    "2024-04-15": {
        "content": "Kesuksesan bukanlah hal yang final; kegagalan bukanlah hal yang fatal: Yang terpenting adalah keberanian untuk terus maju. -Winston S. Churchill"
    },
    "2024-04-16": {
        "content": "Dunia itu seluas langkah kaki. Jelajahilah dan jangan pernah takut melangkah. Hanya dengan itu kita bisa mengerti kehidupan dan menyatu dengannya.–Soe Hok Gie"
    },
    "2024-04-17": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2024-04-18": {
        "content": "Kebijaksanaan adalah lebih berharga daripada kekayaan. –Heraclitus"
    },
    "2024-04-19": {
        "content": "Kamu tidak selalu membutuhkan rencana. Terkadang kamu hanya perlu bernapas, percaya, melepaskan dan melihat apa yang terjadi –Mandy Hale"
    },
    "2024-04-20": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. -Maya Angelou"
    },
    "2024-04-21": {
        "content": "Hadapkan wajahmu selalu ke arah matahari, sehingga bayangan akan jatuh di belakangmu. -Walt Whitman"
    },
    "2024-04-22": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2024-04-23": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2024-04-24": {
        "content": "Saya tidak bisa mengubah arah angin, namun saya bisa menyesuaikan pelayaran saya untuk selalu menggapai tujuan saya –Jimmy Dean"
    },
    "2024-04-25": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2024-04-26": {
        "content": "Kesempatan emas yang kau cari ada di dalam dirimu sendiri –Orison Sweet Marden."
    },
    "2024-04-27": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2024-04-28": {
        "content": "Jangan menunggu orang lain membahagiakanmu. Kebahagiaan apa pun yang Anda peroleh, harus Anda ciptakan sendiri. -Alice Walker"
    },
    "2024-04-29": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semuanya harus dirasakan dengan hati. –Helen Keller"
    },
    "2024-04-30": {
        "content": "Ketika kesulitan datang, ingatlah bahwa Allah selalu bersamamu. –Jalal ad-Din Rumi"
    },
    "2024-05-01": {
        "content": "Jalan menuju sukses dan jalan menuju kegagalan hampir persis sama –Colin R. Davis"
    },
    "2024-05-02": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2024-05-03": {
        "content": "Aku memilih untuk membuat sisa hidupku menjadi yang terbaik dalam hidupku. -Louise Hay"
    },
    "2024-05-04": {
        "content": "Belajarlah seolah-olah kamu akan hidup selamanya, hiduplah seolah-olah kamu akan mati besok. –Mahatma Gandhi"
    },
    "2024-05-05": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2024-05-06": {
        "content": "Jauhi orang-orang yang mencoba meremehkan ambisimu. Pikiran kecil akan selalu melakukan itu, tetapi pikiran besar akan memberi perasaan bahwa kamu juga bisa menjadi hebat –Mark Twain"
    },
    "2024-05-07": {
        "content": "Tidak ada kata terlambat untuk menjadi dirimu yang seharusnya. –George Eliot"
    },
    "2024-05-08": {
        "content": "Pengetahuan tidak memiliki nilai kecuali jika dipraktekkan. –Thomas Aquinas"
    },
    "2024-05-09": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2024-05-10": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2024-05-11": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2024-05-12": {
        "content": "Kebahagiaan berada di dalam. Hal itu tidak ada hubungannya dengan seberapa banyak tepuk tangan yang kau peroleh atau seberapa banyak orang yang menyanjungmu. Kebahagiaan datang saat kau percaya telah melaksanakan sesuatu yang benar-benar berharga –Martin Yan."
    },
    "2024-05-13": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2024-05-14": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. –Zig Ziglar"
    },
    "2024-05-15": {
        "content": "Dalam hidup ini kita tidak bisa melakukan hal-hal besar. Kita hanya bisa melakukan hal-hal kecil dengan cinta yang besar. –Bunda Teresa"
    },
    "2024-05-16": {
        "content": "Hiduplah seolah-olah Anda akan mati besok. Belajarlah seolah Anda hidup selamanya. –Mahatma Gandhi"
    },
    "2024-05-17": {
        "content": "Karena cinta, duri menjadi mawar. Karena cinta, cuka menjelma anggur segar. –Jalaluddin Rumi"
    },
    "2024-05-18": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2024-05-19": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2024-05-20": {
        "content": "Percayalah, jika dia memang cinta sejati kau, mau semenyakitkan apa pun, mau seberapa sulit liku yang harus dilalui, dia tetap akan bersama kau kelak, suatu saat nanti. –Tere Liye"
    },
    "2024-05-21": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2024-05-22": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2024-05-23": {
        "content": "Kegelapan tidak dapat mengusir kegelapan: hanya cahaya yang dapat melakukannya. Kebencian tidak dapat mengusir kebencian: hanya cinta yang dapat melakukannya. -Martin Luther King Jr."
    },
    "2024-05-24": {
        "content": "Jangan tinggalkan apa pun untuk hari esok yang bisa dilakukan hari ini. -Abraham Lincoln"
    },
    "2024-05-25": {
        "content": "Cobalah untuk tidak menjadi orang yang sukses. Sebaliknya, jadilah orang yang bernilai. -Albert Einstein"
    },
    "2024-05-26": {
        "content": "Aku telah belajar jika ada lebih banyak kekuatan di dalam sebuah pelukan yang kuat dibandingkan dengan seribu kata-kata –Ann Hood."
    },
    "2024-05-27": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2024-05-28": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2024-05-29": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2024-05-30": {
        "content": "Cinta selalu saja misterius Jangan diburu-buru, atau kau akan merusak jalan ceritanya sendiri –Tere Liye"
    },
    "2024-05-31": {
        "content": "Yang membuatku terus berkembang adalah tujuan-tujuan hidupku. -Muhammad Ali"
    },
    "2024-06-01": {
        "content": "Berjuang sampai napas terakhir –William Shakespeare"
    },
    "2024-06-02": {
        "content": "Pikirkanlah sebelum berbicara, karena perkataan memiliki kekuatan yang besar. –Ali bin Abi Thalib"
    },
    "2024-06-03": {
        "content": "Hidup merupakan suatu perjalanan yang dapat dijadikan pengalaman, bukan sekadar masalah yang harus diselesaikan –C.S. Lewis."
    },
    "2024-06-04": {
        "content": "Hidup adalah yang terjadi saat kamu sibuk membuat rencana lain. –John Lennon"
    },
    "2024-06-05": {
        "content": "Seseorang tak akan pernah tahu betapa dalam kadar cintanya sampai terjadi sebuah perpisahan. -Kahlil Gibran"
    },
    "2024-06-06": {
        "content": "Anda memiliki otak di kepala Anda. Anda memiliki kaki di sepatu Anda. Anda dapat mengarahkan diri Anda ke arah mana pun yang Anda pilih. -Dr. Seuss"
    },
    "2024-06-07": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2024-06-08": {
        "content": "Arahkan mata Anda pada bintang-bintang dengan kaki tetap berpijak pada tanah. -Theodore Roosevelt"
    },
    "2024-06-09": {
        "content": "Tetap menghadapkan wajah selalu ke arah sinar matahari, dan bayangan akan jatuh di belakangmu –Walt Whitman"
    },
    "2024-06-10": {
        "content": "Kemuliaan terbesar dalam hidup tidak terletak pada tidak pernah jatuh, tetapi dalam bangkit setiap kali kita jatuh. –Nelson Mandela"
    },
    "2024-06-11": {
        "content": "Jangan pernah bermimpi untuk sukses, tapi kerjakan sesuatu untuk meraih kesuksesan –Ester Lauder"
    },
    "2024-06-12": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2024-06-13": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2024-06-14": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2024-06-15": {
        "content": "Tuntutlah ilmu, tapi tidak melupakan ibadah. Kerjakanlah ibadah tapi tidak boleh lupa pada ilmu. –Hassan Al Bashri"
    },
    "2024-06-16": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2024-06-17": {
        "content": "Tujuan hidup adalah untuk hidup dengan bijaksana dan merenung. –Plato"
    },
    "2024-06-18": {
        "content": "Kedamaian hilang karena kita lupa jika sebenarnya memiliki satu sama lain –Bunda Maria Teresa Bojaxhiu."
    },
    "2024-06-19": {
        "content": "Seseorang yang benar-benar hebat merupakan orang yang membuat tiap orang merasa hebat –G.K. Chesterton."
    },
    "2024-06-20": {
        "content": "Kebijaksanaan bukanlah produk dari sekolah tetapi dari usaha seumur hidup untuk mendapatkannya. –Albert Einstein"
    },
    "2024-06-21": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2024-06-22": {
        "content": "Anda hanya hidup sekali, tetapi jika Anda melakukannya dengan benar, sekali saja sudah cukup. -Mae West"
    },
    "2024-06-23": {
        "content": "Jangan takut akan kesulitan, karena itu adalah kesempatan untuk tumbuh. –Albert Einstein"
    },
    "2024-06-24": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2024-06-25": {
        "content": "Aku tidak takut badai karena telah belajar berlayar dengan kapalku –Louisa May Alcott."
    },
    "2024-06-26": {
        "content": "Rasa bahagia dan tak bahagia bukan berasal dari apa yang kamu miliki, bukan pula berasal dari siapa diri kamu, atau apa yang kamu kerjakan. Bahagia dan tak bahagia berasal dari pikiran kamu. –Dale Carnegie"
    },
    "2024-06-27": {
        "content": "Suatu ide yang berguna lebih berharga daripada kekayaan. –Socrates"
    },
    "2024-06-28": {
        "content": "Sebelum apa pun, persiapan adalah kunci menuju kesuksesan. -Alexander Graham Bell"
    },
    "2024-06-29": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2024-06-30": {
        "content": "Tiada awan di langit yang tetap selamanya. Tiada mungkin akan terus-menerus terang cuaca. Sehabis malam gelap gulita lahir pagi membawa keindahan. Kehidupan manusia serupa alam. –RA Kartini"
    },
    "2024-07-01": {
        "content": "Jangan khawatir tentang kegagalan, khawatirkan tentang peluang yang kamu lewatkan ketika kamu bahkan tidak mencoba. –Jack Canfield"
    },
    "2024-07-02": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2024-07-03": {
        "content": "Satu-satunya sumber dari pengertahuan adalah pengalaman. -Albert Einstein"
    },
    "2024-07-04": {
        "content": "Gagal itu makanan sehari-hari. Itu biasa, yang penting bagimana kamu menyikapinya. Evaluasi. Bangkit. Gagal lagi? Bangkit lagi!” –Chairul Tanjung"
    },
    "2024-07-05": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2024-07-06": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2024-07-07": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2024-07-08": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2024-07-09": {
        "content": "Rahasia dari kesuksesan kita adalah bahwa kita tidak pernah menyerah. –Ilma Mankiller"
    },
    "2024-07-10": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2024-07-11": {
        "content": "Cinta tak berupa tatapan satu sama lain, tetapi memandang keluar bersama ke arah yang sama. –B.J. Habibie"
    },
    "2024-07-12": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2024-07-13": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2024-07-14": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2024-07-15": {
        "content": "Bagaimana kau mengeja 'cinta'? tanya Piglet.Kau tak usah mengejanya….rasakan saja. Jawab Pooh. -A.A Milne"
    },
    "2024-07-16": {
        "content": "Perjalanan seribu mil dimulai dengan satu langkah. –Lao Tzu"
    },
    "2024-07-17": {
        "content": "Banyak dari kegagalan hidup adalah karena mereka tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. –Thomas A. Edison"
    },
    "2024-07-18": {
        "content": "Ketika Anda jatuh cinta, kebahagiaan akan membuat Anda sulit tertidur karena kenyataan lebih baik dibandingkan mimpi Anda –Dr Seuss"
    },
    "2024-07-19": {
        "content": "Jangan merusak sesuatu yang kau miliki dengan mengharapkan sesuatu yang tidak akan pernah kau miliki; ingatlah jika sesuatu yang kau miliki saat ini pernah menjadi salah satu hal yang kau harapkan –Epicurus."
    },
    "2024-07-20": {
        "content": "Hidup tanpa tujuan adalah seperti menelusuri lautan tanpa kompas. –Thomas Carlyle"
    },
    "2024-07-21": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2024-07-22": {
        "content": "Semuanya kelihatan tidak mungkin sampai segala sesuatu selesai. -Nelson Mandela"
    },
    "2024-07-23": {
        "content": "Keyakinan merupakan suatu pengetahuan di dalam hati, jauh tak terjangkau oleh bukti. –Kahlil Gibran, Pujangga"
    },
    "2024-07-24": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2024-07-25": {
        "content": "Belajar tidak pernah melelahkan pikiran –Leonardo Da Vinci"
    },
    "2024-07-26": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2024-07-27": {
        "content": "Kebijaksanaan adalah lebih berharga daripada kekayaan. –Heraclitus"
    },
    "2024-07-28": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2024-07-29": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2024-07-30": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan. -Shakuntala Devi"
    },
    "2024-07-31": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2024-08-01": {
        "content": "Pikiran yang baik dan hati yang baik selalu merupakan kombinasi yang hebat –Nelson Mandela"
    },
    "2024-08-02": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2024-08-03": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2024-08-04": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2024-08-05": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2024-08-06": {
        "content": "Cinta tidak terlihat dengan mata, tetapi dengan hati.–William Shakespeare"
    },
    "2024-08-07": {
        "content": "Tidak ada yang tidak mungkin. Kata itu sendiri mengatakan 'Saya mungkin!'” —Audrey Hepburn"
    },
    "2024-08-08": {
        "content": "Dalam hidup ini kita tidak bisa melakukan hal-hal besar. Kita hanya bisa melakukan hal-hal kecil dengan cinta yang besar. -Bunda Teresa"
    },
    "2024-08-09": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2024-08-10": {
        "content": "Lakukanlah sesuatu hari ini yang akan membuatmu berterima kasih kepada orang lain di masa depan nanti –Sean Patrick."
    },
    "2024-08-11": {
        "content": "Saya tidak bisa mengubah arah angin, namun saya bisa menyesuaikan pelayaran saya untuk selalu menggapai tujuan saya –Jimmy Dean"
    },
    "2024-08-12": {
        "content": "Hal yang paling menyakitkan adalah kehilangan jati dirimu saat engkau terlalu mencintai seseorang. Serta lupa bahwa sebenarnya engkau juga spesial. -Ernest Hemingway"
    },
    "2024-08-13": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2024-08-14": {
        "content": "Kamu bisa menjadi segalanya. Kamu bisa menjadi orang yang tidak terbatas jumlahnya. ” –Kesha"
    },
    "2024-08-15": {
        "content": "Jika kamu ingin menjalani hidup yang bahagia, ikatlah dengan tujuan, bukan pada orang atau benda. –Albert Einstein"
    },
    "2024-08-16": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2024-08-17": {
        "content": "Hidup itu sebentar. Kamu harus bisa tersenyum saat merasakan kepedihan atau kita tak akan pernah melanjutkan hidup.–Jeff Ross"
    },
    "2024-08-18": {
        "content": "Sahabat adalah keluarga yang Anda pilih –Jess C Scott"
    },
    "2024-08-19": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2024-08-20": {
        "content": "Kamu menjadi apa yang kamu yakini. -Oprah Winfrey"
    },
    "2024-08-21": {
        "content": "Lebih baik mempunyai kehidupan yang bermakna dan memberikan perbedaan dibandingkan hanya mempunyai umur yang panjang –Bryant H. Mc.Gill."
    },
    "2024-08-22": {
        "content": "Tidak masalah seberapa lambat kau berjalan asalkan kau tidak berhenti. -Confucius"
    },
    "2024-08-23": {
        "content": "Hanya mereka yang berani mengambil risiko melangkah terlalu jauh, yang mungkin bisa mengetahui seberapa jauh seseorang bisa melangkah. –TS Eliot"
    },
    "2024-08-24": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2024-08-25": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2024-08-26": {
        "content": "Cinta itu seperti halnya angin. Kita tidak dapat melihatnya, tetapi dapat merasakannya –Nicholas Sparks."
    },
    "2024-08-27": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2024-08-28": {
        "content": "Jika kamu benar-benar menginginkan sesuatu, jangan menunggu untuk itu –ajari dirimu untuk tidak sabar –Gurbaksh Chahal"
    },
    "2024-08-29": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2024-08-30": {
        "content": "Jangan katakan tidak punya cukup waktu. Anda memiliki jumlah jam yang persis sama per hari yang diberikan kepada Helen Keller, Pasteur, Michelangelo, Mother Teresa, Leonardo da Vinci, Thomas Jefferson, dan Albert Einstein. –H. Jackson Brown Jr"
    },
    "2024-08-31": {
        "content": "Dia, yang tidak cukup berani untuk mengambil risiko, tidak akan mencapai apa pun dalam hidup. –Muhammad Ali"
    },
    "2024-09-01": {
        "content": "Dunia ini adalah sebuah cermin bagi pikiran kita sendiri. –Baruch Spinoza"
    },
    "2024-09-02": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2024-09-03": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2024-09-04": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2024-09-05": {
        "content": "Tidak ada hal apapun di dunia ini yang lebih berharga dari persahabatan sejati –Thomas Aquinas"
    },
    "2024-09-06": {
        "content": "Jika kamu melihat apa yang kamu miliki dalam hidup, kamu akan selalu memiliki lebih banyak. Jika kamu melihat apa yang tidak kamu miliki dalam hidup, kamu tidak akan pernah merasa cukup. –Oprah Winfrey"
    },
    "2024-09-07": {
        "content": "Kegigihan adalah kunci kesuksesan dalam pencapaian tujuan. –Abdul Qadir al-Jilani"
    },
    "2024-09-08": {
        "content": "Doa adalah senjata terbesar umat manusia. –Abu Hamid al-Ghazali"
    },
    "2024-09-09": {
        "content": "Satu-satunya batasan untuk meraih mimpi kita adalah keragu-raguan kita akan hari ini. Marilah kita maju dengan keyakinan yang aktif dan kuat –Franklin Roosevelt"
    },
    "2024-09-10": {
        "content": "Sebarkan cinta ke mana pun kamu pergi. Jangan biarkan orang lain mendatangimu tanpa mendapatkan hal yang lebih bahagia. –Bunda Teresa"
    },
    "2024-09-11": {
        "content": "Siapapun yang bahagia akan membuat orang lain juga bahagia. –Anne Frank"
    },
    "2024-09-12": {
        "content": "Banyak orang gagal dalam kehidupan, bukan karena kurangnya kemampuan, pengetahuan, atau keberanian, namun hanya karena mereka tidak pernah mengatur energinya pada sasaran –Elbert Hubbard"
    },
    "2024-09-13": {
        "content": "Orang yang memiliki sasaran akan menjadi sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2024-09-14": {
        "content": "Kesuksesan bersumber dari perbuatan. Orang yang sukses terus melakukan usaha. Orang sukses bahkan membuat kesalahan, namun mereka tidak berhenti usaha –Cobrad Hilton"
    },
    "2024-09-15": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2024-09-16": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2024-09-17": {
        "content": "Berjuang untuk sukses tanpa kerja keras seperti mencoba memanen ketika kamu belum menanam –David Bly"
    },
    "2024-09-18": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2024-09-19": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2024-09-20": {
        "content": "Jangan menilai setiap hari dengan panen yang kamu tuai, tetapi dengan benih yang kamu tanam. –Robert Louis Stevenson"
    },
    "2024-09-21": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2024-09-22": {
        "content": "Cara untuk memulai adalah dengan berhenti berbicara dan mulai melakukan. -Walt Disney"
    },
    "2024-09-23": {
        "content": "Gravitasi tidak bertanggung-jawab atas orang yang jatuh cinta –Albert Einstein"
    },
    "2024-09-24": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2024-09-25": {
        "content": "Hidup yang baik adalah yang terinspirasi dari cinta dan dipandu oleh ilmu pengetahuan. –Bertrand Russell."
    },
    "2024-09-26": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2024-09-27": {
        "content": "Kebenaran adalah cahaya yang menghilangkan kegelapan. –al-Ghazali"
    },
    "2024-09-28": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2024-09-29": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2024-09-30": {
        "content": "Jika kamu berpikir kamu terlalu kecil untuk membuat sebuah perubahan, cobalah tidur di ruangan dengan seekor nyamuk. -Dalai Lama"
    },
    "2024-10-01": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2024-10-02": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2024-10-03": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2024-10-04": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2024-10-05": {
        "content": "Bangun dan wujudkan mimpimu atau orang lain akan memperkerjakanmu untuk membangun mimpi mereka –Farrah Gray"
    },
    "2024-10-06": {
        "content": "Cara untuk memulai adalah dengan berhenti berbicara dan mulai melakukan. -Walt Disney"
    },
    "2024-10-07": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2024-10-08": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2024-10-09": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2024-10-10": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2024-10-11": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2024-10-12": {
        "content": "Jangan menilai setiap hari dengan panen yang kamu tuai, tetapi dengan benih yang kamu tanam. –Robert Louis Stevenson"
    },
    "2024-10-13": {
        "content": "Cara paling mendasar dan kuat untuk terhubung dengan orang lain adalah dengan mendengarkan. Cukup Dengarkan. Mungkin hal terpenting yang bisa kita berikan kepada orang lain adalah perhatian kita –Rachel Naomi Remen"
    },
    "2024-10-14": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2024-10-15": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2024-10-16": {
        "content": "Cinta itu layaknya angin, aku tidak bisa melihatnya tetapi aku bisa merasakannya. –Nicholas Sparck"
    },
    "2024-10-17": {
        "content": "Kesuksesan biasanya datang pada mereka yang terlalu sibuk untuk mencarinya. -Henry David Thoreau"
    },
    "2024-10-18": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2024-10-19": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2024-10-20": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2024-10-21": {
        "content": "Kekuatan dan perkembangan datang hanya dari usaha dan perjuangan yang terus menerus. –Napoleon Hill"
    },
    "2024-10-22": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2024-10-23": {
        "content": "Menjadi diri sendiri di dunia yang terus-menerus berusaha menjadikan Anda orang lain adalah pencapaian terbesar. -Ralph Waldo Emerson"
    },
    "2024-10-24": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2024-10-25": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    },
    "2024-10-26": {
        "content": "Kebahagiaan kita tergantung kepada diri kita sendiri –Aristoteles."
    },
    "2024-10-27": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2024-10-28": {
        "content": "Jika Anda tidak mampu berpikir secara jernih, tidak Anda mempunyai hak untuk bertindak. –Martin Heidegger"
    },
    "2024-10-29": {
        "content": "Hubungan asmara itu seperti kaca. Terkadang lebih baik meninggalkannya dalam keadaan pecah. Daripada menyakiti dirimu dengan cara menyatukan mereka kembali. -D.Love"
    },
    "2024-10-30": {
        "content": "Jangan habiskan waktumu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. -Coco Canel"
    },
    "2024-10-31": {
        "content": "Orang yang meninggal memperoleh lebih banyak bunga dibandingkan orang yang masih hidup karena penyesalan lebih kuat dibandingkan rasa syukur –Anne Frank."
    },
    "2024-11-01": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    },
    "2024-11-02": {
        "content": "Ingatlah selalu bahwa kamu benar-benar unik. Sama seperti orang lain. –Margaret Mead"
    },
    "2024-11-03": {
        "content": "Keadilan adalah tanda kekuatan dan keberanian. –Ali bin Abi Thalib"
    },
    "2024-11-04": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2024-11-05": {
        "content": "Seseorang pernah bertanya kepadaku,Mengapa kau selalu bersikukuh mengambil jalan tersulit?” Aku menjawabnya,Mengapa kau menganggapku memilih dua jalan?” –John Fitzgerald Kennedy."
    },
    "2024-11-06": {
        "content": "Pencarian ilmu adalah ibadah yang paling utama. –Abu Yusuf al-Qadi"
    },
    "2024-11-07": {
        "content": "Cinta adalah kebenaran terbesar dan kebaikan tertinggi. –Plato"
    },
    "2024-11-08": {
        "content": "Orang yang hebat tidak dilahirkan begitu saja, tetapi mereka tumbuh menjadi lebih hebat –Mario Puzo."
    },
    "2024-11-09": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2024-11-10": {
        "content": "Orang paling kesepian memiliki kepribadian yang baik hati. Orang paling sedih memiliki senyum paling cerah. Orang paling rusak memiliki kebijaksanaan yang luas. Semua itu karena mereka tidak ingin orang lain menderita seperti mereka –Zarathustra."
    },
    "2024-11-11": {
        "content": "Cintai hidup yang kau jalani. Jalani hidup yang kau cintai. –Bob Marley"
    },
    "2024-11-12": {
        "content": "Kesempurnaan adalah hasil dari usaha dan keteguhan dalam mengejar kebaikan. –Ibn Taymiyyah"
    },
    "2024-11-13": {
        "content": "Saya tidak memikirkan semua penderitaan, tetapi keindahan yang masih tersisa. –Anne Frank"
    },
    "2024-11-14": {
        "content": "Semakin kau tahu tentang jati diri dan sesuatu yang kau inginkan, semakin sedikit pula kau membiarkan berbagai hal yang membuatmu kesal berlalu –Stephanie Perkins."
    },
    "2024-11-15": {
        "content": "Hidup adalah perjalanan spiritual menuju kebenaran mutlak. –Rumi"
    },
    "2024-11-16": {
        "content": "Pekerjaan-pekerjaan kecil yang selesai dilakukan, lebih baik daripada rencana-rencana besar yang hanya didiskusikan. -Peter Marshall"
    },
    "2024-11-17": {
        "content": "Kamu dapat menipu beberapa orang setiap saat dan semua orang pada suatu waktu, tetapi kamu tidak dapat membodohi semua orang setiap saat. -Abraham Lincol"
    },
    "2024-11-18": {
        "content": "Beri nilai dari usahanya jangan dari hasilnya. Baru kita bisa menilai kehidupan. -Albert Einstein"
    },
    "2024-11-19": {
        "content": "Sejauh apapun perpisahan, sesibuk apapun kita nanti, dan meski langkah kita berbeda, waktu tidak akan dapat memisahkan gelar 'sahabat' di antara kita –mnurulnatasha"
    },
    "2024-11-20": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. –John F. Kennedy"
    },
    "2024-11-21": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2024-11-22": {
        "content": "Yang membuatku terus berkembang adalah tujuan-tujuan hidupku. -Muhammad Ali"
    },
    "2024-11-23": {
        "content": "Anda ingin mengetahui siapa diri Anda? Jangan bertanya. Beraksilah! -Thomas Jefferson "
    },
    "2024-11-24": {
        "content": "Kita tidak hidup dari apa yang kita miliki, tetapi dari apa yang kita berikan. –Pablo Picasso"
    },
    "2024-11-25": {
        "content": "Keyakinan merupakan suatu pengetahuan di dalam hati, jauh tak terjangkau oleh bukti.–Kahlil Gibran, Pujangga"
    },
    "2024-11-26": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2024-11-27": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2024-11-28": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2024-11-29": {
        "content": "Ketika kita memahami diri kita sendiri, kita mendekati pemahaman tentang Tuhan. –Ibn Sina"
    },
    "2024-11-30": {
        "content": "Satu-satunya cara untuk mencapai yang tidak mungkin adalah percaya bahwa itu mungkin –Charles Kingsleigh"
    },
    "2024-12-01": {
        "content": "Anda mungkin bisa menunda, tapi waktu tidak akan menunggu. –Benjamin Franklin"
    },
    "2024-12-02": {
        "content": "Penemuan terbesar sepanjang masa adalah bahwa seseorang bisa mengubah masa depannya hanya dengan mengubah sikapnya saat ini. -Oprah Winfrey"
    },
    "2024-12-03": {
        "content": "Kau harus membiarkan orang lain untuk pergi. Setiap orang yang ada dalam kehidupanmu ditakdirkan untuk berada dalam perjalanan, tetapi tidak semuanya dimaksudkan untuk tinggal hingga akhir –Vasco da Gama."
    },
    "2024-12-04": {
        "content": "Kemuliaan terbesar dalam hidup bukan terletak pada tidak pernah jatuh, tetapi bangkit setiap kali kita jatuh. -Nelson Mandela"
    },
    "2024-12-05": {
        "content": "Satu-satunya tempat di mana kesuksesan datang sebelum bekerja adalah di kamus. -Vidal Sassoon"
    },
    "2024-12-06": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2024-12-07": {
        "content": "Dia yang mengetahui semua jawaban belum pernah memperoleh pertanyaan –Confucius."
    },
    "2024-12-08": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2024-12-09": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2024-12-10": {
        "content": "Kita harus belajar untuk hidup bersama sebagai saudara atau kita akan binasa bersama-sama sebagai orang bodoh. –Martin Luther King"
    },
    "2024-12-11": {
        "content": "Tidak apa-apa merayakan kesuksesan, tapi lebih penting untuk memperhatikan pelajaran tentang kegagalan.  –Bill Gates"
    },
    "2024-12-12": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2024-12-13": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2024-12-14": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2024-12-15": {
        "content": "Kebebasan adalah hak setiap individu. –John Locke"
    },
    "2024-12-16": {
        "content": "Kebijaksanaan sejati adalah mengenal diri sendiri. –Ali bin Abi Thalib"
    },
    "2024-12-17": {
        "content": "Kesabaran adalah kekuatan; kebitteran adalah kelemahan. –Immanuel Kant"
    },
    "2024-12-18": {
        "content": "Apa yang kita pikirkan menentukan apa yang akan terjadi pada kita. Jadi jika kita ingin mengubah hidup, kita perlu sedikit mengubah pikiran kita. –Wayne Dyer."
    },
    "2024-12-19": {
        "content": "Saya suka mereka yang bisa tersenyum dalam kesulitan. –Leonardo da Vinci"
    },
    "2024-12-20": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2024-12-21": {
        "content": "Kehidupan adalah pengorbanan untuk mencapai kedamaian batin. –Ibn Hazm"
    },
    "2024-12-22": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2024-12-23": {
        "content": "Kamu hanya gagal saat kamu berhenti mencoba –Albert Einstein"
    },
    "2024-12-24": {
        "content": "Hidup itu sendiri adalah dongeng yang paling indah. -Hans Christian Andersen"
    },
    "2024-12-25": {
        "content": "Tidak ada akhir untuk pendidikan. Bukan berarti Anda membaca buku, lulus ujian, dan menyelesaikan pendidikan. Seluruh kehidupan, dari saat Anda lahir hingga saat Anda mati, adalah proses pembelajaran. –Jiddu Krishnamurti"
    },
    "2024-12-26": {
        "content": "Hidup itu sendiri adalah dongeng yang paling indah. -Hans Christian Andersen"
    },
    "2024-12-27": {
        "content": "Cinta itu bukan hanya perasaan senang ketika bersamanya Cinta juga adalah komitmen untuk tetap bersamanya, ketika perasaan senang itu hilang –Merry Riana"
    },
    "2024-12-28": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2024-12-29": {
        "content": "Kau tidak pernah dilahirkan untuk hidup kalah, tertekan, bersalah, malu, terkutuk, dan tidak layak. Kau dilahirkan untuk menjadi seorang pemenang –Mikhail Sergeyevich Gorbachev."
    },
    "2024-12-30": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2024-12-31": {
        "content": "Bekerja keraslah dengan diam. Kesuksesan adalah suaramu –Frank Ocean."
    },
    "2025-01-01": {
        "content": "Kebebasan adalah hak setiap individu. –John Locke"
    },
    "2025-01-02": {
        "content": "Tetap menghadapkan wajah selalu ke arah sinar matahari, dan bayangan akan jatuh di belakangmu –Walt Whitman"
    },
    "2025-01-03": {
        "content": "Apa yang kita pikirkan menentukan apa yang akan terjadi pada kita. Jadi jika kita ingin mengubah hidup, kita perlu sedikit mengubah pikiran kita. –Wayne Dyer."
    },
    "2025-01-04": {
        "content": "Sebab sahabat itu saling tumbuh, bukan yang hilang ketika satunya jatuh –Boy Candra"
    },
    "2025-01-05": {
        "content": "Aku telah belajar jika ada lebih banyak kekuatan di dalam sebuah pelukan yang kuat dibandingkan dengan seribu kata-kata –Ann Hood."
    },
    "2025-01-06": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2025-01-07": {
        "content": "Jangan menilai setiap hari dengan panen yang kamu tuai, tetapi dengan benih yang kamu tanam. –Robert Louis Stevenson"
    },
    "2025-01-08": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2025-01-09": {
        "content": "Seseorang pernah bertanya kepadaku,Mengapa kau selalu bersikukuh mengambil jalan tersulit?” Aku menjawabnya,Mengapa kau menganggapku memilih dua jalan?” –John Fitzgerald Kennedy."
    },
    "2025-01-10": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2025-01-11": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan –Shakuntala Devi"
    },
    "2025-01-12": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2025-01-13": {
        "content": "Sukses bukanlah akhir, kegagalan bukanlah fatal, yang terpenting adalah keberanian untuk melanjutkan –Winston S. Churchill"
    },
    "2025-01-14": {
        "content": "Banyak dari kegagalan hidup adalah karena mereka tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. –Thomas A. Edison"
    },
    "2025-01-15": {
        "content": "Keselamatan adalah hasil akhir dari kesabaran. –Ibn Taymiyyah"
    },
    "2025-01-16": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. –Wayne Huizenga"
    },
    "2025-01-17": {
        "content": "Kebahagiaan dari hidupmu tergantung dari kualitas pikiranmu –Marcus Aurelius."
    },
    "2025-01-18": {
        "content": "Jadilah seperti bebek. Tenang di permukaan tapi selalu mengayuh seperti ayam di bawahnya. -Michael Caine"
    },
    "2025-01-19": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2025-01-20": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2025-01-21": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2025-01-22": {
        "content": "Hiduplah seolah-olah Anda akan mati besok. Belajarlah seolah Anda hidup selamanya. –Mahatma Gandhi"
    },
    "2025-01-23": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2025-01-24": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2025-01-25": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semuanya harus dirasakan dengan hati. –Helen Keller"
    },
    "2025-01-26": {
        "content": "Anda memiliki otak di kepala Anda. Anda memiliki kaki di sepatu Anda. Anda dapat mengarahkan diri Anda ke arah mana pun yang Anda pilih. -Dr. Seuss"
    },
    "2025-01-27": {
        "content": "Saya tidak bisa mengubah arah angin, namun saya bisa menyesuaikan pelayaran saya untuk selalu menggapai tujuan saya –Jimmy Dean"
    },
    "2025-01-28": {
        "content": "Anda mungkin bisa menunda, tapi waktu tidak akan menunggu. -Benjamin Franklin"
    },
    "2025-01-29": {
        "content": "Cinta bukan mengajar kita lemah, tetapi membangkitkan kekuatan Cinta bukan mengajar kita menghinakan diri, tetapi mengembuskan kegagahan Cinta bukan melemahkan semangat, tetapi membangkitkan semangat –Buya Hamka"
    },
    "2025-01-30": {
        "content": "Sahabat adalah keluarga yang Anda pilih –Jess C Scott"
    },
    "2025-01-31": {
        "content": "Perjalanan seribu mil dimulai dengan satu langkah. –Lao Tzu"
    },
    "2025-02-01": {
        "content": "Doa adalah senjata terbesar umat manusia. –Abu Hamid al-Ghazali"
    },
    "2025-02-02": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. –John F. Kennedy"
    },
    "2025-02-03": {
        "content": "Kemuliaan terbesar dalam hidup tidak terletak pada tidak pernah jatuh, tetapi dalam bangkit setiap kali kita jatuh. –Nelson Mandela"
    },
    "2025-02-04": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    },
    "2025-02-05": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2025-02-06": {
        "content": "Keadilan adalah tanda kekuatan dan keberanian. –Ali bin Abi Thalib"
    },
    "2025-02-07": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. -Maya Angelou"
    },
    "2025-02-08": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2025-02-09": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2025-02-10": {
        "content": "Kamu tidak selalu membutuhkan rencana. Terkadang kamu hanya perlu bernapas, percaya, melepaskan dan melihat apa yang terjadi –Mandy Hale"
    },
    "2025-02-11": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2025-02-12": {
        "content": "Kegigihan adalah kunci kesuksesan dalam pencapaian tujuan. –Abdul Qadir al-Jilani"
    },
    "2025-02-13": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2025-02-14": {
        "content": "Kita harus belajar untuk hidup bersama sebagai saudara atau kita akan binasa bersama-sama sebagai orang bodoh. –Martin Luther King"
    },
    "2025-02-15": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. –Maya Angelou"
    },
    "2025-02-16": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2025-02-17": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2025-02-18": {
        "content": "Siapapun yang bahagia akan membuat orang lain juga bahagia. –Anne Frank"
    },
    "2025-02-19": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2025-02-20": {
        "content": "Saya tidak bisa mengubah arah angin, namun saya bisa menyesuaikan pelayaran saya untuk selalu menggapai tujuan saya –Jimmy Dean"
    },
    "2025-02-21": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. –Zig Ziglar"
    },
    "2025-02-22": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2025-02-23": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2025-02-24": {
        "content": "Tiga hal dalam hidup –kesehatanmu, misimu dan orang yang kamu cintai. –Naval Ravikant"
    },
    "2025-02-25": {
        "content": "Tindakan manusia dapat dimodifikasi sampai batas tertentu, tetapi sifat manusia tidak dapat diubah. –Abraham Lincoln"
    },
    "2025-02-26": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2025-02-27": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2025-02-28": {
        "content": "Sulit untuk mengalahkan orang yang tidak pernah menyerah –Babe Ruth"
    },
    "2025-03-01": {
        "content": "Jika tindakanmu menginspirasi orang lain untuk bermimpi lebih banyak, belajar lebih banyak, berbuat lebih banyak, dan menjadi lebih sukses, kamu adalah seorang pemimpin –John Quincy Adams"
    },
    "2025-03-02": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2025-03-03": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2025-03-04": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2025-03-05": {
        "content": "Jauhi orang-orang yang mencoba meremehkan ambisimu. Pikiran kecil akan selalu melakukan itu, tetapi pikiran besar akan memberi perasaan bahwa kamu juga bisa menjadi hebat –Mark Twain"
    },
    "2025-03-06": {
        "content": "Kesuksesan biasanya datang pada mereka yang terlalu sibuk untuk mencarinya. -Henry David Thoreau"
    },
    "2025-03-07": {
        "content": "Rasa bahagia dan tak bahagia bukan berasal dari apa yang kamu miliki, bukan pula berasal dari siapa diri kamu, atau apa yang kamu kerjakan. Bahagia dan tak bahagia berasal dari pikiran kamu. –Dale Carnegie"
    },
    "2025-03-08": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2025-03-09": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2025-03-10": {
        "content": "Saya tidak memikirkan semua penderitaan, tetapi keindahan yang masih tersisa. –Anne Frank"
    },
    "2025-03-11": {
        "content": "Tujuan hidup adalah untuk hidup dengan bijaksana dan merenung. –Plato"
    },
    "2025-03-12": {
        "content": "Jika kamu benar-benar menginginkan sesuatu, jangan menunggu untuk itu –ajari dirimu untuk tidak sabar –Gurbaksh Chahal"
    },
    "2025-03-13": {
        "content": "Bagaimana kau mengeja 'cinta'? tanya Piglet.Kau tak usah mengejanya….rasakan saja. Jawab Pooh. -A.A Milne"
    },
    "2025-03-14": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2025-03-15": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2025-03-16": {
        "content": "Kita adalah apa yang kita pikirkan. –Marcus Aurelius"
    },
    "2025-03-17": {
        "content": "Kepanikan adalah separuh penyakit. Ketenangan adalah separuh obat, kesabaran adalah permulaan kesembuhan.–Ibnu Sina"
    },
    "2025-03-18": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2025-03-19": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2025-03-20": {
        "content": "Gagal itu makanan sehari-hari. Itu biasa, yang penting bagimana kamu menyikapinya. Evaluasi. Bangkit. Gagal lagi? Bangkit lagi!” –Chairul Tanjung"
    },
    "2025-03-21": {
        "content": "Ketika kita memahami diri kita sendiri, kita mendekati pemahaman tentang Tuhan. –Ibn Sina"
    },
    "2025-03-22": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2025-03-23": {
        "content": "Jangan biarkan rasa takut kalah lebih besar daripada kegembiraan saat menang –Robert Kiyosaki"
    },
    "2025-03-24": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2025-03-25": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2025-03-26": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2025-03-27": {
        "content": "Ketahuilah bahwa hidup ini adalah ujian yang sebenarnya. –Ibn Qayyim al-Jawziyya"
    },
    "2025-03-28": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2025-03-29": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2025-03-30": {
        "content": "Tindakan menyalahkan hanya akan membuang waktu. Sebesar apapun kesalahan yang kamu timpakan ke orang lain, dan sebesar apapun kamu menyalahkannya, hal tersebut tidak akan mengubahmu –Wayne Dyer"
    },
    "2025-03-31": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara. -Shah Rukh Khan"
    },
    "2025-04-01": {
        "content": "Pencarian ilmu adalah ibadah yang paling utama. –Abu Yusuf al-Qadi"
    },
    "2025-04-02": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2025-04-03": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2025-04-04": {
        "content": "Yang membuatku terus berkembang adalah tujuan-tujuan hidupku. -Muhammad Ali"
    },
    "2025-04-05": {
        "content": "Lebih baik mempunyai kehidupan yang bermakna dan memberikan perbedaan dibandingkan hanya mempunyai umur yang panjang –Bryant H. Mc.Gill."
    },
    "2025-04-06": {
        "content": "Gravitasi tidak bertanggung-jawab atas orang yang jatuh cinta –Albert Einstein"
    },
    "2025-04-07": {
        "content": "Jangan takut akan kesulitan, karena itu adalah kesempatan untuk tumbuh. –Albert Einstein"
    },
    "2025-04-08": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2025-04-09": {
        "content": "Satu-satunya tempat di mana kesuksesan datang sebelum bekerja adalah di kamus. -Vidal Sassoon"
    },
    "2025-04-10": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2025-04-11": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2025-04-12": {
        "content": "Berjuang sampai napas terakhir –William Shakespeare"
    },
    "2025-04-13": {
        "content": "Ketika dirimu tidak memperoleh solusi untuk mengatasi permasalahan, itu mungkin bukanlah masalah yang harus diatasi, melainkan kebenaran yang harus diterima –Mao Zedong."
    },
    "2025-04-14": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2025-04-15": {
        "content": "Kesempurnaan adalah hasil dari usaha dan keteguhan dalam mengejar kebaikan. –Ibn Taymiyyah"
    },
    "2025-04-16": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2025-04-17": {
        "content": "Hidup tanpa tujuan adalah seperti menelusuri lautan tanpa kompas. –Thomas Carlyle"
    },
    "2025-04-18": {
        "content": "Cintai hidup yang kau jalani. Jalani hidup yang kau cintai. –Bob Marley"
    },
    "2025-04-19": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2025-04-20": {
        "content": "Suatu ide yang berguna lebih berharga daripada kekayaan. –Socrates"
    },
    "2025-04-21": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    },
    "2025-04-22": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2025-04-23": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2025-04-24": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2025-04-25": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2025-04-26": {
        "content": "Kamu hanya gagal saat kamu berhenti mencoba –Albert Einstein"
    },
    "2025-04-27": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2025-04-28": {
        "content": "Kesempatan emas yang kau cari ada di dalam dirimu sendiri –Orison Sweet Marden."
    },
    "2025-04-29": {
        "content": "Jika kamu ingin menjalani hidup yang bahagia, ikatlah dengan tujuan, bukan pada orang atau benda. –Albert Einstein"
    },
    "2025-04-30": {
        "content": "Tujuan pendidikan itu untuk mempertajam kecerdasan, memperkukuh kemauan serta memperhalus perasaan. –Tan Malaka"
    },
    "2025-05-01": {
        "content": "Hanya mereka yang berani mengambil risiko melangkah terlalu jauh, yang mungkin bisa mengetahui seberapa jauh seseorang bisa melangkah. –TS Eliot"
    },
    "2025-05-02": {
        "content": "Bila Anda gagal hari ini, jangan pernah menyerah Ulangi terus kegagalan Anda sampai atasan/komandan Anda menyerah –Mario Teguh"
    },
    "2025-05-03": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2025-05-04": {
        "content": "Dia yang mengetahui semua jawaban belum pernah memperoleh pertanyaan –Confucius."
    },
    "2025-05-05": {
        "content": "Ingatlah selalu bahwa kamu benar-benar unik. Sama seperti orang lain. –Margaret Mead"
    },
    "2025-05-06": {
        "content": "Orang yang meninggal memperoleh lebih banyak bunga dibandingkan orang yang masih hidup karena penyesalan lebih kuat dibandingkan rasa syukur –Anne Frank."
    },
    "2025-05-07": {
        "content": "Berjuang untuk sukses tanpa kerja keras seperti mencoba memanen ketika kamu belum menanam –David Bly"
    },
    "2025-05-08": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2025-05-09": {
        "content": "Kebijaksanaan adalah lebih berharga daripada kekayaan. –Heraclitus"
    },
    "2025-05-10": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2025-05-11": {
        "content": "Keindahan persahabatan adalah bahwa kamu tahu kepada siapa kamu dapat mempercayakan rahasia –Alessandro Manzoni"
    },
    "2025-05-12": {
        "content": "Untuk sukses, sikap sama pentingnya dengan kemampuan. -Walter Scott"
    },
    "2025-05-13": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. –Maya Angelou"
    },
    "2025-05-14": {
        "content": "Menjadi diri sendiri di dunia yang terus-menerus berusaha menjadikan Anda orang lain adalah pencapaian terbesar. -Ralph Waldo Emerson"
    },
    "2025-05-15": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2025-05-16": {
        "content": "Rahasia kesuksesan adalah melakukan hal yang biasa dengan sangat baik. -John D. Rockefeller Jr."
    },
    "2025-05-17": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2025-05-18": {
        "content": "Jangan khawatir jika Anda tidak diakui, tetapi berusahalah untuk menjadi layak diakui. -Abraham Lincoln"
    },
    "2025-05-19": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2025-05-20": {
        "content": "Keyakinan merupakan suatu pengetahuan di dalam hati, jauh tak terjangkau oleh bukti. –Kahlil Gibran, Pujangga"
    },
    "2025-05-21": {
        "content": "Hidup adalah rangkaian pelajaran yang harus dijalani untuk dipahami. –Ralph Waldo Emerson"
    },
    "2025-05-22": {
        "content": "Dia, yang tidak cukup berani untuk mengambil risiko, tidak akan mencapai apa pun dalam hidup. –Muhammad Ali"
    },
    "2025-05-23": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2025-05-24": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2025-05-25": {
        "content": "Hidup itu sebentar. Kamu harus bisa tersenyum saat merasakan kepedihan atau kita tak akan pernah melanjutkan hidup.–Jeff Ross"
    },
    "2025-05-26": {
        "content": "Cinta adalah ketika kebahagiaan orang lain lebih penting dari kebahagiaanmu. -H. Jackson Brown"
    },
    "2025-05-27": {
        "content": "Seseorang tak akan pernah tahu betapa dalam kadar cintanya sampai terjadi sebuah perpisahan. -Kahlil Gibran"
    },
    "2025-05-28": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2025-05-29": {
        "content": "Hubungan asmara itu seperti kaca. Terkadang lebih baik meninggalkannya dalam keadaan pecah. Daripada menyakiti dirimu dengan cara menyatukan mereka kembali. -D.Love"
    },
    "2025-05-30": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2025-05-31": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2025-06-01": {
        "content": "Hidup itu sendiri adalah dongeng yang paling indah. -Hans Christian Andersen"
    },
    "2025-06-02": {
        "content": "Kegelapan tidak dapat mengusir kegelapan: hanya cahaya yang dapat melakukannya. Kebencian tidak dapat mengusir kebencian: hanya cinta yang dapat melakukannya. -Martin Luther King Jr."
    },
    "2025-06-03": {
        "content": "Kebahagiaan kita tergantung kepada diri kita sendiri –Aristoteles."
    },
    "2025-06-04": {
        "content": "Ketika dirimu tidak memperoleh solusi untuk mengatasi permasalahan, itu mungkin bukanlah masalah yang harus diatasi, melainkan kebenaran yang harus diterima –Mao Zedong."
    },
    "2025-06-05": {
        "content": "Semua mimpi kita bisa jadi kenyataan, jika kita memiliki keberanian untuk mengejarnya –Walt Disney"
    },
    "2025-06-06": {
        "content": "Anda mungkin bisa menunda, tapi waktu tidak akan menunggu. –Benjamin Franklin"
    },
    "2025-06-07": {
        "content": "Penemuan terbesar sepanjang masa adalah bahwa seseorang bisa mengubah masa depannya hanya dengan mengubah sikapnya saat ini. -Oprah Winfrey"
    },
    "2025-06-08": {
        "content": "Kau harus membiarkan orang lain untuk pergi. Setiap orang yang ada dalam kehidupanmu ditakdirkan untuk berada dalam perjalanan, tetapi tidak semuanya dimaksudkan untuk tinggal hingga akhir –Vasco da Gama."
    },
    "2025-06-09": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2025-06-10": {
        "content": "Jangan menunggu orang lain membahagiakanmu. Kebahagiaan apa pun yang Anda peroleh, harus Anda ciptakan sendiri. -Alice Walker"
    },
    "2025-06-11": {
        "content": "Semakin kau tahu tentang jati diri dan sesuatu yang kau inginkan, semakin sedikit pula kau membiarkan berbagai hal yang membuatmu kesal berlalu –Stephanie Perkins."
    },
    "2025-06-12": {
        "content": "Hal yang paling menyakitkan adalah kehilangan jati dirimu saat engkau terlalu mencintai seseorang. Serta lupa bahwa sebenarnya engkau juga spesial. -Ernest Hemingway"
    },
    "2025-06-13": {
        "content": "Jangan habiskan waktu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. –Coco Canel"
    },
    "2025-06-14": {
        "content": "Ingatlah bahwa kita hanya bisa hidup saat ini, dalam waktu yang sekarang. –Jean-Paul Sartre"
    },
    "2025-06-15": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2025-06-16": {
        "content": "Karena cinta, duri menjadi mawar. Karena cinta, cuka menjelma anggur segar. –Jalaluddin Rumi"
    },
    "2025-06-17": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2025-06-18": {
        "content": "Janganlah menganggap remeh hal-hal yang terdekat dengan hatimu. Rangkullah mereka seperti sama berharganya dengan hidupmu, karena tanpa mereka hidup adalah sia-sia –Peribahasa Cina"
    },
    "2025-06-19": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2025-06-20": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2025-06-21": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2025-06-22": {
        "content": "Jangan merusak sesuatu yang kau miliki dengan mengharapkan sesuatu yang tidak akan pernah kau miliki; ingatlah jika sesuatu yang kau miliki saat ini pernah menjadi salah satu hal yang kau harapkan –Epicurus."
    },
    "2025-06-23": {
        "content": "Memaafkan belum tentu membuat kita lebih baik atau bahkan merasa lebih baik tetapi yang jelas membuka jalan kebaikan.–Eleanor Roosevelt"
    },
    "2025-06-24": {
        "content": "Anda akan menghadapi banyak kekalahan dalam hidup, tetapi jangan pernah membiarkan diri Anda dikalahkan. -Maya Angelou"
    },
    "2025-06-25": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2025-06-26": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2025-06-27": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2025-06-28": {
        "content": "Kebahagiaan dirasakan oleh orang-orang yang dapat merasa puas kepada dirinya sendiri –Agatha Christie."
    },
    "2025-06-29": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2025-06-30": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2025-07-01": {
        "content": "Kamu menjadi apa yang kamu yakini. -Oprah Winfrey"
    },
    "2025-07-02": {
        "content": "Kesuksesan bersumber dari perbuatan. Orang yang sukses terus melakukan usaha. Orang sukses bahkan membuat kesalahan, namun mereka tidak berhenti usaha –Cobrad Hilton"
    },
    "2025-07-03": {
        "content": "Kesabaran adalah kekuatan; kebitteran adalah kelemahan. –Immanuel Kant"
    },
    "2025-07-04": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2025-07-05": {
        "content": "Anda ingin mengetahui siapa diri Anda? Jangan bertanya. Beraksilah! -Thomas Jefferson "
    },
    "2025-07-06": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2025-07-07": {
        "content": "Jika kamu melihat apa yang kamu miliki dalam hidup, kamu akan selalu memiliki lebih banyak. Jika kamu melihat apa yang tidak kamu miliki dalam hidup, kamu tidak akan pernah merasa cukup. –Oprah Winfrey"
    },
    "2025-07-08": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2025-07-09": {
        "content": "Cobalah untuk tidak menjadi orang yang sukses. Sebaliknya, jadilah orang yang bernilai. -Albert Einstein"
    },
    "2025-07-10": {
        "content": "Banyak orang gagal dalam kehidupan, bukan karena kurangnya kemampuan, pengetahuan, atau keberanian, namun hanya karena mereka tidak pernah mengatur energinya pada sasaran –Elbert Hubbard"
    },
    "2025-07-11": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2025-07-12": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2025-07-13": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2025-07-14": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2025-07-15": {
        "content": "Orang yang hebat tidak dilahirkan begitu saja, tetapi mereka tumbuh menjadi lebih hebat –Mario Puzo."
    },
    "2025-07-16": {
        "content": "Arahkan mata Anda pada bintang-bintang dengan kaki tetap berpijak pada tanah. -Theodore Roosevelt"
    },
    "2025-07-17": {
        "content": "Banyak dari kegagalan hidup adalah karena mereka tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. –Thomas A. Edison"
    },
    "2025-07-18": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2025-07-19": {
        "content": "Pada saat-saat tergelaplah kita harus fokus untuk melihat cahaya. -Aristoteles"
    },
    "2025-07-20": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2025-07-21": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2025-07-22": {
        "content": "Cara terbaik untuk menyiapkan kehidupan adalah memulai hidup –Elbert Hubbard."
    },
    "2025-07-23": {
        "content": "Kebijaksanaan bukanlah produk dari sekolah tetapi dari usaha seumur hidup untuk mendapatkannya. –Albert Einstein"
    },
    "2025-07-24": {
        "content": "Kau tidak pernah dilahirkan untuk hidup kalah, tertekan, bersalah, malu, terkutuk, dan tidak layak. Kau dilahirkan untuk menjadi seorang pemenang –Mikhail Sergeyevich Gorbachev."
    },
    "2025-07-25": {
        "content": "Satu-satunya cara untuk mencapai yang tidak mungkin adalah percaya bahwa itu mungkin –Charles Kingsleigh"
    },
    "2025-07-26": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2025-07-27": {
        "content": "Dunia ini adalah sebuah cermin bagi pikiran kita sendiri. –Baruch Spinoza"
    },
    "2025-07-28": {
        "content": " Orang yang memiliki sasaran sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2025-07-29": {
        "content": "Dalam hidup ini kita tidak bisa melakukan hal-hal besar. Kita hanya bisa melakukan hal-hal kecil dengan cinta yang besar. -Bunda Teresa"
    },
    "2025-07-30": {
        "content": "Keyakinan menciptakan fakta yang sebenarnya –William James"
    },
    "2025-07-31": {
        "content": "Cinta terjadi begitu singkat, namun melupakan memakan waktu begitu lama. -Pablo Neruda"
    },
    "2025-08-01": {
        "content": "Orang paling kesepian memiliki kepribadian yang baik hati. Orang paling sedih memiliki senyum paling cerah. Orang paling rusak memiliki kebijaksanaan yang luas. Semua itu karena mereka tidak ingin orang lain menderita seperti mereka –Zarathustra."
    },
    "2025-08-02": {
        "content": "Aku hanya ingin orang lain mengambil langkah mundur, mengambil napas yang dalam, dan benar-benar mengamati sesuatu dengan cara yang berbeda. Namun, mayoritas orang tidak akan pernah melakukannya –Brian Mc.Knight."
    },
    "2025-08-03": {
        "content": "Saya suka mereka yang bisa tersenyum dalam kesulitan. –Leonardo da Vinci"
    },
    "2025-08-04": {
        "content": "Diam adalah sumber dari kekuatan yang luar biasa. -Lao Tzu"
    },
    "2025-08-05": {
        "content": "Tidak masalah seberapa lambat kau berjalan asalkan kau tidak berhenti. -Confucius"
    },
    "2025-08-06": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2025-08-07": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2025-08-08": {
        "content": "Cinta itu bukan hanya perasaan senang ketika bersamanya Cinta juga adalah komitmen untuk tetap bersamanya, ketika perasaan senang itu hilang –Merry Riana"
    },
    "2025-08-09": {
        "content": "Aku hanya ingin orang lain mengambil langkah mundur, mengambil napas yang dalam, dan benar-benar mengamati sesuatu dengan cara yang berbeda. Namun, mayoritas orang tidak akan pernah melakukannya –Brian Mc.Knight."
    },
    "2025-08-10": {
        "content": "Kebahagiaan berada di dalam. Hal itu tidak ada hubungannya dengan seberapa banyak tepuk tangan yang kau peroleh atau seberapa banyak orang yang menyanjungmu. Kebahagiaan datang saat kau percaya telah melaksanakan sesuatu yang benar-benar berharga –Martin Yan."
    },
    "2025-08-11": {
        "content": "Tiada awan di langit yang tetap selamanya. Tiada mungkin akan terus-menerus terang cuaca. Sehabis malam gelap gulita lahir pagi membawa keindahan. Kehidupan manusia serupa alam. –RA Kartini"
    },
    "2025-08-12": {
        "content": "Ubah lukamu menjadi kebijaksanaan. –Oprah Winfrey"
    },
    "2025-08-13": {
        "content": "Kekuatan dan perkembangan datang hanya dari usaha dan perjuangan yang terus menerus. –Napoleon Hill"
    },
    "2025-08-14": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2025-08-15": {
        "content": "Tidak apa-apa merayakan kesuksesan, tapi lebih penting untuk memperhatikan pelajaran tentang kegagalan.  –Bill Gates"
    },
    "2025-08-16": {
        "content": "Semuanya kelihatan tidak mungkin sampai segala sesuatu selesai. -Nelson Mandela"
    },
    "2025-08-17": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2025-08-18": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2025-08-19": {
        "content": "Harta yang paling berharga adalah hati yang bertakwa. –Umar bin Khattab"
    },
    "2025-08-20": {
        "content": "Jangan khawatir tentang kegagalan, khawatirkan tentang peluang yang kamu lewatkan ketika kamu bahkan tidak mencoba. –Jack Canfield"
    },
    "2025-08-21": {
        "content": "Sesuatu akan terlihat berkesan jika hal tersebut dapat bermakna dan penuh warna –Joshua Foer."
    },
    "2025-08-22": {
        "content": "Belajar tidak pernah melelahkan pikiran –Leonardo Da Vinci"
    },
    "2025-08-23": {
        "content": "Pikiran yang baik dan hati yang baik selalu merupakan kombinasi yang hebat –Nelson Mandela"
    },
    "2025-08-24": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2025-08-25": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2025-08-26": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2025-08-27": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2025-08-28": {
        "content": "Sebarkan cinta ke mana pun kamu pergi. Jangan biarkan orang lain mendatangimu tanpa mendapatkan hal yang lebih bahagia. –Bunda Teresa"
    },
    "2025-08-29": {
        "content": "Sebab sahabat itu saling tumbuh, bukan yang hilang ketika satunya jatuh –Boy Candra"
    },
    "2025-08-30": {
        "content": "Kamu dapat menipu beberapa orang setiap saat dan semua orang pada suatu waktu, tetapi kamu tidak dapat membodohi semua orang setiap saat. -Abraham Lincol"
    },
    "2025-08-31": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2025-09-01": {
        "content": "Tuntutlah ilmu, tapi tidak melupakan ibadah. Kerjakanlah ibadah tapi tidak boleh lupa pada ilmu. –Hassan Al Bashri"
    },
    "2025-09-02": {
        "content": "Cara untuk memulai adalah dengan berhenti berbicara dan mulai melakukan. -Walt Disney"
    },
    "2025-09-03": {
        "content": "Cara paling mendasar dan kuat untuk terhubung dengan orang lain adalah dengan mendengarkan. Cukup Dengarkan. Mungkin hal terpenting yang bisa kita berikan kepada orang lain adalah perhatian kita –Rachel Naomi Remen"
    },
    "2025-09-04": {
        "content": "Cinta tidak terlihat dengan mata, tetapi dengan hati.–William Shakespeare"
    },
    "2025-09-05": {
        "content": "Sebelum apa pun, persiapan adalah kunci menuju kesuksesan. -Alexander Graham Bell"
    },
    "2025-09-06": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2025-09-07": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2025-09-08": {
        "content": "Cinta tak berupa tatapan satu sama lain, tetapi memandang keluar bersama ke arah yang sama. –B.J. Habibie"
    },
    "2025-09-09": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2025-09-10": {
        "content": "Pengetahuan tidak memiliki nilai kecuali jika dipraktekkan. –Thomas Aquinas"
    },
    "2025-09-11": {
        "content": "Tidak ada kata terlambat untuk menjadi dirimu yang seharusnya. –George Eliot"
    },
    "2025-09-12": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2025-09-13": {
        "content": "Jadilah diri Anda sendiri; semua orang sudah menjadi orang lain. -Oscar Wilde"
    },
    "2025-09-14": {
        "content": "Ketika kamu mengubah pikiran, ingatlah untuk juga mengubah duniamu juga —Norman Vincent Peale"
    },
    "2025-09-15": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2025-09-16": {
        "content": "Kedamaian hilang karena kita lupa jika sebenarnya memiliki satu sama lain –Bunda Maria Teresa Bojaxhiu."
    },
    "2025-09-17": {
        "content": "Cinta itu seperti halnya angin. Kita tidak dapat melihatnya, tetapi dapat merasakannya –Nicholas Sparks."
    },
    "2025-09-18": {
        "content": "Saya telah gagal berkali-kali dalam hidup. Dan itulah mengapa saya berhasil. –Michael Jordan"
    },
    "2025-09-19": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2025-09-20": {
        "content": "Pekerjaan-pekerjaan kecil yang selesai dilakukan, lebih baik daripada rencana-rencana besar yang hanya didiskusikan. -Peter Marshall"
    },
    "2025-09-21": {
        "content": "Kita memahami dunia tidak sebagaimana ia adalah, tetapi sebagaimana kita. –Immanuel Kant"
    },
    "2025-09-22": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2025-09-23": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2025-09-24": {
        "content": "Jangan tinggalkan apa pun untuk hari esok yang bisa dilakukan hari ini. -Abraham Lincoln"
    },
    "2025-09-25": {
        "content": "Jika kamu berpikir kamu terlalu kecil untuk membuat sebuah perubahan, cobalah tidur di ruangan dengan seekor nyamuk. -Dalai Lama"
    },
    "2025-09-26": {
        "content": "Kesuksesan bukanlah hal yang final; kegagalan bukanlah hal yang fatal: Yang terpenting adalah keberanian untuk terus maju. -Winston S. Churchill"
    },
    "2025-09-27": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2025-09-28": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2025-09-29": {
        "content": "Hidup yang baik adalah yang terinspirasi dari cinta dan dipandu oleh ilmu pengetahuan. –Bertrand Russell."
    },
    "2025-09-30": {
        "content": "Beri nilai dari usahanya jangan dari hasilnya. Baru kita bisa menilai kehidupan. -Albert Einstein"
    },
    "2025-10-01": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2025-10-02": {
        "content": "Mimpi adalah jendela ke dalam alam bawah sadar. –Sigmund Freud"
    },
    "2025-10-03": {
        "content": "Kita tidak hidup dari apa yang kita miliki, tetapi dari apa yang kita berikan. –Pablo Picasso"
    },
    "2025-10-04": {
        "content": "Cinta selalu saja misterius Jangan diburu-buru, atau kau akan merusak jalan ceritanya sendiri –Tere Liye"
    },
    "2025-10-05": {
        "content": "Hidup merupakan suatu perjalanan yang dapat dijadikan pengalaman, bukan sekadar masalah yang harus diselesaikan –C.S. Lewis."
    },
    "2025-10-06": {
        "content": "Kabar buruknya adalah waktu berlalu begitu saja. Kabar baiknya adalah kamu adalah pilotnya. —Michael Altshuler"
    },
    "2025-10-07": {
        "content": "Seseorang pernah bertanya kepadaku,Mengapa kau selalu bersikukuh mengambil jalan tersulit?” Aku menjawabnya,Mengapa kau menganggapku memilih dua jalan?” –John Fitzgerald Kennedy."
    },
    "2025-10-08": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2025-10-09": {
        "content": "Kebanggaan kita yang terbesar adalah bukan tidak pernah gagal, tetapi bangkit kembali setiap kali kita jatuh. –Confusius"
    },
    "2025-10-10": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2025-10-11": {
        "content": "Kamu tidak bisa kembali dan mengubah awal saat kamu memulainya, tapi kamu bisa memulainya lagi dari di mana kamu berada sekarang dan ubah akhirnya. -C.S Lewis"
    },
    "2025-10-12": {
        "content": "Aku menginginkanmu seutuhnya, selamanya, kamu dan aku, setiap hari. –The Notebook, Nicholas Sparks"
    },
    "2025-10-13": {
        "content": "Lakukanlah sesuatu hari ini yang akan membuatmu berterima kasih kepada orang lain di masa depan nanti –Sean Patrick."
    },
    "2025-10-14": {
        "content": "Hidup itu sendiri adalah dongeng yang paling indah. -Hans Christian Andersen"
    },
    "2025-10-15": {
        "content": "Seseorang yang benar-benar hebat merupakan orang yang membuat tiap orang merasa hebat –G.K. Chesterton."
    },
    "2025-10-16": {
        "content": "Dunia itu seluas langkah kaki. Jelajahilah dan jangan pernah takut melangkah. Hanya dengan itu kita bisa mengerti kehidupan dan menyatu dengannya.–Soe Hok Gie"
    },
    "2025-10-17": {
        "content": "Tidak ada akhir untuk pendidikan. Bukan berarti Anda membaca buku, lulus ujian, dan menyelesaikan pendidikan. Seluruh kehidupan, dari saat Anda lahir hingga saat Anda mati, adalah proses pembelajaran. –Jiddu Krishnamurti"
    },
    "2025-10-18": {
        "content": "Aku tidak takut badai karena telah belajar berlayar dengan kapalku –Louisa May Alcott."
    },
    "2025-10-19": {
        "content": "Jika Anda tidak mampu berpikir secara jernih, tidak Anda mempunyai hak untuk bertindak. –Martin Heidegger"
    },
    "2025-10-20": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2025-10-21": {
        "content": "Kejujuran adalah batu penjuru dari segala kesuksesan. Pengakuan adalah motivasi terkuat. Bahkan kritik dapat membangun rasa percaya diri saat 'disisipkan' di antara pujian. –May Kay Ash"
    },
    "2025-10-22": {
        "content": "Bukan gunung di depan untuk didaki yang membuatmu lelah, melainkan kerikil di sepatumu. –Muhammad Ali"
    },
    "2025-10-23": {
        "content": "Kebijaksanaan adalah lebih berharga daripada kekayaan. –Heraclitus"
    },
    "2025-10-24": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2025-10-25": {
        "content": "Banyak kegagalan dalam hidup adalah orang-orang yang tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. -Thomas A. Edison"
    },
    "2025-10-26": {
        "content": "Orang bijak belajar ketika mereka bisa. Orang bodoh belajar ketika mereka dipaksa. -Arthur Wellesley"
    },
    "2025-10-27": {
        "content": "Hadiah terbesar dalam hidup ini adalah persahabatan, dan aku telah mendapatkannya –Hubert H Humphrey"
    },
    "2025-10-28": {
        "content": "Hal yang paling menyakitkan adalah kehilangan jati dirimu saat engkau terlalu mencintai seseorang. Serta lupa bahwa sebenarnya engkau juga spesial. -Ernest Hemingway"
    },
    "2025-10-29": {
        "content": "Anda hanya hidup sekali, tetapi jika Anda melakukannya dengan benar, sekali saja sudah cukup. -Mae West"
    },
    "2025-10-30": {
        "content": "Bangun dan wujudkan mimpimu atau orang lain akan memperkerjakanmu untuk membangun mimpi mereka –Farrah Gray"
    },
    "2025-10-31": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2025-11-01": {
        "content": "Semakin tinggi ilmu seseorang, maka semakin tinggi toleransinya. –Gus Dur"
    },
    "2025-11-02": {
        "content": "Aku memilih untuk membuat sisa hidupku menjadi yang terbaik dalam hidupku. -Louise Hay"
    },
    "2025-11-03": {
        "content": "Ini adalah agamaku yang sederhana. Tak perlu ada kuil; tak perlu filosofi yang rumit. Otak kita sendiri, hati kita sendiri adalah kuil kita; filosofinya adalah kebaikan –Dalai Lama."
    },
    "2025-11-04": {
        "content": "Satu-satunya batasan untuk meraih mimpi kita adalah keragu-raguan kita akan hari ini. Marilah kita maju dengan keyakinan yang aktif dan kuat –Franklin Roosevelt"
    },
    "2025-11-05": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2025-11-06": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2025-11-07": {
        "content": "Pikirkanlah sebelum berbicara, karena perkataan memiliki kekuatan yang besar. –Ali bin Abi Thalib"
    },
    "2025-11-08": {
        "content": "Belajarlah seolah-olah kamu akan hidup selamanya, hiduplah seolah-olah kamu akan mati besok. –Mahatma Gandhi"
    },
    "2025-11-09": {
        "content": "​Sukses adalah jumlah dari usaha-usaha kecil, berulang-ulang hari demi hari –Robert Collier"
    },
    "2025-11-10": {
        "content": "Saya suka mereka yang bisa tersenyum dalam kesulitan. –Leonardo da Vinci"
    },
    "2025-11-11": {
        "content": "Anda tidak dapat menjelekkan tanah di mana Anda berdiri. –Arthur Schopenhauer"
    },
    "2025-11-12": {
        "content": "Kebijaksanaan sejati adalah mengenal diri sendiri. –Ali bin Abi Thalib"
    },
    "2025-11-13": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semuanya harus dirasakan dengan hati. –Helen Keller"
    },
    "2025-11-14": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2025-11-15": {
        "content": " Hidup memiliki semua tikungan dan belokan itu. Kamu harus berpegangan erat-erat dan pergilah. –Nicole Kidman"
    },
    "2025-11-16": {
        "content": "Hidup adalah perjalanan spiritual menuju kebenaran mutlak. –Rumi"
    },
    "2025-11-17": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2025-11-18": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2025-11-19": {
        "content": "Hadapkan wajahmu selalu ke arah matahari, sehingga bayangan akan jatuh di belakangmu. -Walt Whitman"
    },
    "2025-11-20": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2025-11-21": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2025-11-22": {
        "content": "Ketika kita memahami diri kita sendiri, kita mendekati pemahaman tentang Tuhan. –Ibn Sina"
    },
    "2025-11-23": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2025-11-24": {
        "content": "Orang yang memiliki sasaran akan menjadi sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2025-11-25": {
        "content": "Cinta itu layaknya angin, aku tidak bisa melihatnya tetapi aku bisa merasakannya. –Nicholas Sparck"
    },
    "2025-11-26": {
        "content": "Jangan katakan tidak punya cukup waktu. Anda memiliki jumlah jam yang persis sama per hari yang diberikan kepada Helen Keller, Pasteur, Michelangelo, Mother Teresa, Leonardo da Vinci, Thomas Jefferson, dan Albert Einstein. –H. Jackson Brown Jr"
    },
    "2025-11-27": {
        "content": "Tujuan hidup kita adalah untuk menjadi bahagia. -Dalai Lama"
    },
    "2025-11-28": {
        "content": "Kemuliaan terbesar dalam hidup bukan terletak pada tidak pernah jatuh, tetapi bangkit setiap kali kita jatuh. -Nelson Mandela"
    },
    "2025-11-29": {
        "content": "Jangan pernah bermimpi untuk sukses, tapi kerjakan sesuatu untuk meraih kesuksesan –Ester Lauder"
    },
    "2025-11-30": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2025-12-01": {
        "content": "Cinta adalah kebenaran terbesar dan kebaikan tertinggi. –Plato"
    },
    "2025-12-02": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. -Zig Ziglar"
    },
    "2025-12-03": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan. -Shakuntala Devi"
    },
    "2025-12-04": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2025-12-05": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2025-12-06": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2025-12-07": {
        "content": "Cinta yang tak dewasa: 'Aku mencintaimu karena aku membutuhkanmu' Cinta yang dewasa: 'Aku membutuhkanmu karena aku mencintaimu' –Erich Fromm"
    },
    "2025-12-08": {
        "content": "Suatu pekerjaan yang paling tak kunjung bisa diselesaikan adalah pekerjaan yang tak kunjung pernah dimulai. –JRR Tolkien"
    },
    "2025-12-09": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2025-12-10": {
        "content": "Hidup adalah yang terjadi saat kamu sibuk membuat rencana lain. –John Lennon"
    },
    "2025-12-11": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2025-12-12": {
        "content": "Jalan menuju sukses dan jalan menuju kegagalan hampir persis sama –Colin R. Davis"
    },
    "2025-12-13": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2025-12-14": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2025-12-15": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2025-12-16": {
        "content": "Ketika Anda jatuh cinta, kebahagiaan akan membuat Anda sulit tertidur karena kenyataan lebih baik dibandingkan mimpi Anda –Dr Seuss"
    },
    "2025-12-17": {
        "content": "Kehidupan adalah pengorbanan untuk mencapai kedamaian batin. –Ibn Hazm"
    },
    "2025-12-18": {
        "content": "Kamu bisa menjadi segalanya. Kamu bisa menjadi orang yang tidak terbatas jumlahnya. ” –Kesha"
    },
    "2025-12-19": {
        "content": "Doa adalah senjata terbesar umat manusia. –Abu Hamid al-Ghazali"
    },
    "2025-12-20": {
        "content": "Pekerjaan-pekerjaan kecil yang selesai dilakukan, lebih baik daripada rencana-rencana besar yang hanya didiskusikan. -Peter Marshall"
    },
    "2025-12-21": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2025-12-22": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2025-12-23": {
        "content": "Orang yang hebat tidak dilahirkan begitu saja, tetapi mereka tumbuh menjadi lebih hebat –Mario Puzo."
    },
    "2025-12-24": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2025-12-25": {
        "content": "Sejauh apapun perpisahan, sesibuk apapun kita nanti, dan meski langkah kita berbeda, waktu tidak akan dapat memisahkan gelar 'sahabat' di antara kita –mnurulnatasha"
    },
    "2025-12-26": {
        "content": "Jangan habiskan waktumu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. -Coco Canel"
    },
    "2025-12-27": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2025-12-28": {
        "content": "Percayalah, jika dia memang cinta sejati kau, mau semenyakitkan apa pun, mau seberapa sulit liku yang harus dilalui, dia tetap akan bersama kau kelak, suatu saat nanti. –Tere Liye"
    },
    "2025-12-29": {
        "content": "Ketika kesulitan datang, ingatlah bahwa Allah selalu bersamamu. –Jalal ad-Din Rumi"
    },
    "2025-12-30": {
        "content": "Kebenaran adalah cahaya yang menghilangkan kegelapan. –al-Ghazali"
    },
    "2025-12-31": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2026-01-01": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2026-01-02": {
        "content": "Cinta itu seperti halnya angin. Kita tidak dapat melihatnya, tetapi dapat merasakannya –Nicholas Sparks."
    },
    "2026-01-03": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2026-01-04": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2026-01-05": {
        "content": "Aku memilih untuk membuat sisa hidupku menjadi yang terbaik dalam hidupku. -Louise Hay"
    },
    "2026-01-06": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2026-01-07": {
        "content": "Kau harus membiarkan orang lain untuk pergi. Setiap orang yang ada dalam kehidupanmu ditakdirkan untuk berada dalam perjalanan, tetapi tidak semuanya dimaksudkan untuk tinggal hingga akhir –Vasco da Gama."
    },
    "2026-01-08": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2026-01-09": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2026-01-10": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2026-01-11": {
        "content": "Pekerjaan-pekerjaan kecil yang selesai dilakukan, lebih baik daripada rencana-rencana besar yang hanya didiskusikan. -Peter Marshall"
    },
    "2026-01-12": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2026-01-13": {
        "content": "Kita adalah apa yang kita pikirkan. –Marcus Aurelius"
    },
    "2026-01-14": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2026-01-15": {
        "content": "Cara untuk memulai adalah dengan berhenti berbicara dan mulai melakukan. -Walt Disney"
    },
    "2026-01-16": {
        "content": "Kebijaksanaan adalah lebih berharga daripada kekayaan. –Heraclitus"
    },
    "2026-01-17": {
        "content": "Orang yang hebat tidak dilahirkan begitu saja, tetapi mereka tumbuh menjadi lebih hebat –Mario Puzo."
    },
    "2026-01-18": {
        "content": "Hidup yang baik adalah yang terinspirasi dari cinta dan dipandu oleh ilmu pengetahuan. –Bertrand Russell."
    },
    "2026-01-19": {
        "content": "Percayalah, jika dia memang cinta sejati kau, mau semenyakitkan apa pun, mau seberapa sulit liku yang harus dilalui, dia tetap akan bersama kau kelak, suatu saat nanti. –Tere Liye"
    },
    "2026-01-20": {
        "content": "Kejujuran adalah batu penjuru dari segala kesuksesan. Pengakuan adalah motivasi terkuat. Bahkan kritik dapat membangun rasa percaya diri saat 'disisipkan' di antara pujian. –May Kay Ash"
    },
    "2026-01-21": {
        "content": "Pada saat-saat tergelaplah kita harus fokus untuk melihat cahaya. -Aristoteles"
    },
    "2026-01-22": {
        "content": "Kamu tidak selalu membutuhkan rencana. Terkadang kamu hanya perlu bernapas, percaya, melepaskan dan melihat apa yang terjadi –Mandy Hale"
    },
    "2026-01-23": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2026-01-24": {
        "content": "Aku hanya ingin orang lain mengambil langkah mundur, mengambil napas yang dalam, dan benar-benar mengamati sesuatu dengan cara yang berbeda. Namun, mayoritas orang tidak akan pernah melakukannya –Brian Mc.Knight."
    },
    "2026-01-25": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2026-01-26": {
        "content": "Jika Anda tidak mampu berpikir secara jernih, tidak Anda mempunyai hak untuk bertindak. –Martin Heidegger"
    },
    "2026-01-27": {
        "content": "Anda tidak dapat menjelekkan tanah di mana Anda berdiri. –Arthur Schopenhauer"
    },
    "2026-01-28": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2026-01-29": {
        "content": "Siapapun yang bahagia akan membuat orang lain juga bahagia. –Anne Frank"
    },
    "2026-01-30": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2026-01-31": {
        "content": "Saya tidak bisa mengubah arah angin, namun saya bisa menyesuaikan pelayaran saya untuk selalu menggapai tujuan saya –Jimmy Dean"
    },
    "2026-02-01": {
        "content": "Aku menginginkanmu seutuhnya, selamanya, kamu dan aku, setiap hari. –The Notebook, Nicholas Sparks"
    },
    "2026-02-02": {
        "content": "Ingatlah bahwa kita hanya bisa hidup saat ini, dalam waktu yang sekarang. –Jean-Paul Sartre"
    },
    "2026-02-03": {
        "content": "Pencarian ilmu adalah ibadah yang paling utama. –Abu Yusuf al-Qadi"
    },
    "2026-02-04": {
        "content": "Sukses bukanlah akhir, kegagalan bukanlah fatal, yang terpenting adalah keberanian untuk melanjutkan –Winston S. Churchill"
    },
    "2026-02-05": {
        "content": "Cinta yang tak dewasa: 'Aku mencintaimu karena aku membutuhkanmu' Cinta yang dewasa: 'Aku membutuhkanmu karena aku mencintaimu' –Erich Fromm"
    },
    "2026-02-06": {
        "content": "Bila Anda gagal hari ini, jangan pernah menyerah Ulangi terus kegagalan Anda sampai atasan/komandan Anda menyerah –Mario Teguh"
    },
    "2026-02-07": {
        "content": "Jika itu penting bagi Anda, Anda akan menemukan jalan. Jika tidak, Anda akan menemukan alasan. –Ryan Blair"
    },
    "2026-02-08": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. –Zig Ziglar"
    },
    "2026-02-09": {
        "content": "Kamu hanya gagal saat kamu berhenti mencoba –Albert Einstein"
    },
    "2026-02-10": {
        "content": "Ketika dirimu tidak memperoleh solusi untuk mengatasi permasalahan, itu mungkin bukanlah masalah yang harus diatasi, melainkan kebenaran yang harus diterima –Mao Zedong."
    },
    "2026-02-11": {
        "content": "Semua mimpi kita bisa jadi kenyataan, jika kita memiliki keberanian untuk mengejarnya –Walt Disney"
    },
    "2026-02-12": {
        "content": "Banyak orang gagal dalam kehidupan, bukan karena kurangnya kemampuan, pengetahuan, atau keberanian, namun hanya karena mereka tidak pernah mengatur energinya pada sasaran –Elbert Hubbard"
    },
    "2026-02-13": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2026-02-14": {
        "content": "Hiduplah seolah-olah Anda akan mati besok. Belajarlah seolah Anda hidup selamanya. –Mahatma Gandhi"
    },
    "2026-02-15": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2026-02-16": {
        "content": "Bukan gunung di depan untuk didaki yang membuatmu lelah, melainkan kerikil di sepatumu. –Muhammad Ali"
    },
    "2026-02-17": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2026-02-18": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2026-02-19": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2026-02-20": {
        "content": "Keraguan akan membunuh lebih banyak mimpi dibandingkan kegagalan –Francis Bacon."
    },
    "2026-02-21": {
        "content": "Ketika Anda jatuh cinta, kebahagiaan akan membuat Anda sulit tertidur karena kenyataan lebih baik dibandingkan mimpi Anda –Dr Seuss"
    },
    "2026-02-22": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2026-02-23": {
        "content": "Tujuan hidup kita adalah untuk menjadi bahagia. -Dalai Lama"
    },
    "2026-02-24": {
        "content": "Kita tidak hidup dari apa yang kita miliki, tetapi dari apa yang kita berikan. –Pablo Picasso"
    },
    "2026-02-25": {
        "content": "Hadapkan wajahmu selalu ke arah matahari, sehingga bayangan akan jatuh di belakangmu. -Walt Whitman"
    },
    "2026-02-26": {
        "content": "Banyak kegagalan dalam hidup adalah orang-orang yang tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. -Thomas A. Edison"
    },
    "2026-02-27": {
        "content": "Kepanikan adalah separuh penyakit. Ketenangan adalah separuh obat, kesabaran adalah permulaan kesembuhan.–Ibnu Sina"
    },
    "2026-02-28": {
        "content": "Kita harus belajar untuk hidup bersama sebagai saudara atau kita akan binasa bersama-sama sebagai orang bodoh. –Martin Luther King"
    },
    "2026-03-01": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2026-03-02": {
        "content": "Cinta tidak terlihat dengan mata, tetapi dengan hati.–William Shakespeare"
    },
    "2026-03-03": {
        "content": "Anda memiliki otak di kepala Anda. Anda memiliki kaki di sepatu Anda. Anda dapat mengarahkan diri Anda ke arah mana pun yang Anda pilih. -Dr. Seuss"
    },
    "2026-03-04": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2026-03-05": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2026-03-06": {
        "content": "Keselamatan adalah hasil akhir dari kesabaran. –Ibn Taymiyyah"
    },
    "2026-03-07": {
        "content": "Satu-satunya sumber dari pengertahuan adalah pengalaman. -Albert Einstein"
    },
    "2026-03-08": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2026-03-09": {
        "content": "Jika tindakanmu menginspirasi orang lain untuk bermimpi lebih banyak, belajar lebih banyak, berbuat lebih banyak, dan menjadi lebih sukses, kamu adalah seorang pemimpin –John Quincy Adams"
    },
    "2026-03-10": {
        "content": "Kamu tidak perlu menjadi luar biasa untuk memulai, tapi kamu harus memulai untuk menjadi luar biasa. -Zig Ziglar"
    },
    "2026-03-11": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2026-03-12": {
        "content": "Keyakinan merupakan suatu pengetahuan di dalam hati, jauh tak terjangkau oleh bukti.–Kahlil Gibran, Pujangga"
    },
    "2026-03-13": {
        "content": "Saya telah gagal berkali-kali dalam hidup. Dan itulah mengapa saya berhasil. –Michael Jordan"
    },
    "2026-03-14": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2026-03-15": {
        "content": "Kebijaksanaan bukanlah produk dari sekolah tetapi dari usaha seumur hidup untuk mendapatkannya. –Albert Einstein"
    },
    "2026-03-16": {
        "content": "Keindahan persahabatan adalah bahwa kamu tahu kepada siapa kamu dapat mempercayakan rahasia –Alessandro Manzoni"
    },
    "2026-03-17": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2026-03-18": {
        "content": "Aku tidak takut badai karena telah belajar berlayar dengan kapalku –Louisa May Alcott."
    },
    "2026-03-19": {
        "content": "Ketika kamu mengubah pikiran, ingatlah untuk juga mengubah duniamu juga —Norman Vincent Peale"
    },
    "2026-03-20": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2026-03-21": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2026-03-22": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2026-03-23": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2026-03-24": {
        "content": "Sulit untuk mengalahkan orang yang tidak pernah menyerah –Babe Ruth"
    },
    "2026-03-25": {
        "content": "Sakit dalam perjuangan itu hanya sementara. Bisa jadi kamu rasakan dalam semenit, sejam, sehari, atau setahun. Namun jika menyerah, rasa sakit itu akan terasa selamanya. –Lance Armstrong"
    },
    "2026-03-26": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2026-03-27": {
        "content": "Hadiah terbesar dalam hidup ini adalah persahabatan, dan aku telah mendapatkannya –Hubert H Humphrey"
    },
    "2026-03-28": {
        "content": "Perjalanan seribu mil dimulai dengan satu langkah. –Lao Tzu"
    },
    "2026-03-29": {
        "content": "Jika kamu berpikir kamu terlalu kecil untuk membuat sebuah perubahan, cobalah tidur di ruangan dengan seekor nyamuk. -Dalai Lama"
    },
    "2026-03-30": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semuanya harus dirasakan dengan hati. –Helen Keller"
    },
    "2026-03-31": {
        "content": "Ubah lukamu menjadi kebijaksanaan. –Oprah Winfrey"
    },
    "2026-04-01": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2026-04-02": {
        "content": "Kekuatan dan perkembangan datang hanya dari usaha dan perjuangan yang terus menerus. –Napoleon Hill"
    },
    "2026-04-03": {
        "content": "Hitunglah umurmu dengan teman, bukan tahun. Hitunglah hidupmu dengan senyum, bukan air mata. -John Lennon"
    },
    "2026-04-04": {
        "content": "Hidup merupakan suatu perjalanan yang dapat dijadikan pengalaman, bukan sekadar masalah yang harus diselesaikan –C.S. Lewis."
    },
    "2026-04-05": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2026-04-06": {
        "content": "​Sukses adalah jumlah dari usaha-usaha kecil, berulang-ulang hari demi hari –Robert Collier"
    },
    "2026-04-07": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2026-04-08": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2026-04-09": {
        "content": "Jangan takut akan kesulitan, karena itu adalah kesempatan untuk tumbuh. –Albert Einstein"
    },
    "2026-04-10": {
        "content": "Hal yang paling menyakitkan adalah kehilangan jati dirimu saat engkau terlalu mencintai seseorang. Serta lupa bahwa sebenarnya engkau juga spesial. -Ernest Hemingway"
    },
    "2026-04-11": {
        "content": "Ambillah risiko yang lebih besar dari apa yang dipikirkan orang lain aman. Berilah perhatian lebih dari apa yang orang lain pikir bijak. Bermimpilah lebih dari apa yang orang lain pikir masuk akal –Claude T. Bissell"
    },
    "2026-04-12": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2026-04-13": {
        "content": "Mimpi adalah jendela ke dalam alam bawah sadar. –Sigmund Freud"
    },
    "2026-04-14": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2026-04-15": {
        "content": "Hidup adalah yang terjadi saat kamu sibuk membuat rencana lain. –John Lennon"
    },
    "2026-04-16": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2026-04-17": {
        "content": "Kebahagiaan dirasakan oleh orang-orang yang dapat merasa puas kepada dirinya sendiri –Agatha Christie."
    },
    "2026-04-18": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan. -Shakuntala Devi"
    },
    "2026-04-19": {
        "content": "Jadilah seperti bebek. Tenang di permukaan tapi selalu mengayuh seperti ayam di bawahnya. -Michael Caine"
    },
    "2026-04-20": {
        "content": "Lakukanlah sesuatu hari ini yang akan membuatmu berterima kasih kepada orang lain di masa depan nanti –Sean Patrick."
    },
    "2026-04-21": {
        "content": "Ini adalah agamaku yang sederhana. Tak perlu ada kuil; tak perlu filosofi yang rumit. Otak kita sendiri, hati kita sendiri adalah kuil kita; filosofinya adalah kebaikan –Dalai Lama."
    },
    "2026-04-22": {
        "content": "Tujuan hidup adalah untuk hidup dengan bijaksana dan merenung. –Plato"
    },
    "2026-04-23": {
        "content": "Hidup itu sendiri adalah dongeng yang paling indah. -Hans Christian Andersen"
    },
    "2026-04-24": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. -Maya Angelou"
    },
    "2026-04-25": {
        "content": "Kebahagiaan berada di dalam. Hal itu tidak ada hubungannya dengan seberapa banyak tepuk tangan yang kau peroleh atau seberapa banyak orang yang menyanjungmu. Kebahagiaan datang saat kau percaya telah melaksanakan sesuatu yang benar-benar berharga –Martin Yan."
    },
    "2026-04-26": {
        "content": "Janganlah pernah menyerah ketika kamu masih mampu berusaha lagi. Tidak ada kata berakhir sampai kamu berhenti mencoba –Brian Dyson"
    },
    "2026-04-27": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2026-04-28": {
        "content": "Satu-satunya batasan untuk meraih mimpi kita adalah keragu-raguan kita akan hari ini. Marilah kita maju dengan keyakinan yang aktif dan kuat –Franklin Roosevelt"
    },
    "2026-04-29": {
        "content": "Seseorang yang benar-benar hebat merupakan orang yang membuat tiap orang merasa hebat –G.K. Chesterton."
    },
    "2026-04-30": {
        "content": "Sesuatu akan terlihat berkesan jika hal tersebut dapat bermakna dan penuh warna –Joshua Foer."
    },
    "2026-05-01": {
        "content": "Hidup tanpa tujuan adalah seperti menelusuri lautan tanpa kompas. –Thomas Carlyle"
    },
    "2026-05-02": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2026-05-03": {
        "content": "Hanya mereka yang berani mengambil risiko melangkah terlalu jauh, yang mungkin bisa mengetahui seberapa jauh seseorang bisa melangkah. –TS Eliot"
    },
    "2026-05-04": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2026-05-05": {
        "content": "Belajar tidak pernah melelahkan pikiran –Leonardo Da Vinci"
    },
    "2026-05-06": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2026-05-07": {
        "content": "Cinta adalah ketika kebahagiaan orang lain lebih penting dari kebahagiaanmu. -H. Jackson Brown"
    },
    "2026-05-08": {
        "content": "Dalam hidup ini kita tidak bisa melakukan hal-hal besar. Kita hanya bisa melakukan hal-hal kecil dengan cinta yang besar. –Bunda Teresa"
    },
    "2026-05-09": {
        "content": "Pekerjaan-pekerjaan kecil yang selesai dilakukan, lebih baik daripada rencana-rencana besar yang hanya didiskusikan. -Peter Marshall"
    },
    "2026-05-10": {
        "content": "Keyakinan merupakan suatu pengetahuan di dalam hati, jauh tak terjangkau oleh bukti. –Kahlil Gibran, Pujangga"
    },
    "2026-05-11": {
        "content": "Kebahagiaan dari hidupmu tergantung dari kualitas pikiranmu –Marcus Aurelius."
    },
    "2026-05-12": {
        "content": "Kehidupan adalah pengorbanan untuk mencapai kedamaian batin. –Ibn Hazm"
    },
    "2026-05-13": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2026-05-14": {
        "content": "Seseorang tak akan pernah tahu betapa dalam kadar cintanya sampai terjadi sebuah perpisahan. -Kahlil Gibran"
    },
    "2026-05-15": {
        "content": "Tidak ada yang akan berhasil kecuali kau melakukannya. –Maya Angelou"
    },
    "2026-05-16": {
        "content": "Tetap menghadapkan wajah selalu ke arah sinar matahari, dan bayangan akan jatuh di belakangmu –Walt Whitman"
    },
    "2026-05-17": {
        "content": "Satu-satunya cara untuk mencapai yang tidak mungkin adalah percaya bahwa itu mungkin –Charles Kingsleigh"
    },
    "2026-05-18": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2026-05-19": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2026-05-20": {
        "content": "Semakin kau tahu tentang jati diri dan sesuatu yang kau inginkan, semakin sedikit pula kau membiarkan berbagai hal yang membuatmu kesal berlalu –Stephanie Perkins."
    },
    "2026-05-21": {
        "content": "Ingatlah selalu bahwa kamu benar-benar unik. Sama seperti orang lain. –Margaret Mead"
    },
    "2026-05-22": {
        "content": "Tidak masalah seberapa lambat kau berjalan asalkan kau tidak berhenti. -Confucius"
    },
    "2026-05-23": {
        "content": "Diam adalah sumber dari kekuatan yang luar biasa. -Lao Tzu"
    },
    "2026-05-24": {
        "content": "Jangan pernah bermimpi untuk sukses, tapi kerjakan sesuatu untuk meraih kesuksesan –Ester Lauder"
    },
    "2026-05-25": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. -Wayne Huizenga"
    },
    "2026-05-26": {
        "content": "Doa adalah senjata terbesar umat manusia. –Abu Hamid al-Ghazali"
    },
    "2026-05-27": {
        "content": "Jangan tinggalkan apa pun untuk hari esok yang bisa dilakukan hari ini. -Abraham Lincoln"
    },
    "2026-05-28": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. –John F. Kennedy"
    },
    "2026-05-29": {
        "content": "Cinta tak berupa tatapan satu sama lain, tetapi memandang keluar bersama ke arah yang sama. –B.J. Habibie"
    },
    "2026-05-30": {
        "content": "Berjuang untuk sukses tanpa kerja keras seperti mencoba memanen ketika kamu belum menanam –David Bly"
    },
    "2026-05-31": {
        "content": "Setiap ada kefokusan, di situlah akan ada energi yang akan mengalir –Tony Robbins."
    },
    "2026-06-01": {
        "content": "Pikirkanlah sebelum berbicara, karena perkataan memiliki kekuatan yang besar. –Ali bin Abi Thalib"
    },
    "2026-06-02": {
        "content": "Tidak ada yang tidak mungkin bagi mereka yang mau berusaha –Alexander yang Agung"
    },
    "2026-06-03": {
        "content": "Usaha dan keberanian tidak cukup tanpa tujuan dan arah perencanaan. -John F. Kennedy"
    },
    "2026-06-04": {
        "content": "Kesuksesan biasanya datang pada mereka yang terlalu sibuk untuk mencarinya. -Henry David Thoreau"
    },
    "2026-06-05": {
        "content": "Jika kamu ingin bahagia, tetapkan sasaran yang membangkitkan pikiran, membebaskan energi, dan menginspirasi harapanmu –Andrew Carnegie"
    },
    "2026-06-06": {
        "content": "Jika kamu ingin menjalani hidup yang bahagia, ikatlah dengan tujuan, bukan pada orang atau benda. –Albert Einstein"
    },
    "2026-06-07": {
        "content": "Jalan menuju sukses dan jalan menuju kegagalan hampir persis sama –Colin R. Davis"
    },
    "2026-06-08": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2026-06-09": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2026-06-10": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2026-06-11": {
        "content": "Orang yang meninggal memperoleh lebih banyak bunga dibandingkan orang yang masih hidup karena penyesalan lebih kuat dibandingkan rasa syukur –Anne Frank."
    },
    "2026-06-12": {
        "content": "Rahasia kesuksesan adalah melakukan hal yang biasa dengan sangat baik. -John D. Rockefeller Jr."
    },
    "2026-06-13": {
        "content": "Keyakinan menciptakan fakta yang sebenarnya –William James"
    },
    "2026-06-14": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2026-06-15": {
        "content": "Kita memahami dunia tidak sebagaimana ia adalah, tetapi sebagaimana kita. –Immanuel Kant"
    },
    "2026-06-16": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2026-06-17": {
        "content": "Yang membuatku terus berkembang adalah tujuan-tujuan hidupku. -Muhammad Ali"
    },
    "2026-06-18": {
        "content": "Ketika kita memahami diri kita sendiri, kita mendekati pemahaman tentang Tuhan. –Ibn Sina"
    },
    "2026-06-19": {
        "content": "Kamu dapat menipu beberapa orang setiap saat dan semua orang pada suatu waktu, tetapi kamu tidak dapat membodohi semua orang setiap saat. -Abraham Lincol"
    },
    "2026-06-20": {
        "content": "Hubungan asmara itu seperti kaca. Terkadang lebih baik meninggalkannya dalam keadaan pecah. Daripada menyakiti dirimu dengan cara menyatukan mereka kembali. -D.Love"
    },
    "2026-06-21": {
        "content": "Tindakan menyalahkan hanya akan membuang waktu. Sebesar apapun kesalahan yang kamu timpakan ke orang lain, dan sebesar apapun kamu menyalahkannya, hal tersebut tidak akan mengubahmu –Wayne Dyer"
    },
    "2026-06-22": {
        "content": "Tuntutlah ilmu, tapi tidak melupakan ibadah. Kerjakanlah ibadah tapi tidak boleh lupa pada ilmu. –Hassan Al Bashri"
    },
    "2026-06-23": {
        "content": "Kemuliaan terbesar dalam hidup tidak terletak pada tidak pernah jatuh, tetapi dalam bangkit setiap kali kita jatuh. –Nelson Mandela"
    },
    "2026-06-24": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2026-06-25": {
        "content": "Tidak apa-apa merayakan kesuksesan, tapi lebih penting untuk memperhatikan pelajaran tentang kegagalan.  –Bill Gates"
    },
    "2026-06-26": {
        "content": "Tidak ada hal apapun di dunia ini yang lebih berharga dari persahabatan sejati –Thomas Aquinas"
    },
    "2026-06-27": {
        "content": "Tindakan manusia dapat dimodifikasi sampai batas tertentu, tetapi sifat manusia tidak dapat diubah. –Abraham Lincoln"
    },
    "2026-06-28": {
        "content": "Tak ada yang terasa semengerikan dulu saat kau sudah punya teman sejati –Bill Watterson"
    },
    "2026-06-29": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2026-06-30": {
        "content": "Pendidikan adalah senjata paling ampuh untuk mengubah dunia. –Nelson Mandela"
    },
    "2026-07-01": {
        "content": "Bangun dan wujudkan mimpimu atau orang lain akan memperkerjakanmu untuk membangun mimpi mereka –Farrah Gray"
    },
    "2026-07-02": {
        "content": " Hidup memiliki semua tikungan dan belokan itu. Kamu harus berpegangan erat-erat dan pergilah. –Nicole Kidman"
    },
    "2026-07-03": {
        "content": "Jauhi orang-orang yang mencoba meremehkan ambisimu. Pikiran kecil akan selalu melakukan itu, tetapi pikiran besar akan memberi perasaan bahwa kamu juga bisa menjadi hebat –Mark Twain"
    },
    "2026-07-04": {
        "content": "Arahkan mata Anda pada bintang-bintang dengan kaki tetap berpijak pada tanah. -Theodore Roosevelt"
    },
    "2026-07-05": {
        "content": "Jika kamu melihat apa yang kamu miliki dalam hidup, kamu akan selalu memiliki lebih banyak. Jika kamu melihat apa yang tidak kamu miliki dalam hidup, kamu tidak akan pernah merasa cukup. –Oprah Winfrey"
    },
    "2026-07-06": {
        "content": "Cinta bukanlah bertahan seberapa lama. Tetapi seberapa jelas dan ke arah mana. –Emha Ainun Nadjib"
    },
    "2026-07-07": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2026-07-08": {
        "content": "Jika kamu benar-benar menginginkan sesuatu, jangan menunggu untuk itu –ajari dirimu untuk tidak sabar –Gurbaksh Chahal"
    },
    "2026-07-09": {
        "content": "Jangan menilai setiap hari dengan panen yang kamu tuai, tetapi dengan benih yang kamu tanam. –Robert Louis Stevenson"
    },
    "2026-07-10": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2026-07-11": {
        "content": "Cinta terjadi begitu singkat, namun melupakan memakan waktu begitu lama. -Pablo Neruda"
    },
    "2026-07-12": {
        "content": "Aku telah belajar jika ada lebih banyak kekuatan di dalam sebuah pelukan yang kuat dibandingkan dengan seribu kata-kata –Ann Hood."
    },
    "2026-07-13": {
        "content": "Dunia ini adalah sebuah cermin bagi pikiran kita sendiri. –Baruch Spinoza"
    },
    "2026-07-14": {
        "content": "Orang yang memiliki sasaran akan menjadi sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2026-07-15": {
        "content": "Doa adalah senjata terbesar umat manusia. –Abu Hamid al-Ghazali"
    },
    "2026-07-16": {
        "content": "Ketahuilah bahwa hidup ini adalah ujian yang sebenarnya. –Ibn Qayyim al-Jawziyya"
    },
    "2026-07-17": {
        "content": "Kesempatan kamu untuk sukses di setiap kondisi selalu dapat diukur oleh seberapa besar kepercayaan kamu pada diri sendiri.–Robert Collier"
    },
    "2026-07-18": {
        "content": "Bekerja keraslah dengan diam. Kesuksesan adalah suaramu –Frank Ocean."
    },
    "2026-07-19": {
        "content": "Hidup adalah perjalanan spiritual menuju kebenaran mutlak. –Rumi"
    },
    "2026-07-20": {
        "content": "Suatu pekerjaan yang paling tak kunjung bisa diselesaikan adalah pekerjaan yang tak kunjung pernah dimulai. –JRR Tolkien"
    },
    "2026-07-21": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2026-07-22": {
        "content": "Memaafkan belum tentu membuat kita lebih baik atau bahkan merasa lebih baik tetapi yang jelas membuka jalan kebaikan.–Eleanor Roosevelt"
    },
    "2026-07-23": {
        "content": "Yang membuatku terus berkembang adalah tujuan-tujuan hidupku. -Muhammad Ali"
    },
    "2026-07-24": {
        "content": "Kegigihan adalah kunci kesuksesan dalam pencapaian tujuan. –Abdul Qadir al-Jilani"
    },
    "2026-07-25": {
        "content": "Hidup adalah rangkaian pelajaran yang harus dijalani untuk dipahami. –Ralph Waldo Emerson"
    },
    "2026-07-26": {
        "content": "Cinta itu layaknya angin, aku tidak bisa melihatnya tetapi aku bisa merasakannya. –Nicholas Sparck"
    },
    "2026-07-27": {
        "content": "Dunia ini cukup untuk memenuhi kebutuhan manusia, bukan untuk memenuhi keserakahan manusia. -Mahatma Gandhi"
    },
    "2026-07-28": {
        "content": "Jangan merusak sesuatu yang kau miliki dengan mengharapkan sesuatu yang tidak akan pernah kau miliki; ingatlah jika sesuatu yang kau miliki saat ini pernah menjadi salah satu hal yang kau harapkan –Epicurus."
    },
    "2026-07-29": {
        "content": "Kesempatan emas yang kau cari ada di dalam dirimu sendiri –Orison Sweet Marden."
    },
    "2026-07-30": {
        "content": "Bagaimana kau mengeja 'cinta'? tanya Piglet.Kau tak usah mengejanya….rasakan saja. Jawab Pooh. -A.A Milne"
    },
    "2026-07-31": {
        "content": "Tidak ada akhir untuk pendidikan. Bukan berarti Anda membaca buku, lulus ujian, dan menyelesaikan pendidikan. Seluruh kehidupan, dari saat Anda lahir hingga saat Anda mati, adalah proses pembelajaran. –Jiddu Krishnamurti"
    },
    "2026-08-01": {
        "content": "Sejauh apapun perpisahan, sesibuk apapun kita nanti, dan meski langkah kita berbeda, waktu tidak akan dapat memisahkan gelar 'sahabat' di antara kita –mnurulnatasha"
    },
    "2026-08-02": {
        "content": "Sebab sahabat itu saling tumbuh, bukan yang hilang ketika satunya jatuh –Boy Candra"
    },
    "2026-08-03": {
        "content": "Kebijaksanaan sejati adalah mengenal diri sendiri. –Ali bin Abi Thalib"
    },
    "2026-08-04": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2026-08-05": {
        "content": "Cinta bukan melepas tapi merelakan Bukan memaksa tapi memperjuangkan Bukan menyerah tapi mengikhlaskan Bukan merantai tapi memberi sayap –Fiersa Besari"
    },
    "2026-08-06": {
        "content": "Sebelum apa pun, persiapan adalah kunci menuju kesuksesan. -Alexander Graham Bell"
    },
    "2026-08-07": {
        "content": "Sahabat adalah keluarga yang Anda pilih –Jess C Scott"
    },
    "2026-08-08": {
        "content": "Satu-satunya batasan untuk meraih mimpi kita adalah keragu-raguan kita akan hari ini. Marilah kita maju dengan keyakinan yang aktif dan kuat –Franklin Roosevelt"
    },
    "2026-08-09": {
        "content": "Gagal itu makanan sehari-hari. Itu biasa, yang penting bagimana kamu menyikapinya. Evaluasi. Bangkit. Gagal lagi? Bangkit lagi!” –Chairul Tanjung"
    },
    "2026-08-10": {
        "content": "Anda tidak bisa pergi dari tanggung jawab esok hari dengan menghindarinya hari ini. -Abraham Lincoln"
    },
    "2026-08-11": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2026-08-12": {
        "content": "Suatu ide yang berguna lebih berharga daripada kekayaan. –Socrates"
    },
    "2026-08-13": {
        "content": "Jika seseorang mengambil tanggung jawab tanpa paksaan, itulah cinta –Radhanath Swami."
    },
    "2026-08-14": {
        "content": "Jangan habiskan waktu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. –Coco Canel"
    },
    "2026-08-15": {
        "content": "Pengetahuan tidak memiliki nilai kecuali jika dipraktekkan. –Thomas Aquinas"
    },
    "2026-08-16": {
        "content": "Pendidikan bukan cuma pergi ke sekolah dan mendapatkan gelar. Tapi, juga soal memperluas pengetahuan dan menyerap ilmu kehidupan –Shakuntala Devi"
    },
    "2026-08-17": {
        "content": "Kesenangan dalam sebuah pekerjaan membuat kesempurnaan pada hasil yang dicapai. -Aristoteles"
    },
    "2026-08-18": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2026-08-19": {
        "content": "Jadilah diri Anda sendiri; semua orang sudah menjadi orang lain. -Oscar Wilde"
    },
    "2026-08-20": {
        "content": "Kebebasan adalah hak setiap individu. –John Locke"
    },
    "2026-08-21": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2026-08-22": {
        "content": "Seseorang pernah bertanya kepadaku,Mengapa kau selalu bersikukuh mengambil jalan tersulit?” Aku menjawabnya,Mengapa kau menganggapku memilih dua jalan?” –John Fitzgerald Kennedy."
    },
    "2026-08-23": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2026-08-24": {
        "content": "Orang yang hebat tidak dilahirkan begitu saja, tetapi mereka tumbuh menjadi lebih hebat –Mario Puzo."
    },
    "2026-08-25": {
        "content": "Janganlah menganggap remeh hal-hal yang terdekat dengan hatimu. Rangkullah mereka seperti sama berharganya dengan hidupmu, karena tanpa mereka hidup adalah sia-sia –Peribahasa Cina"
    },
    "2026-08-26": {
        "content": "Jadilah orang yang kuat, tetapi tidak kasar. Bersikaplah baik, tetapi jangan lemah. Bersikaplah rendah hati, tetapi tidak menjadi pemalu. Percaya dirilah, tetapi tidak sombong –Thomas Robert Malthus."
    },
    "2026-08-27": {
        "content": "Kita tidak bisa memecahkan masalah dengan cara berpikir yang kita gunakan ketika kita menemukan masalah itu –Albert Einstein"
    },
    "2026-08-28": {
        "content": "Untuk sukses, sikap sama pentingnya dengan kemampuan. -Walter Scott"
    },
    "2026-08-29": {
        "content": "Seorang pemenang adalah pemimpi yang tidak pernah menyerah –Nelson Mandela"
    },
    "2026-08-30": {
        "content": "Cara untuk memulai adalah dengan berhenti berbicara dan mulai melakukan. -Walt Disney"
    },
    "2026-08-31": {
        "content": "Ketika kesulitan datang, ingatlah bahwa Allah selalu bersamamu. –Jalal ad-Din Rumi"
    },
    "2026-09-01": {
        "content": " Hidup memiliki semua tikungan dan belokan itu. Kamu harus berpegangan erat-erat dan pergilah. –Nicole Kidman"
    },
    "2026-09-02": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2026-09-03": {
        "content": "Beberapa orang akan pergi dari hidupmu, tapi itu bukan akhir dari ceritamu. Itu cuma akhir dari bagian mereka di ceritamu. -Faraaz Kazi"
    },
    "2026-09-04": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2026-09-05": {
        "content": "Cinta bukan mengajar kita lemah, tetapi membangkitkan kekuatan Cinta bukan mengajar kita menghinakan diri, tetapi mengembuskan kegagahan Cinta bukan melemahkan semangat, tetapi membangkitkan semangat –Buya Hamka"
    },
    "2026-09-06": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2026-09-07": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2026-09-08": {
        "content": "Dunia itu seluas langkah kaki. Jelajahilah dan jangan pernah takut melangkah. Hanya dengan itu kita bisa mengerti kehidupan dan menyatu dengannya.–Soe Hok Gie"
    },
    "2026-09-09": {
        "content": "Lebih baik mempunyai kehidupan yang bermakna dan memberikan perbedaan dibandingkan hanya mempunyai umur yang panjang –Bryant H. Mc.Gill."
    },
    "2026-09-10": {
        "content": "Menjadi diri sendiri di dunia yang terus-menerus berusaha menjadikan Anda orang lain adalah pencapaian terbesar. -Ralph Waldo Emerson"
    },
    "2026-09-11": {
        "content": "Pertama kita membentuk kebiasaan dan kebiasaan akan membentuk kita. Kalahkan kebiasaan burumu, atau mereka akan mengalahkanmu dengan mudah –Dr. Rob Gilbert"
    },
    "2026-09-12": {
        "content": "Kebahagiaan sejati hanya dapat ditemukan dalam kebijaksanaan. –Epicurus"
    },
    "2026-09-13": {
        "content": "Kau tidak pernah dilahirkan untuk hidup kalah, tertekan, bersalah, malu, terkutuk, dan tidak layak. Kau dilahirkan untuk menjadi seorang pemenang –Mikhail Sergeyevich Gorbachev."
    },
    "2026-09-14": {
        "content": "Semakin tinggi ilmu seseorang, maka semakin tinggi toleransinya. –Gus Dur"
    },
    "2026-09-15": {
        "content": "Apapun dirimu, jadilah yang terbaik –Abraham Lincoln"
    },
    "2026-09-16": {
        "content": "Kesempurnaan adalah hasil dari usaha dan keteguhan dalam mengejar kebaikan. –Ibn Taymiyyah"
    },
    "2026-09-17": {
        "content": "Kesuksesan bukanlah hal yang final; kegagalan bukanlah hal yang fatal: Yang terpenting adalah keberanian untuk terus maju. -Winston S. Churchill"
    },
    "2026-09-18": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2026-09-19": {
        "content": "Jika kamu menginginkan sesuatu yang belum pernah dimiliki dalam hidupmu. Kamu harus melakukan sesuatu yang belum pernah dilakukan sebelumnya –JD Houston"
    },
    "2026-09-20": {
        "content": "Rahasia dari kesuksesan kita adalah bahwa kita tidak pernah menyerah. –Ilma Mankiller"
    },
    "2026-09-21": {
        "content": "Hanya ketika kita mengambil peluang, ketika hidup kita membaik. Risiko awal dan paling sulit yang perlu kita ambil adalah menjadi jujur. —Walter Anderson"
    },
    "2026-09-22": {
        "content": "Begitu kita menerima batasan kita, kita melampauinya. –Albert Einstein"
    },
    "2026-09-23": {
        "content": "Tujuan dari belajar adalah terus tumbuh Akal tidak sama dengan tubuh, akal terus bertumbuh selama kita hidup –Martimer Adler"
    },
    "2026-09-24": {
        "content": "Cinta itu seperti suatu peperangan. Mudah untuk memulainya, tetapi sangat sulit untuk menyudahinya –H.L. Mencken."
    },
    "2026-09-25": {
        "content": "Jangan menilai setiap hari dengan panen yang kamu tuai, tetapi dengan benih yang kamu tanam. –Robert Louis Stevenson"
    },
    "2026-09-26": {
        "content": "Teman yang baik tak akan membiarkamu melakukan hal-hal bodoh sendirian –Ain Eineziz"
    },
    "2026-09-27": {
        "content": "Cara paling mendasar dan kuat untuk terhubung dengan orang lain adalah dengan mendengarkan. Cukup Dengarkan. Mungkin hal terpenting yang bisa kita berikan kepada orang lain adalah perhatian kita –Rachel Naomi Remen"
    },
    "2026-09-28": {
        "content": "Rasa bahagia dan tak bahagia bukan berasal dari apa yang kamu miliki, bukan pula berasal dari siapa diri kamu, atau apa yang kamu kerjakan. Bahagia dan tak bahagia berasal dari pikiran kamu. –Dale Carnegie"
    },
    "2026-09-29": {
        "content": "Hal-hal terbaik dan terindah di dunia tidak dapat dilihat atau bahkan disentuh –semua itu harus dirasakan dengan hati. -Helen Keller"
    },
    "2026-09-30": {
        "content": "Kesuksesan bersumber dari perbuatan. Orang yang sukses terus melakukan usaha. Orang sukses bahkan membuat kesalahan, namun mereka tidak berhenti usaha –Cobrad Hilton"
    },
    "2026-10-01": {
        "content": "Saya tidak memikirkan semua penderitaan, tetapi keindahan yang masih tersisa. –Anne Frank"
    },
    "2026-10-02": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2026-10-03": {
        "content": "Kebahagiaan kita tergantung kepada diri kita sendiri –Aristoteles."
    },
    "2026-10-04": {
        "content": "Gravitasi tidak bertanggung-jawab atas orang yang jatuh cinta –Albert Einstein"
    },
    "2026-10-05": {
        "content": "Anda mungkin bisa menunda, tapi waktu tidak akan menunggu. –Benjamin Franklin"
    },
    "2026-10-06": {
        "content": "Kegelapan tidak dapat mengusir kegelapan: hanya cahaya yang dapat melakukannya. Kebencian tidak dapat mengusir kebencian: hanya cinta yang dapat melakukannya. -Martin Luther King Jr."
    },
    "2026-10-07": {
        "content": "Kamu tidak bisa kembali dan mengubah awal saat kamu memulainya, tapi kamu bisa memulainya lagi dari di mana kamu berada sekarang dan ubah akhirnya. -C.S Lewis"
    },
    "2026-10-08": {
        "content": "Cinta adalah kebenaran terbesar dan kebaikan tertinggi. –Plato"
    },
    "2026-10-09": {
        "content": "Banyak dari kegagalan hidup adalah karena mereka tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. –Thomas A. Edison"
    },
    "2026-10-10": {
        "content": "Lakukanlah sesuatu yang harus kau lakukan hingga kau tidak dapat melakukan sesuatu yang kau inginkan –Oprah Winfrey."
    },
    "2026-10-11": {
        "content": "Jangan menunggu orang lain membahagiakanmu. Kebahagiaan apa pun yang Anda peroleh, harus Anda ciptakan sendiri. -Alice Walker"
    },
    "2026-10-12": {
        "content": "Kabar buruknya adalah waktu berlalu begitu saja. Kabar baiknya adalah kamu adalah pilotnya. —Michael Altshuler"
    },
    "2026-10-13": {
        "content": "Kedamaian hilang karena kita lupa jika sebenarnya memiliki satu sama lain –Bunda Maria Teresa Bojaxhiu."
    },
    "2026-10-14": {
        "content": "Jangan biarkan ambisimu yang besar menghalangi berbagai pencapaian kecil yang jauh lebih bermakna –Bryant H. Mc.Gill"
    },
    "2026-10-15": {
        "content": "Dia, yang tidak cukup berani untuk mengambil risiko, tidak akan mencapai apa pun dalam hidup. –Muhammad Ali"
    },
    "2026-10-16": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2026-10-17": {
        "content": "Anda hanya hidup sekali, tetapi jika Anda melakukannya dengan benar, sekali saja sudah cukup. -Mae West"
    },
    "2026-10-18": {
        "content": "Jangan habiskan waktumu memukuli dinding dan berharap bisa mengubahnya menjadi pintu. -Coco Canel"
    },
    "2026-10-19": {
        "content": "Tindakan merupakan kunci dasar untuk memperoleh semua kesuksesan –Pablo Picasso."
    },
    "2026-10-20": {
        "content": "Pikiran yang baik dan hati yang baik selalu merupakan kombinasi yang hebat –Nelson Mandela"
    },
    "2026-10-21": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    },
    "2026-10-22": {
        "content": "Tanpa sasaran dan rencana meraihnya, kamu seperti kapal yang berlayar tanpa tujuan –Fitzhugh Dodson"
    },
    "2026-10-23": {
        "content": "Seribu orang tua bisa bermimpi, satu orang pemuda bisa mengubah dunia. -Soekarno"
    },
    "2026-10-24": {
        "content": "Cintai hidup yang kau jalani. Jalani hidup yang kau cintai. –Bob Marley"
    },
    "2026-10-25": {
        "content": "Anda ingin mengetahui siapa diri Anda? Jangan bertanya. Beraksilah! -Thomas Jefferson "
    },
    "2026-10-26": {
        "content": "Tidak ada kata terlambat untuk menjadi dirimu yang seharusnya. –George Eliot"
    },
    "2026-10-27": {
        "content": "Ketika dirimu tidak memperoleh solusi untuk mengatasi permasalahan, itu mungkin bukanlah masalah yang harus diatasi, melainkan kebenaran yang harus diterima –Mao Zedong."
    },
    "2026-10-28": {
        "content": "Saya suka mereka yang bisa tersenyum dalam kesulitan. –Leonardo da Vinci"
    },
    "2026-10-29": {
        "content": "Tujuan hidup adalah untuk hidup dengan bijaksana dan merenung. –Plato"
    },
    "2026-10-30": {
        "content": "Cinta itu seperti angin. Kau tak dapat melihatnya, tapi kau dapat merasakannya. -Nicholas Sparks"
    },
    "2026-10-31": {
        "content": "Aku hanya ingin orang lain mengambil langkah mundur, mengambil napas yang dalam, dan benar-benar mengamati sesuatu dengan cara yang berbeda. Namun, mayoritas orang tidak akan pernah melakukannya –Brian Mc.Knight."
    },
    "2026-11-01": {
        "content": "Keadilan adalah tanda kekuatan dan keberanian. –Ali bin Abi Thalib"
    },
    "2026-11-02": {
        "content": "Anda akan menghadapi banyak kekalahan dalam hidup, tetapi jangan pernah membiarkan diri Anda dikalahkan. -Maya Angelou"
    },
    "2026-11-03": {
        "content": "Ketika saya melepaskan diri saya yang sekarang, saya menjadi apa yang saya inginkan. –Lao Tzu"
    },
    "2026-11-04": {
        "content": "Bukankah kehidupan sendiri adalah bahagia dan sedih? Bahagia karena napas mengalir dan jantung berdetak, sedih karena pikiran diliputi bayang-bayang. –WS Rendra"
    },
    "2026-11-05": {
        "content": "Jadilah diri kamu sendiri. Siapa lagi yang bisa melakukannya lebih baik ketimbang diri kamu sendiri? –Frank J Giblin"
    },
    "2026-11-06": {
        "content": "Penemuan terbesar sepanjang masa adalah bahwa seseorang bisa mengubah masa depannya hanya dengan mengubah sikapnya saat ini. -Oprah Winfrey"
    },
    "2026-11-07": {
        "content": "Hidup itu sebentar. Kamu harus bisa tersenyum saat merasakan kepedihan atau kita tak akan pernah melanjutkan hidup.–Jeff Ross"
    },
    "2026-11-08": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2026-11-09": {
        "content": "Kemuliaan terbesar dalam hidup bukan terletak pada tidak pernah jatuh, tetapi bangkit setiap kali kita jatuh. -Nelson Mandela"
    },
    "2026-11-10": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2026-11-11": {
        "content": "Seseorang pernah bertanya kepadaku,Mengapa kau selalu bersikukuh mengambil jalan tersulit?” Aku menjawabnya,Mengapa kau menganggapku memilih dua jalan?” –John Fitzgerald Kennedy."
    },
    "2026-11-12": {
        "content": "Pikiran kamu bagaikan api yang perlu dinyalakan, bukan bejana yang menanti untuk diisi. –Dorothea Brande"
    },
    "2026-11-13": {
        "content": "Ketika memberikan kegembiraan kepada orang lain, kamu mendapatkan lebih banyak kegembiraan sebagai balasannya. Kamu harus memikirkan kebahagiaan yang bisa kamu berikan–Eleanor Roosevelt"
    },
    "2026-11-14": {
        "content": "Asmara bukan hanya sekadar saling memandang satu sama lain. Tapi, juga sama sama melihat ke satu arah yang sama. -Antoine de Saint-Exupéry"
    },
    "2026-11-15": {
        "content": "Cara terbaik untuk menyiapkan kehidupan adalah memulai hidup –Elbert Hubbard."
    },
    "2026-11-16": {
        "content": "Jika Anda ingin mewujudkan impian Anda, hal pertama yang harus Anda lakukan adalah bangun. -J.M. Power"
    },
    "2026-11-17": {
        "content": "Satu-satunya tempat di mana kesuksesan datang sebelum bekerja adalah di kamus. -Vidal Sassoon"
    },
    "2026-11-18": {
        "content": "Bukan melakukan apa yang kamu sukai, tetapi menyukai apa yang kamu lakukan adalah rahasia kebahagiaan. -JM Barrie"
    },
    "2026-11-19": {
        "content": "Kesabaran adalah kekuatan; kebitteran adalah kelemahan. –Immanuel Kant"
    },
    "2026-11-20": {
        "content": "Beberapa orang memimpikan kesuksesan, sementara yang lain bangun setiap pagi untuk mewujudkannya. –Wayne Huizenga"
    },
    "2026-11-21": {
        "content": "Banyak dari kegagalan hidup adalah karena mereka tidak menyadari betapa dekatnya mereka dengan kesuksesan ketika mereka menyerah. –Thomas A. Edison"
    },
    "2026-11-22": {
        "content": "Aku tidak tahu semua yang mungkin akan datang, tetapi apa pun yang akan terjadi, aku akan melakukannya sambil tertawa –Herman Melville"
    },
    "2026-11-23": {
        "content": "Cobalah untuk tidak menjadi orang yang sukses. Sebaliknya, jadilah orang yang bernilai. -Albert Einstein"
    },
    "2026-11-24": {
        "content": "Cinta selalu saja misterius Jangan diburu-buru, atau kau akan merusak jalan ceritanya sendiri –Tere Liye"
    },
    "2026-11-25": {
        "content": "Ia yang mengerjakan lebih dari apa yang dibayar pada suatu saat akan dibayar lebih dari apa yang ia kerjakan. –Napoleon Hill"
    },
    "2026-11-26": {
        "content": "Kebenaran adalah cahaya yang menghilangkan kegelapan. –al-Ghazali"
    },
    "2026-11-27": {
        "content": "Saya tidak bisa mengubah arah angin, namun saya bisa menyesuaikan pelayaran saya untuk selalu menggapai tujuan saya –Jimmy Dean"
    },
    "2026-11-28": {
        "content": "Jangan biarkan rasa takut kalah lebih besar daripada kegembiraan saat menang –Robert Kiyosaki"
    },
    "2026-11-29": {
        "content": "Dalam hidup ini kita tidak bisa melakukan hal-hal besar. Kita hanya bisa melakukan hal-hal kecil dengan cinta yang besar. -Bunda Teresa"
    },
    "2026-11-30": {
        "content": "Dia yang mengetahui semua jawaban belum pernah memperoleh pertanyaan –Confucius."
    },
    "2026-12-01": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2026-12-02": {
        "content": "Kebanggaan kita yang terbesar adalah bukan tidak pernah gagal, tetapi bangkit kembali setiap kali kita jatuh. –Confusius"
    },
    "2026-12-03": {
        "content": "Berjuang sampai napas terakhir –William Shakespeare"
    },
    "2026-12-04": {
        "content": "Ketika memiliki mimpi, kamu harus meraihnya dan tidak pernah melepaskannya –Carol Burnett"
    },
    "2026-12-05": {
        "content": "Beri nilai dari usahanya jangan dari hasilnya. Baru kita bisa menilai kehidupan. -Albert Einstein"
    },
    "2026-12-06": {
        "content": "Jangan khawatir jika Anda tidak diakui, tetapi berusahalah untuk menjadi layak diakui. -Abraham Lincoln"
    },
    "2026-12-07": {
        "content": "Kebijaksanaan adalah lebih berharga daripada kekayaan. –Heraclitus"
    },
    "2026-12-08": {
        "content": " Orang yang memiliki sasaran sukses karena mereka tahu ke mana akan pergi –Earl Nightingale"
    },
    "2026-12-09": {
        "content": "Sebarkan cinta ke mana pun kamu pergi. Jangan biarkan orang lain mendatangimu tanpa mendapatkan hal yang lebih bahagia. –Bunda Teresa"
    },
    "2026-12-10": {
        "content": "Tiga hal dalam hidup –kesehatanmu, misimu dan orang yang kamu cintai. –Naval Ravikant"
    },
    "2026-12-11": {
        "content": "Jangan tanyakan pada dirimu apa yang dibutuhkan dunia. Bertanyalah apa yang membuat kamu merasa hidup, kemudian kerjakan. Karena yang dibutuhkan dunia adalah orang yang antusias –Harold Whitman"
    },
    "2026-12-12": {
        "content": "Pelajarilah dengan sungguh-sungguh apa yang paling menarik minatmu dengan cara yang paling tidak disiplin, tidak sopan, dan orisinal –Richard Feynmann"
    },
    "2026-12-13": {
        "content": "Saya suka mereka yang bisa tersenyum dalam kesulitan. –Leonardo da Vinci"
    },
    "2026-12-14": {
        "content": "Optimisme adalah iman yang menuntunmu ke pencapaian –Helen Keller"
    },
    "2026-12-15": {
        "content": "Hidup bukanlah untuk menunggu badai berlalu, tetapi belajar menari di tengah hujan –Henry Ford."
    },
    "2026-12-16": {
        "content": "Kita harus berarti untuk diri kita sendiri dulu sebelum kita menjadi orang yang berharga bagi orang lain. -Ralph Waldo Emerson"
    },
    "2026-12-17": {
        "content": "Orang paling kesepian memiliki kepribadian yang baik hati. Orang paling sedih memiliki senyum paling cerah. Orang paling rusak memiliki kebijaksanaan yang luas. Semua itu karena mereka tidak ingin orang lain menderita seperti mereka –Zarathustra."
    },
    "2026-12-18": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2026-12-19": {
        "content": "Tujuan pendidikan itu untuk mempertajam kecerdasan, memperkukuh kemauan serta memperhalus perasaan. –Tan Malaka"
    },
    "2026-12-20": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara. -Shah Rukh Khan"
    },
    "2026-12-21": {
        "content": "Kamu menjadi apa yang kamu yakini. -Oprah Winfrey"
    },
    "2026-12-22": {
        "content": "Dalam tiga kata, saya dapat menyimpulkan semua yang telah saya pelajari tentang kehidupan: hidup terus berjalan. -Robert Frost"
    },
    "2026-12-23": {
        "content": "Orang bijak belajar ketika mereka bisa. Orang bodoh belajar ketika mereka dipaksa. -Arthur Wellesley"
    },
    "2026-12-24": {
        "content": "Kesuksesan dan kegagalan adalah sama-sama bagian dalam hidup. Keduanya hanyalah sementara.–Shah Rukh Khan"
    },
    "2026-12-25": {
        "content": "Jangan takut atas kebenaran, meskipun kebenaran akan menyakitkan. –Ibn Arabi"
    },
    "2026-12-26": {
        "content": "Tiada awan di langit yang tetap selamanya. Tiada mungkin akan terus-menerus terang cuaca. Sehabis malam gelap gulita lahir pagi membawa keindahan. Kehidupan manusia serupa alam. –RA Kartini"
    },
    "2026-12-27": {
        "content": "Belajarlah seolah-olah kamu akan hidup selamanya, hiduplah seolah-olah kamu akan mati besok. –Mahatma Gandhi"
    },
    "2026-12-28": {
        "content": "Jangan katakan tidak punya cukup waktu. Anda memiliki jumlah jam yang persis sama per hari yang diberikan kepada Helen Keller, Pasteur, Michelangelo, Mother Teresa, Leonardo da Vinci, Thomas Jefferson, dan Albert Einstein. –H. Jackson Brown Jr"
    },
    "2026-12-29": {
        "content": "Jangan takut untuk takut. -Maurice Chevalier"
    },
    "2026-12-30": {
        "content": "Orang beriman adalah orang yang berpikir sebelum bertindak. –Hasan al-Banna"
    },
    "2026-12-31": {
        "content": "Seseorang yang berani membuang satu jam waktunya tidak mengetahui nilai dari kehidupan. –Charles Darwin."
    }
}
export const dateEnList = {
    "2024-01-01": {
        "content": "We are what we repeatedly do. Excellence, therefore, is not an act, but a habit. -Aristotle"
    },
    "2024-01-02": {
        "content": "A river cuts through rock, not because of its power, but because of its persistence. -Jim Watkins"
    },
    "2024-01-03": {
        "content": "Energy and persistence conquer all things. -Benjamin Franklin"
    },
    "2024-01-04": {
        "content": "Opportunities are usually disguised as hard work, so most people don’t recognize them. -Ann Landers"
    },
    "2024-01-05": {
        "content": "\"If you can't fly, then run. If you can't run, then walk. If you can't walk, then crawl, but whatever you do, you have to keep moving forward.\"-Martin Luther King Jr."
    },
    "2024-01-06": {
        "content": "With ordinary talent and extraordinary perseverance, all things are attainable. -Thomas Fowell Buxton"
    },
    "2024-01-07": {
        "content": "Our greatest glory is not in never failing, but in rising up every time we fail. -Ralph Waldo Emerson"
    },
    "2024-01-08": {
        "content": "Success is stumbling from failure to failure with no loss of enthusiasm. -Winston Churchill"
    },
    "2024-01-09": {
        "content": "Thankfully, persistence is a great substitute for talent. -Steve Martin"
    },
    "2024-01-10": {
        "content": "I'm a greater believer in luck, and I find that the harder I work, the more I have of it. -Thomas Jefferson"
    },
    "2024-01-11": {
        "content": "Only put off until tomorrow what you are willing to die having left undone. -Pablo Picasso"
    },
    "2024-01-12": {
        "content": "There are no secrets to success. It is the result of preparation, hard work, and learning from failure. -Colin Powell"
    },
    "2024-01-13": {
        "content": "Let me tell you the secret that has led me to my goal: my strength lies solely in my tenacity. -Louis Pasteur"
    },
    "2024-01-14": {
        "content": "Nothing in this world can take the place of persistence. Talent will not; nothing is more common than unsuccessful people with talent. Genius will not; unrewarded genius is almost a proverb. -Calvin Coolidge"
    },
    "2024-01-15": {
        "content": "The best way out is always through. -Robert Frost"
    },
    "2024-01-16": {
        "content": "Many of life’s failures are people who did not realize how close they were to success when they gave up. -Thomas A. Edison"
    },
    "2024-01-17": {
        "content": "We are made to persist. That’s how we find out who we are. -Tobias Wolff"
    },
    "2024-01-18": {
        "content": "Knowing trees, I understand the meaning of patience. Knowing grass, I can appreciate persistence. -Hal Borland"
    },
    "2024-01-19": {
        "content": "Dripping water hollows out stone, not through force but through persistence. -Ovid"
    },
    "2024-01-20": {
        "content": "Persistence is very important. You should not give up unless you are forced to give up. -Elon Musk"
    },
    "2024-01-21": {
        "content": "Flaming enthusiasm, backed by horse sense and persistence, is the quality that most frequently makes for success. -Dale Carnegie"
    },
    "2024-01-22": {
        "content": "Ambition is the path to success. Persistence is the vehicle you arrive in. -Bill Bradley"
    },
    "2024-01-23": {
        "content": "Focus on the solution, not the problem. -Walter Anderson"
    },
    "2024-01-24": {
        "content": "When life knocks you down, you have two choices – stay down or get up. -Tom Krause"
    },
    "2024-01-25": {
        "content": "Success is the sum of small efforts, repeated day in and day out. -Robert Collier"
    },
    "2024-01-26": {
        "content": "A dream is just a dream. A goal is a dream with a plan and a deadline. -Harvey MacKay"
    },
    "2024-01-27": {
        "content": "Never give up on something that you can’t go a day without thinking about. -Winston Churchill"
    },
    "2024-01-28": {
        "content": "Diamonds are nothing more than chunks of coal that stuck to their jobs. -Malcolm S. Forbes"
    },
    "2024-01-29": {
        "content": "Nothing can be done except little by little. -Charles Baudelaire"
    },
    "2024-01-30": {
        "content": "If you are going through hell, keep going. -Winston Churchill"
    },
    "2024-01-31": {
        "content": "The key of persistence opens all doors closed by resistance. -John Di Lemme"
    },
    "2024-02-01": {
        "content": "If we look at those who are the most successful in the world, persistence is the common denominator. -Justin Sachs"
    },
    "2024-02-02": {
        "content": "You can eat an elephant one bit at a time. -Mary Kay Ash"
    },
    "2024-02-03": {
        "content": "I do not think that there is any other quality so essential to success of any kind as the quality of perseverance. It overcomes almost everything, even nature. -John D. Rockefeller"
    },
    "2024-02-04": {
        "content": "If you want to turn a vision into reality, you have to give 100% and never stop believing in your dream. -Arnold Schwarzenegger"
    },
    "2024-02-05": {
        "content": "Run when you can, walk if you have to, crawl if you must; just never give up. -Dean Karnazes"
    },
    "2024-02-06": {
        "content": "Going that one more round when you don’t think you can – that’s what makes all the difference in your life. -Sylvester Stallone"
    },
    "2024-02-07": {
        "content": "Listen to me, even when you lose, it’s OK to lose, but you can never get comfortable with it. You can never be satisfied with losing. When you lose, it’s got to hurt. -Eric Thomas"
    },
    "2024-02-08": {
        "content": "Keep walking the walk, one step at a time. -Joyce Meyer"
    },
    "2024-02-09": {
        "content": "We should not give up and we should not allow the problem to defeat us. -Abdul Kalam"
    },
    "2024-02-10": {
        "content": "By endurance we conquer. -Ernest Shackleton"
    },
    "2024-02-11": {
        "content": "The brick walls are there for a reason. The brick walls are not there to keep us out. The brick walls are there to give us a chance to show how badly we want something. Because the brick walls are there to stop the people who don’t want it badly enough. They’re there to stop the other people. -Randy Pausch"
    },
    "2024-02-12": {
        "content": "Success is almost totally dependent upon drive and persistence. The extra energy required to make another effort or try another approach is the secret of winning. -Denis Waitley"
    },
    "2024-02-13": {
        "content": "I’d made it this far and refused to give up because all my life I had always finished the race. -Louis Zamperini"
    },
    "2024-02-14": {
        "content": "Survival can be summed up in three words – never give up. That’s the heart of it, really. Just keep trying. -Bear Grylls"
    },
    "2024-02-15": {
        "content": "No more. No more excuses. No more: “I’ll start tomorrow.” No more: “Just this once.” No more accepting the shortfalls of my own will. No more taking the easy road. No more bowing down to whatever unhealthy or unproductive thoughts float through my mind. -Jocko Willink"
    },
    "2024-02-16": {
        "content": "Little strokes fell great oaks. -Benjamin Franklin"
    },
    "2024-02-17": {
        "content": "I am willing. I am wired to win. I got this. I embrace the uncertainty. I am not my thoughts; I am what I do. I am relentless. I expect nothing and accept everything. -Gary John Bishop"
    },
    "2024-02-18": {
        "content": "I have not failed 700 times. I have not failed once. I have succeeded in proving that those 700 ways will not work. When I have eliminated the ways that will not work, I will find the way that will work. -Thomas A. Edison"
    },
    "2024-02-19": {
        "content": "GRIT is Guts, Resilience, Industriousness and Tenacity. GRIT is the ability to focus, stay determined, stay optimistic in the face of a challenge, and simply work harder than the next guy or gal. -Linda Kaplan Thaler"
    },
    "2024-02-20": {
        "content": "I think my secret is that there are no shortcuts for hard work, determination, and having that ‘don’t give up’ attitude. -Jerry Rice"
    },
    "2024-02-21": {
        "content": "Never stop fighting until you arrive at your destined place – that is, the unique you. Have an aim in life, continuously acquire knowledge, work hard, and have perseverance to realize the great life. -Abdul Kalam"
    },
    "2024-02-22": {
        "content": "Don’t stop when you are tired. Stop when you are done. -David Goggins"
    },
    "2024-02-23": {
        "content": "Do not judge me by my successes, judge me by how many times I fell down and got back up again. -Nelson Mandela"
    },
    "2024-02-24": {
        "content": "What is not started today is never finished tomorrow. -Johann Wolfgang von Goethe"
    },
    "2024-02-25": {
        "content": "If you write a hundred short stories and they’re all bad, that doesn’t mean you’ve failed. You fail only if you stop writing. -Ray Bradbury"
    },
    "2024-02-26": {
        "content": "The master has failed more times than the beginner has even tried. -Stephen McCranie"
    },
    "2024-02-27": {
        "content": "To hell with circumstances; I create opportunities. -Bruce Lee"
    },
    "2024-02-28": {
        "content": "The only thing worse than starting something and failing is not starting something. -Seth Godin"
    },
    "2024-02-29": {
        "content": "Never leave till tomorrow that which you can do today. -Benjamin Franklin"
    },
    "2024-03-01": {
        "content": "Remember, hope is a good thing, maybe the best of things, and no good thing ever dies. -Stephen King"
    },
    "2024-03-02": {
        "content": "Entrepreneurs don’t finish when we are tired. We finish when we are done. -Robert T. Kiyosaki"
    },
    "2024-03-03": {
        "content": "Persistence and determination alone are omnipotent. -Calvin Coolidge"
    },
    "2024-03-04": {
        "content": "Paralyze resistance with persistence. -Woody Hayes"
    },
    "2024-03-05": {
        "content": "Success is never owned, it is rented, and the rent is due every day. -Rory Vaden"
    },
    "2024-03-06": {
        "content": "Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing or learning to do. -Pelé"
    },
    "2024-03-07": {
        "content": "There is no way around the hard work. Embrace it. -Roger Federer"
    },
    "2024-03-08": {
        "content": "A dream doesn’t become reality through magic; it takes sweat, determination and hard work. -Colin Powell"
    },
    "2024-03-09": {
        "content": "Learning never exhausts the mind. -Leonardo da Vinci"
    },
    "2024-03-10": {
        "content": "Anyone who has never made a mistake has never tried anything new. -Albert Einstein"
    },
    "2024-03-11": {
        "content": "Try to learn something about everything and everything about something. -Thomas Henry Huxley"
    },
    "2024-03-12": {
        "content": "A man only learns in two ways, one by reading, and the other by association with smarter people. -Will Rogers"
    },
    "2024-03-13": {
        "content": "You don’t understand anything until you learn it more than one way. -Marvin Minsky"
    },
    "2024-03-14": {
        "content": "Tell me and I forget, teach me and I may remember, involve me and I learn. -Benjamin Franklin"
    },
    "2024-03-15": {
        "content": "If you want to increase your success rate, double your failure rate. -Thomas J. Watson"
    },
    "2024-03-16": {
        "content": "Intelligence is what you use when you don’t know what to do. -Jean Piaget"
    },
    "2024-03-17": {
        "content": "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. -Alvin Toffler"
    },
    "2024-03-18": {
        "content": "It is what we know already that often prevents us from learning. -Claude Bernard"
    },
    "2024-03-19": {
        "content": "The whole purpose of education is to turn mirrors into windows. -Sydney J. Harris"
    },
    "2024-03-20": {
        "content": "I am not afraid of storms, for I am learning how to sail my ship. -Louisa May Alcott"
    },
    "2024-03-21": {
        "content": "The only person who is educated is the one who has learned how to learn and change. -Carl R. Rogers"
    },
    "2024-03-22": {
        "content": "I have never met a man so ignorant that I couldn’t learn something from him. -Galileo Galilei"
    },
    "2024-03-23": {
        "content": "Nothing ever goes away until it has taught us what we need to know. -Pema Chödrön"
    },
    "2024-03-24": {
        "content": "Practice makes perfect. After a long time of practicing, our work will become natural, skillful, swift, and steady. -Bruce Lee"
    },
    "2024-03-25": {
        "content": "Strive for progress, not perfection. -Anonymous"
    },
    "2024-03-26": {
        "content": "I am always doing what I cannot do yet, in order to learn how to do it. -Vincent van Gogh"
    },
    "2024-03-27": {
        "content": "I learned very early the difference between knowing the name of something and knowing something. -Richard P. Feynman"
    },
    "2024-03-28": {
        "content": "The capacity to learn is a gift. The ability to learn is a skill. The willingness to learn is a choice. -Brian Herbert"
    },
    "2024-03-29": {
        "content": "Learn everything you can, anytime you can, from anyone you can – there will always come a time when you will be grateful you did. -Sarah Caldwell"
    },
    "2024-03-30": {
        "content": "I do not think much of a man who is not wiser today than he was yesterday. -Abraham Lincoln"
    },
    "2024-03-31": {
        "content": "The key to success is dedication to life-long learning. -Stephen R. Covey"
    },
    "2024-04-01": {
        "content": "Be passionate and bold. Always keep learning. You stop doing useful things if you don’t learn. -Satya Nadella"
    },
    "2024-04-02": {
        "content": "The highest activity a human being can attain is learning for understanding, because to understand is to be free. -Baruch Spinoza"
    },
    "2024-04-03": {
        "content": "If you don’t keep learning, other people will pass you by. Temperament alone won’t do it – you need a lot of curiosity for a long, long time. -Charlie Munger"
    },
    "2024-04-04": {
        "content": "A learning organization is an organization that is continually expanding its capacity to create its future. -Peter Senge"
    },
    "2024-04-05": {
        "content": "The day you stop learning is the day you begin decaying. -Isaac Asimov"
    },
    "2024-04-06": {
        "content": "Learning is an ornament in prosperity, a refuge in adversity, and a provision in old age. -Aristotle"
    },
    "2024-04-07": {
        "content": "To learn hard things quickly, you must focus intensely without distraction. To learn, in other words, is an act of deep work. -Cal Newport"
    },
    "2024-04-08": {
        "content": "Any fool can know. The point is to understand. -Albert Einstein"
    },
    "2024-04-09": {
        "content": "Spend each day trying to be a little wiser than you were when you woke up. -Charlie Munger"
    },
    "2024-04-10": {
        "content": "Invest in yourself, in your education. There’s nothing better. -Sylvia Porter"
    },
    "2024-04-11": {
        "content": "Self-education is a continuing source of pleasure to me, for the more I know, the fuller my life is and the better I appreciate my own existence. -Isaac Asimov"
    },
    "2024-04-12": {
        "content": "You can get help from teachers, but you are going to have to learn a lot by yourself, sitting alone in a room. -Dr. Seuss"
    },
    "2024-04-13": {
        "content": "Learning happens when someone wants to learn, not when someone wants to teach. -Roger Schank"
    },
    "2024-04-14": {
        "content": "A person cannot teach another person directly; a person can only facilitate another’s learning. -Carl R. Rogers"
    },
    "2024-04-15": {
        "content": "Learning is not compulsory; it’s voluntary. Improvement is not compulsory; it’s voluntary. But to survive, we must learn. -W. Edwards Deming"
    },
    "2024-04-16": {
        "content": "I am always doing that which I can not do, in order that I may learn how to do it. -Pablo Picasso"
    },
    "2024-04-17": {
        "content": "No thief, however skillful, can rob one of knowledge, and that is why knowledge is the best and safest treasure to acquire. -L. Frank Baum"
    },
    "2024-04-18": {
        "content": "I think that’s the single best piece of advice: constantly think about how you could be doing things better and questioning yourself. -Elon Musk"
    },
    "2024-04-19": {
        "content": "A wise man can learn more from a foolish question than a fool can learn from a wise answer. -Bruce Lee"
    },
    "2024-04-20": {
        "content": "If I have seen further, it is by standing on the shoulders of giants. -Isaac Newton"
    },
    "2024-04-21": {
        "content": "What we know is a drop, what we don’t know is an ocean. -Isaac Newton"
    },
    "2024-04-22": {
        "content": "The beautiful thing about learning is that nobody can take it away from you. -B. B. King"
    },
    "2024-04-23": {
        "content": "If you want to be a writer, you must do two things above all others: read a lot and write a lot. -Stephen King"
    },
    "2024-04-24": {
        "content": "Repetition is the mother of skill. -Tony Robbins"
    },
    "2024-04-25": {
        "content": "Wonder is the beginning of wisdom. -Socrates"
    },
    "2024-04-26": {
        "content": "The purpose of education is to replace an empty mind with an open one. -Malcolm S. Forbes"
    },
    "2024-04-27": {
        "content": "Nothing in life is to be feared, it is only to be understood. Now is the time to understand more, so that we may fear less. -Marie Curie"
    },
    "2024-04-28": {
        "content": "Whenever you are asked if you can do a job, tell them, “Certainly I can!”. Then get busy and find out how to do it. -Theodore Roosevelt"
    },
    "2024-04-29": {
        "content": "We all need people who will give us feedback. That’s how we improve. -Bill Gates"
    },
    "2024-04-30": {
        "content": "Education is the key to unlocking the world, a passport to freedom. -Oprah Winfrey"
    },
    "2024-05-01": {
        "content": "Everything begins with an idea. -Earl Nightingale"
    },
    "2024-05-02": {
        "content": "The best investment you can make is in yourself. -Warren Buffett"
    },
    "2024-05-03": {
        "content": "It’s not about money or connections. It’s the willingness to outwork and outlearn everyone. -Mark Cuban"
    },
    "2024-05-04": {
        "content": "As long as you live, keep learning how to live. -Seneca"
    },
    "2024-05-05": {
        "content": "To learn to succeed, you must first learn to fail. -Michael Jordan"
    },
    "2024-05-06": {
        "content": "Don’t waste a good mistake, learn from it. -Robert T. Kiyosaki"
    },
    "2024-05-07": {
        "content": "To acquire knowledge, one must study; but to acquire wisdom, one must observe. -Marilyn Vos Savant"
    },
    "2024-05-08": {
        "content": "You live and learn. At any rate, you live. -Douglas Adams"
    },
    "2024-05-09": {
        "content": "I only know one thing, and that is I know nothing. -Socrates"
    },
    "2024-05-10": {
        "content": "Wisdom comes from experience. Experience is often a result of lack of wisdom. -Terry Pratchett"
    },
    "2024-05-11": {
        "content": "We can judge our progress by the courage of our questions and the depth of our answers, our willingness to embrace what is true rather than what feels good. -Carl Sagan"
    },
    "2024-05-12": {
        "content": "I would rather have questions that can’t be answered than answers that can’t be questioned. -Richard P. Feynman"
    },
    "2024-05-13": {
        "content": "I am always ready to learn, although I do not always like being taught. -Winston Churchill"
    },
    "2024-05-14": {
        "content": "He who loves practice without theory is like the sailor who boards ship without a rudder and compass and never knows where he may cast. -Leonardo da Vinci"
    },
    "2024-05-15": {
        "content": "It is better to create than to learn. Creating is the essence of life. -Julius Caesar"
    },
    "2024-05-16": {
        "content": "What the hand does the mind remembers. -Maria Montessori"
    },
    "2024-05-17": {
        "content": "Always walk through life as if you have something new to learn, and you will. -Vernon Howard"
    },
    "2024-05-18": {
        "content": "Failure is success if we learn from it. -Malcolm S. Forbes"
    },
    "2024-05-19": {
        "content": "Education is the best friend. An educated person is respected everywhere. Education beats beauty and youth. -Chanakya"
    },
    "2024-05-20": {
        "content": "Do not think that what is hard for you to master is humanly impossible; but if a thing is humanly possible, consider it to be within your reach. -Marcus Aurelius"
    },
    "2024-05-21": {
        "content": "Learning is a constant process of discovery – a process without end. -Bruce Lee"
    },
    "2024-05-22": {
        "content": "Being ignorant is not so much a shame as being unwilling to learn. -Benjamin Franklin"
    },
    "2024-05-23": {
        "content": "I am convinced that knowledge is power—to overcome the past, to change our own situations, to fight new obstacles, to make better decisions. -Ben Carson"
    },
    "2024-05-24": {
        "content": "Breathing in, I calm body and mind. Breathing out, I smile. Dwelling in the present moment, I know this is the only moment. -Thich Nhat Hanh"
    },
    "2024-05-25": {
        "content": "Too often we underestimate the power of a touch, a smile, a kind word, a listening ear, an honest compliment, or the smallest act of caring, all of which have the potential to turn a life around. -Leo Buscaglia"
    },
    "2024-05-26": {
        "content": "How we spend our days is, of course, how we spend our lives. -Annie Dillard"
    },
    "2024-05-27": {
        "content": "Nurture your mind with great thoughts, for you will never go any higher than you think. -Benjamin Disraeli"
    },
    "2024-05-28": {
        "content": "You don’t learn to walk by following rules. You learn by doing and falling over. -Richard Branson"
    },
    "2024-05-29": {
        "content": "It is impossible to live without failing at something, unless you live so cautiously that you might as well not have lived at all, in which case you fail by default. -J.K. Rowling"
    },
    "2024-05-30": {
        "content": "If you want to be happy, be. -Leo Tolstoy"
    },
    "2024-05-31": {
        "content": "Nobody can hurt me without my permission. -Mahatma Gandhi"
    },
    "2024-06-01": {
        "content": "The reason we struggle with insecurity is because we compare our behind-the-scenes with everyone else’s highlight reel. -Steven Furtick"
    },
    "2024-06-02": {
        "content": "Remember, today is the tomorrow you worried about yesterday. -Dale Carnegie"
    },
    "2024-06-03": {
        "content": "We must be willing to let go of the life we planned so as to have the life that is waiting for us. -Joseph Campbell"
    },
    "2024-06-04": {
        "content": "A team is not a group of people that work together. A team is a group of people that trust each other. -Simon Sinek"
    },
    "2024-06-05": {
        "content": "Perpetual optimism is a force multiplier. -Colin Powell"
    },
    "2024-06-06": {
        "content": "Count your age by friends, not years. Count your life by smiles, not tears. -John Lennon"
    },
    "2024-06-07": {
        "content": "Perseverance and spirit have done wonders in all ages. -George Washington"
    },
    "2024-06-08": {
        "content": "We are a way for the cosmos to know itself. -Carl Sagan"
    },
    "2024-06-09": {
        "content": "A good teacher can inspire hope, ignite the imagination, and instill a love of learning. -Brad Henry"
    },
    "2024-06-10": {
        "content": "One of the greatest discoveries a person makes, one of their great surprises, is to find they can do what they were afraid they couldn’t do. -Henry Ford"
    },
    "2024-06-11": {
        "content": "When was the last time you did something for the first time?-John C. Maxwell"
    },
    "2024-06-12": {
        "content": "If you are not in the process of becoming the person you want to be, you are automatically engaged in becoming the person you don’t want to be. -Dale Carnegie"
    },
    "2024-06-13": {
        "content": "Fortune favors the brave. -Latin proverb"
    },
    "2024-06-14": {
        "content": "Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful. -Albert Schweitzer"
    },
    "2024-06-15": {
        "content": "Don’t gain the world and lose your soul; wisdom is better than silver or gold. -Bob Marley"
    },
    "2024-06-16": {
        "content": "Begin at once to live, and count each separate day as a separate life. -Seneca"
    },
    "2024-06-17": {
        "content": "Unless someone like you cares a whole awful lot, nothing is going to get better. It’s not. -Dr. Seuss"
    },
    "2024-06-18": {
        "content": "They did not know it was impossible, so they did it. -Mark Twain"
    },
    "2024-06-19": {
        "content": "And the day came when the risk to remain tight in the bud was more painful than the risk it took to blossom. -Franklin D. Roosevelt"
    },
    "2024-06-20": {
        "content": "There's no talent here, this is hard work. This is an obsession. Talent does not exist, we are all equal as human beings. You could be anyone if you put in the time. You will reach the top, and that is that. I am not talented, I am obsessed. -Ralph Waldo Emerson"
    },
    "2024-06-21": {
        "content": "Success is your duty, obligation, and responsibility. -C. S. Lewis"
    },
    "2024-06-22": {
        "content": "The greatest day in your life and mine is when we take total responsibility for our attitudes. That's the day we truly grow up. -Alan Watts"
    },
    "2024-06-23": {
        "content": "REPEATED FROM LINE 6-T. Harv Eker"
    },
    "2024-06-24": {
        "content": "Keep your dreams alive. Understand that to achieve anything requires faith and belief in yourself, vision, hard work, determination, and dedication. Remember all things are possible for those who believe. -Lance Armstrong"
    },
    "2024-06-25": {
        "content": "This is the real secret of life: to be completely engaged with what you are doing in the here and now. And instead of calling it work, realize it is play. -John Muir"
    },
    "2024-06-26": {
        "content": "Some changes look negative on the surface, but you will soon realize that space is being created in your life for something new to emerge. -Edwin Louis Cole"
    },
    "2024-06-27": {
        "content": "If your actions inspire others to dream more, learn more, do more, and become more, you are a leader. -Eckhart Tolle"
    },
    "2024-06-28": {
        "content": "Be fearless in the pursuit of what sets your soul on fire. -Jennifer Lee"
    },
    "2024-06-29": {
        "content": "When people walk away from you, let them go. Your destiny is never tied to anyone who leaves you, and it doesn’t mean they are bad people. It just means that their part in your story is over. -T.D. Jakes"
    },
    "2024-06-30": {
        "content": "Leadership is the capacity to translate vision into reality. -Warren G. Bennis"
    },
    "2024-07-01": {
        "content": "The only thing worse than being blind is having sight but no vision. -Helen Keller"
    },
    "2024-07-02": {
        "content": "Hope is the thing with feathers that perches in the soul - and sings the tune without the words - and never stops at all. -Emily Dickinson"
    },
    "2024-07-03": {
        "content": "And by the way, everything in life is writable about if you have the outgoing guts to do it, and the imagination to improvise. The worst enemy to creativity is self-doubt. -Sylvia Plath"
    },
    "2024-07-04": {
        "content": "Nothing we do can change the past, but everything we do changes the future. -Ashleigh Brilliant"
    },
    "2024-07-05": {
        "content": "Leadership is a choice. It is not a rank. -Simon Sinek"
    },
    "2024-07-06": {
        "content": "All shall be well, and all shall be well and all manner of thing shall be well. -Julian of Norwich"
    },
    "2024-07-07": {
        "content": "Every one of us is, in the cosmic perspective, precious. If a human disagrees with you, let him live. In a hundred billion galaxies, you will not find another. -Carl Sagan"
    },
    "2024-07-08": {
        "content": "Intelligence plus character – that is the goal of true education. -Martin Luther King Jr."
    },
    "2024-07-09": {
        "content": "The more you lose yourself in something bigger than yourself, the more energy you will have. -Norman Vincent Peale"
    },
    "2024-07-10": {
        "content": "Get the fundamentals down and the level of everything you do will rise. -Michael Jordan"
    },
    "2024-07-11": {
        "content": "You can’t live at all unless you can live fully now. -Alan Watts"
    },
    "2024-07-12": {
        "content": "You are an infinite spiritual being having a temporary human experience. -Wayne W. Dyer"
    },
    "2024-07-13": {
        "content": "You have to dream before your dreams can come true. -Abdul Kalam"
    },
    "2024-07-14": {
        "content": "I can shake off everything as I write; my sorrows disappear, my courage is reborn. -Anne Frank"
    },
    "2024-07-15": {
        "content": "The goal is not to be perfect by the end. The goal is to be better today. -Simon Sinek"
    },
    "2024-07-16": {
        "content": "Go confidently in the direction of your dreams. Live the life you’ve imagined. -Henry David Thoreau"
    },
    "2024-07-17": {
        "content": "You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose. You’re on your own. And you know what you know. And you are the one who’ll decide where to go. -Dr. Seuss"
    },
    "2024-07-18": {
        "content": "What you focus on expands, and when you focus on the goodness in your life, you create more of it. -Oprah Winfrey"
    },
    "2024-07-19": {
        "content": "Everything I need to know is revealed to me. Everything I need comes to me. All is well in my life. -Louise Hay"
    },
    "2024-07-20": {
        "content": "I am totally safe in the Universe. I am at peace everywhere. I trust life. -Louise Hay"
    },
    "2024-07-21": {
        "content": "Turn your face to the sun and the shadows fall behind you. -Maori Proverb"
    },
    "2024-07-22": {
        "content": "Courage is not having the strength to go on; it is going on when you don’t have the strength. -Theodore Roosevelt"
    },
    "2024-07-23": {
        "content": "The future depends on what you do today. -Mahatma Gandhi"
    },
    "2024-07-24": {
        "content": "A winner is a dreamer who never gives up. -Nelson Mandela"
    },
    "2024-07-25": {
        "content": "Don’t cry because it’s over, smile because it happened. -Dr. Seuss"
    },
    "2024-07-26": {
        "content": "In three words I can sum up everything I’ve learned about life: it goes on. -Robert Frost"
    },
    "2024-07-27": {
        "content": "Live out of your imagination, not your history. -Stephen R. Covey"
    },
    "2024-07-28": {
        "content": "The way I see it, if you want the rainbow, you gotta put up with the rain. -Dolly Parton"
    },
    "2024-07-29": {
        "content": "The greatness of a man is not in how much wealth he acquires, but in his integrity and his ability to affect those around him positively. -Bob Marley"
    },
    "2024-07-30": {
        "content": "It is never too late to be what you might have been. -George Eliot"
    },
    "2024-07-31": {
        "content": "Adopting the right attitude can convert a negative stress into a positive one. -Hans Selye"
    },
    "2024-08-01": {
        "content": "Dare to live the life you have dreamed for yourself. Go forward and make your dreams come true. -Ralph Waldo Emerson"
    },
    "2024-08-02": {
        "content": "The time you enjoy wasting is not wasted time. -Bertrand Russell"
    },
    "2024-08-03": {
        "content": "The curious paradox is that when I accept myself just as I am, then I can change. -Carl R. Rogers"
    },
    "2024-08-04": {
        "content": "Be part of the solution, not part of the problem. -Stephen R. Covey"
    },
    "2024-08-05": {
        "content": "The secret to living is giving. -Tony Robbins"
    },
    "2024-08-06": {
        "content": "Make every day your masterpiece. -John Wooden"
    },
    "2024-08-07": {
        "content": "Never give up on what you really want to do-H. Jackson Brown Jr."
    },
    "2024-08-08": {
        "content": "Don’t look back – you’re not going that way. -Mary Engelbreit"
    },
    "2024-08-09": {
        "content": "Live, travel, adventure, bless, and don’t be sorry. -Jack Kerouac"
    },
    "2024-08-10": {
        "content": "In the midst of winter, I found there was, within me, an invincible summer. And that makes me happy. For it says that no matter how hard the world pushes against me, within me, there’s something stronger – something better, pushing right back. -Albert Camus"
    },
    "2024-08-11": {
        "content": "Some believe it is only great power that can hold evil in check, but that is not what I have found. It is the small everyday deeds of ordinary folk that keep the darkness at bay. Small acts of kindness and love. -J. R. R. Tolkien"
    },
    "2024-08-12": {
        "content": "Be phenomenal or be forgotten!-Eric Thomas"
    },
    "2024-08-13": {
        "content": "When you have a choice to be right, or to be kind, choose to be kind. -Wayne W. Dyer"
    },
    "2024-08-14": {
        "content": "Human beings can alter their lives by altering their attitudes of mind. -William James"
    },
    "2024-08-15": {
        "content": "Health is the greatest possession. -Laozi"
    },
    "2024-08-16": {
        "content": "Let me not pray to be sheltered from dangers, but to be fearless in facing them. Let me not beg for the stilling of my pain, but for the heart to conquer it. -Rabindranath Tagore"
    },
    "2024-08-17": {
        "content": "And the day came when the risk to remain tight in the bud was more painful than the risk it took to blossom. -Anaïs Nin"
    },
    "2024-08-18": {
        "content": "There should be no boundaries to human endeavor. However bad life may seem, there is always hope. -Stephen Hawking"
    },
    "2024-08-19": {
        "content": "And I urge you to please notice when you are happy, and exclaim or murmur or think at some point, ‘If this isn’t nice, I don’t know what is.’-Kurt Vonnegut"
    },
    "2024-08-20": {
        "content": "It is your reaction to adversity, not the adversity itself, that determines how your life’s story will develop. -Dieter F. Uchtdorf"
    },
    "2024-08-21": {
        "content": "It isn’t what you have or who you are or where you are or what you are doing that makes you happy or unhappy. It is what you think about it. -Dale Carnegie"
    },
    "2024-08-22": {
        "content": "The more that you read, the more things you will know. The more that you learn, the more places you’ll go. -Dr. Seuss"
    },
    "2024-08-23": {
        "content": "All of our dreams can come true. -Walt Disney"
    },
    "2024-08-24": {
        "content": "The privilege of a lifetime is being who you are. -Joseph Campbell"
    },
    "2024-08-25": {
        "content": "No one is useless in this world who lightens the burdens of another. -Charles Dickens"
    },
    "2024-08-26": {
        "content": "Find a place inside where there’s joy, and the joy will burn out the pain. -Joseph Campbell"
    },
    "2024-08-27": {
        "content": "Don’t ask what the world needs. Ask what makes you come alive and go do it. Because what the world needs is more people who have come alive. -Howard Thurman"
    },
    "2024-08-28": {
        "content": "Your feelings are your greatest tools to help you create your life. -Rhonda Byrne"
    },
    "2024-08-29": {
        "content": "I deserve the best and I accept the best now. -Louise Hay"
    },
    "2024-08-30": {
        "content": "When you want to succeed as bad as you want to breathe, then you’ll be successful. -Eric Thomas"
    },
    "2024-08-31": {
        "content": "I hated every minute of training, but I said, “Don’t quit. Suffer now and live the rest of your life as a champion.”-Muhammad Ali"
    },
    "2024-09-01": {
        "content": "It is not the critic who counts, not the one who points out how the strong man stumbled or how the doer of deeds might have done them better. The credit belongs to the man who is actually in the arena, whose face is marred with sweat and dust and blood; who strives valiantly; who errs and comes short again and again; who knows the great enthusiasms, the great devotions, and spends himself in a worthy cause; who, if he wins, knows the triumph of high achievement; and who, if he fails, at least fails while daring greatly, so that his place shall never be with those cold and timid souls who know neither victory nor defeat. -Theodore Roosevelt"
    },
    "2024-09-02": {
        "content": "The biggest adventure you can ever take is to live the life of your dreams. -Oprah Winfrey"
    },
    "2024-09-03": {
        "content": "Without a struggle, there can be no progress. -Frederick Douglass"
    },
    "2024-09-04": {
        "content": "A dream written down with a date becomes a goal. A goal broken down into steps becomes a plan. A plan backed by action makes your dreams come true. -Greg Reid"
    },
    "2024-09-05": {
        "content": "Do the one thing you think you cannot do. Fail at it. Try again. Do better the second time. The only people who never tumble are those who never mount the high wire. -Oprah Winfrey"
    },
    "2024-09-06": {
        "content": "Expect change. Analyze the landscape. Take the opportunities. Stop being the chess piece; become the player. It’s your move. -Tony Robbins"
    },
    "2024-09-07": {
        "content": "You are free. You are powerful. You are good. You are love. You have value. You have purpose. All is well. -Esther Hicks"
    },
    "2024-09-08": {
        "content": "Even if you are on the right track, you’ll get run over if you just sit there. -Will Rogers"
    },
    "2024-09-09": {
        "content": "I think it is possible for ordinary people to choose to be extraordinary. -Elon Musk"
    },
    "2024-09-10": {
        "content": "You don’t learn to walk by following rules. You learn by doing and falling over. -Richard Branson"
    },
    "2024-09-11": {
        "content": "There's no talent here, this is hard work. This is an obsession. Talent does not exist, we are all equal as human beings. You could be anyone if you put in the time. You will reach the top, and that is that. I am not talented, I am obsessed. -Conor McGregor"
    },
    "2024-09-12": {
        "content": "A dream is not what you see while sleeping; it is something that does not let you sleep. -Abdul Kalam"
    },
    "2024-09-13": {
        "content": "When you have exhausted all possibilities, remember this – you haven’t. -Thomas A. Edison"
    },
    "2024-09-14": {
        "content": "Take chances, make mistakes. That’s how you grow. Pain nourishes your courage. You have to fail in order to practice being brave. -Mary Tyler Moore"
    },
    "2024-09-15": {
        "content": "Whatever you focus on is what you get. -Tony Robbins"
    },
    "2024-09-16": {
        "content": "If they can make penicillin out of moldy bread, then they can sure make something out of you. -Muhammad Ali"
    },
    "2024-09-17": {
        "content": "You were not born a winner, and you were not born a loser. You are what you make yourself be. -Lou Holtz"
    },
    "2024-09-18": {
        "content": "Success is your duty, obligation, and responsibility. -Grant Cardone"
    },
    "2024-09-19": {
        "content": "There is little difference in people, but that little difference makes a big difference. The little difference is attitude. The big difference is whether it is positive or negative. -W. Clement Stone"
    },
    "2024-09-20": {
        "content": "Leaders must be close enough to relate to others, but far enough ahead to motivate them. -John C. Maxwell"
    },
    "2024-09-21": {
        "content": "Never say never, because limits, like fears, are often just an illusion. -Michael Jordan"
    },
    "2024-09-22": {
        "content": "You must expect great things of yourself before you can do them. -Michael Jordan"
    },
    "2024-09-23": {
        "content": "In the world of business, the people who are most successful are those who are doing what they love. -Warren Buffett"
    },
    "2024-09-24": {
        "content": "Action will destroy your procrastination. -Og Mandino"
    },
    "2024-09-25": {
        "content": "Failure is not an option for me. Success is all I envision. -Conor McGregor"
    },
    "2024-09-26": {
        "content": "Success doesn’t come from what you do occasionally, it comes from what you do consistently. -Marie Forleo"
    },
    "2024-09-27": {
        "content": "Confidence and hard work are the best medicines to kill the disease called failure. They will make you a successful person. -Abdul Kalam"
    },
    "2024-09-28": {
        "content": "If you want to shine like the sun, first burn like the sun. -Abdul Kalam"
    },
    "2024-09-29": {
        "content": "While you\\'re out there partying, horsing around, someone out there at the same time is working hard. Someone is getting smarter and someone is winning. Just remember that. -Arnold Schwarzenegger"
    },
    "2024-09-30": {
        "content": "If you do what you’ve always done, you’ll get what you’ve always gotten. -Tony Robbins"
    },
    "2024-10-01": {
        "content": "Progress equals happiness. -Tony Robbins"
    },
    "2024-10-02": {
        "content": "You can have results or excuses. Not both. -Arnold Schwarzenegger"
    },
    "2024-10-03": {
        "content": "Discipline equals freedom. -Jocko Willink"
    },
    "2024-10-04": {
        "content": "Don’t dwell on what went wrong. Instead, focus on what to do next. Spend your energies on moving forward, toward finding the answer. -Denis Waitley"
    },
    "2024-10-05": {
        "content": "Be the leader you wish you had. -Simon Sinek"
    },
    "2024-10-06": {
        "content": "My attitude is that if you push me towards something that you think is a weakness, then I will turn that perceived weakness into a strength. -Michael Jordan"
    },
    "2024-10-07": {
        "content": "The greater danger for most of us lies not in setting our aim too high and falling short; but in setting our aim too low, and achieving our mark. -Michelangelo"
    },
    "2024-10-08": {
        "content": "Everybody has a dream, but not everybody has a grind. -Eric Thomas"
    },
    "2024-10-09": {
        "content": "Leaders are made, they are not born. They are made by hard effort, which is the price which all of us must pay to achieve any goal that is worthwhile. -Vince Lombardi"
    },
    "2024-10-10": {
        "content": "We choose to go to the moon in this decade and do the other things. Not because they are easy, but because they are hard. -John F. Kennedy"
    },
    "2024-10-11": {
        "content": "The greatest day in your life and mine is when we take total responsibility for our attitudes. That's the day we truly grow up. -John C. Maxwell"
    },
    "2024-10-12": {
        "content": "Be the silent watcher of your thoughts and behavior. You are beneath the thinker. You are the stillness beneath the mental noise. You are the love and joy beneath the pain. -Eckhart Tolle"
    },
    "2024-10-13": {
        "content": "If you can’t fly then run, if you can’t run then walk, if you can’t walk then crawl, but whatever you do you have to keep moving forward. -Martin Luther King Jr."
    },
    "2024-10-14": {
        "content": "Forgiveness is not an occasional act, it is a constant attitude. -Martin Luther King Jr."
    },
    "2024-10-15": {
        "content": "Too often we underestimate the power of a touch, a smile, a kind word, a listening ear, an honest compliment, or the smallest act of caring, all of which have the potential to turn a life around. -Leo Buscaglia"
    },
    "2024-10-16": {
        "content": "Keep your dreams alive. Understand that to achieve anything requires faith and belief in yourself, vision, hard work, determination, and dedication. Remember all things are possible for those who believe. -Gail Devers"
    },
    "2024-10-17": {
        "content": "Sport has the power to change the world. It has the power to inspire. It has the power to unite people in a way that little else does. It speaks to youth in a language they understand. Sport can create hope where once there was only despair. -Nelson Mandela"
    },
    "2024-10-18": {
        "content": "Ask for what you want. Believe that you deserve it, and then allow Life to give it to you. -Louise Hay"
    },
    "2024-10-19": {
        "content": "Live with intention. Walk to the edge. Listen hard. Practice wellness. Play with abandon. Laugh. Choose with no regret. Appreciate your friends. Continue to learn. Do what you love. Live as if this is all there is. -Mary Anne Radmacher"
    },
    "2024-10-20": {
        "content": "What you focus on expands, and when you focus on the goodness in your life, you create more of it. -Oprah Winfrey"
    },
    "2024-10-21": {
        "content": "You have power over your mind, not outside events. Realize this, and you will find strength. -Marcus Aurelius"
    },
    "2024-10-22": {
        "content": "Don’t make excuses for why you can’t get it done. Focus on all the reasons why you must make it happen. -Ralph Marston"
    },
    "2024-10-23": {
        "content": "Where there is love there is life. -Mahatma Gandhi"
    },
    "2024-10-24": {
        "content": "You’ve gotta dance like there’s nobody watching, love like you’ll never be hurt, sing like there’s nobody listening, and live like it’s heaven on earth. -William W. Purkey"
    },
    "2024-10-25": {
        "content": "Success is knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others. -John C. Maxwell"
    },
    "2024-10-26": {
        "content": "A dream you dream alone is only a dream. A dream you dream together is reality. -John Lennon"
    },
    "2024-10-27": {
        "content": "This is the real secret of life: to be completely engaged with what you are doing in the here and now. And instead of calling it work, realize it is play. -Alan Watts"
    },
    "2024-10-28": {
        "content": "The more you praise and celebrate your life, the more there is in life to celebrate. -Oprah Winfrey"
    },
    "2024-10-29": {
        "content": "Never doubt that a small group of thoughtful, committed citizens can change the world. Indeed, it is the only thing that ever has. -Margaret Mead"
    },
    "2024-10-30": {
        "content": "Push yourself, because no one else is going to do it for you. -Anonymous"
    },
    "2024-10-31": {
        "content": "True humility is not thinking less of yourself; it is thinking of yourself less. -C. S. Lewis"
    },
    "2024-11-01": {
        "content": "If you can change your mind, you can change your life. -William James"
    },
    "2024-11-02": {
        "content": "Focus on where you want to go, not on what you fear. -Tony Robbins"
    },
    "2024-11-03": {
        "content": "Do what you can, with what you have, where you are. -Theodore Roosevelt"
    },
    "2024-11-04": {
        "content": "Some changes look negative on the surface, but you will soon realize that space is being created in your life for something new to emerge. -Eckhart Tolle"
    },
    "2024-11-05": {
        "content": "If your actions inspire others to dream more, learn more, do more, and become more, you are a leader. -John Quincy Adams"
    },
    "2024-11-06": {
        "content": "Don’t worry about a thing, every little thing is gonna be alright. -Bob Marley"
    },
    "2024-11-07": {
        "content": "Dream big, stay positive, work hard, and enjoy the journey. -Urijah Faber"
    },
    "2024-11-08": {
        "content": "You are here to enable the divine purpose of the Universe to unfold. That is how important you are!-Eckhart Tolle"
    },
    "2024-11-09": {
        "content": "Live with passion!-Tony Robbins"
    },
    "2024-11-10": {
        "content": "Believe you can and you’re halfway there. -Theodore Roosevelt"
    },
    "2024-11-11": {
        "content": "Our lives begin to end the day we become silent about things that matter. -Martin Luther King Jr."
    },
    "2024-11-12": {
        "content": "Working hard for something we don’t care about is called stress; working hard for something we love is called passion. -Simon Sinek"
    },
    "2024-11-13": {
        "content": "The cave you fear to enter holds the treasure you seek. -Joseph Campbell"
    },
    "2024-11-14": {
        "content": "Leadership is about empathy. It is about having the ability to relate to and connect with people for the purpose of inspiring and empowering their lives. -Oprah Winfrey"
    },
    "2024-11-15": {
        "content": "There is nothing impossible to him who will try. -Alexander the Great"
    },
    "2024-11-16": {
        "content": "Most of the important things in the world have been accomplished by people who have kept on trying when there seemed to be no hope at all. -Dale Carnegie"
    },
    "2024-11-17": {
        "content": "We keep moving forward, opening new doors, and doing new things, because we’re curious and curiosity keeps leading us down new paths. -Walt Disney"
    },
    "2024-11-18": {
        "content": "Do what you have to do until you can do what you want to do. -Oprah Winfrey"
    },
    "2024-11-19": {
        "content": "Believing that you’re enough is what gives you the courage to be authentic. -Brené Brown"
    },
    "2024-11-20": {
        "content": "It is our choices, Harry, that show what we truly are, far more than our abilities. -J.K. Rowling"
    },
    "2024-11-21": {
        "content": "Follow your bliss and the universe will open doors for you where there were only walls. -Joseph Campbell"
    },
    "2024-11-22": {
        "content": "Dreams are not those that come to us while we are sleeping, but dreams are those that you don’t sleep before fulfilling them. -Abdul Kalam"
    },
    "2024-11-23": {
        "content": "Daring greatly means the courage to be vulnerable. It means to show up and be seen. To ask for what you need. To talk about how you’re feeling. To have the hard conversations. -Brené Brown"
    },
    "2024-11-24": {
        "content": "You will never ever be successful, until you turn your pain into greatness, until you allow your pain to push you from where you are to push you to where you need to be. Stop running from your pain and embrace your pain. Your pain is going to be a part of your prize, a part of your product. I challenge you to push yourself. -Eric Thomas"
    },
    "2024-11-25": {
        "content": "We are what we repeatedly do. Excellence, therefore, is not an act, but a habit. -Aristotle"
    },
    "2024-11-26": {
        "content": "A river cuts through rock, not because of its power, but because of its persistence. -Jim Watkins"
    },
    "2024-11-27": {
        "content": "Energy and persistence conquer all things. -Benjamin Franklin"
    },
    "2024-11-28": {
        "content": "Opportunities are usually disguised as hard work, so most people don’t recognize them. -Ann Landers"
    },
    "2024-11-29": {
        "content": "\"If you can't fly, then run. If you can't run, then walk. If you can't walk, then crawl, but whatever you do, you have to keep moving forward.\"-Martin Luther King Jr."
    },
    "2024-11-30": {
        "content": "With ordinary talent and extraordinary perseverance, all things are attainable. -Thomas Fowell Buxton"
    },
    "2024-12-01": {
        "content": "Our greatest glory is not in never failing, but in rising up every time we fail. -Ralph Waldo Emerson"
    },
    "2024-12-02": {
        "content": "Success is stumbling from failure to failure with no loss of enthusiasm. -Winston Churchill"
    },
    "2024-12-03": {
        "content": "Thankfully, persistence is a great substitute for talent. -Steve Martin"
    },
    "2024-12-04": {
        "content": "I'm a greater believer in luck, and I find that the harder I work, the more I have of it. -Thomas Jefferson"
    },
    "2024-12-05": {
        "content": "Only put off until tomorrow what you are willing to die having left undone. -Pablo Picasso"
    },
    "2024-12-06": {
        "content": "There are no secrets to success. It is the result of preparation, hard work, and learning from failure. -Colin Powell"
    },
    "2024-12-07": {
        "content": "Let me tell you the secret that has led me to my goal: my strength lies solely in my tenacity. -Louis Pasteur"
    },
    "2024-12-08": {
        "content": "Nothing in this world can take the place of persistence. Talent will not; nothing is more common than unsuccessful people with talent. Genius will not; unrewarded genius is almost a proverb. -Calvin Coolidge"
    },
    "2024-12-09": {
        "content": "The best way out is always through. -Robert Frost"
    },
    "2024-12-10": {
        "content": "Many of life’s failures are people who did not realize how close they were to success when they gave up. -Thomas A. Edison"
    },
    "2024-12-11": {
        "content": "We are made to persist. That’s how we find out who we are. -Tobias Wolff"
    },
    "2024-12-12": {
        "content": "Knowing trees, I understand the meaning of patience. Knowing grass, I can appreciate persistence. -Hal Borland"
    },
    "2024-12-13": {
        "content": "Dripping water hollows out stone, not through force but through persistence. -Ovid"
    },
    "2024-12-14": {
        "content": "Persistence is very important. You should not give up unless you are forced to give up. -Elon Musk"
    },
    "2024-12-15": {
        "content": "Flaming enthusiasm, backed by horse sense and persistence, is the quality that most frequently makes for success. -Dale Carnegie"
    },
    "2024-12-16": {
        "content": "Ambition is the path to success. Persistence is the vehicle you arrive in. -Bill Bradley"
    },
    "2024-12-17": {
        "content": "Focus on the solution, not the problem. -Walter Anderson"
    },
    "2024-12-18": {
        "content": "When life knocks you down, you have two choices – stay down or get up. -Tom Krause"
    },
    "2024-12-19": {
        "content": "Success is the sum of small efforts, repeated day in and day out. -Robert Collier"
    },
    "2024-12-20": {
        "content": "A dream is just a dream. A goal is a dream with a plan and a deadline. -Harvey MacKay"
    },
    "2024-12-21": {
        "content": "Never give up on something that you can’t go a day without thinking about. -Winston Churchill"
    },
    "2024-12-22": {
        "content": "Diamonds are nothing more than chunks of coal that stuck to their jobs. -Malcolm S. Forbes"
    },
    "2024-12-23": {
        "content": "Nothing can be done except little by little. -Charles Baudelaire"
    },
    "2024-12-24": {
        "content": "If you are going through hell, keep going. -Winston Churchill"
    },
    "2024-12-25": {
        "content": "The key of persistence opens all doors closed by resistance. -John Di Lemme"
    },
    "2024-12-26": {
        "content": "If we look at those who are the most successful in the world, persistence is the common denominator. -Justin Sachs"
    },
    "2024-12-27": {
        "content": "You can eat an elephant one bit at a time. -Mary Kay Ash"
    },
    "2024-12-28": {
        "content": "I do not think that there is any other quality so essential to success of any kind as the quality of perseverance. It overcomes almost everything, even nature. -John D. Rockefeller"
    },
    "2024-12-29": {
        "content": "If you want to turn a vision into reality, you have to give 100% and never stop believing in your dream. -Arnold Schwarzenegger"
    },
    "2024-12-30": {
        "content": "Run when you can, walk if you have to, crawl if you must; just never give up. -Dean Karnazes"
    },
    "2024-12-31": {
        "content": "Going that one more round when you don’t think you can – that’s what makes all the difference in your life. -Sylvester Stallone"
    },
    "2025-01-01": {
        "content": "We are what we repeatedly do. Excellence, therefore, is not an act, but a habit. -Aristotle"
    },
    "2025-01-02": {
        "content": "A river cuts through rock, not because of its power, but because of its persistence. -Jim Watkins"
    },
    "2025-01-03": {
        "content": "Energy and persistence conquer all things. -Benjamin Franklin"
    },
    "2025-01-04": {
        "content": "Opportunities are usually disguised as hard work, so most people don’t recognize them. -Ann Landers"
    },
    "2025-01-05": {
        "content": "\"If you can't fly, then run. If you can't run, then walk. If you can't walk, then crawl, but whatever you do, you have to keep moving forward.\"-Martin Luther King Jr."
    },
    "2025-01-06": {
        "content": "With ordinary talent and extraordinary perseverance, all things are attainable. -Thomas Fowell Buxton"
    },
    "2025-01-07": {
        "content": "Our greatest glory is not in never failing, but in rising up every time we fail. -Ralph Waldo Emerson"
    },
    "2025-01-08": {
        "content": "Success is stumbling from failure to failure with no loss of enthusiasm. -Winston Churchill"
    },
    "2025-01-09": {
        "content": "Thankfully, persistence is a great substitute for talent. -Steve Martin"
    },
    "2025-01-10": {
        "content": "I'm a greater believer in luck, and I find that the harder I work, the more I have of it. -Thomas Jefferson"
    },
    "2025-01-11": {
        "content": "Only put off until tomorrow what you are willing to die having left undone. -Pablo Picasso"
    },
    "2025-01-12": {
        "content": "There are no secrets to success. It is the result of preparation, hard work, and learning from failure. -Colin Powell"
    },
    "2025-01-13": {
        "content": "Let me tell you the secret that has led me to my goal: my strength lies solely in my tenacity. -Louis Pasteur"
    },
    "2025-01-14": {
        "content": "Nothing in this world can take the place of persistence. Talent will not; nothing is more common than unsuccessful people with talent. Genius will not; unrewarded genius is almost a proverb. -Calvin Coolidge"
    },
    "2025-01-15": {
        "content": "The best way out is always through. -Robert Frost"
    },
    "2025-01-16": {
        "content": "Many of life’s failures are people who did not realize how close they were to success when they gave up. -Thomas A. Edison"
    },
    "2025-01-17": {
        "content": "We are made to persist. That’s how we find out who we are. -Tobias Wolff"
    },
    "2025-01-18": {
        "content": "Knowing trees, I understand the meaning of patience. Knowing grass, I can appreciate persistence. -Hal Borland"
    },
    "2025-01-19": {
        "content": "Dripping water hollows out stone, not through force but through persistence. -Ovid"
    },
    "2025-01-20": {
        "content": "Persistence is very important. You should not give up unless you are forced to give up. -Elon Musk"
    },
    "2025-01-21": {
        "content": "Flaming enthusiasm, backed by horse sense and persistence, is the quality that most frequently makes for success. -Dale Carnegie"
    },
    "2025-01-22": {
        "content": "Ambition is the path to success. Persistence is the vehicle you arrive in. -Bill Bradley"
    },
    "2025-01-23": {
        "content": "Focus on the solution, not the problem. -Walter Anderson"
    },
    "2025-01-24": {
        "content": "When life knocks you down, you have two choices – stay down or get up. -Tom Krause"
    },
    "2025-01-25": {
        "content": "Success is the sum of small efforts, repeated day in and day out. -Robert Collier"
    },
    "2025-01-26": {
        "content": "A dream is just a dream. A goal is a dream with a plan and a deadline. -Harvey MacKay"
    },
    "2025-01-27": {
        "content": "Never give up on something that you can’t go a day without thinking about. -Winston Churchill"
    },
    "2025-01-28": {
        "content": "Diamonds are nothing more than chunks of coal that stuck to their jobs. -Malcolm S. Forbes"
    },
    "2025-01-29": {
        "content": "Nothing can be done except little by little. -Charles Baudelaire"
    },
    "2025-01-30": {
        "content": "If you are going through hell, keep going. -Winston Churchill"
    },
    "2025-01-31": {
        "content": "The key of persistence opens all doors closed by resistance. -John Di Lemme"
    },
    "2025-02-01": {
        "content": "If we look at those who are the most successful in the world, persistence is the common denominator. -Justin Sachs"
    },
    "2025-02-02": {
        "content": "You can eat an elephant one bit at a time. -Mary Kay Ash"
    },
    "2025-02-03": {
        "content": "I do not think that there is any other quality so essential to success of any kind as the quality of perseverance. It overcomes almost everything, even nature. -John D. Rockefeller"
    },
    "2025-02-04": {
        "content": "If you want to turn a vision into reality, you have to give 100% and never stop believing in your dream. -Arnold Schwarzenegger"
    },
    "2025-02-05": {
        "content": "Run when you can, walk if you have to, crawl if you must; just never give up. -Dean Karnazes"
    },
    "2025-02-06": {
        "content": "Going that one more round when you don’t think you can – that’s what makes all the difference in your life. -Sylvester Stallone"
    },
    "2025-02-07": {
        "content": "Listen to me, even when you lose, it’s OK to lose, but you can never get comfortable with it. You can never be satisfied with losing. When you lose, it’s got to hurt. -Eric Thomas"
    },
    "2025-02-08": {
        "content": "Keep walking the walk, one step at a time. -Joyce Meyer"
    },
    "2025-02-09": {
        "content": "We should not give up and we should not allow the problem to defeat us. -Abdul Kalam"
    },
    "2025-02-10": {
        "content": "By endurance we conquer. -Ernest Shackleton"
    },
    "2025-02-11": {
        "content": "The brick walls are there for a reason. The brick walls are not there to keep us out. The brick walls are there to give us a chance to show how badly we want something. Because the brick walls are there to stop the people who don’t want it badly enough. They’re there to stop the other people. -Randy Pausch"
    },
    "2025-02-12": {
        "content": "Success is almost totally dependent upon drive and persistence. The extra energy required to make another effort or try another approach is the secret of winning. -Denis Waitley"
    },
    "2025-02-13": {
        "content": "I’d made it this far and refused to give up because all my life I had always finished the race. -Louis Zamperini"
    },
    "2025-02-14": {
        "content": "Survival can be summed up in three words – never give up. That’s the heart of it, really. Just keep trying. -Bear Grylls"
    },
    "2025-02-15": {
        "content": "No more. No more excuses. No more: “I’ll start tomorrow.” No more: “Just this once.” No more accepting the shortfalls of my own will. No more taking the easy road. No more bowing down to whatever unhealthy or unproductive thoughts float through my mind. -Jocko Willink"
    },
    "2025-02-16": {
        "content": "Little strokes fell great oaks. -Benjamin Franklin"
    },
    "2025-02-17": {
        "content": "I am willing. I am wired to win. I got this. I embrace the uncertainty. I am not my thoughts; I am what I do. I am relentless. I expect nothing and accept everything. -Gary John Bishop"
    },
    "2025-02-18": {
        "content": "I have not failed 700 times. I have not failed once. I have succeeded in proving that those 700 ways will not work. When I have eliminated the ways that will not work, I will find the way that will work. -Thomas A. Edison"
    },
    "2025-02-19": {
        "content": "GRIT is Guts, Resilience, Industriousness and Tenacity. GRIT is the ability to focus, stay determined, stay optimistic in the face of a challenge, and simply work harder than the next guy or gal. -Linda Kaplan Thaler"
    },
    "2025-02-20": {
        "content": "I think my secret is that there are no shortcuts for hard work, determination, and having that ‘don’t give up’ attitude. -Jerry Rice"
    },
    "2025-02-21": {
        "content": "Never stop fighting until you arrive at your destined place – that is, the unique you. Have an aim in life, continuously acquire knowledge, work hard, and have perseverance to realize the great life. -Abdul Kalam"
    },
    "2025-02-22": {
        "content": "Don’t stop when you are tired. Stop when you are done. -David Goggins"
    },
    "2025-02-23": {
        "content": "Do not judge me by my successes, judge me by how many times I fell down and got back up again. -Nelson Mandela"
    },
    "2025-02-24": {
        "content": "What is not started today is never finished tomorrow. -Johann Wolfgang von Goethe"
    },
    "2025-02-25": {
        "content": "If you write a hundred short stories and they’re all bad, that doesn’t mean you’ve failed. You fail only if you stop writing. -Ray Bradbury"
    },
    "2025-02-26": {
        "content": "The master has failed more times than the beginner has even tried. -Stephen McCranie"
    },
    "2025-02-27": {
        "content": "To hell with circumstances; I create opportunities. -Bruce Lee"
    },
    "2025-02-28": {
        "content": "The only thing worse than starting something and failing is not starting something. -Seth Godin"
    },
    "2025-03-01": {
        "content": "Never leave till tomorrow that which you can do today. -Benjamin Franklin"
    },
    "2025-03-02": {
        "content": "Remember, hope is a good thing, maybe the best of things, and no good thing ever dies. -Stephen King"
    },
    "2025-03-03": {
        "content": "Entrepreneurs don’t finish when we are tired. We finish when we are done. -Robert T. Kiyosaki"
    },
    "2025-03-04": {
        "content": "Persistence and determination alone are omnipotent. -Calvin Coolidge"
    },
    "2025-03-05": {
        "content": "Paralyze resistance with persistence. -Woody Hayes"
    },
    "2025-03-06": {
        "content": "Success is never owned, it is rented, and the rent is due every day. -Rory Vaden"
    },
    "2025-03-07": {
        "content": "Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing or learning to do. -Pelé"
    },
    "2025-03-08": {
        "content": "There is no way around the hard work. Embrace it. -Roger Federer"
    },
    "2025-03-09": {
        "content": "A dream doesn’t become reality through magic; it takes sweat, determination and hard work. -Colin Powell"
    },
    "2025-03-10": {
        "content": "Learning never exhausts the mind. -Leonardo da Vinci"
    },
    "2025-03-11": {
        "content": "Anyone who has never made a mistake has never tried anything new. -Albert Einstein"
    },
    "2025-03-12": {
        "content": "Try to learn something about everything and everything about something. -Thomas Henry Huxley"
    },
    "2025-03-13": {
        "content": "A man only learns in two ways, one by reading, and the other by association with smarter people. -Will Rogers"
    },
    "2025-03-14": {
        "content": "You don’t understand anything until you learn it more than one way. -Marvin Minsky"
    },
    "2025-03-15": {
        "content": "Tell me and I forget, teach me and I may remember, involve me and I learn. -Benjamin Franklin"
    },
    "2025-03-16": {
        "content": "If you want to increase your success rate, double your failure rate. -Thomas J. Watson"
    },
    "2025-03-17": {
        "content": "Intelligence is what you use when you don’t know what to do. -Jean Piaget"
    },
    "2025-03-18": {
        "content": "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. -Alvin Toffler"
    },
    "2025-03-19": {
        "content": "It is what we know already that often prevents us from learning. -Claude Bernard"
    },
    "2025-03-20": {
        "content": "The whole purpose of education is to turn mirrors into windows. -Sydney J. Harris"
    },
    "2025-03-21": {
        "content": "I am not afraid of storms, for I am learning how to sail my ship. -Louisa May Alcott"
    },
    "2025-03-22": {
        "content": "The only person who is educated is the one who has learned how to learn and change. -Carl R. Rogers"
    },
    "2025-03-23": {
        "content": "I have never met a man so ignorant that I couldn’t learn something from him. -Galileo Galilei"
    },
    "2025-03-24": {
        "content": "Nothing ever goes away until it has taught us what we need to know. -Pema Chödrön"
    },
    "2025-03-25": {
        "content": "Practice makes perfect. After a long time of practicing, our work will become natural, skillful, swift, and steady. -Bruce Lee"
    },
    "2025-03-26": {
        "content": "Strive for progress, not perfection. -Anonymous"
    },
    "2025-03-27": {
        "content": "I am always doing what I cannot do yet, in order to learn how to do it. -Vincent van Gogh"
    },
    "2025-03-28": {
        "content": "I learned very early the difference between knowing the name of something and knowing something. -Richard P. Feynman"
    },
    "2025-03-29": {
        "content": "The capacity to learn is a gift. The ability to learn is a skill. The willingness to learn is a choice. -Brian Herbert"
    },
    "2025-03-30": {
        "content": "Learn everything you can, anytime you can, from anyone you can – there will always come a time when you will be grateful you did. -Sarah Caldwell"
    },
    "2025-03-31": {
        "content": "I do not think much of a man who is not wiser today than he was yesterday. -Abraham Lincoln"
    },
    "2025-04-01": {
        "content": "The key to success is dedication to life-long learning. -Stephen R. Covey"
    },
    "2025-04-02": {
        "content": "Be passionate and bold. Always keep learning. You stop doing useful things if you don’t learn. -Satya Nadella"
    },
    "2025-04-03": {
        "content": "The highest activity a human being can attain is learning for understanding, because to understand is to be free. -Baruch Spinoza"
    },
    "2025-04-04": {
        "content": "If you don’t keep learning, other people will pass you by. Temperament alone won’t do it – you need a lot of curiosity for a long, long time. -Charlie Munger"
    },
    "2025-04-05": {
        "content": "A learning organization is an organization that is continually expanding its capacity to create its future. -Peter Senge"
    },
    "2025-04-06": {
        "content": "The day you stop learning is the day you begin decaying. -Isaac Asimov"
    },
    "2025-04-07": {
        "content": "Learning is an ornament in prosperity, a refuge in adversity, and a provision in old age. -Aristotle"
    },
    "2025-04-08": {
        "content": "To learn hard things quickly, you must focus intensely without distraction. To learn, in other words, is an act of deep work. -Cal Newport"
    },
    "2025-04-09": {
        "content": "Any fool can know. The point is to understand. -Albert Einstein"
    },
    "2025-04-10": {
        "content": "Spend each day trying to be a little wiser than you were when you woke up. -Charlie Munger"
    },
    "2025-04-11": {
        "content": "Invest in yourself, in your education. There’s nothing better. -Sylvia Porter"
    },
    "2025-04-12": {
        "content": "Self-education is a continuing source of pleasure to me, for the more I know, the fuller my life is and the better I appreciate my own existence. -Isaac Asimov"
    },
    "2025-04-13": {
        "content": "You can get help from teachers, but you are going to have to learn a lot by yourself, sitting alone in a room. -Dr. Seuss"
    },
    "2025-04-14": {
        "content": "Learning happens when someone wants to learn, not when someone wants to teach. -Roger Schank"
    },
    "2025-04-15": {
        "content": "A person cannot teach another person directly; a person can only facilitate another’s learning. -Carl R. Rogers"
    },
    "2025-04-16": {
        "content": "Learning is not compulsory; it’s voluntary. Improvement is not compulsory; it’s voluntary. But to survive, we must learn. -W. Edwards Deming"
    },
    "2025-04-17": {
        "content": "I am always doing that which I can not do, in order that I may learn how to do it. -Pablo Picasso"
    },
    "2025-04-18": {
        "content": "No thief, however skillful, can rob one of knowledge, and that is why knowledge is the best and safest treasure to acquire. -L. Frank Baum"
    },
    "2025-04-19": {
        "content": "I think that’s the single best piece of advice: constantly think about how you could be doing things better and questioning yourself. -Elon Musk"
    },
    "2025-04-20": {
        "content": "A wise man can learn more from a foolish question than a fool can learn from a wise answer. -Bruce Lee"
    },
    "2025-04-21": {
        "content": "If I have seen further, it is by standing on the shoulders of giants. -Isaac Newton"
    },
    "2025-04-22": {
        "content": "What we know is a drop, what we don’t know is an ocean. -Isaac Newton"
    },
    "2025-04-23": {
        "content": "The beautiful thing about learning is that nobody can take it away from you. -B. B. King"
    },
    "2025-04-24": {
        "content": "If you want to be a writer, you must do two things above all others: read a lot and write a lot. -Stephen King"
    },
    "2025-04-25": {
        "content": "Repetition is the mother of skill. -Tony Robbins"
    },
    "2025-04-26": {
        "content": "Wonder is the beginning of wisdom. -Socrates"
    },
    "2025-04-27": {
        "content": "The purpose of education is to replace an empty mind with an open one. -Malcolm S. Forbes"
    },
    "2025-04-28": {
        "content": "Nothing in life is to be feared, it is only to be understood. Now is the time to understand more, so that we may fear less. -Marie Curie"
    },
    "2025-04-29": {
        "content": "Whenever you are asked if you can do a job, tell them, “Certainly I can!”. Then get busy and find out how to do it. -Theodore Roosevelt"
    },
    "2025-04-30": {
        "content": "We all need people who will give us feedback. That’s how we improve. -Bill Gates"
    },
    "2025-05-01": {
        "content": "Education is the key to unlocking the world, a passport to freedom. -Oprah Winfrey"
    },
    "2025-05-02": {
        "content": "Everything begins with an idea. -Earl Nightingale"
    },
    "2025-05-03": {
        "content": "The best investment you can make is in yourself. -Warren Buffett"
    },
    "2025-05-04": {
        "content": "It’s not about money or connections. It’s the willingness to outwork and outlearn everyone. -Mark Cuban"
    },
    "2025-05-05": {
        "content": "As long as you live, keep learning how to live. -Seneca"
    },
    "2025-05-06": {
        "content": "To learn to succeed, you must first learn to fail. -Michael Jordan"
    },
    "2025-05-07": {
        "content": "Don’t waste a good mistake, learn from it. -Robert T. Kiyosaki"
    },
    "2025-05-08": {
        "content": "To acquire knowledge, one must study; but to acquire wisdom, one must observe. -Marilyn Vos Savant"
    },
    "2025-05-09": {
        "content": "You live and learn. At any rate, you live. -Douglas Adams"
    },
    "2025-05-10": {
        "content": "I only know one thing, and that is I know nothing. -Socrates"
    },
    "2025-05-11": {
        "content": "Wisdom comes from experience. Experience is often a result of lack of wisdom. -Terry Pratchett"
    },
    "2025-05-12": {
        "content": "We can judge our progress by the courage of our questions and the depth of our answers, our willingness to embrace what is true rather than what feels good. -Carl Sagan"
    },
    "2025-05-13": {
        "content": "I would rather have questions that can’t be answered than answers that can’t be questioned. -Richard P. Feynman"
    },
    "2025-05-14": {
        "content": "I am always ready to learn, although I do not always like being taught. -Winston Churchill"
    },
    "2025-05-15": {
        "content": "He who loves practice without theory is like the sailor who boards ship without a rudder and compass and never knows where he may cast. -Leonardo da Vinci"
    },
    "2025-05-16": {
        "content": "It is better to create than to learn. Creating is the essence of life. -Julius Caesar"
    },
    "2025-05-17": {
        "content": "What the hand does the mind remembers. -Maria Montessori"
    },
    "2025-05-18": {
        "content": "Always walk through life as if you have something new to learn, and you will. -Vernon Howard"
    },
    "2025-05-19": {
        "content": "Failure is success if we learn from it. -Malcolm S. Forbes"
    },
    "2025-05-20": {
        "content": "Education is the best friend. An educated person is respected everywhere. Education beats beauty and youth. -Chanakya"
    },
    "2025-05-21": {
        "content": "Do not think that what is hard for you to master is humanly impossible; but if a thing is humanly possible, consider it to be within your reach. -Marcus Aurelius"
    },
    "2025-05-22": {
        "content": "Learning is a constant process of discovery – a process without end. -Bruce Lee"
    },
    "2025-05-23": {
        "content": "Being ignorant is not so much a shame as being unwilling to learn. -Benjamin Franklin"
    },
    "2025-05-24": {
        "content": "I am convinced that knowledge is power—to overcome the past, to change our own situations, to fight new obstacles, to make better decisions. -Ben Carson"
    },
    "2025-05-25": {
        "content": "Breathing in, I calm body and mind. Breathing out, I smile. Dwelling in the present moment, I know this is the only moment. -Thich Nhat Hanh"
    },
    "2025-05-26": {
        "content": "Too often we underestimate the power of a touch, a smile, a kind word, a listening ear, an honest compliment, or the smallest act of caring, all of which have the potential to turn a life around. -Leo Buscaglia"
    },
    "2025-05-27": {
        "content": "How we spend our days is, of course, how we spend our lives. -Annie Dillard"
    },
    "2025-05-28": {
        "content": "Nurture your mind with great thoughts, for you will never go any higher than you think. -Benjamin Disraeli"
    },
    "2025-05-29": {
        "content": "You don’t learn to walk by following rules. You learn by doing and falling over. -Richard Branson"
    },
    "2025-05-30": {
        "content": "It is impossible to live without failing at something, unless you live so cautiously that you might as well not have lived at all, in which case you fail by default. -J.K. Rowling"
    },
    "2025-05-31": {
        "content": "If you want to be happy, be. -Leo Tolstoy"
    },
    "2025-06-01": {
        "content": "Nobody can hurt me without my permission. -Mahatma Gandhi"
    },
    "2025-06-02": {
        "content": "The reason we struggle with insecurity is because we compare our behind-the-scenes with everyone else’s highlight reel. -Steven Furtick"
    },
    "2025-06-03": {
        "content": "Remember, today is the tomorrow you worried about yesterday. -Dale Carnegie"
    },
    "2025-06-04": {
        "content": "We must be willing to let go of the life we planned so as to have the life that is waiting for us. -Joseph Campbell"
    },
    "2025-06-05": {
        "content": "A team is not a group of people that work together. A team is a group of people that trust each other. -Simon Sinek"
    },
    "2025-06-06": {
        "content": "Perpetual optimism is a force multiplier. -Colin Powell"
    },
    "2025-06-07": {
        "content": "Count your age by friends, not years. Count your life by smiles, not tears. -John Lennon"
    },
    "2025-06-08": {
        "content": "Perseverance and spirit have done wonders in all ages. -George Washington"
    },
    "2025-06-09": {
        "content": "We are a way for the cosmos to know itself. -Carl Sagan"
    },
    "2025-06-10": {
        "content": "A good teacher can inspire hope, ignite the imagination, and instill a love of learning. -Brad Henry"
    },
    "2025-06-11": {
        "content": "One of the greatest discoveries a person makes, one of their great surprises, is to find they can do what they were afraid they couldn’t do. -Henry Ford"
    },
    "2025-06-12": {
        "content": "When was the last time you did something for the first time?-John C. Maxwell"
    },
    "2025-06-13": {
        "content": "If you are not in the process of becoming the person you want to be, you are automatically engaged in becoming the person you don’t want to be. -Dale Carnegie"
    },
    "2025-06-14": {
        "content": "Fortune favors the brave. -Latin proverb"
    },
    "2025-06-15": {
        "content": "Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful. -Albert Schweitzer"
    },
    "2025-06-16": {
        "content": "Don’t gain the world and lose your soul; wisdom is better than silver or gold. -Bob Marley"
    },
    "2025-06-17": {
        "content": "Begin at once to live, and count each separate day as a separate life. -Seneca"
    },
    "2025-06-18": {
        "content": "Unless someone like you cares a whole awful lot, nothing is going to get better. It’s not. -Dr. Seuss"
    },
    "2025-06-19": {
        "content": "They did not know it was impossible, so they did it. -Mark Twain"
    },
    "2025-06-20": {
        "content": "And the day came when the risk to remain tight in the bud was more painful than the risk it took to blossom. -Franklin D. Roosevelt"
    },
    "2025-06-21": {
        "content": "There's no talent here, this is hard work. This is an obsession. Talent does not exist, we are all equal as human beings. You could be anyone if you put in the time. You will reach the top, and that is that. I am not talented, I am obsessed. -Ralph Waldo Emerson"
    },
    "2025-06-22": {
        "content": "Success is your duty, obligation, and responsibility. -C. S. Lewis"
    },
    "2025-06-23": {
        "content": "The greatest day in your life and mine is when we take total responsibility for our attitudes. That's the day we truly grow up. -Alan Watts"
    },
    "2025-06-24": {
        "content": "REPEATED FROM LINE 6-T. Harv Eker"
    },
    "2025-06-25": {
        "content": "Keep your dreams alive. Understand that to achieve anything requires faith and belief in yourself, vision, hard work, determination, and dedication. Remember all things are possible for those who believe. -Lance Armstrong"
    },
    "2025-06-26": {
        "content": "This is the real secret of life: to be completely engaged with what you are doing in the here and now. And instead of calling it work, realize it is play. -John Muir"
    },
    "2025-06-27": {
        "content": "Some changes look negative on the surface, but you will soon realize that space is being created in your life for something new to emerge. -Edwin Louis Cole"
    },
    "2025-06-28": {
        "content": "If your actions inspire others to dream more, learn more, do more, and become more, you are a leader. -Eckhart Tolle"
    },
    "2025-06-29": {
        "content": "Be fearless in the pursuit of what sets your soul on fire. -Jennifer Lee"
    },
    "2025-06-30": {
        "content": "When people walk away from you, let them go. Your destiny is never tied to anyone who leaves you, and it doesn’t mean they are bad people. It just means that their part in your story is over. -T.D. Jakes"
    },
    "2025-07-01": {
        "content": "Leadership is the capacity to translate vision into reality. -Warren G. Bennis"
    },
    "2025-07-02": {
        "content": "The only thing worse than being blind is having sight but no vision. -Helen Keller"
    },
    "2025-07-03": {
        "content": "Hope is the thing with feathers that perches in the soul - and sings the tune without the words - and never stops at all. -Emily Dickinson"
    },
    "2025-07-04": {
        "content": "And by the way, everything in life is writable about if you have the outgoing guts to do it, and the imagination to improvise. The worst enemy to creativity is self-doubt. -Sylvia Plath"
    },
    "2025-07-05": {
        "content": "Nothing we do can change the past, but everything we do changes the future. -Ashleigh Brilliant"
    },
    "2025-07-06": {
        "content": "Leadership is a choice. It is not a rank. -Simon Sinek"
    },
    "2025-07-07": {
        "content": "All shall be well, and all shall be well and all manner of thing shall be well. -Julian of Norwich"
    },
    "2025-07-08": {
        "content": "Every one of us is, in the cosmic perspective, precious. If a human disagrees with you, let him live. In a hundred billion galaxies, you will not find another. -Carl Sagan"
    },
    "2025-07-09": {
        "content": "Intelligence plus character – that is the goal of true education. -Martin Luther King Jr."
    },
    "2025-07-10": {
        "content": "The more you lose yourself in something bigger than yourself, the more energy you will have. -Norman Vincent Peale"
    },
    "2025-07-11": {
        "content": "Get the fundamentals down and the level of everything you do will rise. -Michael Jordan"
    },
    "2025-07-12": {
        "content": "You can’t live at all unless you can live fully now. -Alan Watts"
    },
    "2025-07-13": {
        "content": "You are an infinite spiritual being having a temporary human experience. -Wayne W. Dyer"
    },
    "2025-07-14": {
        "content": "You have to dream before your dreams can come true. -Abdul Kalam"
    },
    "2025-07-15": {
        "content": "I can shake off everything as I write; my sorrows disappear, my courage is reborn. -Anne Frank"
    },
    "2025-07-16": {
        "content": "The goal is not to be perfect by the end. The goal is to be better today. -Simon Sinek"
    },
    "2025-07-17": {
        "content": "Go confidently in the direction of your dreams. Live the life you’ve imagined. -Henry David Thoreau"
    },
    "2025-07-18": {
        "content": "You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose. You’re on your own. And you know what you know. And you are the one who’ll decide where to go. -Dr. Seuss"
    },
    "2025-07-19": {
        "content": "What you focus on expands, and when you focus on the goodness in your life, you create more of it. -Oprah Winfrey"
    },
    "2025-07-20": {
        "content": "Everything I need to know is revealed to me. Everything I need comes to me. All is well in my life. -Louise Hay"
    },
    "2025-07-21": {
        "content": "I am totally safe in the Universe. I am at peace everywhere. I trust life. -Louise Hay"
    },
    "2025-07-22": {
        "content": "Turn your face to the sun and the shadows fall behind you. -Maori Proverb"
    },
    "2025-07-23": {
        "content": "Courage is not having the strength to go on; it is going on when you don’t have the strength. -Theodore Roosevelt"
    },
    "2025-07-24": {
        "content": "The future depends on what you do today. -Mahatma Gandhi"
    },
    "2025-07-25": {
        "content": "A winner is a dreamer who never gives up. -Nelson Mandela"
    },
    "2025-07-26": {
        "content": "Don’t cry because it’s over, smile because it happened. -Dr. Seuss"
    },
    "2025-07-27": {
        "content": "In three words I can sum up everything I’ve learned about life: it goes on. -Robert Frost"
    },
    "2025-07-28": {
        "content": "Live out of your imagination, not your history. -Stephen R. Covey"
    },
    "2025-07-29": {
        "content": "The way I see it, if you want the rainbow, you gotta put up with the rain. -Dolly Parton"
    },
    "2025-07-30": {
        "content": "The greatness of a man is not in how much wealth he acquires, but in his integrity and his ability to affect those around him positively. -Bob Marley"
    },
    "2025-07-31": {
        "content": "It is never too late to be what you might have been. -George Eliot"
    },
    "2025-08-01": {
        "content": "Adopting the right attitude can convert a negative stress into a positive one. -Hans Selye"
    },
    "2025-08-02": {
        "content": "Dare to live the life you have dreamed for yourself. Go forward and make your dreams come true. -Ralph Waldo Emerson"
    },
    "2025-08-03": {
        "content": "The time you enjoy wasting is not wasted time. -Bertrand Russell"
    },
    "2025-08-04": {
        "content": "The curious paradox is that when I accept myself just as I am, then I can change. -Carl R. Rogers"
    },
    "2025-08-05": {
        "content": "Be part of the solution, not part of the problem. -Stephen R. Covey"
    },
    "2025-08-06": {
        "content": "The secret to living is giving. -Tony Robbins"
    },
    "2025-08-07": {
        "content": "Make every day your masterpiece. -John Wooden"
    },
    "2025-08-08": {
        "content": "Never give up on what you really want to do-H. Jackson Brown Jr."
    },
    "2025-08-09": {
        "content": "Don’t look back – you’re not going that way. -Mary Engelbreit"
    },
    "2025-08-10": {
        "content": "Live, travel, adventure, bless, and don’t be sorry. -Jack Kerouac"
    },
    "2025-08-11": {
        "content": "In the midst of winter, I found there was, within me, an invincible summer. And that makes me happy. For it says that no matter how hard the world pushes against me, within me, there’s something stronger – something better, pushing right back. -Albert Camus"
    },
    "2025-08-12": {
        "content": "Some believe it is only great power that can hold evil in check, but that is not what I have found. It is the small everyday deeds of ordinary folk that keep the darkness at bay. Small acts of kindness and love. -J. R. R. Tolkien"
    },
    "2025-08-13": {
        "content": "Be phenomenal or be forgotten!-Eric Thomas"
    },
    "2025-08-14": {
        "content": "When you have a choice to be right, or to be kind, choose to be kind. -Wayne W. Dyer"
    },
    "2025-08-15": {
        "content": "Human beings can alter their lives by altering their attitudes of mind. -William James"
    },
    "2025-08-16": {
        "content": "Health is the greatest possession. -Laozi"
    },
    "2025-08-17": {
        "content": "Let me not pray to be sheltered from dangers, but to be fearless in facing them. Let me not beg for the stilling of my pain, but for the heart to conquer it. -Rabindranath Tagore"
    },
    "2025-08-18": {
        "content": "And the day came when the risk to remain tight in the bud was more painful than the risk it took to blossom. -Anaïs Nin"
    },
    "2025-08-19": {
        "content": "There should be no boundaries to human endeavor. However bad life may seem, there is always hope. -Stephen Hawking"
    },
    "2025-08-20": {
        "content": "And I urge you to please notice when you are happy, and exclaim or murmur or think at some point, ‘If this isn’t nice, I don’t know what is.’-Kurt Vonnegut"
    },
    "2025-08-21": {
        "content": "It is your reaction to adversity, not the adversity itself, that determines how your life’s story will develop. -Dieter F. Uchtdorf"
    },
    "2025-08-22": {
        "content": "It isn’t what you have or who you are or where you are or what you are doing that makes you happy or unhappy. It is what you think about it. -Dale Carnegie"
    },
    "2025-08-23": {
        "content": "The more that you read, the more things you will know. The more that you learn, the more places you’ll go. -Dr. Seuss"
    },
    "2025-08-24": {
        "content": "All of our dreams can come true. -Walt Disney"
    },
    "2025-08-25": {
        "content": "The privilege of a lifetime is being who you are. -Joseph Campbell"
    },
    "2025-08-26": {
        "content": "No one is useless in this world who lightens the burdens of another. -Charles Dickens"
    },
    "2025-08-27": {
        "content": "Find a place inside where there’s joy, and the joy will burn out the pain. -Joseph Campbell"
    },
    "2025-08-28": {
        "content": "Don’t ask what the world needs. Ask what makes you come alive and go do it. Because what the world needs is more people who have come alive. -Howard Thurman"
    },
    "2025-08-29": {
        "content": "Your feelings are your greatest tools to help you create your life. -Rhonda Byrne"
    },
    "2025-08-30": {
        "content": "I deserve the best and I accept the best now. -Louise Hay"
    },
    "2025-08-31": {
        "content": "When you want to succeed as bad as you want to breathe, then you’ll be successful. -Eric Thomas"
    },
    "2025-09-01": {
        "content": "I hated every minute of training, but I said, “Don’t quit. Suffer now and live the rest of your life as a champion.”-Muhammad Ali"
    },
    "2025-09-02": {
        "content": "It is not the critic who counts, not the one who points out how the strong man stumbled or how the doer of deeds might have done them better. The credit belongs to the man who is actually in the arena, whose face is marred with sweat and dust and blood; who strives valiantly; who errs and comes short again and again; who knows the great enthusiasms, the great devotions, and spends himself in a worthy cause; who, if he wins, knows the triumph of high achievement; and who, if he fails, at least fails while daring greatly, so that his place shall never be with those cold and timid souls who know neither victory nor defeat. -Theodore Roosevelt"
    },
    "2025-09-03": {
        "content": "The biggest adventure you can ever take is to live the life of your dreams. -Oprah Winfrey"
    },
    "2025-09-04": {
        "content": "Without a struggle, there can be no progress. -Frederick Douglass"
    },
    "2025-09-05": {
        "content": "A dream written down with a date becomes a goal. A goal broken down into steps becomes a plan. A plan backed by action makes your dreams come true. -Greg Reid"
    },
    "2025-09-06": {
        "content": "Do the one thing you think you cannot do. Fail at it. Try again. Do better the second time. The only people who never tumble are those who never mount the high wire. -Oprah Winfrey"
    },
    "2025-09-07": {
        "content": "Expect change. Analyze the landscape. Take the opportunities. Stop being the chess piece; become the player. It’s your move. -Tony Robbins"
    },
    "2025-09-08": {
        "content": "You are free. You are powerful. You are good. You are love. You have value. You have purpose. All is well. -Esther Hicks"
    },
    "2025-09-09": {
        "content": "Even if you are on the right track, you’ll get run over if you just sit there. -Will Rogers"
    },
    "2025-09-10": {
        "content": "I think it is possible for ordinary people to choose to be extraordinary. -Elon Musk"
    },
    "2025-09-11": {
        "content": "You don’t learn to walk by following rules. You learn by doing and falling over. -Richard Branson"
    },
    "2025-09-12": {
        "content": "There's no talent here, this is hard work. This is an obsession. Talent does not exist, we are all equal as human beings. You could be anyone if you put in the time. You will reach the top, and that is that. I am not talented, I am obsessed. -Conor McGregor"
    },
    "2025-09-13": {
        "content": "A dream is not what you see while sleeping; it is something that does not let you sleep. -Abdul Kalam"
    },
    "2025-09-14": {
        "content": "When you have exhausted all possibilities, remember this – you haven’t. -Thomas A. Edison"
    },
    "2025-09-15": {
        "content": "Take chances, make mistakes. That’s how you grow. Pain nourishes your courage. You have to fail in order to practice being brave. -Mary Tyler Moore"
    },
    "2025-09-16": {
        "content": "Whatever you focus on is what you get. -Tony Robbins"
    },
    "2025-09-17": {
        "content": "If they can make penicillin out of moldy bread, then they can sure make something out of you. -Muhammad Ali"
    },
    "2025-09-18": {
        "content": "You were not born a winner, and you were not born a loser. You are what you make yourself be. -Lou Holtz"
    },
    "2025-09-19": {
        "content": "Success is your duty, obligation, and responsibility. -Grant Cardone"
    },
    "2025-09-20": {
        "content": "There is little difference in people, but that little difference makes a big difference. The little difference is attitude. The big difference is whether it is positive or negative. -W. Clement Stone"
    },
    "2025-09-21": {
        "content": "Leaders must be close enough to relate to others, but far enough ahead to motivate them. -John C. Maxwell"
    },
    "2025-09-22": {
        "content": "Never say never, because limits, like fears, are often just an illusion. -Michael Jordan"
    },
    "2025-09-23": {
        "content": "You must expect great things of yourself before you can do them. -Michael Jordan"
    },
    "2025-09-24": {
        "content": "In the world of business, the people who are most successful are those who are doing what they love. -Warren Buffett"
    },
    "2025-09-25": {
        "content": "Action will destroy your procrastination. -Og Mandino"
    },
    "2025-09-26": {
        "content": "Failure is not an option for me. Success is all I envision. -Conor McGregor"
    },
    "2025-09-27": {
        "content": "Success doesn’t come from what you do occasionally, it comes from what you do consistently. -Marie Forleo"
    },
    "2025-09-28": {
        "content": "Confidence and hard work are the best medicines to kill the disease called failure. They will make you a successful person. -Abdul Kalam"
    },
    "2025-09-29": {
        "content": "If you want to shine like the sun, first burn like the sun. -Abdul Kalam"
    },
    "2025-09-30": {
        "content": "While you\\'re out there partying, horsing around, someone out there at the same time is working hard. Someone is getting smarter and someone is winning. Just remember that. -Arnold Schwarzenegger"
    },
    "2025-10-01": {
        "content": "If you do what you’ve always done, you’ll get what you’ve always gotten. -Tony Robbins"
    },
    "2025-10-02": {
        "content": "Progress equals happiness. -Tony Robbins"
    },
    "2025-10-03": {
        "content": "You can have results or excuses. Not both. -Arnold Schwarzenegger"
    },
    "2025-10-04": {
        "content": "Discipline equals freedom. -Jocko Willink"
    },
    "2025-10-05": {
        "content": "Don’t dwell on what went wrong. Instead, focus on what to do next. Spend your energies on moving forward, toward finding the answer. -Denis Waitley"
    },
    "2025-10-06": {
        "content": "Be the leader you wish you had. -Simon Sinek"
    },
    "2025-10-07": {
        "content": "My attitude is that if you push me towards something that you think is a weakness, then I will turn that perceived weakness into a strength. -Michael Jordan"
    },
    "2025-10-08": {
        "content": "The greater danger for most of us lies not in setting our aim too high and falling short; but in setting our aim too low, and achieving our mark. -Michelangelo"
    },
    "2025-10-09": {
        "content": "Everybody has a dream, but not everybody has a grind. -Eric Thomas"
    },
    "2025-10-10": {
        "content": "Leaders are made, they are not born. They are made by hard effort, which is the price which all of us must pay to achieve any goal that is worthwhile. -Vince Lombardi"
    },
    "2025-10-11": {
        "content": "We choose to go to the moon in this decade and do the other things. Not because they are easy, but because they are hard. -John F. Kennedy"
    },
    "2025-10-12": {
        "content": "The greatest day in your life and mine is when we take total responsibility for our attitudes. That's the day we truly grow up. -John C. Maxwell"
    },
    "2025-10-13": {
        "content": "Be the silent watcher of your thoughts and behavior. You are beneath the thinker. You are the stillness beneath the mental noise. You are the love and joy beneath the pain. -Eckhart Tolle"
    },
    "2025-10-14": {
        "content": "If you can’t fly then run, if you can’t run then walk, if you can’t walk then crawl, but whatever you do you have to keep moving forward. -Martin Luther King Jr."
    },
    "2025-10-15": {
        "content": "Forgiveness is not an occasional act, it is a constant attitude. -Martin Luther King Jr."
    },
    "2025-10-16": {
        "content": "Too often we underestimate the power of a touch, a smile, a kind word, a listening ear, an honest compliment, or the smallest act of caring, all of which have the potential to turn a life around. -Leo Buscaglia"
    },
    "2025-10-17": {
        "content": "Keep your dreams alive. Understand that to achieve anything requires faith and belief in yourself, vision, hard work, determination, and dedication. Remember all things are possible for those who believe. -Gail Devers"
    },
    "2025-10-18": {
        "content": "Sport has the power to change the world. It has the power to inspire. It has the power to unite people in a way that little else does. It speaks to youth in a language they understand. Sport can create hope where once there was only despair. -Nelson Mandela"
    },
    "2025-10-19": {
        "content": "Ask for what you want. Believe that you deserve it, and then allow Life to give it to you. -Louise Hay"
    },
    "2025-10-20": {
        "content": "Live with intention. Walk to the edge. Listen hard. Practice wellness. Play with abandon. Laugh. Choose with no regret. Appreciate your friends. Continue to learn. Do what you love. Live as if this is all there is. -Mary Anne Radmacher"
    },
    "2025-10-21": {
        "content": "What you focus on expands, and when you focus on the goodness in your life, you create more of it. -Oprah Winfrey"
    },
    "2025-10-22": {
        "content": "You have power over your mind, not outside events. Realize this, and you will find strength. -Marcus Aurelius"
    },
    "2025-10-23": {
        "content": "Don’t make excuses for why you can’t get it done. Focus on all the reasons why you must make it happen. -Ralph Marston"
    },
    "2025-10-24": {
        "content": "Where there is love there is life. -Mahatma Gandhi"
    },
    "2025-10-25": {
        "content": "You’ve gotta dance like there’s nobody watching, love like you’ll never be hurt, sing like there’s nobody listening, and live like it’s heaven on earth. -William W. Purkey"
    },
    "2025-10-26": {
        "content": "Success is knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others. -John C. Maxwell"
    },
    "2025-10-27": {
        "content": "A dream you dream alone is only a dream. A dream you dream together is reality. -John Lennon"
    },
    "2025-10-28": {
        "content": "This is the real secret of life: to be completely engaged with what you are doing in the here and now. And instead of calling it work, realize it is play. -Alan Watts"
    },
    "2025-10-29": {
        "content": "The more you praise and celebrate your life, the more there is in life to celebrate. -Oprah Winfrey"
    },
    "2025-10-30": {
        "content": "Never doubt that a small group of thoughtful, committed citizens can change the world. Indeed, it is the only thing that ever has. -Margaret Mead"
    },
    "2025-10-31": {
        "content": "Push yourself, because no one else is going to do it for you. -Anonymous"
    },
    "2025-11-01": {
        "content": "True humility is not thinking less of yourself; it is thinking of yourself less. -C. S. Lewis"
    },
    "2025-11-02": {
        "content": "If you can change your mind, you can change your life. -William James"
    },
    "2025-11-03": {
        "content": "Focus on where you want to go, not on what you fear. -Tony Robbins"
    },
    "2025-11-04": {
        "content": "Do what you can, with what you have, where you are. -Theodore Roosevelt"
    },
    "2025-11-05": {
        "content": "Some changes look negative on the surface, but you will soon realize that space is being created in your life for something new to emerge. -Eckhart Tolle"
    },
    "2025-11-06": {
        "content": "If your actions inspire others to dream more, learn more, do more, and become more, you are a leader. -John Quincy Adams"
    },
    "2025-11-07": {
        "content": "Don’t worry about a thing, every little thing is gonna be alright. -Bob Marley"
    },
    "2025-11-08": {
        "content": "Dream big, stay positive, work hard, and enjoy the journey. -Urijah Faber"
    },
    "2025-11-09": {
        "content": "You are here to enable the divine purpose of the Universe to unfold. That is how important you are!-Eckhart Tolle"
    },
    "2025-11-10": {
        "content": "Live with passion!-Tony Robbins"
    },
    "2025-11-11": {
        "content": "Believe you can and you’re halfway there. -Theodore Roosevelt"
    },
    "2025-11-12": {
        "content": "Our lives begin to end the day we become silent about things that matter. -Martin Luther King Jr."
    },
    "2025-11-13": {
        "content": "Working hard for something we don’t care about is called stress; working hard for something we love is called passion. -Simon Sinek"
    },
    "2025-11-14": {
        "content": "The cave you fear to enter holds the treasure you seek. -Joseph Campbell"
    },
    "2025-11-15": {
        "content": "Leadership is about empathy. It is about having the ability to relate to and connect with people for the purpose of inspiring and empowering their lives. -Oprah Winfrey"
    },
    "2025-11-16": {
        "content": "There is nothing impossible to him who will try. -Alexander the Great"
    },
    "2025-11-17": {
        "content": "Most of the important things in the world have been accomplished by people who have kept on trying when there seemed to be no hope at all. -Dale Carnegie"
    },
    "2025-11-18": {
        "content": "We keep moving forward, opening new doors, and doing new things, because we’re curious and curiosity keeps leading us down new paths. -Walt Disney"
    },
    "2025-11-19": {
        "content": "Do what you have to do until you can do what you want to do. -Oprah Winfrey"
    },
    "2025-11-20": {
        "content": "Believing that you’re enough is what gives you the courage to be authentic. -Brené Brown"
    },
    "2025-11-21": {
        "content": "It is our choices, Harry, that show what we truly are, far more than our abilities. -J.K. Rowling"
    },
    "2025-11-22": {
        "content": "Follow your bliss and the universe will open doors for you where there were only walls. -Joseph Campbell"
    },
    "2025-11-23": {
        "content": "Dreams are not those that come to us while we are sleeping, but dreams are those that you don’t sleep before fulfilling them. -Abdul Kalam"
    },
    "2025-11-24": {
        "content": "Daring greatly means the courage to be vulnerable. It means to show up and be seen. To ask for what you need. To talk about how you’re feeling. To have the hard conversations. -Brené Brown"
    },
    "2025-11-25": {
        "content": "You will never ever be successful, until you turn your pain into greatness, until you allow your pain to push you from where you are to push you to where you need to be. Stop running from your pain and embrace your pain. Your pain is going to be a part of your prize, a part of your product. I challenge you to push yourself. -Eric Thomas"
    },
    "2025-11-26": {
        "content": "We are what we repeatedly do. Excellence, therefore, is not an act, but a habit. -Aristotle"
    },
    "2025-11-27": {
        "content": "A river cuts through rock, not because of its power, but because of its persistence. -Jim Watkins"
    },
    "2025-11-28": {
        "content": "Energy and persistence conquer all things. -Benjamin Franklin"
    },
    "2025-11-29": {
        "content": "Opportunities are usually disguised as hard work, so most people don’t recognize them. -Ann Landers"
    },
    "2025-11-30": {
        "content": "\"If you can't fly, then run. If you can't run, then walk. If you can't walk, then crawl, but whatever you do, you have to keep moving forward.\"-Martin Luther King Jr."
    },
    "2025-12-01": {
        "content": "With ordinary talent and extraordinary perseverance, all things are attainable. -Thomas Fowell Buxton"
    },
    "2025-12-02": {
        "content": "Our greatest glory is not in never failing, but in rising up every time we fail. -Ralph Waldo Emerson"
    },
    "2025-12-03": {
        "content": "Success is stumbling from failure to failure with no loss of enthusiasm. -Winston Churchill"
    },
    "2025-12-04": {
        "content": "Thankfully, persistence is a great substitute for talent. -Steve Martin"
    },
    "2025-12-05": {
        "content": "I'm a greater believer in luck, and I find that the harder I work, the more I have of it. -Thomas Jefferson"
    },
    "2025-12-06": {
        "content": "Only put off until tomorrow what you are willing to die having left undone. -Pablo Picasso"
    },
    "2025-12-07": {
        "content": "There are no secrets to success. It is the result of preparation, hard work, and learning from failure. -Colin Powell"
    },
    "2025-12-08": {
        "content": "Let me tell you the secret that has led me to my goal: my strength lies solely in my tenacity. -Louis Pasteur"
    },
    "2025-12-09": {
        "content": "Nothing in this world can take the place of persistence. Talent will not; nothing is more common than unsuccessful people with talent. Genius will not; unrewarded genius is almost a proverb. -Calvin Coolidge"
    },
    "2025-12-10": {
        "content": "The best way out is always through. -Robert Frost"
    },
    "2025-12-11": {
        "content": "Many of life’s failures are people who did not realize how close they were to success when they gave up. -Thomas A. Edison"
    },
    "2025-12-12": {
        "content": "We are made to persist. That’s how we find out who we are. -Tobias Wolff"
    },
    "2025-12-13": {
        "content": "Knowing trees, I understand the meaning of patience. Knowing grass, I can appreciate persistence. -Hal Borland"
    },
    "2025-12-14": {
        "content": "Dripping water hollows out stone, not through force but through persistence. -Ovid"
    },
    "2025-12-15": {
        "content": "Persistence is very important. You should not give up unless you are forced to give up. -Elon Musk"
    },
    "2025-12-16": {
        "content": "Flaming enthusiasm, backed by horse sense and persistence, is the quality that most frequently makes for success. -Dale Carnegie"
    },
    "2025-12-17": {
        "content": "Ambition is the path to success. Persistence is the vehicle you arrive in. -Bill Bradley"
    },
    "2025-12-18": {
        "content": "Focus on the solution, not the problem. -Walter Anderson"
    },
    "2025-12-19": {
        "content": "When life knocks you down, you have two choices – stay down or get up. -Tom Krause"
    },
    "2025-12-20": {
        "content": "Success is the sum of small efforts, repeated day in and day out. -Robert Collier"
    },
    "2025-12-21": {
        "content": "A dream is just a dream. A goal is a dream with a plan and a deadline. -Harvey MacKay"
    },
    "2025-12-22": {
        "content": "Never give up on something that you can’t go a day without thinking about. -Winston Churchill"
    },
    "2025-12-23": {
        "content": "Diamonds are nothing more than chunks of coal that stuck to their jobs. -Malcolm S. Forbes"
    },
    "2025-12-24": {
        "content": "Nothing can be done except little by little. -Charles Baudelaire"
    },
    "2025-12-25": {
        "content": "If you are going through hell, keep going. -Winston Churchill"
    },
    "2025-12-26": {
        "content": "The key of persistence opens all doors closed by resistance. -John Di Lemme"
    },
    "2025-12-27": {
        "content": "If we look at those who are the most successful in the world, persistence is the common denominator. -Justin Sachs"
    },
    "2025-12-28": {
        "content": "You can eat an elephant one bit at a time. -Mary Kay Ash"
    },
    "2025-12-29": {
        "content": "I do not think that there is any other quality so essential to success of any kind as the quality of perseverance. It overcomes almost everything, even nature. -John D. Rockefeller"
    },
    "2025-12-30": {
        "content": "If you want to turn a vision into reality, you have to give 100% and never stop believing in your dream. -Arnold Schwarzenegger"
    },
    "2025-12-31": {
        "content": "Run when you can, walk if you have to, crawl if you must; just never give up. -Dean Karnazes"
    },
    "2026-01-01": {
        "content": "We are what we repeatedly do. Excellence, therefore, is not an act, but a habit. -Aristotle"
    },
    "2026-01-02": {
        "content": "A river cuts through rock, not because of its power, but because of its persistence. -Jim Watkins"
    },
    "2026-01-03": {
        "content": "Energy and persistence conquer all things. -Benjamin Franklin"
    },
    "2026-01-04": {
        "content": "Opportunities are usually disguised as hard work, so most people don’t recognize them. -Ann Landers"
    },
    "2026-01-05": {
        "content": "\"If you can't fly, then run. If you can't run, then walk. If you can't walk, then crawl, but whatever you do, you have to keep moving forward.\"-Martin Luther King Jr."
    },
    "2026-01-06": {
        "content": "With ordinary talent and extraordinary perseverance, all things are attainable. -Thomas Fowell Buxton"
    },
    "2026-01-07": {
        "content": "Our greatest glory is not in never failing, but in rising up every time we fail. -Ralph Waldo Emerson"
    },
    "2026-01-08": {
        "content": "Success is stumbling from failure to failure with no loss of enthusiasm. -Winston Churchill"
    },
    "2026-01-09": {
        "content": "Thankfully, persistence is a great substitute for talent. -Steve Martin"
    },
    "2026-01-10": {
        "content": "I'm a greater believer in luck, and I find that the harder I work, the more I have of it. -Thomas Jefferson"
    },
    "2026-01-11": {
        "content": "Only put off until tomorrow what you are willing to die having left undone. -Pablo Picasso"
    },
    "2026-01-12": {
        "content": "There are no secrets to success. It is the result of preparation, hard work, and learning from failure. -Colin Powell"
    },
    "2026-01-13": {
        "content": "Let me tell you the secret that has led me to my goal: my strength lies solely in my tenacity. -Louis Pasteur"
    },
    "2026-01-14": {
        "content": "Nothing in this world can take the place of persistence. Talent will not; nothing is more common than unsuccessful people with talent. Genius will not; unrewarded genius is almost a proverb. -Calvin Coolidge"
    },
    "2026-01-15": {
        "content": "The best way out is always through. -Robert Frost"
    },
    "2026-01-16": {
        "content": "Many of life’s failures are people who did not realize how close they were to success when they gave up. -Thomas A. Edison"
    },
    "2026-01-17": {
        "content": "We are made to persist. That’s how we find out who we are. -Tobias Wolff"
    },
    "2026-01-18": {
        "content": "Knowing trees, I understand the meaning of patience. Knowing grass, I can appreciate persistence. -Hal Borland"
    },
    "2026-01-19": {
        "content": "Dripping water hollows out stone, not through force but through persistence. -Ovid"
    },
    "2026-01-20": {
        "content": "Persistence is very important. You should not give up unless you are forced to give up. -Elon Musk"
    },
    "2026-01-21": {
        "content": "Flaming enthusiasm, backed by horse sense and persistence, is the quality that most frequently makes for success. -Dale Carnegie"
    },
    "2026-01-22": {
        "content": "Ambition is the path to success. Persistence is the vehicle you arrive in. -Bill Bradley"
    },
    "2026-01-23": {
        "content": "Focus on the solution, not the problem. -Walter Anderson"
    },
    "2026-01-24": {
        "content": "When life knocks you down, you have two choices – stay down or get up. -Tom Krause"
    },
    "2026-01-25": {
        "content": "Success is the sum of small efforts, repeated day in and day out. -Robert Collier"
    },
    "2026-01-26": {
        "content": "A dream is just a dream. A goal is a dream with a plan and a deadline. -Harvey MacKay"
    },
    "2026-01-27": {
        "content": "Never give up on something that you can’t go a day without thinking about. -Winston Churchill"
    },
    "2026-01-28": {
        "content": "Diamonds are nothing more than chunks of coal that stuck to their jobs. -Malcolm S. Forbes"
    },
    "2026-01-29": {
        "content": "Nothing can be done except little by little. -Charles Baudelaire"
    },
    "2026-01-30": {
        "content": "If you are going through hell, keep going. -Winston Churchill"
    },
    "2026-01-31": {
        "content": "The key of persistence opens all doors closed by resistance. -John Di Lemme"
    },
    "2026-02-01": {
        "content": "If we look at those who are the most successful in the world, persistence is the common denominator. -Justin Sachs"
    },
    "2026-02-02": {
        "content": "You can eat an elephant one bit at a time. -Mary Kay Ash"
    },
    "2026-02-03": {
        "content": "I do not think that there is any other quality so essential to success of any kind as the quality of perseverance. It overcomes almost everything, even nature. -John D. Rockefeller"
    },
    "2026-02-04": {
        "content": "If you want to turn a vision into reality, you have to give 100% and never stop believing in your dream. -Arnold Schwarzenegger"
    },
    "2026-02-05": {
        "content": "Run when you can, walk if you have to, crawl if you must; just never give up. -Dean Karnazes"
    },
    "2026-02-06": {
        "content": "Going that one more round when you don’t think you can – that’s what makes all the difference in your life. -Sylvester Stallone"
    },
    "2026-02-07": {
        "content": "Listen to me, even when you lose, it’s OK to lose, but you can never get comfortable with it. You can never be satisfied with losing. When you lose, it’s got to hurt. -Eric Thomas"
    },
    "2026-02-08": {
        "content": "Keep walking the walk, one step at a time. -Joyce Meyer"
    },
    "2026-02-09": {
        "content": "We should not give up and we should not allow the problem to defeat us. -Abdul Kalam"
    },
    "2026-02-10": {
        "content": "By endurance we conquer. -Ernest Shackleton"
    },
    "2026-02-11": {
        "content": "The brick walls are there for a reason. The brick walls are not there to keep us out. The brick walls are there to give us a chance to show how badly we want something. Because the brick walls are there to stop the people who don’t want it badly enough. They’re there to stop the other people. -Randy Pausch"
    },
    "2026-02-12": {
        "content": "Success is almost totally dependent upon drive and persistence. The extra energy required to make another effort or try another approach is the secret of winning. -Denis Waitley"
    },
    "2026-02-13": {
        "content": "I’d made it this far and refused to give up because all my life I had always finished the race. -Louis Zamperini"
    },
    "2026-02-14": {
        "content": "Survival can be summed up in three words – never give up. That’s the heart of it, really. Just keep trying. -Bear Grylls"
    },
    "2026-02-15": {
        "content": "No more. No more excuses. No more: “I’ll start tomorrow.” No more: “Just this once.” No more accepting the shortfalls of my own will. No more taking the easy road. No more bowing down to whatever unhealthy or unproductive thoughts float through my mind. -Jocko Willink"
    },
    "2026-02-16": {
        "content": "Little strokes fell great oaks. -Benjamin Franklin"
    },
    "2026-02-17": {
        "content": "I am willing. I am wired to win. I got this. I embrace the uncertainty. I am not my thoughts; I am what I do. I am relentless. I expect nothing and accept everything. -Gary John Bishop"
    },
    "2026-02-18": {
        "content": "I have not failed 700 times. I have not failed once. I have succeeded in proving that those 700 ways will not work. When I have eliminated the ways that will not work, I will find the way that will work. -Thomas A. Edison"
    },
    "2026-02-19": {
        "content": "GRIT is Guts, Resilience, Industriousness and Tenacity. GRIT is the ability to focus, stay determined, stay optimistic in the face of a challenge, and simply work harder than the next guy or gal. -Linda Kaplan Thaler"
    },
    "2026-02-20": {
        "content": "I think my secret is that there are no shortcuts for hard work, determination, and having that ‘don’t give up’ attitude. -Jerry Rice"
    },
    "2026-02-21": {
        "content": "Never stop fighting until you arrive at your destined place – that is, the unique you. Have an aim in life, continuously acquire knowledge, work hard, and have perseverance to realize the great life. -Abdul Kalam"
    },
    "2026-02-22": {
        "content": "Don’t stop when you are tired. Stop when you are done. -David Goggins"
    },
    "2026-02-23": {
        "content": "Do not judge me by my successes, judge me by how many times I fell down and got back up again. -Nelson Mandela"
    },
    "2026-02-24": {
        "content": "What is not started today is never finished tomorrow. -Johann Wolfgang von Goethe"
    },
    "2026-02-25": {
        "content": "If you write a hundred short stories and they’re all bad, that doesn’t mean you’ve failed. You fail only if you stop writing. -Ray Bradbury"
    },
    "2026-02-26": {
        "content": "The master has failed more times than the beginner has even tried. -Stephen McCranie"
    },
    "2026-02-27": {
        "content": "To hell with circumstances; I create opportunities. -Bruce Lee"
    },
    "2026-02-28": {
        "content": "The only thing worse than starting something and failing is not starting something. -Seth Godin"
    },
    "2026-03-01": {
        "content": "Never leave till tomorrow that which you can do today. -Benjamin Franklin"
    },
    "2026-03-02": {
        "content": "Remember, hope is a good thing, maybe the best of things, and no good thing ever dies. -Stephen King"
    },
    "2026-03-03": {
        "content": "Entrepreneurs don’t finish when we are tired. We finish when we are done. -Robert T. Kiyosaki"
    },
    "2026-03-04": {
        "content": "Persistence and determination alone are omnipotent. -Calvin Coolidge"
    },
    "2026-03-05": {
        "content": "Paralyze resistance with persistence. -Woody Hayes"
    },
    "2026-03-06": {
        "content": "Success is never owned, it is rented, and the rent is due every day. -Rory Vaden"
    },
    "2026-03-07": {
        "content": "Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing or learning to do. -Pelé"
    },
    "2026-03-08": {
        "content": "There is no way around the hard work. Embrace it. -Roger Federer"
    },
    "2026-03-09": {
        "content": "A dream doesn’t become reality through magic; it takes sweat, determination and hard work. -Colin Powell"
    },
    "2026-03-10": {
        "content": "Learning never exhausts the mind. -Leonardo da Vinci"
    },
    "2026-03-11": {
        "content": "Anyone who has never made a mistake has never tried anything new. -Albert Einstein"
    },
    "2026-03-12": {
        "content": "Try to learn something about everything and everything about something. -Thomas Henry Huxley"
    },
    "2026-03-13": {
        "content": "A man only learns in two ways, one by reading, and the other by association with smarter people. -Will Rogers"
    },
    "2026-03-14": {
        "content": "You don’t understand anything until you learn it more than one way. -Marvin Minsky"
    },
    "2026-03-15": {
        "content": "Tell me and I forget, teach me and I may remember, involve me and I learn. -Benjamin Franklin"
    },
    "2026-03-16": {
        "content": "If you want to increase your success rate, double your failure rate. -Thomas J. Watson"
    },
    "2026-03-17": {
        "content": "Intelligence is what you use when you don’t know what to do. -Jean Piaget"
    },
    "2026-03-18": {
        "content": "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. -Alvin Toffler"
    },
    "2026-03-19": {
        "content": "It is what we know already that often prevents us from learning. -Claude Bernard"
    },
    "2026-03-20": {
        "content": "The whole purpose of education is to turn mirrors into windows. -Sydney J. Harris"
    },
    "2026-03-21": {
        "content": "I am not afraid of storms, for I am learning how to sail my ship. -Louisa May Alcott"
    },
    "2026-03-22": {
        "content": "The only person who is educated is the one who has learned how to learn and change. -Carl R. Rogers"
    },
    "2026-03-23": {
        "content": "I have never met a man so ignorant that I couldn’t learn something from him. -Galileo Galilei"
    },
    "2026-03-24": {
        "content": "Nothing ever goes away until it has taught us what we need to know. -Pema Chödrön"
    },
    "2026-03-25": {
        "content": "Practice makes perfect. After a long time of practicing, our work will become natural, skillful, swift, and steady. -Bruce Lee"
    },
    "2026-03-26": {
        "content": "Strive for progress, not perfection. -Anonymous"
    },
    "2026-03-27": {
        "content": "I am always doing what I cannot do yet, in order to learn how to do it. -Vincent van Gogh"
    },
    "2026-03-28": {
        "content": "I learned very early the difference between knowing the name of something and knowing something. -Richard P. Feynman"
    },
    "2026-03-29": {
        "content": "The capacity to learn is a gift. The ability to learn is a skill. The willingness to learn is a choice. -Brian Herbert"
    },
    "2026-03-30": {
        "content": "Learn everything you can, anytime you can, from anyone you can – there will always come a time when you will be grateful you did. -Sarah Caldwell"
    },
    "2026-03-31": {
        "content": "I do not think much of a man who is not wiser today than he was yesterday. -Abraham Lincoln"
    },
    "2026-04-01": {
        "content": "The key to success is dedication to life-long learning. -Stephen R. Covey"
    },
    "2026-04-02": {
        "content": "Be passionate and bold. Always keep learning. You stop doing useful things if you don’t learn. -Satya Nadella"
    },
    "2026-04-03": {
        "content": "The highest activity a human being can attain is learning for understanding, because to understand is to be free. -Baruch Spinoza"
    },
    "2026-04-04": {
        "content": "If you don’t keep learning, other people will pass you by. Temperament alone won’t do it – you need a lot of curiosity for a long, long time. -Charlie Munger"
    },
    "2026-04-05": {
        "content": "A learning organization is an organization that is continually expanding its capacity to create its future. -Peter Senge"
    },
    "2026-04-06": {
        "content": "The day you stop learning is the day you begin decaying. -Isaac Asimov"
    },
    "2026-04-07": {
        "content": "Learning is an ornament in prosperity, a refuge in adversity, and a provision in old age. -Aristotle"
    },
    "2026-04-08": {
        "content": "To learn hard things quickly, you must focus intensely without distraction. To learn, in other words, is an act of deep work. -Cal Newport"
    },
    "2026-04-09": {
        "content": "Any fool can know. The point is to understand. -Albert Einstein"
    },
    "2026-04-10": {
        "content": "Spend each day trying to be a little wiser than you were when you woke up. -Charlie Munger"
    },
    "2026-04-11": {
        "content": "Invest in yourself, in your education. There’s nothing better. -Sylvia Porter"
    },
    "2026-04-12": {
        "content": "Self-education is a continuing source of pleasure to me, for the more I know, the fuller my life is and the better I appreciate my own existence. -Isaac Asimov"
    },
    "2026-04-13": {
        "content": "You can get help from teachers, but you are going to have to learn a lot by yourself, sitting alone in a room. -Dr. Seuss"
    },
    "2026-04-14": {
        "content": "Learning happens when someone wants to learn, not when someone wants to teach. -Roger Schank"
    },
    "2026-04-15": {
        "content": "A person cannot teach another person directly; a person can only facilitate another’s learning. -Carl R. Rogers"
    },
    "2026-04-16": {
        "content": "Learning is not compulsory; it’s voluntary. Improvement is not compulsory; it’s voluntary. But to survive, we must learn. -W. Edwards Deming"
    },
    "2026-04-17": {
        "content": "I am always doing that which I can not do, in order that I may learn how to do it. -Pablo Picasso"
    },
    "2026-04-18": {
        "content": "No thief, however skillful, can rob one of knowledge, and that is why knowledge is the best and safest treasure to acquire. -L. Frank Baum"
    },
    "2026-04-19": {
        "content": "I think that’s the single best piece of advice: constantly think about how you could be doing things better and questioning yourself. -Elon Musk"
    },
    "2026-04-20": {
        "content": "A wise man can learn more from a foolish question than a fool can learn from a wise answer. -Bruce Lee"
    },
    "2026-04-21": {
        "content": "If I have seen further, it is by standing on the shoulders of giants. -Isaac Newton"
    },
    "2026-04-22": {
        "content": "What we know is a drop, what we don’t know is an ocean. -Isaac Newton"
    },
    "2026-04-23": {
        "content": "The beautiful thing about learning is that nobody can take it away from you. -B. B. King"
    },
    "2026-04-24": {
        "content": "If you want to be a writer, you must do two things above all others: read a lot and write a lot. -Stephen King"
    },
    "2026-04-25": {
        "content": "Repetition is the mother of skill. -Tony Robbins"
    },
    "2026-04-26": {
        "content": "Wonder is the beginning of wisdom. -Socrates"
    },
    "2026-04-27": {
        "content": "The purpose of education is to replace an empty mind with an open one. -Malcolm S. Forbes"
    },
    "2026-04-28": {
        "content": "Nothing in life is to be feared, it is only to be understood. Now is the time to understand more, so that we may fear less. -Marie Curie"
    },
    "2026-04-29": {
        "content": "Whenever you are asked if you can do a job, tell them, “Certainly I can!”. Then get busy and find out how to do it. -Theodore Roosevelt"
    },
    "2026-04-30": {
        "content": "We all need people who will give us feedback. That’s how we improve. -Bill Gates"
    },
    "2026-05-01": {
        "content": "Education is the key to unlocking the world, a passport to freedom. -Oprah Winfrey"
    },
    "2026-05-02": {
        "content": "Everything begins with an idea. -Earl Nightingale"
    },
    "2026-05-03": {
        "content": "The best investment you can make is in yourself. -Warren Buffett"
    },
    "2026-05-04": {
        "content": "It’s not about money or connections. It’s the willingness to outwork and outlearn everyone. -Mark Cuban"
    },
    "2026-05-05": {
        "content": "As long as you live, keep learning how to live. -Seneca"
    },
    "2026-05-06": {
        "content": "To learn to succeed, you must first learn to fail. -Michael Jordan"
    },
    "2026-05-07": {
        "content": "Don’t waste a good mistake, learn from it. -Robert T. Kiyosaki"
    },
    "2026-05-08": {
        "content": "To acquire knowledge, one must study; but to acquire wisdom, one must observe. -Marilyn Vos Savant"
    },
    "2026-05-09": {
        "content": "You live and learn. At any rate, you live. -Douglas Adams"
    },
    "2026-05-10": {
        "content": "I only know one thing, and that is I know nothing. -Socrates"
    },
    "2026-05-11": {
        "content": "Wisdom comes from experience. Experience is often a result of lack of wisdom. -Terry Pratchett"
    },
    "2026-05-12": {
        "content": "We can judge our progress by the courage of our questions and the depth of our answers, our willingness to embrace what is true rather than what feels good. -Carl Sagan"
    },
    "2026-05-13": {
        "content": "I would rather have questions that can’t be answered than answers that can’t be questioned. -Richard P. Feynman"
    },
    "2026-05-14": {
        "content": "I am always ready to learn, although I do not always like being taught. -Winston Churchill"
    },
    "2026-05-15": {
        "content": "He who loves practice without theory is like the sailor who boards ship without a rudder and compass and never knows where he may cast. -Leonardo da Vinci"
    },
    "2026-05-16": {
        "content": "It is better to create than to learn. Creating is the essence of life. -Julius Caesar"
    },
    "2026-05-17": {
        "content": "What the hand does the mind remembers. -Maria Montessori"
    },
    "2026-05-18": {
        "content": "Always walk through life as if you have something new to learn, and you will. -Vernon Howard"
    },
    "2026-05-19": {
        "content": "Failure is success if we learn from it. -Malcolm S. Forbes"
    },
    "2026-05-20": {
        "content": "Education is the best friend. An educated person is respected everywhere. Education beats beauty and youth. -Chanakya"
    },
    "2026-05-21": {
        "content": "Do not think that what is hard for you to master is humanly impossible; but if a thing is humanly possible, consider it to be within your reach. -Marcus Aurelius"
    },
    "2026-05-22": {
        "content": "Learning is a constant process of discovery – a process without end. -Bruce Lee"
    },
    "2026-05-23": {
        "content": "Being ignorant is not so much a shame as being unwilling to learn. -Benjamin Franklin"
    },
    "2026-05-24": {
        "content": "I am convinced that knowledge is power—to overcome the past, to change our own situations, to fight new obstacles, to make better decisions. -Ben Carson"
    },
    "2026-05-25": {
        "content": "Breathing in, I calm body and mind. Breathing out, I smile. Dwelling in the present moment, I know this is the only moment. -Thich Nhat Hanh"
    },
    "2026-05-26": {
        "content": "Too often we underestimate the power of a touch, a smile, a kind word, a listening ear, an honest compliment, or the smallest act of caring, all of which have the potential to turn a life around. -Leo Buscaglia"
    },
    "2026-05-27": {
        "content": "How we spend our days is, of course, how we spend our lives. -Annie Dillard"
    },
    "2026-05-28": {
        "content": "Nurture your mind with great thoughts, for you will never go any higher than you think. -Benjamin Disraeli"
    },
    "2026-05-29": {
        "content": "You don’t learn to walk by following rules. You learn by doing and falling over. -Richard Branson"
    },
    "2026-05-30": {
        "content": "It is impossible to live without failing at something, unless you live so cautiously that you might as well not have lived at all, in which case you fail by default. -J.K. Rowling"
    },
    "2026-05-31": {
        "content": "If you want to be happy, be. -Leo Tolstoy"
    },
    "2026-06-01": {
        "content": "Nobody can hurt me without my permission. -Mahatma Gandhi"
    },
    "2026-06-02": {
        "content": "The reason we struggle with insecurity is because we compare our behind-the-scenes with everyone else’s highlight reel. -Steven Furtick"
    },
    "2026-06-03": {
        "content": "Remember, today is the tomorrow you worried about yesterday. -Dale Carnegie"
    },
    "2026-06-04": {
        "content": "We must be willing to let go of the life we planned so as to have the life that is waiting for us. -Joseph Campbell"
    },
    "2026-06-05": {
        "content": "A team is not a group of people that work together. A team is a group of people that trust each other. -Simon Sinek"
    },
    "2026-06-06": {
        "content": "Perpetual optimism is a force multiplier. -Colin Powell"
    },
    "2026-06-07": {
        "content": "Count your age by friends, not years. Count your life by smiles, not tears. -John Lennon"
    },
    "2026-06-08": {
        "content": "Perseverance and spirit have done wonders in all ages. -George Washington"
    },
    "2026-06-09": {
        "content": "We are a way for the cosmos to know itself. -Carl Sagan"
    },
    "2026-06-10": {
        "content": "A good teacher can inspire hope, ignite the imagination, and instill a love of learning. -Brad Henry"
    },
    "2026-06-11": {
        "content": "One of the greatest discoveries a person makes, one of their great surprises, is to find they can do what they were afraid they couldn’t do. -Henry Ford"
    },
    "2026-06-12": {
        "content": "When was the last time you did something for the first time?-John C. Maxwell"
    },
    "2026-06-13": {
        "content": "If you are not in the process of becoming the person you want to be, you are automatically engaged in becoming the person you don’t want to be. -Dale Carnegie"
    },
    "2026-06-14": {
        "content": "Fortune favors the brave. -Latin proverb"
    },
    "2026-06-15": {
        "content": "Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful. -Albert Schweitzer"
    },
    "2026-06-16": {
        "content": "Don’t gain the world and lose your soul; wisdom is better than silver or gold. -Bob Marley"
    },
    "2026-06-17": {
        "content": "Begin at once to live, and count each separate day as a separate life. -Seneca"
    },
    "2026-06-18": {
        "content": "Unless someone like you cares a whole awful lot, nothing is going to get better. It’s not. -Dr. Seuss"
    },
    "2026-06-19": {
        "content": "They did not know it was impossible, so they did it. -Mark Twain"
    },
    "2026-06-20": {
        "content": "And the day came when the risk to remain tight in the bud was more painful than the risk it took to blossom. -Franklin D. Roosevelt"
    },
    "2026-06-21": {
        "content": "There's no talent here, this is hard work. This is an obsession. Talent does not exist, we are all equal as human beings. You could be anyone if you put in the time. You will reach the top, and that is that. I am not talented, I am obsessed. -Ralph Waldo Emerson"
    },
    "2026-06-22": {
        "content": "Success is your duty, obligation, and responsibility. -C. S. Lewis"
    },
    "2026-06-23": {
        "content": "The greatest day in your life and mine is when we take total responsibility for our attitudes. That's the day we truly grow up. -Alan Watts"
    },
    "2026-06-24": {
        "content": "REPEATED FROM LINE 6-T. Harv Eker"
    },
    "2026-06-25": {
        "content": "Keep your dreams alive. Understand that to achieve anything requires faith and belief in yourself, vision, hard work, determination, and dedication. Remember all things are possible for those who believe. -Lance Armstrong"
    },
    "2026-06-26": {
        "content": "This is the real secret of life: to be completely engaged with what you are doing in the here and now. And instead of calling it work, realize it is play. -John Muir"
    },
    "2026-06-27": {
        "content": "Some changes look negative on the surface, but you will soon realize that space is being created in your life for something new to emerge. -Edwin Louis Cole"
    },
    "2026-06-28": {
        "content": "If your actions inspire others to dream more, learn more, do more, and become more, you are a leader. -Eckhart Tolle"
    },
    "2026-06-29": {
        "content": "Be fearless in the pursuit of what sets your soul on fire. -Jennifer Lee"
    },
    "2026-06-30": {
        "content": "When people walk away from you, let them go. Your destiny is never tied to anyone who leaves you, and it doesn’t mean they are bad people. It just means that their part in your story is over. -T.D. Jakes"
    },
    "2026-07-01": {
        "content": "Leadership is the capacity to translate vision into reality. -Warren G. Bennis"
    },
    "2026-07-02": {
        "content": "The only thing worse than being blind is having sight but no vision. -Helen Keller"
    },
    "2026-07-03": {
        "content": "Hope is the thing with feathers that perches in the soul - and sings the tune without the words - and never stops at all. -Emily Dickinson"
    },
    "2026-07-04": {
        "content": "And by the way, everything in life is writable about if you have the outgoing guts to do it, and the imagination to improvise. The worst enemy to creativity is self-doubt. -Sylvia Plath"
    },
    "2026-07-05": {
        "content": "Nothing we do can change the past, but everything we do changes the future. -Ashleigh Brilliant"
    },
    "2026-07-06": {
        "content": "Leadership is a choice. It is not a rank. -Simon Sinek"
    },
    "2026-07-07": {
        "content": "All shall be well, and all shall be well and all manner of thing shall be well. -Julian of Norwich"
    },
    "2026-07-08": {
        "content": "Every one of us is, in the cosmic perspective, precious. If a human disagrees with you, let him live. In a hundred billion galaxies, you will not find another. -Carl Sagan"
    },
    "2026-07-09": {
        "content": "Intelligence plus character – that is the goal of true education. -Martin Luther King Jr."
    },
    "2026-07-10": {
        "content": "The more you lose yourself in something bigger than yourself, the more energy you will have. -Norman Vincent Peale"
    },
    "2026-07-11": {
        "content": "Get the fundamentals down and the level of everything you do will rise. -Michael Jordan"
    },
    "2026-07-12": {
        "content": "You can’t live at all unless you can live fully now. -Alan Watts"
    },
    "2026-07-13": {
        "content": "You are an infinite spiritual being having a temporary human experience. -Wayne W. Dyer"
    },
    "2026-07-14": {
        "content": "You have to dream before your dreams can come true. -Abdul Kalam"
    },
    "2026-07-15": {
        "content": "I can shake off everything as I write; my sorrows disappear, my courage is reborn. -Anne Frank"
    },
    "2026-07-16": {
        "content": "The goal is not to be perfect by the end. The goal is to be better today. -Simon Sinek"
    },
    "2026-07-17": {
        "content": "Go confidently in the direction of your dreams. Live the life you’ve imagined. -Henry David Thoreau"
    },
    "2026-07-18": {
        "content": "You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose. You’re on your own. And you know what you know. And you are the one who’ll decide where to go. -Dr. Seuss"
    },
    "2026-07-19": {
        "content": "What you focus on expands, and when you focus on the goodness in your life, you create more of it. -Oprah Winfrey"
    },
    "2026-07-20": {
        "content": "Everything I need to know is revealed to me. Everything I need comes to me. All is well in my life. -Louise Hay"
    },
    "2026-07-21": {
        "content": "I am totally safe in the Universe. I am at peace everywhere. I trust life. -Louise Hay"
    },
    "2026-07-22": {
        "content": "Turn your face to the sun and the shadows fall behind you. -Maori Proverb"
    },
    "2026-07-23": {
        "content": "Courage is not having the strength to go on; it is going on when you don’t have the strength. -Theodore Roosevelt"
    },
    "2026-07-24": {
        "content": "The future depends on what you do today. -Mahatma Gandhi"
    },
    "2026-07-25": {
        "content": "A winner is a dreamer who never gives up. -Nelson Mandela"
    },
    "2026-07-26": {
        "content": "Don’t cry because it’s over, smile because it happened. -Dr. Seuss"
    },
    "2026-07-27": {
        "content": "In three words I can sum up everything I’ve learned about life: it goes on. -Robert Frost"
    },
    "2026-07-28": {
        "content": "Live out of your imagination, not your history. -Stephen R. Covey"
    },
    "2026-07-29": {
        "content": "The way I see it, if you want the rainbow, you gotta put up with the rain. -Dolly Parton"
    },
    "2026-07-30": {
        "content": "The greatness of a man is not in how much wealth he acquires, but in his integrity and his ability to affect those around him positively. -Bob Marley"
    },
    "2026-07-31": {
        "content": "It is never too late to be what you might have been. -George Eliot"
    },
    "2026-08-01": {
        "content": "Adopting the right attitude can convert a negative stress into a positive one. -Hans Selye"
    },
    "2026-08-02": {
        "content": "Dare to live the life you have dreamed for yourself. Go forward and make your dreams come true. -Ralph Waldo Emerson"
    },
    "2026-08-03": {
        "content": "The time you enjoy wasting is not wasted time. -Bertrand Russell"
    },
    "2026-08-04": {
        "content": "The curious paradox is that when I accept myself just as I am, then I can change. -Carl R. Rogers"
    },
    "2026-08-05": {
        "content": "Be part of the solution, not part of the problem. -Stephen R. Covey"
    },
    "2026-08-06": {
        "content": "The secret to living is giving. -Tony Robbins"
    },
    "2026-08-07": {
        "content": "Make every day your masterpiece. -John Wooden"
    },
    "2026-08-08": {
        "content": "Never give up on what you really want to do-H. Jackson Brown Jr."
    },
    "2026-08-09": {
        "content": "Don’t look back – you’re not going that way. -Mary Engelbreit"
    },
    "2026-08-10": {
        "content": "Live, travel, adventure, bless, and don’t be sorry. -Jack Kerouac"
    },
    "2026-08-11": {
        "content": "In the midst of winter, I found there was, within me, an invincible summer. And that makes me happy. For it says that no matter how hard the world pushes against me, within me, there’s something stronger – something better, pushing right back. -Albert Camus"
    },
    "2026-08-12": {
        "content": "Some believe it is only great power that can hold evil in check, but that is not what I have found. It is the small everyday deeds of ordinary folk that keep the darkness at bay. Small acts of kindness and love. -J. R. R. Tolkien"
    },
    "2026-08-13": {
        "content": "Be phenomenal or be forgotten!-Eric Thomas"
    },
    "2026-08-14": {
        "content": "When you have a choice to be right, or to be kind, choose to be kind. -Wayne W. Dyer"
    },
    "2026-08-15": {
        "content": "Human beings can alter their lives by altering their attitudes of mind. -William James"
    },
    "2026-08-16": {
        "content": "Health is the greatest possession. -Laozi"
    },
    "2026-08-17": {
        "content": "Let me not pray to be sheltered from dangers, but to be fearless in facing them. Let me not beg for the stilling of my pain, but for the heart to conquer it. -Rabindranath Tagore"
    },
    "2026-08-18": {
        "content": "And the day came when the risk to remain tight in the bud was more painful than the risk it took to blossom. -Anaïs Nin"
    },
    "2026-08-19": {
        "content": "There should be no boundaries to human endeavor. However bad life may seem, there is always hope. -Stephen Hawking"
    },
    "2026-08-20": {
        "content": "And I urge you to please notice when you are happy, and exclaim or murmur or think at some point, ‘If this isn’t nice, I don’t know what is.’-Kurt Vonnegut"
    },
    "2026-08-21": {
        "content": "It is your reaction to adversity, not the adversity itself, that determines how your life’s story will develop. -Dieter F. Uchtdorf"
    },
    "2026-08-22": {
        "content": "It isn’t what you have or who you are or where you are or what you are doing that makes you happy or unhappy. It is what you think about it. -Dale Carnegie"
    },
    "2026-08-23": {
        "content": "The more that you read, the more things you will know. The more that you learn, the more places you’ll go. -Dr. Seuss"
    },
    "2026-08-24": {
        "content": "All of our dreams can come true. -Walt Disney"
    },
    "2026-08-25": {
        "content": "The privilege of a lifetime is being who you are. -Joseph Campbell"
    },
    "2026-08-26": {
        "content": "No one is useless in this world who lightens the burdens of another. -Charles Dickens"
    },
    "2026-08-27": {
        "content": "Find a place inside where there’s joy, and the joy will burn out the pain. -Joseph Campbell"
    },
    "2026-08-28": {
        "content": "Don’t ask what the world needs. Ask what makes you come alive and go do it. Because what the world needs is more people who have come alive. -Howard Thurman"
    },
    "2026-08-29": {
        "content": "Your feelings are your greatest tools to help you create your life. -Rhonda Byrne"
    },
    "2026-08-30": {
        "content": "I deserve the best and I accept the best now. -Louise Hay"
    },
    "2026-08-31": {
        "content": "When you want to succeed as bad as you want to breathe, then you’ll be successful. -Eric Thomas"
    },
    "2026-09-01": {
        "content": "I hated every minute of training, but I said, “Don’t quit. Suffer now and live the rest of your life as a champion.”-Muhammad Ali"
    },
    "2026-09-02": {
        "content": "It is not the critic who counts, not the one who points out how the strong man stumbled or how the doer of deeds might have done them better. The credit belongs to the man who is actually in the arena, whose face is marred with sweat and dust and blood; who strives valiantly; who errs and comes short again and again; who knows the great enthusiasms, the great devotions, and spends himself in a worthy cause; who, if he wins, knows the triumph of high achievement; and who, if he fails, at least fails while daring greatly, so that his place shall never be with those cold and timid souls who know neither victory nor defeat. -Theodore Roosevelt"
    },
    "2026-09-03": {
        "content": "The biggest adventure you can ever take is to live the life of your dreams. -Oprah Winfrey"
    },
    "2026-09-04": {
        "content": "Without a struggle, there can be no progress. -Frederick Douglass"
    },
    "2026-09-05": {
        "content": "A dream written down with a date becomes a goal. A goal broken down into steps becomes a plan. A plan backed by action makes your dreams come true. -Greg Reid"
    },
    "2026-09-06": {
        "content": "Do the one thing you think you cannot do. Fail at it. Try again. Do better the second time. The only people who never tumble are those who never mount the high wire. -Oprah Winfrey"
    },
    "2026-09-07": {
        "content": "Expect change. Analyze the landscape. Take the opportunities. Stop being the chess piece; become the player. It’s your move. -Tony Robbins"
    },
    "2026-09-08": {
        "content": "You are free. You are powerful. You are good. You are love. You have value. You have purpose. All is well. -Esther Hicks"
    },
    "2026-09-09": {
        "content": "Even if you are on the right track, you’ll get run over if you just sit there. -Will Rogers"
    },
    "2026-09-10": {
        "content": "I think it is possible for ordinary people to choose to be extraordinary. -Elon Musk"
    },
    "2026-09-11": {
        "content": "You don’t learn to walk by following rules. You learn by doing and falling over. -Richard Branson"
    },
    "2026-09-12": {
        "content": "There's no talent here, this is hard work. This is an obsession. Talent does not exist, we are all equal as human beings. You could be anyone if you put in the time. You will reach the top, and that is that. I am not talented, I am obsessed. -Conor McGregor"
    },
    "2026-09-13": {
        "content": "A dream is not what you see while sleeping; it is something that does not let you sleep. -Abdul Kalam"
    },
    "2026-09-14": {
        "content": "When you have exhausted all possibilities, remember this – you haven’t. -Thomas A. Edison"
    },
    "2026-09-15": {
        "content": "Take chances, make mistakes. That’s how you grow. Pain nourishes your courage. You have to fail in order to practice being brave. -Mary Tyler Moore"
    },
    "2026-09-16": {
        "content": "Whatever you focus on is what you get. -Tony Robbins"
    },
    "2026-09-17": {
        "content": "If they can make penicillin out of moldy bread, then they can sure make something out of you. -Muhammad Ali"
    },
    "2026-09-18": {
        "content": "You were not born a winner, and you were not born a loser. You are what you make yourself be. -Lou Holtz"
    },
    "2026-09-19": {
        "content": "Success is your duty, obligation, and responsibility. -Grant Cardone"
    },
    "2026-09-20": {
        "content": "There is little difference in people, but that little difference makes a big difference. The little difference is attitude. The big difference is whether it is positive or negative. -W. Clement Stone"
    },
    "2026-09-21": {
        "content": "Leaders must be close enough to relate to others, but far enough ahead to motivate them. -John C. Maxwell"
    },
    "2026-09-22": {
        "content": "Never say never, because limits, like fears, are often just an illusion. -Michael Jordan"
    },
    "2026-09-23": {
        "content": "You must expect great things of yourself before you can do them. -Michael Jordan"
    },
    "2026-09-24": {
        "content": "In the world of business, the people who are most successful are those who are doing what they love. -Warren Buffett"
    },
    "2026-09-25": {
        "content": "Action will destroy your procrastination. -Og Mandino"
    },
    "2026-09-26": {
        "content": "Failure is not an option for me. Success is all I envision. -Conor McGregor"
    },
    "2026-09-27": {
        "content": "Success doesn’t come from what you do occasionally, it comes from what you do consistently. -Marie Forleo"
    },
    "2026-09-28": {
        "content": "Confidence and hard work are the best medicines to kill the disease called failure. They will make you a successful person. -Abdul Kalam"
    },
    "2026-09-29": {
        "content": "If you want to shine like the sun, first burn like the sun. -Abdul Kalam"
    },
    "2026-09-30": {
        "content": "While you\\'re out there partying, horsing around, someone out there at the same time is working hard. Someone is getting smarter and someone is winning. Just remember that. -Arnold Schwarzenegger"
    },
    "2026-10-01": {
        "content": "If you do what you’ve always done, you’ll get what you’ve always gotten. -Tony Robbins"
    },
    "2026-10-02": {
        "content": "Progress equals happiness. -Tony Robbins"
    },
    "2026-10-03": {
        "content": "You can have results or excuses. Not both. -Arnold Schwarzenegger"
    },
    "2026-10-04": {
        "content": "Discipline equals freedom. -Jocko Willink"
    },
    "2026-10-05": {
        "content": "Don’t dwell on what went wrong. Instead, focus on what to do next. Spend your energies on moving forward, toward finding the answer. -Denis Waitley"
    },
    "2026-10-06": {
        "content": "Be the leader you wish you had. -Simon Sinek"
    },
    "2026-10-07": {
        "content": "My attitude is that if you push me towards something that you think is a weakness, then I will turn that perceived weakness into a strength. -Michael Jordan"
    },
    "2026-10-08": {
        "content": "The greater danger for most of us lies not in setting our aim too high and falling short; but in setting our aim too low, and achieving our mark. -Michelangelo"
    },
    "2026-10-09": {
        "content": "Everybody has a dream, but not everybody has a grind. -Eric Thomas"
    },
    "2026-10-10": {
        "content": "Leaders are made, they are not born. They are made by hard effort, which is the price which all of us must pay to achieve any goal that is worthwhile. -Vince Lombardi"
    },
    "2026-10-11": {
        "content": "We choose to go to the moon in this decade and do the other things. Not because they are easy, but because they are hard. -John F. Kennedy"
    },
    "2026-10-12": {
        "content": "The greatest day in your life and mine is when we take total responsibility for our attitudes. That's the day we truly grow up. -John C. Maxwell"
    },
    "2026-10-13": {
        "content": "Be the silent watcher of your thoughts and behavior. You are beneath the thinker. You are the stillness beneath the mental noise. You are the love and joy beneath the pain. -Eckhart Tolle"
    },
    "2026-10-14": {
        "content": "If you can’t fly then run, if you can’t run then walk, if you can’t walk then crawl, but whatever you do you have to keep moving forward. -Martin Luther King Jr."
    },
    "2026-10-15": {
        "content": "Forgiveness is not an occasional act, it is a constant attitude. -Martin Luther King Jr."
    },
    "2026-10-16": {
        "content": "Too often we underestimate the power of a touch, a smile, a kind word, a listening ear, an honest compliment, or the smallest act of caring, all of which have the potential to turn a life around. -Leo Buscaglia"
    },
    "2026-10-17": {
        "content": "Keep your dreams alive. Understand that to achieve anything requires faith and belief in yourself, vision, hard work, determination, and dedication. Remember all things are possible for those who believe. -Gail Devers"
    },
    "2026-10-18": {
        "content": "Sport has the power to change the world. It has the power to inspire. It has the power to unite people in a way that little else does. It speaks to youth in a language they understand. Sport can create hope where once there was only despair. -Nelson Mandela"
    },
    "2026-10-19": {
        "content": "Ask for what you want. Believe that you deserve it, and then allow Life to give it to you. -Louise Hay"
    },
    "2026-10-20": {
        "content": "Live with intention. Walk to the edge. Listen hard. Practice wellness. Play with abandon. Laugh. Choose with no regret. Appreciate your friends. Continue to learn. Do what you love. Live as if this is all there is. -Mary Anne Radmacher"
    },
    "2026-10-21": {
        "content": "What you focus on expands, and when you focus on the goodness in your life, you create more of it. -Oprah Winfrey"
    },
    "2026-10-22": {
        "content": "You have power over your mind, not outside events. Realize this, and you will find strength. -Marcus Aurelius"
    },
    "2026-10-23": {
        "content": "Don’t make excuses for why you can’t get it done. Focus on all the reasons why you must make it happen. -Ralph Marston"
    },
    "2026-10-24": {
        "content": "Where there is love there is life. -Mahatma Gandhi"
    },
    "2026-10-25": {
        "content": "You’ve gotta dance like there’s nobody watching, love like you’ll never be hurt, sing like there’s nobody listening, and live like it’s heaven on earth. -William W. Purkey"
    },
    "2026-10-26": {
        "content": "Success is knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others. -John C. Maxwell"
    },
    "2026-10-27": {
        "content": "A dream you dream alone is only a dream. A dream you dream together is reality. -John Lennon"
    },
    "2026-10-28": {
        "content": "This is the real secret of life: to be completely engaged with what you are doing in the here and now. And instead of calling it work, realize it is play. -Alan Watts"
    },
    "2026-10-29": {
        "content": "The more you praise and celebrate your life, the more there is in life to celebrate. -Oprah Winfrey"
    },
    "2026-10-30": {
        "content": "Never doubt that a small group of thoughtful, committed citizens can change the world. Indeed, it is the only thing that ever has. -Margaret Mead"
    },
    "2026-10-31": {
        "content": "Push yourself, because no one else is going to do it for you. -Anonymous"
    },
    "2026-11-01": {
        "content": "True humility is not thinking less of yourself; it is thinking of yourself less. -C. S. Lewis"
    },
    "2026-11-02": {
        "content": "If you can change your mind, you can change your life. -William James"
    },
    "2026-11-03": {
        "content": "Focus on where you want to go, not on what you fear. -Tony Robbins"
    },
    "2026-11-04": {
        "content": "Do what you can, with what you have, where you are. -Theodore Roosevelt"
    },
    "2026-11-05": {
        "content": "Some changes look negative on the surface, but you will soon realize that space is being created in your life for something new to emerge. -Eckhart Tolle"
    },
    "2026-11-06": {
        "content": "If your actions inspire others to dream more, learn more, do more, and become more, you are a leader. -John Quincy Adams"
    },
    "2026-11-07": {
        "content": "Don’t worry about a thing, every little thing is gonna be alright. -Bob Marley"
    },
    "2026-11-08": {
        "content": "Dream big, stay positive, work hard, and enjoy the journey. -Urijah Faber"
    },
    "2026-11-09": {
        "content": "You are here to enable the divine purpose of the Universe to unfold. That is how important you are!-Eckhart Tolle"
    },
    "2026-11-10": {
        "content": "Live with passion!-Tony Robbins"
    },
    "2026-11-11": {
        "content": "Believe you can and you’re halfway there. -Theodore Roosevelt"
    },
    "2026-11-12": {
        "content": "Our lives begin to end the day we become silent about things that matter. -Martin Luther King Jr."
    },
    "2026-11-13": {
        "content": "Working hard for something we don’t care about is called stress; working hard for something we love is called passion. -Simon Sinek"
    },
    "2026-11-14": {
        "content": "The cave you fear to enter holds the treasure you seek. -Joseph Campbell"
    },
    "2026-11-15": {
        "content": "Leadership is about empathy. It is about having the ability to relate to and connect with people for the purpose of inspiring and empowering their lives. -Oprah Winfrey"
    },
    "2026-11-16": {
        "content": "There is nothing impossible to him who will try. -Alexander the Great"
    },
    "2026-11-17": {
        "content": "Most of the important things in the world have been accomplished by people who have kept on trying when there seemed to be no hope at all. -Dale Carnegie"
    },
    "2026-11-18": {
        "content": "We keep moving forward, opening new doors, and doing new things, because we’re curious and curiosity keeps leading us down new paths. -Walt Disney"
    },
    "2026-11-19": {
        "content": "Do what you have to do until you can do what you want to do. -Oprah Winfrey"
    },
    "2026-11-20": {
        "content": "Believing that you’re enough is what gives you the courage to be authentic. -Brené Brown"
    },
    "2026-11-21": {
        "content": "It is our choices, Harry, that show what we truly are, far more than our abilities. -J.K. Rowling"
    },
    "2026-11-22": {
        "content": "Follow your bliss and the universe will open doors for you where there were only walls. -Joseph Campbell"
    },
    "2026-11-23": {
        "content": "Dreams are not those that come to us while we are sleeping, but dreams are those that you don’t sleep before fulfilling them. -Abdul Kalam"
    },
    "2026-11-24": {
        "content": "Daring greatly means the courage to be vulnerable. It means to show up and be seen. To ask for what you need. To talk about how you’re feeling. To have the hard conversations. -Brené Brown"
    },
    "2026-11-25": {
        "content": "You will never ever be successful, until you turn your pain into greatness, until you allow your pain to push you from where you are to push you to where you need to be. Stop running from your pain and embrace your pain. Your pain is going to be a part of your prize, a part of your product. I challenge you to push yourself. -Eric Thomas"
    },
    "2026-11-26": {
        "content": "We are what we repeatedly do. Excellence, therefore, is not an act, but a habit. -Aristotle"
    },
    "2026-11-27": {
        "content": "A river cuts through rock, not because of its power, but because of its persistence. -Jim Watkins"
    },
    "2026-11-28": {
        "content": "Energy and persistence conquer all things. -Benjamin Franklin"
    },
    "2026-11-29": {
        "content": "Opportunities are usually disguised as hard work, so most people don’t recognize them. -Ann Landers"
    },
    "2026-11-30": {
        "content": "\"If you can't fly, then run. If you can't run, then walk. If you can't walk, then crawl, but whatever you do, you have to keep moving forward.\"-Martin Luther King Jr."
    },
    "2026-12-01": {
        "content": "With ordinary talent and extraordinary perseverance, all things are attainable. -Thomas Fowell Buxton"
    },
    "2026-12-02": {
        "content": "Our greatest glory is not in never failing, but in rising up every time we fail. -Ralph Waldo Emerson"
    },
    "2026-12-03": {
        "content": "Success is stumbling from failure to failure with no loss of enthusiasm. -Winston Churchill"
    },
    "2026-12-04": {
        "content": "Thankfully, persistence is a great substitute for talent. -Steve Martin"
    },
    "2026-12-05": {
        "content": "I'm a greater believer in luck, and I find that the harder I work, the more I have of it. -Thomas Jefferson"
    },
    "2026-12-06": {
        "content": "Only put off until tomorrow what you are willing to die having left undone. -Pablo Picasso"
    },
    "2026-12-07": {
        "content": "There are no secrets to success. It is the result of preparation, hard work, and learning from failure. -Colin Powell"
    },
    "2026-12-08": {
        "content": "Let me tell you the secret that has led me to my goal: my strength lies solely in my tenacity. -Louis Pasteur"
    },
    "2026-12-09": {
        "content": "Nothing in this world can take the place of persistence. Talent will not; nothing is more common than unsuccessful people with talent. Genius will not; unrewarded genius is almost a proverb. -Calvin Coolidge"
    },
    "2026-12-10": {
        "content": "The best way out is always through. -Robert Frost"
    },
    "2026-12-11": {
        "content": "Many of life’s failures are people who did not realize how close they were to success when they gave up. -Thomas A. Edison"
    },
    "2026-12-12": {
        "content": "We are made to persist. That’s how we find out who we are. -Tobias Wolff"
    },
    "2026-12-13": {
        "content": "Knowing trees, I understand the meaning of patience. Knowing grass, I can appreciate persistence. -Hal Borland"
    },
    "2026-12-14": {
        "content": "Dripping water hollows out stone, not through force but through persistence. -Ovid"
    },
    "2026-12-15": {
        "content": "Persistence is very important. You should not give up unless you are forced to give up. -Elon Musk"
    },
    "2026-12-16": {
        "content": "Flaming enthusiasm, backed by horse sense and persistence, is the quality that most frequently makes for success. -Dale Carnegie"
    },
    "2026-12-17": {
        "content": "Ambition is the path to success. Persistence is the vehicle you arrive in. -Bill Bradley"
    },
    "2026-12-18": {
        "content": "Focus on the solution, not the problem. -Walter Anderson"
    },
    "2026-12-19": {
        "content": "When life knocks you down, you have two choices – stay down or get up. -Tom Krause"
    },
    "2026-12-20": {
        "content": "Success is the sum of small efforts, repeated day in and day out. -Robert Collier"
    },
    "2026-12-21": {
        "content": "A dream is just a dream. A goal is a dream with a plan and a deadline. -Harvey MacKay"
    },
    "2026-12-22": {
        "content": "Never give up on something that you can’t go a day without thinking about. -Winston Churchill"
    },
    "2026-12-23": {
        "content": "Diamonds are nothing more than chunks of coal that stuck to their jobs. -Malcolm S. Forbes"
    },
    "2026-12-24": {
        "content": "Nothing can be done except little by little. -Charles Baudelaire"
    },
    "2026-12-25": {
        "content": "If you are going through hell, keep going. -Winston Churchill"
    },
    "2026-12-26": {
        "content": "The key of persistence opens all doors closed by resistance. -John Di Lemme"
    },
    "2026-12-27": {
        "content": "If we look at those who are the most successful in the world, persistence is the common denominator. -Justin Sachs"
    },
    "2026-12-28": {
        "content": "You can eat an elephant one bit at a time. -Mary Kay Ash"
    },
    "2026-12-29": {
        "content": "I do not think that there is any other quality so essential to success of any kind as the quality of perseverance. It overcomes almost everything, even nature. -John D. Rockefeller"
    },
    "2026-12-30": {
        "content": "If you want to turn a vision into reality, you have to give 100% and never stop believing in your dream. -Arnold Schwarzenegger"
    },
    "2026-12-31": {
        "content": "Run when you can, walk if you have to, crawl if you must; just never give up. -Dean Karnazes"
    }
}
export const dateRussianList = {
    "2024-01-01": {
        "content": " Мы есть то, что мы постоянно делаем. Поэтому совершенство — это не действие, а привычка. -Аристотель"
    },
    "2024-01-02": {
        "content": " Река прорезает скалу не благодаря своей силе, а благодаря своему упорству. -Джим Уоткинс"
    },
    "2024-01-03": {
        "content": " Энергия и упорство побеждают все. -Бенджамин Франклин"
    },
    "2024-01-04": {
        "content": " Возможности обычно маскируются под упорный труд, поэтому большинство людей их не распознают. -Энн Лэндерс"
    },
    "2024-01-05": {
        "content": " Если не можешь летать, беги, если не можешь бежать, иди, если не можешь ходить, ползай, но что бы ты ни делал, ты должен продолжать двигаться вперед. -Мартин Лютер Кинг-младший."
    },
    "2024-01-06": {
        "content": " Настойчивость гарантирует неизбежность результатов. -Парамаханса Йогананда"
    },
    "2024-01-07": {
        "content": " При наличии обычного таланта и необычайного упорства все достижимо. -Томас Фоуэлл Бакстон"
    },
    "2024-01-08": {
        "content": " Наша величайшая слава не в том, чтобы никогда не терпеть неудач, а в том, чтобы подниматься каждый раз, когда мы терпим неудачу. -Ральф Уолдо Эмерсон"
    },
    "2024-01-09": {
        "content": " Успех — это спотыкающийся путь от неудачи к неудаче без потери энтузиазма. -Уинстон Черчилль"
    },
    "2024-01-10": {
        "content": "К счастью, настойчивость — отличная замена таланту. -Стив Мартин"
    },
    "2024-01-11": {
        "content": " Я больше верю в удачу, и я обнаружил, что чем больше я работаю, тем больше ее у меня есть. -Томас Джефферсон"
    },
    "2024-01-12": {
        "content": " Откладывай на завтра только то, что ты готов оставить несделанным до самой смерти. -Пабло Пикассо"
    },
    "2024-01-13": {
        "content": " Нет никаких секретов успеха: не тратьте время на их поиски. Успех — это результат совершенства, упорного труда, обучения на неудачах, преданности тем, для кого вы работаете, и настойчивости. -Колин Пауэлл"
    },
    "2024-01-14": {
        "content": " Если хочешь быть впереди, то веди себя так, как будто ты сзади. -Лао-цзы"
    },
    "2024-01-15": {
        "content": " Позвольте мне раскрыть вам секрет, который привел меня к моей цели: моя сила заключается исключительно в моем упорстве. -Луи Пастер"
    },
    "2024-01-16": {
        "content": " Ничто в этом мире не заменит упорства. Талант не заменит; нет ничего более распространенного, чем неудачники с талантом. Гений не заменит; невознагражденный гений — это почти пословица. -Кэлвин Кулидж"
    },
    "2024-01-17": {
        "content": " Лучший выход всегда — насквозь. -Роберт Фрост"
    },
    "2024-01-18": {
        "content": "Многие из тех, кто потерпел неудачу в жизни, — это люди, которые не осознавали, насколько близки они были к успеху, когда сдались. -Томас А. Эдисон"
    },
    "2024-01-19": {
        "content": " Мы созданы для упорства. Так мы узнаем, кто мы есть. -Тобиас Вольф"
    },
    "2024-01-20": {
        "content": " Зная деревья, я понимаю значение терпения. Зная траву, я могу оценить настойчивость. -Хэл Борланд"
    },
    "2024-01-21": {
        "content": " Капающая вода точит камень, но не силой, а настойчивостью. -Овидий"
    },
    "2024-01-22": {
        "content": " Настойчивость очень важна. Не стоит сдаваться, если только вас не вынуждают сдаться. -Илон Маск"
    },
    "2024-01-23": {
        "content": " Пламенный энтузиазм, подкрепленный здравым смыслом и настойчивостью, — это качество, которое чаще всего способствует успеху. -Дейл Карнеги"
    },
    "2024-01-24": {
        "content": " Амбиции — это путь к успеху. Упорство — это средство передвижения, на котором вы прибудете. -Билл Брэдли"
    },
    "2024-01-25": {
        "content": " Сосредоточьтесь на решении, а не на проблеме. -Уолтер Андерсон"
    },
    "2024-01-26": {
        "content": " Когда жизнь сбивает тебя с ног, у тебя есть два выбора — оставаться внизу или вставать. -Том Краузе"
    },
    "2024-01-27": {
        "content": "Успех — это сумма небольших усилий, повторяемых изо дня в день. -Роберт Колльер"
    },
    "2024-01-28": {
        "content": " Мечта — это всего лишь мечта. Цель — это мечта с планом и сроком. -Харви Маккей"
    },
    "2024-01-29": {
        "content": " Никогда не отказывайтесь от чего-то, без мыслей о чем вы не можете прожить и дня. -Уинстон Черчилль"
    },
    "2024-01-30": {
        "content": " Алмазы — это не более чем куски угля, прилипшие к своим рабочим местам. -Малкольм С. Форбс"
    },
    "2024-01-31": {
        "content": " Ничего нельзя сделать, кроме как понемногу. -Шарль Бодлер"
    },
    "2024-02-01": {
        "content": " Если вы проходите через ад, продолжайте идти. -Уинстон Черчилль"
    },
    "2024-02-02": {
        "content": " Ключ настойчивости открывает все двери, закрытые сопротивлением. -Джон Ди Лемме"
    },
    "2024-02-03": {
        "content": " Если мы посмотрим на самых успешных людей в мире, то их общим знаменателем будет настойчивость. -Джастин Сакс"
    },
    "2024-02-04": {
        "content": " Слона можно съесть по частям. -Мэри Кэй Эш"
    },
    "2024-02-05": {
        "content": " Я не думаю, что есть какое-либо другое качество, столь необходимое для успеха любого рода, как качество настойчивости. Оно преодолевает почти все, даже природу. -Джон Д. Рокфеллер"
    },
    "2024-02-06": {
        "content": "Если вы хотите превратить мечту в реальность, вам придется выложиться на все 100% и никогда не переставать верить в свою мечту. -Арнольд Шварценеггер"
    },
    "2024-02-07": {
        "content": " Бегите, когда можете, идите, если нужно, ползите, если нужно; просто никогда не сдавайтесь. -Дин Карназес"
    },
    "2024-02-08": {
        "content": " Пройти еще один раунд, когда вы думаете, что не можете этого сделать, — вот что имеет решающее значение в вашей жизни. -Сильвестр Сталлоне"
    },
    "2024-02-09": {
        "content": " Послушай меня, даже когда ты проигрываешь, проигрывать нормально, но ты никогда не сможешь с этим смириться. Ты никогда не сможешь быть удовлетворен проигрышем. Когда ты проигрываешь, это должно быть больно. -Эрик Томас"
    },
    "2024-02-10": {
        "content": " Продолжайте идти своим путем, шаг за шагом. -Джойс Майер"
    },
    "2024-02-11": {
        "content": " Мы не должны сдаваться и не должны позволять проблеме победить нас. -Абдул Калам"
    },
    "2024-02-12": {
        "content": " Благодаря терпению мы побеждаем. -Эрнест Шеклтон"
    },
    "2024-02-13": {
        "content": "Кирпичные стены существуют не просто так. Кирпичные стены существуют не для того, чтобы нас не пускать. Кирпичные стены существуют для того, чтобы дать нам возможность показать, как сильно мы чего-то хотим. Потому что кирпичные стены существуют для того, чтобы останавливать людей, которые хотят этого недостаточно сильно. Они существуют для того, чтобы останавливать других людей. -Рэнди Пауш"
    },
    "2024-02-14": {
        "content": " Успех почти полностью зависит от напористости и упорства. Дополнительная энергия, необходимая для того, чтобы приложить еще одно усилие или попробовать другой подход, — вот секрет победы. -Денис Уэйтли"
    },
    "2024-02-15": {
        "content": " Я добился этого и отказался сдаваться, потому что всю свою жизнь я всегда доходил до конца гонки. -Луи Замперини"
    },
    "2024-02-16": {
        "content": " Выживание можно описать тремя словами – никогда не сдавайся. Вот в чем суть. Просто продолжай пытаться. -Беар Гриллс"
    },
    "2024-02-17": {
        "content": "БОЛЬШЕ НИКАКИХ. Больше никаких оправданий. Больше никаких: «Я начну завтра». Больше никаких: «Только в этот раз». Больше никаких смирений с недостатками собственной воли. Больше никаких легких путей. Больше никаких преклонений перед любыми нездоровыми или непродуктивными мыслями, которые мелькают в моем сознании. -Джоко Виллинк"
    },
    "2024-02-18": {
        "content": " Маленькие удары валят большие дубы. -Бенджамин Франклин"
    },
    "2024-02-19": {
        "content": " Я готов. Я настроен на победу. Я понимаю это. Я принимаю неопределенность. Я — это не мои мысли; я — это то, что я делаю. Я непреклонен. Я ничего не ожидаю и принимаю все. -Гари Джон Бишоп"
    },
    "2024-02-20": {
        "content": " Я не терпел неудач 700 раз. Я не терпел неудач ни разу. Мне удалось доказать, что эти 700 способов не сработают. Когда я устраню способы, которые не сработают, я найду способ, который сработает. -Томас А. Эдисон"
    },
    "2024-02-21": {
        "content": " GRIT — это сила воли, стойкость, трудолюбие и упорство. GRIT — это способность сосредотачиваться, сохранять решимость, сохранять оптимизм перед лицом трудностей и просто работать усерднее, чем соседи. -Линда Каплан Талер"
    },
    "2024-02-22": {
        "content": "Я думаю, мой секрет в том, что не существует коротких путей к упорному труду, решимости и настрою «никогда не сдаваться». -Джерри Райс"
    },
    "2024-02-23": {
        "content": " Никогда не прекращайте бороться, пока не достигнете своего предназначенного места – то есть уникального себя. Имейте цель в жизни, постоянно приобретайте знания, усердно работайте и будьте настойчивы, чтобы реализовать великую жизнь. -Абдул Калам"
    },
    "2024-02-24": {
        "content": " Не останавливайся, когда устал. Остановись, когда закончишь. -Дэвид Гоггинс"
    },
    "2024-02-25": {
        "content": " Не судите меня по моим успехам, судите меня по тому, сколько раз я падал и снова вставал. -Нельсон Мандела"
    },
    "2024-02-26": {
        "content": " То, что не начато сегодня, никогда не закончится завтра. -Иоганн Вольфганг фон Гёте"
    },
    "2024-02-27": {
        "content": " Если вы написали сотню рассказов и все они плохие, это не значит, что вы потерпели неудачу. Вы потерпели неудачу только если перестали писать. -Рэй Брэдбери"
    },
    "2024-02-28": {
        "content": " Мастер терпел неудачу чаще, чем новичок пытался что-либо сделать. -Стивен МакКрейни"
    },
    "2024-02-29": {
        "content": " К черту обстоятельства; я создаю возможности. -Брюс Ли"
    },
    "2024-03-01": {
        "content": "Единственное, что хуже, чем начать что-то и потерпеть неудачу, — это не начать ничего. -Сет Годин"
    },
    "2024-03-02": {
        "content": " Никогда не откладывай на завтра то, что можно сделать сегодня. -Бенджамин Франклин"
    },
    "2024-03-03": {
        "content": " Благодаря упорству улитка добралась до ковчега. -Чарльз Х. Сперджен"
    },
    "2024-03-04": {
        "content": " Помните, надежда — это хорошо, может быть, даже лучше всего, и ничто хорошее не умирает. -Стивен Кинг"
    },
    "2024-03-05": {
        "content": " Предприниматели не заканчивают, когда мы устали. Мы заканчиваем, когда мы закончили. -Роберт Т. Кийосаки"
    },
    "2024-03-06": {
        "content": " Только упорство и решимость всемогущи. -Кэлвин Кулидж"
    },
    "2024-03-07": {
        "content": " Парализуйте сопротивление настойчивостью. -Вуди Хейс"
    },
    "2024-03-08": {
        "content": " Успех никогда не является собственностью, он арендуется, и арендная плата взимается каждый день. -Рори Ваден"
    },
    "2024-03-09": {
        "content": " Успех не случаен. Это тяжелая работа, упорство, обучение, изучение, жертвенность и, прежде всего, любовь к тому, что вы делаете или учитесь делать. -Пеле"
    },
    "2024-03-10": {
        "content": " Нет способа обойти тяжелую работу. Примите это. -Роджер Федерер"
    },
    "2024-03-11": {
        "content": " Мечта не становится реальностью с помощью волшебства; для этого нужны пот, решимость и упорный труд. -Колин Пауэлл"
    },
    "2024-03-12": {
        "content": "Обучение никогда не истощает разум. -Леонардо да Винчи"
    },
    "2024-03-13": {
        "content": " Я слышу и забываю. Я вижу и запоминаю. Я делаю и понимаю. -Конфуций"
    },
    "2024-03-14": {
        "content": " Тот, кто никогда не совершал ошибок, никогда не пробовал ничего нового. -Альберт Эйнштейн"
    },
    "2024-03-15": {
        "content": " Постарайтесь узнать что-нибудь обо всем и все о чем-нибудь. -Томас Генри Хаксли"
    },
    "2024-03-16": {
        "content": " Человек учится только двумя способами: читая и общаясь с более умными людьми. -Уилл Роджерс"
    },
    "2024-03-17": {
        "content": " Вы ничего не поймете, пока не узнаете это более чем одним способом. -Марвин Мински"
    },
    "2024-03-18": {
        "content": " Скажи мне, и я забуду, научи меня, и я, может быть, запомню, вовлеки меня, и я научусь. -Бенджамин Франклин"
    },
    "2024-03-19": {
        "content": " Если вы хотите увеличить свой процент успеха, удвойте процент неудач. -Томас Дж. Уотсон"
    },
    "2024-03-20": {
        "content": " Интеллект — это то, что вы используете, когда не знаете, что делать. -Жан Пиаже"
    },
    "2024-03-21": {
        "content": " Неграмотными в XXI веке будут не те, кто не умеет читать и писать, а те, кто не умеет учиться, разучиваться и переучиваться. -Элвин Тоффлер"
    },
    "2024-03-22": {
        "content": "Именно то, что мы уже знаем, часто мешает нам учиться. -Клод Бернар"
    },
    "2024-03-23": {
        "content": " Математика — это язык, на котором Бог написал вселенную. -Галилео Галилей"
    },
    "2024-03-24": {
        "content": " Вся цель образования — превратить зеркала в окна. -Сидней Дж. Харрис"
    },
    "2024-03-25": {
        "content": " Я не боюсь штормов, потому что учусь управлять своим кораблем. -Луиза Мэй Олкотт"
    },
    "2024-03-26": {
        "content": " Образован только тот человек, который научился учиться и меняться. -Карл Р. Роджерс"
    },
    "2024-03-27": {
        "content": " Я никогда не встречал настолько невежественного человека, у которого я не мог бы чему-то научиться. -Галилео Галилей"
    },
    "2024-03-28": {
        "content": " Ничто не уходит, пока не научит нас тому, что нам нужно знать. -Пема Чодрон"
    },
    "2024-03-29": {
        "content": " Практика приводит к совершенству. После долгой практики наша работа станет естественной, искусной, быстрой и стабильной. -Брюс Ли"
    },
    "2024-03-30": {
        "content": " Когда вы говорите, вы только повторяете то, что уже знаете. Но если вы слушаете, вы можете узнать что-то новое. -Далай-лама XIV"
    },
    "2024-03-31": {
        "content": " Стремитесь к прогрессу, а не к совершенству. -Анонимный"
    },
    "2024-04-01": {
        "content": "Я всегда делаю то, чего пока не умею, чтобы научиться это делать. -Винсент Ван Гог"
    },
    "2024-04-02": {
        "content": " Знание делает человека непригодным к рабству. -Фредерик Дугласс"
    },
    "2024-04-03": {
        "content": " Я очень рано понял разницу между знанием названия чего-либо и знанием чего-либо. -Ричард П. Фейнман"
    },
    "2024-04-04": {
        "content": " Способность учиться — это дар; Способность учиться — это навык; Желание учиться — это выбор. -Брайан Герберт"
    },
    "2024-04-05": {
        "content": " Учитесь всему, чему можете, когда можете и у кого можете, — обязательно наступит время, когда вы будете благодарны за это. -Сара Колдуэлл"
    },
    "2024-04-06": {
        "content": " Я невысокого мнения о человеке, который сегодня не стал мудрее, чем он был вчера. -Авраам Линкольн"
    },
    "2024-04-07": {
        "content": " Ключ к успеху — это стремление к непрерывному обучению. -Стивен Р. Кови"
    },
    "2024-04-08": {
        "content": " Будьте страстными и смелыми. Всегда продолжайте учиться. Вы перестанете делать полезные вещи, если не будете учиться. -Сатья Наделла"
    },
    "2024-04-09": {
        "content": "Высшая деятельность, которой может достичь человек, — это обучение ради понимания, потому что понимать — значит быть свободным. -Барух Спиноза"
    },
    "2024-04-10": {
        "content": " Если вы не будете продолжать учиться, другие люди пройдут мимо вас. Один темперамент не поможет — нужно много любопытства на долгое-долгое время. -Чарли Мангер"
    },
    "2024-04-11": {
        "content": " Обучающаяся организация — это организация, которая постоянно расширяет свои возможности по созданию своего будущего. -Питер Сенге"
    },
    "2024-04-12": {
        "content": " В тот день, когда вы перестаете учиться, вы начинаете деградировать. -Айзек Азимов"
    },
    "2024-04-13": {
        "content": " Учение — украшение в процветании, убежище в невзгодах и обеспечение в старости. -Аристотель"
    },
    "2024-04-14": {
        "content": " Все лидеры — ученики. Как только вы перестаете учиться, вы перестаете вести за собой. Я учусь так многому, как могу, у стольких, у кого могу, так часто, как могу. -Рик Уоррен"
    },
    "2024-04-15": {
        "content": " Чтобы быстро научиться сложным вещам, нужно сосредоточиться, не отвлекаясь. Другими словами, учиться — это акт глубокой работы. -Кэл Ньюпорт"
    },
    "2024-04-16": {
        "content": " Любой дурак может знать. Главное — понять. -Альберт Эйнштейн"
    },
    "2024-04-17": {
        "content": "Проводите каждый день, стараясь стать немного мудрее, чем вы были, когда проснулись. -Чарли Мангер"
    },
    "2024-04-18": {
        "content": " Инвестируйте в себя, в свое образование. Нет ничего лучше. -Сильвия Портер"
    },
    "2024-04-19": {
        "content": " Самообразование является для меня постоянным источником удовольствия, ведь чем больше я узнаю, тем полнее становится моя жизнь и тем больше я ценю собственное существование. -Айзек Азимов"
    },
    "2024-04-20": {
        "content": " Вы можете получить помощь от учителей, но вам придется многому научиться самостоятельно, сидя в одиночестве в классе. -Доктор Сьюз"
    },
    "2024-04-21": {
        "content": " Обучение происходит тогда, когда кто-то хочет учиться, а не тогда, когда кто-то хочет учить. -Роджер Шэнк"
    },
    "2024-04-22": {
        "content": " Человек не может научить другого человека напрямую; человек может лишь способствовать обучению другого человека. -Карл Р. Роджерс"
    },
    "2024-04-23": {
        "content": " Обучение не обязательно; оно добровольно. Улучшение не обязательно; оно добровольно. Но чтобы выжить, мы должны учиться. -У. Эдвардс Деминг"
    },
    "2024-04-24": {
        "content": " Я всегда делаю то, чего не умею, чтобы научиться это делать. -Пабло Пикассо"
    },
    "2024-04-25": {
        "content": "Ни один вор, каким бы искусным он ни был, не может украсть у человека знания, и именно поэтому знания — это лучшее и самое безопасное сокровище, которое можно приобрести. -Л. Фрэнк Баум"
    },
    "2024-04-26": {
        "content": " Я думаю, это самый лучший совет: постоянно думайте о том, как вы могли бы что-то сделать лучше, и задавайте себе вопросы. -Илон Маск"
    },
    "2024-04-27": {
        "content": " Мудрый человек может больше узнать из глупого вопроса, чем дурак из мудрого ответа. -Брюс Ли"
    },
    "2024-04-28": {
        "content": " Если я и видел дальше, то лишь потому, что стоял на плечах гигантов. -Исаак Ньютон"
    },
    "2024-04-29": {
        "content": " То, что мы знаем — это капля, то, чего мы не знаем — это океан. -Исаак Ньютон"
    },
    "2024-04-30": {
        "content": " Самое прекрасное в обучении то, что никто не может его у вас отнять. -ББ Кинг"
    },
    "2024-05-01": {
        "content": " Если вы хотите стать писателем, вам прежде всего нужно делать две вещи: много читать и много писать. -Стивен Кинг"
    },
    "2024-05-02": {
        "content": " Повторение — мать мастерства. -Тони Роббинс"
    },
    "2024-05-03": {
        "content": " Удивление — начало мудрости. -Сократ"
    },
    "2024-05-04": {
        "content": " Если вы совершили ошибку и не исправили ее, это называется ошибкой. -Конфуций"
    },
    "2024-05-05": {
        "content": " Цель образования — заменить пустой ум открытым. -Малкольм С. Форбс"
    },
    "2024-05-06": {
        "content": "Ничего в жизни не надо бояться, надо только понимать. Сейчас самое время больше понимать, чтобы меньше бояться. -Мария Кюри"
    },
    "2024-05-07": {
        "content": " Когда вас спросят, сможете ли вы выполнить работу, отвечайте: «Конечно, смогу!». Затем займитесь делом и выясните, как это сделать. -Теодор Рузвельт"
    },
    "2024-05-08": {
        "content": " Нам всем нужны люди, которые дадут нам обратную связь. Так мы совершенствуемся. -Билл Гейтс"
    },
    "2024-05-09": {
        "content": " Образование — это ключ к познанию мира, пропуск к свободе. -Опра Уинфри"
    },
    "2024-05-10": {
        "content": " Все начинается с идеи. -Эрл Найтингейл"
    },
    "2024-05-11": {
        "content": " Лучшая инвестиция, которую вы можете сделать, — это вложение в себя. -Уоррен Баффет"
    },
    "2024-05-12": {
        "content": " Дело не в деньгах или связях. Дело в готовности работать и учиться лучше всех. -Марк Кьюбан"
    },
    "2024-05-13": {
        "content": " Пока вы живы, продолжайте учиться жить. -Сенека"
    },
    "2024-05-14": {
        "content": " Чтобы научиться добиваться успеха, сначала нужно научиться терпеть неудачи. -Майкл Джордан"
    },
    "2024-05-15": {
        "content": " Не упускайте хорошую ошибку, учитесь на ней. -Роберт Т. Кийосаки"
    },
    "2024-05-16": {
        "content": "Чтобы приобрести знания, нужно учиться; но чтобы приобрести мудрость, нужно наблюдать. -Мэрилин Вос Савант"
    },
    "2024-05-17": {
        "content": " Век живи — век учись. В любом случае, век живи. -Дуглас Адамс"
    },
    "2024-05-18": {
        "content": " Терпение — спутник мудрости. -Святой Августин"
    },
    "2024-05-19": {
        "content": " Я знаю только одно: я ничего не знаю. -Сократ"
    },
    "2024-05-20": {
        "content": " Мудрость приходит с опытом. Опыт часто является результатом отсутствия мудрости. -Терри Пратчетт"
    },
    "2024-05-21": {
        "content": " Мы можем судить о своем прогрессе по смелости наших вопросов и глубине наших ответов, по нашей готовности принять то, что истинно, а не то, что кажется хорошим. -Карл Саган"
    },
    "2024-05-22": {
        "content": " Я бы предпочел вопросы, на которые нельзя ответить, чем ответы, которые нельзя подвергнуть сомнению. -Ричард П. Фейнман"
    },
    "2024-05-23": {
        "content": " Я всегда готов учиться, хотя мне не всегда нравится, когда меня учат. -Уинстон Черчилль"
    },
    "2024-05-24": {
        "content": " Тот, кто любит практику без теории, подобен моряку, который садится на корабль без руля и компаса и никогда не знает, куда его приведет. -Леонардо да Винчи"
    },
    "2024-05-25": {
        "content": " Лучше творить, чем учиться. Творчество — суть жизни. -Юлий Цезарь"
    },
    "2024-05-26": {
        "content": "То, что делает рука, помнит разум. -Мария Монтессори"
    },
    "2024-05-27": {
        "content": " Всегда идите по жизни так, словно вам предстоит узнать что-то новое, и вы это узнаете. -Вернон Ховард"
    },
    "2024-05-28": {
        "content": " Неудача становится успехом, если мы извлекаем из нее уроки. -Малкольм С. Форбс"
    },
    "2024-05-29": {
        "content": " Образование — лучший друг. Образованный человек уважаем везде. Образование побеждает красоту и молодость. -Чанакья"
    },
    "2024-05-30": {
        "content": " Не думай, что то, что тебе трудно освоить, для человека невозможно; но если что-то для человека возможно, считай это достижимым. -Марк Аврелий"
    },
    "2024-05-31": {
        "content": " Обучение — это постоянный процесс открытия, процесс, не имеющий конца. -Брюс Ли"
    },
    "2024-06-01": {
        "content": " Не столько стыдно быть невежественным, сколько нежелать учиться. -Бенджамин Франклин"
    },
    "2024-06-02": {
        "content": " Я убежден, что знание — это сила, позволяющая преодолевать прошлое, менять собственные ситуации, бороться с новыми препятствиями и принимать более обоснованные решения. -Бен Карсон"
    },
    "2024-06-03": {
        "content": " Вдыхая, я успокаиваю тело и разум. Выдыхая, я улыбаюсь. Пребывая в настоящем моменте, я знаю, что это единственный момент. -Тит Нат Хан"
    },
    "2024-06-04": {
        "content": "Если вы считаете, что вы слишком малы, чтобы что-то изменить, попробуйте спать с комаром. -Далай-лама XIV"
    },
    "2024-06-05": {
        "content": " Слишком часто мы недооцениваем силу прикосновения, улыбки, доброго слова, внимательного выслушивания, честного комплимента или даже самого маленького проявления заботы, хотя все это может изменить жизнь. -Лео Бускалья"
    },
    "2024-06-06": {
        "content": " Как мы проводим наши дни, так мы, конечно же, и проводим нашу жизнь. -Энни Диллард"
    },
    "2024-06-07": {
        "content": " Питайте свой разум великими мыслями, ибо вы никогда не подниметесь выше, чем думаете. -Бенджамин Дизраэли"
    },
    "2024-06-08": {
        "content": " Ты не научишься ходить, следуя правилам. Ты учишься, делая и падая. -Ричард Брэнсон"
    },
    "2024-06-09": {
        "content": " Невозможно прожить жизнь, не потерпев ни одной неудачи, если только вы не живете настолько осторожно, что с тем же успехом могли бы не жить вовсе. В таком случае вы по умолчанию терпите неудачу. -Дж. К. Роулинг"
    },
    "2024-06-10": {
        "content": " Если хочешь быть счастливым — будь им. -Лев Толстой"
    },
    "2024-06-11": {
        "content": " Никто не может причинить мне вред без моего разрешения. -Махатма Ганди"
    },
    "2024-06-12": {
        "content": " Когда я отпускаю то, кем я являюсь, я становлюсь тем, кем я могу быть. -Лао-цзы"
    },
    "2024-06-13": {
        "content": "Причина, по которой мы боремся с неуверенностью, заключается в том, что мы сравниваем то, что происходит за кулисами нашей жизни, с яркими моментами жизни других людей. -Стивен Фуртик"
    },
    "2024-06-14": {
        "content": " Помните, сегодня – это то завтра, о котором вы беспокоились вчера. -Дейл Карнеги"
    },
    "2024-06-15": {
        "content": " Мы должны быть готовы отказаться от той жизни, которую мы запланировали, чтобы иметь ту жизнь, которая нас ждет. -Джозеф Кэмпбелл"
    },
    "2024-06-16": {
        "content": " Перестань уходить, и ты придёшь. Перестань искать, и ты увидишь. Перестань убегать, и тебя найдут. -Лао-цзы"
    },
    "2024-06-17": {
        "content": " Команда — это не группа людей, которые работают вместе. Команда — это группа людей, которые доверяют друг другу. -Саймон Синек"
    },
    "2024-06-18": {
        "content": " Постоянный оптимизм — это умножитель силы. -Колин Пауэлл"
    },
    "2024-06-19": {
        "content": " Когда вы будете довольны тем, что вы просто являетесь собой, не будете сравнивать себя с другими и соперничать с ними, все будут вас уважать. -Лао-цзы"
    },
    "2024-06-20": {
        "content": " Считай свой возраст по друзьям, а не по годам. Считай свою жизнь по улыбкам, а не по слезам. -Джон Леннон"
    },
    "2024-06-21": {
        "content": " Дайте тем, кого вы любите, крылья, чтобы летать, корни, чтобы вернуться, и причины остаться. -Далай-лама XIV"
    },
    "2024-06-22": {
        "content": " Упорство и сила духа творили чудеса во все века. -Джордж Вашингтон"
    },
    "2024-06-23": {
        "content": "Поделитесь своими знаниями. Это способ достичь бессмертия. -Далай-лама XIV"
    },
    "2024-06-24": {
        "content": " Мы — способ, с помощью которого космос познает себя. -Карл Саган"
    },
    "2024-06-25": {
        "content": " Хороший учитель может вселить надежду, пробудить воображение и привить любовь к учебе. -Брэд Генри"
    },
    "2024-06-26": {
        "content": " Одно из величайших открытий, которое делает человек, один из его величайших сюрпризов — это осознание того, что он может сделать то, чего он боялся не сделать. -Генри Форд"
    },
    "2024-06-27": {
        "content": " Когда вы в последний раз делали что-то впервые? -Джон К. Максвелл"
    },
    "2024-06-28": {
        "content": " Если вы не находитесь в процессе становления тем человеком, которым хотите быть, вы автоматически становитесь тем человеком, которым не хотите быть. -Дейл Карнеги"
    },
    "2024-06-29": {
        "content": " Удача сопутствует смелым. -Латинская пословица"
    },
    "2024-06-30": {
        "content": " Успех — не ключ к счастью. Счастье — ключ к успеху. Если вы любите то, что делаете, вы будете успешны. -Альберт Швейцер"
    },
    "2024-07-01": {
        "content": " Не приобретай мир и не губи душу свою: мудрость лучше серебра и золота. -Боб Марли"
    },
    "2024-07-02": {
        "content": " Начните жить немедленно и считайте каждый отдельный день отдельной жизнью. -Сенека"
    },
    "2024-07-03": {
        "content": "Если кто-то вроде тебя не проявит к этому большого интереса, то лучше уже не станет. -Доктор Сьюз"
    },
    "2024-07-04": {
        "content": " Они не знали, что это невозможно, поэтому они это сделали. -Марк Твен"
    },
    "2024-07-05": {
        "content": " Я могу делать то, чего не можешь ты, ты можешь делать то, чего не могу я; вместе мы можем творить великие дела. -Мать Тереза"
    },
    "2024-07-06": {
        "content": " Единственное, чего нам следует бояться, — это самого страха. -Франклин Д. Рузвельт"
    },
    "2024-07-07": {
        "content": " Ничто великое не достигалось без энтузиазма. -Ральф Уолдо Эмерсон"
    },
    "2024-07-08": {
        "content": " Мужайся, дорогое сердце. -К.С. Льюис"
    },
    "2024-07-09": {
        "content": " Единственный способ осмыслить перемены — это окунуться в них, двигаться вместе с ними и присоединиться к танцу. -Алан Уоттс"
    },
    "2024-07-10": {
        "content": " Куда направлено внимание, туда течет энергия и видны результаты. -Т. Харв Экер"
    },
    "2024-07-11": {
        "content": " Боль временна. Она может длиться минуту, час, день или год, но в конце концов она утихнет и что-то другое займет ее место. Однако если я уйду, она будет длиться вечно. -Лэнс Армстронг"
    },
    "2024-07-12": {
        "content": " В каждой прогулке на природе человек получает гораздо больше, чем ищет. -Джон Мьюир"
    },
    "2024-07-13": {
        "content": "Победители — это не те, кто никогда не терпит неудач, а те, кто никогда не сдается. -Эдвин Луис Коул"
    },
    "2024-07-14": {
        "content": " Вместо того чтобы бороться с тьмой, вы несете свет. -Экхарт Толле"
    },
    "2024-07-15": {
        "content": " Будьте бесстрашны в погоне за тем, что зажигает вашу душу. -Дженнифер Ли"
    },
    "2024-07-16": {
        "content": " Когда люди уходят от вас, отпустите их. Ваша судьба никогда не связана с теми, кто вас покидает, и это не значит, что они плохие люди. Это просто значит, что их роль в вашей истории окончена. -ТД Джейкс"
    },
    "2024-07-17": {
        "content": " Лидерство — это способность воплощать видение в реальность. -Уоррен Г. Беннис"
    },
    "2024-07-18": {
        "content": " Вера — это когда ты веришь в то, чего не видишь; награда за эту веру — видеть то, во что веришь. -Святой Августин"
    },
    "2024-07-19": {
        "content": " Нет ничего невозможного, пока вы так не думаете. -Парамаханса Йогананда"
    },
    "2024-07-20": {
        "content": " Единственное, что хуже слепоты, — это иметь зрение, но не иметь видения. -Хелен Келлер"
    },
    "2024-07-21": {
        "content": " Во всем есть своя красота, но не все ее видят. -Конфуций"
    },
    "2024-07-22": {
        "content": " Бог говорит в тишине сердца. -Мать Тереза"
    },
    "2024-07-23": {
        "content": "Надежда — это нечто с перьями, что сидит в душе и поет мелодию без слов, и никогда не останавливается. -Эмили Дикинсон"
    },
    "2024-07-24": {
        "content": " Сколько бы святых слов вы ни читали, сколько бы ни произносили, какую пользу они вам принесут, если вы не будете следовать им? -Будда"
    },
    "2024-07-25": {
        "content": " И, кстати, обо всем в жизни можно написать, если у вас есть смелость это сделать и воображение, чтобы импровизировать. Самый страшный враг творчества — это неуверенность в себе. -Сильвия Плат"
    },
    "2024-07-26": {
        "content": " Ничто из того, что мы делаем, не может изменить прошлое, но все, что мы делаем, меняет будущее. -Эшли Бриллиант"
    },
    "2024-07-27": {
        "content": " Лидерство — это выбор. Это не звание. -Саймон Синек"
    },
    "2024-07-28": {
        "content": " Все будет хорошо, и все будет хорошо, и все будет хорошо. -Джулиан из Норвича"
    },
    "2024-07-29": {
        "content": " Каждый из нас, в космической перспективе, драгоценен. Если человек не согласен с тобой, оставь его в живых. В ста миллиардах галактик ты не найдешь другого. -Карл Саган"
    },
    "2024-07-30": {
        "content": " Интеллект плюс характер — вот цель настоящего образования. -Мартин Лютер Кинг-младший."
    },
    "2024-07-31": {
        "content": "Чем больше вы погружаетесь в нечто большее, чем вы сами, тем больше у вас будет энергии. -Норман Винсент Пил"
    },
    "2024-08-01": {
        "content": " Освойте основы, и уровень всего, что вы делаете, повысится. -Майкл Джордан"
    },
    "2024-08-02": {
        "content": " Вы не сможете жить вообще, если не сможете жить полноценно сейчас. -Алан Уоттс"
    },
    "2024-08-03": {
        "content": " Помните, что иногда не получить желаемое — это большая удача. -Далай-лама XIV"
    },
    "2024-08-04": {
        "content": " Сделайте все возможное, а затем расслабьтесь. Позвольте вещам идти естественным путем, а не форсируйте их. -Парамаханса Йогананда"
    },
    "2024-08-05": {
        "content": " Вы — бесконечное духовное существо, переживающее временный человеческий опыт. -Уэйн У. Дайер"
    },
    "2024-08-06": {
        "content": " Прежде чем ваши мечты сбудутся, нужно мечтать. -Абдул Калам"
    },
    "2024-08-07": {
        "content": " Больше всего береги свое сердце, ибо все, что ты делаешь, вытекает из него. -Соломон"
    },
    "2024-08-08": {
        "content": " Я могу отбросить все, пока пишу; мои печали исчезают, мое мужество возрождается. -Анна Франк"
    },
    "2024-08-09": {
        "content": " Цель не в том, чтобы быть идеальным к концу. Цель в том, чтобы стать лучше сегодня. -Саймон Синек"
    },
    "2024-08-10": {
        "content": " Идите уверенно к своей мечте. Живите жизнью, которую вы себе представляете. -Генри Дэвид Торо"
    },
    "2024-08-11": {
        "content": "Будьте добры, когда это возможно. Это всегда возможно. -Далай-лама XIV"
    },
    "2024-08-12": {
        "content": " Наша главная цель в этой жизни — помогать другим. А если вы не можете им помочь, то хотя бы не причиняйте им вреда. -Далай-лама XIV"
    },
    "2024-08-13": {
        "content": " У тебя есть мозги в голове. У тебя есть ноги в ботинках. Ты можешь направить себя в любом направлении, которое выберешь. Ты сам по себе. И ты знаешь то, что ты знаешь. И ты тот, кто решит, куда идти. -Доктор Сьюз"
    },
    "2024-08-14": {
        "content": " То, на чем вы фокусируетесь, расширяется, а когда вы фокусируетесь на хорошем в своей жизни, вы создаете его больше. -Опра Уинфри"
    },
    "2024-08-15": {
        "content": " Все, что мне нужно знать, открыто мне. Все, что мне нужно, приходит ко мне. Все хорошо в моей жизни. -Луиза Хей"
    },
    "2024-08-16": {
        "content": " Я в полной безопасности во Вселенной. Я везде в покое. Я доверяю жизни. -Луиза Хей"
    },
    "2024-08-17": {
        "content": " Повернитесь лицом к солнцу, и тени останутся позади вас. -Пословица маори"
    },
    "2024-08-18": {
        "content": " Мужество — это не иметь сил идти дальше; это продолжать, когда у тебя нет сил. -Теодор Рузвельт"
    },
    "2024-08-19": {
        "content": " Будущее зависит от того, что вы делаете сегодня. -Махатма Ганди"
    },
    "2024-08-20": {
        "content": " Победитель — это мечтатель, который никогда не сдается. -Нельсон Мандела"
    },
    "2024-08-21": {
        "content": "Не плачь, потому что это закончилось, улыбнись, потому что это было. -Доктор Сьюз"
    },
    "2024-08-22": {
        "content": " Я могу выразить тремя словами все, что я узнал о жизни: она продолжается. -Роберт Фрост"
    },
    "2024-08-23": {
        "content": " Живите своим воображением, а не своей историей. -Стивен Р. Кови"
    },
    "2024-08-24": {
        "content": " Я считаю, что если хочешь радугу, придется смириться с дождем. -Долли Партон"
    },
    "2024-08-25": {
        "content": " Величие человека не в том, сколько богатства он приобрел, а в его честности и способности оказывать положительное влияние на окружающих. -Боб Марли"
    },
    "2024-08-26": {
        "content": " Счастье в основном зависит от нашего собственного отношения, а не от внешних факторов. -Далай-лама XIV"
    },
    "2024-08-27": {
        "content": " Великие деяния складываются из малых дел. -Лао-цзы"
    },
    "2024-08-28": {
        "content": " Никогда не поздно стать тем, кем ты мог бы быть. -Джордж Элиот"
    },
    "2024-08-29": {
        "content": " Правильный настрой может превратить негативный стресс в позитивный. -Ганс Селье"
    },
    "2024-08-30": {
        "content": " Осмелитесь прожить жизнь, о которой вы мечтали. Идите вперед и воплощайте свои мечты в реальность. -Ральф Уолдо Эмерсон"
    },
    "2024-08-31": {
        "content": " Время, которое вам нравится тратить, не является потраченным впустую. -Бертран Рассел"
    },
    "2024-09-01": {
        "content": "Нужно лишь немного бдительности, чтобы увидеть и понять: жизнь — это на самом деле великий космический смех. -Ошо"
    },
    "2024-09-02": {
        "content": " Любопытный парадокс заключается в том, что когда я принимаю себя таким, какой я есть, я могу измениться. -Карл Р. Роджерс"
    },
    "2024-09-03": {
        "content": " Будьте частью решения, а не частью проблемы. -Стивен Р. Кови"
    },
    "2024-09-04": {
        "content": " Секрет жизни — в умении отдавать. -Тони Роббинс"
    },
    "2024-09-05": {
        "content": " Сделайте каждый день своим шедевром. -Джон Вуден"
    },
    "2024-09-06": {
        "content": " Никогда не отказывайтесь от того, что вы действительно хотите сделать. -Х. Джексон Браун-младший."
    },
    "2024-09-07": {
        "content": " Не оглядывайся назад – ты не пойдешь этим путем. -Мэри Энгельбрайт"
    },
    "2024-09-08": {
        "content": " Делайте все возможное, а Бог сделает все остальное. -Ник Вуйчич"
    },
    "2024-09-09": {
        "content": " Живите, путешествуйте, ищите приключения, благословляйте и не сожалейте. -Джек Керуак"
    },
    "2024-09-10": {
        "content": " В разгар зимы я обнаружил, что внутри меня есть непобедимое лето. И это делает меня счастливым. Ибо это говорит о том, что как бы сильно мир ни давил на меня, внутри меня есть что-то сильнее – что-то лучшее, что давит в ответ. -Альбер Камю"
    },
    "2024-09-11": {
        "content": "Некоторые считают, что только великая сила может сдерживать зло, но я не это обнаружил. Это маленькие повседневные дела простых людей, которые держат тьму в страхе. Маленькие акты доброты и любви. -Дж. Р. Р. Толкин"
    },
    "2024-09-12": {
        "content": " Будьте верны в малом, потому что именно в этом ваша сила. -Мать Тереза"
    },
    "2024-09-13": {
        "content": " Сделай из себя свет. -Будда"
    },
    "2024-09-14": {
        "content": " ВИЗУАЛИЗИРУЙТЕ!!! Увидьте, почувствуйте! Вот тут-то и начинается действие. -Ронда Берн"
    },
    "2024-09-15": {
        "content": " Будь феноменальным или будешь забыт! -Эрик Томас"
    },
    "2024-09-16": {
        "content": " Когда у вас есть выбор быть правым или быть добрым, выбирайте быть добрым. -Уэйн У. Дайер"
    },
    "2024-09-17": {
        "content": " Люди могут изменить свою жизнь, изменив образ мышления. -Уильям Джеймс"
    },
    "2024-09-18": {
        "content": " Здоровье – величайшее богатство. -Лао-цзы"
    },
    "2024-09-19": {
        "content": " Дай мне не молиться о том, чтобы меня защитили от опасностей, но молить о том, чтобы я был бесстрашен в их встрече. Дай мне не молить об успокоении моей боли, но о том, чтобы сердце победило ее. -Рабиндранат Тагор"
    },
    "2024-09-20": {
        "content": " Направьте сердце ваше на добрые дела. Делайте это снова и снова, и вы будете наполнены радостью. -Будда"
    },
    "2024-09-21": {
        "content": "Я не могу в одиночку изменить мир, но могу бросить камень в воду, чтобы создать множество кругов. -Мать Тереза"
    },
    "2024-09-22": {
        "content": " И настал день, когда риск остаться в бутоне оказался более болезненным, чем риск расцвести. -Анаис Нин"
    },
    "2024-09-23": {
        "content": " Не должно быть никаких границ для человеческих усилий. Какой бы плохой ни казалась жизнь, всегда есть надежда. -Стивен Хокинг"
    },
    "2024-09-24": {
        "content": " И я призываю вас, пожалуйста, замечать, когда вы счастливы, и восклицать, или бормотать, или думать в какой-то момент: «Если это не приятно, то я не знаю, что это». -Курт Воннегут"
    },
    "2024-09-25": {
        "content": " Именно ваша реакция на невзгоды, а не сами невзгоды, определяют, как будет развиваться история вашей жизни. -Дитер Ф. Ухтдорф"
    },
    "2024-09-26": {
        "content": " Не то, что у тебя есть, кто ты, где ты, что ты делаешь, делает тебя счастливым или несчастным. А то, что ты об этом думаешь. -Дейл Карнеги"
    },
    "2024-09-27": {
        "content": " Чем больше ты читаешь, тем больше вещей ты узнаешь. Чем больше ты узнаешь, тем больше мест ты посетишь. -Доктор Сьюз"
    },
    "2024-09-28": {
        "content": " Все наши мечты могут стать реальностью. -Уолт Дисней"
    },
    "2024-09-29": {
        "content": "Привилегия всей жизни — быть тем, кто ты есть. -Джозеф Кэмпбелл"
    },
    "2024-09-30": {
        "content": " В этом мире нет бесполезных людей, которые облегчают бремя других. -Чарльз Диккенс"
    },
    "2024-10-01": {
        "content": " Найдите внутри себя место, где есть радость, и радость выжжет боль. -Джозеф Кэмпбелл"
    },
    "2024-10-02": {
        "content": " Не спрашивай, что нужно миру. Спроси, что заставляет тебя оживать, и иди и делай это. Потому что миру нужно больше людей, которые ожили. -Говард Турман"
    },
    "2024-10-03": {
        "content": " Ваши чувства — это ваши главные инструменты, помогающие вам творить свою жизнь. -Ронда Берн"
    },
    "2024-10-04": {
        "content": " Я заслуживаю лучшего и принимаю лучшее сейчас. -Луиза Хей"
    },
    "2024-10-05": {
        "content": " Важно не то, сколько мы отдаем, а сколько любви мы вкладываем в то, что отдаем. -Мать Тереза"
    },
    "2024-10-06": {
        "content": " Когда вы хотите добиться успеха так же сильно, как хотите дышать, тогда вы добьетесь успеха. -Эрик Томас"
    },
    "2024-10-07": {
        "content": " Я ненавидел каждую минуту тренировок, но я сказал себе: «Не сдавайся. Потерпи сейчас и проживи остаток жизни как чемпион». -Мухаммед Али"
    },
    "2024-10-08": {
        "content": "Не критик имеет значение, не тот, кто указывает, как споткнулся сильный человек или как творец деяний мог бы сделать их лучше. Честь принадлежит тому, кто действительно находится на арене, чье лицо запятнано потом, пылью и кровью; кто доблестно борется; кто ошибается и терпит неудачу снова и снова; кто знает великий энтузиазм, великую преданность и тратит себя на достойное дело; кто, если он побеждает, знает триумф высокого достижения; и кто, если он терпит неудачу, по крайней мере терпит неудачу, будучи очень смелым, так что его место никогда не будет среди тех холодных и робких душ, которые не знают ни победы, ни поражения. -Теодор Рузвельт"
    },
    "2024-10-09": {
        "content": " Самое большое приключение, которое вы когда-либо можете совершить, — это прожить жизнь своей мечты. -Опра Уинфри"
    },
    "2024-10-10": {
        "content": " Без борьбы не может быть прогресса. -Фредерик Дугласс"
    },
    "2024-10-11": {
        "content": " Мечта, записанная с датой, становится целью. Цель, разбитая на шаги, становится планом. План, подкрепленный действием, делает ваши мечты реальностью. -Грег Рид"
    },
    "2024-10-12": {
        "content": "Сделайте то, что, по вашему мнению, вы не можете сделать. Потерпите неудачу. Попробуйте еще раз. Сделайте лучше во второй раз. Единственные люди, которые никогда не падают, — это те, кто никогда не лазает по канату. -Опра Уинфри"
    },
    "2024-10-13": {
        "content": " Ожидайте перемен. Анализируйте обстановку. Используйте возможности. Перестаньте быть шахматной пешкой; станьте игроком. Это ваш ход. -Тони Роббинс"
    },
    "2024-10-14": {
        "content": " Ты свободен. Ты силен. Ты хорош. Ты — любовь. Ты ценен. У тебя есть цель. Все хорошо. -Эстер Хикс"
    },
    "2024-10-15": {
        "content": "Если вы хотите чего-то настолько сильно, чтобы выйти и бороться за это, работать ради этого день и ночь, отдать свое время, свой покой и свой сон ради этого. Если все, о чем вы мечтаете и что планируете, касается этого, а жизнь без этого кажется бесполезной и никчемной; Если вы с радостью потеете, беспокоитесь и планируете это и теряете весь свой страх перед сопротивлением; Если вы просто идете за тем, чего хотите, со всеми своими способностями, силой и проницательностью, верой, надеждой и уверенностью и тверды в упорстве; Если ни холод, ни бедность, голод или подагра, болезнь или боль тела и мозга не могут удержать вас от того, чего вы хотите; Если вы упрямы и угрюмы, будете растить и зачинать это, с помощью БОЖЬЕЙ вы это получите. -Бертон Брейли"
    },
    "2024-10-16": {
        "content": " Даже если вы на правильном пути, вас переедут, если вы будете просто сидеть на месте. -Уилл Роджерс"
    },
    "2024-10-17": {
        "content": " Я думаю, что обычные люди могут выбрать быть необыкновенными. -Илон Маск"
    },
    "2024-10-18": {
        "content": " Ты не научишься ходить, следуя правилам. Ты учишься, делая и падая. -Ричард Брэнсон"
    },
    "2024-10-19": {
        "content": "Здесь нет таланта, это тяжелая работа. Это одержимость. Таланта не существует, мы все равны как люди. Вы можете стать кем угодно, если потратите время. Вы достигнете вершины, и все. Я не талантлив, я одержим. -Конор МакГрегор"
    },
    "2024-10-20": {
        "content": " Сон — это не то, что вы видите во время сна; это то, что не дает вам спать. -Абдул Калам"
    },
    "2024-10-21": {
        "content": " Когда вы исчерпали все возможности, помните: вы этого не сделали. -Томас А. Эдисон"
    },
    "2024-10-22": {
        "content": " Рискуй, совершай ошибки. Так ты растешь. Боль питает твою смелость. Ты должен терпеть неудачи, чтобы практиковать храбрость. -Мэри Тайлер Мур"
    },
    "2024-10-23": {
        "content": " На чем вы сосредоточитесь, то и получите. -Тони Роббинс"
    },
    "2024-10-24": {
        "content": " «Суета» — самое важное слово на свете. -Гари Вайнерчук"
    },
    "2024-10-25": {
        "content": " Если они смогли сделать пенициллин из заплесневелого хлеба, то они наверняка смогут сделать что-то и из вас. -Мухаммед Али"
    },
    "2024-10-26": {
        "content": " Ты не родился победителем, и ты не родился неудачником. Ты тот, кем ты себя делаешь. -Лу Хольц"
    },
    "2024-10-27": {
        "content": " Успех — это ваш долг, обязанность и ответственность. -Грант Кардон"
    },
    "2024-10-28": {
        "content": "Различий между людьми немного, но это небольшое различие имеет большое значение. Небольшое различие — это отношение. Большое различие — это то, является ли оно положительным или отрицательным. -У. Клемент Стоун"
    },
    "2024-10-29": {
        "content": " Лидеры должны быть достаточно близки, чтобы общаться с другими, но достаточно далеки от них, чтобы мотивировать их. -Джон К. Максвелл"
    },
    "2024-10-30": {
        "content": " Никогда не говори никогда, потому что ограничения, как и страхи, часто являются всего лишь иллюзией. -Майкл Джордан"
    },
    "2024-10-31": {
        "content": " Вы должны ожидать от себя великих дел, прежде чем сможете их совершить. -Майкл Джордан"
    },
    "2024-11-01": {
        "content": " В мире бизнеса наибольшего успеха добиваются те, кто занимается любимым делом. -Уоррен Баффет"
    },
    "2024-11-02": {
        "content": " Действие уничтожит вашу прокрастинацию. -Ог Мандино"
    },
    "2024-11-03": {
        "content": " Неудача для меня не вариант. Успех — это все, что я себе представляю. -Конор МакГрегор"
    },
    "2024-11-04": {
        "content": " Успех приходит не от того, что вы делаете время от времени, а от того, что вы делаете постоянно. -Мари Форлео"
    },
    "2024-11-05": {
        "content": " Уверенность и упорный труд — лучшие лекарства от болезни, называемой неудачей. Они сделают вас успешным человеком. -Абдул Калам"
    },
    "2024-11-06": {
        "content": " Если хочешь сиять как солнце, сначала гори как солнце. -Абдул Калам"
    },
    "2024-11-07": {
        "content": "Пока ты там тусуешься, валяешь дурака, кто-то там в это же время усердно трудится. Кто-то становится умнее, а кто-то побеждает. Просто помни об этом. -Арнольд Шварценеггер"
    },
    "2024-11-08": {
        "content": " Если вы делаете то, что всегда делали, вы и получите то, что всегда получали. -Тони Роббинс"
    },
    "2024-11-09": {
        "content": " Прогресс равнозначен счастью. -Тони Роббинс"
    },
    "2024-11-10": {
        "content": " У вас могут быть либо результаты, либо оправдания. Но не то и другое одновременно. -Арнольд Шварценеггер"
    },
    "2024-11-11": {
        "content": " Дисциплина равно свободе. -Джоко Виллинк"
    },
    "2024-11-12": {
        "content": " Не зацикливайтесь на том, что пошло не так. Вместо этого сосредоточьтесь на том, что делать дальше. Направьте свою энергию на движение вперед, на поиск ответа. -Денис Уэйтли"
    },
    "2024-11-13": {
        "content": " Будьте таким лидером, каким вы хотели бы быть. -Саймон Синек"
    },
    "2024-11-14": {
        "content": " Я позиция такая: если вы подталкиваете меня к чему-то, что, по вашему мнению, является слабостью, то я превращу эту кажущуюся слабость в силу. -Майкл Джордан"
    },
    "2024-11-15": {
        "content": " Для большинства из нас большая опасность заключается не в том, что мы ставим перед собой слишком высокую цель и не достигаем ее, а в том, что мы ставим перед собой слишком низкую цель и не достигаем ее. -Микеланджело"
    },
    "2024-11-16": {
        "content": " У каждого есть мечта, но не у каждого есть цель. -Эрик Томас"
    },
    "2024-11-17": {
        "content": "Лидерами становятся, ими не рождаются. Их создают упорные усилия, и это цена, которую все мы должны заплатить, чтобы достичь любой стоящей цели. -Винс Ломбарди"
    },
    "2024-11-18": {
        "content": " Мы выбираем отправиться на Луну в этом десятилетии и сделать другие вещи. Не потому, что это легко, а потому, что это трудно. -Джон Ф. Кеннеди"
    },
    "2024-11-19": {
        "content": " Самый лучший день в твоей и моей жизни — это когда мы берем на себя полную ответственность за свои взгляды. Это день, когда мы по-настоящему взрослеем. -Джон К. Максвелл"
    },
    "2024-11-20": {
        "content": " Каждый раз, когда вы улыбаетесь кому-то, это акт любви, дар этому человеку, прекрасная вещь. -Мать Тереза"
    },
    "2024-11-21": {
        "content": " Будьте молчаливым наблюдателем своих мыслей и поведения. Вы ниже мыслителя. Вы — тишина под ментальным шумом. Вы — любовь и радость под болью. -Экхарт Толле"
    },
    "2024-11-22": {
        "content": " Если не можешь летать, беги, если не можешь бежать, иди, если не можешь ходить, ползай, но что бы ты ни делал, ты должен продолжать двигаться вперед. -Мартин Лютер Кинг-младший."
    },
    "2024-11-23": {
        "content": " Прощение — это не разовое действие, это постоянная позиция. -Мартин Лютер Кинг-младший."
    },
    "2024-11-24": {
        "content": " Слишком часто мы недооцениваем силу прикосновения, улыбки, доброго слова, внимательного выслушивания, честного комплимента или даже самого маленького проявления заботы, хотя все это может изменить жизнь. -Лео Бускалья"
    },
    "2024-11-25": {
        "content": "Сохраняйте свои мечты живыми. Поймите, чтобы чего-то достичь, нужны вера и убежденность в себе, видение, упорный труд, решимость и преданность. Помните, что все возможно для тех, кто верит. -Гейл Деверс"
    },
    "2024-11-26": {
        "content": " Спорт обладает силой изменить мир. Он обладает силой вдохновлять. Он обладает силой объединять людей так, как мало что другое. Он говорит с молодежью на понятном ей языке. Спорт может создать надежду там, где когда-то было только отчаяние. -Нельсон Мандела"
    },
    "2024-11-27": {
        "content": " Проси то, чего хочешь. Поверь, что ты этого заслуживаешь, а затем позволь Жизни дать тебе это. -Луиза Хей"
    },
    "2024-11-28": {
        "content": " Живите с намерением. Идите к краю. Внимательно слушайте. Практикуйте благополучие. Играйте самозабвенно. Смейтесь. Выбирайте без сожалений. Цените своих друзей. Продолжайте учиться. Делайте то, что любите. Живите так, как будто это все, что есть. -Мэри Энн Радмахер"
    },
    "2024-11-29": {
        "content": " То, на чем вы фокусируетесь, расширяется, а когда вы фокусируетесь на хорошем в своей жизни, вы создаете его больше. -Опра Уинфри"
    },
    "2024-11-30": {
        "content": " У вас есть власть над вашим разумом, а не над внешними событиями. Осознайте это, и вы обретете силу. -Марк Аврелий"
    },
    "2024-12-01": {
        "content": "Не ищите оправданий, почему вы не можете этого сделать. Сосредоточьтесь на всех причинах, по которым вы должны это сделать. -Ральф Марстон"
    },
    "2024-12-02": {
        "content": " Где любовь, там жизнь. -Махатма Ганди"
    },
    "2024-12-03": {
        "content": " Нужно танцевать так, словно никто не видит, любить так, словно никто не причинит тебе боль, петь так, словно никто не слышит, и жить так, словно на земле рай. -Уильям В. Перки"
    },
    "2024-12-04": {
        "content": " Успех — это осознание своего предназначения в жизни, стремление раскрыть свой максимальный потенциал и сеять семена, приносящие пользу другим. -Джон К. Максвелл"
    },
    "2024-12-05": {
        "content": " Мечта, которую ты видишь в одиночку, — всего лишь мечта. Мечта, которую ты видишь вместе, — реальность. -Джон Леннон"
    },
    "2024-12-06": {
        "content": " Это настоящий секрет жизни — быть полностью вовлеченным в то, что вы делаете здесь и сейчас. И вместо того, чтобы называть это работой, осознайте, что это игра. -Алан Уоттс"
    },
    "2024-12-07": {
        "content": " Вчера уже прошло. Завтра еще не наступило. У нас есть только сегодня. Давайте начнем. -Мать Тереза"
    },
    "2024-12-08": {
        "content": " Чем больше вы хвалите и празднуете свою жизнь, тем больше в ней поводов для празднования. -Опра Уинфри"
    },
    "2024-12-09": {
        "content": "Никогда не сомневайтесь, что небольшая группа думающих, преданных граждан может изменить мир. На самом деле, это единственное, что когда-либо изменялось. -Маргарет Мид"
    },
    "2024-12-10": {
        "content": " Подталкивайте себя, потому что никто другой не сделает этого за вас. -Анонимный"
    },
    "2024-12-11": {
        "content": " Истинное смирение — это не думать о себе хуже, а думать о себе меньше. -К.С. Льюис"
    },
    "2024-12-12": {
        "content": " Если вы сможете изменить свое мнение, вы сможете изменить свою жизнь. -Уильям Джеймс"
    },
    "2024-12-13": {
        "content": " Сосредоточьтесь на том, куда вы хотите пойти, а не на том, чего вы боитесь. -Тони Роббинс"
    },
    "2024-12-14": {
        "content": " Уважайте себя, и другие будут уважать вас. -Конфуций"
    },
    "2024-12-15": {
        "content": " Делай то, что можешь, с тем, что имеешь, там, где ты есть. -Теодор Рузвельт"
    },
    "2024-12-16": {
        "content": " Некоторые изменения на первый взгляд кажутся негативными, но вскоре вы поймете, что в вашей жизни освобождается место для появления чего-то нового. -Экхарт Толле"
    },
    "2024-12-17": {
        "content": " Если ваши действия вдохновляют других мечтать больше, узнавать больше, делать больше и становиться лучше, вы — лидер. -Джон Куинси Адамс"
    },
    "2024-12-18": {
        "content": " Не беспокойся ни о чем, все будет хорошо. -Боб Марли"
    },
    "2024-12-19": {
        "content": " Мечтайте по-крупному, сохраняйте позитивный настрой, усердно работайте и наслаждайтесь путешествием. -Юрия Фабер"
    },
    "2024-12-20": {
        "content": "Вы здесь, чтобы дать возможность божественному замыслу Вселенной раскрыться. Вот насколько вы важны! -Экхарт Толле"
    },
    "2024-12-21": {
        "content": " Живите со страстью! -Тони Роббинс"
    },
    "2024-12-22": {
        "content": " Поверьте, что вы можете, и вы уже на полпути. -Теодор Рузвельт"
    },
    "2024-12-23": {
        "content": " Наша жизнь подходит к концу в тот день, когда мы перестаем говорить о важных вещах. -Мартин Лютер Кинг-младший."
    },
    "2024-12-24": {
        "content": " Вместе мы можем творить великие дела. -Мать Тереза"
    },
    "2024-12-25": {
        "content": " Упорный труд ради того, что нам безразлично, называется стрессом; упорный труд ради того, что мы любим, называется страстью. -Саймон Синек"
    },
    "2024-12-26": {
        "content": " Пещера, в которую вы боитесь войти, хранит сокровище, которое вы ищете. -Джозеф Кэмпбелл"
    },
    "2024-12-27": {
        "content": " Лидерство — это эмпатия. Это способность устанавливать связь и налаживать связи с людьми с целью вдохновения и расширения их прав и возможностей. -Опра Уинфри"
    },
    "2024-12-28": {
        "content": " Нет ничего невозможного для того, кто попытается. -Александр Македонский"
    },
    "2024-12-29": {
        "content": " Большинство важных вещей в мире были достигнуты людьми, которые продолжали стараться, когда, казалось бы, не осталось никакой надежды. -Дейл Карнеги"
    },
    "2024-12-30": {
        "content": " Мы продолжаем двигаться вперед, открываем новые двери и делаем новые вещи, потому что мы любопытны, а любопытство постоянно ведет нас по новым путям. -Уолт Дисней"
    },
    "2024-12-31": {
        "content": "Делай то, что должен, пока не сможешь делать то, что хочешь. -Опра Уинфри"
    },
    "2025-01-01": {
        "content": " Вера в то, что вы самодостаточны, дает вам смелость быть настоящим. -Брене Браун"
    },
    "2025-01-02": {
        "content": " Именно наш выбор, Гарри, показывает, кем мы являемся на самом деле, гораздо больше, чем наши способности. -Дж. К. Роулинг"
    },
    "2025-01-03": {
        "content": " Следуйте за своим счастьем, и вселенная откроет вам двери там, где раньше были только стены. -Джозеф Кэмпбелл"
    },
    "2025-01-04": {
        "content": " Сны — это не те, которые приходят к нам во время сна, а те, которые не успевают исполниться, как мы засыпаем. -Абдул Калам"
    },
    "2025-01-05": {
        "content": " Смелость в значительной степени означает смелость быть уязвимым. Это значит показаться и быть увиденным. Просить о том, что вам нужно. Говорить о том, что вы чувствуете. Вести трудные разговоры. -Брене Браун"
    },
    "2025-01-06": {
        "content": " Вы никогда не добьетесь успеха, пока не превратите свою боль в величие, пока не позволите своей боли вытолкнуть вас оттуда, где вы находитесь, туда, где вам нужно быть. Перестаньте бежать от своей боли и примите свою боль. Ваша боль станет частью вашего приза, частью вашего продукта. Я бросаю вам вызов: подтолкните себя. -Эрик Томас"
    },
    "2025-01-07": {
        "content": " Мы есть то, что мы постоянно делаем. Поэтому совершенство — это не действие, а привычка. -Аристотель"
    },
    "2025-01-08": {
        "content": " Река прорезает скалу не благодаря своей силе, а благодаря своему упорству. -Джим Уоткинс"
    },
    "2025-01-09": {
        "content": " Энергия и упорство побеждают все. -Бенджамин Франклин"
    },
    "2025-01-10": {
        "content": " Возможности обычно маскируются под упорный труд, поэтому большинство людей их не распознают. -Энн Лэндерс"
    },
    "2025-01-11": {
        "content": " Если не можешь летать, беги, если не можешь бежать, иди, если не можешь ходить, ползай, но что бы ты ни делал, ты должен продолжать двигаться вперед. -Мартин Лютер Кинг-младший."
    },
    "2025-01-12": {
        "content": " Настойчивость гарантирует неизбежность результатов. -Парамаханса Йогананда"
    },
    "2025-01-13": {
        "content": " При наличии обычного таланта и необычайного упорства все достижимо. -Томас Фоуэлл Бакстон"
    },
    "2025-01-14": {
        "content": " Наша величайшая слава не в том, чтобы никогда не терпеть неудач, а в том, чтобы подниматься каждый раз, когда мы терпим неудачу. -Ральф Уолдо Эмерсон"
    },
    "2025-01-15": {
        "content": " Успех — это спотыкающийся путь от неудачи к неудаче без потери энтузиазма. -Уинстон Черчилль"
    },
    "2025-01-16": {
        "content": "К счастью, настойчивость — отличная замена таланту. -Стив Мартин"
    },
    "2025-01-17": {
        "content": " Я больше верю в удачу, и я обнаружил, что чем больше я работаю, тем больше ее у меня есть. -Томас Джефферсон"
    },
    "2025-01-18": {
        "content": " Откладывай на завтра только то, что ты готов оставить несделанным до самой смерти. -Пабло Пикассо"
    },
    "2025-01-19": {
        "content": " Нет никаких секретов успеха: не тратьте время на их поиски. Успех — это результат совершенства, упорного труда, обучения на неудачах, преданности тем, для кого вы работаете, и настойчивости. -Колин Пауэлл"
    },
    "2025-01-20": {
        "content": " Если хочешь быть впереди, то веди себя так, как будто ты сзади. -Лао-цзы"
    },
    "2025-01-21": {
        "content": " Позвольте мне раскрыть вам секрет, который привел меня к моей цели: моя сила заключается исключительно в моем упорстве. -Луи Пастер"
    },
    "2025-01-22": {
        "content": " Ничто в этом мире не заменит упорства. Талант не заменит; нет ничего более распространенного, чем неудачники с талантом. Гений не заменит; невознагражденный гений — это почти пословица. -Кэлвин Кулидж"
    },
    "2025-01-23": {
        "content": " Лучший выход всегда — насквозь. -Роберт Фрост"
    },
    "2025-01-24": {
        "content": "Многие из тех, кто потерпел неудачу в жизни, — это люди, которые не осознавали, насколько близки они были к успеху, когда сдались. -Томас А. Эдисон"
    },
    "2025-01-25": {
        "content": " Мы созданы для упорства. Так мы узнаем, кто мы есть. -Тобиас Вольф"
    },
    "2025-01-26": {
        "content": " Зная деревья, я понимаю значение терпения. Зная траву, я могу оценить настойчивость. -Хэл Борланд"
    },
    "2025-01-27": {
        "content": " Капающая вода точит камень, но не силой, а настойчивостью. -Овидий"
    },
    "2025-01-28": {
        "content": " Настойчивость очень важна. Не стоит сдаваться, если только вас не вынуждают сдаться. -Илон Маск"
    },
    "2025-01-29": {
        "content": " Пламенный энтузиазм, подкрепленный здравым смыслом и настойчивостью, — это качество, которое чаще всего способствует успеху. -Дейл Карнеги"
    },
    "2025-01-30": {
        "content": " Амбиции — это путь к успеху. Упорство — это средство передвижения, на котором вы прибудете. -Билл Брэдли"
    },
    "2025-01-31": {
        "content": " Сосредоточьтесь на решении, а не на проблеме. -Уолтер Андерсон"
    },
    "2025-02-01": {
        "content": " Когда жизнь сбивает тебя с ног, у тебя есть два выбора — оставаться внизу или вставать. -Том Краузе"
    },
    "2025-02-02": {
        "content": "Успех — это сумма небольших усилий, повторяемых изо дня в день. -Роберт Колльер"
    },
    "2025-02-03": {
        "content": " Мечта — это всего лишь мечта. Цель — это мечта с планом и сроком. -Харви Маккей"
    },
    "2025-02-04": {
        "content": " Никогда не отказывайтесь от чего-то, без мыслей о чем вы не можете прожить и дня. -Уинстон Черчилль"
    },
    "2025-02-05": {
        "content": " Алмазы — это не более чем куски угля, прилипшие к своим рабочим местам. -Малкольм С. Форбс"
    },
    "2025-02-06": {
        "content": " Ничего нельзя сделать, кроме как понемногу. -Шарль Бодлер"
    },
    "2025-02-07": {
        "content": " Если вы проходите через ад, продолжайте идти. -Уинстон Черчилль"
    },
    "2025-02-08": {
        "content": " Ключ настойчивости открывает все двери, закрытые сопротивлением. -Джон Ди Лемме"
    },
    "2025-02-09": {
        "content": " Если мы посмотрим на самых успешных людей в мире, то их общим знаменателем будет настойчивость. -Джастин Сакс"
    },
    "2025-02-10": {
        "content": " Слона можно съесть по частям. -Мэри Кэй Эш"
    },
    "2025-02-11": {
        "content": " Я не думаю, что есть какое-либо другое качество, столь необходимое для успеха любого рода, как качество настойчивости. Оно преодолевает почти все, даже природу. -Джон Д. Рокфеллер"
    },
    "2025-02-12": {
        "content": "Если вы хотите превратить мечту в реальность, вам придется выложиться на все 100% и никогда не переставать верить в свою мечту. -Арнольд Шварценеггер"
    },
    "2025-02-13": {
        "content": " Бегите, когда можете, идите, если нужно, ползите, если нужно; просто никогда не сдавайтесь. -Дин Карназес"
    },
    "2025-02-14": {
        "content": " Пройти еще один раунд, когда вы думаете, что не можете этого сделать, — вот что имеет решающее значение в вашей жизни. -Сильвестр Сталлоне"
    },
    "2025-02-15": {
        "content": " Послушай меня, даже когда ты проигрываешь, проигрывать нормально, но ты никогда не сможешь с этим смириться. Ты никогда не сможешь быть удовлетворен проигрышем. Когда ты проигрываешь, это должно быть больно. -Эрик Томас"
    },
    "2025-02-16": {
        "content": " Продолжайте идти своим путем, шаг за шагом. -Джойс Майер"
    },
    "2025-02-17": {
        "content": " Мы не должны сдаваться и не должны позволять проблеме победить нас. -Абдул Калам"
    },
    "2025-02-18": {
        "content": " Благодаря терпению мы побеждаем. -Эрнест Шеклтон"
    },
    "2025-02-19": {
        "content": "Кирпичные стены существуют не просто так. Кирпичные стены существуют не для того, чтобы нас не пускать. Кирпичные стены существуют для того, чтобы дать нам возможность показать, как сильно мы чего-то хотим. Потому что кирпичные стены существуют для того, чтобы останавливать людей, которые хотят этого недостаточно сильно. Они существуют для того, чтобы останавливать других людей. -Рэнди Пауш"
    },
    "2025-02-20": {
        "content": " Успех почти полностью зависит от напористости и упорства. Дополнительная энергия, необходимая для того, чтобы приложить еще одно усилие или попробовать другой подход, — вот секрет победы. -Денис Уэйтли"
    },
    "2025-02-21": {
        "content": " Я добился этого и отказался сдаваться, потому что всю свою жизнь я всегда доходил до конца гонки. -Луи Замперини"
    },
    "2025-02-22": {
        "content": " Выживание можно описать тремя словами – никогда не сдавайся. Вот в чем суть. Просто продолжай пытаться. -Беар Гриллс"
    },
    "2025-02-23": {
        "content": "БОЛЬШЕ НИКАКИХ. Больше никаких оправданий. Больше никаких: «Я начну завтра». Больше никаких: «Только в этот раз». Больше никаких смирений с недостатками собственной воли. Больше никаких легких путей. Больше никаких преклонений перед любыми нездоровыми или непродуктивными мыслями, которые мелькают в моем сознании. -Джоко Виллинк"
    },
    "2025-02-24": {
        "content": " Маленькие удары валят большие дубы. -Бенджамин Франклин"
    },
    "2025-02-25": {
        "content": " Я готов. Я настроен на победу. Я понимаю это. Я принимаю неопределенность. Я — это не мои мысли; я — это то, что я делаю. Я непреклонен. Я ничего не ожидаю и принимаю все. -Гари Джон Бишоп"
    },
    "2025-02-26": {
        "content": " Я не терпел неудач 700 раз. Я не терпел неудач ни разу. Мне удалось доказать, что эти 700 способов не сработают. Когда я устраню способы, которые не сработают, я найду способ, который сработает. -Томас А. Эдисон"
    },
    "2025-02-27": {
        "content": " GRIT — это сила воли, стойкость, трудолюбие и упорство. GRIT — это способность сосредотачиваться, сохранять решимость, сохранять оптимизм перед лицом трудностей и просто работать усерднее, чем соседи. -Линда Каплан Талер"
    },
    "2025-02-28": {
        "content": "Я думаю, мой секрет в том, что не существует коротких путей к упорному труду, решимости и настрою «никогда не сдаваться». -Джерри Райс"
    },
    "2025-03-01": {
        "content": " Никогда не прекращайте бороться, пока не достигнете своего предназначенного места – то есть уникального себя. Имейте цель в жизни, постоянно приобретайте знания, усердно работайте и будьте настойчивы, чтобы реализовать великую жизнь. -Абдул Калам"
    },
    "2025-03-02": {
        "content": " Не останавливайся, когда устал. Остановись, когда закончишь. -Дэвид Гоггинс"
    },
    "2025-03-03": {
        "content": " Не судите меня по моим успехам, судите меня по тому, сколько раз я падал и снова вставал. -Нельсон Мандела"
    },
    "2025-03-04": {
        "content": " То, что не начато сегодня, никогда не закончится завтра. -Иоганн Вольфганг фон Гёте"
    },
    "2025-03-05": {
        "content": " Если вы написали сотню рассказов и все они плохие, это не значит, что вы потерпели неудачу. Вы потерпели неудачу только если перестали писать. -Рэй Брэдбери"
    },
    "2025-03-06": {
        "content": " Мастер терпел неудачу чаще, чем новичок пытался что-либо сделать. -Стивен МакКрейни"
    },
    "2025-03-07": {
        "content": " К черту обстоятельства; я создаю возможности. -Брюс Ли"
    },
    "2025-03-08": {
        "content": "Единственное, что хуже, чем начать что-то и потерпеть неудачу, — это не начать ничего. -Сет Годин"
    },
    "2025-03-09": {
        "content": " Никогда не откладывай на завтра то, что можно сделать сегодня. -Бенджамин Франклин"
    },
    "2025-03-10": {
        "content": " Благодаря упорству улитка добралась до ковчега. -Чарльз Х. Сперджен"
    },
    "2025-03-11": {
        "content": " Помните, надежда — это хорошо, может быть, даже лучше всего, и ничто хорошее не умирает. -Стивен Кинг"
    },
    "2025-03-12": {
        "content": " Предприниматели не заканчивают, когда мы устали. Мы заканчиваем, когда мы закончили. -Роберт Т. Кийосаки"
    },
    "2025-03-13": {
        "content": " Только упорство и решимость всемогущи. -Кэлвин Кулидж"
    },
    "2025-03-14": {
        "content": " Парализуйте сопротивление настойчивостью. -Вуди Хейс"
    },
    "2025-03-15": {
        "content": " Успех никогда не является собственностью, он арендуется, и арендная плата взимается каждый день. -Рори Ваден"
    },
    "2025-03-16": {
        "content": " Успех не случаен. Это тяжелая работа, упорство, обучение, изучение, жертвенность и, прежде всего, любовь к тому, что вы делаете или учитесь делать. -Пеле"
    },
    "2025-03-17": {
        "content": " Нет способа обойти тяжелую работу. Примите это. -Роджер Федерер"
    },
    "2025-03-18": {
        "content": " Мечта не становится реальностью с помощью волшебства; для этого нужны пот, решимость и упорный труд. -Колин Пауэлл"
    },
    "2025-03-19": {
        "content": "Обучение никогда не истощает разум. -Леонардо да Винчи"
    },
    "2025-03-20": {
        "content": " Я слышу и забываю. Я вижу и запоминаю. Я делаю и понимаю. -Конфуций"
    },
    "2025-03-21": {
        "content": " Тот, кто никогда не совершал ошибок, никогда не пробовал ничего нового. -Альберт Эйнштейн"
    },
    "2025-03-22": {
        "content": " Постарайтесь узнать что-нибудь обо всем и все о чем-нибудь. -Томас Генри Хаксли"
    },
    "2025-03-23": {
        "content": " Человек учится только двумя способами: читая и общаясь с более умными людьми. -Уилл Роджерс"
    },
    "2025-03-24": {
        "content": " Вы ничего не поймете, пока не узнаете это более чем одним способом. -Марвин Мински"
    },
    "2025-03-25": {
        "content": " Скажи мне, и я забуду, научи меня, и я, может быть, запомню, вовлеки меня, и я научусь. -Бенджамин Франклин"
    },
    "2025-03-26": {
        "content": " Если вы хотите увеличить свой процент успеха, удвойте процент неудач. -Томас Дж. Уотсон"
    },
    "2025-03-27": {
        "content": " Интеллект — это то, что вы используете, когда не знаете, что делать. -Жан Пиаже"
    },
    "2025-03-28": {
        "content": " Неграмотными в XXI веке будут не те, кто не умеет читать и писать, а те, кто не умеет учиться, разучиваться и переучиваться. -Элвин Тоффлер"
    },
    "2025-03-29": {
        "content": "Именно то, что мы уже знаем, часто мешает нам учиться. -Клод Бернар"
    },
    "2025-03-30": {
        "content": " Математика — это язык, на котором Бог написал вселенную. -Галилео Галилей"
    },
    "2025-03-31": {
        "content": " Вся цель образования — превратить зеркала в окна. -Сидней Дж. Харрис"
    },
    "2025-04-01": {
        "content": " Я не боюсь штормов, потому что учусь управлять своим кораблем. -Луиза Мэй Олкотт"
    },
    "2025-04-02": {
        "content": " Образован только тот человек, который научился учиться и меняться. -Карл Р. Роджерс"
    },
    "2025-04-03": {
        "content": " Я никогда не встречал настолько невежественного человека, у которого я не мог бы чему-то научиться. -Галилео Галилей"
    },
    "2025-04-04": {
        "content": " Ничто не уходит, пока не научит нас тому, что нам нужно знать. -Пема Чодрон"
    },
    "2025-04-05": {
        "content": " Практика приводит к совершенству. После долгой практики наша работа станет естественной, искусной, быстрой и стабильной. -Брюс Ли"
    },
    "2025-04-06": {
        "content": " Когда вы говорите, вы только повторяете то, что уже знаете. Но если вы слушаете, вы можете узнать что-то новое. -Далай-лама XIV"
    },
    "2025-04-07": {
        "content": " Стремитесь к прогрессу, а не к совершенству. -Анонимный"
    },
    "2025-04-08": {
        "content": "Я всегда делаю то, чего пока не умею, чтобы научиться это делать. -Винсент Ван Гог"
    },
    "2025-04-09": {
        "content": " Знание делает человека непригодным к рабству. -Фредерик Дугласс"
    },
    "2025-04-10": {
        "content": " Я очень рано понял разницу между знанием названия чего-либо и знанием чего-либо. -Ричард П. Фейнман"
    },
    "2025-04-11": {
        "content": " Способность учиться — это дар; Способность учиться — это навык; Желание учиться — это выбор. -Брайан Герберт"
    },
    "2025-04-12": {
        "content": " Учитесь всему, чему можете, когда можете и у кого можете, — обязательно наступит время, когда вы будете благодарны за это. -Сара Колдуэлл"
    },
    "2025-04-13": {
        "content": " Я невысокого мнения о человеке, который сегодня не стал мудрее, чем он был вчера. -Авраам Линкольн"
    },
    "2025-04-14": {
        "content": " Ключ к успеху — это стремление к непрерывному обучению. -Стивен Р. Кови"
    },
    "2025-04-15": {
        "content": " Будьте страстными и смелыми. Всегда продолжайте учиться. Вы перестанете делать полезные вещи, если не будете учиться. -Сатья Наделла"
    },
    "2025-04-16": {
        "content": "Высшая деятельность, которой может достичь человек, — это обучение ради понимания, потому что понимать — значит быть свободным. -Барух Спиноза"
    },
    "2025-04-17": {
        "content": " Если вы не будете продолжать учиться, другие люди пройдут мимо вас. Один темперамент не поможет — нужно много любопытства на долгое-долгое время. -Чарли Мангер"
    },
    "2025-04-18": {
        "content": " Обучающаяся организация — это организация, которая постоянно расширяет свои возможности по созданию своего будущего. -Питер Сенге"
    },
    "2025-04-19": {
        "content": " В тот день, когда вы перестаете учиться, вы начинаете деградировать. -Айзек Азимов"
    },
    "2025-04-20": {
        "content": " Учение — украшение в процветании, убежище в невзгодах и обеспечение в старости. -Аристотель"
    },
    "2025-04-21": {
        "content": " Все лидеры — ученики. Как только вы перестаете учиться, вы перестаете вести за собой. Я учусь так многому, как могу, у стольких, у кого могу, так часто, как могу. -Рик Уоррен"
    },
    "2025-04-22": {
        "content": " Чтобы быстро научиться сложным вещам, нужно сосредоточиться, не отвлекаясь. Другими словами, учиться — это акт глубокой работы. -Кэл Ньюпорт"
    },
    "2025-04-23": {
        "content": " Любой дурак может знать. Главное — понять. -Альберт Эйнштейн"
    },
    "2025-04-24": {
        "content": "Проводите каждый день, стараясь стать немного мудрее, чем вы были, когда проснулись. -Чарли Мангер"
    },
    "2025-04-25": {
        "content": " Инвестируйте в себя, в свое образование. Нет ничего лучше. -Сильвия Портер"
    },
    "2025-04-26": {
        "content": " Самообразование является для меня постоянным источником удовольствия, ведь чем больше я узнаю, тем полнее становится моя жизнь и тем больше я ценю собственное существование. -Айзек Азимов"
    },
    "2025-04-27": {
        "content": " Вы можете получить помощь от учителей, но вам придется многому научиться самостоятельно, сидя в одиночестве в классе. -Доктор Сьюз"
    },
    "2025-04-28": {
        "content": " Обучение происходит тогда, когда кто-то хочет учиться, а не тогда, когда кто-то хочет учить. -Роджер Шэнк"
    },
    "2025-04-29": {
        "content": " Человек не может научить другого человека напрямую; человек может лишь способствовать обучению другого человека. -Карл Р. Роджерс"
    },
    "2025-04-30": {
        "content": " Обучение не обязательно; оно добровольно. Улучшение не обязательно; оно добровольно. Но чтобы выжить, мы должны учиться. -У. Эдвардс Деминг"
    },
    "2025-05-01": {
        "content": " Я всегда делаю то, чего не умею, чтобы научиться это делать. -Пабло Пикассо"
    },
    "2025-05-02": {
        "content": "Ни один вор, каким бы искусным он ни был, не может украсть у человека знания, и именно поэтому знания — это лучшее и самое безопасное сокровище, которое можно приобрести. -Л. Фрэнк Баум"
    },
    "2025-05-03": {
        "content": " Я думаю, это самый лучший совет: постоянно думайте о том, как вы могли бы что-то сделать лучше, и задавайте себе вопросы. -Илон Маск"
    },
    "2025-05-04": {
        "content": " Мудрый человек может больше узнать из глупого вопроса, чем дурак из мудрого ответа. -Брюс Ли"
    },
    "2025-05-05": {
        "content": " Если я и видел дальше, то лишь потому, что стоял на плечах гигантов. -Исаак Ньютон"
    },
    "2025-05-06": {
        "content": " То, что мы знаем — это капля, то, чего мы не знаем — это океан. -Исаак Ньютон"
    },
    "2025-05-07": {
        "content": " Самое прекрасное в обучении то, что никто не может его у вас отнять. -ББ Кинг"
    },
    "2025-05-08": {
        "content": " Если вы хотите стать писателем, вам прежде всего нужно делать две вещи: много читать и много писать. -Стивен Кинг"
    },
    "2025-05-09": {
        "content": " Повторение — мать мастерства. -Тони Роббинс"
    },
    "2025-05-10": {
        "content": " Удивление — начало мудрости. -Сократ"
    },
    "2025-05-11": {
        "content": " Если вы совершили ошибку и не исправили ее, это называется ошибкой. -Конфуций"
    },
    "2025-05-12": {
        "content": " Цель образования — заменить пустой ум открытым. -Малкольм С. Форбс"
    },
    "2025-05-13": {
        "content": "Ничего в жизни не надо бояться, надо только понимать. Сейчас самое время больше понимать, чтобы меньше бояться. -Мария Кюри"
    },
    "2025-05-14": {
        "content": " Когда вас спросят, сможете ли вы выполнить работу, отвечайте: «Конечно, смогу!». Затем займитесь делом и выясните, как это сделать. -Теодор Рузвельт"
    },
    "2025-05-15": {
        "content": " Нам всем нужны люди, которые дадут нам обратную связь. Так мы совершенствуемся. -Билл Гейтс"
    },
    "2025-05-16": {
        "content": " Образование — это ключ к познанию мира, пропуск к свободе. -Опра Уинфри"
    },
    "2025-05-17": {
        "content": " Все начинается с идеи. -Эрл Найтингейл"
    },
    "2025-05-18": {
        "content": " Лучшая инвестиция, которую вы можете сделать, — это вложение в себя. -Уоррен Баффет"
    },
    "2025-05-19": {
        "content": " Дело не в деньгах или связях. Дело в готовности работать и учиться лучше всех. -Марк Кьюбан"
    },
    "2025-05-20": {
        "content": " Пока вы живы, продолжайте учиться жить. -Сенека"
    },
    "2025-05-21": {
        "content": " Чтобы научиться добиваться успеха, сначала нужно научиться терпеть неудачи. -Майкл Джордан"
    },
    "2025-05-22": {
        "content": " Не упускайте хорошую ошибку, учитесь на ней. -Роберт Т. Кийосаки"
    },
    "2025-05-23": {
        "content": "Чтобы приобрести знания, нужно учиться; но чтобы приобрести мудрость, нужно наблюдать. -Мэрилин Вос Савант"
    },
    "2025-05-24": {
        "content": " Век живи — век учись. В любом случае, век живи. -Дуглас Адамс"
    },
    "2025-05-25": {
        "content": " Терпение — спутник мудрости. -Святой Августин"
    },
    "2025-05-26": {
        "content": " Я знаю только одно: я ничего не знаю. -Сократ"
    },
    "2025-05-27": {
        "content": " Мудрость приходит с опытом. Опыт часто является результатом отсутствия мудрости. -Терри Пратчетт"
    },
    "2025-05-28": {
        "content": " Мы можем судить о своем прогрессе по смелости наших вопросов и глубине наших ответов, по нашей готовности принять то, что истинно, а не то, что кажется хорошим. -Карл Саган"
    },
    "2025-05-29": {
        "content": " Я бы предпочел вопросы, на которые нельзя ответить, чем ответы, которые нельзя подвергнуть сомнению. -Ричард П. Фейнман"
    },
    "2025-05-30": {
        "content": " Я всегда готов учиться, хотя мне не всегда нравится, когда меня учат. -Уинстон Черчилль"
    },
    "2025-05-31": {
        "content": " Тот, кто любит практику без теории, подобен моряку, который садится на корабль без руля и компаса и никогда не знает, куда его приведет. -Леонардо да Винчи"
    },
    "2025-06-01": {
        "content": " Лучше творить, чем учиться. Творчество — суть жизни. -Юлий Цезарь"
    },
    "2025-06-02": {
        "content": "То, что делает рука, помнит разум. -Мария Монтессори"
    },
    "2025-06-03": {
        "content": " Всегда идите по жизни так, словно вам предстоит узнать что-то новое, и вы это узнаете. -Вернон Ховард"
    },
    "2025-06-04": {
        "content": " Неудача становится успехом, если мы извлекаем из нее уроки. -Малкольм С. Форбс"
    },
    "2025-06-05": {
        "content": " Образование — лучший друг. Образованный человек уважаем везде. Образование побеждает красоту и молодость. -Чанакья"
    },
    "2025-06-06": {
        "content": " Не думай, что то, что тебе трудно освоить, для человека невозможно; но если что-то для человека возможно, считай это достижимым. -Марк Аврелий"
    },
    "2025-06-07": {
        "content": " Обучение — это постоянный процесс открытия, процесс, не имеющий конца. -Брюс Ли"
    },
    "2025-06-08": {
        "content": " Не столько стыдно быть невежественным, сколько нежелать учиться. -Бенджамин Франклин"
    },
    "2025-06-09": {
        "content": " Я убежден, что знание — это сила, позволяющая преодолевать прошлое, менять собственные ситуации, бороться с новыми препятствиями и принимать более обоснованные решения. -Бен Карсон"
    },
    "2025-06-10": {
        "content": " Вдыхая, я успокаиваю тело и разум. Выдыхая, я улыбаюсь. Пребывая в настоящем моменте, я знаю, что это единственный момент. -Тит Нат Хан"
    },
    "2025-06-11": {
        "content": "Если вы считаете, что вы слишком малы, чтобы что-то изменить, попробуйте спать с комаром. -Далай-лама XIV"
    },
    "2025-06-12": {
        "content": " Слишком часто мы недооцениваем силу прикосновения, улыбки, доброго слова, внимательного выслушивания, честного комплимента или даже самого маленького проявления заботы, хотя все это может изменить жизнь. -Лео Бускалья"
    },
    "2025-06-13": {
        "content": " Как мы проводим наши дни, так мы, конечно же, и проводим нашу жизнь. -Энни Диллард"
    },
    "2025-06-14": {
        "content": " Питайте свой разум великими мыслями, ибо вы никогда не подниметесь выше, чем думаете. -Бенджамин Дизраэли"
    },
    "2025-06-15": {
        "content": " Ты не научишься ходить, следуя правилам. Ты учишься, делая и падая. -Ричард Брэнсон"
    },
    "2025-06-16": {
        "content": " Невозможно прожить жизнь, не потерпев ни одной неудачи, если только вы не живете настолько осторожно, что с тем же успехом могли бы не жить вовсе. В таком случае вы по умолчанию терпите неудачу. -Дж. К. Роулинг"
    },
    "2025-06-17": {
        "content": " Если хочешь быть счастливым — будь им. -Лев Толстой"
    },
    "2025-06-18": {
        "content": " Никто не может причинить мне вред без моего разрешения. -Махатма Ганди"
    },
    "2025-06-19": {
        "content": " Когда я отпускаю то, кем я являюсь, я становлюсь тем, кем я могу быть. -Лао-цзы"
    },
    "2025-06-20": {
        "content": "Причина, по которой мы боремся с неуверенностью, заключается в том, что мы сравниваем то, что происходит за кулисами нашей жизни, с яркими моментами жизни других людей. -Стивен Фуртик"
    },
    "2025-06-21": {
        "content": " Помните, сегодня – это то завтра, о котором вы беспокоились вчера. -Дейл Карнеги"
    },
    "2025-06-22": {
        "content": " Мы должны быть готовы отказаться от той жизни, которую мы запланировали, чтобы иметь ту жизнь, которая нас ждет. -Джозеф Кэмпбелл"
    },
    "2025-06-23": {
        "content": " Перестань уходить, и ты придёшь. Перестань искать, и ты увидишь. Перестань убегать, и тебя найдут. -Лао-цзы"
    },
    "2025-06-24": {
        "content": " Команда — это не группа людей, которые работают вместе. Команда — это группа людей, которые доверяют друг другу. -Саймон Синек"
    },
    "2025-06-25": {
        "content": " Постоянный оптимизм — это умножитель силы. -Колин Пауэлл"
    },
    "2025-06-26": {
        "content": " Когда вы будете довольны тем, что вы просто являетесь собой, не будете сравнивать себя с другими и соперничать с ними, все будут вас уважать. -Лао-цзы"
    },
    "2025-06-27": {
        "content": " Считай свой возраст по друзьям, а не по годам. Считай свою жизнь по улыбкам, а не по слезам. -Джон Леннон"
    },
    "2025-06-28": {
        "content": " Дайте тем, кого вы любите, крылья, чтобы летать, корни, чтобы вернуться, и причины остаться. -Далай-лама XIV"
    },
    "2025-06-29": {
        "content": " Упорство и сила духа творили чудеса во все века. -Джордж Вашингтон"
    },
    "2025-06-30": {
        "content": "Поделитесь своими знаниями. Это способ достичь бессмертия. -Далай-лама XIV"
    },
    "2025-07-01": {
        "content": " Мы — способ, с помощью которого космос познает себя. -Карл Саган"
    },
    "2025-07-02": {
        "content": " Хороший учитель может вселить надежду, пробудить воображение и привить любовь к учебе. -Брэд Генри"
    },
    "2025-07-03": {
        "content": " Одно из величайших открытий, которое делает человек, один из его величайших сюрпризов — это осознание того, что он может сделать то, чего он боялся не сделать. -Генри Форд"
    },
    "2025-07-04": {
        "content": " Когда вы в последний раз делали что-то впервые? -Джон К. Максвелл"
    },
    "2025-07-05": {
        "content": " Если вы не находитесь в процессе становления тем человеком, которым хотите быть, вы автоматически становитесь тем человеком, которым не хотите быть. -Дейл Карнеги"
    },
    "2025-07-06": {
        "content": " Удача сопутствует смелым. -Латинская пословица"
    },
    "2025-07-07": {
        "content": " Успех — не ключ к счастью. Счастье — ключ к успеху. Если вы любите то, что делаете, вы будете успешны. -Альберт Швейцер"
    },
    "2025-07-08": {
        "content": " Не приобретай мир и не губи душу свою: мудрость лучше серебра и золота. -Боб Марли"
    },
    "2025-07-09": {
        "content": " Начните жить немедленно и считайте каждый отдельный день отдельной жизнью. -Сенека"
    },
    "2025-07-10": {
        "content": "Если кто-то вроде тебя не проявит к этому большого интереса, то лучше уже не станет. -Доктор Сьюз"
    },
    "2025-07-11": {
        "content": " Они не знали, что это невозможно, поэтому они это сделали. -Марк Твен"
    },
    "2025-07-12": {
        "content": " Я могу делать то, чего не можешь ты, ты можешь делать то, чего не могу я; вместе мы можем творить великие дела. -Мать Тереза"
    },
    "2025-07-13": {
        "content": " Единственное, чего нам следует бояться, — это самого страха. -Франклин Д. Рузвельт"
    },
    "2025-07-14": {
        "content": " Ничто великое не достигалось без энтузиазма. -Ральф Уолдо Эмерсон"
    },
    "2025-07-15": {
        "content": " Мужайся, дорогое сердце. -К.С. Льюис"
    },
    "2025-07-16": {
        "content": " Единственный способ осмыслить перемены — это окунуться в них, двигаться вместе с ними и присоединиться к танцу. -Алан Уоттс"
    },
    "2025-07-17": {
        "content": " Куда направлено внимание, туда течет энергия и видны результаты. -Т. Харв Экер"
    },
    "2025-07-18": {
        "content": " Боль временна. Она может длиться минуту, час, день или год, но в конце концов она утихнет и что-то другое займет ее место. Однако если я уйду, она будет длиться вечно. -Лэнс Армстронг"
    },
    "2025-07-19": {
        "content": " В каждой прогулке на природе человек получает гораздо больше, чем ищет. -Джон Мьюир"
    },
    "2025-07-20": {
        "content": "Победители — это не те, кто никогда не терпит неудач, а те, кто никогда не сдается. -Эдвин Луис Коул"
    },
    "2025-07-21": {
        "content": " Вместо того чтобы бороться с тьмой, вы несете свет. -Экхарт Толле"
    },
    "2025-07-22": {
        "content": " Будьте бесстрашны в погоне за тем, что зажигает вашу душу. -Дженнифер Ли"
    },
    "2025-07-23": {
        "content": " Когда люди уходят от вас, отпустите их. Ваша судьба никогда не связана с теми, кто вас покидает, и это не значит, что они плохие люди. Это просто значит, что их роль в вашей истории окончена. -ТД Джейкс"
    },
    "2025-07-24": {
        "content": " Лидерство — это способность воплощать видение в реальность. -Уоррен Г. Беннис"
    },
    "2025-07-25": {
        "content": " Вера — это когда ты веришь в то, чего не видишь; награда за эту веру — видеть то, во что веришь. -Святой Августин"
    },
    "2025-07-26": {
        "content": " Нет ничего невозможного, пока вы так не думаете. -Парамаханса Йогананда"
    },
    "2025-07-27": {
        "content": " Единственное, что хуже слепоты, — это иметь зрение, но не иметь видения. -Хелен Келлер"
    },
    "2025-07-28": {
        "content": " Во всем есть своя красота, но не все ее видят. -Конфуций"
    },
    "2025-07-29": {
        "content": " Бог говорит в тишине сердца. -Мать Тереза"
    },
    "2025-07-30": {
        "content": "Надежда — это нечто с перьями, что сидит в душе и поет мелодию без слов, и никогда не останавливается. -Эмили Дикинсон"
    },
    "2025-07-31": {
        "content": " Сколько бы святых слов вы ни читали, сколько бы ни произносили, какую пользу они вам принесут, если вы не будете следовать им? -Будда"
    },
    "2025-08-01": {
        "content": " И, кстати, обо всем в жизни можно написать, если у вас есть смелость это сделать и воображение, чтобы импровизировать. Самый страшный враг творчества — это неуверенность в себе. -Сильвия Плат"
    },
    "2025-08-02": {
        "content": " Ничто из того, что мы делаем, не может изменить прошлое, но все, что мы делаем, меняет будущее. -Эшли Бриллиант"
    },
    "2025-08-03": {
        "content": " Лидерство — это выбор. Это не звание. -Саймон Синек"
    },
    "2025-08-04": {
        "content": " Все будет хорошо, и все будет хорошо, и все будет хорошо. -Джулиан из Норвича"
    },
    "2025-08-05": {
        "content": " Каждый из нас, в космической перспективе, драгоценен. Если человек не согласен с тобой, оставь его в живых. В ста миллиардах галактик ты не найдешь другого. -Карл Саган"
    },
    "2025-08-06": {
        "content": " Интеллект плюс характер — вот цель настоящего образования. -Мартин Лютер Кинг-младший."
    },
    "2025-08-07": {
        "content": "Чем больше вы погружаетесь в нечто большее, чем вы сами, тем больше у вас будет энергии. -Норман Винсент Пил"
    },
    "2025-08-08": {
        "content": " Освойте основы, и уровень всего, что вы делаете, повысится. -Майкл Джордан"
    },
    "2025-08-09": {
        "content": " Вы не сможете жить вообще, если не сможете жить полноценно сейчас. -Алан Уоттс"
    },
    "2025-08-10": {
        "content": " Помните, что иногда не получить желаемое — это большая удача. -Далай-лама XIV"
    },
    "2025-08-11": {
        "content": " Сделайте все возможное, а затем расслабьтесь. Позвольте вещам идти естественным путем, а не форсируйте их. -Парамаханса Йогананда"
    },
    "2025-08-12": {
        "content": " Вы — бесконечное духовное существо, переживающее временный человеческий опыт. -Уэйн У. Дайер"
    },
    "2025-08-13": {
        "content": " Прежде чем ваши мечты сбудутся, нужно мечтать. -Абдул Калам"
    },
    "2025-08-14": {
        "content": " Больше всего береги свое сердце, ибо все, что ты делаешь, вытекает из него. -Соломон"
    },
    "2025-08-15": {
        "content": " Я могу отбросить все, пока пишу; мои печали исчезают, мое мужество возрождается. -Анна Франк"
    },
    "2025-08-16": {
        "content": " Цель не в том, чтобы быть идеальным к концу. Цель в том, чтобы стать лучше сегодня. -Саймон Синек"
    },
    "2025-08-17": {
        "content": " Идите уверенно к своей мечте. Живите жизнью, которую вы себе представляете. -Генри Дэвид Торо"
    },
    "2025-08-18": {
        "content": "Будьте добры, когда это возможно. Это всегда возможно. -Далай-лама XIV"
    },
    "2025-08-19": {
        "content": " Наша главная цель в этой жизни — помогать другим. А если вы не можете им помочь, то хотя бы не причиняйте им вреда. -Далай-лама XIV"
    },
    "2025-08-20": {
        "content": " У тебя есть мозги в голове. У тебя есть ноги в ботинках. Ты можешь направить себя в любом направлении, которое выберешь. Ты сам по себе. И ты знаешь то, что ты знаешь. И ты тот, кто решит, куда идти. -Доктор Сьюз"
    },
    "2025-08-21": {
        "content": " То, на чем вы фокусируетесь, расширяется, а когда вы фокусируетесь на хорошем в своей жизни, вы создаете его больше. -Опра Уинфри"
    },
    "2025-08-22": {
        "content": " Все, что мне нужно знать, открыто мне. Все, что мне нужно, приходит ко мне. Все хорошо в моей жизни. -Луиза Хей"
    },
    "2025-08-23": {
        "content": " Я в полной безопасности во Вселенной. Я везде в покое. Я доверяю жизни. -Луиза Хей"
    },
    "2025-08-24": {
        "content": " Повернитесь лицом к солнцу, и тени останутся позади вас. -Пословица маори"
    },
    "2025-08-25": {
        "content": " Мужество — это не иметь сил идти дальше; это продолжать, когда у тебя нет сил. -Теодор Рузвельт"
    },
    "2025-08-26": {
        "content": " Будущее зависит от того, что вы делаете сегодня. -Махатма Ганди"
    },
    "2025-08-27": {
        "content": " Победитель — это мечтатель, который никогда не сдается. -Нельсон Мандела"
    },
    "2025-08-28": {
        "content": "Не плачь, потому что это закончилось, улыбнись, потому что это было. -Доктор Сьюз"
    },
    "2025-08-29": {
        "content": " Я могу выразить тремя словами все, что я узнал о жизни: она продолжается. -Роберт Фрост"
    },
    "2025-08-30": {
        "content": " Живите своим воображением, а не своей историей. -Стивен Р. Кови"
    },
    "2025-08-31": {
        "content": " Я считаю, что если хочешь радугу, придется смириться с дождем. -Долли Партон"
    },
    "2025-09-01": {
        "content": " Величие человека не в том, сколько богатства он приобрел, а в его честности и способности оказывать положительное влияние на окружающих. -Боб Марли"
    },
    "2025-09-02": {
        "content": " Счастье в основном зависит от нашего собственного отношения, а не от внешних факторов. -Далай-лама XIV"
    },
    "2025-09-03": {
        "content": " Великие деяния складываются из малых дел. -Лао-цзы"
    },
    "2025-09-04": {
        "content": " Никогда не поздно стать тем, кем ты мог бы быть. -Джордж Элиот"
    },
    "2025-09-05": {
        "content": " Правильный настрой может превратить негативный стресс в позитивный. -Ганс Селье"
    },
    "2025-09-06": {
        "content": " Осмелитесь прожить жизнь, о которой вы мечтали. Идите вперед и воплощайте свои мечты в реальность. -Ральф Уолдо Эмерсон"
    },
    "2025-09-07": {
        "content": " Время, которое вам нравится тратить, не является потраченным впустую. -Бертран Рассел"
    },
    "2025-09-08": {
        "content": "Нужно лишь немного бдительности, чтобы увидеть и понять: жизнь — это на самом деле великий космический смех. -Ошо"
    },
    "2025-09-09": {
        "content": " Любопытный парадокс заключается в том, что когда я принимаю себя таким, какой я есть, я могу измениться. -Карл Р. Роджерс"
    },
    "2025-09-10": {
        "content": " Будьте частью решения, а не частью проблемы. -Стивен Р. Кови"
    },
    "2025-09-11": {
        "content": " Секрет жизни — в умении отдавать. -Тони Роббинс"
    },
    "2025-09-12": {
        "content": " Сделайте каждый день своим шедевром. -Джон Вуден"
    },
    "2025-09-13": {
        "content": " Никогда не отказывайтесь от того, что вы действительно хотите сделать. -Х. Джексон Браун-младший."
    },
    "2025-09-14": {
        "content": " Не оглядывайся назад – ты не пойдешь этим путем. -Мэри Энгельбрайт"
    },
    "2025-09-15": {
        "content": " Делайте все возможное, а Бог сделает все остальное. -Ник Вуйчич"
    },
    "2025-09-16": {
        "content": " Живите, путешествуйте, ищите приключения, благословляйте и не сожалейте. -Джек Керуак"
    },
    "2025-09-17": {
        "content": " В разгар зимы я обнаружил, что внутри меня есть непобедимое лето. И это делает меня счастливым. Ибо это говорит о том, что как бы сильно мир ни давил на меня, внутри меня есть что-то сильнее – что-то лучшее, что давит в ответ. -Альбер Камю"
    },
    "2025-09-18": {
        "content": "Некоторые считают, что только великая сила может сдерживать зло, но я не это обнаружил. Это маленькие повседневные дела простых людей, которые держат тьму в страхе. Маленькие акты доброты и любви. -Дж. Р. Р. Толкин"
    },
    "2025-09-19": {
        "content": " Будьте верны в малом, потому что именно в этом ваша сила. -Мать Тереза"
    },
    "2025-09-20": {
        "content": " Сделай из себя свет. -Будда"
    },
    "2025-09-21": {
        "content": " ВИЗУАЛИЗИРУЙТЕ!!! Увидьте, почувствуйте! Вот тут-то и начинается действие. -Ронда Берн"
    },
    "2025-09-22": {
        "content": " Будь феноменальным или будешь забыт! -Эрик Томас"
    },
    "2025-09-23": {
        "content": " Когда у вас есть выбор быть правым или быть добрым, выбирайте быть добрым. -Уэйн У. Дайер"
    },
    "2025-09-24": {
        "content": " Люди могут изменить свою жизнь, изменив образ мышления. -Уильям Джеймс"
    },
    "2025-09-25": {
        "content": " Здоровье – величайшее богатство. -Лао-цзы"
    },
    "2025-09-26": {
        "content": " Дай мне не молиться о том, чтобы меня защитили от опасностей, но молить о том, чтобы я был бесстрашен в их встрече. Дай мне не молить об успокоении моей боли, но о том, чтобы сердце победило ее. -Рабиндранат Тагор"
    },
    "2025-09-27": {
        "content": " Направьте сердце ваше на добрые дела. Делайте это снова и снова, и вы будете наполнены радостью. -Будда"
    },
    "2025-09-28": {
        "content": "Я не могу в одиночку изменить мир, но могу бросить камень в воду, чтобы создать множество кругов. -Мать Тереза"
    },
    "2025-09-29": {
        "content": " И настал день, когда риск остаться в бутоне оказался более болезненным, чем риск расцвести. -Анаис Нин"
    },
    "2025-09-30": {
        "content": " Не должно быть никаких границ для человеческих усилий. Какой бы плохой ни казалась жизнь, всегда есть надежда. -Стивен Хокинг"
    },
    "2025-10-01": {
        "content": " И я призываю вас, пожалуйста, замечать, когда вы счастливы, и восклицать, или бормотать, или думать в какой-то момент: «Если это не приятно, то я не знаю, что это». -Курт Воннегут"
    },
    "2025-10-02": {
        "content": " Именно ваша реакция на невзгоды, а не сами невзгоды, определяют, как будет развиваться история вашей жизни. -Дитер Ф. Ухтдорф"
    },
    "2025-10-03": {
        "content": " Не то, что у тебя есть, кто ты, где ты, что ты делаешь, делает тебя счастливым или несчастным. А то, что ты об этом думаешь. -Дейл Карнеги"
    },
    "2025-10-04": {
        "content": " Чем больше ты читаешь, тем больше вещей ты узнаешь. Чем больше ты узнаешь, тем больше мест ты посетишь. -Доктор Сьюз"
    },
    "2025-10-05": {
        "content": " Все наши мечты могут стать реальностью. -Уолт Дисней"
    },
    "2025-10-06": {
        "content": "Привилегия всей жизни — быть тем, кто ты есть. -Джозеф Кэмпбелл"
    },
    "2025-10-07": {
        "content": " В этом мире нет бесполезных людей, которые облегчают бремя других. -Чарльз Диккенс"
    },
    "2025-10-08": {
        "content": " Найдите внутри себя место, где есть радость, и радость выжжет боль. -Джозеф Кэмпбелл"
    },
    "2025-10-09": {
        "content": " Не спрашивай, что нужно миру. Спроси, что заставляет тебя оживать, и иди и делай это. Потому что миру нужно больше людей, которые ожили. -Говард Турман"
    },
    "2025-10-10": {
        "content": " Ваши чувства — это ваши главные инструменты, помогающие вам творить свою жизнь. -Ронда Берн"
    },
    "2025-10-11": {
        "content": " Я заслуживаю лучшего и принимаю лучшее сейчас. -Луиза Хей"
    },
    "2025-10-12": {
        "content": " Важно не то, сколько мы отдаем, а сколько любви мы вкладываем в то, что отдаем. -Мать Тереза"
    },
    "2025-10-13": {
        "content": " Когда вы хотите добиться успеха так же сильно, как хотите дышать, тогда вы добьетесь успеха. -Эрик Томас"
    },
    "2025-10-14": {
        "content": " Я ненавидел каждую минуту тренировок, но я сказал себе: «Не сдавайся. Потерпи сейчас и проживи остаток жизни как чемпион». -Мухаммед Али"
    },
    "2025-10-15": {
        "content": "Не критик имеет значение, не тот, кто указывает, как споткнулся сильный человек или как творец деяний мог бы сделать их лучше. Честь принадлежит тому, кто действительно находится на арене, чье лицо запятнано потом, пылью и кровью; кто доблестно борется; кто ошибается и терпит неудачу снова и снова; кто знает великий энтузиазм, великую преданность и тратит себя на достойное дело; кто, если он побеждает, знает триумф высокого достижения; и кто, если он терпит неудачу, по крайней мере терпит неудачу, будучи очень смелым, так что его место никогда не будет среди тех холодных и робких душ, которые не знают ни победы, ни поражения. -Теодор Рузвельт"
    },
    "2025-10-16": {
        "content": " Самое большое приключение, которое вы когда-либо можете совершить, — это прожить жизнь своей мечты. -Опра Уинфри"
    },
    "2025-10-17": {
        "content": " Без борьбы не может быть прогресса. -Фредерик Дугласс"
    },
    "2025-10-18": {
        "content": " Мечта, записанная с датой, становится целью. Цель, разбитая на шаги, становится планом. План, подкрепленный действием, делает ваши мечты реальностью. -Грег Рид"
    },
    "2025-10-19": {
        "content": "Сделайте то, что, по вашему мнению, вы не можете сделать. Потерпите неудачу. Попробуйте еще раз. Сделайте лучше во второй раз. Единственные люди, которые никогда не падают, — это те, кто никогда не лазает по канату. -Опра Уинфри"
    },
    "2025-10-20": {
        "content": " Ожидайте перемен. Анализируйте обстановку. Используйте возможности. Перестаньте быть шахматной пешкой; станьте игроком. Это ваш ход. -Тони Роббинс"
    },
    "2025-10-21": {
        "content": " Ты свободен. Ты силен. Ты хорош. Ты — любовь. Ты ценен. У тебя есть цель. Все хорошо. -Эстер Хикс"
    },
    "2025-10-22": {
        "content": "Если вы хотите чего-то настолько сильно, чтобы выйти и бороться за это, работать ради этого день и ночь, отдать свое время, свой покой и свой сон ради этого. Если все, о чем вы мечтаете и что планируете, касается этого, а жизнь без этого кажется бесполезной и никчемной; Если вы с радостью потеете, беспокоитесь и планируете это и теряете весь свой страх перед сопротивлением; Если вы просто идете за тем, чего хотите, со всеми своими способностями, силой и проницательностью, верой, надеждой и уверенностью и тверды в упорстве; Если ни холод, ни бедность, голод или подагра, болезнь или боль тела и мозга не могут удержать вас от того, чего вы хотите; Если вы упрямы и угрюмы, будете растить и зачинать это, с помощью БОЖЬЕЙ вы это получите. -Бертон Брейли"
    },
    "2025-10-23": {
        "content": " Даже если вы на правильном пути, вас переедут, если вы будете просто сидеть на месте. -Уилл Роджерс"
    },
    "2025-10-24": {
        "content": " Я думаю, что обычные люди могут выбрать быть необыкновенными. -Илон Маск"
    },
    "2025-10-25": {
        "content": " Ты не научишься ходить, следуя правилам. Ты учишься, делая и падая. -Ричард Брэнсон"
    },
    "2025-10-26": {
        "content": "Здесь нет таланта, это тяжелая работа. Это одержимость. Таланта не существует, мы все равны как люди. Вы можете стать кем угодно, если потратите время. Вы достигнете вершины, и все. Я не талантлив, я одержим. -Конор МакГрегор"
    },
    "2025-10-27": {
        "content": " Сон — это не то, что вы видите во время сна; это то, что не дает вам спать. -Абдул Калам"
    },
    "2025-10-28": {
        "content": " Когда вы исчерпали все возможности, помните: вы этого не сделали. -Томас А. Эдисон"
    },
    "2025-10-29": {
        "content": " Рискуй, совершай ошибки. Так ты растешь. Боль питает твою смелость. Ты должен терпеть неудачи, чтобы практиковать храбрость. -Мэри Тайлер Мур"
    },
    "2025-10-30": {
        "content": " На чем вы сосредоточитесь, то и получите. -Тони Роббинс"
    },
    "2025-10-31": {
        "content": " «Суета» — самое важное слово на свете. -Гари Вайнерчук"
    },
    "2025-11-01": {
        "content": " Если они смогли сделать пенициллин из заплесневелого хлеба, то они наверняка смогут сделать что-то и из вас. -Мухаммед Али"
    },
    "2025-11-02": {
        "content": " Ты не родился победителем, и ты не родился неудачником. Ты тот, кем ты себя делаешь. -Лу Хольц"
    },
    "2025-11-03": {
        "content": " Успех — это ваш долг, обязанность и ответственность. -Грант Кардон"
    },
    "2025-11-04": {
        "content": "Различий между людьми немного, но это небольшое различие имеет большое значение. Небольшое различие — это отношение. Большое различие — это то, является ли оно положительным или отрицательным. -У. Клемент Стоун"
    },
    "2025-11-05": {
        "content": " Лидеры должны быть достаточно близки, чтобы общаться с другими, но достаточно далеки от них, чтобы мотивировать их. -Джон К. Максвелл"
    },
    "2025-11-06": {
        "content": " Никогда не говори никогда, потому что ограничения, как и страхи, часто являются всего лишь иллюзией. -Майкл Джордан"
    },
    "2025-11-07": {
        "content": " Вы должны ожидать от себя великих дел, прежде чем сможете их совершить. -Майкл Джордан"
    },
    "2025-11-08": {
        "content": " В мире бизнеса наибольшего успеха добиваются те, кто занимается любимым делом. -Уоррен Баффет"
    },
    "2025-11-09": {
        "content": " Действие уничтожит вашу прокрастинацию. -Ог Мандино"
    },
    "2025-11-10": {
        "content": " Неудача для меня не вариант. Успех — это все, что я себе представляю. -Конор МакГрегор"
    },
    "2025-11-11": {
        "content": " Успех приходит не от того, что вы делаете время от времени, а от того, что вы делаете постоянно. -Мари Форлео"
    },
    "2025-11-12": {
        "content": " Уверенность и упорный труд — лучшие лекарства от болезни, называемой неудачей. Они сделают вас успешным человеком. -Абдул Калам"
    },
    "2025-11-13": {
        "content": " Если хочешь сиять как солнце, сначала гори как солнце. -Абдул Калам"
    },
    "2025-11-14": {
        "content": "Пока ты там тусуешься, валяешь дурака, кто-то там в это же время усердно трудится. Кто-то становится умнее, а кто-то побеждает. Просто помни об этом. -Арнольд Шварценеггер"
    },
    "2025-11-15": {
        "content": " Если вы делаете то, что всегда делали, вы и получите то, что всегда получали. -Тони Роббинс"
    },
    "2025-11-16": {
        "content": " Прогресс равнозначен счастью. -Тони Роббинс"
    },
    "2025-11-17": {
        "content": " У вас могут быть либо результаты, либо оправдания. Но не то и другое одновременно. -Арнольд Шварценеггер"
    },
    "2025-11-18": {
        "content": " Дисциплина равно свободе. -Джоко Виллинк"
    },
    "2025-11-19": {
        "content": " Не зацикливайтесь на том, что пошло не так. Вместо этого сосредоточьтесь на том, что делать дальше. Направьте свою энергию на движение вперед, на поиск ответа. -Денис Уэйтли"
    },
    "2025-11-20": {
        "content": " Будьте таким лидером, каким вы хотели бы быть. -Саймон Синек"
    },
    "2025-11-21": {
        "content": " Я позиция такая: если вы подталкиваете меня к чему-то, что, по вашему мнению, является слабостью, то я превращу эту кажущуюся слабость в силу. -Майкл Джордан"
    },
    "2025-11-22": {
        "content": " Для большинства из нас большая опасность заключается не в том, что мы ставим перед собой слишком высокую цель и не достигаем ее, а в том, что мы ставим перед собой слишком низкую цель и не достигаем ее. -Микеланджело"
    },
    "2025-11-23": {
        "content": " У каждого есть мечта, но не у каждого есть цель. -Эрик Томас"
    },
    "2025-11-24": {
        "content": "Лидерами становятся, ими не рождаются. Их создают упорные усилия, и это цена, которую все мы должны заплатить, чтобы достичь любой стоящей цели. -Винс Ломбарди"
    },
    "2025-11-25": {
        "content": " Мы выбираем отправиться на Луну в этом десятилетии и сделать другие вещи. Не потому, что это легко, а потому, что это трудно. -Джон Ф. Кеннеди"
    },
    "2025-11-26": {
        "content": " Самый лучший день в твоей и моей жизни — это когда мы берем на себя полную ответственность за свои взгляды. Это день, когда мы по-настоящему взрослеем. -Джон К. Максвелл"
    },
    "2025-11-27": {
        "content": " Каждый раз, когда вы улыбаетесь кому-то, это акт любви, дар этому человеку, прекрасная вещь. -Мать Тереза"
    },
    "2025-11-28": {
        "content": " Будьте молчаливым наблюдателем своих мыслей и поведения. Вы ниже мыслителя. Вы — тишина под ментальным шумом. Вы — любовь и радость под болью. -Экхарт Толле"
    },
    "2025-11-29": {
        "content": " Если не можешь летать, беги, если не можешь бежать, иди, если не можешь ходить, ползай, но что бы ты ни делал, ты должен продолжать двигаться вперед. -Мартин Лютер Кинг-младший."
    },
    "2025-11-30": {
        "content": " Прощение — это не разовое действие, это постоянная позиция. -Мартин Лютер Кинг-младший."
    },
    "2025-12-01": {
        "content": " Слишком часто мы недооцениваем силу прикосновения, улыбки, доброго слова, внимательного выслушивания, честного комплимента или даже самого маленького проявления заботы, хотя все это может изменить жизнь. -Лео Бускалья"
    },
    "2025-12-02": {
        "content": "Сохраняйте свои мечты живыми. Поймите, чтобы чего-то достичь, нужны вера и убежденность в себе, видение, упорный труд, решимость и преданность. Помните, что все возможно для тех, кто верит. -Гейл Деверс"
    },
    "2025-12-03": {
        "content": " Спорт обладает силой изменить мир. Он обладает силой вдохновлять. Он обладает силой объединять людей так, как мало что другое. Он говорит с молодежью на понятном ей языке. Спорт может создать надежду там, где когда-то было только отчаяние. -Нельсон Мандела"
    },
    "2025-12-04": {
        "content": " Проси то, чего хочешь. Поверь, что ты этого заслуживаешь, а затем позволь Жизни дать тебе это. -Луиза Хей"
    },
    "2025-12-05": {
        "content": " Живите с намерением. Идите к краю. Внимательно слушайте. Практикуйте благополучие. Играйте самозабвенно. Смейтесь. Выбирайте без сожалений. Цените своих друзей. Продолжайте учиться. Делайте то, что любите. Живите так, как будто это все, что есть. -Мэри Энн Радмахер"
    },
    "2025-12-06": {
        "content": " То, на чем вы фокусируетесь, расширяется, а когда вы фокусируетесь на хорошем в своей жизни, вы создаете его больше. -Опра Уинфри"
    },
    "2025-12-07": {
        "content": " У вас есть власть над вашим разумом, а не над внешними событиями. Осознайте это, и вы обретете силу. -Марк Аврелий"
    },
    "2025-12-08": {
        "content": "Не ищите оправданий, почему вы не можете этого сделать. Сосредоточьтесь на всех причинах, по которым вы должны это сделать. -Ральф Марстон"
    },
    "2025-12-09": {
        "content": " Где любовь, там жизнь. -Махатма Ганди"
    },
    "2025-12-10": {
        "content": " Нужно танцевать так, словно никто не видит, любить так, словно никто не причинит тебе боль, петь так, словно никто не слышит, и жить так, словно на земле рай. -Уильям В. Перки"
    },
    "2025-12-11": {
        "content": " Успех — это осознание своего предназначения в жизни, стремление раскрыть свой максимальный потенциал и сеять семена, приносящие пользу другим. -Джон К. Максвелл"
    },
    "2025-12-12": {
        "content": " Мечта, которую ты видишь в одиночку, — всего лишь мечта. Мечта, которую ты видишь вместе, — реальность. -Джон Леннон"
    },
    "2025-12-13": {
        "content": " Это настоящий секрет жизни — быть полностью вовлеченным в то, что вы делаете здесь и сейчас. И вместо того, чтобы называть это работой, осознайте, что это игра. -Алан Уоттс"
    },
    "2025-12-14": {
        "content": " Вчера уже прошло. Завтра еще не наступило. У нас есть только сегодня. Давайте начнем. -Мать Тереза"
    },
    "2025-12-15": {
        "content": " Чем больше вы хвалите и празднуете свою жизнь, тем больше в ней поводов для празднования. -Опра Уинфри"
    },
    "2025-12-16": {
        "content": "Никогда не сомневайтесь, что небольшая группа думающих, преданных граждан может изменить мир. На самом деле, это единственное, что когда-либо изменялось. -Маргарет Мид"
    },
    "2025-12-17": {
        "content": " Подталкивайте себя, потому что никто другой не сделает этого за вас. -Анонимный"
    },
    "2025-12-18": {
        "content": " Истинное смирение — это не думать о себе хуже, а думать о себе меньше. -К.С. Льюис"
    },
    "2025-12-19": {
        "content": " Если вы сможете изменить свое мнение, вы сможете изменить свою жизнь. -Уильям Джеймс"
    },
    "2025-12-20": {
        "content": " Сосредоточьтесь на том, куда вы хотите пойти, а не на том, чего вы боитесь. -Тони Роббинс"
    },
    "2025-12-21": {
        "content": " Уважайте себя, и другие будут уважать вас. -Конфуций"
    },
    "2025-12-22": {
        "content": " Делай то, что можешь, с тем, что имеешь, там, где ты есть. -Теодор Рузвельт"
    },
    "2025-12-23": {
        "content": " Некоторые изменения на первый взгляд кажутся негативными, но вскоре вы поймете, что в вашей жизни освобождается место для появления чего-то нового. -Экхарт Толле"
    },
    "2025-12-24": {
        "content": " Если ваши действия вдохновляют других мечтать больше, узнавать больше, делать больше и становиться лучше, вы — лидер. -Джон Куинси Адамс"
    },
    "2025-12-25": {
        "content": " Не беспокойся ни о чем, все будет хорошо. -Боб Марли"
    },
    "2025-12-26": {
        "content": " Мечтайте по-крупному, сохраняйте позитивный настрой, усердно работайте и наслаждайтесь путешествием. -Юрия Фабер"
    },
    "2025-12-27": {
        "content": "Вы здесь, чтобы дать возможность божественному замыслу Вселенной раскрыться. Вот насколько вы важны! -Экхарт Толле"
    },
    "2025-12-28": {
        "content": " Живите со страстью! -Тони Роббинс"
    },
    "2025-12-29": {
        "content": " Поверьте, что вы можете, и вы уже на полпути. -Теодор Рузвельт"
    },
    "2025-12-30": {
        "content": " Наша жизнь подходит к концу в тот день, когда мы перестаем говорить о важных вещах. -Мартин Лютер Кинг-младший."
    },
    "2025-12-31": {
        "content": " Вместе мы можем творить великие дела. -Мать Тереза"
    },
    "2026-01-01": {
        "content": " Упорный труд ради того, что нам безразлично, называется стрессом; упорный труд ради того, что мы любим, называется страстью. -Саймон Синек"
    },
    "2026-01-02": {
        "content": " Пещера, в которую вы боитесь войти, хранит сокровище, которое вы ищете. -Джозеф Кэмпбелл"
    },
    "2026-01-03": {
        "content": " Лидерство — это эмпатия. Это способность устанавливать связь и налаживать связи с людьми с целью вдохновения и расширения их прав и возможностей. -Опра Уинфри"
    },
    "2026-01-04": {
        "content": " Нет ничего невозможного для того, кто попытается. -Александр Македонский"
    },
    "2026-01-05": {
        "content": " Большинство важных вещей в мире были достигнуты людьми, которые продолжали стараться, когда, казалось бы, не осталось никакой надежды. -Дейл Карнеги"
    },
    "2026-01-06": {
        "content": " Мы продолжаем двигаться вперед, открываем новые двери и делаем новые вещи, потому что мы любопытны, а любопытство постоянно ведет нас по новым путям. -Уолт Дисней"
    },
    "2026-01-07": {
        "content": "Делай то, что должен, пока не сможешь делать то, что хочешь. -Опра Уинфри"
    },
    "2026-01-08": {
        "content": " Вера в то, что вы самодостаточны, дает вам смелость быть настоящим. -Брене Браун"
    },
    "2026-01-09": {
        "content": " Именно наш выбор, Гарри, показывает, кем мы являемся на самом деле, гораздо больше, чем наши способности. -Дж. К. Роулинг"
    },
    "2026-01-10": {
        "content": " Следуйте за своим счастьем, и вселенная откроет вам двери там, где раньше были только стены. -Джозеф Кэмпбелл"
    },
    "2026-01-11": {
        "content": " Сны — это не те, которые приходят к нам во время сна, а те, которые не успевают исполниться, как мы засыпаем. -Абдул Калам"
    },
    "2026-01-12": {
        "content": " Смелость в значительной степени означает смелость быть уязвимым. Это значит показаться и быть увиденным. Просить о том, что вам нужно. Говорить о том, что вы чувствуете. Вести трудные разговоры. -Брене Браун"
    },
    "2026-01-13": {
        "content": " Вы никогда не добьетесь успеха, пока не превратите свою боль в величие, пока не позволите своей боли вытолкнуть вас оттуда, где вы находитесь, туда, где вам нужно быть. Перестаньте бежать от своей боли и примите свою боль. Ваша боль станет частью вашего приза, частью вашего продукта. Я бросаю вам вызов: подтолкните себя. -Эрик Томас"
    },
    "2026-01-14": {
        "content": " Мы есть то, что мы постоянно делаем. Поэтому совершенство — это не действие, а привычка. -Аристотель"
    },
    "2026-01-15": {
        "content": " Река прорезает скалу не благодаря своей силе, а благодаря своему упорству. -Джим Уоткинс"
    },
    "2026-01-16": {
        "content": " Энергия и упорство побеждают все. -Бенджамин Франклин"
    },
    "2026-01-17": {
        "content": " Возможности обычно маскируются под упорный труд, поэтому большинство людей их не распознают. -Энн Лэндерс"
    },
    "2026-01-18": {
        "content": " Если не можешь летать, беги, если не можешь бежать, иди, если не можешь ходить, ползай, но что бы ты ни делал, ты должен продолжать двигаться вперед. -Мартин Лютер Кинг-младший."
    },
    "2026-01-19": {
        "content": " Настойчивость гарантирует неизбежность результатов. -Парамаханса Йогананда"
    },
    "2026-01-20": {
        "content": " При наличии обычного таланта и необычайного упорства все достижимо. -Томас Фоуэлл Бакстон"
    },
    "2026-01-21": {
        "content": " Наша величайшая слава не в том, чтобы никогда не терпеть неудач, а в том, чтобы подниматься каждый раз, когда мы терпим неудачу. -Ральф Уолдо Эмерсон"
    },
    "2026-01-22": {
        "content": " Успех — это спотыкающийся путь от неудачи к неудаче без потери энтузиазма. -Уинстон Черчилль"
    },
    "2026-01-23": {
        "content": "К счастью, настойчивость — отличная замена таланту. -Стив Мартин"
    },
    "2026-01-24": {
        "content": " Я больше верю в удачу, и я обнаружил, что чем больше я работаю, тем больше ее у меня есть. -Томас Джефферсон"
    },
    "2026-01-25": {
        "content": " Откладывай на завтра только то, что ты готов оставить несделанным до самой смерти. -Пабло Пикассо"
    },
    "2026-01-26": {
        "content": " Нет никаких секретов успеха: не тратьте время на их поиски. Успех — это результат совершенства, упорного труда, обучения на неудачах, преданности тем, для кого вы работаете, и настойчивости. -Колин Пауэлл"
    },
    "2026-01-27": {
        "content": " Если хочешь быть впереди, то веди себя так, как будто ты сзади. -Лао-цзы"
    },
    "2026-01-28": {
        "content": " Позвольте мне раскрыть вам секрет, который привел меня к моей цели: моя сила заключается исключительно в моем упорстве. -Луи Пастер"
    },
    "2026-01-29": {
        "content": " Ничто в этом мире не заменит упорства. Талант не заменит; нет ничего более распространенного, чем неудачники с талантом. Гений не заменит; невознагражденный гений — это почти пословица. -Кэлвин Кулидж"
    },
    "2026-01-30": {
        "content": " Лучший выход всегда — насквозь. -Роберт Фрост"
    },
    "2026-01-31": {
        "content": "Многие из тех, кто потерпел неудачу в жизни, — это люди, которые не осознавали, насколько близки они были к успеху, когда сдались. -Томас А. Эдисон"
    },
    "2026-02-01": {
        "content": " Мы созданы для упорства. Так мы узнаем, кто мы есть. -Тобиас Вольф"
    },
    "2026-02-02": {
        "content": " Зная деревья, я понимаю значение терпения. Зная траву, я могу оценить настойчивость. -Хэл Борланд"
    },
    "2026-02-03": {
        "content": " Капающая вода точит камень, но не силой, а настойчивостью. -Овидий"
    },
    "2026-02-04": {
        "content": " Настойчивость очень важна. Не стоит сдаваться, если только вас не вынуждают сдаться. -Илон Маск"
    },
    "2026-02-05": {
        "content": " Пламенный энтузиазм, подкрепленный здравым смыслом и настойчивостью, — это качество, которое чаще всего способствует успеху. -Дейл Карнеги"
    },
    "2026-02-06": {
        "content": " Амбиции — это путь к успеху. Упорство — это средство передвижения, на котором вы прибудете. -Билл Брэдли"
    },
    "2026-02-07": {
        "content": " Сосредоточьтесь на решении, а не на проблеме. -Уолтер Андерсон"
    },
    "2026-02-08": {
        "content": " Когда жизнь сбивает тебя с ног, у тебя есть два выбора — оставаться внизу или вставать. -Том Краузе"
    },
    "2026-02-09": {
        "content": "Успех — это сумма небольших усилий, повторяемых изо дня в день. -Роберт Колльер"
    },
    "2026-02-10": {
        "content": " Мечта — это всего лишь мечта. Цель — это мечта с планом и сроком. -Харви Маккей"
    },
    "2026-02-11": {
        "content": " Никогда не отказывайтесь от чего-то, без мыслей о чем вы не можете прожить и дня. -Уинстон Черчилль"
    },
    "2026-02-12": {
        "content": " Алмазы — это не более чем куски угля, прилипшие к своим рабочим местам. -Малкольм С. Форбс"
    },
    "2026-02-13": {
        "content": " Ничего нельзя сделать, кроме как понемногу. -Шарль Бодлер"
    },
    "2026-02-14": {
        "content": " Если вы проходите через ад, продолжайте идти. -Уинстон Черчилль"
    },
    "2026-02-15": {
        "content": " Ключ настойчивости открывает все двери, закрытые сопротивлением. -Джон Ди Лемме"
    },
    "2026-02-16": {
        "content": " Если мы посмотрим на самых успешных людей в мире, то их общим знаменателем будет настойчивость. -Джастин Сакс"
    },
    "2026-02-17": {
        "content": " Слона можно съесть по частям. -Мэри Кэй Эш"
    },
    "2026-02-18": {
        "content": " Я не думаю, что есть какое-либо другое качество, столь необходимое для успеха любого рода, как качество настойчивости. Оно преодолевает почти все, даже природу. -Джон Д. Рокфеллер"
    },
    "2026-02-19": {
        "content": "Если вы хотите превратить мечту в реальность, вам придется выложиться на все 100% и никогда не переставать верить в свою мечту. -Арнольд Шварценеггер"
    },
    "2026-02-20": {
        "content": " Бегите, когда можете, идите, если нужно, ползите, если нужно; просто никогда не сдавайтесь. -Дин Карназес"
    },
    "2026-02-21": {
        "content": " Пройти еще один раунд, когда вы думаете, что не можете этого сделать, — вот что имеет решающее значение в вашей жизни. -Сильвестр Сталлоне"
    },
    "2026-02-22": {
        "content": " Послушай меня, даже когда ты проигрываешь, проигрывать нормально, но ты никогда не сможешь с этим смириться. Ты никогда не сможешь быть удовлетворен проигрышем. Когда ты проигрываешь, это должно быть больно. -Эрик Томас"
    },
    "2026-02-23": {
        "content": " Продолжайте идти своим путем, шаг за шагом. -Джойс Майер"
    },
    "2026-02-24": {
        "content": " Мы не должны сдаваться и не должны позволять проблеме победить нас. -Абдул Калам"
    },
    "2026-02-25": {
        "content": " Благодаря терпению мы побеждаем. -Эрнест Шеклтон"
    },
    "2026-02-26": {
        "content": "Кирпичные стены существуют не просто так. Кирпичные стены существуют не для того, чтобы нас не пускать. Кирпичные стены существуют для того, чтобы дать нам возможность показать, как сильно мы чего-то хотим. Потому что кирпичные стены существуют для того, чтобы останавливать людей, которые хотят этого недостаточно сильно. Они существуют для того, чтобы останавливать других людей. -Рэнди Пауш"
    },
    "2026-02-27": {
        "content": " Успех почти полностью зависит от напористости и упорства. Дополнительная энергия, необходимая для того, чтобы приложить еще одно усилие или попробовать другой подход, — вот секрет победы. -Денис Уэйтли"
    },
    "2026-02-28": {
        "content": " Я добился этого и отказался сдаваться, потому что всю свою жизнь я всегда доходил до конца гонки. -Луи Замперини"
    },
    "2026-03-01": {
        "content": " Выживание можно описать тремя словами – никогда не сдавайся. Вот в чем суть. Просто продолжай пытаться. -Беар Гриллс"
    },
    "2026-03-02": {
        "content": "БОЛЬШЕ НИКАКИХ. Больше никаких оправданий. Больше никаких: «Я начну завтра». Больше никаких: «Только в этот раз». Больше никаких смирений с недостатками собственной воли. Больше никаких легких путей. Больше никаких преклонений перед любыми нездоровыми или непродуктивными мыслями, которые мелькают в моем сознании. -Джоко Виллинк"
    },
    "2026-03-03": {
        "content": " Маленькие удары валят большие дубы. -Бенджамин Франклин"
    },
    "2026-03-04": {
        "content": " Я готов. Я настроен на победу. Я понимаю это. Я принимаю неопределенность. Я — это не мои мысли; я — это то, что я делаю. Я непреклонен. Я ничего не ожидаю и принимаю все. -Гари Джон Бишоп"
    },
    "2026-03-05": {
        "content": " Я не терпел неудач 700 раз. Я не терпел неудач ни разу. Мне удалось доказать, что эти 700 способов не сработают. Когда я устраню способы, которые не сработают, я найду способ, который сработает. -Томас А. Эдисон"
    },
    "2026-03-06": {
        "content": " GRIT — это сила воли, стойкость, трудолюбие и упорство. GRIT — это способность сосредотачиваться, сохранять решимость, сохранять оптимизм перед лицом трудностей и просто работать усерднее, чем соседи. -Линда Каплан Талер"
    },
    "2026-03-07": {
        "content": "Я думаю, мой секрет в том, что не существует коротких путей к упорному труду, решимости и настрою «никогда не сдаваться». -Джерри Райс"
    },
    "2026-03-08": {
        "content": " Никогда не прекращайте бороться, пока не достигнете своего предназначенного места – то есть уникального себя. Имейте цель в жизни, постоянно приобретайте знания, усердно работайте и будьте настойчивы, чтобы реализовать великую жизнь. -Абдул Калам"
    },
    "2026-03-09": {
        "content": " Не останавливайся, когда устал. Остановись, когда закончишь. -Дэвид Гоггинс"
    },
    "2026-03-10": {
        "content": " Не судите меня по моим успехам, судите меня по тому, сколько раз я падал и снова вставал. -Нельсон Мандела"
    },
    "2026-03-11": {
        "content": " То, что не начато сегодня, никогда не закончится завтра. -Иоганн Вольфганг фон Гёте"
    },
    "2026-03-12": {
        "content": " Если вы написали сотню рассказов и все они плохие, это не значит, что вы потерпели неудачу. Вы потерпели неудачу только если перестали писать. -Рэй Брэдбери"
    },
    "2026-03-13": {
        "content": " Мастер терпел неудачу чаще, чем новичок пытался что-либо сделать. -Стивен МакКрейни"
    },
    "2026-03-14": {
        "content": " К черту обстоятельства; я создаю возможности. -Брюс Ли"
    },
    "2026-03-15": {
        "content": "Единственное, что хуже, чем начать что-то и потерпеть неудачу, — это не начать ничего. -Сет Годин"
    },
    "2026-03-16": {
        "content": " Никогда не откладывай на завтра то, что можно сделать сегодня. -Бенджамин Франклин"
    },
    "2026-03-17": {
        "content": " Благодаря упорству улитка добралась до ковчега. -Чарльз Х. Сперджен"
    },
    "2026-03-18": {
        "content": " Помните, надежда — это хорошо, может быть, даже лучше всего, и ничто хорошее не умирает. -Стивен Кинг"
    },
    "2026-03-19": {
        "content": " Предприниматели не заканчивают, когда мы устали. Мы заканчиваем, когда мы закончили. -Роберт Т. Кийосаки"
    },
    "2026-03-20": {
        "content": " Только упорство и решимость всемогущи. -Кэлвин Кулидж"
    },
    "2026-03-21": {
        "content": " Парализуйте сопротивление настойчивостью. -Вуди Хейс"
    },
    "2026-03-22": {
        "content": " Успех никогда не является собственностью, он арендуется, и арендная плата взимается каждый день. -Рори Ваден"
    },
    "2026-03-23": {
        "content": " Успех не случаен. Это тяжелая работа, упорство, обучение, изучение, жертвенность и, прежде всего, любовь к тому, что вы делаете или учитесь делать. -Пеле"
    },
    "2026-03-24": {
        "content": " Нет способа обойти тяжелую работу. Примите это. -Роджер Федерер"
    },
    "2026-03-25": {
        "content": " Мечта не становится реальностью с помощью волшебства; для этого нужны пот, решимость и упорный труд. -Колин Пауэлл"
    },
    "2026-03-26": {
        "content": "Обучение никогда не истощает разум. -Леонардо да Винчи"
    },
    "2026-03-27": {
        "content": " Я слышу и забываю. Я вижу и запоминаю. Я делаю и понимаю. -Конфуций"
    },
    "2026-03-28": {
        "content": " Тот, кто никогда не совершал ошибок, никогда не пробовал ничего нового. -Альберт Эйнштейн"
    },
    "2026-03-29": {
        "content": " Постарайтесь узнать что-нибудь обо всем и все о чем-нибудь. -Томас Генри Хаксли"
    },
    "2026-03-30": {
        "content": " Человек учится только двумя способами: читая и общаясь с более умными людьми. -Уилл Роджерс"
    },
    "2026-03-31": {
        "content": " Вы ничего не поймете, пока не узнаете это более чем одним способом. -Марвин Мински"
    },
    "2026-04-01": {
        "content": " Скажи мне, и я забуду, научи меня, и я, может быть, запомню, вовлеки меня, и я научусь. -Бенджамин Франклин"
    },
    "2026-04-02": {
        "content": " Если вы хотите увеличить свой процент успеха, удвойте процент неудач. -Томас Дж. Уотсон"
    },
    "2026-04-03": {
        "content": " Интеллект — это то, что вы используете, когда не знаете, что делать. -Жан Пиаже"
    },
    "2026-04-04": {
        "content": " Неграмотными в XXI веке будут не те, кто не умеет читать и писать, а те, кто не умеет учиться, разучиваться и переучиваться. -Элвин Тоффлер"
    },
    "2026-04-05": {
        "content": "Именно то, что мы уже знаем, часто мешает нам учиться. -Клод Бернар"
    },
    "2026-04-06": {
        "content": " Математика — это язык, на котором Бог написал вселенную. -Галилео Галилей"
    },
    "2026-04-07": {
        "content": " Вся цель образования — превратить зеркала в окна. -Сидней Дж. Харрис"
    },
    "2026-04-08": {
        "content": " Я не боюсь штормов, потому что учусь управлять своим кораблем. -Луиза Мэй Олкотт"
    },
    "2026-04-09": {
        "content": " Образован только тот человек, который научился учиться и меняться. -Карл Р. Роджерс"
    },
    "2026-04-10": {
        "content": " Я никогда не встречал настолько невежественного человека, у которого я не мог бы чему-то научиться. -Галилео Галилей"
    },
    "2026-04-11": {
        "content": " Ничто не уходит, пока не научит нас тому, что нам нужно знать. -Пема Чодрон"
    },
    "2026-04-12": {
        "content": " Практика приводит к совершенству. После долгой практики наша работа станет естественной, искусной, быстрой и стабильной. -Брюс Ли"
    },
    "2026-04-13": {
        "content": " Когда вы говорите, вы только повторяете то, что уже знаете. Но если вы слушаете, вы можете узнать что-то новое. -Далай-лама XIV"
    },
    "2026-04-14": {
        "content": " Стремитесь к прогрессу, а не к совершенству. -Анонимный"
    },
    "2026-04-15": {
        "content": "Я всегда делаю то, чего пока не умею, чтобы научиться это делать. -Винсент Ван Гог"
    },
    "2026-04-16": {
        "content": " Знание делает человека непригодным к рабству. -Фредерик Дугласс"
    },
    "2026-04-17": {
        "content": " Я очень рано понял разницу между знанием названия чего-либо и знанием чего-либо. -Ричард П. Фейнман"
    },
    "2026-04-18": {
        "content": " Способность учиться — это дар; Способность учиться — это навык; Желание учиться — это выбор. -Брайан Герберт"
    },
    "2026-04-19": {
        "content": " Учитесь всему, чему можете, когда можете и у кого можете, — обязательно наступит время, когда вы будете благодарны за это. -Сара Колдуэлл"
    },
    "2026-04-20": {
        "content": " Я невысокого мнения о человеке, который сегодня не стал мудрее, чем он был вчера. -Авраам Линкольн"
    },
    "2026-04-21": {
        "content": " Ключ к успеху — это стремление к непрерывному обучению. -Стивен Р. Кови"
    },
    "2026-04-22": {
        "content": " Будьте страстными и смелыми. Всегда продолжайте учиться. Вы перестанете делать полезные вещи, если не будете учиться. -Сатья Наделла"
    },
    "2026-04-23": {
        "content": "Высшая деятельность, которой может достичь человек, — это обучение ради понимания, потому что понимать — значит быть свободным. -Барух Спиноза"
    },
    "2026-04-24": {
        "content": " Если вы не будете продолжать учиться, другие люди пройдут мимо вас. Один темперамент не поможет — нужно много любопытства на долгое-долгое время. -Чарли Мангер"
    },
    "2026-04-25": {
        "content": " Обучающаяся организация — это организация, которая постоянно расширяет свои возможности по созданию своего будущего. -Питер Сенге"
    },
    "2026-04-26": {
        "content": " В тот день, когда вы перестаете учиться, вы начинаете деградировать. -Айзек Азимов"
    },
    "2026-04-27": {
        "content": " Учение — украшение в процветании, убежище в невзгодах и обеспечение в старости. -Аристотель"
    },
    "2026-04-28": {
        "content": " Все лидеры — ученики. Как только вы перестаете учиться, вы перестаете вести за собой. Я учусь так многому, как могу, у стольких, у кого могу, так часто, как могу. -Рик Уоррен"
    },
    "2026-04-29": {
        "content": " Чтобы быстро научиться сложным вещам, нужно сосредоточиться, не отвлекаясь. Другими словами, учиться — это акт глубокой работы. -Кэл Ньюпорт"
    },
    "2026-04-30": {
        "content": " Любой дурак может знать. Главное — понять. -Альберт Эйнштейн"
    },
    "2026-05-01": {
        "content": "Проводите каждый день, стараясь стать немного мудрее, чем вы были, когда проснулись. -Чарли Мангер"
    },
    "2026-05-02": {
        "content": " Инвестируйте в себя, в свое образование. Нет ничего лучше. -Сильвия Портер"
    },
    "2026-05-03": {
        "content": " Самообразование является для меня постоянным источником удовольствия, ведь чем больше я узнаю, тем полнее становится моя жизнь и тем больше я ценю собственное существование. -Айзек Азимов"
    },
    "2026-05-04": {
        "content": " Вы можете получить помощь от учителей, но вам придется многому научиться самостоятельно, сидя в одиночестве в классе. -Доктор Сьюз"
    },
    "2026-05-05": {
        "content": " Обучение происходит тогда, когда кто-то хочет учиться, а не тогда, когда кто-то хочет учить. -Роджер Шэнк"
    },
    "2026-05-06": {
        "content": " Человек не может научить другого человека напрямую; человек может лишь способствовать обучению другого человека. -Карл Р. Роджерс"
    },
    "2026-05-07": {
        "content": " Обучение не обязательно; оно добровольно. Улучшение не обязательно; оно добровольно. Но чтобы выжить, мы должны учиться. -У. Эдвардс Деминг"
    },
    "2026-05-08": {
        "content": " Я всегда делаю то, чего не умею, чтобы научиться это делать. -Пабло Пикассо"
    },
    "2026-05-09": {
        "content": "Ни один вор, каким бы искусным он ни был, не может украсть у человека знания, и именно поэтому знания — это лучшее и самое безопасное сокровище, которое можно приобрести. -Л. Фрэнк Баум"
    },
    "2026-05-10": {
        "content": " Я думаю, это самый лучший совет: постоянно думайте о том, как вы могли бы что-то сделать лучше, и задавайте себе вопросы. -Илон Маск"
    },
    "2026-05-11": {
        "content": " Мудрый человек может больше узнать из глупого вопроса, чем дурак из мудрого ответа. -Брюс Ли"
    },
    "2026-05-12": {
        "content": " Если я и видел дальше, то лишь потому, что стоял на плечах гигантов. -Исаак Ньютон"
    },
    "2026-05-13": {
        "content": " То, что мы знаем — это капля, то, чего мы не знаем — это океан. -Исаак Ньютон"
    },
    "2026-05-14": {
        "content": " Самое прекрасное в обучении то, что никто не может его у вас отнять. -ББ Кинг"
    },
    "2026-05-15": {
        "content": " Если вы хотите стать писателем, вам прежде всего нужно делать две вещи: много читать и много писать. -Стивен Кинг"
    },
    "2026-05-16": {
        "content": " Повторение — мать мастерства. -Тони Роббинс"
    },
    "2026-05-17": {
        "content": " Удивление — начало мудрости. -Сократ"
    },
    "2026-05-18": {
        "content": " Если вы совершили ошибку и не исправили ее, это называется ошибкой. -Конфуций"
    },
    "2026-05-19": {
        "content": " Цель образования — заменить пустой ум открытым. -Малкольм С. Форбс"
    },
    "2026-05-20": {
        "content": "Ничего в жизни не надо бояться, надо только понимать. Сейчас самое время больше понимать, чтобы меньше бояться. -Мария Кюри"
    },
    "2026-05-21": {
        "content": " Когда вас спросят, сможете ли вы выполнить работу, отвечайте: «Конечно, смогу!». Затем займитесь делом и выясните, как это сделать. -Теодор Рузвельт"
    },
    "2026-05-22": {
        "content": " Нам всем нужны люди, которые дадут нам обратную связь. Так мы совершенствуемся. -Билл Гейтс"
    },
    "2026-05-23": {
        "content": " Образование — это ключ к познанию мира, пропуск к свободе. -Опра Уинфри"
    },
    "2026-05-24": {
        "content": " Все начинается с идеи. -Эрл Найтингейл"
    },
    "2026-05-25": {
        "content": " Лучшая инвестиция, которую вы можете сделать, — это вложение в себя. -Уоррен Баффет"
    },
    "2026-05-26": {
        "content": " Дело не в деньгах или связях. Дело в готовности работать и учиться лучше всех. -Марк Кьюбан"
    },
    "2026-05-27": {
        "content": " Пока вы живы, продолжайте учиться жить. -Сенека"
    },
    "2026-05-28": {
        "content": " Чтобы научиться добиваться успеха, сначала нужно научиться терпеть неудачи. -Майкл Джордан"
    },
    "2026-05-29": {
        "content": " Не упускайте хорошую ошибку, учитесь на ней. -Роберт Т. Кийосаки"
    },
    "2026-05-30": {
        "content": "Чтобы приобрести знания, нужно учиться; но чтобы приобрести мудрость, нужно наблюдать. -Мэрилин Вос Савант"
    },
    "2026-05-31": {
        "content": " Век живи — век учись. В любом случае, век живи. -Дуглас Адамс"
    },
    "2026-06-01": {
        "content": " Терпение — спутник мудрости. -Святой Августин"
    },
    "2026-06-02": {
        "content": " Я знаю только одно: я ничего не знаю. -Сократ"
    },
    "2026-06-03": {
        "content": " Мудрость приходит с опытом. Опыт часто является результатом отсутствия мудрости. -Терри Пратчетт"
    },
    "2026-06-04": {
        "content": " Мы можем судить о своем прогрессе по смелости наших вопросов и глубине наших ответов, по нашей готовности принять то, что истинно, а не то, что кажется хорошим. -Карл Саган"
    },
    "2026-06-05": {
        "content": " Я бы предпочел вопросы, на которые нельзя ответить, чем ответы, которые нельзя подвергнуть сомнению. -Ричард П. Фейнман"
    },
    "2026-06-06": {
        "content": " Я всегда готов учиться, хотя мне не всегда нравится, когда меня учат. -Уинстон Черчилль"
    },
    "2026-06-07": {
        "content": " Тот, кто любит практику без теории, подобен моряку, который садится на корабль без руля и компаса и никогда не знает, куда его приведет. -Леонардо да Винчи"
    },
    "2026-06-08": {
        "content": " Лучше творить, чем учиться. Творчество — суть жизни. -Юлий Цезарь"
    },
    "2026-06-09": {
        "content": "То, что делает рука, помнит разум. -Мария Монтессори"
    },
    "2026-06-10": {
        "content": " Всегда идите по жизни так, словно вам предстоит узнать что-то новое, и вы это узнаете. -Вернон Ховард"
    },
    "2026-06-11": {
        "content": " Неудача становится успехом, если мы извлекаем из нее уроки. -Малкольм С. Форбс"
    },
    "2026-06-12": {
        "content": " Образование — лучший друг. Образованный человек уважаем везде. Образование побеждает красоту и молодость. -Чанакья"
    },
    "2026-06-13": {
        "content": " Не думай, что то, что тебе трудно освоить, для человека невозможно; но если что-то для человека возможно, считай это достижимым. -Марк Аврелий"
    },
    "2026-06-14": {
        "content": " Обучение — это постоянный процесс открытия, процесс, не имеющий конца. -Брюс Ли"
    },
    "2026-06-15": {
        "content": " Не столько стыдно быть невежественным, сколько нежелать учиться. -Бенджамин Франклин"
    },
    "2026-06-16": {
        "content": " Я убежден, что знание — это сила, позволяющая преодолевать прошлое, менять собственные ситуации, бороться с новыми препятствиями и принимать более обоснованные решения. -Бен Карсон"
    },
    "2026-06-17": {
        "content": " Вдыхая, я успокаиваю тело и разум. Выдыхая, я улыбаюсь. Пребывая в настоящем моменте, я знаю, что это единственный момент. -Тит Нат Хан"
    },
    "2026-06-18": {
        "content": "Если вы считаете, что вы слишком малы, чтобы что-то изменить, попробуйте спать с комаром. -Далай-лама XIV"
    },
    "2026-06-19": {
        "content": " Слишком часто мы недооцениваем силу прикосновения, улыбки, доброго слова, внимательного выслушивания, честного комплимента или даже самого маленького проявления заботы, хотя все это может изменить жизнь. -Лео Бускалья"
    },
    "2026-06-20": {
        "content": " Как мы проводим наши дни, так мы, конечно же, и проводим нашу жизнь. -Энни Диллард"
    },
    "2026-06-21": {
        "content": " Питайте свой разум великими мыслями, ибо вы никогда не подниметесь выше, чем думаете. -Бенджамин Дизраэли"
    },
    "2026-06-22": {
        "content": " Ты не научишься ходить, следуя правилам. Ты учишься, делая и падая. -Ричард Брэнсон"
    },
    "2026-06-23": {
        "content": " Невозможно прожить жизнь, не потерпев ни одной неудачи, если только вы не живете настолько осторожно, что с тем же успехом могли бы не жить вовсе. В таком случае вы по умолчанию терпите неудачу. -Дж. К. Роулинг"
    },
    "2026-06-24": {
        "content": " Если хочешь быть счастливым — будь им. -Лев Толстой"
    },
    "2026-06-25": {
        "content": " Никто не может причинить мне вред без моего разрешения. -Махатма Ганди"
    },
    "2026-06-26": {
        "content": " Когда я отпускаю то, кем я являюсь, я становлюсь тем, кем я могу быть. -Лао-цзы"
    },
    "2026-06-27": {
        "content": "Причина, по которой мы боремся с неуверенностью, заключается в том, что мы сравниваем то, что происходит за кулисами нашей жизни, с яркими моментами жизни других людей. -Стивен Фуртик"
    },
    "2026-06-28": {
        "content": " Помните, сегодня – это то завтра, о котором вы беспокоились вчера. -Дейл Карнеги"
    },
    "2026-06-29": {
        "content": " Мы должны быть готовы отказаться от той жизни, которую мы запланировали, чтобы иметь ту жизнь, которая нас ждет. -Джозеф Кэмпбелл"
    },
    "2026-06-30": {
        "content": " Перестань уходить, и ты придёшь. Перестань искать, и ты увидишь. Перестань убегать, и тебя найдут. -Лао-цзы"
    },
    "2026-07-01": {
        "content": " Команда — это не группа людей, которые работают вместе. Команда — это группа людей, которые доверяют друг другу. -Саймон Синек"
    },
    "2026-07-02": {
        "content": " Постоянный оптимизм — это умножитель силы. -Колин Пауэлл"
    },
    "2026-07-03": {
        "content": " Когда вы будете довольны тем, что вы просто являетесь собой, не будете сравнивать себя с другими и соперничать с ними, все будут вас уважать. -Лао-цзы"
    },
    "2026-07-04": {
        "content": " Считай свой возраст по друзьям, а не по годам. Считай свою жизнь по улыбкам, а не по слезам. -Джон Леннон"
    },
    "2026-07-05": {
        "content": " Дайте тем, кого вы любите, крылья, чтобы летать, корни, чтобы вернуться, и причины остаться. -Далай-лама XIV"
    },
    "2026-07-06": {
        "content": " Упорство и сила духа творили чудеса во все века. -Джордж Вашингтон"
    },
    "2026-07-07": {
        "content": "Поделитесь своими знаниями. Это способ достичь бессмертия. -Далай-лама XIV"
    },
    "2026-07-08": {
        "content": " Мы — способ, с помощью которого космос познает себя. -Карл Саган"
    },
    "2026-07-09": {
        "content": " Хороший учитель может вселить надежду, пробудить воображение и привить любовь к учебе. -Брэд Генри"
    },
    "2026-07-10": {
        "content": " Одно из величайших открытий, которое делает человек, один из его величайших сюрпризов — это осознание того, что он может сделать то, чего он боялся не сделать. -Генри Форд"
    },
    "2026-07-11": {
        "content": " Когда вы в последний раз делали что-то впервые? -Джон К. Максвелл"
    },
    "2026-07-12": {
        "content": " Если вы не находитесь в процессе становления тем человеком, которым хотите быть, вы автоматически становитесь тем человеком, которым не хотите быть. -Дейл Карнеги"
    },
    "2026-07-13": {
        "content": " Удача сопутствует смелым. -Латинская пословица"
    },
    "2026-07-14": {
        "content": " Успех — не ключ к счастью. Счастье — ключ к успеху. Если вы любите то, что делаете, вы будете успешны. -Альберт Швейцер"
    },
    "2026-07-15": {
        "content": " Не приобретай мир и не губи душу свою: мудрость лучше серебра и золота. -Боб Марли"
    },
    "2026-07-16": {
        "content": " Начните жить немедленно и считайте каждый отдельный день отдельной жизнью. -Сенека"
    },
    "2026-07-17": {
        "content": "Если кто-то вроде тебя не проявит к этому большого интереса, то лучше уже не станет. -Доктор Сьюз"
    },
    "2026-07-18": {
        "content": " Они не знали, что это невозможно, поэтому они это сделали. -Марк Твен"
    },
    "2026-07-19": {
        "content": " Я могу делать то, чего не можешь ты, ты можешь делать то, чего не могу я; вместе мы можем творить великие дела. -Мать Тереза"
    },
    "2026-07-20": {
        "content": " Единственное, чего нам следует бояться, — это самого страха. -Франклин Д. Рузвельт"
    },
    "2026-07-21": {
        "content": " Ничто великое не достигалось без энтузиазма. -Ральф Уолдо Эмерсон"
    },
    "2026-07-22": {
        "content": " Мужайся, дорогое сердце. -К.С. Льюис"
    },
    "2026-07-23": {
        "content": " Единственный способ осмыслить перемены — это окунуться в них, двигаться вместе с ними и присоединиться к танцу. -Алан Уоттс"
    },
    "2026-07-24": {
        "content": " Куда направлено внимание, туда течет энергия и видны результаты. -Т. Харв Экер"
    },
    "2026-07-25": {
        "content": " Боль временна. Она может длиться минуту, час, день или год, но в конце концов она утихнет и что-то другое займет ее место. Однако если я уйду, она будет длиться вечно. -Лэнс Армстронг"
    },
    "2026-07-26": {
        "content": " В каждой прогулке на природе человек получает гораздо больше, чем ищет. -Джон Мьюир"
    },
    "2026-07-27": {
        "content": "Победители — это не те, кто никогда не терпит неудач, а те, кто никогда не сдается. -Эдвин Луис Коул"
    },
    "2026-07-28": {
        "content": " Вместо того чтобы бороться с тьмой, вы несете свет. -Экхарт Толле"
    },
    "2026-07-29": {
        "content": " Будьте бесстрашны в погоне за тем, что зажигает вашу душу. -Дженнифер Ли"
    },
    "2026-07-30": {
        "content": " Когда люди уходят от вас, отпустите их. Ваша судьба никогда не связана с теми, кто вас покидает, и это не значит, что они плохие люди. Это просто значит, что их роль в вашей истории окончена. -ТД Джейкс"
    },
    "2026-07-31": {
        "content": " Лидерство — это способность воплощать видение в реальность. -Уоррен Г. Беннис"
    },
    "2026-08-01": {
        "content": " Вера — это когда ты веришь в то, чего не видишь; награда за эту веру — видеть то, во что веришь. -Святой Августин"
    },
    "2026-08-02": {
        "content": " Нет ничего невозможного, пока вы так не думаете. -Парамаханса Йогананда"
    },
    "2026-08-03": {
        "content": " Единственное, что хуже слепоты, — это иметь зрение, но не иметь видения. -Хелен Келлер"
    },
    "2026-08-04": {
        "content": " Во всем есть своя красота, но не все ее видят. -Конфуций"
    },
    "2026-08-05": {
        "content": " Бог говорит в тишине сердца. -Мать Тереза"
    },
    "2026-08-06": {
        "content": "Надежда — это нечто с перьями, что сидит в душе и поет мелодию без слов, и никогда не останавливается. -Эмили Дикинсон"
    },
    "2026-08-07": {
        "content": " Сколько бы святых слов вы ни читали, сколько бы ни произносили, какую пользу они вам принесут, если вы не будете следовать им? -Будда"
    },
    "2026-08-08": {
        "content": " И, кстати, обо всем в жизни можно написать, если у вас есть смелость это сделать и воображение, чтобы импровизировать. Самый страшный враг творчества — это неуверенность в себе. -Сильвия Плат"
    },
    "2026-08-09": {
        "content": " Ничто из того, что мы делаем, не может изменить прошлое, но все, что мы делаем, меняет будущее. -Эшли Бриллиант"
    },
    "2026-08-10": {
        "content": " Лидерство — это выбор. Это не звание. -Саймон Синек"
    },
    "2026-08-11": {
        "content": " Все будет хорошо, и все будет хорошо, и все будет хорошо. -Джулиан из Норвича"
    },
    "2026-08-12": {
        "content": " Каждый из нас, в космической перспективе, драгоценен. Если человек не согласен с тобой, оставь его в живых. В ста миллиардах галактик ты не найдешь другого. -Карл Саган"
    },
    "2026-08-13": {
        "content": " Интеллект плюс характер — вот цель настоящего образования. -Мартин Лютер Кинг-младший."
    },
    "2026-08-14": {
        "content": "Чем больше вы погружаетесь в нечто большее, чем вы сами, тем больше у вас будет энергии. -Норман Винсент Пил"
    },
    "2026-08-15": {
        "content": " Освойте основы, и уровень всего, что вы делаете, повысится. -Майкл Джордан"
    },
    "2026-08-16": {
        "content": " Вы не сможете жить вообще, если не сможете жить полноценно сейчас. -Алан Уоттс"
    },
    "2026-08-17": {
        "content": " Помните, что иногда не получить желаемое — это большая удача. -Далай-лама XIV"
    },
    "2026-08-18": {
        "content": " Сделайте все возможное, а затем расслабьтесь. Позвольте вещам идти естественным путем, а не форсируйте их. -Парамаханса Йогананда"
    },
    "2026-08-19": {
        "content": " Вы — бесконечное духовное существо, переживающее временный человеческий опыт. -Уэйн У. Дайер"
    },
    "2026-08-20": {
        "content": " Прежде чем ваши мечты сбудутся, нужно мечтать. -Абдул Калам"
    },
    "2026-08-21": {
        "content": " Больше всего береги свое сердце, ибо все, что ты делаешь, вытекает из него. -Соломон"
    },
    "2026-08-22": {
        "content": " Я могу отбросить все, пока пишу; мои печали исчезают, мое мужество возрождается. -Анна Франк"
    },
    "2026-08-23": {
        "content": " Цель не в том, чтобы быть идеальным к концу. Цель в том, чтобы стать лучше сегодня. -Саймон Синек"
    },
    "2026-08-24": {
        "content": " Идите уверенно к своей мечте. Живите жизнью, которую вы себе представляете. -Генри Дэвид Торо"
    },
    "2026-08-25": {
        "content": "Будьте добры, когда это возможно. Это всегда возможно. -Далай-лама XIV"
    },
    "2026-08-26": {
        "content": " Наша главная цель в этой жизни — помогать другим. А если вы не можете им помочь, то хотя бы не причиняйте им вреда. -Далай-лама XIV"
    },
    "2026-08-27": {
        "content": " У тебя есть мозги в голове. У тебя есть ноги в ботинках. Ты можешь направить себя в любом направлении, которое выберешь. Ты сам по себе. И ты знаешь то, что ты знаешь. И ты тот, кто решит, куда идти. -Доктор Сьюз"
    },
    "2026-08-28": {
        "content": " То, на чем вы фокусируетесь, расширяется, а когда вы фокусируетесь на хорошем в своей жизни, вы создаете его больше. -Опра Уинфри"
    },
    "2026-08-29": {
        "content": " Все, что мне нужно знать, открыто мне. Все, что мне нужно, приходит ко мне. Все хорошо в моей жизни. -Луиза Хей"
    },
    "2026-08-30": {
        "content": " Я в полной безопасности во Вселенной. Я везде в покое. Я доверяю жизни. -Луиза Хей"
    },
    "2026-08-31": {
        "content": " Повернитесь лицом к солнцу, и тени останутся позади вас. -Пословица маори"
    },
    "2026-09-01": {
        "content": " Мужество — это не иметь сил идти дальше; это продолжать, когда у тебя нет сил. -Теодор Рузвельт"
    },
    "2026-09-02": {
        "content": " Будущее зависит от того, что вы делаете сегодня. -Махатма Ганди"
    },
    "2026-09-03": {
        "content": " Победитель — это мечтатель, который никогда не сдается. -Нельсон Мандела"
    },
    "2026-09-04": {
        "content": "Не плачь, потому что это закончилось, улыбнись, потому что это было. -Доктор Сьюз"
    },
    "2026-09-05": {
        "content": " Я могу выразить тремя словами все, что я узнал о жизни: она продолжается. -Роберт Фрост"
    },
    "2026-09-06": {
        "content": " Живите своим воображением, а не своей историей. -Стивен Р. Кови"
    },
    "2026-09-07": {
        "content": " Я считаю, что если хочешь радугу, придется смириться с дождем. -Долли Партон"
    },
    "2026-09-08": {
        "content": " Величие человека не в том, сколько богатства он приобрел, а в его честности и способности оказывать положительное влияние на окружающих. -Боб Марли"
    },
    "2026-09-09": {
        "content": " Счастье в основном зависит от нашего собственного отношения, а не от внешних факторов. -Далай-лама XIV"
    },
    "2026-09-10": {
        "content": " Великие деяния складываются из малых дел. -Лао-цзы"
    },
    "2026-09-11": {
        "content": " Никогда не поздно стать тем, кем ты мог бы быть. -Джордж Элиот"
    },
    "2026-09-12": {
        "content": " Правильный настрой может превратить негативный стресс в позитивный. -Ганс Селье"
    },
    "2026-09-13": {
        "content": " Осмелитесь прожить жизнь, о которой вы мечтали. Идите вперед и воплощайте свои мечты в реальность. -Ральф Уолдо Эмерсон"
    },
    "2026-09-14": {
        "content": " Время, которое вам нравится тратить, не является потраченным впустую. -Бертран Рассел"
    },
    "2026-09-15": {
        "content": "Нужно лишь немного бдительности, чтобы увидеть и понять: жизнь — это на самом деле великий космический смех. -Ошо"
    },
    "2026-09-16": {
        "content": " Любопытный парадокс заключается в том, что когда я принимаю себя таким, какой я есть, я могу измениться. -Карл Р. Роджерс"
    },
    "2026-09-17": {
        "content": " Будьте частью решения, а не частью проблемы. -Стивен Р. Кови"
    },
    "2026-09-18": {
        "content": " Секрет жизни — в умении отдавать. -Тони Роббинс"
    },
    "2026-09-19": {
        "content": " Сделайте каждый день своим шедевром. -Джон Вуден"
    },
    "2026-09-20": {
        "content": " Никогда не отказывайтесь от того, что вы действительно хотите сделать. -Х. Джексон Браун-младший."
    },
    "2026-09-21": {
        "content": " Не оглядывайся назад – ты не пойдешь этим путем. -Мэри Энгельбрайт"
    },
    "2026-09-22": {
        "content": " Делайте все возможное, а Бог сделает все остальное. -Ник Вуйчич"
    },
    "2026-09-23": {
        "content": " Живите, путешествуйте, ищите приключения, благословляйте и не сожалейте. -Джек Керуак"
    },
    "2026-09-24": {
        "content": " В разгар зимы я обнаружил, что внутри меня есть непобедимое лето. И это делает меня счастливым. Ибо это говорит о том, что как бы сильно мир ни давил на меня, внутри меня есть что-то сильнее – что-то лучшее, что давит в ответ. -Альбер Камю"
    },
    "2026-09-25": {
        "content": "Некоторые считают, что только великая сила может сдерживать зло, но я не это обнаружил. Это маленькие повседневные дела простых людей, которые держат тьму в страхе. Маленькие акты доброты и любви. -Дж. Р. Р. Толкин"
    },
    "2026-09-26": {
        "content": " Будьте верны в малом, потому что именно в этом ваша сила. -Мать Тереза"
    },
    "2026-09-27": {
        "content": " Сделай из себя свет. -Будда"
    },
    "2026-09-28": {
        "content": " ВИЗУАЛИЗИРУЙТЕ!!! Увидьте, почувствуйте! Вот тут-то и начинается действие. -Ронда Берн"
    },
    "2026-09-29": {
        "content": " Будь феноменальным или будешь забыт! -Эрик Томас"
    },
    "2026-09-30": {
        "content": " Когда у вас есть выбор быть правым или быть добрым, выбирайте быть добрым. -Уэйн У. Дайер"
    },
    "2026-10-01": {
        "content": " Люди могут изменить свою жизнь, изменив образ мышления. -Уильям Джеймс"
    },
    "2026-10-02": {
        "content": " Здоровье – величайшее богатство. -Лао-цзы"
    },
    "2026-10-03": {
        "content": " Дай мне не молиться о том, чтобы меня защитили от опасностей, но молить о том, чтобы я был бесстрашен в их встрече. Дай мне не молить об успокоении моей боли, но о том, чтобы сердце победило ее. -Рабиндранат Тагор"
    },
    "2026-10-04": {
        "content": " Направьте сердце ваше на добрые дела. Делайте это снова и снова, и вы будете наполнены радостью. -Будда"
    },
    "2026-10-05": {
        "content": "Я не могу в одиночку изменить мир, но могу бросить камень в воду, чтобы создать множество кругов. -Мать Тереза"
    },
    "2026-10-06": {
        "content": " И настал день, когда риск остаться в бутоне оказался более болезненным, чем риск расцвести. -Анаис Нин"
    },
    "2026-10-07": {
        "content": " Не должно быть никаких границ для человеческих усилий. Какой бы плохой ни казалась жизнь, всегда есть надежда. -Стивен Хокинг"
    },
    "2026-10-08": {
        "content": " И я призываю вас, пожалуйста, замечать, когда вы счастливы, и восклицать, или бормотать, или думать в какой-то момент: «Если это не приятно, то я не знаю, что это». -Курт Воннегут"
    },
    "2026-10-09": {
        "content": " Именно ваша реакция на невзгоды, а не сами невзгоды, определяют, как будет развиваться история вашей жизни. -Дитер Ф. Ухтдорф"
    },
    "2026-10-10": {
        "content": " Не то, что у тебя есть, кто ты, где ты, что ты делаешь, делает тебя счастливым или несчастным. А то, что ты об этом думаешь. -Дейл Карнеги"
    },
    "2026-10-11": {
        "content": " Чем больше ты читаешь, тем больше вещей ты узнаешь. Чем больше ты узнаешь, тем больше мест ты посетишь. -Доктор Сьюз"
    },
    "2026-10-12": {
        "content": " Все наши мечты могут стать реальностью. -Уолт Дисней"
    },
    "2026-10-13": {
        "content": "Привилегия всей жизни — быть тем, кто ты есть. -Джозеф Кэмпбелл"
    },
    "2026-10-14": {
        "content": " В этом мире нет бесполезных людей, которые облегчают бремя других. -Чарльз Диккенс"
    },
    "2026-10-15": {
        "content": " Найдите внутри себя место, где есть радость, и радость выжжет боль. -Джозеф Кэмпбелл"
    },
    "2026-10-16": {
        "content": " Не спрашивай, что нужно миру. Спроси, что заставляет тебя оживать, и иди и делай это. Потому что миру нужно больше людей, которые ожили. -Говард Турман"
    },
    "2026-10-17": {
        "content": " Ваши чувства — это ваши главные инструменты, помогающие вам творить свою жизнь. -Ронда Берн"
    },
    "2026-10-18": {
        "content": " Я заслуживаю лучшего и принимаю лучшее сейчас. -Луиза Хей"
    },
    "2026-10-19": {
        "content": " Важно не то, сколько мы отдаем, а сколько любви мы вкладываем в то, что отдаем. -Мать Тереза"
    },
    "2026-10-20": {
        "content": " Когда вы хотите добиться успеха так же сильно, как хотите дышать, тогда вы добьетесь успеха. -Эрик Томас"
    },
    "2026-10-21": {
        "content": " Я ненавидел каждую минуту тренировок, но я сказал себе: «Не сдавайся. Потерпи сейчас и проживи остаток жизни как чемпион». -Мухаммед Али"
    },
    "2026-10-22": {
        "content": "Не критик имеет значение, не тот, кто указывает, как споткнулся сильный человек или как творец деяний мог бы сделать их лучше. Честь принадлежит тому, кто действительно находится на арене, чье лицо запятнано потом, пылью и кровью; кто доблестно борется; кто ошибается и терпит неудачу снова и снова; кто знает великий энтузиазм, великую преданность и тратит себя на достойное дело; кто, если он побеждает, знает триумф высокого достижения; и кто, если он терпит неудачу, по крайней мере терпит неудачу, будучи очень смелым, так что его место никогда не будет среди тех холодных и робких душ, которые не знают ни победы, ни поражения. -Теодор Рузвельт"
    },
    "2026-10-23": {
        "content": " Самое большое приключение, которое вы когда-либо можете совершить, — это прожить жизнь своей мечты. -Опра Уинфри"
    },
    "2026-10-24": {
        "content": " Без борьбы не может быть прогресса. -Фредерик Дугласс"
    },
    "2026-10-25": {
        "content": " Мечта, записанная с датой, становится целью. Цель, разбитая на шаги, становится планом. План, подкрепленный действием, делает ваши мечты реальностью. -Грег Рид"
    },
    "2026-10-26": {
        "content": "Сделайте то, что, по вашему мнению, вы не можете сделать. Потерпите неудачу. Попробуйте еще раз. Сделайте лучше во второй раз. Единственные люди, которые никогда не падают, — это те, кто никогда не лазает по канату. -Опра Уинфри"
    },
    "2026-10-27": {
        "content": " Ожидайте перемен. Анализируйте обстановку. Используйте возможности. Перестаньте быть шахматной пешкой; станьте игроком. Это ваш ход. -Тони Роббинс"
    },
    "2026-10-28": {
        "content": " Ты свободен. Ты силен. Ты хорош. Ты — любовь. Ты ценен. У тебя есть цель. Все хорошо. -Эстер Хикс"
    },
    "2026-10-29": {
        "content": "Если вы хотите чего-то настолько сильно, чтобы выйти и бороться за это, работать ради этого день и ночь, отдать свое время, свой покой и свой сон ради этого. Если все, о чем вы мечтаете и что планируете, касается этого, а жизнь без этого кажется бесполезной и никчемной; Если вы с радостью потеете, беспокоитесь и планируете это и теряете весь свой страх перед сопротивлением; Если вы просто идете за тем, чего хотите, со всеми своими способностями, силой и проницательностью, верой, надеждой и уверенностью и тверды в упорстве; Если ни холод, ни бедность, голод или подагра, болезнь или боль тела и мозга не могут удержать вас от того, чего вы хотите; Если вы упрямы и угрюмы, будете растить и зачинать это, с помощью БОЖЬЕЙ вы это получите. -Бертон Брейли"
    },
    "2026-10-30": {
        "content": " Даже если вы на правильном пути, вас переедут, если вы будете просто сидеть на месте. -Уилл Роджерс"
    },
    "2026-10-31": {
        "content": " Я думаю, что обычные люди могут выбрать быть необыкновенными. -Илон Маск"
    },
    "2026-11-01": {
        "content": " Ты не научишься ходить, следуя правилам. Ты учишься, делая и падая. -Ричард Брэнсон"
    },
    "2026-11-02": {
        "content": "Здесь нет таланта, это тяжелая работа. Это одержимость. Таланта не существует, мы все равны как люди. Вы можете стать кем угодно, если потратите время. Вы достигнете вершины, и все. Я не талантлив, я одержим. -Конор МакГрегор"
    },
    "2026-11-03": {
        "content": " Сон — это не то, что вы видите во время сна; это то, что не дает вам спать. -Абдул Калам"
    },
    "2026-11-04": {
        "content": " Когда вы исчерпали все возможности, помните: вы этого не сделали. -Томас А. Эдисон"
    },
    "2026-11-05": {
        "content": " Рискуй, совершай ошибки. Так ты растешь. Боль питает твою смелость. Ты должен терпеть неудачи, чтобы практиковать храбрость. -Мэри Тайлер Мур"
    },
    "2026-11-06": {
        "content": " На чем вы сосредоточитесь, то и получите. -Тони Роббинс"
    },
    "2026-11-07": {
        "content": " «Суета» — самое важное слово на свете. -Гари Вайнерчук"
    },
    "2026-11-08": {
        "content": " Если они смогли сделать пенициллин из заплесневелого хлеба, то они наверняка смогут сделать что-то и из вас. -Мухаммед Али"
    },
    "2026-11-09": {
        "content": " Ты не родился победителем, и ты не родился неудачником. Ты тот, кем ты себя делаешь. -Лу Хольц"
    },
    "2026-11-10": {
        "content": " Успех — это ваш долг, обязанность и ответственность. -Грант Кардон"
    },
    "2026-11-11": {
        "content": "Различий между людьми немного, но это небольшое различие имеет большое значение. Небольшое различие — это отношение. Большое различие — это то, является ли оно положительным или отрицательным. -У. Клемент Стоун"
    },
    "2026-11-12": {
        "content": " Лидеры должны быть достаточно близки, чтобы общаться с другими, но достаточно далеки от них, чтобы мотивировать их. -Джон К. Максвелл"
    },
    "2026-11-13": {
        "content": " Никогда не говори никогда, потому что ограничения, как и страхи, часто являются всего лишь иллюзией. -Майкл Джордан"
    },
    "2026-11-14": {
        "content": " Вы должны ожидать от себя великих дел, прежде чем сможете их совершить. -Майкл Джордан"
    },
    "2026-11-15": {
        "content": " В мире бизнеса наибольшего успеха добиваются те, кто занимается любимым делом. -Уоррен Баффет"
    },
    "2026-11-16": {
        "content": " Действие уничтожит вашу прокрастинацию. -Ог Мандино"
    },
    "2026-11-17": {
        "content": " Неудача для меня не вариант. Успех — это все, что я себе представляю. -Конор МакГрегор"
    },
    "2026-11-18": {
        "content": " Успех приходит не от того, что вы делаете время от времени, а от того, что вы делаете постоянно. -Мари Форлео"
    },
    "2026-11-19": {
        "content": " Уверенность и упорный труд — лучшие лекарства от болезни, называемой неудачей. Они сделают вас успешным человеком. -Абдул Калам"
    },
    "2026-11-20": {
        "content": " Если хочешь сиять как солнце, сначала гори как солнце. -Абдул Калам"
    },
    "2026-11-21": {
        "content": "Пока ты там тусуешься, валяешь дурака, кто-то там в это же время усердно трудится. Кто-то становится умнее, а кто-то побеждает. Просто помни об этом. -Арнольд Шварценеггер"
    },
    "2026-11-22": {
        "content": " Если вы делаете то, что всегда делали, вы и получите то, что всегда получали. -Тони Роббинс"
    },
    "2026-11-23": {
        "content": " Прогресс равнозначен счастью. -Тони Роббинс"
    },
    "2026-11-24": {
        "content": " У вас могут быть либо результаты, либо оправдания. Но не то и другое одновременно. -Арнольд Шварценеггер"
    },
    "2026-11-25": {
        "content": " Дисциплина равно свободе. -Джоко Виллинк"
    },
    "2026-11-26": {
        "content": " Не зацикливайтесь на том, что пошло не так. Вместо этого сосредоточьтесь на том, что делать дальше. Направьте свою энергию на движение вперед, на поиск ответа. -Денис Уэйтли"
    },
    "2026-11-27": {
        "content": " Будьте таким лидером, каким вы хотели бы быть. -Саймон Синек"
    },
    "2026-11-28": {
        "content": " Я позиция такая: если вы подталкиваете меня к чему-то, что, по вашему мнению, является слабостью, то я превращу эту кажущуюся слабость в силу. -Майкл Джордан"
    },
    "2026-11-29": {
        "content": " Для большинства из нас большая опасность заключается не в том, что мы ставим перед собой слишком высокую цель и не достигаем ее, а в том, что мы ставим перед собой слишком низкую цель и не достигаем ее. -Микеланджело"
    },
    "2026-11-30": {
        "content": " У каждого есть мечта, но не у каждого есть цель. -Эрик Томас"
    },
    "2026-12-01": {
        "content": "Лидерами становятся, ими не рождаются. Их создают упорные усилия, и это цена, которую все мы должны заплатить, чтобы достичь любой стоящей цели. -Винс Ломбарди"
    },
    "2026-12-02": {
        "content": " Мы выбираем отправиться на Луну в этом десятилетии и сделать другие вещи. Не потому, что это легко, а потому, что это трудно. -Джон Ф. Кеннеди"
    },
    "2026-12-03": {
        "content": " Самый лучший день в твоей и моей жизни — это когда мы берем на себя полную ответственность за свои взгляды. Это день, когда мы по-настоящему взрослеем. -Джон К. Максвелл"
    },
    "2026-12-04": {
        "content": " Каждый раз, когда вы улыбаетесь кому-то, это акт любви, дар этому человеку, прекрасная вещь. -Мать Тереза"
    },
    "2026-12-05": {
        "content": " Будьте молчаливым наблюдателем своих мыслей и поведения. Вы ниже мыслителя. Вы — тишина под ментальным шумом. Вы — любовь и радость под болью. -Экхарт Толле"
    },
    "2026-12-06": {
        "content": " Если не можешь летать, беги, если не можешь бежать, иди, если не можешь ходить, ползай, но что бы ты ни делал, ты должен продолжать двигаться вперед. -Мартин Лютер Кинг-младший."
    },
    "2026-12-07": {
        "content": " Прощение — это не разовое действие, это постоянная позиция. -Мартин Лютер Кинг-младший."
    },
    "2026-12-08": {
        "content": " Слишком часто мы недооцениваем силу прикосновения, улыбки, доброго слова, внимательного выслушивания, честного комплимента или даже самого маленького проявления заботы, хотя все это может изменить жизнь. -Лео Бускалья"
    },
    "2026-12-09": {
        "content": "Сохраняйте свои мечты живыми. Поймите, чтобы чего-то достичь, нужны вера и убежденность в себе, видение, упорный труд, решимость и преданность. Помните, что все возможно для тех, кто верит. -Гейл Деверс"
    },
    "2026-12-10": {
        "content": " Спорт обладает силой изменить мир. Он обладает силой вдохновлять. Он обладает силой объединять людей так, как мало что другое. Он говорит с молодежью на понятном ей языке. Спорт может создать надежду там, где когда-то было только отчаяние. -Нельсон Мандела"
    },
    "2026-12-11": {
        "content": " Проси то, чего хочешь. Поверь, что ты этого заслуживаешь, а затем позволь Жизни дать тебе это. -Луиза Хей"
    },
    "2026-12-12": {
        "content": " Живите с намерением. Идите к краю. Внимательно слушайте. Практикуйте благополучие. Играйте самозабвенно. Смейтесь. Выбирайте без сожалений. Цените своих друзей. Продолжайте учиться. Делайте то, что любите. Живите так, как будто это все, что есть. -Мэри Энн Радмахер"
    },
    "2026-12-13": {
        "content": " То, на чем вы фокусируетесь, расширяется, а когда вы фокусируетесь на хорошем в своей жизни, вы создаете его больше. -Опра Уинфри"
    },
    "2026-12-14": {
        "content": " У вас есть власть над вашим разумом, а не над внешними событиями. Осознайте это, и вы обретете силу. -Марк Аврелий"
    },
    "2026-12-15": {
        "content": "Не ищите оправданий, почему вы не можете этого сделать. Сосредоточьтесь на всех причинах, по которым вы должны это сделать. -Ральф Марстон"
    },
    "2026-12-16": {
        "content": " Где любовь, там жизнь. -Махатма Ганди"
    },
    "2026-12-17": {
        "content": " Нужно танцевать так, словно никто не видит, любить так, словно никто не причинит тебе боль, петь так, словно никто не слышит, и жить так, словно на земле рай. -Уильям В. Перки"
    },
    "2026-12-18": {
        "content": " Успех — это осознание своего предназначения в жизни, стремление раскрыть свой максимальный потенциал и сеять семена, приносящие пользу другим. -Джон К. Максвелл"
    },
    "2026-12-19": {
        "content": " Мечта, которую ты видишь в одиночку, — всего лишь мечта. Мечта, которую ты видишь вместе, — реальность. -Джон Леннон"
    },
    "2026-12-20": {
        "content": " Это настоящий секрет жизни — быть полностью вовлеченным в то, что вы делаете здесь и сейчас. И вместо того, чтобы называть это работой, осознайте, что это игра. -Алан Уоттс"
    },
    "2026-12-21": {
        "content": " Вчера уже прошло. Завтра еще не наступило. У нас есть только сегодня. Давайте начнем. -Мать Тереза"
    },
    "2026-12-22": {
        "content": " Чем больше вы хвалите и празднуете свою жизнь, тем больше в ней поводов для празднования. -Опра Уинфри"
    },
    "2026-12-23": {
        "content": "Никогда не сомневайтесь, что небольшая группа думающих, преданных граждан может изменить мир. На самом деле, это единственное, что когда-либо изменялось. -Маргарет Мид"
    },
    "2026-12-24": {
        "content": " Подталкивайте себя, потому что никто другой не сделает этого за вас. -Анонимный"
    },
    "2026-12-25": {
        "content": " Истинное смирение — это не думать о себе хуже, а думать о себе меньше. -К.С. Льюис"
    },
    "2026-12-26": {
        "content": " Если вы сможете изменить свое мнение, вы сможете изменить свою жизнь. -Уильям Джеймс"
    },
    "2026-12-27": {
        "content": " Сосредоточьтесь на том, куда вы хотите пойти, а не на том, чего вы боитесь. -Тони Роббинс"
    },
    "2026-12-28": {
        "content": " Уважайте себя, и другие будут уважать вас. -Конфуций"
    },
    "2026-12-29": {
        "content": " Делай то, что можешь, с тем, что имеешь, там, где ты есть. -Теодор Рузвельт"
    },
    "2026-12-30": {
        "content": " Некоторые изменения на первый взгляд кажутся негативными, но вскоре вы поймете, что в вашей жизни освобождается место для появления чего-то нового. -Экхарт Толле"
    },
    "2026-12-31": {
        "content": " Если ваши действия вдохновляют других мечтать больше, узнавать больше, делать больше и становиться лучше, вы — лидер. -Джон Куинси Адамс"
    }
}

export const dateFrenchList = {
    "2024-01-01": {
        "content": " Nous sommes ce que nous faisons de manière répétée. L'excellence n'est donc pas un acte, mais une habitude. -Aristote"
    },
    "2024-01-02": {
        "content": " Une rivière traverse la roche, non pas en raison de sa puissance, mais en raison de sa persistance. -Jim Watkins"
    },
    "2024-01-03": {
        "content": " L’énergie et la persévérance triomphent de toutes choses. -Benjamin Franklin"
    },
    "2024-01-04": {
        "content": " Les opportunités sont généralement déguisées en travail acharné, de sorte que la plupart des gens ne les reconnaissent pas. -Ann Landers"
    },
    "2024-01-05": {
        "content": " Si vous ne pouvez pas voler, courez, si vous ne pouvez pas courir, marchez, si vous ne pouvez pas marcher, rampez, mais quoi que vous fassiez, vous devez continuer à avancer. -Martin Luther King Jr."
    },
    "2024-01-06": {
        "content": " La persévérance garantit que les résultats sont inévitables. -Paramahansa Yogananda"
    },
    "2024-01-07": {
        "content": " Avec un talent ordinaire et une persévérance extraordinaire, tout est réalisable -Thomas Fowell Buxton"
    },
    "2024-01-08": {
        "content": " Notre plus grande gloire n’est pas de ne jamais échouer, mais de nous relever chaque fois que nous échouons. -Ralph Waldo Emerson"
    },
    "2024-01-09": {
        "content": " Le succès consiste à trébucher d’échec en échec sans perdre son enthousiasme. -Winston Churchill"
    },
    "2024-01-10": {
        "content": "Heureusement, la persévérance est un excellent substitut au talent. -Steve Martin"
    },
    "2024-01-11": {
        "content": " Je crois davantage à la chance, et je trouve que plus je travaille dur, plus j'en ai. -Thomas Jefferson"
    },
    "2024-01-12": {
        "content": " Ne remettez à demain que ce que vous seriez prêt à mourir sans avoir fait. -Pablo Picasso"
    },
    "2024-01-13": {
        "content": " Il n'y a pas de secret pour réussir : ne perdez pas de temps à le chercher. Le succès est le fruit de la perfection, du travail acharné, de l'apprentissage de l'échec, de la loyauté envers ceux pour qui vous travaillez et de la persévérance. -Colin Powell"
    },
    "2024-01-14": {
        "content": " Si vous souhaitez être devant, agissez comme si vous étiez derrière. -Lao Tseu"
    },
    "2024-01-15": {
        "content": " Laissez-moi vous révéler le secret qui m’a conduit à mon objectif : ma force réside uniquement dans ma ténacité. -Louis Pasteur"
    },
    "2024-01-16": {
        "content": " Rien au monde ne peut remplacer la persévérance. Le talent ne le fera pas ; rien n'est plus commun que les personnes talentueuses et incompétentes. Le génie ne le fera pas ; le génie non récompensé est presque un proverbe. -Calvin Coolidge"
    },
    "2024-01-17": {
        "content": " La meilleure issue est toujours de passer à travers. -Robert Frost"
    },
    "2024-01-18": {
        "content": "Beaucoup d’échecs dans la vie sont dus à des personnes qui n’ont pas réalisé à quel point elles étaient proches du succès lorsqu’elles ont abandonné. -Thomas A. Edison"
    },
    "2024-01-19": {
        "content": " Nous sommes faits pour persévérer. C'est ainsi que nous découvrons qui nous sommes. -Tobias Wolff"
    },
    "2024-01-20": {
        "content": " Connaissant les arbres, je comprends le sens de la patience. Connaissant l'herbe, j'apprécie la persévérance. -Hal Borland"
    },
    "2024-01-21": {
        "content": " L'eau qui coule creuse la pierre, non pas par la force mais par la persistance. -Ovide"
    },
    "2024-01-22": {
        "content": " La persévérance est essentielle. N'abandonnez pas, sauf si vous y êtes contraint. -Elon Musk"
    },
    "2024-01-23": {
        "content": " Un enthousiasme débordant, soutenu par le bon sens et la persévérance, est la qualité qui conduit le plus souvent au succès. -Dale Carnegie"
    },
    "2024-01-24": {
        "content": " L'ambition est la voie du succès. La persévérance est le véhicule qui y conduit. -Bill Bradley"
    },
    "2024-01-25": {
        "content": " Concentrez-vous sur la solution, pas sur le problème. -Walter Anderson"
    },
    "2024-01-26": {
        "content": " Lorsque la vie vous fait tomber, vous avez deux choix : rester à terre ou vous relever. -Tom Krause"
    },
    "2024-01-27": {
        "content": "Le succès est la somme de petits efforts, répétés jour après jour. -Robert Collier"
    },
    "2024-01-28": {
        "content": " Un rêve n'est qu'un rêve. Un objectif est un rêve avec un plan et une échéance. -Harvey MacKay"
    },
    "2024-01-29": {
        "content": " N'abandonnez jamais quelque chose auquel vous ne pouvez pas passer une journée sans penser. -Winston Churchill"
    },
    "2024-01-30": {
        "content": " Les diamants ne sont rien d’autre que des morceaux de charbon qui restent collés à leur travail. -Malcolm S. Forbes"
    },
    "2024-01-31": {
        "content": " On ne peut rien faire d'autre que petit à petit. -Charles Baudelaire"
    },
    "2024-02-01": {
        "content": " Si vous traversez l’enfer, continuez. -Winston Churchill"
    },
    "2024-02-02": {
        "content": " La clé de la persévérance ouvre toutes les portes fermées par la résistance. -John Di Lemme"
    },
    "2024-02-03": {
        "content": " Si nous regardons ceux qui réussissent le mieux dans le monde, la persévérance est le dénominateur commun. -Justin Sachs"
    },
    "2024-02-04": {
        "content": " Vous pouvez manger un éléphant petit à petit. -Mary Kay Ash"
    },
    "2024-02-05": {
        "content": " Je ne pense pas qu'il existe une qualité aussi essentielle à la réussite, quelle qu'elle soit, que la persévérance. Elle permet de surmonter presque tout, même la nature. -John D. Rockefeller"
    },
    "2024-02-06": {
        "content": "Si vous voulez transformer une vision en réalité, vous devez vous donner à 100 % et ne jamais cesser de croire en votre rêve. -Arnold Schwarzenegger"
    },
    "2024-02-07": {
        "content": " Courez quand vous le pouvez, marchez si vous le devez, rampez si vous le devez ; n'abandonnez jamais. -Doyen Karnazes"
    },
    "2024-02-08": {
        "content": " Faire un tour de plus quand vous pensez ne pas pouvoir le faire, c'est ce qui fait toute la différence dans votre vie. -Sylvester Stallone"
    },
    "2024-02-09": {
        "content": " Écoutez-moi, même quand on perd, c'est normal de perdre, mais on ne peut jamais s'y habituer. On ne peut jamais se satisfaire de perdre. Quand on perd, ça fait forcément mal. -Éric Thomas"
    },
    "2024-02-10": {
        "content": " Continuez à marcher, un pas à la fois. -Joyce Meyer"
    },
    "2024-02-11": {
        "content": " Nous ne devons pas abandonner et ne devons pas laisser le problème nous vaincre. -Abdul Kalam"
    },
    "2024-02-12": {
        "content": " C'est par l'endurance que nous conquérons. -Ernest Shackleton"
    },
    "2024-02-13": {
        "content": "Les murs de briques existent pour une raison. Ils ne sont pas là pour nous empêcher d'accéder à quelque chose. Ils sont là pour nous permettre de montrer à quel point nous le désirons. Parce qu'ils sont là pour arrêter ceux qui ne le désirent pas suffisamment. Ils sont là pour arrêter les autres. -Randy Pausch"
    },
    "2024-02-14": {
        "content": " Le succès dépend presque entièrement de la motivation et de la persévérance. L'énergie supplémentaire nécessaire pour redoubler d'efforts ou tenter une nouvelle approche est le secret de la victoire. -Denis Waitley"
    },
    "2024-02-15": {
        "content": " J'étais arrivé jusqu'ici et j'avais refusé d'abandonner car toute ma vie j'avais toujours terminé la course. -Louis Zamperini"
    },
    "2024-02-16": {
        "content": " La survie peut se résumer en trois mots : ne jamais abandonner. C'est le cœur du problème. Continuer d'essayer. -Bear Grylls"
    },
    "2024-02-17": {
        "content": "PLUS JAMAIS. Plus d'excuses. Plus de : « Je commence demain. » Plus de : « Juste pour cette fois. » Plus besoin d'accepter mes propres échecs. Plus besoin de prendre la facilité. Plus besoin de m'incliner devant les pensées malsaines ou improductives qui me traversent l'esprit. -Jocko Willink"
    },
    "2024-02-18": {
        "content": " De petits coups ont fait tomber de grands chênes. -Benjamin Franklin"
    },
    "2024-02-19": {
        "content": " « Je suis prêt. » « Je suis fait pour gagner. » « J'y suis parvenu. » « J'accepte l'incertitude. » « Je ne suis pas mes pensées ; je suis ce que je fais. » « Je suis acharné. » « Je n'attends rien et j'accepte tout. -Gary John Bishop"
    },
    "2024-02-20": {
        "content": " Je n'ai pas échoué 700 fois. Je n'ai pas échoué une seule fois. J'ai réussi à prouver que ces 700 méthodes ne fonctionneront pas. Une fois que j'aurai éliminé celles qui ne fonctionneront pas, je trouverai celle qui fonctionnera. -Thomas A. Edison"
    },
    "2024-02-21": {
        "content": " GRIT signifie courage, résilience, assiduité et ténacité. GRIT, c'est la capacité à se concentrer, à rester déterminé, à rester optimiste face aux défis et à travailler plus dur que ses pairs. -Linda Kaplan Thaler"
    },
    "2024-02-22": {
        "content": "Je pense que mon secret est qu'il n'y a pas de raccourcis pour travailler dur, être déterminé et avoir cette attitude de « ne pas abandonner ». -Jerry Rice"
    },
    "2024-02-23": {
        "content": " Ne cessez jamais de vous battre jusqu'à atteindre votre destinée, c'est-à-dire votre moi unique. Ayez un but dans la vie, acquérez continuellement des connaissances, travaillez dur et persévérez pour réaliser une vie formidable. -Abdul Kalam"
    },
    "2024-02-24": {
        "content": " Ne vous arrêtez pas quand vous êtes fatigué. Arrêtez-vous quand vous avez terminé. -David Goggins"
    },
    "2024-02-25": {
        "content": " Ne me jugez pas sur mes succès, jugez-moi sur le nombre de fois où je suis tombé et me suis relevé. -Nelson Mandela"
    },
    "2024-02-26": {
        "content": " Ce qui n'est pas commencé aujourd'hui n'est jamais terminé demain. -Johann Wolfgang von Goethe"
    },
    "2024-02-27": {
        "content": " Si vous écrivez une centaine de nouvelles et qu'elles sont toutes mauvaises, cela ne signifie pas que vous avez échoué. Vous échouez seulement si vous arrêtez d'écrire. -Ray Bradbury"
    },
    "2024-02-28": {
        "content": " Le maître a échoué plus de fois que le débutant n’a essayé. -Stephen McCranie"
    },
    "2024-02-29": {
        "content": " Au diable les circonstances ; je crée des opportunités. -Bruce Lee"
    },
    "2024-03-01": {
        "content": "La seule chose pire que de commencer quelque chose et d’échouer, c’est de ne rien commencer. -Seth Godin"
    },
    "2024-03-02": {
        "content": " Ne remettez jamais à demain ce que vous pouvez faire aujourd’hui. -Benjamin Franklin"
    },
    "2024-03-03": {
        "content": " Grâce à sa persévérance, l'escargot atteignit l'arche. -Charles H. Spurgeon"
    },
    "2024-03-04": {
        "content": " N'oubliez pas que l'espoir est une bonne chose, peut-être la meilleure des choses, et qu'aucune bonne chose ne meurt jamais. -Stephen King"
    },
    "2024-03-05": {
        "content": " Les entrepreneurs ne finissent pas quand ils sont fatigués. Ils finissent quand ils ont fini. -Robert T. Kiyosaki"
    },
    "2024-03-06": {
        "content": " Seules la persévérance et la détermination sont omnipotentes. -Calvin Coolidge"
    },
    "2024-03-07": {
        "content": " Paralyser la résistance par la persévérance. -Woody Hayes"
    },
    "2024-03-08": {
        "content": " Le succès n’est jamais possédé, il est loué, et le loyer est dû chaque jour. -Rory Vaden"
    },
    "2024-03-09": {
        "content": " Le succès n'est pas le fruit du hasard. C'est le fruit du travail, de la persévérance, de l'apprentissage, des études, du sacrifice et, surtout, de l'amour de ce que l'on fait ou apprend à faire. -Pelé"
    },
    "2024-03-10": {
        "content": " Il n'y a pas d'autre solution que de travailler dur. Acceptez-le. -Roger Federer"
    },
    "2024-03-11": {
        "content": " Un rêve ne devient pas réalité par magie ; il faut de la sueur, de la détermination et du travail acharné. -Colin Powell"
    },
    "2024-03-12": {
        "content": "L’apprentissage n’épuise jamais l’esprit. -Léonard de Vinci"
    },
    "2024-03-13": {
        "content": " J'entends et j'oublie. Je vois et je me souviens. Je fais et je comprends. -Confucius"
    },
    "2024-03-14": {
        "content": " Celui qui n’a jamais fait d’erreur n’a jamais rien essayé de nouveau. -Albert Einstein"
    },
    "2024-03-15": {
        "content": " Essayez d’apprendre quelque chose sur tout et tout sur quelque chose. -Thomas Henry Huxley"
    },
    "2024-03-16": {
        "content": " Un homme n’apprend que de deux manières : l’une en lisant, l’autre en fréquentant des personnes plus intelligentes. -Will Rogers"
    },
    "2024-03-17": {
        "content": " Vous ne comprenez rien tant que vous ne l’apprenez pas de plusieurs manières. -Marvin Minsky"
    },
    "2024-03-18": {
        "content": " Dis-moi et j'oublie, enseigne-moi et je me souviendrai, implique-moi et j'apprends. -Benjamin Franklin"
    },
    "2024-03-19": {
        "content": " Si vous voulez augmenter votre taux de réussite, doublez votre taux d’échec. -Thomas J. Watson"
    },
    "2024-03-20": {
        "content": " L'intelligence est ce que vous utilisez lorsque vous ne savez pas quoi faire. -Jean Piaget"
    },
    "2024-03-21": {
        "content": " Les analphabètes du XXIe siècle ne seront pas ceux qui ne savent ni lire ni écrire, mais ceux qui ne savent pas apprendre, désapprendre et réapprendre. -Alvin Toffler"
    },
    "2024-03-22": {
        "content": "C’est ce que nous savons déjà qui nous empêche souvent d’apprendre. -Claude Bernard"
    },
    "2024-03-23": {
        "content": " Les mathématiques sont le langage avec lequel Dieu a écrit l’univers. -Galileo Galilei"
    },
    "2024-03-24": {
        "content": " Le but de l’éducation est de transformer les miroirs en fenêtres. -Sydney J. Harris"
    },
    "2024-03-25": {
        "content": " Je n’ai pas peur des tempêtes car j’apprends à naviguer sur mon navire. -Louisa May Alcott"
    },
    "2024-03-26": {
        "content": " La seule personne éduquée est celle qui a appris à apprendre et à changer. -Carl R. Rogers"
    },
    "2024-03-27": {
        "content": " Je n’ai jamais rencontré un homme si ignorant que je ne puisse apprendre quelque chose de lui. -Galileo Galilei"
    },
    "2024-03-28": {
        "content": " Rien ne disparaît jamais tant que nous n’avons pas appris ce que nous devons savoir. -Pema Chödrön"
    },
    "2024-03-29": {
        "content": " C'est en forgeant qu'on devient forgeron. Après une longue période de pratique, notre travail deviendra naturel, habile, rapide et régulier. -Bruce Lee"
    },
    "2024-03-30": {
        "content": " Lorsque vous parlez, vous ne faites que répéter ce que vous savez déjà. Mais si vous écoutez, vous pouvez apprendre quelque chose de nouveau. -Dalaï Lama XIV"
    },
    "2024-03-31": {
        "content": " Efforcez-vous d’atteindre le progrès, pas la perfection. -Anonyme"
    },
    "2024-04-01": {
        "content": "Je fais toujours ce que je ne peux pas encore faire, afin d'apprendre à le faire. -Vincent van Gogh"
    },
    "2024-04-02": {
        "content": " La connaissance rend l’homme inapte à être esclave. -Frédéric Douglass"
    },
    "2024-04-03": {
        "content": " J’ai appris très tôt la différence entre connaître le nom de quelque chose et connaître quelque chose. -Richard P. Feynman"
    },
    "2024-04-04": {
        "content": " La capacité d’apprendre est un don ; la capacité d’apprendre est une compétence ; la volonté d’apprendre est un choix. -Brian Herbert"
    },
    "2024-04-05": {
        "content": " Apprenez tout ce que vous pouvez, à chaque fois que vous le pouvez, de qui vous voulez – il viendra toujours un moment où vous serez reconnaissant de l’avoir fait. -Sarah Caldwell"
    },
    "2024-04-06": {
        "content": " Je n’ai pas une grande opinion d’un homme qui n’est pas plus sage aujourd’hui qu’il ne l’était hier. -Abraham Lincoln"
    },
    "2024-04-07": {
        "content": " La clé du succès réside dans le dévouement à l’apprentissage tout au long de la vie. -Stephen R. Covey"
    },
    "2024-04-08": {
        "content": " Soyez passionné et audacieux. Continuez à apprendre. Vous ne ferez rien d'utile si vous n'apprenez pas. -Satya Nadella"
    },
    "2024-04-09": {
        "content": "L’activité la plus élevée qu’un être humain puisse atteindre est d’apprendre pour comprendre, car comprendre, c’est être libre. -Baruch Spinoza"
    },
    "2024-04-10": {
        "content": " Si vous n'apprenez pas continuellement, les autres vous dépasseront. Le tempérament seul ne suffit pas : il faut beaucoup de curiosité et une très longue durée. -Charlie Munger"
    },
    "2024-04-11": {
        "content": " Une organisation apprenante est une organisation qui développe continuellement sa capacité à créer son avenir. -Pierre Senge"
    },
    "2024-04-12": {
        "content": " Le jour où vous arrêtez d’apprendre est le jour où vous commencez à vous dégrader. -Isaac Asimov"
    },
    "2024-04-13": {
        "content": " L’apprentissage est un ornement dans la prospérité, un refuge dans l’adversité et une provision dans la vieillesse. -Aristote"
    },
    "2024-04-14": {
        "content": " Tous les leaders sont des apprenants. Dès qu'on cesse d'apprendre, on cesse de diriger. J'apprends autant que possible, du plus grand nombre et aussi souvent que possible. -Rick Warren"
    },
    "2024-04-15": {
        "content": " Pour apprendre rapidement des choses difficiles, il faut se concentrer intensément, sans distraction. Apprendre, en d'autres termes, est un travail en profondeur. -Cal Newport"
    },
    "2024-04-16": {
        "content": " N'importe quel imbécile peut savoir. L'important est de comprendre. -Albert Einstein"
    },
    "2024-04-17": {
        "content": "Passez chaque jour à essayer d’être un peu plus sage que vous ne l’étiez à votre réveil. -Charlie Munger"
    },
    "2024-04-18": {
        "content": " Investissez en vous-même, dans votre éducation. Il n'y a rien de mieux. -Sylvia Porter"
    },
    "2024-04-19": {
        "content": " L’auto-éducation est pour moi une source continue de plaisir, car plus j’en sais, plus ma vie est épanouie et plus j’apprécie ma propre existence. -Isaac Asimov"
    },
    "2024-04-20": {
        "content": " Vous pouvez obtenir de l’aide de la part des professeurs, mais vous allez devoir apprendre beaucoup de choses par vous-même, assis seul dans une pièce. -Dr Seuss"
    },
    "2024-04-21": {
        "content": " L’apprentissage se produit lorsque quelqu’un veut apprendre, pas lorsque quelqu’un veut enseigner. -Roger Schank"
    },
    "2024-04-22": {
        "content": " Une personne ne peut pas enseigner directement à une autre personne ; elle ne peut que faciliter l’apprentissage d’une autre personne. -Carl R. Rogers"
    },
    "2024-04-23": {
        "content": " Apprendre n'est pas obligatoire, c'est volontaire. S'améliorer n'est pas obligatoire, c'est volontaire. Mais pour survivre, nous devons apprendre. -W. Edwards Deming"
    },
    "2024-04-24": {
        "content": " Je fais toujours ce que je ne peux pas faire, afin d’apprendre à le faire. -Pablo Picasso"
    },
    "2024-04-25": {
        "content": "Aucun voleur, aussi habile soit-il, ne peut voler la connaissance à quelqu'un, et c'est pourquoi la connaissance est le trésor le meilleur et le plus sûr à acquérir. -L. Frank Baum"
    },
    "2024-04-26": {
        "content": " Je pense que c’est le meilleur conseil : pensez constamment à la façon dont vous pourriez faire les choses mieux et remettez-vous en question. -Elon Musk"
    },
    "2024-04-27": {
        "content": " Un homme sage peut apprendre plus d’une question stupide qu’un imbécile peut apprendre d’une réponse sage. -Bruce Lee"
    },
    "2024-04-28": {
        "content": " Si j'ai vu plus loin, c'est en me tenant sur les épaules des Géants. -Isaac Newton"
    },
    "2024-04-29": {
        "content": " Ce que nous connaissons est une goutte, ce que nous ne connaissons pas est un océan. -Isaac Newton"
    },
    "2024-04-30": {
        "content": " Ce qui est bien avec l’apprentissage, c’est que personne ne peut vous l’enlever. -BB King"
    },
    "2024-05-01": {
        "content": " Si vous voulez devenir écrivain, vous devez faire deux choses avant tout : lire beaucoup et écrire beaucoup. -Stephen King"
    },
    "2024-05-02": {
        "content": " La répétition est la mère de la compétence. -Tony Robbins"
    },
    "2024-05-03": {
        "content": " L’émerveillement est le début de la sagesse. -Socrate"
    },
    "2024-05-04": {
        "content": " Si vous faites une erreur et ne la corrigez pas, cela s’appelle une erreur. -Confucius"
    },
    "2024-05-05": {
        "content": " Le but de l’éducation est de remplacer un esprit vide par un esprit ouvert. -Malcolm S. Forbes"
    },
    "2024-05-06": {
        "content": "Dans la vie, rien n'est à craindre, il faut simplement le comprendre. Il est temps de mieux comprendre, afin d'avoir moins peur. -Marie Curie"
    },
    "2024-05-07": {
        "content": " Lorsqu'on vous demande si vous êtes capable d'effectuer un travail, répondez : « Bien sûr que je peux ! ». Ensuite, mettez-vous au travail et découvrez comment le faire. -Théodore Roosevelt"
    },
    "2024-05-08": {
        "content": " Nous avons tous besoin de commentaires. C'est ainsi que nous progressons. -Bill Gates"
    },
    "2024-05-09": {
        "content": " L’éducation est la clé pour ouvrir le monde, un passeport pour la liberté. -Oprah Winfrey"
    },
    "2024-05-10": {
        "content": " Tout commence par une idée. -Comte Nightingale"
    },
    "2024-05-11": {
        "content": " Le meilleur investissement que vous puissiez faire est en vous-même. -Warren Buffett"
    },
    "2024-05-12": {
        "content": " Ce n'est pas une question d'argent ou de relations. C'est la volonté de travailler et d'apprendre mieux que tout le monde. -Mark Cuban"
    },
    "2024-05-13": {
        "content": " Tant que tu vivras, continue à apprendre à vivre. -Sénèque"
    },
    "2024-05-14": {
        "content": " Pour apprendre à réussir, il faut d’abord apprendre à échouer. -Michael Jordan"
    },
    "2024-05-15": {
        "content": " Ne gâchez pas une bonne erreur, apprenez-en. -Robert T. Kiyosaki"
    },
    "2024-05-16": {
        "content": "Pour acquérir la connaissance, il faut étudier ; mais pour acquérir la sagesse, il faut observer. -Marilyn Vos Savant"
    },
    "2024-05-17": {
        "content": " On vit et on apprend. En tout cas, on vit. -Douglas Adams"
    },
    "2024-05-18": {
        "content": " La patience est la compagne de la sagesse. -Saint Augustin"
    },
    "2024-05-19": {
        "content": " Je ne sais qu'une chose, c'est que je ne sais rien. -Socrate"
    },
    "2024-05-20": {
        "content": " La sagesse vient de l'expérience. L'expérience est souvent le résultat d'un manque de sagesse. -Terry Pratchett"
    },
    "2024-05-21": {
        "content": " Nous pouvons juger nos progrès par le courage de nos questions et la profondeur de nos réponses, notre volonté d’accepter ce qui est vrai plutôt que ce qui nous fait du bien. -Carl Sagan"
    },
    "2024-05-22": {
        "content": " Je préfère avoir des questions auxquelles on ne peut pas répondre plutôt que des réponses qu'on ne peut pas remettre en question. -Richard P. Feynman"
    },
    "2024-05-23": {
        "content": " Je suis toujours prêt à apprendre même si je n'aime pas toujours qu'on me enseigne. -Winston Churchill"
    },
    "2024-05-24": {
        "content": " Celui qui aime la pratique sans théorie est comme le marin qui monte à bord d'un navire sans gouvernail ni boussole et ne sait jamais où il peut jeter son dévolu. -Léonard de Vinci"
    },
    "2024-05-25": {
        "content": " Il vaut mieux créer qu'apprendre. Créer est l'essence même de la vie. -Jules César"
    },
    "2024-05-26": {
        "content": "Ce que fait la main, l'esprit s'en souvient. -Maria Montessori"
    },
    "2024-05-27": {
        "content": " Avancez toujours dans la vie comme si vous aviez quelque chose de nouveau à apprendre, et vous l’apprendrez. -Vernon Howard"
    },
    "2024-05-28": {
        "content": " L’échec est un succès si nous en tirons des leçons. -Malcolm S. Forbes"
    },
    "2024-05-29": {
        "content": " L'éducation est notre meilleure amie. Une personne instruite est respectée partout. L'éducation surpasse la beauté et la jeunesse. -Chanakya"
    },
    "2024-05-30": {
        "content": " Ne pensez pas que ce qui est difficile à maîtriser pour vous est humainement impossible ; mais si une chose est humainement possible, considérez-la comme étant à votre portée. -Marc Aurèle"
    },
    "2024-05-31": {
        "content": " L’apprentissage est un processus constant de découverte – un processus sans fin. -Bruce Lee"
    },
    "2024-06-01": {
        "content": " Être ignorant n’est pas tant une honte que de ne pas vouloir apprendre. -Benjamin Franklin"
    },
    "2024-06-02": {
        "content": " Je suis convaincu que la connaissance est un pouvoir – pour surmonter le passé, pour changer nos propres situations, pour combattre de nouveaux obstacles, pour prendre de meilleures décisions. -Ben Carson"
    },
    "2024-06-03": {
        "content": " En inspirant, j'apaise mon corps et mon esprit. En expirant, je souris. En vivant l'instant présent, je sais que c'est le seul moment. -Thich Nhat Hanh"
    },
    "2024-06-04": {
        "content": "Si vous pensez que vous êtes trop petit pour faire la différence, essayez de dormir avec un moustique. -Dalaï Lama XIV"
    },
    "2024-06-05": {
        "content": " Trop souvent, nous sous-estimons le pouvoir d’un contact, d’un sourire, d’un mot gentil, d’une oreille attentive, d’un compliment honnête ou du plus petit acte d’attention, qui ont tous le potentiel de changer une vie. -Léo Buscaglia"
    },
    "2024-06-06": {
        "content": " La façon dont nous passons nos journées est, bien sûr, la façon dont nous passons nos vies. -Annie Dillard"
    },
    "2024-06-07": {
        "content": " Nourrissez votre esprit de grandes pensées, car vous n’irez jamais plus haut que vous ne le pensez. -Benjamin Disraeli"
    },
    "2024-06-08": {
        "content": " On n'apprend pas à marcher en suivant des règles. On apprend en faisant et en tombant. -Richard Branson"
    },
    "2024-06-09": {
        "content": " Il est impossible de vivre sans échouer à quelque chose, à moins que vous ne viviez avec tant de prudence que vous auriez tout aussi bien pu ne pas vivre du tout, auquel cas vous échouez par défaut. -J.K. Rowling"
    },
    "2024-06-10": {
        "content": " Si tu veux être heureux, sois-le. -Léon Tolstoï"
    },
    "2024-06-11": {
        "content": " Personne ne peut me faire de mal sans ma permission. -Mahatma Gandhi"
    },
    "2024-06-12": {
        "content": " Quand je lâche prise sur ce que je suis, je deviens ce que je pourrais être. -Lao Tseu"
    },
    "2024-06-13": {
        "content": "La raison pour laquelle nous luttons contre l’insécurité est que nous comparons nos coulisses avec les moments forts de tout le monde. -Steven Furtick"
    },
    "2024-06-14": {
        "content": " N'oubliez pas qu'aujourd'hui est le lendemain dont vous vous inquiétiez hier. -Dale Carnegie"
    },
    "2024-06-15": {
        "content": " Nous devons être prêts à abandonner la vie que nous avions planifiée afin d’avoir la vie qui nous attend. -Joseph Campbell"
    },
    "2024-06-16": {
        "content": " Arrête de partir et tu arriveras. Arrête de chercher et tu verras. Arrête de fuir et on te trouvera. -Lao Tseu"
    },
    "2024-06-17": {
        "content": " Une équipe n'est pas un groupe de personnes qui travaillent ensemble. Une équipe est un groupe de personnes qui se font confiance. -Simon Sinek"
    },
    "2024-06-18": {
        "content": " L’optimisme perpétuel est un multiplicateur de force. -Colin Powell"
    },
    "2024-06-19": {
        "content": " Lorsque vous vous contentez d'être simplement vous-même et que vous ne comparez pas ou ne rivalisez pas, tout le monde vous respectera. -Lao Tseu"
    },
    "2024-06-20": {
        "content": " Comptez votre âge en amis, pas en années. Comptez votre vie en sourires, pas en larmes. -John Lennon"
    },
    "2024-06-21": {
        "content": " Donnez à ceux que vous aimez des ailes pour voler, des racines pour revenir et des raisons de rester. -Dalaï Lama XIV"
    },
    "2024-06-22": {
        "content": " La persévérance et l’esprit ont fait des merveilles à toutes les époques. -George Washington"
    },
    "2024-06-23": {
        "content": "Partagez vos connaissances. C'est un moyen d'atteindre l'immortalité. -Dalaï Lama XIV"
    },
    "2024-06-24": {
        "content": " Nous sommes un moyen pour le cosmos de se connaître lui-même. -Carl Sagan"
    },
    "2024-06-25": {
        "content": " Un bon enseignant peut inspirer l’espoir, stimuler l’imagination et inculquer l’amour de l’apprentissage. -Brad Henry"
    },
    "2024-06-26": {
        "content": " L’une des plus grandes découvertes qu’une personne fasse, l’une de ses grandes surprises, est de découvrir qu’elle peut faire ce qu’elle craignait de ne pas pouvoir faire. -Henry Ford"
    },
    "2024-06-27": {
        "content": " À quand remonte la dernière fois où vous avez fait quelque chose pour la première fois ? -John C. Maxwell"
    },
    "2024-06-28": {
        "content": " Si vous n’êtes pas en train de devenir la personne que vous voulez être, vous êtes automatiquement en train de devenir la personne que vous ne voulez pas être. -Dale Carnegie"
    },
    "2024-06-29": {
        "content": " La fortune favorise les audacieux. -Proverbe latin"
    },
    "2024-06-30": {
        "content": " Le succès n'est pas la clé du bonheur. Le bonheur est la clé du succès. Si vous aimez ce que vous faites, vous réussirez. -Albert Schweitzer"
    },
    "2024-07-01": {
        "content": " Ne gagnez pas le monde si vous perdez votre âme ; la sagesse vaut mieux que l'argent ou l'or. -Bob Marley"
    },
    "2024-07-02": {
        "content": " Commencez dès maintenant à vivre et comptez chaque jour comme une vie distincte. -Sénèque"
    },
    "2024-07-03": {
        "content": "À moins que quelqu'un comme vous ne s'en soucie vraiment, rien ne s'améliorera. Ce n'est pas le cas. -Dr Seuss"
    },
    "2024-07-04": {
        "content": " Ils ne savaient pas que c'était impossible alors ils l'ont fait. -Mark Twain"
    },
    "2024-07-05": {
        "content": " Je peux faire des choses que tu ne peux pas faire, tu peux faire des choses que je ne peux pas faire ; ensemble nous pouvons faire de grandes choses. -Mère Teresa"
    },
    "2024-07-06": {
        "content": " La seule chose que nous devons craindre, c’est la peur elle-même. -Franklin D. Roosevelt"
    },
    "2024-07-07": {
        "content": " Rien de grand n’a jamais été accompli sans enthousiasme. -Ralph Waldo Emerson"
    },
    "2024-07-08": {
        "content": " Courage, cher cœur. -CS Lewis"
    },
    "2024-07-09": {
        "content": " La seule façon de donner un sens au changement est de s’y plonger, de bouger avec lui et de rejoindre la danse. -Alan Watts"
    },
    "2024-07-10": {
        "content": " Là où l’attention se porte, l’énergie circule et les résultats se voient. -T. Harv Eker"
    },
    "2024-07-11": {
        "content": " La douleur est temporaire. Elle peut durer une minute, une heure, un jour, voire un an, mais elle finira par s'atténuer et quelque chose d'autre la remplacera. Si j'arrête, en revanche, elle durera éternellement. -Lance Armstrong"
    },
    "2024-07-12": {
        "content": " À chaque promenade dans la nature, on reçoit bien plus que ce que l’on recherche. -John Muir"
    },
    "2024-07-13": {
        "content": "Les gagnants ne sont pas ceux qui n’échouent jamais, mais ceux qui n’abandonnent jamais. -Edwin Louis Cole"
    },
    "2024-07-14": {
        "content": " Au lieu de combattre les ténèbres, vous faites entrer la lumière. -Eckhart Tolle"
    },
    "2024-07-15": {
        "content": " Soyez sans peur dans la poursuite de ce qui enflamme votre âme. -Jennifer Lee"
    },
    "2024-07-16": {
        "content": " Quand les gens vous quittent, laissez-les partir. Votre destin n'est jamais lié à ceux qui vous quittent, et cela ne signifie pas que ce sont de mauvaises personnes. Cela signifie simplement que leur rôle dans votre histoire est terminé. -TD Jakes"
    },
    "2024-07-17": {
        "content": " Le leadership est la capacité de traduire une vision en réalité. -Warren G. Bennis"
    },
    "2024-07-18": {
        "content": " La foi, c'est croire ce que l'on ne voit pas ; la récompense de cette foi, c'est de voir ce que l'on croit. -Saint Augustin"
    },
    "2024-07-19": {
        "content": " Rien n’est impossible à moins que vous ne le pensiez. -Paramahansa Yogananda"
    },
    "2024-07-20": {
        "content": " La seule chose pire que d’être aveugle, c’est d’avoir la vue mais pas de vision. -Hélène Keller"
    },
    "2024-07-21": {
        "content": " Tout a sa beauté, mais tout le monde ne la voit pas. -Confucius"
    },
    "2024-07-22": {
        "content": " Dieu parle dans le silence du cœur. -Mère Teresa"
    },
    "2024-07-23": {
        "content": "L'espoir est cette chose avec des plumes qui se perche dans l'âme - et chante la mélodie sans les paroles - et ne s'arrête jamais du tout. -Emily Dickinson"
    },
    "2024-07-24": {
        "content": " Peu importe le nombre de paroles saintes que vous lisez, peu importe le nombre de paroles que vous prononcez, à quoi vous serviront-elles si vous ne les mettez pas en pratique ? -Bouddha"
    },
    "2024-07-25": {
        "content": " Et d'ailleurs, tout dans la vie est inscriptible si l'on a le courage de le faire et l'imagination nécessaire pour improviser. Le pire ennemi de la créativité, c'est le doute de soi. -Sylvia Plath"
    },
    "2024-07-26": {
        "content": " Rien de ce que nous faisons ne peut changer le passé, mais tout ce que nous faisons change l’avenir. -Ashleigh Brilliant"
    },
    "2024-07-27": {
        "content": " Le leadership est un choix, pas un grade. -Simon Sinek"
    },
    "2024-07-28": {
        "content": " Tout ira bien, tout ira bien et toutes sortes de choses iront bien. -Julien de Norwich"
    },
    "2024-07-29": {
        "content": " Chacun de nous est précieux, du point de vue cosmique. Si un humain n'est pas d'accord avec vous, laissez-le vivre. Dans cent milliards de galaxies, vous n'en trouverez pas d'autre. -Carl Sagan"
    },
    "2024-07-30": {
        "content": " L’intelligence et le caractère : tel est le but de la véritable éducation. -Martin Luther King Jr."
    },
    "2024-07-31": {
        "content": "Plus vous vous perdez dans quelque chose de plus grand que vous, plus vous aurez d’énergie. -Norman Vincent Peale"
    },
    "2024-08-01": {
        "content": " Maîtrisez les fondamentaux et le niveau de tout ce que vous faites augmentera -Michael Jordan"
    },
    "2024-08-02": {
        "content": " Vous ne pouvez pas vivre du tout si vous ne pouvez pas vivre pleinement maintenant. -Alan Watts"
    },
    "2024-08-03": {
        "content": " N’oubliez pas que parfois, ne pas obtenir ce que vous voulez est un merveilleux coup de chance. -Dalaï Lama XIV"
    },
    "2024-08-04": {
        "content": " Faites de votre mieux, puis détendez-vous. Laissez les choses suivre leur cours naturel, plutôt que de les forcer. -Paramahansa Yogananda"
    },
    "2024-08-05": {
        "content": " Vous êtes un être spirituel infini vivant une expérience humaine temporaire. -Wayne W. Dyer"
    },
    "2024-08-06": {
        "content": " Il faut rêver avant que vos rêves puissent se réaliser. -Abdul Kalam"
    },
    "2024-08-07": {
        "content": " Par-dessus tout, garde ton cœur, car tout ce que tu fais découle de lui. -Salomon"
    },
    "2024-08-08": {
        "content": " Je peux tout secouer en écrivant ; mes chagrins disparaissent, mon courage renaît. -Anne Frank"
    },
    "2024-08-09": {
        "content": " L'objectif n'est pas d'être parfait à la fin, mais d'être meilleur aujourd'hui. -Simon Sinek"
    },
    "2024-08-10": {
        "content": " Avancez avec confiance vers vos rêves. Vivez la vie que vous avez imaginée. -Henry David Thoreau"
    },
    "2024-08-11": {
        "content": "Soyez gentil autant que possible. C'est toujours possible. -Dalaï Lama XIV"
    },
    "2024-08-12": {
        "content": " Notre but premier dans la vie est d'aider les autres. Et si vous ne pouvez pas les aider, au moins ne leur faites pas de mal. -Dalaï Lama XIV"
    },
    "2024-08-13": {
        "content": " Tu as un cerveau dans la tête. Tu as les pieds dans les chaussures. Tu peux te diriger dans la direction que tu veux. Tu es seul. Et tu sais ce que tu sais. Et c'est toi qui décides où aller. -Dr Seuss"
    },
    "2024-08-14": {
        "content": " Ce sur quoi vous vous concentrez s’étend, et lorsque vous vous concentrez sur la bonté dans votre vie, vous en créez davantage. -Oprah Winfrey"
    },
    "2024-08-15": {
        "content": " Tout ce que j'ai besoin de savoir m'est révélé. Tout ce dont j'ai besoin vient à moi. Tout va bien dans ma vie. -Louise Hay"
    },
    "2024-08-16": {
        "content": " Je suis en parfaite sécurité dans l'Univers. Je suis en paix partout. J'ai confiance en la vie. -Louise Hay"
    },
    "2024-08-17": {
        "content": " Tournez votre visage vers le soleil et les ombres tombent derrière vous. -Proverbe maori"
    },
    "2024-08-18": {
        "content": " Le courage ne consiste pas à avoir la force de continuer, mais à continuer quand on n'en a pas la force. -Théodore Roosevelt"
    },
    "2024-08-19": {
        "content": " L’avenir dépend de ce que vous faites aujourd’hui. -Mahatma Gandhi"
    },
    "2024-08-20": {
        "content": " Un gagnant est un rêveur qui n’abandonne jamais. -Nelson Mandela"
    },
    "2024-08-21": {
        "content": "Ne pleurez pas parce que c'est fini, souriez parce que c'est arrivé. -Dr Seuss"
    },
    "2024-08-22": {
        "content": " En trois mots, je peux résumer tout ce que j'ai appris sur la vie : elle continue. -Robert Frost"
    },
    "2024-08-23": {
        "content": " Vivez selon votre imagination, pas selon votre histoire. -Stephen R. Covey"
    },
    "2024-08-24": {
        "content": " À mon avis, si vous voulez l’arc-en-ciel, vous devez supporter la pluie. -Dolly Parton"
    },
    "2024-08-25": {
        "content": " La grandeur d’un homme ne réside pas dans la quantité de richesses qu’il acquiert, mais dans son intégrité et sa capacité à influencer positivement ceux qui l’entourent. -Bob Marley"
    },
    "2024-08-26": {
        "content": " Le bonheur vient principalement de notre propre attitude, plutôt que de facteurs externes. -Dalaï Lama XIV"
    },
    "2024-08-27": {
        "content": " Les grands actes sont constitués de petits actes. -Lao Tseu"
    },
    "2024-08-28": {
        "content": " Il n’est jamais trop tard pour être ce que vous auriez pu être. -George Eliot"
    },
    "2024-08-29": {
        "content": " Adopter la bonne attitude peut transformer un stress négatif en un stress positif. -Hans Selye"
    },
    "2024-08-30": {
        "content": " Osez vivre la vie dont vous rêvez. Allez de l'avant et réalisez vos rêves. -Ralph Waldo Emerson"
    },
    "2024-08-31": {
        "content": " Le temps que vous aimez perdre n’est pas du temps perdu. -Bertrand Russell"
    },
    "2024-09-01": {
        "content": "Il suffit d’un peu de vigilance pour voir et découvrir : la vie est en réalité un grand rire cosmique. -Osho"
    },
    "2024-09-02": {
        "content": " Le paradoxe curieux est que lorsque je m’accepte tel que je suis, alors je peux changer. -Carl R. Rogers"
    },
    "2024-09-03": {
        "content": " Faites partie de la solution, pas du problème. -Stephen R. Covey"
    },
    "2024-09-04": {
        "content": " Le secret de la vie est de donner. -Tony Robbins"
    },
    "2024-09-05": {
        "content": " Faites de chaque jour votre chef-d'œuvre. -John Wooden"
    },
    "2024-09-06": {
        "content": " N'abandonnez jamais ce que vous voulez vraiment faire -H. Jackson Brown Jr."
    },
    "2024-09-07": {
        "content": " Ne regarde pas en arrière, tu n’iras pas dans cette direction. -Mary Engelbreit"
    },
    "2024-09-08": {
        "content": " Faites de votre mieux et Dieu fera le reste. -Nick Vujicic"
    },
    "2024-09-09": {
        "content": " Vivez, voyagez, partez à l'aventure, bénissez et ne soyez pas désolé. -Jack Kerouac"
    },
    "2024-09-10": {
        "content": " Au cœur de l'hiver, j'ai découvert qu'il y avait, en moi, un été invincible. Et cela me rend heureuse. Car cela signifie que, quelle que soit la pression exercée par le monde sur moi, il y a en moi quelque chose de plus fort, quelque chose de meilleur, qui me repousse. -Albert Camus"
    },
    "2024-09-11": {
        "content": "Certains pensent que seule une grande puissance peut contenir le mal, mais ce n'est pas ce que j'ai constaté. Ce sont les petits gestes quotidiens des gens ordinaires qui tiennent les ténèbres à distance. De petits gestes de bonté et d'amour. -JRR Tolkien"
    },
    "2024-09-12": {
        "content": " Soyez fidèle dans les petites choses, car c’est en elles que réside votre force. -Mère Teresa"
    },
    "2024-09-13": {
        "content": " Faites de vous une lumière. -Bouddha"
    },
    "2024-09-14": {
        "content": " VISUALISER ! Voyez, ressentez ! C'est ici que l'action commence. -Rhonda Byrne"
    },
    "2024-09-15": {
        "content": " Soyez phénoménal ou soyez oublié ! -Éric Thomas"
    },
    "2024-09-16": {
        "content": " Lorsque vous avez le choix d’avoir raison ou d’être gentil, choisissez d’être gentil. -Wayne W. Dyer"
    },
    "2024-09-17": {
        "content": " Les êtres humains peuvent changer leur vie en modifiant leurs attitudes mentales. -William James"
    },
    "2024-09-18": {
        "content": " La santé est le plus grand bien. -Laozi"
    },
    "2024-09-19": {
        "content": " Que je ne prie pas pour être à l'abri des dangers, mais pour les affronter sans crainte. Que je ne supplie pas pour apaiser ma douleur, mais pour que mon cœur la surmonte. -Rabindranath Tagore"
    },
    "2024-09-20": {
        "content": " Ayez à cœur de faire le bien. Répétez-le encore et encore, et vous serez rempli de joie. -Bouddha"
    },
    "2024-09-21": {
        "content": "Je ne peux pas changer le monde à moi seul, mais je peux jeter une pierre sur les eaux pour créer de nombreuses ondulations. -Mère Teresa"
    },
    "2024-09-22": {
        "content": " Et le jour est venu où le risque de rester enfermé dans un bourgeon était plus douloureux que le risque de fleurir. -Anaïs Nin"
    },
    "2024-09-23": {
        "content": " L'effort humain ne devrait connaître aucune limite. Aussi difficile que puisse paraître la vie, il y a toujours de l'espoir. -Stephen Hawking"
    },
    "2024-09-24": {
        "content": " Et je vous exhorte à remarquer quand vous êtes heureux, et à vous exclamer, à murmurer ou à penser à un moment donné : « Si ce n'est pas agréable, je ne sais pas ce que c'est. » -Kurt Vonnegut"
    },
    "2024-09-25": {
        "content": " C'est votre réaction à l'adversité, et non l'adversité elle-même, qui détermine la manière dont l'histoire de votre vie se développera. -Dieter F. Uchtdorf"
    },
    "2024-09-26": {
        "content": " Ce n'est pas ce que vous avez, qui vous êtes, où vous êtes ou ce que vous faites qui vous rend heureux ou malheureux. C'est ce que vous en pensez. -Dale Carnegie"
    },
    "2024-09-27": {
        "content": " Plus vous lirez, plus vous saurez. Plus vous apprendrez, plus vous visiterez de lieux. -Dr Seuss"
    },
    "2024-09-28": {
        "content": " Tous nos rêves peuvent devenir réalité. -Walt Disney"
    },
    "2024-09-29": {
        "content": "Le privilège d’une vie est d’être qui vous êtes. -Joseph Campbell"
    },
    "2024-09-30": {
        "content": " Personne n’est inutile dans ce monde s’il allège le fardeau d’un autre. -Charles Dickens"
    },
    "2024-10-01": {
        "content": " Trouvez un endroit à l'intérieur où il y a de la joie, et la joie brûlera la douleur. -Joseph Campbell"
    },
    "2024-10-02": {
        "content": " Ne demandez pas ce dont le monde a besoin. Demandez-vous ce qui vous anime et faites-le. Car ce dont le monde a besoin, c'est de plus de personnes qui s'épanouissent. -Howard Thurman"
    },
    "2024-10-03": {
        "content": " Vos sentiments sont vos meilleurs outils pour vous aider à créer votre vie. -Rhonda Byrne"
    },
    "2024-10-04": {
        "content": " Je mérite le meilleur et j'accepte le meilleur maintenant. -Louise Hay"
    },
    "2024-10-05": {
        "content": " Ce n’est pas la quantité que nous donnons qui compte, mais l’amour que nous mettons dans ce don. -Mère Teresa"
    },
    "2024-10-06": {
        "content": " Quand vous voulez réussir autant que vous voulez respirer, alors vous réussirez. -Éric Thomas"
    },
    "2024-10-07": {
        "content": " J'ai détesté chaque minute d'entraînement, mais je me suis dit : « N'abandonne pas. Souffre maintenant et vis le reste de ta vie comme un champion. » -Muhammad Ali"
    },
    "2024-10-08": {
        "content": "Ce n'est pas le critique qui compte, ni celui qui souligne les trébuchements de l'homme fort ou la manière dont l'auteur aurait pu faire mieux. Le mérite revient à l'homme qui est réellement dans l'arène, dont le visage est couvert de sueur, de poussière et de sang ; qui lutte vaillamment ; qui commet des erreurs et échoue encore et encore ; qui connaît les grands enthousiasmes, les grands dévouements, et se dépense pour une noble cause ; qui, s'il gagne, connaît le triomphe d'une grande réussite ; et qui, s'il échoue, échoue au moins en osant beaucoup, de sorte que sa place ne sera jamais parmi ces âmes froides et timides qui ne connaissent ni victoire ni défaite. -Théodore Roosevelt"
    },
    "2024-10-09": {
        "content": " La plus grande aventure que vous puissiez vivre est de vivre la vie de vos rêves. -Oprah Winfrey"
    },
    "2024-10-10": {
        "content": " Sans lutte, il ne peut y avoir de progrès. -Frédéric Douglass"
    },
    "2024-10-11": {
        "content": " Un rêve écrit avec une date devient un objectif. Un objectif décomposé en étapes devient un plan. Un plan suivi d'actions permet à vos rêves de se réaliser. -Greg Reid"
    },
    "2024-10-12": {
        "content": "Faites la seule chose que vous pensez ne pas pouvoir faire. Échouez. Réessayez. Faites mieux la deuxième fois. Les seules personnes qui ne tombent jamais sont celles qui ne montent jamais sur le fil. -Oprah Winfrey"
    },
    "2024-10-13": {
        "content": " Attendez-vous au changement. Analysez le paysage. Saisissez les opportunités. Cessez d'être la pièce d'échecs ; devenez le joueur. À vous de jouer. -Tony Robbins"
    },
    "2024-10-14": {
        "content": " Tu es libre. Tu es puissant. Tu es bon. Tu es amour. Tu as de la valeur. Tu as un but. Tout va bien. -Esther Hicks"
    },
    "2024-10-15": {
        "content": "Si vous désirez une chose au point de vous battre pour elle, de travailler jour et nuit pour elle, de donner votre temps, votre paix et votre sommeil pour elle. Si tout ce dont vous rêvez et planifiez ne concerne que cela et que la vie semble inutile et sans valeur sans cela ; Si vous transpirez, vous inquiétez et planifiez volontiers pour cela et perdez toute votre terreur de l'opposition pour cela ; Si vous poursuivez simplement cette chose que vous voulez avec toute votre capacité, votre force et votre sagacité, votre foi, votre espoir et votre confiance et votre ténacité pour la ténacité ; Si ni le froid ni la pauvreté, la famine ni la goutte, la maladie ni la douleur du corps et de l'esprit ne peuvent vous éloigner de la chose que vous voulez ; Si vous êtes obstiné et sinistre, vous la taillez et l'engendrez, avec l'aide de DIEU vous l'obtiendrez. -Berton Braley"
    },
    "2024-10-16": {
        "content": " Même si vous êtes sur la bonne voie, vous serez renversé si vous restez assis là. -Will Rogers"
    },
    "2024-10-17": {
        "content": " Je pense qu’il est possible pour les gens ordinaires de choisir d’être extraordinaires. -Elon Musk"
    },
    "2024-10-18": {
        "content": " On n'apprend pas à marcher en suivant des règles. On apprend en faisant et en tombant. -Richard Branson"
    },
    "2024-10-19": {
        "content": "Il n'y a pas de talent ici, c'est du travail acharné. C'est une obsession. Le talent n'existe pas, nous sommes tous égaux en tant qu'êtres humains. Tu peux devenir qui tu veux si tu y mets du temps. Tu atteindras le sommet, un point c'est tout. Je n'ai pas de talent, je suis obsédé. -Conor McGregor"
    },
    "2024-10-20": {
        "content": " Un rêve n’est pas ce que vous voyez pendant votre sommeil ; c’est quelque chose qui vous empêche de dormir. -Abdul Kalam"
    },
    "2024-10-21": {
        "content": " Lorsque vous avez épuisé toutes les possibilités, rappelez-vous ceci : vous ne l'avez pas fait. -Thomas A. Edison"
    },
    "2024-10-22": {
        "content": " Prenez des risques, faites des erreurs. C'est ainsi que l'on grandit. La douleur nourrit votre courage. Il faut échouer pour s'exercer au courage. -Mary Tyler Moore"
    },
    "2024-10-23": {
        "content": " Ce sur quoi vous vous concentrez, c'est ce que vous obtenez. -Tony Robbins"
    },
    "2024-10-24": {
        "content": " Hustle est le mot le plus important de TOUS LES TEMPS. -Gary Vaynerchuk"
    },
    "2024-10-25": {
        "content": " S'ils peuvent fabriquer de la pénicilline à partir de pain moisi, alors ils peuvent certainement faire quelque chose de vous. -Muhammad Ali"
    },
    "2024-10-26": {
        "content": " Vous n'êtes pas né gagnant, ni perdant. Vous êtes ce que vous décidez d'être. -Lou Holtz"
    },
    "2024-10-27": {
        "content": " Le succès est votre devoir, votre obligation et votre responsabilité. -Grant Cardone"
    },
    "2024-10-28": {
        "content": "Il y a peu de différences entre les gens, mais cette petite différence fait une grande différence. Cette petite différence réside dans l'attitude. La grande différence réside dans son caractère positif ou négatif. -W. Clément Stone"
    },
    "2024-10-29": {
        "content": " Les dirigeants doivent être suffisamment proches des autres pour établir des relations, mais suffisamment en avance pour les motiver. -John C. Maxwell"
    },
    "2024-10-30": {
        "content": " Il ne faut jamais dire jamais, car les limites, comme les peurs, ne sont souvent qu’une illusion. -Michael Jordan"
    },
    "2024-10-31": {
        "content": " Vous devez attendre de grandes choses de vous-même avant de pouvoir les réaliser. -Michael Jordan"
    },
    "2024-11-01": {
        "content": " Dans le monde des affaires, les personnes qui réussissent le mieux sont celles qui font ce qu’elles aiment. -Warren Buffett"
    },
    "2024-11-02": {
        "content": " L’action détruira votre procrastination. -Og Mandino"
    },
    "2024-11-03": {
        "content": " L'échec n'est pas une option pour moi. Le succès est tout ce que j'envisage. -Conor McGregor"
    },
    "2024-11-04": {
        "content": " Le succès ne vient pas de ce que vous faites occasionnellement, mais de ce que vous faites régulièrement. -Marie Forleo"
    },
    "2024-11-05": {
        "content": " La confiance et le travail acharné sont les meilleurs remèdes contre l'échec. Ils feront de vous une personne accomplie. -Abdul Kalam"
    },
    "2024-11-06": {
        "content": " Si tu veux briller comme le soleil, brûle d'abord comme le soleil. -Abdul Kalam"
    },
    "2024-11-07": {
        "content": "Pendant que vous faites la fête et vous amusez, quelqu'un travaille dur. Quelqu'un devient plus intelligent et quelqu'un gagne. Souvenez-vous-en. -Arnold Schwarzenegger"
    },
    "2024-11-08": {
        "content": " Si vous faites ce que vous avez toujours fait, vous obtiendrez ce que vous avez toujours obtenu. -Tony Robbins"
    },
    "2024-11-09": {
        "content": " Le progrès est synonyme de bonheur. -Tony Robbins"
    },
    "2024-11-10": {
        "content": " On peut avoir des résultats ou des excuses. Pas les deux. -Arnold Schwarzenegger"
    },
    "2024-11-11": {
        "content": " La discipline est synonyme de liberté. -Jocko Willink"
    },
    "2024-11-12": {
        "content": " Ne vous attardez pas sur ce qui a mal tourné. Concentrez-vous plutôt sur la suite des événements. Consacrez votre énergie à avancer, à trouver la solution. -Denis Waitley"
    },
    "2024-11-13": {
        "content": " Soyez le leader que vous auriez aimé avoir. -Simon Sinek"
    },
    "2024-11-14": {
        "content": " Mon attitude est que si vous me poussez vers quelque chose que vous pensez être une faiblesse, alors je transformerai cette faiblesse perçue en une force. -Michael Jordan"
    },
    "2024-11-15": {
        "content": " Le plus grand danger pour la plupart d’entre nous ne réside pas dans le fait de fixer des objectifs trop élevés et de ne pas les atteindre, mais dans le fait de fixer des objectifs trop bas et d’atteindre notre objectif. -Michel-Ange"
    },
    "2024-11-16": {
        "content": " Tout le monde a un rêve, mais tout le monde n’a pas de motivation. -Éric Thomas"
    },
    "2024-11-17": {
        "content": "On devient leader, on ne naît pas leader. On le devient au prix d'efforts acharnés, prix que chacun de nous doit payer pour atteindre un objectif qui en vaut la peine. -Vince Lombardi"
    },
    "2024-11-18": {
        "content": " Nous avons choisi d'aller sur la Lune cette décennie et de faire le reste. Non pas parce que c'est facile, mais parce que c'est difficile. -John F. Kennedy"
    },
    "2024-11-19": {
        "content": " Le plus beau jour de votre vie et de la mienne est celui où nous assumons pleinement la responsabilité de nos attitudes. C'est le jour où nous grandissons vraiment. -John C. Maxwell"
    },
    "2024-11-20": {
        "content": " Chaque fois que vous souriez à quelqu’un, c’est un acte d’amour, un cadeau fait à cette personne, une belle chose. -Mère Teresa"
    },
    "2024-11-21": {
        "content": " Soyez l'observateur silencieux de vos pensées et de votre comportement. Vous êtes sous le penseur. Vous êtes le calme sous le bruit mental. Vous êtes l'amour et la joie sous la douleur. -Eckhart Tolle"
    },
    "2024-11-22": {
        "content": " Si vous ne pouvez pas voler, courez, si vous ne pouvez pas courir, marchez, si vous ne pouvez pas marcher, rampez, mais quoi que vous fassiez, vous devez continuer à avancer. -Martin Luther King Jr."
    },
    "2024-11-23": {
        "content": " Le pardon n’est pas un acte occasionnel, c’est une attitude constante. -Martin Luther King Jr."
    },
    "2024-11-24": {
        "content": " Trop souvent, nous sous-estimons le pouvoir d’un contact, d’un sourire, d’un mot gentil, d’une oreille attentive, d’un compliment honnête ou du plus petit acte d’attention, qui ont tous le potentiel de changer une vie. -Léo Buscaglia"
    },
    "2024-11-25": {
        "content": "Gardez vos rêves en vie. Comprenez que pour réussir quoi que ce soit, il faut avoir foi en soi, une vision, du travail acharné, de la détermination et du dévouement. N'oubliez pas que tout est possible à ceux qui y croient. -Gail Devers"
    },
    "2024-11-26": {
        "content": " Le sport a le pouvoir de changer le monde. Il a le pouvoir d'inspirer. Il a le pouvoir d'unir les gens comme peu d'autres le font. Il parle aux jeunes dans un langage qu'ils comprennent. Le sport peut créer de l'espoir là où il n'y avait autrefois que désespoir. -Nelson Mandela"
    },
    "2024-11-27": {
        "content": " Demandez ce que vous voulez. Croyez que vous le méritez, et laissez la vie vous l'accorder. -Louise Hay"
    },
    "2024-11-28": {
        "content": " Vivez avec intention. Allez jusqu'au bout. Écoutez attentivement. Pratiquez le bien-être. Jouez avec abandon. Riez. Choisissez sans regret. Appréciez vos amis. Continuez à apprendre. Faites ce que vous aimez. Vivez comme si c'était tout ce qu'il y avait. -Mary Anne Radmacher"
    },
    "2024-11-29": {
        "content": " Ce sur quoi vous vous concentrez s’étend, et lorsque vous vous concentrez sur la bonté dans votre vie, vous en créez davantage. -Oprah Winfrey"
    },
    "2024-11-30": {
        "content": " Vous avez le pouvoir sur votre esprit, et non sur les événements extérieurs. Prenez-en conscience et vous trouverez la force. -Marc Aurèle"
    },
    "2024-12-01": {
        "content": "Ne cherchez pas d'excuses pour ne pas y arriver. Concentrez-vous sur toutes les raisons pour lesquelles vous devez y parvenir. -Ralph Marston"
    },
    "2024-12-02": {
        "content": " Là où il y a de l'amour, il y a de la vie. -Mahatma Gandhi"
    },
    "2024-12-03": {
        "content": " Tu dois danser comme si personne ne te regardait, aimer comme si tu ne souffrirais jamais, chanter comme si personne ne t'écoutait et vivre comme si c'était le paradis sur terre. -William W. Purkey"
    },
    "2024-12-04": {
        "content": " Le succès consiste à connaître votre objectif dans la vie, à grandir pour atteindre votre potentiel maximum et à semer des graines qui profitent aux autres. -John C. Maxwell"
    },
    "2024-12-05": {
        "content": " Un rêve que l'on fait seul n'est qu'un rêve. Un rêve que l'on fait ensemble est réalité. -John Lennon"
    },
    "2024-12-06": {
        "content": " Le véritable secret de la vie est de s'investir pleinement dans ce que l'on fait, ici et maintenant. Et au lieu de considérer cela comme du travail, réalisez que c'est un jeu. -Alan Watts"
    },
    "2024-12-07": {
        "content": " Hier est passé. Demain n'est pas encore arrivé. Il ne nous reste qu'aujourd'hui. Commençons. -Mère Teresa"
    },
    "2024-12-08": {
        "content": " Plus vous louez et célébrez votre vie, plus il y a de choses à célébrer dans la vie. -Oprah Winfrey"
    },
    "2024-12-09": {
        "content": "Ne doutez jamais qu'un petit groupe de citoyens réfléchis et engagés puisse changer le monde. C'est d'ailleurs la seule chose qui y soit jamais parvenue. -Margaret Mead"
    },
    "2024-12-10": {
        "content": " Poussez-vous, car personne d’autre ne le fera à votre place. -Anonyme"
    },
    "2024-12-11": {
        "content": " La véritable humilité ne consiste pas à penser moins à soi-même ; c’est à penser moins à soi-même. -CS Lewis"
    },
    "2024-12-12": {
        "content": " Si vous pouvez changer d’avis, vous pouvez changer votre vie. -William James"
    },
    "2024-12-13": {
        "content": " Concentrez-vous sur l’endroit où vous voulez aller, pas sur ce que vous craignez. -Tony Robbins"
    },
    "2024-12-14": {
        "content": " Respectez-vous et les autres vous respecteront. -Confucius"
    },
    "2024-12-15": {
        "content": " Faites ce que vous pouvez, avec ce que vous avez, là où vous êtes. -Théodore Roosevelt"
    },
    "2024-12-16": {
        "content": " Certains changements semblent négatifs à première vue, mais vous réaliserez bientôt qu’un espace est créé dans votre vie pour que quelque chose de nouveau émerge. -Eckhart Tolle"
    },
    "2024-12-17": {
        "content": " Si vos actions inspirent les autres à rêver davantage, à apprendre davantage, à faire davantage et à devenir davantage, vous êtes un leader. -John Quincy Adams"
    },
    "2024-12-18": {
        "content": " Ne vous inquiétez de rien, tout ira bien. -Bob Marley"
    },
    "2024-12-19": {
        "content": " Rêvez grand, restez positif, travaillez dur et profitez du voyage. -Urie Faber"
    },
    "2024-12-20": {
        "content": "Vous êtes ici pour permettre au dessein divin de l'Univers de se réaliser. C'est dire votre importance ! -Eckhart Tolle"
    },
    "2024-12-21": {
        "content": " Vivez avec passion ! -Tony Robbins"
    },
    "2024-12-22": {
        "content": " Croyez que vous pouvez y arriver et vous y êtes déjà à mi-chemin. -Théodore Roosevelt"
    },
    "2024-12-23": {
        "content": " Nos vies commencent à se terminer le jour où nous devenons silencieux sur des choses qui comptent. -Martin Luther King Jr."
    },
    "2024-12-24": {
        "content": " Ensemble, nous pouvons faire de grandes choses. -Mère Teresa"
    },
    "2024-12-25": {
        "content": " Travailler dur pour quelque chose qui ne nous intéresse pas s'appelle du stress ; travailler dur pour quelque chose que nous aimons s'appelle de la passion. -Simon Sinek"
    },
    "2024-12-26": {
        "content": " La grotte dans laquelle vous avez peur d’entrer contient le trésor que vous recherchez. -Joseph Campbell"
    },
    "2024-12-27": {
        "content": " Le leadership est une question d'empathie. C'est la capacité à établir des liens avec les autres afin de les inspirer et de les valoriser. -Oprah Winfrey"
    },
    "2024-12-28": {
        "content": " Il n’y a rien d’impossible à celui qui essaie. -Alexandre le Grand"
    },
    "2024-12-29": {
        "content": " La plupart des choses importantes dans le monde ont été accomplies par des gens qui ont continué à essayer alors qu’il semblait n’y avoir aucun espoir. -Dale Carnegie"
    },
    "2024-12-30": {
        "content": " Nous continuons d'avancer, d'ouvrir de nouvelles portes et de faire de nouvelles choses, parce que nous sommes curieux et que la curiosité nous conduit sans cesse sur de nouveaux chemins. -Walt Disney"
    },
    "2024-12-31": {
        "content": "Faites ce que vous avez à faire jusqu’à ce que vous puissiez faire ce que vous voulez faire. -Oprah Winfrey"
    },
    "2025-01-01": {
        "content": " Croire que vous êtes suffisant est ce qui vous donne le courage d’être authentique. -Brené Brown"
    },
    "2025-01-02": {
        "content": " Ce sont nos choix, Harry, qui montrent ce que nous sommes vraiment, bien plus que nos capacités. -J.K. Rowling"
    },
    "2025-01-03": {
        "content": " Suivez votre bonheur et l’univers vous ouvrira des portes là où il n’y avait que des murs. -Joseph Campbell"
    },
    "2025-01-04": {
        "content": " Les rêves ne sont pas ceux qui nous viennent pendant que nous dormons, mais les rêves sont ceux que nous ne dormons pas avant de réaliser. -Abdul Kalam"
    },
    "2025-01-05": {
        "content": " Oser, c'est avoir le courage d'être vulnérable. C'est se montrer et être vu. Demander ce dont on a besoin. Parler de ce qu'on ressent. Avoir des conversations difficiles. -Brené Brown"
    },
    "2025-01-06": {
        "content": " Vous ne réussirez jamais tant que vous ne transformerez pas votre souffrance en grandeur, tant que vous ne la laisserez pas vous pousser de là où vous êtes pour vous propulser là où vous devez être. Arrêtez de fuir votre souffrance et acceptez-la. Elle fera partie de votre récompense, de votre produit. Je vous mets au défi de vous dépasser. -Éric Thomas"
    },
    "2025-01-07": {
        "content": " Nous sommes ce que nous faisons de manière répétée. L'excellence n'est donc pas un acte, mais une habitude. -Aristote"
    },
    "2025-01-08": {
        "content": " Une rivière traverse la roche, non pas en raison de sa puissance, mais en raison de sa persistance. -Jim Watkins"
    },
    "2025-01-09": {
        "content": " L’énergie et la persévérance triomphent de toutes choses. -Benjamin Franklin"
    },
    "2025-01-10": {
        "content": " Les opportunités sont généralement déguisées en travail acharné, de sorte que la plupart des gens ne les reconnaissent pas. -Ann Landers"
    },
    "2025-01-11": {
        "content": " Si vous ne pouvez pas voler, courez, si vous ne pouvez pas courir, marchez, si vous ne pouvez pas marcher, rampez, mais quoi que vous fassiez, vous devez continuer à avancer. -Martin Luther King Jr."
    },
    "2025-01-12": {
        "content": " La persévérance garantit que les résultats sont inévitables. -Paramahansa Yogananda"
    },
    "2025-01-13": {
        "content": " Avec un talent ordinaire et une persévérance extraordinaire, tout est réalisable -Thomas Fowell Buxton"
    },
    "2025-01-14": {
        "content": " Notre plus grande gloire n’est pas de ne jamais échouer, mais de nous relever chaque fois que nous échouons. -Ralph Waldo Emerson"
    },
    "2025-01-15": {
        "content": " Le succès consiste à trébucher d’échec en échec sans perdre son enthousiasme. -Winston Churchill"
    },
    "2025-01-16": {
        "content": "Heureusement, la persévérance est un excellent substitut au talent. -Steve Martin"
    },
    "2025-01-17": {
        "content": " Je crois davantage à la chance, et je trouve que plus je travaille dur, plus j'en ai. -Thomas Jefferson"
    },
    "2025-01-18": {
        "content": " Ne remettez à demain que ce que vous seriez prêt à mourir sans avoir fait. -Pablo Picasso"
    },
    "2025-01-19": {
        "content": " Il n'y a pas de secret pour réussir : ne perdez pas de temps à le chercher. Le succès est le fruit de la perfection, du travail acharné, de l'apprentissage de l'échec, de la loyauté envers ceux pour qui vous travaillez et de la persévérance. -Colin Powell"
    },
    "2025-01-20": {
        "content": " Si vous souhaitez être devant, agissez comme si vous étiez derrière. -Lao Tseu"
    },
    "2025-01-21": {
        "content": " Laissez-moi vous révéler le secret qui m’a conduit à mon objectif : ma force réside uniquement dans ma ténacité. -Louis Pasteur"
    },
    "2025-01-22": {
        "content": " Rien au monde ne peut remplacer la persévérance. Le talent ne le fera pas ; rien n'est plus commun que les personnes talentueuses et incompétentes. Le génie ne le fera pas ; le génie non récompensé est presque un proverbe. -Calvin Coolidge"
    },
    "2025-01-23": {
        "content": " La meilleure issue est toujours de passer à travers. -Robert Frost"
    },
    "2025-01-24": {
        "content": "Beaucoup d’échecs dans la vie sont dus à des personnes qui n’ont pas réalisé à quel point elles étaient proches du succès lorsqu’elles ont abandonné. -Thomas A. Edison"
    },
    "2025-01-25": {
        "content": " Nous sommes faits pour persévérer. C'est ainsi que nous découvrons qui nous sommes. -Tobias Wolff"
    },
    "2025-01-26": {
        "content": " Connaissant les arbres, je comprends le sens de la patience. Connaissant l'herbe, j'apprécie la persévérance. -Hal Borland"
    },
    "2025-01-27": {
        "content": " L'eau qui coule creuse la pierre, non pas par la force mais par la persistance. -Ovide"
    },
    "2025-01-28": {
        "content": " La persévérance est essentielle. N'abandonnez pas, sauf si vous y êtes contraint. -Elon Musk"
    },
    "2025-01-29": {
        "content": " Un enthousiasme débordant, soutenu par le bon sens et la persévérance, est la qualité qui conduit le plus souvent au succès. -Dale Carnegie"
    },
    "2025-01-30": {
        "content": " L'ambition est la voie du succès. La persévérance est le véhicule qui y conduit. -Bill Bradley"
    },
    "2025-01-31": {
        "content": " Concentrez-vous sur la solution, pas sur le problème. -Walter Anderson"
    },
    "2025-02-01": {
        "content": " Lorsque la vie vous fait tomber, vous avez deux choix : rester à terre ou vous relever. -Tom Krause"
    },
    "2025-02-02": {
        "content": "Le succès est la somme de petits efforts, répétés jour après jour. -Robert Collier"
    },
    "2025-02-03": {
        "content": " Un rêve n'est qu'un rêve. Un objectif est un rêve avec un plan et une échéance. -Harvey MacKay"
    },
    "2025-02-04": {
        "content": " N'abandonnez jamais quelque chose auquel vous ne pouvez pas passer une journée sans penser. -Winston Churchill"
    },
    "2025-02-05": {
        "content": " Les diamants ne sont rien d’autre que des morceaux de charbon qui restent collés à leur travail. -Malcolm S. Forbes"
    },
    "2025-02-06": {
        "content": " On ne peut rien faire d'autre que petit à petit. -Charles Baudelaire"
    },
    "2025-02-07": {
        "content": " Si vous traversez l’enfer, continuez. -Winston Churchill"
    },
    "2025-02-08": {
        "content": " La clé de la persévérance ouvre toutes les portes fermées par la résistance. -John Di Lemme"
    },
    "2025-02-09": {
        "content": " Si nous regardons ceux qui réussissent le mieux dans le monde, la persévérance est le dénominateur commun. -Justin Sachs"
    },
    "2025-02-10": {
        "content": " Vous pouvez manger un éléphant petit à petit. -Mary Kay Ash"
    },
    "2025-02-11": {
        "content": " Je ne pense pas qu'il existe une qualité aussi essentielle à la réussite, quelle qu'elle soit, que la persévérance. Elle permet de surmonter presque tout, même la nature. -John D. Rockefeller"
    },
    "2025-02-12": {
        "content": "Si vous voulez transformer une vision en réalité, vous devez vous donner à 100 % et ne jamais cesser de croire en votre rêve. -Arnold Schwarzenegger"
    },
    "2025-02-13": {
        "content": " Courez quand vous le pouvez, marchez si vous le devez, rampez si vous le devez ; n'abandonnez jamais. -Doyen Karnazes"
    },
    "2025-02-14": {
        "content": " Faire un tour de plus quand vous pensez ne pas pouvoir le faire, c'est ce qui fait toute la différence dans votre vie. -Sylvester Stallone"
    },
    "2025-02-15": {
        "content": " Écoutez-moi, même quand on perd, c'est normal de perdre, mais on ne peut jamais s'y habituer. On ne peut jamais se satisfaire de perdre. Quand on perd, ça fait forcément mal. -Éric Thomas"
    },
    "2025-02-16": {
        "content": " Continuez à marcher, un pas à la fois. -Joyce Meyer"
    },
    "2025-02-17": {
        "content": " Nous ne devons pas abandonner et ne devons pas laisser le problème nous vaincre. -Abdul Kalam"
    },
    "2025-02-18": {
        "content": " C'est par l'endurance que nous conquérons. -Ernest Shackleton"
    },
    "2025-02-19": {
        "content": "Les murs de briques existent pour une raison. Ils ne sont pas là pour nous empêcher d'accéder à quelque chose. Ils sont là pour nous permettre de montrer à quel point nous le désirons. Parce qu'ils sont là pour arrêter ceux qui ne le désirent pas suffisamment. Ils sont là pour arrêter les autres. -Randy Pausch"
    },
    "2025-02-20": {
        "content": " Le succès dépend presque entièrement de la motivation et de la persévérance. L'énergie supplémentaire nécessaire pour redoubler d'efforts ou tenter une nouvelle approche est le secret de la victoire. -Denis Waitley"
    },
    "2025-02-21": {
        "content": " J'étais arrivé jusqu'ici et j'avais refusé d'abandonner car toute ma vie j'avais toujours terminé la course. -Louis Zamperini"
    },
    "2025-02-22": {
        "content": " La survie peut se résumer en trois mots : ne jamais abandonner. C'est le cœur du problème. Continuer d'essayer. -Bear Grylls"
    },
    "2025-02-23": {
        "content": "PLUS JAMAIS. Plus d'excuses. Plus de : « Je commence demain. » Plus de : « Juste pour cette fois. » Plus besoin d'accepter mes propres échecs. Plus besoin de prendre la facilité. Plus besoin de m'incliner devant les pensées malsaines ou improductives qui me traversent l'esprit. -Jocko Willink"
    },
    "2025-02-24": {
        "content": " De petits coups ont fait tomber de grands chênes. -Benjamin Franklin"
    },
    "2025-02-25": {
        "content": " « Je suis prêt. » « Je suis fait pour gagner. » « J'y suis parvenu. » « J'accepte l'incertitude. » « Je ne suis pas mes pensées ; je suis ce que je fais. » « Je suis acharné. » « Je n'attends rien et j'accepte tout. -Gary John Bishop"
    },
    "2025-02-26": {
        "content": " Je n'ai pas échoué 700 fois. Je n'ai pas échoué une seule fois. J'ai réussi à prouver que ces 700 méthodes ne fonctionneront pas. Une fois que j'aurai éliminé celles qui ne fonctionneront pas, je trouverai celle qui fonctionnera. -Thomas A. Edison"
    },
    "2025-02-27": {
        "content": " GRIT signifie courage, résilience, assiduité et ténacité. GRIT, c'est la capacité à se concentrer, à rester déterminé, à rester optimiste face aux défis et à travailler plus dur que ses pairs. -Linda Kaplan Thaler"
    },
    "2025-02-28": {
        "content": "Je pense que mon secret est qu'il n'y a pas de raccourcis pour travailler dur, être déterminé et avoir cette attitude de « ne pas abandonner ». -Jerry Rice"
    },
    "2025-03-01": {
        "content": " Ne cessez jamais de vous battre jusqu'à atteindre votre destinée, c'est-à-dire votre moi unique. Ayez un but dans la vie, acquérez continuellement des connaissances, travaillez dur et persévérez pour réaliser une vie formidable. -Abdul Kalam"
    },
    "2025-03-02": {
        "content": " Ne vous arrêtez pas quand vous êtes fatigué. Arrêtez-vous quand vous avez terminé. -David Goggins"
    },
    "2025-03-03": {
        "content": " Ne me jugez pas sur mes succès, jugez-moi sur le nombre de fois où je suis tombé et me suis relevé. -Nelson Mandela"
    },
    "2025-03-04": {
        "content": " Ce qui n'est pas commencé aujourd'hui n'est jamais terminé demain. -Johann Wolfgang von Goethe"
    },
    "2025-03-05": {
        "content": " Si vous écrivez une centaine de nouvelles et qu'elles sont toutes mauvaises, cela ne signifie pas que vous avez échoué. Vous échouez seulement si vous arrêtez d'écrire. -Ray Bradbury"
    },
    "2025-03-06": {
        "content": " Le maître a échoué plus de fois que le débutant n’a essayé. -Stephen McCranie"
    },
    "2025-03-07": {
        "content": " Au diable les circonstances ; je crée des opportunités. -Bruce Lee"
    },
    "2025-03-08": {
        "content": "La seule chose pire que de commencer quelque chose et d’échouer, c’est de ne rien commencer. -Seth Godin"
    },
    "2025-03-09": {
        "content": " Ne remettez jamais à demain ce que vous pouvez faire aujourd’hui. -Benjamin Franklin"
    },
    "2025-03-10": {
        "content": " Grâce à sa persévérance, l'escargot atteignit l'arche. -Charles H. Spurgeon"
    },
    "2025-03-11": {
        "content": " N'oubliez pas que l'espoir est une bonne chose, peut-être la meilleure des choses, et qu'aucune bonne chose ne meurt jamais. -Stephen King"
    },
    "2025-03-12": {
        "content": " Les entrepreneurs ne finissent pas quand ils sont fatigués. Ils finissent quand ils ont fini. -Robert T. Kiyosaki"
    },
    "2025-03-13": {
        "content": " Seules la persévérance et la détermination sont omnipotentes. -Calvin Coolidge"
    },
    "2025-03-14": {
        "content": " Paralyser la résistance par la persévérance. -Woody Hayes"
    },
    "2025-03-15": {
        "content": " Le succès n’est jamais possédé, il est loué, et le loyer est dû chaque jour. -Rory Vaden"
    },
    "2025-03-16": {
        "content": " Le succès n'est pas le fruit du hasard. C'est le fruit du travail, de la persévérance, de l'apprentissage, des études, du sacrifice et, surtout, de l'amour de ce que l'on fait ou apprend à faire. -Pelé"
    },
    "2025-03-17": {
        "content": " Il n'y a pas d'autre solution que de travailler dur. Acceptez-le. -Roger Federer"
    },
    "2025-03-18": {
        "content": " Un rêve ne devient pas réalité par magie ; il faut de la sueur, de la détermination et du travail acharné. -Colin Powell"
    },
    "2025-03-19": {
        "content": "L’apprentissage n’épuise jamais l’esprit. -Léonard de Vinci"
    },
    "2025-03-20": {
        "content": " J'entends et j'oublie. Je vois et je me souviens. Je fais et je comprends. -Confucius"
    },
    "2025-03-21": {
        "content": " Celui qui n’a jamais fait d’erreur n’a jamais rien essayé de nouveau. -Albert Einstein"
    },
    "2025-03-22": {
        "content": " Essayez d’apprendre quelque chose sur tout et tout sur quelque chose. -Thomas Henry Huxley"
    },
    "2025-03-23": {
        "content": " Un homme n’apprend que de deux manières : l’une en lisant, l’autre en fréquentant des personnes plus intelligentes. -Will Rogers"
    },
    "2025-03-24": {
        "content": " Vous ne comprenez rien tant que vous ne l’apprenez pas de plusieurs manières. -Marvin Minsky"
    },
    "2025-03-25": {
        "content": " Dis-moi et j'oublie, enseigne-moi et je me souviendrai, implique-moi et j'apprends. -Benjamin Franklin"
    },
    "2025-03-26": {
        "content": " Si vous voulez augmenter votre taux de réussite, doublez votre taux d’échec. -Thomas J. Watson"
    },
    "2025-03-27": {
        "content": " L'intelligence est ce que vous utilisez lorsque vous ne savez pas quoi faire. -Jean Piaget"
    },
    "2025-03-28": {
        "content": " Les analphabètes du XXIe siècle ne seront pas ceux qui ne savent ni lire ni écrire, mais ceux qui ne savent pas apprendre, désapprendre et réapprendre. -Alvin Toffler"
    },
    "2025-03-29": {
        "content": "C’est ce que nous savons déjà qui nous empêche souvent d’apprendre. -Claude Bernard"
    },
    "2025-03-30": {
        "content": " Les mathématiques sont le langage avec lequel Dieu a écrit l’univers. -Galileo Galilei"
    },
    "2025-03-31": {
        "content": " Le but de l’éducation est de transformer les miroirs en fenêtres. -Sydney J. Harris"
    },
    "2025-04-01": {
        "content": " Je n’ai pas peur des tempêtes car j’apprends à naviguer sur mon navire. -Louisa May Alcott"
    },
    "2025-04-02": {
        "content": " La seule personne éduquée est celle qui a appris à apprendre et à changer. -Carl R. Rogers"
    },
    "2025-04-03": {
        "content": " Je n’ai jamais rencontré un homme si ignorant que je ne puisse apprendre quelque chose de lui. -Galileo Galilei"
    },
    "2025-04-04": {
        "content": " Rien ne disparaît jamais tant que nous n’avons pas appris ce que nous devons savoir. -Pema Chödrön"
    },
    "2025-04-05": {
        "content": " C'est en forgeant qu'on devient forgeron. Après une longue période de pratique, notre travail deviendra naturel, habile, rapide et régulier. -Bruce Lee"
    },
    "2025-04-06": {
        "content": " Lorsque vous parlez, vous ne faites que répéter ce que vous savez déjà. Mais si vous écoutez, vous pouvez apprendre quelque chose de nouveau. -Dalaï Lama XIV"
    },
    "2025-04-07": {
        "content": " Efforcez-vous d’atteindre le progrès, pas la perfection. -Anonyme"
    },
    "2025-04-08": {
        "content": "Je fais toujours ce que je ne peux pas encore faire, afin d'apprendre à le faire. -Vincent van Gogh"
    },
    "2025-04-09": {
        "content": " La connaissance rend l’homme inapte à être esclave. -Frédéric Douglass"
    },
    "2025-04-10": {
        "content": " J’ai appris très tôt la différence entre connaître le nom de quelque chose et connaître quelque chose. -Richard P. Feynman"
    },
    "2025-04-11": {
        "content": " La capacité d’apprendre est un don ; la capacité d’apprendre est une compétence ; la volonté d’apprendre est un choix. -Brian Herbert"
    },
    "2025-04-12": {
        "content": " Apprenez tout ce que vous pouvez, à chaque fois que vous le pouvez, de qui vous voulez – il viendra toujours un moment où vous serez reconnaissant de l’avoir fait. -Sarah Caldwell"
    },
    "2025-04-13": {
        "content": " Je n’ai pas une grande opinion d’un homme qui n’est pas plus sage aujourd’hui qu’il ne l’était hier. -Abraham Lincoln"
    },
    "2025-04-14": {
        "content": " La clé du succès réside dans le dévouement à l’apprentissage tout au long de la vie. -Stephen R. Covey"
    },
    "2025-04-15": {
        "content": " Soyez passionné et audacieux. Continuez à apprendre. Vous ne ferez rien d'utile si vous n'apprenez pas. -Satya Nadella"
    },
    "2025-04-16": {
        "content": "L’activité la plus élevée qu’un être humain puisse atteindre est d’apprendre pour comprendre, car comprendre, c’est être libre. -Baruch Spinoza"
    },
    "2025-04-17": {
        "content": " Si vous n'apprenez pas continuellement, les autres vous dépasseront. Le tempérament seul ne suffit pas : il faut beaucoup de curiosité et une très longue durée. -Charlie Munger"
    },
    "2025-04-18": {
        "content": " Une organisation apprenante est une organisation qui développe continuellement sa capacité à créer son avenir. -Pierre Senge"
    },
    "2025-04-19": {
        "content": " Le jour où vous arrêtez d’apprendre est le jour où vous commencez à vous dégrader. -Isaac Asimov"
    },
    "2025-04-20": {
        "content": " L’apprentissage est un ornement dans la prospérité, un refuge dans l’adversité et une provision dans la vieillesse. -Aristote"
    },
    "2025-04-21": {
        "content": " Tous les leaders sont des apprenants. Dès qu'on cesse d'apprendre, on cesse de diriger. J'apprends autant que possible, du plus grand nombre et aussi souvent que possible. -Rick Warren"
    },
    "2025-04-22": {
        "content": " Pour apprendre rapidement des choses difficiles, il faut se concentrer intensément, sans distraction. Apprendre, en d'autres termes, est un travail en profondeur. -Cal Newport"
    },
    "2025-04-23": {
        "content": " N'importe quel imbécile peut savoir. L'important est de comprendre. -Albert Einstein"
    },
    "2025-04-24": {
        "content": "Passez chaque jour à essayer d’être un peu plus sage que vous ne l’étiez à votre réveil. -Charlie Munger"
    },
    "2025-04-25": {
        "content": " Investissez en vous-même, dans votre éducation. Il n'y a rien de mieux. -Sylvia Porter"
    },
    "2025-04-26": {
        "content": " L’auto-éducation est pour moi une source continue de plaisir, car plus j’en sais, plus ma vie est épanouie et plus j’apprécie ma propre existence. -Isaac Asimov"
    },
    "2025-04-27": {
        "content": " Vous pouvez obtenir de l’aide de la part des professeurs, mais vous allez devoir apprendre beaucoup de choses par vous-même, assis seul dans une pièce. -Dr Seuss"
    },
    "2025-04-28": {
        "content": " L’apprentissage se produit lorsque quelqu’un veut apprendre, pas lorsque quelqu’un veut enseigner. -Roger Schank"
    },
    "2025-04-29": {
        "content": " Une personne ne peut pas enseigner directement à une autre personne ; elle ne peut que faciliter l’apprentissage d’une autre personne. -Carl R. Rogers"
    },
    "2025-04-30": {
        "content": " Apprendre n'est pas obligatoire, c'est volontaire. S'améliorer n'est pas obligatoire, c'est volontaire. Mais pour survivre, nous devons apprendre. -W. Edwards Deming"
    },
    "2025-05-01": {
        "content": " Je fais toujours ce que je ne peux pas faire, afin d’apprendre à le faire. -Pablo Picasso"
    },
    "2025-05-02": {
        "content": "Aucun voleur, aussi habile soit-il, ne peut voler la connaissance à quelqu'un, et c'est pourquoi la connaissance est le trésor le meilleur et le plus sûr à acquérir. -L. Frank Baum"
    },
    "2025-05-03": {
        "content": " Je pense que c’est le meilleur conseil : pensez constamment à la façon dont vous pourriez faire les choses mieux et remettez-vous en question. -Elon Musk"
    },
    "2025-05-04": {
        "content": " Un homme sage peut apprendre plus d’une question stupide qu’un imbécile peut apprendre d’une réponse sage. -Bruce Lee"
    },
    "2025-05-05": {
        "content": " Si j'ai vu plus loin, c'est en me tenant sur les épaules des Géants. -Isaac Newton"
    },
    "2025-05-06": {
        "content": " Ce que nous connaissons est une goutte, ce que nous ne connaissons pas est un océan. -Isaac Newton"
    },
    "2025-05-07": {
        "content": " Ce qui est bien avec l’apprentissage, c’est que personne ne peut vous l’enlever. -BB King"
    },
    "2025-05-08": {
        "content": " Si vous voulez devenir écrivain, vous devez faire deux choses avant tout : lire beaucoup et écrire beaucoup. -Stephen King"
    },
    "2025-05-09": {
        "content": " La répétition est la mère de la compétence. -Tony Robbins"
    },
    "2025-05-10": {
        "content": " L’émerveillement est le début de la sagesse. -Socrate"
    },
    "2025-05-11": {
        "content": " Si vous faites une erreur et ne la corrigez pas, cela s’appelle une erreur. -Confucius"
    },
    "2025-05-12": {
        "content": " Le but de l’éducation est de remplacer un esprit vide par un esprit ouvert. -Malcolm S. Forbes"
    },
    "2025-05-13": {
        "content": "Dans la vie, rien n'est à craindre, il faut simplement le comprendre. Il est temps de mieux comprendre, afin d'avoir moins peur. -Marie Curie"
    },
    "2025-05-14": {
        "content": " Lorsqu'on vous demande si vous êtes capable d'effectuer un travail, répondez : « Bien sûr que je peux ! ». Ensuite, mettez-vous au travail et découvrez comment le faire. -Théodore Roosevelt"
    },
    "2025-05-15": {
        "content": " Nous avons tous besoin de commentaires. C'est ainsi que nous progressons. -Bill Gates"
    },
    "2025-05-16": {
        "content": " L’éducation est la clé pour ouvrir le monde, un passeport pour la liberté. -Oprah Winfrey"
    },
    "2025-05-17": {
        "content": " Tout commence par une idée. -Comte Nightingale"
    },
    "2025-05-18": {
        "content": " Le meilleur investissement que vous puissiez faire est en vous-même. -Warren Buffett"
    },
    "2025-05-19": {
        "content": " Ce n'est pas une question d'argent ou de relations. C'est la volonté de travailler et d'apprendre mieux que tout le monde. -Mark Cuban"
    },
    "2025-05-20": {
        "content": " Tant que tu vivras, continue à apprendre à vivre. -Sénèque"
    },
    "2025-05-21": {
        "content": " Pour apprendre à réussir, il faut d’abord apprendre à échouer. -Michael Jordan"
    },
    "2025-05-22": {
        "content": " Ne gâchez pas une bonne erreur, apprenez-en. -Robert T. Kiyosaki"
    },
    "2025-05-23": {
        "content": "Pour acquérir la connaissance, il faut étudier ; mais pour acquérir la sagesse, il faut observer. -Marilyn Vos Savant"
    },
    "2025-05-24": {
        "content": " On vit et on apprend. En tout cas, on vit. -Douglas Adams"
    },
    "2025-05-25": {
        "content": " La patience est la compagne de la sagesse. -Saint Augustin"
    },
    "2025-05-26": {
        "content": " Je ne sais qu'une chose, c'est que je ne sais rien. -Socrate"
    },
    "2025-05-27": {
        "content": " La sagesse vient de l'expérience. L'expérience est souvent le résultat d'un manque de sagesse. -Terry Pratchett"
    },
    "2025-05-28": {
        "content": " Nous pouvons juger nos progrès par le courage de nos questions et la profondeur de nos réponses, notre volonté d’accepter ce qui est vrai plutôt que ce qui nous fait du bien. -Carl Sagan"
    },
    "2025-05-29": {
        "content": " Je préfère avoir des questions auxquelles on ne peut pas répondre plutôt que des réponses qu'on ne peut pas remettre en question. -Richard P. Feynman"
    },
    "2025-05-30": {
        "content": " Je suis toujours prêt à apprendre même si je n'aime pas toujours qu'on me enseigne. -Winston Churchill"
    },
    "2025-05-31": {
        "content": " Celui qui aime la pratique sans théorie est comme le marin qui monte à bord d'un navire sans gouvernail ni boussole et ne sait jamais où il peut jeter son dévolu. -Léonard de Vinci"
    },
    "2025-06-01": {
        "content": " Il vaut mieux créer qu'apprendre. Créer est l'essence même de la vie. -Jules César"
    },
    "2025-06-02": {
        "content": "Ce que fait la main, l'esprit s'en souvient. -Maria Montessori"
    },
    "2025-06-03": {
        "content": " Avancez toujours dans la vie comme si vous aviez quelque chose de nouveau à apprendre, et vous l’apprendrez. -Vernon Howard"
    },
    "2025-06-04": {
        "content": " L’échec est un succès si nous en tirons des leçons. -Malcolm S. Forbes"
    },
    "2025-06-05": {
        "content": " L'éducation est notre meilleure amie. Une personne instruite est respectée partout. L'éducation surpasse la beauté et la jeunesse. -Chanakya"
    },
    "2025-06-06": {
        "content": " Ne pensez pas que ce qui est difficile à maîtriser pour vous est humainement impossible ; mais si une chose est humainement possible, considérez-la comme étant à votre portée. -Marc Aurèle"
    },
    "2025-06-07": {
        "content": " L’apprentissage est un processus constant de découverte – un processus sans fin. -Bruce Lee"
    },
    "2025-06-08": {
        "content": " Être ignorant n’est pas tant une honte que de ne pas vouloir apprendre. -Benjamin Franklin"
    },
    "2025-06-09": {
        "content": " Je suis convaincu que la connaissance est un pouvoir – pour surmonter le passé, pour changer nos propres situations, pour combattre de nouveaux obstacles, pour prendre de meilleures décisions. -Ben Carson"
    },
    "2025-06-10": {
        "content": " En inspirant, j'apaise mon corps et mon esprit. En expirant, je souris. En vivant l'instant présent, je sais que c'est le seul moment. -Thich Nhat Hanh"
    },
    "2025-06-11": {
        "content": "Si vous pensez que vous êtes trop petit pour faire la différence, essayez de dormir avec un moustique. -Dalaï Lama XIV"
    },
    "2025-06-12": {
        "content": " Trop souvent, nous sous-estimons le pouvoir d’un contact, d’un sourire, d’un mot gentil, d’une oreille attentive, d’un compliment honnête ou du plus petit acte d’attention, qui ont tous le potentiel de changer une vie. -Léo Buscaglia"
    },
    "2025-06-13": {
        "content": " La façon dont nous passons nos journées est, bien sûr, la façon dont nous passons nos vies. -Annie Dillard"
    },
    "2025-06-14": {
        "content": " Nourrissez votre esprit de grandes pensées, car vous n’irez jamais plus haut que vous ne le pensez. -Benjamin Disraeli"
    },
    "2025-06-15": {
        "content": " On n'apprend pas à marcher en suivant des règles. On apprend en faisant et en tombant. -Richard Branson"
    },
    "2025-06-16": {
        "content": " Il est impossible de vivre sans échouer à quelque chose, à moins que vous ne viviez avec tant de prudence que vous auriez tout aussi bien pu ne pas vivre du tout, auquel cas vous échouez par défaut. -J.K. Rowling"
    },
    "2025-06-17": {
        "content": " Si tu veux être heureux, sois-le. -Léon Tolstoï"
    },
    "2025-06-18": {
        "content": " Personne ne peut me faire de mal sans ma permission. -Mahatma Gandhi"
    },
    "2025-06-19": {
        "content": " Quand je lâche prise sur ce que je suis, je deviens ce que je pourrais être. -Lao Tseu"
    },
    "2025-06-20": {
        "content": "La raison pour laquelle nous luttons contre l’insécurité est que nous comparons nos coulisses avec les moments forts de tout le monde. -Steven Furtick"
    },
    "2025-06-21": {
        "content": " N'oubliez pas qu'aujourd'hui est le lendemain dont vous vous inquiétiez hier. -Dale Carnegie"
    },
    "2025-06-22": {
        "content": " Nous devons être prêts à abandonner la vie que nous avions planifiée afin d’avoir la vie qui nous attend. -Joseph Campbell"
    },
    "2025-06-23": {
        "content": " Arrête de partir et tu arriveras. Arrête de chercher et tu verras. Arrête de fuir et on te trouvera. -Lao Tseu"
    },
    "2025-06-24": {
        "content": " Une équipe n'est pas un groupe de personnes qui travaillent ensemble. Une équipe est un groupe de personnes qui se font confiance. -Simon Sinek"
    },
    "2025-06-25": {
        "content": " L’optimisme perpétuel est un multiplicateur de force. -Colin Powell"
    },
    "2025-06-26": {
        "content": " Lorsque vous vous contentez d'être simplement vous-même et que vous ne comparez pas ou ne rivalisez pas, tout le monde vous respectera. -Lao Tseu"
    },
    "2025-06-27": {
        "content": " Comptez votre âge en amis, pas en années. Comptez votre vie en sourires, pas en larmes. -John Lennon"
    },
    "2025-06-28": {
        "content": " Donnez à ceux que vous aimez des ailes pour voler, des racines pour revenir et des raisons de rester. -Dalaï Lama XIV"
    },
    "2025-06-29": {
        "content": " La persévérance et l’esprit ont fait des merveilles à toutes les époques. -George Washington"
    },
    "2025-06-30": {
        "content": "Partagez vos connaissances. C'est un moyen d'atteindre l'immortalité. -Dalaï Lama XIV"
    },
    "2025-07-01": {
        "content": " Nous sommes un moyen pour le cosmos de se connaître lui-même. -Carl Sagan"
    },
    "2025-07-02": {
        "content": " Un bon enseignant peut inspirer l’espoir, stimuler l’imagination et inculquer l’amour de l’apprentissage. -Brad Henry"
    },
    "2025-07-03": {
        "content": " L’une des plus grandes découvertes qu’une personne fasse, l’une de ses grandes surprises, est de découvrir qu’elle peut faire ce qu’elle craignait de ne pas pouvoir faire. -Henry Ford"
    },
    "2025-07-04": {
        "content": " À quand remonte la dernière fois où vous avez fait quelque chose pour la première fois ? -John C. Maxwell"
    },
    "2025-07-05": {
        "content": " Si vous n’êtes pas en train de devenir la personne que vous voulez être, vous êtes automatiquement en train de devenir la personne que vous ne voulez pas être. -Dale Carnegie"
    },
    "2025-07-06": {
        "content": " La fortune favorise les audacieux. -Proverbe latin"
    },
    "2025-07-07": {
        "content": " Le succès n'est pas la clé du bonheur. Le bonheur est la clé du succès. Si vous aimez ce que vous faites, vous réussirez. -Albert Schweitzer"
    },
    "2025-07-08": {
        "content": " Ne gagnez pas le monde si vous perdez votre âme ; la sagesse vaut mieux que l'argent ou l'or. -Bob Marley"
    },
    "2025-07-09": {
        "content": " Commencez dès maintenant à vivre et comptez chaque jour comme une vie distincte. -Sénèque"
    },
    "2025-07-10": {
        "content": "À moins que quelqu'un comme vous ne s'en soucie vraiment, rien ne s'améliorera. Ce n'est pas le cas. -Dr Seuss"
    },
    "2025-07-11": {
        "content": " Ils ne savaient pas que c'était impossible alors ils l'ont fait. -Mark Twain"
    },
    "2025-07-12": {
        "content": " Je peux faire des choses que tu ne peux pas faire, tu peux faire des choses que je ne peux pas faire ; ensemble nous pouvons faire de grandes choses. -Mère Teresa"
    },
    "2025-07-13": {
        "content": " La seule chose que nous devons craindre, c’est la peur elle-même. -Franklin D. Roosevelt"
    },
    "2025-07-14": {
        "content": " Rien de grand n’a jamais été accompli sans enthousiasme. -Ralph Waldo Emerson"
    },
    "2025-07-15": {
        "content": " Courage, cher cœur. -CS Lewis"
    },
    "2025-07-16": {
        "content": " La seule façon de donner un sens au changement est de s’y plonger, de bouger avec lui et de rejoindre la danse. -Alan Watts"
    },
    "2025-07-17": {
        "content": " Là où l’attention se porte, l’énergie circule et les résultats se voient. -T. Harv Eker"
    },
    "2025-07-18": {
        "content": " La douleur est temporaire. Elle peut durer une minute, une heure, un jour, voire un an, mais elle finira par s'atténuer et quelque chose d'autre la remplacera. Si j'arrête, en revanche, elle durera éternellement. -Lance Armstrong"
    },
    "2025-07-19": {
        "content": " À chaque promenade dans la nature, on reçoit bien plus que ce que l’on recherche. -John Muir"
    },
    "2025-07-20": {
        "content": "Les gagnants ne sont pas ceux qui n’échouent jamais, mais ceux qui n’abandonnent jamais. -Edwin Louis Cole"
    },
    "2025-07-21": {
        "content": " Au lieu de combattre les ténèbres, vous faites entrer la lumière. -Eckhart Tolle"
    },
    "2025-07-22": {
        "content": " Soyez sans peur dans la poursuite de ce qui enflamme votre âme. -Jennifer Lee"
    },
    "2025-07-23": {
        "content": " Quand les gens vous quittent, laissez-les partir. Votre destin n'est jamais lié à ceux qui vous quittent, et cela ne signifie pas que ce sont de mauvaises personnes. Cela signifie simplement que leur rôle dans votre histoire est terminé. -TD Jakes"
    },
    "2025-07-24": {
        "content": " Le leadership est la capacité de traduire une vision en réalité. -Warren G. Bennis"
    },
    "2025-07-25": {
        "content": " La foi, c'est croire ce que l'on ne voit pas ; la récompense de cette foi, c'est de voir ce que l'on croit. -Saint Augustin"
    },
    "2025-07-26": {
        "content": " Rien n’est impossible à moins que vous ne le pensiez. -Paramahansa Yogananda"
    },
    "2025-07-27": {
        "content": " La seule chose pire que d’être aveugle, c’est d’avoir la vue mais pas de vision. -Hélène Keller"
    },
    "2025-07-28": {
        "content": " Tout a sa beauté, mais tout le monde ne la voit pas. -Confucius"
    },
    "2025-07-29": {
        "content": " Dieu parle dans le silence du cœur. -Mère Teresa"
    },
    "2025-07-30": {
        "content": "L'espoir est cette chose avec des plumes qui se perche dans l'âme - et chante la mélodie sans les paroles - et ne s'arrête jamais du tout. -Emily Dickinson"
    },
    "2025-07-31": {
        "content": " Peu importe le nombre de paroles saintes que vous lisez, peu importe le nombre de paroles que vous prononcez, à quoi vous serviront-elles si vous ne les mettez pas en pratique ? -Bouddha"
    },
    "2025-08-01": {
        "content": " Et d'ailleurs, tout dans la vie est inscriptible si l'on a le courage de le faire et l'imagination nécessaire pour improviser. Le pire ennemi de la créativité, c'est le doute de soi. -Sylvia Plath"
    },
    "2025-08-02": {
        "content": " Rien de ce que nous faisons ne peut changer le passé, mais tout ce que nous faisons change l’avenir. -Ashleigh Brilliant"
    },
    "2025-08-03": {
        "content": " Le leadership est un choix, pas un grade. -Simon Sinek"
    },
    "2025-08-04": {
        "content": " Tout ira bien, tout ira bien et toutes sortes de choses iront bien. -Julien de Norwich"
    },
    "2025-08-05": {
        "content": " Chacun de nous est précieux, du point de vue cosmique. Si un humain n'est pas d'accord avec vous, laissez-le vivre. Dans cent milliards de galaxies, vous n'en trouverez pas d'autre. -Carl Sagan"
    },
    "2025-08-06": {
        "content": " L’intelligence et le caractère : tel est le but de la véritable éducation. -Martin Luther King Jr."
    },
    "2025-08-07": {
        "content": "Plus vous vous perdez dans quelque chose de plus grand que vous, plus vous aurez d’énergie. -Norman Vincent Peale"
    },
    "2025-08-08": {
        "content": " Maîtrisez les fondamentaux et le niveau de tout ce que vous faites augmentera -Michael Jordan"
    },
    "2025-08-09": {
        "content": " Vous ne pouvez pas vivre du tout si vous ne pouvez pas vivre pleinement maintenant. -Alan Watts"
    },
    "2025-08-10": {
        "content": " N’oubliez pas que parfois, ne pas obtenir ce que vous voulez est un merveilleux coup de chance. -Dalaï Lama XIV"
    },
    "2025-08-11": {
        "content": " Faites de votre mieux, puis détendez-vous. Laissez les choses suivre leur cours naturel, plutôt que de les forcer. -Paramahansa Yogananda"
    },
    "2025-08-12": {
        "content": " Vous êtes un être spirituel infini vivant une expérience humaine temporaire. -Wayne W. Dyer"
    },
    "2025-08-13": {
        "content": " Il faut rêver avant que vos rêves puissent se réaliser. -Abdul Kalam"
    },
    "2025-08-14": {
        "content": " Par-dessus tout, garde ton cœur, car tout ce que tu fais découle de lui. -Salomon"
    },
    "2025-08-15": {
        "content": " Je peux tout secouer en écrivant ; mes chagrins disparaissent, mon courage renaît. -Anne Frank"
    },
    "2025-08-16": {
        "content": " L'objectif n'est pas d'être parfait à la fin, mais d'être meilleur aujourd'hui. -Simon Sinek"
    },
    "2025-08-17": {
        "content": " Avancez avec confiance vers vos rêves. Vivez la vie que vous avez imaginée. -Henry David Thoreau"
    },
    "2025-08-18": {
        "content": "Soyez gentil autant que possible. C'est toujours possible. -Dalaï Lama XIV"
    },
    "2025-08-19": {
        "content": " Notre but premier dans la vie est d'aider les autres. Et si vous ne pouvez pas les aider, au moins ne leur faites pas de mal. -Dalaï Lama XIV"
    },
    "2025-08-20": {
        "content": " Tu as un cerveau dans la tête. Tu as les pieds dans les chaussures. Tu peux te diriger dans la direction que tu veux. Tu es seul. Et tu sais ce que tu sais. Et c'est toi qui décides où aller. -Dr Seuss"
    },
    "2025-08-21": {
        "content": " Ce sur quoi vous vous concentrez s’étend, et lorsque vous vous concentrez sur la bonté dans votre vie, vous en créez davantage. -Oprah Winfrey"
    },
    "2025-08-22": {
        "content": " Tout ce que j'ai besoin de savoir m'est révélé. Tout ce dont j'ai besoin vient à moi. Tout va bien dans ma vie. -Louise Hay"
    },
    "2025-08-23": {
        "content": " Je suis en parfaite sécurité dans l'Univers. Je suis en paix partout. J'ai confiance en la vie. -Louise Hay"
    },
    "2025-08-24": {
        "content": " Tournez votre visage vers le soleil et les ombres tombent derrière vous. -Proverbe maori"
    },
    "2025-08-25": {
        "content": " Le courage ne consiste pas à avoir la force de continuer, mais à continuer quand on n'en a pas la force. -Théodore Roosevelt"
    },
    "2025-08-26": {
        "content": " L’avenir dépend de ce que vous faites aujourd’hui. -Mahatma Gandhi"
    },
    "2025-08-27": {
        "content": " Un gagnant est un rêveur qui n’abandonne jamais. -Nelson Mandela"
    },
    "2025-08-28": {
        "content": "Ne pleurez pas parce que c'est fini, souriez parce que c'est arrivé. -Dr Seuss"
    },
    "2025-08-29": {
        "content": " En trois mots, je peux résumer tout ce que j'ai appris sur la vie : elle continue. -Robert Frost"
    },
    "2025-08-30": {
        "content": " Vivez selon votre imagination, pas selon votre histoire. -Stephen R. Covey"
    },
    "2025-08-31": {
        "content": " À mon avis, si vous voulez l’arc-en-ciel, vous devez supporter la pluie. -Dolly Parton"
    },
    "2025-09-01": {
        "content": " La grandeur d’un homme ne réside pas dans la quantité de richesses qu’il acquiert, mais dans son intégrité et sa capacité à influencer positivement ceux qui l’entourent. -Bob Marley"
    },
    "2025-09-02": {
        "content": " Le bonheur vient principalement de notre propre attitude, plutôt que de facteurs externes. -Dalaï Lama XIV"
    },
    "2025-09-03": {
        "content": " Les grands actes sont constitués de petits actes. -Lao Tseu"
    },
    "2025-09-04": {
        "content": " Il n’est jamais trop tard pour être ce que vous auriez pu être. -George Eliot"
    },
    "2025-09-05": {
        "content": " Adopter la bonne attitude peut transformer un stress négatif en un stress positif. -Hans Selye"
    },
    "2025-09-06": {
        "content": " Osez vivre la vie dont vous rêvez. Allez de l'avant et réalisez vos rêves. -Ralph Waldo Emerson"
    },
    "2025-09-07": {
        "content": " Le temps que vous aimez perdre n’est pas du temps perdu. -Bertrand Russell"
    },
    "2025-09-08": {
        "content": "Il suffit d’un peu de vigilance pour voir et découvrir : la vie est en réalité un grand rire cosmique. -Osho"
    },
    "2025-09-09": {
        "content": " Le paradoxe curieux est que lorsque je m’accepte tel que je suis, alors je peux changer. -Carl R. Rogers"
    },
    "2025-09-10": {
        "content": " Faites partie de la solution, pas du problème. -Stephen R. Covey"
    },
    "2025-09-11": {
        "content": " Le secret de la vie est de donner. -Tony Robbins"
    },
    "2025-09-12": {
        "content": " Faites de chaque jour votre chef-d'œuvre. -John Wooden"
    },
    "2025-09-13": {
        "content": " N'abandonnez jamais ce que vous voulez vraiment faire -H. Jackson Brown Jr."
    },
    "2025-09-14": {
        "content": " Ne regarde pas en arrière, tu n’iras pas dans cette direction. -Mary Engelbreit"
    },
    "2025-09-15": {
        "content": " Faites de votre mieux et Dieu fera le reste. -Nick Vujicic"
    },
    "2025-09-16": {
        "content": " Vivez, voyagez, partez à l'aventure, bénissez et ne soyez pas désolé. -Jack Kerouac"
    },
    "2025-09-17": {
        "content": " Au cœur de l'hiver, j'ai découvert qu'il y avait, en moi, un été invincible. Et cela me rend heureuse. Car cela signifie que, quelle que soit la pression exercée par le monde sur moi, il y a en moi quelque chose de plus fort, quelque chose de meilleur, qui me repousse. -Albert Camus"
    },
    "2025-09-18": {
        "content": "Certains pensent que seule une grande puissance peut contenir le mal, mais ce n'est pas ce que j'ai constaté. Ce sont les petits gestes quotidiens des gens ordinaires qui tiennent les ténèbres à distance. De petits gestes de bonté et d'amour. -JRR Tolkien"
    },
    "2025-09-19": {
        "content": " Soyez fidèle dans les petites choses, car c’est en elles que réside votre force. -Mère Teresa"
    },
    "2025-09-20": {
        "content": " Faites de vous une lumière. -Bouddha"
    },
    "2025-09-21": {
        "content": " VISUALISER ! Voyez, ressentez ! C'est ici que l'action commence. -Rhonda Byrne"
    },
    "2025-09-22": {
        "content": " Soyez phénoménal ou soyez oublié ! -Éric Thomas"
    },
    "2025-09-23": {
        "content": " Lorsque vous avez le choix d’avoir raison ou d’être gentil, choisissez d’être gentil. -Wayne W. Dyer"
    },
    "2025-09-24": {
        "content": " Les êtres humains peuvent changer leur vie en modifiant leurs attitudes mentales. -William James"
    },
    "2025-09-25": {
        "content": " La santé est le plus grand bien. -Laozi"
    },
    "2025-09-26": {
        "content": " Que je ne prie pas pour être à l'abri des dangers, mais pour les affronter sans crainte. Que je ne supplie pas pour apaiser ma douleur, mais pour que mon cœur la surmonte. -Rabindranath Tagore"
    },
    "2025-09-27": {
        "content": " Ayez à cœur de faire le bien. Répétez-le encore et encore, et vous serez rempli de joie. -Bouddha"
    },
    "2025-09-28": {
        "content": "Je ne peux pas changer le monde à moi seul, mais je peux jeter une pierre sur les eaux pour créer de nombreuses ondulations. -Mère Teresa"
    },
    "2025-09-29": {
        "content": " Et le jour est venu où le risque de rester enfermé dans un bourgeon était plus douloureux que le risque de fleurir. -Anaïs Nin"
    },
    "2025-09-30": {
        "content": " L'effort humain ne devrait connaître aucune limite. Aussi difficile que puisse paraître la vie, il y a toujours de l'espoir. -Stephen Hawking"
    },
    "2025-10-01": {
        "content": " Et je vous exhorte à remarquer quand vous êtes heureux, et à vous exclamer, à murmurer ou à penser à un moment donné : « Si ce n'est pas agréable, je ne sais pas ce que c'est. » -Kurt Vonnegut"
    },
    "2025-10-02": {
        "content": " C'est votre réaction à l'adversité, et non l'adversité elle-même, qui détermine la manière dont l'histoire de votre vie se développera. -Dieter F. Uchtdorf"
    },
    "2025-10-03": {
        "content": " Ce n'est pas ce que vous avez, qui vous êtes, où vous êtes ou ce que vous faites qui vous rend heureux ou malheureux. C'est ce que vous en pensez. -Dale Carnegie"
    },
    "2025-10-04": {
        "content": " Plus vous lirez, plus vous saurez. Plus vous apprendrez, plus vous visiterez de lieux. -Dr Seuss"
    },
    "2025-10-05": {
        "content": " Tous nos rêves peuvent devenir réalité. -Walt Disney"
    },
    "2025-10-06": {
        "content": "Le privilège d’une vie est d’être qui vous êtes. -Joseph Campbell"
    },
    "2025-10-07": {
        "content": " Personne n’est inutile dans ce monde s’il allège le fardeau d’un autre. -Charles Dickens"
    },
    "2025-10-08": {
        "content": " Trouvez un endroit à l'intérieur où il y a de la joie, et la joie brûlera la douleur. -Joseph Campbell"
    },
    "2025-10-09": {
        "content": " Ne demandez pas ce dont le monde a besoin. Demandez-vous ce qui vous anime et faites-le. Car ce dont le monde a besoin, c'est de plus de personnes qui s'épanouissent. -Howard Thurman"
    },
    "2025-10-10": {
        "content": " Vos sentiments sont vos meilleurs outils pour vous aider à créer votre vie. -Rhonda Byrne"
    },
    "2025-10-11": {
        "content": " Je mérite le meilleur et j'accepte le meilleur maintenant. -Louise Hay"
    },
    "2025-10-12": {
        "content": " Ce n’est pas la quantité que nous donnons qui compte, mais l’amour que nous mettons dans ce don. -Mère Teresa"
    },
    "2025-10-13": {
        "content": " Quand vous voulez réussir autant que vous voulez respirer, alors vous réussirez. -Éric Thomas"
    },
    "2025-10-14": {
        "content": " J'ai détesté chaque minute d'entraînement, mais je me suis dit : « N'abandonne pas. Souffre maintenant et vis le reste de ta vie comme un champion. » -Muhammad Ali"
    },
    "2025-10-15": {
        "content": "Ce n'est pas le critique qui compte, ni celui qui souligne les trébuchements de l'homme fort ou la manière dont l'auteur aurait pu faire mieux. Le mérite revient à l'homme qui est réellement dans l'arène, dont le visage est couvert de sueur, de poussière et de sang ; qui lutte vaillamment ; qui commet des erreurs et échoue encore et encore ; qui connaît les grands enthousiasmes, les grands dévouements, et se dépense pour une noble cause ; qui, s'il gagne, connaît le triomphe d'une grande réussite ; et qui, s'il échoue, échoue au moins en osant beaucoup, de sorte que sa place ne sera jamais parmi ces âmes froides et timides qui ne connaissent ni victoire ni défaite. -Théodore Roosevelt"
    },
    "2025-10-16": {
        "content": " La plus grande aventure que vous puissiez vivre est de vivre la vie de vos rêves. -Oprah Winfrey"
    },
    "2025-10-17": {
        "content": " Sans lutte, il ne peut y avoir de progrès. -Frédéric Douglass"
    },
    "2025-10-18": {
        "content": " Un rêve écrit avec une date devient un objectif. Un objectif décomposé en étapes devient un plan. Un plan suivi d'actions permet à vos rêves de se réaliser. -Greg Reid"
    },
    "2025-10-19": {
        "content": "Faites la seule chose que vous pensez ne pas pouvoir faire. Échouez. Réessayez. Faites mieux la deuxième fois. Les seules personnes qui ne tombent jamais sont celles qui ne montent jamais sur le fil. -Oprah Winfrey"
    },
    "2025-10-20": {
        "content": " Attendez-vous au changement. Analysez le paysage. Saisissez les opportunités. Cessez d'être la pièce d'échecs ; devenez le joueur. À vous de jouer. -Tony Robbins"
    },
    "2025-10-21": {
        "content": " Tu es libre. Tu es puissant. Tu es bon. Tu es amour. Tu as de la valeur. Tu as un but. Tout va bien. -Esther Hicks"
    },
    "2025-10-22": {
        "content": "Si vous désirez une chose au point de vous battre pour elle, de travailler jour et nuit pour elle, de donner votre temps, votre paix et votre sommeil pour elle. Si tout ce dont vous rêvez et planifiez ne concerne que cela et que la vie semble inutile et sans valeur sans cela ; Si vous transpirez, vous inquiétez et planifiez volontiers pour cela et perdez toute votre terreur de l'opposition pour cela ; Si vous poursuivez simplement cette chose que vous voulez avec toute votre capacité, votre force et votre sagacité, votre foi, votre espoir et votre confiance et votre ténacité pour la ténacité ; Si ni le froid ni la pauvreté, la famine ni la goutte, la maladie ni la douleur du corps et de l'esprit ne peuvent vous éloigner de la chose que vous voulez ; Si vous êtes obstiné et sinistre, vous la taillez et l'engendrez, avec l'aide de DIEU vous l'obtiendrez. -Berton Braley"
    },
    "2025-10-23": {
        "content": " Même si vous êtes sur la bonne voie, vous serez renversé si vous restez assis là. -Will Rogers"
    },
    "2025-10-24": {
        "content": " Je pense qu’il est possible pour les gens ordinaires de choisir d’être extraordinaires. -Elon Musk"
    },
    "2025-10-25": {
        "content": " On n'apprend pas à marcher en suivant des règles. On apprend en faisant et en tombant. -Richard Branson"
    },
    "2025-10-26": {
        "content": "Il n'y a pas de talent ici, c'est du travail acharné. C'est une obsession. Le talent n'existe pas, nous sommes tous égaux en tant qu'êtres humains. Tu peux devenir qui tu veux si tu y mets du temps. Tu atteindras le sommet, un point c'est tout. Je n'ai pas de talent, je suis obsédé. -Conor McGregor"
    },
    "2025-10-27": {
        "content": " Un rêve n’est pas ce que vous voyez pendant votre sommeil ; c’est quelque chose qui vous empêche de dormir. -Abdul Kalam"
    },
    "2025-10-28": {
        "content": " Lorsque vous avez épuisé toutes les possibilités, rappelez-vous ceci : vous ne l'avez pas fait. -Thomas A. Edison"
    },
    "2025-10-29": {
        "content": " Prenez des risques, faites des erreurs. C'est ainsi que l'on grandit. La douleur nourrit votre courage. Il faut échouer pour s'exercer au courage. -Mary Tyler Moore"
    },
    "2025-10-30": {
        "content": " Ce sur quoi vous vous concentrez, c'est ce que vous obtenez. -Tony Robbins"
    },
    "2025-10-31": {
        "content": " Hustle est le mot le plus important de TOUS LES TEMPS. -Gary Vaynerchuk"
    },
    "2025-11-01": {
        "content": " S'ils peuvent fabriquer de la pénicilline à partir de pain moisi, alors ils peuvent certainement faire quelque chose de vous. -Muhammad Ali"
    },
    "2025-11-02": {
        "content": " Vous n'êtes pas né gagnant, ni perdant. Vous êtes ce que vous décidez d'être. -Lou Holtz"
    },
    "2025-11-03": {
        "content": " Le succès est votre devoir, votre obligation et votre responsabilité. -Grant Cardone"
    },
    "2025-11-04": {
        "content": "Il y a peu de différences entre les gens, mais cette petite différence fait une grande différence. Cette petite différence réside dans l'attitude. La grande différence réside dans son caractère positif ou négatif. -W. Clément Stone"
    },
    "2025-11-05": {
        "content": " Les dirigeants doivent être suffisamment proches des autres pour établir des relations, mais suffisamment en avance pour les motiver. -John C. Maxwell"
    },
    "2025-11-06": {
        "content": " Il ne faut jamais dire jamais, car les limites, comme les peurs, ne sont souvent qu’une illusion. -Michael Jordan"
    },
    "2025-11-07": {
        "content": " Vous devez attendre de grandes choses de vous-même avant de pouvoir les réaliser. -Michael Jordan"
    },
    "2025-11-08": {
        "content": " Dans le monde des affaires, les personnes qui réussissent le mieux sont celles qui font ce qu’elles aiment. -Warren Buffett"
    },
    "2025-11-09": {
        "content": " L’action détruira votre procrastination. -Og Mandino"
    },
    "2025-11-10": {
        "content": " L'échec n'est pas une option pour moi. Le succès est tout ce que j'envisage. -Conor McGregor"
    },
    "2025-11-11": {
        "content": " Le succès ne vient pas de ce que vous faites occasionnellement, mais de ce que vous faites régulièrement. -Marie Forleo"
    },
    "2025-11-12": {
        "content": " La confiance et le travail acharné sont les meilleurs remèdes contre l'échec. Ils feront de vous une personne accomplie. -Abdul Kalam"
    },
    "2025-11-13": {
        "content": " Si tu veux briller comme le soleil, brûle d'abord comme le soleil. -Abdul Kalam"
    },
    "2025-11-14": {
        "content": "Pendant que vous faites la fête et vous amusez, quelqu'un travaille dur. Quelqu'un devient plus intelligent et quelqu'un gagne. Souvenez-vous-en. -Arnold Schwarzenegger"
    },
    "2025-11-15": {
        "content": " Si vous faites ce que vous avez toujours fait, vous obtiendrez ce que vous avez toujours obtenu. -Tony Robbins"
    },
    "2025-11-16": {
        "content": " Le progrès est synonyme de bonheur. -Tony Robbins"
    },
    "2025-11-17": {
        "content": " On peut avoir des résultats ou des excuses. Pas les deux. -Arnold Schwarzenegger"
    },
    "2025-11-18": {
        "content": " La discipline est synonyme de liberté. -Jocko Willink"
    },
    "2025-11-19": {
        "content": " Ne vous attardez pas sur ce qui a mal tourné. Concentrez-vous plutôt sur la suite des événements. Consacrez votre énergie à avancer, à trouver la solution. -Denis Waitley"
    },
    "2025-11-20": {
        "content": " Soyez le leader que vous auriez aimé avoir. -Simon Sinek"
    },
    "2025-11-21": {
        "content": " Mon attitude est que si vous me poussez vers quelque chose que vous pensez être une faiblesse, alors je transformerai cette faiblesse perçue en une force. -Michael Jordan"
    },
    "2025-11-22": {
        "content": " Le plus grand danger pour la plupart d’entre nous ne réside pas dans le fait de fixer des objectifs trop élevés et de ne pas les atteindre, mais dans le fait de fixer des objectifs trop bas et d’atteindre notre objectif. -Michel-Ange"
    },
    "2025-11-23": {
        "content": " Tout le monde a un rêve, mais tout le monde n’a pas de motivation. -Éric Thomas"
    },
    "2025-11-24": {
        "content": "On devient leader, on ne naît pas leader. On le devient au prix d'efforts acharnés, prix que chacun de nous doit payer pour atteindre un objectif qui en vaut la peine. -Vince Lombardi"
    },
    "2025-11-25": {
        "content": " Nous avons choisi d'aller sur la Lune cette décennie et de faire le reste. Non pas parce que c'est facile, mais parce que c'est difficile. -John F. Kennedy"
    },
    "2025-11-26": {
        "content": " Le plus beau jour de votre vie et de la mienne est celui où nous assumons pleinement la responsabilité de nos attitudes. C'est le jour où nous grandissons vraiment. -John C. Maxwell"
    },
    "2025-11-27": {
        "content": " Chaque fois que vous souriez à quelqu’un, c’est un acte d’amour, un cadeau fait à cette personne, une belle chose. -Mère Teresa"
    },
    "2025-11-28": {
        "content": " Soyez l'observateur silencieux de vos pensées et de votre comportement. Vous êtes sous le penseur. Vous êtes le calme sous le bruit mental. Vous êtes l'amour et la joie sous la douleur. -Eckhart Tolle"
    },
    "2025-11-29": {
        "content": " Si vous ne pouvez pas voler, courez, si vous ne pouvez pas courir, marchez, si vous ne pouvez pas marcher, rampez, mais quoi que vous fassiez, vous devez continuer à avancer. -Martin Luther King Jr."
    },
    "2025-11-30": {
        "content": " Le pardon n’est pas un acte occasionnel, c’est une attitude constante. -Martin Luther King Jr."
    },
    "2025-12-01": {
        "content": " Trop souvent, nous sous-estimons le pouvoir d’un contact, d’un sourire, d’un mot gentil, d’une oreille attentive, d’un compliment honnête ou du plus petit acte d’attention, qui ont tous le potentiel de changer une vie. -Léo Buscaglia"
    },
    "2025-12-02": {
        "content": "Gardez vos rêves en vie. Comprenez que pour réussir quoi que ce soit, il faut avoir foi en soi, une vision, du travail acharné, de la détermination et du dévouement. N'oubliez pas que tout est possible à ceux qui y croient. -Gail Devers"
    },
    "2025-12-03": {
        "content": " Le sport a le pouvoir de changer le monde. Il a le pouvoir d'inspirer. Il a le pouvoir d'unir les gens comme peu d'autres le font. Il parle aux jeunes dans un langage qu'ils comprennent. Le sport peut créer de l'espoir là où il n'y avait autrefois que désespoir. -Nelson Mandela"
    },
    "2025-12-04": {
        "content": " Demandez ce que vous voulez. Croyez que vous le méritez, et laissez la vie vous l'accorder. -Louise Hay"
    },
    "2025-12-05": {
        "content": " Vivez avec intention. Allez jusqu'au bout. Écoutez attentivement. Pratiquez le bien-être. Jouez avec abandon. Riez. Choisissez sans regret. Appréciez vos amis. Continuez à apprendre. Faites ce que vous aimez. Vivez comme si c'était tout ce qu'il y avait. -Mary Anne Radmacher"
    },
    "2025-12-06": {
        "content": " Ce sur quoi vous vous concentrez s’étend, et lorsque vous vous concentrez sur la bonté dans votre vie, vous en créez davantage. -Oprah Winfrey"
    },
    "2025-12-07": {
        "content": " Vous avez le pouvoir sur votre esprit, et non sur les événements extérieurs. Prenez-en conscience et vous trouverez la force. -Marc Aurèle"
    },
    "2025-12-08": {
        "content": "Ne cherchez pas d'excuses pour ne pas y arriver. Concentrez-vous sur toutes les raisons pour lesquelles vous devez y parvenir. -Ralph Marston"
    },
    "2025-12-09": {
        "content": " Là où il y a de l'amour, il y a de la vie. -Mahatma Gandhi"
    },
    "2025-12-10": {
        "content": " Tu dois danser comme si personne ne te regardait, aimer comme si tu ne souffrirais jamais, chanter comme si personne ne t'écoutait et vivre comme si c'était le paradis sur terre. -William W. Purkey"
    },
    "2025-12-11": {
        "content": " Le succès consiste à connaître votre objectif dans la vie, à grandir pour atteindre votre potentiel maximum et à semer des graines qui profitent aux autres. -John C. Maxwell"
    },
    "2025-12-12": {
        "content": " Un rêve que l'on fait seul n'est qu'un rêve. Un rêve que l'on fait ensemble est réalité. -John Lennon"
    },
    "2025-12-13": {
        "content": " Le véritable secret de la vie est de s'investir pleinement dans ce que l'on fait, ici et maintenant. Et au lieu de considérer cela comme du travail, réalisez que c'est un jeu. -Alan Watts"
    },
    "2025-12-14": {
        "content": " Hier est passé. Demain n'est pas encore arrivé. Il ne nous reste qu'aujourd'hui. Commençons. -Mère Teresa"
    },
    "2025-12-15": {
        "content": " Plus vous louez et célébrez votre vie, plus il y a de choses à célébrer dans la vie. -Oprah Winfrey"
    },
    "2025-12-16": {
        "content": "Ne doutez jamais qu'un petit groupe de citoyens réfléchis et engagés puisse changer le monde. C'est d'ailleurs la seule chose qui y soit jamais parvenue. -Margaret Mead"
    },
    "2025-12-17": {
        "content": " Poussez-vous, car personne d’autre ne le fera à votre place. -Anonyme"
    },
    "2025-12-18": {
        "content": " La véritable humilité ne consiste pas à penser moins à soi-même ; c’est à penser moins à soi-même. -CS Lewis"
    },
    "2025-12-19": {
        "content": " Si vous pouvez changer d’avis, vous pouvez changer votre vie. -William James"
    },
    "2025-12-20": {
        "content": " Concentrez-vous sur l’endroit où vous voulez aller, pas sur ce que vous craignez. -Tony Robbins"
    },
    "2025-12-21": {
        "content": " Respectez-vous et les autres vous respecteront. -Confucius"
    },
    "2025-12-22": {
        "content": " Faites ce que vous pouvez, avec ce que vous avez, là où vous êtes. -Théodore Roosevelt"
    },
    "2025-12-23": {
        "content": " Certains changements semblent négatifs à première vue, mais vous réaliserez bientôt qu’un espace est créé dans votre vie pour que quelque chose de nouveau émerge. -Eckhart Tolle"
    },
    "2025-12-24": {
        "content": " Si vos actions inspirent les autres à rêver davantage, à apprendre davantage, à faire davantage et à devenir davantage, vous êtes un leader. -John Quincy Adams"
    },
    "2025-12-25": {
        "content": " Ne vous inquiétez de rien, tout ira bien. -Bob Marley"
    },
    "2025-12-26": {
        "content": " Rêvez grand, restez positif, travaillez dur et profitez du voyage. -Urie Faber"
    },
    "2025-12-27": {
        "content": "Vous êtes ici pour permettre au dessein divin de l'Univers de se réaliser. C'est dire votre importance ! -Eckhart Tolle"
    },
    "2025-12-28": {
        "content": " Vivez avec passion ! -Tony Robbins"
    },
    "2025-12-29": {
        "content": " Croyez que vous pouvez y arriver et vous y êtes déjà à mi-chemin. -Théodore Roosevelt"
    },
    "2025-12-30": {
        "content": " Nos vies commencent à se terminer le jour où nous devenons silencieux sur des choses qui comptent. -Martin Luther King Jr."
    },
    "2025-12-31": {
        "content": " Ensemble, nous pouvons faire de grandes choses. -Mère Teresa"
    },
    "2026-01-01": {
        "content": " Travailler dur pour quelque chose qui ne nous intéresse pas s'appelle du stress ; travailler dur pour quelque chose que nous aimons s'appelle de la passion. -Simon Sinek"
    },
    "2026-01-02": {
        "content": " La grotte dans laquelle vous avez peur d’entrer contient le trésor que vous recherchez. -Joseph Campbell"
    },
    "2026-01-03": {
        "content": " Le leadership est une question d'empathie. C'est la capacité à établir des liens avec les autres afin de les inspirer et de les valoriser. -Oprah Winfrey"
    },
    "2026-01-04": {
        "content": " Il n’y a rien d’impossible à celui qui essaie. -Alexandre le Grand"
    },
    "2026-01-05": {
        "content": " La plupart des choses importantes dans le monde ont été accomplies par des gens qui ont continué à essayer alors qu’il semblait n’y avoir aucun espoir. -Dale Carnegie"
    },
    "2026-01-06": {
        "content": " Nous continuons d'avancer, d'ouvrir de nouvelles portes et de faire de nouvelles choses, parce que nous sommes curieux et que la curiosité nous conduit sans cesse sur de nouveaux chemins. -Walt Disney"
    },
    "2026-01-07": {
        "content": "Faites ce que vous avez à faire jusqu’à ce que vous puissiez faire ce que vous voulez faire. -Oprah Winfrey"
    },
    "2026-01-08": {
        "content": " Croire que vous êtes suffisant est ce qui vous donne le courage d’être authentique. -Brené Brown"
    },
    "2026-01-09": {
        "content": " Ce sont nos choix, Harry, qui montrent ce que nous sommes vraiment, bien plus que nos capacités. -J.K. Rowling"
    },
    "2026-01-10": {
        "content": " Suivez votre bonheur et l’univers vous ouvrira des portes là où il n’y avait que des murs. -Joseph Campbell"
    },
    "2026-01-11": {
        "content": " Les rêves ne sont pas ceux qui nous viennent pendant que nous dormons, mais les rêves sont ceux que nous ne dormons pas avant de réaliser. -Abdul Kalam"
    },
    "2026-01-12": {
        "content": " Oser, c'est avoir le courage d'être vulnérable. C'est se montrer et être vu. Demander ce dont on a besoin. Parler de ce qu'on ressent. Avoir des conversations difficiles. -Brené Brown"
    },
    "2026-01-13": {
        "content": " Vous ne réussirez jamais tant que vous ne transformerez pas votre souffrance en grandeur, tant que vous ne la laisserez pas vous pousser de là où vous êtes pour vous propulser là où vous devez être. Arrêtez de fuir votre souffrance et acceptez-la. Elle fera partie de votre récompense, de votre produit. Je vous mets au défi de vous dépasser. -Éric Thomas"
    },
    "2026-01-14": {
        "content": " Nous sommes ce que nous faisons de manière répétée. L'excellence n'est donc pas un acte, mais une habitude. -Aristote"
    },
    "2026-01-15": {
        "content": " Une rivière traverse la roche, non pas en raison de sa puissance, mais en raison de sa persistance. -Jim Watkins"
    },
    "2026-01-16": {
        "content": " L’énergie et la persévérance triomphent de toutes choses. -Benjamin Franklin"
    },
    "2026-01-17": {
        "content": " Les opportunités sont généralement déguisées en travail acharné, de sorte que la plupart des gens ne les reconnaissent pas. -Ann Landers"
    },
    "2026-01-18": {
        "content": " Si vous ne pouvez pas voler, courez, si vous ne pouvez pas courir, marchez, si vous ne pouvez pas marcher, rampez, mais quoi que vous fassiez, vous devez continuer à avancer. -Martin Luther King Jr."
    },
    "2026-01-19": {
        "content": " La persévérance garantit que les résultats sont inévitables. -Paramahansa Yogananda"
    },
    "2026-01-20": {
        "content": " Avec un talent ordinaire et une persévérance extraordinaire, tout est réalisable -Thomas Fowell Buxton"
    },
    "2026-01-21": {
        "content": " Notre plus grande gloire n’est pas de ne jamais échouer, mais de nous relever chaque fois que nous échouons. -Ralph Waldo Emerson"
    },
    "2026-01-22": {
        "content": " Le succès consiste à trébucher d’échec en échec sans perdre son enthousiasme. -Winston Churchill"
    },
    "2026-01-23": {
        "content": "Heureusement, la persévérance est un excellent substitut au talent. -Steve Martin"
    },
    "2026-01-24": {
        "content": " Je crois davantage à la chance, et je trouve que plus je travaille dur, plus j'en ai. -Thomas Jefferson"
    },
    "2026-01-25": {
        "content": " Ne remettez à demain que ce que vous seriez prêt à mourir sans avoir fait. -Pablo Picasso"
    },
    "2026-01-26": {
        "content": " Il n'y a pas de secret pour réussir : ne perdez pas de temps à le chercher. Le succès est le fruit de la perfection, du travail acharné, de l'apprentissage de l'échec, de la loyauté envers ceux pour qui vous travaillez et de la persévérance. -Colin Powell"
    },
    "2026-01-27": {
        "content": " Si vous souhaitez être devant, agissez comme si vous étiez derrière. -Lao Tseu"
    },
    "2026-01-28": {
        "content": " Laissez-moi vous révéler le secret qui m’a conduit à mon objectif : ma force réside uniquement dans ma ténacité. -Louis Pasteur"
    },
    "2026-01-29": {
        "content": " Rien au monde ne peut remplacer la persévérance. Le talent ne le fera pas ; rien n'est plus commun que les personnes talentueuses et incompétentes. Le génie ne le fera pas ; le génie non récompensé est presque un proverbe. -Calvin Coolidge"
    },
    "2026-01-30": {
        "content": " La meilleure issue est toujours de passer à travers. -Robert Frost"
    },
    "2026-01-31": {
        "content": "Beaucoup d’échecs dans la vie sont dus à des personnes qui n’ont pas réalisé à quel point elles étaient proches du succès lorsqu’elles ont abandonné. -Thomas A. Edison"
    },
    "2026-02-01": {
        "content": " Nous sommes faits pour persévérer. C'est ainsi que nous découvrons qui nous sommes. -Tobias Wolff"
    },
    "2026-02-02": {
        "content": " Connaissant les arbres, je comprends le sens de la patience. Connaissant l'herbe, j'apprécie la persévérance. -Hal Borland"
    },
    "2026-02-03": {
        "content": " L'eau qui coule creuse la pierre, non pas par la force mais par la persistance. -Ovide"
    },
    "2026-02-04": {
        "content": " La persévérance est essentielle. N'abandonnez pas, sauf si vous y êtes contraint. -Elon Musk"
    },
    "2026-02-05": {
        "content": " Un enthousiasme débordant, soutenu par le bon sens et la persévérance, est la qualité qui conduit le plus souvent au succès. -Dale Carnegie"
    },
    "2026-02-06": {
        "content": " L'ambition est la voie du succès. La persévérance est le véhicule qui y conduit. -Bill Bradley"
    },
    "2026-02-07": {
        "content": " Concentrez-vous sur la solution, pas sur le problème. -Walter Anderson"
    },
    "2026-02-08": {
        "content": " Lorsque la vie vous fait tomber, vous avez deux choix : rester à terre ou vous relever. -Tom Krause"
    },
    "2026-02-09": {
        "content": "Le succès est la somme de petits efforts, répétés jour après jour. -Robert Collier"
    },
    "2026-02-10": {
        "content": " Un rêve n'est qu'un rêve. Un objectif est un rêve avec un plan et une échéance. -Harvey MacKay"
    },
    "2026-02-11": {
        "content": " N'abandonnez jamais quelque chose auquel vous ne pouvez pas passer une journée sans penser. -Winston Churchill"
    },
    "2026-02-12": {
        "content": " Les diamants ne sont rien d’autre que des morceaux de charbon qui restent collés à leur travail. -Malcolm S. Forbes"
    },
    "2026-02-13": {
        "content": " On ne peut rien faire d'autre que petit à petit. -Charles Baudelaire"
    },
    "2026-02-14": {
        "content": " Si vous traversez l’enfer, continuez. -Winston Churchill"
    },
    "2026-02-15": {
        "content": " La clé de la persévérance ouvre toutes les portes fermées par la résistance. -John Di Lemme"
    },
    "2026-02-16": {
        "content": " Si nous regardons ceux qui réussissent le mieux dans le monde, la persévérance est le dénominateur commun. -Justin Sachs"
    },
    "2026-02-17": {
        "content": " Vous pouvez manger un éléphant petit à petit. -Mary Kay Ash"
    },
    "2026-02-18": {
        "content": " Je ne pense pas qu'il existe une qualité aussi essentielle à la réussite, quelle qu'elle soit, que la persévérance. Elle permet de surmonter presque tout, même la nature. -John D. Rockefeller"
    },
    "2026-02-19": {
        "content": "Si vous voulez transformer une vision en réalité, vous devez vous donner à 100 % et ne jamais cesser de croire en votre rêve. -Arnold Schwarzenegger"
    },
    "2026-02-20": {
        "content": " Courez quand vous le pouvez, marchez si vous le devez, rampez si vous le devez ; n'abandonnez jamais. -Doyen Karnazes"
    },
    "2026-02-21": {
        "content": " Faire un tour de plus quand vous pensez ne pas pouvoir le faire, c'est ce qui fait toute la différence dans votre vie. -Sylvester Stallone"
    },
    "2026-02-22": {
        "content": " Écoutez-moi, même quand on perd, c'est normal de perdre, mais on ne peut jamais s'y habituer. On ne peut jamais se satisfaire de perdre. Quand on perd, ça fait forcément mal. -Éric Thomas"
    },
    "2026-02-23": {
        "content": " Continuez à marcher, un pas à la fois. -Joyce Meyer"
    },
    "2026-02-24": {
        "content": " Nous ne devons pas abandonner et ne devons pas laisser le problème nous vaincre. -Abdul Kalam"
    },
    "2026-02-25": {
        "content": " C'est par l'endurance que nous conquérons. -Ernest Shackleton"
    },
    "2026-02-26": {
        "content": "Les murs de briques existent pour une raison. Ils ne sont pas là pour nous empêcher d'accéder à quelque chose. Ils sont là pour nous permettre de montrer à quel point nous le désirons. Parce qu'ils sont là pour arrêter ceux qui ne le désirent pas suffisamment. Ils sont là pour arrêter les autres. -Randy Pausch"
    },
    "2026-02-27": {
        "content": " Le succès dépend presque entièrement de la motivation et de la persévérance. L'énergie supplémentaire nécessaire pour redoubler d'efforts ou tenter une nouvelle approche est le secret de la victoire. -Denis Waitley"
    },
    "2026-02-28": {
        "content": " J'étais arrivé jusqu'ici et j'avais refusé d'abandonner car toute ma vie j'avais toujours terminé la course. -Louis Zamperini"
    },
    "2026-03-01": {
        "content": " La survie peut se résumer en trois mots : ne jamais abandonner. C'est le cœur du problème. Continuer d'essayer. -Bear Grylls"
    },
    "2026-03-02": {
        "content": "PLUS JAMAIS. Plus d'excuses. Plus de : « Je commence demain. » Plus de : « Juste pour cette fois. » Plus besoin d'accepter mes propres échecs. Plus besoin de prendre la facilité. Plus besoin de m'incliner devant les pensées malsaines ou improductives qui me traversent l'esprit. -Jocko Willink"
    },
    "2026-03-03": {
        "content": " De petits coups ont fait tomber de grands chênes. -Benjamin Franklin"
    },
    "2026-03-04": {
        "content": " « Je suis prêt. » « Je suis fait pour gagner. » « J'y suis parvenu. » « J'accepte l'incertitude. » « Je ne suis pas mes pensées ; je suis ce que je fais. » « Je suis acharné. » « Je n'attends rien et j'accepte tout. -Gary John Bishop"
    },
    "2026-03-05": {
        "content": " Je n'ai pas échoué 700 fois. Je n'ai pas échoué une seule fois. J'ai réussi à prouver que ces 700 méthodes ne fonctionneront pas. Une fois que j'aurai éliminé celles qui ne fonctionneront pas, je trouverai celle qui fonctionnera. -Thomas A. Edison"
    },
    "2026-03-06": {
        "content": " GRIT signifie courage, résilience, assiduité et ténacité. GRIT, c'est la capacité à se concentrer, à rester déterminé, à rester optimiste face aux défis et à travailler plus dur que ses pairs. -Linda Kaplan Thaler"
    },
    "2026-03-07": {
        "content": "Je pense que mon secret est qu'il n'y a pas de raccourcis pour travailler dur, être déterminé et avoir cette attitude de « ne pas abandonner ». -Jerry Rice"
    },
    "2026-03-08": {
        "content": " Ne cessez jamais de vous battre jusqu'à atteindre votre destinée, c'est-à-dire votre moi unique. Ayez un but dans la vie, acquérez continuellement des connaissances, travaillez dur et persévérez pour réaliser une vie formidable. -Abdul Kalam"
    },
    "2026-03-09": {
        "content": " Ne vous arrêtez pas quand vous êtes fatigué. Arrêtez-vous quand vous avez terminé. -David Goggins"
    },
    "2026-03-10": {
        "content": " Ne me jugez pas sur mes succès, jugez-moi sur le nombre de fois où je suis tombé et me suis relevé. -Nelson Mandela"
    },
    "2026-03-11": {
        "content": " Ce qui n'est pas commencé aujourd'hui n'est jamais terminé demain. -Johann Wolfgang von Goethe"
    },
    "2026-03-12": {
        "content": " Si vous écrivez une centaine de nouvelles et qu'elles sont toutes mauvaises, cela ne signifie pas que vous avez échoué. Vous échouez seulement si vous arrêtez d'écrire. -Ray Bradbury"
    },
    "2026-03-13": {
        "content": " Le maître a échoué plus de fois que le débutant n’a essayé. -Stephen McCranie"
    },
    "2026-03-14": {
        "content": " Au diable les circonstances ; je crée des opportunités. -Bruce Lee"
    },
    "2026-03-15": {
        "content": "La seule chose pire que de commencer quelque chose et d’échouer, c’est de ne rien commencer. -Seth Godin"
    },
    "2026-03-16": {
        "content": " Ne remettez jamais à demain ce que vous pouvez faire aujourd’hui. -Benjamin Franklin"
    },
    "2026-03-17": {
        "content": " Grâce à sa persévérance, l'escargot atteignit l'arche. -Charles H. Spurgeon"
    },
    "2026-03-18": {
        "content": " N'oubliez pas que l'espoir est une bonne chose, peut-être la meilleure des choses, et qu'aucune bonne chose ne meurt jamais. -Stephen King"
    },
    "2026-03-19": {
        "content": " Les entrepreneurs ne finissent pas quand ils sont fatigués. Ils finissent quand ils ont fini. -Robert T. Kiyosaki"
    },
    "2026-03-20": {
        "content": " Seules la persévérance et la détermination sont omnipotentes. -Calvin Coolidge"
    },
    "2026-03-21": {
        "content": " Paralyser la résistance par la persévérance. -Woody Hayes"
    },
    "2026-03-22": {
        "content": " Le succès n’est jamais possédé, il est loué, et le loyer est dû chaque jour. -Rory Vaden"
    },
    "2026-03-23": {
        "content": " Le succès n'est pas le fruit du hasard. C'est le fruit du travail, de la persévérance, de l'apprentissage, des études, du sacrifice et, surtout, de l'amour de ce que l'on fait ou apprend à faire. -Pelé"
    },
    "2026-03-24": {
        "content": " Il n'y a pas d'autre solution que de travailler dur. Acceptez-le. -Roger Federer"
    },
    "2026-03-25": {
        "content": " Un rêve ne devient pas réalité par magie ; il faut de la sueur, de la détermination et du travail acharné. -Colin Powell"
    },
    "2026-03-26": {
        "content": "L’apprentissage n’épuise jamais l’esprit. -Léonard de Vinci"
    },
    "2026-03-27": {
        "content": " J'entends et j'oublie. Je vois et je me souviens. Je fais et je comprends. -Confucius"
    },
    "2026-03-28": {
        "content": " Celui qui n’a jamais fait d’erreur n’a jamais rien essayé de nouveau. -Albert Einstein"
    },
    "2026-03-29": {
        "content": " Essayez d’apprendre quelque chose sur tout et tout sur quelque chose. -Thomas Henry Huxley"
    },
    "2026-03-30": {
        "content": " Un homme n’apprend que de deux manières : l’une en lisant, l’autre en fréquentant des personnes plus intelligentes. -Will Rogers"
    },
    "2026-03-31": {
        "content": " Vous ne comprenez rien tant que vous ne l’apprenez pas de plusieurs manières. -Marvin Minsky"
    },
    "2026-04-01": {
        "content": " Dis-moi et j'oublie, enseigne-moi et je me souviendrai, implique-moi et j'apprends. -Benjamin Franklin"
    },
    "2026-04-02": {
        "content": " Si vous voulez augmenter votre taux de réussite, doublez votre taux d’échec. -Thomas J. Watson"
    },
    "2026-04-03": {
        "content": " L'intelligence est ce que vous utilisez lorsque vous ne savez pas quoi faire. -Jean Piaget"
    },
    "2026-04-04": {
        "content": " Les analphabètes du XXIe siècle ne seront pas ceux qui ne savent ni lire ni écrire, mais ceux qui ne savent pas apprendre, désapprendre et réapprendre. -Alvin Toffler"
    },
    "2026-04-05": {
        "content": "C’est ce que nous savons déjà qui nous empêche souvent d’apprendre. -Claude Bernard"
    },
    "2026-04-06": {
        "content": " Les mathématiques sont le langage avec lequel Dieu a écrit l’univers. -Galileo Galilei"
    },
    "2026-04-07": {
        "content": " Le but de l’éducation est de transformer les miroirs en fenêtres. -Sydney J. Harris"
    },
    "2026-04-08": {
        "content": " Je n’ai pas peur des tempêtes car j’apprends à naviguer sur mon navire. -Louisa May Alcott"
    },
    "2026-04-09": {
        "content": " La seule personne éduquée est celle qui a appris à apprendre et à changer. -Carl R. Rogers"
    },
    "2026-04-10": {
        "content": " Je n’ai jamais rencontré un homme si ignorant que je ne puisse apprendre quelque chose de lui. -Galileo Galilei"
    },
    "2026-04-11": {
        "content": " Rien ne disparaît jamais tant que nous n’avons pas appris ce que nous devons savoir. -Pema Chödrön"
    },
    "2026-04-12": {
        "content": " C'est en forgeant qu'on devient forgeron. Après une longue période de pratique, notre travail deviendra naturel, habile, rapide et régulier. -Bruce Lee"
    },
    "2026-04-13": {
        "content": " Lorsque vous parlez, vous ne faites que répéter ce que vous savez déjà. Mais si vous écoutez, vous pouvez apprendre quelque chose de nouveau. -Dalaï Lama XIV"
    },
    "2026-04-14": {
        "content": " Efforcez-vous d’atteindre le progrès, pas la perfection. -Anonyme"
    },
    "2026-04-15": {
        "content": "Je fais toujours ce que je ne peux pas encore faire, afin d'apprendre à le faire. -Vincent van Gogh"
    },
    "2026-04-16": {
        "content": " La connaissance rend l’homme inapte à être esclave. -Frédéric Douglass"
    },
    "2026-04-17": {
        "content": " J’ai appris très tôt la différence entre connaître le nom de quelque chose et connaître quelque chose. -Richard P. Feynman"
    },
    "2026-04-18": {
        "content": " La capacité d’apprendre est un don ; la capacité d’apprendre est une compétence ; la volonté d’apprendre est un choix. -Brian Herbert"
    },
    "2026-04-19": {
        "content": " Apprenez tout ce que vous pouvez, à chaque fois que vous le pouvez, de qui vous voulez – il viendra toujours un moment où vous serez reconnaissant de l’avoir fait. -Sarah Caldwell"
    },
    "2026-04-20": {
        "content": " Je n’ai pas une grande opinion d’un homme qui n’est pas plus sage aujourd’hui qu’il ne l’était hier. -Abraham Lincoln"
    },
    "2026-04-21": {
        "content": " La clé du succès réside dans le dévouement à l’apprentissage tout au long de la vie. -Stephen R. Covey"
    },
    "2026-04-22": {
        "content": " Soyez passionné et audacieux. Continuez à apprendre. Vous ne ferez rien d'utile si vous n'apprenez pas. -Satya Nadella"
    },
    "2026-04-23": {
        "content": "L’activité la plus élevée qu’un être humain puisse atteindre est d’apprendre pour comprendre, car comprendre, c’est être libre. -Baruch Spinoza"
    },
    "2026-04-24": {
        "content": " Si vous n'apprenez pas continuellement, les autres vous dépasseront. Le tempérament seul ne suffit pas : il faut beaucoup de curiosité et une très longue durée. -Charlie Munger"
    },
    "2026-04-25": {
        "content": " Une organisation apprenante est une organisation qui développe continuellement sa capacité à créer son avenir. -Pierre Senge"
    },
    "2026-04-26": {
        "content": " Le jour où vous arrêtez d’apprendre est le jour où vous commencez à vous dégrader. -Isaac Asimov"
    },
    "2026-04-27": {
        "content": " L’apprentissage est un ornement dans la prospérité, un refuge dans l’adversité et une provision dans la vieillesse. -Aristote"
    },
    "2026-04-28": {
        "content": " Tous les leaders sont des apprenants. Dès qu'on cesse d'apprendre, on cesse de diriger. J'apprends autant que possible, du plus grand nombre et aussi souvent que possible. -Rick Warren"
    },
    "2026-04-29": {
        "content": " Pour apprendre rapidement des choses difficiles, il faut se concentrer intensément, sans distraction. Apprendre, en d'autres termes, est un travail en profondeur. -Cal Newport"
    },
    "2026-04-30": {
        "content": " N'importe quel imbécile peut savoir. L'important est de comprendre. -Albert Einstein"
    },
    "2026-05-01": {
        "content": "Passez chaque jour à essayer d’être un peu plus sage que vous ne l’étiez à votre réveil. -Charlie Munger"
    },
    "2026-05-02": {
        "content": " Investissez en vous-même, dans votre éducation. Il n'y a rien de mieux. -Sylvia Porter"
    },
    "2026-05-03": {
        "content": " L’auto-éducation est pour moi une source continue de plaisir, car plus j’en sais, plus ma vie est épanouie et plus j’apprécie ma propre existence. -Isaac Asimov"
    },
    "2026-05-04": {
        "content": " Vous pouvez obtenir de l’aide de la part des professeurs, mais vous allez devoir apprendre beaucoup de choses par vous-même, assis seul dans une pièce. -Dr Seuss"
    },
    "2026-05-05": {
        "content": " L’apprentissage se produit lorsque quelqu’un veut apprendre, pas lorsque quelqu’un veut enseigner. -Roger Schank"
    },
    "2026-05-06": {
        "content": " Une personne ne peut pas enseigner directement à une autre personne ; elle ne peut que faciliter l’apprentissage d’une autre personne. -Carl R. Rogers"
    },
    "2026-05-07": {
        "content": " Apprendre n'est pas obligatoire, c'est volontaire. S'améliorer n'est pas obligatoire, c'est volontaire. Mais pour survivre, nous devons apprendre. -W. Edwards Deming"
    },
    "2026-05-08": {
        "content": " Je fais toujours ce que je ne peux pas faire, afin d’apprendre à le faire. -Pablo Picasso"
    },
    "2026-05-09": {
        "content": "Aucun voleur, aussi habile soit-il, ne peut voler la connaissance à quelqu'un, et c'est pourquoi la connaissance est le trésor le meilleur et le plus sûr à acquérir. -L. Frank Baum"
    },
    "2026-05-10": {
        "content": " Je pense que c’est le meilleur conseil : pensez constamment à la façon dont vous pourriez faire les choses mieux et remettez-vous en question. -Elon Musk"
    },
    "2026-05-11": {
        "content": " Un homme sage peut apprendre plus d’une question stupide qu’un imbécile peut apprendre d’une réponse sage. -Bruce Lee"
    },
    "2026-05-12": {
        "content": " Si j'ai vu plus loin, c'est en me tenant sur les épaules des Géants. -Isaac Newton"
    },
    "2026-05-13": {
        "content": " Ce que nous connaissons est une goutte, ce que nous ne connaissons pas est un océan. -Isaac Newton"
    },
    "2026-05-14": {
        "content": " Ce qui est bien avec l’apprentissage, c’est que personne ne peut vous l’enlever. -BB King"
    },
    "2026-05-15": {
        "content": " Si vous voulez devenir écrivain, vous devez faire deux choses avant tout : lire beaucoup et écrire beaucoup. -Stephen King"
    },
    "2026-05-16": {
        "content": " La répétition est la mère de la compétence. -Tony Robbins"
    },
    "2026-05-17": {
        "content": " L’émerveillement est le début de la sagesse. -Socrate"
    },
    "2026-05-18": {
        "content": " Si vous faites une erreur et ne la corrigez pas, cela s’appelle une erreur. -Confucius"
    },
    "2026-05-19": {
        "content": " Le but de l’éducation est de remplacer un esprit vide par un esprit ouvert. -Malcolm S. Forbes"
    },
    "2026-05-20": {
        "content": "Dans la vie, rien n'est à craindre, il faut simplement le comprendre. Il est temps de mieux comprendre, afin d'avoir moins peur. -Marie Curie"
    },
    "2026-05-21": {
        "content": " Lorsqu'on vous demande si vous êtes capable d'effectuer un travail, répondez : « Bien sûr que je peux ! ». Ensuite, mettez-vous au travail et découvrez comment le faire. -Théodore Roosevelt"
    },
    "2026-05-22": {
        "content": " Nous avons tous besoin de commentaires. C'est ainsi que nous progressons. -Bill Gates"
    },
    "2026-05-23": {
        "content": " L’éducation est la clé pour ouvrir le monde, un passeport pour la liberté. -Oprah Winfrey"
    },
    "2026-05-24": {
        "content": " Tout commence par une idée. -Comte Nightingale"
    },
    "2026-05-25": {
        "content": " Le meilleur investissement que vous puissiez faire est en vous-même. -Warren Buffett"
    },
    "2026-05-26": {
        "content": " Ce n'est pas une question d'argent ou de relations. C'est la volonté de travailler et d'apprendre mieux que tout le monde. -Mark Cuban"
    },
    "2026-05-27": {
        "content": " Tant que tu vivras, continue à apprendre à vivre. -Sénèque"
    },
    "2026-05-28": {
        "content": " Pour apprendre à réussir, il faut d’abord apprendre à échouer. -Michael Jordan"
    },
    "2026-05-29": {
        "content": " Ne gâchez pas une bonne erreur, apprenez-en. -Robert T. Kiyosaki"
    },
    "2026-05-30": {
        "content": "Pour acquérir la connaissance, il faut étudier ; mais pour acquérir la sagesse, il faut observer. -Marilyn Vos Savant"
    },
    "2026-05-31": {
        "content": " On vit et on apprend. En tout cas, on vit. -Douglas Adams"
    },
    "2026-06-01": {
        "content": " La patience est la compagne de la sagesse. -Saint Augustin"
    },
    "2026-06-02": {
        "content": " Je ne sais qu'une chose, c'est que je ne sais rien. -Socrate"
    },
    "2026-06-03": {
        "content": " La sagesse vient de l'expérience. L'expérience est souvent le résultat d'un manque de sagesse. -Terry Pratchett"
    },
    "2026-06-04": {
        "content": " Nous pouvons juger nos progrès par le courage de nos questions et la profondeur de nos réponses, notre volonté d’accepter ce qui est vrai plutôt que ce qui nous fait du bien. -Carl Sagan"
    },
    "2026-06-05": {
        "content": " Je préfère avoir des questions auxquelles on ne peut pas répondre plutôt que des réponses qu'on ne peut pas remettre en question. -Richard P. Feynman"
    },
    "2026-06-06": {
        "content": " Je suis toujours prêt à apprendre même si je n'aime pas toujours qu'on me enseigne. -Winston Churchill"
    },
    "2026-06-07": {
        "content": " Celui qui aime la pratique sans théorie est comme le marin qui monte à bord d'un navire sans gouvernail ni boussole et ne sait jamais où il peut jeter son dévolu. -Léonard de Vinci"
    },
    "2026-06-08": {
        "content": " Il vaut mieux créer qu'apprendre. Créer est l'essence même de la vie. -Jules César"
    },
    "2026-06-09": {
        "content": "Ce que fait la main, l'esprit s'en souvient. -Maria Montessori"
    },
    "2026-06-10": {
        "content": " Avancez toujours dans la vie comme si vous aviez quelque chose de nouveau à apprendre, et vous l’apprendrez. -Vernon Howard"
    },
    "2026-06-11": {
        "content": " L’échec est un succès si nous en tirons des leçons. -Malcolm S. Forbes"
    },
    "2026-06-12": {
        "content": " L'éducation est notre meilleure amie. Une personne instruite est respectée partout. L'éducation surpasse la beauté et la jeunesse. -Chanakya"
    },
    "2026-06-13": {
        "content": " Ne pensez pas que ce qui est difficile à maîtriser pour vous est humainement impossible ; mais si une chose est humainement possible, considérez-la comme étant à votre portée. -Marc Aurèle"
    },
    "2026-06-14": {
        "content": " L’apprentissage est un processus constant de découverte – un processus sans fin. -Bruce Lee"
    },
    "2026-06-15": {
        "content": " Être ignorant n’est pas tant une honte que de ne pas vouloir apprendre. -Benjamin Franklin"
    },
    "2026-06-16": {
        "content": " Je suis convaincu que la connaissance est un pouvoir – pour surmonter le passé, pour changer nos propres situations, pour combattre de nouveaux obstacles, pour prendre de meilleures décisions. -Ben Carson"
    },
    "2026-06-17": {
        "content": " En inspirant, j'apaise mon corps et mon esprit. En expirant, je souris. En vivant l'instant présent, je sais que c'est le seul moment. -Thich Nhat Hanh"
    },
    "2026-06-18": {
        "content": "Si vous pensez que vous êtes trop petit pour faire la différence, essayez de dormir avec un moustique. -Dalaï Lama XIV"
    },
    "2026-06-19": {
        "content": " Trop souvent, nous sous-estimons le pouvoir d’un contact, d’un sourire, d’un mot gentil, d’une oreille attentive, d’un compliment honnête ou du plus petit acte d’attention, qui ont tous le potentiel de changer une vie. -Léo Buscaglia"
    },
    "2026-06-20": {
        "content": " La façon dont nous passons nos journées est, bien sûr, la façon dont nous passons nos vies. -Annie Dillard"
    },
    "2026-06-21": {
        "content": " Nourrissez votre esprit de grandes pensées, car vous n’irez jamais plus haut que vous ne le pensez. -Benjamin Disraeli"
    },
    "2026-06-22": {
        "content": " On n'apprend pas à marcher en suivant des règles. On apprend en faisant et en tombant. -Richard Branson"
    },
    "2026-06-23": {
        "content": " Il est impossible de vivre sans échouer à quelque chose, à moins que vous ne viviez avec tant de prudence que vous auriez tout aussi bien pu ne pas vivre du tout, auquel cas vous échouez par défaut. -J.K. Rowling"
    },
    "2026-06-24": {
        "content": " Si tu veux être heureux, sois-le. -Léon Tolstoï"
    },
    "2026-06-25": {
        "content": " Personne ne peut me faire de mal sans ma permission. -Mahatma Gandhi"
    },
    "2026-06-26": {
        "content": " Quand je lâche prise sur ce que je suis, je deviens ce que je pourrais être. -Lao Tseu"
    },
    "2026-06-27": {
        "content": "La raison pour laquelle nous luttons contre l’insécurité est que nous comparons nos coulisses avec les moments forts de tout le monde. -Steven Furtick"
    },
    "2026-06-28": {
        "content": " N'oubliez pas qu'aujourd'hui est le lendemain dont vous vous inquiétiez hier. -Dale Carnegie"
    },
    "2026-06-29": {
        "content": " Nous devons être prêts à abandonner la vie que nous avions planifiée afin d’avoir la vie qui nous attend. -Joseph Campbell"
    },
    "2026-06-30": {
        "content": " Arrête de partir et tu arriveras. Arrête de chercher et tu verras. Arrête de fuir et on te trouvera. -Lao Tseu"
    },
    "2026-07-01": {
        "content": " Une équipe n'est pas un groupe de personnes qui travaillent ensemble. Une équipe est un groupe de personnes qui se font confiance. -Simon Sinek"
    },
    "2026-07-02": {
        "content": " L’optimisme perpétuel est un multiplicateur de force. -Colin Powell"
    },
    "2026-07-03": {
        "content": " Lorsque vous vous contentez d'être simplement vous-même et que vous ne comparez pas ou ne rivalisez pas, tout le monde vous respectera. -Lao Tseu"
    },
    "2026-07-04": {
        "content": " Comptez votre âge en amis, pas en années. Comptez votre vie en sourires, pas en larmes. -John Lennon"
    },
    "2026-07-05": {
        "content": " Donnez à ceux que vous aimez des ailes pour voler, des racines pour revenir et des raisons de rester. -Dalaï Lama XIV"
    },
    "2026-07-06": {
        "content": " La persévérance et l’esprit ont fait des merveilles à toutes les époques. -George Washington"
    },
    "2026-07-07": {
        "content": "Partagez vos connaissances. C'est un moyen d'atteindre l'immortalité. -Dalaï Lama XIV"
    },
    "2026-07-08": {
        "content": " Nous sommes un moyen pour le cosmos de se connaître lui-même. -Carl Sagan"
    },
    "2026-07-09": {
        "content": " Un bon enseignant peut inspirer l’espoir, stimuler l’imagination et inculquer l’amour de l’apprentissage. -Brad Henry"
    },
    "2026-07-10": {
        "content": " L’une des plus grandes découvertes qu’une personne fasse, l’une de ses grandes surprises, est de découvrir qu’elle peut faire ce qu’elle craignait de ne pas pouvoir faire. -Henry Ford"
    },
    "2026-07-11": {
        "content": " À quand remonte la dernière fois où vous avez fait quelque chose pour la première fois ? -John C. Maxwell"
    },
    "2026-07-12": {
        "content": " Si vous n’êtes pas en train de devenir la personne que vous voulez être, vous êtes automatiquement en train de devenir la personne que vous ne voulez pas être. -Dale Carnegie"
    },
    "2026-07-13": {
        "content": " La fortune favorise les audacieux. -Proverbe latin"
    },
    "2026-07-14": {
        "content": " Le succès n'est pas la clé du bonheur. Le bonheur est la clé du succès. Si vous aimez ce que vous faites, vous réussirez. -Albert Schweitzer"
    },
    "2026-07-15": {
        "content": " Ne gagnez pas le monde si vous perdez votre âme ; la sagesse vaut mieux que l'argent ou l'or. -Bob Marley"
    },
    "2026-07-16": {
        "content": " Commencez dès maintenant à vivre et comptez chaque jour comme une vie distincte. -Sénèque"
    },
    "2026-07-17": {
        "content": "À moins que quelqu'un comme vous ne s'en soucie vraiment, rien ne s'améliorera. Ce n'est pas le cas. -Dr Seuss"
    },
    "2026-07-18": {
        "content": " Ils ne savaient pas que c'était impossible alors ils l'ont fait. -Mark Twain"
    },
    "2026-07-19": {
        "content": " Je peux faire des choses que tu ne peux pas faire, tu peux faire des choses que je ne peux pas faire ; ensemble nous pouvons faire de grandes choses. -Mère Teresa"
    },
    "2026-07-20": {
        "content": " La seule chose que nous devons craindre, c’est la peur elle-même. -Franklin D. Roosevelt"
    },
    "2026-07-21": {
        "content": " Rien de grand n’a jamais été accompli sans enthousiasme. -Ralph Waldo Emerson"
    },
    "2026-07-22": {
        "content": " Courage, cher cœur. -CS Lewis"
    },
    "2026-07-23": {
        "content": " La seule façon de donner un sens au changement est de s’y plonger, de bouger avec lui et de rejoindre la danse. -Alan Watts"
    },
    "2026-07-24": {
        "content": " Là où l’attention se porte, l’énergie circule et les résultats se voient. -T. Harv Eker"
    },
    "2026-07-25": {
        "content": " La douleur est temporaire. Elle peut durer une minute, une heure, un jour, voire un an, mais elle finira par s'atténuer et quelque chose d'autre la remplacera. Si j'arrête, en revanche, elle durera éternellement. -Lance Armstrong"
    },
    "2026-07-26": {
        "content": " À chaque promenade dans la nature, on reçoit bien plus que ce que l’on recherche. -John Muir"
    },
    "2026-07-27": {
        "content": "Les gagnants ne sont pas ceux qui n’échouent jamais, mais ceux qui n’abandonnent jamais. -Edwin Louis Cole"
    },
    "2026-07-28": {
        "content": " Au lieu de combattre les ténèbres, vous faites entrer la lumière. -Eckhart Tolle"
    },
    "2026-07-29": {
        "content": " Soyez sans peur dans la poursuite de ce qui enflamme votre âme. -Jennifer Lee"
    },
    "2026-07-30": {
        "content": " Quand les gens vous quittent, laissez-les partir. Votre destin n'est jamais lié à ceux qui vous quittent, et cela ne signifie pas que ce sont de mauvaises personnes. Cela signifie simplement que leur rôle dans votre histoire est terminé. -TD Jakes"
    },
    "2026-07-31": {
        "content": " Le leadership est la capacité de traduire une vision en réalité. -Warren G. Bennis"
    },
    "2026-08-01": {
        "content": " La foi, c'est croire ce que l'on ne voit pas ; la récompense de cette foi, c'est de voir ce que l'on croit. -Saint Augustin"
    },
    "2026-08-02": {
        "content": " Rien n’est impossible à moins que vous ne le pensiez. -Paramahansa Yogananda"
    },
    "2026-08-03": {
        "content": " La seule chose pire que d’être aveugle, c’est d’avoir la vue mais pas de vision. -Hélène Keller"
    },
    "2026-08-04": {
        "content": " Tout a sa beauté, mais tout le monde ne la voit pas. -Confucius"
    },
    "2026-08-05": {
        "content": " Dieu parle dans le silence du cœur. -Mère Teresa"
    },
    "2026-08-06": {
        "content": "L'espoir est cette chose avec des plumes qui se perche dans l'âme - et chante la mélodie sans les paroles - et ne s'arrête jamais du tout. -Emily Dickinson"
    },
    "2026-08-07": {
        "content": " Peu importe le nombre de paroles saintes que vous lisez, peu importe le nombre de paroles que vous prononcez, à quoi vous serviront-elles si vous ne les mettez pas en pratique ? -Bouddha"
    },
    "2026-08-08": {
        "content": " Et d'ailleurs, tout dans la vie est inscriptible si l'on a le courage de le faire et l'imagination nécessaire pour improviser. Le pire ennemi de la créativité, c'est le doute de soi. -Sylvia Plath"
    },
    "2026-08-09": {
        "content": " Rien de ce que nous faisons ne peut changer le passé, mais tout ce que nous faisons change l’avenir. -Ashleigh Brilliant"
    },
    "2026-08-10": {
        "content": " Le leadership est un choix, pas un grade. -Simon Sinek"
    },
    "2026-08-11": {
        "content": " Tout ira bien, tout ira bien et toutes sortes de choses iront bien. -Julien de Norwich"
    },
    "2026-08-12": {
        "content": " Chacun de nous est précieux, du point de vue cosmique. Si un humain n'est pas d'accord avec vous, laissez-le vivre. Dans cent milliards de galaxies, vous n'en trouverez pas d'autre. -Carl Sagan"
    },
    "2026-08-13": {
        "content": " L’intelligence et le caractère : tel est le but de la véritable éducation. -Martin Luther King Jr."
    },
    "2026-08-14": {
        "content": "Plus vous vous perdez dans quelque chose de plus grand que vous, plus vous aurez d’énergie. -Norman Vincent Peale"
    },
    "2026-08-15": {
        "content": " Maîtrisez les fondamentaux et le niveau de tout ce que vous faites augmentera -Michael Jordan"
    },
    "2026-08-16": {
        "content": " Vous ne pouvez pas vivre du tout si vous ne pouvez pas vivre pleinement maintenant. -Alan Watts"
    },
    "2026-08-17": {
        "content": " N’oubliez pas que parfois, ne pas obtenir ce que vous voulez est un merveilleux coup de chance. -Dalaï Lama XIV"
    },
    "2026-08-18": {
        "content": " Faites de votre mieux, puis détendez-vous. Laissez les choses suivre leur cours naturel, plutôt que de les forcer. -Paramahansa Yogananda"
    },
    "2026-08-19": {
        "content": " Vous êtes un être spirituel infini vivant une expérience humaine temporaire. -Wayne W. Dyer"
    },
    "2026-08-20": {
        "content": " Il faut rêver avant que vos rêves puissent se réaliser. -Abdul Kalam"
    },
    "2026-08-21": {
        "content": " Par-dessus tout, garde ton cœur, car tout ce que tu fais découle de lui. -Salomon"
    },
    "2026-08-22": {
        "content": " Je peux tout secouer en écrivant ; mes chagrins disparaissent, mon courage renaît. -Anne Frank"
    },
    "2026-08-23": {
        "content": " L'objectif n'est pas d'être parfait à la fin, mais d'être meilleur aujourd'hui. -Simon Sinek"
    },
    "2026-08-24": {
        "content": " Avancez avec confiance vers vos rêves. Vivez la vie que vous avez imaginée. -Henry David Thoreau"
    },
    "2026-08-25": {
        "content": "Soyez gentil autant que possible. C'est toujours possible. -Dalaï Lama XIV"
    },
    "2026-08-26": {
        "content": " Notre but premier dans la vie est d'aider les autres. Et si vous ne pouvez pas les aider, au moins ne leur faites pas de mal. -Dalaï Lama XIV"
    },
    "2026-08-27": {
        "content": " Tu as un cerveau dans la tête. Tu as les pieds dans les chaussures. Tu peux te diriger dans la direction que tu veux. Tu es seul. Et tu sais ce que tu sais. Et c'est toi qui décides où aller. -Dr Seuss"
    },
    "2026-08-28": {
        "content": " Ce sur quoi vous vous concentrez s’étend, et lorsque vous vous concentrez sur la bonté dans votre vie, vous en créez davantage. -Oprah Winfrey"
    },
    "2026-08-29": {
        "content": " Tout ce que j'ai besoin de savoir m'est révélé. Tout ce dont j'ai besoin vient à moi. Tout va bien dans ma vie. -Louise Hay"
    },
    "2026-08-30": {
        "content": " Je suis en parfaite sécurité dans l'Univers. Je suis en paix partout. J'ai confiance en la vie. -Louise Hay"
    },
    "2026-08-31": {
        "content": " Tournez votre visage vers le soleil et les ombres tombent derrière vous. -Proverbe maori"
    },
    "2026-09-01": {
        "content": " Le courage ne consiste pas à avoir la force de continuer, mais à continuer quand on n'en a pas la force. -Théodore Roosevelt"
    },
    "2026-09-02": {
        "content": " L’avenir dépend de ce que vous faites aujourd’hui. -Mahatma Gandhi"
    },
    "2026-09-03": {
        "content": " Un gagnant est un rêveur qui n’abandonne jamais. -Nelson Mandela"
    },
    "2026-09-04": {
        "content": "Ne pleurez pas parce que c'est fini, souriez parce que c'est arrivé. -Dr Seuss"
    },
    "2026-09-05": {
        "content": " En trois mots, je peux résumer tout ce que j'ai appris sur la vie : elle continue. -Robert Frost"
    },
    "2026-09-06": {
        "content": " Vivez selon votre imagination, pas selon votre histoire. -Stephen R. Covey"
    },
    "2026-09-07": {
        "content": " À mon avis, si vous voulez l’arc-en-ciel, vous devez supporter la pluie. -Dolly Parton"
    },
    "2026-09-08": {
        "content": " La grandeur d’un homme ne réside pas dans la quantité de richesses qu’il acquiert, mais dans son intégrité et sa capacité à influencer positivement ceux qui l’entourent. -Bob Marley"
    },
    "2026-09-09": {
        "content": " Le bonheur vient principalement de notre propre attitude, plutôt que de facteurs externes. -Dalaï Lama XIV"
    },
    "2026-09-10": {
        "content": " Les grands actes sont constitués de petits actes. -Lao Tseu"
    },
    "2026-09-11": {
        "content": " Il n’est jamais trop tard pour être ce que vous auriez pu être. -George Eliot"
    },
    "2026-09-12": {
        "content": " Adopter la bonne attitude peut transformer un stress négatif en un stress positif. -Hans Selye"
    },
    "2026-09-13": {
        "content": " Osez vivre la vie dont vous rêvez. Allez de l'avant et réalisez vos rêves. -Ralph Waldo Emerson"
    },
    "2026-09-14": {
        "content": " Le temps que vous aimez perdre n’est pas du temps perdu. -Bertrand Russell"
    },
    "2026-09-15": {
        "content": "Il suffit d’un peu de vigilance pour voir et découvrir : la vie est en réalité un grand rire cosmique. -Osho"
    },
    "2026-09-16": {
        "content": " Le paradoxe curieux est que lorsque je m’accepte tel que je suis, alors je peux changer. -Carl R. Rogers"
    },
    "2026-09-17": {
        "content": " Faites partie de la solution, pas du problème. -Stephen R. Covey"
    },
    "2026-09-18": {
        "content": " Le secret de la vie est de donner. -Tony Robbins"
    },
    "2026-09-19": {
        "content": " Faites de chaque jour votre chef-d'œuvre. -John Wooden"
    },
    "2026-09-20": {
        "content": " N'abandonnez jamais ce que vous voulez vraiment faire -H. Jackson Brown Jr."
    },
    "2026-09-21": {
        "content": " Ne regarde pas en arrière, tu n’iras pas dans cette direction. -Mary Engelbreit"
    },
    "2026-09-22": {
        "content": " Faites de votre mieux et Dieu fera le reste. -Nick Vujicic"
    },
    "2026-09-23": {
        "content": " Vivez, voyagez, partez à l'aventure, bénissez et ne soyez pas désolé. -Jack Kerouac"
    },
    "2026-09-24": {
        "content": " Au cœur de l'hiver, j'ai découvert qu'il y avait, en moi, un été invincible. Et cela me rend heureuse. Car cela signifie que, quelle que soit la pression exercée par le monde sur moi, il y a en moi quelque chose de plus fort, quelque chose de meilleur, qui me repousse. -Albert Camus"
    },
    "2026-09-25": {
        "content": "Certains pensent que seule une grande puissance peut contenir le mal, mais ce n'est pas ce que j'ai constaté. Ce sont les petits gestes quotidiens des gens ordinaires qui tiennent les ténèbres à distance. De petits gestes de bonté et d'amour. -JRR Tolkien"
    },
    "2026-09-26": {
        "content": " Soyez fidèle dans les petites choses, car c’est en elles que réside votre force. -Mère Teresa"
    },
    "2026-09-27": {
        "content": " Faites de vous une lumière. -Bouddha"
    },
    "2026-09-28": {
        "content": " VISUALISER ! Voyez, ressentez ! C'est ici que l'action commence. -Rhonda Byrne"
    },
    "2026-09-29": {
        "content": " Soyez phénoménal ou soyez oublié ! -Éric Thomas"
    },
    "2026-09-30": {
        "content": " Lorsque vous avez le choix d’avoir raison ou d’être gentil, choisissez d’être gentil. -Wayne W. Dyer"
    },
    "2026-10-01": {
        "content": " Les êtres humains peuvent changer leur vie en modifiant leurs attitudes mentales. -William James"
    },
    "2026-10-02": {
        "content": " La santé est le plus grand bien. -Laozi"
    },
    "2026-10-03": {
        "content": " Que je ne prie pas pour être à l'abri des dangers, mais pour les affronter sans crainte. Que je ne supplie pas pour apaiser ma douleur, mais pour que mon cœur la surmonte. -Rabindranath Tagore"
    },
    "2026-10-04": {
        "content": " Ayez à cœur de faire le bien. Répétez-le encore et encore, et vous serez rempli de joie. -Bouddha"
    },
    "2026-10-05": {
        "content": "Je ne peux pas changer le monde à moi seul, mais je peux jeter une pierre sur les eaux pour créer de nombreuses ondulations. -Mère Teresa"
    },
    "2026-10-06": {
        "content": " Et le jour est venu où le risque de rester enfermé dans un bourgeon était plus douloureux que le risque de fleurir. -Anaïs Nin"
    },
    "2026-10-07": {
        "content": " L'effort humain ne devrait connaître aucune limite. Aussi difficile que puisse paraître la vie, il y a toujours de l'espoir. -Stephen Hawking"
    },
    "2026-10-08": {
        "content": " Et je vous exhorte à remarquer quand vous êtes heureux, et à vous exclamer, à murmurer ou à penser à un moment donné : « Si ce n'est pas agréable, je ne sais pas ce que c'est. » -Kurt Vonnegut"
    },
    "2026-10-09": {
        "content": " C'est votre réaction à l'adversité, et non l'adversité elle-même, qui détermine la manière dont l'histoire de votre vie se développera. -Dieter F. Uchtdorf"
    },
    "2026-10-10": {
        "content": " Ce n'est pas ce que vous avez, qui vous êtes, où vous êtes ou ce que vous faites qui vous rend heureux ou malheureux. C'est ce que vous en pensez. -Dale Carnegie"
    },
    "2026-10-11": {
        "content": " Plus vous lirez, plus vous saurez. Plus vous apprendrez, plus vous visiterez de lieux. -Dr Seuss"
    },
    "2026-10-12": {
        "content": " Tous nos rêves peuvent devenir réalité. -Walt Disney"
    },
    "2026-10-13": {
        "content": "Le privilège d’une vie est d’être qui vous êtes. -Joseph Campbell"
    },
    "2026-10-14": {
        "content": " Personne n’est inutile dans ce monde s’il allège le fardeau d’un autre. -Charles Dickens"
    },
    "2026-10-15": {
        "content": " Trouvez un endroit à l'intérieur où il y a de la joie, et la joie brûlera la douleur. -Joseph Campbell"
    },
    "2026-10-16": {
        "content": " Ne demandez pas ce dont le monde a besoin. Demandez-vous ce qui vous anime et faites-le. Car ce dont le monde a besoin, c'est de plus de personnes qui s'épanouissent. -Howard Thurman"
    },
    "2026-10-17": {
        "content": " Vos sentiments sont vos meilleurs outils pour vous aider à créer votre vie. -Rhonda Byrne"
    },
    "2026-10-18": {
        "content": " Je mérite le meilleur et j'accepte le meilleur maintenant. -Louise Hay"
    },
    "2026-10-19": {
        "content": " Ce n’est pas la quantité que nous donnons qui compte, mais l’amour que nous mettons dans ce don. -Mère Teresa"
    },
    "2026-10-20": {
        "content": " Quand vous voulez réussir autant que vous voulez respirer, alors vous réussirez. -Éric Thomas"
    },
    "2026-10-21": {
        "content": " J'ai détesté chaque minute d'entraînement, mais je me suis dit : « N'abandonne pas. Souffre maintenant et vis le reste de ta vie comme un champion. » -Muhammad Ali"
    },
    "2026-10-22": {
        "content": "Ce n'est pas le critique qui compte, ni celui qui souligne les trébuchements de l'homme fort ou la manière dont l'auteur aurait pu faire mieux. Le mérite revient à l'homme qui est réellement dans l'arène, dont le visage est couvert de sueur, de poussière et de sang ; qui lutte vaillamment ; qui commet des erreurs et échoue encore et encore ; qui connaît les grands enthousiasmes, les grands dévouements, et se dépense pour une noble cause ; qui, s'il gagne, connaît le triomphe d'une grande réussite ; et qui, s'il échoue, échoue au moins en osant beaucoup, de sorte que sa place ne sera jamais parmi ces âmes froides et timides qui ne connaissent ni victoire ni défaite. -Théodore Roosevelt"
    },
    "2026-10-23": {
        "content": " La plus grande aventure que vous puissiez vivre est de vivre la vie de vos rêves. -Oprah Winfrey"
    },
    "2026-10-24": {
        "content": " Sans lutte, il ne peut y avoir de progrès. -Frédéric Douglass"
    },
    "2026-10-25": {
        "content": " Un rêve écrit avec une date devient un objectif. Un objectif décomposé en étapes devient un plan. Un plan suivi d'actions permet à vos rêves de se réaliser. -Greg Reid"
    },
    "2026-10-26": {
        "content": "Faites la seule chose que vous pensez ne pas pouvoir faire. Échouez. Réessayez. Faites mieux la deuxième fois. Les seules personnes qui ne tombent jamais sont celles qui ne montent jamais sur le fil. -Oprah Winfrey"
    },
    "2026-10-27": {
        "content": " Attendez-vous au changement. Analysez le paysage. Saisissez les opportunités. Cessez d'être la pièce d'échecs ; devenez le joueur. À vous de jouer. -Tony Robbins"
    },
    "2026-10-28": {
        "content": " Tu es libre. Tu es puissant. Tu es bon. Tu es amour. Tu as de la valeur. Tu as un but. Tout va bien. -Esther Hicks"
    },
    "2026-10-29": {
        "content": "Si vous désirez une chose au point de vous battre pour elle, de travailler jour et nuit pour elle, de donner votre temps, votre paix et votre sommeil pour elle. Si tout ce dont vous rêvez et planifiez ne concerne que cela et que la vie semble inutile et sans valeur sans cela ; Si vous transpirez, vous inquiétez et planifiez volontiers pour cela et perdez toute votre terreur de l'opposition pour cela ; Si vous poursuivez simplement cette chose que vous voulez avec toute votre capacité, votre force et votre sagacité, votre foi, votre espoir et votre confiance et votre ténacité pour la ténacité ; Si ni le froid ni la pauvreté, la famine ni la goutte, la maladie ni la douleur du corps et de l'esprit ne peuvent vous éloigner de la chose que vous voulez ; Si vous êtes obstiné et sinistre, vous la taillez et l'engendrez, avec l'aide de DIEU vous l'obtiendrez. -Berton Braley"
    },
    "2026-10-30": {
        "content": " Même si vous êtes sur la bonne voie, vous serez renversé si vous restez assis là. -Will Rogers"
    },
    "2026-10-31": {
        "content": " Je pense qu’il est possible pour les gens ordinaires de choisir d’être extraordinaires. -Elon Musk"
    },
    "2026-11-01": {
        "content": " On n'apprend pas à marcher en suivant des règles. On apprend en faisant et en tombant. -Richard Branson"
    },
    "2026-11-02": {
        "content": "Il n'y a pas de talent ici, c'est du travail acharné. C'est une obsession. Le talent n'existe pas, nous sommes tous égaux en tant qu'êtres humains. Tu peux devenir qui tu veux si tu y mets du temps. Tu atteindras le sommet, un point c'est tout. Je n'ai pas de talent, je suis obsédé. -Conor McGregor"
    },
    "2026-11-03": {
        "content": " Un rêve n’est pas ce que vous voyez pendant votre sommeil ; c’est quelque chose qui vous empêche de dormir. -Abdul Kalam"
    },
    "2026-11-04": {
        "content": " Lorsque vous avez épuisé toutes les possibilités, rappelez-vous ceci : vous ne l'avez pas fait. -Thomas A. Edison"
    },
    "2026-11-05": {
        "content": " Prenez des risques, faites des erreurs. C'est ainsi que l'on grandit. La douleur nourrit votre courage. Il faut échouer pour s'exercer au courage. -Mary Tyler Moore"
    },
    "2026-11-06": {
        "content": " Ce sur quoi vous vous concentrez, c'est ce que vous obtenez. -Tony Robbins"
    },
    "2026-11-07": {
        "content": " Hustle est le mot le plus important de TOUS LES TEMPS. -Gary Vaynerchuk"
    },
    "2026-11-08": {
        "content": " S'ils peuvent fabriquer de la pénicilline à partir de pain moisi, alors ils peuvent certainement faire quelque chose de vous. -Muhammad Ali"
    },
    "2026-11-09": {
        "content": " Vous n'êtes pas né gagnant, ni perdant. Vous êtes ce que vous décidez d'être. -Lou Holtz"
    },
    "2026-11-10": {
        "content": " Le succès est votre devoir, votre obligation et votre responsabilité. -Grant Cardone"
    },
    "2026-11-11": {
        "content": "Il y a peu de différences entre les gens, mais cette petite différence fait une grande différence. Cette petite différence réside dans l'attitude. La grande différence réside dans son caractère positif ou négatif. -W. Clément Stone"
    },
    "2026-11-12": {
        "content": " Les dirigeants doivent être suffisamment proches des autres pour établir des relations, mais suffisamment en avance pour les motiver. -John C. Maxwell"
    },
    "2026-11-13": {
        "content": " Il ne faut jamais dire jamais, car les limites, comme les peurs, ne sont souvent qu’une illusion. -Michael Jordan"
    },
    "2026-11-14": {
        "content": " Vous devez attendre de grandes choses de vous-même avant de pouvoir les réaliser. -Michael Jordan"
    },
    "2026-11-15": {
        "content": " Dans le monde des affaires, les personnes qui réussissent le mieux sont celles qui font ce qu’elles aiment. -Warren Buffett"
    },
    "2026-11-16": {
        "content": " L’action détruira votre procrastination. -Og Mandino"
    },
    "2026-11-17": {
        "content": " L'échec n'est pas une option pour moi. Le succès est tout ce que j'envisage. -Conor McGregor"
    },
    "2026-11-18": {
        "content": " Le succès ne vient pas de ce que vous faites occasionnellement, mais de ce que vous faites régulièrement. -Marie Forleo"
    },
    "2026-11-19": {
        "content": " La confiance et le travail acharné sont les meilleurs remèdes contre l'échec. Ils feront de vous une personne accomplie. -Abdul Kalam"
    },
    "2026-11-20": {
        "content": " Si tu veux briller comme le soleil, brûle d'abord comme le soleil. -Abdul Kalam"
    },
    "2026-11-21": {
        "content": "Pendant que vous faites la fête et vous amusez, quelqu'un travaille dur. Quelqu'un devient plus intelligent et quelqu'un gagne. Souvenez-vous-en. -Arnold Schwarzenegger"
    },
    "2026-11-22": {
        "content": " Si vous faites ce que vous avez toujours fait, vous obtiendrez ce que vous avez toujours obtenu. -Tony Robbins"
    },
    "2026-11-23": {
        "content": " Le progrès est synonyme de bonheur. -Tony Robbins"
    },
    "2026-11-24": {
        "content": " On peut avoir des résultats ou des excuses. Pas les deux. -Arnold Schwarzenegger"
    },
    "2026-11-25": {
        "content": " La discipline est synonyme de liberté. -Jocko Willink"
    },
    "2026-11-26": {
        "content": " Ne vous attardez pas sur ce qui a mal tourné. Concentrez-vous plutôt sur la suite des événements. Consacrez votre énergie à avancer, à trouver la solution. -Denis Waitley"
    },
    "2026-11-27": {
        "content": " Soyez le leader que vous auriez aimé avoir. -Simon Sinek"
    },
    "2026-11-28": {
        "content": " Mon attitude est que si vous me poussez vers quelque chose que vous pensez être une faiblesse, alors je transformerai cette faiblesse perçue en une force. -Michael Jordan"
    },
    "2026-11-29": {
        "content": " Le plus grand danger pour la plupart d’entre nous ne réside pas dans le fait de fixer des objectifs trop élevés et de ne pas les atteindre, mais dans le fait de fixer des objectifs trop bas et d’atteindre notre objectif. -Michel-Ange"
    },
    "2026-11-30": {
        "content": " Tout le monde a un rêve, mais tout le monde n’a pas de motivation. -Éric Thomas"
    },
    "2026-12-01": {
        "content": "On devient leader, on ne naît pas leader. On le devient au prix d'efforts acharnés, prix que chacun de nous doit payer pour atteindre un objectif qui en vaut la peine. -Vince Lombardi"
    },
    "2026-12-02": {
        "content": " Nous avons choisi d'aller sur la Lune cette décennie et de faire le reste. Non pas parce que c'est facile, mais parce que c'est difficile. -John F. Kennedy"
    },
    "2026-12-03": {
        "content": " Le plus beau jour de votre vie et de la mienne est celui où nous assumons pleinement la responsabilité de nos attitudes. C'est le jour où nous grandissons vraiment. -John C. Maxwell"
    },
    "2026-12-04": {
        "content": " Chaque fois que vous souriez à quelqu’un, c’est un acte d’amour, un cadeau fait à cette personne, une belle chose. -Mère Teresa"
    },
    "2026-12-05": {
        "content": " Soyez l'observateur silencieux de vos pensées et de votre comportement. Vous êtes sous le penseur. Vous êtes le calme sous le bruit mental. Vous êtes l'amour et la joie sous la douleur. -Eckhart Tolle"
    },
    "2026-12-06": {
        "content": " Si vous ne pouvez pas voler, courez, si vous ne pouvez pas courir, marchez, si vous ne pouvez pas marcher, rampez, mais quoi que vous fassiez, vous devez continuer à avancer. -Martin Luther King Jr."
    },
    "2026-12-07": {
        "content": " Le pardon n’est pas un acte occasionnel, c’est une attitude constante. -Martin Luther King Jr."
    },
    "2026-12-08": {
        "content": " Trop souvent, nous sous-estimons le pouvoir d’un contact, d’un sourire, d’un mot gentil, d’une oreille attentive, d’un compliment honnête ou du plus petit acte d’attention, qui ont tous le potentiel de changer une vie. -Léo Buscaglia"
    },
    "2026-12-09": {
        "content": "Gardez vos rêves en vie. Comprenez que pour réussir quoi que ce soit, il faut avoir foi en soi, une vision, du travail acharné, de la détermination et du dévouement. N'oubliez pas que tout est possible à ceux qui y croient. -Gail Devers"
    },
    "2026-12-10": {
        "content": " Le sport a le pouvoir de changer le monde. Il a le pouvoir d'inspirer. Il a le pouvoir d'unir les gens comme peu d'autres le font. Il parle aux jeunes dans un langage qu'ils comprennent. Le sport peut créer de l'espoir là où il n'y avait autrefois que désespoir. -Nelson Mandela"
    },
    "2026-12-11": {
        "content": " Demandez ce que vous voulez. Croyez que vous le méritez, et laissez la vie vous l'accorder. -Louise Hay"
    },
    "2026-12-12": {
        "content": " Vivez avec intention. Allez jusqu'au bout. Écoutez attentivement. Pratiquez le bien-être. Jouez avec abandon. Riez. Choisissez sans regret. Appréciez vos amis. Continuez à apprendre. Faites ce que vous aimez. Vivez comme si c'était tout ce qu'il y avait. -Mary Anne Radmacher"
    },
    "2026-12-13": {
        "content": " Ce sur quoi vous vous concentrez s’étend, et lorsque vous vous concentrez sur la bonté dans votre vie, vous en créez davantage. -Oprah Winfrey"
    },
    "2026-12-14": {
        "content": " Vous avez le pouvoir sur votre esprit, et non sur les événements extérieurs. Prenez-en conscience et vous trouverez la force. -Marc Aurèle"
    },
    "2026-12-15": {
        "content": "Ne cherchez pas d'excuses pour ne pas y arriver. Concentrez-vous sur toutes les raisons pour lesquelles vous devez y parvenir. -Ralph Marston"
    },
    "2026-12-16": {
        "content": " Là où il y a de l'amour, il y a de la vie. -Mahatma Gandhi"
    },
    "2026-12-17": {
        "content": " Tu dois danser comme si personne ne te regardait, aimer comme si tu ne souffrirais jamais, chanter comme si personne ne t'écoutait et vivre comme si c'était le paradis sur terre. -William W. Purkey"
    },
    "2026-12-18": {
        "content": " Le succès consiste à connaître votre objectif dans la vie, à grandir pour atteindre votre potentiel maximum et à semer des graines qui profitent aux autres. -John C. Maxwell"
    },
    "2026-12-19": {
        "content": " Un rêve que l'on fait seul n'est qu'un rêve. Un rêve que l'on fait ensemble est réalité. -John Lennon"
    },
    "2026-12-20": {
        "content": " Le véritable secret de la vie est de s'investir pleinement dans ce que l'on fait, ici et maintenant. Et au lieu de considérer cela comme du travail, réalisez que c'est un jeu. -Alan Watts"
    },
    "2026-12-21": {
        "content": " Hier est passé. Demain n'est pas encore arrivé. Il ne nous reste qu'aujourd'hui. Commençons. -Mère Teresa"
    },
    "2026-12-22": {
        "content": " Plus vous louez et célébrez votre vie, plus il y a de choses à célébrer dans la vie. -Oprah Winfrey"
    },
    "2026-12-23": {
        "content": "Ne doutez jamais qu'un petit groupe de citoyens réfléchis et engagés puisse changer le monde. C'est d'ailleurs la seule chose qui y soit jamais parvenue. -Margaret Mead"
    },
    "2026-12-24": {
        "content": " Poussez-vous, car personne d’autre ne le fera à votre place. -Anonyme"
    },
    "2026-12-25": {
        "content": " La véritable humilité ne consiste pas à penser moins à soi-même ; c’est à penser moins à soi-même. -CS Lewis"
    },
    "2026-12-26": {
        "content": " Si vous pouvez changer d’avis, vous pouvez changer votre vie. -William James"
    },
    "2026-12-27": {
        "content": " Concentrez-vous sur l’endroit où vous voulez aller, pas sur ce que vous craignez. -Tony Robbins"
    },
    "2026-12-28": {
        "content": " Respectez-vous et les autres vous respecteront. -Confucius"
    },
    "2026-12-29": {
        "content": " Faites ce que vous pouvez, avec ce que vous avez, là où vous êtes. -Théodore Roosevelt"
    },
    "2026-12-30": {
        "content": " Certains changements semblent négatifs à première vue, mais vous réaliserez bientôt qu’un espace est créé dans votre vie pour que quelque chose de nouveau émerge. -Eckhart Tolle"
    },
    "2026-12-31": {
        "content": " Si vos actions inspirent les autres à rêver davantage, à apprendre davantage, à faire davantage et à devenir davantage, vous êtes un leader. -John Quincy Adams"
    }
}
export const dateItalyList = {
    "2024-01-01": {
        "content": " Siamo ciò che facciamo ripetutamente. L'eccellenza, quindi, non è un atto, ma un'abitudine. -Aristotele"
    },
    "2024-01-02": {
        "content": " Un fiume scava la roccia non per la sua potenza, ma per la sua persistenza. -Disegno di Jim Watkins"
    },
    "2024-01-03": {
        "content": " L'energia e la perseveranza conquistano ogni cosa. -Benjamin Franklin"
    },
    "2024-01-04": {
        "content": " Di solito le opportunità sono mascherate da duro lavoro, quindi la maggior parte delle persone non le riconosce. -Ann Landers"
    },
    "2024-01-05": {
        "content": " Se non puoi volare allora corri, se non puoi correre allora cammina, se non puoi camminare allora striscia, ma qualsiasi cosa tu faccia devi continuare ad andare avanti. -Martin Luther King Jr."
    },
    "2024-01-06": {
        "content": " La perseveranza garantisce che i risultati siano inevitabili. -Paramahansa Yogananda"
    },
    "2024-01-07": {
        "content": " Con un talento ordinario e una perseveranza straordinaria, tutto è realizzabile -Thomas Fowell Buxton"
    },
    "2024-01-08": {
        "content": " La nostra più grande gloria non sta nel non fallire mai, ma nel rialzarci ogni volta che falliamo. -Ralph Waldo Emerson"
    },
    "2024-01-09": {
        "content": " Il successo è passare da un fallimento all'altro senza perdere l'entusiasmo. -Winston Churchill"
    },
    "2024-01-10": {
        "content": "Fortunatamente, la perseveranza è un ottimo sostituto del talento. -Steve Martin"
    },
    "2024-01-11": {
        "content": " Credo molto nella fortuna e ho scoperto che più lavoro duramente, più ne ho. -Tommaso Jefferson"
    },
    "2024-01-12": {
        "content": " Rimanda a domani solo ciò che sei disposto a lasciare incompiuto, anche se muori. -Pablo Picasso"
    },
    "2024-01-13": {
        "content": " Non ci sono segreti per il successo: non perdere tempo a cercarli. Il successo è il risultato della perfezione, del duro lavoro, dell'imparare dagli errori, della lealtà verso coloro per cui lavori e della perseveranza. -Colin Powell"
    },
    "2024-01-14": {
        "content": " Se vuoi stare davanti, comportati come se fossi dietro. -Lao Tzu"
    },
    "2024-01-15": {
        "content": " Lasciatemi svelare il segreto che mi ha condotto al mio obiettivo: la mia forza risiede unicamente nella mia tenacia. -Luigi Pasteur"
    },
    "2024-01-16": {
        "content": " Niente al mondo può sostituire la perseveranza. Il talento non lo farà; niente è più comune delle persone senza successo dotate di talento. Il genio non lo farà; il genio non ricompensato è quasi un proverbio. -Calvin Coolidge"
    },
    "2024-01-17": {
        "content": " La via d'uscita migliore è sempre quella di attraversare. -Robert Gelo"
    },
    "2024-01-18": {
        "content": "Molti fallimenti nella vita sono dovuti al fatto che le persone non si sono rese conto di quanto fossero vicine al successo quando hanno rinunciato. -Thomas A. Edison"
    },
    "2024-01-19": {
        "content": " Siamo fatti per persistere. È così che scopriamo chi siamo. -Tobias Wolff"
    },
    "2024-01-20": {
        "content": " Conoscendo gli alberi, capisco il significato della pazienza. Conoscendo l'erba, posso apprezzare la perseveranza. -Hal Borland"
    },
    "2024-01-21": {
        "content": " L'acqua che gocciola scava la pietra, non con la forza ma con la perseveranza. -Ovidio"
    },
    "2024-01-22": {
        "content": " La perseveranza è molto importante. Non dovresti arrenderti a meno che tu non sia costretto a farlo. -Elon Musk"
    },
    "2024-01-23": {
        "content": " Un entusiasmo ardente, sostenuto da buonsenso e perseveranza, è la qualità che più spesso determina il successo. -Dale Carnegie"
    },
    "2024-01-24": {
        "content": " L'ambizione è la strada per il successo. La perseveranza è il veicolo con cui arrivi. -Bill Bradley"
    },
    "2024-01-25": {
        "content": " Concentratevi sulla soluzione, non sul problema. -Walter Anderson"
    },
    "2024-01-26": {
        "content": " Quando la vita ti abbatte hai due scelte: restare giù o rialzarti. -Tom Krause"
    },
    "2024-01-27": {
        "content": "Il successo è la somma di piccoli sforzi, ripetuti giorno dopo giorno. -Robert Collier"
    },
    "2024-01-28": {
        "content": " Un sogno è solo un sogno. Un obiettivo è un sogno con un piano e una scadenza. -Harvey MacKay"
    },
    "2024-01-29": {
        "content": " Non rinunciare mai a qualcosa a cui non puoi passare un giorno senza pensare. -Winston Churchill"
    },
    "2024-01-30": {
        "content": " I diamanti non sono altro che pezzi di carbone rimasti attaccati al loro posto. -Malcolm S. Forbes"
    },
    "2024-01-31": {
        "content": " Non si può fare nulla se non poco alla volta. -Carlo Baudelaire"
    },
    "2024-02-01": {
        "content": " Se stai attraversando l'inferno, continua ad andare avanti. -Winston Churchill"
    },
    "2024-02-02": {
        "content": " La chiave della perseveranza apre tutte le porte chiuse dalla resistenza. -Giovanni Di Lemme"
    },
    "2024-02-03": {
        "content": " Se consideriamo coloro che hanno più successo al mondo, la perseveranza è il denominatore comune. -Giustino Sachs"
    },
    "2024-02-04": {
        "content": " Puoi mangiare un elefante un boccone alla volta. -Mary Kay Ash"
    },
    "2024-02-05": {
        "content": " Non credo che ci sia un'altra qualità così essenziale per il successo di qualsiasi tipo come la qualità della perseveranza. Supera quasi tutto, persino la natura. -John D. Rockefeller"
    },
    "2024-02-06": {
        "content": "Se vuoi trasformare una visione in realtà, devi dare il 100% e non smettere mai di credere nel tuo sogno. -Arnold Schwarzenegger"
    },
    "2024-02-07": {
        "content": " Corri quando puoi, cammina se devi, striscia se devi; ma non arrenderti mai. -Preside Karnazes"
    },
    "2024-02-08": {
        "content": " Fare un altro giro quando pensi di non farcela: questo è ciò che fa la differenza nella tua vita. -Sylvester Stallone"
    },
    "2024-02-09": {
        "content": " Ascoltami, anche quando perdi, va bene perdere, ma non puoi mai sentirti a tuo agio con questo. Non puoi mai essere soddisfatto di perdere. Quando perdi, deve farti male. -Eric Thomas"
    },
    "2024-02-10": {
        "content": " Continua a camminare, un passo alla volta. -Giovedì 13 Novembre 2018"
    },
    "2024-02-11": {
        "content": " Non dobbiamo arrenderci e non dobbiamo permettere che il problema ci sconfigga. -Abdul Kalam"
    },
    "2024-02-12": {
        "content": " Con la perseveranza vinciamo. -Ernest Shackleton"
    },
    "2024-02-13": {
        "content": " muri di mattoni sono lì per un motivo. I muri di mattoni non sono lì per tenerci fuori. I muri di mattoni sono lì per darci la possibilità di mostrare quanto desideriamo qualcosa. Perché i muri di mattoni sono lì per fermare le persone che non la desiderano abbastanza. Sono lì per fermare le altre persone. -Randy Pausch"
    },
    "2024-02-14": {
        "content": " Il successo dipende quasi totalmente dalla spinta e dalla perseveranza. L'energia extra richiesta per fare un altro sforzo o provare un altro approccio è il segreto della vittoria. -Disegno di Denis Waitley"
    },
    "2024-02-15": {
        "content": " Ero arrivato fin lì e mi rifiutavo di arrendermi perché per tutta la vita avevo sempre portato a termine la gara. -Luigi Zamperini"
    },
    "2024-02-16": {
        "content": " La sopravvivenza può essere riassunta in tre parole: non mollare mai. Questo è il nocciolo della questione. Continua a provare. -Orso Grylls"
    },
    "2024-02-17": {
        "content": "BASTA. Niente più scuse. Niente più: \"Comincerò domani\". Niente più: \"Solo questa volta\". Niente più accettare le carenze della mia volontà. Niente più prendere la strada più facile. Niente più inchinarmi a qualsiasi pensiero malsano o improduttivo mi passi per la mente. -Jocko Willink"
    },
    "2024-02-18": {
        "content": " Piccoli colpi abbatterono grandi querce. -Benjamin Franklin"
    },
    "2024-02-19": {
        "content": " \"Sono disposto.\" \"Sono programmato per vincere.\" \"Ce la farò.\" \"Abbraccio l'incertezza.\" \"Non sono i miei pensieri; sono ciò che faccio.\" \"Sono implacabile.\" \"Non mi aspetto nulla e accetto tutto. -Gary John Vescovo"
    },
    "2024-02-20": {
        "content": " Non ho fallito 700 volte. Non ho fallito una volta. Sono riuscito a dimostrare che quei 700 modi non funzioneranno. Quando avrò eliminato i modi che non funzioneranno, troverò il modo che funzionerà. -Thomas A. Edison"
    },
    "2024-02-21": {
        "content": " GRIT è Guts, Resilience, Industriousness e Tenacity. GRIT è la capacità di concentrarsi, di restare determinati, di restare ottimisti di fronte a una sfida e semplicemente di lavorare più duramente del prossimo ragazzo o ragazza. -Linda Kaplan Tallero"
    },
    "2024-02-22": {
        "content": "Penso che il mio segreto sia che non ci sono scorciatoie per il duro lavoro, la determinazione e l'atteggiamento del \"non arrendersi\". -Riso Jerry"
    },
    "2024-02-23": {
        "content": " Non smettere mai di lottare finché non arrivi al tuo posto destinato, ovvero, al tuo unico te. Abbi uno scopo nella vita, acquisisci continuamente conoscenza, lavora sodo e abbi perseveranza per realizzare la grande vita. -Abdul Kalam"
    },
    "2024-02-24": {
        "content": " Non fermarti quando sei stanco. Fermati quando hai finito. -David Goggins"
    },
    "2024-02-25": {
        "content": " Non giudicarmi per i miei successi, giudicami per quante volte sono caduto e mi sono rialzato. -Nelson Mandela"
    },
    "2024-02-26": {
        "content": " Ciò che non si inizia oggi non si finisce domani. -Johann Wolfgang di Goethe"
    },
    "2024-02-27": {
        "content": " Se scrivi cento racconti brevi e sono tutti brutti, non significa che hai fallito. Fallisci solo se smetti di scrivere. -Ray Bradbury"
    },
    "2024-02-28": {
        "content": " Il maestro ha fallito più volte di quante il principiante abbia mai provato. -Stephen McCranie"
    },
    "2024-02-29": {
        "content": " Al diavolo le circostanze: le opportunità le creo io. -Bruce Lee"
    },
    "2024-03-01": {
        "content": "L'unica cosa peggiore che iniziare qualcosa e fallire è non iniziare nulla. -Seth Godin"
    },
    "2024-03-02": {
        "content": " Non rimandare mai a domani quello che puoi fare oggi. -Benjamin Franklin"
    },
    "2024-03-03": {
        "content": " Con perseveranza la lumaca raggiunse l'arca. -Charles H. Spurgeon"
    },
    "2024-03-04": {
        "content": " Ricorda, la speranza è una cosa buona, forse la migliore delle cose, e nessuna cosa buona muore mai. -Stephen Re"
    },
    "2024-03-05": {
        "content": " Gli imprenditori non finiscono quando siamo stanchi. Finiamo quando abbiamo finito. -Robert T. Kiyosaki"
    },
    "2024-03-06": {
        "content": " Solo la perseveranza e la determinazione sono onnipotenti. -Calvin Coolidge"
    },
    "2024-03-07": {
        "content": " Paralizzare la resistenza con la perseveranza. -Giovedì 13 Novembre"
    },
    "2024-03-08": {
        "content": " Il successo non si possiede mai, si affitta, e l'affitto è dovuto ogni giorno. -Rory Vaden"
    },
    "2024-03-09": {
        "content": " Il successo non è un caso. È duro lavoro, perseveranza, apprendimento, studio, sacrificio e, soprattutto, amore per ciò che fai o impari a fare. -Pelé"
    },
    "2024-03-10": {
        "content": " Non c'è modo di aggirare il duro lavoro. Abbraccialo. -Roger Federer"
    },
    "2024-03-11": {
        "content": " Un sogno non diventa realtà per magia; ci vogliono sudore, determinazione e duro lavoro. -Colin Powell"
    },
    "2024-03-12": {
        "content": "Imparare non esaurisce mai la mente. -Leonardo da Vinci"
    },
    "2024-03-13": {
        "content": " Sento e dimentico. Vedo e ricordo. Faccio e capisco. -Confucio"
    },
    "2024-03-14": {
        "content": " Chi non ha mai commesso un errore non ha mai provato nulla di nuovo. -Albert Einstein"
    },
    "2024-03-15": {
        "content": " Cerca di imparare qualcosa su tutto e tutto su qualcosa. -Thomas Henry Huxley"
    },
    "2024-03-16": {
        "content": " L'uomo impara solo in due modi: leggendo e frequentando persone più intelligenti. -Will Rogers"
    },
    "2024-03-17": {
        "content": " Non capisci nulla finché non lo impari in più di un modo. -Marvin Minsky"
    },
    "2024-03-18": {
        "content": " Dimmi e dimentico, insegnami e potrei ricordare, coinvolgimi e imparo. -Benjamin Franklin"
    },
    "2024-03-19": {
        "content": " Se vuoi aumentare il tuo tasso di successo, raddoppia il tuo tasso di fallimento. -Thomas J. Watson"
    },
    "2024-03-20": {
        "content": " L'intelligenza è ciò a cui ricorriamo quando non sappiamo cosa fare. -Jean Piaget"
    },
    "2024-03-21": {
        "content": " Gli analfabeti del XXI secolo non saranno coloro che non sanno leggere e scrivere, ma coloro che non sanno imparare, disimparare e reimparare. -Alvin Toffler"
    },
    "2024-03-22": {
        "content": "Spesso è proprio ciò che già sappiamo a impedirci di imparare. -Claude Bernard"
    },
    "2024-03-23": {
        "content": " La matematica è il linguaggio con cui Dio ha scritto l'universo. -Galileo Galilei"
    },
    "2024-03-24": {
        "content": " Lo scopo dell'istruzione è trasformare gli specchi in finestre. -Sydney J. Harris"
    },
    "2024-03-25": {
        "content": " Non ho paura delle tempeste perché sto imparando a governare la mia nave. -Louisa May Alcott"
    },
    "2024-03-26": {
        "content": " L'unica persona istruita è quella che ha imparato a imparare e a cambiare. -Carl R. Rogers"
    },
    "2024-03-27": {
        "content": " Non ho mai incontrato un uomo così ignorante da non poter imparare qualcosa da lui. -Galileo Galilei"
    },
    "2024-03-28": {
        "content": " Niente scompare finché non ci ha insegnato ciò che dobbiamo sapere. -Pema Chodrön"
    },
    "2024-03-29": {
        "content": " La pratica rende perfetti. Dopo un lungo periodo di pratica, il nostro lavoro diventerà naturale, abile, rapido e costante. -Bruce Lee"
    },
    "2024-03-30": {
        "content": " Quando parli stai solo ripetendo qualcosa che già sai. Ma se ascolti potresti imparare qualcosa di nuovo. -Dalai Lama XIV"
    },
    "2024-03-31": {
        "content": " Impegnati per il progresso, non per la perfezione. -Anonimo"
    },
    "2024-04-01": {
        "content": "Faccio sempre quello che ancora non so fare, per imparare a farlo. -Vincent van Gogh"
    },
    "2024-04-02": {
        "content": " La conoscenza rende l'uomo inadatto a essere schiavo. -Federico Douglass"
    },
    "2024-04-03": {
        "content": " Ho imparato molto presto la differenza tra sapere il nome di qualcosa e conoscere effettivamente qualcosa. -Richard P. Feynman"
    },
    "2024-04-04": {
        "content": " La capacità di imparare è un dono; la capacità di imparare è un'abilità; la volontà di imparare è una scelta. -Brian Herbert"
    },
    "2024-04-05": {
        "content": " Impara tutto quello che puoi, in qualsiasi momento tu possa, da chiunque tu possa: arriverà sempre un momento in cui sarai grato di averlo fatto. -Sarah Caldwell"
    },
    "2024-04-06": {
        "content": " Non ho grande stima di un uomo che oggi non è più saggio di ieri. -Abramo Lincoln"
    },
    "2024-04-07": {
        "content": " La chiave del successo è la dedizione all'apprendimento continuo. -Stephen R. Covey"
    },
    "2024-04-08": {
        "content": " Sii appassionato e audace. Continua sempre a imparare. Smetti di fare cose utili se non impari. -Satya Nadella"
    },
    "2024-04-09": {
        "content": "L'attività più elevata che un essere umano possa raggiungere è imparare per comprendere, perché comprendere significa essere liberi. -Baruch Spinoza"
    },
    "2024-04-10": {
        "content": " Se non continui a imparare, gli altri ti ignoreranno. Il temperamento da solo non basta: hai bisogno di molta curiosità per molto, molto tempo. -Charlie Munger"
    },
    "2024-04-11": {
        "content": " Un'organizzazione che apprende è un'organizzazione che amplia continuamente la propria capacità di creare il proprio futuro. -Pietro Senge"
    },
    "2024-04-12": {
        "content": " Il giorno in cui smetti di imparare è il giorno in cui inizi a decadere. -Isaac Asimov"
    },
    "2024-04-13": {
        "content": " L'apprendimento è un ornamento nella prosperità, un rifugio nelle avversità e una provvista nella vecchiaia. -Aristotele"
    },
    "2024-04-14": {
        "content": " Tutti i leader sono studenti. Nel momento in cui smetti di imparare, smetti di guidare. Imparo il più possibile, da più persone possibili, il più spesso possibile. -Rick Warren"
    },
    "2024-04-15": {
        "content": " Per imparare cose difficili in fretta, devi concentrarti intensamente senza distrazioni. Imparare, in altre parole, è un atto di lavoro profondo. -Cal Newport"
    },
    "2024-04-16": {
        "content": " Anche un idiota può saperlo. Il punto è capire. -Albert Einstein"
    },
    "2024-04-17": {
        "content": "Trascorri ogni giorno cercando di essere un po' più saggio di quando ti sei svegliato. -Charlie Munger"
    },
    "2024-04-18": {
        "content": " Investi in te stesso, nella tua istruzione. Non c'è niente di meglio. -Sylvia Porter"
    },
    "2024-04-19": {
        "content": " L'autoformazione è per me una fonte continua di piacere, perché più so, più piena è la mia vita e più apprezzo la mia esistenza. -Isaac Asimov"
    },
    "2024-04-20": {
        "content": " Puoi farti aiutare dagli insegnanti, ma dovrai imparare molto da solo, seduto in una stanza. -Dr. Seuss"
    },
    "2024-04-21": {
        "content": " L'apprendimento avviene quando qualcuno vuole imparare, non quando qualcuno vuole insegnare. -Roger Schank"
    },
    "2024-04-22": {
        "content": " Una persona non può insegnare direttamente a un'altra persona; può solo facilitarne l'apprendimento. -Carl R. Rogers"
    },
    "2024-04-23": {
        "content": " L'apprendimento non è obbligatorio; è volontario. Il miglioramento non è obbligatorio; è volontario. Ma per sopravvivere, dobbiamo imparare. -W. Edwards Deming"
    },
    "2024-04-24": {
        "content": " Faccio sempre ciò che non so fare, per imparare a farlo. -Pablo Picasso"
    },
    "2024-04-25": {
        "content": "Nessun ladro, per quanto abile, può rubare la conoscenza, ed è per questo che la conoscenza è il tesoro migliore e più sicuro da acquisire. -L. Frank Baum"
    },
    "2024-04-26": {
        "content": " Penso che questo sia il consiglio migliore: pensa costantemente a come potresti fare meglio le cose e mettiti in discussione. -Elon Musk"
    },
    "2024-04-27": {
        "content": " Un uomo saggio può imparare di più da una domanda sciocca di quanto uno stolto possa imparare da una risposta saggia. -Bruce Lee"
    },
    "2024-04-28": {
        "content": " Se ho visto più lontano è stato perché sono salito sulle spalle dei Giganti. -Isacco Newton"
    },
    "2024-04-29": {
        "content": " Ciò che conosciamo è una goccia, ciò che non conosciamo è un oceano. -Isacco Newton"
    },
    "2024-04-30": {
        "content": " Il bello dell'imparare è che nessuno può portartelo via. -BB Re"
    },
    "2024-05-01": {
        "content": " Se vuoi diventare uno scrittore, devi fare due cose prima di ogni altra cosa: leggere molto e scrivere molto. -Stephen Re"
    },
    "2024-05-02": {
        "content": " La ripetizione è la madre dell'abilità. -Tony Robbins"
    },
    "2024-05-03": {
        "content": " La meraviglia è l'inizio della saggezza. -Socrate"
    },
    "2024-05-04": {
        "content": " Se commetti un errore e non lo correggi, questo si chiama errore. -Confucio"
    },
    "2024-05-05": {
        "content": " Lo scopo dell'istruzione è sostituire una mente vuota con una aperta. -Malcolm S. Forbes"
    },
    "2024-05-06": {
        "content": "Niente nella vita è da temere, è solo da comprendere. Ora è il momento di comprendere di più, così da temere di meno. -Marie Curie"
    },
    "2024-05-07": {
        "content": " Ogni volta che ti chiedono se sai fare un lavoro, rispondi \"Certamente che posso!\". Poi datti da fare e scopri come farlo. -Teodoro Roosevelt"
    },
    "2024-05-08": {
        "content": " Abbiamo tutti bisogno di persone che ci diano feedback. È così che miglioriamo. -Bill Gates"
    },
    "2024-05-09": {
        "content": " L'istruzione è la chiave per scoprire il mondo, un passaporto per la libertà. -Oprah Winfrey"
    },
    "2024-05-10": {
        "content": " Tutto inizia con un'idea. -Il conte Nightingale"
    },
    "2024-05-11": {
        "content": " Il miglior investimento che puoi fare è in te stesso. -Warren Buffett"
    },
    "2024-05-12": {
        "content": " Non è una questione di soldi o di conoscenze. È la volontà di lavorare e imparare più di tutti. -Marco cubano"
    },
    "2024-05-13": {
        "content": " Finché vivi, continua a imparare a vivere. -Seneca"
    },
    "2024-05-14": {
        "content": " Per imparare ad avere successo, devi prima imparare a fallire. -Michael Giordano"
    },
    "2024-05-15": {
        "content": " Non sprecare un buon errore, impara da esso. -Robert T. Kiyosaki"
    },
    "2024-05-16": {
        "content": "Per acquisire conoscenza bisogna studiare; ma per acquisire saggezza bisogna osservare. -Marilyn Vos Savant"
    },
    "2024-05-17": {
        "content": " Vivi e impari. In ogni caso, vivi. -Douglas Adams"
    },
    "2024-05-18": {
        "content": " La pazienza è compagna della saggezza. -Sant'Agostino"
    },
    "2024-05-19": {
        "content": " So solo una cosa: non so nulla. -Socrate"
    },
    "2024-05-20": {
        "content": " La saggezza deriva dall'esperienza. L'esperienza è spesso il risultato della mancanza di saggezza. -Terry Pratchett"
    },
    "2024-05-21": {
        "content": " Possiamo giudicare i nostri progressi dal coraggio delle nostre domande e dalla profondità delle nostre risposte, dalla nostra disponibilità ad abbracciare ciò che è vero piuttosto che ciò che ci fa sentire bene. -Carl Sagan"
    },
    "2024-05-22": {
        "content": " Preferisco avere domande a cui non si può rispondere piuttosto che risposte a cui non si può mettere in discussione. -Richard P. Feynman"
    },
    "2024-05-23": {
        "content": " Sono sempre pronto a imparare, anche se non sempre mi piace che mi venga insegnato qualcosa. -Winston Churchill"
    },
    "2024-05-24": {
        "content": " Chi ama la pratica senza la teoria è come il marinaio che sale su una nave senza timone e senza bussola e non sa mai dove gettare l'ancora. -Leonardo da Vinci"
    },
    "2024-05-25": {
        "content": " È meglio creare che imparare. Creare è l'essenza della vita. -Giulio Cesare"
    },
    "2024-05-26": {
        "content": "Ciò che fa la mano, la mente lo ricorda. -Maria Montessori"
    },
    "2024-05-27": {
        "content": " Affronta sempre la vita come se avessi qualcosa di nuovo da imparare, e lo farai. -Vernon Howard"
    },
    "2024-05-28": {
        "content": " Il fallimento è un successo se impariamo da esso. -Malcolm S. Forbes"
    },
    "2024-05-29": {
        "content": " L'istruzione è la migliore amica. Una persona istruita è rispettata ovunque. L'istruzione batte la bellezza e la gioventù. -Canakya"
    },
    "2024-05-30": {
        "content": " Non pensare che ciò che per te è difficile da padroneggiare sia umanamente impossibile; ma se una cosa è umanamente possibile, considerala alla tua portata. -Marco Aurelio"
    },
    "2024-05-31": {
        "content": " L'apprendimento è un processo di scoperta costante, un processo senza fine. -Bruce Lee"
    },
    "2024-06-01": {
        "content": " Essere ignoranti non è tanto una vergogna quanto non essere disposti a imparare. -Benjamin Franklin"
    },
    "2024-06-02": {
        "content": " Sono convinto che la conoscenza sia potere: per superare il passato, per cambiare le nostre situazioni, per combattere nuovi ostacoli, per prendere decisioni migliori. -Ben Carson"
    },
    "2024-06-03": {
        "content": " Inspirando, calmo corpo e mente. Espirando, sorrido. Soffermandomi nel momento presente, so che questo è l'unico momento. -Thich Nhat Hanh"
    },
    "2024-06-04": {
        "content": "Se pensi di essere troppo piccolo per fare la differenza, prova a dormire con una zanzara. -Dalai Lama XIV"
    },
    "2024-06-05": {
        "content": " Troppo spesso sottovalutiamo il potere di un tocco, di un sorriso, di una parola gentile, di un orecchio attento, di un complimento sincero o del più piccolo gesto di premura, tutti atti che hanno il potenziale di cambiare una vita. -Leo Buscaglia"
    },
    "2024-06-06": {
        "content": " Il modo in cui trascorriamo le nostre giornate, ovviamente, determina il modo in cui trascorriamo la nostra vita. -Annie Dillard"
    },
    "2024-06-07": {
        "content": " Nutri la tua mente con grandi pensieri, perché non andrai mai più in alto di quanto pensi. -Benjamin Disraeli"
    },
    "2024-06-08": {
        "content": " Non impari a camminare seguendo le regole. Impari facendo e cadendo. -Richard Branson"
    },
    "2024-06-09": {
        "content": " È impossibile vivere senza fallire in qualcosa, a meno che non si viva con tanta cautela da considerare che sarebbe come non aver vissuto affatto, nel qual caso si fallisce per impostazione predefinita. -JK Rowling"
    },
    "2024-06-10": {
        "content": " Se vuoi essere felice, sii. -Lev Tolstoj"
    },
    "2024-06-11": {
        "content": " Nessuno può farmi del male senza il mio permesso. -Mahatma Gandhi"
    },
    "2024-06-12": {
        "content": " Quando rinuncio a ciò che sono, divento ciò che potrei essere. -Lao Tzu"
    },
    "2024-06-13": {
        "content": "Il motivo per cui lottiamo contro l'insicurezza è perché confrontiamo il nostro dietro le quinte con i momenti salienti di tutti gli altri. -Steven Furtick"
    },
    "2024-06-14": {
        "content": " Ricordati che oggi è il domani di cui ti preoccupavi ieri. -Dale Carnegie"
    },
    "2024-06-15": {
        "content": " Dobbiamo essere disposti a rinunciare alla vita che abbiamo pianificato per avere la vita che ci aspetta. -Giuseppe Campbell"
    },
    "2024-06-16": {
        "content": " Smetti di partire e arriverai. Smetti di cercare e vedrai. Smetti di scappare e sarai trovato. -Lao Tzu"
    },
    "2024-06-17": {
        "content": " Un team non è un gruppo di persone che lavorano insieme. Un team è un gruppo di persone che si fidano l'una dell'altra. -Simon Sinek"
    },
    "2024-06-18": {
        "content": " L'ottimismo perpetuo è un moltiplicatore di forza. -Colin Powell"
    },
    "2024-06-19": {
        "content": " Quando ti accontenti di essere semplicemente te stesso e non fai paragoni o competizioni, tutti ti rispetteranno. -Lao Tzu"
    },
    "2024-06-20": {
        "content": " Conta la tua età in base agli amici, non agli anni. Conta la tua vita in base ai sorrisi, non alle lacrime. -John Lennon"
    },
    "2024-06-21": {
        "content": " Dona a chi ami ali per volare, radici per tornare e motivi per restare. -Dalai Lama XIV"
    },
    "2024-06-22": {
        "content": " La perseveranza e lo spirito hanno fatto miracoli in tutte le epoche. -Giorgio Washington"
    },
    "2024-06-23": {
        "content": "Condividi la tua conoscenza. È un modo per raggiungere l'immortalità. -Dalai Lama XIV"
    },
    "2024-06-24": {
        "content": " Siamo un mezzo attraverso cui il cosmo può conoscere se stesso. -Carl Sagan"
    },
    "2024-06-25": {
        "content": " Un buon insegnante può ispirare speranza, accendere l'immaginazione e instillare l'amore per l'apprendimento. -Direttore: Brad Henry"
    },
    "2024-06-26": {
        "content": " Una delle più grandi scoperte che una persona possa fare, una delle sue più grandi sorprese, è scoprire di poter fare ciò che temeva di non poter fare. -Henry Ford"
    },
    "2024-06-27": {
        "content": " Quando è stata l'ultima volta che hai fatto qualcosa per la prima volta? -John C. Maxwell"
    },
    "2024-06-28": {
        "content": " Se non sei nel processo di diventare la persona che vuoi essere, sei automaticamente impegnato a diventare la persona che non vuoi essere. -Dale Carnegie"
    },
    "2024-06-29": {
        "content": " La fortuna aiuta gli audaci. -Proverbio latino"
    },
    "2024-06-30": {
        "content": " Il successo non è la chiave della felicità. La felicità è la chiave del successo. Se ami ciò che fai, avrai successo. -Albert Schweitzer"
    },
    "2024-07-01": {
        "content": " Non guadagnare il mondo e perdere la tua anima; la saggezza vale più dell'argento e dell'oro. -Bob Marley"
    },
    "2024-07-02": {
        "content": " Comincia subito a vivere e considera ogni singolo giorno come una vita a sé stante. -Seneca"
    },
    "2024-07-03": {
        "content": " meno che a qualcuno come te non importi un granché, niente migliorerà. Non è così. -Dr. Seuss"
    },
    "2024-07-04": {
        "content": " Non sapevano che fosse impossibile, quindi lo fecero. -Mark Twain"
    },
    "2024-07-05": {
        "content": " Io posso fare cose che tu non puoi, tu puoi fare cose che io non posso; insieme possiamo fare grandi cose. -Madre Teresa"
    },
    "2024-07-06": {
        "content": " L'unica cosa di cui dobbiamo avere paura è la paura stessa. -Franklin D. Roosevelt"
    },
    "2024-07-07": {
        "content": " Senza entusiasmo non si è mai realizzato nulla di grande. -Ralph Waldo Emerson"
    },
    "2024-07-08": {
        "content": " Coraggio, caro cuore. -CS Lewis"
    },
    "2024-07-09": {
        "content": " L'unico modo per dare un senso al cambiamento è immergersi in esso, muoversi con esso e unirsi alla danza. -Alan Watts"
    },
    "2024-07-10": {
        "content": " Dove va l'attenzione, scorre l'energia e si vedono i risultati. -T. Harv Eker"
    },
    "2024-07-11": {
        "content": " Il dolore è temporaneo. Può durare un minuto, un'ora, un giorno o un anno, ma alla fine si attenuerà e qualcos'altro prenderà il suo posto. Se smetto, tuttavia, durerà per sempre. -Lance Armstrong"
    },
    "2024-07-12": {
        "content": " In ogni passeggiata nella natura si riceve molto più di quanto si cerchi. -Giovanni Muir"
    },
    "2024-07-13": {
        "content": " vincitori non sono coloro che non falliscono mai, ma coloro che non si arrendono mai. -Edwin Louis Cole"
    },
    "2024-07-14": {
        "content": " Invece di combattere l'oscurità, fai entrare la luce. -Eckhart Tolle"
    },
    "2024-07-15": {
        "content": " Sii coraggioso nel perseguire ciò che accende la tua anima. -Jennifer Lee"
    },
    "2024-07-16": {
        "content": " Quando le persone se ne vanno da te, lasciale andare. Il tuo destino non è mai legato a chi ti lascia, e non significa che siano cattive persone. Significa solo che la loro parte nella tua storia è finita. -TD Jakes"
    },
    "2024-07-17": {
        "content": " La leadership è la capacità di tradurre la visione in realtà. -Warren G. Bennis"
    },
    "2024-07-18": {
        "content": " La fede è credere a ciò che non si vede; la ricompensa di questa fede è vedere ciò in cui si crede. -Sant'Agostino"
    },
    "2024-07-19": {
        "content": " Niente è impossibile, a meno che tu non lo creda. -Paramahansa Yogananda"
    },
    "2024-07-20": {
        "content": " L'unica cosa peggiore dell'essere ciechi è avere la vista ma non la capacità visiva. -Helen Keller"
    },
    "2024-07-21": {
        "content": " Ogni cosa ha la sua bellezza, ma non tutti la vedono. -Confucio"
    },
    "2024-07-22": {
        "content": " Dio parla nel silenzio del cuore. -Madre Teresa"
    },
    "2024-07-23": {
        "content": "La speranza è quella cosa con le piume che si appollaia nell'anima, e canta la melodia senza le parole, senza mai fermarsi. -Emily Dickinson"
    },
    "2024-07-24": {
        "content": " Per quante parole sante tu legga, per quante ne pronunci, a cosa ti serviranno se non le metti in pratica? -Buddha"
    },
    "2024-07-25": {
        "content": " E a proposito, tutto nella vita è scrivibile se hai il coraggio di farlo e l'immaginazione di improvvisare. Il peggior nemico della creatività è l'insicurezza. -Sylvia Plath"
    },
    "2024-07-26": {
        "content": " Niente di ciò che facciamo può cambiare il passato, ma tutto ciò che facciamo cambia il futuro. -Ashleigh Brillante"
    },
    "2024-07-27": {
        "content": " La leadership è una scelta. Non è un grado. -Simon Sinek"
    },
    "2024-07-28": {
        "content": " Tutto andrà bene, tutto andrà bene e ogni cosa andrà bene. -Giuliano di Norwich"
    },
    "2024-07-29": {
        "content": " Ognuno di noi è, nella prospettiva cosmica, prezioso. Se un umano non è d'accordo con te, lascialo vivere. In cento miliardi di galassie, non ne troverai un altro. -Carl Sagan"
    },
    "2024-07-30": {
        "content": " Intelligenza più carattere: questo è l'obiettivo della vera educazione. -Martin Luther King Jr."
    },
    "2024-07-31": {
        "content": "Quanto più ti perdi in qualcosa di più grande di te, tanta più energia avrai. -Norman Vincent Peale"
    },
    "2024-08-01": {
        "content": " Impara le basi e il livello di tutto ciò che fai aumenterà -Michael Giordano"
    },
    "2024-08-02": {
        "content": " Non puoi vivere affatto se non vivi pienamente adesso. -Alan Watts"
    },
    "2024-08-03": {
        "content": " Ricorda che a volte non ottenere ciò che desideri è un colpo di fortuna meraviglioso. -Dalai Lama XIV"
    },
    "2024-08-04": {
        "content": " Fai del tuo meglio e poi rilassati. Lascia che le cose vadano avanti in modo naturale, anziché forzarle. -Paramahansa Yogananda"
    },
    "2024-08-05": {
        "content": " Sei un essere spirituale infinito che sta vivendo un'esperienza umana temporanea. -Wayne W. Dyer"
    },
    "2024-08-06": {
        "content": " Bisogna sognare prima che i propri sogni possano avverarsi. -Abdul Kalam"
    },
    "2024-08-07": {
        "content": " Custodisci soprattutto il tuo cuore, perché tutto ciò che fai scaturisce da esso. -Salomone"
    },
    "2024-08-08": {
        "content": " Mentre scrivo riesco a scrollarmi di dosso tutto; i miei dolori scompaiono, il mio coraggio rinasce. -Anna Frank"
    },
    "2024-08-09": {
        "content": " L'obiettivo non è essere perfetti alla fine. L'obiettivo è essere migliori oggi. -Simon Sinek"
    },
    "2024-08-10": {
        "content": " Vai con sicurezza nella direzione dei tuoi sogni. Vivi la vita che hai immaginato. -Henry David Thoreau"
    },
    "2024-08-11": {
        "content": "Siate gentili ogni volta che è possibile. È sempre possibile. -Dalai Lama XIV"
    },
    "2024-08-12": {
        "content": " Il nostro scopo principale in questa vita è aiutare gli altri. E se non puoi aiutarli, almeno non far loro del male. -Dalai Lama XIV"
    },
    "2024-08-13": {
        "content": " Hai un cervello nella testa. Hai i piedi nelle scarpe. Puoi orientarti in qualsiasi direzione tu scelga. Sei da solo. E sai quello che sai. E sei tu quello che deciderà dove andare. -Dr. Seuss"
    },
    "2024-08-14": {
        "content": " Ciò su cui ti concentri si espande e quando ti concentri sulle cose buone della tua vita, ne crei di più. -Oprah Winfrey"
    },
    "2024-08-15": {
        "content": " Tutto ciò che ho bisogno di sapere mi viene rivelato. Tutto ciò di cui ho bisogno mi viene incontro. Tutto va bene nella mia vita. -Louise Fieno"
    },
    "2024-08-16": {
        "content": " Sono totalmente al sicuro nell'Universo. Sono in pace ovunque. Ho fiducia nella vita. -Louise Fieno"
    },
    "2024-08-17": {
        "content": " Rivolgi il viso verso il sole e le ombre cadranno dietro di te. -Proverbio Maori"
    },
    "2024-08-18": {
        "content": " Il coraggio non è avere la forza di andare avanti; è andare avanti quando non si ha la forza. -Teodoro Roosevelt"
    },
    "2024-08-19": {
        "content": " Il futuro dipende da ciò che fai oggi. -Mahatma Gandhi"
    },
    "2024-08-20": {
        "content": " Un vincitore è un sognatore che non si arrende mai. -Nelson Mandela"
    },
    "2024-08-21": {
        "content": "Non piangere perché è finita, sorridi perché è successo. -Dr. Seuss"
    },
    "2024-08-22": {
        "content": " In tre parole posso riassumere tutto quello che ho imparato sulla vita: continua. -Robert Gelo"
    },
    "2024-08-23": {
        "content": " Vivi seguendo la tua immaginazione, non la tua storia. -Stephen R. Covey"
    },
    "2024-08-24": {
        "content": " A mio avviso, se vuoi l'arcobaleno, devi sopportare la pioggia. -Dolly Parton"
    },
    "2024-08-25": {
        "content": " La grandezza di un uomo non risiede nella quantità di ricchezza che acquisisce, ma nella sua integrità e nella sua capacità di influenzare positivamente chi lo circonda. -Bob Marley"
    },
    "2024-08-26": {
        "content": " La felicità deriva principalmente dal nostro atteggiamento, piuttosto che da fattori esterni. -Dalai Lama XIV"
    },
    "2024-08-27": {
        "content": " Le grandi azioni sono fatte di piccole azioni. -Lao Tzu"
    },
    "2024-08-28": {
        "content": " Non è mai troppo tardi per essere ciò che avresti potuto essere. -George Eliot"
    },
    "2024-08-29": {
        "content": " Adottare l'atteggiamento giusto può trasformare uno stress negativo in uno positivo. -Hans Selye"
    },
    "2024-08-30": {
        "content": " Osate vivere la vita che avete sognato per voi stessi. Andate avanti e fate sì che i vostri sogni diventino realtà. -Ralph Waldo Emerson"
    },
    "2024-08-31": {
        "content": " Il tempo che ti piace sprecare non è tempo sprecato. -Bertrand Russell"
    },
    "2024-09-01": {
        "content": "Basta un po' di attenzione per vedere e scoprire: la vita è davvero una grande risata cosmica. -Osho"
    },
    "2024-09-02": {
        "content": " Il curioso paradosso è che quando mi accetto così come sono, allora posso cambiare. -Carl R. Rogers"
    },
    "2024-09-03": {
        "content": " Sii parte della soluzione, non parte del problema. -Stephen R. Covey"
    },
    "2024-09-04": {
        "content": " Il segreto della vita è dare. -Tony Robbins"
    },
    "2024-09-05": {
        "content": " Fai di ogni giorno il tuo capolavoro. -John Legno"
    },
    "2024-09-06": {
        "content": " Non rinunciare mai a ciò che vuoi veramente fare Italiano:"
    },
    "2024-09-07": {
        "content": " Non voltarti indietro: non andrai da quella parte. -Mary Engelbreit"
    },
    "2024-09-08": {
        "content": " Fai del tuo meglio e Dio farà il resto. -Nick Vujicic"
    },
    "2024-09-09": {
        "content": " Vivi, viaggia, vivi l'avventura, benedici e non pentirti. -Jack Kerouac"
    },
    "2024-09-10": {
        "content": " Nel bel mezzo dell'inverno, ho scoperto che dentro di me c'era un'estate invincibile. E questo mi rende felice. Perché dice che non importa quanto duramente il mondo mi spinga contro, dentro di me c'è qualcosa di più forte, qualcosa di meglio, che mi spinge indietro. -Albert Camus"
    },
    "2024-09-11": {
        "content": "Alcuni credono che solo un grande potere possa tenere a bada il male, ma non è quello che ho scoperto. Sono le piccole azioni quotidiane della gente comune che tengono a bada l'oscurità. Piccoli atti di gentilezza e amore. -JRR Tolkien"
    },
    "2024-09-12": {
        "content": " Sii fedele nelle piccole cose perché è in esse che risiede la tua forza. -Madre Teresa"
    },
    "2024-09-13": {
        "content": " Renditi una luce. -Buddha"
    },
    "2024-09-14": {
        "content": " VISUALIZZA!!! Guardalo, sentilo! È qui che inizia l'azione. -Rhonda Byrne"
    },
    "2024-09-15": {
        "content": " Sii fenomenale o verrai dimenticato! -Eric Thomas"
    },
    "2024-09-16": {
        "content": " Quando puoi scegliere tra avere ragione o essere gentile, scegli di essere gentile. -Wayne W. Dyer"
    },
    "2024-09-17": {
        "content": " Gli esseri umani possono cambiare la propria vita modificando il proprio atteggiamento mentale. -Guglielmo James"
    },
    "2024-09-18": {
        "content": " La salute è il bene più prezioso. -Laozi"
    },
    "2024-09-19": {
        "content": " Non lasciarmi pregare per essere al riparo dai pericoli, ma per essere impavido nell'affrontarli. Non lasciarmi implorare la calma del mio dolore, ma il cuore per vincerlo. -Rabindranath Tagore"
    },
    "2024-09-20": {
        "content": " Metti il tuo cuore nel fare del bene. Fallo più e più volte, e sarai pieno di gioia. -Buddha"
    },
    "2024-09-21": {
        "content": "Da solo non posso cambiare il mondo, ma posso lanciare un sasso nell'acqua e creare numerose increspature. -Madre Teresa"
    },
    "2024-09-22": {
        "content": " E venne il giorno in cui il rischio di restare chiusi in un bocciolo era più doloroso del rischio di sbocciare. -Anaïs Nin"
    },
    "2024-09-23": {
        "content": " Non dovrebbero esserci limiti all'impegno umano. Per quanto brutta possa sembrare la vita, c'è sempre speranza. -Stephen Hawking"
    },
    "2024-09-24": {
        "content": " E vi esorto a notare quando siete felici, e a esclamare o mormorare o pensare a un certo punto: \"Se questo non è bello, non so cosa lo sia\". -Kurt Vonnegut"
    },
    "2024-09-25": {
        "content": " È la tua reazione alle avversità, non l'avversità in sé, a determinare come si svilupperà la storia della tua vita. -Dieter F. Uchtdorf"
    },
    "2024-09-26": {
        "content": " Non è ciò che hai o chi sei o dove sei o cosa stai facendo che ti rende felice o infelice. È ciò che pensi a riguardo. -Dale Carnegie"
    },
    "2024-09-27": {
        "content": " Più leggi, più cose saprai. Più impari, più posti visiterai. -Dr. Seuss"
    },
    "2024-09-28": {
        "content": " Tutti i nostri sogni possono diventare realtà. -Walt Disney"
    },
    "2024-09-29": {
        "content": "Il privilegio di una vita è essere chi sei. -Giuseppe Campbell"
    },
    "2024-09-30": {
        "content": " Nessuno è inutile in questo mondo se alleggerisce i fardelli di un altro. -Carlo Dickens"
    },
    "2024-10-01": {
        "content": " Trova un posto dentro di te dove c'è gioia, e la gioia brucerà il dolore. -Giuseppe Campbell"
    },
    "2024-10-02": {
        "content": " Non chiederti di cosa ha bisogno il mondo. Chiediti cosa ti fa sentire vivo e fallo. Perché ciò di cui ha bisogno il mondo è più gente che si sia sentita viva. -Howard Thurman"
    },
    "2024-10-03": {
        "content": " I tuoi sentimenti sono il tuo strumento più importante per creare la tua vita. -Rhonda Byrne"
    },
    "2024-10-04": {
        "content": " Merito il meglio e accetto il meglio fin da ora. -Louise Fieno"
    },
    "2024-10-05": {
        "content": " Non è importante quanto diamo, ma quanto amore mettiamo nel donare. -Madre Teresa"
    },
    "2024-10-06": {
        "content": " Quando vuoi avere successo con tutta la tua forza di volontà, allora avrai successo. -Eric Thomas"
    },
    "2024-10-07": {
        "content": " Odiavo ogni minuto di allenamento, ma dicevo: \"Non mollare. Soffri ora e vivi il resto della tua vita da campione\". -Muhammad Ali"
    },
    "2024-10-08": {
        "content": "Non è il critico che conta, non colui che sottolinea come l'uomo forte sia inciampato o come l'autore delle azioni avrebbe potuto farle meglio. Il merito spetta all'uomo che è effettivamente nell'arena, il cui volto è segnato da sudore, polvere e sangue; che si sforza coraggiosamente; che sbaglia e fallisce ancora e ancora; che conosce i grandi entusiasmi, le grandi devozioni e si spende per una causa degna; che, se vince, conosce il trionfo di grandi risultati; e che, se fallisce, almeno fallisce osando molto, così che il suo posto non sarà mai con quelle anime fredde e timide che non conoscono né vittoria né sconfitta. -Teodoro Roosevelt"
    },
    "2024-10-09": {
        "content": " L'avventura più grande che tu possa mai intraprendere è vivere la vita dei tuoi sogni. -Oprah Winfrey"
    },
    "2024-10-10": {
        "content": " Senza lotta non può esserci progresso. -Federico Douglass"
    },
    "2024-10-11": {
        "content": " Un sogno scritto con una data diventa un obiettivo. Un obiettivo suddiviso in passaggi diventa un piano. Un piano supportato dall'azione fa sì che i tuoi sogni diventino realtà. -Greg Reid"
    },
    "2024-10-12": {
        "content": "Fai l'unica cosa che pensi di non poter fare. Fallisci. Riprova. Fai meglio la seconda volta. Le uniche persone che non cadono mai sono quelle che non salgono mai sul filo teso. -Oprah Winfrey"
    },
    "2024-10-13": {
        "content": " Aspettatevi il cambiamento. Analizzate il panorama. Cogliete le opportunità. Smettete di essere il pezzo degli scacchi; diventate il giocatore. È la vostra mossa. -Tony Robbins"
    },
    "2024-10-14": {
        "content": " Sei libero. Sei potente. Sei buono. Sei amore. Hai valore. Hai uno scopo. Tutto va bene. -Esther Hicks"
    },
    "2024-10-15": {
        "content": "Se desideri una cosa abbastanza da uscire e combattere per essa, da lavorare giorno e notte per essa, da rinunciare al tuo tempo, alla tua pace e al tuo sonno per essa; se tutto ciò che sogni e progetti riguarda quella cosa e la vita sembra inutile e senza valore senza di essa; se ti agiti volentieri per essa, ti agiti e progetti per essa e perdi tutto il tuo terrore per l'opposizione; se semplicemente insegui quella cosa che vuoi con tutte le tue capacità, forza e sagacia, fede, speranza e fiducia e severità per la tenacia; se né il freddo né la povertà, la fame o la gotta, la malattia o il dolore del corpo e del cervello possono tenerti lontano dalla cosa che vuoi; se sei tenace e ostinato e la generi, con l'aiuto di DIO la otterrai. -Berton Braley"
    },
    "2024-10-16": {
        "content": " Anche se sei sulla strada giusta, se rimani lì seduto verrai investito. -Will Rogers"
    },
    "2024-10-17": {
        "content": " Penso che sia possibile per le persone comuni scegliere di essere straordinarie. -Elon Musk"
    },
    "2024-10-18": {
        "content": " Non impari a camminare seguendo le regole. Impari facendo e cadendo. -Richard Branson"
    },
    "2024-10-19": {
        "content": "Non c'è talento qui, questo è duro lavoro. Questa è un'ossessione. Il talento non esiste, siamo tutti uguali come esseri umani. Potresti essere chiunque se ci metti tempo. Raggiungerai la cima, e questo è tutto. Non ho talento, sono ossessionato. -Conor McGregor"
    },
    "2024-10-20": {
        "content": " Un sogno non è ciò che vedi mentre dormi; è qualcosa che non ti lascia dormire. -Abdul Kalam"
    },
    "2024-10-21": {
        "content": " Quando hai esaurito tutte le possibilità, ricorda questo: non è così. -Thomas A. Edison"
    },
    "2024-10-22": {
        "content": " Prendi delle opportunità, commetti degli errori. È così che cresci. Il dolore nutre il tuo coraggio. Devi fallire per esercitarti a essere coraggioso. -Mary Tyler Moore"
    },
    "2024-10-23": {
        "content": " Ciò su cui ti concentri è ciò che ottieni. -Tony Robbins"
    },
    "2024-10-24": {
        "content": " \"Hustle\" è la parola più importante in assoluto. -Gary Vaynerchuk"
    },
    "2024-10-25": {
        "content": " Se sono riusciti a ricavare la penicillina dal pane ammuffito, allora possono sicuramente ricavare qualcosa da te. -Muhammad Ali"
    },
    "2024-10-26": {
        "content": " Non sei nato vincitore e non sei nato perdente. Sei ciò che ti fai essere. -Lou Holtz"
    },
    "2024-10-27": {
        "content": " Il successo è un tuo dovere, obbligo e responsabilità. -Grant Cardone"
    },
    "2024-10-28": {
        "content": "C'è poca differenza nelle persone, ma quella piccola differenza fa una grande differenza. La piccola differenza è l'atteggiamento. La grande differenza è se è positivo o negativo. -W. Clemente Pietra"
    },
    "2024-10-29": {
        "content": " I leader devono essere sufficientemente vicini per relazionarsi con gli altri, ma sufficientemente avanti per motivarli. -John C. Maxwell"
    },
    "2024-10-30": {
        "content": " Mai dire mai, perché i limiti, come le paure, sono spesso solo un'illusione. -Michael Giordano"
    },
    "2024-10-31": {
        "content": " Devi aspettarti grandi cose da te stesso prima di poterle realizzare. -Michael Giordano"
    },
    "2024-11-01": {
        "content": " Nel mondo degli affari, le persone che hanno più successo sono quelle che fanno ciò che amano. -Warren Buffett"
    },
    "2024-11-02": {
        "content": " L'azione distruggerà la tua procrastinazione. -Og Mandino"
    },
    "2024-11-03": {
        "content": " Il fallimento non è un'opzione per me. Il successo è tutto ciò che immagino. -Conor McGregor"
    },
    "2024-11-04": {
        "content": " Il successo non deriva da ciò che fai occasionalmente, ma da ciò che fai costantemente. -Marie Forleo"
    },
    "2024-11-05": {
        "content": " La fiducia e il duro lavoro sono le migliori medicine per uccidere la malattia chiamata fallimento. Ti renderanno una persona di successo. -Abdul Kalam"
    },
    "2024-11-06": {
        "content": " Se vuoi brillare come il sole, prima brucia come il sole. -Abdul Kalam"
    },
    "2024-11-07": {
        "content": "Mentre tu sei là fuori a fare festa, a scherzare, c'è qualcuno là fuori che lavora sodo nello stesso momento. Qualcuno sta diventando più intelligente e qualcuno sta vincendo. Ricordatelo. -Arnold Schwarzenegger"
    },
    "2024-11-08": {
        "content": " Se fai quello che hai sempre fatto, otterrai quello che hai sempre ottenuto. -Tony Robbins"
    },
    "2024-11-09": {
        "content": " Progresso uguale felicità. -Tony Robbins"
    },
    "2024-11-10": {
        "content": " Puoi avere risultati o scuse. Non entrambi. -Arnold Schwarzenegger"
    },
    "2024-11-11": {
        "content": " Disciplina uguale libertà. -Jocko Willink"
    },
    "2024-11-12": {
        "content": " Non soffermarti su cosa è andato storto. Concentrati invece su cosa fare dopo. Dedica le tue energie ad andare avanti, verso la ricerca della risposta. -Disegno di Denis Waitley"
    },
    "2024-11-13": {
        "content": " Sii il leader che vorresti avere. -Simon Sinek"
    },
    "2024-11-14": {
        "content": " Il mio atteggiamento è che se mi spingi verso qualcosa che ritieni una debolezza, allora trasformerò quella debolezza percepita in un punto di forza. -Michael Giordano"
    },
    "2024-11-15": {
        "content": " Per la maggior parte di noi il pericolo maggiore non sta nel prefissare obiettivi troppo alti e non raggiungerli, ma nel prefissarli troppo bassi e non raggiungerli. -Michelangelo"
    },
    "2024-11-16": {
        "content": " Tutti hanno un sogno, ma non tutti hanno una sfida. -Eric Thomas"
    },
    "2024-11-17": {
        "content": " leader si creano, non si nasce. Si creano con duro sforzo, che è il prezzo che tutti noi dobbiamo pagare per raggiungere qualsiasi obiettivo che valga la pena. -Vince Lombardi"
    },
    "2024-11-18": {
        "content": " Scegliamo di andare sulla luna in questo decennio e fare le altre cose. Non perché siano facili, ma perché sono difficili. -John F. Kennedy"
    },
    "2024-11-19": {
        "content": " Il giorno più bello della tua vita e della mia è quando ci assumiamo la totale responsabilità dei nostri atteggiamenti. È il giorno in cui cresciamo davvero. -John C. Maxwell"
    },
    "2024-11-20": {
        "content": " Ogni volta che sorridi a qualcuno, è un gesto d'amore, un regalo a quella persona, una cosa meravigliosa. -Madre Teresa"
    },
    "2024-11-21": {
        "content": " Sii l'osservatore silenzioso dei tuoi pensieri e del tuo comportamento. Sei sotto il pensatore. Sei la quiete sotto il rumore mentale. Sei l'amore e la gioia sotto il dolore. -Eckhart Tolle"
    },
    "2024-11-22": {
        "content": " Se non puoi volare allora corri, se non puoi correre allora cammina, se non puoi camminare allora striscia, ma qualsiasi cosa tu faccia devi continuare ad andare avanti. -Martin Luther King Jr."
    },
    "2024-11-23": {
        "content": " Il perdono non è un atto occasionale, è un atteggiamento costante. -Martin Luther King Jr."
    },
    "2024-11-24": {
        "content": " Troppo spesso sottovalutiamo il potere di un tocco, di un sorriso, di una parola gentile, di un orecchio attento, di un complimento sincero o del più piccolo gesto di premura, tutti atti che hanno il potenziale di cambiare una vita. -Leo Buscaglia"
    },
    "2024-11-25": {
        "content": "Mantieni vivi i tuoi sogni. Comprendi che per raggiungere qualsiasi cosa servono fede e convinzione in te stesso, visione, duro lavoro, determinazione e dedizione. Ricorda che tutte le cose sono possibili per coloro che credono. -Gail Devers"
    },
    "2024-11-26": {
        "content": " Lo sport ha il potere di cambiare il mondo. Ha il potere di ispirare. Ha il potere di unire le persone in un modo che poche altre cose riescono a fare. Parla ai giovani in un linguaggio che capiscono. Lo sport può creare speranza dove una volta c'era solo disperazione. -Nelson Mandela"
    },
    "2024-11-27": {
        "content": " Chiedi ciò che vuoi. Credi di meritarlo, e poi lascia che la Vita te lo dia. -Louise Fieno"
    },
    "2024-11-28": {
        "content": " Vivi con intenzione. Cammina fino al limite. Ascolta attentamente. Pratica il benessere. Gioca con abbandono. Ridi. Scegli senza rimpianti. Apprezza i tuoi amici. Continua a imparare. Fai ciò che ami. Vivi come se questo fosse tutto ciò che c'è. -Mary Anne Radmacher"
    },
    "2024-11-29": {
        "content": " Ciò su cui ti concentri si espande e quando ti concentri sulle cose buone della tua vita, ne crei di più. -Oprah Winfrey"
    },
    "2024-11-30": {
        "content": " Hai potere sulla tua mente, non sugli eventi esterni. Renditi conto di questo, e troverai la forza. -Marco Aurelio"
    },
    "2024-12-01": {
        "content": "Non cercare scuse per non farcela. Concentrati su tutte le ragioni per cui devi farcela. -Ralph Marston"
    },
    "2024-12-02": {
        "content": " Dove c'è amore c'è vita. -Mahatma Gandhi"
    },
    "2024-12-03": {
        "content": " Devi ballare come se nessuno ti guardasse, amare come se non ti facessero mai del male, cantare come se nessuno ti ascoltasse e vivere come se il paradiso fosse in terra. -William W. Purkey"
    },
    "2024-12-04": {
        "content": " Il successo consiste nel conoscere il proprio scopo nella vita, crescere per raggiungere il proprio massimo potenziale e piantare semi che siano utili agli altri. -John C. Maxwell"
    },
    "2024-12-05": {
        "content": " Un sogno che fai da solo è solo un sogno. Un sogno che fai insieme è realtà. -John Lennon"
    },
    "2024-12-06": {
        "content": " Questo è il vero segreto della vita: essere completamente coinvolti in ciò che fai qui e ora. E invece di chiamarlo lavoro, renditi conto che è un gioco. -Alan Watts"
    },
    "2024-12-07": {
        "content": " Ieri è passato. Domani non è ancora arrivato. Abbiamo solo oggi. Cominciamo. -Madre Teresa"
    },
    "2024-12-08": {
        "content": " Più lodi e celebri la tua vita, più nella vita c'è da celebrare. -Oprah Winfrey"
    },
    "2024-12-09": {
        "content": "Non dubitare mai che un piccolo gruppo di cittadini riflessivi e impegnati possa cambiare il mondo. In effetti, è l'unica cosa che abbia mai fatto. -Margaret Mead"
    },
    "2024-12-10": {
        "content": " Sforzati, perché nessun altro lo farà per te. -Anonimo"
    },
    "2024-12-11": {
        "content": " La vera umiltà non è pensare meno a se stessi; è pensare meno a se stessi. -CS Lewis"
    },
    "2024-12-12": {
        "content": " Se puoi cambiare idea, puoi cambiare la tua vita. -Guglielmo James"
    },
    "2024-12-13": {
        "content": " Concentrati su dove vuoi arrivare, non su ciò che temi. -Tony Robbins"
    },
    "2024-12-14": {
        "content": " Rispetta te stesso e gli altri ti rispetteranno. -Confucio"
    },
    "2024-12-15": {
        "content": " Fai quello che puoi, con quello che hai, dove sei. -Teodoro Roosevelt"
    },
    "2024-12-16": {
        "content": " Alcuni cambiamenti possono sembrare negativi in superficie, ma presto ti renderai conto che nella tua vita si sta creando spazio affinché qualcosa di nuovo possa emergere. -Eckhart Tolle"
    },
    "2024-12-17": {
        "content": " Se le tue azioni ispirano gli altri a sognare di più, imparare di più, fare di più e diventare di più, sei un leader. -Giovanni Quincy Adams"
    },
    "2024-12-18": {
        "content": " Non preoccuparti di nulla, tutto andrà per il meglio. -Bob Marley"
    },
    "2024-12-19": {
        "content": " Sogna in grande, sii positivo, lavora sodo e goditi il viaggio. -Urija Faber"
    },
    "2024-12-20": {
        "content": "Tu sei qui per consentire allo scopo divino dell'Universo di dispiegarsi. Ecco quanto sei importante! -Eckhart Tolle"
    },
    "2024-12-21": {
        "content": " Vivi con passione! -Tony Robbins"
    },
    "2024-12-22": {
        "content": " Credimi e sarai a metà strada. -Teodoro Roosevelt"
    },
    "2024-12-23": {
        "content": " La nostra vita comincia a finire il giorno in cui taciamo sulle cose importanti. -Martin Luther King Jr."
    },
    "2024-12-24": {
        "content": " Insieme possiamo fare grandi cose. -Madre Teresa"
    },
    "2024-12-25": {
        "content": " Lavorare sodo per qualcosa che non ci interessa si chiama stress; lavorare sodo per qualcosa che amiamo si chiama passione. -Simon Sinek"
    },
    "2024-12-26": {
        "content": " La caverna in cui hai paura di entrare nasconde il tesoro che cerchi. -Giuseppe Campbell"
    },
    "2024-12-27": {
        "content": " La leadership riguarda l'empatia. Riguarda la capacità di relazionarsi e connettersi con le persone allo scopo di ispirare e rafforzare le loro vite. -Oprah Winfrey"
    },
    "2024-12-28": {
        "content": " Non c'è nulla di impossibile per chi ci prova. -Alessandro Magno"
    },
    "2024-12-29": {
        "content": " La maggior parte delle cose importanti al mondo sono state realizzate da persone che hanno continuato a provare quando sembrava non esserci più alcuna speranza. -Dale Carnegie"
    },
    "2024-12-30": {
        "content": " Continuiamo ad andare avanti, ad aprire nuove porte e a fare cose nuove, perché siamo curiosi e la curiosità continua a condurci verso nuove strade. -Walt Disney"
    },
    "2024-12-31": {
        "content": "Fai quello che devi fare finché non riesci a fare quello che vuoi fare. -Oprah Winfrey"
    },
    "2025-01-01": {
        "content": " Credere di essere abbastanza è ciò che ti dà il coraggio di essere autentici. -Brené Marrone"
    },
    "2025-01-02": {
        "content": " Sono le nostre scelte, Harry, a dimostrare chi siamo veramente, molto più delle nostre capacità. -JK Rowling"
    },
    "2025-01-03": {
        "content": " Segui la tua felicità e l'universo ti aprirà porte lì dove prima c'erano solo muri. -Giuseppe Campbell"
    },
    "2025-01-04": {
        "content": " I sogni non sono quelli che ci vengono mentre dormiamo, ma quelli che non dormiamo prima di realizzarli. -Abdul Kalam"
    },
    "2025-01-05": {
        "content": " Osare significa in gran parte il coraggio di essere vulnerabili. Significa mostrarsi ed essere visti. Chiedere ciò di cui si ha bisogno. Parlare di come ci si sente. Avere conversazioni difficili. -Brené Marrone"
    },
    "2025-01-06": {
        "content": " Non avrai mai successo, finché non trasformerai il tuo dolore in grandezza, finché non permetterai al tuo dolore di spingerti da dove sei a dove devi essere. Smetti di scappare dal tuo dolore e abbraccia il tuo dolore. Il tuo dolore sarà parte del tuo premio, parte del tuo prodotto. Ti sfido a spingerti oltre. -Eric Thomas"
    },
    "2025-01-07": {
        "content": " Siamo ciò che facciamo ripetutamente. L'eccellenza, quindi, non è un atto, ma un'abitudine. -Aristotele"
    },
    "2025-01-08": {
        "content": " Un fiume scava la roccia non per la sua potenza, ma per la sua persistenza. -Disegno di Jim Watkins"
    },
    "2025-01-09": {
        "content": " L'energia e la perseveranza conquistano ogni cosa. -Benjamin Franklin"
    },
    "2025-01-10": {
        "content": " Di solito le opportunità sono mascherate da duro lavoro, quindi la maggior parte delle persone non le riconosce. -Ann Landers"
    },
    "2025-01-11": {
        "content": " Se non puoi volare allora corri, se non puoi correre allora cammina, se non puoi camminare allora striscia, ma qualsiasi cosa tu faccia devi continuare ad andare avanti. -Martin Luther King Jr."
    },
    "2025-01-12": {
        "content": " La perseveranza garantisce che i risultati siano inevitabili. -Paramahansa Yogananda"
    },
    "2025-01-13": {
        "content": " Con un talento ordinario e una perseveranza straordinaria, tutto è realizzabile -Thomas Fowell Buxton"
    },
    "2025-01-14": {
        "content": " La nostra più grande gloria non sta nel non fallire mai, ma nel rialzarci ogni volta che falliamo. -Ralph Waldo Emerson"
    },
    "2025-01-15": {
        "content": " Il successo è passare da un fallimento all'altro senza perdere l'entusiasmo. -Winston Churchill"
    },
    "2025-01-16": {
        "content": "Fortunatamente, la perseveranza è un ottimo sostituto del talento. -Steve Martin"
    },
    "2025-01-17": {
        "content": " Credo molto nella fortuna e ho scoperto che più lavoro duramente, più ne ho. -Tommaso Jefferson"
    },
    "2025-01-18": {
        "content": " Rimanda a domani solo ciò che sei disposto a lasciare incompiuto, anche se muori. -Pablo Picasso"
    },
    "2025-01-19": {
        "content": " Non ci sono segreti per il successo: non perdere tempo a cercarli. Il successo è il risultato della perfezione, del duro lavoro, dell'imparare dagli errori, della lealtà verso coloro per cui lavori e della perseveranza. -Colin Powell"
    },
    "2025-01-20": {
        "content": " Se vuoi stare davanti, comportati come se fossi dietro. -Lao Tzu"
    },
    "2025-01-21": {
        "content": " Lasciatemi svelare il segreto che mi ha condotto al mio obiettivo: la mia forza risiede unicamente nella mia tenacia. -Luigi Pasteur"
    },
    "2025-01-22": {
        "content": " Niente al mondo può sostituire la perseveranza. Il talento non lo farà; niente è più comune delle persone senza successo dotate di talento. Il genio non lo farà; il genio non ricompensato è quasi un proverbio. -Calvin Coolidge"
    },
    "2025-01-23": {
        "content": " La via d'uscita migliore è sempre quella di attraversare. -Robert Gelo"
    },
    "2025-01-24": {
        "content": "Molti fallimenti nella vita sono dovuti al fatto che le persone non si sono rese conto di quanto fossero vicine al successo quando hanno rinunciato. -Thomas A. Edison"
    },
    "2025-01-25": {
        "content": " Siamo fatti per persistere. È così che scopriamo chi siamo. -Tobias Wolff"
    },
    "2025-01-26": {
        "content": " Conoscendo gli alberi, capisco il significato della pazienza. Conoscendo l'erba, posso apprezzare la perseveranza. -Hal Borland"
    },
    "2025-01-27": {
        "content": " L'acqua che gocciola scava la pietra, non con la forza ma con la perseveranza. -Ovidio"
    },
    "2025-01-28": {
        "content": " La perseveranza è molto importante. Non dovresti arrenderti a meno che tu non sia costretto a farlo. -Elon Musk"
    },
    "2025-01-29": {
        "content": " Un entusiasmo ardente, sostenuto da buonsenso e perseveranza, è la qualità che più spesso determina il successo. -Dale Carnegie"
    },
    "2025-01-30": {
        "content": " L'ambizione è la strada per il successo. La perseveranza è il veicolo con cui arrivi. -Bill Bradley"
    },
    "2025-01-31": {
        "content": " Concentratevi sulla soluzione, non sul problema. -Walter Anderson"
    },
    "2025-02-01": {
        "content": " Quando la vita ti abbatte hai due scelte: restare giù o rialzarti. -Tom Krause"
    },
    "2025-02-02": {
        "content": "Il successo è la somma di piccoli sforzi, ripetuti giorno dopo giorno. -Robert Collier"
    },
    "2025-02-03": {
        "content": " Un sogno è solo un sogno. Un obiettivo è un sogno con un piano e una scadenza. -Harvey MacKay"
    },
    "2025-02-04": {
        "content": " Non rinunciare mai a qualcosa a cui non puoi passare un giorno senza pensare. -Winston Churchill"
    },
    "2025-02-05": {
        "content": " I diamanti non sono altro che pezzi di carbone rimasti attaccati al loro posto. -Malcolm S. Forbes"
    },
    "2025-02-06": {
        "content": " Non si può fare nulla se non poco alla volta. -Carlo Baudelaire"
    },
    "2025-02-07": {
        "content": " Se stai attraversando l'inferno, continua ad andare avanti. -Winston Churchill"
    },
    "2025-02-08": {
        "content": " La chiave della perseveranza apre tutte le porte chiuse dalla resistenza. -Giovanni Di Lemme"
    },
    "2025-02-09": {
        "content": " Se consideriamo coloro che hanno più successo al mondo, la perseveranza è il denominatore comune. -Giustino Sachs"
    },
    "2025-02-10": {
        "content": " Puoi mangiare un elefante un boccone alla volta. -Mary Kay Ash"
    },
    "2025-02-11": {
        "content": " Non credo che ci sia un'altra qualità così essenziale per il successo di qualsiasi tipo come la qualità della perseveranza. Supera quasi tutto, persino la natura. -John D. Rockefeller"
    },
    "2025-02-12": {
        "content": "Se vuoi trasformare una visione in realtà, devi dare il 100% e non smettere mai di credere nel tuo sogno. -Arnold Schwarzenegger"
    },
    "2025-02-13": {
        "content": " Corri quando puoi, cammina se devi, striscia se devi; ma non arrenderti mai. -Preside Karnazes"
    },
    "2025-02-14": {
        "content": " Fare un altro giro quando pensi di non farcela: questo è ciò che fa la differenza nella tua vita. -Sylvester Stallone"
    },
    "2025-02-15": {
        "content": " Ascoltami, anche quando perdi, va bene perdere, ma non puoi mai sentirti a tuo agio con questo. Non puoi mai essere soddisfatto di perdere. Quando perdi, deve farti male. -Eric Thomas"
    },
    "2025-02-16": {
        "content": " Continua a camminare, un passo alla volta. -Giovedì 13 Novembre 2018"
    },
    "2025-02-17": {
        "content": " Non dobbiamo arrenderci e non dobbiamo permettere che il problema ci sconfigga. -Abdul Kalam"
    },
    "2025-02-18": {
        "content": " Con la perseveranza vinciamo. -Ernest Shackleton"
    },
    "2025-02-19": {
        "content": " muri di mattoni sono lì per un motivo. I muri di mattoni non sono lì per tenerci fuori. I muri di mattoni sono lì per darci la possibilità di mostrare quanto desideriamo qualcosa. Perché i muri di mattoni sono lì per fermare le persone che non la desiderano abbastanza. Sono lì per fermare le altre persone. -Randy Pausch"
    },
    "2025-02-20": {
        "content": " Il successo dipende quasi totalmente dalla spinta e dalla perseveranza. L'energia extra richiesta per fare un altro sforzo o provare un altro approccio è il segreto della vittoria. -Disegno di Denis Waitley"
    },
    "2025-02-21": {
        "content": " Ero arrivato fin lì e mi rifiutavo di arrendermi perché per tutta la vita avevo sempre portato a termine la gara. -Luigi Zamperini"
    },
    "2025-02-22": {
        "content": " La sopravvivenza può essere riassunta in tre parole: non mollare mai. Questo è il nocciolo della questione. Continua a provare. -Orso Grylls"
    },
    "2025-02-23": {
        "content": "BASTA. Niente più scuse. Niente più: \"Comincerò domani\". Niente più: \"Solo questa volta\". Niente più accettare le carenze della mia volontà. Niente più prendere la strada più facile. Niente più inchinarmi a qualsiasi pensiero malsano o improduttivo mi passi per la mente. -Jocko Willink"
    },
    "2025-02-24": {
        "content": " Piccoli colpi abbatterono grandi querce. -Benjamin Franklin"
    },
    "2025-02-25": {
        "content": " \"Sono disposto.\" \"Sono programmato per vincere.\" \"Ce la farò.\" \"Abbraccio l'incertezza.\" \"Non sono i miei pensieri; sono ciò che faccio.\" \"Sono implacabile.\" \"Non mi aspetto nulla e accetto tutto. -Gary John Vescovo"
    },
    "2025-02-26": {
        "content": " Non ho fallito 700 volte. Non ho fallito una volta. Sono riuscito a dimostrare che quei 700 modi non funzioneranno. Quando avrò eliminato i modi che non funzioneranno, troverò il modo che funzionerà. -Thomas A. Edison"
    },
    "2025-02-27": {
        "content": " GRIT è Guts, Resilience, Industriousness e Tenacity. GRIT è la capacità di concentrarsi, di restare determinati, di restare ottimisti di fronte a una sfida e semplicemente di lavorare più duramente del prossimo ragazzo o ragazza. -Linda Kaplan Tallero"
    },
    "2025-02-28": {
        "content": "Penso che il mio segreto sia che non ci sono scorciatoie per il duro lavoro, la determinazione e l'atteggiamento del \"non arrendersi\". -Riso Jerry"
    },
    "2025-03-01": {
        "content": " Non smettere mai di lottare finché non arrivi al tuo posto destinato, ovvero, al tuo unico te. Abbi uno scopo nella vita, acquisisci continuamente conoscenza, lavora sodo e abbi perseveranza per realizzare la grande vita. -Abdul Kalam"
    },
    "2025-03-02": {
        "content": " Non fermarti quando sei stanco. Fermati quando hai finito. -David Goggins"
    },
    "2025-03-03": {
        "content": " Non giudicarmi per i miei successi, giudicami per quante volte sono caduto e mi sono rialzato. -Nelson Mandela"
    },
    "2025-03-04": {
        "content": " Ciò che non si inizia oggi non si finisce domani. -Johann Wolfgang di Goethe"
    },
    "2025-03-05": {
        "content": " Se scrivi cento racconti brevi e sono tutti brutti, non significa che hai fallito. Fallisci solo se smetti di scrivere. -Ray Bradbury"
    },
    "2025-03-06": {
        "content": " Il maestro ha fallito più volte di quante il principiante abbia mai provato. -Stephen McCranie"
    },
    "2025-03-07": {
        "content": " Al diavolo le circostanze: le opportunità le creo io. -Bruce Lee"
    },
    "2025-03-08": {
        "content": "L'unica cosa peggiore che iniziare qualcosa e fallire è non iniziare nulla. -Seth Godin"
    },
    "2025-03-09": {
        "content": " Non rimandare mai a domani quello che puoi fare oggi. -Benjamin Franklin"
    },
    "2025-03-10": {
        "content": " Con perseveranza la lumaca raggiunse l'arca. -Charles H. Spurgeon"
    },
    "2025-03-11": {
        "content": " Ricorda, la speranza è una cosa buona, forse la migliore delle cose, e nessuna cosa buona muore mai. -Stephen Re"
    },
    "2025-03-12": {
        "content": " Gli imprenditori non finiscono quando siamo stanchi. Finiamo quando abbiamo finito. -Robert T. Kiyosaki"
    },
    "2025-03-13": {
        "content": " Solo la perseveranza e la determinazione sono onnipotenti. -Calvin Coolidge"
    },
    "2025-03-14": {
        "content": " Paralizzare la resistenza con la perseveranza. -Giovedì 13 Novembre"
    },
    "2025-03-15": {
        "content": " Il successo non si possiede mai, si affitta, e l'affitto è dovuto ogni giorno. -Rory Vaden"
    },
    "2025-03-16": {
        "content": " Il successo non è un caso. È duro lavoro, perseveranza, apprendimento, studio, sacrificio e, soprattutto, amore per ciò che fai o impari a fare. -Pelé"
    },
    "2025-03-17": {
        "content": " Non c'è modo di aggirare il duro lavoro. Abbraccialo. -Roger Federer"
    },
    "2025-03-18": {
        "content": " Un sogno non diventa realtà per magia; ci vogliono sudore, determinazione e duro lavoro. -Colin Powell"
    },
    "2025-03-19": {
        "content": "Imparare non esaurisce mai la mente. -Leonardo da Vinci"
    },
    "2025-03-20": {
        "content": " Sento e dimentico. Vedo e ricordo. Faccio e capisco. -Confucio"
    },
    "2025-03-21": {
        "content": " Chi non ha mai commesso un errore non ha mai provato nulla di nuovo. -Albert Einstein"
    },
    "2025-03-22": {
        "content": " Cerca di imparare qualcosa su tutto e tutto su qualcosa. -Thomas Henry Huxley"
    },
    "2025-03-23": {
        "content": " L'uomo impara solo in due modi: leggendo e frequentando persone più intelligenti. -Will Rogers"
    },
    "2025-03-24": {
        "content": " Non capisci nulla finché non lo impari in più di un modo. -Marvin Minsky"
    },
    "2025-03-25": {
        "content": " Dimmi e dimentico, insegnami e potrei ricordare, coinvolgimi e imparo. -Benjamin Franklin"
    },
    "2025-03-26": {
        "content": " Se vuoi aumentare il tuo tasso di successo, raddoppia il tuo tasso di fallimento. -Thomas J. Watson"
    },
    "2025-03-27": {
        "content": " L'intelligenza è ciò a cui ricorriamo quando non sappiamo cosa fare. -Jean Piaget"
    },
    "2025-03-28": {
        "content": " Gli analfabeti del XXI secolo non saranno coloro che non sanno leggere e scrivere, ma coloro che non sanno imparare, disimparare e reimparare. -Alvin Toffler"
    },
    "2025-03-29": {
        "content": "Spesso è proprio ciò che già sappiamo a impedirci di imparare. -Claude Bernard"
    },
    "2025-03-30": {
        "content": " La matematica è il linguaggio con cui Dio ha scritto l'universo. -Galileo Galilei"
    },
    "2025-03-31": {
        "content": " Lo scopo dell'istruzione è trasformare gli specchi in finestre. -Sydney J. Harris"
    },
    "2025-04-01": {
        "content": " Non ho paura delle tempeste perché sto imparando a governare la mia nave. -Louisa May Alcott"
    },
    "2025-04-02": {
        "content": " L'unica persona istruita è quella che ha imparato a imparare e a cambiare. -Carl R. Rogers"
    },
    "2025-04-03": {
        "content": " Non ho mai incontrato un uomo così ignorante da non poter imparare qualcosa da lui. -Galileo Galilei"
    },
    "2025-04-04": {
        "content": " Niente scompare finché non ci ha insegnato ciò che dobbiamo sapere. -Pema Chodrön"
    },
    "2025-04-05": {
        "content": " La pratica rende perfetti. Dopo un lungo periodo di pratica, il nostro lavoro diventerà naturale, abile, rapido e costante. -Bruce Lee"
    },
    "2025-04-06": {
        "content": " Quando parli stai solo ripetendo qualcosa che già sai. Ma se ascolti potresti imparare qualcosa di nuovo. -Dalai Lama XIV"
    },
    "2025-04-07": {
        "content": " Impegnati per il progresso, non per la perfezione. -Anonimo"
    },
    "2025-04-08": {
        "content": "Faccio sempre quello che ancora non so fare, per imparare a farlo. -Vincent van Gogh"
    },
    "2025-04-09": {
        "content": " La conoscenza rende l'uomo inadatto a essere schiavo. -Federico Douglass"
    },
    "2025-04-10": {
        "content": " Ho imparato molto presto la differenza tra sapere il nome di qualcosa e conoscere effettivamente qualcosa. -Richard P. Feynman"
    },
    "2025-04-11": {
        "content": " La capacità di imparare è un dono; la capacità di imparare è un'abilità; la volontà di imparare è una scelta. -Brian Herbert"
    },
    "2025-04-12": {
        "content": " Impara tutto quello che puoi, in qualsiasi momento tu possa, da chiunque tu possa: arriverà sempre un momento in cui sarai grato di averlo fatto. -Sarah Caldwell"
    },
    "2025-04-13": {
        "content": " Non ho grande stima di un uomo che oggi non è più saggio di ieri. -Abramo Lincoln"
    },
    "2025-04-14": {
        "content": " La chiave del successo è la dedizione all'apprendimento continuo. -Stephen R. Covey"
    },
    "2025-04-15": {
        "content": " Sii appassionato e audace. Continua sempre a imparare. Smetti di fare cose utili se non impari. -Satya Nadella"
    },
    "2025-04-16": {
        "content": "L'attività più elevata che un essere umano possa raggiungere è imparare per comprendere, perché comprendere significa essere liberi. -Baruch Spinoza"
    },
    "2025-04-17": {
        "content": " Se non continui a imparare, gli altri ti ignoreranno. Il temperamento da solo non basta: hai bisogno di molta curiosità per molto, molto tempo. -Charlie Munger"
    },
    "2025-04-18": {
        "content": " Un'organizzazione che apprende è un'organizzazione che amplia continuamente la propria capacità di creare il proprio futuro. -Pietro Senge"
    },
    "2025-04-19": {
        "content": " Il giorno in cui smetti di imparare è il giorno in cui inizi a decadere. -Isaac Asimov"
    },
    "2025-04-20": {
        "content": " L'apprendimento è un ornamento nella prosperità, un rifugio nelle avversità e una provvista nella vecchiaia. -Aristotele"
    },
    "2025-04-21": {
        "content": " Tutti i leader sono studenti. Nel momento in cui smetti di imparare, smetti di guidare. Imparo il più possibile, da più persone possibili, il più spesso possibile. -Rick Warren"
    },
    "2025-04-22": {
        "content": " Per imparare cose difficili in fretta, devi concentrarti intensamente senza distrazioni. Imparare, in altre parole, è un atto di lavoro profondo. -Cal Newport"
    },
    "2025-04-23": {
        "content": " Anche un idiota può saperlo. Il punto è capire. -Albert Einstein"
    },
    "2025-04-24": {
        "content": "Trascorri ogni giorno cercando di essere un po' più saggio di quando ti sei svegliato. -Charlie Munger"
    },
    "2025-04-25": {
        "content": " Investi in te stesso, nella tua istruzione. Non c'è niente di meglio. -Sylvia Porter"
    },
    "2025-04-26": {
        "content": " L'autoformazione è per me una fonte continua di piacere, perché più so, più piena è la mia vita e più apprezzo la mia esistenza. -Isaac Asimov"
    },
    "2025-04-27": {
        "content": " Puoi farti aiutare dagli insegnanti, ma dovrai imparare molto da solo, seduto in una stanza. -Dr. Seuss"
    },
    "2025-04-28": {
        "content": " L'apprendimento avviene quando qualcuno vuole imparare, non quando qualcuno vuole insegnare. -Roger Schank"
    },
    "2025-04-29": {
        "content": " Una persona non può insegnare direttamente a un'altra persona; può solo facilitarne l'apprendimento. -Carl R. Rogers"
    },
    "2025-04-30": {
        "content": " L'apprendimento non è obbligatorio; è volontario. Il miglioramento non è obbligatorio; è volontario. Ma per sopravvivere, dobbiamo imparare. -W. Edwards Deming"
    },
    "2025-05-01": {
        "content": " Faccio sempre ciò che non so fare, per imparare a farlo. -Pablo Picasso"
    },
    "2025-05-02": {
        "content": "Nessun ladro, per quanto abile, può rubare la conoscenza, ed è per questo che la conoscenza è il tesoro migliore e più sicuro da acquisire. -L. Frank Baum"
    },
    "2025-05-03": {
        "content": " Penso che questo sia il consiglio migliore: pensa costantemente a come potresti fare meglio le cose e mettiti in discussione. -Elon Musk"
    },
    "2025-05-04": {
        "content": " Un uomo saggio può imparare di più da una domanda sciocca di quanto uno stolto possa imparare da una risposta saggia. -Bruce Lee"
    },
    "2025-05-05": {
        "content": " Se ho visto più lontano è stato perché sono salito sulle spalle dei Giganti. -Isacco Newton"
    },
    "2025-05-06": {
        "content": " Ciò che conosciamo è una goccia, ciò che non conosciamo è un oceano. -Isacco Newton"
    },
    "2025-05-07": {
        "content": " Il bello dell'imparare è che nessuno può portartelo via. -BB Re"
    },
    "2025-05-08": {
        "content": " Se vuoi diventare uno scrittore, devi fare due cose prima di ogni altra cosa: leggere molto e scrivere molto. -Stephen Re"
    },
    "2025-05-09": {
        "content": " La ripetizione è la madre dell'abilità. -Tony Robbins"
    },
    "2025-05-10": {
        "content": " La meraviglia è l'inizio della saggezza. -Socrate"
    },
    "2025-05-11": {
        "content": " Se commetti un errore e non lo correggi, questo si chiama errore. -Confucio"
    },
    "2025-05-12": {
        "content": " Lo scopo dell'istruzione è sostituire una mente vuota con una aperta. -Malcolm S. Forbes"
    },
    "2025-05-13": {
        "content": "Niente nella vita è da temere, è solo da comprendere. Ora è il momento di comprendere di più, così da temere di meno. -Marie Curie"
    },
    "2025-05-14": {
        "content": " Ogni volta che ti chiedono se sai fare un lavoro, rispondi \"Certamente che posso!\". Poi datti da fare e scopri come farlo. -Teodoro Roosevelt"
    },
    "2025-05-15": {
        "content": " Abbiamo tutti bisogno di persone che ci diano feedback. È così che miglioriamo. -Bill Gates"
    },
    "2025-05-16": {
        "content": " L'istruzione è la chiave per scoprire il mondo, un passaporto per la libertà. -Oprah Winfrey"
    },
    "2025-05-17": {
        "content": " Tutto inizia con un'idea. -Il conte Nightingale"
    },
    "2025-05-18": {
        "content": " Il miglior investimento che puoi fare è in te stesso. -Warren Buffett"
    },
    "2025-05-19": {
        "content": " Non è una questione di soldi o di conoscenze. È la volontà di lavorare e imparare più di tutti. -Marco cubano"
    },
    "2025-05-20": {
        "content": " Finché vivi, continua a imparare a vivere. -Seneca"
    },
    "2025-05-21": {
        "content": " Per imparare ad avere successo, devi prima imparare a fallire. -Michael Giordano"
    },
    "2025-05-22": {
        "content": " Non sprecare un buon errore, impara da esso. -Robert T. Kiyosaki"
    },
    "2025-05-23": {
        "content": "Per acquisire conoscenza bisogna studiare; ma per acquisire saggezza bisogna osservare. -Marilyn Vos Savant"
    },
    "2025-05-24": {
        "content": " Vivi e impari. In ogni caso, vivi. -Douglas Adams"
    },
    "2025-05-25": {
        "content": " La pazienza è compagna della saggezza. -Sant'Agostino"
    },
    "2025-05-26": {
        "content": " So solo una cosa: non so nulla. -Socrate"
    },
    "2025-05-27": {
        "content": " La saggezza deriva dall'esperienza. L'esperienza è spesso il risultato della mancanza di saggezza. -Terry Pratchett"
    },
    "2025-05-28": {
        "content": " Possiamo giudicare i nostri progressi dal coraggio delle nostre domande e dalla profondità delle nostre risposte, dalla nostra disponibilità ad abbracciare ciò che è vero piuttosto che ciò che ci fa sentire bene. -Carl Sagan"
    },
    "2025-05-29": {
        "content": " Preferisco avere domande a cui non si può rispondere piuttosto che risposte a cui non si può mettere in discussione. -Richard P. Feynman"
    },
    "2025-05-30": {
        "content": " Sono sempre pronto a imparare, anche se non sempre mi piace che mi venga insegnato qualcosa. -Winston Churchill"
    },
    "2025-05-31": {
        "content": " Chi ama la pratica senza la teoria è come il marinaio che sale su una nave senza timone e senza bussola e non sa mai dove gettare l'ancora. -Leonardo da Vinci"
    },
    "2025-06-01": {
        "content": " È meglio creare che imparare. Creare è l'essenza della vita. -Giulio Cesare"
    },
    "2025-06-02": {
        "content": "Ciò che fa la mano, la mente lo ricorda. -Maria Montessori"
    },
    "2025-06-03": {
        "content": " Affronta sempre la vita come se avessi qualcosa di nuovo da imparare, e lo farai. -Vernon Howard"
    },
    "2025-06-04": {
        "content": " Il fallimento è un successo se impariamo da esso. -Malcolm S. Forbes"
    },
    "2025-06-05": {
        "content": " L'istruzione è la migliore amica. Una persona istruita è rispettata ovunque. L'istruzione batte la bellezza e la gioventù. -Canakya"
    },
    "2025-06-06": {
        "content": " Non pensare che ciò che per te è difficile da padroneggiare sia umanamente impossibile; ma se una cosa è umanamente possibile, considerala alla tua portata. -Marco Aurelio"
    },
    "2025-06-07": {
        "content": " L'apprendimento è un processo di scoperta costante, un processo senza fine. -Bruce Lee"
    },
    "2025-06-08": {
        "content": " Essere ignoranti non è tanto una vergogna quanto non essere disposti a imparare. -Benjamin Franklin"
    },
    "2025-06-09": {
        "content": " Sono convinto che la conoscenza sia potere: per superare il passato, per cambiare le nostre situazioni, per combattere nuovi ostacoli, per prendere decisioni migliori. -Ben Carson"
    },
    "2025-06-10": {
        "content": " Inspirando, calmo corpo e mente. Espirando, sorrido. Soffermandomi nel momento presente, so che questo è l'unico momento. -Thich Nhat Hanh"
    },
    "2025-06-11": {
        "content": "Se pensi di essere troppo piccolo per fare la differenza, prova a dormire con una zanzara. -Dalai Lama XIV"
    },
    "2025-06-12": {
        "content": " Troppo spesso sottovalutiamo il potere di un tocco, di un sorriso, di una parola gentile, di un orecchio attento, di un complimento sincero o del più piccolo gesto di premura, tutti atti che hanno il potenziale di cambiare una vita. -Leo Buscaglia"
    },
    "2025-06-13": {
        "content": " Il modo in cui trascorriamo le nostre giornate, ovviamente, determina il modo in cui trascorriamo la nostra vita. -Annie Dillard"
    },
    "2025-06-14": {
        "content": " Nutri la tua mente con grandi pensieri, perché non andrai mai più in alto di quanto pensi. -Benjamin Disraeli"
    },
    "2025-06-15": {
        "content": " Non impari a camminare seguendo le regole. Impari facendo e cadendo. -Richard Branson"
    },
    "2025-06-16": {
        "content": " È impossibile vivere senza fallire in qualcosa, a meno che non si viva con tanta cautela da considerare che sarebbe come non aver vissuto affatto, nel qual caso si fallisce per impostazione predefinita. -JK Rowling"
    },
    "2025-06-17": {
        "content": " Se vuoi essere felice, sii. -Lev Tolstoj"
    },
    "2025-06-18": {
        "content": " Nessuno può farmi del male senza il mio permesso. -Mahatma Gandhi"
    },
    "2025-06-19": {
        "content": " Quando rinuncio a ciò che sono, divento ciò che potrei essere. -Lao Tzu"
    },
    "2025-06-20": {
        "content": "Il motivo per cui lottiamo contro l'insicurezza è perché confrontiamo il nostro dietro le quinte con i momenti salienti di tutti gli altri. -Steven Furtick"
    },
    "2025-06-21": {
        "content": " Ricordati che oggi è il domani di cui ti preoccupavi ieri. -Dale Carnegie"
    },
    "2025-06-22": {
        "content": " Dobbiamo essere disposti a rinunciare alla vita che abbiamo pianificato per avere la vita che ci aspetta. -Giuseppe Campbell"
    },
    "2025-06-23": {
        "content": " Smetti di partire e arriverai. Smetti di cercare e vedrai. Smetti di scappare e sarai trovato. -Lao Tzu"
    },
    "2025-06-24": {
        "content": " Un team non è un gruppo di persone che lavorano insieme. Un team è un gruppo di persone che si fidano l'una dell'altra. -Simon Sinek"
    },
    "2025-06-25": {
        "content": " L'ottimismo perpetuo è un moltiplicatore di forza. -Colin Powell"
    },
    "2025-06-26": {
        "content": " Quando ti accontenti di essere semplicemente te stesso e non fai paragoni o competizioni, tutti ti rispetteranno. -Lao Tzu"
    },
    "2025-06-27": {
        "content": " Conta la tua età in base agli amici, non agli anni. Conta la tua vita in base ai sorrisi, non alle lacrime. -John Lennon"
    },
    "2025-06-28": {
        "content": " Dona a chi ami ali per volare, radici per tornare e motivi per restare. -Dalai Lama XIV"
    },
    "2025-06-29": {
        "content": " La perseveranza e lo spirito hanno fatto miracoli in tutte le epoche. -Giorgio Washington"
    },
    "2025-06-30": {
        "content": "Condividi la tua conoscenza. È un modo per raggiungere l'immortalità. -Dalai Lama XIV"
    },
    "2025-07-01": {
        "content": " Siamo un mezzo attraverso cui il cosmo può conoscere se stesso. -Carl Sagan"
    },
    "2025-07-02": {
        "content": " Un buon insegnante può ispirare speranza, accendere l'immaginazione e instillare l'amore per l'apprendimento. -Direttore: Brad Henry"
    },
    "2025-07-03": {
        "content": " Una delle più grandi scoperte che una persona possa fare, una delle sue più grandi sorprese, è scoprire di poter fare ciò che temeva di non poter fare. -Henry Ford"
    },
    "2025-07-04": {
        "content": " Quando è stata l'ultima volta che hai fatto qualcosa per la prima volta? -John C. Maxwell"
    },
    "2025-07-05": {
        "content": " Se non sei nel processo di diventare la persona che vuoi essere, sei automaticamente impegnato a diventare la persona che non vuoi essere. -Dale Carnegie"
    },
    "2025-07-06": {
        "content": " La fortuna aiuta gli audaci. -Proverbio latino"
    },
    "2025-07-07": {
        "content": " Il successo non è la chiave della felicità. La felicità è la chiave del successo. Se ami ciò che fai, avrai successo. -Albert Schweitzer"
    },
    "2025-07-08": {
        "content": " Non guadagnare il mondo e perdere la tua anima; la saggezza vale più dell'argento e dell'oro. -Bob Marley"
    },
    "2025-07-09": {
        "content": " Comincia subito a vivere e considera ogni singolo giorno come una vita a sé stante. -Seneca"
    },
    "2025-07-10": {
        "content": " meno che a qualcuno come te non importi un granché, niente migliorerà. Non è così. -Dr. Seuss"
    },
    "2025-07-11": {
        "content": " Non sapevano che fosse impossibile, quindi lo fecero. -Mark Twain"
    },
    "2025-07-12": {
        "content": " Io posso fare cose che tu non puoi, tu puoi fare cose che io non posso; insieme possiamo fare grandi cose. -Madre Teresa"
    },
    "2025-07-13": {
        "content": " L'unica cosa di cui dobbiamo avere paura è la paura stessa. -Franklin D. Roosevelt"
    },
    "2025-07-14": {
        "content": " Senza entusiasmo non si è mai realizzato nulla di grande. -Ralph Waldo Emerson"
    },
    "2025-07-15": {
        "content": " Coraggio, caro cuore. -CS Lewis"
    },
    "2025-07-16": {
        "content": " L'unico modo per dare un senso al cambiamento è immergersi in esso, muoversi con esso e unirsi alla danza. -Alan Watts"
    },
    "2025-07-17": {
        "content": " Dove va l'attenzione, scorre l'energia e si vedono i risultati. -T. Harv Eker"
    },
    "2025-07-18": {
        "content": " Il dolore è temporaneo. Può durare un minuto, un'ora, un giorno o un anno, ma alla fine si attenuerà e qualcos'altro prenderà il suo posto. Se smetto, tuttavia, durerà per sempre. -Lance Armstrong"
    },
    "2025-07-19": {
        "content": " In ogni passeggiata nella natura si riceve molto più di quanto si cerchi. -Giovanni Muir"
    },
    "2025-07-20": {
        "content": " vincitori non sono coloro che non falliscono mai, ma coloro che non si arrendono mai. -Edwin Louis Cole"
    },
    "2025-07-21": {
        "content": " Invece di combattere l'oscurità, fai entrare la luce. -Eckhart Tolle"
    },
    "2025-07-22": {
        "content": " Sii coraggioso nel perseguire ciò che accende la tua anima. -Jennifer Lee"
    },
    "2025-07-23": {
        "content": " Quando le persone se ne vanno da te, lasciale andare. Il tuo destino non è mai legato a chi ti lascia, e non significa che siano cattive persone. Significa solo che la loro parte nella tua storia è finita. -TD Jakes"
    },
    "2025-07-24": {
        "content": " La leadership è la capacità di tradurre la visione in realtà. -Warren G. Bennis"
    },
    "2025-07-25": {
        "content": " La fede è credere a ciò che non si vede; la ricompensa di questa fede è vedere ciò in cui si crede. -Sant'Agostino"
    },
    "2025-07-26": {
        "content": " Niente è impossibile, a meno che tu non lo creda. -Paramahansa Yogananda"
    },
    "2025-07-27": {
        "content": " L'unica cosa peggiore dell'essere ciechi è avere la vista ma non la capacità visiva. -Helen Keller"
    },
    "2025-07-28": {
        "content": " Ogni cosa ha la sua bellezza, ma non tutti la vedono. -Confucio"
    },
    "2025-07-29": {
        "content": " Dio parla nel silenzio del cuore. -Madre Teresa"
    },
    "2025-07-30": {
        "content": "La speranza è quella cosa con le piume che si appollaia nell'anima, e canta la melodia senza le parole, senza mai fermarsi. -Emily Dickinson"
    },
    "2025-07-31": {
        "content": " Per quante parole sante tu legga, per quante ne pronunci, a cosa ti serviranno se non le metti in pratica? -Buddha"
    },
    "2025-08-01": {
        "content": " E a proposito, tutto nella vita è scrivibile se hai il coraggio di farlo e l'immaginazione di improvvisare. Il peggior nemico della creatività è l'insicurezza. -Sylvia Plath"
    },
    "2025-08-02": {
        "content": " Niente di ciò che facciamo può cambiare il passato, ma tutto ciò che facciamo cambia il futuro. -Ashleigh Brillante"
    },
    "2025-08-03": {
        "content": " La leadership è una scelta. Non è un grado. -Simon Sinek"
    },
    "2025-08-04": {
        "content": " Tutto andrà bene, tutto andrà bene e ogni cosa andrà bene. -Giuliano di Norwich"
    },
    "2025-08-05": {
        "content": " Ognuno di noi è, nella prospettiva cosmica, prezioso. Se un umano non è d'accordo con te, lascialo vivere. In cento miliardi di galassie, non ne troverai un altro. -Carl Sagan"
    },
    "2025-08-06": {
        "content": " Intelligenza più carattere: questo è l'obiettivo della vera educazione. -Martin Luther King Jr."
    },
    "2025-08-07": {
        "content": "Quanto più ti perdi in qualcosa di più grande di te, tanta più energia avrai. -Norman Vincent Peale"
    },
    "2025-08-08": {
        "content": " Impara le basi e il livello di tutto ciò che fai aumenterà -Michael Giordano"
    },
    "2025-08-09": {
        "content": " Non puoi vivere affatto se non vivi pienamente adesso. -Alan Watts"
    },
    "2025-08-10": {
        "content": " Ricorda che a volte non ottenere ciò che desideri è un colpo di fortuna meraviglioso. -Dalai Lama XIV"
    },
    "2025-08-11": {
        "content": " Fai del tuo meglio e poi rilassati. Lascia che le cose vadano avanti in modo naturale, anziché forzarle. -Paramahansa Yogananda"
    },
    "2025-08-12": {
        "content": " Sei un essere spirituale infinito che sta vivendo un'esperienza umana temporanea. -Wayne W. Dyer"
    },
    "2025-08-13": {
        "content": " Bisogna sognare prima che i propri sogni possano avverarsi. -Abdul Kalam"
    },
    "2025-08-14": {
        "content": " Custodisci soprattutto il tuo cuore, perché tutto ciò che fai scaturisce da esso. -Salomone"
    },
    "2025-08-15": {
        "content": " Mentre scrivo riesco a scrollarmi di dosso tutto; i miei dolori scompaiono, il mio coraggio rinasce. -Anna Frank"
    },
    "2025-08-16": {
        "content": " L'obiettivo non è essere perfetti alla fine. L'obiettivo è essere migliori oggi. -Simon Sinek"
    },
    "2025-08-17": {
        "content": " Vai con sicurezza nella direzione dei tuoi sogni. Vivi la vita che hai immaginato. -Henry David Thoreau"
    },
    "2025-08-18": {
        "content": "Siate gentili ogni volta che è possibile. È sempre possibile. -Dalai Lama XIV"
    },
    "2025-08-19": {
        "content": " Il nostro scopo principale in questa vita è aiutare gli altri. E se non puoi aiutarli, almeno non far loro del male. -Dalai Lama XIV"
    },
    "2025-08-20": {
        "content": " Hai un cervello nella testa. Hai i piedi nelle scarpe. Puoi orientarti in qualsiasi direzione tu scelga. Sei da solo. E sai quello che sai. E sei tu quello che deciderà dove andare. -Dr. Seuss"
    },
    "2025-08-21": {
        "content": " Ciò su cui ti concentri si espande e quando ti concentri sulle cose buone della tua vita, ne crei di più. -Oprah Winfrey"
    },
    "2025-08-22": {
        "content": " Tutto ciò che ho bisogno di sapere mi viene rivelato. Tutto ciò di cui ho bisogno mi viene incontro. Tutto va bene nella mia vita. -Louise Fieno"
    },
    "2025-08-23": {
        "content": " Sono totalmente al sicuro nell'Universo. Sono in pace ovunque. Ho fiducia nella vita. -Louise Fieno"
    },
    "2025-08-24": {
        "content": " Rivolgi il viso verso il sole e le ombre cadranno dietro di te. -Proverbio Maori"
    },
    "2025-08-25": {
        "content": " Il coraggio non è avere la forza di andare avanti; è andare avanti quando non si ha la forza. -Teodoro Roosevelt"
    },
    "2025-08-26": {
        "content": " Il futuro dipende da ciò che fai oggi. -Mahatma Gandhi"
    },
    "2025-08-27": {
        "content": " Un vincitore è un sognatore che non si arrende mai. -Nelson Mandela"
    },
    "2025-08-28": {
        "content": "Non piangere perché è finita, sorridi perché è successo. -Dr. Seuss"
    },
    "2025-08-29": {
        "content": " In tre parole posso riassumere tutto quello che ho imparato sulla vita: continua. -Robert Gelo"
    },
    "2025-08-30": {
        "content": " Vivi seguendo la tua immaginazione, non la tua storia. -Stephen R. Covey"
    },
    "2025-08-31": {
        "content": " A mio avviso, se vuoi l'arcobaleno, devi sopportare la pioggia. -Dolly Parton"
    },
    "2025-09-01": {
        "content": " La grandezza di un uomo non risiede nella quantità di ricchezza che acquisisce, ma nella sua integrità e nella sua capacità di influenzare positivamente chi lo circonda. -Bob Marley"
    },
    "2025-09-02": {
        "content": " La felicità deriva principalmente dal nostro atteggiamento, piuttosto che da fattori esterni. -Dalai Lama XIV"
    },
    "2025-09-03": {
        "content": " Le grandi azioni sono fatte di piccole azioni. -Lao Tzu"
    },
    "2025-09-04": {
        "content": " Non è mai troppo tardi per essere ciò che avresti potuto essere. -George Eliot"
    },
    "2025-09-05": {
        "content": " Adottare l'atteggiamento giusto può trasformare uno stress negativo in uno positivo. -Hans Selye"
    },
    "2025-09-06": {
        "content": " Osate vivere la vita che avete sognato per voi stessi. Andate avanti e fate sì che i vostri sogni diventino realtà. -Ralph Waldo Emerson"
    },
    "2025-09-07": {
        "content": " Il tempo che ti piace sprecare non è tempo sprecato. -Bertrand Russell"
    },
    "2025-09-08": {
        "content": "Basta un po' di attenzione per vedere e scoprire: la vita è davvero una grande risata cosmica. -Osho"
    },
    "2025-09-09": {
        "content": " Il curioso paradosso è che quando mi accetto così come sono, allora posso cambiare. -Carl R. Rogers"
    },
    "2025-09-10": {
        "content": " Sii parte della soluzione, non parte del problema. -Stephen R. Covey"
    },
    "2025-09-11": {
        "content": " Il segreto della vita è dare. -Tony Robbins"
    },
    "2025-09-12": {
        "content": " Fai di ogni giorno il tuo capolavoro. -John Legno"
    },
    "2025-09-13": {
        "content": " Non rinunciare mai a ciò che vuoi veramente fare Italiano:"
    },
    "2025-09-14": {
        "content": " Non voltarti indietro: non andrai da quella parte. -Mary Engelbreit"
    },
    "2025-09-15": {
        "content": " Fai del tuo meglio e Dio farà il resto. -Nick Vujicic"
    },
    "2025-09-16": {
        "content": " Vivi, viaggia, vivi l'avventura, benedici e non pentirti. -Jack Kerouac"
    },
    "2025-09-17": {
        "content": " Nel bel mezzo dell'inverno, ho scoperto che dentro di me c'era un'estate invincibile. E questo mi rende felice. Perché dice che non importa quanto duramente il mondo mi spinga contro, dentro di me c'è qualcosa di più forte, qualcosa di meglio, che mi spinge indietro. -Albert Camus"
    },
    "2025-09-18": {
        "content": "Alcuni credono che solo un grande potere possa tenere a bada il male, ma non è quello che ho scoperto. Sono le piccole azioni quotidiane della gente comune che tengono a bada l'oscurità. Piccoli atti di gentilezza e amore. -JRR Tolkien"
    },
    "2025-09-19": {
        "content": " Sii fedele nelle piccole cose perché è in esse che risiede la tua forza. -Madre Teresa"
    },
    "2025-09-20": {
        "content": " Renditi una luce. -Buddha"
    },
    "2025-09-21": {
        "content": " VISUALIZZA!!! Guardalo, sentilo! È qui che inizia l'azione. -Rhonda Byrne"
    },
    "2025-09-22": {
        "content": " Sii fenomenale o verrai dimenticato! -Eric Thomas"
    },
    "2025-09-23": {
        "content": " Quando puoi scegliere tra avere ragione o essere gentile, scegli di essere gentile. -Wayne W. Dyer"
    },
    "2025-09-24": {
        "content": " Gli esseri umani possono cambiare la propria vita modificando il proprio atteggiamento mentale. -Guglielmo James"
    },
    "2025-09-25": {
        "content": " La salute è il bene più prezioso. -Laozi"
    },
    "2025-09-26": {
        "content": " Non lasciarmi pregare per essere al riparo dai pericoli, ma per essere impavido nell'affrontarli. Non lasciarmi implorare la calma del mio dolore, ma il cuore per vincerlo. -Rabindranath Tagore"
    },
    "2025-09-27": {
        "content": " Metti il tuo cuore nel fare del bene. Fallo più e più volte, e sarai pieno di gioia. -Buddha"
    },
    "2025-09-28": {
        "content": "Da solo non posso cambiare il mondo, ma posso lanciare un sasso nell'acqua e creare numerose increspature. -Madre Teresa"
    },
    "2025-09-29": {
        "content": " E venne il giorno in cui il rischio di restare chiusi in un bocciolo era più doloroso del rischio di sbocciare. -Anaïs Nin"
    },
    "2025-09-30": {
        "content": " Non dovrebbero esserci limiti all'impegno umano. Per quanto brutta possa sembrare la vita, c'è sempre speranza. -Stephen Hawking"
    },
    "2025-10-01": {
        "content": " E vi esorto a notare quando siete felici, e a esclamare o mormorare o pensare a un certo punto: \"Se questo non è bello, non so cosa lo sia\". -Kurt Vonnegut"
    },
    "2025-10-02": {
        "content": " È la tua reazione alle avversità, non l'avversità in sé, a determinare come si svilupperà la storia della tua vita. -Dieter F. Uchtdorf"
    },
    "2025-10-03": {
        "content": " Non è ciò che hai o chi sei o dove sei o cosa stai facendo che ti rende felice o infelice. È ciò che pensi a riguardo. -Dale Carnegie"
    },
    "2025-10-04": {
        "content": " Più leggi, più cose saprai. Più impari, più posti visiterai. -Dr. Seuss"
    },
    "2025-10-05": {
        "content": " Tutti i nostri sogni possono diventare realtà. -Walt Disney"
    },
    "2025-10-06": {
        "content": "Il privilegio di una vita è essere chi sei. -Giuseppe Campbell"
    },
    "2025-10-07": {
        "content": " Nessuno è inutile in questo mondo se alleggerisce i fardelli di un altro. -Carlo Dickens"
    },
    "2025-10-08": {
        "content": " Trova un posto dentro di te dove c'è gioia, e la gioia brucerà il dolore. -Giuseppe Campbell"
    },
    "2025-10-09": {
        "content": " Non chiederti di cosa ha bisogno il mondo. Chiediti cosa ti fa sentire vivo e fallo. Perché ciò di cui ha bisogno il mondo è più gente che si sia sentita viva. -Howard Thurman"
    },
    "2025-10-10": {
        "content": " I tuoi sentimenti sono il tuo strumento più importante per creare la tua vita. -Rhonda Byrne"
    },
    "2025-10-11": {
        "content": " Merito il meglio e accetto il meglio fin da ora. -Louise Fieno"
    },
    "2025-10-12": {
        "content": " Non è importante quanto diamo, ma quanto amore mettiamo nel donare. -Madre Teresa"
    },
    "2025-10-13": {
        "content": " Quando vuoi avere successo con tutta la tua forza di volontà, allora avrai successo. -Eric Thomas"
    },
    "2025-10-14": {
        "content": " Odiavo ogni minuto di allenamento, ma dicevo: \"Non mollare. Soffri ora e vivi il resto della tua vita da campione\". -Muhammad Ali"
    },
    "2025-10-15": {
        "content": "Non è il critico che conta, non colui che sottolinea come l'uomo forte sia inciampato o come l'autore delle azioni avrebbe potuto farle meglio. Il merito spetta all'uomo che è effettivamente nell'arena, il cui volto è segnato da sudore, polvere e sangue; che si sforza coraggiosamente; che sbaglia e fallisce ancora e ancora; che conosce i grandi entusiasmi, le grandi devozioni e si spende per una causa degna; che, se vince, conosce il trionfo di grandi risultati; e che, se fallisce, almeno fallisce osando molto, così che il suo posto non sarà mai con quelle anime fredde e timide che non conoscono né vittoria né sconfitta. -Teodoro Roosevelt"
    },
    "2025-10-16": {
        "content": " L'avventura più grande che tu possa mai intraprendere è vivere la vita dei tuoi sogni. -Oprah Winfrey"
    },
    "2025-10-17": {
        "content": " Senza lotta non può esserci progresso. -Federico Douglass"
    },
    "2025-10-18": {
        "content": " Un sogno scritto con una data diventa un obiettivo. Un obiettivo suddiviso in passaggi diventa un piano. Un piano supportato dall'azione fa sì che i tuoi sogni diventino realtà. -Greg Reid"
    },
    "2025-10-19": {
        "content": "Fai l'unica cosa che pensi di non poter fare. Fallisci. Riprova. Fai meglio la seconda volta. Le uniche persone che non cadono mai sono quelle che non salgono mai sul filo teso. -Oprah Winfrey"
    },
    "2025-10-20": {
        "content": " Aspettatevi il cambiamento. Analizzate il panorama. Cogliete le opportunità. Smettete di essere il pezzo degli scacchi; diventate il giocatore. È la vostra mossa. -Tony Robbins"
    },
    "2025-10-21": {
        "content": " Sei libero. Sei potente. Sei buono. Sei amore. Hai valore. Hai uno scopo. Tutto va bene. -Esther Hicks"
    },
    "2025-10-22": {
        "content": "Se desideri una cosa abbastanza da uscire e combattere per essa, da lavorare giorno e notte per essa, da rinunciare al tuo tempo, alla tua pace e al tuo sonno per essa; se tutto ciò che sogni e progetti riguarda quella cosa e la vita sembra inutile e senza valore senza di essa; se ti agiti volentieri per essa, ti agiti e progetti per essa e perdi tutto il tuo terrore per l'opposizione; se semplicemente insegui quella cosa che vuoi con tutte le tue capacità, forza e sagacia, fede, speranza e fiducia e severità per la tenacia; se né il freddo né la povertà, la fame o la gotta, la malattia o il dolore del corpo e del cervello possono tenerti lontano dalla cosa che vuoi; se sei tenace e ostinato e la generi, con l'aiuto di DIO la otterrai. -Berton Braley"
    },
    "2025-10-23": {
        "content": " Anche se sei sulla strada giusta, se rimani lì seduto verrai investito. -Will Rogers"
    },
    "2025-10-24": {
        "content": " Penso che sia possibile per le persone comuni scegliere di essere straordinarie. -Elon Musk"
    },
    "2025-10-25": {
        "content": " Non impari a camminare seguendo le regole. Impari facendo e cadendo. -Richard Branson"
    },
    "2025-10-26": {
        "content": "Non c'è talento qui, questo è duro lavoro. Questa è un'ossessione. Il talento non esiste, siamo tutti uguali come esseri umani. Potresti essere chiunque se ci metti tempo. Raggiungerai la cima, e questo è tutto. Non ho talento, sono ossessionato. -Conor McGregor"
    },
    "2025-10-27": {
        "content": " Un sogno non è ciò che vedi mentre dormi; è qualcosa che non ti lascia dormire. -Abdul Kalam"
    },
    "2025-10-28": {
        "content": " Quando hai esaurito tutte le possibilità, ricorda questo: non è così. -Thomas A. Edison"
    },
    "2025-10-29": {
        "content": " Prendi delle opportunità, commetti degli errori. È così che cresci. Il dolore nutre il tuo coraggio. Devi fallire per esercitarti a essere coraggioso. -Mary Tyler Moore"
    },
    "2025-10-30": {
        "content": " Ciò su cui ti concentri è ciò che ottieni. -Tony Robbins"
    },
    "2025-10-31": {
        "content": " \"Hustle\" è la parola più importante in assoluto. -Gary Vaynerchuk"
    },
    "2025-11-01": {
        "content": " Se sono riusciti a ricavare la penicillina dal pane ammuffito, allora possono sicuramente ricavare qualcosa da te. -Muhammad Ali"
    },
    "2025-11-02": {
        "content": " Non sei nato vincitore e non sei nato perdente. Sei ciò che ti fai essere. -Lou Holtz"
    },
    "2025-11-03": {
        "content": " Il successo è un tuo dovere, obbligo e responsabilità. -Grant Cardone"
    },
    "2025-11-04": {
        "content": "C'è poca differenza nelle persone, ma quella piccola differenza fa una grande differenza. La piccola differenza è l'atteggiamento. La grande differenza è se è positivo o negativo. -W. Clemente Pietra"
    },
    "2025-11-05": {
        "content": " I leader devono essere sufficientemente vicini per relazionarsi con gli altri, ma sufficientemente avanti per motivarli. -John C. Maxwell"
    },
    "2025-11-06": {
        "content": " Mai dire mai, perché i limiti, come le paure, sono spesso solo un'illusione. -Michael Giordano"
    },
    "2025-11-07": {
        "content": " Devi aspettarti grandi cose da te stesso prima di poterle realizzare. -Michael Giordano"
    },
    "2025-11-08": {
        "content": " Nel mondo degli affari, le persone che hanno più successo sono quelle che fanno ciò che amano. -Warren Buffett"
    },
    "2025-11-09": {
        "content": " L'azione distruggerà la tua procrastinazione. -Og Mandino"
    },
    "2025-11-10": {
        "content": " Il fallimento non è un'opzione per me. Il successo è tutto ciò che immagino. -Conor McGregor"
    },
    "2025-11-11": {
        "content": " Il successo non deriva da ciò che fai occasionalmente, ma da ciò che fai costantemente. -Marie Forleo"
    },
    "2025-11-12": {
        "content": " La fiducia e il duro lavoro sono le migliori medicine per uccidere la malattia chiamata fallimento. Ti renderanno una persona di successo. -Abdul Kalam"
    },
    "2025-11-13": {
        "content": " Se vuoi brillare come il sole, prima brucia come il sole. -Abdul Kalam"
    },
    "2025-11-14": {
        "content": "Mentre tu sei là fuori a fare festa, a scherzare, c'è qualcuno là fuori che lavora sodo nello stesso momento. Qualcuno sta diventando più intelligente e qualcuno sta vincendo. Ricordatelo. -Arnold Schwarzenegger"
    },
    "2025-11-15": {
        "content": " Se fai quello che hai sempre fatto, otterrai quello che hai sempre ottenuto. -Tony Robbins"
    },
    "2025-11-16": {
        "content": " Progresso uguale felicità. -Tony Robbins"
    },
    "2025-11-17": {
        "content": " Puoi avere risultati o scuse. Non entrambi. -Arnold Schwarzenegger"
    },
    "2025-11-18": {
        "content": " Disciplina uguale libertà. -Jocko Willink"
    },
    "2025-11-19": {
        "content": " Non soffermarti su cosa è andato storto. Concentrati invece su cosa fare dopo. Dedica le tue energie ad andare avanti, verso la ricerca della risposta. -Disegno di Denis Waitley"
    },
    "2025-11-20": {
        "content": " Sii il leader che vorresti avere. -Simon Sinek"
    },
    "2025-11-21": {
        "content": " Il mio atteggiamento è che se mi spingi verso qualcosa che ritieni una debolezza, allora trasformerò quella debolezza percepita in un punto di forza. -Michael Giordano"
    },
    "2025-11-22": {
        "content": " Per la maggior parte di noi il pericolo maggiore non sta nel prefissare obiettivi troppo alti e non raggiungerli, ma nel prefissarli troppo bassi e non raggiungerli. -Michelangelo"
    },
    "2025-11-23": {
        "content": " Tutti hanno un sogno, ma non tutti hanno una sfida. -Eric Thomas"
    },
    "2025-11-24": {
        "content": " leader si creano, non si nasce. Si creano con duro sforzo, che è il prezzo che tutti noi dobbiamo pagare per raggiungere qualsiasi obiettivo che valga la pena. -Vince Lombardi"
    },
    "2025-11-25": {
        "content": " Scegliamo di andare sulla luna in questo decennio e fare le altre cose. Non perché siano facili, ma perché sono difficili. -John F. Kennedy"
    },
    "2025-11-26": {
        "content": " Il giorno più bello della tua vita e della mia è quando ci assumiamo la totale responsabilità dei nostri atteggiamenti. È il giorno in cui cresciamo davvero. -John C. Maxwell"
    },
    "2025-11-27": {
        "content": " Ogni volta che sorridi a qualcuno, è un gesto d'amore, un regalo a quella persona, una cosa meravigliosa. -Madre Teresa"
    },
    "2025-11-28": {
        "content": " Sii l'osservatore silenzioso dei tuoi pensieri e del tuo comportamento. Sei sotto il pensatore. Sei la quiete sotto il rumore mentale. Sei l'amore e la gioia sotto il dolore. -Eckhart Tolle"
    },
    "2025-11-29": {
        "content": " Se non puoi volare allora corri, se non puoi correre allora cammina, se non puoi camminare allora striscia, ma qualsiasi cosa tu faccia devi continuare ad andare avanti. -Martin Luther King Jr."
    },
    "2025-11-30": {
        "content": " Il perdono non è un atto occasionale, è un atteggiamento costante. -Martin Luther King Jr."
    },
    "2025-12-01": {
        "content": " Troppo spesso sottovalutiamo il potere di un tocco, di un sorriso, di una parola gentile, di un orecchio attento, di un complimento sincero o del più piccolo gesto di premura, tutti atti che hanno il potenziale di cambiare una vita. -Leo Buscaglia"
    },
    "2025-12-02": {
        "content": "Mantieni vivi i tuoi sogni. Comprendi che per raggiungere qualsiasi cosa servono fede e convinzione in te stesso, visione, duro lavoro, determinazione e dedizione. Ricorda che tutte le cose sono possibili per coloro che credono. -Gail Devers"
    },
    "2025-12-03": {
        "content": " Lo sport ha il potere di cambiare il mondo. Ha il potere di ispirare. Ha il potere di unire le persone in un modo che poche altre cose riescono a fare. Parla ai giovani in un linguaggio che capiscono. Lo sport può creare speranza dove una volta c'era solo disperazione. -Nelson Mandela"
    },
    "2025-12-04": {
        "content": " Chiedi ciò che vuoi. Credi di meritarlo, e poi lascia che la Vita te lo dia. -Louise Fieno"
    },
    "2025-12-05": {
        "content": " Vivi con intenzione. Cammina fino al limite. Ascolta attentamente. Pratica il benessere. Gioca con abbandono. Ridi. Scegli senza rimpianti. Apprezza i tuoi amici. Continua a imparare. Fai ciò che ami. Vivi come se questo fosse tutto ciò che c'è. -Mary Anne Radmacher"
    },
    "2025-12-06": {
        "content": " Ciò su cui ti concentri si espande e quando ti concentri sulle cose buone della tua vita, ne crei di più. -Oprah Winfrey"
    },
    "2025-12-07": {
        "content": " Hai potere sulla tua mente, non sugli eventi esterni. Renditi conto di questo, e troverai la forza. -Marco Aurelio"
    },
    "2025-12-08": {
        "content": "Non cercare scuse per non farcela. Concentrati su tutte le ragioni per cui devi farcela. -Ralph Marston"
    },
    "2025-12-09": {
        "content": " Dove c'è amore c'è vita. -Mahatma Gandhi"
    },
    "2025-12-10": {
        "content": " Devi ballare come se nessuno ti guardasse, amare come se non ti facessero mai del male, cantare come se nessuno ti ascoltasse e vivere come se il paradiso fosse in terra. -William W. Purkey"
    },
    "2025-12-11": {
        "content": " Il successo consiste nel conoscere il proprio scopo nella vita, crescere per raggiungere il proprio massimo potenziale e piantare semi che siano utili agli altri. -John C. Maxwell"
    },
    "2025-12-12": {
        "content": " Un sogno che fai da solo è solo un sogno. Un sogno che fai insieme è realtà. -John Lennon"
    },
    "2025-12-13": {
        "content": " Questo è il vero segreto della vita: essere completamente coinvolti in ciò che fai qui e ora. E invece di chiamarlo lavoro, renditi conto che è un gioco. -Alan Watts"
    },
    "2025-12-14": {
        "content": " Ieri è passato. Domani non è ancora arrivato. Abbiamo solo oggi. Cominciamo. -Madre Teresa"
    },
    "2025-12-15": {
        "content": " Più lodi e celebri la tua vita, più nella vita c'è da celebrare. -Oprah Winfrey"
    },
    "2025-12-16": {
        "content": "Non dubitare mai che un piccolo gruppo di cittadini riflessivi e impegnati possa cambiare il mondo. In effetti, è l'unica cosa che abbia mai fatto. -Margaret Mead"
    },
    "2025-12-17": {
        "content": " Sforzati, perché nessun altro lo farà per te. -Anonimo"
    },
    "2025-12-18": {
        "content": " La vera umiltà non è pensare meno a se stessi; è pensare meno a se stessi. -CS Lewis"
    },
    "2025-12-19": {
        "content": " Se puoi cambiare idea, puoi cambiare la tua vita. -Guglielmo James"
    },
    "2025-12-20": {
        "content": " Concentrati su dove vuoi arrivare, non su ciò che temi. -Tony Robbins"
    },
    "2025-12-21": {
        "content": " Rispetta te stesso e gli altri ti rispetteranno. -Confucio"
    },
    "2025-12-22": {
        "content": " Fai quello che puoi, con quello che hai, dove sei. -Teodoro Roosevelt"
    },
    "2025-12-23": {
        "content": " Alcuni cambiamenti possono sembrare negativi in superficie, ma presto ti renderai conto che nella tua vita si sta creando spazio affinché qualcosa di nuovo possa emergere. -Eckhart Tolle"
    },
    "2025-12-24": {
        "content": " Se le tue azioni ispirano gli altri a sognare di più, imparare di più, fare di più e diventare di più, sei un leader. -Giovanni Quincy Adams"
    },
    "2025-12-25": {
        "content": " Non preoccuparti di nulla, tutto andrà per il meglio. -Bob Marley"
    },
    "2025-12-26": {
        "content": " Sogna in grande, sii positivo, lavora sodo e goditi il viaggio. -Urija Faber"
    },
    "2025-12-27": {
        "content": "Tu sei qui per consentire allo scopo divino dell'Universo di dispiegarsi. Ecco quanto sei importante! -Eckhart Tolle"
    },
    "2025-12-28": {
        "content": " Vivi con passione! -Tony Robbins"
    },
    "2025-12-29": {
        "content": " Credimi e sarai a metà strada. -Teodoro Roosevelt"
    },
    "2025-12-30": {
        "content": " La nostra vita comincia a finire il giorno in cui taciamo sulle cose importanti. -Martin Luther King Jr."
    },
    "2025-12-31": {
        "content": " Insieme possiamo fare grandi cose. -Madre Teresa"
    },
    "2026-01-01": {
        "content": " Lavorare sodo per qualcosa che non ci interessa si chiama stress; lavorare sodo per qualcosa che amiamo si chiama passione. -Simon Sinek"
    },
    "2026-01-02": {
        "content": " La caverna in cui hai paura di entrare nasconde il tesoro che cerchi. -Giuseppe Campbell"
    },
    "2026-01-03": {
        "content": " La leadership riguarda l'empatia. Riguarda la capacità di relazionarsi e connettersi con le persone allo scopo di ispirare e rafforzare le loro vite. -Oprah Winfrey"
    },
    "2026-01-04": {
        "content": " Non c'è nulla di impossibile per chi ci prova. -Alessandro Magno"
    },
    "2026-01-05": {
        "content": " La maggior parte delle cose importanti al mondo sono state realizzate da persone che hanno continuato a provare quando sembrava non esserci più alcuna speranza. -Dale Carnegie"
    },
    "2026-01-06": {
        "content": " Continuiamo ad andare avanti, ad aprire nuove porte e a fare cose nuove, perché siamo curiosi e la curiosità continua a condurci verso nuove strade. -Walt Disney"
    },
    "2026-01-07": {
        "content": "Fai quello che devi fare finché non riesci a fare quello che vuoi fare. -Oprah Winfrey"
    },
    "2026-01-08": {
        "content": " Credere di essere abbastanza è ciò che ti dà il coraggio di essere autentici. -Brené Marrone"
    },
    "2026-01-09": {
        "content": " Sono le nostre scelte, Harry, a dimostrare chi siamo veramente, molto più delle nostre capacità. -JK Rowling"
    },
    "2026-01-10": {
        "content": " Segui la tua felicità e l'universo ti aprirà porte lì dove prima c'erano solo muri. -Giuseppe Campbell"
    },
    "2026-01-11": {
        "content": " I sogni non sono quelli che ci vengono mentre dormiamo, ma quelli che non dormiamo prima di realizzarli. -Abdul Kalam"
    },
    "2026-01-12": {
        "content": " Osare significa in gran parte il coraggio di essere vulnerabili. Significa mostrarsi ed essere visti. Chiedere ciò di cui si ha bisogno. Parlare di come ci si sente. Avere conversazioni difficili. -Brené Marrone"
    },
    "2026-01-13": {
        "content": " Non avrai mai successo, finché non trasformerai il tuo dolore in grandezza, finché non permetterai al tuo dolore di spingerti da dove sei a dove devi essere. Smetti di scappare dal tuo dolore e abbraccia il tuo dolore. Il tuo dolore sarà parte del tuo premio, parte del tuo prodotto. Ti sfido a spingerti oltre. -Eric Thomas"
    },
    "2026-01-14": {
        "content": " Siamo ciò che facciamo ripetutamente. L'eccellenza, quindi, non è un atto, ma un'abitudine. -Aristotele"
    },
    "2026-01-15": {
        "content": " Un fiume scava la roccia non per la sua potenza, ma per la sua persistenza. -Disegno di Jim Watkins"
    },
    "2026-01-16": {
        "content": " L'energia e la perseveranza conquistano ogni cosa. -Benjamin Franklin"
    },
    "2026-01-17": {
        "content": " Di solito le opportunità sono mascherate da duro lavoro, quindi la maggior parte delle persone non le riconosce. -Ann Landers"
    },
    "2026-01-18": {
        "content": " Se non puoi volare allora corri, se non puoi correre allora cammina, se non puoi camminare allora striscia, ma qualsiasi cosa tu faccia devi continuare ad andare avanti. -Martin Luther King Jr."
    },
    "2026-01-19": {
        "content": " La perseveranza garantisce che i risultati siano inevitabili. -Paramahansa Yogananda"
    },
    "2026-01-20": {
        "content": " Con un talento ordinario e una perseveranza straordinaria, tutto è realizzabile -Thomas Fowell Buxton"
    },
    "2026-01-21": {
        "content": " La nostra più grande gloria non sta nel non fallire mai, ma nel rialzarci ogni volta che falliamo. -Ralph Waldo Emerson"
    },
    "2026-01-22": {
        "content": " Il successo è passare da un fallimento all'altro senza perdere l'entusiasmo. -Winston Churchill"
    },
    "2026-01-23": {
        "content": "Fortunatamente, la perseveranza è un ottimo sostituto del talento. -Steve Martin"
    },
    "2026-01-24": {
        "content": " Credo molto nella fortuna e ho scoperto che più lavoro duramente, più ne ho. -Tommaso Jefferson"
    },
    "2026-01-25": {
        "content": " Rimanda a domani solo ciò che sei disposto a lasciare incompiuto, anche se muori. -Pablo Picasso"
    },
    "2026-01-26": {
        "content": " Non ci sono segreti per il successo: non perdere tempo a cercarli. Il successo è il risultato della perfezione, del duro lavoro, dell'imparare dagli errori, della lealtà verso coloro per cui lavori e della perseveranza. -Colin Powell"
    },
    "2026-01-27": {
        "content": " Se vuoi stare davanti, comportati come se fossi dietro. -Lao Tzu"
    },
    "2026-01-28": {
        "content": " Lasciatemi svelare il segreto che mi ha condotto al mio obiettivo: la mia forza risiede unicamente nella mia tenacia. -Luigi Pasteur"
    },
    "2026-01-29": {
        "content": " Niente al mondo può sostituire la perseveranza. Il talento non lo farà; niente è più comune delle persone senza successo dotate di talento. Il genio non lo farà; il genio non ricompensato è quasi un proverbio. -Calvin Coolidge"
    },
    "2026-01-30": {
        "content": " La via d'uscita migliore è sempre quella di attraversare. -Robert Gelo"
    },
    "2026-01-31": {
        "content": "Molti fallimenti nella vita sono dovuti al fatto che le persone non si sono rese conto di quanto fossero vicine al successo quando hanno rinunciato. -Thomas A. Edison"
    },
    "2026-02-01": {
        "content": " Siamo fatti per persistere. È così che scopriamo chi siamo. -Tobias Wolff"
    },
    "2026-02-02": {
        "content": " Conoscendo gli alberi, capisco il significato della pazienza. Conoscendo l'erba, posso apprezzare la perseveranza. -Hal Borland"
    },
    "2026-02-03": {
        "content": " L'acqua che gocciola scava la pietra, non con la forza ma con la perseveranza. -Ovidio"
    },
    "2026-02-04": {
        "content": " La perseveranza è molto importante. Non dovresti arrenderti a meno che tu non sia costretto a farlo. -Elon Musk"
    },
    "2026-02-05": {
        "content": " Un entusiasmo ardente, sostenuto da buonsenso e perseveranza, è la qualità che più spesso determina il successo. -Dale Carnegie"
    },
    "2026-02-06": {
        "content": " L'ambizione è la strada per il successo. La perseveranza è il veicolo con cui arrivi. -Bill Bradley"
    },
    "2026-02-07": {
        "content": " Concentratevi sulla soluzione, non sul problema. -Walter Anderson"
    },
    "2026-02-08": {
        "content": " Quando la vita ti abbatte hai due scelte: restare giù o rialzarti. -Tom Krause"
    },
    "2026-02-09": {
        "content": "Il successo è la somma di piccoli sforzi, ripetuti giorno dopo giorno. -Robert Collier"
    },
    "2026-02-10": {
        "content": " Un sogno è solo un sogno. Un obiettivo è un sogno con un piano e una scadenza. -Harvey MacKay"
    },
    "2026-02-11": {
        "content": " Non rinunciare mai a qualcosa a cui non puoi passare un giorno senza pensare. -Winston Churchill"
    },
    "2026-02-12": {
        "content": " I diamanti non sono altro che pezzi di carbone rimasti attaccati al loro posto. -Malcolm S. Forbes"
    },
    "2026-02-13": {
        "content": " Non si può fare nulla se non poco alla volta. -Carlo Baudelaire"
    },
    "2026-02-14": {
        "content": " Se stai attraversando l'inferno, continua ad andare avanti. -Winston Churchill"
    },
    "2026-02-15": {
        "content": " La chiave della perseveranza apre tutte le porte chiuse dalla resistenza. -Giovanni Di Lemme"
    },
    "2026-02-16": {
        "content": " Se consideriamo coloro che hanno più successo al mondo, la perseveranza è il denominatore comune. -Giustino Sachs"
    },
    "2026-02-17": {
        "content": " Puoi mangiare un elefante un boccone alla volta. -Mary Kay Ash"
    },
    "2026-02-18": {
        "content": " Non credo che ci sia un'altra qualità così essenziale per il successo di qualsiasi tipo come la qualità della perseveranza. Supera quasi tutto, persino la natura. -John D. Rockefeller"
    },
    "2026-02-19": {
        "content": "Se vuoi trasformare una visione in realtà, devi dare il 100% e non smettere mai di credere nel tuo sogno. -Arnold Schwarzenegger"
    },
    "2026-02-20": {
        "content": " Corri quando puoi, cammina se devi, striscia se devi; ma non arrenderti mai. -Preside Karnazes"
    },
    "2026-02-21": {
        "content": " Fare un altro giro quando pensi di non farcela: questo è ciò che fa la differenza nella tua vita. -Sylvester Stallone"
    },
    "2026-02-22": {
        "content": " Ascoltami, anche quando perdi, va bene perdere, ma non puoi mai sentirti a tuo agio con questo. Non puoi mai essere soddisfatto di perdere. Quando perdi, deve farti male. -Eric Thomas"
    },
    "2026-02-23": {
        "content": " Continua a camminare, un passo alla volta. -Giovedì 13 Novembre 2018"
    },
    "2026-02-24": {
        "content": " Non dobbiamo arrenderci e non dobbiamo permettere che il problema ci sconfigga. -Abdul Kalam"
    },
    "2026-02-25": {
        "content": " Con la perseveranza vinciamo. -Ernest Shackleton"
    },
    "2026-02-26": {
        "content": " muri di mattoni sono lì per un motivo. I muri di mattoni non sono lì per tenerci fuori. I muri di mattoni sono lì per darci la possibilità di mostrare quanto desideriamo qualcosa. Perché i muri di mattoni sono lì per fermare le persone che non la desiderano abbastanza. Sono lì per fermare le altre persone. -Randy Pausch"
    },
    "2026-02-27": {
        "content": " Il successo dipende quasi totalmente dalla spinta e dalla perseveranza. L'energia extra richiesta per fare un altro sforzo o provare un altro approccio è il segreto della vittoria. -Disegno di Denis Waitley"
    },
    "2026-02-28": {
        "content": " Ero arrivato fin lì e mi rifiutavo di arrendermi perché per tutta la vita avevo sempre portato a termine la gara. -Luigi Zamperini"
    },
    "2026-03-01": {
        "content": " La sopravvivenza può essere riassunta in tre parole: non mollare mai. Questo è il nocciolo della questione. Continua a provare. -Orso Grylls"
    },
    "2026-03-02": {
        "content": "BASTA. Niente più scuse. Niente più: \"Comincerò domani\". Niente più: \"Solo questa volta\". Niente più accettare le carenze della mia volontà. Niente più prendere la strada più facile. Niente più inchinarmi a qualsiasi pensiero malsano o improduttivo mi passi per la mente. -Jocko Willink"
    },
    "2026-03-03": {
        "content": " Piccoli colpi abbatterono grandi querce. -Benjamin Franklin"
    },
    "2026-03-04": {
        "content": " \"Sono disposto.\" \"Sono programmato per vincere.\" \"Ce la farò.\" \"Abbraccio l'incertezza.\" \"Non sono i miei pensieri; sono ciò che faccio.\" \"Sono implacabile.\" \"Non mi aspetto nulla e accetto tutto. -Gary John Vescovo"
    },
    "2026-03-05": {
        "content": " Non ho fallito 700 volte. Non ho fallito una volta. Sono riuscito a dimostrare che quei 700 modi non funzioneranno. Quando avrò eliminato i modi che non funzioneranno, troverò il modo che funzionerà. -Thomas A. Edison"
    },
    "2026-03-06": {
        "content": " GRIT è Guts, Resilience, Industriousness e Tenacity. GRIT è la capacità di concentrarsi, di restare determinati, di restare ottimisti di fronte a una sfida e semplicemente di lavorare più duramente del prossimo ragazzo o ragazza. -Linda Kaplan Tallero"
    },
    "2026-03-07": {
        "content": "Penso che il mio segreto sia che non ci sono scorciatoie per il duro lavoro, la determinazione e l'atteggiamento del \"non arrendersi\". -Riso Jerry"
    },
    "2026-03-08": {
        "content": " Non smettere mai di lottare finché non arrivi al tuo posto destinato, ovvero, al tuo unico te. Abbi uno scopo nella vita, acquisisci continuamente conoscenza, lavora sodo e abbi perseveranza per realizzare la grande vita. -Abdul Kalam"
    },
    "2026-03-09": {
        "content": " Non fermarti quando sei stanco. Fermati quando hai finito. -David Goggins"
    },
    "2026-03-10": {
        "content": " Non giudicarmi per i miei successi, giudicami per quante volte sono caduto e mi sono rialzato. -Nelson Mandela"
    },
    "2026-03-11": {
        "content": " Ciò che non si inizia oggi non si finisce domani. -Johann Wolfgang di Goethe"
    },
    "2026-03-12": {
        "content": " Se scrivi cento racconti brevi e sono tutti brutti, non significa che hai fallito. Fallisci solo se smetti di scrivere. -Ray Bradbury"
    },
    "2026-03-13": {
        "content": " Il maestro ha fallito più volte di quante il principiante abbia mai provato. -Stephen McCranie"
    },
    "2026-03-14": {
        "content": " Al diavolo le circostanze: le opportunità le creo io. -Bruce Lee"
    },
    "2026-03-15": {
        "content": "L'unica cosa peggiore che iniziare qualcosa e fallire è non iniziare nulla. -Seth Godin"
    },
    "2026-03-16": {
        "content": " Non rimandare mai a domani quello che puoi fare oggi. -Benjamin Franklin"
    },
    "2026-03-17": {
        "content": " Con perseveranza la lumaca raggiunse l'arca. -Charles H. Spurgeon"
    },
    "2026-03-18": {
        "content": " Ricorda, la speranza è una cosa buona, forse la migliore delle cose, e nessuna cosa buona muore mai. -Stephen Re"
    },
    "2026-03-19": {
        "content": " Gli imprenditori non finiscono quando siamo stanchi. Finiamo quando abbiamo finito. -Robert T. Kiyosaki"
    },
    "2026-03-20": {
        "content": " Solo la perseveranza e la determinazione sono onnipotenti. -Calvin Coolidge"
    },
    "2026-03-21": {
        "content": " Paralizzare la resistenza con la perseveranza. -Giovedì 13 Novembre"
    },
    "2026-03-22": {
        "content": " Il successo non si possiede mai, si affitta, e l'affitto è dovuto ogni giorno. -Rory Vaden"
    },
    "2026-03-23": {
        "content": " Il successo non è un caso. È duro lavoro, perseveranza, apprendimento, studio, sacrificio e, soprattutto, amore per ciò che fai o impari a fare. -Pelé"
    },
    "2026-03-24": {
        "content": " Non c'è modo di aggirare il duro lavoro. Abbraccialo. -Roger Federer"
    },
    "2026-03-25": {
        "content": " Un sogno non diventa realtà per magia; ci vogliono sudore, determinazione e duro lavoro. -Colin Powell"
    },
    "2026-03-26": {
        "content": "Imparare non esaurisce mai la mente. -Leonardo da Vinci"
    },
    "2026-03-27": {
        "content": " Sento e dimentico. Vedo e ricordo. Faccio e capisco. -Confucio"
    },
    "2026-03-28": {
        "content": " Chi non ha mai commesso un errore non ha mai provato nulla di nuovo. -Albert Einstein"
    },
    "2026-03-29": {
        "content": " Cerca di imparare qualcosa su tutto e tutto su qualcosa. -Thomas Henry Huxley"
    },
    "2026-03-30": {
        "content": " L'uomo impara solo in due modi: leggendo e frequentando persone più intelligenti. -Will Rogers"
    },
    "2026-03-31": {
        "content": " Non capisci nulla finché non lo impari in più di un modo. -Marvin Minsky"
    },
    "2026-04-01": {
        "content": " Dimmi e dimentico, insegnami e potrei ricordare, coinvolgimi e imparo. -Benjamin Franklin"
    },
    "2026-04-02": {
        "content": " Se vuoi aumentare il tuo tasso di successo, raddoppia il tuo tasso di fallimento. -Thomas J. Watson"
    },
    "2026-04-03": {
        "content": " L'intelligenza è ciò a cui ricorriamo quando non sappiamo cosa fare. -Jean Piaget"
    },
    "2026-04-04": {
        "content": " Gli analfabeti del XXI secolo non saranno coloro che non sanno leggere e scrivere, ma coloro che non sanno imparare, disimparare e reimparare. -Alvin Toffler"
    },
    "2026-04-05": {
        "content": "Spesso è proprio ciò che già sappiamo a impedirci di imparare. -Claude Bernard"
    },
    "2026-04-06": {
        "content": " La matematica è il linguaggio con cui Dio ha scritto l'universo. -Galileo Galilei"
    },
    "2026-04-07": {
        "content": " Lo scopo dell'istruzione è trasformare gli specchi in finestre. -Sydney J. Harris"
    },
    "2026-04-08": {
        "content": " Non ho paura delle tempeste perché sto imparando a governare la mia nave. -Louisa May Alcott"
    },
    "2026-04-09": {
        "content": " L'unica persona istruita è quella che ha imparato a imparare e a cambiare. -Carl R. Rogers"
    },
    "2026-04-10": {
        "content": " Non ho mai incontrato un uomo così ignorante da non poter imparare qualcosa da lui. -Galileo Galilei"
    },
    "2026-04-11": {
        "content": " Niente scompare finché non ci ha insegnato ciò che dobbiamo sapere. -Pema Chodrön"
    },
    "2026-04-12": {
        "content": " La pratica rende perfetti. Dopo un lungo periodo di pratica, il nostro lavoro diventerà naturale, abile, rapido e costante. -Bruce Lee"
    },
    "2026-04-13": {
        "content": " Quando parli stai solo ripetendo qualcosa che già sai. Ma se ascolti potresti imparare qualcosa di nuovo. -Dalai Lama XIV"
    },
    "2026-04-14": {
        "content": " Impegnati per il progresso, non per la perfezione. -Anonimo"
    },
    "2026-04-15": {
        "content": "Faccio sempre quello che ancora non so fare, per imparare a farlo. -Vincent van Gogh"
    },
    "2026-04-16": {
        "content": " La conoscenza rende l'uomo inadatto a essere schiavo. -Federico Douglass"
    },
    "2026-04-17": {
        "content": " Ho imparato molto presto la differenza tra sapere il nome di qualcosa e conoscere effettivamente qualcosa. -Richard P. Feynman"
    },
    "2026-04-18": {
        "content": " La capacità di imparare è un dono; la capacità di imparare è un'abilità; la volontà di imparare è una scelta. -Brian Herbert"
    },
    "2026-04-19": {
        "content": " Impara tutto quello che puoi, in qualsiasi momento tu possa, da chiunque tu possa: arriverà sempre un momento in cui sarai grato di averlo fatto. -Sarah Caldwell"
    },
    "2026-04-20": {
        "content": " Non ho grande stima di un uomo che oggi non è più saggio di ieri. -Abramo Lincoln"
    },
    "2026-04-21": {
        "content": " La chiave del successo è la dedizione all'apprendimento continuo. -Stephen R. Covey"
    },
    "2026-04-22": {
        "content": " Sii appassionato e audace. Continua sempre a imparare. Smetti di fare cose utili se non impari. -Satya Nadella"
    },
    "2026-04-23": {
        "content": "L'attività più elevata che un essere umano possa raggiungere è imparare per comprendere, perché comprendere significa essere liberi. -Baruch Spinoza"
    },
    "2026-04-24": {
        "content": " Se non continui a imparare, gli altri ti ignoreranno. Il temperamento da solo non basta: hai bisogno di molta curiosità per molto, molto tempo. -Charlie Munger"
    },
    "2026-04-25": {
        "content": " Un'organizzazione che apprende è un'organizzazione che amplia continuamente la propria capacità di creare il proprio futuro. -Pietro Senge"
    },
    "2026-04-26": {
        "content": " Il giorno in cui smetti di imparare è il giorno in cui inizi a decadere. -Isaac Asimov"
    },
    "2026-04-27": {
        "content": " L'apprendimento è un ornamento nella prosperità, un rifugio nelle avversità e una provvista nella vecchiaia. -Aristotele"
    },
    "2026-04-28": {
        "content": " Tutti i leader sono studenti. Nel momento in cui smetti di imparare, smetti di guidare. Imparo il più possibile, da più persone possibili, il più spesso possibile. -Rick Warren"
    },
    "2026-04-29": {
        "content": " Per imparare cose difficili in fretta, devi concentrarti intensamente senza distrazioni. Imparare, in altre parole, è un atto di lavoro profondo. -Cal Newport"
    },
    "2026-04-30": {
        "content": " Anche un idiota può saperlo. Il punto è capire. -Albert Einstein"
    },
    "2026-05-01": {
        "content": "Trascorri ogni giorno cercando di essere un po' più saggio di quando ti sei svegliato. -Charlie Munger"
    },
    "2026-05-02": {
        "content": " Investi in te stesso, nella tua istruzione. Non c'è niente di meglio. -Sylvia Porter"
    },
    "2026-05-03": {
        "content": " L'autoformazione è per me una fonte continua di piacere, perché più so, più piena è la mia vita e più apprezzo la mia esistenza. -Isaac Asimov"
    },
    "2026-05-04": {
        "content": " Puoi farti aiutare dagli insegnanti, ma dovrai imparare molto da solo, seduto in una stanza. -Dr. Seuss"
    },
    "2026-05-05": {
        "content": " L'apprendimento avviene quando qualcuno vuole imparare, non quando qualcuno vuole insegnare. -Roger Schank"
    },
    "2026-05-06": {
        "content": " Una persona non può insegnare direttamente a un'altra persona; può solo facilitarne l'apprendimento. -Carl R. Rogers"
    },
    "2026-05-07": {
        "content": " L'apprendimento non è obbligatorio; è volontario. Il miglioramento non è obbligatorio; è volontario. Ma per sopravvivere, dobbiamo imparare. -W. Edwards Deming"
    },
    "2026-05-08": {
        "content": " Faccio sempre ciò che non so fare, per imparare a farlo. -Pablo Picasso"
    },
    "2026-05-09": {
        "content": "Nessun ladro, per quanto abile, può rubare la conoscenza, ed è per questo che la conoscenza è il tesoro migliore e più sicuro da acquisire. -L. Frank Baum"
    },
    "2026-05-10": {
        "content": " Penso che questo sia il consiglio migliore: pensa costantemente a come potresti fare meglio le cose e mettiti in discussione. -Elon Musk"
    },
    "2026-05-11": {
        "content": " Un uomo saggio può imparare di più da una domanda sciocca di quanto uno stolto possa imparare da una risposta saggia. -Bruce Lee"
    },
    "2026-05-12": {
        "content": " Se ho visto più lontano è stato perché sono salito sulle spalle dei Giganti. -Isacco Newton"
    },
    "2026-05-13": {
        "content": " Ciò che conosciamo è una goccia, ciò che non conosciamo è un oceano. -Isacco Newton"
    },
    "2026-05-14": {
        "content": " Il bello dell'imparare è che nessuno può portartelo via. -BB Re"
    },
    "2026-05-15": {
        "content": " Se vuoi diventare uno scrittore, devi fare due cose prima di ogni altra cosa: leggere molto e scrivere molto. -Stephen Re"
    },
    "2026-05-16": {
        "content": " La ripetizione è la madre dell'abilità. -Tony Robbins"
    },
    "2026-05-17": {
        "content": " La meraviglia è l'inizio della saggezza. -Socrate"
    },
    "2026-05-18": {
        "content": " Se commetti un errore e non lo correggi, questo si chiama errore. -Confucio"
    },
    "2026-05-19": {
        "content": " Lo scopo dell'istruzione è sostituire una mente vuota con una aperta. -Malcolm S. Forbes"
    },
    "2026-05-20": {
        "content": "Niente nella vita è da temere, è solo da comprendere. Ora è il momento di comprendere di più, così da temere di meno. -Marie Curie"
    },
    "2026-05-21": {
        "content": " Ogni volta che ti chiedono se sai fare un lavoro, rispondi \"Certamente che posso!\". Poi datti da fare e scopri come farlo. -Teodoro Roosevelt"
    },
    "2026-05-22": {
        "content": " Abbiamo tutti bisogno di persone che ci diano feedback. È così che miglioriamo. -Bill Gates"
    },
    "2026-05-23": {
        "content": " L'istruzione è la chiave per scoprire il mondo, un passaporto per la libertà. -Oprah Winfrey"
    },
    "2026-05-24": {
        "content": " Tutto inizia con un'idea. -Il conte Nightingale"
    },
    "2026-05-25": {
        "content": " Il miglior investimento che puoi fare è in te stesso. -Warren Buffett"
    },
    "2026-05-26": {
        "content": " Non è una questione di soldi o di conoscenze. È la volontà di lavorare e imparare più di tutti. -Marco cubano"
    },
    "2026-05-27": {
        "content": " Finché vivi, continua a imparare a vivere. -Seneca"
    },
    "2026-05-28": {
        "content": " Per imparare ad avere successo, devi prima imparare a fallire. -Michael Giordano"
    },
    "2026-05-29": {
        "content": " Non sprecare un buon errore, impara da esso. -Robert T. Kiyosaki"
    },
    "2026-05-30": {
        "content": "Per acquisire conoscenza bisogna studiare; ma per acquisire saggezza bisogna osservare. -Marilyn Vos Savant"
    },
    "2026-05-31": {
        "content": " Vivi e impari. In ogni caso, vivi. -Douglas Adams"
    },
    "2026-06-01": {
        "content": " La pazienza è compagna della saggezza. -Sant'Agostino"
    },
    "2026-06-02": {
        "content": " So solo una cosa: non so nulla. -Socrate"
    },
    "2026-06-03": {
        "content": " La saggezza deriva dall'esperienza. L'esperienza è spesso il risultato della mancanza di saggezza. -Terry Pratchett"
    },
    "2026-06-04": {
        "content": " Possiamo giudicare i nostri progressi dal coraggio delle nostre domande e dalla profondità delle nostre risposte, dalla nostra disponibilità ad abbracciare ciò che è vero piuttosto che ciò che ci fa sentire bene. -Carl Sagan"
    },
    "2026-06-05": {
        "content": " Preferisco avere domande a cui non si può rispondere piuttosto che risposte a cui non si può mettere in discussione. -Richard P. Feynman"
    },
    "2026-06-06": {
        "content": " Sono sempre pronto a imparare, anche se non sempre mi piace che mi venga insegnato qualcosa. -Winston Churchill"
    },
    "2026-06-07": {
        "content": " Chi ama la pratica senza la teoria è come il marinaio che sale su una nave senza timone e senza bussola e non sa mai dove gettare l'ancora. -Leonardo da Vinci"
    },
    "2026-06-08": {
        "content": " È meglio creare che imparare. Creare è l'essenza della vita. -Giulio Cesare"
    },
    "2026-06-09": {
        "content": "Ciò che fa la mano, la mente lo ricorda. -Maria Montessori"
    },
    "2026-06-10": {
        "content": " Affronta sempre la vita come se avessi qualcosa di nuovo da imparare, e lo farai. -Vernon Howard"
    },
    "2026-06-11": {
        "content": " Il fallimento è un successo se impariamo da esso. -Malcolm S. Forbes"
    },
    "2026-06-12": {
        "content": " L'istruzione è la migliore amica. Una persona istruita è rispettata ovunque. L'istruzione batte la bellezza e la gioventù. -Canakya"
    },
    "2026-06-13": {
        "content": " Non pensare che ciò che per te è difficile da padroneggiare sia umanamente impossibile; ma se una cosa è umanamente possibile, considerala alla tua portata. -Marco Aurelio"
    },
    "2026-06-14": {
        "content": " L'apprendimento è un processo di scoperta costante, un processo senza fine. -Bruce Lee"
    },
    "2026-06-15": {
        "content": " Essere ignoranti non è tanto una vergogna quanto non essere disposti a imparare. -Benjamin Franklin"
    },
    "2026-06-16": {
        "content": " Sono convinto che la conoscenza sia potere: per superare il passato, per cambiare le nostre situazioni, per combattere nuovi ostacoli, per prendere decisioni migliori. -Ben Carson"
    },
    "2026-06-17": {
        "content": " Inspirando, calmo corpo e mente. Espirando, sorrido. Soffermandomi nel momento presente, so che questo è l'unico momento. -Thich Nhat Hanh"
    },
    "2026-06-18": {
        "content": "Se pensi di essere troppo piccolo per fare la differenza, prova a dormire con una zanzara. -Dalai Lama XIV"
    },
    "2026-06-19": {
        "content": " Troppo spesso sottovalutiamo il potere di un tocco, di un sorriso, di una parola gentile, di un orecchio attento, di un complimento sincero o del più piccolo gesto di premura, tutti atti che hanno il potenziale di cambiare una vita. -Leo Buscaglia"
    },
    "2026-06-20": {
        "content": " Il modo in cui trascorriamo le nostre giornate, ovviamente, determina il modo in cui trascorriamo la nostra vita. -Annie Dillard"
    },
    "2026-06-21": {
        "content": " Nutri la tua mente con grandi pensieri, perché non andrai mai più in alto di quanto pensi. -Benjamin Disraeli"
    },
    "2026-06-22": {
        "content": " Non impari a camminare seguendo le regole. Impari facendo e cadendo. -Richard Branson"
    },
    "2026-06-23": {
        "content": " È impossibile vivere senza fallire in qualcosa, a meno che non si viva con tanta cautela da considerare che sarebbe come non aver vissuto affatto, nel qual caso si fallisce per impostazione predefinita. -JK Rowling"
    },
    "2026-06-24": {
        "content": " Se vuoi essere felice, sii. -Lev Tolstoj"
    },
    "2026-06-25": {
        "content": " Nessuno può farmi del male senza il mio permesso. -Mahatma Gandhi"
    },
    "2026-06-26": {
        "content": " Quando rinuncio a ciò che sono, divento ciò che potrei essere. -Lao Tzu"
    },
    "2026-06-27": {
        "content": "Il motivo per cui lottiamo contro l'insicurezza è perché confrontiamo il nostro dietro le quinte con i momenti salienti di tutti gli altri. -Steven Furtick"
    },
    "2026-06-28": {
        "content": " Ricordati che oggi è il domani di cui ti preoccupavi ieri. -Dale Carnegie"
    },
    "2026-06-29": {
        "content": " Dobbiamo essere disposti a rinunciare alla vita che abbiamo pianificato per avere la vita che ci aspetta. -Giuseppe Campbell"
    },
    "2026-06-30": {
        "content": " Smetti di partire e arriverai. Smetti di cercare e vedrai. Smetti di scappare e sarai trovato. -Lao Tzu"
    },
    "2026-07-01": {
        "content": " Un team non è un gruppo di persone che lavorano insieme. Un team è un gruppo di persone che si fidano l'una dell'altra. -Simon Sinek"
    },
    "2026-07-02": {
        "content": " L'ottimismo perpetuo è un moltiplicatore di forza. -Colin Powell"
    },
    "2026-07-03": {
        "content": " Quando ti accontenti di essere semplicemente te stesso e non fai paragoni o competizioni, tutti ti rispetteranno. -Lao Tzu"
    },
    "2026-07-04": {
        "content": " Conta la tua età in base agli amici, non agli anni. Conta la tua vita in base ai sorrisi, non alle lacrime. -John Lennon"
    },
    "2026-07-05": {
        "content": " Dona a chi ami ali per volare, radici per tornare e motivi per restare. -Dalai Lama XIV"
    },
    "2026-07-06": {
        "content": " La perseveranza e lo spirito hanno fatto miracoli in tutte le epoche. -Giorgio Washington"
    },
    "2026-07-07": {
        "content": "Condividi la tua conoscenza. È un modo per raggiungere l'immortalità. -Dalai Lama XIV"
    },
    "2026-07-08": {
        "content": " Siamo un mezzo attraverso cui il cosmo può conoscere se stesso. -Carl Sagan"
    },
    "2026-07-09": {
        "content": " Un buon insegnante può ispirare speranza, accendere l'immaginazione e instillare l'amore per l'apprendimento. -Direttore: Brad Henry"
    },
    "2026-07-10": {
        "content": " Una delle più grandi scoperte che una persona possa fare, una delle sue più grandi sorprese, è scoprire di poter fare ciò che temeva di non poter fare. -Henry Ford"
    },
    "2026-07-11": {
        "content": " Quando è stata l'ultima volta che hai fatto qualcosa per la prima volta? -John C. Maxwell"
    },
    "2026-07-12": {
        "content": " Se non sei nel processo di diventare la persona che vuoi essere, sei automaticamente impegnato a diventare la persona che non vuoi essere. -Dale Carnegie"
    },
    "2026-07-13": {
        "content": " La fortuna aiuta gli audaci. -Proverbio latino"
    },
    "2026-07-14": {
        "content": " Il successo non è la chiave della felicità. La felicità è la chiave del successo. Se ami ciò che fai, avrai successo. -Albert Schweitzer"
    },
    "2026-07-15": {
        "content": " Non guadagnare il mondo e perdere la tua anima; la saggezza vale più dell'argento e dell'oro. -Bob Marley"
    },
    "2026-07-16": {
        "content": " Comincia subito a vivere e considera ogni singolo giorno come una vita a sé stante. -Seneca"
    },
    "2026-07-17": {
        "content": " meno che a qualcuno come te non importi un granché, niente migliorerà. Non è così. -Dr. Seuss"
    },
    "2026-07-18": {
        "content": " Non sapevano che fosse impossibile, quindi lo fecero. -Mark Twain"
    },
    "2026-07-19": {
        "content": " Io posso fare cose che tu non puoi, tu puoi fare cose che io non posso; insieme possiamo fare grandi cose. -Madre Teresa"
    },
    "2026-07-20": {
        "content": " L'unica cosa di cui dobbiamo avere paura è la paura stessa. -Franklin D. Roosevelt"
    },
    "2026-07-21": {
        "content": " Senza entusiasmo non si è mai realizzato nulla di grande. -Ralph Waldo Emerson"
    },
    "2026-07-22": {
        "content": " Coraggio, caro cuore. -CS Lewis"
    },
    "2026-07-23": {
        "content": " L'unico modo per dare un senso al cambiamento è immergersi in esso, muoversi con esso e unirsi alla danza. -Alan Watts"
    },
    "2026-07-24": {
        "content": " Dove va l'attenzione, scorre l'energia e si vedono i risultati. -T. Harv Eker"
    },
    "2026-07-25": {
        "content": " Il dolore è temporaneo. Può durare un minuto, un'ora, un giorno o un anno, ma alla fine si attenuerà e qualcos'altro prenderà il suo posto. Se smetto, tuttavia, durerà per sempre. -Lance Armstrong"
    },
    "2026-07-26": {
        "content": " In ogni passeggiata nella natura si riceve molto più di quanto si cerchi. -Giovanni Muir"
    },
    "2026-07-27": {
        "content": " vincitori non sono coloro che non falliscono mai, ma coloro che non si arrendono mai. -Edwin Louis Cole"
    },
    "2026-07-28": {
        "content": " Invece di combattere l'oscurità, fai entrare la luce. -Eckhart Tolle"
    },
    "2026-07-29": {
        "content": " Sii coraggioso nel perseguire ciò che accende la tua anima. -Jennifer Lee"
    },
    "2026-07-30": {
        "content": " Quando le persone se ne vanno da te, lasciale andare. Il tuo destino non è mai legato a chi ti lascia, e non significa che siano cattive persone. Significa solo che la loro parte nella tua storia è finita. -TD Jakes"
    },
    "2026-07-31": {
        "content": " La leadership è la capacità di tradurre la visione in realtà. -Warren G. Bennis"
    },
    "2026-08-01": {
        "content": " La fede è credere a ciò che non si vede; la ricompensa di questa fede è vedere ciò in cui si crede. -Sant'Agostino"
    },
    "2026-08-02": {
        "content": " Niente è impossibile, a meno che tu non lo creda. -Paramahansa Yogananda"
    },
    "2026-08-03": {
        "content": " L'unica cosa peggiore dell'essere ciechi è avere la vista ma non la capacità visiva. -Helen Keller"
    },
    "2026-08-04": {
        "content": " Ogni cosa ha la sua bellezza, ma non tutti la vedono. -Confucio"
    },
    "2026-08-05": {
        "content": " Dio parla nel silenzio del cuore. -Madre Teresa"
    },
    "2026-08-06": {
        "content": "La speranza è quella cosa con le piume che si appollaia nell'anima, e canta la melodia senza le parole, senza mai fermarsi. -Emily Dickinson"
    },
    "2026-08-07": {
        "content": " Per quante parole sante tu legga, per quante ne pronunci, a cosa ti serviranno se non le metti in pratica? -Buddha"
    },
    "2026-08-08": {
        "content": " E a proposito, tutto nella vita è scrivibile se hai il coraggio di farlo e l'immaginazione di improvvisare. Il peggior nemico della creatività è l'insicurezza. -Sylvia Plath"
    },
    "2026-08-09": {
        "content": " Niente di ciò che facciamo può cambiare il passato, ma tutto ciò che facciamo cambia il futuro. -Ashleigh Brillante"
    },
    "2026-08-10": {
        "content": " La leadership è una scelta. Non è un grado. -Simon Sinek"
    },
    "2026-08-11": {
        "content": " Tutto andrà bene, tutto andrà bene e ogni cosa andrà bene. -Giuliano di Norwich"
    },
    "2026-08-12": {
        "content": " Ognuno di noi è, nella prospettiva cosmica, prezioso. Se un umano non è d'accordo con te, lascialo vivere. In cento miliardi di galassie, non ne troverai un altro. -Carl Sagan"
    },
    "2026-08-13": {
        "content": " Intelligenza più carattere: questo è l'obiettivo della vera educazione. -Martin Luther King Jr."
    },
    "2026-08-14": {
        "content": "Quanto più ti perdi in qualcosa di più grande di te, tanta più energia avrai. -Norman Vincent Peale"
    },
    "2026-08-15": {
        "content": " Impara le basi e il livello di tutto ciò che fai aumenterà -Michael Giordano"
    },
    "2026-08-16": {
        "content": " Non puoi vivere affatto se non vivi pienamente adesso. -Alan Watts"
    },
    "2026-08-17": {
        "content": " Ricorda che a volte non ottenere ciò che desideri è un colpo di fortuna meraviglioso. -Dalai Lama XIV"
    },
    "2026-08-18": {
        "content": " Fai del tuo meglio e poi rilassati. Lascia che le cose vadano avanti in modo naturale, anziché forzarle. -Paramahansa Yogananda"
    },
    "2026-08-19": {
        "content": " Sei un essere spirituale infinito che sta vivendo un'esperienza umana temporanea. -Wayne W. Dyer"
    },
    "2026-08-20": {
        "content": " Bisogna sognare prima che i propri sogni possano avverarsi. -Abdul Kalam"
    },
    "2026-08-21": {
        "content": " Custodisci soprattutto il tuo cuore, perché tutto ciò che fai scaturisce da esso. -Salomone"
    },
    "2026-08-22": {
        "content": " Mentre scrivo riesco a scrollarmi di dosso tutto; i miei dolori scompaiono, il mio coraggio rinasce. -Anna Frank"
    },
    "2026-08-23": {
        "content": " L'obiettivo non è essere perfetti alla fine. L'obiettivo è essere migliori oggi. -Simon Sinek"
    },
    "2026-08-24": {
        "content": " Vai con sicurezza nella direzione dei tuoi sogni. Vivi la vita che hai immaginato. -Henry David Thoreau"
    },
    "2026-08-25": {
        "content": "Siate gentili ogni volta che è possibile. È sempre possibile. -Dalai Lama XIV"
    },
    "2026-08-26": {
        "content": " Il nostro scopo principale in questa vita è aiutare gli altri. E se non puoi aiutarli, almeno non far loro del male. -Dalai Lama XIV"
    },
    "2026-08-27": {
        "content": " Hai un cervello nella testa. Hai i piedi nelle scarpe. Puoi orientarti in qualsiasi direzione tu scelga. Sei da solo. E sai quello che sai. E sei tu quello che deciderà dove andare. -Dr. Seuss"
    },
    "2026-08-28": {
        "content": " Ciò su cui ti concentri si espande e quando ti concentri sulle cose buone della tua vita, ne crei di più. -Oprah Winfrey"
    },
    "2026-08-29": {
        "content": " Tutto ciò che ho bisogno di sapere mi viene rivelato. Tutto ciò di cui ho bisogno mi viene incontro. Tutto va bene nella mia vita. -Louise Fieno"
    },
    "2026-08-30": {
        "content": " Sono totalmente al sicuro nell'Universo. Sono in pace ovunque. Ho fiducia nella vita. -Louise Fieno"
    },
    "2026-08-31": {
        "content": " Rivolgi il viso verso il sole e le ombre cadranno dietro di te. -Proverbio Maori"
    },
    "2026-09-01": {
        "content": " Il coraggio non è avere la forza di andare avanti; è andare avanti quando non si ha la forza. -Teodoro Roosevelt"
    },
    "2026-09-02": {
        "content": " Il futuro dipende da ciò che fai oggi. -Mahatma Gandhi"
    },
    "2026-09-03": {
        "content": " Un vincitore è un sognatore che non si arrende mai. -Nelson Mandela"
    },
    "2026-09-04": {
        "content": "Non piangere perché è finita, sorridi perché è successo. -Dr. Seuss"
    },
    "2026-09-05": {
        "content": " In tre parole posso riassumere tutto quello che ho imparato sulla vita: continua. -Robert Gelo"
    },
    "2026-09-06": {
        "content": " Vivi seguendo la tua immaginazione, non la tua storia. -Stephen R. Covey"
    },
    "2026-09-07": {
        "content": " A mio avviso, se vuoi l'arcobaleno, devi sopportare la pioggia. -Dolly Parton"
    },
    "2026-09-08": {
        "content": " La grandezza di un uomo non risiede nella quantità di ricchezza che acquisisce, ma nella sua integrità e nella sua capacità di influenzare positivamente chi lo circonda. -Bob Marley"
    },
    "2026-09-09": {
        "content": " La felicità deriva principalmente dal nostro atteggiamento, piuttosto che da fattori esterni. -Dalai Lama XIV"
    },
    "2026-09-10": {
        "content": " Le grandi azioni sono fatte di piccole azioni. -Lao Tzu"
    },
    "2026-09-11": {
        "content": " Non è mai troppo tardi per essere ciò che avresti potuto essere. -George Eliot"
    },
    "2026-09-12": {
        "content": " Adottare l'atteggiamento giusto può trasformare uno stress negativo in uno positivo. -Hans Selye"
    },
    "2026-09-13": {
        "content": " Osate vivere la vita che avete sognato per voi stessi. Andate avanti e fate sì che i vostri sogni diventino realtà. -Ralph Waldo Emerson"
    },
    "2026-09-14": {
        "content": " Il tempo che ti piace sprecare non è tempo sprecato. -Bertrand Russell"
    },
    "2026-09-15": {
        "content": "Basta un po' di attenzione per vedere e scoprire: la vita è davvero una grande risata cosmica. -Osho"
    },
    "2026-09-16": {
        "content": " Il curioso paradosso è che quando mi accetto così come sono, allora posso cambiare. -Carl R. Rogers"
    },
    "2026-09-17": {
        "content": " Sii parte della soluzione, non parte del problema. -Stephen R. Covey"
    },
    "2026-09-18": {
        "content": " Il segreto della vita è dare. -Tony Robbins"
    },
    "2026-09-19": {
        "content": " Fai di ogni giorno il tuo capolavoro. -John Legno"
    },
    "2026-09-20": {
        "content": " Non rinunciare mai a ciò che vuoi veramente fare Italiano:"
    },
    "2026-09-21": {
        "content": " Non voltarti indietro: non andrai da quella parte. -Mary Engelbreit"
    },
    "2026-09-22": {
        "content": " Fai del tuo meglio e Dio farà il resto. -Nick Vujicic"
    },
    "2026-09-23": {
        "content": " Vivi, viaggia, vivi l'avventura, benedici e non pentirti. -Jack Kerouac"
    },
    "2026-09-24": {
        "content": " Nel bel mezzo dell'inverno, ho scoperto che dentro di me c'era un'estate invincibile. E questo mi rende felice. Perché dice che non importa quanto duramente il mondo mi spinga contro, dentro di me c'è qualcosa di più forte, qualcosa di meglio, che mi spinge indietro. -Albert Camus"
    },
    "2026-09-25": {
        "content": "Alcuni credono che solo un grande potere possa tenere a bada il male, ma non è quello che ho scoperto. Sono le piccole azioni quotidiane della gente comune che tengono a bada l'oscurità. Piccoli atti di gentilezza e amore. -JRR Tolkien"
    },
    "2026-09-26": {
        "content": " Sii fedele nelle piccole cose perché è in esse che risiede la tua forza. -Madre Teresa"
    },
    "2026-09-27": {
        "content": " Renditi una luce. -Buddha"
    },
    "2026-09-28": {
        "content": " VISUALIZZA!!! Guardalo, sentilo! È qui che inizia l'azione. -Rhonda Byrne"
    },
    "2026-09-29": {
        "content": " Sii fenomenale o verrai dimenticato! -Eric Thomas"
    },
    "2026-09-30": {
        "content": " Quando puoi scegliere tra avere ragione o essere gentile, scegli di essere gentile. -Wayne W. Dyer"
    },
    "2026-10-01": {
        "content": " Gli esseri umani possono cambiare la propria vita modificando il proprio atteggiamento mentale. -Guglielmo James"
    },
    "2026-10-02": {
        "content": " La salute è il bene più prezioso. -Laozi"
    },
    "2026-10-03": {
        "content": " Non lasciarmi pregare per essere al riparo dai pericoli, ma per essere impavido nell'affrontarli. Non lasciarmi implorare la calma del mio dolore, ma il cuore per vincerlo. -Rabindranath Tagore"
    },
    "2026-10-04": {
        "content": " Metti il tuo cuore nel fare del bene. Fallo più e più volte, e sarai pieno di gioia. -Buddha"
    },
    "2026-10-05": {
        "content": "Da solo non posso cambiare il mondo, ma posso lanciare un sasso nell'acqua e creare numerose increspature. -Madre Teresa"
    },
    "2026-10-06": {
        "content": " E venne il giorno in cui il rischio di restare chiusi in un bocciolo era più doloroso del rischio di sbocciare. -Anaïs Nin"
    },
    "2026-10-07": {
        "content": " Non dovrebbero esserci limiti all'impegno umano. Per quanto brutta possa sembrare la vita, c'è sempre speranza. -Stephen Hawking"
    },
    "2026-10-08": {
        "content": " E vi esorto a notare quando siete felici, e a esclamare o mormorare o pensare a un certo punto: \"Se questo non è bello, non so cosa lo sia\". -Kurt Vonnegut"
    },
    "2026-10-09": {
        "content": " È la tua reazione alle avversità, non l'avversità in sé, a determinare come si svilupperà la storia della tua vita. -Dieter F. Uchtdorf"
    },
    "2026-10-10": {
        "content": " Non è ciò che hai o chi sei o dove sei o cosa stai facendo che ti rende felice o infelice. È ciò che pensi a riguardo. -Dale Carnegie"
    },
    "2026-10-11": {
        "content": " Più leggi, più cose saprai. Più impari, più posti visiterai. -Dr. Seuss"
    },
    "2026-10-12": {
        "content": " Tutti i nostri sogni possono diventare realtà. -Walt Disney"
    },
    "2026-10-13": {
        "content": "Il privilegio di una vita è essere chi sei. -Giuseppe Campbell"
    },
    "2026-10-14": {
        "content": " Nessuno è inutile in questo mondo se alleggerisce i fardelli di un altro. -Carlo Dickens"
    },
    "2026-10-15": {
        "content": " Trova un posto dentro di te dove c'è gioia, e la gioia brucerà il dolore. -Giuseppe Campbell"
    },
    "2026-10-16": {
        "content": " Non chiederti di cosa ha bisogno il mondo. Chiediti cosa ti fa sentire vivo e fallo. Perché ciò di cui ha bisogno il mondo è più gente che si sia sentita viva. -Howard Thurman"
    },
    "2026-10-17": {
        "content": " I tuoi sentimenti sono il tuo strumento più importante per creare la tua vita. -Rhonda Byrne"
    },
    "2026-10-18": {
        "content": " Merito il meglio e accetto il meglio fin da ora. -Louise Fieno"
    },
    "2026-10-19": {
        "content": " Non è importante quanto diamo, ma quanto amore mettiamo nel donare. -Madre Teresa"
    },
    "2026-10-20": {
        "content": " Quando vuoi avere successo con tutta la tua forza di volontà, allora avrai successo. -Eric Thomas"
    },
    "2026-10-21": {
        "content": " Odiavo ogni minuto di allenamento, ma dicevo: \"Non mollare. Soffri ora e vivi il resto della tua vita da campione\". -Muhammad Ali"
    },
    "2026-10-22": {
        "content": "Non è il critico che conta, non colui che sottolinea come l'uomo forte sia inciampato o come l'autore delle azioni avrebbe potuto farle meglio. Il merito spetta all'uomo che è effettivamente nell'arena, il cui volto è segnato da sudore, polvere e sangue; che si sforza coraggiosamente; che sbaglia e fallisce ancora e ancora; che conosce i grandi entusiasmi, le grandi devozioni e si spende per una causa degna; che, se vince, conosce il trionfo di grandi risultati; e che, se fallisce, almeno fallisce osando molto, così che il suo posto non sarà mai con quelle anime fredde e timide che non conoscono né vittoria né sconfitta. -Teodoro Roosevelt"
    },
    "2026-10-23": {
        "content": " L'avventura più grande che tu possa mai intraprendere è vivere la vita dei tuoi sogni. -Oprah Winfrey"
    },
    "2026-10-24": {
        "content": " Senza lotta non può esserci progresso. -Federico Douglass"
    },
    "2026-10-25": {
        "content": " Un sogno scritto con una data diventa un obiettivo. Un obiettivo suddiviso in passaggi diventa un piano. Un piano supportato dall'azione fa sì che i tuoi sogni diventino realtà. -Greg Reid"
    },
    "2026-10-26": {
        "content": "Fai l'unica cosa che pensi di non poter fare. Fallisci. Riprova. Fai meglio la seconda volta. Le uniche persone che non cadono mai sono quelle che non salgono mai sul filo teso. -Oprah Winfrey"
    },
    "2026-10-27": {
        "content": " Aspettatevi il cambiamento. Analizzate il panorama. Cogliete le opportunità. Smettete di essere il pezzo degli scacchi; diventate il giocatore. È la vostra mossa. -Tony Robbins"
    },
    "2026-10-28": {
        "content": " Sei libero. Sei potente. Sei buono. Sei amore. Hai valore. Hai uno scopo. Tutto va bene. -Esther Hicks"
    },
    "2026-10-29": {
        "content": "Se desideri una cosa abbastanza da uscire e combattere per essa, da lavorare giorno e notte per essa, da rinunciare al tuo tempo, alla tua pace e al tuo sonno per essa; se tutto ciò che sogni e progetti riguarda quella cosa e la vita sembra inutile e senza valore senza di essa; se ti agiti volentieri per essa, ti agiti e progetti per essa e perdi tutto il tuo terrore per l'opposizione; se semplicemente insegui quella cosa che vuoi con tutte le tue capacità, forza e sagacia, fede, speranza e fiducia e severità per la tenacia; se né il freddo né la povertà, la fame o la gotta, la malattia o il dolore del corpo e del cervello possono tenerti lontano dalla cosa che vuoi; se sei tenace e ostinato e la generi, con l'aiuto di DIO la otterrai. -Berton Braley"
    },
    "2026-10-30": {
        "content": " Anche se sei sulla strada giusta, se rimani lì seduto verrai investito. -Will Rogers"
    },
    "2026-10-31": {
        "content": " Penso che sia possibile per le persone comuni scegliere di essere straordinarie. -Elon Musk"
    },
    "2026-11-01": {
        "content": " Non impari a camminare seguendo le regole. Impari facendo e cadendo. -Richard Branson"
    },
    "2026-11-02": {
        "content": "Non c'è talento qui, questo è duro lavoro. Questa è un'ossessione. Il talento non esiste, siamo tutti uguali come esseri umani. Potresti essere chiunque se ci metti tempo. Raggiungerai la cima, e questo è tutto. Non ho talento, sono ossessionato. -Conor McGregor"
    },
    "2026-11-03": {
        "content": " Un sogno non è ciò che vedi mentre dormi; è qualcosa che non ti lascia dormire. -Abdul Kalam"
    },
    "2026-11-04": {
        "content": " Quando hai esaurito tutte le possibilità, ricorda questo: non è così. -Thomas A. Edison"
    },
    "2026-11-05": {
        "content": " Prendi delle opportunità, commetti degli errori. È così che cresci. Il dolore nutre il tuo coraggio. Devi fallire per esercitarti a essere coraggioso. -Mary Tyler Moore"
    },
    "2026-11-06": {
        "content": " Ciò su cui ti concentri è ciò che ottieni. -Tony Robbins"
    },
    "2026-11-07": {
        "content": " \"Hustle\" è la parola più importante in assoluto. -Gary Vaynerchuk"
    },
    "2026-11-08": {
        "content": " Se sono riusciti a ricavare la penicillina dal pane ammuffito, allora possono sicuramente ricavare qualcosa da te. -Muhammad Ali"
    },
    "2026-11-09": {
        "content": " Non sei nato vincitore e non sei nato perdente. Sei ciò che ti fai essere. -Lou Holtz"
    },
    "2026-11-10": {
        "content": " Il successo è un tuo dovere, obbligo e responsabilità. -Grant Cardone"
    },
    "2026-11-11": {
        "content": "C'è poca differenza nelle persone, ma quella piccola differenza fa una grande differenza. La piccola differenza è l'atteggiamento. La grande differenza è se è positivo o negativo. -W. Clemente Pietra"
    },
    "2026-11-12": {
        "content": " I leader devono essere sufficientemente vicini per relazionarsi con gli altri, ma sufficientemente avanti per motivarli. -John C. Maxwell"
    },
    "2026-11-13": {
        "content": " Mai dire mai, perché i limiti, come le paure, sono spesso solo un'illusione. -Michael Giordano"
    },
    "2026-11-14": {
        "content": " Devi aspettarti grandi cose da te stesso prima di poterle realizzare. -Michael Giordano"
    },
    "2026-11-15": {
        "content": " Nel mondo degli affari, le persone che hanno più successo sono quelle che fanno ciò che amano. -Warren Buffett"
    },
    "2026-11-16": {
        "content": " L'azione distruggerà la tua procrastinazione. -Og Mandino"
    },
    "2026-11-17": {
        "content": " Il fallimento non è un'opzione per me. Il successo è tutto ciò che immagino. -Conor McGregor"
    },
    "2026-11-18": {
        "content": " Il successo non deriva da ciò che fai occasionalmente, ma da ciò che fai costantemente. -Marie Forleo"
    },
    "2026-11-19": {
        "content": " La fiducia e il duro lavoro sono le migliori medicine per uccidere la malattia chiamata fallimento. Ti renderanno una persona di successo. -Abdul Kalam"
    },
    "2026-11-20": {
        "content": " Se vuoi brillare come il sole, prima brucia come il sole. -Abdul Kalam"
    },
    "2026-11-21": {
        "content": "Mentre tu sei là fuori a fare festa, a scherzare, c'è qualcuno là fuori che lavora sodo nello stesso momento. Qualcuno sta diventando più intelligente e qualcuno sta vincendo. Ricordatelo. -Arnold Schwarzenegger"
    },
    "2026-11-22": {
        "content": " Se fai quello che hai sempre fatto, otterrai quello che hai sempre ottenuto. -Tony Robbins"
    },
    "2026-11-23": {
        "content": " Progresso uguale felicità. -Tony Robbins"
    },
    "2026-11-24": {
        "content": " Puoi avere risultati o scuse. Non entrambi. -Arnold Schwarzenegger"
    },
    "2026-11-25": {
        "content": " Disciplina uguale libertà. -Jocko Willink"
    },
    "2026-11-26": {
        "content": " Non soffermarti su cosa è andato storto. Concentrati invece su cosa fare dopo. Dedica le tue energie ad andare avanti, verso la ricerca della risposta. -Disegno di Denis Waitley"
    },
    "2026-11-27": {
        "content": " Sii il leader che vorresti avere. -Simon Sinek"
    },
    "2026-11-28": {
        "content": " Il mio atteggiamento è che se mi spingi verso qualcosa che ritieni una debolezza, allora trasformerò quella debolezza percepita in un punto di forza. -Michael Giordano"
    },
    "2026-11-29": {
        "content": " Per la maggior parte di noi il pericolo maggiore non sta nel prefissare obiettivi troppo alti e non raggiungerli, ma nel prefissarli troppo bassi e non raggiungerli. -Michelangelo"
    },
    "2026-11-30": {
        "content": " Tutti hanno un sogno, ma non tutti hanno una sfida. -Eric Thomas"
    },
    "2026-12-01": {
        "content": " leader si creano, non si nasce. Si creano con duro sforzo, che è il prezzo che tutti noi dobbiamo pagare per raggiungere qualsiasi obiettivo che valga la pena. -Vince Lombardi"
    },
    "2026-12-02": {
        "content": " Scegliamo di andare sulla luna in questo decennio e fare le altre cose. Non perché siano facili, ma perché sono difficili. -John F. Kennedy"
    },
    "2026-12-03": {
        "content": " Il giorno più bello della tua vita e della mia è quando ci assumiamo la totale responsabilità dei nostri atteggiamenti. È il giorno in cui cresciamo davvero. -John C. Maxwell"
    },
    "2026-12-04": {
        "content": " Ogni volta che sorridi a qualcuno, è un gesto d'amore, un regalo a quella persona, una cosa meravigliosa. -Madre Teresa"
    },
    "2026-12-05": {
        "content": " Sii l'osservatore silenzioso dei tuoi pensieri e del tuo comportamento. Sei sotto il pensatore. Sei la quiete sotto il rumore mentale. Sei l'amore e la gioia sotto il dolore. -Eckhart Tolle"
    },
    "2026-12-06": {
        "content": " Se non puoi volare allora corri, se non puoi correre allora cammina, se non puoi camminare allora striscia, ma qualsiasi cosa tu faccia devi continuare ad andare avanti. -Martin Luther King Jr."
    },
    "2026-12-07": {
        "content": " Il perdono non è un atto occasionale, è un atteggiamento costante. -Martin Luther King Jr."
    },
    "2026-12-08": {
        "content": " Troppo spesso sottovalutiamo il potere di un tocco, di un sorriso, di una parola gentile, di un orecchio attento, di un complimento sincero o del più piccolo gesto di premura, tutti atti che hanno il potenziale di cambiare una vita. -Leo Buscaglia"
    },
    "2026-12-09": {
        "content": "Mantieni vivi i tuoi sogni. Comprendi che per raggiungere qualsiasi cosa servono fede e convinzione in te stesso, visione, duro lavoro, determinazione e dedizione. Ricorda che tutte le cose sono possibili per coloro che credono. -Gail Devers"
    },
    "2026-12-10": {
        "content": " Lo sport ha il potere di cambiare il mondo. Ha il potere di ispirare. Ha il potere di unire le persone in un modo che poche altre cose riescono a fare. Parla ai giovani in un linguaggio che capiscono. Lo sport può creare speranza dove una volta c'era solo disperazione. -Nelson Mandela"
    },
    "2026-12-11": {
        "content": " Chiedi ciò che vuoi. Credi di meritarlo, e poi lascia che la Vita te lo dia. -Louise Fieno"
    },
    "2026-12-12": {
        "content": " Vivi con intenzione. Cammina fino al limite. Ascolta attentamente. Pratica il benessere. Gioca con abbandono. Ridi. Scegli senza rimpianti. Apprezza i tuoi amici. Continua a imparare. Fai ciò che ami. Vivi come se questo fosse tutto ciò che c'è. -Mary Anne Radmacher"
    },
    "2026-12-13": {
        "content": " Ciò su cui ti concentri si espande e quando ti concentri sulle cose buone della tua vita, ne crei di più. -Oprah Winfrey"
    },
    "2026-12-14": {
        "content": " Hai potere sulla tua mente, non sugli eventi esterni. Renditi conto di questo, e troverai la forza. -Marco Aurelio"
    },
    "2026-12-15": {
        "content": "Non cercare scuse per non farcela. Concentrati su tutte le ragioni per cui devi farcela. -Ralph Marston"
    },
    "2026-12-16": {
        "content": " Dove c'è amore c'è vita. -Mahatma Gandhi"
    },
    "2026-12-17": {
        "content": " Devi ballare come se nessuno ti guardasse, amare come se non ti facessero mai del male, cantare come se nessuno ti ascoltasse e vivere come se il paradiso fosse in terra. -William W. Purkey"
    },
    "2026-12-18": {
        "content": " Il successo consiste nel conoscere il proprio scopo nella vita, crescere per raggiungere il proprio massimo potenziale e piantare semi che siano utili agli altri. -John C. Maxwell"
    },
    "2026-12-19": {
        "content": " Un sogno che fai da solo è solo un sogno. Un sogno che fai insieme è realtà. -John Lennon"
    },
    "2026-12-20": {
        "content": " Questo è il vero segreto della vita: essere completamente coinvolti in ciò che fai qui e ora. E invece di chiamarlo lavoro, renditi conto che è un gioco. -Alan Watts"
    },
    "2026-12-21": {
        "content": " Ieri è passato. Domani non è ancora arrivato. Abbiamo solo oggi. Cominciamo. -Madre Teresa"
    },
    "2026-12-22": {
        "content": " Più lodi e celebri la tua vita, più nella vita c'è da celebrare. -Oprah Winfrey"
    },
    "2026-12-23": {
        "content": "Non dubitare mai che un piccolo gruppo di cittadini riflessivi e impegnati possa cambiare il mondo. In effetti, è l'unica cosa che abbia mai fatto. -Margaret Mead"
    },
    "2026-12-24": {
        "content": " Sforzati, perché nessun altro lo farà per te. -Anonimo"
    },
    "2026-12-25": {
        "content": " La vera umiltà non è pensare meno a se stessi; è pensare meno a se stessi. -CS Lewis"
    },
    "2026-12-26": {
        "content": " Se puoi cambiare idea, puoi cambiare la tua vita. -Guglielmo James"
    },
    "2026-12-27": {
        "content": " Concentrati su dove vuoi arrivare, non su ciò che temi. -Tony Robbins"
    },
    "2026-12-28": {
        "content": " Rispetta te stesso e gli altri ti rispetteranno. -Confucio"
    },
    "2026-12-29": {
        "content": " Fai quello che puoi, con quello che hai, dove sei. -Teodoro Roosevelt"
    },
    "2026-12-30": {
        "content": " Alcuni cambiamenti possono sembrare negativi in superficie, ma presto ti renderai conto che nella tua vita si sta creando spazio affinché qualcosa di nuovo possa emergere. -Eckhart Tolle"
    },
    "2026-12-31": {
        "content": " Se le tue azioni ispirano gli altri a sognare di più, imparare di più, fare di più e diventare di più, sei un leader. -Giovanni Quincy Adams"
    }
}
export const datePortugalList = {
    "2024-01-01": {
        "content": " Somos o que fazemos repetidamente. Excelência, portanto, não é um ato, mas um hábito. -Aristóteles"
    },
    "2024-01-02": {
        "content": " Um rio corta a rocha, não por causa de sua força, mas por causa de sua persistência. -Jim Watkins"
    },
    "2024-01-03": {
        "content": " Energia e persistência conquistam todas as coisas. -Benjamin Franklin"
    },
    "2024-01-04": {
        "content": " As oportunidades geralmente vêm disfarçadas de trabalho duro, então a maioria das pessoas não as reconhece. -Ann Landers"
    },
    "2024-01-05": {
        "content": " Se você não pode voar, então corra; se você não pode correr, então ande; se você não pode andar, então rasteje; mas não importa o que você faça, você tem que continuar seguindo em frente. -Martin Luther King Jr."
    },
    "2024-01-06": {
        "content": " A persistência garante que os resultados sejam inevitáveis. -Paramahansa Yogananda"
    },
    "2024-01-07": {
        "content": " Com talento comum e perseverança extraordinária, todas as coisas são alcançáveis -Thomas Fowell Buxton"
    },
    "2024-01-08": {
        "content": " Nossa maior glória não é nunca falhar, mas sim nos levantarmos sempre que falhamos. -Ralph Waldo Emerson"
    },
    "2024-01-09": {
        "content": " Sucesso é tropeçar de fracasso em fracasso sem perder o entusiasmo. -Winston Churchill"
    },
    "2024-01-10": {
        "content": "Felizmente, a persistência é um ótimo substituto para o talento. -Steve Martin"
    },
    "2024-01-11": {
        "content": " Acredito muito mais na sorte e percebo que quanto mais trabalho, mais sorte tenho. -Thomas Jefferson"
    },
    "2024-01-12": {
        "content": " Deixe para amanhã apenas aquilo que você está disposto a morrer sem ter feito. -Pablo Picasso"
    },
    "2024-01-13": {
        "content": " Não há segredos para o sucesso: não perca tempo procurando por eles. O sucesso é o resultado da perfeição, trabalho duro, aprendizado com o fracasso, lealdade àqueles para quem você trabalha e persistência. -Colin Powell"
    },
    "2024-01-14": {
        "content": " Se você quer estar na frente, então aja como se estivesse atrás. -Lao Tsé"
    },
    "2024-01-15": {
        "content": " Deixe-me contar o segredo que me levou ao meu objetivo: minha força está unicamente na minha tenacidade. -Luís Pasteur"
    },
    "2024-01-16": {
        "content": " Nada neste mundo pode substituir a persistência. Talento não; nada é mais comum do que pessoas malsucedidas com talento. Gênio não; gênio não recompensado é quase um provérbio. -Calvin Coolidge"
    },
    "2024-01-17": {
        "content": " A melhor saída é sempre seguir em frente. -Roberto Frost"
    },
    "2024-01-18": {
        "content": "Muitos dos fracassos da vida são pessoas que não perceberam o quão perto estavam do sucesso quando desistiram. -Thomas A. Edison"
    },
    "2024-01-19": {
        "content": " Somos feitos para persistir. É assim que descobrimos quem somos. -Tobias Wolff"
    },
    "2024-01-20": {
        "content": " Conhecendo as árvores, entendo o significado da paciência. Conhecendo a grama, posso apreciar a persistência. -Hal Borland"
    },
    "2024-01-21": {
        "content": " A água pingando escava a pedra, não pela força, mas pela persistência. -Ovídio"
    },
    "2024-01-22": {
        "content": " Persistência é muito importante. Você não deve desistir a menos que seja forçado a desistir. -Elon Musk"
    },
    "2024-01-23": {
        "content": " Entusiasmo ardente, apoiado por bom senso e persistência, é a qualidade que mais frequentemente leva ao sucesso. -Dale Carnegie"
    },
    "2024-01-24": {
        "content": " Ambição é o caminho para o sucesso. Persistência é o veículo em que você chega. -Bill Bradley"
    },
    "2024-01-25": {
        "content": " Concentre-se na solução, não no problema. -Walter Anderson"
    },
    "2024-01-26": {
        "content": " Quando a vida te derruba, você tem duas escolhas: ficar no chão ou se levantar. -Tom Krause"
    },
    "2024-01-27": {
        "content": " sucesso é a soma de pequenos esforços, repetidos dia após dia. -Robert Collier"
    },
    "2024-01-28": {
        "content": " Um sonho é apenas um sonho. Uma meta é um sonho com um plano e um prazo. -Harvey MacKay"
    },
    "2024-01-29": {
        "content": " Nunca desista de algo que você não consegue passar um dia sem pensar. -Winston Churchill"
    },
    "2024-01-30": {
        "content": " Diamantes nada mais são do que pedaços de carvão que permaneceram presos em suas funções. -Malcolm S. Forbes"
    },
    "2024-01-31": {
        "content": " Nada pode ser feito exceto aos poucos. -Charles Baudelaire"
    },
    "2024-02-01": {
        "content": " Se você estiver passando pelo inferno, continue. -Winston Churchill"
    },
    "2024-02-02": {
        "content": " A chave da persistência abre todas as portas fechadas pela resistência. -John Di Lemme"
    },
    "2024-02-03": {
        "content": " Se olharmos para aqueles que são mais bem-sucedidos no mundo, a persistência é o denominador comum. -Justin Sachs"
    },
    "2024-02-04": {
        "content": " Você pode comer um elefante aos poucos. -Mary Kay Ash"
    },
    "2024-02-05": {
        "content": " Não acho que exista outra qualidade tão essencial ao sucesso de qualquer tipo quanto a qualidade da perseverança. Ela supera quase tudo, até mesmo a natureza. -John D. Rockefeller"
    },
    "2024-02-06": {
        "content": "Se você quer transformar uma visão em realidade, você tem que dar 100% e nunca parar de acreditar no seu sonho. -Arnold Schwarzenegger"
    },
    "2024-02-07": {
        "content": " Corra quando puder, ande se for preciso, rasteje se for preciso; mas nunca desista. -Decano Karnazes"
    },
    "2024-02-08": {
        "content": " Dar mais uma volta quando você acha que não consegue – é isso que faz toda a diferença na sua vida. -Sylvester Stallone"
    },
    "2024-02-09": {
        "content": " Escute-me, mesmo quando você perde, é OK perder, mas você nunca pode ficar confortável com isso. Você nunca pode ficar satisfeito com a perda. Quando você perde, tem que doer. -Éric Thomas"
    },
    "2024-02-10": {
        "content": " Continue caminhando, um passo de cada vez. -Joyce Meyer"
    },
    "2024-02-11": {
        "content": " Não devemos desistir e não devemos permitir que o problema nos derrote. -Abdul Kalam"
    },
    "2024-02-12": {
        "content": " Pela perseverança nós conquistamos. -Ernest Shackleton"
    },
    "2024-02-13": {
        "content": "As paredes de tijolos estão lá por uma razão. As paredes de tijolos não estão lá para nos manter fora. As paredes de tijolos estão lá para nos dar uma chance de mostrar o quanto queremos algo. Porque as paredes de tijolos estão lá para parar as pessoas que não querem isso o suficiente. Elas estão lá para parar as outras pessoas. -Randy Pausch"
    },
    "2024-02-14": {
        "content": " O sucesso depende quase totalmente de motivação e persistência. A energia extra necessária para fazer outro esforço ou tentar outra abordagem é o segredo da vitória. -Denis Waitley"
    },
    "2024-02-15": {
        "content": " Eu cheguei até aqui e me recusei a desistir porque durante toda a minha vida sempre terminei a corrida. -Luís Zamperini"
    },
    "2024-02-16": {
        "content": " A sobrevivência pode ser resumida em três palavras – nunca desista. Esse é o cerne da questão, na verdade. Apenas continue tentando. -Urso Grylls"
    },
    "2024-02-17": {
        "content": "NÃO MAIS. Não mais desculpas. Não mais: \"Começo amanhã.\" Não mais: \"Só dessa vez.\" Não mais aceitar as deficiências da minha própria vontade. Não mais pegar o caminho mais fácil. Não mais me curvar a quaisquer pensamentos doentios ou improdutivos que flutuem pela minha mente. -Jocko Willink"
    },
    "2024-02-18": {
        "content": " Pequenos golpes derrubaram grandes carvalhos. -Benjamin Franklin"
    },
    "2024-02-19": {
        "content": " Estou disposto.” “Estou preparado para vencer.” “Eu consigo.” “Eu abraço a incerteza.” “Eu não sou meus pensamentos; eu sou o que eu faço.” “Eu sou implacável.” “Eu não espero nada e aceito tudo. -Gary John Bispo"
    },
    "2024-02-20": {
        "content": " Eu não falhei 700 vezes. Eu não falhei uma vez. Eu tive sucesso em provar que essas 700 maneiras não vão funcionar. Quando eu tiver eliminado as maneiras que não vão funcionar, eu vou encontrar a maneira que vai funcionar. -Thomas A. Edison"
    },
    "2024-02-21": {
        "content": " GRIT é Guts, Resilience, Industriousness e Tenacity. GRIT é a habilidade de focar, permanecer determinado, permanecer otimista diante de um desafio e simplesmente trabalhar mais duro do que o próximo cara ou garota. -Linda Kaplan Thaler"
    },
    "2024-02-22": {
        "content": "Acho que meu segredo é que não existem atalhos para trabalho duro, determinação e ter aquela atitude de \"não desistir\". -Jerry Arroz"
    },
    "2024-02-23": {
        "content": " Nunca pare de lutar até chegar ao seu lugar destinado – isto é, o seu eu único. Tenha um objetivo na vida, adquira conhecimento continuamente, trabalhe duro e tenha perseverança para realizar a grande vida. -Abdul Kalam"
    },
    "2024-02-24": {
        "content": " Não pare quando estiver cansado. Pare quando tiver terminado. -David Goggins"
    },
    "2024-02-25": {
        "content": " Não me julgue pelos meus sucessos, julgue-me por quantas vezes eu caí e me levantei novamente. -Nelson Mandela"
    },
    "2024-02-26": {
        "content": " O que não começa hoje nunca termina amanhã. -Johann Wolfgang von Goethe"
    },
    "2024-02-27": {
        "content": " Se você escreve cem contos e todos eles são ruins, isso não significa que você falhou. Você falha somente se parar de escrever. -Ray Bradbury"
    },
    "2024-02-28": {
        "content": " O mestre falhou mais vezes do que o iniciante tentou. -Stephen McCranie"
    },
    "2024-02-29": {
        "content": " Para o inferno com as circunstâncias; eu crio oportunidades. -Bruce Lee"
    },
    "2024-03-01": {
        "content": " única coisa pior do que começar algo e falhar é não começar. -Seth Godin"
    },
    "2024-03-02": {
        "content": " Nunca deixe para amanhã o que você pode fazer hoje. -Benjamin Franklin"
    },
    "2024-03-03": {
        "content": " Com perseverança o caracol chegou à arca. -Charles H. Spurgeon"
    },
    "2024-03-04": {
        "content": " Lembre-se, a esperança é uma coisa boa, talvez a melhor das coisas, e nenhuma coisa boa morre. -Stephen Rei"
    },
    "2024-03-05": {
        "content": " Empreendedores não terminam quando estamos cansados. Nós terminamos quando terminamos. -Robert T. Kiyosaki"
    },
    "2024-03-06": {
        "content": " Persistência e determinação por si só são onipotentes. -Calvin Coolidge"
    },
    "2024-03-07": {
        "content": " Paralise a resistência com persistência. -Woody Hayes"
    },
    "2024-03-08": {
        "content": " O sucesso nunca é possuído, ele é alugado, e o aluguel é devido todos os dias. -Rory Vaden"
    },
    "2024-03-09": {
        "content": " Sucesso não é acidente. É trabalho duro, perseverança, aprendizado, estudo, sacrifício e, acima de tudo, amor pelo que você está fazendo ou aprendendo a fazer. -Pelé"
    },
    "2024-03-10": {
        "content": " Não há como evitar o trabalho duro. Abrace-o. -Roger Federer"
    },
    "2024-03-11": {
        "content": " Um sonho não se torna realidade por mágica; é preciso suor, determinação e trabalho duro. -Colin Powell"
    },
    "2024-03-12": {
        "content": "Aprender nunca esgota a mente. -Leonardo da Vinci"
    },
    "2024-03-13": {
        "content": " Eu ouço e esqueço. Eu vejo e lembro. Eu faço e entendo. -Confúcio"
    },
    "2024-03-14": {
        "content": " Quem nunca cometeu um erro nunca tentou nada novo. -Alberto Einstein"
    },
    "2024-03-15": {
        "content": " Tente aprender algo sobre tudo e tudo sobre alguma coisa. -Thomas Henry Huxley"
    },
    "2024-03-16": {
        "content": " Um homem só aprende de duas maneiras: uma lendo e a outra pela associação com pessoas mais inteligentes. -Will Rogers"
    },
    "2024-03-17": {
        "content": " Você não entende nada até aprender mais de uma maneira. -Marvin Minsky"
    },
    "2024-03-18": {
        "content": " Diga-me e eu esqueço, ensine-me e eu posso lembrar, envolva-me e eu aprendo. -Benjamin Franklin"
    },
    "2024-03-19": {
        "content": " Se você quer aumentar sua taxa de sucesso, dobre sua taxa de fracasso. -Thomas J. Watson"
    },
    "2024-03-20": {
        "content": " Inteligência é o que você usa quando não sabe o que fazer. -Jean Piaget"
    },
    "2024-03-21": {
        "content": " Os analfabetos do século XXI não serão aqueles que não sabem ler e escrever, mas aqueles que não sabem aprender, desaprender e reaprender. -Alvin Toffler"
    },
    "2024-03-22": {
        "content": "É o que já sabemos que muitas vezes nos impede de aprender. - Cláudio Bernardo"
    },
    "2024-03-23": {
        "content": " A matemática é a linguagem com a qual Deus escreveu o universo. -Galileu Galilei"
    },
    "2024-03-24": {
        "content": " O propósito da educação é transformar espelhos em janelas. -Sydney J. Harris"
    },
    "2024-03-25": {
        "content": " Não tenho medo de tempestades porque estou aprendendo a navegar meu navio. -Louisa May Alcott"
    },
    "2024-03-26": {
        "content": " A única pessoa educada é aquela que aprendeu a aprender e a mudar. -Carl R. Rogers"
    },
    "2024-03-27": {
        "content": " Nunca conheci um homem tão ignorante que não pudesse aprender algo com ele. -Galileu Galilei"
    },
    "2024-03-28": {
        "content": " Nada desaparece até que nos ensine o que precisamos saber. -Pema Chodron"
    },
    "2024-03-29": {
        "content": " A prática leva à perfeição. Depois de muito tempo de prática, nosso trabalho se tornará natural, habilidoso, rápido e estável. -Bruce Lee"
    },
    "2024-03-30": {
        "content": " Quando você fala, você está apenas repetindo algo que já sabe. Mas, se você ouvir, você pode aprender algo novo. -Dalai Lama XIV"
    },
    "2024-03-31": {
        "content": " Busque o progresso, não a perfeição. -Anônimo"
    },
    "2024-04-01": {
        "content": "Estou sempre fazendo o que ainda não consigo fazer, para aprender como fazer. -Vicent van Gogh"
    },
    "2024-04-02": {
        "content": " O conhecimento torna o homem indigno de ser escravo. -Frederico Douglass"
    },
    "2024-04-03": {
        "content": " Aprendi muito cedo a diferença entre saber o nome de algo e conhecer algo. -Richard P. Feynman"
    },
    "2024-04-04": {
        "content": " A capacidade de aprender é um dom; A habilidade de aprender é uma habilidade; A vontade de aprender é uma escolha. -Brian Herbert"
    },
    "2024-04-05": {
        "content": " Aprenda tudo o que puder, sempre que puder, de qualquer pessoa que puder – sempre chegará um momento em que você será grato por ter feito isso. -Sarah Caldwell"
    },
    "2024-04-06": {
        "content": " Não tenho grande consideração por um homem que não é mais sábio hoje do que era ontem. -Abraão Lincoln"
    },
    "2024-04-07": {
        "content": " A chave para o sucesso é a dedicação ao aprendizado ao longo da vida. -Stephen R. Covey"
    },
    "2024-04-08": {
        "content": " Seja apaixonado e ousado. Continue sempre aprendendo. Você para de fazer coisas úteis se não aprender. -Satya Nadella"
    },
    "2024-04-09": {
        "content": " atividade mais elevada que um ser humano pode atingir é aprender para compreender, porque compreender é ser livre. -Baruch Spinoza"
    },
    "2024-04-10": {
        "content": " Se você não continuar aprendendo, outras pessoas passarão por você. Temperamento sozinho não vai resolver – você precisa de muita curiosidade por um longo, longo tempo. -Charlie Munger"
    },
    "2024-04-11": {
        "content": " Uma organização de aprendizagem é uma organização que está continuamente expandindo sua capacidade de criar seu futuro. -Peter Senge"
    },
    "2024-04-12": {
        "content": " O dia em que você para de aprender é o dia em que você começa a decair. -Isaac Asimov"
    },
    "2024-04-13": {
        "content": " O aprendizado é um ornamento na prosperidade, um refúgio na adversidade e uma provisão na velhice. -Aristóteles"
    },
    "2024-04-14": {
        "content": " Todos os líderes são aprendizes. No momento em que você para de aprender, você para de liderar. Eu aprendo o máximo que posso, de tantos quanto posso, sempre que posso. -Rick Warren"
    },
    "2024-04-15": {
        "content": " Para aprender coisas difíceis rapidamente, você deve se concentrar intensamente, sem distração. Aprender, em outras palavras, é um ato de trabalho profundo. -Cal Newport"
    },
    "2024-04-16": {
        "content": " Qualquer tolo pode saber. O ponto é entender. -Alberto Einstein"
    },
    "2024-04-17": {
        "content": "Passe cada dia tentando ser um pouco mais sábio do que você era quando acordou. -Charlie Munger"
    },
    "2024-04-18": {
        "content": " Invista em você mesmo, na sua educação. Não há nada melhor. -Sílvia Porter"
    },
    "2024-04-19": {
        "content": " A autoeducação é uma fonte contínua de prazer para mim, pois quanto mais sei, mais plena minha vida se torna e melhor aprecio minha própria existência. -Isaac Asimov"
    },
    "2024-04-20": {
        "content": " Você pode obter ajuda de professores, mas terá que aprender muito sozinho, sentado em uma sala. -Dr. Seuss"
    },
    "2024-04-21": {
        "content": " A aprendizagem acontece quando alguém quer aprender, não quando alguém quer ensinar. -Roger Schank"
    },
    "2024-04-22": {
        "content": " Uma pessoa não pode ensinar outra diretamente; uma pessoa pode apenas facilitar o aprendizado de outra. -Carl R. Rogers"
    },
    "2024-04-23": {
        "content": " Aprender não é obrigatório; é voluntário. Melhorar não é obrigatório; é voluntário. Mas para sobreviver, precisamos aprender. -W. Edwards Deming"
    },
    "2024-04-24": {
        "content": " Estou sempre fazendo aquilo que não consigo fazer, para poder aprender como fazê-lo. -Pablo Picasso"
    },
    "2024-04-25": {
        "content": "Nenhum ladrão, por mais habilidoso que seja, pode roubar o conhecimento de alguém, e é por isso que o conhecimento é o melhor e mais seguro tesouro a ser adquirido. -L. Frank Baum"
    },
    "2024-04-26": {
        "content": " Acho que esse é o melhor conselho: pense constantemente em como você poderia fazer as coisas melhor e questione-se. -Elon Musk"
    },
    "2024-04-27": {
        "content": " Um homem sábio pode aprender mais com uma pergunta tola do que um tolo pode aprender com uma resposta sábia. -Bruce Lee"
    },
    "2024-04-28": {
        "content": " Se eu vi mais longe foi por estar sobre os ombros de gigantes. -Isaac Newton"
    },
    "2024-04-29": {
        "content": " O que sabemos é uma gota, o que não sabemos é um oceano. -Isaac Newton"
    },
    "2024-04-30": {
        "content": " O melhor de aprender é que ninguém pode tirar isso de você. -Rei BB"
    },
    "2024-05-01": {
        "content": " Se você quer ser um escritor, você deve fazer duas coisas acima de tudo: ler muito e escrever muito. -Stephen Rei"
    },
    "2024-05-02": {
        "content": " A repetição é a mãe da habilidade. -Tony Robbins"
    },
    "2024-05-03": {
        "content": " A admiração é o começo da sabedoria. -Sócrates"
    },
    "2024-05-04": {
        "content": " Se você comete um erro e não o corrige, isso é chamado de erro. -Confúcio"
    },
    "2024-05-05": {
        "content": " O propósito da educação é substituir uma mente vazia por uma aberta. -Malcolm S. Forbes"
    },
    "2024-05-06": {
        "content": "Nada na vida é para ser temido, é apenas para ser compreendido. Agora é o momento de entender mais, para que possamos temer menos. -Maria Curie"
    },
    "2024-05-07": {
        "content": " Sempre que lhe perguntarem se você pode fazer um trabalho, diga a eles: \"Certamente eu posso!\". Então, ocupe-se e descubra como fazê-lo. -Teodoro Roosevelt"
    },
    "2024-05-08": {
        "content": " Todos nós precisamos de pessoas que nos deem feedback. É assim que melhoramos. -Bill Gates"
    },
    "2024-05-09": {
        "content": " A educação é a chave para abrir o mundo, um passaporte para a liberdade. -Oprah Winfrey"
    },
    "2024-05-10": {
        "content": " Tudo começa com uma ideia. -Conde Nightingale"
    },
    "2024-05-11": {
        "content": " O melhor investimento que você pode fazer é em você mesmo. -Warren Buffett"
    },
    "2024-05-12": {
        "content": " Não é sobre dinheiro ou conexões. É a disposição de trabalhar mais e aprender mais que todos. -Marcos Cubano"
    },
    "2024-05-13": {
        "content": " Enquanto você viver, continue aprendendo a viver. -Sêneca"
    },
    "2024-05-14": {
        "content": " Para aprender a ter sucesso, você deve primeiro aprender a falhar. -Michael Jordânia"
    },
    "2024-05-15": {
        "content": " Não desperdice um bom erro, aprenda com ele. -Robert T. Kiyosaki"
    },
    "2024-05-16": {
        "content": "Para adquirir conhecimento, é preciso estudar; mas para adquirir sabedoria, é preciso observar. -Marilyn Vos Savant"
    },
    "2024-05-17": {
        "content": " Você vive e aprende. De qualquer forma, você vive. -Douglas Adams"
    },
    "2024-05-18": {
        "content": " A paciência é companheira da sabedoria. -Santo Agostinho"
    },
    "2024-05-19": {
        "content": " Eu só sei de uma coisa: não sei nada. -Sócrates"
    },
    "2024-05-20": {
        "content": " A sabedoria vem da experiência. A experiência é frequentemente resultado da falta de sabedoria. -Terry Pratchett"
    },
    "2024-05-21": {
        "content": " Podemos julgar nosso progresso pela coragem de nossas perguntas e pela profundidade de nossas respostas, nossa disposição de abraçar o que é verdadeiro em vez do que parece bom. -Carl Sagan"
    },
    "2024-05-22": {
        "content": " Prefiro ter perguntas que não podem ser respondidas do que respostas que não podem ser questionadas. -Richard P. Feynman"
    },
    "2024-05-23": {
        "content": " Estou sempre pronto para aprender, embora nem sempre goste de ser ensinado. -Winston Churchill"
    },
    "2024-05-24": {
        "content": " Aquele que ama a prática sem a teoria é como o marinheiro que embarca sem leme e bússola e nunca sabe onde vai pescar. -Leonardo da Vinci"
    },
    "2024-05-25": {
        "content": " É melhor criar do que aprender. Criar é a essência da vida. -Júlio César"
    },
    "2024-05-26": {
        "content": " que a mão faz a mente lembra. -Maria Montessori"
    },
    "2024-05-27": {
        "content": " Sempre caminhe pela vida como se tivesse algo novo para aprender, e você aprenderá. -Vernon Howard"
    },
    "2024-05-28": {
        "content": " O fracasso é sucesso se aprendermos com ele. -Malcolm S. Forbes"
    },
    "2024-05-29": {
        "content": " Educação é a melhor amiga. Uma pessoa educada é respeitada em todos os lugares. Educação vence a beleza e a juventude. -Chanakya"
    },
    "2024-05-30": {
        "content": " Não pense que o que é difícil para você dominar é humanamente impossível; mas se algo é humanamente possível, considere-o ao seu alcance. -Marco Aurélio"
    },
    "2024-05-31": {
        "content": " Aprender é um processo constante de descoberta – um processo sem fim. -Bruce Lee"
    },
    "2024-06-01": {
        "content": " Ser ignorante não é uma vergonha, mas sim não querer aprender. -Benjamin Franklin"
    },
    "2024-06-02": {
        "content": " Estou convencido de que conhecimento é poder - para superar o passado, mudar nossas próprias situações, lutar contra novos obstáculos e tomar melhores decisões. -Ben Carson"
    },
    "2024-06-03": {
        "content": " Inspirando, acalmo o corpo e a mente. Expirando, sorrio. Morando no momento presente, sei que este é o único momento. -Thich Nhat Hanh"
    },
    "2024-06-04": {
        "content": "Se você acha que é pequeno demais para fazer a diferença, tente dormir com um mosquito. -Dalai Lama XIV"
    },
    "2024-06-05": {
        "content": " Muitas vezes subestimamos o poder de um toque, um sorriso, uma palavra gentil, um ouvido atento, um elogio honesto ou o menor ato de carinho, todos eles com o potencial de mudar uma vida. -Leo Buscaglia"
    },
    "2024-06-06": {
        "content": " A maneira como passamos nossos dias é, naturalmente, a maneira como passamos nossas vidas. -Annie Dillard"
    },
    "2024-06-07": {
        "content": " Alimente sua mente com grandes pensamentos, pois você nunca irá mais alto do que pensa. -Benjamin Disraeli"
    },
    "2024-06-08": {
        "content": " Você não aprende a andar seguindo regras. Você aprende fazendo e caindo. -Richard Branson"
    },
    "2024-06-09": {
        "content": " É impossível viver sem falhar em alguma coisa, a menos que você viva com tanta cautela que seria como se não tivesse vivido, caso em que você fracassaria por omissão. -J. K. Rowling"
    },
    "2024-06-10": {
        "content": " Se você quer ser feliz, seja. -Leão Tolstói"
    },
    "2024-06-11": {
        "content": " Ninguém pode me machucar sem minha permissão. -Mahatma Gandhi"
    },
    "2024-06-12": {
        "content": " Quando deixo de lado o que sou, me torno o que poderia ser. -Lao Tsé"
    },
    "2024-06-13": {
        "content": " razão pela qual lutamos contra a insegurança é porque comparamos nossos bastidores com os melhores momentos de todos os outros. -Steven Furtick"
    },
    "2024-06-14": {
        "content": " Lembre-se, hoje é o amanhã com o qual você se preocupou ontem. -Dale Carnegie"
    },
    "2024-06-15": {
        "content": " Devemos estar dispostos a abrir mão da vida que planejamos para podermos ter a vida que nos espera. -Joseph Campbell"
    },
    "2024-06-16": {
        "content": " Pare de sair e você chegará. Pare de procurar e você verá. Pare de fugir e você será encontrado. -Lao Tsé"
    },
    "2024-06-17": {
        "content": " Uma equipe não é um grupo de pessoas que trabalham juntas. Uma equipe é um grupo de pessoas que confiam umas nas outras. -Simão Sinek"
    },
    "2024-06-18": {
        "content": " O otimismo perpétuo é um multiplicador de força. -Colin Powell"
    },
    "2024-06-19": {
        "content": " Quando você se contenta em ser você mesmo e não se compara nem compete, todos o respeitarão. -Lao Tsé"
    },
    "2024-06-20": {
        "content": " Conte sua idade pelos amigos, não pelos anos. Conte sua vida pelos sorrisos, não pelas lágrimas. -John Lennon"
    },
    "2024-06-21": {
        "content": " Dê àqueles que você ama asas para voar, raízes para voltar e motivos para ficar. -Dalai Lama XIV"
    },
    "2024-06-22": {
        "content": " Perseverança e espírito fizeram maravilhas em todas as épocas. -George Washington"
    },
    "2024-06-23": {
        "content": "Compartilhe seu conhecimento. É uma maneira de atingir a imortalidade. -Dalai Lama XIV"
    },
    "2024-06-24": {
        "content": " Somos uma maneira do cosmos conhecer a si mesmo. -Carl Sagan"
    },
    "2024-06-25": {
        "content": " Um bom professor pode inspirar esperança, despertar a imaginação e incutir o amor pelo aprendizado. -Brad Henrique"
    },
    "2024-06-26": {
        "content": " Uma das maiores descobertas que uma pessoa faz, uma das suas grandes surpresas, é descobrir que ela pode fazer o que temia não conseguir fazer. -Henrique Ford"
    },
    "2024-06-27": {
        "content": " Quando foi a última vez que você fez algo pela primeira vez? -John C. Maxwell"
    },
    "2024-06-28": {
        "content": " Se você não está no processo de se tornar a pessoa que deseja ser, você está automaticamente se envolvendo em se tornar a pessoa que não deseja ser. -Dale Carnegie"
    },
    "2024-06-29": {
        "content": " A sorte favorece os corajosos. -Provérbio latino"
    },
    "2024-06-30": {
        "content": " Sucesso não é a chave para a felicidade. Felicidade é a chave para o sucesso. Se você ama o que está fazendo, você será bem-sucedido. -Albert Schweitzer"
    },
    "2024-07-01": {
        "content": " Não ganhe o mundo e perca sua alma; a sabedoria é melhor do que prata e ouro. -Bob Marley"
    },
    "2024-07-02": {
        "content": " Comece a viver imediatamente e conte cada dia como uma vida separada. -Sêneca"
    },
    "2024-07-03": {
        "content": " menos que alguém como você se importe muito, nada vai melhorar. Não vai. -Dr. Seuss"
    },
    "2024-07-04": {
        "content": " Eles não sabiam que era impossível, então fizeram. -Mark Twain"
    },
    "2024-07-05": {
        "content": " Eu posso fazer coisas que você não pode, você pode fazer coisas que eu não posso; juntos podemos fazer grandes coisas. -Madre Teresa"
    },
    "2024-07-06": {
        "content": " A única coisa que devemos temer é o próprio medo. -Franklin D. Roosevelt"
    },
    "2024-07-07": {
        "content": " Nada de grandioso foi alcançado sem entusiasmo. -Ralph Waldo Emerson"
    },
    "2024-07-08": {
        "content": " Coragem, meu querido coração. -CS Lewis"
    },
    "2024-07-09": {
        "content": " A única maneira de dar sentido à mudança é mergulhar nela, mover-se com ela e participar da dança. -Alan Watts"
    },
    "2024-07-10": {
        "content": " Onde há atenção, a energia flui e os resultados aparecem. -T.Harv Eker"
    },
    "2024-07-11": {
        "content": " A dor é temporária. Pode durar um minuto, ou uma hora, ou um dia, ou um ano, mas eventualmente ela vai diminuir e outra coisa tomará seu lugar. Se eu parar, no entanto, ela dura para sempre. -Lance Armstrong"
    },
    "2024-07-12": {
        "content": " Em cada caminhada com a natureza, recebemos muito mais do que buscamos. -John Muir"
    },
    "2024-07-13": {
        "content": "Os vencedores não são aqueles que nunca falham, mas aqueles que nunca desistem. -Edwin Louis Cole"
    },
    "2024-07-14": {
        "content": " Em vez de lutar contra a escuridão, você traz a luz. -Eckhart Tolle"
    },
    "2024-07-15": {
        "content": " Não tenha medo de perseguir aquilo que incendeia sua alma. -Jennifer Lee"
    },
    "2024-07-16": {
        "content": " Quando as pessoas se afastam de você, deixe-as ir. Seu destino nunca está vinculado a ninguém que o abandona, e isso não significa que sejam pessoas más. Significa apenas que a parte delas na sua história acabou. -TD Jakes"
    },
    "2024-07-17": {
        "content": " Liderança é a capacidade de traduzir visão em realidade. -Warren G. Bennis"
    },
    "2024-07-18": {
        "content": " Fé é acreditar no que você não vê; a recompensa dessa fé é ver o que você acredita. -Santo Agostinho"
    },
    "2024-07-19": {
        "content": " Nada é impossível a menos que você pense que é. -Paramahansa Yogananda"
    },
    "2024-07-20": {
        "content": " A única coisa pior do que ser cego é ter visão, mas não ter visão. -Helen Keller"
    },
    "2024-07-21": {
        "content": " Tudo tem sua beleza, mas nem todos a veem. -Confúcio"
    },
    "2024-07-22": {
        "content": " Deus fala no silêncio do coração. -Madre Teresa"
    },
    "2024-07-23": {
        "content": "Esperança é aquela coisa com penas que pousa na alma - e canta a melodia sem as palavras - e nunca para. -Emily Dickinson"
    },
    "2024-07-24": {
        "content": " Não importa quantas palavras sagradas você leia, não importa quantas você fale, de que lhe servirão se você não agir de acordo com elas? -Buda"
    },
    "2024-07-25": {
        "content": " E, a propósito, tudo na vida é escrevível se você tiver coragem extrovertida para fazê-lo e imaginação para improvisar. O pior inimigo da criatividade é a dúvida. -Sílvia Plath"
    },
    "2024-07-26": {
        "content": " Nada que fazemos pode mudar o passado, mas tudo que fazemos muda o futuro. -Ashleigh Brilhante"
    },
    "2024-07-27": {
        "content": " Liderança é uma escolha. Não é uma classificação. -Simão Sinek"
    },
    "2024-07-28": {
        "content": " Tudo ficará bem, e tudo ficará bem, e todo tipo de coisa ficará bem. -Juliano de Norwich"
    },
    "2024-07-29": {
        "content": " Cada um de nós é, na perspectiva cósmica, precioso. Se um humano discorda de você, deixe-o viver. Em cem bilhões de galáxias, você não encontrará outro. -Carl Sagan"
    },
    "2024-07-30": {
        "content": " Inteligência mais caráter – esse é o objetivo da verdadeira educação. -Martin Luther King Jr."
    },
    "2024-07-31": {
        "content": "Quanto mais você se perder em algo maior que você, mais energia terá. -Norman Vincent Peale"
    },
    "2024-08-01": {
        "content": " Aprenda os fundamentos e o nível de tudo o que você faz aumentará -Michael Jordânia"
    },
    "2024-08-02": {
        "content": " Você não pode viver a menos que viva plenamente agora. -Alan Watts"
    },
    "2024-08-03": {
        "content": " Lembre-se de que às vezes não conseguir o que você quer é um golpe de sorte maravilhoso. -Dalai Lama XIV"
    },
    "2024-08-04": {
        "content": " Faça o seu melhor e depois relaxe. Deixe as coisas acontecerem naturalmente, em vez de forçá-las. -Paramahansa Yogananda"
    },
    "2024-08-05": {
        "content": " Você é um ser espiritual infinito tendo uma experiência humana temporária. -Wayne W. Dyer"
    },
    "2024-08-06": {
        "content": " Você tem que sonhar antes que seus sonhos se tornem realidade. -Abdul Kalam"
    },
    "2024-08-07": {
        "content": " Acima de tudo, guarde o seu coração, pois tudo o que você faz flui dele. -Salomão"
    },
    "2024-08-08": {
        "content": " Posso me livrar de tudo enquanto escrevo; minhas tristezas desaparecem, minha coragem renasce. -Ana Frank"
    },
    "2024-08-09": {
        "content": " O objetivo não é ser perfeito até o fim. O objetivo é ser melhor hoje. -Simão Sinek"
    },
    "2024-08-10": {
        "content": " Vá confiantemente na direção dos seus sonhos. Viva a vida que você imaginou. -Henrique David Thoreau"
    },
    "2024-08-11": {
        "content": "Seja gentil sempre que possível. É sempre possível. -Dalai Lama XIV"
    },
    "2024-08-12": {
        "content": " Nosso principal propósito nesta vida é ajudar os outros. E se você não pode ajudá-los, pelo menos não os machuque. -Dalai Lama XIV"
    },
    "2024-08-13": {
        "content": " Você tem cérebro na cabeça. Você tem pés nos sapatos. Você pode se guiar em qualquer direção que escolher. Você está por conta própria. E você sabe o que sabe. E você é quem vai decidir para onde ir. -Dr. Seuss"
    },
    "2024-08-14": {
        "content": " Aquilo em que você se concentra se expande e, quando você se concentra nas coisas boas da sua vida, você cria mais delas. -Oprah Winfrey"
    },
    "2024-08-15": {
        "content": " Tudo o que preciso saber me é revelado. Tudo o que preciso vem a mim. Tudo está bem na minha vida. -Louise Feno"
    },
    "2024-08-16": {
        "content": " Estou totalmente seguro no Universo. Estou em paz em todos os lugares. Confio na vida. -Louise Feno"
    },
    "2024-08-17": {
        "content": " Vire o rosto para o sol e as sombras ficarão atrás de você. -Provérbio Maori"
    },
    "2024-08-18": {
        "content": " Coragem é não ter forças para continuar; é continuar quando você não tem forças. -Teodoro Roosevelt"
    },
    "2024-08-19": {
        "content": " O futuro depende do que você faz hoje. -Mahatma Gandhi"
    },
    "2024-08-20": {
        "content": " Um vencedor é um sonhador que nunca desiste. -Nelson Mandela"
    },
    "2024-08-21": {
        "content": "Não chore porque acabou, sorria porque aconteceu. -Dr. Seuss"
    },
    "2024-08-22": {
        "content": " Posso resumir em três palavras tudo o que aprendi sobre a vida: ela continua. -Roberto Frost"
    },
    "2024-08-23": {
        "content": " Viva a sua imaginação, não a sua história. -Stephen R. Covey"
    },
    "2024-08-24": {
        "content": " Do meu ponto de vista, se você quer o arco-íris, você tem que aguentar a chuva. -Dolly Parton"
    },
    "2024-08-25": {
        "content": " A grandeza de um homem não está na quantidade de riqueza que ele adquire, mas na sua integridade e na sua capacidade de afetar positivamente aqueles ao seu redor. -Bob Marley"
    },
    "2024-08-26": {
        "content": " A felicidade vem principalmente da nossa própria atitude, e não de fatores externos. -Dalai Lama XIV"
    },
    "2024-08-27": {
        "content": " Grandes atos são feitos de pequenos feitos. -Lao Tsé"
    },
    "2024-08-28": {
        "content": " Nunca é tarde demais para ser o que você poderia ter sido. -George Eliot"
    },
    "2024-08-29": {
        "content": " Adotar a atitude correta pode converter um estresse negativo em positivo. -Hans Selye"
    },
    "2024-08-30": {
        "content": " Ouse viver a vida que você sonhou para si mesmo. Vá em frente e faça seus sonhos se tornarem realidade. -Ralph Waldo Emerson"
    },
    "2024-08-31": {
        "content": " O tempo que você gosta de desperdiçar não é tempo perdido. -Bertrand Russel"
    },
    "2024-09-01": {
        "content": "Basta um pouco de atenção para ver e descobrir: a vida é realmente um grande riso cósmico. -Osho"
    },
    "2024-09-02": {
        "content": " O curioso paradoxo é que quando me aceito como sou, então posso mudar. -Carl R. Rogers"
    },
    "2024-09-03": {
        "content": " Seja parte da solução, não parte do problema. -Stephen R. Covey"
    },
    "2024-09-04": {
        "content": " O segredo da vida é doar. -Tony Robbins"
    },
    "2024-09-05": {
        "content": " Faça de cada dia sua obra-prima. -John de madeira"
    },
    "2024-09-06": {
        "content": " Nunca desista do que você realmente quer fazer -H. Jackson Brown Jr."
    },
    "2024-09-07": {
        "content": " Não olhe para trás – você não vai por esse caminho. -Maria Engelbreit"
    },
    "2024-09-08": {
        "content": " Faça o seu melhor e Deus fará o resto. -Nick Vujicic"
    },
    "2024-09-09": {
        "content": " Viva, viaje, aventure-se, abençoe e não se desculpe. -Jack Kerouac"
    },
    "2024-09-10": {
        "content": " No meio do inverno, descobri que havia, dentro de mim, um verão invencível. E isso me faz feliz. Pois ele diz que não importa o quanto o mundo me empurre, dentro de mim, há algo mais forte – algo melhor, empurrando de volta. -Alberto Camus"
    },
    "2024-09-11": {
        "content": "Alguns acreditam que é apenas um grande poder que pode manter o mal sob controle, mas não foi isso que eu descobri. São as pequenas ações cotidianas de pessoas comuns que mantêm a escuridão sob controle. Pequenos atos de gentileza e amor. -J. R. R. Tolkien"
    },
    "2024-09-12": {
        "content": " Seja fiel nas pequenas coisas porque é nelas que reside a sua força. -Madre Teresa"
    },
    "2024-09-13": {
        "content": " Faça de você uma luz. -Buda"
    },
    "2024-09-14": {
        "content": " VISUALIZE!!! Veja, sinta! É aqui que a ação começa. -Rhonda Byrne"
    },
    "2024-09-15": {
        "content": " Seja fenomenal ou seja esquecido! -Éric Thomas"
    },
    "2024-09-16": {
        "content": " Quando você tiver que escolher entre estar certo ou ser gentil, escolha ser gentil. -Wayne W. Dyer"
    },
    "2024-09-17": {
        "content": " Os seres humanos podem alterar suas vidas alterando suas atitudes mentais. -William James"
    },
    "2024-09-18": {
        "content": " A saúde é o maior bem. -Lao Tsé"
    },
    "2024-09-19": {
        "content": " Que eu não reze para ser protegido dos perigos, mas para ser destemido ao enfrentá-los. Que eu não implore pelo acalmamento da minha dor, mas pelo coração para conquistá-la. -Rabindranath Tagore"
    },
    "2024-09-20": {
        "content": " Coloque seu coração em fazer o bem. Faça isso repetidamente, e você será preenchido com alegria. -Buda"
    },
    "2024-09-21": {
        "content": "Eu sozinho não posso mudar o mundo, mas posso lançar uma pedra sobre as águas e criar muitas ondulações. -Madre Teresa"
    },
    "2024-09-22": {
        "content": " E chegou o dia em que o risco de permanecer preso num botão era mais doloroso do que o risco de florescer. -Anaïs Nin"
    },
    "2024-09-23": {
        "content": " Não deve haver limites para o esforço humano. Por pior que a vida pareça, sempre há esperança. -Stephen Hawking"
    },
    "2024-09-24": {
        "content": " E eu peço que você perceba quando estiver feliz e exclame, murmure ou pense em algum momento: \"Se isso não é legal, então não sei o que é\". -Kurt Vonnegut"
    },
    "2024-09-25": {
        "content": " É a sua reação à adversidade, não a adversidade em si, que determina como a história da sua vida se desenvolverá. -Dieter F. Uchtdorf"
    },
    "2024-09-26": {
        "content": " Não é o que você tem ou quem você é ou onde você está ou o que você está fazendo que o faz feliz ou infeliz. É o que você pensa sobre isso. -Dale Carnegie"
    },
    "2024-09-27": {
        "content": " Quanto mais você ler, mais coisas você saberá. Quanto mais você aprender, mais lugares você irá. -Dr. Seuss"
    },
    "2024-09-28": {
        "content": " Todos os nossos sonhos podem se tornar realidade. -Walt Disney"
    },
    "2024-09-29": {
        "content": " privilégio de uma vida é ser quem você é. -Joseph Campbell"
    },
    "2024-09-30": {
        "content": " Ninguém é inútil neste mundo se alivia o fardo dos outros. -Charles Dickens"
    },
    "2024-10-01": {
        "content": " Encontre um lugar dentro de você onde haja alegria, e a alegria queimará a dor. -Joseph Campbell"
    },
    "2024-10-02": {
        "content": " Não pergunte o que o mundo precisa. Pergunte o que faz você se sentir vivo e vá fazer. Porque o que o mundo precisa é de mais pessoas que se sentiram vivas. -Howard Thurman"
    },
    "2024-10-03": {
        "content": " Seus sentimentos são suas maiores ferramentas para ajudar você a criar sua vida. -Rhonda Byrne"
    },
    "2024-10-04": {
        "content": " Eu mereço o melhor e aceito o melhor agora. -Louise Feno"
    },
    "2024-10-05": {
        "content": " Não é o quanto damos, mas quanto amor colocamos em dar. -Madre Teresa"
    },
    "2024-10-06": {
        "content": " Quando você quer ter sucesso tanto quanto quer respirar, então você terá sucesso. -Éric Thomas"
    },
    "2024-10-07": {
        "content": " Eu odiava cada minuto de treinamento, mas eu disse: \"Não desista. Sofra agora e viva o resto da sua vida como um campeão.\" -Muhammad Ali"
    },
    "2024-10-08": {
        "content": "Não é o crítico que conta, nem aquele que aponta como o homem forte tropeçou ou como o autor de feitos poderia tê-los feito melhor. O crédito pertence ao homem que está realmente na arena, cujo rosto está manchado de suor, poeira e sangue; que se esforça bravamente; que erra e fica aquém de novo e de novo; que conhece os grandes entusiasmos, as grandes devoções e se dedica a uma causa digna; que, se vencer, conhece o triunfo de grandes realizações; e que, se falhar, pelo menos falha ousando muito, para que seu lugar nunca seja com aquelas almas frias e tímidas que não conhecem nem vitória nem derrota. -Teodoro Roosevelt"
    },
    "2024-10-09": {
        "content": " A maior aventura que você pode viver é viver a vida dos seus sonhos. -Oprah Winfrey"
    },
    "2024-10-10": {
        "content": " Sem luta não pode haver progresso. -Frederico Douglass"
    },
    "2024-10-11": {
        "content": " Um sonho escrito com uma data se torna uma meta. Uma meta dividida em etapas se torna um plano. Um plano apoiado por ação faz seus sonhos se tornarem realidade. -Greg Reid"
    },
    "2024-10-12": {
        "content": "Faça a única coisa que você acha que não pode fazer. Fracasse. Tente novamente. Faça melhor na segunda vez. As únicas pessoas que nunca caem são aquelas que nunca sobem no arame alto. -Oprah Winfrey"
    },
    "2024-10-13": {
        "content": " Espere mudanças. Analise o cenário. Aproveite as oportunidades. Pare de ser a peça de xadrez; torne-se o jogador. A jogada é sua. -Tony Robbins"
    },
    "2024-10-14": {
        "content": " Você é livre. Você é poderoso. Você é bom. Você é amor. Você tem valor. Você tem propósito. Tudo está bem. -Esther Hicks"
    },
    "2024-10-15": {
        "content": "Se você quer algo tanto a ponto de sair e lutar por ele, trabalhar dia e noite por ele, abrir mão do seu tempo, da sua paz e do seu sono por ele; se tudo o que você sonha e planeja é sobre ele e a vida parece inútil e sem valor sem ele; se você suar de alegria, se preocupar e planejar por ele e perder todo o seu terror da oposição por ele; se você simplesmente for atrás do que você quer com toda a sua capacidade, força e sagacidade, fé, esperança e confiança e firme em sua tenacidade; se nem o frio ou a pobreza, a fome ou a gota, a doença ou a dor do corpo e do cérebro puderem mantê-lo longe do que você quer; se você for obstinado e sombrio e o gerar, com a ajuda de DEUS você o obterá. -Berton Braley"
    },
    "2024-10-16": {
        "content": " Mesmo que você esteja no caminho certo, você será atropelado se ficar parado. -Will Rogers"
    },
    "2024-10-17": {
        "content": " Acredito que é possível que pessoas comuns escolham ser extraordinárias. -Elon Musk"
    },
    "2024-10-18": {
        "content": " Você não aprende a andar seguindo regras. Você aprende fazendo e caindo. -Richard Branson"
    },
    "2024-10-19": {
        "content": "Não há talento aqui, isso é trabalho duro. Isso é uma obsessão. Talento não existe, somos todos iguais como seres humanos. Você pode ser qualquer um se investir tempo. Você chegará ao topo, e é isso. Eu não sou talentoso, sou obcecado. -Conor McGregor"
    },
    "2024-10-20": {
        "content": " Um sonho não é o que você vê enquanto dorme; é algo que não deixa você dormir. -Abdul Kalam"
    },
    "2024-10-21": {
        "content": " Quando você tiver esgotado todas as possibilidades, lembre-se disto: você não esgotou. -Thomas A. Edison"
    },
    "2024-10-22": {
        "content": " Arrisque-se, cometa erros. É assim que você cresce. A dor nutre sua coragem. Você tem que falhar para praticar ser corajoso. -Mary Tyler Moore"
    },
    "2024-10-23": {
        "content": " Você obtém aquilo em que se concentra. -Tony Robbins"
    },
    "2024-10-24": {
        "content": " Agitação é a palavra mais importante de SEMPRE. -Gary Vaynerchuk"
    },
    "2024-10-25": {
        "content": " Se eles conseguem fazer penicilina com pão mofado, então certamente podem fazer algo com você. -Muhammad Ali"
    },
    "2024-10-26": {
        "content": " Você não nasceu um vencedor, e você não nasceu um perdedor. Você é o que você faz de si mesmo ser. -Lou Holtz"
    },
    "2024-10-27": {
        "content": " O sucesso é seu dever, obrigação e responsabilidade. -Grant Cardone"
    },
    "2024-10-28": {
        "content": "Há pouca diferença nas pessoas, mas essa pequena diferença faz uma grande diferença. A pequena diferença é a atitude. A grande diferença é se ela é positiva ou negativa. -W. Clemente Pedra"
    },
    "2024-10-29": {
        "content": " Os líderes devem estar próximos o suficiente para se relacionar com os outros, mas distantes o suficiente para motivá-los. -John C. Maxwell"
    },
    "2024-10-30": {
        "content": " Nunca diga nunca, porque os limites, assim como os medos, muitas vezes são apenas uma ilusão. -Michael Jordânia"
    },
    "2024-10-31": {
        "content": " Você deve esperar grandes coisas de si mesmo antes de poder fazê-las. -Michael Jordânia"
    },
    "2024-11-01": {
        "content": " No mundo dos negócios, as pessoas mais bem-sucedidas são aquelas que fazem o que amam. -Warren Buffett"
    },
    "2024-11-02": {
        "content": " A ação destruirá sua procrastinação. -Og Mandino"
    },
    "2024-11-03": {
        "content": " O fracasso não é uma opção para mim. O sucesso é tudo que eu imagino. -Conor McGregor"
    },
    "2024-11-04": {
        "content": " O sucesso não vem do que você faz ocasionalmente, mas sim do que você faz consistentemente. -Maria Forleo"
    },
    "2024-11-05": {
        "content": " Confiança e trabalho duro são os melhores remédios para matar a doença chamada fracasso. Eles farão de você uma pessoa bem-sucedida. -Abdul Kalam"
    },
    "2024-11-06": {
        "content": " Se você quer brilhar como o sol, primeiro queime como o sol. -Abdul Kalam"
    },
    "2024-11-07": {
        "content": "Enquanto você está lá fora festejando, brincando, alguém lá fora ao mesmo tempo está trabalhando duro. Alguém está ficando mais esperto e alguém está vencendo. Apenas lembre-se disso. -Arnold Schwarzenegger"
    },
    "2024-11-08": {
        "content": " Se você fizer o que sempre fez, obterá o que sempre obteve. -Tony Robbins"
    },
    "2024-11-09": {
        "content": " Progresso é igual a felicidade. -Tony Robbins"
    },
    "2024-11-10": {
        "content": " Você pode ter resultados ou desculpas. Não ambos. -Arnold Schwarzenegger"
    },
    "2024-11-11": {
        "content": " Disciplina é igual a liberdade. -Jocko Willink"
    },
    "2024-11-12": {
        "content": " Não se detenha no que deu errado. Em vez disso, concentre-se no que fazer em seguida. Gaste suas energias em seguir em frente, em direção à busca da resposta. -Denis Waitley"
    },
    "2024-11-13": {
        "content": " Seja o líder que você gostaria de ter. -Simão Sinek"
    },
    "2024-11-14": {
        "content": " Minha atitude é que se você me empurrar para algo que você acha que é uma fraqueza, então eu transformarei essa fraqueza percebida em uma força. -Michael Jordânia"
    },
    "2024-11-15": {
        "content": " O maior perigo para a maioria de nós não está em estabelecer metas muito altas e não atingi-las; mas em estabelecer metas muito baixas e atingir nossos objetivos. -Michelangelo"
    },
    "2024-11-16": {
        "content": " Todo mundo tem um sonho, mas nem todo mundo tem uma rotina. -Éric Thomas"
    },
    "2024-11-17": {
        "content": "Líderes são feitos, eles não nascem. Eles são feitos por esforço duro, que é o preço que todos nós devemos pagar para atingir qualquer objetivo que valha a pena. -Vince Lombardi"
    },
    "2024-11-18": {
        "content": " Escolhemos ir à lua nesta década e fazer as outras coisas. Não porque elas são fáceis, mas porque elas são difíceis. -John F. Kennedy"
    },
    "2024-11-19": {
        "content": " O melhor dia da sua vida e da minha é quando assumimos total responsabilidade por nossas atitudes. Esse é o dia em que realmente crescemos. -John C. Maxwell"
    },
    "2024-11-20": {
        "content": " Cada vez que você sorri para alguém, é uma ação de amor, um presente para aquela pessoa, algo lindo. -Madre Teresa"
    },
    "2024-11-21": {
        "content": " Seja o observador silencioso de seus pensamentos e comportamento. Você está abaixo do pensador. Você é a quietude abaixo do ruído mental. Você é o amor e a alegria abaixo da dor. -Eckhart Tolle"
    },
    "2024-11-22": {
        "content": " Se você não pode voar, então corra; se você não pode correr, então ande; se você não pode andar, então rasteje; mas não importa o que você faça, você tem que continuar seguindo em frente. -Martin Luther King Jr."
    },
    "2024-11-23": {
        "content": " O perdão não é um ato ocasional, é uma atitude constante. -Martin Luther King Jr."
    },
    "2024-11-24": {
        "content": " Muitas vezes subestimamos o poder de um toque, um sorriso, uma palavra gentil, um ouvido atento, um elogio honesto ou o menor ato de carinho, todos eles com o potencial de mudar uma vida. -Leo Buscaglia"
    },
    "2024-11-25": {
        "content": "Mantenha seus sonhos vivos. Entenda que para alcançar qualquer coisa é preciso fé e crença em si mesmo, visão, trabalho duro, determinação e dedicação. Lembre-se de que todas as coisas são possíveis para aqueles que acreditam. -Gail Devers"
    },
    "2024-11-26": {
        "content": " O esporte tem o poder de mudar o mundo. Ele tem o poder de inspirar. Ele tem o poder de unir as pessoas de uma forma que poucas outras coisas fazem. Ele fala aos jovens em uma linguagem que eles entendem. O esporte pode criar esperança onde antes só havia desespero. -Nelson Mandela"
    },
    "2024-11-27": {
        "content": " Peça o que você quer. Acredite que você merece, e então permita que a Vida lhe dê. -Louise Feno"
    },
    "2024-11-28": {
        "content": " Viva com intenção. Caminhe até o limite. Ouça com atenção. Pratique o bem-estar. Brinque com abandono. Ria. Escolha sem arrependimento. Aprecie seus amigos. Continue aprendendo. Faça o que você ama. Viva como se isso fosse tudo o que existe. -Mary Anne Radmacher"
    },
    "2024-11-29": {
        "content": " Aquilo em que você se concentra se expande e, quando você se concentra nas coisas boas da sua vida, você cria mais delas. -Oprah Winfrey"
    },
    "2024-11-30": {
        "content": " Você tem poder sobre sua mente, não sobre eventos externos. Perceba isso, e você encontrará força. -Marco Aurélio"
    },
    "2024-12-01": {
        "content": "Não dê desculpas para o porquê de você não conseguir fazer. Concentre-se em todas as razões pelas quais você deve fazer acontecer. -Ralph Marston"
    },
    "2024-12-02": {
        "content": " Onde há amor há vida. -Mahatma Gandhi"
    },
    "2024-12-03": {
        "content": " Você tem que dançar como se ninguém estivesse olhando, amar como se nunca fosse se machucar, cantar como se ninguém estivesse ouvindo e viver como se o paraíso estivesse na Terra. -William W. Purkey"
    },
    "2024-12-04": {
        "content": " Sucesso é conhecer seu propósito na vida, crescer para atingir seu potencial máximo e plantar sementes que beneficiem os outros. -John C. Maxwell"
    },
    "2024-12-05": {
        "content": " Um sonho que você sonha sozinho é apenas um sonho. Um sonho que você sonha junto é realidade. -John Lennon"
    },
    "2024-12-06": {
        "content": " Este é o verdadeiro segredo da vida: estar completamente engajado com o que você está fazendo aqui e agora. E em vez de chamar isso de trabalho, perceba que é diversão. -Alan Watts"
    },
    "2024-12-07": {
        "content": " Ontem se foi. Amanhã ainda não chegou. Temos apenas hoje. Vamos começar. -Madre Teresa"
    },
    "2024-12-08": {
        "content": " Quanto mais você elogia e celebra sua vida, mais há na vida para celebrar. -Oprah Winfrey"
    },
    "2024-12-09": {
        "content": "Nunca duvide que um pequeno grupo de cidadãos pensativos e comprometidos pode mudar o mundo. De fato, é a única coisa que já fez isso. -Margaret Mead"
    },
    "2024-12-10": {
        "content": " Esforce-se, porque ninguém mais fará isso por você. -Anônimo"
    },
    "2024-12-11": {
        "content": " A verdadeira humildade não é pensar menos de si mesmo; é pensar menos em si mesmo. -CS Lewis"
    },
    "2024-12-12": {
        "content": " Se você pode mudar sua mente, você pode mudar sua vida. -William James"
    },
    "2024-12-13": {
        "content": " Concentre-se em onde você quer chegar, não no que você teme. -Tony Robbins"
    },
    "2024-12-14": {
        "content": " Respeite a si mesmo e os outros respeitarão você. -Confúcio"
    },
    "2024-12-15": {
        "content": " Faça o que puder, com o que tiver, onde estiver. -Teodoro Roosevelt"
    },
    "2024-12-16": {
        "content": " Algumas mudanças parecem negativas à primeira vista, mas você logo perceberá que está sendo criado espaço em sua vida para que algo novo surja. -Eckhart Tolle"
    },
    "2024-12-17": {
        "content": " Se suas ações inspiram outros a sonhar mais, aprender mais, fazer mais e se tornar mais, você é um líder. -John Quincy Adams"
    },
    "2024-12-18": {
        "content": " Não se preocupe com nada, tudo vai ficar bem. -Bob Marley"
    },
    "2024-12-19": {
        "content": " Sonhe alto, seja positivo, trabalhe duro e aproveite a jornada. -Urijah Faber"
    },
    "2024-12-20": {
        "content": "Você está aqui para permitir que o propósito divino do Universo se desdobre. É assim que você é importante! -Eckhart Tolle"
    },
    "2024-12-21": {
        "content": " Viva com paixão! -Tony Robbins"
    },
    "2024-12-22": {
        "content": " Acredite que você pode e estará na metade do caminho. -Teodoro Roosevelt"
    },
    "2024-12-23": {
        "content": " Nossas vidas começam a acabar no dia em que ficamos em silêncio sobre coisas que importam. -Martin Luther King Jr."
    },
    "2024-12-24": {
        "content": " Juntos podemos fazer grandes coisas. -Madre Teresa"
    },
    "2024-12-25": {
        "content": " Trabalhar duro por algo que não nos importa é chamado de estresse; trabalhar duro por algo que amamos é chamado de paixão. -Simão Sinek"
    },
    "2024-12-26": {
        "content": " A caverna que você tem medo de entrar guarda o tesouro que você procura. -Joseph Campbell"
    },
    "2024-12-27": {
        "content": " Liderança é sobre empatia. É sobre ter a habilidade de se relacionar e se conectar com pessoas com o propósito de inspirar e empoderar suas vidas. -Oprah Winfrey"
    },
    "2024-12-28": {
        "content": " Não há nada impossível para quem tenta. -Alexandre, o Grande"
    },
    "2024-12-29": {
        "content": " A maioria das coisas importantes no mundo foram realizadas por pessoas que continuaram tentando quando parecia não haver mais esperança. -Dale Carnegie"
    },
    "2024-12-30": {
        "content": " Continuamos avançando, abrindo novas portas e fazendo coisas novas, porque somos curiosos e a curiosidade continua nos levando por novos caminhos. -Walt Disney"
    },
    "2024-12-31": {
        "content": "Faça o que você tem que fazer até que você possa fazer o que você quer fazer. -Oprah Winfrey"
    },
    "2025-01-01": {
        "content": " Acreditar que você é suficiente é o que lhe dá coragem para ser autêntico. -Brene Brown"
    },
    "2025-01-02": {
        "content": " São as nossas escolhas, Harry, que mostram o que realmente somos, muito mais do que as nossas habilidades. -J. K. Rowling"
    },
    "2025-01-03": {
        "content": " Siga sua felicidade e o universo abrirá portas para você onde antes só havia paredes. -Joseph Campbell"
    },
    "2025-01-04": {
        "content": " Sonhos não são aqueles que vêm até nós enquanto dormimos, mas sonhos são aqueles que você não dorme antes de realizar. -Abdul Kalam"
    },
    "2025-01-05": {
        "content": " Ousar significa muito a coragem de ser vulnerável. Significa aparecer e ser visto. Pedir o que você precisa. Falar sobre como você está se sentindo. Ter conversas difíceis. -Brene Brown"
    },
    "2025-01-06": {
        "content": " Você nunca será bem-sucedido, até que transforme sua dor em grandeza, até que permita que sua dor o empurre de onde você está para onde você precisa estar. Pare de fugir de sua dor e abrace sua dor. Sua dor será parte de seu prêmio, parte de seu produto. Eu desafio você a se esforçar. -Éric Thomas"
    },
    "2025-01-07": {
        "content": " Somos o que fazemos repetidamente. Excelência, portanto, não é um ato, mas um hábito. -Aristóteles"
    },
    "2025-01-08": {
        "content": " Um rio corta a rocha, não por causa de sua força, mas por causa de sua persistência. -Jim Watkins"
    },
    "2025-01-09": {
        "content": " Energia e persistência conquistam todas as coisas. -Benjamin Franklin"
    },
    "2025-01-10": {
        "content": " As oportunidades geralmente vêm disfarçadas de trabalho duro, então a maioria das pessoas não as reconhece. -Ann Landers"
    },
    "2025-01-11": {
        "content": " Se você não pode voar, então corra; se você não pode correr, então ande; se você não pode andar, então rasteje; mas não importa o que você faça, você tem que continuar seguindo em frente. -Martin Luther King Jr."
    },
    "2025-01-12": {
        "content": " A persistência garante que os resultados sejam inevitáveis. -Paramahansa Yogananda"
    },
    "2025-01-13": {
        "content": " Com talento comum e perseverança extraordinária, todas as coisas são alcançáveis -Thomas Fowell Buxton"
    },
    "2025-01-14": {
        "content": " Nossa maior glória não é nunca falhar, mas sim nos levantarmos sempre que falhamos. -Ralph Waldo Emerson"
    },
    "2025-01-15": {
        "content": " Sucesso é tropeçar de fracasso em fracasso sem perder o entusiasmo. -Winston Churchill"
    },
    "2025-01-16": {
        "content": "Felizmente, a persistência é um ótimo substituto para o talento. -Steve Martin"
    },
    "2025-01-17": {
        "content": " Acredito muito mais na sorte e percebo que quanto mais trabalho, mais sorte tenho. -Thomas Jefferson"
    },
    "2025-01-18": {
        "content": " Deixe para amanhã apenas aquilo que você está disposto a morrer sem ter feito. -Pablo Picasso"
    },
    "2025-01-19": {
        "content": " Não há segredos para o sucesso: não perca tempo procurando por eles. O sucesso é o resultado da perfeição, trabalho duro, aprendizado com o fracasso, lealdade àqueles para quem você trabalha e persistência. -Colin Powell"
    },
    "2025-01-20": {
        "content": " Se você quer estar na frente, então aja como se estivesse atrás. -Lao Tsé"
    },
    "2025-01-21": {
        "content": " Deixe-me contar o segredo que me levou ao meu objetivo: minha força está unicamente na minha tenacidade. -Luís Pasteur"
    },
    "2025-01-22": {
        "content": " Nada neste mundo pode substituir a persistência. Talento não; nada é mais comum do que pessoas malsucedidas com talento. Gênio não; gênio não recompensado é quase um provérbio. -Calvin Coolidge"
    },
    "2025-01-23": {
        "content": " A melhor saída é sempre seguir em frente. -Roberto Frost"
    },
    "2025-01-24": {
        "content": "Muitos dos fracassos da vida são pessoas que não perceberam o quão perto estavam do sucesso quando desistiram. -Thomas A. Edison"
    },
    "2025-01-25": {
        "content": " Somos feitos para persistir. É assim que descobrimos quem somos. -Tobias Wolff"
    },
    "2025-01-26": {
        "content": " Conhecendo as árvores, entendo o significado da paciência. Conhecendo a grama, posso apreciar a persistência. -Hal Borland"
    },
    "2025-01-27": {
        "content": " A água pingando escava a pedra, não pela força, mas pela persistência. -Ovídio"
    },
    "2025-01-28": {
        "content": " Persistência é muito importante. Você não deve desistir a menos que seja forçado a desistir. -Elon Musk"
    },
    "2025-01-29": {
        "content": " Entusiasmo ardente, apoiado por bom senso e persistência, é a qualidade que mais frequentemente leva ao sucesso. -Dale Carnegie"
    },
    "2025-01-30": {
        "content": " Ambição é o caminho para o sucesso. Persistência é o veículo em que você chega. -Bill Bradley"
    },
    "2025-01-31": {
        "content": " Concentre-se na solução, não no problema. -Walter Anderson"
    },
    "2025-02-01": {
        "content": " Quando a vida te derruba, você tem duas escolhas: ficar no chão ou se levantar. -Tom Krause"
    },
    "2025-02-02": {
        "content": " sucesso é a soma de pequenos esforços, repetidos dia após dia. -Robert Collier"
    },
    "2025-02-03": {
        "content": " Um sonho é apenas um sonho. Uma meta é um sonho com um plano e um prazo. -Harvey MacKay"
    },
    "2025-02-04": {
        "content": " Nunca desista de algo que você não consegue passar um dia sem pensar. -Winston Churchill"
    },
    "2025-02-05": {
        "content": " Diamantes nada mais são do que pedaços de carvão que permaneceram presos em suas funções. -Malcolm S. Forbes"
    },
    "2025-02-06": {
        "content": " Nada pode ser feito exceto aos poucos. -Charles Baudelaire"
    },
    "2025-02-07": {
        "content": " Se você estiver passando pelo inferno, continue. -Winston Churchill"
    },
    "2025-02-08": {
        "content": " A chave da persistência abre todas as portas fechadas pela resistência. -John Di Lemme"
    },
    "2025-02-09": {
        "content": " Se olharmos para aqueles que são mais bem-sucedidos no mundo, a persistência é o denominador comum. -Justin Sachs"
    },
    "2025-02-10": {
        "content": " Você pode comer um elefante aos poucos. -Mary Kay Ash"
    },
    "2025-02-11": {
        "content": " Não acho que exista outra qualidade tão essencial ao sucesso de qualquer tipo quanto a qualidade da perseverança. Ela supera quase tudo, até mesmo a natureza. -John D. Rockefeller"
    },
    "2025-02-12": {
        "content": "Se você quer transformar uma visão em realidade, você tem que dar 100% e nunca parar de acreditar no seu sonho. -Arnold Schwarzenegger"
    },
    "2025-02-13": {
        "content": " Corra quando puder, ande se for preciso, rasteje se for preciso; mas nunca desista. -Decano Karnazes"
    },
    "2025-02-14": {
        "content": " Dar mais uma volta quando você acha que não consegue – é isso que faz toda a diferença na sua vida. -Sylvester Stallone"
    },
    "2025-02-15": {
        "content": " Escute-me, mesmo quando você perde, é OK perder, mas você nunca pode ficar confortável com isso. Você nunca pode ficar satisfeito com a perda. Quando você perde, tem que doer. -Éric Thomas"
    },
    "2025-02-16": {
        "content": " Continue caminhando, um passo de cada vez. -Joyce Meyer"
    },
    "2025-02-17": {
        "content": " Não devemos desistir e não devemos permitir que o problema nos derrote. -Abdul Kalam"
    },
    "2025-02-18": {
        "content": " Pela perseverança nós conquistamos. -Ernest Shackleton"
    },
    "2025-02-19": {
        "content": "As paredes de tijolos estão lá por uma razão. As paredes de tijolos não estão lá para nos manter fora. As paredes de tijolos estão lá para nos dar uma chance de mostrar o quanto queremos algo. Porque as paredes de tijolos estão lá para parar as pessoas que não querem isso o suficiente. Elas estão lá para parar as outras pessoas. -Randy Pausch"
    },
    "2025-02-20": {
        "content": " O sucesso depende quase totalmente de motivação e persistência. A energia extra necessária para fazer outro esforço ou tentar outra abordagem é o segredo da vitória. -Denis Waitley"
    },
    "2025-02-21": {
        "content": " Eu cheguei até aqui e me recusei a desistir porque durante toda a minha vida sempre terminei a corrida. -Luís Zamperini"
    },
    "2025-02-22": {
        "content": " A sobrevivência pode ser resumida em três palavras – nunca desista. Esse é o cerne da questão, na verdade. Apenas continue tentando. -Urso Grylls"
    },
    "2025-02-23": {
        "content": "NÃO MAIS. Não mais desculpas. Não mais: \"Começo amanhã.\" Não mais: \"Só dessa vez.\" Não mais aceitar as deficiências da minha própria vontade. Não mais pegar o caminho mais fácil. Não mais me curvar a quaisquer pensamentos doentios ou improdutivos que flutuem pela minha mente. -Jocko Willink"
    },
    "2025-02-24": {
        "content": " Pequenos golpes derrubaram grandes carvalhos. -Benjamin Franklin"
    },
    "2025-02-25": {
        "content": " Estou disposto.” “Estou preparado para vencer.” “Eu consigo.” “Eu abraço a incerteza.” “Eu não sou meus pensamentos; eu sou o que eu faço.” “Eu sou implacável.” “Eu não espero nada e aceito tudo. -Gary John Bispo"
    },
    "2025-02-26": {
        "content": " Eu não falhei 700 vezes. Eu não falhei uma vez. Eu tive sucesso em provar que essas 700 maneiras não vão funcionar. Quando eu tiver eliminado as maneiras que não vão funcionar, eu vou encontrar a maneira que vai funcionar. -Thomas A. Edison"
    },
    "2025-02-27": {
        "content": " GRIT é Guts, Resilience, Industriousness e Tenacity. GRIT é a habilidade de focar, permanecer determinado, permanecer otimista diante de um desafio e simplesmente trabalhar mais duro do que o próximo cara ou garota. -Linda Kaplan Thaler"
    },
    "2025-02-28": {
        "content": "Acho que meu segredo é que não existem atalhos para trabalho duro, determinação e ter aquela atitude de \"não desistir\". -Jerry Arroz"
    },
    "2025-03-01": {
        "content": " Nunca pare de lutar até chegar ao seu lugar destinado – isto é, o seu eu único. Tenha um objetivo na vida, adquira conhecimento continuamente, trabalhe duro e tenha perseverança para realizar a grande vida. -Abdul Kalam"
    },
    "2025-03-02": {
        "content": " Não pare quando estiver cansado. Pare quando tiver terminado. -David Goggins"
    },
    "2025-03-03": {
        "content": " Não me julgue pelos meus sucessos, julgue-me por quantas vezes eu caí e me levantei novamente. -Nelson Mandela"
    },
    "2025-03-04": {
        "content": " O que não começa hoje nunca termina amanhã. -Johann Wolfgang von Goethe"
    },
    "2025-03-05": {
        "content": " Se você escreve cem contos e todos eles são ruins, isso não significa que você falhou. Você falha somente se parar de escrever. -Ray Bradbury"
    },
    "2025-03-06": {
        "content": " O mestre falhou mais vezes do que o iniciante tentou. -Stephen McCranie"
    },
    "2025-03-07": {
        "content": " Para o inferno com as circunstâncias; eu crio oportunidades. -Bruce Lee"
    },
    "2025-03-08": {
        "content": " única coisa pior do que começar algo e falhar é não começar. -Seth Godin"
    },
    "2025-03-09": {
        "content": " Nunca deixe para amanhã o que você pode fazer hoje. -Benjamin Franklin"
    },
    "2025-03-10": {
        "content": " Com perseverança o caracol chegou à arca. -Charles H. Spurgeon"
    },
    "2025-03-11": {
        "content": " Lembre-se, a esperança é uma coisa boa, talvez a melhor das coisas, e nenhuma coisa boa morre. -Stephen Rei"
    },
    "2025-03-12": {
        "content": " Empreendedores não terminam quando estamos cansados. Nós terminamos quando terminamos. -Robert T. Kiyosaki"
    },
    "2025-03-13": {
        "content": " Persistência e determinação por si só são onipotentes. -Calvin Coolidge"
    },
    "2025-03-14": {
        "content": " Paralise a resistência com persistência. -Woody Hayes"
    },
    "2025-03-15": {
        "content": " O sucesso nunca é possuído, ele é alugado, e o aluguel é devido todos os dias. -Rory Vaden"
    },
    "2025-03-16": {
        "content": " Sucesso não é acidente. É trabalho duro, perseverança, aprendizado, estudo, sacrifício e, acima de tudo, amor pelo que você está fazendo ou aprendendo a fazer. -Pelé"
    },
    "2025-03-17": {
        "content": " Não há como evitar o trabalho duro. Abrace-o. -Roger Federer"
    },
    "2025-03-18": {
        "content": " Um sonho não se torna realidade por mágica; é preciso suor, determinação e trabalho duro. -Colin Powell"
    },
    "2025-03-19": {
        "content": "Aprender nunca esgota a mente. -Leonardo da Vinci"
    },
    "2025-03-20": {
        "content": " Eu ouço e esqueço. Eu vejo e lembro. Eu faço e entendo. -Confúcio"
    },
    "2025-03-21": {
        "content": " Quem nunca cometeu um erro nunca tentou nada novo. -Alberto Einstein"
    },
    "2025-03-22": {
        "content": " Tente aprender algo sobre tudo e tudo sobre alguma coisa. -Thomas Henry Huxley"
    },
    "2025-03-23": {
        "content": " Um homem só aprende de duas maneiras: uma lendo e a outra pela associação com pessoas mais inteligentes. -Will Rogers"
    },
    "2025-03-24": {
        "content": " Você não entende nada até aprender mais de uma maneira. -Marvin Minsky"
    },
    "2025-03-25": {
        "content": " Diga-me e eu esqueço, ensine-me e eu posso lembrar, envolva-me e eu aprendo. -Benjamin Franklin"
    },
    "2025-03-26": {
        "content": " Se você quer aumentar sua taxa de sucesso, dobre sua taxa de fracasso. -Thomas J. Watson"
    },
    "2025-03-27": {
        "content": " Inteligência é o que você usa quando não sabe o que fazer. -Jean Piaget"
    },
    "2025-03-28": {
        "content": " Os analfabetos do século XXI não serão aqueles que não sabem ler e escrever, mas aqueles que não sabem aprender, desaprender e reaprender. -Alvin Toffler"
    },
    "2025-03-29": {
        "content": "É o que já sabemos que muitas vezes nos impede de aprender. - Cláudio Bernardo"
    },
    "2025-03-30": {
        "content": " A matemática é a linguagem com a qual Deus escreveu o universo. -Galileu Galilei"
    },
    "2025-03-31": {
        "content": " O propósito da educação é transformar espelhos em janelas. -Sydney J. Harris"
    },
    "2025-04-01": {
        "content": " Não tenho medo de tempestades porque estou aprendendo a navegar meu navio. -Louisa May Alcott"
    },
    "2025-04-02": {
        "content": " A única pessoa educada é aquela que aprendeu a aprender e a mudar. -Carl R. Rogers"
    },
    "2025-04-03": {
        "content": " Nunca conheci um homem tão ignorante que não pudesse aprender algo com ele. -Galileu Galilei"
    },
    "2025-04-04": {
        "content": " Nada desaparece até que nos ensine o que precisamos saber. -Pema Chodron"
    },
    "2025-04-05": {
        "content": " A prática leva à perfeição. Depois de muito tempo de prática, nosso trabalho se tornará natural, habilidoso, rápido e estável. -Bruce Lee"
    },
    "2025-04-06": {
        "content": " Quando você fala, você está apenas repetindo algo que já sabe. Mas, se você ouvir, você pode aprender algo novo. -Dalai Lama XIV"
    },
    "2025-04-07": {
        "content": " Busque o progresso, não a perfeição. -Anônimo"
    },
    "2025-04-08": {
        "content": "Estou sempre fazendo o que ainda não consigo fazer, para aprender como fazer. -Vicent van Gogh"
    },
    "2025-04-09": {
        "content": " O conhecimento torna o homem indigno de ser escravo. -Frederico Douglass"
    },
    "2025-04-10": {
        "content": " Aprendi muito cedo a diferença entre saber o nome de algo e conhecer algo. -Richard P. Feynman"
    },
    "2025-04-11": {
        "content": " A capacidade de aprender é um dom; A habilidade de aprender é uma habilidade; A vontade de aprender é uma escolha. -Brian Herbert"
    },
    "2025-04-12": {
        "content": " Aprenda tudo o que puder, sempre que puder, de qualquer pessoa que puder – sempre chegará um momento em que você será grato por ter feito isso. -Sarah Caldwell"
    },
    "2025-04-13": {
        "content": " Não tenho grande consideração por um homem que não é mais sábio hoje do que era ontem. -Abraão Lincoln"
    },
    "2025-04-14": {
        "content": " A chave para o sucesso é a dedicação ao aprendizado ao longo da vida. -Stephen R. Covey"
    },
    "2025-04-15": {
        "content": " Seja apaixonado e ousado. Continue sempre aprendendo. Você para de fazer coisas úteis se não aprender. -Satya Nadella"
    },
    "2025-04-16": {
        "content": " atividade mais elevada que um ser humano pode atingir é aprender para compreender, porque compreender é ser livre. -Baruch Spinoza"
    },
    "2025-04-17": {
        "content": " Se você não continuar aprendendo, outras pessoas passarão por você. Temperamento sozinho não vai resolver – você precisa de muita curiosidade por um longo, longo tempo. -Charlie Munger"
    },
    "2025-04-18": {
        "content": " Uma organização de aprendizagem é uma organização que está continuamente expandindo sua capacidade de criar seu futuro. -Peter Senge"
    },
    "2025-04-19": {
        "content": " O dia em que você para de aprender é o dia em que você começa a decair. -Isaac Asimov"
    },
    "2025-04-20": {
        "content": " O aprendizado é um ornamento na prosperidade, um refúgio na adversidade e uma provisão na velhice. -Aristóteles"
    },
    "2025-04-21": {
        "content": " Todos os líderes são aprendizes. No momento em que você para de aprender, você para de liderar. Eu aprendo o máximo que posso, de tantos quanto posso, sempre que posso. -Rick Warren"
    },
    "2025-04-22": {
        "content": " Para aprender coisas difíceis rapidamente, você deve se concentrar intensamente, sem distração. Aprender, em outras palavras, é um ato de trabalho profundo. -Cal Newport"
    },
    "2025-04-23": {
        "content": " Qualquer tolo pode saber. O ponto é entender. -Alberto Einstein"
    },
    "2025-04-24": {
        "content": "Passe cada dia tentando ser um pouco mais sábio do que você era quando acordou. -Charlie Munger"
    },
    "2025-04-25": {
        "content": " Invista em você mesmo, na sua educação. Não há nada melhor. -Sílvia Porter"
    },
    "2025-04-26": {
        "content": " A autoeducação é uma fonte contínua de prazer para mim, pois quanto mais sei, mais plena minha vida se torna e melhor aprecio minha própria existência. -Isaac Asimov"
    },
    "2025-04-27": {
        "content": " Você pode obter ajuda de professores, mas terá que aprender muito sozinho, sentado em uma sala. -Dr. Seuss"
    },
    "2025-04-28": {
        "content": " A aprendizagem acontece quando alguém quer aprender, não quando alguém quer ensinar. -Roger Schank"
    },
    "2025-04-29": {
        "content": " Uma pessoa não pode ensinar outra diretamente; uma pessoa pode apenas facilitar o aprendizado de outra. -Carl R. Rogers"
    },
    "2025-04-30": {
        "content": " Aprender não é obrigatório; é voluntário. Melhorar não é obrigatório; é voluntário. Mas para sobreviver, precisamos aprender. -W. Edwards Deming"
    },
    "2025-05-01": {
        "content": " Estou sempre fazendo aquilo que não consigo fazer, para poder aprender como fazê-lo. -Pablo Picasso"
    },
    "2025-05-02": {
        "content": "Nenhum ladrão, por mais habilidoso que seja, pode roubar o conhecimento de alguém, e é por isso que o conhecimento é o melhor e mais seguro tesouro a ser adquirido. -L. Frank Baum"
    },
    "2025-05-03": {
        "content": " Acho que esse é o melhor conselho: pense constantemente em como você poderia fazer as coisas melhor e questione-se. -Elon Musk"
    },
    "2025-05-04": {
        "content": " Um homem sábio pode aprender mais com uma pergunta tola do que um tolo pode aprender com uma resposta sábia. -Bruce Lee"
    },
    "2025-05-05": {
        "content": " Se eu vi mais longe foi por estar sobre os ombros de gigantes. -Isaac Newton"
    },
    "2025-05-06": {
        "content": " O que sabemos é uma gota, o que não sabemos é um oceano. -Isaac Newton"
    },
    "2025-05-07": {
        "content": " O melhor de aprender é que ninguém pode tirar isso de você. -Rei BB"
    },
    "2025-05-08": {
        "content": " Se você quer ser um escritor, você deve fazer duas coisas acima de tudo: ler muito e escrever muito. -Stephen Rei"
    },
    "2025-05-09": {
        "content": " A repetição é a mãe da habilidade. -Tony Robbins"
    },
    "2025-05-10": {
        "content": " A admiração é o começo da sabedoria. -Sócrates"
    },
    "2025-05-11": {
        "content": " Se você comete um erro e não o corrige, isso é chamado de erro. -Confúcio"
    },
    "2025-05-12": {
        "content": " O propósito da educação é substituir uma mente vazia por uma aberta. -Malcolm S. Forbes"
    },
    "2025-05-13": {
        "content": "Nada na vida é para ser temido, é apenas para ser compreendido. Agora é o momento de entender mais, para que possamos temer menos. -Maria Curie"
    },
    "2025-05-14": {
        "content": " Sempre que lhe perguntarem se você pode fazer um trabalho, diga a eles: \"Certamente eu posso!\". Então, ocupe-se e descubra como fazê-lo. -Teodoro Roosevelt"
    },
    "2025-05-15": {
        "content": " Todos nós precisamos de pessoas que nos deem feedback. É assim que melhoramos. -Bill Gates"
    },
    "2025-05-16": {
        "content": " A educação é a chave para abrir o mundo, um passaporte para a liberdade. -Oprah Winfrey"
    },
    "2025-05-17": {
        "content": " Tudo começa com uma ideia. -Conde Nightingale"
    },
    "2025-05-18": {
        "content": " O melhor investimento que você pode fazer é em você mesmo. -Warren Buffett"
    },
    "2025-05-19": {
        "content": " Não é sobre dinheiro ou conexões. É a disposição de trabalhar mais e aprender mais que todos. -Marcos Cubano"
    },
    "2025-05-20": {
        "content": " Enquanto você viver, continue aprendendo a viver. -Sêneca"
    },
    "2025-05-21": {
        "content": " Para aprender a ter sucesso, você deve primeiro aprender a falhar. -Michael Jordânia"
    },
    "2025-05-22": {
        "content": " Não desperdice um bom erro, aprenda com ele. -Robert T. Kiyosaki"
    },
    "2025-05-23": {
        "content": "Para adquirir conhecimento, é preciso estudar; mas para adquirir sabedoria, é preciso observar. -Marilyn Vos Savant"
    },
    "2025-05-24": {
        "content": " Você vive e aprende. De qualquer forma, você vive. -Douglas Adams"
    },
    "2025-05-25": {
        "content": " A paciência é companheira da sabedoria. -Santo Agostinho"
    },
    "2025-05-26": {
        "content": " Eu só sei de uma coisa: não sei nada. -Sócrates"
    },
    "2025-05-27": {
        "content": " A sabedoria vem da experiência. A experiência é frequentemente resultado da falta de sabedoria. -Terry Pratchett"
    },
    "2025-05-28": {
        "content": " Podemos julgar nosso progresso pela coragem de nossas perguntas e pela profundidade de nossas respostas, nossa disposição de abraçar o que é verdadeiro em vez do que parece bom. -Carl Sagan"
    },
    "2025-05-29": {
        "content": " Prefiro ter perguntas que não podem ser respondidas do que respostas que não podem ser questionadas. -Richard P. Feynman"
    },
    "2025-05-30": {
        "content": " Estou sempre pronto para aprender, embora nem sempre goste de ser ensinado. -Winston Churchill"
    },
    "2025-05-31": {
        "content": " Aquele que ama a prática sem a teoria é como o marinheiro que embarca sem leme e bússola e nunca sabe onde vai pescar. -Leonardo da Vinci"
    },
    "2025-06-01": {
        "content": " É melhor criar do que aprender. Criar é a essência da vida. -Júlio César"
    },
    "2025-06-02": {
        "content": " que a mão faz a mente lembra. -Maria Montessori"
    },
    "2025-06-03": {
        "content": " Sempre caminhe pela vida como se tivesse algo novo para aprender, e você aprenderá. -Vernon Howard"
    },
    "2025-06-04": {
        "content": " O fracasso é sucesso se aprendermos com ele. -Malcolm S. Forbes"
    },
    "2025-06-05": {
        "content": " Educação é a melhor amiga. Uma pessoa educada é respeitada em todos os lugares. Educação vence a beleza e a juventude. -Chanakya"
    },
    "2025-06-06": {
        "content": " Não pense que o que é difícil para você dominar é humanamente impossível; mas se algo é humanamente possível, considere-o ao seu alcance. -Marco Aurélio"
    },
    "2025-06-07": {
        "content": " Aprender é um processo constante de descoberta – um processo sem fim. -Bruce Lee"
    },
    "2025-06-08": {
        "content": " Ser ignorante não é uma vergonha, mas sim não querer aprender. -Benjamin Franklin"
    },
    "2025-06-09": {
        "content": " Estou convencido de que conhecimento é poder - para superar o passado, mudar nossas próprias situações, lutar contra novos obstáculos e tomar melhores decisões. -Ben Carson"
    },
    "2025-06-10": {
        "content": " Inspirando, acalmo o corpo e a mente. Expirando, sorrio. Morando no momento presente, sei que este é o único momento. -Thich Nhat Hanh"
    },
    "2025-06-11": {
        "content": "Se você acha que é pequeno demais para fazer a diferença, tente dormir com um mosquito. -Dalai Lama XIV"
    },
    "2025-06-12": {
        "content": " Muitas vezes subestimamos o poder de um toque, um sorriso, uma palavra gentil, um ouvido atento, um elogio honesto ou o menor ato de carinho, todos eles com o potencial de mudar uma vida. -Leo Buscaglia"
    },
    "2025-06-13": {
        "content": " A maneira como passamos nossos dias é, naturalmente, a maneira como passamos nossas vidas. -Annie Dillard"
    },
    "2025-06-14": {
        "content": " Alimente sua mente com grandes pensamentos, pois você nunca irá mais alto do que pensa. -Benjamin Disraeli"
    },
    "2025-06-15": {
        "content": " Você não aprende a andar seguindo regras. Você aprende fazendo e caindo. -Richard Branson"
    },
    "2025-06-16": {
        "content": " É impossível viver sem falhar em alguma coisa, a menos que você viva com tanta cautela que seria como se não tivesse vivido, caso em que você fracassaria por omissão. -J. K. Rowling"
    },
    "2025-06-17": {
        "content": " Se você quer ser feliz, seja. -Leão Tolstói"
    },
    "2025-06-18": {
        "content": " Ninguém pode me machucar sem minha permissão. -Mahatma Gandhi"
    },
    "2025-06-19": {
        "content": " Quando deixo de lado o que sou, me torno o que poderia ser. -Lao Tsé"
    },
    "2025-06-20": {
        "content": " razão pela qual lutamos contra a insegurança é porque comparamos nossos bastidores com os melhores momentos de todos os outros. -Steven Furtick"
    },
    "2025-06-21": {
        "content": " Lembre-se, hoje é o amanhã com o qual você se preocupou ontem. -Dale Carnegie"
    },
    "2025-06-22": {
        "content": " Devemos estar dispostos a abrir mão da vida que planejamos para podermos ter a vida que nos espera. -Joseph Campbell"
    },
    "2025-06-23": {
        "content": " Pare de sair e você chegará. Pare de procurar e você verá. Pare de fugir e você será encontrado. -Lao Tsé"
    },
    "2025-06-24": {
        "content": " Uma equipe não é um grupo de pessoas que trabalham juntas. Uma equipe é um grupo de pessoas que confiam umas nas outras. -Simão Sinek"
    },
    "2025-06-25": {
        "content": " O otimismo perpétuo é um multiplicador de força. -Colin Powell"
    },
    "2025-06-26": {
        "content": " Quando você se contenta em ser você mesmo e não se compara nem compete, todos o respeitarão. -Lao Tsé"
    },
    "2025-06-27": {
        "content": " Conte sua idade pelos amigos, não pelos anos. Conte sua vida pelos sorrisos, não pelas lágrimas. -John Lennon"
    },
    "2025-06-28": {
        "content": " Dê àqueles que você ama asas para voar, raízes para voltar e motivos para ficar. -Dalai Lama XIV"
    },
    "2025-06-29": {
        "content": " Perseverança e espírito fizeram maravilhas em todas as épocas. -George Washington"
    },
    "2025-06-30": {
        "content": "Compartilhe seu conhecimento. É uma maneira de atingir a imortalidade. -Dalai Lama XIV"
    },
    "2025-07-01": {
        "content": " Somos uma maneira do cosmos conhecer a si mesmo. -Carl Sagan"
    },
    "2025-07-02": {
        "content": " Um bom professor pode inspirar esperança, despertar a imaginação e incutir o amor pelo aprendizado. -Brad Henrique"
    },
    "2025-07-03": {
        "content": " Uma das maiores descobertas que uma pessoa faz, uma das suas grandes surpresas, é descobrir que ela pode fazer o que temia não conseguir fazer. -Henrique Ford"
    },
    "2025-07-04": {
        "content": " Quando foi a última vez que você fez algo pela primeira vez? -John C. Maxwell"
    },
    "2025-07-05": {
        "content": " Se você não está no processo de se tornar a pessoa que deseja ser, você está automaticamente se envolvendo em se tornar a pessoa que não deseja ser. -Dale Carnegie"
    },
    "2025-07-06": {
        "content": " A sorte favorece os corajosos. -Provérbio latino"
    },
    "2025-07-07": {
        "content": " Sucesso não é a chave para a felicidade. Felicidade é a chave para o sucesso. Se você ama o que está fazendo, você será bem-sucedido. -Albert Schweitzer"
    },
    "2025-07-08": {
        "content": " Não ganhe o mundo e perca sua alma; a sabedoria é melhor do que prata e ouro. -Bob Marley"
    },
    "2025-07-09": {
        "content": " Comece a viver imediatamente e conte cada dia como uma vida separada. -Sêneca"
    },
    "2025-07-10": {
        "content": " menos que alguém como você se importe muito, nada vai melhorar. Não vai. -Dr. Seuss"
    },
    "2025-07-11": {
        "content": " Eles não sabiam que era impossível, então fizeram. -Mark Twain"
    },
    "2025-07-12": {
        "content": " Eu posso fazer coisas que você não pode, você pode fazer coisas que eu não posso; juntos podemos fazer grandes coisas. -Madre Teresa"
    },
    "2025-07-13": {
        "content": " A única coisa que devemos temer é o próprio medo. -Franklin D. Roosevelt"
    },
    "2025-07-14": {
        "content": " Nada de grandioso foi alcançado sem entusiasmo. -Ralph Waldo Emerson"
    },
    "2025-07-15": {
        "content": " Coragem, meu querido coração. -CS Lewis"
    },
    "2025-07-16": {
        "content": " A única maneira de dar sentido à mudança é mergulhar nela, mover-se com ela e participar da dança. -Alan Watts"
    },
    "2025-07-17": {
        "content": " Onde há atenção, a energia flui e os resultados aparecem. -T.Harv Eker"
    },
    "2025-07-18": {
        "content": " A dor é temporária. Pode durar um minuto, ou uma hora, ou um dia, ou um ano, mas eventualmente ela vai diminuir e outra coisa tomará seu lugar. Se eu parar, no entanto, ela dura para sempre. -Lance Armstrong"
    },
    "2025-07-19": {
        "content": " Em cada caminhada com a natureza, recebemos muito mais do que buscamos. -John Muir"
    },
    "2025-07-20": {
        "content": "Os vencedores não são aqueles que nunca falham, mas aqueles que nunca desistem. -Edwin Louis Cole"
    },
    "2025-07-21": {
        "content": " Em vez de lutar contra a escuridão, você traz a luz. -Eckhart Tolle"
    },
    "2025-07-22": {
        "content": " Não tenha medo de perseguir aquilo que incendeia sua alma. -Jennifer Lee"
    },
    "2025-07-23": {
        "content": " Quando as pessoas se afastam de você, deixe-as ir. Seu destino nunca está vinculado a ninguém que o abandona, e isso não significa que sejam pessoas más. Significa apenas que a parte delas na sua história acabou. -TD Jakes"
    },
    "2025-07-24": {
        "content": " Liderança é a capacidade de traduzir visão em realidade. -Warren G. Bennis"
    },
    "2025-07-25": {
        "content": " Fé é acreditar no que você não vê; a recompensa dessa fé é ver o que você acredita. -Santo Agostinho"
    },
    "2025-07-26": {
        "content": " Nada é impossível a menos que você pense que é. -Paramahansa Yogananda"
    },
    "2025-07-27": {
        "content": " A única coisa pior do que ser cego é ter visão, mas não ter visão. -Helen Keller"
    },
    "2025-07-28": {
        "content": " Tudo tem sua beleza, mas nem todos a veem. -Confúcio"
    },
    "2025-07-29": {
        "content": " Deus fala no silêncio do coração. -Madre Teresa"
    },
    "2025-07-30": {
        "content": "Esperança é aquela coisa com penas que pousa na alma - e canta a melodia sem as palavras - e nunca para. -Emily Dickinson"
    },
    "2025-07-31": {
        "content": " Não importa quantas palavras sagradas você leia, não importa quantas você fale, de que lhe servirão se você não agir de acordo com elas? -Buda"
    },
    "2025-08-01": {
        "content": " E, a propósito, tudo na vida é escrevível se você tiver coragem extrovertida para fazê-lo e imaginação para improvisar. O pior inimigo da criatividade é a dúvida. -Sílvia Plath"
    },
    "2025-08-02": {
        "content": " Nada que fazemos pode mudar o passado, mas tudo que fazemos muda o futuro. -Ashleigh Brilhante"
    },
    "2025-08-03": {
        "content": " Liderança é uma escolha. Não é uma classificação. -Simão Sinek"
    },
    "2025-08-04": {
        "content": " Tudo ficará bem, e tudo ficará bem, e todo tipo de coisa ficará bem. -Juliano de Norwich"
    },
    "2025-08-05": {
        "content": " Cada um de nós é, na perspectiva cósmica, precioso. Se um humano discorda de você, deixe-o viver. Em cem bilhões de galáxias, você não encontrará outro. -Carl Sagan"
    },
    "2025-08-06": {
        "content": " Inteligência mais caráter – esse é o objetivo da verdadeira educação. -Martin Luther King Jr."
    },
    "2025-08-07": {
        "content": "Quanto mais você se perder em algo maior que você, mais energia terá. -Norman Vincent Peale"
    },
    "2025-08-08": {
        "content": " Aprenda os fundamentos e o nível de tudo o que você faz aumentará -Michael Jordânia"
    },
    "2025-08-09": {
        "content": " Você não pode viver a menos que viva plenamente agora. -Alan Watts"
    },
    "2025-08-10": {
        "content": " Lembre-se de que às vezes não conseguir o que você quer é um golpe de sorte maravilhoso. -Dalai Lama XIV"
    },
    "2025-08-11": {
        "content": " Faça o seu melhor e depois relaxe. Deixe as coisas acontecerem naturalmente, em vez de forçá-las. -Paramahansa Yogananda"
    },
    "2025-08-12": {
        "content": " Você é um ser espiritual infinito tendo uma experiência humana temporária. -Wayne W. Dyer"
    },
    "2025-08-13": {
        "content": " Você tem que sonhar antes que seus sonhos se tornem realidade. -Abdul Kalam"
    },
    "2025-08-14": {
        "content": " Acima de tudo, guarde o seu coração, pois tudo o que você faz flui dele. -Salomão"
    },
    "2025-08-15": {
        "content": " Posso me livrar de tudo enquanto escrevo; minhas tristezas desaparecem, minha coragem renasce. -Ana Frank"
    },
    "2025-08-16": {
        "content": " O objetivo não é ser perfeito até o fim. O objetivo é ser melhor hoje. -Simão Sinek"
    },
    "2025-08-17": {
        "content": " Vá confiantemente na direção dos seus sonhos. Viva a vida que você imaginou. -Henrique David Thoreau"
    },
    "2025-08-18": {
        "content": "Seja gentil sempre que possível. É sempre possível. -Dalai Lama XIV"
    },
    "2025-08-19": {
        "content": " Nosso principal propósito nesta vida é ajudar os outros. E se você não pode ajudá-los, pelo menos não os machuque. -Dalai Lama XIV"
    },
    "2025-08-20": {
        "content": " Você tem cérebro na cabeça. Você tem pés nos sapatos. Você pode se guiar em qualquer direção que escolher. Você está por conta própria. E você sabe o que sabe. E você é quem vai decidir para onde ir. -Dr. Seuss"
    },
    "2025-08-21": {
        "content": " Aquilo em que você se concentra se expande e, quando você se concentra nas coisas boas da sua vida, você cria mais delas. -Oprah Winfrey"
    },
    "2025-08-22": {
        "content": " Tudo o que preciso saber me é revelado. Tudo o que preciso vem a mim. Tudo está bem na minha vida. -Louise Feno"
    },
    "2025-08-23": {
        "content": " Estou totalmente seguro no Universo. Estou em paz em todos os lugares. Confio na vida. -Louise Feno"
    },
    "2025-08-24": {
        "content": " Vire o rosto para o sol e as sombras ficarão atrás de você. -Provérbio Maori"
    },
    "2025-08-25": {
        "content": " Coragem é não ter forças para continuar; é continuar quando você não tem forças. -Teodoro Roosevelt"
    },
    "2025-08-26": {
        "content": " O futuro depende do que você faz hoje. -Mahatma Gandhi"
    },
    "2025-08-27": {
        "content": " Um vencedor é um sonhador que nunca desiste. -Nelson Mandela"
    },
    "2025-08-28": {
        "content": "Não chore porque acabou, sorria porque aconteceu. -Dr. Seuss"
    },
    "2025-08-29": {
        "content": " Posso resumir em três palavras tudo o que aprendi sobre a vida: ela continua. -Roberto Frost"
    },
    "2025-08-30": {
        "content": " Viva a sua imaginação, não a sua história. -Stephen R. Covey"
    },
    "2025-08-31": {
        "content": " Do meu ponto de vista, se você quer o arco-íris, você tem que aguentar a chuva. -Dolly Parton"
    },
    "2025-09-01": {
        "content": " A grandeza de um homem não está na quantidade de riqueza que ele adquire, mas na sua integridade e na sua capacidade de afetar positivamente aqueles ao seu redor. -Bob Marley"
    },
    "2025-09-02": {
        "content": " A felicidade vem principalmente da nossa própria atitude, e não de fatores externos. -Dalai Lama XIV"
    },
    "2025-09-03": {
        "content": " Grandes atos são feitos de pequenos feitos. -Lao Tsé"
    },
    "2025-09-04": {
        "content": " Nunca é tarde demais para ser o que você poderia ter sido. -George Eliot"
    },
    "2025-09-05": {
        "content": " Adotar a atitude correta pode converter um estresse negativo em positivo. -Hans Selye"
    },
    "2025-09-06": {
        "content": " Ouse viver a vida que você sonhou para si mesmo. Vá em frente e faça seus sonhos se tornarem realidade. -Ralph Waldo Emerson"
    },
    "2025-09-07": {
        "content": " O tempo que você gosta de desperdiçar não é tempo perdido. -Bertrand Russel"
    },
    "2025-09-08": {
        "content": "Basta um pouco de atenção para ver e descobrir: a vida é realmente um grande riso cósmico. -Osho"
    },
    "2025-09-09": {
        "content": " O curioso paradoxo é que quando me aceito como sou, então posso mudar. -Carl R. Rogers"
    },
    "2025-09-10": {
        "content": " Seja parte da solução, não parte do problema. -Stephen R. Covey"
    },
    "2025-09-11": {
        "content": " O segredo da vida é doar. -Tony Robbins"
    },
    "2025-09-12": {
        "content": " Faça de cada dia sua obra-prima. -John de madeira"
    },
    "2025-09-13": {
        "content": " Nunca desista do que você realmente quer fazer -H. Jackson Brown Jr."
    },
    "2025-09-14": {
        "content": " Não olhe para trás – você não vai por esse caminho. -Maria Engelbreit"
    },
    "2025-09-15": {
        "content": " Faça o seu melhor e Deus fará o resto. -Nick Vujicic"
    },
    "2025-09-16": {
        "content": " Viva, viaje, aventure-se, abençoe e não se desculpe. -Jack Kerouac"
    },
    "2025-09-17": {
        "content": " No meio do inverno, descobri que havia, dentro de mim, um verão invencível. E isso me faz feliz. Pois ele diz que não importa o quanto o mundo me empurre, dentro de mim, há algo mais forte – algo melhor, empurrando de volta. -Alberto Camus"
    },
    "2025-09-18": {
        "content": "Alguns acreditam que é apenas um grande poder que pode manter o mal sob controle, mas não foi isso que eu descobri. São as pequenas ações cotidianas de pessoas comuns que mantêm a escuridão sob controle. Pequenos atos de gentileza e amor. -J. R. R. Tolkien"
    },
    "2025-09-19": {
        "content": " Seja fiel nas pequenas coisas porque é nelas que reside a sua força. -Madre Teresa"
    },
    "2025-09-20": {
        "content": " Faça de você uma luz. -Buda"
    },
    "2025-09-21": {
        "content": " VISUALIZE!!! Veja, sinta! É aqui que a ação começa. -Rhonda Byrne"
    },
    "2025-09-22": {
        "content": " Seja fenomenal ou seja esquecido! -Éric Thomas"
    },
    "2025-09-23": {
        "content": " Quando você tiver que escolher entre estar certo ou ser gentil, escolha ser gentil. -Wayne W. Dyer"
    },
    "2025-09-24": {
        "content": " Os seres humanos podem alterar suas vidas alterando suas atitudes mentais. -William James"
    },
    "2025-09-25": {
        "content": " A saúde é o maior bem. -Lao Tsé"
    },
    "2025-09-26": {
        "content": " Que eu não reze para ser protegido dos perigos, mas para ser destemido ao enfrentá-los. Que eu não implore pelo acalmamento da minha dor, mas pelo coração para conquistá-la. -Rabindranath Tagore"
    },
    "2025-09-27": {
        "content": " Coloque seu coração em fazer o bem. Faça isso repetidamente, e você será preenchido com alegria. -Buda"
    },
    "2025-09-28": {
        "content": "Eu sozinho não posso mudar o mundo, mas posso lançar uma pedra sobre as águas e criar muitas ondulações. -Madre Teresa"
    },
    "2025-09-29": {
        "content": " E chegou o dia em que o risco de permanecer preso num botão era mais doloroso do que o risco de florescer. -Anaïs Nin"
    },
    "2025-09-30": {
        "content": " Não deve haver limites para o esforço humano. Por pior que a vida pareça, sempre há esperança. -Stephen Hawking"
    },
    "2025-10-01": {
        "content": " E eu peço que você perceba quando estiver feliz e exclame, murmure ou pense em algum momento: \"Se isso não é legal, então não sei o que é\". -Kurt Vonnegut"
    },
    "2025-10-02": {
        "content": " É a sua reação à adversidade, não a adversidade em si, que determina como a história da sua vida se desenvolverá. -Dieter F. Uchtdorf"
    },
    "2025-10-03": {
        "content": " Não é o que você tem ou quem você é ou onde você está ou o que você está fazendo que o faz feliz ou infeliz. É o que você pensa sobre isso. -Dale Carnegie"
    },
    "2025-10-04": {
        "content": " Quanto mais você ler, mais coisas você saberá. Quanto mais você aprender, mais lugares você irá. -Dr. Seuss"
    },
    "2025-10-05": {
        "content": " Todos os nossos sonhos podem se tornar realidade. -Walt Disney"
    },
    "2025-10-06": {
        "content": " privilégio de uma vida é ser quem você é. -Joseph Campbell"
    },
    "2025-10-07": {
        "content": " Ninguém é inútil neste mundo se alivia o fardo dos outros. -Charles Dickens"
    },
    "2025-10-08": {
        "content": " Encontre um lugar dentro de você onde haja alegria, e a alegria queimará a dor. -Joseph Campbell"
    },
    "2025-10-09": {
        "content": " Não pergunte o que o mundo precisa. Pergunte o que faz você se sentir vivo e vá fazer. Porque o que o mundo precisa é de mais pessoas que se sentiram vivas. -Howard Thurman"
    },
    "2025-10-10": {
        "content": " Seus sentimentos são suas maiores ferramentas para ajudar você a criar sua vida. -Rhonda Byrne"
    },
    "2025-10-11": {
        "content": " Eu mereço o melhor e aceito o melhor agora. -Louise Feno"
    },
    "2025-10-12": {
        "content": " Não é o quanto damos, mas quanto amor colocamos em dar. -Madre Teresa"
    },
    "2025-10-13": {
        "content": " Quando você quer ter sucesso tanto quanto quer respirar, então você terá sucesso. -Éric Thomas"
    },
    "2025-10-14": {
        "content": " Eu odiava cada minuto de treinamento, mas eu disse: \"Não desista. Sofra agora e viva o resto da sua vida como um campeão.\" -Muhammad Ali"
    },
    "2025-10-15": {
        "content": "Não é o crítico que conta, nem aquele que aponta como o homem forte tropeçou ou como o autor de feitos poderia tê-los feito melhor. O crédito pertence ao homem que está realmente na arena, cujo rosto está manchado de suor, poeira e sangue; que se esforça bravamente; que erra e fica aquém de novo e de novo; que conhece os grandes entusiasmos, as grandes devoções e se dedica a uma causa digna; que, se vencer, conhece o triunfo de grandes realizações; e que, se falhar, pelo menos falha ousando muito, para que seu lugar nunca seja com aquelas almas frias e tímidas que não conhecem nem vitória nem derrota. -Teodoro Roosevelt"
    },
    "2025-10-16": {
        "content": " A maior aventura que você pode viver é viver a vida dos seus sonhos. -Oprah Winfrey"
    },
    "2025-10-17": {
        "content": " Sem luta não pode haver progresso. -Frederico Douglass"
    },
    "2025-10-18": {
        "content": " Um sonho escrito com uma data se torna uma meta. Uma meta dividida em etapas se torna um plano. Um plano apoiado por ação faz seus sonhos se tornarem realidade. -Greg Reid"
    },
    "2025-10-19": {
        "content": "Faça a única coisa que você acha que não pode fazer. Fracasse. Tente novamente. Faça melhor na segunda vez. As únicas pessoas que nunca caem são aquelas que nunca sobem no arame alto. -Oprah Winfrey"
    },
    "2025-10-20": {
        "content": " Espere mudanças. Analise o cenário. Aproveite as oportunidades. Pare de ser a peça de xadrez; torne-se o jogador. A jogada é sua. -Tony Robbins"
    },
    "2025-10-21": {
        "content": " Você é livre. Você é poderoso. Você é bom. Você é amor. Você tem valor. Você tem propósito. Tudo está bem. -Esther Hicks"
    },
    "2025-10-22": {
        "content": "Se você quer algo tanto a ponto de sair e lutar por ele, trabalhar dia e noite por ele, abrir mão do seu tempo, da sua paz e do seu sono por ele; se tudo o que você sonha e planeja é sobre ele e a vida parece inútil e sem valor sem ele; se você suar de alegria, se preocupar e planejar por ele e perder todo o seu terror da oposição por ele; se você simplesmente for atrás do que você quer com toda a sua capacidade, força e sagacidade, fé, esperança e confiança e firme em sua tenacidade; se nem o frio ou a pobreza, a fome ou a gota, a doença ou a dor do corpo e do cérebro puderem mantê-lo longe do que você quer; se você for obstinado e sombrio e o gerar, com a ajuda de DEUS você o obterá. -Berton Braley"
    },
    "2025-10-23": {
        "content": " Mesmo que você esteja no caminho certo, você será atropelado se ficar parado. -Will Rogers"
    },
    "2025-10-24": {
        "content": " Acredito que é possível que pessoas comuns escolham ser extraordinárias. -Elon Musk"
    },
    "2025-10-25": {
        "content": " Você não aprende a andar seguindo regras. Você aprende fazendo e caindo. -Richard Branson"
    },
    "2025-10-26": {
        "content": "Não há talento aqui, isso é trabalho duro. Isso é uma obsessão. Talento não existe, somos todos iguais como seres humanos. Você pode ser qualquer um se investir tempo. Você chegará ao topo, e é isso. Eu não sou talentoso, sou obcecado. -Conor McGregor"
    },
    "2025-10-27": {
        "content": " Um sonho não é o que você vê enquanto dorme; é algo que não deixa você dormir. -Abdul Kalam"
    },
    "2025-10-28": {
        "content": " Quando você tiver esgotado todas as possibilidades, lembre-se disto: você não esgotou. -Thomas A. Edison"
    },
    "2025-10-29": {
        "content": " Arrisque-se, cometa erros. É assim que você cresce. A dor nutre sua coragem. Você tem que falhar para praticar ser corajoso. -Mary Tyler Moore"
    },
    "2025-10-30": {
        "content": " Você obtém aquilo em que se concentra. -Tony Robbins"
    },
    "2025-10-31": {
        "content": " Agitação é a palavra mais importante de SEMPRE. -Gary Vaynerchuk"
    },
    "2025-11-01": {
        "content": " Se eles conseguem fazer penicilina com pão mofado, então certamente podem fazer algo com você. -Muhammad Ali"
    },
    "2025-11-02": {
        "content": " Você não nasceu um vencedor, e você não nasceu um perdedor. Você é o que você faz de si mesmo ser. -Lou Holtz"
    },
    "2025-11-03": {
        "content": " O sucesso é seu dever, obrigação e responsabilidade. -Grant Cardone"
    },
    "2025-11-04": {
        "content": "Há pouca diferença nas pessoas, mas essa pequena diferença faz uma grande diferença. A pequena diferença é a atitude. A grande diferença é se ela é positiva ou negativa. -W. Clemente Pedra"
    },
    "2025-11-05": {
        "content": " Os líderes devem estar próximos o suficiente para se relacionar com os outros, mas distantes o suficiente para motivá-los. -John C. Maxwell"
    },
    "2025-11-06": {
        "content": " Nunca diga nunca, porque os limites, assim como os medos, muitas vezes são apenas uma ilusão. -Michael Jordânia"
    },
    "2025-11-07": {
        "content": " Você deve esperar grandes coisas de si mesmo antes de poder fazê-las. -Michael Jordânia"
    },
    "2025-11-08": {
        "content": " No mundo dos negócios, as pessoas mais bem-sucedidas são aquelas que fazem o que amam. -Warren Buffett"
    },
    "2025-11-09": {
        "content": " A ação destruirá sua procrastinação. -Og Mandino"
    },
    "2025-11-10": {
        "content": " O fracasso não é uma opção para mim. O sucesso é tudo que eu imagino. -Conor McGregor"
    },
    "2025-11-11": {
        "content": " O sucesso não vem do que você faz ocasionalmente, mas sim do que você faz consistentemente. -Maria Forleo"
    },
    "2025-11-12": {
        "content": " Confiança e trabalho duro são os melhores remédios para matar a doença chamada fracasso. Eles farão de você uma pessoa bem-sucedida. -Abdul Kalam"
    },
    "2025-11-13": {
        "content": " Se você quer brilhar como o sol, primeiro queime como o sol. -Abdul Kalam"
    },
    "2025-11-14": {
        "content": "Enquanto você está lá fora festejando, brincando, alguém lá fora ao mesmo tempo está trabalhando duro. Alguém está ficando mais esperto e alguém está vencendo. Apenas lembre-se disso. -Arnold Schwarzenegger"
    },
    "2025-11-15": {
        "content": " Se você fizer o que sempre fez, obterá o que sempre obteve. -Tony Robbins"
    },
    "2025-11-16": {
        "content": " Progresso é igual a felicidade. -Tony Robbins"
    },
    "2025-11-17": {
        "content": " Você pode ter resultados ou desculpas. Não ambos. -Arnold Schwarzenegger"
    },
    "2025-11-18": {
        "content": " Disciplina é igual a liberdade. -Jocko Willink"
    },
    "2025-11-19": {
        "content": " Não se detenha no que deu errado. Em vez disso, concentre-se no que fazer em seguida. Gaste suas energias em seguir em frente, em direção à busca da resposta. -Denis Waitley"
    },
    "2025-11-20": {
        "content": " Seja o líder que você gostaria de ter. -Simão Sinek"
    },
    "2025-11-21": {
        "content": " Minha atitude é que se você me empurrar para algo que você acha que é uma fraqueza, então eu transformarei essa fraqueza percebida em uma força. -Michael Jordânia"
    },
    "2025-11-22": {
        "content": " O maior perigo para a maioria de nós não está em estabelecer metas muito altas e não atingi-las; mas em estabelecer metas muito baixas e atingir nossos objetivos. -Michelangelo"
    },
    "2025-11-23": {
        "content": " Todo mundo tem um sonho, mas nem todo mundo tem uma rotina. -Éric Thomas"
    },
    "2025-11-24": {
        "content": "Líderes são feitos, eles não nascem. Eles são feitos por esforço duro, que é o preço que todos nós devemos pagar para atingir qualquer objetivo que valha a pena. -Vince Lombardi"
    },
    "2025-11-25": {
        "content": " Escolhemos ir à lua nesta década e fazer as outras coisas. Não porque elas são fáceis, mas porque elas são difíceis. -John F. Kennedy"
    },
    "2025-11-26": {
        "content": " O melhor dia da sua vida e da minha é quando assumimos total responsabilidade por nossas atitudes. Esse é o dia em que realmente crescemos. -John C. Maxwell"
    },
    "2025-11-27": {
        "content": " Cada vez que você sorri para alguém, é uma ação de amor, um presente para aquela pessoa, algo lindo. -Madre Teresa"
    },
    "2025-11-28": {
        "content": " Seja o observador silencioso de seus pensamentos e comportamento. Você está abaixo do pensador. Você é a quietude abaixo do ruído mental. Você é o amor e a alegria abaixo da dor. -Eckhart Tolle"
    },
    "2025-11-29": {
        "content": " Se você não pode voar, então corra; se você não pode correr, então ande; se você não pode andar, então rasteje; mas não importa o que você faça, você tem que continuar seguindo em frente. -Martin Luther King Jr."
    },
    "2025-11-30": {
        "content": " O perdão não é um ato ocasional, é uma atitude constante. -Martin Luther King Jr."
    },
    "2025-12-01": {
        "content": " Muitas vezes subestimamos o poder de um toque, um sorriso, uma palavra gentil, um ouvido atento, um elogio honesto ou o menor ato de carinho, todos eles com o potencial de mudar uma vida. -Leo Buscaglia"
    },
    "2025-12-02": {
        "content": "Mantenha seus sonhos vivos. Entenda que para alcançar qualquer coisa é preciso fé e crença em si mesmo, visão, trabalho duro, determinação e dedicação. Lembre-se de que todas as coisas são possíveis para aqueles que acreditam. -Gail Devers"
    },
    "2025-12-03": {
        "content": " O esporte tem o poder de mudar o mundo. Ele tem o poder de inspirar. Ele tem o poder de unir as pessoas de uma forma que poucas outras coisas fazem. Ele fala aos jovens em uma linguagem que eles entendem. O esporte pode criar esperança onde antes só havia desespero. -Nelson Mandela"
    },
    "2025-12-04": {
        "content": " Peça o que você quer. Acredite que você merece, e então permita que a Vida lhe dê. -Louise Feno"
    },
    "2025-12-05": {
        "content": " Viva com intenção. Caminhe até o limite. Ouça com atenção. Pratique o bem-estar. Brinque com abandono. Ria. Escolha sem arrependimento. Aprecie seus amigos. Continue aprendendo. Faça o que você ama. Viva como se isso fosse tudo o que existe. -Mary Anne Radmacher"
    },
    "2025-12-06": {
        "content": " Aquilo em que você se concentra se expande e, quando você se concentra nas coisas boas da sua vida, você cria mais delas. -Oprah Winfrey"
    },
    "2025-12-07": {
        "content": " Você tem poder sobre sua mente, não sobre eventos externos. Perceba isso, e você encontrará força. -Marco Aurélio"
    },
    "2025-12-08": {
        "content": "Não dê desculpas para o porquê de você não conseguir fazer. Concentre-se em todas as razões pelas quais você deve fazer acontecer. -Ralph Marston"
    },
    "2025-12-09": {
        "content": " Onde há amor há vida. -Mahatma Gandhi"
    },
    "2025-12-10": {
        "content": " Você tem que dançar como se ninguém estivesse olhando, amar como se nunca fosse se machucar, cantar como se ninguém estivesse ouvindo e viver como se o paraíso estivesse na Terra. -William W. Purkey"
    },
    "2025-12-11": {
        "content": " Sucesso é conhecer seu propósito na vida, crescer para atingir seu potencial máximo e plantar sementes que beneficiem os outros. -John C. Maxwell"
    },
    "2025-12-12": {
        "content": " Um sonho que você sonha sozinho é apenas um sonho. Um sonho que você sonha junto é realidade. -John Lennon"
    },
    "2025-12-13": {
        "content": " Este é o verdadeiro segredo da vida: estar completamente engajado com o que você está fazendo aqui e agora. E em vez de chamar isso de trabalho, perceba que é diversão. -Alan Watts"
    },
    "2025-12-14": {
        "content": " Ontem se foi. Amanhã ainda não chegou. Temos apenas hoje. Vamos começar. -Madre Teresa"
    },
    "2025-12-15": {
        "content": " Quanto mais você elogia e celebra sua vida, mais há na vida para celebrar. -Oprah Winfrey"
    },
    "2025-12-16": {
        "content": "Nunca duvide que um pequeno grupo de cidadãos pensativos e comprometidos pode mudar o mundo. De fato, é a única coisa que já fez isso. -Margaret Mead"
    },
    "2025-12-17": {
        "content": " Esforce-se, porque ninguém mais fará isso por você. -Anônimo"
    },
    "2025-12-18": {
        "content": " A verdadeira humildade não é pensar menos de si mesmo; é pensar menos em si mesmo. -CS Lewis"
    },
    "2025-12-19": {
        "content": " Se você pode mudar sua mente, você pode mudar sua vida. -William James"
    },
    "2025-12-20": {
        "content": " Concentre-se em onde você quer chegar, não no que você teme. -Tony Robbins"
    },
    "2025-12-21": {
        "content": " Respeite a si mesmo e os outros respeitarão você. -Confúcio"
    },
    "2025-12-22": {
        "content": " Faça o que puder, com o que tiver, onde estiver. -Teodoro Roosevelt"
    },
    "2025-12-23": {
        "content": " Algumas mudanças parecem negativas à primeira vista, mas você logo perceberá que está sendo criado espaço em sua vida para que algo novo surja. -Eckhart Tolle"
    },
    "2025-12-24": {
        "content": " Se suas ações inspiram outros a sonhar mais, aprender mais, fazer mais e se tornar mais, você é um líder. -John Quincy Adams"
    },
    "2025-12-25": {
        "content": " Não se preocupe com nada, tudo vai ficar bem. -Bob Marley"
    },
    "2025-12-26": {
        "content": " Sonhe alto, seja positivo, trabalhe duro e aproveite a jornada. -Urijah Faber"
    },
    "2025-12-27": {
        "content": "Você está aqui para permitir que o propósito divino do Universo se desdobre. É assim que você é importante! -Eckhart Tolle"
    },
    "2025-12-28": {
        "content": " Viva com paixão! -Tony Robbins"
    },
    "2025-12-29": {
        "content": " Acredite que você pode e estará na metade do caminho. -Teodoro Roosevelt"
    },
    "2025-12-30": {
        "content": " Nossas vidas começam a acabar no dia em que ficamos em silêncio sobre coisas que importam. -Martin Luther King Jr."
    },
    "2025-12-31": {
        "content": " Juntos podemos fazer grandes coisas. -Madre Teresa"
    },
    "2026-01-01": {
        "content": " Trabalhar duro por algo que não nos importa é chamado de estresse; trabalhar duro por algo que amamos é chamado de paixão. -Simão Sinek"
    },
    "2026-01-02": {
        "content": " A caverna que você tem medo de entrar guarda o tesouro que você procura. -Joseph Campbell"
    },
    "2026-01-03": {
        "content": " Liderança é sobre empatia. É sobre ter a habilidade de se relacionar e se conectar com pessoas com o propósito de inspirar e empoderar suas vidas. -Oprah Winfrey"
    },
    "2026-01-04": {
        "content": " Não há nada impossível para quem tenta. -Alexandre, o Grande"
    },
    "2026-01-05": {
        "content": " A maioria das coisas importantes no mundo foram realizadas por pessoas que continuaram tentando quando parecia não haver mais esperança. -Dale Carnegie"
    },
    "2026-01-06": {
        "content": " Continuamos avançando, abrindo novas portas e fazendo coisas novas, porque somos curiosos e a curiosidade continua nos levando por novos caminhos. -Walt Disney"
    },
    "2026-01-07": {
        "content": "Faça o que você tem que fazer até que você possa fazer o que você quer fazer. -Oprah Winfrey"
    },
    "2026-01-08": {
        "content": " Acreditar que você é suficiente é o que lhe dá coragem para ser autêntico. -Brene Brown"
    },
    "2026-01-09": {
        "content": " São as nossas escolhas, Harry, que mostram o que realmente somos, muito mais do que as nossas habilidades. -J. K. Rowling"
    },
    "2026-01-10": {
        "content": " Siga sua felicidade e o universo abrirá portas para você onde antes só havia paredes. -Joseph Campbell"
    },
    "2026-01-11": {
        "content": " Sonhos não são aqueles que vêm até nós enquanto dormimos, mas sonhos são aqueles que você não dorme antes de realizar. -Abdul Kalam"
    },
    "2026-01-12": {
        "content": " Ousar significa muito a coragem de ser vulnerável. Significa aparecer e ser visto. Pedir o que você precisa. Falar sobre como você está se sentindo. Ter conversas difíceis. -Brene Brown"
    },
    "2026-01-13": {
        "content": " Você nunca será bem-sucedido, até que transforme sua dor em grandeza, até que permita que sua dor o empurre de onde você está para onde você precisa estar. Pare de fugir de sua dor e abrace sua dor. Sua dor será parte de seu prêmio, parte de seu produto. Eu desafio você a se esforçar. -Éric Thomas"
    },
    "2026-01-14": {
        "content": " Somos o que fazemos repetidamente. Excelência, portanto, não é um ato, mas um hábito. -Aristóteles"
    },
    "2026-01-15": {
        "content": " Um rio corta a rocha, não por causa de sua força, mas por causa de sua persistência. -Jim Watkins"
    },
    "2026-01-16": {
        "content": " Energia e persistência conquistam todas as coisas. -Benjamin Franklin"
    },
    "2026-01-17": {
        "content": " As oportunidades geralmente vêm disfarçadas de trabalho duro, então a maioria das pessoas não as reconhece. -Ann Landers"
    },
    "2026-01-18": {
        "content": " Se você não pode voar, então corra; se você não pode correr, então ande; se você não pode andar, então rasteje; mas não importa o que você faça, você tem que continuar seguindo em frente. -Martin Luther King Jr."
    },
    "2026-01-19": {
        "content": " A persistência garante que os resultados sejam inevitáveis. -Paramahansa Yogananda"
    },
    "2026-01-20": {
        "content": " Com talento comum e perseverança extraordinária, todas as coisas são alcançáveis -Thomas Fowell Buxton"
    },
    "2026-01-21": {
        "content": " Nossa maior glória não é nunca falhar, mas sim nos levantarmos sempre que falhamos. -Ralph Waldo Emerson"
    },
    "2026-01-22": {
        "content": " Sucesso é tropeçar de fracasso em fracasso sem perder o entusiasmo. -Winston Churchill"
    },
    "2026-01-23": {
        "content": "Felizmente, a persistência é um ótimo substituto para o talento. -Steve Martin"
    },
    "2026-01-24": {
        "content": " Acredito muito mais na sorte e percebo que quanto mais trabalho, mais sorte tenho. -Thomas Jefferson"
    },
    "2026-01-25": {
        "content": " Deixe para amanhã apenas aquilo que você está disposto a morrer sem ter feito. -Pablo Picasso"
    },
    "2026-01-26": {
        "content": " Não há segredos para o sucesso: não perca tempo procurando por eles. O sucesso é o resultado da perfeição, trabalho duro, aprendizado com o fracasso, lealdade àqueles para quem você trabalha e persistência. -Colin Powell"
    },
    "2026-01-27": {
        "content": " Se você quer estar na frente, então aja como se estivesse atrás. -Lao Tsé"
    },
    "2026-01-28": {
        "content": " Deixe-me contar o segredo que me levou ao meu objetivo: minha força está unicamente na minha tenacidade. -Luís Pasteur"
    },
    "2026-01-29": {
        "content": " Nada neste mundo pode substituir a persistência. Talento não; nada é mais comum do que pessoas malsucedidas com talento. Gênio não; gênio não recompensado é quase um provérbio. -Calvin Coolidge"
    },
    "2026-01-30": {
        "content": " A melhor saída é sempre seguir em frente. -Roberto Frost"
    },
    "2026-01-31": {
        "content": "Muitos dos fracassos da vida são pessoas que não perceberam o quão perto estavam do sucesso quando desistiram. -Thomas A. Edison"
    },
    "2026-02-01": {
        "content": " Somos feitos para persistir. É assim que descobrimos quem somos. -Tobias Wolff"
    },
    "2026-02-02": {
        "content": " Conhecendo as árvores, entendo o significado da paciência. Conhecendo a grama, posso apreciar a persistência. -Hal Borland"
    },
    "2026-02-03": {
        "content": " A água pingando escava a pedra, não pela força, mas pela persistência. -Ovídio"
    },
    "2026-02-04": {
        "content": " Persistência é muito importante. Você não deve desistir a menos que seja forçado a desistir. -Elon Musk"
    },
    "2026-02-05": {
        "content": " Entusiasmo ardente, apoiado por bom senso e persistência, é a qualidade que mais frequentemente leva ao sucesso. -Dale Carnegie"
    },
    "2026-02-06": {
        "content": " Ambição é o caminho para o sucesso. Persistência é o veículo em que você chega. -Bill Bradley"
    },
    "2026-02-07": {
        "content": " Concentre-se na solução, não no problema. -Walter Anderson"
    },
    "2026-02-08": {
        "content": " Quando a vida te derruba, você tem duas escolhas: ficar no chão ou se levantar. -Tom Krause"
    },
    "2026-02-09": {
        "content": " sucesso é a soma de pequenos esforços, repetidos dia após dia. -Robert Collier"
    },
    "2026-02-10": {
        "content": " Um sonho é apenas um sonho. Uma meta é um sonho com um plano e um prazo. -Harvey MacKay"
    },
    "2026-02-11": {
        "content": " Nunca desista de algo que você não consegue passar um dia sem pensar. -Winston Churchill"
    },
    "2026-02-12": {
        "content": " Diamantes nada mais são do que pedaços de carvão que permaneceram presos em suas funções. -Malcolm S. Forbes"
    },
    "2026-02-13": {
        "content": " Nada pode ser feito exceto aos poucos. -Charles Baudelaire"
    },
    "2026-02-14": {
        "content": " Se você estiver passando pelo inferno, continue. -Winston Churchill"
    },
    "2026-02-15": {
        "content": " A chave da persistência abre todas as portas fechadas pela resistência. -John Di Lemme"
    },
    "2026-02-16": {
        "content": " Se olharmos para aqueles que são mais bem-sucedidos no mundo, a persistência é o denominador comum. -Justin Sachs"
    },
    "2026-02-17": {
        "content": " Você pode comer um elefante aos poucos. -Mary Kay Ash"
    },
    "2026-02-18": {
        "content": " Não acho que exista outra qualidade tão essencial ao sucesso de qualquer tipo quanto a qualidade da perseverança. Ela supera quase tudo, até mesmo a natureza. -John D. Rockefeller"
    },
    "2026-02-19": {
        "content": "Se você quer transformar uma visão em realidade, você tem que dar 100% e nunca parar de acreditar no seu sonho. -Arnold Schwarzenegger"
    },
    "2026-02-20": {
        "content": " Corra quando puder, ande se for preciso, rasteje se for preciso; mas nunca desista. -Decano Karnazes"
    },
    "2026-02-21": {
        "content": " Dar mais uma volta quando você acha que não consegue – é isso que faz toda a diferença na sua vida. -Sylvester Stallone"
    },
    "2026-02-22": {
        "content": " Escute-me, mesmo quando você perde, é OK perder, mas você nunca pode ficar confortável com isso. Você nunca pode ficar satisfeito com a perda. Quando você perde, tem que doer. -Éric Thomas"
    },
    "2026-02-23": {
        "content": " Continue caminhando, um passo de cada vez. -Joyce Meyer"
    },
    "2026-02-24": {
        "content": " Não devemos desistir e não devemos permitir que o problema nos derrote. -Abdul Kalam"
    },
    "2026-02-25": {
        "content": " Pela perseverança nós conquistamos. -Ernest Shackleton"
    },
    "2026-02-26": {
        "content": "As paredes de tijolos estão lá por uma razão. As paredes de tijolos não estão lá para nos manter fora. As paredes de tijolos estão lá para nos dar uma chance de mostrar o quanto queremos algo. Porque as paredes de tijolos estão lá para parar as pessoas que não querem isso o suficiente. Elas estão lá para parar as outras pessoas. -Randy Pausch"
    },
    "2026-02-27": {
        "content": " O sucesso depende quase totalmente de motivação e persistência. A energia extra necessária para fazer outro esforço ou tentar outra abordagem é o segredo da vitória. -Denis Waitley"
    },
    "2026-02-28": {
        "content": " Eu cheguei até aqui e me recusei a desistir porque durante toda a minha vida sempre terminei a corrida. -Luís Zamperini"
    },
    "2026-03-01": {
        "content": " A sobrevivência pode ser resumida em três palavras – nunca desista. Esse é o cerne da questão, na verdade. Apenas continue tentando. -Urso Grylls"
    },
    "2026-03-02": {
        "content": "NÃO MAIS. Não mais desculpas. Não mais: \"Começo amanhã.\" Não mais: \"Só dessa vez.\" Não mais aceitar as deficiências da minha própria vontade. Não mais pegar o caminho mais fácil. Não mais me curvar a quaisquer pensamentos doentios ou improdutivos que flutuem pela minha mente. -Jocko Willink"
    },
    "2026-03-03": {
        "content": " Pequenos golpes derrubaram grandes carvalhos. -Benjamin Franklin"
    },
    "2026-03-04": {
        "content": " Estou disposto.” “Estou preparado para vencer.” “Eu consigo.” “Eu abraço a incerteza.” “Eu não sou meus pensamentos; eu sou o que eu faço.” “Eu sou implacável.” “Eu não espero nada e aceito tudo. -Gary John Bispo"
    },
    "2026-03-05": {
        "content": " Eu não falhei 700 vezes. Eu não falhei uma vez. Eu tive sucesso em provar que essas 700 maneiras não vão funcionar. Quando eu tiver eliminado as maneiras que não vão funcionar, eu vou encontrar a maneira que vai funcionar. -Thomas A. Edison"
    },
    "2026-03-06": {
        "content": " GRIT é Guts, Resilience, Industriousness e Tenacity. GRIT é a habilidade de focar, permanecer determinado, permanecer otimista diante de um desafio e simplesmente trabalhar mais duro do que o próximo cara ou garota. -Linda Kaplan Thaler"
    },
    "2026-03-07": {
        "content": "Acho que meu segredo é que não existem atalhos para trabalho duro, determinação e ter aquela atitude de \"não desistir\". -Jerry Arroz"
    },
    "2026-03-08": {
        "content": " Nunca pare de lutar até chegar ao seu lugar destinado – isto é, o seu eu único. Tenha um objetivo na vida, adquira conhecimento continuamente, trabalhe duro e tenha perseverança para realizar a grande vida. -Abdul Kalam"
    },
    "2026-03-09": {
        "content": " Não pare quando estiver cansado. Pare quando tiver terminado. -David Goggins"
    },
    "2026-03-10": {
        "content": " Não me julgue pelos meus sucessos, julgue-me por quantas vezes eu caí e me levantei novamente. -Nelson Mandela"
    },
    "2026-03-11": {
        "content": " O que não começa hoje nunca termina amanhã. -Johann Wolfgang von Goethe"
    },
    "2026-03-12": {
        "content": " Se você escreve cem contos e todos eles são ruins, isso não significa que você falhou. Você falha somente se parar de escrever. -Ray Bradbury"
    },
    "2026-03-13": {
        "content": " O mestre falhou mais vezes do que o iniciante tentou. -Stephen McCranie"
    },
    "2026-03-14": {
        "content": " Para o inferno com as circunstâncias; eu crio oportunidades. -Bruce Lee"
    },
    "2026-03-15": {
        "content": " única coisa pior do que começar algo e falhar é não começar. -Seth Godin"
    },
    "2026-03-16": {
        "content": " Nunca deixe para amanhã o que você pode fazer hoje. -Benjamin Franklin"
    },
    "2026-03-17": {
        "content": " Com perseverança o caracol chegou à arca. -Charles H. Spurgeon"
    },
    "2026-03-18": {
        "content": " Lembre-se, a esperança é uma coisa boa, talvez a melhor das coisas, e nenhuma coisa boa morre. -Stephen Rei"
    },
    "2026-03-19": {
        "content": " Empreendedores não terminam quando estamos cansados. Nós terminamos quando terminamos. -Robert T. Kiyosaki"
    },
    "2026-03-20": {
        "content": " Persistência e determinação por si só são onipotentes. -Calvin Coolidge"
    },
    "2026-03-21": {
        "content": " Paralise a resistência com persistência. -Woody Hayes"
    },
    "2026-03-22": {
        "content": " O sucesso nunca é possuído, ele é alugado, e o aluguel é devido todos os dias. -Rory Vaden"
    },
    "2026-03-23": {
        "content": " Sucesso não é acidente. É trabalho duro, perseverança, aprendizado, estudo, sacrifício e, acima de tudo, amor pelo que você está fazendo ou aprendendo a fazer. -Pelé"
    },
    "2026-03-24": {
        "content": " Não há como evitar o trabalho duro. Abrace-o. -Roger Federer"
    },
    "2026-03-25": {
        "content": " Um sonho não se torna realidade por mágica; é preciso suor, determinação e trabalho duro. -Colin Powell"
    },
    "2026-03-26": {
        "content": "Aprender nunca esgota a mente. -Leonardo da Vinci"
    },
    "2026-03-27": {
        "content": " Eu ouço e esqueço. Eu vejo e lembro. Eu faço e entendo. -Confúcio"
    },
    "2026-03-28": {
        "content": " Quem nunca cometeu um erro nunca tentou nada novo. -Alberto Einstein"
    },
    "2026-03-29": {
        "content": " Tente aprender algo sobre tudo e tudo sobre alguma coisa. -Thomas Henry Huxley"
    },
    "2026-03-30": {
        "content": " Um homem só aprende de duas maneiras: uma lendo e a outra pela associação com pessoas mais inteligentes. -Will Rogers"
    },
    "2026-03-31": {
        "content": " Você não entende nada até aprender mais de uma maneira. -Marvin Minsky"
    },
    "2026-04-01": {
        "content": " Diga-me e eu esqueço, ensine-me e eu posso lembrar, envolva-me e eu aprendo. -Benjamin Franklin"
    },
    "2026-04-02": {
        "content": " Se você quer aumentar sua taxa de sucesso, dobre sua taxa de fracasso. -Thomas J. Watson"
    },
    "2026-04-03": {
        "content": " Inteligência é o que você usa quando não sabe o que fazer. -Jean Piaget"
    },
    "2026-04-04": {
        "content": " Os analfabetos do século XXI não serão aqueles que não sabem ler e escrever, mas aqueles que não sabem aprender, desaprender e reaprender. -Alvin Toffler"
    },
    "2026-04-05": {
        "content": "É o que já sabemos que muitas vezes nos impede de aprender. - Cláudio Bernardo"
    },
    "2026-04-06": {
        "content": " A matemática é a linguagem com a qual Deus escreveu o universo. -Galileu Galilei"
    },
    "2026-04-07": {
        "content": " O propósito da educação é transformar espelhos em janelas. -Sydney J. Harris"
    },
    "2026-04-08": {
        "content": " Não tenho medo de tempestades porque estou aprendendo a navegar meu navio. -Louisa May Alcott"
    },
    "2026-04-09": {
        "content": " A única pessoa educada é aquela que aprendeu a aprender e a mudar. -Carl R. Rogers"
    },
    "2026-04-10": {
        "content": " Nunca conheci um homem tão ignorante que não pudesse aprender algo com ele. -Galileu Galilei"
    },
    "2026-04-11": {
        "content": " Nada desaparece até que nos ensine o que precisamos saber. -Pema Chodron"
    },
    "2026-04-12": {
        "content": " A prática leva à perfeição. Depois de muito tempo de prática, nosso trabalho se tornará natural, habilidoso, rápido e estável. -Bruce Lee"
    },
    "2026-04-13": {
        "content": " Quando você fala, você está apenas repetindo algo que já sabe. Mas, se você ouvir, você pode aprender algo novo. -Dalai Lama XIV"
    },
    "2026-04-14": {
        "content": " Busque o progresso, não a perfeição. -Anônimo"
    },
    "2026-04-15": {
        "content": "Estou sempre fazendo o que ainda não consigo fazer, para aprender como fazer. -Vicent van Gogh"
    },
    "2026-04-16": {
        "content": " O conhecimento torna o homem indigno de ser escravo. -Frederico Douglass"
    },
    "2026-04-17": {
        "content": " Aprendi muito cedo a diferença entre saber o nome de algo e conhecer algo. -Richard P. Feynman"
    },
    "2026-04-18": {
        "content": " A capacidade de aprender é um dom; A habilidade de aprender é uma habilidade; A vontade de aprender é uma escolha. -Brian Herbert"
    },
    "2026-04-19": {
        "content": " Aprenda tudo o que puder, sempre que puder, de qualquer pessoa que puder – sempre chegará um momento em que você será grato por ter feito isso. -Sarah Caldwell"
    },
    "2026-04-20": {
        "content": " Não tenho grande consideração por um homem que não é mais sábio hoje do que era ontem. -Abraão Lincoln"
    },
    "2026-04-21": {
        "content": " A chave para o sucesso é a dedicação ao aprendizado ao longo da vida. -Stephen R. Covey"
    },
    "2026-04-22": {
        "content": " Seja apaixonado e ousado. Continue sempre aprendendo. Você para de fazer coisas úteis se não aprender. -Satya Nadella"
    },
    "2026-04-23": {
        "content": " atividade mais elevada que um ser humano pode atingir é aprender para compreender, porque compreender é ser livre. -Baruch Spinoza"
    },
    "2026-04-24": {
        "content": " Se você não continuar aprendendo, outras pessoas passarão por você. Temperamento sozinho não vai resolver – você precisa de muita curiosidade por um longo, longo tempo. -Charlie Munger"
    },
    "2026-04-25": {
        "content": " Uma organização de aprendizagem é uma organização que está continuamente expandindo sua capacidade de criar seu futuro. -Peter Senge"
    },
    "2026-04-26": {
        "content": " O dia em que você para de aprender é o dia em que você começa a decair. -Isaac Asimov"
    },
    "2026-04-27": {
        "content": " O aprendizado é um ornamento na prosperidade, um refúgio na adversidade e uma provisão na velhice. -Aristóteles"
    },
    "2026-04-28": {
        "content": " Todos os líderes são aprendizes. No momento em que você para de aprender, você para de liderar. Eu aprendo o máximo que posso, de tantos quanto posso, sempre que posso. -Rick Warren"
    },
    "2026-04-29": {
        "content": " Para aprender coisas difíceis rapidamente, você deve se concentrar intensamente, sem distração. Aprender, em outras palavras, é um ato de trabalho profundo. -Cal Newport"
    },
    "2026-04-30": {
        "content": " Qualquer tolo pode saber. O ponto é entender. -Alberto Einstein"
    },
    "2026-05-01": {
        "content": "Passe cada dia tentando ser um pouco mais sábio do que você era quando acordou. -Charlie Munger"
    },
    "2026-05-02": {
        "content": " Invista em você mesmo, na sua educação. Não há nada melhor. -Sílvia Porter"
    },
    "2026-05-03": {
        "content": " A autoeducação é uma fonte contínua de prazer para mim, pois quanto mais sei, mais plena minha vida se torna e melhor aprecio minha própria existência. -Isaac Asimov"
    },
    "2026-05-04": {
        "content": " Você pode obter ajuda de professores, mas terá que aprender muito sozinho, sentado em uma sala. -Dr. Seuss"
    },
    "2026-05-05": {
        "content": " A aprendizagem acontece quando alguém quer aprender, não quando alguém quer ensinar. -Roger Schank"
    },
    "2026-05-06": {
        "content": " Uma pessoa não pode ensinar outra diretamente; uma pessoa pode apenas facilitar o aprendizado de outra. -Carl R. Rogers"
    },
    "2026-05-07": {
        "content": " Aprender não é obrigatório; é voluntário. Melhorar não é obrigatório; é voluntário. Mas para sobreviver, precisamos aprender. -W. Edwards Deming"
    },
    "2026-05-08": {
        "content": " Estou sempre fazendo aquilo que não consigo fazer, para poder aprender como fazê-lo. -Pablo Picasso"
    },
    "2026-05-09": {
        "content": "Nenhum ladrão, por mais habilidoso que seja, pode roubar o conhecimento de alguém, e é por isso que o conhecimento é o melhor e mais seguro tesouro a ser adquirido. -L. Frank Baum"
    },
    "2026-05-10": {
        "content": " Acho que esse é o melhor conselho: pense constantemente em como você poderia fazer as coisas melhor e questione-se. -Elon Musk"
    },
    "2026-05-11": {
        "content": " Um homem sábio pode aprender mais com uma pergunta tola do que um tolo pode aprender com uma resposta sábia. -Bruce Lee"
    },
    "2026-05-12": {
        "content": " Se eu vi mais longe foi por estar sobre os ombros de gigantes. -Isaac Newton"
    },
    "2026-05-13": {
        "content": " O que sabemos é uma gota, o que não sabemos é um oceano. -Isaac Newton"
    },
    "2026-05-14": {
        "content": " O melhor de aprender é que ninguém pode tirar isso de você. -Rei BB"
    },
    "2026-05-15": {
        "content": " Se você quer ser um escritor, você deve fazer duas coisas acima de tudo: ler muito e escrever muito. -Stephen Rei"
    },
    "2026-05-16": {
        "content": " A repetição é a mãe da habilidade. -Tony Robbins"
    },
    "2026-05-17": {
        "content": " A admiração é o começo da sabedoria. -Sócrates"
    },
    "2026-05-18": {
        "content": " Se você comete um erro e não o corrige, isso é chamado de erro. -Confúcio"
    },
    "2026-05-19": {
        "content": " O propósito da educação é substituir uma mente vazia por uma aberta. -Malcolm S. Forbes"
    },
    "2026-05-20": {
        "content": "Nada na vida é para ser temido, é apenas para ser compreendido. Agora é o momento de entender mais, para que possamos temer menos. -Maria Curie"
    },
    "2026-05-21": {
        "content": " Sempre que lhe perguntarem se você pode fazer um trabalho, diga a eles: \"Certamente eu posso!\". Então, ocupe-se e descubra como fazê-lo. -Teodoro Roosevelt"
    },
    "2026-05-22": {
        "content": " Todos nós precisamos de pessoas que nos deem feedback. É assim que melhoramos. -Bill Gates"
    },
    "2026-05-23": {
        "content": " A educação é a chave para abrir o mundo, um passaporte para a liberdade. -Oprah Winfrey"
    },
    "2026-05-24": {
        "content": " Tudo começa com uma ideia. -Conde Nightingale"
    },
    "2026-05-25": {
        "content": " O melhor investimento que você pode fazer é em você mesmo. -Warren Buffett"
    },
    "2026-05-26": {
        "content": " Não é sobre dinheiro ou conexões. É a disposição de trabalhar mais e aprender mais que todos. -Marcos Cubano"
    },
    "2026-05-27": {
        "content": " Enquanto você viver, continue aprendendo a viver. -Sêneca"
    },
    "2026-05-28": {
        "content": " Para aprender a ter sucesso, você deve primeiro aprender a falhar. -Michael Jordânia"
    },
    "2026-05-29": {
        "content": " Não desperdice um bom erro, aprenda com ele. -Robert T. Kiyosaki"
    },
    "2026-05-30": {
        "content": "Para adquirir conhecimento, é preciso estudar; mas para adquirir sabedoria, é preciso observar. -Marilyn Vos Savant"
    },
    "2026-05-31": {
        "content": " Você vive e aprende. De qualquer forma, você vive. -Douglas Adams"
    },
    "2026-06-01": {
        "content": " A paciência é companheira da sabedoria. -Santo Agostinho"
    },
    "2026-06-02": {
        "content": " Eu só sei de uma coisa: não sei nada. -Sócrates"
    },
    "2026-06-03": {
        "content": " A sabedoria vem da experiência. A experiência é frequentemente resultado da falta de sabedoria. -Terry Pratchett"
    },
    "2026-06-04": {
        "content": " Podemos julgar nosso progresso pela coragem de nossas perguntas e pela profundidade de nossas respostas, nossa disposição de abraçar o que é verdadeiro em vez do que parece bom. -Carl Sagan"
    },
    "2026-06-05": {
        "content": " Prefiro ter perguntas que não podem ser respondidas do que respostas que não podem ser questionadas. -Richard P. Feynman"
    },
    "2026-06-06": {
        "content": " Estou sempre pronto para aprender, embora nem sempre goste de ser ensinado. -Winston Churchill"
    },
    "2026-06-07": {
        "content": " Aquele que ama a prática sem a teoria é como o marinheiro que embarca sem leme e bússola e nunca sabe onde vai pescar. -Leonardo da Vinci"
    },
    "2026-06-08": {
        "content": " É melhor criar do que aprender. Criar é a essência da vida. -Júlio César"
    },
    "2026-06-09": {
        "content": " que a mão faz a mente lembra. -Maria Montessori"
    },
    "2026-06-10": {
        "content": " Sempre caminhe pela vida como se tivesse algo novo para aprender, e você aprenderá. -Vernon Howard"
    },
    "2026-06-11": {
        "content": " O fracasso é sucesso se aprendermos com ele. -Malcolm S. Forbes"
    },
    "2026-06-12": {
        "content": " Educação é a melhor amiga. Uma pessoa educada é respeitada em todos os lugares. Educação vence a beleza e a juventude. -Chanakya"
    },
    "2026-06-13": {
        "content": " Não pense que o que é difícil para você dominar é humanamente impossível; mas se algo é humanamente possível, considere-o ao seu alcance. -Marco Aurélio"
    },
    "2026-06-14": {
        "content": " Aprender é um processo constante de descoberta – um processo sem fim. -Bruce Lee"
    },
    "2026-06-15": {
        "content": " Ser ignorante não é uma vergonha, mas sim não querer aprender. -Benjamin Franklin"
    },
    "2026-06-16": {
        "content": " Estou convencido de que conhecimento é poder - para superar o passado, mudar nossas próprias situações, lutar contra novos obstáculos e tomar melhores decisões. -Ben Carson"
    },
    "2026-06-17": {
        "content": " Inspirando, acalmo o corpo e a mente. Expirando, sorrio. Morando no momento presente, sei que este é o único momento. -Thich Nhat Hanh"
    },
    "2026-06-18": {
        "content": "Se você acha que é pequeno demais para fazer a diferença, tente dormir com um mosquito. -Dalai Lama XIV"
    },
    "2026-06-19": {
        "content": " Muitas vezes subestimamos o poder de um toque, um sorriso, uma palavra gentil, um ouvido atento, um elogio honesto ou o menor ato de carinho, todos eles com o potencial de mudar uma vida. -Leo Buscaglia"
    },
    "2026-06-20": {
        "content": " A maneira como passamos nossos dias é, naturalmente, a maneira como passamos nossas vidas. -Annie Dillard"
    },
    "2026-06-21": {
        "content": " Alimente sua mente com grandes pensamentos, pois você nunca irá mais alto do que pensa. -Benjamin Disraeli"
    },
    "2026-06-22": {
        "content": " Você não aprende a andar seguindo regras. Você aprende fazendo e caindo. -Richard Branson"
    },
    "2026-06-23": {
        "content": " É impossível viver sem falhar em alguma coisa, a menos que você viva com tanta cautela que seria como se não tivesse vivido, caso em que você fracassaria por omissão. -J. K. Rowling"
    },
    "2026-06-24": {
        "content": " Se você quer ser feliz, seja. -Leão Tolstói"
    },
    "2026-06-25": {
        "content": " Ninguém pode me machucar sem minha permissão. -Mahatma Gandhi"
    },
    "2026-06-26": {
        "content": " Quando deixo de lado o que sou, me torno o que poderia ser. -Lao Tsé"
    },
    "2026-06-27": {
        "content": " razão pela qual lutamos contra a insegurança é porque comparamos nossos bastidores com os melhores momentos de todos os outros. -Steven Furtick"
    },
    "2026-06-28": {
        "content": " Lembre-se, hoje é o amanhã com o qual você se preocupou ontem. -Dale Carnegie"
    },
    "2026-06-29": {
        "content": " Devemos estar dispostos a abrir mão da vida que planejamos para podermos ter a vida que nos espera. -Joseph Campbell"
    },
    "2026-06-30": {
        "content": " Pare de sair e você chegará. Pare de procurar e você verá. Pare de fugir e você será encontrado. -Lao Tsé"
    },
    "2026-07-01": {
        "content": " Uma equipe não é um grupo de pessoas que trabalham juntas. Uma equipe é um grupo de pessoas que confiam umas nas outras. -Simão Sinek"
    },
    "2026-07-02": {
        "content": " O otimismo perpétuo é um multiplicador de força. -Colin Powell"
    },
    "2026-07-03": {
        "content": " Quando você se contenta em ser você mesmo e não se compara nem compete, todos o respeitarão. -Lao Tsé"
    },
    "2026-07-04": {
        "content": " Conte sua idade pelos amigos, não pelos anos. Conte sua vida pelos sorrisos, não pelas lágrimas. -John Lennon"
    },
    "2026-07-05": {
        "content": " Dê àqueles que você ama asas para voar, raízes para voltar e motivos para ficar. -Dalai Lama XIV"
    },
    "2026-07-06": {
        "content": " Perseverança e espírito fizeram maravilhas em todas as épocas. -George Washington"
    },
    "2026-07-07": {
        "content": "Compartilhe seu conhecimento. É uma maneira de atingir a imortalidade. -Dalai Lama XIV"
    },
    "2026-07-08": {
        "content": " Somos uma maneira do cosmos conhecer a si mesmo. -Carl Sagan"
    },
    "2026-07-09": {
        "content": " Um bom professor pode inspirar esperança, despertar a imaginação e incutir o amor pelo aprendizado. -Brad Henrique"
    },
    "2026-07-10": {
        "content": " Uma das maiores descobertas que uma pessoa faz, uma das suas grandes surpresas, é descobrir que ela pode fazer o que temia não conseguir fazer. -Henrique Ford"
    },
    "2026-07-11": {
        "content": " Quando foi a última vez que você fez algo pela primeira vez? -John C. Maxwell"
    },
    "2026-07-12": {
        "content": " Se você não está no processo de se tornar a pessoa que deseja ser, você está automaticamente se envolvendo em se tornar a pessoa que não deseja ser. -Dale Carnegie"
    },
    "2026-07-13": {
        "content": " A sorte favorece os corajosos. -Provérbio latino"
    },
    "2026-07-14": {
        "content": " Sucesso não é a chave para a felicidade. Felicidade é a chave para o sucesso. Se você ama o que está fazendo, você será bem-sucedido. -Albert Schweitzer"
    },
    "2026-07-15": {
        "content": " Não ganhe o mundo e perca sua alma; a sabedoria é melhor do que prata e ouro. -Bob Marley"
    },
    "2026-07-16": {
        "content": " Comece a viver imediatamente e conte cada dia como uma vida separada. -Sêneca"
    },
    "2026-07-17": {
        "content": " menos que alguém como você se importe muito, nada vai melhorar. Não vai. -Dr. Seuss"
    },
    "2026-07-18": {
        "content": " Eles não sabiam que era impossível, então fizeram. -Mark Twain"
    },
    "2026-07-19": {
        "content": " Eu posso fazer coisas que você não pode, você pode fazer coisas que eu não posso; juntos podemos fazer grandes coisas. -Madre Teresa"
    },
    "2026-07-20": {
        "content": " A única coisa que devemos temer é o próprio medo. -Franklin D. Roosevelt"
    },
    "2026-07-21": {
        "content": " Nada de grandioso foi alcançado sem entusiasmo. -Ralph Waldo Emerson"
    },
    "2026-07-22": {
        "content": " Coragem, meu querido coração. -CS Lewis"
    },
    "2026-07-23": {
        "content": " A única maneira de dar sentido à mudança é mergulhar nela, mover-se com ela e participar da dança. -Alan Watts"
    },
    "2026-07-24": {
        "content": " Onde há atenção, a energia flui e os resultados aparecem. -T.Harv Eker"
    },
    "2026-07-25": {
        "content": " A dor é temporária. Pode durar um minuto, ou uma hora, ou um dia, ou um ano, mas eventualmente ela vai diminuir e outra coisa tomará seu lugar. Se eu parar, no entanto, ela dura para sempre. -Lance Armstrong"
    },
    "2026-07-26": {
        "content": " Em cada caminhada com a natureza, recebemos muito mais do que buscamos. -John Muir"
    },
    "2026-07-27": {
        "content": "Os vencedores não são aqueles que nunca falham, mas aqueles que nunca desistem. -Edwin Louis Cole"
    },
    "2026-07-28": {
        "content": " Em vez de lutar contra a escuridão, você traz a luz. -Eckhart Tolle"
    },
    "2026-07-29": {
        "content": " Não tenha medo de perseguir aquilo que incendeia sua alma. -Jennifer Lee"
    },
    "2026-07-30": {
        "content": " Quando as pessoas se afastam de você, deixe-as ir. Seu destino nunca está vinculado a ninguém que o abandona, e isso não significa que sejam pessoas más. Significa apenas que a parte delas na sua história acabou. -TD Jakes"
    },
    "2026-07-31": {
        "content": " Liderança é a capacidade de traduzir visão em realidade. -Warren G. Bennis"
    },
    "2026-08-01": {
        "content": " Fé é acreditar no que você não vê; a recompensa dessa fé é ver o que você acredita. -Santo Agostinho"
    },
    "2026-08-02": {
        "content": " Nada é impossível a menos que você pense que é. -Paramahansa Yogananda"
    },
    "2026-08-03": {
        "content": " A única coisa pior do que ser cego é ter visão, mas não ter visão. -Helen Keller"
    },
    "2026-08-04": {
        "content": " Tudo tem sua beleza, mas nem todos a veem. -Confúcio"
    },
    "2026-08-05": {
        "content": " Deus fala no silêncio do coração. -Madre Teresa"
    },
    "2026-08-06": {
        "content": "Esperança é aquela coisa com penas que pousa na alma - e canta a melodia sem as palavras - e nunca para. -Emily Dickinson"
    },
    "2026-08-07": {
        "content": " Não importa quantas palavras sagradas você leia, não importa quantas você fale, de que lhe servirão se você não agir de acordo com elas? -Buda"
    },
    "2026-08-08": {
        "content": " E, a propósito, tudo na vida é escrevível se você tiver coragem extrovertida para fazê-lo e imaginação para improvisar. O pior inimigo da criatividade é a dúvida. -Sílvia Plath"
    },
    "2026-08-09": {
        "content": " Nada que fazemos pode mudar o passado, mas tudo que fazemos muda o futuro. -Ashleigh Brilhante"
    },
    "2026-08-10": {
        "content": " Liderança é uma escolha. Não é uma classificação. -Simão Sinek"
    },
    "2026-08-11": {
        "content": " Tudo ficará bem, e tudo ficará bem, e todo tipo de coisa ficará bem. -Juliano de Norwich"
    },
    "2026-08-12": {
        "content": " Cada um de nós é, na perspectiva cósmica, precioso. Se um humano discorda de você, deixe-o viver. Em cem bilhões de galáxias, você não encontrará outro. -Carl Sagan"
    },
    "2026-08-13": {
        "content": " Inteligência mais caráter – esse é o objetivo da verdadeira educação. -Martin Luther King Jr."
    },
    "2026-08-14": {
        "content": "Quanto mais você se perder em algo maior que você, mais energia terá. -Norman Vincent Peale"
    },
    "2026-08-15": {
        "content": " Aprenda os fundamentos e o nível de tudo o que você faz aumentará -Michael Jordânia"
    },
    "2026-08-16": {
        "content": " Você não pode viver a menos que viva plenamente agora. -Alan Watts"
    },
    "2026-08-17": {
        "content": " Lembre-se de que às vezes não conseguir o que você quer é um golpe de sorte maravilhoso. -Dalai Lama XIV"
    },
    "2026-08-18": {
        "content": " Faça o seu melhor e depois relaxe. Deixe as coisas acontecerem naturalmente, em vez de forçá-las. -Paramahansa Yogananda"
    },
    "2026-08-19": {
        "content": " Você é um ser espiritual infinito tendo uma experiência humana temporária. -Wayne W. Dyer"
    },
    "2026-08-20": {
        "content": " Você tem que sonhar antes que seus sonhos se tornem realidade. -Abdul Kalam"
    },
    "2026-08-21": {
        "content": " Acima de tudo, guarde o seu coração, pois tudo o que você faz flui dele. -Salomão"
    },
    "2026-08-22": {
        "content": " Posso me livrar de tudo enquanto escrevo; minhas tristezas desaparecem, minha coragem renasce. -Ana Frank"
    },
    "2026-08-23": {
        "content": " O objetivo não é ser perfeito até o fim. O objetivo é ser melhor hoje. -Simão Sinek"
    },
    "2026-08-24": {
        "content": " Vá confiantemente na direção dos seus sonhos. Viva a vida que você imaginou. -Henrique David Thoreau"
    },
    "2026-08-25": {
        "content": "Seja gentil sempre que possível. É sempre possível. -Dalai Lama XIV"
    },
    "2026-08-26": {
        "content": " Nosso principal propósito nesta vida é ajudar os outros. E se você não pode ajudá-los, pelo menos não os machuque. -Dalai Lama XIV"
    },
    "2026-08-27": {
        "content": " Você tem cérebro na cabeça. Você tem pés nos sapatos. Você pode se guiar em qualquer direção que escolher. Você está por conta própria. E você sabe o que sabe. E você é quem vai decidir para onde ir. -Dr. Seuss"
    },
    "2026-08-28": {
        "content": " Aquilo em que você se concentra se expande e, quando você se concentra nas coisas boas da sua vida, você cria mais delas. -Oprah Winfrey"
    },
    "2026-08-29": {
        "content": " Tudo o que preciso saber me é revelado. Tudo o que preciso vem a mim. Tudo está bem na minha vida. -Louise Feno"
    },
    "2026-08-30": {
        "content": " Estou totalmente seguro no Universo. Estou em paz em todos os lugares. Confio na vida. -Louise Feno"
    },
    "2026-08-31": {
        "content": " Vire o rosto para o sol e as sombras ficarão atrás de você. -Provérbio Maori"
    },
    "2026-09-01": {
        "content": " Coragem é não ter forças para continuar; é continuar quando você não tem forças. -Teodoro Roosevelt"
    },
    "2026-09-02": {
        "content": " O futuro depende do que você faz hoje. -Mahatma Gandhi"
    },
    "2026-09-03": {
        "content": " Um vencedor é um sonhador que nunca desiste. -Nelson Mandela"
    },
    "2026-09-04": {
        "content": "Não chore porque acabou, sorria porque aconteceu. -Dr. Seuss"
    },
    "2026-09-05": {
        "content": " Posso resumir em três palavras tudo o que aprendi sobre a vida: ela continua. -Roberto Frost"
    },
    "2026-09-06": {
        "content": " Viva a sua imaginação, não a sua história. -Stephen R. Covey"
    },
    "2026-09-07": {
        "content": " Do meu ponto de vista, se você quer o arco-íris, você tem que aguentar a chuva. -Dolly Parton"
    },
    "2026-09-08": {
        "content": " A grandeza de um homem não está na quantidade de riqueza que ele adquire, mas na sua integridade e na sua capacidade de afetar positivamente aqueles ao seu redor. -Bob Marley"
    },
    "2026-09-09": {
        "content": " A felicidade vem principalmente da nossa própria atitude, e não de fatores externos. -Dalai Lama XIV"
    },
    "2026-09-10": {
        "content": " Grandes atos são feitos de pequenos feitos. -Lao Tsé"
    },
    "2026-09-11": {
        "content": " Nunca é tarde demais para ser o que você poderia ter sido. -George Eliot"
    },
    "2026-09-12": {
        "content": " Adotar a atitude correta pode converter um estresse negativo em positivo. -Hans Selye"
    },
    "2026-09-13": {
        "content": " Ouse viver a vida que você sonhou para si mesmo. Vá em frente e faça seus sonhos se tornarem realidade. -Ralph Waldo Emerson"
    },
    "2026-09-14": {
        "content": " O tempo que você gosta de desperdiçar não é tempo perdido. -Bertrand Russel"
    },
    "2026-09-15": {
        "content": "Basta um pouco de atenção para ver e descobrir: a vida é realmente um grande riso cósmico. -Osho"
    },
    "2026-09-16": {
        "content": " O curioso paradoxo é que quando me aceito como sou, então posso mudar. -Carl R. Rogers"
    },
    "2026-09-17": {
        "content": " Seja parte da solução, não parte do problema. -Stephen R. Covey"
    },
    "2026-09-18": {
        "content": " O segredo da vida é doar. -Tony Robbins"
    },
    "2026-09-19": {
        "content": " Faça de cada dia sua obra-prima. -John de madeira"
    },
    "2026-09-20": {
        "content": " Nunca desista do que você realmente quer fazer -H. Jackson Brown Jr."
    },
    "2026-09-21": {
        "content": " Não olhe para trás – você não vai por esse caminho. -Maria Engelbreit"
    },
    "2026-09-22": {
        "content": " Faça o seu melhor e Deus fará o resto. -Nick Vujicic"
    },
    "2026-09-23": {
        "content": " Viva, viaje, aventure-se, abençoe e não se desculpe. -Jack Kerouac"
    },
    "2026-09-24": {
        "content": " No meio do inverno, descobri que havia, dentro de mim, um verão invencível. E isso me faz feliz. Pois ele diz que não importa o quanto o mundo me empurre, dentro de mim, há algo mais forte – algo melhor, empurrando de volta. -Alberto Camus"
    },
    "2026-09-25": {
        "content": "Alguns acreditam que é apenas um grande poder que pode manter o mal sob controle, mas não foi isso que eu descobri. São as pequenas ações cotidianas de pessoas comuns que mantêm a escuridão sob controle. Pequenos atos de gentileza e amor. -J. R. R. Tolkien"
    },
    "2026-09-26": {
        "content": " Seja fiel nas pequenas coisas porque é nelas que reside a sua força. -Madre Teresa"
    },
    "2026-09-27": {
        "content": " Faça de você uma luz. -Buda"
    },
    "2026-09-28": {
        "content": " VISUALIZE!!! Veja, sinta! É aqui que a ação começa. -Rhonda Byrne"
    },
    "2026-09-29": {
        "content": " Seja fenomenal ou seja esquecido! -Éric Thomas"
    },
    "2026-09-30": {
        "content": " Quando você tiver que escolher entre estar certo ou ser gentil, escolha ser gentil. -Wayne W. Dyer"
    },
    "2026-10-01": {
        "content": " Os seres humanos podem alterar suas vidas alterando suas atitudes mentais. -William James"
    },
    "2026-10-02": {
        "content": " A saúde é o maior bem. -Lao Tsé"
    },
    "2026-10-03": {
        "content": " Que eu não reze para ser protegido dos perigos, mas para ser destemido ao enfrentá-los. Que eu não implore pelo acalmamento da minha dor, mas pelo coração para conquistá-la. -Rabindranath Tagore"
    },
    "2026-10-04": {
        "content": " Coloque seu coração em fazer o bem. Faça isso repetidamente, e você será preenchido com alegria. -Buda"
    },
    "2026-10-05": {
        "content": "Eu sozinho não posso mudar o mundo, mas posso lançar uma pedra sobre as águas e criar muitas ondulações. -Madre Teresa"
    },
    "2026-10-06": {
        "content": " E chegou o dia em que o risco de permanecer preso num botão era mais doloroso do que o risco de florescer. -Anaïs Nin"
    },
    "2026-10-07": {
        "content": " Não deve haver limites para o esforço humano. Por pior que a vida pareça, sempre há esperança. -Stephen Hawking"
    },
    "2026-10-08": {
        "content": " E eu peço que você perceba quando estiver feliz e exclame, murmure ou pense em algum momento: \"Se isso não é legal, então não sei o que é\". -Kurt Vonnegut"
    },
    "2026-10-09": {
        "content": " É a sua reação à adversidade, não a adversidade em si, que determina como a história da sua vida se desenvolverá. -Dieter F. Uchtdorf"
    },
    "2026-10-10": {
        "content": " Não é o que você tem ou quem você é ou onde você está ou o que você está fazendo que o faz feliz ou infeliz. É o que você pensa sobre isso. -Dale Carnegie"
    },
    "2026-10-11": {
        "content": " Quanto mais você ler, mais coisas você saberá. Quanto mais você aprender, mais lugares você irá. -Dr. Seuss"
    },
    "2026-10-12": {
        "content": " Todos os nossos sonhos podem se tornar realidade. -Walt Disney"
    },
    "2026-10-13": {
        "content": " privilégio de uma vida é ser quem você é. -Joseph Campbell"
    },
    "2026-10-14": {
        "content": " Ninguém é inútil neste mundo se alivia o fardo dos outros. -Charles Dickens"
    },
    "2026-10-15": {
        "content": " Encontre um lugar dentro de você onde haja alegria, e a alegria queimará a dor. -Joseph Campbell"
    },
    "2026-10-16": {
        "content": " Não pergunte o que o mundo precisa. Pergunte o que faz você se sentir vivo e vá fazer. Porque o que o mundo precisa é de mais pessoas que se sentiram vivas. -Howard Thurman"
    },
    "2026-10-17": {
        "content": " Seus sentimentos são suas maiores ferramentas para ajudar você a criar sua vida. -Rhonda Byrne"
    },
    "2026-10-18": {
        "content": " Eu mereço o melhor e aceito o melhor agora. -Louise Feno"
    },
    "2026-10-19": {
        "content": " Não é o quanto damos, mas quanto amor colocamos em dar. -Madre Teresa"
    },
    "2026-10-20": {
        "content": " Quando você quer ter sucesso tanto quanto quer respirar, então você terá sucesso. -Éric Thomas"
    },
    "2026-10-21": {
        "content": " Eu odiava cada minuto de treinamento, mas eu disse: \"Não desista. Sofra agora e viva o resto da sua vida como um campeão.\" -Muhammad Ali"
    },
    "2026-10-22": {
        "content": "Não é o crítico que conta, nem aquele que aponta como o homem forte tropeçou ou como o autor de feitos poderia tê-los feito melhor. O crédito pertence ao homem que está realmente na arena, cujo rosto está manchado de suor, poeira e sangue; que se esforça bravamente; que erra e fica aquém de novo e de novo; que conhece os grandes entusiasmos, as grandes devoções e se dedica a uma causa digna; que, se vencer, conhece o triunfo de grandes realizações; e que, se falhar, pelo menos falha ousando muito, para que seu lugar nunca seja com aquelas almas frias e tímidas que não conhecem nem vitória nem derrota. -Teodoro Roosevelt"
    },
    "2026-10-23": {
        "content": " A maior aventura que você pode viver é viver a vida dos seus sonhos. -Oprah Winfrey"
    },
    "2026-10-24": {
        "content": " Sem luta não pode haver progresso. -Frederico Douglass"
    },
    "2026-10-25": {
        "content": " Um sonho escrito com uma data se torna uma meta. Uma meta dividida em etapas se torna um plano. Um plano apoiado por ação faz seus sonhos se tornarem realidade. -Greg Reid"
    },
    "2026-10-26": {
        "content": "Faça a única coisa que você acha que não pode fazer. Fracasse. Tente novamente. Faça melhor na segunda vez. As únicas pessoas que nunca caem são aquelas que nunca sobem no arame alto. -Oprah Winfrey"
    },
    "2026-10-27": {
        "content": " Espere mudanças. Analise o cenário. Aproveite as oportunidades. Pare de ser a peça de xadrez; torne-se o jogador. A jogada é sua. -Tony Robbins"
    },
    "2026-10-28": {
        "content": " Você é livre. Você é poderoso. Você é bom. Você é amor. Você tem valor. Você tem propósito. Tudo está bem. -Esther Hicks"
    },
    "2026-10-29": {
        "content": "Se você quer algo tanto a ponto de sair e lutar por ele, trabalhar dia e noite por ele, abrir mão do seu tempo, da sua paz e do seu sono por ele; se tudo o que você sonha e planeja é sobre ele e a vida parece inútil e sem valor sem ele; se você suar de alegria, se preocupar e planejar por ele e perder todo o seu terror da oposição por ele; se você simplesmente for atrás do que você quer com toda a sua capacidade, força e sagacidade, fé, esperança e confiança e firme em sua tenacidade; se nem o frio ou a pobreza, a fome ou a gota, a doença ou a dor do corpo e do cérebro puderem mantê-lo longe do que você quer; se você for obstinado e sombrio e o gerar, com a ajuda de DEUS você o obterá. -Berton Braley"
    },
    "2026-10-30": {
        "content": " Mesmo que você esteja no caminho certo, você será atropelado se ficar parado. -Will Rogers"
    },
    "2026-10-31": {
        "content": " Acredito que é possível que pessoas comuns escolham ser extraordinárias. -Elon Musk"
    },
    "2026-11-01": {
        "content": " Você não aprende a andar seguindo regras. Você aprende fazendo e caindo. -Richard Branson"
    },
    "2026-11-02": {
        "content": "Não há talento aqui, isso é trabalho duro. Isso é uma obsessão. Talento não existe, somos todos iguais como seres humanos. Você pode ser qualquer um se investir tempo. Você chegará ao topo, e é isso. Eu não sou talentoso, sou obcecado. -Conor McGregor"
    },
    "2026-11-03": {
        "content": " Um sonho não é o que você vê enquanto dorme; é algo que não deixa você dormir. -Abdul Kalam"
    },
    "2026-11-04": {
        "content": " Quando você tiver esgotado todas as possibilidades, lembre-se disto: você não esgotou. -Thomas A. Edison"
    },
    "2026-11-05": {
        "content": " Arrisque-se, cometa erros. É assim que você cresce. A dor nutre sua coragem. Você tem que falhar para praticar ser corajoso. -Mary Tyler Moore"
    },
    "2026-11-06": {
        "content": " Você obtém aquilo em que se concentra. -Tony Robbins"
    },
    "2026-11-07": {
        "content": " Agitação é a palavra mais importante de SEMPRE. -Gary Vaynerchuk"
    },
    "2026-11-08": {
        "content": " Se eles conseguem fazer penicilina com pão mofado, então certamente podem fazer algo com você. -Muhammad Ali"
    },
    "2026-11-09": {
        "content": " Você não nasceu um vencedor, e você não nasceu um perdedor. Você é o que você faz de si mesmo ser. -Lou Holtz"
    },
    "2026-11-10": {
        "content": " O sucesso é seu dever, obrigação e responsabilidade. -Grant Cardone"
    },
    "2026-11-11": {
        "content": "Há pouca diferença nas pessoas, mas essa pequena diferença faz uma grande diferença. A pequena diferença é a atitude. A grande diferença é se ela é positiva ou negativa. -W. Clemente Pedra"
    },
    "2026-11-12": {
        "content": " Os líderes devem estar próximos o suficiente para se relacionar com os outros, mas distantes o suficiente para motivá-los. -John C. Maxwell"
    },
    "2026-11-13": {
        "content": " Nunca diga nunca, porque os limites, assim como os medos, muitas vezes são apenas uma ilusão. -Michael Jordânia"
    },
    "2026-11-14": {
        "content": " Você deve esperar grandes coisas de si mesmo antes de poder fazê-las. -Michael Jordânia"
    },
    "2026-11-15": {
        "content": " No mundo dos negócios, as pessoas mais bem-sucedidas são aquelas que fazem o que amam. -Warren Buffett"
    },
    "2026-11-16": {
        "content": " A ação destruirá sua procrastinação. -Og Mandino"
    },
    "2026-11-17": {
        "content": " O fracasso não é uma opção para mim. O sucesso é tudo que eu imagino. -Conor McGregor"
    },
    "2026-11-18": {
        "content": " O sucesso não vem do que você faz ocasionalmente, mas sim do que você faz consistentemente. -Maria Forleo"
    },
    "2026-11-19": {
        "content": " Confiança e trabalho duro são os melhores remédios para matar a doença chamada fracasso. Eles farão de você uma pessoa bem-sucedida. -Abdul Kalam"
    },
    "2026-11-20": {
        "content": " Se você quer brilhar como o sol, primeiro queime como o sol. -Abdul Kalam"
    },
    "2026-11-21": {
        "content": "Enquanto você está lá fora festejando, brincando, alguém lá fora ao mesmo tempo está trabalhando duro. Alguém está ficando mais esperto e alguém está vencendo. Apenas lembre-se disso. -Arnold Schwarzenegger"
    },
    "2026-11-22": {
        "content": " Se você fizer o que sempre fez, obterá o que sempre obteve. -Tony Robbins"
    },
    "2026-11-23": {
        "content": " Progresso é igual a felicidade. -Tony Robbins"
    },
    "2026-11-24": {
        "content": " Você pode ter resultados ou desculpas. Não ambos. -Arnold Schwarzenegger"
    },
    "2026-11-25": {
        "content": " Disciplina é igual a liberdade. -Jocko Willink"
    },
    "2026-11-26": {
        "content": " Não se detenha no que deu errado. Em vez disso, concentre-se no que fazer em seguida. Gaste suas energias em seguir em frente, em direção à busca da resposta. -Denis Waitley"
    },
    "2026-11-27": {
        "content": " Seja o líder que você gostaria de ter. -Simão Sinek"
    },
    "2026-11-28": {
        "content": " Minha atitude é que se você me empurrar para algo que você acha que é uma fraqueza, então eu transformarei essa fraqueza percebida em uma força. -Michael Jordânia"
    },
    "2026-11-29": {
        "content": " O maior perigo para a maioria de nós não está em estabelecer metas muito altas e não atingi-las; mas em estabelecer metas muito baixas e atingir nossos objetivos. -Michelangelo"
    },
    "2026-11-30": {
        "content": " Todo mundo tem um sonho, mas nem todo mundo tem uma rotina. -Éric Thomas"
    },
    "2026-12-01": {
        "content": "Líderes são feitos, eles não nascem. Eles são feitos por esforço duro, que é o preço que todos nós devemos pagar para atingir qualquer objetivo que valha a pena. -Vince Lombardi"
    },
    "2026-12-02": {
        "content": " Escolhemos ir à lua nesta década e fazer as outras coisas. Não porque elas são fáceis, mas porque elas são difíceis. -John F. Kennedy"
    },
    "2026-12-03": {
        "content": " O melhor dia da sua vida e da minha é quando assumimos total responsabilidade por nossas atitudes. Esse é o dia em que realmente crescemos. -John C. Maxwell"
    },
    "2026-12-04": {
        "content": " Cada vez que você sorri para alguém, é uma ação de amor, um presente para aquela pessoa, algo lindo. -Madre Teresa"
    },
    "2026-12-05": {
        "content": " Seja o observador silencioso de seus pensamentos e comportamento. Você está abaixo do pensador. Você é a quietude abaixo do ruído mental. Você é o amor e a alegria abaixo da dor. -Eckhart Tolle"
    },
    "2026-12-06": {
        "content": " Se você não pode voar, então corra; se você não pode correr, então ande; se você não pode andar, então rasteje; mas não importa o que você faça, você tem que continuar seguindo em frente. -Martin Luther King Jr."
    },
    "2026-12-07": {
        "content": " O perdão não é um ato ocasional, é uma atitude constante. -Martin Luther King Jr."
    },
    "2026-12-08": {
        "content": " Muitas vezes subestimamos o poder de um toque, um sorriso, uma palavra gentil, um ouvido atento, um elogio honesto ou o menor ato de carinho, todos eles com o potencial de mudar uma vida. -Leo Buscaglia"
    },
    "2026-12-09": {
        "content": "Mantenha seus sonhos vivos. Entenda que para alcançar qualquer coisa é preciso fé e crença em si mesmo, visão, trabalho duro, determinação e dedicação. Lembre-se de que todas as coisas são possíveis para aqueles que acreditam. -Gail Devers"
    },
    "2026-12-10": {
        "content": " O esporte tem o poder de mudar o mundo. Ele tem o poder de inspirar. Ele tem o poder de unir as pessoas de uma forma que poucas outras coisas fazem. Ele fala aos jovens em uma linguagem que eles entendem. O esporte pode criar esperança onde antes só havia desespero. -Nelson Mandela"
    },
    "2026-12-11": {
        "content": " Peça o que você quer. Acredite que você merece, e então permita que a Vida lhe dê. -Louise Feno"
    },
    "2026-12-12": {
        "content": " Viva com intenção. Caminhe até o limite. Ouça com atenção. Pratique o bem-estar. Brinque com abandono. Ria. Escolha sem arrependimento. Aprecie seus amigos. Continue aprendendo. Faça o que você ama. Viva como se isso fosse tudo o que existe. -Mary Anne Radmacher"
    },
    "2026-12-13": {
        "content": " Aquilo em que você se concentra se expande e, quando você se concentra nas coisas boas da sua vida, você cria mais delas. -Oprah Winfrey"
    },
    "2026-12-14": {
        "content": " Você tem poder sobre sua mente, não sobre eventos externos. Perceba isso, e você encontrará força. -Marco Aurélio"
    },
    "2026-12-15": {
        "content": "Não dê desculpas para o porquê de você não conseguir fazer. Concentre-se em todas as razões pelas quais você deve fazer acontecer. -Ralph Marston"
    },
    "2026-12-16": {
        "content": " Onde há amor há vida. -Mahatma Gandhi"
    },
    "2026-12-17": {
        "content": " Você tem que dançar como se ninguém estivesse olhando, amar como se nunca fosse se machucar, cantar como se ninguém estivesse ouvindo e viver como se o paraíso estivesse na Terra. -William W. Purkey"
    },
    "2026-12-18": {
        "content": " Sucesso é conhecer seu propósito na vida, crescer para atingir seu potencial máximo e plantar sementes que beneficiem os outros. -John C. Maxwell"
    },
    "2026-12-19": {
        "content": " Um sonho que você sonha sozinho é apenas um sonho. Um sonho que você sonha junto é realidade. -John Lennon"
    },
    "2026-12-20": {
        "content": " Este é o verdadeiro segredo da vida: estar completamente engajado com o que você está fazendo aqui e agora. E em vez de chamar isso de trabalho, perceba que é diversão. -Alan Watts"
    },
    "2026-12-21": {
        "content": " Ontem se foi. Amanhã ainda não chegou. Temos apenas hoje. Vamos começar. -Madre Teresa"
    },
    "2026-12-22": {
        "content": " Quanto mais você elogia e celebra sua vida, mais há na vida para celebrar. -Oprah Winfrey"
    },
    "2026-12-23": {
        "content": "Nunca duvide que um pequeno grupo de cidadãos pensativos e comprometidos pode mudar o mundo. De fato, é a única coisa que já fez isso. -Margaret Mead"
    },
    "2026-12-24": {
        "content": " Esforce-se, porque ninguém mais fará isso por você. -Anônimo"
    },
    "2026-12-25": {
        "content": " A verdadeira humildade não é pensar menos de si mesmo; é pensar menos em si mesmo. -CS Lewis"
    },
    "2026-12-26": {
        "content": " Se você pode mudar sua mente, você pode mudar sua vida. -William James"
    },
    "2026-12-27": {
        "content": " Concentre-se em onde você quer chegar, não no que você teme. -Tony Robbins"
    },
    "2026-12-28": {
        "content": " Respeite a si mesmo e os outros respeitarão você. -Confúcio"
    },
    "2026-12-29": {
        "content": " Faça o que puder, com o que tiver, onde estiver. -Teodoro Roosevelt"
    },
    "2026-12-30": {
        "content": " Algumas mudanças parecem negativas à primeira vista, mas você logo perceberá que está sendo criado espaço em sua vida para que algo novo surja. -Eckhart Tolle"
    },
    "2026-12-31": {
        "content": " Se suas ações inspiram outros a sonhar mais, aprender mais, fazer mais e se tornar mais, você é um líder. -John Quincy Adams"
    }
}

export const dateTurkishList = {
    "2024-01-01": {
        "content": " Biz, tekrar tekrar yaptığımız şeyiz. Bu nedenle mükemmellik bir eylem değil, bir alışkanlıktır. -Aristo"
    },
    "2024-01-02": {
        "content": " Bir nehrin kayayı delmesi gücünden değil, ısrarcılığından kaynaklanır. -Jim Watkins"
    },
    "2024-01-03": {
        "content": " Enerji ve azim her şeyi yener. -Benjamin Franklin"
    },
    "2024-01-04": {
        "content": " Fırsatlar genellikle sıkı çalışma kisvesi altında gelir, bu yüzden çoğu insan onları fark etmez. -Ann Landers"
    },
    "2024-01-05": {
        "content": " Uçamıyorsan koş, koşamıyorsan yürü, yürüyemiyorsan sürün, ama ne yaparsan yap ilerlemeye devam etmelisin. -Martin Luther King Jr."
    },
    "2024-01-06": {
        "content": " Azim, sonuçların kaçınılmaz olduğunun garantisidir. -Paramahansa Yogananda"
    },
    "2024-01-07": {
        "content": " Sıradan bir yetenek ve olağanüstü bir azimle her şey başarılabilir -Thomas Fowell Buxton"
    },
    "2024-01-08": {
        "content": " En büyük zaferimiz hiçbir zaman başarısız olmamak değil, her başarısız olduğumuzda ayağa kalkabilmektir. -Ralph Waldo Emerson"
    },
    "2024-01-09": {
        "content": " Başarı, coşkuyu kaybetmeden başarısızlıktan başarısızlığa koşmaktır. -Winston Churchill"
    },
    "2024-01-10": {
        "content": "Neyse ki, azim yeteneğin harika bir alternatifidir. -Steve Martin"
    },
    "2024-01-11": {
        "content": " Şansa daha çok inanıyorum ve ne kadar çok çalışırsam şansımın o kadar arttığını görüyorum -Thomas Jefferson"
    },
    "2024-01-12": {
        "content": " Yarına ertelediğin tek şey, ölmeyi göze aldığın ve yarım bıraktığın şeylerdir. -Pablo Picasso"
    },
    "2024-01-13": {
        "content": " Başarının sırları yoktur: bunları aramakla zaman kaybetmeyin. Başarı, mükemmeliyetin, sıkı çalışmanın, başarısızlıktan ders çıkarmanın, çalıştığınız kişilere sadakatin ve ısrarcılığın sonucudur. -Colin Powell"
    },
    "2024-01-14": {
        "content": " Önde olmak istiyorsan, arkadaymış gibi davran. -Lao Tzu"
    },
    "2024-01-15": {
        "content": " Hedefime ulaşmamı sağlayan sırrımı söyleyeyim: Benim gücüm sadece azmimdedir. -Louis Pasteur"
    },
    "2024-01-16": {
        "content": " Bu dünyada hiçbir şey azmin yerini tutamaz. Yetenek tutamaz; yetenekli ama başarısız insanlardan daha yaygın bir şey yoktur. Deha tutamaz; ödüllendirilmeyen deha neredeyse bir atasözüdür. -Calvin Coolidge"
    },
    "2024-01-17": {
        "content": " En iyi çıkış yolu her zaman içinden geçmektir. -Robert Frost"
    },
    "2024-01-18": {
        "content": "Hayattaki birçok başarısızlığın sebebi, pes ettiklerinde başarıya ne kadar yakın olduklarını fark edemeyen insanlardır. -Thomas A. Edison"
    },
    "2024-01-19": {
        "content": " Biz ısrarcı olmak için yaratıldık. Bu şekilde kim olduğumuzu öğreniriz. -Tobias Wolff"
    },
    "2024-01-20": {
        "content": " Ağaçları tanıdığımda sabrın anlamını anlıyorum. Çimleri tanıdığımda ise azmin değerini anlayabiliyorum. -Hal Borland"
    },
    "2024-01-21": {
        "content": " Damlayan su, taşı kuvvetle değil ısrarla oyar. -Ovid"
    },
    "2024-01-22": {
        "content": " Azim çok önemlidir. Vazgeçmeye zorlanmadığınız sürece vazgeçmemelisiniz. -Elon Musk"
    },
    "2024-01-23": {
        "content": " At sağduyusu ve azimle desteklenen ateşli coşku, çoğu zaman başarıyı getiren özelliktir. -Dale Carnegie"
    },
    "2024-01-24": {
        "content": " Hırs başarıya giden yoldur. Azim ise ulaştığınız araçtır. -Bill Bradley"
    },
    "2024-01-25": {
        "content": " Soruna değil, çözüme odaklanın. -Walter Anderson"
    },
    "2024-01-26": {
        "content": " Hayat seni yere serdiğinde iki seçeneğin vardır; ya yerde kalırsın ya da ayağa kalkarsın. -Tom Krause"
    },
    "2024-01-27": {
        "content": "Başarı, her gün tekrarlanan küçük çabaların toplamıdır. -Robert Collier"
    },
    "2024-01-28": {
        "content": " Bir rüya sadece bir rüyadır. Bir hedef, bir planı ve bir son tarihi olan bir rüyadır. -Harvey MacKay"
    },
    "2024-01-29": {
        "content": " Hiçbir zaman düşünmeden bir gün geçiremeyeceğiniz bir şeyden vazgeçmeyin. -Winston Churchill"
    },
    "2024-01-30": {
        "content": " Elmaslar, görevlerini yerine getiren kömür parçalarından başka bir şey değildir. -Malcolm S. Forbes"
    },
    "2024-01-31": {
        "content": " Azar azar bir şeyler yapmaktan başka bir şey yapılamaz. -Charles Baudelaire"
    },
    "2024-02-01": {
        "content": " Cehennemden geçiyorsan, devam et. -Winston Churchill"
    },
    "2024-02-02": {
        "content": " Azmin anahtarı, dirençle kapalı olan bütün kapıları açar. -John Di Lemme"
    },
    "2024-02-03": {
        "content": " Dünyanın en başarılı insanlarına baktığımızda hepsinin ortak paydasının azim olduğunu görürüz. -Justin Sachs"
    },
    "2024-02-04": {
        "content": " Bir fili parça parça yiyebilirsiniz. -Mary Kay Külü"
    },
    "2024-02-05": {
        "content": " Herhangi bir tür başarı için azim niteliği kadar önemli başka bir nitelik olduğunu düşünmüyorum. Neredeyse her şeyin üstesinden gelir, hatta doğanın bile. -John D. Rockefeller"
    },
    "2024-02-06": {
        "content": "Bir vizyonu gerçeğe dönüştürmek istiyorsanız %100'ünüzü vermeli ve hayalinize inanmayı asla bırakmamalısınız. -Arnold Schwarzenegger"
    },
    "2024-02-07": {
        "content": " Koşabildiğinizde koşun, yürümeniz gerektiğinde yürüyün, sürünmeniz gerektiğinde sürün; ama asla pes etmeyin. -Dekan Karnazes"
    },
    "2024-02-08": {
        "content": " Yapamayacağınızı düşündüğünüzde bir tur daha atmak, hayatınızda fark yaratan şeydir. -Sylvester Stallone"
    },
    "2024-02-09": {
        "content": " Beni dinle, kaybettiğinde bile kaybetmek sorun değil, ama bununla asla rahat edemezsin. Kaybetmekten asla memnun olamazsın. Kaybettiğinde, acı çekmen gerekir. -Eric Thomas"
    },
    "2024-02-10": {
        "content": " Adım adım yürümeye devam edin. -Joyce Meyer"
    },
    "2024-02-11": {
        "content": " Pes etmemeli ve sorunun bizi yenmesine izin vermemeliyiz. -Abdul Kelam"
    },
    "2024-02-12": {
        "content": " Sabrederek fethederiz. -Ernest Shackleton"
    },
    "2024-02-13": {
        "content": "Tuğla duvarlar bir sebepten dolayı oradadır. Tuğla duvarlar bizi dışarıda tutmak için orada değildir. Tuğla duvarlar bize bir şeyi ne kadar çok istediğimizi gösterme şansı vermek için oradadır. Çünkü tuğla duvarlar onu yeterince kötü istemeyen insanları durdurmak için oradadır. Diğer insanları durdurmak için oradadırlar. -Randy Pausch"
    },
    "2024-02-14": {
        "content": " Başarı neredeyse tamamen azim ve sebatkarlığa bağlıdır. Başka bir çaba göstermek veya başka bir yaklaşımı denemek için gereken ekstra enerji, kazanmanın sırrıdır. -Denis Waitley"
    },
    "2024-02-15": {
        "content": " Buraya kadar gelmiştim ve pes etmeyi reddettim çünkü hayatım boyunca hep yarışı bitirmiştim. -Louis Zamperini"
    },
    "2024-02-16": {
        "content": " Hayatta kalma üç kelimeyle özetlenebilir - asla pes etme. Aslında meselenin özü bu. Sadece denemeye devam et. -Ayı Grylls"
    },
    "2024-02-17": {
        "content": "ARTIK YOK. Artık bahane yok. Artık: \"Yarın başlayacağım.\" Artık: \"Sadece bu seferlik.\" Artık kendi irademin eksikliklerini kabul etmiyorum. Artık kolay yolu seçmiyorum. Artık zihnimden geçen sağlıksız veya verimsiz düşüncelere boyun eğmiyorum. -Jocko Willink"
    },
    "2024-02-18": {
        "content": " Küçük darbelerle büyük meşeler devrilir. -Benjamin Franklin"
    },
    "2024-02-19": {
        "content": " İstekliyim.” “Kazanmak için programlandım.” “Bunu başarabilirim.” “Belirsizliği kucaklıyorum.” “Ben düşüncelerim değilim; ben yaptıklarımım.” “Ben amansızım.” “Hiçbir şey beklemiyorum ve her şeyi kabul ediyorum. -Gary John Bishop"
    },
    "2024-02-20": {
        "content": " 700 kez başarısız olmadım. Bir kez bile başarısız olmadım. O 700 yolun işe yaramayacağını kanıtlamayı başardım. İşe yaramayacak yolları elediğimde, işe yarayacak yolu bulacağım. -Thomas A. Edison"
    },
    "2024-02-21": {
        "content": " GRIT, Cesaret, Dayanıklılık, Çalışkanlık ve Azimdir. GRIT, odaklanma, kararlı kalma, bir zorlukla karşı karşıya kalındığında iyimser kalma ve diğer erkeklerden veya kadınlardan daha çok çalışma yeteneğidir. -Linda Kaplan Thaler"
    },
    "2024-02-22": {
        "content": "Sanırım sırrım, sıkı çalışmanın, kararlılığın ve 'vazgeçmeme' tavrının kısayollarının olmaması. -Jerry Rice"
    },
    "2024-02-23": {
        "content": " Kaderinizdeki yere varana kadar, yani eşsiz siz olana kadar mücadeleyi asla bırakmayın. Hayatta bir amacınız olsun, sürekli bilgi edinin, sıkı çalışın ve harika hayatı gerçekleştirmek için azimli olun. -Abdul Kelam"
    },
    "2024-02-24": {
        "content": " Yorulduğunuzda durmayın. Bitirdiğinizde durun. -David Goggins"
    },
    "2024-02-25": {
        "content": " Beni başarılarımla yargılamayın, kaç kez düşüp tekrar ayağa kalktığımla yargılayın. -Nelson Mandela"
    },
    "2024-02-26": {
        "content": " Bugün başlanmayan iş, yarın asla bitmez. -Johann Wolfgang von Goethe"
    },
    "2024-02-27": {
        "content": " Yüz tane kısa hikaye yazarsanız ve hepsi kötüyse, bu başarısız olduğunuz anlamına gelmez. Sadece yazmayı bırakırsanız başarısız olursunuz. -Ray Bradbury"
    },
    "2024-02-28": {
        "content": " Usta, yeni başlayanın denediğinden daha fazla başarısızlığa uğramıştır. -Stephen McCranie"
    },
    "2024-02-29": {
        "content": " Şartlar cehenneme, ben fırsatları yaratırım. -Bruce Lee"
    },
    "2024-03-01": {
        "content": "Bir şeye başlayıp başarısız olmaktan daha kötü olan tek şey, bir şeye başlamamaktır. -Seth Godin"
    },
    "2024-03-02": {
        "content": " Bugün yapabileceğin işi asla yarına bırakma. -Benjamin Franklin"
    },
    "2024-03-03": {
        "content": " Salyangoz azimle gemiye ulaştı. -Charles H. Spurgeon"
    },
    "2024-03-04": {
        "content": " Unutmayın, umut iyi bir şeydir, belki de en iyi şeydir ve hiçbir iyi şey asla ölmez. -Stephen King"
    },
    "2024-03-05": {
        "content": " Girişimciler yorgun olduğumuzda bitirmezler. İşimiz bitince bitiririz. -Robert T. Kiyosaki"
    },
    "2024-03-06": {
        "content": " Yalnızca azim ve kararlılık her şeye kadirdir. -Calvin Coolidge"
    },
    "2024-03-07": {
        "content": " Direnci ısrarla felç edin. -Woody Hayes"
    },
    "2024-03-08": {
        "content": " Başarı hiçbir zaman sahip olunamaz, kiralanır ve kirası her gün ödenir. -Rory Vaden"
    },
    "2024-03-09": {
        "content": " Başarı tesadüf değildir. Sıkı çalışma, azim, öğrenme, çalışma, fedakarlık ve en önemlisi yaptığınız veya yapmayı öğrendiğiniz şeye olan sevgidir. -Pele"
    },
    "2024-03-10": {
        "content": " Zor işin etrafından dolanmanın bir yolu yok. Onu kucakla. -Roger Federer"
    },
    "2024-03-11": {
        "content": " Bir hayalin gerçeğe dönüşmesi sihirle olmaz; ter, kararlılık ve sıkı çalışma gerektirir. -Colin Powell"
    },
    "2024-03-12": {
        "content": "Öğrenmek zihni asla yormaz. -Leonardo da Vinci"
    },
    "2024-03-13": {
        "content": " Duyuyorum ve unutuyorum. Görüyorum ve hatırlıyorum. Yapıyorum ve anlıyorum. -Konfüçyüs"
    },
    "2024-03-14": {
        "content": " Hiç hata yapmamış olan insan, hiç yeni bir şey denememiştir. -Albert Einstein"
    },
    "2024-03-15": {
        "content": " Her şey hakkında bir şeyler, bir şey hakkında da her şeyi öğrenmeye çalışın. -Thomas Henry Huxley"
    },
    "2024-03-16": {
        "content": " İnsan ancak iki şekilde öğrenir; biri okuyarak, diğeri de daha akıllı insanlarla arkadaşlık ederek. -Will Rogers"
    },
    "2024-03-17": {
        "content": " Bir şeyi birden fazla şekilde öğrenmedikçe hiçbir şeyi anlayamazsın. -Marvin Minsky"
    },
    "2024-03-18": {
        "content": " Bana söyle unutayım, bana öğret hatırlayayım, beni dahil et öğreneyim. -Benjamin Franklin"
    },
    "2024-03-19": {
        "content": " Başarı oranınızı artırmak istiyorsanız, başarısızlık oranınızı iki katına çıkarın. -Thomas J. Watson"
    },
    "2024-03-20": {
        "content": " Zekâ, ne yapacağını bilmediğin zaman kullandığın şeydir. -Jean Piaget"
    },
    "2024-03-21": {
        "content": " 21. yüzyılın cahili, okuma yazma bilmeyenler değil, öğrenemeyen, öğrendiklerini unutamayan ve yeniden öğrenemeyenler olacaktır. -Alvin Toffler"
    },
    "2024-03-22": {
        "content": "Öğrenmemizi engelleyen şey çoğu zaman bildiklerimizdir. -Claude Bernard"
    },
    "2024-03-23": {
        "content": " Matematik, Tanrı'nın evreni yazdığı dildir. -Galileo Galilei"
    },
    "2024-03-24": {
        "content": " Eğitimin bütün amacı aynaları pencereye dönüştürmektir. -Sidney J. Harris"
    },
    "2024-03-25": {
        "content": " Fırtınalardan korkmuyorum çünkü gemimi nasıl yelkenleyeceğimi öğreniyorum. -Louisa May Alcott"
    },
    "2024-03-26": {
        "content": " Eğitimli olan tek kişi, öğrenmeyi ve değişmeyi öğrenmiş olan kişidir. -Carl R. Rogers"
    },
    "2024-03-27": {
        "content": " Hiçbir zaman kendisinden bir şey öğrenemeyeceğim kadar cahil bir adamla karşılaşmadım. -Galileo Galilei"
    },
    "2024-03-28": {
        "content": " Hiçbir şey bize bilmemiz gerekeni öğretmeden ortadan kalkmaz. -Pema Chödrön"
    },
    "2024-03-29": {
        "content": " Alıştırma mükemmelleştirir. Uzun süreli pratikten sonra, işimiz doğal, becerikli, hızlı ve istikrarlı hale gelecektir. -Bruce Lee"
    },
    "2024-03-30": {
        "content": " Konuştuğunuzda sadece zaten bildiğiniz bir şeyi tekrarlıyorsunuz. Ancak, dinlerseniz yeni bir şey öğrenebilirsiniz. -Dalay Lama XIV"
    },
    "2024-03-31": {
        "content": " Mükemmelliğe değil, ilerlemeye çabalayın. -Anonim"
    },
    "2024-04-01": {
        "content": "Ben hep henüz yapamadığım şeyleri yapıyorum, nasıl yapacağımı öğrenmek için. -Vincent van Gogh"
    },
    "2024-04-02": {
        "content": " Bilgi, insanı köle olmaya elverişsiz kılar. -Frederick Douglass"
    },
    "2024-04-03": {
        "content": " Bir şeyin adını bilmekle, onu bilmek arasındaki farkı çok erken öğrendim. -Richard P. Feynman"
    },
    "2024-04-04": {
        "content": " Öğrenme kapasitesi bir armağandır; öğrenme yeteneği bir beceridir; öğrenme isteği ise bir seçimdir. -Brian Herbert"
    },
    "2024-04-05": {
        "content": " Öğrenebildiğiniz her şeyi, mümkün olan her zaman, herkesten öğrenin; bunu yaptığınız için minnettar olacağınız bir zaman mutlaka gelecektir. -Sarah Caldwell"
    },
    "2024-04-06": {
        "content": " Dün olduğundan daha akıllı olmayan bir adam hakkında pek fazla bir şey düşünmem. -Abraham Lincoln"
    },
    "2024-04-07": {
        "content": " Başarının anahtarı yaşam boyu öğrenmeye adanmışlıktır. -Stephen R. Covey"
    },
    "2024-04-08": {
        "content": " Tutkulu ve cesur olun. Her zaman öğrenmeye devam edin. Öğrenmezseniz yararlı şeyler yapmayı bırakırsınız. -Satya Nadella"
    },
    "2024-04-09": {
        "content": "İnsanın ulaşabileceği en yüksek etkinlik, anlamak için öğrenmektir; çünkü anlamak özgür olmaktır. -Baruch Spinoza"
    },
    "2024-04-10": {
        "content": " Öğrenmeye devam etmezseniz, diğer insanlar sizi geçecektir. Sadece mizaç bunu başaramaz - uzun, uzun bir süre boyunca çok fazla meraka ihtiyacınız var. -Charlie Munger"
    },
    "2024-04-11": {
        "content": " Öğrenen organizasyon, geleceğini yaratma kapasitesini sürekli olarak genişleten bir organizasyondur. -Peter Senge"
    },
    "2024-04-12": {
        "content": " Öğrenmeyi bıraktığınız gün, çürümeye başladığınız gündür. -Isaac Asimov"
    },
    "2024-04-13": {
        "content": " İlim, refah zamanında süs, sıkıntı zamanında sığınak, yaşlılıkta ise geçim kaynağıdır. -Aristo"
    },
    "2024-04-14": {
        "content": " Tüm liderler öğrenendir. Öğrenmeyi bıraktığınız anda, liderlik etmeyi bırakırsınız. Mümkün olduğunca çok, mümkün olduğunca çok kişiden, mümkün olduğunca sık öğrenirim. -Rick Warren"
    },
    "2024-04-15": {
        "content": " Zor şeyleri hızlı bir şekilde öğrenmek için, dikkat dağıtıcı unsurlar olmadan yoğun bir şekilde odaklanmalısınız. Öğrenmek, başka bir deyişle, derin bir çalışma eylemidir. -Cal Newport"
    },
    "2024-04-16": {
        "content": " Herhangi bir aptal bile bilebilir. Önemli olan anlamaktır. -Albert Einstein"
    },
    "2024-04-17": {
        "content": "Her gününüzü uyandığınızda olduğunuzdan biraz daha akıllı olmaya çalışarak geçirin. -Charlie Munger"
    },
    "2024-04-18": {
        "content": " Kendinize, eğitiminize yatırım yapın. Bundan iyisi yok. -Sylvia Porter"
    },
    "2024-04-19": {
        "content": " Kendimi eğitmek benim için sürekli bir zevk kaynağıdır, çünkü ne kadar çok şey bilirsem, hayatım o kadar dolu olur ve kendi varlığımı o kadar iyi takdir ederim. -Isaac Asimov"
    },
    "2024-04-20": {
        "content": " Öğretmenlerden yardım alabilirsiniz ama çok şeyi kendi başınıza, bir odada tek başınıza oturarak öğrenmeniz gerekecek. -Dr. Seuss"
    },
    "2024-04-21": {
        "content": " Öğrenme, öğretmek isteyenle değil, öğrenmek isteyenle gerçekleşir. -Roger Schank"
    },
    "2024-04-22": {
        "content": " Bir kişi bir başka kişiye doğrudan bir şey öğretemez; bir kişi sadece bir başkasının öğrenmesini kolaylaştırabilir. -Carl R. Rogers"
    },
    "2024-04-23": {
        "content": " Öğrenmek zorunlu değildir; gönüllüdür. Gelişim zorunlu değildir; gönüllüdür. Ancak hayatta kalmak için öğrenmeliyiz. -W. Edwards Deming"
    },
    "2024-04-24": {
        "content": " Ben her zaman yapamadığım şeyi yapıyorum ki, onu nasıl yapacağımı öğreneyim. -Pablo Picasso"
    },
    "2024-04-25": {
        "content": "Hiçbir hırsız, ne kadar usta olursa olsun, bir insanın bilgisini çalamaz. İşte bu yüzden bilgi, edinilebilecek en iyi ve en güvenli hazinedir. -L. Frank Baum"
    },
    "2024-04-26": {
        "content": " Bence verilebilecek en iyi tavsiye şu: Sürekli olarak, işleri nasıl daha iyi yapabileceğinizi düşünün ve kendinizi sorgulayın. -Elon Musk"
    },
    "2024-04-27": {
        "content": " Akıllı bir adam, aptal bir adamın akıllıca bir cevaptan öğrenebileceğinden daha fazlasını, aptalca bir sorudan öğrenebilir. -Bruce Lee"
    },
    "2024-04-28": {
        "content": " Eğer daha ileriyi görebildiysem, bu Devlerin omuzlarına basarak olmuştur. -Isaac Newton"
    },
    "2024-04-29": {
        "content": " Bildiklerimiz bir damla, bilmediklerimiz ise bir okyanustur. -Isaac Newton"
    },
    "2024-04-30": {
        "content": " Öğrenmenin en güzel yanı, onu sizden kimsenin alamamasıdır. -BB Kralı"
    },
    "2024-05-01": {
        "content": " Yazar olmak istiyorsanız her şeyden önce iki şeyi yapmalısınız: Çok okumak ve çok yazmak. -Stephen King"
    },
    "2024-05-02": {
        "content": " Tekrar, becerinin anasıdır. -Tony Robbins"
    },
    "2024-05-03": {
        "content": " Hayret, bilgeliğin başlangıcıdır. -Sokrates"
    },
    "2024-05-04": {
        "content": " Bir hata yapıp düzeltmezsen buna hata denir. -Konfüçyüs"
    },
    "2024-05-05": {
        "content": " Eğitimin amacı boş zihni açık zihinle değiştirmektir. -Malcolm S. Forbes"
    },
    "2024-05-06": {
        "content": "Hayatta korkulacak hiçbir şey yoktur, sadece anlaşılmalıdır. Şimdi daha fazlasını anlamanın zamanıdır, böylece daha az korkabiliriz. -Marie Curie"
    },
    "2024-05-07": {
        "content": " Bir işi yapıp yapamayacağınız sorulduğunda, onlara \"Elbette yapabilirim!\" deyin. Sonra harekete geçin ve nasıl yapılacağını öğrenin. -Theodore Roosevelt"
    },
    "2024-05-08": {
        "content": " Hepimizin bize geri bildirim verecek insanlara ihtiyacımız var. Bu şekilde gelişiriz. -Bill Gates"
    },
    "2024-05-09": {
        "content": " Eğitim, dünyanın kilidini açmanın anahtarı, özgürlüğe giden pasaporttur. -Oprah Winfrey"
    },
    "2024-05-10": {
        "content": " Her şey bir fikirle başlar. -Kont Nightingale"
    },
    "2024-05-11": {
        "content": " Yapabileceğiniz en iyi yatırım kendinize yaptığınızdır. -Warren Buffett"
    },
    "2024-05-12": {
        "content": " Bu para veya bağlantılarla ilgili değil. Herkesten daha fazla çalışmaya ve daha fazla öğrenmeye istekli olmaktır. -Mark Kübalı"
    },
    "2024-05-13": {
        "content": " Yaşadığınız sürece yaşamayı öğrenmeye devam edin. -Seneca"
    },
    "2024-05-14": {
        "content": " Başarmayı öğrenmek için önce başarısız olmayı öğrenmelisiniz. -Michael Jordan"
    },
    "2024-05-15": {
        "content": " İyi bir hatayı boşa harcamayın, ondan ders çıkarın. -Robert T. Kiyosaki"
    },
    "2024-05-16": {
        "content": "Bilgi edinmek için çalışmak gerekir; fakat hikmet edinmek için gözlem yapmak gerekir. -Marilyn Vos Savant"
    },
    "2024-05-17": {
        "content": " Yaşayıp öğreniyorsun. Her neyse, yaşıyorsun. -Douglas Adams"
    },
    "2024-05-18": {
        "content": " Sabır, hikmetin yoldaşıdır. -Aziz Augustinus"
    },
    "2024-05-19": {
        "content": " Ben sadece bir şey biliyorum, o da hiçbir şey bilmediğimdir. -Sokrates"
    },
    "2024-05-20": {
        "content": " Bilgelik deneyimden gelir. Deneyim genellikle bilgelik eksikliğinin bir sonucudur. -Terry Pratchett"
    },
    "2024-05-21": {
        "content": " İlerlememizi, sorularımızın cesaretine, cevaplarımızın derinliğine, iyi hissettiren şeylerden ziyade gerçek olanı benimsemeye olan istekliliğimize göre değerlendirebiliriz. -Carl Sagan"
    },
    "2024-05-22": {
        "content": " Soru sorulamayan cevaplardan çok, cevaplanamayan sorularım olmasını tercih ederim. -Richard P. Feynman"
    },
    "2024-05-23": {
        "content": " Öğretilmekten her zaman hoşlanmasam da öğrenmeye her zaman hazırım. -Winston Churchill"
    },
    "2024-05-24": {
        "content": " Teori olmadan pratiği seven kişi, dümeni ve pusulası olmayan ve nereye gideceğini asla bilemeyen denizciye benzer. -Leonardo da Vinci"
    },
    "2024-05-25": {
        "content": " Öğrenmektense yaratmak daha iyidir. Yaratmak hayatın özüdür. -Julius Sezar"
    },
    "2024-05-26": {
        "content": "El ne yaparsa akıl onu hatırlar. -Maria Montessori"
    },
    "2024-05-27": {
        "content": " Hayatınızda her zaman yeni bir şey öğrenecekmişsiniz gibi yürüyün, o zaman öğreneceksiniz. -Vernon Howard"
    },
    "2024-05-28": {
        "content": " Başarısızlık, ondan ders çıkarırsak başarıdır. -Malcolm S. Forbes"
    },
    "2024-05-29": {
        "content": " Eğitim en iyi arkadaştır. Eğitimli bir kişi her yerde saygı görür. Eğitim güzelliği ve gençliği yener. -Çanakya"
    },
    "2024-05-30": {
        "content": " Sizin için başarılması zor olan bir şeyin insan olarak imkânsız olduğunu düşünmeyin; ama eğer bir şey insan olarak mümkünse, onu ulaşabileceğiniz mesafede sayın. -Marcus Aurelius"
    },
    "2024-05-31": {
        "content": " Öğrenme, sürekli bir keşif sürecidir; sonu olmayan bir süreçtir. -Bruce Lee"
    },
    "2024-06-01": {
        "content": " Cahil olmak ayıp değil, öğrenmeye isteksiz olmaktır. -Benjamin Franklin"
    },
    "2024-06-02": {
        "content": " Bilginin güç olduğuna inanıyorum; geçmişi aşmak, içinde bulunduğumuz durumu değiştirmek, yeni engellerle mücadele etmek, daha iyi kararlar almak için. -Ben Carson"
    },
    "2024-06-03": {
        "content": " Nefes alırken, bedenimi ve zihnimi sakinleştiriyorum. Nefes verirken, gülümsüyorum. Şimdiki anda yaşayarak, bunun tek an olduğunu biliyorum. -Thich Nhat Hanh"
    },
    "2024-06-04": {
        "content": "Eğer bir fark yaratamayacak kadar küçük olduğunuzu düşünüyorsanız, bir sivrisinekle uyumayı deneyin. -Dalay Lama XIV"
    },
    "2024-06-05": {
        "content": " Çoğu zaman bir dokunuşun, bir gülümsemenin, nazik bir sözün, dinleyen bir kulağın, içten bir iltifatın veya en ufak bir şefkat eyleminin gücünü hafife alırız; bunların hepsi bir hayatı değiştirme potansiyeline sahiptir. -Leo Buscaglia"
    },
    "2024-06-06": {
        "content": " Günlerimizi nasıl geçirirsek, hayatımızı da öyle geçiriyoruz elbette. -Annie Dillard"
    },
    "2024-06-07": {
        "content": " Zihninizi büyük düşüncelerle besleyin, çünkü düşündüğünüzden daha yükseğe asla çıkamayacaksınız. -Benjamin Disraeli"
    },
    "2024-06-08": {
        "content": " Kurallara uyarak yürümeyi öğrenemezsin. Yaparak ve düşerek öğrenirsin. -Richard Branson"
    },
    "2024-06-09": {
        "content": " Bir şeyde başarısız olmadan yaşamak imkansızdır; ancak o kadar dikkatli yaşarsanız hiç yaşamamış sayılırsınız ki, otomatik olarak başarısız olursunuz. -JK Rowling"
    },
    "2024-06-10": {
        "content": " Mutlu olmak istiyorsan ol. -Leo Tolstoy"
    },
    "2024-06-11": {
        "content": " Hiç kimse benim iznim olmadan bana zarar veremez. -Mahatma Gandi"
    },
    "2024-06-12": {
        "content": " Ne olduğumu bıraktığımda, ne olabileceğim haline gelirim. -Lao Tzu"
    },
    "2024-06-13": {
        "content": "Güvensizlik duygusuyla boğuşmamızın sebebi, sahne arkasını başkalarının öne çıkan anlarıyla karşılaştırmamızdır. -Steven Furtick"
    },
    "2024-06-14": {
        "content": " Unutma, bugün dün endişelendiğin yarındır. -Dale Carnegie"
    },
    "2024-06-15": {
        "content": " Planladığımız hayattan vazgeçmeye razı olmalıyız ki, bizi bekleyen hayata sahip olabilelim. -Joseph Campbell"
    },
    "2024-06-16": {
        "content": " Gitmeyi bırak, varacaksın. Aramayı bırak, göreceksin. Kaçmayı bırak, bulunacaksın. -Lao Tzu"
    },
    "2024-06-17": {
        "content": " Bir ekip, birlikte çalışan bir grup insan değildir. Bir ekip, birbirine güvenen bir grup insandır. -Simon Sinek"
    },
    "2024-06-18": {
        "content": " Sürekli iyimserlik kuvvet çarpanıdır. -Colin Powell"
    },
    "2024-06-19": {
        "content": " Sadece kendiniz olmayı başardığınızda ve başkalarıyla kıyaslama veya rekabet yapmadığınızda, herkes size saygı duyacaktır. -Lao Tzu"
    },
    "2024-06-20": {
        "content": " Yaşını arkadaşların ile say, yılların ile değil. Hayatını gülümsemelerin ile say, gözyaşların ile değil. -John Lennon"
    },
    "2024-06-21": {
        "content": " Sevdiklerinize uçmaları için kanatlar, geri dönmeleri için kökler ve kalmaları için sebepler verin. -Dalay Lama XIV"
    },
    "2024-06-22": {
        "content": " Azim ve cesaret her çağda harikalar yaratmıştır. -George Washington"
    },
    "2024-06-23": {
        "content": "Bilginizi paylaşın. Ölümsüzlüğe ulaşmanın bir yoludur. -Dalay Lama XIV"
    },
    "2024-06-24": {
        "content": " Biz kozmosun kendini tanımasının bir yoluyuz. -Carl Sagan"
    },
    "2024-06-25": {
        "content": " İyi bir öğretmen umut aşılayabilir, hayal gücünü ateşleyebilir ve öğrenme sevgisi aşılayabilir. -Brad Henry"
    },
    "2024-06-26": {
        "content": " Bir insanın yapabileceği en büyük keşiflerden biri, en büyük sürprizlerinden biri, yapamayacağından korktuğu şeyi başarabilmesidir. -Henry Ford"
    },
    "2024-06-27": {
        "content": " En son ne zaman bir şeyi ilk defa yaptın? -John C. Maxwell"
    },
    "2024-06-28": {
        "content": " Olmak istediğiniz kişi olma sürecinde değilseniz, otomatik olarak olmak istemediğiniz kişiye dönüşmeye başlarsınız. -Dale Carnegie"
    },
    "2024-06-29": {
        "content": " Şans cesurların yanındadır. -Latince atasözü"
    },
    "2024-06-30": {
        "content": " Başarı mutluluğun anahtarı değildir. Mutluluk başarının anahtarıdır. Yaptığınız işi seviyorsanız başarılı olursunuz. -Albert Schweitzer"
    },
    "2024-07-01": {
        "content": " Dünyayı kazanıp da canını kaybetme; hikmet, gümüşten ve altından daha iyidir. -Bob Marley"
    },
    "2024-07-02": {
        "content": " Hemen yaşamaya başla ve her ayrı günü ayrı bir hayat olarak say. -Seneca"
    },
    "2024-07-03": {
        "content": "Senin gibi biri çok fazla umursamadığı sürece hiçbir şey düzelmeyecek. İyileşmiyor. -Dr. Seuss"
    },
    "2024-07-04": {
        "content": " Bunun imkansız olduğunu bilmiyorlardı ve bunu başardılar. -Mark Twain"
    },
    "2024-07-05": {
        "content": " Senin yapamadığın şeyleri ben yapabilirim, benim yapamadığım şeyleri sen yapabilirsin; birlikte çok büyük şeyler başarabiliriz. -Rahibe Teresa"
    },
    "2024-07-06": {
        "content": " Korkmamız gereken tek şey korkunun kendisidir. -Franklin D. Roosevelt"
    },
    "2024-07-07": {
        "content": " Coşku olmadan hiçbir büyük başarı elde edilemez. -Ralph Waldo Emerson"
    },
    "2024-07-08": {
        "content": " Cesaret, canım yüreğim. -CS Lewis"
    },
    "2024-07-09": {
        "content": " Değişimden anlam çıkarmanın tek yolu, ona dalmak, onunla birlikte hareket etmek ve dansa katılmaktır. -Alan Watts"
    },
    "2024-07-10": {
        "content": " Dikkatin olduğu yere enerji akar ve sonuçlar ortaya çıkar. -T. Harv Eker"
    },
    "2024-07-11": {
        "content": " Acı geçicidir. Bir dakika, bir saat, bir gün veya bir yıl sürebilir, ancak sonunda azalacaktır ve yerini başka bir şey alacaktır. Ancak bırakırsam sonsuza dek sürer. -Lance Armstrong"
    },
    "2024-07-12": {
        "content": " Doğayla yapılan her yürüyüşte, insan aradığından çok daha fazlasını bulur. -John Muir"
    },
    "2024-07-13": {
        "content": "Kazananlar asla başarısız olmayanlar değil, asla vazgeçmeyenlerdir. -Edwin Louis Cole"
    },
    "2024-07-14": {
        "content": " Karanlıkla savaşmak yerine, ışığı getirirsiniz. -Eckhart Tolle"
    },
    "2024-07-15": {
        "content": " Ruhunuzu ateşleyen şeylerin peşinde koşarken korkusuz olun. -Jennifer Lee"
    },
    "2024-07-16": {
        "content": " İnsanlar sizden uzaklaştığında, bırakın gitsinler. Kaderiniz sizi terk eden hiç kimseye bağlı değildir ve bu onların kötü insanlar olduğu anlamına gelmez. Bu sadece hikayenizdeki rollerinin bittiği anlamına gelir. -TD Jakes"
    },
    "2024-07-17": {
        "content": " Liderlik, vizyonu gerçeğe dönüştürme kapasitesidir. -Warren G. Bennis"
    },
    "2024-07-18": {
        "content": " İman, görmediğine inanmaktır; bu imanın mükafatı ise inandığını görmektir. -Aziz Augustinus"
    },
    "2024-07-19": {
        "content": " Hiçbir şey imkansız değildir, ta ki siz öyle olduğunu düşünmediğiniz sürece. -Paramahansa Yogananda"
    },
    "2024-07-20": {
        "content": " Kör olmaktan daha kötü olan tek şey, görebilmek ama vizyon sahibi olmamaktır. -Helen Keller"
    },
    "2024-07-21": {
        "content": " Her şeyin bir güzelliği vardır ama herkes bunu göremez. -Konfüçyüs"
    },
    "2024-07-22": {
        "content": " Allah, kalbin sessizliğinde konuşur. -Rahibe Teresa"
    },
    "2024-07-23": {
        "content": "Umut, ruha konan tüylü bir şeydir - ve sözsüz bir melodi söyler - ve asla durmaz. -Emily Dickinson"
    },
    "2024-07-24": {
        "content": " Ne kadar kutsal söz okursanız okuyun, ne kadar söylerseniz söyleyin, bunları uygulamazsanız size ne faydası olur? -Buda"
    },
    "2024-07-25": {
        "content": " Ve bu arada, eğer bunu yapacak dışa dönük cesaretiniz ve doğaçlama yapacak hayal gücünüz varsa, hayattaki her şey yazılabilir. Yaratıcılığın en büyük düşmanı kendinden şüphe duymaktır. -Sylvia Plath"
    },
    "2024-07-26": {
        "content": " Geçmişi değiştirecek hiçbir şey yapamayız ama yaptığımız her şey geleceği değiştirir. -Ashleigh Harika"
    },
    "2024-07-27": {
        "content": " Liderlik bir tercihtir. Bir rütbe değildir. -Simon Sinek"
    },
    "2024-07-28": {
        "content": " Her şey iyi olacak, her şey iyi olacak, her türlü şey iyi olacak. -Norwich'li Julian"
    },
    "2024-07-29": {
        "content": " Kozmik bakış açısına göre her birimiz değerliyiz. Eğer bir insan sizinle aynı fikirde değilse, bırakın yaşasın. Yüz milyar galakside bir tane daha bulamazsınız. -Carl Sagan"
    },
    "2024-07-30": {
        "content": " Zekâ artı karakter – işte gerçek eğitimin amacı budur. -Martin Luther King Jr."
    },
    "2024-07-31": {
        "content": "Kendinizi kendinizden daha büyük bir şeye ne kadar kaptırırsanız, o kadar fazla enerjiye sahip olursunuz. -Norman Vincent Peale"
    },
    "2024-08-01": {
        "content": " Temelleri öğrenin ve yaptığınız her şeyin seviyesi yükselecektir -Michael Jordan"
    },
    "2024-08-02": {
        "content": " Şimdi tam anlamıyla yaşayamazsan hiç yaşayamazsın. -Alan Watts"
    },
    "2024-08-03": {
        "content": " Bazen istediğinizi elde edememenin büyük bir şans olduğunu unutmayın. -Dalay Lama XIV"
    },
    "2024-08-04": {
        "content": " Elinizden gelenin en iyisini yapın ve sonra rahatlayın. İşleri zorlamak yerine doğal bir şekilde ilerlemesine izin verin. -Paramahansa Yogananda"
    },
    "2024-08-05": {
        "content": " Sen geçici bir insan deneyimi yaşayan sonsuz bir ruhsal varlıksın. -Wayne W. Dyer"
    },
    "2024-08-06": {
        "content": " Hayallerinizin gerçekleşmesi için önce hayal kurmanız gerekir. -Abdul Kelam"
    },
    "2024-08-07": {
        "content": " Her şeyden önce kalbinizi koruyun, çünkü yaptığınız her şey kalbinizden kaynaklanır. -Süleyman"
    },
    "2024-08-08": {
        "content": " Yazarken her şeyden sıyrılıyorum; üzüntülerim kayboluyor, cesaretim yeniden doğuyor. -Anne Frank"
    },
    "2024-08-09": {
        "content": " Amaç sonuna kadar mükemmel olmak değil. Amaç bugün daha iyi olmak. -Simon Sinek"
    },
    "2024-08-10": {
        "content": " Hayallerinizin doğrultusunda güvenle ilerleyin. Hayal ettiğiniz hayatı yaşayın. -Henry David Thoreau"
    },
    "2024-08-11": {
        "content": "Mümkün olduğunca nazik olun. Bu her zaman mümkündür. -Dalay Lama XIV"
    },
    "2024-08-12": {
        "content": " Bu hayattaki asıl amacımız başkalarına yardım etmektir. Ve eğer onlara yardım edemiyorsanız, en azından onlara zarar vermeyin. -Dalay Lama XIV"
    },
    "2024-08-13": {
        "content": " Kafanızın içinde beyniniz var. Ayakkabılarınızın içinde ayaklarınız var. Kendinizi istediğiniz yöne yönlendirebilirsiniz. Kendi başınızasınız. Ve ne bildiğinizi biliyorsunuz. Ve nereye gideceğinize karar verecek olan sizsiniz. -Dr. Seuss"
    },
    "2024-08-14": {
        "content": " Neye odaklanırsanız onu büyütürsünüz ve hayatınızdaki iyiliğe odaklandığınızda daha fazlasını yaratırsınız. -Oprah Winfrey"
    },
    "2024-08-15": {
        "content": " Bilmem gereken her şey bana açıklanıyor. İhtiyacım olan her şey bana geliyor. Hayatımda her şey yolunda. -Louise Hay"
    },
    "2024-08-16": {
        "content": " Evrende tamamen güvendeyim. Her yerde huzur içindeyim. Hayata güveniyorum. -Louise Hay"
    },
    "2024-08-17": {
        "content": " Yüzünü güneşe dön, gölgeler arkanda kalsın. -Maori Atasözü"
    },
    "2024-08-18": {
        "content": " Cesaret, devam edecek güce sahip olmak değil; gücün olmadığında devam edebilmektir. -Theodore Roosevelt"
    },
    "2024-08-19": {
        "content": " Gelecek, bugün ne yaptığınıza bağlıdır. -Mahatma Gandi"
    },
    "2024-08-20": {
        "content": " Kazanan, asla vazgeçmeyen hayalperesttir. -Nelson Mandela"
    },
    "2024-08-21": {
        "content": "Bittiği için ağlama, yaşandığı için gülümse. -Dr. Seuss"
    },
    "2024-08-22": {
        "content": " Hayat hakkında öğrendiğim her şeyi üç kelimeyle özetleyebilirim: Hayat devam ediyor. -Robert Frost"
    },
    "2024-08-23": {
        "content": " Hayallerinizle yaşayın, tarihinizle değil. -Stephen R. Covey"
    },
    "2024-08-24": {
        "content": " Benim bakış açıma göre, gökkuşağını istiyorsan yağmura katlanmalısın. -Dolly Parton"
    },
    "2024-08-25": {
        "content": " Bir insanın büyüklüğü, ne kadar çok servete sahip olduğuyla değil, dürüstlüğüyle ve etrafındakileri olumlu yönde etkileyebilme yeteneğiyle ölçülür. -Bob Marley"
    },
    "2024-08-26": {
        "content": " Mutluluk dış etkenlerden ziyade, esas olarak kendi tutumumuzdan kaynaklanır. -Dalay Lama XIV"
    },
    "2024-08-27": {
        "content": " Büyük işler küçük işlerden meydana gelir. -Lao Tzu"
    },
    "2024-08-28": {
        "content": " Ne olabileceğiniz konusunda asla geç değildir. -George Eliot"
    },
    "2024-08-29": {
        "content": " Doğru tutumu benimsemek olumsuz stresi olumluya dönüştürebilir. -Hans Selye"
    },
    "2024-08-30": {
        "content": " Kendiniz için hayal ettiğiniz hayatı yaşamaya cesaret edin. İlerleyin ve hayallerinizi gerçekleştirin. -Ralph Waldo Emerson"
    },
    "2024-08-31": {
        "content": " Boşa harcamaktan zevk aldığınız zaman, boşa harcanmış zaman değildir. -Bertrand Russell"
    },
    "2024-09-01": {
        "content": "Görmek ve anlamak için biraz uyanık olmak yeterli: Hayat aslında büyük bir kozmik kahkahadır. -Osho"
    },
    "2024-09-02": {
        "content": " İlginç bir paradoks şu ki, kendimi olduğum gibi kabul ettiğimde değişebilirim. -Carl R. Rogers"
    },
    "2024-09-03": {
        "content": " Sorunun değil, çözümün parçası olun. -Stephen R. Covey"
    },
    "2024-09-04": {
        "content": " Yaşamanın sırrı vermektir. -Tony Robbins"
    },
    "2024-09-05": {
        "content": " Her günü şaheseriniz yapın. -John Ahşap"
    },
    "2024-09-06": {
        "content": " Gerçekten yapmak istediklerinizden asla vazgeçmeyin -H. Jackson Brown Jr."
    },
    "2024-09-07": {
        "content": " Geriye bakma, o yöne gitmiyorsun. -Mary Engelbreit"
    },
    "2024-09-08": {
        "content": " Sen elinden geleni yap, gerisini Allah halleder. -Nick Vujicic"
    },
    "2024-09-09": {
        "content": " Yaşa, seyahat et, maceraya atıl, şükret ve pişman olma. -Jack Kerouac"
    },
    "2024-09-10": {
        "content": " Kışın ortasında, içimde yenilmez bir yaz olduğunu keşfettim. Ve bu beni mutlu ediyor. Çünkü bu, dünya bana ne kadar sert baskı yaparsa yapsın, içimde daha güçlü bir şeyin, daha iyi bir şeyin, tam geri ittiğini söylüyor. -Albert Camus"
    },
    "2024-09-11": {
        "content": "Bazıları kötülüğü kontrol altında tutabilecek tek şeyin büyük bir güç olduğuna inanır, ancak benim bulduğum bu değil. Karanlığı uzak tutan şey sıradan insanların küçük günlük eylemleridir. Küçük nezaket ve sevgi eylemleri. -JRR Tolkien"
    },
    "2024-09-12": {
        "content": " Küçük şeylerde sadık olun, çünkü gücünüz onlardadır. -Rahibe Teresa"
    },
    "2024-09-13": {
        "content": " Kendini bir ışık yap. -Buda"
    },
    "2024-09-14": {
        "content": " GÖRSELLEŞTİR!!! Gör, hisset! Aksiyon burada başlıyor. -Rhonda Byrne"
    },
    "2024-09-15": {
        "content": " Olağanüstü ol ya da unutul! -Eric Thomas"
    },
    "2024-09-16": {
        "content": " Haklı olmak ya da nazik olmak arasında bir seçim yapmanız gerektiğinde, nazik olmayı seçin. -Wayne W. Dyer"
    },
    "2024-09-17": {
        "content": " İnsanlar zihinsel tutumlarını değiştirerek hayatlarını değiştirebilirler. -William James"
    },
    "2024-09-18": {
        "content": " Sağlık en büyük servettir. -Laozi"
    },
    "2024-09-19": {
        "content": " Tehlikelerden korunmak için dua etmeyeyim, onlarla yüzleşmekten korkmayayım. Acımın dinmesi için yalvarmayayım, onu fethetmek için yürekten yalvarayım. -Rabindranath Tagore"
    },
    "2024-09-20": {
        "content": " Kalbinizi iyilik yapmaya odaklayın. Bunu tekrar tekrar yapın, sevinçle dolacaksınız. -Buda"
    },
    "2024-09-21": {
        "content": "Ben tek başıma dünyayı değiştiremem ama suyun üzerine bir taş atıp dalgalar yaratabilirim. -Rahibe Teresa"
    },
    "2024-09-22": {
        "content": " Ve bir gün geldi ki, tomurcukta sımsıkı kalmanın riski, çiçek açmanın riskinden daha acı verici oldu. -Anaïs Nin"
    },
    "2024-09-23": {
        "content": " İnsan çabasının sınırları olmamalıdır. Hayat ne kadar kötü görünürse görünsün, her zaman umut vardır. -Stephen Hawking"
    },
    "2024-09-24": {
        "content": " Ve sizi mutlu olduğunuz zamanların farkına varmaya ve bir noktada haykırmaya, mırıldanmaya veya düşünmeye çağırıyorum: 'Eğer bu güzel değilse, neyin güzel olduğunu bilmiyorum.' -Kurt Vonnegut"
    },
    "2024-09-25": {
        "content": " Hayat hikayenizin nasıl gelişeceğini, sıkıntının kendisi değil, sizin sıkıntıya verdiğiniz tepki belirler. -Dieter F. Uchtdorf"
    },
    "2024-09-26": {
        "content": " Seni mutlu ya da mutsuz eden şey sahip olduğun şeyler, kim olduğun, nerede olduğun ya da ne yaptığın değildir. Bunlar hakkında ne düşündüğündür. -Dale Carnegie"
    },
    "2024-09-27": {
        "content": " Ne kadar çok okursanız, o kadar çok şey bileceksiniz. Ne kadar çok öğrenirseniz, o kadar çok yere gideceksiniz. -Dr. Seuss"
    },
    "2024-09-28": {
        "content": " Bütün hayallerimiz gerçek olabilir. -Walt Disney"
    },
    "2024-09-29": {
        "content": "Hayatınızın ayrıcalığı, kendiniz olmaktır. -Joseph Campbell"
    },
    "2024-09-30": {
        "content": " Bu dünyada bir başkasının yükünü hafifleten hiç kimse işe yaramaz değildir. -Charles Dickens"
    },
    "2024-10-01": {
        "content": " İçinizde neşenin olduğu bir yer bulun, neşe acıyı yakıp yok edecektir. -Joseph Campbell"
    },
    "2024-10-02": {
        "content": " Dünyanın neye ihtiyacı olduğunu sorma. Seni neyin canlandırdığını sor ve git onu yap. Çünkü dünyanın ihtiyacı olan şey, canlanan daha fazla insan. -Howard Thurman"
    },
    "2024-10-03": {
        "content": " Duygularınız hayatınızı yaratmanıza yardımcı olan en büyük araçlarınızdır. -Rhonda Byrne"
    },
    "2024-10-04": {
        "content": " Ben en iyisini hak ediyorum ve artık en iyisini kabul ediyorum. -Louise Hay"
    },
    "2024-10-05": {
        "content": " Önemli olan ne kadar verdiğimiz değil, verirken ne kadar sevgi koyduğumuzdur. -Rahibe Teresa"
    },
    "2024-10-06": {
        "content": " Başarılı olmayı nefes almak istediğin kadar çok istediğinde, o zaman başarılı olursun. -Eric Thomas"
    },
    "2024-10-07": {
        "content": " Antrenmanların her dakikasından nefret ediyordum ama dedim ki, \"Vazgeçme. Şimdi acı çek ve hayatının geri kalanını bir şampiyon olarak yaşa.\" -Muhammed Ali"
    },
    "2024-10-08": {
        "content": "Önemli olan eleştirmen değildir, güçlü adamın nasıl tökezlediğini veya işlerin failinin onları nasıl daha iyi yapabileceğini gösteren kişi değildir. Övgü, arenada gerçekten bulunan, yüzü ter, toz ve kanla lekelenmiş; yiğitçe çabalayan; hata yapan ve tekrar tekrar başarısız olan; büyük coşkuları, büyük bağlılıkları bilen ve kendini değerli bir dava uğruna harcayan; kazanırsa, yüksek başarının zaferini bilen; ve başarısız olursa, en azından büyük cesaret göstererek başarısız olan, böylece yeri asla zaferi veya yenilgiyi bilmeyen o soğuk ve korkak ruhlarla olmayacak adama aittir. -Theodore Roosevelt"
    },
    "2024-10-09": {
        "content": " Hayatınızda yaşayabileceğiniz en büyük macera, hayallerinizdeki hayatı yaşamaktır. -Oprah Winfrey"
    },
    "2024-10-10": {
        "content": " Mücadele olmadan ilerleme olmaz. -Frederick Douglass"
    },
    "2024-10-11": {
        "content": " Bir tarihle yazılmış bir rüya bir hedefe dönüşür. Adımlara bölünmüş bir hedef bir plana dönüşür. Eylemle desteklenen bir plan hayallerinizi gerçekleştirir. -Greg Reid"
    },
    "2024-10-12": {
        "content": "Yapamayacağını düşündüğün tek şeyi yap. Başarısız ol. Tekrar dene. İkinci seferde daha iyisini yap. Asla düşmeyen tek insanlar, asla yüksek telden yukarı çıkmayanlardır. -Oprah Winfrey"
    },
    "2024-10-13": {
        "content": " Değişimi bekleyin. Manzarayı analiz edin. Fırsatları değerlendirin. Satranç taşı olmayı bırakın; oyuncu olun. Sıra sizde. -Tony Robbins"
    },
    "2024-10-14": {
        "content": " Özgürsün. Güçlüsün. İyisin. Sevgisin. Değerlisin. Amacın var. Her şey yolunda. -Esther Hicks"
    },
    "2024-10-15": {
        "content": "Eğer bir şeyi çok istiyorsan, onun için dışarı çıkıp savaşacak, gece gündüz çalışacak, zamanından, huzurundan ve uykundan vazgeçecek kadar çok istiyorsan; Eğer tüm hayal ettiğin ve planladığın şey onun hakkındaysa ve hayat onsuz işe yaramaz ve değersiz görünüyorsa; Eğer onun için seve seve ter döküyor, üzülüyor ve plan yapıyorsan ve onun uğruna karşındakine karşı duyduğun korkudan kurtuluyorsan; Eğer istediğin şeyin peşinden tüm kapasiten, gücün ve zekan, inancın, umudun ve güvenin ve inatçılığınla gidiyorsan; Eğer ne soğuk ne de yoksulluk, açlık veya gut hastalığı, beden ve beyninin hastalığı veya acısı seni istediğin şeyden uzak tutamıyorsa; Eğer inatçı ve asabiysen ve onu doğuruyorsan, Tanrı'nın yardımıyla onu elde edeceksin. -Berton Braley"
    },
    "2024-10-16": {
        "content": " Doğru yolda olsanız bile, orada öylece oturursanız ezilirsiniz. -Will Rogers"
    },
    "2024-10-17": {
        "content": " Sıradan insanların sıra dışı olmayı seçebileceğini düşünüyorum. -Elon Musk"
    },
    "2024-10-18": {
        "content": " Kurallara uyarak yürümeyi öğrenemezsin. Yaparak ve düşerek öğrenirsin. -Richard Branson"
    },
    "2024-10-19": {
        "content": "Burada yetenek yok, bu sıkı çalışma. Bu bir saplantı. Yetenek diye bir şey yok, hepimiz insan olarak eşitiz. Zaman harcarsan herkes olabilirsin. Zirveye ulaşacaksın ve bu kadar. Ben yetenekli değilim, saplantılıyım. -Conor McGregor"
    },
    "2024-10-20": {
        "content": " Rüya, uyurken gördüğünüz şey değil, uyumanıza engel olan şeydir. -Abdul Kelam"
    },
    "2024-10-21": {
        "content": " Tüm olasılıkları tükettiğinizde şunu hatırlayın: Tüketmediniz. -Thomas A. Edison"
    },
    "2024-10-22": {
        "content": " Şansını dene, hata yap. Büyümenin yolu budur. Acı cesaretini besler. Cesur olmayı uygulamak için başarısız olman gerekir. -Mary Tyler Moore"
    },
    "2024-10-23": {
        "content": " Neye odaklanırsanız onu elde edersiniz. -Tony Robbins"
    },
    "2024-10-24": {
        "content": " Telaş, HER ZAMAN en önemli kelimedir. -Gary Vaynerchuk"
    },
    "2024-10-25": {
        "content": " Küflü ekmekten penisilin yapabiliyorlarsa, senden de bir şeyler yapabilirler. -Muhammed Ali"
    },
    "2024-10-26": {
        "content": " Kazanan olarak doğmadın ve kaybeden olarak doğmadın. Kendini ne yaparsan osun. -Lou Holtz"
    },
    "2024-10-27": {
        "content": " Başarı sizin göreviniz, zorunluluğunuz ve sorumluluğunuzdur. -Grant Cardone"
    },
    "2024-10-28": {
        "content": "İnsanlar arasında çok az fark vardır, ancak o küçük fark büyük bir fark yaratır. Küçük fark tutumdur. Büyük fark ise olumlu ya da olumsuz olmasıdır. -W. Clement Taşı"
    },
    "2024-10-29": {
        "content": " Liderler başkalarıyla ilişki kurabilecek kadar yakın, ama onları motive edebilecek kadar da önde olmalıdır. -John C. Maxwell"
    },
    "2024-10-30": {
        "content": " Asla asla demeyin, çünkü sınırlar da korkular gibi çoğu zaman sadece birer yanılsamadır. -Michael Jordan"
    },
    "2024-10-31": {
        "content": " Büyük şeyler başarabilmek için, önce kendinizden büyük şeyler beklemelisiniz. -Michael Jordan"
    },
    "2024-11-01": {
        "content": " İş dünyasında en başarılı olanlar, sevdikleri işi yapanlardır. -Warren Buffett"
    },
    "2024-11-02": {
        "content": " Eylem, erteleme alışkanlığınızı yok edecektir. -Og Mandino"
    },
    "2024-11-03": {
        "content": " Başarısızlık benim için bir seçenek değil. Başarı benim için tek hayal. -Conor McGregor"
    },
    "2024-11-04": {
        "content": " Başarı ara sıra yaptığınız şeyden değil, sürekli yaptığınız şeyden gelir. -Marie Forleo"
    },
    "2024-11-05": {
        "content": " Güven ve sıkı çalışma başarısızlık denen hastalığı öldürmek için en iyi ilaçlardır. Sizi başarılı bir insan yapacaktır. -Abdul Kelam"
    },
    "2024-11-06": {
        "content": " Güneş gibi parlamak istiyorsan önce güneş gibi yan. -Abdul Kelam"
    },
    "2024-11-07": {
        "content": "Siz dışarıda parti yaparken, at koştururken, aynı anda birileri de çok çalışıyor. Birileri akıllanıyor ve birileri kazanıyor. Bunu unutmayın. -Arnold Schwarzenegger"
    },
    "2024-11-08": {
        "content": " Her zaman yaptığınızı yaparsanız, her zaman aldığınızı alırsınız. -Tony Robbins"
    },
    "2024-11-09": {
        "content": " İlerleme mutluluk demektir. -Tony Robbins"
    },
    "2024-11-10": {
        "content": " Sonuçlar veya bahaneler olabilir. İkisi birden değil. -Arnold Schwarzenegger"
    },
    "2024-11-11": {
        "content": " Disiplin eşittir özgürlük. -Jocko Willink"
    },
    "2024-11-12": {
        "content": " Neyin yanlış gittiğine takılıp kalmayın. Bunun yerine, bundan sonra ne yapacağınıza odaklanın. Enerjinizi ileriye doğru hareket etmeye, cevabı bulmaya harcayın. -Denis Waitley"
    },
    "2024-11-13": {
        "content": " Keşke sahip olmayı istediğin lider ol. -Simon Sinek"
    },
    "2024-11-14": {
        "content": " Benim tutumum şu: Eğer beni zayıflık olarak gördüğünüz bir şeye doğru iterseniz, o algılanan zayıflığı bir güce dönüştürürüm. -Michael Jordan"
    },
    "2024-11-15": {
        "content": " Çoğumuz için en büyük tehlike hedefimizi çok yükseğe koyup hedefimize ulaşamamak değil; hedefimizi çok düşük tutup hedefimize ulaşamamaktır. -Michelangelo"
    },
    "2024-11-16": {
        "content": " Herkesin bir hayali vardır ama herkesin bir çabası yoktur. -Eric Thomas"
    },
    "2024-11-17": {
        "content": "Liderler yapılır, doğmazlar. Onlar sıkı çabayla yapılırlar, bu da değerli herhangi bir hedefe ulaşmak için hepimizin ödemesi gereken bedeldir. -Vince Lombardi"
    },
    "2024-11-18": {
        "content": " Bu on yılda aya gitmeyi ve diğer şeyleri yapmayı seçiyoruz. Kolay oldukları için değil, zor oldukları için. -John F. Kennedy"
    },
    "2024-11-19": {
        "content": " Senin ve benim hayatımızdaki en büyük gün, tutumlarımız için tüm sorumluluğu aldığımız gündür. İşte o gün gerçekten büyüdüğümüz gündür. -John C. Maxwell"
    },
    "2024-11-20": {
        "content": " Birine her gülümsediğinizde, bu bir sevgi eylemidir, o kişiye bir hediyedir, güzel bir şeydir. -Rahibe Teresa"
    },
    "2024-11-21": {
        "content": " Düşüncelerinizin ve davranışlarınızın sessiz izleyicisi olun. Düşünenin altındasınız. Zihinsel gürültünün altındaki dinginliksiniz. Acının altındaki sevgi ve neşesiniz. -Eckhart Tolle"
    },
    "2024-11-22": {
        "content": " Uçamıyorsan koş, koşamıyorsan yürü, yürüyemiyorsan sürün, ama ne yaparsan yap ilerlemeye devam etmelisin. -Martin Luther King Jr."
    },
    "2024-11-23": {
        "content": " Affetmek ara sıra yapılan bir eylem değil, sürekli bir tutumdur. -Martin Luther King Jr."
    },
    "2024-11-24": {
        "content": " Çoğu zaman bir dokunuşun, bir gülümsemenin, nazik bir sözün, dinleyen bir kulağın, içten bir iltifatın veya en ufak bir şefkat eyleminin gücünü hafife alırız; bunların hepsi bir hayatı değiştirme potansiyeline sahiptir. -Leo Buscaglia"
    },
    "2024-11-25": {
        "content": "Hayallerinizi canlı tutun. Herhangi bir şeyi başarmanın kendinize olan inanç ve güven, vizyon, sıkı çalışma, kararlılık ve özveri gerektirdiğini anlayın. İnananlar için her şeyin mümkün olduğunu unutmayın. -Gail Devers"
    },
    "2024-11-26": {
        "content": " Sporun dünyayı değiştirme gücü vardır. İlham verme gücü vardır. İnsanları başka hiçbir şeyin yapamayacağı şekilde birleştirme gücü vardır. Gençlere anladıkları bir dilde konuşur. Spor, bir zamanlar sadece umutsuzluk olan yerde umut yaratabilir. -Nelson Mandela"
    },
    "2024-11-27": {
        "content": " İstediğini iste. Bunu hak ettiğine inan ve sonra Hayatın onu sana vermesine izin ver. -Louise Hay"
    },
    "2024-11-28": {
        "content": " Niyetli yaşa. Sınıra kadar yürü. İyi dinle. Sağlıklı olmayı uygula. Terk edilmiş bir şekilde oyna. Gül. Pişman olmadan seç. Arkadaşlarına değer ver. Öğrenmeye devam et. Sevdiğin şeyi yap. Sanki her şey bundan ibaretmiş gibi yaşa. -Mary Anne Radmacher"
    },
    "2024-11-29": {
        "content": " Neye odaklanırsanız onu büyütürsünüz ve hayatınızdaki iyiliğe odaklandığınızda daha fazlasını yaratırsınız. -Oprah Winfrey"
    },
    "2024-11-30": {
        "content": " Zihniniz üzerinde gücünüz var, dış olaylar üzerinde değil. Bunu fark edin ve güç bulacaksınız. -Marcus Aurelius"
    },
    "2024-12-01": {
        "content": "Neden yapamayacağınıza dair bahaneler üretmeyin. Bunu neden yapmanız gerektiğine dair tüm nedenlere odaklanın. -Ralph Marston"
    },
    "2024-12-02": {
        "content": " Aşkın olduğu yerde hayat vardır. -Mahatma Gandi"
    },
    "2024-12-03": {
        "content": " Hiç kimse izlemiyormuş gibi dans etmelisin, asla incinmeyecekmiş gibi sevmelisin, hiç kimse dinlemiyormuş gibi şarkı söylemelisin ve yeryüzünde cennetmiş gibi yaşamalısın. -William W. Purkey"
    },
    "2024-12-04": {
        "content": " Başarı, hayattaki amacınızı bilmek, maksimum potansiyelinize ulaşmak için büyümek ve başkalarına fayda sağlayacak tohumlar ekmektir. -John C. Maxwell"
    },
    "2024-12-05": {
        "content": " Tek başınıza kurduğunuz bir rüya sadece bir rüyadır. Birlikte kurduğunuz bir rüya ise gerçekliktir. -John Lennon"
    },
    "2024-12-06": {
        "content": " Hayatın gerçek sırrı, burada ve şimdi yaptığınız şeyle tamamen meşgul olmaktır. Ve buna iş demek yerine, bunun bir oyun olduğunu fark edin. -Alan Watts"
    },
    "2024-12-07": {
        "content": " Dün geçti. Yarın henüz gelmedi. Sadece bugünümüz var. Başlayalım. -Rahibe Teresa"
    },
    "2024-12-08": {
        "content": " Hayatınızı ne kadar çok över ve kutlarsanız, hayatta kutlanacak o kadar çok şey olur. -Oprah Winfrey"
    },
    "2024-12-09": {
        "content": "Düşünceli, kararlı bir grup vatandaşın dünyayı değiştirebileceğinden asla şüphe etmeyin. Gerçekten de, bunu başaran tek şey budur. -Margaret Mead"
    },
    "2024-12-10": {
        "content": " Kendinizi zorlayın, çünkü bunu sizin için kimse yapmayacak. -Anonim"
    },
    "2024-12-11": {
        "content": " Gerçek tevazu, kendinizi küçümsemek değil; kendinizi daha az düşünmektir. -CS Lewis"
    },
    "2024-12-12": {
        "content": " Eğer zihninizi değiştirebilirseniz, hayatınızı değiştirebilirsiniz. -William James"
    },
    "2024-12-13": {
        "content": " Korktuğunuz şeye değil, gitmek istediğiniz yere odaklanın. -Tony Robbins"
    },
    "2024-12-14": {
        "content": " Kendinize saygı gösterin, başkaları da size saygı duyacaktır. -Konfüçyüs"
    },
    "2024-12-15": {
        "content": " Elinizde olanla, bulunduğunuz yerde elinizden geleni yapın. -Theodore Roosevelt"
    },
    "2024-12-16": {
        "content": " Bazı değişimler ilk bakışta olumsuz gibi görünse de, kısa sürede hayatınızda yeni bir şeyin ortaya çıkması için alan açıldığını fark edeceksiniz. -Eckhart Tolle"
    },
    "2024-12-17": {
        "content": " Eğer eylemleriniz başkalarına daha fazla hayal kurma, daha fazla öğrenme, daha fazla şey yapma ve daha fazlası olma konusunda ilham veriyorsa, siz bir lidersiniz. -John Quincy Adams"
    },
    "2024-12-18": {
        "content": " Hiçbir şey için endişelenme, her şey yoluna girecek. -Bob Marley"
    },
    "2024-12-19": {
        "content": " Büyük hayaller kurun, pozitif kalın, sıkı çalışın ve yolculuğun tadını çıkarın. -Urijah Faber"
    },
    "2024-12-20": {
        "content": "Evrenin ilahi amacının açığa çıkmasını sağlamak için buradasınız. İşte bu kadar önemlisiniz! -Eckhart Tolle"
    },
    "2024-12-21": {
        "content": " Tutkuyla yaşa! -Tony Robbins"
    },
    "2024-12-22": {
        "content": " Başarabileceğinize inanın, yolun yarısını kat etmiş olursunuz. -Theodore Roosevelt"
    },
    "2024-12-23": {
        "content": " Hayatımız, önemsediğimiz şeyler hakkında sessiz kaldığımız gün son bulmaya başlar. -Martin Luther King Jr."
    },
    "2024-12-24": {
        "content": " Birlikte büyük işler başarabiliriz. -Rahibe Teresa"
    },
    "2024-12-25": {
        "content": " Umursamadığımız bir şey için çok çalışmaya stres denir; sevdiğimiz bir şey için çok çalışmaya ise tutku denir. -Simon Sinek"
    },
    "2024-12-26": {
        "content": " Girmekten korktuğun mağara, aradığın hazineyi barındırır. -Joseph Campbell"
    },
    "2024-12-27": {
        "content": " Liderlik empatiyle ilgilidir. İnsanların hayatlarına ilham verme ve onları güçlendirme amacıyla onlarla ilişki kurma ve bağlantı kurma yeteneğine sahip olmakla ilgilidir. -Oprah Winfrey"
    },
    "2024-12-28": {
        "content": " Deneyen için imkansız diye bir şey yoktur. -Büyük İskender"
    },
    "2024-12-29": {
        "content": " Dünyadaki en önemli şeylerin çoğu, hiçbir umut yokmuş gibi göründüğünde bile denemeye devam eden insanlar tarafından başarılmıştır. -Dale Carnegie"
    },
    "2024-12-30": {
        "content": " Sürekli ileriye doğru hareket ediyoruz, yeni kapılar açıyoruz, yeni şeyler yapıyoruz çünkü meraklıyız ve merak bizi sürekli yeni yollara götürüyor. -Walt Disney"
    },
    "2024-12-31": {
        "content": "İstediğini yapana kadar yapman gerekeni yap. -Oprah Winfrey"
    },
    "2025-01-01": {
        "content": " Yeterli olduğunuza inanmak, size özgün olma cesaretini verir. -Brené Brown"
    },
    "2025-01-02": {
        "content": " Harry, yeteneklerimizden çok, seçimlerimiz aslında kim olduğumuzu gösterir. -JK Rowling"
    },
    "2025-01-03": {
        "content": " Mutluluğunuzun peşinden gidin, evren size duvarların olduğu yerlerde kapılar açacaktır. -Joseph Campbell"
    },
    "2025-01-04": {
        "content": " Rüyalar uyurken gelenler değil, uyumadan gerçekleşenlerdir. -Abdul Kelam"
    },
    "2025-01-05": {
        "content": " Cesaret etmek, savunmasız olma cesaretini göstermek anlamına gelir. Ortaya çıkmak ve görülmek anlamına gelir. İhtiyacınız olanı istemek. Nasıl hissettiğiniz hakkında konuşmak. Zor konuşmaları yapmak anlamına gelir. -Brené Brown"
    },
    "2025-01-06": {
        "content": " Acınızı büyüklüğe dönüştürmediğiniz sürece, acınızın sizi olduğunuz yerden sizi olmanız gereken yere itmesine izin vermediğiniz sürece asla başarılı olamazsınız. Acınızdan kaçmayı bırakın ve acınızı kucaklayın. Acınız ödülünüzün bir parçası, ürününüzün bir parçası olacak. Kendinizi zorlamanız için sizi meydan okuyorum. -Eric Thomas"
    },
    "2025-01-07": {
        "content": " Biz, tekrar tekrar yaptığımız şeyiz. Bu nedenle mükemmellik bir eylem değil, bir alışkanlıktır. -Aristo"
    },
    "2025-01-08": {
        "content": " Bir nehrin kayayı delmesi gücünden değil, ısrarcılığından kaynaklanır. -Jim Watkins"
    },
    "2025-01-09": {
        "content": " Enerji ve azim her şeyi yener. -Benjamin Franklin"
    },
    "2025-01-10": {
        "content": " Fırsatlar genellikle sıkı çalışma kisvesi altında gelir, bu yüzden çoğu insan onları fark etmez. -Ann Landers"
    },
    "2025-01-11": {
        "content": " Uçamıyorsan koş, koşamıyorsan yürü, yürüyemiyorsan sürün, ama ne yaparsan yap ilerlemeye devam etmelisin. -Martin Luther King Jr."
    },
    "2025-01-12": {
        "content": " Azim, sonuçların kaçınılmaz olduğunun garantisidir. -Paramahansa Yogananda"
    },
    "2025-01-13": {
        "content": " Sıradan bir yetenek ve olağanüstü bir azimle her şey başarılabilir -Thomas Fowell Buxton"
    },
    "2025-01-14": {
        "content": " En büyük zaferimiz hiçbir zaman başarısız olmamak değil, her başarısız olduğumuzda ayağa kalkabilmektir. -Ralph Waldo Emerson"
    },
    "2025-01-15": {
        "content": " Başarı, coşkuyu kaybetmeden başarısızlıktan başarısızlığa koşmaktır. -Winston Churchill"
    },
    "2025-01-16": {
        "content": "Neyse ki, azim yeteneğin harika bir alternatifidir. -Steve Martin"
    },
    "2025-01-17": {
        "content": " Şansa daha çok inanıyorum ve ne kadar çok çalışırsam şansımın o kadar arttığını görüyorum -Thomas Jefferson"
    },
    "2025-01-18": {
        "content": " Yarına ertelediğin tek şey, ölmeyi göze aldığın ve yarım bıraktığın şeylerdir. -Pablo Picasso"
    },
    "2025-01-19": {
        "content": " Başarının sırları yoktur: bunları aramakla zaman kaybetmeyin. Başarı, mükemmeliyetin, sıkı çalışmanın, başarısızlıktan ders çıkarmanın, çalıştığınız kişilere sadakatin ve ısrarcılığın sonucudur. -Colin Powell"
    },
    "2025-01-20": {
        "content": " Önde olmak istiyorsan, arkadaymış gibi davran. -Lao Tzu"
    },
    "2025-01-21": {
        "content": " Hedefime ulaşmamı sağlayan sırrımı söyleyeyim: Benim gücüm sadece azmimdedir. -Louis Pasteur"
    },
    "2025-01-22": {
        "content": " Bu dünyada hiçbir şey azmin yerini tutamaz. Yetenek tutamaz; yetenekli ama başarısız insanlardan daha yaygın bir şey yoktur. Deha tutamaz; ödüllendirilmeyen deha neredeyse bir atasözüdür. -Calvin Coolidge"
    },
    "2025-01-23": {
        "content": " En iyi çıkış yolu her zaman içinden geçmektir. -Robert Frost"
    },
    "2025-01-24": {
        "content": "Hayattaki birçok başarısızlığın sebebi, pes ettiklerinde başarıya ne kadar yakın olduklarını fark edemeyen insanlardır. -Thomas A. Edison"
    },
    "2025-01-25": {
        "content": " Biz ısrarcı olmak için yaratıldık. Bu şekilde kim olduğumuzu öğreniriz. -Tobias Wolff"
    },
    "2025-01-26": {
        "content": " Ağaçları tanıdığımda sabrın anlamını anlıyorum. Çimleri tanıdığımda ise azmin değerini anlayabiliyorum. -Hal Borland"
    },
    "2025-01-27": {
        "content": " Damlayan su, taşı kuvvetle değil ısrarla oyar. -Ovid"
    },
    "2025-01-28": {
        "content": " Azim çok önemlidir. Vazgeçmeye zorlanmadığınız sürece vazgeçmemelisiniz. -Elon Musk"
    },
    "2025-01-29": {
        "content": " At sağduyusu ve azimle desteklenen ateşli coşku, çoğu zaman başarıyı getiren özelliktir. -Dale Carnegie"
    },
    "2025-01-30": {
        "content": " Hırs başarıya giden yoldur. Azim ise ulaştığınız araçtır. -Bill Bradley"
    },
    "2025-01-31": {
        "content": " Soruna değil, çözüme odaklanın. -Walter Anderson"
    },
    "2025-02-01": {
        "content": " Hayat seni yere serdiğinde iki seçeneğin vardır; ya yerde kalırsın ya da ayağa kalkarsın. -Tom Krause"
    },
    "2025-02-02": {
        "content": "Başarı, her gün tekrarlanan küçük çabaların toplamıdır. -Robert Collier"
    },
    "2025-02-03": {
        "content": " Bir rüya sadece bir rüyadır. Bir hedef, bir planı ve bir son tarihi olan bir rüyadır. -Harvey MacKay"
    },
    "2025-02-04": {
        "content": " Hiçbir zaman düşünmeden bir gün geçiremeyeceğiniz bir şeyden vazgeçmeyin. -Winston Churchill"
    },
    "2025-02-05": {
        "content": " Elmaslar, görevlerini yerine getiren kömür parçalarından başka bir şey değildir. -Malcolm S. Forbes"
    },
    "2025-02-06": {
        "content": " Azar azar bir şeyler yapmaktan başka bir şey yapılamaz. -Charles Baudelaire"
    },
    "2025-02-07": {
        "content": " Cehennemden geçiyorsan, devam et. -Winston Churchill"
    },
    "2025-02-08": {
        "content": " Azmin anahtarı, dirençle kapalı olan bütün kapıları açar. -John Di Lemme"
    },
    "2025-02-09": {
        "content": " Dünyanın en başarılı insanlarına baktığımızda hepsinin ortak paydasının azim olduğunu görürüz. -Justin Sachs"
    },
    "2025-02-10": {
        "content": " Bir fili parça parça yiyebilirsiniz. -Mary Kay Külü"
    },
    "2025-02-11": {
        "content": " Herhangi bir tür başarı için azim niteliği kadar önemli başka bir nitelik olduğunu düşünmüyorum. Neredeyse her şeyin üstesinden gelir, hatta doğanın bile. -John D. Rockefeller"
    },
    "2025-02-12": {
        "content": "Bir vizyonu gerçeğe dönüştürmek istiyorsanız %100'ünüzü vermeli ve hayalinize inanmayı asla bırakmamalısınız. -Arnold Schwarzenegger"
    },
    "2025-02-13": {
        "content": " Koşabildiğinizde koşun, yürümeniz gerektiğinde yürüyün, sürünmeniz gerektiğinde sürün; ama asla pes etmeyin. -Dekan Karnazes"
    },
    "2025-02-14": {
        "content": " Yapamayacağınızı düşündüğünüzde bir tur daha atmak, hayatınızda fark yaratan şeydir. -Sylvester Stallone"
    },
    "2025-02-15": {
        "content": " Beni dinle, kaybettiğinde bile kaybetmek sorun değil, ama bununla asla rahat edemezsin. Kaybetmekten asla memnun olamazsın. Kaybettiğinde, acı çekmen gerekir. -Eric Thomas"
    },
    "2025-02-16": {
        "content": " Adım adım yürümeye devam edin. -Joyce Meyer"
    },
    "2025-02-17": {
        "content": " Pes etmemeli ve sorunun bizi yenmesine izin vermemeliyiz. -Abdul Kelam"
    },
    "2025-02-18": {
        "content": " Sabrederek fethederiz. -Ernest Shackleton"
    },
    "2025-02-19": {
        "content": "Tuğla duvarlar bir sebepten dolayı oradadır. Tuğla duvarlar bizi dışarıda tutmak için orada değildir. Tuğla duvarlar bize bir şeyi ne kadar çok istediğimizi gösterme şansı vermek için oradadır. Çünkü tuğla duvarlar onu yeterince kötü istemeyen insanları durdurmak için oradadır. Diğer insanları durdurmak için oradadırlar. -Randy Pausch"
    },
    "2025-02-20": {
        "content": " Başarı neredeyse tamamen azim ve sebatkarlığa bağlıdır. Başka bir çaba göstermek veya başka bir yaklaşımı denemek için gereken ekstra enerji, kazanmanın sırrıdır. -Denis Waitley"
    },
    "2025-02-21": {
        "content": " Buraya kadar gelmiştim ve pes etmeyi reddettim çünkü hayatım boyunca hep yarışı bitirmiştim. -Louis Zamperini"
    },
    "2025-02-22": {
        "content": " Hayatta kalma üç kelimeyle özetlenebilir - asla pes etme. Aslında meselenin özü bu. Sadece denemeye devam et. -Ayı Grylls"
    },
    "2025-02-23": {
        "content": "ARTIK YOK. Artık bahane yok. Artık: \"Yarın başlayacağım.\" Artık: \"Sadece bu seferlik.\" Artık kendi irademin eksikliklerini kabul etmiyorum. Artık kolay yolu seçmiyorum. Artık zihnimden geçen sağlıksız veya verimsiz düşüncelere boyun eğmiyorum. -Jocko Willink"
    },
    "2025-02-24": {
        "content": " Küçük darbelerle büyük meşeler devrilir. -Benjamin Franklin"
    },
    "2025-02-25": {
        "content": " İstekliyim.” “Kazanmak için programlandım.” “Bunu başarabilirim.” “Belirsizliği kucaklıyorum.” “Ben düşüncelerim değilim; ben yaptıklarımım.” “Ben amansızım.” “Hiçbir şey beklemiyorum ve her şeyi kabul ediyorum. -Gary John Bishop"
    },
    "2025-02-26": {
        "content": " 700 kez başarısız olmadım. Bir kez bile başarısız olmadım. O 700 yolun işe yaramayacağını kanıtlamayı başardım. İşe yaramayacak yolları elediğimde, işe yarayacak yolu bulacağım. -Thomas A. Edison"
    },
    "2025-02-27": {
        "content": " GRIT, Cesaret, Dayanıklılık, Çalışkanlık ve Azimdir. GRIT, odaklanma, kararlı kalma, bir zorlukla karşı karşıya kalındığında iyimser kalma ve diğer erkeklerden veya kadınlardan daha çok çalışma yeteneğidir. -Linda Kaplan Thaler"
    },
    "2025-02-28": {
        "content": "Sanırım sırrım, sıkı çalışmanın, kararlılığın ve 'vazgeçmeme' tavrının kısayollarının olmaması. -Jerry Rice"
    },
    "2025-03-01": {
        "content": " Kaderinizdeki yere varana kadar, yani eşsiz siz olana kadar mücadeleyi asla bırakmayın. Hayatta bir amacınız olsun, sürekli bilgi edinin, sıkı çalışın ve harika hayatı gerçekleştirmek için azimli olun. -Abdul Kelam"
    },
    "2025-03-02": {
        "content": " Yorulduğunuzda durmayın. Bitirdiğinizde durun. -David Goggins"
    },
    "2025-03-03": {
        "content": " Beni başarılarımla yargılamayın, kaç kez düşüp tekrar ayağa kalktığımla yargılayın. -Nelson Mandela"
    },
    "2025-03-04": {
        "content": " Bugün başlanmayan iş, yarın asla bitmez. -Johann Wolfgang von Goethe"
    },
    "2025-03-05": {
        "content": " Yüz tane kısa hikaye yazarsanız ve hepsi kötüyse, bu başarısız olduğunuz anlamına gelmez. Sadece yazmayı bırakırsanız başarısız olursunuz. -Ray Bradbury"
    },
    "2025-03-06": {
        "content": " Usta, yeni başlayanın denediğinden daha fazla başarısızlığa uğramıştır. -Stephen McCranie"
    },
    "2025-03-07": {
        "content": " Şartlar cehenneme, ben fırsatları yaratırım. -Bruce Lee"
    },
    "2025-03-08": {
        "content": "Bir şeye başlayıp başarısız olmaktan daha kötü olan tek şey, bir şeye başlamamaktır. -Seth Godin"
    },
    "2025-03-09": {
        "content": " Bugün yapabileceğin işi asla yarına bırakma. -Benjamin Franklin"
    },
    "2025-03-10": {
        "content": " Salyangoz azimle gemiye ulaştı. -Charles H. Spurgeon"
    },
    "2025-03-11": {
        "content": " Unutmayın, umut iyi bir şeydir, belki de en iyi şeydir ve hiçbir iyi şey asla ölmez. -Stephen King"
    },
    "2025-03-12": {
        "content": " Girişimciler yorgun olduğumuzda bitirmezler. İşimiz bitince bitiririz. -Robert T. Kiyosaki"
    },
    "2025-03-13": {
        "content": " Yalnızca azim ve kararlılık her şeye kadirdir. -Calvin Coolidge"
    },
    "2025-03-14": {
        "content": " Direnci ısrarla felç edin. -Woody Hayes"
    },
    "2025-03-15": {
        "content": " Başarı hiçbir zaman sahip olunamaz, kiralanır ve kirası her gün ödenir. -Rory Vaden"
    },
    "2025-03-16": {
        "content": " Başarı tesadüf değildir. Sıkı çalışma, azim, öğrenme, çalışma, fedakarlık ve en önemlisi yaptığınız veya yapmayı öğrendiğiniz şeye olan sevgidir. -Pele"
    },
    "2025-03-17": {
        "content": " Zor işin etrafından dolanmanın bir yolu yok. Onu kucakla. -Roger Federer"
    },
    "2025-03-18": {
        "content": " Bir hayalin gerçeğe dönüşmesi sihirle olmaz; ter, kararlılık ve sıkı çalışma gerektirir. -Colin Powell"
    },
    "2025-03-19": {
        "content": "Öğrenmek zihni asla yormaz. -Leonardo da Vinci"
    },
    "2025-03-20": {
        "content": " Duyuyorum ve unutuyorum. Görüyorum ve hatırlıyorum. Yapıyorum ve anlıyorum. -Konfüçyüs"
    },
    "2025-03-21": {
        "content": " Hiç hata yapmamış olan insan, hiç yeni bir şey denememiştir. -Albert Einstein"
    },
    "2025-03-22": {
        "content": " Her şey hakkında bir şeyler, bir şey hakkında da her şeyi öğrenmeye çalışın. -Thomas Henry Huxley"
    },
    "2025-03-23": {
        "content": " İnsan ancak iki şekilde öğrenir; biri okuyarak, diğeri de daha akıllı insanlarla arkadaşlık ederek. -Will Rogers"
    },
    "2025-03-24": {
        "content": " Bir şeyi birden fazla şekilde öğrenmedikçe hiçbir şeyi anlayamazsın. -Marvin Minsky"
    },
    "2025-03-25": {
        "content": " Bana söyle unutayım, bana öğret hatırlayayım, beni dahil et öğreneyim. -Benjamin Franklin"
    },
    "2025-03-26": {
        "content": " Başarı oranınızı artırmak istiyorsanız, başarısızlık oranınızı iki katına çıkarın. -Thomas J. Watson"
    },
    "2025-03-27": {
        "content": " Zekâ, ne yapacağını bilmediğin zaman kullandığın şeydir. -Jean Piaget"
    },
    "2025-03-28": {
        "content": " 21. yüzyılın cahili, okuma yazma bilmeyenler değil, öğrenemeyen, öğrendiklerini unutamayan ve yeniden öğrenemeyenler olacaktır. -Alvin Toffler"
    },
    "2025-03-29": {
        "content": "Öğrenmemizi engelleyen şey çoğu zaman bildiklerimizdir. -Claude Bernard"
    },
    "2025-03-30": {
        "content": " Matematik, Tanrı'nın evreni yazdığı dildir. -Galileo Galilei"
    },
    "2025-03-31": {
        "content": " Eğitimin bütün amacı aynaları pencereye dönüştürmektir. -Sidney J. Harris"
    },
    "2025-04-01": {
        "content": " Fırtınalardan korkmuyorum çünkü gemimi nasıl yelkenleyeceğimi öğreniyorum. -Louisa May Alcott"
    },
    "2025-04-02": {
        "content": " Eğitimli olan tek kişi, öğrenmeyi ve değişmeyi öğrenmiş olan kişidir. -Carl R. Rogers"
    },
    "2025-04-03": {
        "content": " Hiçbir zaman kendisinden bir şey öğrenemeyeceğim kadar cahil bir adamla karşılaşmadım. -Galileo Galilei"
    },
    "2025-04-04": {
        "content": " Hiçbir şey bize bilmemiz gerekeni öğretmeden ortadan kalkmaz. -Pema Chödrön"
    },
    "2025-04-05": {
        "content": " Alıştırma mükemmelleştirir. Uzun süreli pratikten sonra, işimiz doğal, becerikli, hızlı ve istikrarlı hale gelecektir. -Bruce Lee"
    },
    "2025-04-06": {
        "content": " Konuştuğunuzda sadece zaten bildiğiniz bir şeyi tekrarlıyorsunuz. Ancak, dinlerseniz yeni bir şey öğrenebilirsiniz. -Dalay Lama XIV"
    },
    "2025-04-07": {
        "content": " Mükemmelliğe değil, ilerlemeye çabalayın. -Anonim"
    },
    "2025-04-08": {
        "content": "Ben hep henüz yapamadığım şeyleri yapıyorum, nasıl yapacağımı öğrenmek için. -Vincent van Gogh"
    },
    "2025-04-09": {
        "content": " Bilgi, insanı köle olmaya elverişsiz kılar. -Frederick Douglass"
    },
    "2025-04-10": {
        "content": " Bir şeyin adını bilmekle, onu bilmek arasındaki farkı çok erken öğrendim. -Richard P. Feynman"
    },
    "2025-04-11": {
        "content": " Öğrenme kapasitesi bir armağandır; öğrenme yeteneği bir beceridir; öğrenme isteği ise bir seçimdir. -Brian Herbert"
    },
    "2025-04-12": {
        "content": " Öğrenebildiğiniz her şeyi, mümkün olan her zaman, herkesten öğrenin; bunu yaptığınız için minnettar olacağınız bir zaman mutlaka gelecektir. -Sarah Caldwell"
    },
    "2025-04-13": {
        "content": " Dün olduğundan daha akıllı olmayan bir adam hakkında pek fazla bir şey düşünmem. -Abraham Lincoln"
    },
    "2025-04-14": {
        "content": " Başarının anahtarı yaşam boyu öğrenmeye adanmışlıktır. -Stephen R. Covey"
    },
    "2025-04-15": {
        "content": " Tutkulu ve cesur olun. Her zaman öğrenmeye devam edin. Öğrenmezseniz yararlı şeyler yapmayı bırakırsınız. -Satya Nadella"
    },
    "2025-04-16": {
        "content": "İnsanın ulaşabileceği en yüksek etkinlik, anlamak için öğrenmektir; çünkü anlamak özgür olmaktır. -Baruch Spinoza"
    },
    "2025-04-17": {
        "content": " Öğrenmeye devam etmezseniz, diğer insanlar sizi geçecektir. Sadece mizaç bunu başaramaz - uzun, uzun bir süre boyunca çok fazla meraka ihtiyacınız var. -Charlie Munger"
    },
    "2025-04-18": {
        "content": " Öğrenen organizasyon, geleceğini yaratma kapasitesini sürekli olarak genişleten bir organizasyondur. -Peter Senge"
    },
    "2025-04-19": {
        "content": " Öğrenmeyi bıraktığınız gün, çürümeye başladığınız gündür. -Isaac Asimov"
    },
    "2025-04-20": {
        "content": " İlim, refah zamanında süs, sıkıntı zamanında sığınak, yaşlılıkta ise geçim kaynağıdır. -Aristo"
    },
    "2025-04-21": {
        "content": " Tüm liderler öğrenendir. Öğrenmeyi bıraktığınız anda, liderlik etmeyi bırakırsınız. Mümkün olduğunca çok, mümkün olduğunca çok kişiden, mümkün olduğunca sık öğrenirim. -Rick Warren"
    },
    "2025-04-22": {
        "content": " Zor şeyleri hızlı bir şekilde öğrenmek için, dikkat dağıtıcı unsurlar olmadan yoğun bir şekilde odaklanmalısınız. Öğrenmek, başka bir deyişle, derin bir çalışma eylemidir. -Cal Newport"
    },
    "2025-04-23": {
        "content": " Herhangi bir aptal bile bilebilir. Önemli olan anlamaktır. -Albert Einstein"
    },
    "2025-04-24": {
        "content": "Her gününüzü uyandığınızda olduğunuzdan biraz daha akıllı olmaya çalışarak geçirin. -Charlie Munger"
    },
    "2025-04-25": {
        "content": " Kendinize, eğitiminize yatırım yapın. Bundan iyisi yok. -Sylvia Porter"
    },
    "2025-04-26": {
        "content": " Kendimi eğitmek benim için sürekli bir zevk kaynağıdır, çünkü ne kadar çok şey bilirsem, hayatım o kadar dolu olur ve kendi varlığımı o kadar iyi takdir ederim. -Isaac Asimov"
    },
    "2025-04-27": {
        "content": " Öğretmenlerden yardım alabilirsiniz ama çok şeyi kendi başınıza, bir odada tek başınıza oturarak öğrenmeniz gerekecek. -Dr. Seuss"
    },
    "2025-04-28": {
        "content": " Öğrenme, öğretmek isteyenle değil, öğrenmek isteyenle gerçekleşir. -Roger Schank"
    },
    "2025-04-29": {
        "content": " Bir kişi bir başka kişiye doğrudan bir şey öğretemez; bir kişi sadece bir başkasının öğrenmesini kolaylaştırabilir. -Carl R. Rogers"
    },
    "2025-04-30": {
        "content": " Öğrenmek zorunlu değildir; gönüllüdür. Gelişim zorunlu değildir; gönüllüdür. Ancak hayatta kalmak için öğrenmeliyiz. -W. Edwards Deming"
    },
    "2025-05-01": {
        "content": " Ben her zaman yapamadığım şeyi yapıyorum ki, onu nasıl yapacağımı öğreneyim. -Pablo Picasso"
    },
    "2025-05-02": {
        "content": "Hiçbir hırsız, ne kadar usta olursa olsun, bir insanın bilgisini çalamaz. İşte bu yüzden bilgi, edinilebilecek en iyi ve en güvenli hazinedir. -L. Frank Baum"
    },
    "2025-05-03": {
        "content": " Bence verilebilecek en iyi tavsiye şu: Sürekli olarak, işleri nasıl daha iyi yapabileceğinizi düşünün ve kendinizi sorgulayın. -Elon Musk"
    },
    "2025-05-04": {
        "content": " Akıllı bir adam, aptal bir adamın akıllıca bir cevaptan öğrenebileceğinden daha fazlasını, aptalca bir sorudan öğrenebilir. -Bruce Lee"
    },
    "2025-05-05": {
        "content": " Eğer daha ileriyi görebildiysem, bu Devlerin omuzlarına basarak olmuştur. -Isaac Newton"
    },
    "2025-05-06": {
        "content": " Bildiklerimiz bir damla, bilmediklerimiz ise bir okyanustur. -Isaac Newton"
    },
    "2025-05-07": {
        "content": " Öğrenmenin en güzel yanı, onu sizden kimsenin alamamasıdır. -BB Kralı"
    },
    "2025-05-08": {
        "content": " Yazar olmak istiyorsanız her şeyden önce iki şeyi yapmalısınız: Çok okumak ve çok yazmak. -Stephen King"
    },
    "2025-05-09": {
        "content": " Tekrar, becerinin anasıdır. -Tony Robbins"
    },
    "2025-05-10": {
        "content": " Hayret, bilgeliğin başlangıcıdır. -Sokrates"
    },
    "2025-05-11": {
        "content": " Bir hata yapıp düzeltmezsen buna hata denir. -Konfüçyüs"
    },
    "2025-05-12": {
        "content": " Eğitimin amacı boş zihni açık zihinle değiştirmektir. -Malcolm S. Forbes"
    },
    "2025-05-13": {
        "content": "Hayatta korkulacak hiçbir şey yoktur, sadece anlaşılmalıdır. Şimdi daha fazlasını anlamanın zamanıdır, böylece daha az korkabiliriz. -Marie Curie"
    },
    "2025-05-14": {
        "content": " Bir işi yapıp yapamayacağınız sorulduğunda, onlara \"Elbette yapabilirim!\" deyin. Sonra harekete geçin ve nasıl yapılacağını öğrenin. -Theodore Roosevelt"
    },
    "2025-05-15": {
        "content": " Hepimizin bize geri bildirim verecek insanlara ihtiyacımız var. Bu şekilde gelişiriz. -Bill Gates"
    },
    "2025-05-16": {
        "content": " Eğitim, dünyanın kilidini açmanın anahtarı, özgürlüğe giden pasaporttur. -Oprah Winfrey"
    },
    "2025-05-17": {
        "content": " Her şey bir fikirle başlar. -Kont Nightingale"
    },
    "2025-05-18": {
        "content": " Yapabileceğiniz en iyi yatırım kendinize yaptığınızdır. -Warren Buffett"
    },
    "2025-05-19": {
        "content": " Bu para veya bağlantılarla ilgili değil. Herkesten daha fazla çalışmaya ve daha fazla öğrenmeye istekli olmaktır. -Mark Kübalı"
    },
    "2025-05-20": {
        "content": " Yaşadığınız sürece yaşamayı öğrenmeye devam edin. -Seneca"
    },
    "2025-05-21": {
        "content": " Başarmayı öğrenmek için önce başarısız olmayı öğrenmelisiniz. -Michael Jordan"
    },
    "2025-05-22": {
        "content": " İyi bir hatayı boşa harcamayın, ondan ders çıkarın. -Robert T. Kiyosaki"
    },
    "2025-05-23": {
        "content": "Bilgi edinmek için çalışmak gerekir; fakat hikmet edinmek için gözlem yapmak gerekir. -Marilyn Vos Savant"
    },
    "2025-05-24": {
        "content": " Yaşayıp öğreniyorsun. Her neyse, yaşıyorsun. -Douglas Adams"
    },
    "2025-05-25": {
        "content": " Sabır, hikmetin yoldaşıdır. -Aziz Augustinus"
    },
    "2025-05-26": {
        "content": " Ben sadece bir şey biliyorum, o da hiçbir şey bilmediğimdir. -Sokrates"
    },
    "2025-05-27": {
        "content": " Bilgelik deneyimden gelir. Deneyim genellikle bilgelik eksikliğinin bir sonucudur. -Terry Pratchett"
    },
    "2025-05-28": {
        "content": " İlerlememizi, sorularımızın cesaretine, cevaplarımızın derinliğine, iyi hissettiren şeylerden ziyade gerçek olanı benimsemeye olan istekliliğimize göre değerlendirebiliriz. -Carl Sagan"
    },
    "2025-05-29": {
        "content": " Soru sorulamayan cevaplardan çok, cevaplanamayan sorularım olmasını tercih ederim. -Richard P. Feynman"
    },
    "2025-05-30": {
        "content": " Öğretilmekten her zaman hoşlanmasam da öğrenmeye her zaman hazırım. -Winston Churchill"
    },
    "2025-05-31": {
        "content": " Teori olmadan pratiği seven kişi, dümeni ve pusulası olmayan ve nereye gideceğini asla bilemeyen denizciye benzer. -Leonardo da Vinci"
    },
    "2025-06-01": {
        "content": " Öğrenmektense yaratmak daha iyidir. Yaratmak hayatın özüdür. -Julius Sezar"
    },
    "2025-06-02": {
        "content": "El ne yaparsa akıl onu hatırlar. -Maria Montessori"
    },
    "2025-06-03": {
        "content": " Hayatınızda her zaman yeni bir şey öğrenecekmişsiniz gibi yürüyün, o zaman öğreneceksiniz. -Vernon Howard"
    },
    "2025-06-04": {
        "content": " Başarısızlık, ondan ders çıkarırsak başarıdır. -Malcolm S. Forbes"
    },
    "2025-06-05": {
        "content": " Eğitim en iyi arkadaştır. Eğitimli bir kişi her yerde saygı görür. Eğitim güzelliği ve gençliği yener. -Çanakya"
    },
    "2025-06-06": {
        "content": " Sizin için başarılması zor olan bir şeyin insan olarak imkânsız olduğunu düşünmeyin; ama eğer bir şey insan olarak mümkünse, onu ulaşabileceğiniz mesafede sayın. -Marcus Aurelius"
    },
    "2025-06-07": {
        "content": " Öğrenme, sürekli bir keşif sürecidir; sonu olmayan bir süreçtir. -Bruce Lee"
    },
    "2025-06-08": {
        "content": " Cahil olmak ayıp değil, öğrenmeye isteksiz olmaktır. -Benjamin Franklin"
    },
    "2025-06-09": {
        "content": " Bilginin güç olduğuna inanıyorum; geçmişi aşmak, içinde bulunduğumuz durumu değiştirmek, yeni engellerle mücadele etmek, daha iyi kararlar almak için. -Ben Carson"
    },
    "2025-06-10": {
        "content": " Nefes alırken, bedenimi ve zihnimi sakinleştiriyorum. Nefes verirken, gülümsüyorum. Şimdiki anda yaşayarak, bunun tek an olduğunu biliyorum. -Thich Nhat Hanh"
    },
    "2025-06-11": {
        "content": "Eğer bir fark yaratamayacak kadar küçük olduğunuzu düşünüyorsanız, bir sivrisinekle uyumayı deneyin. -Dalay Lama XIV"
    },
    "2025-06-12": {
        "content": " Çoğu zaman bir dokunuşun, bir gülümsemenin, nazik bir sözün, dinleyen bir kulağın, içten bir iltifatın veya en ufak bir şefkat eyleminin gücünü hafife alırız; bunların hepsi bir hayatı değiştirme potansiyeline sahiptir. -Leo Buscaglia"
    },
    "2025-06-13": {
        "content": " Günlerimizi nasıl geçirirsek, hayatımızı da öyle geçiriyoruz elbette. -Annie Dillard"
    },
    "2025-06-14": {
        "content": " Zihninizi büyük düşüncelerle besleyin, çünkü düşündüğünüzden daha yükseğe asla çıkamayacaksınız. -Benjamin Disraeli"
    },
    "2025-06-15": {
        "content": " Kurallara uyarak yürümeyi öğrenemezsin. Yaparak ve düşerek öğrenirsin. -Richard Branson"
    },
    "2025-06-16": {
        "content": " Bir şeyde başarısız olmadan yaşamak imkansızdır; ancak o kadar dikkatli yaşarsanız hiç yaşamamış sayılırsınız ki, otomatik olarak başarısız olursunuz. -JK Rowling"
    },
    "2025-06-17": {
        "content": " Mutlu olmak istiyorsan ol. -Leo Tolstoy"
    },
    "2025-06-18": {
        "content": " Hiç kimse benim iznim olmadan bana zarar veremez. -Mahatma Gandi"
    },
    "2025-06-19": {
        "content": " Ne olduğumu bıraktığımda, ne olabileceğim haline gelirim. -Lao Tzu"
    },
    "2025-06-20": {
        "content": "Güvensizlik duygusuyla boğuşmamızın sebebi, sahne arkasını başkalarının öne çıkan anlarıyla karşılaştırmamızdır. -Steven Furtick"
    },
    "2025-06-21": {
        "content": " Unutma, bugün dün endişelendiğin yarındır. -Dale Carnegie"
    },
    "2025-06-22": {
        "content": " Planladığımız hayattan vazgeçmeye razı olmalıyız ki, bizi bekleyen hayata sahip olabilelim. -Joseph Campbell"
    },
    "2025-06-23": {
        "content": " Gitmeyi bırak, varacaksın. Aramayı bırak, göreceksin. Kaçmayı bırak, bulunacaksın. -Lao Tzu"
    },
    "2025-06-24": {
        "content": " Bir ekip, birlikte çalışan bir grup insan değildir. Bir ekip, birbirine güvenen bir grup insandır. -Simon Sinek"
    },
    "2025-06-25": {
        "content": " Sürekli iyimserlik kuvvet çarpanıdır. -Colin Powell"
    },
    "2025-06-26": {
        "content": " Sadece kendiniz olmayı başardığınızda ve başkalarıyla kıyaslama veya rekabet yapmadığınızda, herkes size saygı duyacaktır. -Lao Tzu"
    },
    "2025-06-27": {
        "content": " Yaşını arkadaşların ile say, yılların ile değil. Hayatını gülümsemelerin ile say, gözyaşların ile değil. -John Lennon"
    },
    "2025-06-28": {
        "content": " Sevdiklerinize uçmaları için kanatlar, geri dönmeleri için kökler ve kalmaları için sebepler verin. -Dalay Lama XIV"
    },
    "2025-06-29": {
        "content": " Azim ve cesaret her çağda harikalar yaratmıştır. -George Washington"
    },
    "2025-06-30": {
        "content": "Bilginizi paylaşın. Ölümsüzlüğe ulaşmanın bir yoludur. -Dalay Lama XIV"
    },
    "2025-07-01": {
        "content": " Biz kozmosun kendini tanımasının bir yoluyuz. -Carl Sagan"
    },
    "2025-07-02": {
        "content": " İyi bir öğretmen umut aşılayabilir, hayal gücünü ateşleyebilir ve öğrenme sevgisi aşılayabilir. -Brad Henry"
    },
    "2025-07-03": {
        "content": " Bir insanın yapabileceği en büyük keşiflerden biri, en büyük sürprizlerinden biri, yapamayacağından korktuğu şeyi başarabilmesidir. -Henry Ford"
    },
    "2025-07-04": {
        "content": " En son ne zaman bir şeyi ilk defa yaptın? -John C. Maxwell"
    },
    "2025-07-05": {
        "content": " Olmak istediğiniz kişi olma sürecinde değilseniz, otomatik olarak olmak istemediğiniz kişiye dönüşmeye başlarsınız. -Dale Carnegie"
    },
    "2025-07-06": {
        "content": " Şans cesurların yanındadır. -Latince atasözü"
    },
    "2025-07-07": {
        "content": " Başarı mutluluğun anahtarı değildir. Mutluluk başarının anahtarıdır. Yaptığınız işi seviyorsanız başarılı olursunuz. -Albert Schweitzer"
    },
    "2025-07-08": {
        "content": " Dünyayı kazanıp da canını kaybetme; hikmet, gümüşten ve altından daha iyidir. -Bob Marley"
    },
    "2025-07-09": {
        "content": " Hemen yaşamaya başla ve her ayrı günü ayrı bir hayat olarak say. -Seneca"
    },
    "2025-07-10": {
        "content": "Senin gibi biri çok fazla umursamadığı sürece hiçbir şey düzelmeyecek. İyileşmiyor. -Dr. Seuss"
    },
    "2025-07-11": {
        "content": " Bunun imkansız olduğunu bilmiyorlardı ve bunu başardılar. -Mark Twain"
    },
    "2025-07-12": {
        "content": " Senin yapamadığın şeyleri ben yapabilirim, benim yapamadığım şeyleri sen yapabilirsin; birlikte çok büyük şeyler başarabiliriz. -Rahibe Teresa"
    },
    "2025-07-13": {
        "content": " Korkmamız gereken tek şey korkunun kendisidir. -Franklin D. Roosevelt"
    },
    "2025-07-14": {
        "content": " Coşku olmadan hiçbir büyük başarı elde edilemez. -Ralph Waldo Emerson"
    },
    "2025-07-15": {
        "content": " Cesaret, canım yüreğim. -CS Lewis"
    },
    "2025-07-16": {
        "content": " Değişimden anlam çıkarmanın tek yolu, ona dalmak, onunla birlikte hareket etmek ve dansa katılmaktır. -Alan Watts"
    },
    "2025-07-17": {
        "content": " Dikkatin olduğu yere enerji akar ve sonuçlar ortaya çıkar. -T. Harv Eker"
    },
    "2025-07-18": {
        "content": " Acı geçicidir. Bir dakika, bir saat, bir gün veya bir yıl sürebilir, ancak sonunda azalacaktır ve yerini başka bir şey alacaktır. Ancak bırakırsam sonsuza dek sürer. -Lance Armstrong"
    },
    "2025-07-19": {
        "content": " Doğayla yapılan her yürüyüşte, insan aradığından çok daha fazlasını bulur. -John Muir"
    },
    "2025-07-20": {
        "content": "Kazananlar asla başarısız olmayanlar değil, asla vazgeçmeyenlerdir. -Edwin Louis Cole"
    },
    "2025-07-21": {
        "content": " Karanlıkla savaşmak yerine, ışığı getirirsiniz. -Eckhart Tolle"
    },
    "2025-07-22": {
        "content": " Ruhunuzu ateşleyen şeylerin peşinde koşarken korkusuz olun. -Jennifer Lee"
    },
    "2025-07-23": {
        "content": " İnsanlar sizden uzaklaştığında, bırakın gitsinler. Kaderiniz sizi terk eden hiç kimseye bağlı değildir ve bu onların kötü insanlar olduğu anlamına gelmez. Bu sadece hikayenizdeki rollerinin bittiği anlamına gelir. -TD Jakes"
    },
    "2025-07-24": {
        "content": " Liderlik, vizyonu gerçeğe dönüştürme kapasitesidir. -Warren G. Bennis"
    },
    "2025-07-25": {
        "content": " İman, görmediğine inanmaktır; bu imanın mükafatı ise inandığını görmektir. -Aziz Augustinus"
    },
    "2025-07-26": {
        "content": " Hiçbir şey imkansız değildir, ta ki siz öyle olduğunu düşünmediğiniz sürece. -Paramahansa Yogananda"
    },
    "2025-07-27": {
        "content": " Kör olmaktan daha kötü olan tek şey, görebilmek ama vizyon sahibi olmamaktır. -Helen Keller"
    },
    "2025-07-28": {
        "content": " Her şeyin bir güzelliği vardır ama herkes bunu göremez. -Konfüçyüs"
    },
    "2025-07-29": {
        "content": " Allah, kalbin sessizliğinde konuşur. -Rahibe Teresa"
    },
    "2025-07-30": {
        "content": "Umut, ruha konan tüylü bir şeydir - ve sözsüz bir melodi söyler - ve asla durmaz. -Emily Dickinson"
    },
    "2025-07-31": {
        "content": " Ne kadar kutsal söz okursanız okuyun, ne kadar söylerseniz söyleyin, bunları uygulamazsanız size ne faydası olur? -Buda"
    },
    "2025-08-01": {
        "content": " Ve bu arada, eğer bunu yapacak dışa dönük cesaretiniz ve doğaçlama yapacak hayal gücünüz varsa, hayattaki her şey yazılabilir. Yaratıcılığın en büyük düşmanı kendinden şüphe duymaktır. -Sylvia Plath"
    },
    "2025-08-02": {
        "content": " Geçmişi değiştirecek hiçbir şey yapamayız ama yaptığımız her şey geleceği değiştirir. -Ashleigh Harika"
    },
    "2025-08-03": {
        "content": " Liderlik bir tercihtir. Bir rütbe değildir. -Simon Sinek"
    },
    "2025-08-04": {
        "content": " Her şey iyi olacak, her şey iyi olacak, her türlü şey iyi olacak. -Norwich'li Julian"
    },
    "2025-08-05": {
        "content": " Kozmik bakış açısına göre her birimiz değerliyiz. Eğer bir insan sizinle aynı fikirde değilse, bırakın yaşasın. Yüz milyar galakside bir tane daha bulamazsınız. -Carl Sagan"
    },
    "2025-08-06": {
        "content": " Zekâ artı karakter – işte gerçek eğitimin amacı budur. -Martin Luther King Jr."
    },
    "2025-08-07": {
        "content": "Kendinizi kendinizden daha büyük bir şeye ne kadar kaptırırsanız, o kadar fazla enerjiye sahip olursunuz. -Norman Vincent Peale"
    },
    "2025-08-08": {
        "content": " Temelleri öğrenin ve yaptığınız her şeyin seviyesi yükselecektir -Michael Jordan"
    },
    "2025-08-09": {
        "content": " Şimdi tam anlamıyla yaşayamazsan hiç yaşayamazsın. -Alan Watts"
    },
    "2025-08-10": {
        "content": " Bazen istediğinizi elde edememenin büyük bir şans olduğunu unutmayın. -Dalay Lama XIV"
    },
    "2025-08-11": {
        "content": " Elinizden gelenin en iyisini yapın ve sonra rahatlayın. İşleri zorlamak yerine doğal bir şekilde ilerlemesine izin verin. -Paramahansa Yogananda"
    },
    "2025-08-12": {
        "content": " Sen geçici bir insan deneyimi yaşayan sonsuz bir ruhsal varlıksın. -Wayne W. Dyer"
    },
    "2025-08-13": {
        "content": " Hayallerinizin gerçekleşmesi için önce hayal kurmanız gerekir. -Abdul Kelam"
    },
    "2025-08-14": {
        "content": " Her şeyden önce kalbinizi koruyun, çünkü yaptığınız her şey kalbinizden kaynaklanır. -Süleyman"
    },
    "2025-08-15": {
        "content": " Yazarken her şeyden sıyrılıyorum; üzüntülerim kayboluyor, cesaretim yeniden doğuyor. -Anne Frank"
    },
    "2025-08-16": {
        "content": " Amaç sonuna kadar mükemmel olmak değil. Amaç bugün daha iyi olmak. -Simon Sinek"
    },
    "2025-08-17": {
        "content": " Hayallerinizin doğrultusunda güvenle ilerleyin. Hayal ettiğiniz hayatı yaşayın. -Henry David Thoreau"
    },
    "2025-08-18": {
        "content": "Mümkün olduğunca nazik olun. Bu her zaman mümkündür. -Dalay Lama XIV"
    },
    "2025-08-19": {
        "content": " Bu hayattaki asıl amacımız başkalarına yardım etmektir. Ve eğer onlara yardım edemiyorsanız, en azından onlara zarar vermeyin. -Dalay Lama XIV"
    },
    "2025-08-20": {
        "content": " Kafanızın içinde beyniniz var. Ayakkabılarınızın içinde ayaklarınız var. Kendinizi istediğiniz yöne yönlendirebilirsiniz. Kendi başınızasınız. Ve ne bildiğinizi biliyorsunuz. Ve nereye gideceğinize karar verecek olan sizsiniz. -Dr. Seuss"
    },
    "2025-08-21": {
        "content": " Neye odaklanırsanız onu büyütürsünüz ve hayatınızdaki iyiliğe odaklandığınızda daha fazlasını yaratırsınız. -Oprah Winfrey"
    },
    "2025-08-22": {
        "content": " Bilmem gereken her şey bana açıklanıyor. İhtiyacım olan her şey bana geliyor. Hayatımda her şey yolunda. -Louise Hay"
    },
    "2025-08-23": {
        "content": " Evrende tamamen güvendeyim. Her yerde huzur içindeyim. Hayata güveniyorum. -Louise Hay"
    },
    "2025-08-24": {
        "content": " Yüzünü güneşe dön, gölgeler arkanda kalsın. -Maori Atasözü"
    },
    "2025-08-25": {
        "content": " Cesaret, devam edecek güce sahip olmak değil; gücün olmadığında devam edebilmektir. -Theodore Roosevelt"
    },
    "2025-08-26": {
        "content": " Gelecek, bugün ne yaptığınıza bağlıdır. -Mahatma Gandi"
    },
    "2025-08-27": {
        "content": " Kazanan, asla vazgeçmeyen hayalperesttir. -Nelson Mandela"
    },
    "2025-08-28": {
        "content": "Bittiği için ağlama, yaşandığı için gülümse. -Dr. Seuss"
    },
    "2025-08-29": {
        "content": " Hayat hakkında öğrendiğim her şeyi üç kelimeyle özetleyebilirim: Hayat devam ediyor. -Robert Frost"
    },
    "2025-08-30": {
        "content": " Hayallerinizle yaşayın, tarihinizle değil. -Stephen R. Covey"
    },
    "2025-08-31": {
        "content": " Benim bakış açıma göre, gökkuşağını istiyorsan yağmura katlanmalısın. -Dolly Parton"
    },
    "2025-09-01": {
        "content": " Bir insanın büyüklüğü, ne kadar çok servete sahip olduğuyla değil, dürüstlüğüyle ve etrafındakileri olumlu yönde etkileyebilme yeteneğiyle ölçülür. -Bob Marley"
    },
    "2025-09-02": {
        "content": " Mutluluk dış etkenlerden ziyade, esas olarak kendi tutumumuzdan kaynaklanır. -Dalay Lama XIV"
    },
    "2025-09-03": {
        "content": " Büyük işler küçük işlerden meydana gelir. -Lao Tzu"
    },
    "2025-09-04": {
        "content": " Ne olabileceğiniz konusunda asla geç değildir. -George Eliot"
    },
    "2025-09-05": {
        "content": " Doğru tutumu benimsemek olumsuz stresi olumluya dönüştürebilir. -Hans Selye"
    },
    "2025-09-06": {
        "content": " Kendiniz için hayal ettiğiniz hayatı yaşamaya cesaret edin. İlerleyin ve hayallerinizi gerçekleştirin. -Ralph Waldo Emerson"
    },
    "2025-09-07": {
        "content": " Boşa harcamaktan zevk aldığınız zaman, boşa harcanmış zaman değildir. -Bertrand Russell"
    },
    "2025-09-08": {
        "content": "Görmek ve anlamak için biraz uyanık olmak yeterli: Hayat aslında büyük bir kozmik kahkahadır. -Osho"
    },
    "2025-09-09": {
        "content": " İlginç bir paradoks şu ki, kendimi olduğum gibi kabul ettiğimde değişebilirim. -Carl R. Rogers"
    },
    "2025-09-10": {
        "content": " Sorunun değil, çözümün parçası olun. -Stephen R. Covey"
    },
    "2025-09-11": {
        "content": " Yaşamanın sırrı vermektir. -Tony Robbins"
    },
    "2025-09-12": {
        "content": " Her günü şaheseriniz yapın. -John Ahşap"
    },
    "2025-09-13": {
        "content": " Gerçekten yapmak istediklerinizden asla vazgeçmeyin -H. Jackson Brown Jr."
    },
    "2025-09-14": {
        "content": " Geriye bakma, o yöne gitmiyorsun. -Mary Engelbreit"
    },
    "2025-09-15": {
        "content": " Sen elinden geleni yap, gerisini Allah halleder. -Nick Vujicic"
    },
    "2025-09-16": {
        "content": " Yaşa, seyahat et, maceraya atıl, şükret ve pişman olma. -Jack Kerouac"
    },
    "2025-09-17": {
        "content": " Kışın ortasında, içimde yenilmez bir yaz olduğunu keşfettim. Ve bu beni mutlu ediyor. Çünkü bu, dünya bana ne kadar sert baskı yaparsa yapsın, içimde daha güçlü bir şeyin, daha iyi bir şeyin, tam geri ittiğini söylüyor. -Albert Camus"
    },
    "2025-09-18": {
        "content": "Bazıları kötülüğü kontrol altında tutabilecek tek şeyin büyük bir güç olduğuna inanır, ancak benim bulduğum bu değil. Karanlığı uzak tutan şey sıradan insanların küçük günlük eylemleridir. Küçük nezaket ve sevgi eylemleri. -JRR Tolkien"
    },
    "2025-09-19": {
        "content": " Küçük şeylerde sadık olun, çünkü gücünüz onlardadır. -Rahibe Teresa"
    },
    "2025-09-20": {
        "content": " Kendini bir ışık yap. -Buda"
    },
    "2025-09-21": {
        "content": " GÖRSELLEŞTİR!!! Gör, hisset! Aksiyon burada başlıyor. -Rhonda Byrne"
    },
    "2025-09-22": {
        "content": " Olağanüstü ol ya da unutul! -Eric Thomas"
    },
    "2025-09-23": {
        "content": " Haklı olmak ya da nazik olmak arasında bir seçim yapmanız gerektiğinde, nazik olmayı seçin. -Wayne W. Dyer"
    },
    "2025-09-24": {
        "content": " İnsanlar zihinsel tutumlarını değiştirerek hayatlarını değiştirebilirler. -William James"
    },
    "2025-09-25": {
        "content": " Sağlık en büyük servettir. -Laozi"
    },
    "2025-09-26": {
        "content": " Tehlikelerden korunmak için dua etmeyeyim, onlarla yüzleşmekten korkmayayım. Acımın dinmesi için yalvarmayayım, onu fethetmek için yürekten yalvarayım. -Rabindranath Tagore"
    },
    "2025-09-27": {
        "content": " Kalbinizi iyilik yapmaya odaklayın. Bunu tekrar tekrar yapın, sevinçle dolacaksınız. -Buda"
    },
    "2025-09-28": {
        "content": "Ben tek başıma dünyayı değiştiremem ama suyun üzerine bir taş atıp dalgalar yaratabilirim. -Rahibe Teresa"
    },
    "2025-09-29": {
        "content": " Ve bir gün geldi ki, tomurcukta sımsıkı kalmanın riski, çiçek açmanın riskinden daha acı verici oldu. -Anaïs Nin"
    },
    "2025-09-30": {
        "content": " İnsan çabasının sınırları olmamalıdır. Hayat ne kadar kötü görünürse görünsün, her zaman umut vardır. -Stephen Hawking"
    },
    "2025-10-01": {
        "content": " Ve sizi mutlu olduğunuz zamanların farkına varmaya ve bir noktada haykırmaya, mırıldanmaya veya düşünmeye çağırıyorum: 'Eğer bu güzel değilse, neyin güzel olduğunu bilmiyorum.' -Kurt Vonnegut"
    },
    "2025-10-02": {
        "content": " Hayat hikayenizin nasıl gelişeceğini, sıkıntının kendisi değil, sizin sıkıntıya verdiğiniz tepki belirler. -Dieter F. Uchtdorf"
    },
    "2025-10-03": {
        "content": " Seni mutlu ya da mutsuz eden şey sahip olduğun şeyler, kim olduğun, nerede olduğun ya da ne yaptığın değildir. Bunlar hakkında ne düşündüğündür. -Dale Carnegie"
    },
    "2025-10-04": {
        "content": " Ne kadar çok okursanız, o kadar çok şey bileceksiniz. Ne kadar çok öğrenirseniz, o kadar çok yere gideceksiniz. -Dr. Seuss"
    },
    "2025-10-05": {
        "content": " Bütün hayallerimiz gerçek olabilir. -Walt Disney"
    },
    "2025-10-06": {
        "content": "Hayatınızın ayrıcalığı, kendiniz olmaktır. -Joseph Campbell"
    },
    "2025-10-07": {
        "content": " Bu dünyada bir başkasının yükünü hafifleten hiç kimse işe yaramaz değildir. -Charles Dickens"
    },
    "2025-10-08": {
        "content": " İçinizde neşenin olduğu bir yer bulun, neşe acıyı yakıp yok edecektir. -Joseph Campbell"
    },
    "2025-10-09": {
        "content": " Dünyanın neye ihtiyacı olduğunu sorma. Seni neyin canlandırdığını sor ve git onu yap. Çünkü dünyanın ihtiyacı olan şey, canlanan daha fazla insan. -Howard Thurman"
    },
    "2025-10-10": {
        "content": " Duygularınız hayatınızı yaratmanıza yardımcı olan en büyük araçlarınızdır. -Rhonda Byrne"
    },
    "2025-10-11": {
        "content": " Ben en iyisini hak ediyorum ve artık en iyisini kabul ediyorum. -Louise Hay"
    },
    "2025-10-12": {
        "content": " Önemli olan ne kadar verdiğimiz değil, verirken ne kadar sevgi koyduğumuzdur. -Rahibe Teresa"
    },
    "2025-10-13": {
        "content": " Başarılı olmayı nefes almak istediğin kadar çok istediğinde, o zaman başarılı olursun. -Eric Thomas"
    },
    "2025-10-14": {
        "content": " Antrenmanların her dakikasından nefret ediyordum ama dedim ki, \"Vazgeçme. Şimdi acı çek ve hayatının geri kalanını bir şampiyon olarak yaşa.\" -Muhammed Ali"
    },
    "2025-10-15": {
        "content": "Önemli olan eleştirmen değildir, güçlü adamın nasıl tökezlediğini veya işlerin failinin onları nasıl daha iyi yapabileceğini gösteren kişi değildir. Övgü, arenada gerçekten bulunan, yüzü ter, toz ve kanla lekelenmiş; yiğitçe çabalayan; hata yapan ve tekrar tekrar başarısız olan; büyük coşkuları, büyük bağlılıkları bilen ve kendini değerli bir dava uğruna harcayan; kazanırsa, yüksek başarının zaferini bilen; ve başarısız olursa, en azından büyük cesaret göstererek başarısız olan, böylece yeri asla zaferi veya yenilgiyi bilmeyen o soğuk ve korkak ruhlarla olmayacak adama aittir. -Theodore Roosevelt"
    },
    "2025-10-16": {
        "content": " Hayatınızda yaşayabileceğiniz en büyük macera, hayallerinizdeki hayatı yaşamaktır. -Oprah Winfrey"
    },
    "2025-10-17": {
        "content": " Mücadele olmadan ilerleme olmaz. -Frederick Douglass"
    },
    "2025-10-18": {
        "content": " Bir tarihle yazılmış bir rüya bir hedefe dönüşür. Adımlara bölünmüş bir hedef bir plana dönüşür. Eylemle desteklenen bir plan hayallerinizi gerçekleştirir. -Greg Reid"
    },
    "2025-10-19": {
        "content": "Yapamayacağını düşündüğün tek şeyi yap. Başarısız ol. Tekrar dene. İkinci seferde daha iyisini yap. Asla düşmeyen tek insanlar, asla yüksek telden yukarı çıkmayanlardır. -Oprah Winfrey"
    },
    "2025-10-20": {
        "content": " Değişimi bekleyin. Manzarayı analiz edin. Fırsatları değerlendirin. Satranç taşı olmayı bırakın; oyuncu olun. Sıra sizde. -Tony Robbins"
    },
    "2025-10-21": {
        "content": " Özgürsün. Güçlüsün. İyisin. Sevgisin. Değerlisin. Amacın var. Her şey yolunda. -Esther Hicks"
    },
    "2025-10-22": {
        "content": "Eğer bir şeyi çok istiyorsan, onun için dışarı çıkıp savaşacak, gece gündüz çalışacak, zamanından, huzurundan ve uykundan vazgeçecek kadar çok istiyorsan; Eğer tüm hayal ettiğin ve planladığın şey onun hakkındaysa ve hayat onsuz işe yaramaz ve değersiz görünüyorsa; Eğer onun için seve seve ter döküyor, üzülüyor ve plan yapıyorsan ve onun uğruna karşındakine karşı duyduğun korkudan kurtuluyorsan; Eğer istediğin şeyin peşinden tüm kapasiten, gücün ve zekan, inancın, umudun ve güvenin ve inatçılığınla gidiyorsan; Eğer ne soğuk ne de yoksulluk, açlık veya gut hastalığı, beden ve beyninin hastalığı veya acısı seni istediğin şeyden uzak tutamıyorsa; Eğer inatçı ve asabiysen ve onu doğuruyorsan, Tanrı'nın yardımıyla onu elde edeceksin. -Berton Braley"
    },
    "2025-10-23": {
        "content": " Doğru yolda olsanız bile, orada öylece oturursanız ezilirsiniz. -Will Rogers"
    },
    "2025-10-24": {
        "content": " Sıradan insanların sıra dışı olmayı seçebileceğini düşünüyorum. -Elon Musk"
    },
    "2025-10-25": {
        "content": " Kurallara uyarak yürümeyi öğrenemezsin. Yaparak ve düşerek öğrenirsin. -Richard Branson"
    },
    "2025-10-26": {
        "content": "Burada yetenek yok, bu sıkı çalışma. Bu bir saplantı. Yetenek diye bir şey yok, hepimiz insan olarak eşitiz. Zaman harcarsan herkes olabilirsin. Zirveye ulaşacaksın ve bu kadar. Ben yetenekli değilim, saplantılıyım. -Conor McGregor"
    },
    "2025-10-27": {
        "content": " Rüya, uyurken gördüğünüz şey değil, uyumanıza engel olan şeydir. -Abdul Kelam"
    },
    "2025-10-28": {
        "content": " Tüm olasılıkları tükettiğinizde şunu hatırlayın: Tüketmediniz. -Thomas A. Edison"
    },
    "2025-10-29": {
        "content": " Şansını dene, hata yap. Büyümenin yolu budur. Acı cesaretini besler. Cesur olmayı uygulamak için başarısız olman gerekir. -Mary Tyler Moore"
    },
    "2025-10-30": {
        "content": " Neye odaklanırsanız onu elde edersiniz. -Tony Robbins"
    },
    "2025-10-31": {
        "content": " Telaş, HER ZAMAN en önemli kelimedir. -Gary Vaynerchuk"
    },
    "2025-11-01": {
        "content": " Küflü ekmekten penisilin yapabiliyorlarsa, senden de bir şeyler yapabilirler. -Muhammed Ali"
    },
    "2025-11-02": {
        "content": " Kazanan olarak doğmadın ve kaybeden olarak doğmadın. Kendini ne yaparsan osun. -Lou Holtz"
    },
    "2025-11-03": {
        "content": " Başarı sizin göreviniz, zorunluluğunuz ve sorumluluğunuzdur. -Grant Cardone"
    },
    "2025-11-04": {
        "content": "İnsanlar arasında çok az fark vardır, ancak o küçük fark büyük bir fark yaratır. Küçük fark tutumdur. Büyük fark ise olumlu ya da olumsuz olmasıdır. -W. Clement Taşı"
    },
    "2025-11-05": {
        "content": " Liderler başkalarıyla ilişki kurabilecek kadar yakın, ama onları motive edebilecek kadar da önde olmalıdır. -John C. Maxwell"
    },
    "2025-11-06": {
        "content": " Asla asla demeyin, çünkü sınırlar da korkular gibi çoğu zaman sadece birer yanılsamadır. -Michael Jordan"
    },
    "2025-11-07": {
        "content": " Büyük şeyler başarabilmek için, önce kendinizden büyük şeyler beklemelisiniz. -Michael Jordan"
    },
    "2025-11-08": {
        "content": " İş dünyasında en başarılı olanlar, sevdikleri işi yapanlardır. -Warren Buffett"
    },
    "2025-11-09": {
        "content": " Eylem, erteleme alışkanlığınızı yok edecektir. -Og Mandino"
    },
    "2025-11-10": {
        "content": " Başarısızlık benim için bir seçenek değil. Başarı benim için tek hayal. -Conor McGregor"
    },
    "2025-11-11": {
        "content": " Başarı ara sıra yaptığınız şeyden değil, sürekli yaptığınız şeyden gelir. -Marie Forleo"
    },
    "2025-11-12": {
        "content": " Güven ve sıkı çalışma başarısızlık denen hastalığı öldürmek için en iyi ilaçlardır. Sizi başarılı bir insan yapacaktır. -Abdul Kelam"
    },
    "2025-11-13": {
        "content": " Güneş gibi parlamak istiyorsan önce güneş gibi yan. -Abdul Kelam"
    },
    "2025-11-14": {
        "content": "Siz dışarıda parti yaparken, at koştururken, aynı anda birileri de çok çalışıyor. Birileri akıllanıyor ve birileri kazanıyor. Bunu unutmayın. -Arnold Schwarzenegger"
    },
    "2025-11-15": {
        "content": " Her zaman yaptığınızı yaparsanız, her zaman aldığınızı alırsınız. -Tony Robbins"
    },
    "2025-11-16": {
        "content": " İlerleme mutluluk demektir. -Tony Robbins"
    },
    "2025-11-17": {
        "content": " Sonuçlar veya bahaneler olabilir. İkisi birden değil. -Arnold Schwarzenegger"
    },
    "2025-11-18": {
        "content": " Disiplin eşittir özgürlük. -Jocko Willink"
    },
    "2025-11-19": {
        "content": " Neyin yanlış gittiğine takılıp kalmayın. Bunun yerine, bundan sonra ne yapacağınıza odaklanın. Enerjinizi ileriye doğru hareket etmeye, cevabı bulmaya harcayın. -Denis Waitley"
    },
    "2025-11-20": {
        "content": " Keşke sahip olmayı istediğin lider ol. -Simon Sinek"
    },
    "2025-11-21": {
        "content": " Benim tutumum şu: Eğer beni zayıflık olarak gördüğünüz bir şeye doğru iterseniz, o algılanan zayıflığı bir güce dönüştürürüm. -Michael Jordan"
    },
    "2025-11-22": {
        "content": " Çoğumuz için en büyük tehlike hedefimizi çok yükseğe koyup hedefimize ulaşamamak değil; hedefimizi çok düşük tutup hedefimize ulaşamamaktır. -Michelangelo"
    },
    "2025-11-23": {
        "content": " Herkesin bir hayali vardır ama herkesin bir çabası yoktur. -Eric Thomas"
    },
    "2025-11-24": {
        "content": "Liderler yapılır, doğmazlar. Onlar sıkı çabayla yapılırlar, bu da değerli herhangi bir hedefe ulaşmak için hepimizin ödemesi gereken bedeldir. -Vince Lombardi"
    },
    "2025-11-25": {
        "content": " Bu on yılda aya gitmeyi ve diğer şeyleri yapmayı seçiyoruz. Kolay oldukları için değil, zor oldukları için. -John F. Kennedy"
    },
    "2025-11-26": {
        "content": " Senin ve benim hayatımızdaki en büyük gün, tutumlarımız için tüm sorumluluğu aldığımız gündür. İşte o gün gerçekten büyüdüğümüz gündür. -John C. Maxwell"
    },
    "2025-11-27": {
        "content": " Birine her gülümsediğinizde, bu bir sevgi eylemidir, o kişiye bir hediyedir, güzel bir şeydir. -Rahibe Teresa"
    },
    "2025-11-28": {
        "content": " Düşüncelerinizin ve davranışlarınızın sessiz izleyicisi olun. Düşünenin altındasınız. Zihinsel gürültünün altındaki dinginliksiniz. Acının altındaki sevgi ve neşesiniz. -Eckhart Tolle"
    },
    "2025-11-29": {
        "content": " Uçamıyorsan koş, koşamıyorsan yürü, yürüyemiyorsan sürün, ama ne yaparsan yap ilerlemeye devam etmelisin. -Martin Luther King Jr."
    },
    "2025-11-30": {
        "content": " Affetmek ara sıra yapılan bir eylem değil, sürekli bir tutumdur. -Martin Luther King Jr."
    },
    "2025-12-01": {
        "content": " Çoğu zaman bir dokunuşun, bir gülümsemenin, nazik bir sözün, dinleyen bir kulağın, içten bir iltifatın veya en ufak bir şefkat eyleminin gücünü hafife alırız; bunların hepsi bir hayatı değiştirme potansiyeline sahiptir. -Leo Buscaglia"
    },
    "2025-12-02": {
        "content": "Hayallerinizi canlı tutun. Herhangi bir şeyi başarmanın kendinize olan inanç ve güven, vizyon, sıkı çalışma, kararlılık ve özveri gerektirdiğini anlayın. İnananlar için her şeyin mümkün olduğunu unutmayın. -Gail Devers"
    },
    "2025-12-03": {
        "content": " Sporun dünyayı değiştirme gücü vardır. İlham verme gücü vardır. İnsanları başka hiçbir şeyin yapamayacağı şekilde birleştirme gücü vardır. Gençlere anladıkları bir dilde konuşur. Spor, bir zamanlar sadece umutsuzluk olan yerde umut yaratabilir. -Nelson Mandela"
    },
    "2025-12-04": {
        "content": " İstediğini iste. Bunu hak ettiğine inan ve sonra Hayatın onu sana vermesine izin ver. -Louise Hay"
    },
    "2025-12-05": {
        "content": " Niyetli yaşa. Sınıra kadar yürü. İyi dinle. Sağlıklı olmayı uygula. Terk edilmiş bir şekilde oyna. Gül. Pişman olmadan seç. Arkadaşlarına değer ver. Öğrenmeye devam et. Sevdiğin şeyi yap. Sanki her şey bundan ibaretmiş gibi yaşa. -Mary Anne Radmacher"
    },
    "2025-12-06": {
        "content": " Neye odaklanırsanız onu büyütürsünüz ve hayatınızdaki iyiliğe odaklandığınızda daha fazlasını yaratırsınız. -Oprah Winfrey"
    },
    "2025-12-07": {
        "content": " Zihniniz üzerinde gücünüz var, dış olaylar üzerinde değil. Bunu fark edin ve güç bulacaksınız. -Marcus Aurelius"
    },
    "2025-12-08": {
        "content": "Neden yapamayacağınıza dair bahaneler üretmeyin. Bunu neden yapmanız gerektiğine dair tüm nedenlere odaklanın. -Ralph Marston"
    },
    "2025-12-09": {
        "content": " Aşkın olduğu yerde hayat vardır. -Mahatma Gandi"
    },
    "2025-12-10": {
        "content": " Hiç kimse izlemiyormuş gibi dans etmelisin, asla incinmeyecekmiş gibi sevmelisin, hiç kimse dinlemiyormuş gibi şarkı söylemelisin ve yeryüzünde cennetmiş gibi yaşamalısın. -William W. Purkey"
    },
    "2025-12-11": {
        "content": " Başarı, hayattaki amacınızı bilmek, maksimum potansiyelinize ulaşmak için büyümek ve başkalarına fayda sağlayacak tohumlar ekmektir. -John C. Maxwell"
    },
    "2025-12-12": {
        "content": " Tek başınıza kurduğunuz bir rüya sadece bir rüyadır. Birlikte kurduğunuz bir rüya ise gerçekliktir. -John Lennon"
    },
    "2025-12-13": {
        "content": " Hayatın gerçek sırrı, burada ve şimdi yaptığınız şeyle tamamen meşgul olmaktır. Ve buna iş demek yerine, bunun bir oyun olduğunu fark edin. -Alan Watts"
    },
    "2025-12-14": {
        "content": " Dün geçti. Yarın henüz gelmedi. Sadece bugünümüz var. Başlayalım. -Rahibe Teresa"
    },
    "2025-12-15": {
        "content": " Hayatınızı ne kadar çok över ve kutlarsanız, hayatta kutlanacak o kadar çok şey olur. -Oprah Winfrey"
    },
    "2025-12-16": {
        "content": "Düşünceli, kararlı bir grup vatandaşın dünyayı değiştirebileceğinden asla şüphe etmeyin. Gerçekten de, bunu başaran tek şey budur. -Margaret Mead"
    },
    "2025-12-17": {
        "content": " Kendinizi zorlayın, çünkü bunu sizin için kimse yapmayacak. -Anonim"
    },
    "2025-12-18": {
        "content": " Gerçek tevazu, kendinizi küçümsemek değil; kendinizi daha az düşünmektir. -CS Lewis"
    },
    "2025-12-19": {
        "content": " Eğer zihninizi değiştirebilirseniz, hayatınızı değiştirebilirsiniz. -William James"
    },
    "2025-12-20": {
        "content": " Korktuğunuz şeye değil, gitmek istediğiniz yere odaklanın. -Tony Robbins"
    },
    "2025-12-21": {
        "content": " Kendinize saygı gösterin, başkaları da size saygı duyacaktır. -Konfüçyüs"
    },
    "2025-12-22": {
        "content": " Elinizde olanla, bulunduğunuz yerde elinizden geleni yapın. -Theodore Roosevelt"
    },
    "2025-12-23": {
        "content": " Bazı değişimler ilk bakışta olumsuz gibi görünse de, kısa sürede hayatınızda yeni bir şeyin ortaya çıkması için alan açıldığını fark edeceksiniz. -Eckhart Tolle"
    },
    "2025-12-24": {
        "content": " Eğer eylemleriniz başkalarına daha fazla hayal kurma, daha fazla öğrenme, daha fazla şey yapma ve daha fazlası olma konusunda ilham veriyorsa, siz bir lidersiniz. -John Quincy Adams"
    },
    "2025-12-25": {
        "content": " Hiçbir şey için endişelenme, her şey yoluna girecek. -Bob Marley"
    },
    "2025-12-26": {
        "content": " Büyük hayaller kurun, pozitif kalın, sıkı çalışın ve yolculuğun tadını çıkarın. -Urijah Faber"
    },
    "2025-12-27": {
        "content": "Evrenin ilahi amacının açığa çıkmasını sağlamak için buradasınız. İşte bu kadar önemlisiniz! -Eckhart Tolle"
    },
    "2025-12-28": {
        "content": " Tutkuyla yaşa! -Tony Robbins"
    },
    "2025-12-29": {
        "content": " Başarabileceğinize inanın, yolun yarısını kat etmiş olursunuz. -Theodore Roosevelt"
    },
    "2025-12-30": {
        "content": " Hayatımız, önemsediğimiz şeyler hakkında sessiz kaldığımız gün son bulmaya başlar. -Martin Luther King Jr."
    },
    "2025-12-31": {
        "content": " Birlikte büyük işler başarabiliriz. -Rahibe Teresa"
    },
    "2026-01-01": {
        "content": " Umursamadığımız bir şey için çok çalışmaya stres denir; sevdiğimiz bir şey için çok çalışmaya ise tutku denir. -Simon Sinek"
    },
    "2026-01-02": {
        "content": " Girmekten korktuğun mağara, aradığın hazineyi barındırır. -Joseph Campbell"
    },
    "2026-01-03": {
        "content": " Liderlik empatiyle ilgilidir. İnsanların hayatlarına ilham verme ve onları güçlendirme amacıyla onlarla ilişki kurma ve bağlantı kurma yeteneğine sahip olmakla ilgilidir. -Oprah Winfrey"
    },
    "2026-01-04": {
        "content": " Deneyen için imkansız diye bir şey yoktur. -Büyük İskender"
    },
    "2026-01-05": {
        "content": " Dünyadaki en önemli şeylerin çoğu, hiçbir umut yokmuş gibi göründüğünde bile denemeye devam eden insanlar tarafından başarılmıştır. -Dale Carnegie"
    },
    "2026-01-06": {
        "content": " Sürekli ileriye doğru hareket ediyoruz, yeni kapılar açıyoruz, yeni şeyler yapıyoruz çünkü meraklıyız ve merak bizi sürekli yeni yollara götürüyor. -Walt Disney"
    },
    "2026-01-07": {
        "content": "İstediğini yapana kadar yapman gerekeni yap. -Oprah Winfrey"
    },
    "2026-01-08": {
        "content": " Yeterli olduğunuza inanmak, size özgün olma cesaretini verir. -Brené Brown"
    },
    "2026-01-09": {
        "content": " Harry, yeteneklerimizden çok, seçimlerimiz aslında kim olduğumuzu gösterir. -JK Rowling"
    },
    "2026-01-10": {
        "content": " Mutluluğunuzun peşinden gidin, evren size duvarların olduğu yerlerde kapılar açacaktır. -Joseph Campbell"
    },
    "2026-01-11": {
        "content": " Rüyalar uyurken gelenler değil, uyumadan gerçekleşenlerdir. -Abdul Kelam"
    },
    "2026-01-12": {
        "content": " Cesaret etmek, savunmasız olma cesaretini göstermek anlamına gelir. Ortaya çıkmak ve görülmek anlamına gelir. İhtiyacınız olanı istemek. Nasıl hissettiğiniz hakkında konuşmak. Zor konuşmaları yapmak anlamına gelir. -Brené Brown"
    },
    "2026-01-13": {
        "content": " Acınızı büyüklüğe dönüştürmediğiniz sürece, acınızın sizi olduğunuz yerden sizi olmanız gereken yere itmesine izin vermediğiniz sürece asla başarılı olamazsınız. Acınızdan kaçmayı bırakın ve acınızı kucaklayın. Acınız ödülünüzün bir parçası, ürününüzün bir parçası olacak. Kendinizi zorlamanız için sizi meydan okuyorum. -Eric Thomas"
    },
    "2026-01-14": {
        "content": " Biz, tekrar tekrar yaptığımız şeyiz. Bu nedenle mükemmellik bir eylem değil, bir alışkanlıktır. -Aristo"
    },
    "2026-01-15": {
        "content": " Bir nehrin kayayı delmesi gücünden değil, ısrarcılığından kaynaklanır. -Jim Watkins"
    },
    "2026-01-16": {
        "content": " Enerji ve azim her şeyi yener. -Benjamin Franklin"
    },
    "2026-01-17": {
        "content": " Fırsatlar genellikle sıkı çalışma kisvesi altında gelir, bu yüzden çoğu insan onları fark etmez. -Ann Landers"
    },
    "2026-01-18": {
        "content": " Uçamıyorsan koş, koşamıyorsan yürü, yürüyemiyorsan sürün, ama ne yaparsan yap ilerlemeye devam etmelisin. -Martin Luther King Jr."
    },
    "2026-01-19": {
        "content": " Azim, sonuçların kaçınılmaz olduğunun garantisidir. -Paramahansa Yogananda"
    },
    "2026-01-20": {
        "content": " Sıradan bir yetenek ve olağanüstü bir azimle her şey başarılabilir -Thomas Fowell Buxton"
    },
    "2026-01-21": {
        "content": " En büyük zaferimiz hiçbir zaman başarısız olmamak değil, her başarısız olduğumuzda ayağa kalkabilmektir. -Ralph Waldo Emerson"
    },
    "2026-01-22": {
        "content": " Başarı, coşkuyu kaybetmeden başarısızlıktan başarısızlığa koşmaktır. -Winston Churchill"
    },
    "2026-01-23": {
        "content": "Neyse ki, azim yeteneğin harika bir alternatifidir. -Steve Martin"
    },
    "2026-01-24": {
        "content": " Şansa daha çok inanıyorum ve ne kadar çok çalışırsam şansımın o kadar arttığını görüyorum -Thomas Jefferson"
    },
    "2026-01-25": {
        "content": " Yarına ertelediğin tek şey, ölmeyi göze aldığın ve yarım bıraktığın şeylerdir. -Pablo Picasso"
    },
    "2026-01-26": {
        "content": " Başarının sırları yoktur: bunları aramakla zaman kaybetmeyin. Başarı, mükemmeliyetin, sıkı çalışmanın, başarısızlıktan ders çıkarmanın, çalıştığınız kişilere sadakatin ve ısrarcılığın sonucudur. -Colin Powell"
    },
    "2026-01-27": {
        "content": " Önde olmak istiyorsan, arkadaymış gibi davran. -Lao Tzu"
    },
    "2026-01-28": {
        "content": " Hedefime ulaşmamı sağlayan sırrımı söyleyeyim: Benim gücüm sadece azmimdedir. -Louis Pasteur"
    },
    "2026-01-29": {
        "content": " Bu dünyada hiçbir şey azmin yerini tutamaz. Yetenek tutamaz; yetenekli ama başarısız insanlardan daha yaygın bir şey yoktur. Deha tutamaz; ödüllendirilmeyen deha neredeyse bir atasözüdür. -Calvin Coolidge"
    },
    "2026-01-30": {
        "content": " En iyi çıkış yolu her zaman içinden geçmektir. -Robert Frost"
    },
    "2026-01-31": {
        "content": "Hayattaki birçok başarısızlığın sebebi, pes ettiklerinde başarıya ne kadar yakın olduklarını fark edemeyen insanlardır. -Thomas A. Edison"
    },
    "2026-02-01": {
        "content": " Biz ısrarcı olmak için yaratıldık. Bu şekilde kim olduğumuzu öğreniriz. -Tobias Wolff"
    },
    "2026-02-02": {
        "content": " Ağaçları tanıdığımda sabrın anlamını anlıyorum. Çimleri tanıdığımda ise azmin değerini anlayabiliyorum. -Hal Borland"
    },
    "2026-02-03": {
        "content": " Damlayan su, taşı kuvvetle değil ısrarla oyar. -Ovid"
    },
    "2026-02-04": {
        "content": " Azim çok önemlidir. Vazgeçmeye zorlanmadığınız sürece vazgeçmemelisiniz. -Elon Musk"
    },
    "2026-02-05": {
        "content": " At sağduyusu ve azimle desteklenen ateşli coşku, çoğu zaman başarıyı getiren özelliktir. -Dale Carnegie"
    },
    "2026-02-06": {
        "content": " Hırs başarıya giden yoldur. Azim ise ulaştığınız araçtır. -Bill Bradley"
    },
    "2026-02-07": {
        "content": " Soruna değil, çözüme odaklanın. -Walter Anderson"
    },
    "2026-02-08": {
        "content": " Hayat seni yere serdiğinde iki seçeneğin vardır; ya yerde kalırsın ya da ayağa kalkarsın. -Tom Krause"
    },
    "2026-02-09": {
        "content": "Başarı, her gün tekrarlanan küçük çabaların toplamıdır. -Robert Collier"
    },
    "2026-02-10": {
        "content": " Bir rüya sadece bir rüyadır. Bir hedef, bir planı ve bir son tarihi olan bir rüyadır. -Harvey MacKay"
    },
    "2026-02-11": {
        "content": " Hiçbir zaman düşünmeden bir gün geçiremeyeceğiniz bir şeyden vazgeçmeyin. -Winston Churchill"
    },
    "2026-02-12": {
        "content": " Elmaslar, görevlerini yerine getiren kömür parçalarından başka bir şey değildir. -Malcolm S. Forbes"
    },
    "2026-02-13": {
        "content": " Azar azar bir şeyler yapmaktan başka bir şey yapılamaz. -Charles Baudelaire"
    },
    "2026-02-14": {
        "content": " Cehennemden geçiyorsan, devam et. -Winston Churchill"
    },
    "2026-02-15": {
        "content": " Azmin anahtarı, dirençle kapalı olan bütün kapıları açar. -John Di Lemme"
    },
    "2026-02-16": {
        "content": " Dünyanın en başarılı insanlarına baktığımızda hepsinin ortak paydasının azim olduğunu görürüz. -Justin Sachs"
    },
    "2026-02-17": {
        "content": " Bir fili parça parça yiyebilirsiniz. -Mary Kay Külü"
    },
    "2026-02-18": {
        "content": " Herhangi bir tür başarı için azim niteliği kadar önemli başka bir nitelik olduğunu düşünmüyorum. Neredeyse her şeyin üstesinden gelir, hatta doğanın bile. -John D. Rockefeller"
    },
    "2026-02-19": {
        "content": "Bir vizyonu gerçeğe dönüştürmek istiyorsanız %100'ünüzü vermeli ve hayalinize inanmayı asla bırakmamalısınız. -Arnold Schwarzenegger"
    },
    "2026-02-20": {
        "content": " Koşabildiğinizde koşun, yürümeniz gerektiğinde yürüyün, sürünmeniz gerektiğinde sürün; ama asla pes etmeyin. -Dekan Karnazes"
    },
    "2026-02-21": {
        "content": " Yapamayacağınızı düşündüğünüzde bir tur daha atmak, hayatınızda fark yaratan şeydir. -Sylvester Stallone"
    },
    "2026-02-22": {
        "content": " Beni dinle, kaybettiğinde bile kaybetmek sorun değil, ama bununla asla rahat edemezsin. Kaybetmekten asla memnun olamazsın. Kaybettiğinde, acı çekmen gerekir. -Eric Thomas"
    },
    "2026-02-23": {
        "content": " Adım adım yürümeye devam edin. -Joyce Meyer"
    },
    "2026-02-24": {
        "content": " Pes etmemeli ve sorunun bizi yenmesine izin vermemeliyiz. -Abdul Kelam"
    },
    "2026-02-25": {
        "content": " Sabrederek fethederiz. -Ernest Shackleton"
    },
    "2026-02-26": {
        "content": "Tuğla duvarlar bir sebepten dolayı oradadır. Tuğla duvarlar bizi dışarıda tutmak için orada değildir. Tuğla duvarlar bize bir şeyi ne kadar çok istediğimizi gösterme şansı vermek için oradadır. Çünkü tuğla duvarlar onu yeterince kötü istemeyen insanları durdurmak için oradadır. Diğer insanları durdurmak için oradadırlar. -Randy Pausch"
    },
    "2026-02-27": {
        "content": " Başarı neredeyse tamamen azim ve sebatkarlığa bağlıdır. Başka bir çaba göstermek veya başka bir yaklaşımı denemek için gereken ekstra enerji, kazanmanın sırrıdır. -Denis Waitley"
    },
    "2026-02-28": {
        "content": " Buraya kadar gelmiştim ve pes etmeyi reddettim çünkü hayatım boyunca hep yarışı bitirmiştim. -Louis Zamperini"
    },
    "2026-03-01": {
        "content": " Hayatta kalma üç kelimeyle özetlenebilir - asla pes etme. Aslında meselenin özü bu. Sadece denemeye devam et. -Ayı Grylls"
    },
    "2026-03-02": {
        "content": "ARTIK YOK. Artık bahane yok. Artık: \"Yarın başlayacağım.\" Artık: \"Sadece bu seferlik.\" Artık kendi irademin eksikliklerini kabul etmiyorum. Artık kolay yolu seçmiyorum. Artık zihnimden geçen sağlıksız veya verimsiz düşüncelere boyun eğmiyorum. -Jocko Willink"
    },
    "2026-03-03": {
        "content": " Küçük darbelerle büyük meşeler devrilir. -Benjamin Franklin"
    },
    "2026-03-04": {
        "content": " İstekliyim.” “Kazanmak için programlandım.” “Bunu başarabilirim.” “Belirsizliği kucaklıyorum.” “Ben düşüncelerim değilim; ben yaptıklarımım.” “Ben amansızım.” “Hiçbir şey beklemiyorum ve her şeyi kabul ediyorum. -Gary John Bishop"
    },
    "2026-03-05": {
        "content": " 700 kez başarısız olmadım. Bir kez bile başarısız olmadım. O 700 yolun işe yaramayacağını kanıtlamayı başardım. İşe yaramayacak yolları elediğimde, işe yarayacak yolu bulacağım. -Thomas A. Edison"
    },
    "2026-03-06": {
        "content": " GRIT, Cesaret, Dayanıklılık, Çalışkanlık ve Azimdir. GRIT, odaklanma, kararlı kalma, bir zorlukla karşı karşıya kalındığında iyimser kalma ve diğer erkeklerden veya kadınlardan daha çok çalışma yeteneğidir. -Linda Kaplan Thaler"
    },
    "2026-03-07": {
        "content": "Sanırım sırrım, sıkı çalışmanın, kararlılığın ve 'vazgeçmeme' tavrının kısayollarının olmaması. -Jerry Rice"
    },
    "2026-03-08": {
        "content": " Kaderinizdeki yere varana kadar, yani eşsiz siz olana kadar mücadeleyi asla bırakmayın. Hayatta bir amacınız olsun, sürekli bilgi edinin, sıkı çalışın ve harika hayatı gerçekleştirmek için azimli olun. -Abdul Kelam"
    },
    "2026-03-09": {
        "content": " Yorulduğunuzda durmayın. Bitirdiğinizde durun. -David Goggins"
    },
    "2026-03-10": {
        "content": " Beni başarılarımla yargılamayın, kaç kez düşüp tekrar ayağa kalktığımla yargılayın. -Nelson Mandela"
    },
    "2026-03-11": {
        "content": " Bugün başlanmayan iş, yarın asla bitmez. -Johann Wolfgang von Goethe"
    },
    "2026-03-12": {
        "content": " Yüz tane kısa hikaye yazarsanız ve hepsi kötüyse, bu başarısız olduğunuz anlamına gelmez. Sadece yazmayı bırakırsanız başarısız olursunuz. -Ray Bradbury"
    },
    "2026-03-13": {
        "content": " Usta, yeni başlayanın denediğinden daha fazla başarısızlığa uğramıştır. -Stephen McCranie"
    },
    "2026-03-14": {
        "content": " Şartlar cehenneme, ben fırsatları yaratırım. -Bruce Lee"
    },
    "2026-03-15": {
        "content": "Bir şeye başlayıp başarısız olmaktan daha kötü olan tek şey, bir şeye başlamamaktır. -Seth Godin"
    },
    "2026-03-16": {
        "content": " Bugün yapabileceğin işi asla yarına bırakma. -Benjamin Franklin"
    },
    "2026-03-17": {
        "content": " Salyangoz azimle gemiye ulaştı. -Charles H. Spurgeon"
    },
    "2026-03-18": {
        "content": " Unutmayın, umut iyi bir şeydir, belki de en iyi şeydir ve hiçbir iyi şey asla ölmez. -Stephen King"
    },
    "2026-03-19": {
        "content": " Girişimciler yorgun olduğumuzda bitirmezler. İşimiz bitince bitiririz. -Robert T. Kiyosaki"
    },
    "2026-03-20": {
        "content": " Yalnızca azim ve kararlılık her şeye kadirdir. -Calvin Coolidge"
    },
    "2026-03-21": {
        "content": " Direnci ısrarla felç edin. -Woody Hayes"
    },
    "2026-03-22": {
        "content": " Başarı hiçbir zaman sahip olunamaz, kiralanır ve kirası her gün ödenir. -Rory Vaden"
    },
    "2026-03-23": {
        "content": " Başarı tesadüf değildir. Sıkı çalışma, azim, öğrenme, çalışma, fedakarlık ve en önemlisi yaptığınız veya yapmayı öğrendiğiniz şeye olan sevgidir. -Pele"
    },
    "2026-03-24": {
        "content": " Zor işin etrafından dolanmanın bir yolu yok. Onu kucakla. -Roger Federer"
    },
    "2026-03-25": {
        "content": " Bir hayalin gerçeğe dönüşmesi sihirle olmaz; ter, kararlılık ve sıkı çalışma gerektirir. -Colin Powell"
    },
    "2026-03-26": {
        "content": "Öğrenmek zihni asla yormaz. -Leonardo da Vinci"
    },
    "2026-03-27": {
        "content": " Duyuyorum ve unutuyorum. Görüyorum ve hatırlıyorum. Yapıyorum ve anlıyorum. -Konfüçyüs"
    },
    "2026-03-28": {
        "content": " Hiç hata yapmamış olan insan, hiç yeni bir şey denememiştir. -Albert Einstein"
    },
    "2026-03-29": {
        "content": " Her şey hakkında bir şeyler, bir şey hakkında da her şeyi öğrenmeye çalışın. -Thomas Henry Huxley"
    },
    "2026-03-30": {
        "content": " İnsan ancak iki şekilde öğrenir; biri okuyarak, diğeri de daha akıllı insanlarla arkadaşlık ederek. -Will Rogers"
    },
    "2026-03-31": {
        "content": " Bir şeyi birden fazla şekilde öğrenmedikçe hiçbir şeyi anlayamazsın. -Marvin Minsky"
    },
    "2026-04-01": {
        "content": " Bana söyle unutayım, bana öğret hatırlayayım, beni dahil et öğreneyim. -Benjamin Franklin"
    },
    "2026-04-02": {
        "content": " Başarı oranınızı artırmak istiyorsanız, başarısızlık oranınızı iki katına çıkarın. -Thomas J. Watson"
    },
    "2026-04-03": {
        "content": " Zekâ, ne yapacağını bilmediğin zaman kullandığın şeydir. -Jean Piaget"
    },
    "2026-04-04": {
        "content": " 21. yüzyılın cahili, okuma yazma bilmeyenler değil, öğrenemeyen, öğrendiklerini unutamayan ve yeniden öğrenemeyenler olacaktır. -Alvin Toffler"
    },
    "2026-04-05": {
        "content": "Öğrenmemizi engelleyen şey çoğu zaman bildiklerimizdir. -Claude Bernard"
    },
    "2026-04-06": {
        "content": " Matematik, Tanrı'nın evreni yazdığı dildir. -Galileo Galilei"
    },
    "2026-04-07": {
        "content": " Eğitimin bütün amacı aynaları pencereye dönüştürmektir. -Sidney J. Harris"
    },
    "2026-04-08": {
        "content": " Fırtınalardan korkmuyorum çünkü gemimi nasıl yelkenleyeceğimi öğreniyorum. -Louisa May Alcott"
    },
    "2026-04-09": {
        "content": " Eğitimli olan tek kişi, öğrenmeyi ve değişmeyi öğrenmiş olan kişidir. -Carl R. Rogers"
    },
    "2026-04-10": {
        "content": " Hiçbir zaman kendisinden bir şey öğrenemeyeceğim kadar cahil bir adamla karşılaşmadım. -Galileo Galilei"
    },
    "2026-04-11": {
        "content": " Hiçbir şey bize bilmemiz gerekeni öğretmeden ortadan kalkmaz. -Pema Chödrön"
    },
    "2026-04-12": {
        "content": " Alıştırma mükemmelleştirir. Uzun süreli pratikten sonra, işimiz doğal, becerikli, hızlı ve istikrarlı hale gelecektir. -Bruce Lee"
    },
    "2026-04-13": {
        "content": " Konuştuğunuzda sadece zaten bildiğiniz bir şeyi tekrarlıyorsunuz. Ancak, dinlerseniz yeni bir şey öğrenebilirsiniz. -Dalay Lama XIV"
    },
    "2026-04-14": {
        "content": " Mükemmelliğe değil, ilerlemeye çabalayın. -Anonim"
    },
    "2026-04-15": {
        "content": "Ben hep henüz yapamadığım şeyleri yapıyorum, nasıl yapacağımı öğrenmek için. -Vincent van Gogh"
    },
    "2026-04-16": {
        "content": " Bilgi, insanı köle olmaya elverişsiz kılar. -Frederick Douglass"
    },
    "2026-04-17": {
        "content": " Bir şeyin adını bilmekle, onu bilmek arasındaki farkı çok erken öğrendim. -Richard P. Feynman"
    },
    "2026-04-18": {
        "content": " Öğrenme kapasitesi bir armağandır; öğrenme yeteneği bir beceridir; öğrenme isteği ise bir seçimdir. -Brian Herbert"
    },
    "2026-04-19": {
        "content": " Öğrenebildiğiniz her şeyi, mümkün olan her zaman, herkesten öğrenin; bunu yaptığınız için minnettar olacağınız bir zaman mutlaka gelecektir. -Sarah Caldwell"
    },
    "2026-04-20": {
        "content": " Dün olduğundan daha akıllı olmayan bir adam hakkında pek fazla bir şey düşünmem. -Abraham Lincoln"
    },
    "2026-04-21": {
        "content": " Başarının anahtarı yaşam boyu öğrenmeye adanmışlıktır. -Stephen R. Covey"
    },
    "2026-04-22": {
        "content": " Tutkulu ve cesur olun. Her zaman öğrenmeye devam edin. Öğrenmezseniz yararlı şeyler yapmayı bırakırsınız. -Satya Nadella"
    },
    "2026-04-23": {
        "content": "İnsanın ulaşabileceği en yüksek etkinlik, anlamak için öğrenmektir; çünkü anlamak özgür olmaktır. -Baruch Spinoza"
    },
    "2026-04-24": {
        "content": " Öğrenmeye devam etmezseniz, diğer insanlar sizi geçecektir. Sadece mizaç bunu başaramaz - uzun, uzun bir süre boyunca çok fazla meraka ihtiyacınız var. -Charlie Munger"
    },
    "2026-04-25": {
        "content": " Öğrenen organizasyon, geleceğini yaratma kapasitesini sürekli olarak genişleten bir organizasyondur. -Peter Senge"
    },
    "2026-04-26": {
        "content": " Öğrenmeyi bıraktığınız gün, çürümeye başladığınız gündür. -Isaac Asimov"
    },
    "2026-04-27": {
        "content": " İlim, refah zamanında süs, sıkıntı zamanında sığınak, yaşlılıkta ise geçim kaynağıdır. -Aristo"
    },
    "2026-04-28": {
        "content": " Tüm liderler öğrenendir. Öğrenmeyi bıraktığınız anda, liderlik etmeyi bırakırsınız. Mümkün olduğunca çok, mümkün olduğunca çok kişiden, mümkün olduğunca sık öğrenirim. -Rick Warren"
    },
    "2026-04-29": {
        "content": " Zor şeyleri hızlı bir şekilde öğrenmek için, dikkat dağıtıcı unsurlar olmadan yoğun bir şekilde odaklanmalısınız. Öğrenmek, başka bir deyişle, derin bir çalışma eylemidir. -Cal Newport"
    },
    "2026-04-30": {
        "content": " Herhangi bir aptal bile bilebilir. Önemli olan anlamaktır. -Albert Einstein"
    },
    "2026-05-01": {
        "content": "Her gününüzü uyandığınızda olduğunuzdan biraz daha akıllı olmaya çalışarak geçirin. -Charlie Munger"
    },
    "2026-05-02": {
        "content": " Kendinize, eğitiminize yatırım yapın. Bundan iyisi yok. -Sylvia Porter"
    },
    "2026-05-03": {
        "content": " Kendimi eğitmek benim için sürekli bir zevk kaynağıdır, çünkü ne kadar çok şey bilirsem, hayatım o kadar dolu olur ve kendi varlığımı o kadar iyi takdir ederim. -Isaac Asimov"
    },
    "2026-05-04": {
        "content": " Öğretmenlerden yardım alabilirsiniz ama çok şeyi kendi başınıza, bir odada tek başınıza oturarak öğrenmeniz gerekecek. -Dr. Seuss"
    },
    "2026-05-05": {
        "content": " Öğrenme, öğretmek isteyenle değil, öğrenmek isteyenle gerçekleşir. -Roger Schank"
    },
    "2026-05-06": {
        "content": " Bir kişi bir başka kişiye doğrudan bir şey öğretemez; bir kişi sadece bir başkasının öğrenmesini kolaylaştırabilir. -Carl R. Rogers"
    },
    "2026-05-07": {
        "content": " Öğrenmek zorunlu değildir; gönüllüdür. Gelişim zorunlu değildir; gönüllüdür. Ancak hayatta kalmak için öğrenmeliyiz. -W. Edwards Deming"
    },
    "2026-05-08": {
        "content": " Ben her zaman yapamadığım şeyi yapıyorum ki, onu nasıl yapacağımı öğreneyim. -Pablo Picasso"
    },
    "2026-05-09": {
        "content": "Hiçbir hırsız, ne kadar usta olursa olsun, bir insanın bilgisini çalamaz. İşte bu yüzden bilgi, edinilebilecek en iyi ve en güvenli hazinedir. -L. Frank Baum"
    },
    "2026-05-10": {
        "content": " Bence verilebilecek en iyi tavsiye şu: Sürekli olarak, işleri nasıl daha iyi yapabileceğinizi düşünün ve kendinizi sorgulayın. -Elon Musk"
    },
    "2026-05-11": {
        "content": " Akıllı bir adam, aptal bir adamın akıllıca bir cevaptan öğrenebileceğinden daha fazlasını, aptalca bir sorudan öğrenebilir. -Bruce Lee"
    },
    "2026-05-12": {
        "content": " Eğer daha ileriyi görebildiysem, bu Devlerin omuzlarına basarak olmuştur. -Isaac Newton"
    },
    "2026-05-13": {
        "content": " Bildiklerimiz bir damla, bilmediklerimiz ise bir okyanustur. -Isaac Newton"
    },
    "2026-05-14": {
        "content": " Öğrenmenin en güzel yanı, onu sizden kimsenin alamamasıdır. -BB Kralı"
    },
    "2026-05-15": {
        "content": " Yazar olmak istiyorsanız her şeyden önce iki şeyi yapmalısınız: Çok okumak ve çok yazmak. -Stephen King"
    },
    "2026-05-16": {
        "content": " Tekrar, becerinin anasıdır. -Tony Robbins"
    },
    "2026-05-17": {
        "content": " Hayret, bilgeliğin başlangıcıdır. -Sokrates"
    },
    "2026-05-18": {
        "content": " Bir hata yapıp düzeltmezsen buna hata denir. -Konfüçyüs"
    },
    "2026-05-19": {
        "content": " Eğitimin amacı boş zihni açık zihinle değiştirmektir. -Malcolm S. Forbes"
    },
    "2026-05-20": {
        "content": "Hayatta korkulacak hiçbir şey yoktur, sadece anlaşılmalıdır. Şimdi daha fazlasını anlamanın zamanıdır, böylece daha az korkabiliriz. -Marie Curie"
    },
    "2026-05-21": {
        "content": " Bir işi yapıp yapamayacağınız sorulduğunda, onlara \"Elbette yapabilirim!\" deyin. Sonra harekete geçin ve nasıl yapılacağını öğrenin. -Theodore Roosevelt"
    },
    "2026-05-22": {
        "content": " Hepimizin bize geri bildirim verecek insanlara ihtiyacımız var. Bu şekilde gelişiriz. -Bill Gates"
    },
    "2026-05-23": {
        "content": " Eğitim, dünyanın kilidini açmanın anahtarı, özgürlüğe giden pasaporttur. -Oprah Winfrey"
    },
    "2026-05-24": {
        "content": " Her şey bir fikirle başlar. -Kont Nightingale"
    },
    "2026-05-25": {
        "content": " Yapabileceğiniz en iyi yatırım kendinize yaptığınızdır. -Warren Buffett"
    },
    "2026-05-26": {
        "content": " Bu para veya bağlantılarla ilgili değil. Herkesten daha fazla çalışmaya ve daha fazla öğrenmeye istekli olmaktır. -Mark Kübalı"
    },
    "2026-05-27": {
        "content": " Yaşadığınız sürece yaşamayı öğrenmeye devam edin. -Seneca"
    },
    "2026-05-28": {
        "content": " Başarmayı öğrenmek için önce başarısız olmayı öğrenmelisiniz. -Michael Jordan"
    },
    "2026-05-29": {
        "content": " İyi bir hatayı boşa harcamayın, ondan ders çıkarın. -Robert T. Kiyosaki"
    },
    "2026-05-30": {
        "content": "Bilgi edinmek için çalışmak gerekir; fakat hikmet edinmek için gözlem yapmak gerekir. -Marilyn Vos Savant"
    },
    "2026-05-31": {
        "content": " Yaşayıp öğreniyorsun. Her neyse, yaşıyorsun. -Douglas Adams"
    },
    "2026-06-01": {
        "content": " Sabır, hikmetin yoldaşıdır. -Aziz Augustinus"
    },
    "2026-06-02": {
        "content": " Ben sadece bir şey biliyorum, o da hiçbir şey bilmediğimdir. -Sokrates"
    },
    "2026-06-03": {
        "content": " Bilgelik deneyimden gelir. Deneyim genellikle bilgelik eksikliğinin bir sonucudur. -Terry Pratchett"
    },
    "2026-06-04": {
        "content": " İlerlememizi, sorularımızın cesaretine, cevaplarımızın derinliğine, iyi hissettiren şeylerden ziyade gerçek olanı benimsemeye olan istekliliğimize göre değerlendirebiliriz. -Carl Sagan"
    },
    "2026-06-05": {
        "content": " Soru sorulamayan cevaplardan çok, cevaplanamayan sorularım olmasını tercih ederim. -Richard P. Feynman"
    },
    "2026-06-06": {
        "content": " Öğretilmekten her zaman hoşlanmasam da öğrenmeye her zaman hazırım. -Winston Churchill"
    },
    "2026-06-07": {
        "content": " Teori olmadan pratiği seven kişi, dümeni ve pusulası olmayan ve nereye gideceğini asla bilemeyen denizciye benzer. -Leonardo da Vinci"
    },
    "2026-06-08": {
        "content": " Öğrenmektense yaratmak daha iyidir. Yaratmak hayatın özüdür. -Julius Sezar"
    },
    "2026-06-09": {
        "content": "El ne yaparsa akıl onu hatırlar. -Maria Montessori"
    },
    "2026-06-10": {
        "content": " Hayatınızda her zaman yeni bir şey öğrenecekmişsiniz gibi yürüyün, o zaman öğreneceksiniz. -Vernon Howard"
    },
    "2026-06-11": {
        "content": " Başarısızlık, ondan ders çıkarırsak başarıdır. -Malcolm S. Forbes"
    },
    "2026-06-12": {
        "content": " Eğitim en iyi arkadaştır. Eğitimli bir kişi her yerde saygı görür. Eğitim güzelliği ve gençliği yener. -Çanakya"
    },
    "2026-06-13": {
        "content": " Sizin için başarılması zor olan bir şeyin insan olarak imkânsız olduğunu düşünmeyin; ama eğer bir şey insan olarak mümkünse, onu ulaşabileceğiniz mesafede sayın. -Marcus Aurelius"
    },
    "2026-06-14": {
        "content": " Öğrenme, sürekli bir keşif sürecidir; sonu olmayan bir süreçtir. -Bruce Lee"
    },
    "2026-06-15": {
        "content": " Cahil olmak ayıp değil, öğrenmeye isteksiz olmaktır. -Benjamin Franklin"
    },
    "2026-06-16": {
        "content": " Bilginin güç olduğuna inanıyorum; geçmişi aşmak, içinde bulunduğumuz durumu değiştirmek, yeni engellerle mücadele etmek, daha iyi kararlar almak için. -Ben Carson"
    },
    "2026-06-17": {
        "content": " Nefes alırken, bedenimi ve zihnimi sakinleştiriyorum. Nefes verirken, gülümsüyorum. Şimdiki anda yaşayarak, bunun tek an olduğunu biliyorum. -Thich Nhat Hanh"
    },
    "2026-06-18": {
        "content": "Eğer bir fark yaratamayacak kadar küçük olduğunuzu düşünüyorsanız, bir sivrisinekle uyumayı deneyin. -Dalay Lama XIV"
    },
    "2026-06-19": {
        "content": " Çoğu zaman bir dokunuşun, bir gülümsemenin, nazik bir sözün, dinleyen bir kulağın, içten bir iltifatın veya en ufak bir şefkat eyleminin gücünü hafife alırız; bunların hepsi bir hayatı değiştirme potansiyeline sahiptir. -Leo Buscaglia"
    },
    "2026-06-20": {
        "content": " Günlerimizi nasıl geçirirsek, hayatımızı da öyle geçiriyoruz elbette. -Annie Dillard"
    },
    "2026-06-21": {
        "content": " Zihninizi büyük düşüncelerle besleyin, çünkü düşündüğünüzden daha yükseğe asla çıkamayacaksınız. -Benjamin Disraeli"
    },
    "2026-06-22": {
        "content": " Kurallara uyarak yürümeyi öğrenemezsin. Yaparak ve düşerek öğrenirsin. -Richard Branson"
    },
    "2026-06-23": {
        "content": " Bir şeyde başarısız olmadan yaşamak imkansızdır; ancak o kadar dikkatli yaşarsanız hiç yaşamamış sayılırsınız ki, otomatik olarak başarısız olursunuz. -JK Rowling"
    },
    "2026-06-24": {
        "content": " Mutlu olmak istiyorsan ol. -Leo Tolstoy"
    },
    "2026-06-25": {
        "content": " Hiç kimse benim iznim olmadan bana zarar veremez. -Mahatma Gandi"
    },
    "2026-06-26": {
        "content": " Ne olduğumu bıraktığımda, ne olabileceğim haline gelirim. -Lao Tzu"
    },
    "2026-06-27": {
        "content": "Güvensizlik duygusuyla boğuşmamızın sebebi, sahne arkasını başkalarının öne çıkan anlarıyla karşılaştırmamızdır. -Steven Furtick"
    },
    "2026-06-28": {
        "content": " Unutma, bugün dün endişelendiğin yarındır. -Dale Carnegie"
    },
    "2026-06-29": {
        "content": " Planladığımız hayattan vazgeçmeye razı olmalıyız ki, bizi bekleyen hayata sahip olabilelim. -Joseph Campbell"
    },
    "2026-06-30": {
        "content": " Gitmeyi bırak, varacaksın. Aramayı bırak, göreceksin. Kaçmayı bırak, bulunacaksın. -Lao Tzu"
    },
    "2026-07-01": {
        "content": " Bir ekip, birlikte çalışan bir grup insan değildir. Bir ekip, birbirine güvenen bir grup insandır. -Simon Sinek"
    },
    "2026-07-02": {
        "content": " Sürekli iyimserlik kuvvet çarpanıdır. -Colin Powell"
    },
    "2026-07-03": {
        "content": " Sadece kendiniz olmayı başardığınızda ve başkalarıyla kıyaslama veya rekabet yapmadığınızda, herkes size saygı duyacaktır. -Lao Tzu"
    },
    "2026-07-04": {
        "content": " Yaşını arkadaşların ile say, yılların ile değil. Hayatını gülümsemelerin ile say, gözyaşların ile değil. -John Lennon"
    },
    "2026-07-05": {
        "content": " Sevdiklerinize uçmaları için kanatlar, geri dönmeleri için kökler ve kalmaları için sebepler verin. -Dalay Lama XIV"
    },
    "2026-07-06": {
        "content": " Azim ve cesaret her çağda harikalar yaratmıştır. -George Washington"
    },
    "2026-07-07": {
        "content": "Bilginizi paylaşın. Ölümsüzlüğe ulaşmanın bir yoludur. -Dalay Lama XIV"
    },
    "2026-07-08": {
        "content": " Biz kozmosun kendini tanımasının bir yoluyuz. -Carl Sagan"
    },
    "2026-07-09": {
        "content": " İyi bir öğretmen umut aşılayabilir, hayal gücünü ateşleyebilir ve öğrenme sevgisi aşılayabilir. -Brad Henry"
    },
    "2026-07-10": {
        "content": " Bir insanın yapabileceği en büyük keşiflerden biri, en büyük sürprizlerinden biri, yapamayacağından korktuğu şeyi başarabilmesidir. -Henry Ford"
    },
    "2026-07-11": {
        "content": " En son ne zaman bir şeyi ilk defa yaptın? -John C. Maxwell"
    },
    "2026-07-12": {
        "content": " Olmak istediğiniz kişi olma sürecinde değilseniz, otomatik olarak olmak istemediğiniz kişiye dönüşmeye başlarsınız. -Dale Carnegie"
    },
    "2026-07-13": {
        "content": " Şans cesurların yanındadır. -Latince atasözü"
    },
    "2026-07-14": {
        "content": " Başarı mutluluğun anahtarı değildir. Mutluluk başarının anahtarıdır. Yaptığınız işi seviyorsanız başarılı olursunuz. -Albert Schweitzer"
    },
    "2026-07-15": {
        "content": " Dünyayı kazanıp da canını kaybetme; hikmet, gümüşten ve altından daha iyidir. -Bob Marley"
    },
    "2026-07-16": {
        "content": " Hemen yaşamaya başla ve her ayrı günü ayrı bir hayat olarak say. -Seneca"
    },
    "2026-07-17": {
        "content": "Senin gibi biri çok fazla umursamadığı sürece hiçbir şey düzelmeyecek. İyileşmiyor. -Dr. Seuss"
    },
    "2026-07-18": {
        "content": " Bunun imkansız olduğunu bilmiyorlardı ve bunu başardılar. -Mark Twain"
    },
    "2026-07-19": {
        "content": " Senin yapamadığın şeyleri ben yapabilirim, benim yapamadığım şeyleri sen yapabilirsin; birlikte çok büyük şeyler başarabiliriz. -Rahibe Teresa"
    },
    "2026-07-20": {
        "content": " Korkmamız gereken tek şey korkunun kendisidir. -Franklin D. Roosevelt"
    },
    "2026-07-21": {
        "content": " Coşku olmadan hiçbir büyük başarı elde edilemez. -Ralph Waldo Emerson"
    },
    "2026-07-22": {
        "content": " Cesaret, canım yüreğim. -CS Lewis"
    },
    "2026-07-23": {
        "content": " Değişimden anlam çıkarmanın tek yolu, ona dalmak, onunla birlikte hareket etmek ve dansa katılmaktır. -Alan Watts"
    },
    "2026-07-24": {
        "content": " Dikkatin olduğu yere enerji akar ve sonuçlar ortaya çıkar. -T. Harv Eker"
    },
    "2026-07-25": {
        "content": " Acı geçicidir. Bir dakika, bir saat, bir gün veya bir yıl sürebilir, ancak sonunda azalacaktır ve yerini başka bir şey alacaktır. Ancak bırakırsam sonsuza dek sürer. -Lance Armstrong"
    },
    "2026-07-26": {
        "content": " Doğayla yapılan her yürüyüşte, insan aradığından çok daha fazlasını bulur. -John Muir"
    },
    "2026-07-27": {
        "content": "Kazananlar asla başarısız olmayanlar değil, asla vazgeçmeyenlerdir. -Edwin Louis Cole"
    },
    "2026-07-28": {
        "content": " Karanlıkla savaşmak yerine, ışığı getirirsiniz. -Eckhart Tolle"
    },
    "2026-07-29": {
        "content": " Ruhunuzu ateşleyen şeylerin peşinde koşarken korkusuz olun. -Jennifer Lee"
    },
    "2026-07-30": {
        "content": " İnsanlar sizden uzaklaştığında, bırakın gitsinler. Kaderiniz sizi terk eden hiç kimseye bağlı değildir ve bu onların kötü insanlar olduğu anlamına gelmez. Bu sadece hikayenizdeki rollerinin bittiği anlamına gelir. -TD Jakes"
    },
    "2026-07-31": {
        "content": " Liderlik, vizyonu gerçeğe dönüştürme kapasitesidir. -Warren G. Bennis"
    },
    "2026-08-01": {
        "content": " İman, görmediğine inanmaktır; bu imanın mükafatı ise inandığını görmektir. -Aziz Augustinus"
    },
    "2026-08-02": {
        "content": " Hiçbir şey imkansız değildir, ta ki siz öyle olduğunu düşünmediğiniz sürece. -Paramahansa Yogananda"
    },
    "2026-08-03": {
        "content": " Kör olmaktan daha kötü olan tek şey, görebilmek ama vizyon sahibi olmamaktır. -Helen Keller"
    },
    "2026-08-04": {
        "content": " Her şeyin bir güzelliği vardır ama herkes bunu göremez. -Konfüçyüs"
    },
    "2026-08-05": {
        "content": " Allah, kalbin sessizliğinde konuşur. -Rahibe Teresa"
    },
    "2026-08-06": {
        "content": "Umut, ruha konan tüylü bir şeydir - ve sözsüz bir melodi söyler - ve asla durmaz. -Emily Dickinson"
    },
    "2026-08-07": {
        "content": " Ne kadar kutsal söz okursanız okuyun, ne kadar söylerseniz söyleyin, bunları uygulamazsanız size ne faydası olur? -Buda"
    },
    "2026-08-08": {
        "content": " Ve bu arada, eğer bunu yapacak dışa dönük cesaretiniz ve doğaçlama yapacak hayal gücünüz varsa, hayattaki her şey yazılabilir. Yaratıcılığın en büyük düşmanı kendinden şüphe duymaktır. -Sylvia Plath"
    },
    "2026-08-09": {
        "content": " Geçmişi değiştirecek hiçbir şey yapamayız ama yaptığımız her şey geleceği değiştirir. -Ashleigh Harika"
    },
    "2026-08-10": {
        "content": " Liderlik bir tercihtir. Bir rütbe değildir. -Simon Sinek"
    },
    "2026-08-11": {
        "content": " Her şey iyi olacak, her şey iyi olacak, her türlü şey iyi olacak. -Norwich'li Julian"
    },
    "2026-08-12": {
        "content": " Kozmik bakış açısına göre her birimiz değerliyiz. Eğer bir insan sizinle aynı fikirde değilse, bırakın yaşasın. Yüz milyar galakside bir tane daha bulamazsınız. -Carl Sagan"
    },
    "2026-08-13": {
        "content": " Zekâ artı karakter – işte gerçek eğitimin amacı budur. -Martin Luther King Jr."
    },
    "2026-08-14": {
        "content": "Kendinizi kendinizden daha büyük bir şeye ne kadar kaptırırsanız, o kadar fazla enerjiye sahip olursunuz. -Norman Vincent Peale"
    },
    "2026-08-15": {
        "content": " Temelleri öğrenin ve yaptığınız her şeyin seviyesi yükselecektir -Michael Jordan"
    },
    "2026-08-16": {
        "content": " Şimdi tam anlamıyla yaşayamazsan hiç yaşayamazsın. -Alan Watts"
    },
    "2026-08-17": {
        "content": " Bazen istediğinizi elde edememenin büyük bir şans olduğunu unutmayın. -Dalay Lama XIV"
    },
    "2026-08-18": {
        "content": " Elinizden gelenin en iyisini yapın ve sonra rahatlayın. İşleri zorlamak yerine doğal bir şekilde ilerlemesine izin verin. -Paramahansa Yogananda"
    },
    "2026-08-19": {
        "content": " Sen geçici bir insan deneyimi yaşayan sonsuz bir ruhsal varlıksın. -Wayne W. Dyer"
    },
    "2026-08-20": {
        "content": " Hayallerinizin gerçekleşmesi için önce hayal kurmanız gerekir. -Abdul Kelam"
    },
    "2026-08-21": {
        "content": " Her şeyden önce kalbinizi koruyun, çünkü yaptığınız her şey kalbinizden kaynaklanır. -Süleyman"
    },
    "2026-08-22": {
        "content": " Yazarken her şeyden sıyrılıyorum; üzüntülerim kayboluyor, cesaretim yeniden doğuyor. -Anne Frank"
    },
    "2026-08-23": {
        "content": " Amaç sonuna kadar mükemmel olmak değil. Amaç bugün daha iyi olmak. -Simon Sinek"
    },
    "2026-08-24": {
        "content": " Hayallerinizin doğrultusunda güvenle ilerleyin. Hayal ettiğiniz hayatı yaşayın. -Henry David Thoreau"
    },
    "2026-08-25": {
        "content": "Mümkün olduğunca nazik olun. Bu her zaman mümkündür. -Dalay Lama XIV"
    },
    "2026-08-26": {
        "content": " Bu hayattaki asıl amacımız başkalarına yardım etmektir. Ve eğer onlara yardım edemiyorsanız, en azından onlara zarar vermeyin. -Dalay Lama XIV"
    },
    "2026-08-27": {
        "content": " Kafanızın içinde beyniniz var. Ayakkabılarınızın içinde ayaklarınız var. Kendinizi istediğiniz yöne yönlendirebilirsiniz. Kendi başınızasınız. Ve ne bildiğinizi biliyorsunuz. Ve nereye gideceğinize karar verecek olan sizsiniz. -Dr. Seuss"
    },
    "2026-08-28": {
        "content": " Neye odaklanırsanız onu büyütürsünüz ve hayatınızdaki iyiliğe odaklandığınızda daha fazlasını yaratırsınız. -Oprah Winfrey"
    },
    "2026-08-29": {
        "content": " Bilmem gereken her şey bana açıklanıyor. İhtiyacım olan her şey bana geliyor. Hayatımda her şey yolunda. -Louise Hay"
    },
    "2026-08-30": {
        "content": " Evrende tamamen güvendeyim. Her yerde huzur içindeyim. Hayata güveniyorum. -Louise Hay"
    },
    "2026-08-31": {
        "content": " Yüzünü güneşe dön, gölgeler arkanda kalsın. -Maori Atasözü"
    },
    "2026-09-01": {
        "content": " Cesaret, devam edecek güce sahip olmak değil; gücün olmadığında devam edebilmektir. -Theodore Roosevelt"
    },
    "2026-09-02": {
        "content": " Gelecek, bugün ne yaptığınıza bağlıdır. -Mahatma Gandi"
    },
    "2026-09-03": {
        "content": " Kazanan, asla vazgeçmeyen hayalperesttir. -Nelson Mandela"
    },
    "2026-09-04": {
        "content": "Bittiği için ağlama, yaşandığı için gülümse. -Dr. Seuss"
    },
    "2026-09-05": {
        "content": " Hayat hakkında öğrendiğim her şeyi üç kelimeyle özetleyebilirim: Hayat devam ediyor. -Robert Frost"
    },
    "2026-09-06": {
        "content": " Hayallerinizle yaşayın, tarihinizle değil. -Stephen R. Covey"
    },
    "2026-09-07": {
        "content": " Benim bakış açıma göre, gökkuşağını istiyorsan yağmura katlanmalısın. -Dolly Parton"
    },
    "2026-09-08": {
        "content": " Bir insanın büyüklüğü, ne kadar çok servete sahip olduğuyla değil, dürüstlüğüyle ve etrafındakileri olumlu yönde etkileyebilme yeteneğiyle ölçülür. -Bob Marley"
    },
    "2026-09-09": {
        "content": " Mutluluk dış etkenlerden ziyade, esas olarak kendi tutumumuzdan kaynaklanır. -Dalay Lama XIV"
    },
    "2026-09-10": {
        "content": " Büyük işler küçük işlerden meydana gelir. -Lao Tzu"
    },
    "2026-09-11": {
        "content": " Ne olabileceğiniz konusunda asla geç değildir. -George Eliot"
    },
    "2026-09-12": {
        "content": " Doğru tutumu benimsemek olumsuz stresi olumluya dönüştürebilir. -Hans Selye"
    },
    "2026-09-13": {
        "content": " Kendiniz için hayal ettiğiniz hayatı yaşamaya cesaret edin. İlerleyin ve hayallerinizi gerçekleştirin. -Ralph Waldo Emerson"
    },
    "2026-09-14": {
        "content": " Boşa harcamaktan zevk aldığınız zaman, boşa harcanmış zaman değildir. -Bertrand Russell"
    },
    "2026-09-15": {
        "content": "Görmek ve anlamak için biraz uyanık olmak yeterli: Hayat aslında büyük bir kozmik kahkahadır. -Osho"
    },
    "2026-09-16": {
        "content": " İlginç bir paradoks şu ki, kendimi olduğum gibi kabul ettiğimde değişebilirim. -Carl R. Rogers"
    },
    "2026-09-17": {
        "content": " Sorunun değil, çözümün parçası olun. -Stephen R. Covey"
    },
    "2026-09-18": {
        "content": " Yaşamanın sırrı vermektir. -Tony Robbins"
    },
    "2026-09-19": {
        "content": " Her günü şaheseriniz yapın. -John Ahşap"
    },
    "2026-09-20": {
        "content": " Gerçekten yapmak istediklerinizden asla vazgeçmeyin -H. Jackson Brown Jr."
    },
    "2026-09-21": {
        "content": " Geriye bakma, o yöne gitmiyorsun. -Mary Engelbreit"
    },
    "2026-09-22": {
        "content": " Sen elinden geleni yap, gerisini Allah halleder. -Nick Vujicic"
    },
    "2026-09-23": {
        "content": " Yaşa, seyahat et, maceraya atıl, şükret ve pişman olma. -Jack Kerouac"
    },
    "2026-09-24": {
        "content": " Kışın ortasında, içimde yenilmez bir yaz olduğunu keşfettim. Ve bu beni mutlu ediyor. Çünkü bu, dünya bana ne kadar sert baskı yaparsa yapsın, içimde daha güçlü bir şeyin, daha iyi bir şeyin, tam geri ittiğini söylüyor. -Albert Camus"
    },
    "2026-09-25": {
        "content": "Bazıları kötülüğü kontrol altında tutabilecek tek şeyin büyük bir güç olduğuna inanır, ancak benim bulduğum bu değil. Karanlığı uzak tutan şey sıradan insanların küçük günlük eylemleridir. Küçük nezaket ve sevgi eylemleri. -JRR Tolkien"
    },
    "2026-09-26": {
        "content": " Küçük şeylerde sadık olun, çünkü gücünüz onlardadır. -Rahibe Teresa"
    },
    "2026-09-27": {
        "content": " Kendini bir ışık yap. -Buda"
    },
    "2026-09-28": {
        "content": " GÖRSELLEŞTİR!!! Gör, hisset! Aksiyon burada başlıyor. -Rhonda Byrne"
    },
    "2026-09-29": {
        "content": " Olağanüstü ol ya da unutul! -Eric Thomas"
    },
    "2026-09-30": {
        "content": " Haklı olmak ya da nazik olmak arasında bir seçim yapmanız gerektiğinde, nazik olmayı seçin. -Wayne W. Dyer"
    },
    "2026-10-01": {
        "content": " İnsanlar zihinsel tutumlarını değiştirerek hayatlarını değiştirebilirler. -William James"
    },
    "2026-10-02": {
        "content": " Sağlık en büyük servettir. -Laozi"
    },
    "2026-10-03": {
        "content": " Tehlikelerden korunmak için dua etmeyeyim, onlarla yüzleşmekten korkmayayım. Acımın dinmesi için yalvarmayayım, onu fethetmek için yürekten yalvarayım. -Rabindranath Tagore"
    },
    "2026-10-04": {
        "content": " Kalbinizi iyilik yapmaya odaklayın. Bunu tekrar tekrar yapın, sevinçle dolacaksınız. -Buda"
    },
    "2026-10-05": {
        "content": "Ben tek başıma dünyayı değiştiremem ama suyun üzerine bir taş atıp dalgalar yaratabilirim. -Rahibe Teresa"
    },
    "2026-10-06": {
        "content": " Ve bir gün geldi ki, tomurcukta sımsıkı kalmanın riski, çiçek açmanın riskinden daha acı verici oldu. -Anaïs Nin"
    },
    "2026-10-07": {
        "content": " İnsan çabasının sınırları olmamalıdır. Hayat ne kadar kötü görünürse görünsün, her zaman umut vardır. -Stephen Hawking"
    },
    "2026-10-08": {
        "content": " Ve sizi mutlu olduğunuz zamanların farkına varmaya ve bir noktada haykırmaya, mırıldanmaya veya düşünmeye çağırıyorum: 'Eğer bu güzel değilse, neyin güzel olduğunu bilmiyorum.' -Kurt Vonnegut"
    },
    "2026-10-09": {
        "content": " Hayat hikayenizin nasıl gelişeceğini, sıkıntının kendisi değil, sizin sıkıntıya verdiğiniz tepki belirler. -Dieter F. Uchtdorf"
    },
    "2026-10-10": {
        "content": " Seni mutlu ya da mutsuz eden şey sahip olduğun şeyler, kim olduğun, nerede olduğun ya da ne yaptığın değildir. Bunlar hakkında ne düşündüğündür. -Dale Carnegie"
    },
    "2026-10-11": {
        "content": " Ne kadar çok okursanız, o kadar çok şey bileceksiniz. Ne kadar çok öğrenirseniz, o kadar çok yere gideceksiniz. -Dr. Seuss"
    },
    "2026-10-12": {
        "content": " Bütün hayallerimiz gerçek olabilir. -Walt Disney"
    },
    "2026-10-13": {
        "content": "Hayatınızın ayrıcalığı, kendiniz olmaktır. -Joseph Campbell"
    },
    "2026-10-14": {
        "content": " Bu dünyada bir başkasının yükünü hafifleten hiç kimse işe yaramaz değildir. -Charles Dickens"
    },
    "2026-10-15": {
        "content": " İçinizde neşenin olduğu bir yer bulun, neşe acıyı yakıp yok edecektir. -Joseph Campbell"
    },
    "2026-10-16": {
        "content": " Dünyanın neye ihtiyacı olduğunu sorma. Seni neyin canlandırdığını sor ve git onu yap. Çünkü dünyanın ihtiyacı olan şey, canlanan daha fazla insan. -Howard Thurman"
    },
    "2026-10-17": {
        "content": " Duygularınız hayatınızı yaratmanıza yardımcı olan en büyük araçlarınızdır. -Rhonda Byrne"
    },
    "2026-10-18": {
        "content": " Ben en iyisini hak ediyorum ve artık en iyisini kabul ediyorum. -Louise Hay"
    },
    "2026-10-19": {
        "content": " Önemli olan ne kadar verdiğimiz değil, verirken ne kadar sevgi koyduğumuzdur. -Rahibe Teresa"
    },
    "2026-10-20": {
        "content": " Başarılı olmayı nefes almak istediğin kadar çok istediğinde, o zaman başarılı olursun. -Eric Thomas"
    },
    "2026-10-21": {
        "content": " Antrenmanların her dakikasından nefret ediyordum ama dedim ki, \"Vazgeçme. Şimdi acı çek ve hayatının geri kalanını bir şampiyon olarak yaşa.\" -Muhammed Ali"
    },
    "2026-10-22": {
        "content": "Önemli olan eleştirmen değildir, güçlü adamın nasıl tökezlediğini veya işlerin failinin onları nasıl daha iyi yapabileceğini gösteren kişi değildir. Övgü, arenada gerçekten bulunan, yüzü ter, toz ve kanla lekelenmiş; yiğitçe çabalayan; hata yapan ve tekrar tekrar başarısız olan; büyük coşkuları, büyük bağlılıkları bilen ve kendini değerli bir dava uğruna harcayan; kazanırsa, yüksek başarının zaferini bilen; ve başarısız olursa, en azından büyük cesaret göstererek başarısız olan, böylece yeri asla zaferi veya yenilgiyi bilmeyen o soğuk ve korkak ruhlarla olmayacak adama aittir. -Theodore Roosevelt"
    },
    "2026-10-23": {
        "content": " Hayatınızda yaşayabileceğiniz en büyük macera, hayallerinizdeki hayatı yaşamaktır. -Oprah Winfrey"
    },
    "2026-10-24": {
        "content": " Mücadele olmadan ilerleme olmaz. -Frederick Douglass"
    },
    "2026-10-25": {
        "content": " Bir tarihle yazılmış bir rüya bir hedefe dönüşür. Adımlara bölünmüş bir hedef bir plana dönüşür. Eylemle desteklenen bir plan hayallerinizi gerçekleştirir. -Greg Reid"
    },
    "2026-10-26": {
        "content": "Yapamayacağını düşündüğün tek şeyi yap. Başarısız ol. Tekrar dene. İkinci seferde daha iyisini yap. Asla düşmeyen tek insanlar, asla yüksek telden yukarı çıkmayanlardır. -Oprah Winfrey"
    },
    "2026-10-27": {
        "content": " Değişimi bekleyin. Manzarayı analiz edin. Fırsatları değerlendirin. Satranç taşı olmayı bırakın; oyuncu olun. Sıra sizde. -Tony Robbins"
    },
    "2026-10-28": {
        "content": " Özgürsün. Güçlüsün. İyisin. Sevgisin. Değerlisin. Amacın var. Her şey yolunda. -Esther Hicks"
    },
    "2026-10-29": {
        "content": "Eğer bir şeyi çok istiyorsan, onun için dışarı çıkıp savaşacak, gece gündüz çalışacak, zamanından, huzurundan ve uykundan vazgeçecek kadar çok istiyorsan; Eğer tüm hayal ettiğin ve planladığın şey onun hakkındaysa ve hayat onsuz işe yaramaz ve değersiz görünüyorsa; Eğer onun için seve seve ter döküyor, üzülüyor ve plan yapıyorsan ve onun uğruna karşındakine karşı duyduğun korkudan kurtuluyorsan; Eğer istediğin şeyin peşinden tüm kapasiten, gücün ve zekan, inancın, umudun ve güvenin ve inatçılığınla gidiyorsan; Eğer ne soğuk ne de yoksulluk, açlık veya gut hastalığı, beden ve beyninin hastalığı veya acısı seni istediğin şeyden uzak tutamıyorsa; Eğer inatçı ve asabiysen ve onu doğuruyorsan, Tanrı'nın yardımıyla onu elde edeceksin. -Berton Braley"
    },
    "2026-10-30": {
        "content": " Doğru yolda olsanız bile, orada öylece oturursanız ezilirsiniz. -Will Rogers"
    },
    "2026-10-31": {
        "content": " Sıradan insanların sıra dışı olmayı seçebileceğini düşünüyorum. -Elon Musk"
    },
    "2026-11-01": {
        "content": " Kurallara uyarak yürümeyi öğrenemezsin. Yaparak ve düşerek öğrenirsin. -Richard Branson"
    },
    "2026-11-02": {
        "content": "Burada yetenek yok, bu sıkı çalışma. Bu bir saplantı. Yetenek diye bir şey yok, hepimiz insan olarak eşitiz. Zaman harcarsan herkes olabilirsin. Zirveye ulaşacaksın ve bu kadar. Ben yetenekli değilim, saplantılıyım. -Conor McGregor"
    },
    "2026-11-03": {
        "content": " Rüya, uyurken gördüğünüz şey değil, uyumanıza engel olan şeydir. -Abdul Kelam"
    },
    "2026-11-04": {
        "content": " Tüm olasılıkları tükettiğinizde şunu hatırlayın: Tüketmediniz. -Thomas A. Edison"
    },
    "2026-11-05": {
        "content": " Şansını dene, hata yap. Büyümenin yolu budur. Acı cesaretini besler. Cesur olmayı uygulamak için başarısız olman gerekir. -Mary Tyler Moore"
    },
    "2026-11-06": {
        "content": " Neye odaklanırsanız onu elde edersiniz. -Tony Robbins"
    },
    "2026-11-07": {
        "content": " Telaş, HER ZAMAN en önemli kelimedir. -Gary Vaynerchuk"
    },
    "2026-11-08": {
        "content": " Küflü ekmekten penisilin yapabiliyorlarsa, senden de bir şeyler yapabilirler. -Muhammed Ali"
    },
    "2026-11-09": {
        "content": " Kazanan olarak doğmadın ve kaybeden olarak doğmadın. Kendini ne yaparsan osun. -Lou Holtz"
    },
    "2026-11-10": {
        "content": " Başarı sizin göreviniz, zorunluluğunuz ve sorumluluğunuzdur. -Grant Cardone"
    },
    "2026-11-11": {
        "content": "İnsanlar arasında çok az fark vardır, ancak o küçük fark büyük bir fark yaratır. Küçük fark tutumdur. Büyük fark ise olumlu ya da olumsuz olmasıdır. -W. Clement Taşı"
    },
    "2026-11-12": {
        "content": " Liderler başkalarıyla ilişki kurabilecek kadar yakın, ama onları motive edebilecek kadar da önde olmalıdır. -John C. Maxwell"
    },
    "2026-11-13": {
        "content": " Asla asla demeyin, çünkü sınırlar da korkular gibi çoğu zaman sadece birer yanılsamadır. -Michael Jordan"
    },
    "2026-11-14": {
        "content": " Büyük şeyler başarabilmek için, önce kendinizden büyük şeyler beklemelisiniz. -Michael Jordan"
    },
    "2026-11-15": {
        "content": " İş dünyasında en başarılı olanlar, sevdikleri işi yapanlardır. -Warren Buffett"
    },
    "2026-11-16": {
        "content": " Eylem, erteleme alışkanlığınızı yok edecektir. -Og Mandino"
    },
    "2026-11-17": {
        "content": " Başarısızlık benim için bir seçenek değil. Başarı benim için tek hayal. -Conor McGregor"
    },
    "2026-11-18": {
        "content": " Başarı ara sıra yaptığınız şeyden değil, sürekli yaptığınız şeyden gelir. -Marie Forleo"
    },
    "2026-11-19": {
        "content": " Güven ve sıkı çalışma başarısızlık denen hastalığı öldürmek için en iyi ilaçlardır. Sizi başarılı bir insan yapacaktır. -Abdul Kelam"
    },
    "2026-11-20": {
        "content": " Güneş gibi parlamak istiyorsan önce güneş gibi yan. -Abdul Kelam"
    },
    "2026-11-21": {
        "content": "Siz dışarıda parti yaparken, at koştururken, aynı anda birileri de çok çalışıyor. Birileri akıllanıyor ve birileri kazanıyor. Bunu unutmayın. -Arnold Schwarzenegger"
    },
    "2026-11-22": {
        "content": " Her zaman yaptığınızı yaparsanız, her zaman aldığınızı alırsınız. -Tony Robbins"
    },
    "2026-11-23": {
        "content": " İlerleme mutluluk demektir. -Tony Robbins"
    },
    "2026-11-24": {
        "content": " Sonuçlar veya bahaneler olabilir. İkisi birden değil. -Arnold Schwarzenegger"
    },
    "2026-11-25": {
        "content": " Disiplin eşittir özgürlük. -Jocko Willink"
    },
    "2026-11-26": {
        "content": " Neyin yanlış gittiğine takılıp kalmayın. Bunun yerine, bundan sonra ne yapacağınıza odaklanın. Enerjinizi ileriye doğru hareket etmeye, cevabı bulmaya harcayın. -Denis Waitley"
    },
    "2026-11-27": {
        "content": " Keşke sahip olmayı istediğin lider ol. -Simon Sinek"
    },
    "2026-11-28": {
        "content": " Benim tutumum şu: Eğer beni zayıflık olarak gördüğünüz bir şeye doğru iterseniz, o algılanan zayıflığı bir güce dönüştürürüm. -Michael Jordan"
    },
    "2026-11-29": {
        "content": " Çoğumuz için en büyük tehlike hedefimizi çok yükseğe koyup hedefimize ulaşamamak değil; hedefimizi çok düşük tutup hedefimize ulaşamamaktır. -Michelangelo"
    },
    "2026-11-30": {
        "content": " Herkesin bir hayali vardır ama herkesin bir çabası yoktur. -Eric Thomas"
    },
    "2026-12-01": {
        "content": "Liderler yapılır, doğmazlar. Onlar sıkı çabayla yapılırlar, bu da değerli herhangi bir hedefe ulaşmak için hepimizin ödemesi gereken bedeldir. -Vince Lombardi"
    },
    "2026-12-02": {
        "content": " Bu on yılda aya gitmeyi ve diğer şeyleri yapmayı seçiyoruz. Kolay oldukları için değil, zor oldukları için. -John F. Kennedy"
    },
    "2026-12-03": {
        "content": " Senin ve benim hayatımızdaki en büyük gün, tutumlarımız için tüm sorumluluğu aldığımız gündür. İşte o gün gerçekten büyüdüğümüz gündür. -John C. Maxwell"
    },
    "2026-12-04": {
        "content": " Birine her gülümsediğinizde, bu bir sevgi eylemidir, o kişiye bir hediyedir, güzel bir şeydir. -Rahibe Teresa"
    },
    "2026-12-05": {
        "content": " Düşüncelerinizin ve davranışlarınızın sessiz izleyicisi olun. Düşünenin altındasınız. Zihinsel gürültünün altındaki dinginliksiniz. Acının altındaki sevgi ve neşesiniz. -Eckhart Tolle"
    },
    "2026-12-06": {
        "content": " Uçamıyorsan koş, koşamıyorsan yürü, yürüyemiyorsan sürün, ama ne yaparsan yap ilerlemeye devam etmelisin. -Martin Luther King Jr."
    },
    "2026-12-07": {
        "content": " Affetmek ara sıra yapılan bir eylem değil, sürekli bir tutumdur. -Martin Luther King Jr."
    },
    "2026-12-08": {
        "content": " Çoğu zaman bir dokunuşun, bir gülümsemenin, nazik bir sözün, dinleyen bir kulağın, içten bir iltifatın veya en ufak bir şefkat eyleminin gücünü hafife alırız; bunların hepsi bir hayatı değiştirme potansiyeline sahiptir. -Leo Buscaglia"
    },
    "2026-12-09": {
        "content": "Hayallerinizi canlı tutun. Herhangi bir şeyi başarmanın kendinize olan inanç ve güven, vizyon, sıkı çalışma, kararlılık ve özveri gerektirdiğini anlayın. İnananlar için her şeyin mümkün olduğunu unutmayın. -Gail Devers"
    },
    "2026-12-10": {
        "content": " Sporun dünyayı değiştirme gücü vardır. İlham verme gücü vardır. İnsanları başka hiçbir şeyin yapamayacağı şekilde birleştirme gücü vardır. Gençlere anladıkları bir dilde konuşur. Spor, bir zamanlar sadece umutsuzluk olan yerde umut yaratabilir. -Nelson Mandela"
    },
    "2026-12-11": {
        "content": " İstediğini iste. Bunu hak ettiğine inan ve sonra Hayatın onu sana vermesine izin ver. -Louise Hay"
    },
    "2026-12-12": {
        "content": " Niyetli yaşa. Sınıra kadar yürü. İyi dinle. Sağlıklı olmayı uygula. Terk edilmiş bir şekilde oyna. Gül. Pişman olmadan seç. Arkadaşlarına değer ver. Öğrenmeye devam et. Sevdiğin şeyi yap. Sanki her şey bundan ibaretmiş gibi yaşa. -Mary Anne Radmacher"
    },
    "2026-12-13": {
        "content": " Neye odaklanırsanız onu büyütürsünüz ve hayatınızdaki iyiliğe odaklandığınızda daha fazlasını yaratırsınız. -Oprah Winfrey"
    },
    "2026-12-14": {
        "content": " Zihniniz üzerinde gücünüz var, dış olaylar üzerinde değil. Bunu fark edin ve güç bulacaksınız. -Marcus Aurelius"
    },
    "2026-12-15": {
        "content": "Neden yapamayacağınıza dair bahaneler üretmeyin. Bunu neden yapmanız gerektiğine dair tüm nedenlere odaklanın. -Ralph Marston"
    },
    "2026-12-16": {
        "content": " Aşkın olduğu yerde hayat vardır. -Mahatma Gandi"
    },
    "2026-12-17": {
        "content": " Hiç kimse izlemiyormuş gibi dans etmelisin, asla incinmeyecekmiş gibi sevmelisin, hiç kimse dinlemiyormuş gibi şarkı söylemelisin ve yeryüzünde cennetmiş gibi yaşamalısın. -William W. Purkey"
    },
    "2026-12-18": {
        "content": " Başarı, hayattaki amacınızı bilmek, maksimum potansiyelinize ulaşmak için büyümek ve başkalarına fayda sağlayacak tohumlar ekmektir. -John C. Maxwell"
    },
    "2026-12-19": {
        "content": " Tek başınıza kurduğunuz bir rüya sadece bir rüyadır. Birlikte kurduğunuz bir rüya ise gerçekliktir. -John Lennon"
    },
    "2026-12-20": {
        "content": " Hayatın gerçek sırrı, burada ve şimdi yaptığınız şeyle tamamen meşgul olmaktır. Ve buna iş demek yerine, bunun bir oyun olduğunu fark edin. -Alan Watts"
    },
    "2026-12-21": {
        "content": " Dün geçti. Yarın henüz gelmedi. Sadece bugünümüz var. Başlayalım. -Rahibe Teresa"
    },
    "2026-12-22": {
        "content": " Hayatınızı ne kadar çok över ve kutlarsanız, hayatta kutlanacak o kadar çok şey olur. -Oprah Winfrey"
    },
    "2026-12-23": {
        "content": "Düşünceli, kararlı bir grup vatandaşın dünyayı değiştirebileceğinden asla şüphe etmeyin. Gerçekten de, bunu başaran tek şey budur. -Margaret Mead"
    },
    "2026-12-24": {
        "content": " Kendinizi zorlayın, çünkü bunu sizin için kimse yapmayacak. -Anonim"
    },
    "2026-12-25": {
        "content": " Gerçek tevazu, kendinizi küçümsemek değil; kendinizi daha az düşünmektir. -CS Lewis"
    },
    "2026-12-26": {
        "content": " Eğer zihninizi değiştirebilirseniz, hayatınızı değiştirebilirsiniz. -William James"
    },
    "2026-12-27": {
        "content": " Korktuğunuz şeye değil, gitmek istediğiniz yere odaklanın. -Tony Robbins"
    },
    "2026-12-28": {
        "content": " Kendinize saygı gösterin, başkaları da size saygı duyacaktır. -Konfüçyüs"
    },
    "2026-12-29": {
        "content": " Elinizde olanla, bulunduğunuz yerde elinizden geleni yapın. -Theodore Roosevelt"
    },
    "2026-12-30": {
        "content": " Bazı değişimler ilk bakışta olumsuz gibi görünse de, kısa sürede hayatınızda yeni bir şeyin ortaya çıkması için alan açıldığını fark edeceksiniz. -Eckhart Tolle"
    },
    "2026-12-31": {
        "content": " Eğer eylemleriniz başkalarına daha fazla hayal kurma, daha fazla öğrenme, daha fazla şey yapma ve daha fazlası olma konusunda ilham veriyorsa, siz bir lidersiniz. -John Quincy Adams"
    }
}
export const dateGermanList = {
    "2024-01-01": {
        "content": "Wir sind, was wir wiederholt tun. Exzellenz ist daher keine Handlung, sondern eine Gewohnheit. -Aristoteles"
    },
    "2024-01-02": {
        "content": " Ein Fluss schneidet sich durch Felsen, nicht aufgrund seiner Kraft, sondern aufgrund seiner Beharrlichkeit. -Jim Watkins"
    },
    "2024-01-03": {
        "content": " Energie und Ausdauer überwinden alles. -Benjamin Franklin"
    },
    "2024-01-04": {
        "content": " Chancen werden normalerweise als harte Arbeit getarnt, sodass die meisten Menschen sie nicht erkennen. -Ann Landers"
    },
    "2024-01-05": {
        "content": " Wenn du nicht fliegen kannst, dann laufe. Wenn du nicht rennen kannst, dann geh. Wenn du nicht gehen kannst, dann krieche. Aber was auch immer du tust, du musst weiter vorwärts gehen. -Martin Luther King Jr."
    },
    "2024-01-06": {
        "content": " Durch Beharrlichkeit sind Ergebnisse vorprogrammiert. -Paramahansa Yogananda"
    },
    "2024-01-07": {
        "content": " Mit gewöhnlichem Talent und außergewöhnlicher Ausdauer sind alle Dinge erreichbar -Thomas Fowell Buxton"
    },
    "2024-01-08": {
        "content": " Unser größter Ruhm besteht nicht darin, niemals zu versagen, sondern jedes Mal wieder aufzustehen, wenn wir versagen. -Ralph Waldo Emerson"
    },
    "2024-01-09": {
        "content": " Erfolg bedeutet, von einem Misserfolg zum nächsten zu stolpern, ohne die Begeisterung zu verlieren. -Winston Churchill"
    },
    "2024-01-10": {
        "content": "Glücklicherweise ist Beharrlichkeit ein großartiger Ersatz für Talent. -Steve Martin"
    },
    "2024-01-11": {
        "content": " Ich glaube fest an Glück und je härter ich arbeite, desto mehr habe ich davon. -Thomas Jefferson"
    },
    "2024-01-12": {
        "content": " Verschieben Sie nur das auf morgen, was Sie auch unter dem Eindruck Ihres Todes unerledigt lassen möchten. -Pablo Picasso"
    },
    "2024-01-13": {
        "content": " Es gibt keine Erfolgsgeheimnisse: Verschwenden Sie keine Zeit damit, danach zu suchen. Erfolg ist das Ergebnis von Perfektion, harter Arbeit, Lernen aus Fehlern, Loyalität gegenüber Ihren Mitarbeitern und Beharrlichkeit. -Colin Powell"
    },
    "2024-01-14": {
        "content": " Wenn Sie vorne sein möchten, dann tun Sie so, als wären Sie hinten. -Lao Tzu"
    },
    "2024-01-15": {
        "content": " Lassen Sie mich Ihnen das Geheimnis verraten, das mich zu meinem Ziel geführt hat: Meine Stärke liegt einzig und allein in meiner Hartnäckigkeit. -Louis Pasteur"
    },
    "2024-01-16": {
        "content": " Nichts auf dieser Welt kann Beharrlichkeit ersetzen. Talent nicht; nichts ist häufiger als erfolglose Menschen mit Talent. Genie nicht; unbelohntes Genie ist fast ein Sprichwort. -Calvin Coolidge"
    },
    "2024-01-17": {
        "content": " Der beste Ausweg ist immer der Durchgang. -Robert Frost"
    },
    "2024-01-18": {
        "content": "Viele der Versager im Leben sind Menschen, die nicht erkannt haben, wie nahe sie dem Erfolg waren, als sie aufgegeben haben. -Thomas A. Edison"
    },
    "2024-01-19": {
        "content": " Wir sind dazu geschaffen, durchzuhalten. So finden wir heraus, wer wir sind. -Tobias Wolff"
    },
    "2024-01-20": {
        "content": " Da ich Bäume kenne, verstehe ich die Bedeutung von Geduld. Da ich Gras kenne, weiß ich Beharrlichkeit zu schätzen. -Hal Borland"
    },
    "2024-01-21": {
        "content": " Tropfendes Wasser höhlt Stein aus, nicht durch Kraft, sondern durch Beharrlichkeit. -Ovid"
    },
    "2024-01-22": {
        "content": " Beharrlichkeit ist sehr wichtig. Sie sollten nicht aufgeben, es sei denn, Sie werden dazu gezwungen. -Elon Musk"
    },
    "2024-01-23": {
        "content": " Glühende Begeisterung, gepaart mit gesundem Menschenverstand und Ausdauer, ist die Eigenschaft, die am häufigsten zum Erfolg führt. -Dale Carnegie"
    },
    "2024-01-24": {
        "content": " Ehrgeiz ist der Weg zum Erfolg. Beharrlichkeit ist das Fahrzeug, mit dem Sie ankommen. -Bill Bradley"
    },
    "2024-01-25": {
        "content": " Konzentrieren Sie sich auf die Lösung, nicht auf das Problem. -Walter Anderson"
    },
    "2024-01-26": {
        "content": " Wenn das Leben Sie niederschlägt, haben Sie zwei Möglichkeiten: liegen bleiben oder aufstehen. -Tom Krause"
    },
    "2024-01-27": {
        "content": "Erfolg ist die Summe kleiner Anstrengungen, die Tag für Tag wiederholt werden. -Robert Collier"
    },
    "2024-01-28": {
        "content": " Ein Traum ist nur ein Traum. Ein Ziel ist ein Traum mit einem Plan und einer Frist. -Harvey MacKay"
    },
    "2024-01-29": {
        "content": " Geben Sie niemals etwas auf, an das Sie keinen Tag lang nicht denken können. -Winston Churchill"
    },
    "2024-01-30": {
        "content": " Diamanten sind nichts anderes als Kohlestücke, die an ihrer Aufgabe haften geblieben sind. -Malcolm S. Forbes"
    },
    "2024-01-31": {
        "content": " Man kann nichts tun, außer Stück für Stück. -Charles Baudelaire"
    },
    "2024-02-01": {
        "content": " Wenn Sie durch die Hölle gehen, machen Sie weiter. -Winston Churchill"
    },
    "2024-02-02": {
        "content": " Der Schlüssel der Beharrlichkeit öffnet alle Türen, die durch Widerstand verschlossen sind. -John Di Lemme"
    },
    "2024-02-03": {
        "content": " Wenn wir uns die erfolgreichsten Menschen der Welt ansehen, ist Beharrlichkeit der gemeinsame Nenner. -Justin Sachs"
    },
    "2024-02-04": {
        "content": " Sie können einen Elefanten Stück für Stück essen. -Mary Kay Ash"
    },
    "2024-02-05": {
        "content": " Ich glaube nicht, dass es eine andere Eigenschaft gibt, die für Erfolg jeglicher Art so wichtig ist wie Beharrlichkeit. Sie überwindet fast alles, sogar die Natur. -John D. Rockefeller"
    },
    "2024-02-06": {
        "content": "Wer eine Vision in die Tat umsetzen möchte, muss 100 % geben und nie aufhören, an seinen Traum zu glauben. -Arnold Schwarzenegger"
    },
    "2024-02-07": {
        "content": " Laufen Sie, wenn Sie können, gehen Sie, wenn es sein muss, kriechen Sie, wenn es sein muss; geben Sie einfach niemals auf. -Dean Karnazes"
    },
    "2024-02-08": {
        "content": " Noch eine Runde weiterzugehen, wenn Sie denken, dass Sie es nicht können – das macht den entscheidenden Unterschied in Ihrem Leben. -Sylvester Stallone"
    },
    "2024-02-09": {
        "content": " Hör mir zu, selbst wenn du verlierst, ist es okay zu verlieren, aber du kannst dich nie damit anfreunden. Du kannst nie zufrieden sein mit einer Niederlage. Wenn du verlierst, muss es weh tun. -Eric Thomas"
    },
    "2024-02-10": {
        "content": " Gehen Sie Ihren Weg weiter, Schritt für Schritt. -Joyce Meyer"
    },
    "2024-02-11": {
        "content": " Wir sollten nicht aufgeben und nicht zulassen, dass uns das Problem besiegt. -Abdul Kalam"
    },
    "2024-02-12": {
        "content": " Durch Ausdauer siegen wir. -Ernest Shackleton"
    },
    "2024-02-13": {
        "content": "Die Mauern sind aus einem bestimmten Grund da. Sie sind nicht da, um uns fernzuhalten. Sie sind da, um uns die Möglichkeit zu geben, zu zeigen, wie sehr wir etwas wollen. Denn sie sind da, um diejenigen aufzuhalten, die es nicht stark genug wollen. Sie sind da, um die anderen aufzuhalten. -Randy Pausch"
    },
    "2024-02-14": {
        "content": " Erfolg hängt fast ausschließlich von Tatkraft und Ausdauer ab. Die zusätzliche Energie, die für einen weiteren Versuch oder einen anderen Ansatz erforderlich ist, ist das Geheimnis des Erfolgs. -Denis Waitley"
    },
    "2024-02-15": {
        "content": " Ich hatte es bis hierher geschafft und weigerte mich aufzugeben, weil ich mein ganzes Leben lang jedes Rennen zu Ende gebracht hatte. -Louis Zamperini"
    },
    "2024-02-16": {
        "content": " Überleben lässt sich in drei Worten zusammenfassen: Gib niemals auf. Das ist der Kern der Sache. Versuche es einfach weiter. -Bear Grylls"
    },
    "2024-02-17": {
        "content": "Schluss damit. Keine Ausreden mehr. Schluss mit: „Ich fange morgen an.“ Schluss mit: „Nur dieses eine Mal.“ Schluss mit dem Akzeptieren der Schwächen meines eigenen Willens. Schluss mit dem einfachen Weg. Schluss mit dem Nachgeben gegenüber ungesunden oder unproduktiven Gedanken, die mir durch den Kopf gehen. -Jocko Willink"
    },
    "2024-02-18": {
        "content": " Mit kleinen Schlägen werden große Eichen gefällt. -Benjamin Franklin"
    },
    "2024-02-19": {
        "content": " Ich bin bereit.“ „Ich bin darauf programmiert zu gewinnen.“ „Ich schaffe das.“ „Ich nehme die Ungewissheit an.“ „Ich bin nicht meine Gedanken, ich bin, was ich tue.“ „Ich bin unerbittlich.“ „Ich erwarte nichts und akzeptiere alles.“ -Gary John Bishop"
    },
    "2024-02-20": {
        "content": " Ich habe nicht 700 Mal versagt. Ich habe nicht ein einziges Mal versagt. Ich habe bewiesen, dass diese 700 Wege nicht funktionieren. Wenn ich die Wege eliminiert habe, die nicht funktionieren, werde ich den Weg finden, der funktioniert. -Thomas A. Edison"
    },
    "2024-02-21": {
        "content": " GRIT steht für Mut, Belastbarkeit, Fleiß und Hartnäckigkeit. GRIT ist die Fähigkeit, sich zu konzentrieren, entschlossen zu bleiben, angesichts einer Herausforderung optimistisch zu bleiben und einfach härter zu arbeiten als jeder andere. -Linda Kaplan Thaler"
    },
    "2024-02-22": {
        "content": "Ich glaube, mein Geheimnis ist, dass es keine Abkürzungen für harte Arbeit, Entschlossenheit und die Einstellung „Gib nicht auf“ gibt. -Jerry Rice"
    },
    "2024-02-23": {
        "content": " Hören Sie nie auf zu kämpfen, bis Sie an Ihrem Bestimmungsort angekommen sind – das heißt, bei Ihrem einzigartigen Ich. Setzen Sie sich ein Ziel im Leben, eignen Sie sich kontinuierlich Wissen an, arbeiten Sie hart und haben Sie Ausdauer, um das großartige Leben zu verwirklichen. -Abdul Kalam"
    },
    "2024-02-24": {
        "content": " Hören Sie nicht auf, wenn Sie müde sind. Hören Sie auf, wenn Sie fertig sind. -David Goggins"
    },
    "2024-02-25": {
        "content": " Beurteilen Sie mich nicht nach meinen Erfolgen, sondern danach, wie oft ich hingefallen und wieder aufgestanden bin. -Nelson Mandela"
    },
    "2024-02-26": {
        "content": " Was heute nicht begonnen wird, wird morgen nie beendet sein. -Johann Wolfgang von Goethe"
    },
    "2024-02-27": {
        "content": " Wenn Sie hundert Kurzgeschichten schreiben und alle schlecht sind, heißt das nicht, dass Sie versagt haben. Sie versagen erst, wenn Sie mit dem Schreiben aufhören. -Ray Bradbury"
    },
    "2024-02-28": {
        "content": " Der Meister ist öfter gescheitert, als der Anfänger es überhaupt versucht hat. -Stephen McCranie"
    },
    "2024-02-29": {
        "content": " Zum Teufel mit den Umständen, ich schaffe Gelegenheiten. -Bruce Lee"
    },
    "2024-03-01": {
        "content": "Das Einzige, was schlimmer ist, als etwas anzufangen und zu scheitern, ist, nichts anzufangen. -Seth Godin"
    },
    "2024-03-02": {
        "content": " Verschieben Sie nie auf morgen, was Sie heute tun können. -Benjamin Franklin"
    },
    "2024-03-03": {
        "content": " Durch Beharrlichkeit erreichte die Schnecke die Arche. -Charles H. Spurgeon"
    },
    "2024-03-04": {
        "content": " Denken Sie daran: Hoffnung ist eine gute Sache, vielleicht sogar das Beste, und nichts Gutes stirbt jemals. -Stephen King"
    },
    "2024-03-05": {
        "content": " Unternehmer hören nicht auf, wenn sie müde sind. Wir hören auf, wenn wir fertig sind. -Robert T. Kiyosaki"
    },
    "2024-03-06": {
        "content": " Nur Beharrlichkeit und Entschlossenheit sind allmächtig. -Calvin Coolidge"
    },
    "2024-03-07": {
        "content": " Lähmen Sie den Widerstand durch Beharrlichkeit. -Woody Hayes"
    },
    "2024-03-08": {
        "content": " Erfolg gehört nie jemandem, er wird gemietet, und die Miete ist jeden Tag fällig. -Rory Vaden"
    },
    "2024-03-09": {
        "content": " Erfolg ist kein Zufall. Er erfordert harte Arbeit, Ausdauer, Lernen, Studieren, Opferbereitschaft und vor allem Liebe zu dem, was man tut oder lernt. -Pelé"
    },
    "2024-03-10": {
        "content": " An der harten Arbeit führt kein Weg vorbei. Nehmen Sie sie an. -Roger Federer"
    },
    "2024-03-11": {
        "content": " Ein Traum wird nicht durch Zauberei Wirklichkeit; es erfordert Schweiß, Entschlossenheit und harte Arbeit. -Colin Powell"
    },
    "2024-03-12": {
        "content": "Lernen erschöpft den Geist nie. -Leonardo da Vinci"
    },
    "2024-03-13": {
        "content": " Ich höre und vergesse. Ich sehe und erinnere mich. Ich tue und verstehe. -Konfuzius"
    },
    "2024-03-14": {
        "content": " Wer noch nie einen Fehler gemacht hat, hat noch nie etwas Neues ausprobiert. -Albert Einstein"
    },
    "2024-03-15": {
        "content": " Versuchen Sie, über alles etwas und über etwas alles zu lernen. -Thomas Henry Huxley"
    },
    "2024-03-16": {
        "content": " Der Mensch lernt nur auf zwei Arten: einmal durch Lesen und einmal durch den Umgang mit intelligenteren Menschen. -Will Rogers"
    },
    "2024-03-17": {
        "content": " Sie verstehen nichts, bis Sie es auf mehr als eine Weise lernen. -Marvin Minsky"
    },
    "2024-03-18": {
        "content": " Erzähl es mir und ich vergesse es. Lehre mich und ich erinnere mich vielleicht. Beteilige mich und ich lerne. -Benjamin Franklin"
    },
    "2024-03-19": {
        "content": " Wenn Sie Ihre Erfolgsquote erhöhen möchten, verdoppeln Sie Ihre Misserfolgsquote. -Thomas J. Watson"
    },
    "2024-03-20": {
        "content": " Intelligenz ist das, was Sie einsetzen, wenn Sie nicht wissen, was Sie tun sollen. -Jean Piaget"
    },
    "2024-03-21": {
        "content": " Die Analphabeten des 21. Jahrhunderts werden nicht diejenigen sein, die nicht lesen und schreiben können, sondern diejenigen, die nicht lernen, verlernen und neu lernen können. -Alvin Toffler"
    },
    "2024-03-22": {
        "content": "Es ist das, was wir bereits wissen, das uns oft am Lernen hindert. -Claude Bernard"
    },
    "2024-03-23": {
        "content": " Mathematik ist die Sprache, mit der Gott das Universum geschrieben hat. -Galileo Galilei"
    },
    "2024-03-24": {
        "content": " Der ganze Zweck der Bildung besteht darin, Spiegel in Fenster zu verwandeln. -Sydney J. Harris"
    },
    "2024-03-25": {
        "content": " Ich habe keine Angst vor Stürmen, denn ich lerne, wie ich mein Schiff segele. -Louisa May Alcott"
    },
    "2024-03-26": {
        "content": " Gebildet ist nur derjenige, der gelernt hat, wie man lernt und sich verändert. -Carl R. Rogers"
    },
    "2024-03-27": {
        "content": " Ich habe noch nie einen Menschen getroffen, der so unwissend war, dass ich nichts von ihm hätte lernen können. -Galileo Galilei"
    },
    "2024-03-28": {
        "content": " Nichts verschwindet, bis es uns das beigebracht hat, was wir wissen müssen. -Pema Chödrön"
    },
    "2024-03-29": {
        "content": " Übung macht den Meister. Nach langem Üben wird unsere Arbeit natürlich, geschickt, schnell und stetig. -Bruce Lee"
    },
    "2024-03-30": {
        "content": " Wenn Sie sprechen, wiederholen Sie nur etwas, das Sie bereits wissen. Aber wenn Sie zuhören, lernen Sie vielleicht etwas Neues. -Dalai Lama XIV"
    },
    "2024-03-31": {
        "content": " Streben Sie nach Fortschritt, nicht nach Perfektion. -Anonym"
    },
    "2024-04-01": {
        "content": "Ich tue immer das, was ich noch nicht kann, um zu lernen, wie es geht. -Vincent van Gogh"
    },
    "2024-04-02": {
        "content": " Wissen macht einen Menschen untauglich, ein Sklave zu sein. -Frederick Douglass"
    },
    "2024-04-03": {
        "content": " Ich habe sehr früh den Unterschied gelernt, ob man den Namen einer Sache kennt oder etwas weiß. -Richard P. Feynman"
    },
    "2024-04-04": {
        "content": " Die Fähigkeit zu lernen ist eine Gabe; die Fähigkeit zu lernen ist eine Fertigkeit; die Bereitschaft zu lernen ist eine Entscheidung. -Brian Herbert"
    },
    "2024-04-05": {
        "content": " Lernen Sie alles, was Sie können, wann immer Sie können, von jedem, von dem Sie können – es wird immer eine Zeit kommen, in der Sie dankbar dafür sein werden. -Sarah Caldwell"
    },
    "2024-04-06": {
        "content": " Ich halte nicht viel von einem Mann, der heute nicht weiser ist als gestern. -Abraham Lincoln"
    },
    "2024-04-07": {
        "content": " Der Schlüssel zum Erfolg liegt in der Hingabe zum lebenslangen Lernen. -Stephen R. Covey"
    },
    "2024-04-08": {
        "content": " Seien Sie leidenschaftlich und mutig. Lernen Sie immer weiter. Wenn Sie nicht lernen, hören Sie auf, nützliche Dinge zu tun. -Satya Nadella"
    },
    "2024-04-09": {
        "content": "Die höchste Aktivität, die ein Mensch erreichen kann, ist das Lernen zum Verstehen, denn Verstehen bedeutet Freiheit. -Baruch Spinoza"
    },
    "2024-04-10": {
        "content": " Wenn Sie nicht ständig dazulernen, werden andere an Ihnen vorbeiziehen. Temperament allein reicht nicht aus – Sie brauchen viel Neugier über einen langen, langen Zeitraum. -Charlie Munger"
    },
    "2024-04-11": {
        "content": " Eine lernende Organisation ist eine Organisation, die ihre Kapazitäten zur Gestaltung ihrer Zukunft kontinuierlich erweitert. -Peter Senge"
    },
    "2024-04-12": {
        "content": " Der Tag, an dem Sie aufhören zu lernen, ist der Tag, an dem Sie zu verfallen beginnen. -Isaac Asimov"
    },
    "2024-04-13": {
        "content": " Lernen ist ein Schmuckstück im Wohlstand, ein Zufluchtsort in der Not und eine Vorsorge im Alter. -Aristoteles"
    },
    "2024-04-14": {
        "content": " Alle Führungskräfte lernen. Sobald man aufhört zu lernen, hört man auf zu führen. Ich lerne so viel ich kann, von so vielen Menschen wie möglich, so oft ich kann. -Rick Warren"
    },
    "2024-04-15": {
        "content": " Um schwierige Dinge schnell zu lernen, müssen Sie sich intensiv konzentrieren und dürfen sich nicht ablenken lassen. Lernen ist also ein Akt intensiver Arbeit. -Cal Newport"
    },
    "2024-04-16": {
        "content": " Jeder Dummkopf kann es wissen. Es geht darum, es zu verstehen. -Albert Einstein"
    },
    "2024-04-17": {
        "content": "Versuchen Sie jeden Tag, ein bisschen weiser zu sein als beim Aufwachen. -Charlie Munger"
    },
    "2024-04-18": {
        "content": " Investieren Sie in sich selbst, in Ihre Ausbildung. Es gibt nichts Besseres. -Sylvia Porter"
    },
    "2024-04-19": {
        "content": " Die Selbstbildung bereitet mir immer wieder Freude, denn je mehr ich weiß, desto erfüllter ist mein Leben und desto mehr schätze ich meine eigene Existenz. -Isaac Asimov"
    },
    "2024-04-20": {
        "content": " Sie können Hilfe von Lehrern bekommen, aber Sie müssen viel selbst lernen, indem Sie allein in einem Raum sitzen. -Dr. Seuss"
    },
    "2024-04-21": {
        "content": " Lernen geschieht, wenn jemand lernen möchte, nicht, wenn jemand lehren möchte. -Roger Schank"
    },
    "2024-04-22": {
        "content": " Eine Person kann einer anderen Person nicht direkt etwas beibringen; sie kann lediglich das Lernen einer anderen Person erleichtern. -Carl R. Rogers"
    },
    "2024-04-23": {
        "content": " Lernen ist nicht verpflichtend, sondern freiwillig. Verbesserung ist nicht verpflichtend, sondern freiwillig. Aber um zu überleben, müssen wir lernen. -W. Edwards Deming"
    },
    "2024-04-24": {
        "content": " Ich tue immer das, was ich nicht kann, damit ich lerne, wie es geht. -Pablo Picasso"
    },
    "2024-04-25": {
        "content": "Kein Dieb, egal wie geschickt er ist, kann jemandem sein Wissen rauben, und deshalb ist Wissen der beste und sicherste Schatz, den man erwerben kann. -L. Frank Baum"
    },
    "2024-04-26": {
        "content": " Ich glaube, das ist der beste Ratschlag überhaupt: Denken Sie ständig darüber nach, wie Sie die Dinge besser machen könnten, und stellen Sie sich selbst in Frage. -Elon Musk"
    },
    "2024-04-27": {
        "content": " Ein weiser Mensch kann aus einer dummen Frage mehr lernen als ein Narr aus einer weisen Antwort. -Bruce Lee"
    },
    "2024-04-28": {
        "content": " Wenn ich weiter geblickt habe, dann deshalb, weil ich auf den Schultern von Riesen stehe. -Isaac Newton"
    },
    "2024-04-29": {
        "content": " Was wir wissen, ist ein Tropfen, was wir nicht wissen, ist ein Ozean. -Isaac Newton"
    },
    "2024-04-30": {
        "content": " Das Schöne am Lernen ist, dass es Ihnen niemand nehmen kann. -BB König"
    },
    "2024-05-01": {
        "content": " Wenn Sie Schriftsteller werden möchten, müssen Sie vor allem zwei Dinge tun: viel lesen und viel schreiben. -Stephen King"
    },
    "2024-05-02": {
        "content": " Wiederholung ist die Mutter der Geschicklichkeit. -Tony Robbins"
    },
    "2024-05-03": {
        "content": " Staunen ist der Anfang der Weisheit. -Sokrates"
    },
    "2024-05-04": {
        "content": " Wenn Sie einen Fehler machen und ihn nicht korrigieren, wird dies als Fehler bezeichnet. -Konfuzius"
    },
    "2024-05-05": {
        "content": " Der Zweck der Bildung besteht darin, einen leeren Geist durch einen offenen zu ersetzen. -Malcolm S. Forbes"
    },
    "2024-05-06": {
        "content": "Im Leben gibt es nichts zu fürchten, man muss es nur verstehen. Jetzt ist es an der Zeit, mehr zu verstehen, damit wir weniger Angst haben. -Marie Curie"
    },
    "2024-05-07": {
        "content": " Wenn Sie gefragt werden, ob Sie eine Aufgabe erledigen können, sagen Sie: „Natürlich kann ich das!“. Dann legen Sie los und finden Sie heraus, wie es geht. -Theodore Roosevelt"
    },
    "2024-05-08": {
        "content": " Wir alle brauchen Menschen, die uns Feedback geben. So verbessern wir uns. -Bill Gates"
    },
    "2024-05-09": {
        "content": " Bildung ist der Schlüssel zur Welt, ein Pass zur Freiheit. -Oprah Winfrey"
    },
    "2024-05-10": {
        "content": " Alles beginnt mit einer Idee. -Earl Nightingale"
    },
    "2024-05-11": {
        "content": " Die beste Investition, die Sie tätigen können, ist die in sich selbst. -Warren Buffett"
    },
    "2024-05-12": {
        "content": " Es geht nicht um Geld oder Beziehungen. Es geht um die Bereitschaft, mehr zu arbeiten und mehr zu lernen als alle anderen. -Mark Cuban"
    },
    "2024-05-13": {
        "content": " Lernen Sie Ihr Leben lang, wie man lebt. -Seneca"
    },
    "2024-05-14": {
        "content": " Um zu lernen, erfolgreich zu sein, müssen Sie zuerst lernen, zu scheitern. -Michael Jordan"
    },
    "2024-05-15": {
        "content": " Verschwenden Sie keinen guten Fehler, lernen Sie daraus. -Robert T. Kiyosaki"
    },
    "2024-05-16": {
        "content": "Um Wissen zu erlangen, muss man studieren; um Weisheit zu erlangen, muss man beobachten. -Marilyn Vos Savant"
    },
    "2024-05-17": {
        "content": " Man lebt und lernt. Auf jeden Fall lebt man. -Douglas Adams"
    },
    "2024-05-18": {
        "content": " Geduld ist der Begleiter der Weisheit. - Heiliger Augustinus"
    },
    "2024-05-19": {
        "content": " Ich weiß nur eines, und zwar, dass ich nichts weiß. -Sokrates"
    },
    "2024-05-20": {
        "content": " Weisheit kommt aus Erfahrung. Erfahrung ist oft das Ergebnis eines Mangels an Weisheit. -Terry Pratchett"
    },
    "2024-05-21": {
        "content": " Wir können unseren Fortschritt am Mut unserer Fragen und der Tiefe unserer Antworten messen, an unserer Bereitschaft, das zu akzeptieren, was wahr ist, statt das, was sich gut anfühlt. -Carl Sagan"
    },
    "2024-05-22": {
        "content": " Ich hätte lieber Fragen, die nicht beantwortet werden können, als Antworten, die nicht hinterfragt werden können. -Richard P. Feynman"
    },
    "2024-05-23": {
        "content": " Ich bin immer bereit zu lernen, auch wenn es mir nicht immer gefällt, wenn mir etwas beigebracht wird. -Winston Churchill"
    },
    "2024-05-24": {
        "content": " Wer die Praxis ohne Theorie liebt, ist wie der Seemann, der ohne Ruder und Kompass an Bord eines Schiffes geht und nie weiß, wohin er steuern kann. -Leonardo da Vinci"
    },
    "2024-05-25": {
        "content": " Es ist besser zu erschaffen als zu lernen. Schaffen ist die Essenz des Lebens. -Julius Caesar"
    },
    "2024-05-26": {
        "content": "Was die Hand tut, merkt sich der Verstand. -Maria Montessori"
    },
    "2024-05-27": {
        "content": " Gehen Sie immer durchs Leben, als ob Sie etwas Neues lernen müssten, und das werden Sie auch. -Vernon Howard"
    },
    "2024-05-28": {
        "content": " Ein Misserfolg ist ein Erfolg, wenn wir daraus lernen. -Malcolm S. Forbes"
    },
    "2024-05-29": {
        "content": " Bildung ist der beste Freund. Ein gebildeter Mensch wird überall respektiert. Bildung schlägt Schönheit und Jugend. -Chanakya"
    },
    "2024-05-30": {
        "content": " Denken Sie nicht, dass das, was für Sie schwer zu meistern ist, für den Menschen unmöglich ist. Aber wenn etwas für den Menschen möglich ist, dann betrachten Sie es als in Ihrer Reichweite. -Marcus Aurelius"
    },
    "2024-05-31": {
        "content": " Lernen ist ein ständiger Entdeckungsprozess – ein Prozess ohne Ende. -Bruce Lee"
    },
    "2024-06-01": {
        "content": " Unwissenheit ist nicht so sehr eine Schande, sondern vielmehr die mangelnde Lernbereitschaft. -Benjamin Franklin"
    },
    "2024-06-02": {
        "content": " Ich bin davon überzeugt, dass Wissen Macht ist – um die Vergangenheit zu überwinden, unsere eigene Situation zu ändern, neue Hindernisse zu überwinden und bessere Entscheidungen zu treffen. -Ben Carson"
    },
    "2024-06-03": {
        "content": " Beim Einatmen beruhige ich Körper und Geist. Beim Ausatmen lächle ich. Ich verweile im gegenwärtigen Moment und weiß, dass dies der einzige Moment ist. -Thich Nhat Hanh"
    },
    "2024-06-04": {
        "content": "Wenn Sie meinen, Sie seien zu klein, um etwas zu bewirken, versuchen Sie, mit einer Mücke zu schlafen. -Dalai Lama XIV"
    },
    "2024-06-05": {
        "content": " Zu oft unterschätzen wir die Macht einer Berührung, eines Lächelns, eines freundlichen Wortes, eines offenen Ohrs, eines ehrlichen Kompliments oder der kleinsten Geste der Fürsorge, die alle das Potenzial haben, ein Leben zu verändern. -Leo Buscaglia"
    },
    "2024-06-06": {
        "content": " Wie wir unsere Tage verbringen, bestimmt natürlich auch, wie wir unser Leben verbringen. -Annie Dillard"
    },
    "2024-06-07": {
        "content": " Pflegen Sie Ihren Geist mit großartigen Gedanken, denn Sie werden nie höher hinauskommen, als Sie denken. -Benjamin Disraeli"
    },
    "2024-06-08": {
        "content": " Laufen lernt man nicht durch das Befolgen von Regeln. Man lernt es durch Tun und Hinfallen. -Richard Branson"
    },
    "2024-06-09": {
        "content": " Es ist unmöglich, zu leben, ohne bei etwas zu scheitern, es sei denn, man lebt so vorsichtig, dass man genauso gut gar nicht gelebt haben könnte; in diesem Fall scheitert man automatisch. -JK Rowling"
    },
    "2024-06-10": {
        "content": " Wenn du glücklich sein willst, dann sei es. -Leo Tolstoi"
    },
    "2024-06-11": {
        "content": " Niemand kann mir ohne meine Erlaubnis wehtun. -Mahatma Gandhi"
    },
    "2024-06-12": {
        "content": " Wenn ich loslasse, was ich bin, werde ich, was ich sein könnte. -Lao Tzu"
    },
    "2024-06-13": {
        "content": "Der Grund, warum wir mit Unsicherheit kämpfen, liegt darin, dass wir unsere Blicke hinter die Kulissen mit den Höhepunkten aller anderen vergleichen. -Steven Furtick"
    },
    "2024-06-14": {
        "content": " Denken Sie daran: Heute ist das Morgen, um das Sie sich gestern Sorgen gemacht haben. -Dale Carnegie"
    },
    "2024-06-15": {
        "content": " Wir müssen bereit sein, das Leben, das wir geplant haben, loszulassen, um das Leben zu haben, das auf uns wartet. -Joseph Campbell"
    },
    "2024-06-16": {
        "content": " Hör auf wegzugehen, und du wirst ankommen. Hör auf zu suchen, und du wirst sehen. Hör auf wegzulaufen, und du wirst gefunden werden. -Lao Tzu"
    },
    "2024-06-17": {
        "content": " Ein Team ist nicht eine Gruppe von Menschen, die zusammenarbeiten. Ein Team ist eine Gruppe von Menschen, die einander vertrauen. -Simon Sinek"
    },
    "2024-06-18": {
        "content": " Ständiger Optimismus ist ein Kraftmultiplikator. -Colin Powell"
    },
    "2024-06-19": {
        "content": " Wenn Sie damit zufrieden sind, einfach Sie selbst zu sein und sich nicht mit anderen zu vergleichen oder zu konkurrieren, wird jeder Sie respektieren. -Lao Tzu"
    },
    "2024-06-20": {
        "content": " Berechnen Sie Ihr Alter anhand Ihrer Freunde, nicht anhand Ihrer Jahre. Berechnen Sie Ihr Leben anhand Ihres Lächelns, nicht anhand Ihrer Tränen. -John Lennon"
    },
    "2024-06-21": {
        "content": " Geben Sie den Menschen, die Sie lieben, Flügel zum Fliegen, geben Sie ihnen Wurzeln zum Wiederkehren und einen Grund zum Bleiben. -Dalai Lama XIV"
    },
    "2024-06-22": {
        "content": " Ausdauer und Mut haben zu allen Zeiten Wunder bewirkt. -George Washington"
    },
    "2024-06-23": {
        "content": "Teilen Sie Ihr Wissen. Es ist ein Weg, Unsterblichkeit zu erlangen. -Dalai Lama XIV"
    },
    "2024-06-24": {
        "content": " Wir sind für den Kosmos eine Möglichkeit, sich selbst zu erkennen. -Carl Sagan"
    },
    "2024-06-25": {
        "content": " Ein guter Lehrer kann Hoffnung wecken, die Fantasie anregen und die Liebe zum Lernen vermitteln. -Brad Henry"
    },
    "2024-06-26": {
        "content": " Eine der größten Entdeckungen und Überraschungen, die ein Mensch machen kann, ist die Erkenntnis, dass er Dinge tun kann, von denen er befürchtet hatte, sie nicht tun zu können. -Henry Ford"
    },
    "2024-06-27": {
        "content": " Wann haben Sie das letzte Mal etwas zum ersten Mal getan? -John C. Maxwell"
    },
    "2024-06-28": {
        "content": " Wenn Sie nicht dabei sind, die Person zu werden, die Sie sein möchten, sind Sie automatisch dabei, die Person zu werden, die Sie nicht sein möchten. -Dale Carnegie"
    },
    "2024-06-29": {
        "content": " Das Glück ist mit den Mutigen. -Lateinisches Sprichwort"
    },
    "2024-06-30": {
        "content": " Erfolg ist nicht der Schlüssel zum Glück. Glück ist der Schlüssel zum Erfolg. Wenn du liebst, was du tust, wirst du erfolgreich sein. -Albert Schweitzer"
    },
    "2024-07-01": {
        "content": " Gewinnen Sie nicht die Welt und verlieren Sie Ihre Seele. Weisheit ist besser als Silber oder Gold. -Bob Marley"
    },
    "2024-07-02": {
        "content": " Beginnen Sie sofort zu leben und betrachten Sie jeden einzelnen Tag als ein einzelnes Leben. -Seneca"
    },
    "2024-07-03": {
        "content": "Sofern sich niemand wie Sie wirklich darum kümmert, wird sich nichts bessern. Das wird es nicht. -Dr. Seuss"
    },
    "2024-07-04": {
        "content": " Sie wussten nicht, dass es unmöglich war, also haben sie es getan. -Mark Twain"
    },
    "2024-07-05": {
        "content": " Ich kann Dinge tun, die Sie nicht können, Sie können Dinge tun, die ich nicht kann; gemeinsam können wir Großes erreichen. -Mutter Teresa"
    },
    "2024-07-06": {
        "content": " Das Einzige, was wir fürchten müssen, ist die Furcht selbst. -Franklin D. Roosevelt"
    },
    "2024-07-07": {
        "content": " Ohne Begeisterung wurde nie etwas Großes erreicht. -Ralph Waldo Emerson"
    },
    "2024-07-08": {
        "content": " Nur Mut, mein Herz. -CS Lewis"
    },
    "2024-07-09": {
        "content": " Der einzige Weg, Veränderungen zu verstehen, besteht darin, sich darauf einzulassen, sich mit ihnen zu bewegen und sich dem Tanz anzuschließen. -Alan Watts"
    },
    "2024-07-10": {
        "content": " Wo Aufmerksamkeit hingeht, fließt Energie und es zeigen sich Ergebnisse. -T. Harv Eker"
    },
    "2024-07-11": {
        "content": " Schmerz ist vorübergehend. Er kann eine Minute, eine Stunde, einen Tag oder ein Jahr dauern, aber irgendwann lässt er nach und etwas anderes nimmt seinen Platz ein. Wenn ich jedoch aufhöre, bleibt er für immer. -Lance Armstrong"
    },
    "2024-07-12": {
        "content": " Bei jedem Spaziergang in der Natur erhält man weit mehr, als man sucht. -John Muir"
    },
    "2024-07-13": {
        "content": "Gewinner sind nicht diejenigen, die nie scheitern, sondern diejenigen, die nie aufgeben. -Edwin Louis Cole"
    },
    "2024-07-14": {
        "content": " Anstatt die Dunkelheit zu bekämpfen, bringen Sie das Licht herein. -Eckhart Tolle"
    },
    "2024-07-15": {
        "content": " Seien Sie furchtlos bei der Suche nach dem, was Ihre Seele entflammt. -Jennifer Lee"
    },
    "2024-07-16": {
        "content": " Wenn Menschen dich verlassen, lass sie gehen. Dein Schicksal ist nie an jemanden gebunden, der dich verlässt, und das bedeutet nicht, dass es sich um schlechte Menschen handelt. Es bedeutet nur, dass ihr Teil in deiner Geschichte vorbei ist. -TD Jakes"
    },
    "2024-07-17": {
        "content": " Führung ist die Fähigkeit, Visionen in die Realität umzusetzen. -Warren G. Bennis"
    },
    "2024-07-18": {
        "content": " Glaube bedeutet, zu glauben, was man nicht sieht; die Belohnung für diesen Glauben besteht darin, zu sehen, was man glaubt. - Heiliger Augustinus"
    },
    "2024-07-19": {
        "content": " Nichts ist unmöglich, es sei denn, Sie glauben, dass es so ist. -Paramahansa Yogananda"
    },
    "2024-07-20": {
        "content": " Das Einzige, was schlimmer ist, als blind zu sein, ist, sehen zu können, aber keine Vision zu haben. -Helen Keller"
    },
    "2024-07-21": {
        "content": " Alles hat seine Schönheit, aber nicht jeder sieht sie. -Konfuzius"
    },
    "2024-07-22": {
        "content": " Gott spricht in der Stille des Herzens. -Mutter Teresa"
    },
    "2024-07-23": {
        "content": "Hoffnung ist das Ding mit Federn, das in der Seele nistet – und die Melodie ohne Worte singt – und niemals aufhört. -Emily Dickinson"
    },
    "2024-07-24": {
        "content": " Wie viele heilige Worte Sie auch lesen oder aussprechen, was nützen sie Ihnen, wenn Sie nicht danach handeln? -Buddha"
    },
    "2024-07-25": {
        "content": " Und übrigens: Über alles im Leben lässt sich schreiben, wenn man den Mut dazu und die Fantasie zum Improvisieren hat. Der schlimmste Feind der Kreativität sind Selbstzweifel. -Sylvia Plath"
    },
    "2024-07-26": {
        "content": " Nichts, was wir tun, kann die Vergangenheit ändern, aber alles, was wir tun, ändert die Zukunft. -Ashleigh Brilliant"
    },
    "2024-07-27": {
        "content": " Führung ist eine Entscheidung. Sie ist kein Rang. -Simon Sinek"
    },
    "2024-07-28": {
        "content": " Alles wird gut, und alles wird gut, und alles wird gut. -Julian von Norwich"
    },
    "2024-07-29": {
        "content": " Jeder von uns ist aus kosmischer Sicht wertvoll. Wenn ein Mensch anderer Meinung ist als du, lass ihn leben. In hundert Milliarden Galaxien wirst du keinen anderen finden. -Carl Sagan"
    },
    "2024-07-30": {
        "content": " Intelligenz plus Charakter – das ist das Ziel wahrer Bildung. -Martin Luther King Jr."
    },
    "2024-07-31": {
        "content": "Je mehr Sie sich in etwas verlieren, das größer ist als Sie selbst, desto mehr Energie werden Sie haben. -Norman Vincent Peale"
    },
    "2024-08-01": {
        "content": " Wenn Sie die Grundlagen beherrschen, wird sich das Niveau Ihrer gesamten Tätigkeit steigern -Michael Jordan"
    },
    "2024-08-02": {
        "content": " Sie können überhaupt nicht leben, wenn Sie nicht jetzt voll leben können. -Alan Watts"
    },
    "2024-08-03": {
        "content": " Denken Sie daran, dass es manchmal ein großer Glücksfall ist, nicht das zu bekommen, was Sie wollen. -Dalai Lama XIV"
    },
    "2024-08-04": {
        "content": " Geben Sie Ihr Bestes und entspannen Sie sich dann. Lassen Sie die Dinge ihren natürlichen Lauf nehmen, anstatt sie zu erzwingen. -Paramahansa Yogananda"
    },
    "2024-08-05": {
        "content": " Sie sind ein unendliches spirituelles Wesen, das eine vorübergehende menschliche Erfahrung macht. -Wayne W. Dyer"
    },
    "2024-08-06": {
        "content": " Sie müssen träumen, bevor Ihre Träume wahr werden können. -Abdul Kalam"
    },
    "2024-08-07": {
        "content": " Beschütze vor allem dein Herz, denn alles, was du tust, entspringt ihm. -Solomon"
    },
    "2024-08-08": {
        "content": " Beim Schreiben kann ich alles abschütteln, meine Sorgen verschwinden, mein Mut wird neu geboren. -Anne Frank"
    },
    "2024-08-09": {
        "content": " Das Ziel ist nicht, am Ende perfekt zu sein. Das Ziel ist, heute besser zu sein. -Simon Sinek"
    },
    "2024-08-10": {
        "content": " Gehen Sie selbstbewusst in die Richtung Ihrer Träume. Leben Sie das Leben, das Sie sich vorgestellt haben. -Henry David Thoreau"
    },
    "2024-08-11": {
        "content": "Seien Sie freundlich, wann immer es möglich ist. Es ist immer möglich. -Dalai Lama XIV"
    },
    "2024-08-12": {
        "content": " Unser Hauptzweck in diesem Leben ist es, anderen zu helfen. Und wenn Sie ihnen nicht helfen können, verletzen Sie sie zumindest nicht. -Dalai Lama XIV"
    },
    "2024-08-13": {
        "content": " Du hast Verstand. Du stehst in deinen Schuhen. Du kannst dich in jede gewünschte Richtung bewegen. Du bist auf dich allein gestellt. Und du weißt, was du weißt. Und du entscheidest, wohin es geht. -Dr. Seuss"
    },
    "2024-08-14": {
        "content": " Worauf Sie sich konzentrieren, erweitert sich, und wenn Sie sich auf das Gute in Ihrem Leben konzentrieren, schaffen Sie mehr davon. -Oprah Winfrey"
    },
    "2024-08-15": {
        "content": " Alles, was ich wissen muss, wird mir offenbart. Alles, was ich brauche, kommt zu mir. Alles ist gut in meinem Leben. -Louise Hay"
    },
    "2024-08-16": {
        "content": " Ich bin im Universum vollkommen sicher. Ich bin überall im Frieden. Ich vertraue dem Leben. -Louise Hay"
    },
    "2024-08-17": {
        "content": " Drehen Sie Ihr Gesicht der Sonne zu und die Schatten fallen hinter Sie. -Maori-Sprichwort"
    },
    "2024-08-18": {
        "content": " Mut bedeutet nicht, die Kraft zu haben, weiterzumachen. Mut bedeutet, weiterzumachen, wenn einem die Kraft dazu fehlt. -Theodore Roosevelt"
    },
    "2024-08-19": {
        "content": " Die Zukunft hängt davon ab, was Sie heute tun. -Mahatma Gandhi"
    },
    "2024-08-20": {
        "content": " Ein Gewinner ist ein Träumer, der niemals aufgibt. -Nelson Mandela"
    },
    "2024-08-21": {
        "content": "Weine nicht, weil es vorbei ist, lächle, weil es passiert ist. -Dr. Seuss"
    },
    "2024-08-22": {
        "content": " Ich kann alles, was ich über das Leben gelernt habe, in drei Worten zusammenfassen: Es geht weiter. -Robert Frost"
    },
    "2024-08-23": {
        "content": " Lebe aus deiner Vorstellungskraft, nicht aus deiner Geschichte. -Stephen R. Covey"
    },
    "2024-08-24": {
        "content": " So wie ich das sehe, muss man den Regen ertragen, wenn man den Regenbogen will. -Dolly Parton"
    },
    "2024-08-25": {
        "content": " Die Größe eines Menschen liegt nicht darin, wie viel Reichtum er anhäuft, sondern in seiner Integrität und seiner Fähigkeit, die Menschen um ihn herum positiv zu beeinflussen. -Bob Marley"
    },
    "2024-08-26": {
        "content": " Glück ist in erster Linie eine Folge unserer eigenen Einstellung und nicht auf äußere Faktoren zurückzuführen. -Dalai Lama XIV"
    },
    "2024-08-27": {
        "content": " Große Taten bestehen aus kleinen Taten. -Lao Tzu"
    },
    "2024-08-28": {
        "content": " Es ist nie zu spät, das zu werden, was Sie hätten sein können. -George Eliot"
    },
    "2024-08-29": {
        "content": " Durch die richtige Einstellung kann negativer Stress in positiven umgewandelt werden. -Hans Selye"
    },
    "2024-08-30": {
        "content": " Trauen Sie sich, das Leben zu leben, von dem Sie geträumt haben. Gehen Sie voran und lassen Sie Ihre Träume wahr werden. -Ralph Waldo Emerson"
    },
    "2024-08-31": {
        "content": " Die Zeit, die Sie gerne verschwenden, ist keine verschwendete Zeit. -Bertrand Russell"
    },
    "2024-09-01": {
        "content": "Man braucht nur ein wenig Wachsamkeit, um zu erkennen und herauszufinden: Das Leben ist in Wirklichkeit ein großes kosmisches Lachen. -Osho"
    },
    "2024-09-02": {
        "content": " Das seltsame Paradoxe ist, dass ich mich ändern kann, wenn ich mich so akzeptiere, wie ich bin. -Carl R. Rogers"
    },
    "2024-09-03": {
        "content": " Seien Sie Teil der Lösung, nicht Teil des Problems. -Stephen R. Covey"
    },
    "2024-09-04": {
        "content": " Das Geheimnis des Lebens ist das Geben. -Tony Robbins"
    },
    "2024-09-05": {
        "content": " Machen Sie jeden Tag zu Ihrem Meisterwerk. -John Wooden"
    },
    "2024-09-06": {
        "content": " Gib niemals auf, was du wirklich tun willst -H. Jackson Brown Jr."
    },
    "2024-09-07": {
        "content": " Schauen Sie nicht zurück – Sie gehen nicht diesen Weg. -Mary Engelbreit"
    },
    "2024-09-08": {
        "content": " Geben Sie Ihr Bestes und Gott wird den Rest erledigen. -Nick Vujicic"
    },
    "2024-09-09": {
        "content": " Lebe, reise, erlebe Abenteuer, sei gesegnet und bereue nichts. -Jack Kerouac"
    },
    "2024-09-10": {
        "content": " Mitten im Winter entdeckte ich einen unbesiegbaren Sommer in mir. Und das macht mich glücklich. Denn es sagt mir, dass, egal wie sehr die Welt mich bedrängt, in mir etwas Stärkeres – etwas Besseres – steckt, das zurückschlägt. -Albert Camus"
    },
    "2024-09-11": {
        "content": "Manche glauben, nur große Macht könne das Böse in Schach halten, aber das ist nicht meine Erfahrung. Es sind die kleinen alltäglichen Taten der einfachen Leute, die die Dunkelheit in Schach halten. Kleine Taten der Güte und Liebe. -JRR Tolkien"
    },
    "2024-09-12": {
        "content": " Seien Sie in kleinen Dingen treu, denn darin liegt Ihre Stärke. -Mutter Teresa"
    },
    "2024-09-13": {
        "content": " Machen Sie aus sich selbst ein Licht. -Buddha"
    },
    "2024-09-14": {
        "content": " VISUALISIEREN!!! Sehen und fühlen! Hier beginnt die Action. -Rhonda Byrne"
    },
    "2024-09-15": {
        "content": " Seien Sie phänomenal oder werden Sie vergessen! -Eric Thomas"
    },
    "2024-09-16": {
        "content": " Wenn Sie die Wahl haben, Recht zu haben oder freundlich zu sein, entscheiden Sie sich dafür, freundlich zu sein. -Wayne W. Dyer"
    },
    "2024-09-17": {
        "content": " Menschen können ihr Leben ändern, indem sie ihre Geisteshaltung ändern. -William James"
    },
    "2024-09-18": {
        "content": " Gesundheit ist der höchste Besitz. -Laozi"
    },
    "2024-09-19": {
        "content": " Lass mich nicht darum beten, vor Gefahren geschützt zu werden, sondern darum, ihnen furchtlos entgegenzutreten. Lass mich nicht darum betteln, dass mein Schmerz gestillt wird, sondern darum, dass mein Herz ihn überwindet. -Rabindranath Tagore"
    },
    "2024-09-20": {
        "content": " Konzentriere dich darauf, Gutes zu tun. Tu es immer wieder, und du wirst mit Freude erfüllt sein. -Buddha"
    },
    "2024-09-21": {
        "content": "Ich allein kann die Welt nicht verändern, aber ich kann einen Stein über das Wasser werfen, um viele Wellen zu erzeugen. -Mutter Teresa"
    },
    "2024-09-22": {
        "content": " Und der Tag kam, an dem das Risiko, in der Knospe zu verharren, schmerzhafter war als das Risiko, aufzublühen. -Anaïs Nin"
    },
    "2024-09-23": {
        "content": " Menschlichem Streben sollten keine Grenzen gesetzt sein. So schlimm das Leben auch erscheinen mag, es gibt immer Hoffnung. -Stephen Hawking"
    },
    "2024-09-24": {
        "content": " Und ich bitte Sie dringend, darauf zu achten, wann Sie glücklich sind, und irgendwann auszurufen oder zu murmeln oder zu denken: „Wenn das nicht schön ist, weiß ich nicht, was schön ist.“ -Kurt Vonnegut"
    },
    "2024-09-25": {
        "content": " Es ist Ihre Reaktion auf Widrigkeiten, nicht die Widrigkeiten selbst, die bestimmt, wie sich Ihre Lebensgeschichte entwickeln wird. -Dieter F. Uchtdorf"
    },
    "2024-09-26": {
        "content": " Es ist nicht das, was Sie haben, wer Sie sind, wo Sie sind oder was Sie tun, das Sie glücklich oder unglücklich macht. Es ist das, was Sie darüber denken. -Dale Carnegie"
    },
    "2024-09-27": {
        "content": " Je mehr Sie lesen, desto mehr Dinge werden Sie wissen. Je mehr Sie lernen, desto mehr Orte werden Sie besuchen. -Dr. Seuss"
    },
    "2024-09-28": {
        "content": " Alle unsere Träume können wahr werden. -Walt Disney"
    },
    "2024-09-29": {
        "content": "Das Privileg Ihres Lebens besteht darin, der zu sein, der Sie sind. -Joseph Campbell"
    },
    "2024-09-30": {
        "content": " Niemand auf dieser Welt ist nutzlos, wenn er einem anderen die Last erleichtert. -Charles Dickens"
    },
    "2024-10-01": {
        "content": " Finden Sie einen Ort in Ihrem Inneren, an dem Sie Freude empfinden, und die Freude wird den Schmerz vertreiben. -Joseph Campbell"
    },
    "2024-10-02": {
        "content": " Frag nicht, was die Welt braucht. Frag, was dich lebendig macht, und tu es. Denn was die Welt braucht, sind mehr Menschen, die lebendig geworden sind. -Howard Thurman"
    },
    "2024-10-03": {
        "content": " Ihre Gefühle sind Ihr wichtigstes Werkzeug, um Ihr Leben zu gestalten. -Rhonda Byrne"
    },
    "2024-10-04": {
        "content": " Ich verdiene das Beste und akzeptiere jetzt das Beste. -Louise Hay"
    },
    "2024-10-05": {
        "content": " Es kommt nicht darauf an, wie viel wir geben, sondern wie viel Liebe wir in das Geben stecken. -Mutter Teresa"
    },
    "2024-10-06": {
        "content": " Wenn Ihr Wunsch nach Erfolg genauso stark ist, wie Sie atmen möchten, werden Sie Erfolg haben. -Eric Thomas"
    },
    "2024-10-07": {
        "content": " Ich habe jede Minute des Trainings gehasst, aber ich sagte: „Gib nicht auf. Leide jetzt und lebe den Rest deines Lebens als Champion.“ -Muhammad Ali"
    },
    "2024-10-08": {
        "content": "Nicht der Kritiker zählt, nicht derjenige, der aufzeigt, wie der Starke gestolpert ist oder wie der Handelnde es hätte besser machen können. Der Verdienst gebührt dem Mann, der tatsächlich in der Arena steht, dessen Gesicht von Schweiß, Staub und Blut gezeichnet ist; der tapfer kämpft; der immer wieder irrt und scheitert; der die große Begeisterung und Hingabe kennt und sich für eine würdige Sache einsetzt; der, wenn er gewinnt, den Triumph großer Leistung kennt; und der, wenn er scheitert, zumindest scheitert, während er Großes wagt, sodass sein Platz niemals bei den kalten und ängstlichen Seelen sein wird, die weder Sieg noch Niederlage kennen. -Theodore Roosevelt"
    },
    "2024-10-09": {
        "content": " Das größte Abenteuer, das Sie jemals erleben können, ist, das Leben Ihrer Träume zu leben. -Oprah Winfrey"
    },
    "2024-10-10": {
        "content": " Ohne Kampf kann es keinen Fortschritt geben. -Frederick Douglass"
    },
    "2024-10-11": {
        "content": " Ein mit Datum aufgeschriebener Traum wird zum Ziel. Ein in Schritte unterteiltes Ziel wird zum Plan. Ein durch Taten unterstützter Plan lässt Ihre Träume wahr werden. -Greg Reid"
    },
    "2024-10-12": {
        "content": "Tu das Einzige, von dem du glaubst, dass du es nicht kannst. Scheitere. Versuch es noch einmal. Mach es beim zweiten Mal besser. Die einzigen Menschen, die nie stürzen, sind diejenigen, die nie aufs Hochseil steigen. -Oprah Winfrey"
    },
    "2024-10-13": {
        "content": " Erwarten Sie Veränderungen. Analysieren Sie die Landschaft. Nutzen Sie die Chancen. Seien Sie nicht länger die Schachfigur, sondern werden Sie zum Spieler. Sie sind am Zug. -Tony Robbins"
    },
    "2024-10-14": {
        "content": " Du bist frei. Du bist stark. Du bist gut. Du bist Liebe. Du hast einen Wert. Du hast einen Sinn. Alles ist gut. -Esther Hicks"
    },
    "2024-10-15": {
        "content": "Wenn Sie etwas so sehr wollen, dass Sie hinausgehen und dafür kämpfen, Tag und Nacht dafür arbeiten, Ihre Zeit, Ihre Ruhe und Ihren Schlaf dafür opfern, wenn sich alles, wovon Sie träumen und was Sie planen, darauf bezieht und Ihnen das Leben ohne es nutzlos und wertlos erscheint; wenn Sie gerne dafür schwitzen, sich dafür abmühen und dafür planen und all Ihre Angst vor Widerstand verlieren; wenn Sie einfach mit all Ihren Fähigkeiten, Ihrer Kraft und Scharfsinnigkeit, Ihrem Glauben, Ihrer Hoffnung und Ihrem Vertrauen und Ihrer Hartnäckigkeit dem nachgehen, was Sie wollen; wenn weder Kälte noch Armut, Hunger oder Gicht, Krankheit oder Schmerzen an Körper und Geist Sie von dem abhalten können, was Sie wollen; wenn Sie verbissen und grimmig sind und es erreichen, dann werden Sie es mit Gottes Hilfe bekommen. -Berton Braley"
    },
    "2024-10-16": {
        "content": " Selbst wenn Sie auf dem richtigen Weg sind, werden Sie überfahren, wenn Sie einfach nur herumsitzen. -Will Rogers"
    },
    "2024-10-17": {
        "content": " Ich glaube, dass es für gewöhnliche Menschen möglich ist, sich dafür zu entscheiden, außergewöhnlich zu sein. -Elon Musk"
    },
    "2024-10-18": {
        "content": " Laufen lernt man nicht durch das Befolgen von Regeln. Man lernt es durch Tun und Hinfallen. -Richard Branson"
    },
    "2024-10-19": {
        "content": "Hier fehlt das Talent, das ist harte Arbeit. Das ist Besessenheit. Talent existiert nicht, wir sind alle gleich. Du könntest alles sein, wenn du dir die Zeit nimmst. Du wirst es bis ganz nach oben schaffen, und das war’s. Ich bin nicht talentiert, ich bin besessen. -Conor McGregor"
    },
    "2024-10-20": {
        "content": " Ein Traum ist nicht das, was Sie im Schlaf sehen; es ist etwas, das Sie nicht schlafen lässt. -Abdul Kalam"
    },
    "2024-10-21": {
        "content": " Wenn Sie alle Möglichkeiten ausgeschöpft haben, denken Sie daran: Das haben Sie nicht. -Thomas A. Edison"
    },
    "2024-10-22": {
        "content": " Ergreife Chancen und mache Fehler. So wächst du. Schmerz stärkt deinen Mut. Du musst scheitern, um Mut zu üben. -Mary Tyler Moore"
    },
    "2024-10-23": {
        "content": " Worauf Sie sich konzentrieren, das bekommen Sie. -Tony Robbins"
    },
    "2024-10-24": {
        "content": " „Hustle“ ist das wichtigste Wort aller Zeiten. -Gary Vaynerchuk"
    },
    "2024-10-25": {
        "content": " Wenn sie aus schimmeligem Brot Penicillin herstellen können, dann können sie sicher auch etwas aus Ihnen machen. -Muhammad Ali"
    },
    "2024-10-26": {
        "content": " Du wurdest nicht als Gewinner geboren, und du wurdest nicht als Verlierer geboren. Du bist, was du aus dir machst. -Lou Holtz"
    },
    "2024-10-27": {
        "content": " Erfolg ist Ihre Pflicht, Verpflichtung und Verantwortung. -Grant Cardone"
    },
    "2024-10-28": {
        "content": "Es gibt kleine Unterschiede zwischen Menschen, aber diese kleinen Unterschiede machen einen großen Unterschied. Der kleine Unterschied liegt in der Einstellung. Der große Unterschied liegt darin, ob sie positiv oder negativ ist. -W. Clement Stone"
    },
    "2024-10-29": {
        "content": " Führungskräfte müssen nah genug an anderen sein, um eine Beziehung zu ihnen aufzubauen, aber weit genug voraus, um sie zu motivieren. -John C. Maxwell"
    },
    "2024-10-30": {
        "content": " Sag niemals nie, denn Grenzen sind, wie Ängste, oft nur eine Illusion. -Michael Jordan"
    },
    "2024-10-31": {
        "content": " Sie müssen Großes von sich selbst erwarten, bevor Sie es tun können. -Michael Jordan"
    },
    "2024-11-01": {
        "content": " In der Geschäftswelt sind diejenigen Menschen am erfolgreichsten, die das tun, was sie lieben. -Warren Buffett"
    },
    "2024-11-02": {
        "content": " Durch Handeln wird Ihr Zögern ein Ende haben. -Og Mandino"
    },
    "2024-11-03": {
        "content": " Scheitern ist für mich keine Option. Ich stelle mir nur Erfolg vor. -Conor McGregor"
    },
    "2024-11-04": {
        "content": " Erfolg kommt nicht von dem, was Sie gelegentlich tun, sondern von dem, was Sie konsequent tun. -Marie Forleo"
    },
    "2024-11-05": {
        "content": " Selbstvertrauen und harte Arbeit sind die besten Medikamente gegen das Versagen. Sie machen Sie zu einem erfolgreichen Menschen. -Abdul Kalam"
    },
    "2024-11-06": {
        "content": " Wenn Sie wie die Sonne strahlen möchten, müssen Sie zuerst wie die Sonne brennen. -Abdul Kalam"
    },
    "2024-11-07": {
        "content": "Während du da draußen feierst und herumalberst, arbeitet da draußen gleichzeitig jemand hart. Jemand wird schlauer und jemand gewinnt. Vergiss das einfach nicht. -Arnold Schwarzenegger"
    },
    "2024-11-08": {
        "content": " Wenn Sie tun, was Sie immer getan haben, werden Sie bekommen, was Sie immer bekommen haben. -Tony Robbins"
    },
    "2024-11-09": {
        "content": " Fortschritt ist gleich Glück. -Tony Robbins"
    },
    "2024-11-10": {
        "content": " Sie können Ergebnisse oder Ausreden haben. Nicht beides. -Arnold Schwarzenegger"
    },
    "2024-11-11": {
        "content": " Disziplin ist gleich Freiheit. -Jocko Willink"
    },
    "2024-11-12": {
        "content": " Grübeln Sie nicht darüber nach, was schiefgelaufen ist. Konzentrieren Sie sich stattdessen auf die nächsten Schritte. Konzentrieren Sie sich darauf, voranzukommen und die Antwort zu finden. -Denis Waitley"
    },
    "2024-11-13": {
        "content": " Seien Sie der Anführer, den Sie sich gewünscht hätten. -Simon Sinek"
    },
    "2024-11-14": {
        "content": " Meine Einstellung ist, dass ich, wenn Sie mich zu etwas drängen, was Sie für eine Schwäche halten, diese wahrgenommene Schwäche in eine Stärke umwandeln werde. -Michael Jordan"
    },
    "2024-11-15": {
        "content": " Die größere Gefahr für die meisten von uns besteht nicht darin, dass wir uns zu hohe Ziele setzen und sie nicht erreichen, sondern dass wir uns zu niedrige Ziele setzen und sie nicht erreichen. -Michelangelo"
    },
    "2024-11-16": {
        "content": " Jeder hat einen Traum, aber nicht jeder hat die nötige Plackerei. -Eric Thomas"
    },
    "2024-11-17": {
        "content": "Führungspersönlichkeiten werden nicht geboren, sondern gemacht. Sie entstehen durch harte Arbeit, den Preis, den wir alle zahlen müssen, um ein lohnendes Ziel zu erreichen. -Vince Lombardi"
    },
    "2024-11-18": {
        "content": " Wir haben uns entschieden, in diesem Jahrzehnt zum Mond zu fliegen und die anderen Dinge zu tun. Nicht, weil sie einfach sind, sondern weil sie schwierig sind. -John F. Kennedy"
    },
    "2024-11-19": {
        "content": " Der schönste Tag in Ihrem und meinem Leben ist der, an dem wir die volle Verantwortung für unsere Einstellung übernehmen. Das ist der Tag, an dem wir wirklich erwachsen werden. -John C. Maxwell"
    },
    "2024-11-20": {
        "content": " Jedes Mal, wenn Sie jemanden anlächeln, ist dies ein Akt der Liebe, ein Geschenk an diese Person, etwas Schönes. -Mutter Teresa"
    },
    "2024-11-21": {
        "content": " Sei stiller Beobachter deiner Gedanken und deines Verhaltens. Du bist die Ebene des Denkers. Du bist die Stille unter dem mentalen Lärm. Du bist die Liebe und Freude unter dem Schmerz. -Eckhart Tolle"
    },
    "2024-11-22": {
        "content": " Wenn du nicht fliegen kannst, dann laufe. Wenn du nicht rennen kannst, dann geh. Wenn du nicht gehen kannst, dann krieche. Aber was auch immer du tust, du musst weiter vorwärts gehen. -Martin Luther King Jr."
    },
    "2024-11-23": {
        "content": " Vergebung ist keine gelegentliche Handlung, sondern eine konstante Haltung. -Martin Luther King Jr."
    },
    "2024-11-24": {
        "content": " Zu oft unterschätzen wir die Macht einer Berührung, eines Lächelns, eines freundlichen Wortes, eines offenen Ohrs, eines ehrlichen Kompliments oder der kleinsten Geste der Fürsorge, die alle das Potenzial haben, ein Leben zu verändern. -Leo Buscaglia"
    },
    "2024-11-25": {
        "content": "Halte deine Träume am Leben. Um etwas zu erreichen, braucht es Vertrauen und Glauben an sich selbst, Vision, harte Arbeit, Entschlossenheit und Hingabe. Denk daran, dass für diejenigen, die daran glauben, alles möglich ist. -Gail Devers"
    },
    "2024-11-26": {
        "content": " Sport hat die Kraft, die Welt zu verändern. Er hat die Kraft zu inspirieren. Er hat die Kraft, Menschen auf eine Weise zu vereinen, wie es kaum etwas anderes vermag. Er spricht die Jugend in einer Sprache an, die sie versteht. Sport kann Hoffnung schaffen, wo einst nur Verzweiflung herrschte. -Nelson Mandela"
    },
    "2024-11-27": {
        "content": " Bitten Sie um das, was Sie wollen. Glauben Sie, dass Sie es verdienen, und lassen Sie sich dann vom Leben geben. -Louise Hay"
    },
    "2024-11-28": {
        "content": " Lebe bewusst. Gehe bis ans Limit. Höre aufmerksam zu. Achte auf dein Wohlbefinden. Spiele mit Hingabe. Lache. Triff Entscheidungen ohne Reue. Schätze deine Freunde. Lerne weiter. Tu, was du liebst. Lebe, als wäre das alles, was es gibt. -Mary Anne Radmacher"
    },
    "2024-11-29": {
        "content": " Worauf Sie sich konzentrieren, erweitert sich, und wenn Sie sich auf das Gute in Ihrem Leben konzentrieren, schaffen Sie mehr davon. -Oprah Winfrey"
    },
    "2024-11-30": {
        "content": " Du hast Macht über deinen Geist, nicht über äußere Ereignisse. Wenn du dir das bewusst machst, wirst du Kraft finden. -Marcus Aurelius"
    },
    "2024-12-01": {
        "content": "Suchen Sie keine Ausreden dafür, warum Sie es nicht schaffen. Konzentrieren Sie sich auf alle Gründe, warum Sie es schaffen müssen. -Ralph Marston"
    },
    "2024-12-02": {
        "content": " Wo Liebe ist, ist Leben. -Mahatma Gandhi"
    },
    "2024-12-03": {
        "content": " Du musst tanzen, als würde niemand zusehen, lieben, als würde dir nie etwas passieren, singen, als würde niemand zuhören, und leben, als wäre der Himmel auf Erden. -William W. Purkey"
    },
    "2024-12-04": {
        "content": " Erfolg bedeutet, den Sinn des Lebens zu kennen, zu wachsen, um das eigene Potenzial voll auszuschöpfen und Samen zu säen, die anderen nützen. -John C. Maxwell"
    },
    "2024-12-05": {
        "content": " Ein Traum, den Sie alleine träumen, ist nur ein Traum. Ein Traum, den Sie gemeinsam träumen, ist Realität. -John Lennon"
    },
    "2024-12-06": {
        "content": " Das wahre Geheimnis des Lebens besteht darin, sich voll und ganz auf das einzulassen, was man im Hier und Jetzt tut. Und anstatt es Arbeit zu nennen, ist es ein Spiel. -Alan Watts"
    },
    "2024-12-07": {
        "content": " Gestern ist vorbei. Morgen ist noch nicht da. Wir haben nur heute. Lasst uns beginnen. -Mutter Teresa"
    },
    "2024-12-08": {
        "content": " Je mehr Sie Ihr Leben loben und feiern, desto mehr gibt es im Leben zu feiern. -Oprah Winfrey"
    },
    "2024-12-09": {
        "content": "Zweifeln Sie nie daran, dass eine kleine Gruppe nachdenklicher, engagierter Bürger die Welt verändern kann. Tatsächlich ist es das Einzige, was jemals passiert ist. -Margaret Mead"
    },
    "2024-12-10": {
        "content": " Fordern Sie sich selbst heraus, denn niemand sonst wird es für Sie tun. -Anonym"
    },
    "2024-12-11": {
        "content": " Wahre Demut bedeutet nicht, weniger von sich zu halten, sondern weniger an sich zu denken. -CS Lewis"
    },
    "2024-12-12": {
        "content": " Wenn Sie Ihre Meinung ändern können, können Sie Ihr Leben ändern. -William James"
    },
    "2024-12-13": {
        "content": " Konzentrieren Sie sich auf Ihr Ziel, nicht auf das, was Sie fürchten. -Tony Robbins"
    },
    "2024-12-14": {
        "content": " Respektieren Sie sich selbst und andere werden Sie respektieren. -Konfuzius"
    },
    "2024-12-15": {
        "content": " Tun Sie, was Sie können, mit dem, was Sie haben, dort, wo Sie sind. -Theodore Roosevelt"
    },
    "2024-12-16": {
        "content": " Manche Veränderungen sehen auf den ersten Blick negativ aus, aber Sie werden bald erkennen, dass in Ihrem Leben Platz für etwas Neues geschaffen wird. -Eckhart Tolle"
    },
    "2024-12-17": {
        "content": " Wenn Ihre Handlungen andere dazu inspirieren, mehr zu träumen, mehr zu lernen, mehr zu tun und mehr zu werden, sind Sie ein Anführer. -John Quincy Adams"
    },
    "2024-12-18": {
        "content": " Mach dir um nichts Sorgen, alles wird gut. -Bob Marley"
    },
    "2024-12-19": {
        "content": " Träumen Sie groß, bleiben Sie positiv, arbeiten Sie hart und genießen Sie die Reise. -Urijah Faber"
    },
    "2024-12-20": {
        "content": "Sie sind hier, um die Entfaltung des göttlichen Zwecks des Universums zu ermöglichen. So wichtig sind Sie! -Eckhart Tolle"
    },
    "2024-12-21": {
        "content": " Lebe mit Leidenschaft! -Tony Robbins"
    },
    "2024-12-22": {
        "content": " Glauben Sie daran, dass Sie es können, und Sie haben es schon halb geschafft. -Theodore Roosevelt"
    },
    "2024-12-23": {
        "content": " Unser Leben beginnt zu enden, an dem Tag, an dem wir über die wichtigen Dinge schweigen. -Martin Luther King Jr."
    },
    "2024-12-24": {
        "content": " Gemeinsam können wir Großes erreichen. -Mutter Teresa"
    },
    "2024-12-25": {
        "content": " Hart für etwas zu arbeiten, das uns egal ist, nennt man Stress; hart für etwas zu arbeiten, das wir lieben, nennt man Leidenschaft. -Simon Sinek"
    },
    "2024-12-26": {
        "content": " Die Höhle, die Sie nicht betreten möchten, birgt den Schatz, den Sie suchen. -Joseph Campbell"
    },
    "2024-12-27": {
        "content": " Bei Führung geht es um Empathie. Es geht um die Fähigkeit, mit Menschen in Beziehung zu treten und eine Verbindung zu ihnen aufzubauen, um sie zu inspirieren und ihnen Kraft zu geben. -Oprah Winfrey"
    },
    "2024-12-28": {
        "content": " Für den, der es versucht, ist nichts unmöglich. -Alexander der Große"
    },
    "2024-12-29": {
        "content": " Die meisten wichtigen Dinge auf der Welt wurden von Menschen erreicht, die es immer wieder versucht haben, als es scheinbar keine Hoffnung mehr gab. -Dale Carnegie"
    },
    "2024-12-30": {
        "content": " Wir bewegen uns weiter vorwärts, öffnen neue Türen und tun neue Dinge, weil wir neugierig sind und die Neugier uns immer wieder auf neue Wege führt. -Walt Disney"
    },
    "2024-12-31": {
        "content": "Tun Sie, was Sie tun müssen, bis Sie tun können, was Sie tun möchten. -Oprah Winfrey"
    },
    "2025-01-01": {
        "content": " Der Glaube, dass Sie genug sind, gibt Ihnen den Mut, authentisch zu sein. -Brené Brown"
    },
    "2025-01-02": {
        "content": " Es sind unsere Entscheidungen, Harry, die zeigen, wer wir wirklich sind, viel mehr als unsere Fähigkeiten. -JK Rowling"
    },
    "2025-01-03": {
        "content": " Folgen Sie Ihrem Glück und das Universum wird Ihnen Türen öffnen, wo vorher nur Wände waren. -Joseph Campbell"
    },
    "2025-01-04": {
        "content": " Träume sind nicht die, die uns im Schlaf einfallen, sondern Träume sind die, die wir nicht im Schlaf wahr werden lassen. -Abdul Kalam"
    },
    "2025-01-05": {
        "content": " Wagemut bedeutet, den Mut zu haben, verletzlich zu sein. Es bedeutet, sich zu zeigen und gesehen zu werden. Um das zu bitten, was man braucht. Über die eigenen Gefühle zu sprechen. Schwierige Gespräche zu führen. -Brené Brown"
    },
    "2025-01-06": {
        "content": " Du wirst niemals erfolgreich sein, bis du deinen Schmerz in Größe verwandelst, bis du zulässt, dass er dich von dort, wo du bist, dorthin treibt, wo du hingehörst. Hör auf, vor deinem Schmerz davonzulaufen, und akzeptiere ihn. Dein Schmerz wird Teil deines Erfolgs sein, Teil deines Erfolgs. Ich fordere dich heraus, dich selbst zu übertreffen. -Eric Thomas"
    },
    "2025-01-07": {
        "content": "Wir sind, was wir wiederholt tun. Exzellenz ist daher keine Handlung, sondern eine Gewohnheit. -Aristoteles"
    },
    "2025-01-08": {
        "content": " Ein Fluss schneidet sich durch Felsen, nicht aufgrund seiner Kraft, sondern aufgrund seiner Beharrlichkeit. -Jim Watkins"
    },
    "2025-01-09": {
        "content": " Energie und Ausdauer überwinden alles. -Benjamin Franklin"
    },
    "2025-01-10": {
        "content": " Chancen werden normalerweise als harte Arbeit getarnt, sodass die meisten Menschen sie nicht erkennen. -Ann Landers"
    },
    "2025-01-11": {
        "content": " Wenn du nicht fliegen kannst, dann laufe. Wenn du nicht rennen kannst, dann geh. Wenn du nicht gehen kannst, dann krieche. Aber was auch immer du tust, du musst weiter vorwärts gehen. -Martin Luther King Jr."
    },
    "2025-01-12": {
        "content": " Durch Beharrlichkeit sind Ergebnisse vorprogrammiert. -Paramahansa Yogananda"
    },
    "2025-01-13": {
        "content": " Mit gewöhnlichem Talent und außergewöhnlicher Ausdauer sind alle Dinge erreichbar -Thomas Fowell Buxton"
    },
    "2025-01-14": {
        "content": " Unser größter Ruhm besteht nicht darin, niemals zu versagen, sondern jedes Mal wieder aufzustehen, wenn wir versagen. -Ralph Waldo Emerson"
    },
    "2025-01-15": {
        "content": " Erfolg bedeutet, von einem Misserfolg zum nächsten zu stolpern, ohne die Begeisterung zu verlieren. -Winston Churchill"
    },
    "2025-01-16": {
        "content": "Glücklicherweise ist Beharrlichkeit ein großartiger Ersatz für Talent. -Steve Martin"
    },
    "2025-01-17": {
        "content": " Ich glaube fest an Glück und je härter ich arbeite, desto mehr habe ich davon. -Thomas Jefferson"
    },
    "2025-01-18": {
        "content": " Verschieben Sie nur das auf morgen, was Sie auch unter dem Eindruck Ihres Todes unerledigt lassen möchten. -Pablo Picasso"
    },
    "2025-01-19": {
        "content": " Es gibt keine Erfolgsgeheimnisse: Verschwenden Sie keine Zeit damit, danach zu suchen. Erfolg ist das Ergebnis von Perfektion, harter Arbeit, Lernen aus Fehlern, Loyalität gegenüber Ihren Mitarbeitern und Beharrlichkeit. -Colin Powell"
    },
    "2025-01-20": {
        "content": " Wenn Sie vorne sein möchten, dann tun Sie so, als wären Sie hinten. -Lao Tzu"
    },
    "2025-01-21": {
        "content": " Lassen Sie mich Ihnen das Geheimnis verraten, das mich zu meinem Ziel geführt hat: Meine Stärke liegt einzig und allein in meiner Hartnäckigkeit. -Louis Pasteur"
    },
    "2025-01-22": {
        "content": " Nichts auf dieser Welt kann Beharrlichkeit ersetzen. Talent nicht; nichts ist häufiger als erfolglose Menschen mit Talent. Genie nicht; unbelohntes Genie ist fast ein Sprichwort. -Calvin Coolidge"
    },
    "2025-01-23": {
        "content": " Der beste Ausweg ist immer der Durchgang. -Robert Frost"
    },
    "2025-01-24": {
        "content": "Viele der Versager im Leben sind Menschen, die nicht erkannt haben, wie nahe sie dem Erfolg waren, als sie aufgegeben haben. -Thomas A. Edison"
    },
    "2025-01-25": {
        "content": " Wir sind dazu geschaffen, durchzuhalten. So finden wir heraus, wer wir sind. -Tobias Wolff"
    },
    "2025-01-26": {
        "content": " Da ich Bäume kenne, verstehe ich die Bedeutung von Geduld. Da ich Gras kenne, weiß ich Beharrlichkeit zu schätzen. -Hal Borland"
    },
    "2025-01-27": {
        "content": " Tropfendes Wasser höhlt Stein aus, nicht durch Kraft, sondern durch Beharrlichkeit. -Ovid"
    },
    "2025-01-28": {
        "content": " Beharrlichkeit ist sehr wichtig. Sie sollten nicht aufgeben, es sei denn, Sie werden dazu gezwungen. -Elon Musk"
    },
    "2025-01-29": {
        "content": " Glühende Begeisterung, gepaart mit gesundem Menschenverstand und Ausdauer, ist die Eigenschaft, die am häufigsten zum Erfolg führt. -Dale Carnegie"
    },
    "2025-01-30": {
        "content": " Ehrgeiz ist der Weg zum Erfolg. Beharrlichkeit ist das Fahrzeug, mit dem Sie ankommen. -Bill Bradley"
    },
    "2025-01-31": {
        "content": " Konzentrieren Sie sich auf die Lösung, nicht auf das Problem. -Walter Anderson"
    },
    "2025-02-01": {
        "content": " Wenn das Leben Sie niederschlägt, haben Sie zwei Möglichkeiten: liegen bleiben oder aufstehen. -Tom Krause"
    },
    "2025-02-02": {
        "content": "Erfolg ist die Summe kleiner Anstrengungen, die Tag für Tag wiederholt werden. -Robert Collier"
    },
    "2025-02-03": {
        "content": " Ein Traum ist nur ein Traum. Ein Ziel ist ein Traum mit einem Plan und einer Frist. -Harvey MacKay"
    },
    "2025-02-04": {
        "content": " Geben Sie niemals etwas auf, an das Sie keinen Tag lang nicht denken können. -Winston Churchill"
    },
    "2025-02-05": {
        "content": " Diamanten sind nichts anderes als Kohlestücke, die an ihrer Aufgabe haften geblieben sind. -Malcolm S. Forbes"
    },
    "2025-02-06": {
        "content": " Man kann nichts tun, außer Stück für Stück. -Charles Baudelaire"
    },
    "2025-02-07": {
        "content": " Wenn Sie durch die Hölle gehen, machen Sie weiter. -Winston Churchill"
    },
    "2025-02-08": {
        "content": " Der Schlüssel der Beharrlichkeit öffnet alle Türen, die durch Widerstand verschlossen sind. -John Di Lemme"
    },
    "2025-02-09": {
        "content": " Wenn wir uns die erfolgreichsten Menschen der Welt ansehen, ist Beharrlichkeit der gemeinsame Nenner. -Justin Sachs"
    },
    "2025-02-10": {
        "content": " Sie können einen Elefanten Stück für Stück essen. -Mary Kay Ash"
    },
    "2025-02-11": {
        "content": " Ich glaube nicht, dass es eine andere Eigenschaft gibt, die für Erfolg jeglicher Art so wichtig ist wie Beharrlichkeit. Sie überwindet fast alles, sogar die Natur. -John D. Rockefeller"
    },
    "2025-02-12": {
        "content": "Wer eine Vision in die Tat umsetzen möchte, muss 100 % geben und nie aufhören, an seinen Traum zu glauben. -Arnold Schwarzenegger"
    },
    "2025-02-13": {
        "content": " Laufen Sie, wenn Sie können, gehen Sie, wenn es sein muss, kriechen Sie, wenn es sein muss; geben Sie einfach niemals auf. -Dean Karnazes"
    },
    "2025-02-14": {
        "content": " Noch eine Runde weiterzugehen, wenn Sie denken, dass Sie es nicht können – das macht den entscheidenden Unterschied in Ihrem Leben. -Sylvester Stallone"
    },
    "2025-02-15": {
        "content": " Hör mir zu, selbst wenn du verlierst, ist es okay zu verlieren, aber du kannst dich nie damit anfreunden. Du kannst nie zufrieden sein mit einer Niederlage. Wenn du verlierst, muss es weh tun. -Eric Thomas"
    },
    "2025-02-16": {
        "content": " Gehen Sie Ihren Weg weiter, Schritt für Schritt. -Joyce Meyer"
    },
    "2025-02-17": {
        "content": " Wir sollten nicht aufgeben und nicht zulassen, dass uns das Problem besiegt. -Abdul Kalam"
    },
    "2025-02-18": {
        "content": " Durch Ausdauer siegen wir. -Ernest Shackleton"
    },
    "2025-02-19": {
        "content": "Die Mauern sind aus einem bestimmten Grund da. Sie sind nicht da, um uns fernzuhalten. Sie sind da, um uns die Möglichkeit zu geben, zu zeigen, wie sehr wir etwas wollen. Denn sie sind da, um diejenigen aufzuhalten, die es nicht stark genug wollen. Sie sind da, um die anderen aufzuhalten. -Randy Pausch"
    },
    "2025-02-20": {
        "content": " Erfolg hängt fast ausschließlich von Tatkraft und Ausdauer ab. Die zusätzliche Energie, die für einen weiteren Versuch oder einen anderen Ansatz erforderlich ist, ist das Geheimnis des Erfolgs. -Denis Waitley"
    },
    "2025-02-21": {
        "content": " Ich hatte es bis hierher geschafft und weigerte mich aufzugeben, weil ich mein ganzes Leben lang jedes Rennen zu Ende gebracht hatte. -Louis Zamperini"
    },
    "2025-02-22": {
        "content": " Überleben lässt sich in drei Worten zusammenfassen: Gib niemals auf. Das ist der Kern der Sache. Versuche es einfach weiter. -Bear Grylls"
    },
    "2025-02-23": {
        "content": "Schluss damit. Keine Ausreden mehr. Schluss mit: „Ich fange morgen an.“ Schluss mit: „Nur dieses eine Mal.“ Schluss mit dem Akzeptieren der Schwächen meines eigenen Willens. Schluss mit dem einfachen Weg. Schluss mit dem Nachgeben gegenüber ungesunden oder unproduktiven Gedanken, die mir durch den Kopf gehen. -Jocko Willink"
    },
    "2025-02-24": {
        "content": " Mit kleinen Schlägen werden große Eichen gefällt. -Benjamin Franklin"
    },
    "2025-02-25": {
        "content": " Ich bin bereit.“ „Ich bin darauf programmiert zu gewinnen.“ „Ich schaffe das.“ „Ich nehme die Ungewissheit an.“ „Ich bin nicht meine Gedanken, ich bin, was ich tue.“ „Ich bin unerbittlich.“ „Ich erwarte nichts und akzeptiere alles.“ -Gary John Bishop"
    },
    "2025-02-26": {
        "content": " Ich habe nicht 700 Mal versagt. Ich habe nicht ein einziges Mal versagt. Ich habe bewiesen, dass diese 700 Wege nicht funktionieren. Wenn ich die Wege eliminiert habe, die nicht funktionieren, werde ich den Weg finden, der funktioniert. -Thomas A. Edison"
    },
    "2025-02-27": {
        "content": " GRIT steht für Mut, Belastbarkeit, Fleiß und Hartnäckigkeit. GRIT ist die Fähigkeit, sich zu konzentrieren, entschlossen zu bleiben, angesichts einer Herausforderung optimistisch zu bleiben und einfach härter zu arbeiten als jeder andere. -Linda Kaplan Thaler"
    },
    "2025-02-28": {
        "content": "Ich glaube, mein Geheimnis ist, dass es keine Abkürzungen für harte Arbeit, Entschlossenheit und die Einstellung „Gib nicht auf“ gibt. -Jerry Rice"
    },
    "2025-03-01": {
        "content": " Hören Sie nie auf zu kämpfen, bis Sie an Ihrem Bestimmungsort angekommen sind – das heißt, bei Ihrem einzigartigen Ich. Setzen Sie sich ein Ziel im Leben, eignen Sie sich kontinuierlich Wissen an, arbeiten Sie hart und haben Sie Ausdauer, um das großartige Leben zu verwirklichen. -Abdul Kalam"
    },
    "2025-03-02": {
        "content": " Hören Sie nicht auf, wenn Sie müde sind. Hören Sie auf, wenn Sie fertig sind. -David Goggins"
    },
    "2025-03-03": {
        "content": " Beurteilen Sie mich nicht nach meinen Erfolgen, sondern danach, wie oft ich hingefallen und wieder aufgestanden bin. -Nelson Mandela"
    },
    "2025-03-04": {
        "content": " Was heute nicht begonnen wird, wird morgen nie beendet sein. -Johann Wolfgang von Goethe"
    },
    "2025-03-05": {
        "content": " Wenn Sie hundert Kurzgeschichten schreiben und alle schlecht sind, heißt das nicht, dass Sie versagt haben. Sie versagen erst, wenn Sie mit dem Schreiben aufhören. -Ray Bradbury"
    },
    "2025-03-06": {
        "content": " Der Meister ist öfter gescheitert, als der Anfänger es überhaupt versucht hat. -Stephen McCranie"
    },
    "2025-03-07": {
        "content": " Zum Teufel mit den Umständen, ich schaffe Gelegenheiten. -Bruce Lee"
    },
    "2025-03-08": {
        "content": "Das Einzige, was schlimmer ist, als etwas anzufangen und zu scheitern, ist, nichts anzufangen. -Seth Godin"
    },
    "2025-03-09": {
        "content": " Verschieben Sie nie auf morgen, was Sie heute tun können. -Benjamin Franklin"
    },
    "2025-03-10": {
        "content": " Durch Beharrlichkeit erreichte die Schnecke die Arche. -Charles H. Spurgeon"
    },
    "2025-03-11": {
        "content": " Denken Sie daran: Hoffnung ist eine gute Sache, vielleicht sogar das Beste, und nichts Gutes stirbt jemals. -Stephen King"
    },
    "2025-03-12": {
        "content": " Unternehmer hören nicht auf, wenn sie müde sind. Wir hören auf, wenn wir fertig sind. -Robert T. Kiyosaki"
    },
    "2025-03-13": {
        "content": " Nur Beharrlichkeit und Entschlossenheit sind allmächtig. -Calvin Coolidge"
    },
    "2025-03-14": {
        "content": " Lähmen Sie den Widerstand durch Beharrlichkeit. -Woody Hayes"
    },
    "2025-03-15": {
        "content": " Erfolg gehört nie jemandem, er wird gemietet, und die Miete ist jeden Tag fällig. -Rory Vaden"
    },
    "2025-03-16": {
        "content": " Erfolg ist kein Zufall. Er erfordert harte Arbeit, Ausdauer, Lernen, Studieren, Opferbereitschaft und vor allem Liebe zu dem, was man tut oder lernt. -Pelé"
    },
    "2025-03-17": {
        "content": " An der harten Arbeit führt kein Weg vorbei. Nehmen Sie sie an. -Roger Federer"
    },
    "2025-03-18": {
        "content": " Ein Traum wird nicht durch Zauberei Wirklichkeit; es erfordert Schweiß, Entschlossenheit und harte Arbeit. -Colin Powell"
    },
    "2025-03-19": {
        "content": "Lernen erschöpft den Geist nie. -Leonardo da Vinci"
    },
    "2025-03-20": {
        "content": " Ich höre und vergesse. Ich sehe und erinnere mich. Ich tue und verstehe. -Konfuzius"
    },
    "2025-03-21": {
        "content": " Wer noch nie einen Fehler gemacht hat, hat noch nie etwas Neues ausprobiert. -Albert Einstein"
    },
    "2025-03-22": {
        "content": " Versuchen Sie, über alles etwas und über etwas alles zu lernen. -Thomas Henry Huxley"
    },
    "2025-03-23": {
        "content": " Der Mensch lernt nur auf zwei Arten: einmal durch Lesen und einmal durch den Umgang mit intelligenteren Menschen. -Will Rogers"
    },
    "2025-03-24": {
        "content": " Sie verstehen nichts, bis Sie es auf mehr als eine Weise lernen. -Marvin Minsky"
    },
    "2025-03-25": {
        "content": " Erzähl es mir und ich vergesse es. Lehre mich und ich erinnere mich vielleicht. Beteilige mich und ich lerne. -Benjamin Franklin"
    },
    "2025-03-26": {
        "content": " Wenn Sie Ihre Erfolgsquote erhöhen möchten, verdoppeln Sie Ihre Misserfolgsquote. -Thomas J. Watson"
    },
    "2025-03-27": {
        "content": " Intelligenz ist das, was Sie einsetzen, wenn Sie nicht wissen, was Sie tun sollen. -Jean Piaget"
    },
    "2025-03-28": {
        "content": " Die Analphabeten des 21. Jahrhunderts werden nicht diejenigen sein, die nicht lesen und schreiben können, sondern diejenigen, die nicht lernen, verlernen und neu lernen können. -Alvin Toffler"
    },
    "2025-03-29": {
        "content": "Es ist das, was wir bereits wissen, das uns oft am Lernen hindert. -Claude Bernard"
    },
    "2025-03-30": {
        "content": " Mathematik ist die Sprache, mit der Gott das Universum geschrieben hat. -Galileo Galilei"
    },
    "2025-03-31": {
        "content": " Der ganze Zweck der Bildung besteht darin, Spiegel in Fenster zu verwandeln. -Sydney J. Harris"
    },
    "2025-04-01": {
        "content": " Ich habe keine Angst vor Stürmen, denn ich lerne, wie ich mein Schiff segele. -Louisa May Alcott"
    },
    "2025-04-02": {
        "content": " Gebildet ist nur derjenige, der gelernt hat, wie man lernt und sich verändert. -Carl R. Rogers"
    },
    "2025-04-03": {
        "content": " Ich habe noch nie einen Menschen getroffen, der so unwissend war, dass ich nichts von ihm hätte lernen können. -Galileo Galilei"
    },
    "2025-04-04": {
        "content": " Nichts verschwindet, bis es uns das beigebracht hat, was wir wissen müssen. -Pema Chödrön"
    },
    "2025-04-05": {
        "content": " Übung macht den Meister. Nach langem Üben wird unsere Arbeit natürlich, geschickt, schnell und stetig. -Bruce Lee"
    },
    "2025-04-06": {
        "content": " Wenn Sie sprechen, wiederholen Sie nur etwas, das Sie bereits wissen. Aber wenn Sie zuhören, lernen Sie vielleicht etwas Neues. -Dalai Lama XIV"
    },
    "2025-04-07": {
        "content": " Streben Sie nach Fortschritt, nicht nach Perfektion. -Anonym"
    },
    "2025-04-08": {
        "content": "Ich tue immer das, was ich noch nicht kann, um zu lernen, wie es geht. -Vincent van Gogh"
    },
    "2025-04-09": {
        "content": " Wissen macht einen Menschen untauglich, ein Sklave zu sein. -Frederick Douglass"
    },
    "2025-04-10": {
        "content": " Ich habe sehr früh den Unterschied gelernt, ob man den Namen einer Sache kennt oder etwas weiß. -Richard P. Feynman"
    },
    "2025-04-11": {
        "content": " Die Fähigkeit zu lernen ist eine Gabe; die Fähigkeit zu lernen ist eine Fertigkeit; die Bereitschaft zu lernen ist eine Entscheidung. -Brian Herbert"
    },
    "2025-04-12": {
        "content": " Lernen Sie alles, was Sie können, wann immer Sie können, von jedem, von dem Sie können – es wird immer eine Zeit kommen, in der Sie dankbar dafür sein werden. -Sarah Caldwell"
    },
    "2025-04-13": {
        "content": " Ich halte nicht viel von einem Mann, der heute nicht weiser ist als gestern. -Abraham Lincoln"
    },
    "2025-04-14": {
        "content": " Der Schlüssel zum Erfolg liegt in der Hingabe zum lebenslangen Lernen. -Stephen R. Covey"
    },
    "2025-04-15": {
        "content": " Seien Sie leidenschaftlich und mutig. Lernen Sie immer weiter. Wenn Sie nicht lernen, hören Sie auf, nützliche Dinge zu tun. -Satya Nadella"
    },
    "2025-04-16": {
        "content": "Die höchste Aktivität, die ein Mensch erreichen kann, ist das Lernen zum Verstehen, denn Verstehen bedeutet Freiheit. -Baruch Spinoza"
    },
    "2025-04-17": {
        "content": " Wenn Sie nicht ständig dazulernen, werden andere an Ihnen vorbeiziehen. Temperament allein reicht nicht aus – Sie brauchen viel Neugier über einen langen, langen Zeitraum. -Charlie Munger"
    },
    "2025-04-18": {
        "content": " Eine lernende Organisation ist eine Organisation, die ihre Kapazitäten zur Gestaltung ihrer Zukunft kontinuierlich erweitert. -Peter Senge"
    },
    "2025-04-19": {
        "content": " Der Tag, an dem Sie aufhören zu lernen, ist der Tag, an dem Sie zu verfallen beginnen. -Isaac Asimov"
    },
    "2025-04-20": {
        "content": " Lernen ist ein Schmuckstück im Wohlstand, ein Zufluchtsort in der Not und eine Vorsorge im Alter. -Aristoteles"
    },
    "2025-04-21": {
        "content": " Alle Führungskräfte lernen. Sobald man aufhört zu lernen, hört man auf zu führen. Ich lerne so viel ich kann, von so vielen Menschen wie möglich, so oft ich kann. -Rick Warren"
    },
    "2025-04-22": {
        "content": " Um schwierige Dinge schnell zu lernen, müssen Sie sich intensiv konzentrieren und dürfen sich nicht ablenken lassen. Lernen ist also ein Akt intensiver Arbeit. -Cal Newport"
    },
    "2025-04-23": {
        "content": " Jeder Dummkopf kann es wissen. Es geht darum, es zu verstehen. -Albert Einstein"
    },
    "2025-04-24": {
        "content": "Versuchen Sie jeden Tag, ein bisschen weiser zu sein als beim Aufwachen. -Charlie Munger"
    },
    "2025-04-25": {
        "content": " Investieren Sie in sich selbst, in Ihre Ausbildung. Es gibt nichts Besseres. -Sylvia Porter"
    },
    "2025-04-26": {
        "content": " Die Selbstbildung bereitet mir immer wieder Freude, denn je mehr ich weiß, desto erfüllter ist mein Leben und desto mehr schätze ich meine eigene Existenz. -Isaac Asimov"
    },
    "2025-04-27": {
        "content": " Sie können Hilfe von Lehrern bekommen, aber Sie müssen viel selbst lernen, indem Sie allein in einem Raum sitzen. -Dr. Seuss"
    },
    "2025-04-28": {
        "content": " Lernen geschieht, wenn jemand lernen möchte, nicht, wenn jemand lehren möchte. -Roger Schank"
    },
    "2025-04-29": {
        "content": " Eine Person kann einer anderen Person nicht direkt etwas beibringen; sie kann lediglich das Lernen einer anderen Person erleichtern. -Carl R. Rogers"
    },
    "2025-04-30": {
        "content": " Lernen ist nicht verpflichtend, sondern freiwillig. Verbesserung ist nicht verpflichtend, sondern freiwillig. Aber um zu überleben, müssen wir lernen. -W. Edwards Deming"
    },
    "2025-05-01": {
        "content": " Ich tue immer das, was ich nicht kann, damit ich lerne, wie es geht. -Pablo Picasso"
    },
    "2025-05-02": {
        "content": "Kein Dieb, egal wie geschickt er ist, kann jemandem sein Wissen rauben, und deshalb ist Wissen der beste und sicherste Schatz, den man erwerben kann. -L. Frank Baum"
    },
    "2025-05-03": {
        "content": " Ich glaube, das ist der beste Ratschlag überhaupt: Denken Sie ständig darüber nach, wie Sie die Dinge besser machen könnten, und stellen Sie sich selbst in Frage. -Elon Musk"
    },
    "2025-05-04": {
        "content": " Ein weiser Mensch kann aus einer dummen Frage mehr lernen als ein Narr aus einer weisen Antwort. -Bruce Lee"
    },
    "2025-05-05": {
        "content": " Wenn ich weiter geblickt habe, dann deshalb, weil ich auf den Schultern von Riesen stehe. -Isaac Newton"
    },
    "2025-05-06": {
        "content": " Was wir wissen, ist ein Tropfen, was wir nicht wissen, ist ein Ozean. -Isaac Newton"
    },
    "2025-05-07": {
        "content": " Das Schöne am Lernen ist, dass es Ihnen niemand nehmen kann. -BB König"
    },
    "2025-05-08": {
        "content": " Wenn Sie Schriftsteller werden möchten, müssen Sie vor allem zwei Dinge tun: viel lesen und viel schreiben. -Stephen King"
    },
    "2025-05-09": {
        "content": " Wiederholung ist die Mutter der Geschicklichkeit. -Tony Robbins"
    },
    "2025-05-10": {
        "content": " Staunen ist der Anfang der Weisheit. -Sokrates"
    },
    "2025-05-11": {
        "content": " Wenn Sie einen Fehler machen und ihn nicht korrigieren, wird dies als Fehler bezeichnet. -Konfuzius"
    },
    "2025-05-12": {
        "content": " Der Zweck der Bildung besteht darin, einen leeren Geist durch einen offenen zu ersetzen. -Malcolm S. Forbes"
    },
    "2025-05-13": {
        "content": "Im Leben gibt es nichts zu fürchten, man muss es nur verstehen. Jetzt ist es an der Zeit, mehr zu verstehen, damit wir weniger Angst haben. -Marie Curie"
    },
    "2025-05-14": {
        "content": " Wenn Sie gefragt werden, ob Sie eine Aufgabe erledigen können, sagen Sie: „Natürlich kann ich das!“. Dann legen Sie los und finden Sie heraus, wie es geht. -Theodore Roosevelt"
    },
    "2025-05-15": {
        "content": " Wir alle brauchen Menschen, die uns Feedback geben. So verbessern wir uns. -Bill Gates"
    },
    "2025-05-16": {
        "content": " Bildung ist der Schlüssel zur Welt, ein Pass zur Freiheit. -Oprah Winfrey"
    },
    "2025-05-17": {
        "content": " Alles beginnt mit einer Idee. -Earl Nightingale"
    },
    "2025-05-18": {
        "content": " Die beste Investition, die Sie tätigen können, ist die in sich selbst. -Warren Buffett"
    },
    "2025-05-19": {
        "content": " Es geht nicht um Geld oder Beziehungen. Es geht um die Bereitschaft, mehr zu arbeiten und mehr zu lernen als alle anderen. -Mark Cuban"
    },
    "2025-05-20": {
        "content": " Lernen Sie Ihr Leben lang, wie man lebt. -Seneca"
    },
    "2025-05-21": {
        "content": " Um zu lernen, erfolgreich zu sein, müssen Sie zuerst lernen, zu scheitern. -Michael Jordan"
    },
    "2025-05-22": {
        "content": " Verschwenden Sie keinen guten Fehler, lernen Sie daraus. -Robert T. Kiyosaki"
    },
    "2025-05-23": {
        "content": "Um Wissen zu erlangen, muss man studieren; um Weisheit zu erlangen, muss man beobachten. -Marilyn Vos Savant"
    },
    "2025-05-24": {
        "content": " Man lebt und lernt. Auf jeden Fall lebt man. -Douglas Adams"
    },
    "2025-05-25": {
        "content": " Geduld ist der Begleiter der Weisheit. - Heiliger Augustinus"
    },
    "2025-05-26": {
        "content": " Ich weiß nur eines, und zwar, dass ich nichts weiß. -Sokrates"
    },
    "2025-05-27": {
        "content": " Weisheit kommt aus Erfahrung. Erfahrung ist oft das Ergebnis eines Mangels an Weisheit. -Terry Pratchett"
    },
    "2025-05-28": {
        "content": " Wir können unseren Fortschritt am Mut unserer Fragen und der Tiefe unserer Antworten messen, an unserer Bereitschaft, das zu akzeptieren, was wahr ist, statt das, was sich gut anfühlt. -Carl Sagan"
    },
    "2025-05-29": {
        "content": " Ich hätte lieber Fragen, die nicht beantwortet werden können, als Antworten, die nicht hinterfragt werden können. -Richard P. Feynman"
    },
    "2025-05-30": {
        "content": " Ich bin immer bereit zu lernen, auch wenn es mir nicht immer gefällt, wenn mir etwas beigebracht wird. -Winston Churchill"
    },
    "2025-05-31": {
        "content": " Wer die Praxis ohne Theorie liebt, ist wie der Seemann, der ohne Ruder und Kompass an Bord eines Schiffes geht und nie weiß, wohin er steuern kann. -Leonardo da Vinci"
    },
    "2025-06-01": {
        "content": " Es ist besser zu erschaffen als zu lernen. Schaffen ist die Essenz des Lebens. -Julius Caesar"
    },
    "2025-06-02": {
        "content": "Was die Hand tut, merkt sich der Verstand. -Maria Montessori"
    },
    "2025-06-03": {
        "content": " Gehen Sie immer durchs Leben, als ob Sie etwas Neues lernen müssten, und das werden Sie auch. -Vernon Howard"
    },
    "2025-06-04": {
        "content": " Ein Misserfolg ist ein Erfolg, wenn wir daraus lernen. -Malcolm S. Forbes"
    },
    "2025-06-05": {
        "content": " Bildung ist der beste Freund. Ein gebildeter Mensch wird überall respektiert. Bildung schlägt Schönheit und Jugend. -Chanakya"
    },
    "2025-06-06": {
        "content": " Denken Sie nicht, dass das, was für Sie schwer zu meistern ist, für den Menschen unmöglich ist. Aber wenn etwas für den Menschen möglich ist, dann betrachten Sie es als in Ihrer Reichweite. -Marcus Aurelius"
    },
    "2025-06-07": {
        "content": " Lernen ist ein ständiger Entdeckungsprozess – ein Prozess ohne Ende. -Bruce Lee"
    },
    "2025-06-08": {
        "content": " Unwissenheit ist nicht so sehr eine Schande, sondern vielmehr die mangelnde Lernbereitschaft. -Benjamin Franklin"
    },
    "2025-06-09": {
        "content": " Ich bin davon überzeugt, dass Wissen Macht ist – um die Vergangenheit zu überwinden, unsere eigene Situation zu ändern, neue Hindernisse zu überwinden und bessere Entscheidungen zu treffen. -Ben Carson"
    },
    "2025-06-10": {
        "content": " Beim Einatmen beruhige ich Körper und Geist. Beim Ausatmen lächle ich. Ich verweile im gegenwärtigen Moment und weiß, dass dies der einzige Moment ist. -Thich Nhat Hanh"
    },
    "2025-06-11": {
        "content": "Wenn Sie meinen, Sie seien zu klein, um etwas zu bewirken, versuchen Sie, mit einer Mücke zu schlafen. -Dalai Lama XIV"
    },
    "2025-06-12": {
        "content": " Zu oft unterschätzen wir die Macht einer Berührung, eines Lächelns, eines freundlichen Wortes, eines offenen Ohrs, eines ehrlichen Kompliments oder der kleinsten Geste der Fürsorge, die alle das Potenzial haben, ein Leben zu verändern. -Leo Buscaglia"
    },
    "2025-06-13": {
        "content": " Wie wir unsere Tage verbringen, bestimmt natürlich auch, wie wir unser Leben verbringen. -Annie Dillard"
    },
    "2025-06-14": {
        "content": " Pflegen Sie Ihren Geist mit großartigen Gedanken, denn Sie werden nie höher hinauskommen, als Sie denken. -Benjamin Disraeli"
    },
    "2025-06-15": {
        "content": " Laufen lernt man nicht durch das Befolgen von Regeln. Man lernt es durch Tun und Hinfallen. -Richard Branson"
    },
    "2025-06-16": {
        "content": " Es ist unmöglich, zu leben, ohne bei etwas zu scheitern, es sei denn, man lebt so vorsichtig, dass man genauso gut gar nicht gelebt haben könnte; in diesem Fall scheitert man automatisch. -JK Rowling"
    },
    "2025-06-17": {
        "content": " Wenn du glücklich sein willst, dann sei es. -Leo Tolstoi"
    },
    "2025-06-18": {
        "content": " Niemand kann mir ohne meine Erlaubnis wehtun. -Mahatma Gandhi"
    },
    "2025-06-19": {
        "content": " Wenn ich loslasse, was ich bin, werde ich, was ich sein könnte. -Lao Tzu"
    },
    "2025-06-20": {
        "content": "Der Grund, warum wir mit Unsicherheit kämpfen, liegt darin, dass wir unsere Blicke hinter die Kulissen mit den Höhepunkten aller anderen vergleichen. -Steven Furtick"
    },
    "2025-06-21": {
        "content": " Denken Sie daran: Heute ist das Morgen, um das Sie sich gestern Sorgen gemacht haben. -Dale Carnegie"
    },
    "2025-06-22": {
        "content": " Wir müssen bereit sein, das Leben, das wir geplant haben, loszulassen, um das Leben zu haben, das auf uns wartet. -Joseph Campbell"
    },
    "2025-06-23": {
        "content": " Hör auf wegzugehen, und du wirst ankommen. Hör auf zu suchen, und du wirst sehen. Hör auf wegzulaufen, und du wirst gefunden werden. -Lao Tzu"
    },
    "2025-06-24": {
        "content": " Ein Team ist nicht eine Gruppe von Menschen, die zusammenarbeiten. Ein Team ist eine Gruppe von Menschen, die einander vertrauen. -Simon Sinek"
    },
    "2025-06-25": {
        "content": " Ständiger Optimismus ist ein Kraftmultiplikator. -Colin Powell"
    },
    "2025-06-26": {
        "content": " Wenn Sie damit zufrieden sind, einfach Sie selbst zu sein und sich nicht mit anderen zu vergleichen oder zu konkurrieren, wird jeder Sie respektieren. -Lao Tzu"
    },
    "2025-06-27": {
        "content": " Berechnen Sie Ihr Alter anhand Ihrer Freunde, nicht anhand Ihrer Jahre. Berechnen Sie Ihr Leben anhand Ihres Lächelns, nicht anhand Ihrer Tränen. -John Lennon"
    },
    "2025-06-28": {
        "content": " Geben Sie den Menschen, die Sie lieben, Flügel zum Fliegen, geben Sie ihnen Wurzeln zum Wiederkehren und einen Grund zum Bleiben. -Dalai Lama XIV"
    },
    "2025-06-29": {
        "content": " Ausdauer und Mut haben zu allen Zeiten Wunder bewirkt. -George Washington"
    },
    "2025-06-30": {
        "content": "Teilen Sie Ihr Wissen. Es ist ein Weg, Unsterblichkeit zu erlangen. -Dalai Lama XIV"
    },
    "2025-07-01": {
        "content": " Wir sind für den Kosmos eine Möglichkeit, sich selbst zu erkennen. -Carl Sagan"
    },
    "2025-07-02": {
        "content": " Ein guter Lehrer kann Hoffnung wecken, die Fantasie anregen und die Liebe zum Lernen vermitteln. -Brad Henry"
    },
    "2025-07-03": {
        "content": " Eine der größten Entdeckungen und Überraschungen, die ein Mensch machen kann, ist die Erkenntnis, dass er Dinge tun kann, von denen er befürchtet hatte, sie nicht tun zu können. -Henry Ford"
    },
    "2025-07-04": {
        "content": " Wann haben Sie das letzte Mal etwas zum ersten Mal getan? -John C. Maxwell"
    },
    "2025-07-05": {
        "content": " Wenn Sie nicht dabei sind, die Person zu werden, die Sie sein möchten, sind Sie automatisch dabei, die Person zu werden, die Sie nicht sein möchten. -Dale Carnegie"
    },
    "2025-07-06": {
        "content": " Das Glück ist mit den Mutigen. -Lateinisches Sprichwort"
    },
    "2025-07-07": {
        "content": " Erfolg ist nicht der Schlüssel zum Glück. Glück ist der Schlüssel zum Erfolg. Wenn du liebst, was du tust, wirst du erfolgreich sein. -Albert Schweitzer"
    },
    "2025-07-08": {
        "content": " Gewinnen Sie nicht die Welt und verlieren Sie Ihre Seele. Weisheit ist besser als Silber oder Gold. -Bob Marley"
    },
    "2025-07-09": {
        "content": " Beginnen Sie sofort zu leben und betrachten Sie jeden einzelnen Tag als ein einzelnes Leben. -Seneca"
    },
    "2025-07-10": {
        "content": "Sofern sich niemand wie Sie wirklich darum kümmert, wird sich nichts bessern. Das wird es nicht. -Dr. Seuss"
    },
    "2025-07-11": {
        "content": " Sie wussten nicht, dass es unmöglich war, also haben sie es getan. -Mark Twain"
    },
    "2025-07-12": {
        "content": " Ich kann Dinge tun, die Sie nicht können, Sie können Dinge tun, die ich nicht kann; gemeinsam können wir Großes erreichen. -Mutter Teresa"
    },
    "2025-07-13": {
        "content": " Das Einzige, was wir fürchten müssen, ist die Furcht selbst. -Franklin D. Roosevelt"
    },
    "2025-07-14": {
        "content": " Ohne Begeisterung wurde nie etwas Großes erreicht. -Ralph Waldo Emerson"
    },
    "2025-07-15": {
        "content": " Nur Mut, mein Herz. -CS Lewis"
    },
    "2025-07-16": {
        "content": " Der einzige Weg, Veränderungen zu verstehen, besteht darin, sich darauf einzulassen, sich mit ihnen zu bewegen und sich dem Tanz anzuschließen. -Alan Watts"
    },
    "2025-07-17": {
        "content": " Wo Aufmerksamkeit hingeht, fließt Energie und es zeigen sich Ergebnisse. -T. Harv Eker"
    },
    "2025-07-18": {
        "content": " Schmerz ist vorübergehend. Er kann eine Minute, eine Stunde, einen Tag oder ein Jahr dauern, aber irgendwann lässt er nach und etwas anderes nimmt seinen Platz ein. Wenn ich jedoch aufhöre, bleibt er für immer. -Lance Armstrong"
    },
    "2025-07-19": {
        "content": " Bei jedem Spaziergang in der Natur erhält man weit mehr, als man sucht. -John Muir"
    },
    "2025-07-20": {
        "content": "Gewinner sind nicht diejenigen, die nie scheitern, sondern diejenigen, die nie aufgeben. -Edwin Louis Cole"
    },
    "2025-07-21": {
        "content": " Anstatt die Dunkelheit zu bekämpfen, bringen Sie das Licht herein. -Eckhart Tolle"
    },
    "2025-07-22": {
        "content": " Seien Sie furchtlos bei der Suche nach dem, was Ihre Seele entflammt. -Jennifer Lee"
    },
    "2025-07-23": {
        "content": " Wenn Menschen dich verlassen, lass sie gehen. Dein Schicksal ist nie an jemanden gebunden, der dich verlässt, und das bedeutet nicht, dass es sich um schlechte Menschen handelt. Es bedeutet nur, dass ihr Teil in deiner Geschichte vorbei ist. -TD Jakes"
    },
    "2025-07-24": {
        "content": " Führung ist die Fähigkeit, Visionen in die Realität umzusetzen. -Warren G. Bennis"
    },
    "2025-07-25": {
        "content": " Glaube bedeutet, zu glauben, was man nicht sieht; die Belohnung für diesen Glauben besteht darin, zu sehen, was man glaubt. - Heiliger Augustinus"
    },
    "2025-07-26": {
        "content": " Nichts ist unmöglich, es sei denn, Sie glauben, dass es so ist. -Paramahansa Yogananda"
    },
    "2025-07-27": {
        "content": " Das Einzige, was schlimmer ist, als blind zu sein, ist, sehen zu können, aber keine Vision zu haben. -Helen Keller"
    },
    "2025-07-28": {
        "content": " Alles hat seine Schönheit, aber nicht jeder sieht sie. -Konfuzius"
    },
    "2025-07-29": {
        "content": " Gott spricht in der Stille des Herzens. -Mutter Teresa"
    },
    "2025-07-30": {
        "content": "Hoffnung ist das Ding mit Federn, das in der Seele nistet – und die Melodie ohne Worte singt – und niemals aufhört. -Emily Dickinson"
    },
    "2025-07-31": {
        "content": " Wie viele heilige Worte Sie auch lesen oder aussprechen, was nützen sie Ihnen, wenn Sie nicht danach handeln? -Buddha"
    },
    "2025-08-01": {
        "content": " Und übrigens: Über alles im Leben lässt sich schreiben, wenn man den Mut dazu und die Fantasie zum Improvisieren hat. Der schlimmste Feind der Kreativität sind Selbstzweifel. -Sylvia Plath"
    },
    "2025-08-02": {
        "content": " Nichts, was wir tun, kann die Vergangenheit ändern, aber alles, was wir tun, ändert die Zukunft. -Ashleigh Brilliant"
    },
    "2025-08-03": {
        "content": " Führung ist eine Entscheidung. Sie ist kein Rang. -Simon Sinek"
    },
    "2025-08-04": {
        "content": " Alles wird gut, und alles wird gut, und alles wird gut. -Julian von Norwich"
    },
    "2025-08-05": {
        "content": " Jeder von uns ist aus kosmischer Sicht wertvoll. Wenn ein Mensch anderer Meinung ist als du, lass ihn leben. In hundert Milliarden Galaxien wirst du keinen anderen finden. -Carl Sagan"
    },
    "2025-08-06": {
        "content": " Intelligenz plus Charakter – das ist das Ziel wahrer Bildung. -Martin Luther King Jr."
    },
    "2025-08-07": {
        "content": "Je mehr Sie sich in etwas verlieren, das größer ist als Sie selbst, desto mehr Energie werden Sie haben. -Norman Vincent Peale"
    },
    "2025-08-08": {
        "content": " Wenn Sie die Grundlagen beherrschen, wird sich das Niveau Ihrer gesamten Tätigkeit steigern -Michael Jordan"
    },
    "2025-08-09": {
        "content": " Sie können überhaupt nicht leben, wenn Sie nicht jetzt voll leben können. -Alan Watts"
    },
    "2025-08-10": {
        "content": " Denken Sie daran, dass es manchmal ein großer Glücksfall ist, nicht das zu bekommen, was Sie wollen. -Dalai Lama XIV"
    },
    "2025-08-11": {
        "content": " Geben Sie Ihr Bestes und entspannen Sie sich dann. Lassen Sie die Dinge ihren natürlichen Lauf nehmen, anstatt sie zu erzwingen. -Paramahansa Yogananda"
    },
    "2025-08-12": {
        "content": " Sie sind ein unendliches spirituelles Wesen, das eine vorübergehende menschliche Erfahrung macht. -Wayne W. Dyer"
    },
    "2025-08-13": {
        "content": " Sie müssen träumen, bevor Ihre Träume wahr werden können. -Abdul Kalam"
    },
    "2025-08-14": {
        "content": " Beschütze vor allem dein Herz, denn alles, was du tust, entspringt ihm. -Solomon"
    },
    "2025-08-15": {
        "content": " Beim Schreiben kann ich alles abschütteln, meine Sorgen verschwinden, mein Mut wird neu geboren. -Anne Frank"
    },
    "2025-08-16": {
        "content": " Das Ziel ist nicht, am Ende perfekt zu sein. Das Ziel ist, heute besser zu sein. -Simon Sinek"
    },
    "2025-08-17": {
        "content": " Gehen Sie selbstbewusst in die Richtung Ihrer Träume. Leben Sie das Leben, das Sie sich vorgestellt haben. -Henry David Thoreau"
    },
    "2025-08-18": {
        "content": "Seien Sie freundlich, wann immer es möglich ist. Es ist immer möglich. -Dalai Lama XIV"
    },
    "2025-08-19": {
        "content": " Unser Hauptzweck in diesem Leben ist es, anderen zu helfen. Und wenn Sie ihnen nicht helfen können, verletzen Sie sie zumindest nicht. -Dalai Lama XIV"
    },
    "2025-08-20": {
        "content": " Du hast Verstand. Du stehst in deinen Schuhen. Du kannst dich in jede gewünschte Richtung bewegen. Du bist auf dich allein gestellt. Und du weißt, was du weißt. Und du entscheidest, wohin es geht. -Dr. Seuss"
    },
    "2025-08-21": {
        "content": " Worauf Sie sich konzentrieren, erweitert sich, und wenn Sie sich auf das Gute in Ihrem Leben konzentrieren, schaffen Sie mehr davon. -Oprah Winfrey"
    },
    "2025-08-22": {
        "content": " Alles, was ich wissen muss, wird mir offenbart. Alles, was ich brauche, kommt zu mir. Alles ist gut in meinem Leben. -Louise Hay"
    },
    "2025-08-23": {
        "content": " Ich bin im Universum vollkommen sicher. Ich bin überall im Frieden. Ich vertraue dem Leben. -Louise Hay"
    },
    "2025-08-24": {
        "content": " Drehen Sie Ihr Gesicht der Sonne zu und die Schatten fallen hinter Sie. -Maori-Sprichwort"
    },
    "2025-08-25": {
        "content": " Mut bedeutet nicht, die Kraft zu haben, weiterzumachen. Mut bedeutet, weiterzumachen, wenn einem die Kraft dazu fehlt. -Theodore Roosevelt"
    },
    "2025-08-26": {
        "content": " Die Zukunft hängt davon ab, was Sie heute tun. -Mahatma Gandhi"
    },
    "2025-08-27": {
        "content": " Ein Gewinner ist ein Träumer, der niemals aufgibt. -Nelson Mandela"
    },
    "2025-08-28": {
        "content": "Weine nicht, weil es vorbei ist, lächle, weil es passiert ist. -Dr. Seuss"
    },
    "2025-08-29": {
        "content": " Ich kann alles, was ich über das Leben gelernt habe, in drei Worten zusammenfassen: Es geht weiter. -Robert Frost"
    },
    "2025-08-30": {
        "content": " Lebe aus deiner Vorstellungskraft, nicht aus deiner Geschichte. -Stephen R. Covey"
    },
    "2025-08-31": {
        "content": " So wie ich das sehe, muss man den Regen ertragen, wenn man den Regenbogen will. -Dolly Parton"
    },
    "2025-09-01": {
        "content": " Die Größe eines Menschen liegt nicht darin, wie viel Reichtum er anhäuft, sondern in seiner Integrität und seiner Fähigkeit, die Menschen um ihn herum positiv zu beeinflussen. -Bob Marley"
    },
    "2025-09-02": {
        "content": " Glück ist in erster Linie eine Folge unserer eigenen Einstellung und nicht auf äußere Faktoren zurückzuführen. -Dalai Lama XIV"
    },
    "2025-09-03": {
        "content": " Große Taten bestehen aus kleinen Taten. -Lao Tzu"
    },
    "2025-09-04": {
        "content": " Es ist nie zu spät, das zu werden, was Sie hätten sein können. -George Eliot"
    },
    "2025-09-05": {
        "content": " Durch die richtige Einstellung kann negativer Stress in positiven umgewandelt werden. -Hans Selye"
    },
    "2025-09-06": {
        "content": " Trauen Sie sich, das Leben zu leben, von dem Sie geträumt haben. Gehen Sie voran und lassen Sie Ihre Träume wahr werden. -Ralph Waldo Emerson"
    },
    "2025-09-07": {
        "content": " Die Zeit, die Sie gerne verschwenden, ist keine verschwendete Zeit. -Bertrand Russell"
    },
    "2025-09-08": {
        "content": "Man braucht nur ein wenig Wachsamkeit, um zu erkennen und herauszufinden: Das Leben ist in Wirklichkeit ein großes kosmisches Lachen. -Osho"
    },
    "2025-09-09": {
        "content": " Das seltsame Paradoxe ist, dass ich mich ändern kann, wenn ich mich so akzeptiere, wie ich bin. -Carl R. Rogers"
    },
    "2025-09-10": {
        "content": " Seien Sie Teil der Lösung, nicht Teil des Problems. -Stephen R. Covey"
    },
    "2025-09-11": {
        "content": " Das Geheimnis des Lebens ist das Geben. -Tony Robbins"
    },
    "2025-09-12": {
        "content": " Machen Sie jeden Tag zu Ihrem Meisterwerk. -John Wooden"
    },
    "2025-09-13": {
        "content": " Gib niemals auf, was du wirklich tun willst -H. Jackson Brown Jr."
    },
    "2025-09-14": {
        "content": " Schauen Sie nicht zurück – Sie gehen nicht diesen Weg. -Mary Engelbreit"
    },
    "2025-09-15": {
        "content": " Geben Sie Ihr Bestes und Gott wird den Rest erledigen. -Nick Vujicic"
    },
    "2025-09-16": {
        "content": " Lebe, reise, erlebe Abenteuer, sei gesegnet und bereue nichts. -Jack Kerouac"
    },
    "2025-09-17": {
        "content": " Mitten im Winter entdeckte ich einen unbesiegbaren Sommer in mir. Und das macht mich glücklich. Denn es sagt mir, dass, egal wie sehr die Welt mich bedrängt, in mir etwas Stärkeres – etwas Besseres – steckt, das zurückschlägt. -Albert Camus"
    },
    "2025-09-18": {
        "content": "Manche glauben, nur große Macht könne das Böse in Schach halten, aber das ist nicht meine Erfahrung. Es sind die kleinen alltäglichen Taten der einfachen Leute, die die Dunkelheit in Schach halten. Kleine Taten der Güte und Liebe. -JRR Tolkien"
    },
    "2025-09-19": {
        "content": " Seien Sie in kleinen Dingen treu, denn darin liegt Ihre Stärke. -Mutter Teresa"
    },
    "2025-09-20": {
        "content": " Machen Sie aus sich selbst ein Licht. -Buddha"
    },
    "2025-09-21": {
        "content": " VISUALISIEREN!!! Sehen und fühlen! Hier beginnt die Action. -Rhonda Byrne"
    },
    "2025-09-22": {
        "content": " Seien Sie phänomenal oder werden Sie vergessen! -Eric Thomas"
    },
    "2025-09-23": {
        "content": " Wenn Sie die Wahl haben, Recht zu haben oder freundlich zu sein, entscheiden Sie sich dafür, freundlich zu sein. -Wayne W. Dyer"
    },
    "2025-09-24": {
        "content": " Menschen können ihr Leben ändern, indem sie ihre Geisteshaltung ändern. -William James"
    },
    "2025-09-25": {
        "content": " Gesundheit ist der höchste Besitz. -Laozi"
    },
    "2025-09-26": {
        "content": " Lass mich nicht darum beten, vor Gefahren geschützt zu werden, sondern darum, ihnen furchtlos entgegenzutreten. Lass mich nicht darum betteln, dass mein Schmerz gestillt wird, sondern darum, dass mein Herz ihn überwindet. -Rabindranath Tagore"
    },
    "2025-09-27": {
        "content": " Konzentriere dich darauf, Gutes zu tun. Tu es immer wieder, und du wirst mit Freude erfüllt sein. -Buddha"
    },
    "2025-09-28": {
        "content": "Ich allein kann die Welt nicht verändern, aber ich kann einen Stein über das Wasser werfen, um viele Wellen zu erzeugen. -Mutter Teresa"
    },
    "2025-09-29": {
        "content": " Und der Tag kam, an dem das Risiko, in der Knospe zu verharren, schmerzhafter war als das Risiko, aufzublühen. -Anaïs Nin"
    },
    "2025-09-30": {
        "content": " Menschlichem Streben sollten keine Grenzen gesetzt sein. So schlimm das Leben auch erscheinen mag, es gibt immer Hoffnung. -Stephen Hawking"
    },
    "2025-10-01": {
        "content": " Und ich bitte Sie dringend, darauf zu achten, wann Sie glücklich sind, und irgendwann auszurufen oder zu murmeln oder zu denken: „Wenn das nicht schön ist, weiß ich nicht, was schön ist.“ -Kurt Vonnegut"
    },
    "2025-10-02": {
        "content": " Es ist Ihre Reaktion auf Widrigkeiten, nicht die Widrigkeiten selbst, die bestimmt, wie sich Ihre Lebensgeschichte entwickeln wird. -Dieter F. Uchtdorf"
    },
    "2025-10-03": {
        "content": " Es ist nicht das, was Sie haben, wer Sie sind, wo Sie sind oder was Sie tun, das Sie glücklich oder unglücklich macht. Es ist das, was Sie darüber denken. -Dale Carnegie"
    },
    "2025-10-04": {
        "content": " Je mehr Sie lesen, desto mehr Dinge werden Sie wissen. Je mehr Sie lernen, desto mehr Orte werden Sie besuchen. -Dr. Seuss"
    },
    "2025-10-05": {
        "content": " Alle unsere Träume können wahr werden. -Walt Disney"
    },
    "2025-10-06": {
        "content": "Das Privileg Ihres Lebens besteht darin, der zu sein, der Sie sind. -Joseph Campbell"
    },
    "2025-10-07": {
        "content": " Niemand auf dieser Welt ist nutzlos, wenn er einem anderen die Last erleichtert. -Charles Dickens"
    },
    "2025-10-08": {
        "content": " Finden Sie einen Ort in Ihrem Inneren, an dem Sie Freude empfinden, und die Freude wird den Schmerz vertreiben. -Joseph Campbell"
    },
    "2025-10-09": {
        "content": " Frag nicht, was die Welt braucht. Frag, was dich lebendig macht, und tu es. Denn was die Welt braucht, sind mehr Menschen, die lebendig geworden sind. -Howard Thurman"
    },
    "2025-10-10": {
        "content": " Ihre Gefühle sind Ihr wichtigstes Werkzeug, um Ihr Leben zu gestalten. -Rhonda Byrne"
    },
    "2025-10-11": {
        "content": " Ich verdiene das Beste und akzeptiere jetzt das Beste. -Louise Hay"
    },
    "2025-10-12": {
        "content": " Es kommt nicht darauf an, wie viel wir geben, sondern wie viel Liebe wir in das Geben stecken. -Mutter Teresa"
    },
    "2025-10-13": {
        "content": " Wenn Ihr Wunsch nach Erfolg genauso stark ist, wie Sie atmen möchten, werden Sie Erfolg haben. -Eric Thomas"
    },
    "2025-10-14": {
        "content": " Ich habe jede Minute des Trainings gehasst, aber ich sagte: „Gib nicht auf. Leide jetzt und lebe den Rest deines Lebens als Champion.“ -Muhammad Ali"
    },
    "2025-10-15": {
        "content": "Nicht der Kritiker zählt, nicht derjenige, der aufzeigt, wie der Starke gestolpert ist oder wie der Handelnde es hätte besser machen können. Der Verdienst gebührt dem Mann, der tatsächlich in der Arena steht, dessen Gesicht von Schweiß, Staub und Blut gezeichnet ist; der tapfer kämpft; der immer wieder irrt und scheitert; der die große Begeisterung und Hingabe kennt und sich für eine würdige Sache einsetzt; der, wenn er gewinnt, den Triumph großer Leistung kennt; und der, wenn er scheitert, zumindest scheitert, während er Großes wagt, sodass sein Platz niemals bei den kalten und ängstlichen Seelen sein wird, die weder Sieg noch Niederlage kennen. -Theodore Roosevelt"
    },
    "2025-10-16": {
        "content": " Das größte Abenteuer, das Sie jemals erleben können, ist, das Leben Ihrer Träume zu leben. -Oprah Winfrey"
    },
    "2025-10-17": {
        "content": " Ohne Kampf kann es keinen Fortschritt geben. -Frederick Douglass"
    },
    "2025-10-18": {
        "content": " Ein mit Datum aufgeschriebener Traum wird zum Ziel. Ein in Schritte unterteiltes Ziel wird zum Plan. Ein durch Taten unterstützter Plan lässt Ihre Träume wahr werden. -Greg Reid"
    },
    "2025-10-19": {
        "content": "Tu das Einzige, von dem du glaubst, dass du es nicht kannst. Scheitere. Versuch es noch einmal. Mach es beim zweiten Mal besser. Die einzigen Menschen, die nie stürzen, sind diejenigen, die nie aufs Hochseil steigen. -Oprah Winfrey"
    },
    "2025-10-20": {
        "content": " Erwarten Sie Veränderungen. Analysieren Sie die Landschaft. Nutzen Sie die Chancen. Seien Sie nicht länger die Schachfigur, sondern werden Sie zum Spieler. Sie sind am Zug. -Tony Robbins"
    },
    "2025-10-21": {
        "content": " Du bist frei. Du bist stark. Du bist gut. Du bist Liebe. Du hast einen Wert. Du hast einen Sinn. Alles ist gut. -Esther Hicks"
    },
    "2025-10-22": {
        "content": "Wenn Sie etwas so sehr wollen, dass Sie hinausgehen und dafür kämpfen, Tag und Nacht dafür arbeiten, Ihre Zeit, Ihre Ruhe und Ihren Schlaf dafür opfern, wenn sich alles, wovon Sie träumen und was Sie planen, darauf bezieht und Ihnen das Leben ohne es nutzlos und wertlos erscheint; wenn Sie gerne dafür schwitzen, sich dafür abmühen und dafür planen und all Ihre Angst vor Widerstand verlieren; wenn Sie einfach mit all Ihren Fähigkeiten, Ihrer Kraft und Scharfsinnigkeit, Ihrem Glauben, Ihrer Hoffnung und Ihrem Vertrauen und Ihrer Hartnäckigkeit dem nachgehen, was Sie wollen; wenn weder Kälte noch Armut, Hunger oder Gicht, Krankheit oder Schmerzen an Körper und Geist Sie von dem abhalten können, was Sie wollen; wenn Sie verbissen und grimmig sind und es erreichen, dann werden Sie es mit Gottes Hilfe bekommen. -Berton Braley"
    },
    "2025-10-23": {
        "content": " Selbst wenn Sie auf dem richtigen Weg sind, werden Sie überfahren, wenn Sie einfach nur herumsitzen. -Will Rogers"
    },
    "2025-10-24": {
        "content": " Ich glaube, dass es für gewöhnliche Menschen möglich ist, sich dafür zu entscheiden, außergewöhnlich zu sein. -Elon Musk"
    },
    "2025-10-25": {
        "content": " Laufen lernt man nicht durch das Befolgen von Regeln. Man lernt es durch Tun und Hinfallen. -Richard Branson"
    },
    "2025-10-26": {
        "content": "Hier fehlt das Talent, das ist harte Arbeit. Das ist Besessenheit. Talent existiert nicht, wir sind alle gleich. Du könntest alles sein, wenn du dir die Zeit nimmst. Du wirst es bis ganz nach oben schaffen, und das war’s. Ich bin nicht talentiert, ich bin besessen. -Conor McGregor"
    },
    "2025-10-27": {
        "content": " Ein Traum ist nicht das, was Sie im Schlaf sehen; es ist etwas, das Sie nicht schlafen lässt. -Abdul Kalam"
    },
    "2025-10-28": {
        "content": " Wenn Sie alle Möglichkeiten ausgeschöpft haben, denken Sie daran: Das haben Sie nicht. -Thomas A. Edison"
    },
    "2025-10-29": {
        "content": " Ergreife Chancen und mache Fehler. So wächst du. Schmerz stärkt deinen Mut. Du musst scheitern, um Mut zu üben. -Mary Tyler Moore"
    },
    "2025-10-30": {
        "content": " Worauf Sie sich konzentrieren, das bekommen Sie. -Tony Robbins"
    },
    "2025-10-31": {
        "content": " „Hustle“ ist das wichtigste Wort aller Zeiten. -Gary Vaynerchuk"
    },
    "2025-11-01": {
        "content": " Wenn sie aus schimmeligem Brot Penicillin herstellen können, dann können sie sicher auch etwas aus Ihnen machen. -Muhammad Ali"
    },
    "2025-11-02": {
        "content": " Du wurdest nicht als Gewinner geboren, und du wurdest nicht als Verlierer geboren. Du bist, was du aus dir machst. -Lou Holtz"
    },
    "2025-11-03": {
        "content": " Erfolg ist Ihre Pflicht, Verpflichtung und Verantwortung. -Grant Cardone"
    },
    "2025-11-04": {
        "content": "Es gibt kleine Unterschiede zwischen Menschen, aber diese kleinen Unterschiede machen einen großen Unterschied. Der kleine Unterschied liegt in der Einstellung. Der große Unterschied liegt darin, ob sie positiv oder negativ ist. -W. Clement Stone"
    },
    "2025-11-05": {
        "content": " Führungskräfte müssen nah genug an anderen sein, um eine Beziehung zu ihnen aufzubauen, aber weit genug voraus, um sie zu motivieren. -John C. Maxwell"
    },
    "2025-11-06": {
        "content": " Sag niemals nie, denn Grenzen sind, wie Ängste, oft nur eine Illusion. -Michael Jordan"
    },
    "2025-11-07": {
        "content": " Sie müssen Großes von sich selbst erwarten, bevor Sie es tun können. -Michael Jordan"
    },
    "2025-11-08": {
        "content": " In der Geschäftswelt sind diejenigen Menschen am erfolgreichsten, die das tun, was sie lieben. -Warren Buffett"
    },
    "2025-11-09": {
        "content": " Durch Handeln wird Ihr Zögern ein Ende haben. -Og Mandino"
    },
    "2025-11-10": {
        "content": " Scheitern ist für mich keine Option. Ich stelle mir nur Erfolg vor. -Conor McGregor"
    },
    "2025-11-11": {
        "content": " Erfolg kommt nicht von dem, was Sie gelegentlich tun, sondern von dem, was Sie konsequent tun. -Marie Forleo"
    },
    "2025-11-12": {
        "content": " Selbstvertrauen und harte Arbeit sind die besten Medikamente gegen das Versagen. Sie machen Sie zu einem erfolgreichen Menschen. -Abdul Kalam"
    },
    "2025-11-13": {
        "content": " Wenn Sie wie die Sonne strahlen möchten, müssen Sie zuerst wie die Sonne brennen. -Abdul Kalam"
    },
    "2025-11-14": {
        "content": "Während du da draußen feierst und herumalberst, arbeitet da draußen gleichzeitig jemand hart. Jemand wird schlauer und jemand gewinnt. Vergiss das einfach nicht. -Arnold Schwarzenegger"
    },
    "2025-11-15": {
        "content": " Wenn Sie tun, was Sie immer getan haben, werden Sie bekommen, was Sie immer bekommen haben. -Tony Robbins"
    },
    "2025-11-16": {
        "content": " Fortschritt ist gleich Glück. -Tony Robbins"
    },
    "2025-11-17": {
        "content": " Sie können Ergebnisse oder Ausreden haben. Nicht beides. -Arnold Schwarzenegger"
    },
    "2025-11-18": {
        "content": " Disziplin ist gleich Freiheit. -Jocko Willink"
    },
    "2025-11-19": {
        "content": " Grübeln Sie nicht darüber nach, was schiefgelaufen ist. Konzentrieren Sie sich stattdessen auf die nächsten Schritte. Konzentrieren Sie sich darauf, voranzukommen und die Antwort zu finden. -Denis Waitley"
    },
    "2025-11-20": {
        "content": " Seien Sie der Anführer, den Sie sich gewünscht hätten. -Simon Sinek"
    },
    "2025-11-21": {
        "content": " Meine Einstellung ist, dass ich, wenn Sie mich zu etwas drängen, was Sie für eine Schwäche halten, diese wahrgenommene Schwäche in eine Stärke umwandeln werde. -Michael Jordan"
    },
    "2025-11-22": {
        "content": " Die größere Gefahr für die meisten von uns besteht nicht darin, dass wir uns zu hohe Ziele setzen und sie nicht erreichen, sondern dass wir uns zu niedrige Ziele setzen und sie nicht erreichen. -Michelangelo"
    },
    "2025-11-23": {
        "content": " Jeder hat einen Traum, aber nicht jeder hat die nötige Plackerei. -Eric Thomas"
    },
    "2025-11-24": {
        "content": "Führungspersönlichkeiten werden nicht geboren, sondern gemacht. Sie entstehen durch harte Arbeit, den Preis, den wir alle zahlen müssen, um ein lohnendes Ziel zu erreichen. -Vince Lombardi"
    },
    "2025-11-25": {
        "content": " Wir haben uns entschieden, in diesem Jahrzehnt zum Mond zu fliegen und die anderen Dinge zu tun. Nicht, weil sie einfach sind, sondern weil sie schwierig sind. -John F. Kennedy"
    },
    "2025-11-26": {
        "content": " Der schönste Tag in Ihrem und meinem Leben ist der, an dem wir die volle Verantwortung für unsere Einstellung übernehmen. Das ist der Tag, an dem wir wirklich erwachsen werden. -John C. Maxwell"
    },
    "2025-11-27": {
        "content": " Jedes Mal, wenn Sie jemanden anlächeln, ist dies ein Akt der Liebe, ein Geschenk an diese Person, etwas Schönes. -Mutter Teresa"
    },
    "2025-11-28": {
        "content": " Sei stiller Beobachter deiner Gedanken und deines Verhaltens. Du bist die Ebene des Denkers. Du bist die Stille unter dem mentalen Lärm. Du bist die Liebe und Freude unter dem Schmerz. -Eckhart Tolle"
    },
    "2025-11-29": {
        "content": " Wenn du nicht fliegen kannst, dann laufe. Wenn du nicht rennen kannst, dann geh. Wenn du nicht gehen kannst, dann krieche. Aber was auch immer du tust, du musst weiter vorwärts gehen. -Martin Luther King Jr."
    },
    "2025-11-30": {
        "content": " Vergebung ist keine gelegentliche Handlung, sondern eine konstante Haltung. -Martin Luther King Jr."
    },
    "2025-12-01": {
        "content": " Zu oft unterschätzen wir die Macht einer Berührung, eines Lächelns, eines freundlichen Wortes, eines offenen Ohrs, eines ehrlichen Kompliments oder der kleinsten Geste der Fürsorge, die alle das Potenzial haben, ein Leben zu verändern. -Leo Buscaglia"
    },
    "2025-12-02": {
        "content": "Halte deine Träume am Leben. Um etwas zu erreichen, braucht es Vertrauen und Glauben an sich selbst, Vision, harte Arbeit, Entschlossenheit und Hingabe. Denk daran, dass für diejenigen, die daran glauben, alles möglich ist. -Gail Devers"
    },
    "2025-12-03": {
        "content": " Sport hat die Kraft, die Welt zu verändern. Er hat die Kraft zu inspirieren. Er hat die Kraft, Menschen auf eine Weise zu vereinen, wie es kaum etwas anderes vermag. Er spricht die Jugend in einer Sprache an, die sie versteht. Sport kann Hoffnung schaffen, wo einst nur Verzweiflung herrschte. -Nelson Mandela"
    },
    "2025-12-04": {
        "content": " Bitten Sie um das, was Sie wollen. Glauben Sie, dass Sie es verdienen, und lassen Sie sich dann vom Leben geben. -Louise Hay"
    },
    "2025-12-05": {
        "content": " Lebe bewusst. Gehe bis ans Limit. Höre aufmerksam zu. Achte auf dein Wohlbefinden. Spiele mit Hingabe. Lache. Triff Entscheidungen ohne Reue. Schätze deine Freunde. Lerne weiter. Tu, was du liebst. Lebe, als wäre das alles, was es gibt. -Mary Anne Radmacher"
    },
    "2025-12-06": {
        "content": " Worauf Sie sich konzentrieren, erweitert sich, und wenn Sie sich auf das Gute in Ihrem Leben konzentrieren, schaffen Sie mehr davon. -Oprah Winfrey"
    },
    "2025-12-07": {
        "content": " Du hast Macht über deinen Geist, nicht über äußere Ereignisse. Wenn du dir das bewusst machst, wirst du Kraft finden. -Marcus Aurelius"
    },
    "2025-12-08": {
        "content": "Suchen Sie keine Ausreden dafür, warum Sie es nicht schaffen. Konzentrieren Sie sich auf alle Gründe, warum Sie es schaffen müssen. -Ralph Marston"
    },
    "2025-12-09": {
        "content": " Wo Liebe ist, ist Leben. -Mahatma Gandhi"
    },
    "2025-12-10": {
        "content": " Du musst tanzen, als würde niemand zusehen, lieben, als würde dir nie etwas passieren, singen, als würde niemand zuhören, und leben, als wäre der Himmel auf Erden. -William W. Purkey"
    },
    "2025-12-11": {
        "content": " Erfolg bedeutet, den Sinn des Lebens zu kennen, zu wachsen, um das eigene Potenzial voll auszuschöpfen und Samen zu säen, die anderen nützen. -John C. Maxwell"
    },
    "2025-12-12": {
        "content": " Ein Traum, den Sie alleine träumen, ist nur ein Traum. Ein Traum, den Sie gemeinsam träumen, ist Realität. -John Lennon"
    },
    "2025-12-13": {
        "content": " Das wahre Geheimnis des Lebens besteht darin, sich voll und ganz auf das einzulassen, was man im Hier und Jetzt tut. Und anstatt es Arbeit zu nennen, ist es ein Spiel. -Alan Watts"
    },
    "2025-12-14": {
        "content": " Gestern ist vorbei. Morgen ist noch nicht da. Wir haben nur heute. Lasst uns beginnen. -Mutter Teresa"
    },
    "2025-12-15": {
        "content": " Je mehr Sie Ihr Leben loben und feiern, desto mehr gibt es im Leben zu feiern. -Oprah Winfrey"
    },
    "2025-12-16": {
        "content": "Zweifeln Sie nie daran, dass eine kleine Gruppe nachdenklicher, engagierter Bürger die Welt verändern kann. Tatsächlich ist es das Einzige, was jemals passiert ist. -Margaret Mead"
    },
    "2025-12-17": {
        "content": " Fordern Sie sich selbst heraus, denn niemand sonst wird es für Sie tun. -Anonym"
    },
    "2025-12-18": {
        "content": " Wahre Demut bedeutet nicht, weniger von sich zu halten, sondern weniger an sich zu denken. -CS Lewis"
    },
    "2025-12-19": {
        "content": " Wenn Sie Ihre Meinung ändern können, können Sie Ihr Leben ändern. -William James"
    },
    "2025-12-20": {
        "content": " Konzentrieren Sie sich auf Ihr Ziel, nicht auf das, was Sie fürchten. -Tony Robbins"
    },
    "2025-12-21": {
        "content": " Respektieren Sie sich selbst und andere werden Sie respektieren. -Konfuzius"
    },
    "2025-12-22": {
        "content": " Tun Sie, was Sie können, mit dem, was Sie haben, dort, wo Sie sind. -Theodore Roosevelt"
    },
    "2025-12-23": {
        "content": " Manche Veränderungen sehen auf den ersten Blick negativ aus, aber Sie werden bald erkennen, dass in Ihrem Leben Platz für etwas Neues geschaffen wird. -Eckhart Tolle"
    },
    "2025-12-24": {
        "content": " Wenn Ihre Handlungen andere dazu inspirieren, mehr zu träumen, mehr zu lernen, mehr zu tun und mehr zu werden, sind Sie ein Anführer. -John Quincy Adams"
    },
    "2025-12-25": {
        "content": " Mach dir um nichts Sorgen, alles wird gut. -Bob Marley"
    },
    "2025-12-26": {
        "content": " Träumen Sie groß, bleiben Sie positiv, arbeiten Sie hart und genießen Sie die Reise. -Urijah Faber"
    },
    "2025-12-27": {
        "content": "Sie sind hier, um die Entfaltung des göttlichen Zwecks des Universums zu ermöglichen. So wichtig sind Sie! -Eckhart Tolle"
    },
    "2025-12-28": {
        "content": " Lebe mit Leidenschaft! -Tony Robbins"
    },
    "2025-12-29": {
        "content": " Glauben Sie daran, dass Sie es können, und Sie haben es schon halb geschafft. -Theodore Roosevelt"
    },
    "2025-12-30": {
        "content": " Unser Leben beginnt zu enden, an dem Tag, an dem wir über die wichtigen Dinge schweigen. -Martin Luther King Jr."
    },
    "2025-12-31": {
        "content": " Gemeinsam können wir Großes erreichen. -Mutter Teresa"
    },
    "2026-01-01": {
        "content": " Hart für etwas zu arbeiten, das uns egal ist, nennt man Stress; hart für etwas zu arbeiten, das wir lieben, nennt man Leidenschaft. -Simon Sinek"
    },
    "2026-01-02": {
        "content": " Die Höhle, die Sie nicht betreten möchten, birgt den Schatz, den Sie suchen. -Joseph Campbell"
    },
    "2026-01-03": {
        "content": " Bei Führung geht es um Empathie. Es geht um die Fähigkeit, mit Menschen in Beziehung zu treten und eine Verbindung zu ihnen aufzubauen, um sie zu inspirieren und ihnen Kraft zu geben. -Oprah Winfrey"
    },
    "2026-01-04": {
        "content": " Für den, der es versucht, ist nichts unmöglich. -Alexander der Große"
    },
    "2026-01-05": {
        "content": " Die meisten wichtigen Dinge auf der Welt wurden von Menschen erreicht, die es immer wieder versucht haben, als es scheinbar keine Hoffnung mehr gab. -Dale Carnegie"
    },
    "2026-01-06": {
        "content": " Wir bewegen uns weiter vorwärts, öffnen neue Türen und tun neue Dinge, weil wir neugierig sind und die Neugier uns immer wieder auf neue Wege führt. -Walt Disney"
    },
    "2026-01-07": {
        "content": "Tun Sie, was Sie tun müssen, bis Sie tun können, was Sie tun möchten. -Oprah Winfrey"
    },
    "2026-01-08": {
        "content": " Der Glaube, dass Sie genug sind, gibt Ihnen den Mut, authentisch zu sein. -Brené Brown"
    },
    "2026-01-09": {
        "content": " Es sind unsere Entscheidungen, Harry, die zeigen, wer wir wirklich sind, viel mehr als unsere Fähigkeiten. -JK Rowling"
    },
    "2026-01-10": {
        "content": " Folgen Sie Ihrem Glück und das Universum wird Ihnen Türen öffnen, wo vorher nur Wände waren. -Joseph Campbell"
    },
    "2026-01-11": {
        "content": " Träume sind nicht die, die uns im Schlaf einfallen, sondern Träume sind die, die wir nicht im Schlaf wahr werden lassen. -Abdul Kalam"
    },
    "2026-01-12": {
        "content": " Wagemut bedeutet, den Mut zu haben, verletzlich zu sein. Es bedeutet, sich zu zeigen und gesehen zu werden. Um das zu bitten, was man braucht. Über die eigenen Gefühle zu sprechen. Schwierige Gespräche zu führen. -Brené Brown"
    },
    "2026-01-13": {
        "content": " Du wirst niemals erfolgreich sein, bis du deinen Schmerz in Größe verwandelst, bis du zulässt, dass er dich von dort, wo du bist, dorthin treibt, wo du hingehörst. Hör auf, vor deinem Schmerz davonzulaufen, und akzeptiere ihn. Dein Schmerz wird Teil deines Erfolgs sein, Teil deines Erfolgs. Ich fordere dich heraus, dich selbst zu übertreffen. -Eric Thomas"
    },
    "2026-01-14": {
        "content": "Wir sind, was wir wiederholt tun. Exzellenz ist daher keine Handlung, sondern eine Gewohnheit. -Aristoteles"
    },
    "2026-01-15": {
        "content": " Ein Fluss schneidet sich durch Felsen, nicht aufgrund seiner Kraft, sondern aufgrund seiner Beharrlichkeit. -Jim Watkins"
    },
    "2026-01-16": {
        "content": " Energie und Ausdauer überwinden alles. -Benjamin Franklin"
    },
    "2026-01-17": {
        "content": " Chancen werden normalerweise als harte Arbeit getarnt, sodass die meisten Menschen sie nicht erkennen. -Ann Landers"
    },
    "2026-01-18": {
        "content": " Wenn du nicht fliegen kannst, dann laufe. Wenn du nicht rennen kannst, dann geh. Wenn du nicht gehen kannst, dann krieche. Aber was auch immer du tust, du musst weiter vorwärts gehen. -Martin Luther King Jr."
    },
    "2026-01-19": {
        "content": " Durch Beharrlichkeit sind Ergebnisse vorprogrammiert. -Paramahansa Yogananda"
    },
    "2026-01-20": {
        "content": " Mit gewöhnlichem Talent und außergewöhnlicher Ausdauer sind alle Dinge erreichbar -Thomas Fowell Buxton"
    },
    "2026-01-21": {
        "content": " Unser größter Ruhm besteht nicht darin, niemals zu versagen, sondern jedes Mal wieder aufzustehen, wenn wir versagen. -Ralph Waldo Emerson"
    },
    "2026-01-22": {
        "content": " Erfolg bedeutet, von einem Misserfolg zum nächsten zu stolpern, ohne die Begeisterung zu verlieren. -Winston Churchill"
    },
    "2026-01-23": {
        "content": "Glücklicherweise ist Beharrlichkeit ein großartiger Ersatz für Talent. -Steve Martin"
    },
    "2026-01-24": {
        "content": " Ich glaube fest an Glück und je härter ich arbeite, desto mehr habe ich davon. -Thomas Jefferson"
    },
    "2026-01-25": {
        "content": " Verschieben Sie nur das auf morgen, was Sie auch unter dem Eindruck Ihres Todes unerledigt lassen möchten. -Pablo Picasso"
    },
    "2026-01-26": {
        "content": " Es gibt keine Erfolgsgeheimnisse: Verschwenden Sie keine Zeit damit, danach zu suchen. Erfolg ist das Ergebnis von Perfektion, harter Arbeit, Lernen aus Fehlern, Loyalität gegenüber Ihren Mitarbeitern und Beharrlichkeit. -Colin Powell"
    },
    "2026-01-27": {
        "content": " Wenn Sie vorne sein möchten, dann tun Sie so, als wären Sie hinten. -Lao Tzu"
    },
    "2026-01-28": {
        "content": " Lassen Sie mich Ihnen das Geheimnis verraten, das mich zu meinem Ziel geführt hat: Meine Stärke liegt einzig und allein in meiner Hartnäckigkeit. -Louis Pasteur"
    },
    "2026-01-29": {
        "content": " Nichts auf dieser Welt kann Beharrlichkeit ersetzen. Talent nicht; nichts ist häufiger als erfolglose Menschen mit Talent. Genie nicht; unbelohntes Genie ist fast ein Sprichwort. -Calvin Coolidge"
    },
    "2026-01-30": {
        "content": " Der beste Ausweg ist immer der Durchgang. -Robert Frost"
    },
    "2026-01-31": {
        "content": "Viele der Versager im Leben sind Menschen, die nicht erkannt haben, wie nahe sie dem Erfolg waren, als sie aufgegeben haben. -Thomas A. Edison"
    },
    "2026-02-01": {
        "content": " Wir sind dazu geschaffen, durchzuhalten. So finden wir heraus, wer wir sind. -Tobias Wolff"
    },
    "2026-02-02": {
        "content": " Da ich Bäume kenne, verstehe ich die Bedeutung von Geduld. Da ich Gras kenne, weiß ich Beharrlichkeit zu schätzen. -Hal Borland"
    },
    "2026-02-03": {
        "content": " Tropfendes Wasser höhlt Stein aus, nicht durch Kraft, sondern durch Beharrlichkeit. -Ovid"
    },
    "2026-02-04": {
        "content": " Beharrlichkeit ist sehr wichtig. Sie sollten nicht aufgeben, es sei denn, Sie werden dazu gezwungen. -Elon Musk"
    },
    "2026-02-05": {
        "content": " Glühende Begeisterung, gepaart mit gesundem Menschenverstand und Ausdauer, ist die Eigenschaft, die am häufigsten zum Erfolg führt. -Dale Carnegie"
    },
    "2026-02-06": {
        "content": " Ehrgeiz ist der Weg zum Erfolg. Beharrlichkeit ist das Fahrzeug, mit dem Sie ankommen. -Bill Bradley"
    },
    "2026-02-07": {
        "content": " Konzentrieren Sie sich auf die Lösung, nicht auf das Problem. -Walter Anderson"
    },
    "2026-02-08": {
        "content": " Wenn das Leben Sie niederschlägt, haben Sie zwei Möglichkeiten: liegen bleiben oder aufstehen. -Tom Krause"
    },
    "2026-02-09": {
        "content": "Erfolg ist die Summe kleiner Anstrengungen, die Tag für Tag wiederholt werden. -Robert Collier"
    },
    "2026-02-10": {
        "content": " Ein Traum ist nur ein Traum. Ein Ziel ist ein Traum mit einem Plan und einer Frist. -Harvey MacKay"
    },
    "2026-02-11": {
        "content": " Geben Sie niemals etwas auf, an das Sie keinen Tag lang nicht denken können. -Winston Churchill"
    },
    "2026-02-12": {
        "content": " Diamanten sind nichts anderes als Kohlestücke, die an ihrer Aufgabe haften geblieben sind. -Malcolm S. Forbes"
    },
    "2026-02-13": {
        "content": " Man kann nichts tun, außer Stück für Stück. -Charles Baudelaire"
    },
    "2026-02-14": {
        "content": " Wenn Sie durch die Hölle gehen, machen Sie weiter. -Winston Churchill"
    },
    "2026-02-15": {
        "content": " Der Schlüssel der Beharrlichkeit öffnet alle Türen, die durch Widerstand verschlossen sind. -John Di Lemme"
    },
    "2026-02-16": {
        "content": " Wenn wir uns die erfolgreichsten Menschen der Welt ansehen, ist Beharrlichkeit der gemeinsame Nenner. -Justin Sachs"
    },
    "2026-02-17": {
        "content": " Sie können einen Elefanten Stück für Stück essen. -Mary Kay Ash"
    },
    "2026-02-18": {
        "content": " Ich glaube nicht, dass es eine andere Eigenschaft gibt, die für Erfolg jeglicher Art so wichtig ist wie Beharrlichkeit. Sie überwindet fast alles, sogar die Natur. -John D. Rockefeller"
    },
    "2026-02-19": {
        "content": "Wer eine Vision in die Tat umsetzen möchte, muss 100 % geben und nie aufhören, an seinen Traum zu glauben. -Arnold Schwarzenegger"
    },
    "2026-02-20": {
        "content": " Laufen Sie, wenn Sie können, gehen Sie, wenn es sein muss, kriechen Sie, wenn es sein muss; geben Sie einfach niemals auf. -Dean Karnazes"
    },
    "2026-02-21": {
        "content": " Noch eine Runde weiterzugehen, wenn Sie denken, dass Sie es nicht können – das macht den entscheidenden Unterschied in Ihrem Leben. -Sylvester Stallone"
    },
    "2026-02-22": {
        "content": " Hör mir zu, selbst wenn du verlierst, ist es okay zu verlieren, aber du kannst dich nie damit anfreunden. Du kannst nie zufrieden sein mit einer Niederlage. Wenn du verlierst, muss es weh tun. -Eric Thomas"
    },
    "2026-02-23": {
        "content": " Gehen Sie Ihren Weg weiter, Schritt für Schritt. -Joyce Meyer"
    },
    "2026-02-24": {
        "content": " Wir sollten nicht aufgeben und nicht zulassen, dass uns das Problem besiegt. -Abdul Kalam"
    },
    "2026-02-25": {
        "content": " Durch Ausdauer siegen wir. -Ernest Shackleton"
    },
    "2026-02-26": {
        "content": "Die Mauern sind aus einem bestimmten Grund da. Sie sind nicht da, um uns fernzuhalten. Sie sind da, um uns die Möglichkeit zu geben, zu zeigen, wie sehr wir etwas wollen. Denn sie sind da, um diejenigen aufzuhalten, die es nicht stark genug wollen. Sie sind da, um die anderen aufzuhalten. -Randy Pausch"
    },
    "2026-02-27": {
        "content": " Erfolg hängt fast ausschließlich von Tatkraft und Ausdauer ab. Die zusätzliche Energie, die für einen weiteren Versuch oder einen anderen Ansatz erforderlich ist, ist das Geheimnis des Erfolgs. -Denis Waitley"
    },
    "2026-02-28": {
        "content": " Ich hatte es bis hierher geschafft und weigerte mich aufzugeben, weil ich mein ganzes Leben lang jedes Rennen zu Ende gebracht hatte. -Louis Zamperini"
    },
    "2026-03-01": {
        "content": " Überleben lässt sich in drei Worten zusammenfassen: Gib niemals auf. Das ist der Kern der Sache. Versuche es einfach weiter. -Bear Grylls"
    },
    "2026-03-02": {
        "content": "Schluss damit. Keine Ausreden mehr. Schluss mit: „Ich fange morgen an.“ Schluss mit: „Nur dieses eine Mal.“ Schluss mit dem Akzeptieren der Schwächen meines eigenen Willens. Schluss mit dem einfachen Weg. Schluss mit dem Nachgeben gegenüber ungesunden oder unproduktiven Gedanken, die mir durch den Kopf gehen. -Jocko Willink"
    },
    "2026-03-03": {
        "content": " Mit kleinen Schlägen werden große Eichen gefällt. -Benjamin Franklin"
    },
    "2026-03-04": {
        "content": " Ich bin bereit.“ „Ich bin darauf programmiert zu gewinnen.“ „Ich schaffe das.“ „Ich nehme die Ungewissheit an.“ „Ich bin nicht meine Gedanken, ich bin, was ich tue.“ „Ich bin unerbittlich.“ „Ich erwarte nichts und akzeptiere alles.“ -Gary John Bishop"
    },
    "2026-03-05": {
        "content": " Ich habe nicht 700 Mal versagt. Ich habe nicht ein einziges Mal versagt. Ich habe bewiesen, dass diese 700 Wege nicht funktionieren. Wenn ich die Wege eliminiert habe, die nicht funktionieren, werde ich den Weg finden, der funktioniert. -Thomas A. Edison"
    },
    "2026-03-06": {
        "content": " GRIT steht für Mut, Belastbarkeit, Fleiß und Hartnäckigkeit. GRIT ist die Fähigkeit, sich zu konzentrieren, entschlossen zu bleiben, angesichts einer Herausforderung optimistisch zu bleiben und einfach härter zu arbeiten als jeder andere. -Linda Kaplan Thaler"
    },
    "2026-03-07": {
        "content": "Ich glaube, mein Geheimnis ist, dass es keine Abkürzungen für harte Arbeit, Entschlossenheit und die Einstellung „Gib nicht auf“ gibt. -Jerry Rice"
    },
    "2026-03-08": {
        "content": " Hören Sie nie auf zu kämpfen, bis Sie an Ihrem Bestimmungsort angekommen sind – das heißt, bei Ihrem einzigartigen Ich. Setzen Sie sich ein Ziel im Leben, eignen Sie sich kontinuierlich Wissen an, arbeiten Sie hart und haben Sie Ausdauer, um das großartige Leben zu verwirklichen. -Abdul Kalam"
    },
    "2026-03-09": {
        "content": " Hören Sie nicht auf, wenn Sie müde sind. Hören Sie auf, wenn Sie fertig sind. -David Goggins"
    },
    "2026-03-10": {
        "content": " Beurteilen Sie mich nicht nach meinen Erfolgen, sondern danach, wie oft ich hingefallen und wieder aufgestanden bin. -Nelson Mandela"
    },
    "2026-03-11": {
        "content": " Was heute nicht begonnen wird, wird morgen nie beendet sein. -Johann Wolfgang von Goethe"
    },
    "2026-03-12": {
        "content": " Wenn Sie hundert Kurzgeschichten schreiben und alle schlecht sind, heißt das nicht, dass Sie versagt haben. Sie versagen erst, wenn Sie mit dem Schreiben aufhören. -Ray Bradbury"
    },
    "2026-03-13": {
        "content": " Der Meister ist öfter gescheitert, als der Anfänger es überhaupt versucht hat. -Stephen McCranie"
    },
    "2026-03-14": {
        "content": " Zum Teufel mit den Umständen, ich schaffe Gelegenheiten. -Bruce Lee"
    },
    "2026-03-15": {
        "content": "Das Einzige, was schlimmer ist, als etwas anzufangen und zu scheitern, ist, nichts anzufangen. -Seth Godin"
    },
    "2026-03-16": {
        "content": " Verschieben Sie nie auf morgen, was Sie heute tun können. -Benjamin Franklin"
    },
    "2026-03-17": {
        "content": " Durch Beharrlichkeit erreichte die Schnecke die Arche. -Charles H. Spurgeon"
    },
    "2026-03-18": {
        "content": " Denken Sie daran: Hoffnung ist eine gute Sache, vielleicht sogar das Beste, und nichts Gutes stirbt jemals. -Stephen King"
    },
    "2026-03-19": {
        "content": " Unternehmer hören nicht auf, wenn sie müde sind. Wir hören auf, wenn wir fertig sind. -Robert T. Kiyosaki"
    },
    "2026-03-20": {
        "content": " Nur Beharrlichkeit und Entschlossenheit sind allmächtig. -Calvin Coolidge"
    },
    "2026-03-21": {
        "content": " Lähmen Sie den Widerstand durch Beharrlichkeit. -Woody Hayes"
    },
    "2026-03-22": {
        "content": " Erfolg gehört nie jemandem, er wird gemietet, und die Miete ist jeden Tag fällig. -Rory Vaden"
    },
    "2026-03-23": {
        "content": " Erfolg ist kein Zufall. Er erfordert harte Arbeit, Ausdauer, Lernen, Studieren, Opferbereitschaft und vor allem Liebe zu dem, was man tut oder lernt. -Pelé"
    },
    "2026-03-24": {
        "content": " An der harten Arbeit führt kein Weg vorbei. Nehmen Sie sie an. -Roger Federer"
    },
    "2026-03-25": {
        "content": " Ein Traum wird nicht durch Zauberei Wirklichkeit; es erfordert Schweiß, Entschlossenheit und harte Arbeit. -Colin Powell"
    },
    "2026-03-26": {
        "content": "Lernen erschöpft den Geist nie. -Leonardo da Vinci"
    },
    "2026-03-27": {
        "content": " Ich höre und vergesse. Ich sehe und erinnere mich. Ich tue und verstehe. -Konfuzius"
    },
    "2026-03-28": {
        "content": " Wer noch nie einen Fehler gemacht hat, hat noch nie etwas Neues ausprobiert. -Albert Einstein"
    },
    "2026-03-29": {
        "content": " Versuchen Sie, über alles etwas und über etwas alles zu lernen. -Thomas Henry Huxley"
    },
    "2026-03-30": {
        "content": " Der Mensch lernt nur auf zwei Arten: einmal durch Lesen und einmal durch den Umgang mit intelligenteren Menschen. -Will Rogers"
    },
    "2026-03-31": {
        "content": " Sie verstehen nichts, bis Sie es auf mehr als eine Weise lernen. -Marvin Minsky"
    },
    "2026-04-01": {
        "content": " Erzähl es mir und ich vergesse es. Lehre mich und ich erinnere mich vielleicht. Beteilige mich und ich lerne. -Benjamin Franklin"
    },
    "2026-04-02": {
        "content": " Wenn Sie Ihre Erfolgsquote erhöhen möchten, verdoppeln Sie Ihre Misserfolgsquote. -Thomas J. Watson"
    },
    "2026-04-03": {
        "content": " Intelligenz ist das, was Sie einsetzen, wenn Sie nicht wissen, was Sie tun sollen. -Jean Piaget"
    },
    "2026-04-04": {
        "content": " Die Analphabeten des 21. Jahrhunderts werden nicht diejenigen sein, die nicht lesen und schreiben können, sondern diejenigen, die nicht lernen, verlernen und neu lernen können. -Alvin Toffler"
    },
    "2026-04-05": {
        "content": "Es ist das, was wir bereits wissen, das uns oft am Lernen hindert. -Claude Bernard"
    },
    "2026-04-06": {
        "content": " Mathematik ist die Sprache, mit der Gott das Universum geschrieben hat. -Galileo Galilei"
    },
    "2026-04-07": {
        "content": " Der ganze Zweck der Bildung besteht darin, Spiegel in Fenster zu verwandeln. -Sydney J. Harris"
    },
    "2026-04-08": {
        "content": " Ich habe keine Angst vor Stürmen, denn ich lerne, wie ich mein Schiff segele. -Louisa May Alcott"
    },
    "2026-04-09": {
        "content": " Gebildet ist nur derjenige, der gelernt hat, wie man lernt und sich verändert. -Carl R. Rogers"
    },
    "2026-04-10": {
        "content": " Ich habe noch nie einen Menschen getroffen, der so unwissend war, dass ich nichts von ihm hätte lernen können. -Galileo Galilei"
    },
    "2026-04-11": {
        "content": " Nichts verschwindet, bis es uns das beigebracht hat, was wir wissen müssen. -Pema Chödrön"
    },
    "2026-04-12": {
        "content": " Übung macht den Meister. Nach langem Üben wird unsere Arbeit natürlich, geschickt, schnell und stetig. -Bruce Lee"
    },
    "2026-04-13": {
        "content": " Wenn Sie sprechen, wiederholen Sie nur etwas, das Sie bereits wissen. Aber wenn Sie zuhören, lernen Sie vielleicht etwas Neues. -Dalai Lama XIV"
    },
    "2026-04-14": {
        "content": " Streben Sie nach Fortschritt, nicht nach Perfektion. -Anonym"
    },
    "2026-04-15": {
        "content": "Ich tue immer das, was ich noch nicht kann, um zu lernen, wie es geht. -Vincent van Gogh"
    },
    "2026-04-16": {
        "content": " Wissen macht einen Menschen untauglich, ein Sklave zu sein. -Frederick Douglass"
    },
    "2026-04-17": {
        "content": " Ich habe sehr früh den Unterschied gelernt, ob man den Namen einer Sache kennt oder etwas weiß. -Richard P. Feynman"
    },
    "2026-04-18": {
        "content": " Die Fähigkeit zu lernen ist eine Gabe; die Fähigkeit zu lernen ist eine Fertigkeit; die Bereitschaft zu lernen ist eine Entscheidung. -Brian Herbert"
    },
    "2026-04-19": {
        "content": " Lernen Sie alles, was Sie können, wann immer Sie können, von jedem, von dem Sie können – es wird immer eine Zeit kommen, in der Sie dankbar dafür sein werden. -Sarah Caldwell"
    },
    "2026-04-20": {
        "content": " Ich halte nicht viel von einem Mann, der heute nicht weiser ist als gestern. -Abraham Lincoln"
    },
    "2026-04-21": {
        "content": " Der Schlüssel zum Erfolg liegt in der Hingabe zum lebenslangen Lernen. -Stephen R. Covey"
    },
    "2026-04-22": {
        "content": " Seien Sie leidenschaftlich und mutig. Lernen Sie immer weiter. Wenn Sie nicht lernen, hören Sie auf, nützliche Dinge zu tun. -Satya Nadella"
    },
    "2026-04-23": {
        "content": "Die höchste Aktivität, die ein Mensch erreichen kann, ist das Lernen zum Verstehen, denn Verstehen bedeutet Freiheit. -Baruch Spinoza"
    },
    "2026-04-24": {
        "content": " Wenn Sie nicht ständig dazulernen, werden andere an Ihnen vorbeiziehen. Temperament allein reicht nicht aus – Sie brauchen viel Neugier über einen langen, langen Zeitraum. -Charlie Munger"
    },
    "2026-04-25": {
        "content": " Eine lernende Organisation ist eine Organisation, die ihre Kapazitäten zur Gestaltung ihrer Zukunft kontinuierlich erweitert. -Peter Senge"
    },
    "2026-04-26": {
        "content": " Der Tag, an dem Sie aufhören zu lernen, ist der Tag, an dem Sie zu verfallen beginnen. -Isaac Asimov"
    },
    "2026-04-27": {
        "content": " Lernen ist ein Schmuckstück im Wohlstand, ein Zufluchtsort in der Not und eine Vorsorge im Alter. -Aristoteles"
    },
    "2026-04-28": {
        "content": " Alle Führungskräfte lernen. Sobald man aufhört zu lernen, hört man auf zu führen. Ich lerne so viel ich kann, von so vielen Menschen wie möglich, so oft ich kann. -Rick Warren"
    },
    "2026-04-29": {
        "content": " Um schwierige Dinge schnell zu lernen, müssen Sie sich intensiv konzentrieren und dürfen sich nicht ablenken lassen. Lernen ist also ein Akt intensiver Arbeit. -Cal Newport"
    },
    "2026-04-30": {
        "content": " Jeder Dummkopf kann es wissen. Es geht darum, es zu verstehen. -Albert Einstein"
    },
    "2026-05-01": {
        "content": "Versuchen Sie jeden Tag, ein bisschen weiser zu sein als beim Aufwachen. -Charlie Munger"
    },
    "2026-05-02": {
        "content": " Investieren Sie in sich selbst, in Ihre Ausbildung. Es gibt nichts Besseres. -Sylvia Porter"
    },
    "2026-05-03": {
        "content": " Die Selbstbildung bereitet mir immer wieder Freude, denn je mehr ich weiß, desto erfüllter ist mein Leben und desto mehr schätze ich meine eigene Existenz. -Isaac Asimov"
    },
    "2026-05-04": {
        "content": " Sie können Hilfe von Lehrern bekommen, aber Sie müssen viel selbst lernen, indem Sie allein in einem Raum sitzen. -Dr. Seuss"
    },
    "2026-05-05": {
        "content": " Lernen geschieht, wenn jemand lernen möchte, nicht, wenn jemand lehren möchte. -Roger Schank"
    },
    "2026-05-06": {
        "content": " Eine Person kann einer anderen Person nicht direkt etwas beibringen; sie kann lediglich das Lernen einer anderen Person erleichtern. -Carl R. Rogers"
    },
    "2026-05-07": {
        "content": " Lernen ist nicht verpflichtend, sondern freiwillig. Verbesserung ist nicht verpflichtend, sondern freiwillig. Aber um zu überleben, müssen wir lernen. -W. Edwards Deming"
    },
    "2026-05-08": {
        "content": " Ich tue immer das, was ich nicht kann, damit ich lerne, wie es geht. -Pablo Picasso"
    },
    "2026-05-09": {
        "content": "Kein Dieb, egal wie geschickt er ist, kann jemandem sein Wissen rauben, und deshalb ist Wissen der beste und sicherste Schatz, den man erwerben kann. -L. Frank Baum"
    },
    "2026-05-10": {
        "content": " Ich glaube, das ist der beste Ratschlag überhaupt: Denken Sie ständig darüber nach, wie Sie die Dinge besser machen könnten, und stellen Sie sich selbst in Frage. -Elon Musk"
    },
    "2026-05-11": {
        "content": " Ein weiser Mensch kann aus einer dummen Frage mehr lernen als ein Narr aus einer weisen Antwort. -Bruce Lee"
    },
    "2026-05-12": {
        "content": " Wenn ich weiter geblickt habe, dann deshalb, weil ich auf den Schultern von Riesen stehe. -Isaac Newton"
    },
    "2026-05-13": {
        "content": " Was wir wissen, ist ein Tropfen, was wir nicht wissen, ist ein Ozean. -Isaac Newton"
    },
    "2026-05-14": {
        "content": " Das Schöne am Lernen ist, dass es Ihnen niemand nehmen kann. -BB König"
    },
    "2026-05-15": {
        "content": " Wenn Sie Schriftsteller werden möchten, müssen Sie vor allem zwei Dinge tun: viel lesen und viel schreiben. -Stephen King"
    },
    "2026-05-16": {
        "content": " Wiederholung ist die Mutter der Geschicklichkeit. -Tony Robbins"
    },
    "2026-05-17": {
        "content": " Staunen ist der Anfang der Weisheit. -Sokrates"
    },
    "2026-05-18": {
        "content": " Wenn Sie einen Fehler machen und ihn nicht korrigieren, wird dies als Fehler bezeichnet. -Konfuzius"
    },
    "2026-05-19": {
        "content": " Der Zweck der Bildung besteht darin, einen leeren Geist durch einen offenen zu ersetzen. -Malcolm S. Forbes"
    },
    "2026-05-20": {
        "content": "Im Leben gibt es nichts zu fürchten, man muss es nur verstehen. Jetzt ist es an der Zeit, mehr zu verstehen, damit wir weniger Angst haben. -Marie Curie"
    },
    "2026-05-21": {
        "content": " Wenn Sie gefragt werden, ob Sie eine Aufgabe erledigen können, sagen Sie: „Natürlich kann ich das!“. Dann legen Sie los und finden Sie heraus, wie es geht. -Theodore Roosevelt"
    },
    "2026-05-22": {
        "content": " Wir alle brauchen Menschen, die uns Feedback geben. So verbessern wir uns. -Bill Gates"
    },
    "2026-05-23": {
        "content": " Bildung ist der Schlüssel zur Welt, ein Pass zur Freiheit. -Oprah Winfrey"
    },
    "2026-05-24": {
        "content": " Alles beginnt mit einer Idee. -Earl Nightingale"
    },
    "2026-05-25": {
        "content": " Die beste Investition, die Sie tätigen können, ist die in sich selbst. -Warren Buffett"
    },
    "2026-05-26": {
        "content": " Es geht nicht um Geld oder Beziehungen. Es geht um die Bereitschaft, mehr zu arbeiten und mehr zu lernen als alle anderen. -Mark Cuban"
    },
    "2026-05-27": {
        "content": " Lernen Sie Ihr Leben lang, wie man lebt. -Seneca"
    },
    "2026-05-28": {
        "content": " Um zu lernen, erfolgreich zu sein, müssen Sie zuerst lernen, zu scheitern. -Michael Jordan"
    },
    "2026-05-29": {
        "content": " Verschwenden Sie keinen guten Fehler, lernen Sie daraus. -Robert T. Kiyosaki"
    },
    "2026-05-30": {
        "content": "Um Wissen zu erlangen, muss man studieren; um Weisheit zu erlangen, muss man beobachten. -Marilyn Vos Savant"
    },
    "2026-05-31": {
        "content": " Man lebt und lernt. Auf jeden Fall lebt man. -Douglas Adams"
    },
    "2026-06-01": {
        "content": " Geduld ist der Begleiter der Weisheit. - Heiliger Augustinus"
    },
    "2026-06-02": {
        "content": " Ich weiß nur eines, und zwar, dass ich nichts weiß. -Sokrates"
    },
    "2026-06-03": {
        "content": " Weisheit kommt aus Erfahrung. Erfahrung ist oft das Ergebnis eines Mangels an Weisheit. -Terry Pratchett"
    },
    "2026-06-04": {
        "content": " Wir können unseren Fortschritt am Mut unserer Fragen und der Tiefe unserer Antworten messen, an unserer Bereitschaft, das zu akzeptieren, was wahr ist, statt das, was sich gut anfühlt. -Carl Sagan"
    },
    "2026-06-05": {
        "content": " Ich hätte lieber Fragen, die nicht beantwortet werden können, als Antworten, die nicht hinterfragt werden können. -Richard P. Feynman"
    },
    "2026-06-06": {
        "content": " Ich bin immer bereit zu lernen, auch wenn es mir nicht immer gefällt, wenn mir etwas beigebracht wird. -Winston Churchill"
    },
    "2026-06-07": {
        "content": " Wer die Praxis ohne Theorie liebt, ist wie der Seemann, der ohne Ruder und Kompass an Bord eines Schiffes geht und nie weiß, wohin er steuern kann. -Leonardo da Vinci"
    },
    "2026-06-08": {
        "content": " Es ist besser zu erschaffen als zu lernen. Schaffen ist die Essenz des Lebens. -Julius Caesar"
    },
    "2026-06-09": {
        "content": "Was die Hand tut, merkt sich der Verstand. -Maria Montessori"
    },
    "2026-06-10": {
        "content": " Gehen Sie immer durchs Leben, als ob Sie etwas Neues lernen müssten, und das werden Sie auch. -Vernon Howard"
    },
    "2026-06-11": {
        "content": " Ein Misserfolg ist ein Erfolg, wenn wir daraus lernen. -Malcolm S. Forbes"
    },
    "2026-06-12": {
        "content": " Bildung ist der beste Freund. Ein gebildeter Mensch wird überall respektiert. Bildung schlägt Schönheit und Jugend. -Chanakya"
    },
    "2026-06-13": {
        "content": " Denken Sie nicht, dass das, was für Sie schwer zu meistern ist, für den Menschen unmöglich ist. Aber wenn etwas für den Menschen möglich ist, dann betrachten Sie es als in Ihrer Reichweite. -Marcus Aurelius"
    },
    "2026-06-14": {
        "content": " Lernen ist ein ständiger Entdeckungsprozess – ein Prozess ohne Ende. -Bruce Lee"
    },
    "2026-06-15": {
        "content": " Unwissenheit ist nicht so sehr eine Schande, sondern vielmehr die mangelnde Lernbereitschaft. -Benjamin Franklin"
    },
    "2026-06-16": {
        "content": " Ich bin davon überzeugt, dass Wissen Macht ist – um die Vergangenheit zu überwinden, unsere eigene Situation zu ändern, neue Hindernisse zu überwinden und bessere Entscheidungen zu treffen. -Ben Carson"
    },
    "2026-06-17": {
        "content": " Beim Einatmen beruhige ich Körper und Geist. Beim Ausatmen lächle ich. Ich verweile im gegenwärtigen Moment und weiß, dass dies der einzige Moment ist. -Thich Nhat Hanh"
    },
    "2026-06-18": {
        "content": "Wenn Sie meinen, Sie seien zu klein, um etwas zu bewirken, versuchen Sie, mit einer Mücke zu schlafen. -Dalai Lama XIV"
    },
    "2026-06-19": {
        "content": " Zu oft unterschätzen wir die Macht einer Berührung, eines Lächelns, eines freundlichen Wortes, eines offenen Ohrs, eines ehrlichen Kompliments oder der kleinsten Geste der Fürsorge, die alle das Potenzial haben, ein Leben zu verändern. -Leo Buscaglia"
    },
    "2026-06-20": {
        "content": " Wie wir unsere Tage verbringen, bestimmt natürlich auch, wie wir unser Leben verbringen. -Annie Dillard"
    },
    "2026-06-21": {
        "content": " Pflegen Sie Ihren Geist mit großartigen Gedanken, denn Sie werden nie höher hinauskommen, als Sie denken. -Benjamin Disraeli"
    },
    "2026-06-22": {
        "content": " Laufen lernt man nicht durch das Befolgen von Regeln. Man lernt es durch Tun und Hinfallen. -Richard Branson"
    },
    "2026-06-23": {
        "content": " Es ist unmöglich, zu leben, ohne bei etwas zu scheitern, es sei denn, man lebt so vorsichtig, dass man genauso gut gar nicht gelebt haben könnte; in diesem Fall scheitert man automatisch. -JK Rowling"
    },
    "2026-06-24": {
        "content": " Wenn du glücklich sein willst, dann sei es. -Leo Tolstoi"
    },
    "2026-06-25": {
        "content": " Niemand kann mir ohne meine Erlaubnis wehtun. -Mahatma Gandhi"
    },
    "2026-06-26": {
        "content": " Wenn ich loslasse, was ich bin, werde ich, was ich sein könnte. -Lao Tzu"
    },
    "2026-06-27": {
        "content": "Der Grund, warum wir mit Unsicherheit kämpfen, liegt darin, dass wir unsere Blicke hinter die Kulissen mit den Höhepunkten aller anderen vergleichen. -Steven Furtick"
    },
    "2026-06-28": {
        "content": " Denken Sie daran: Heute ist das Morgen, um das Sie sich gestern Sorgen gemacht haben. -Dale Carnegie"
    },
    "2026-06-29": {
        "content": " Wir müssen bereit sein, das Leben, das wir geplant haben, loszulassen, um das Leben zu haben, das auf uns wartet. -Joseph Campbell"
    },
    "2026-06-30": {
        "content": " Hör auf wegzugehen, und du wirst ankommen. Hör auf zu suchen, und du wirst sehen. Hör auf wegzulaufen, und du wirst gefunden werden. -Lao Tzu"
    },
    "2026-07-01": {
        "content": " Ein Team ist nicht eine Gruppe von Menschen, die zusammenarbeiten. Ein Team ist eine Gruppe von Menschen, die einander vertrauen. -Simon Sinek"
    },
    "2026-07-02": {
        "content": " Ständiger Optimismus ist ein Kraftmultiplikator. -Colin Powell"
    },
    "2026-07-03": {
        "content": " Wenn Sie damit zufrieden sind, einfach Sie selbst zu sein und sich nicht mit anderen zu vergleichen oder zu konkurrieren, wird jeder Sie respektieren. -Lao Tzu"
    },
    "2026-07-04": {
        "content": " Berechnen Sie Ihr Alter anhand Ihrer Freunde, nicht anhand Ihrer Jahre. Berechnen Sie Ihr Leben anhand Ihres Lächelns, nicht anhand Ihrer Tränen. -John Lennon"
    },
    "2026-07-05": {
        "content": " Geben Sie den Menschen, die Sie lieben, Flügel zum Fliegen, geben Sie ihnen Wurzeln zum Wiederkehren und einen Grund zum Bleiben. -Dalai Lama XIV"
    },
    "2026-07-06": {
        "content": " Ausdauer und Mut haben zu allen Zeiten Wunder bewirkt. -George Washington"
    },
    "2026-07-07": {
        "content": "Teilen Sie Ihr Wissen. Es ist ein Weg, Unsterblichkeit zu erlangen. -Dalai Lama XIV"
    },
    "2026-07-08": {
        "content": " Wir sind für den Kosmos eine Möglichkeit, sich selbst zu erkennen. -Carl Sagan"
    },
    "2026-07-09": {
        "content": " Ein guter Lehrer kann Hoffnung wecken, die Fantasie anregen und die Liebe zum Lernen vermitteln. -Brad Henry"
    },
    "2026-07-10": {
        "content": " Eine der größten Entdeckungen und Überraschungen, die ein Mensch machen kann, ist die Erkenntnis, dass er Dinge tun kann, von denen er befürchtet hatte, sie nicht tun zu können. -Henry Ford"
    },
    "2026-07-11": {
        "content": " Wann haben Sie das letzte Mal etwas zum ersten Mal getan? -John C. Maxwell"
    },
    "2026-07-12": {
        "content": " Wenn Sie nicht dabei sind, die Person zu werden, die Sie sein möchten, sind Sie automatisch dabei, die Person zu werden, die Sie nicht sein möchten. -Dale Carnegie"
    },
    "2026-07-13": {
        "content": " Das Glück ist mit den Mutigen. -Lateinisches Sprichwort"
    },
    "2026-07-14": {
        "content": " Erfolg ist nicht der Schlüssel zum Glück. Glück ist der Schlüssel zum Erfolg. Wenn du liebst, was du tust, wirst du erfolgreich sein. -Albert Schweitzer"
    },
    "2026-07-15": {
        "content": " Gewinnen Sie nicht die Welt und verlieren Sie Ihre Seele. Weisheit ist besser als Silber oder Gold. -Bob Marley"
    },
    "2026-07-16": {
        "content": " Beginnen Sie sofort zu leben und betrachten Sie jeden einzelnen Tag als ein einzelnes Leben. -Seneca"
    },
    "2026-07-17": {
        "content": "Sofern sich niemand wie Sie wirklich darum kümmert, wird sich nichts bessern. Das wird es nicht. -Dr. Seuss"
    },
    "2026-07-18": {
        "content": " Sie wussten nicht, dass es unmöglich war, also haben sie es getan. -Mark Twain"
    },
    "2026-07-19": {
        "content": " Ich kann Dinge tun, die Sie nicht können, Sie können Dinge tun, die ich nicht kann; gemeinsam können wir Großes erreichen. -Mutter Teresa"
    },
    "2026-07-20": {
        "content": " Das Einzige, was wir fürchten müssen, ist die Furcht selbst. -Franklin D. Roosevelt"
    },
    "2026-07-21": {
        "content": " Ohne Begeisterung wurde nie etwas Großes erreicht. -Ralph Waldo Emerson"
    },
    "2026-07-22": {
        "content": " Nur Mut, mein Herz. -CS Lewis"
    },
    "2026-07-23": {
        "content": " Der einzige Weg, Veränderungen zu verstehen, besteht darin, sich darauf einzulassen, sich mit ihnen zu bewegen und sich dem Tanz anzuschließen. -Alan Watts"
    },
    "2026-07-24": {
        "content": " Wo Aufmerksamkeit hingeht, fließt Energie und es zeigen sich Ergebnisse. -T. Harv Eker"
    },
    "2026-07-25": {
        "content": " Schmerz ist vorübergehend. Er kann eine Minute, eine Stunde, einen Tag oder ein Jahr dauern, aber irgendwann lässt er nach und etwas anderes nimmt seinen Platz ein. Wenn ich jedoch aufhöre, bleibt er für immer. -Lance Armstrong"
    },
    "2026-07-26": {
        "content": " Bei jedem Spaziergang in der Natur erhält man weit mehr, als man sucht. -John Muir"
    },
    "2026-07-27": {
        "content": "Gewinner sind nicht diejenigen, die nie scheitern, sondern diejenigen, die nie aufgeben. -Edwin Louis Cole"
    },
    "2026-07-28": {
        "content": " Anstatt die Dunkelheit zu bekämpfen, bringen Sie das Licht herein. -Eckhart Tolle"
    },
    "2026-07-29": {
        "content": " Seien Sie furchtlos bei der Suche nach dem, was Ihre Seele entflammt. -Jennifer Lee"
    },
    "2026-07-30": {
        "content": " Wenn Menschen dich verlassen, lass sie gehen. Dein Schicksal ist nie an jemanden gebunden, der dich verlässt, und das bedeutet nicht, dass es sich um schlechte Menschen handelt. Es bedeutet nur, dass ihr Teil in deiner Geschichte vorbei ist. -TD Jakes"
    },
    "2026-07-31": {
        "content": " Führung ist die Fähigkeit, Visionen in die Realität umzusetzen. -Warren G. Bennis"
    },
    "2026-08-01": {
        "content": " Glaube bedeutet, zu glauben, was man nicht sieht; die Belohnung für diesen Glauben besteht darin, zu sehen, was man glaubt. - Heiliger Augustinus"
    },
    "2026-08-02": {
        "content": " Nichts ist unmöglich, es sei denn, Sie glauben, dass es so ist. -Paramahansa Yogananda"
    },
    "2026-08-03": {
        "content": " Das Einzige, was schlimmer ist, als blind zu sein, ist, sehen zu können, aber keine Vision zu haben. -Helen Keller"
    },
    "2026-08-04": {
        "content": " Alles hat seine Schönheit, aber nicht jeder sieht sie. -Konfuzius"
    },
    "2026-08-05": {
        "content": " Gott spricht in der Stille des Herzens. -Mutter Teresa"
    },
    "2026-08-06": {
        "content": "Hoffnung ist das Ding mit Federn, das in der Seele nistet – und die Melodie ohne Worte singt – und niemals aufhört. -Emily Dickinson"
    },
    "2026-08-07": {
        "content": " Wie viele heilige Worte Sie auch lesen oder aussprechen, was nützen sie Ihnen, wenn Sie nicht danach handeln? -Buddha"
    },
    "2026-08-08": {
        "content": " Und übrigens: Über alles im Leben lässt sich schreiben, wenn man den Mut dazu und die Fantasie zum Improvisieren hat. Der schlimmste Feind der Kreativität sind Selbstzweifel. -Sylvia Plath"
    },
    "2026-08-09": {
        "content": " Nichts, was wir tun, kann die Vergangenheit ändern, aber alles, was wir tun, ändert die Zukunft. -Ashleigh Brilliant"
    },
    "2026-08-10": {
        "content": " Führung ist eine Entscheidung. Sie ist kein Rang. -Simon Sinek"
    },
    "2026-08-11": {
        "content": " Alles wird gut, und alles wird gut, und alles wird gut. -Julian von Norwich"
    },
    "2026-08-12": {
        "content": " Jeder von uns ist aus kosmischer Sicht wertvoll. Wenn ein Mensch anderer Meinung ist als du, lass ihn leben. In hundert Milliarden Galaxien wirst du keinen anderen finden. -Carl Sagan"
    },
    "2026-08-13": {
        "content": " Intelligenz plus Charakter – das ist das Ziel wahrer Bildung. -Martin Luther King Jr."
    },
    "2026-08-14": {
        "content": "Je mehr Sie sich in etwas verlieren, das größer ist als Sie selbst, desto mehr Energie werden Sie haben. -Norman Vincent Peale"
    },
    "2026-08-15": {
        "content": " Wenn Sie die Grundlagen beherrschen, wird sich das Niveau Ihrer gesamten Tätigkeit steigern -Michael Jordan"
    },
    "2026-08-16": {
        "content": " Sie können überhaupt nicht leben, wenn Sie nicht jetzt voll leben können. -Alan Watts"
    },
    "2026-08-17": {
        "content": " Denken Sie daran, dass es manchmal ein großer Glücksfall ist, nicht das zu bekommen, was Sie wollen. -Dalai Lama XIV"
    },
    "2026-08-18": {
        "content": " Geben Sie Ihr Bestes und entspannen Sie sich dann. Lassen Sie die Dinge ihren natürlichen Lauf nehmen, anstatt sie zu erzwingen. -Paramahansa Yogananda"
    },
    "2026-08-19": {
        "content": " Sie sind ein unendliches spirituelles Wesen, das eine vorübergehende menschliche Erfahrung macht. -Wayne W. Dyer"
    },
    "2026-08-20": {
        "content": " Sie müssen träumen, bevor Ihre Träume wahr werden können. -Abdul Kalam"
    },
    "2026-08-21": {
        "content": " Beschütze vor allem dein Herz, denn alles, was du tust, entspringt ihm. -Solomon"
    },
    "2026-08-22": {
        "content": " Beim Schreiben kann ich alles abschütteln, meine Sorgen verschwinden, mein Mut wird neu geboren. -Anne Frank"
    },
    "2026-08-23": {
        "content": " Das Ziel ist nicht, am Ende perfekt zu sein. Das Ziel ist, heute besser zu sein. -Simon Sinek"
    },
    "2026-08-24": {
        "content": " Gehen Sie selbstbewusst in die Richtung Ihrer Träume. Leben Sie das Leben, das Sie sich vorgestellt haben. -Henry David Thoreau"
    },
    "2026-08-25": {
        "content": "Seien Sie freundlich, wann immer es möglich ist. Es ist immer möglich. -Dalai Lama XIV"
    },
    "2026-08-26": {
        "content": " Unser Hauptzweck in diesem Leben ist es, anderen zu helfen. Und wenn Sie ihnen nicht helfen können, verletzen Sie sie zumindest nicht. -Dalai Lama XIV"
    },
    "2026-08-27": {
        "content": " Du hast Verstand. Du stehst in deinen Schuhen. Du kannst dich in jede gewünschte Richtung bewegen. Du bist auf dich allein gestellt. Und du weißt, was du weißt. Und du entscheidest, wohin es geht. -Dr. Seuss"
    },
    "2026-08-28": {
        "content": " Worauf Sie sich konzentrieren, erweitert sich, und wenn Sie sich auf das Gute in Ihrem Leben konzentrieren, schaffen Sie mehr davon. -Oprah Winfrey"
    },
    "2026-08-29": {
        "content": " Alles, was ich wissen muss, wird mir offenbart. Alles, was ich brauche, kommt zu mir. Alles ist gut in meinem Leben. -Louise Hay"
    },
    "2026-08-30": {
        "content": " Ich bin im Universum vollkommen sicher. Ich bin überall im Frieden. Ich vertraue dem Leben. -Louise Hay"
    },
    "2026-08-31": {
        "content": " Drehen Sie Ihr Gesicht der Sonne zu und die Schatten fallen hinter Sie. -Maori-Sprichwort"
    },
    "2026-09-01": {
        "content": " Mut bedeutet nicht, die Kraft zu haben, weiterzumachen. Mut bedeutet, weiterzumachen, wenn einem die Kraft dazu fehlt. -Theodore Roosevelt"
    },
    "2026-09-02": {
        "content": " Die Zukunft hängt davon ab, was Sie heute tun. -Mahatma Gandhi"
    },
    "2026-09-03": {
        "content": " Ein Gewinner ist ein Träumer, der niemals aufgibt. -Nelson Mandela"
    },
    "2026-09-04": {
        "content": "Weine nicht, weil es vorbei ist, lächle, weil es passiert ist. -Dr. Seuss"
    },
    "2026-09-05": {
        "content": " Ich kann alles, was ich über das Leben gelernt habe, in drei Worten zusammenfassen: Es geht weiter. -Robert Frost"
    },
    "2026-09-06": {
        "content": " Lebe aus deiner Vorstellungskraft, nicht aus deiner Geschichte. -Stephen R. Covey"
    },
    "2026-09-07": {
        "content": " So wie ich das sehe, muss man den Regen ertragen, wenn man den Regenbogen will. -Dolly Parton"
    },
    "2026-09-08": {
        "content": " Die Größe eines Menschen liegt nicht darin, wie viel Reichtum er anhäuft, sondern in seiner Integrität und seiner Fähigkeit, die Menschen um ihn herum positiv zu beeinflussen. -Bob Marley"
    },
    "2026-09-09": {
        "content": " Glück ist in erster Linie eine Folge unserer eigenen Einstellung und nicht auf äußere Faktoren zurückzuführen. -Dalai Lama XIV"
    },
    "2026-09-10": {
        "content": " Große Taten bestehen aus kleinen Taten. -Lao Tzu"
    },
    "2026-09-11": {
        "content": " Es ist nie zu spät, das zu werden, was Sie hätten sein können. -George Eliot"
    },
    "2026-09-12": {
        "content": " Durch die richtige Einstellung kann negativer Stress in positiven umgewandelt werden. -Hans Selye"
    },
    "2026-09-13": {
        "content": " Trauen Sie sich, das Leben zu leben, von dem Sie geträumt haben. Gehen Sie voran und lassen Sie Ihre Träume wahr werden. -Ralph Waldo Emerson"
    },
    "2026-09-14": {
        "content": " Die Zeit, die Sie gerne verschwenden, ist keine verschwendete Zeit. -Bertrand Russell"
    },
    "2026-09-15": {
        "content": "Man braucht nur ein wenig Wachsamkeit, um zu erkennen und herauszufinden: Das Leben ist in Wirklichkeit ein großes kosmisches Lachen. -Osho"
    },
    "2026-09-16": {
        "content": " Das seltsame Paradoxe ist, dass ich mich ändern kann, wenn ich mich so akzeptiere, wie ich bin. -Carl R. Rogers"
    },
    "2026-09-17": {
        "content": " Seien Sie Teil der Lösung, nicht Teil des Problems. -Stephen R. Covey"
    },
    "2026-09-18": {
        "content": " Das Geheimnis des Lebens ist das Geben. -Tony Robbins"
    },
    "2026-09-19": {
        "content": " Machen Sie jeden Tag zu Ihrem Meisterwerk. -John Wooden"
    },
    "2026-09-20": {
        "content": " Gib niemals auf, was du wirklich tun willst -H. Jackson Brown Jr."
    },
    "2026-09-21": {
        "content": " Schauen Sie nicht zurück – Sie gehen nicht diesen Weg. -Mary Engelbreit"
    },
    "2026-09-22": {
        "content": " Geben Sie Ihr Bestes und Gott wird den Rest erledigen. -Nick Vujicic"
    },
    "2026-09-23": {
        "content": " Lebe, reise, erlebe Abenteuer, sei gesegnet und bereue nichts. -Jack Kerouac"
    },
    "2026-09-24": {
        "content": " Mitten im Winter entdeckte ich einen unbesiegbaren Sommer in mir. Und das macht mich glücklich. Denn es sagt mir, dass, egal wie sehr die Welt mich bedrängt, in mir etwas Stärkeres – etwas Besseres – steckt, das zurückschlägt. -Albert Camus"
    },
    "2026-09-25": {
        "content": "Manche glauben, nur große Macht könne das Böse in Schach halten, aber das ist nicht meine Erfahrung. Es sind die kleinen alltäglichen Taten der einfachen Leute, die die Dunkelheit in Schach halten. Kleine Taten der Güte und Liebe. -JRR Tolkien"
    },
    "2026-09-26": {
        "content": " Seien Sie in kleinen Dingen treu, denn darin liegt Ihre Stärke. -Mutter Teresa"
    },
    "2026-09-27": {
        "content": " Machen Sie aus sich selbst ein Licht. -Buddha"
    },
    "2026-09-28": {
        "content": " VISUALISIEREN!!! Sehen und fühlen! Hier beginnt die Action. -Rhonda Byrne"
    },
    "2026-09-29": {
        "content": " Seien Sie phänomenal oder werden Sie vergessen! -Eric Thomas"
    },
    "2026-09-30": {
        "content": " Wenn Sie die Wahl haben, Recht zu haben oder freundlich zu sein, entscheiden Sie sich dafür, freundlich zu sein. -Wayne W. Dyer"
    },
    "2026-10-01": {
        "content": " Menschen können ihr Leben ändern, indem sie ihre Geisteshaltung ändern. -William James"
    },
    "2026-10-02": {
        "content": " Gesundheit ist der höchste Besitz. -Laozi"
    },
    "2026-10-03": {
        "content": " Lass mich nicht darum beten, vor Gefahren geschützt zu werden, sondern darum, ihnen furchtlos entgegenzutreten. Lass mich nicht darum betteln, dass mein Schmerz gestillt wird, sondern darum, dass mein Herz ihn überwindet. -Rabindranath Tagore"
    },
    "2026-10-04": {
        "content": " Konzentriere dich darauf, Gutes zu tun. Tu es immer wieder, und du wirst mit Freude erfüllt sein. -Buddha"
    },
    "2026-10-05": {
        "content": "Ich allein kann die Welt nicht verändern, aber ich kann einen Stein über das Wasser werfen, um viele Wellen zu erzeugen. -Mutter Teresa"
    },
    "2026-10-06": {
        "content": " Und der Tag kam, an dem das Risiko, in der Knospe zu verharren, schmerzhafter war als das Risiko, aufzublühen. -Anaïs Nin"
    },
    "2026-10-07": {
        "content": " Menschlichem Streben sollten keine Grenzen gesetzt sein. So schlimm das Leben auch erscheinen mag, es gibt immer Hoffnung. -Stephen Hawking"
    },
    "2026-10-08": {
        "content": " Und ich bitte Sie dringend, darauf zu achten, wann Sie glücklich sind, und irgendwann auszurufen oder zu murmeln oder zu denken: „Wenn das nicht schön ist, weiß ich nicht, was schön ist.“ -Kurt Vonnegut"
    },
    "2026-10-09": {
        "content": " Es ist Ihre Reaktion auf Widrigkeiten, nicht die Widrigkeiten selbst, die bestimmt, wie sich Ihre Lebensgeschichte entwickeln wird. -Dieter F. Uchtdorf"
    },
    "2026-10-10": {
        "content": " Es ist nicht das, was Sie haben, wer Sie sind, wo Sie sind oder was Sie tun, das Sie glücklich oder unglücklich macht. Es ist das, was Sie darüber denken. -Dale Carnegie"
    },
    "2026-10-11": {
        "content": " Je mehr Sie lesen, desto mehr Dinge werden Sie wissen. Je mehr Sie lernen, desto mehr Orte werden Sie besuchen. -Dr. Seuss"
    },
    "2026-10-12": {
        "content": " Alle unsere Träume können wahr werden. -Walt Disney"
    },
    "2026-10-13": {
        "content": "Das Privileg Ihres Lebens besteht darin, der zu sein, der Sie sind. -Joseph Campbell"
    },
    "2026-10-14": {
        "content": " Niemand auf dieser Welt ist nutzlos, wenn er einem anderen die Last erleichtert. -Charles Dickens"
    },
    "2026-10-15": {
        "content": " Finden Sie einen Ort in Ihrem Inneren, an dem Sie Freude empfinden, und die Freude wird den Schmerz vertreiben. -Joseph Campbell"
    },
    "2026-10-16": {
        "content": " Frag nicht, was die Welt braucht. Frag, was dich lebendig macht, und tu es. Denn was die Welt braucht, sind mehr Menschen, die lebendig geworden sind. -Howard Thurman"
    },
    "2026-10-17": {
        "content": " Ihre Gefühle sind Ihr wichtigstes Werkzeug, um Ihr Leben zu gestalten. -Rhonda Byrne"
    },
    "2026-10-18": {
        "content": " Ich verdiene das Beste und akzeptiere jetzt das Beste. -Louise Hay"
    },
    "2026-10-19": {
        "content": " Es kommt nicht darauf an, wie viel wir geben, sondern wie viel Liebe wir in das Geben stecken. -Mutter Teresa"
    },
    "2026-10-20": {
        "content": " Wenn Ihr Wunsch nach Erfolg genauso stark ist, wie Sie atmen möchten, werden Sie Erfolg haben. -Eric Thomas"
    },
    "2026-10-21": {
        "content": " Ich habe jede Minute des Trainings gehasst, aber ich sagte: „Gib nicht auf. Leide jetzt und lebe den Rest deines Lebens als Champion.“ -Muhammad Ali"
    },
    "2026-10-22": {
        "content": "Nicht der Kritiker zählt, nicht derjenige, der aufzeigt, wie der Starke gestolpert ist oder wie der Handelnde es hätte besser machen können. Der Verdienst gebührt dem Mann, der tatsächlich in der Arena steht, dessen Gesicht von Schweiß, Staub und Blut gezeichnet ist; der tapfer kämpft; der immer wieder irrt und scheitert; der die große Begeisterung und Hingabe kennt und sich für eine würdige Sache einsetzt; der, wenn er gewinnt, den Triumph großer Leistung kennt; und der, wenn er scheitert, zumindest scheitert, während er Großes wagt, sodass sein Platz niemals bei den kalten und ängstlichen Seelen sein wird, die weder Sieg noch Niederlage kennen. -Theodore Roosevelt"
    },
    "2026-10-23": {
        "content": " Das größte Abenteuer, das Sie jemals erleben können, ist, das Leben Ihrer Träume zu leben. -Oprah Winfrey"
    },
    "2026-10-24": {
        "content": " Ohne Kampf kann es keinen Fortschritt geben. -Frederick Douglass"
    },
    "2026-10-25": {
        "content": " Ein mit Datum aufgeschriebener Traum wird zum Ziel. Ein in Schritte unterteiltes Ziel wird zum Plan. Ein durch Taten unterstützter Plan lässt Ihre Träume wahr werden. -Greg Reid"
    },
    "2026-10-26": {
        "content": "Tu das Einzige, von dem du glaubst, dass du es nicht kannst. Scheitere. Versuch es noch einmal. Mach es beim zweiten Mal besser. Die einzigen Menschen, die nie stürzen, sind diejenigen, die nie aufs Hochseil steigen. -Oprah Winfrey"
    },
    "2026-10-27": {
        "content": " Erwarten Sie Veränderungen. Analysieren Sie die Landschaft. Nutzen Sie die Chancen. Seien Sie nicht länger die Schachfigur, sondern werden Sie zum Spieler. Sie sind am Zug. -Tony Robbins"
    },
    "2026-10-28": {
        "content": " Du bist frei. Du bist stark. Du bist gut. Du bist Liebe. Du hast einen Wert. Du hast einen Sinn. Alles ist gut. -Esther Hicks"
    },
    "2026-10-29": {
        "content": "Wenn Sie etwas so sehr wollen, dass Sie hinausgehen und dafür kämpfen, Tag und Nacht dafür arbeiten, Ihre Zeit, Ihre Ruhe und Ihren Schlaf dafür opfern, wenn sich alles, wovon Sie träumen und was Sie planen, darauf bezieht und Ihnen das Leben ohne es nutzlos und wertlos erscheint; wenn Sie gerne dafür schwitzen, sich dafür abmühen und dafür planen und all Ihre Angst vor Widerstand verlieren; wenn Sie einfach mit all Ihren Fähigkeiten, Ihrer Kraft und Scharfsinnigkeit, Ihrem Glauben, Ihrer Hoffnung und Ihrem Vertrauen und Ihrer Hartnäckigkeit dem nachgehen, was Sie wollen; wenn weder Kälte noch Armut, Hunger oder Gicht, Krankheit oder Schmerzen an Körper und Geist Sie von dem abhalten können, was Sie wollen; wenn Sie verbissen und grimmig sind und es erreichen, dann werden Sie es mit Gottes Hilfe bekommen. -Berton Braley"
    },
    "2026-10-30": {
        "content": " Selbst wenn Sie auf dem richtigen Weg sind, werden Sie überfahren, wenn Sie einfach nur herumsitzen. -Will Rogers"
    },
    "2026-10-31": {
        "content": " Ich glaube, dass es für gewöhnliche Menschen möglich ist, sich dafür zu entscheiden, außergewöhnlich zu sein. -Elon Musk"
    },
    "2026-11-01": {
        "content": " Laufen lernt man nicht durch das Befolgen von Regeln. Man lernt es durch Tun und Hinfallen. -Richard Branson"
    },
    "2026-11-02": {
        "content": "Hier fehlt das Talent, das ist harte Arbeit. Das ist Besessenheit. Talent existiert nicht, wir sind alle gleich. Du könntest alles sein, wenn du dir die Zeit nimmst. Du wirst es bis ganz nach oben schaffen, und das war’s. Ich bin nicht talentiert, ich bin besessen. -Conor McGregor"
    },
    "2026-11-03": {
        "content": " Ein Traum ist nicht das, was Sie im Schlaf sehen; es ist etwas, das Sie nicht schlafen lässt. -Abdul Kalam"
    },
    "2026-11-04": {
        "content": " Wenn Sie alle Möglichkeiten ausgeschöpft haben, denken Sie daran: Das haben Sie nicht. -Thomas A. Edison"
    },
    "2026-11-05": {
        "content": " Ergreife Chancen und mache Fehler. So wächst du. Schmerz stärkt deinen Mut. Du musst scheitern, um Mut zu üben. -Mary Tyler Moore"
    },
    "2026-11-06": {
        "content": " Worauf Sie sich konzentrieren, das bekommen Sie. -Tony Robbins"
    },
    "2026-11-07": {
        "content": " „Hustle“ ist das wichtigste Wort aller Zeiten. -Gary Vaynerchuk"
    },
    "2026-11-08": {
        "content": " Wenn sie aus schimmeligem Brot Penicillin herstellen können, dann können sie sicher auch etwas aus Ihnen machen. -Muhammad Ali"
    },
    "2026-11-09": {
        "content": " Du wurdest nicht als Gewinner geboren, und du wurdest nicht als Verlierer geboren. Du bist, was du aus dir machst. -Lou Holtz"
    },
    "2026-11-10": {
        "content": " Erfolg ist Ihre Pflicht, Verpflichtung und Verantwortung. -Grant Cardone"
    },
    "2026-11-11": {
        "content": "Es gibt kleine Unterschiede zwischen Menschen, aber diese kleinen Unterschiede machen einen großen Unterschied. Der kleine Unterschied liegt in der Einstellung. Der große Unterschied liegt darin, ob sie positiv oder negativ ist. -W. Clement Stone"
    },
    "2026-11-12": {
        "content": " Führungskräfte müssen nah genug an anderen sein, um eine Beziehung zu ihnen aufzubauen, aber weit genug voraus, um sie zu motivieren. -John C. Maxwell"
    },
    "2026-11-13": {
        "content": " Sag niemals nie, denn Grenzen sind, wie Ängste, oft nur eine Illusion. -Michael Jordan"
    },
    "2026-11-14": {
        "content": " Sie müssen Großes von sich selbst erwarten, bevor Sie es tun können. -Michael Jordan"
    },
    "2026-11-15": {
        "content": " In der Geschäftswelt sind diejenigen Menschen am erfolgreichsten, die das tun, was sie lieben. -Warren Buffett"
    },
    "2026-11-16": {
        "content": " Durch Handeln wird Ihr Zögern ein Ende haben. -Og Mandino"
    },
    "2026-11-17": {
        "content": " Scheitern ist für mich keine Option. Ich stelle mir nur Erfolg vor. -Conor McGregor"
    },
    "2026-11-18": {
        "content": " Erfolg kommt nicht von dem, was Sie gelegentlich tun, sondern von dem, was Sie konsequent tun. -Marie Forleo"
    },
    "2026-11-19": {
        "content": " Selbstvertrauen und harte Arbeit sind die besten Medikamente gegen das Versagen. Sie machen Sie zu einem erfolgreichen Menschen. -Abdul Kalam"
    },
    "2026-11-20": {
        "content": " Wenn Sie wie die Sonne strahlen möchten, müssen Sie zuerst wie die Sonne brennen. -Abdul Kalam"
    },
    "2026-11-21": {
        "content": "Während du da draußen feierst und herumalberst, arbeitet da draußen gleichzeitig jemand hart. Jemand wird schlauer und jemand gewinnt. Vergiss das einfach nicht. -Arnold Schwarzenegger"
    },
    "2026-11-22": {
        "content": " Wenn Sie tun, was Sie immer getan haben, werden Sie bekommen, was Sie immer bekommen haben. -Tony Robbins"
    },
    "2026-11-23": {
        "content": " Fortschritt ist gleich Glück. -Tony Robbins"
    },
    "2026-11-24": {
        "content": " Sie können Ergebnisse oder Ausreden haben. Nicht beides. -Arnold Schwarzenegger"
    },
    "2026-11-25": {
        "content": " Disziplin ist gleich Freiheit. -Jocko Willink"
    },
    "2026-11-26": {
        "content": " Grübeln Sie nicht darüber nach, was schiefgelaufen ist. Konzentrieren Sie sich stattdessen auf die nächsten Schritte. Konzentrieren Sie sich darauf, voranzukommen und die Antwort zu finden. -Denis Waitley"
    },
    "2026-11-27": {
        "content": " Seien Sie der Anführer, den Sie sich gewünscht hätten. -Simon Sinek"
    },
    "2026-11-28": {
        "content": " Meine Einstellung ist, dass ich, wenn Sie mich zu etwas drängen, was Sie für eine Schwäche halten, diese wahrgenommene Schwäche in eine Stärke umwandeln werde. -Michael Jordan"
    },
    "2026-11-29": {
        "content": " Die größere Gefahr für die meisten von uns besteht nicht darin, dass wir uns zu hohe Ziele setzen und sie nicht erreichen, sondern dass wir uns zu niedrige Ziele setzen und sie nicht erreichen. -Michelangelo"
    },
    "2026-11-30": {
        "content": " Jeder hat einen Traum, aber nicht jeder hat die nötige Plackerei. -Eric Thomas"
    },
    "2026-12-01": {
        "content": "Führungspersönlichkeiten werden nicht geboren, sondern gemacht. Sie entstehen durch harte Arbeit, den Preis, den wir alle zahlen müssen, um ein lohnendes Ziel zu erreichen. -Vince Lombardi"
    },
    "2026-12-02": {
        "content": " Wir haben uns entschieden, in diesem Jahrzehnt zum Mond zu fliegen und die anderen Dinge zu tun. Nicht, weil sie einfach sind, sondern weil sie schwierig sind. -John F. Kennedy"
    },
    "2026-12-03": {
        "content": " Der schönste Tag in Ihrem und meinem Leben ist der, an dem wir die volle Verantwortung für unsere Einstellung übernehmen. Das ist der Tag, an dem wir wirklich erwachsen werden. -John C. Maxwell"
    },
    "2026-12-04": {
        "content": " Jedes Mal, wenn Sie jemanden anlächeln, ist dies ein Akt der Liebe, ein Geschenk an diese Person, etwas Schönes. -Mutter Teresa"
    },
    "2026-12-05": {
        "content": " Sei stiller Beobachter deiner Gedanken und deines Verhaltens. Du bist die Ebene des Denkers. Du bist die Stille unter dem mentalen Lärm. Du bist die Liebe und Freude unter dem Schmerz. -Eckhart Tolle"
    },
    "2026-12-06": {
        "content": " Wenn du nicht fliegen kannst, dann laufe. Wenn du nicht rennen kannst, dann geh. Wenn du nicht gehen kannst, dann krieche. Aber was auch immer du tust, du musst weiter vorwärts gehen. -Martin Luther King Jr."
    },
    "2026-12-07": {
        "content": " Vergebung ist keine gelegentliche Handlung, sondern eine konstante Haltung. -Martin Luther King Jr."
    },
    "2026-12-08": {
        "content": " Zu oft unterschätzen wir die Macht einer Berührung, eines Lächelns, eines freundlichen Wortes, eines offenen Ohrs, eines ehrlichen Kompliments oder der kleinsten Geste der Fürsorge, die alle das Potenzial haben, ein Leben zu verändern. -Leo Buscaglia"
    },
    "2026-12-09": {
        "content": "Halte deine Träume am Leben. Um etwas zu erreichen, braucht es Vertrauen und Glauben an sich selbst, Vision, harte Arbeit, Entschlossenheit und Hingabe. Denk daran, dass für diejenigen, die daran glauben, alles möglich ist. -Gail Devers"
    },
    "2026-12-10": {
        "content": " Sport hat die Kraft, die Welt zu verändern. Er hat die Kraft zu inspirieren. Er hat die Kraft, Menschen auf eine Weise zu vereinen, wie es kaum etwas anderes vermag. Er spricht die Jugend in einer Sprache an, die sie versteht. Sport kann Hoffnung schaffen, wo einst nur Verzweiflung herrschte. -Nelson Mandela"
    },
    "2026-12-11": {
        "content": " Bitten Sie um das, was Sie wollen. Glauben Sie, dass Sie es verdienen, und lassen Sie sich dann vom Leben geben. -Louise Hay"
    },
    "2026-12-12": {
        "content": " Lebe bewusst. Gehe bis ans Limit. Höre aufmerksam zu. Achte auf dein Wohlbefinden. Spiele mit Hingabe. Lache. Triff Entscheidungen ohne Reue. Schätze deine Freunde. Lerne weiter. Tu, was du liebst. Lebe, als wäre das alles, was es gibt. -Mary Anne Radmacher"
    },
    "2026-12-13": {
        "content": " Worauf Sie sich konzentrieren, erweitert sich, und wenn Sie sich auf das Gute in Ihrem Leben konzentrieren, schaffen Sie mehr davon. -Oprah Winfrey"
    },
    "2026-12-14": {
        "content": " Du hast Macht über deinen Geist, nicht über äußere Ereignisse. Wenn du dir das bewusst machst, wirst du Kraft finden. -Marcus Aurelius"
    },
    "2026-12-15": {
        "content": "Suchen Sie keine Ausreden dafür, warum Sie es nicht schaffen. Konzentrieren Sie sich auf alle Gründe, warum Sie es schaffen müssen. -Ralph Marston"
    },
    "2026-12-16": {
        "content": " Wo Liebe ist, ist Leben. -Mahatma Gandhi"
    },
    "2026-12-17": {
        "content": " Du musst tanzen, als würde niemand zusehen, lieben, als würde dir nie etwas passieren, singen, als würde niemand zuhören, und leben, als wäre der Himmel auf Erden. -William W. Purkey"
    },
    "2026-12-18": {
        "content": " Erfolg bedeutet, den Sinn des Lebens zu kennen, zu wachsen, um das eigene Potenzial voll auszuschöpfen und Samen zu säen, die anderen nützen. -John C. Maxwell"
    },
    "2026-12-19": {
        "content": " Ein Traum, den Sie alleine träumen, ist nur ein Traum. Ein Traum, den Sie gemeinsam träumen, ist Realität. -John Lennon"
    },
    "2026-12-20": {
        "content": " Das wahre Geheimnis des Lebens besteht darin, sich voll und ganz auf das einzulassen, was man im Hier und Jetzt tut. Und anstatt es Arbeit zu nennen, ist es ein Spiel. -Alan Watts"
    },
    "2026-12-21": {
        "content": " Gestern ist vorbei. Morgen ist noch nicht da. Wir haben nur heute. Lasst uns beginnen. -Mutter Teresa"
    },
    "2026-12-22": {
        "content": " Je mehr Sie Ihr Leben loben und feiern, desto mehr gibt es im Leben zu feiern. -Oprah Winfrey"
    },
    "2026-12-23": {
        "content": "Zweifeln Sie nie daran, dass eine kleine Gruppe nachdenklicher, engagierter Bürger die Welt verändern kann. Tatsächlich ist es das Einzige, was jemals passiert ist. -Margaret Mead"
    },
    "2026-12-24": {
        "content": " Fordern Sie sich selbst heraus, denn niemand sonst wird es für Sie tun. -Anonym"
    },
    "2026-12-25": {
        "content": " Wahre Demut bedeutet nicht, weniger von sich zu halten, sondern weniger an sich zu denken. -CS Lewis"
    },
    "2026-12-26": {
        "content": " Wenn Sie Ihre Meinung ändern können, können Sie Ihr Leben ändern. -William James"
    },
    "2026-12-27": {
        "content": " Konzentrieren Sie sich auf Ihr Ziel, nicht auf das, was Sie fürchten. -Tony Robbins"
    },
    "2026-12-28": {
        "content": " Respektieren Sie sich selbst und andere werden Sie respektieren. -Konfuzius"
    },
    "2026-12-29": {
        "content": " Tun Sie, was Sie können, mit dem, was Sie haben, dort, wo Sie sind. -Theodore Roosevelt"
    },
    "2026-12-30": {
        "content": " Manche Veränderungen sehen auf den ersten Blick negativ aus, aber Sie werden bald erkennen, dass in Ihrem Leben Platz für etwas Neues geschaffen wird. -Eckhart Tolle"
    },
    "2026-12-31": {
        "content": " Wenn Ihre Handlungen andere dazu inspirieren, mehr zu träumen, mehr zu lernen, mehr zu tun und mehr zu werden, sind Sie ein Anführer. -John Quincy Adams"
    }
}